import { n as e } from "./rolldown-runtime-CbXtAM7H.js";
import { a as t, c as n, i as r, l as i, n as a, o, r as s, s as c, t as l, u } from "./forms-D-uIurhY.js";
import { a as _Component99, c as f, d as p, f as m, i as _Component, l as g, n as _, o as _Component108, r as _Component8, s as b, t as _Component110, u as S } from "./react-SMFf4B6d.js";
import { a as C, i as _Component111, n as T, o as E, r as D, t as O } from "./query-kvsa2bYy.js";
(function () {
  let e = document.createElement(`link`).relList;
  if (e && e.supports && e.supports(`modulepreload`)) {
    return;
  }
  for (let e of document.querySelectorAll(`link[rel="modulepreload"]`)) {
    n(e);
  }
  new MutationObserver(e => {
    for (let t of e) {
      if (t.type === `childList`) {
        for (let e of t.addedNodes) {
          if (e.tagName === `LINK` && e.rel === `modulepreload`) {
            n(e);
          }
        }
      }
    }
  }).observe(document, {
    childList: true,
    subtree: true
  });
  function t(e) {
    let t = {};
    if (e.integrity) {
      t.integrity = e.integrity;
    }
    if (e.referrerPolicy) {
      t.referrerPolicy = e.referrerPolicy;
    }
    t.credentials = e.crossOrigin === `use-credentials` ? `include` : e.crossOrigin === `anonymous` ? `omit` : `same-origin`;
    return t;
  }
  function n(e) {
    if (e.ep) {
      return;
    }
    e.ep = true;
    let n = t(e);
    fetch(e.href, n);
  }
})();
var k = e(u(), 1);
var A = p();
var ee = e(m(), 1);
function te(e) {
  if (!e || typeof document > `u`) {
    return;
  }
  let t = document.head || document.getElementsByTagName(`head`)[0];
  let n = document.createElement(`style`);
  n.type = `text/css`;
  t.appendChild(n);
  if (n.styleSheet) {
    n.styleSheet.cssText = e;
  } else {
    n.appendChild(document.createTextNode(e));
  }
}
var j = e => {
  switch (e) {
    case `success`:
      return M;
    case `info`:
      return ae;
    case `warning`:
      return ie;
    case `error`:
      return oe;
    default:
      return null;
  }
};
var ne = Array(12).fill(0);
var re = ({
  visible: e,
  className: t
}) => k.createElement(`div`, {
  className: [`sonner-loading-wrapper`, t].filter(Boolean).join(` `),
  "data-visible": e
}, k.createElement(`div`, {
  className: `sonner-spinner`
}, ne.map((e, t) => k.createElement(`div`, {
  className: `sonner-loading-bar`,
  key: `spinner-bar-${t}`
}))));
var M = k.createElement(`svg`, {
  xmlns: `http://www.w3.org/2000/svg`,
  viewBox: `0 0 20 20`,
  fill: `currentColor`,
  height: `20`,
  width: `20`,
  "aria-hidden": `true`
}, k.createElement(`path`, {
  fillRule: `evenodd`,
  d: `M10 18a8 8 0 100-16 8 8 0 000 16zm3.857-9.809a.75.75 0 00-1.214-.882l-3.483 4.79-1.88-1.88a.75.75 0 10-1.06 1.061l2.5 2.5a.75.75 0 001.137-.089l4-5.5z`,
  clipRule: `evenodd`
}));
var ie = k.createElement(`svg`, {
  xmlns: `http://www.w3.org/2000/svg`,
  viewBox: `0 0 24 24`,
  fill: `currentColor`,
  height: `20`,
  width: `20`,
  "aria-hidden": `true`
}, k.createElement(`path`, {
  fillRule: `evenodd`,
  d: `M9.401 3.003c1.155-2 4.043-2 5.197 0l7.355 12.748c1.154 2-.29 4.5-2.599 4.5H4.645c-2.309 0-3.752-2.5-2.598-4.5L9.4 3.003zM12 8.25a.75.75 0 01.75.75v3.75a.75.75 0 01-1.5 0V9a.75.75 0 01.75-.75zm0 8.25a.75.75 0 100-1.5.75.75 0 000 1.5z`,
  clipRule: `evenodd`
}));
var ae = k.createElement(`svg`, {
  xmlns: `http://www.w3.org/2000/svg`,
  viewBox: `0 0 20 20`,
  fill: `currentColor`,
  height: `20`,
  width: `20`,
  "aria-hidden": `true`
}, k.createElement(`path`, {
  fillRule: `evenodd`,
  d: `M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a.75.75 0 000 1.5h.253a.25.25 0 01.244.304l-.459 2.066A1.75 1.75 0 0010.747 15H11a.75.75 0 000-1.5h-.253a.25.25 0 01-.244-.304l.459-2.066A1.75 1.75 0 009.253 9H9z`,
  clipRule: `evenodd`
}));
var oe = k.createElement(`svg`, {
  xmlns: `http://www.w3.org/2000/svg`,
  viewBox: `0 0 20 20`,
  fill: `currentColor`,
  height: `20`,
  width: `20`,
  "aria-hidden": `true`
}, k.createElement(`path`, {
  fillRule: `evenodd`,
  d: `M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-8-5a.75.75 0 01.75.75v4.5a.75.75 0 01-1.5 0v-4.5A.75.75 0 0110 5zm0 10a1 1 0 100-2 1 1 0 000 2z`,
  clipRule: `evenodd`
}));
var se = k.createElement(`svg`, {
  xmlns: `http://www.w3.org/2000/svg`,
  width: `12`,
  height: `12`,
  viewBox: `0 0 24 24`,
  fill: `none`,
  stroke: `currentColor`,
  strokeWidth: `1.5`,
  strokeLinecap: `round`,
  strokeLinejoin: `round`,
  "aria-hidden": `true`
}, k.createElement(`line`, {
  x1: `18`,
  y1: `6`,
  x2: `6`,
  y2: `18`
}), k.createElement(`line`, {
  x1: `6`,
  y1: `6`,
  x2: `18`,
  y2: `18`
}));
var ce = () => {
  let [e, t] = k.useState(document.hidden);
  k.useEffect(() => {
    let e = () => {
      t(document.hidden);
    };
    document.addEventListener(`visibilitychange`, e);
    return () => document.removeEventListener(`visibilitychange`, e);
  }, []);
  return e;
};
var le = 1;
var ue = 100;
var de = e => typeof e?.id == `number` || e?.id?.length > 0 ? e.id : le++;
var fe = new class {
  constructor() {
    this.subscribe = e => {
      this.subscribers.push(e);
      this.getActiveToasts().forEach(t => e(t));
      return () => {
        let t = this.subscribers.indexOf(e);
        this.subscribers.splice(t, 1);
      };
    };
    this.publish = e => {
      this.subscribers.forEach(t => t(e));
    };
    this.addToast = e => {
      this.publish(e);
      this.toasts = [...this.toasts, e];
      this.trimHistory();
    };
    this.trimHistory = () => {
      let e = this.toasts.length - ue;
      if (!(e <= 0)) {
        this.toasts = this.toasts.filter(t => e > 0 && this.dismissedToasts.has(t.id) ? (this.dismissedToasts.delete(t.id), e--, false) : true);
      }
    };
    this.create = e => {
      let {
        message: t,
        ...n
      } = e;
      let r = de(e);
      let i = this.pendingDismissals.get(r);
      if (i !== undefined) {
        cancelAnimationFrame(i);
        this.pendingDismissals.delete(r);
        this.dismissedToasts.delete(r);
      }
      let a = this.dismissedToasts.has(r);
      let o = e.dismissible === undefined || e.dismissible;
      if (a) {
        this.dismissedToasts.delete(r);
        this.toasts = this.toasts.filter(e => e.id !== r);
      }
      if (!a && this.toasts.find(e => e.id === r)) {
        this.toasts = this.toasts.map(n => n.id === r ? (this.publish({
          ...n,
          ...e,
          id: r,
          title: t
        }), {
          ...n,
          ...e,
          id: r,
          dismissible: o,
          title: t
        }) : n);
      } else {
        this.addToast({
          title: t,
          ...n,
          dismissible: o,
          id: r
        });
      }
      return r;
    };
    this.dismiss = e => {
      if (e == null) {
        this.getActiveToasts().forEach(e => {
          this.dismissedToasts.add(e.id);
          this.subscribers.forEach(t => t({
            id: e.id,
            dismiss: true
          }));
        });
        return e;
      }
      this.dismissedToasts.add(e);
      let t = this.pendingDismissals.get(e);
      if (t !== undefined) {
        cancelAnimationFrame(t);
      }
      this.pendingDismissals.set(e, requestAnimationFrame(() => {
        this.pendingDismissals.delete(e);
        this.subscribers.forEach(t => t({
          id: e,
          dismiss: true
        }));
      }));
      return e;
    };
    this.message = (e, t) => this.create({
      ...t,
      message: e,
      type: undefined
    });
    this.error = (e, t) => this.create({
      ...t,
      message: e,
      type: `error`
    });
    this.success = (e, t) => this.create({
      ...t,
      type: `success`,
      message: e
    });
    this.info = (e, t) => this.create({
      ...t,
      type: `info`,
      message: e
    });
    this.warning = (e, t) => this.create({
      ...t,
      type: `warning`,
      message: e
    });
    this.loading = (e, t) => this.create({
      ...t,
      type: `loading`,
      message: e
    });
    this.promise = (e, t) => {
      if (!t) {
        return;
      }
      let n;
      if (t.loading !== undefined) {
        n = this.create({
          ...t,
          promise: e,
          type: `loading`,
          message: t.loading,
          description: typeof t.description == `function` ? undefined : t.description
        });
      }
      let r = Promise.resolve(e instanceof Function ? e() : e);
      let i = n !== undefined;
      let a;
      let o = r.then(async e => {
        a = [`resolve`, e];
        if (k.isValidElement(e)) {
          i = false;
          this.create({
            id: n,
            type: `default`,
            message: e
          });
        } else if (me(e) && !e.ok) {
          i = false;
          let r = typeof t.error == `function` ? await t.error(`HTTP error! status: ${e.status}`) : t.error;
          let a = typeof t.description == `function` ? await t.description(`HTTP error! status: ${e.status}`) : t.description;
          let o = typeof r == `object` && !k.isValidElement(r) ? r : {
            message: r
          };
          this.create({
            id: n,
            type: `error`,
            description: a,
            ...o
          });
        } else if (e instanceof Error) {
          i = false;
          let r = typeof t.error == `function` ? await t.error(e) : t.error;
          let a = typeof t.description == `function` ? await t.description(e) : t.description;
          let o = typeof r == `object` && !k.isValidElement(r) ? r : {
            message: r
          };
          this.create({
            id: n,
            type: `error`,
            description: a,
            ...o
          });
        } else if (t.success !== undefined) {
          i = false;
          let r = typeof t.success == `function` ? await t.success(e) : t.success;
          let a = typeof t.description == `function` ? await t.description(e) : t.description;
          let o = typeof r == `object` && !k.isValidElement(r) ? r : {
            message: r
          };
          this.create({
            id: n,
            type: `success`,
            description: a,
            ...o
          });
        }
      }).catch(async e => {
        a = [`reject`, e];
        if (t.error !== undefined) {
          i = false;
          let r = typeof t.error == `function` ? await t.error(e) : t.error;
          let a = typeof t.description == `function` ? await t.description(e) : t.description;
          let o = typeof r == `object` && !k.isValidElement(r) ? r : {
            message: r
          };
          this.create({
            id: n,
            type: `error`,
            description: a,
            ...o
          });
        }
      }).finally(() => {
        if (i) {
          this.dismiss(n);
          n = undefined;
        }
        if (t.finally != null) {
          t.finally.call(t);
        }
      });
      let s = () => new Promise((e, t) => o.then(() => a[0] === `reject` ? t(a[1]) : e(a[1])).catch(t));
      if (typeof n != `string` && typeof n != `number`) {
        return {
          unwrap: s
        };
      } else {
        return Object.assign(n, {
          unwrap: s
        });
      }
    };
    this.custom = (e, t) => {
      let n = de(t);
      this.create({
        ...t,
        jsx: e(n),
        id: n,
        type: undefined
      });
      return n;
    };
    this.getActiveToasts = () => this.toasts.filter(e => !this.dismissedToasts.has(e.id));
    this.subscribers = [];
    this.toasts = [];
    this.dismissedToasts = new Set();
    this.pendingDismissals = new Map();
  }
}();
var pe = (e, t) => fe.message(e, t);
var me = e => e && typeof e == `object` && `ok` in e && typeof e.ok == `boolean` && `status` in e && typeof e.status == `number`;
var N = Object.assign(pe, {
  success: fe.success,
  info: fe.info,
  warning: fe.warning,
  error: fe.error,
  custom: fe.custom,
  message: fe.message,
  promise: fe.promise,
  dismiss: fe.dismiss,
  loading: fe.loading
}, {
  getHistory: () => fe.toasts,
  getToasts: () => fe.getActiveToasts()
});
te(`[data-sonner-toaster][dir=ltr],html[dir=ltr]{--toast-icon-margin-start:-3px;--toast-icon-margin-end:4px;--toast-svg-margin-start:-1px;--toast-svg-margin-end:0px;--toast-button-margin-start:auto;--toast-button-margin-end:0;--toast-close-button-start:0;--toast-close-button-end:unset;--toast-close-button-transform:translate(-35%, -35%)}[data-sonner-toaster][dir=rtl],html[dir=rtl]{--toast-icon-margin-start:4px;--toast-icon-margin-end:-3px;--toast-svg-margin-start:0px;--toast-svg-margin-end:-1px;--toast-button-margin-start:0;--toast-button-margin-end:auto;--toast-close-button-start:unset;--toast-close-button-end:0;--toast-close-button-transform:translate(35%, -35%)}[data-sonner-toaster]{position:fixed;width:var(--width);font-family:ui-sans-serif,system-ui,-apple-system,BlinkMacSystemFont,Segoe UI,Roboto,Helvetica Neue,Arial,Noto Sans,sans-serif,Apple Color Emoji,Segoe UI Emoji,Segoe UI Symbol,Noto Color Emoji;--gray1:hsl(0, 0%, 99%);--gray2:hsl(0, 0%, 97.3%);--gray3:hsl(0, 0%, 95.1%);--gray4:hsl(0, 0%, 93%);--gray5:hsl(0, 0%, 90.9%);--gray6:hsl(0, 0%, 88.7%);--gray7:hsl(0, 0%, 85.8%);--gray8:hsl(0, 0%, 78%);--gray9:hsl(0, 0%, 56.1%);--gray10:hsl(0, 0%, 52.3%);--gray11:hsl(0, 0%, 43.5%);--gray12:hsl(0, 0%, 9%);--border-radius:8px;box-sizing:border-box;padding:0;margin:0;list-style:none;outline:0;z-index:999999999;transition:transform .4s ease}@media (hover:none) and (pointer:coarse){[data-sonner-toaster][data-lifted=true]{transform:none}}[data-sonner-toaster][data-x-position=right]{right:var(--offset-right)}[data-sonner-toaster][data-x-position=left]{left:var(--offset-left)}[data-sonner-toaster][data-x-position=center]{left:50%;transform:translateX(-50%)}[data-sonner-toaster][data-y-position=top]{top:var(--offset-top)}[data-sonner-toaster][data-y-position=bottom]{bottom:var(--offset-bottom)}[data-sonner-toast]{--y:translateY(100%);--lift-amount:calc(var(--lift) * var(--gap));z-index:var(--z-index);position:absolute;opacity:0;transform:var(--y);touch-action:none;transition:transform .4s,opacity .4s,height .4s,box-shadow .2s;box-sizing:border-box;outline:0;overflow-wrap:anywhere}[data-sonner-toast][data-styled=true]{padding:16px;background:var(--normal-bg);border:1px solid var(--normal-border);color:var(--normal-text);border-radius:var(--border-radius);box-shadow:0 4px 12px rgba(0,0,0,.1);width:var(--width);font-size:13px;display:flex;align-items:center;gap:6px}[data-sonner-toast]:focus-visible{box-shadow:0 4px 12px rgba(0,0,0,.1),0 0 0 2px rgba(0,0,0,.2)}[data-sonner-toast][data-y-position=top]{top:0;--y:translateY(-100%);--lift:1;--lift-amount:calc(1 * var(--gap))}[data-sonner-toast][data-y-position=bottom]{bottom:0;--y:translateY(100%);--lift:-1;--lift-amount:calc(var(--lift) * var(--gap))}[data-sonner-toast][data-styled=true] [data-description]{font-weight:400;line-height:1.4;color:#3f3f3f}[data-rich-colors=true][data-sonner-toast][data-styled=true] [data-description]{color:inherit}[data-sonner-toaster][data-sonner-theme=dark] [data-description]{color:#e8e8e8}[data-sonner-toast][data-styled=true] [data-title]{font-weight:500;line-height:1.5;color:inherit}[data-sonner-toast][data-styled=true] [data-icon]{display:flex;height:16px;width:16px;position:relative;justify-content:flex-start;align-items:center;flex-shrink:0;margin-left:var(--toast-icon-margin-start);margin-right:var(--toast-icon-margin-end)}[data-sonner-toast][data-promise=true] [data-icon]>svg{opacity:0;transform:scale(.8);transform-origin:center;animation:sonner-fade-in .3s ease forwards}[data-sonner-toast][data-styled=true] [data-icon]>*{flex-shrink:0}[data-sonner-toast][data-styled=true] [data-icon] svg{margin-left:var(--toast-svg-margin-start);margin-right:var(--toast-svg-margin-end)}[data-sonner-toast][data-styled=true] [data-content]{display:flex;flex-direction:column;gap:2px;flex:1;min-width:0}[data-sonner-toast][data-styled=true] [data-button]{border-radius:4px;padding-left:8px;padding-right:8px;height:24px;font-size:12px;color:var(--normal-bg);background:var(--normal-text);margin-left:var(--toast-button-margin-start);margin-right:var(--toast-button-margin-end);border:none;font-weight:500;cursor:pointer;outline:0;display:flex;align-items:center;flex-shrink:0;transition:opacity .4s,box-shadow .2s}[data-sonner-toast][data-styled=true] [data-button]:focus-visible{box-shadow:0 0 0 2px rgba(0,0,0,.4)}[data-sonner-toast][data-styled=true] [data-button]:first-of-type{margin-left:var(--toast-button-margin-start);margin-right:var(--toast-button-margin-end)}[data-sonner-toast][data-styled=true] [data-cancel]{color:var(--normal-text);background:rgba(0,0,0,.08)}[data-sonner-toaster][data-sonner-theme=dark] [data-sonner-toast][data-styled=true] [data-cancel]{background:rgba(255,255,255,.3)}[data-sonner-toast][data-styled=true] [data-close-button]{position:absolute;left:var(--toast-close-button-start);right:var(--toast-close-button-end);top:0;height:20px;width:20px;display:flex;justify-content:center;align-items:center;padding:0;color:var(--normal-text);background:var(--normal-bg);border:1px solid var(--normal-border);transform:var(--toast-close-button-transform);border-radius:50%;cursor:pointer;z-index:1;transition:opacity .1s,background .2s,border-color .2s}[data-sonner-toast][data-styled=true] [data-close-button]:focus-visible{box-shadow:0 4px 12px rgba(0,0,0,.1),0 0 0 2px rgba(0,0,0,.2)}[data-sonner-toast][data-styled=true] [data-disabled=true]{cursor:not-allowed}[data-sonner-toast][data-styled=true]:hover [data-close-button]:hover{background:var(--gray2);border-color:var(--gray5)}[data-sonner-toast][data-swiping=true]::before{content:'';position:absolute;left:-100%;right:-100%;height:100%;z-index:-1}[data-sonner-toast][data-y-position=top][data-swiping=true]::before{bottom:50%;transform:scaleY(3) translateY(50%)}[data-sonner-toast][data-y-position=bottom][data-swiping=true]::before{top:50%;transform:scaleY(3) translateY(-50%)}[data-sonner-toast][data-swiping=false][data-removed=true]::before{content:'';position:absolute;inset:0;transform:scaleY(2)}[data-sonner-toast][data-expanded=true]::after{content:'';position:absolute;left:0;height:calc(var(--gap) + 1px);bottom:100%;width:100%}[data-sonner-toast][data-mounted=true]{--y:translateY(0);opacity:1}[data-sonner-toast][data-expanded=false][data-front=false]{--scale:var(--toasts-before) * 0.05 + 1;--y:translateY(calc(var(--lift-amount) * var(--toasts-before))) scale(calc(-1 * var(--scale)));height:var(--front-toast-height)}[data-sonner-toast]>*{transition:opacity .4s}[data-sonner-toast][data-x-position=right]{right:0}[data-sonner-toast][data-x-position=left]{left:0}[data-sonner-toast][data-expanded=false][data-front=false][data-styled=true]>*{opacity:0}[data-sonner-toast][data-visible=false]{opacity:0;pointer-events:none}[data-sonner-toast][data-mounted=true][data-expanded=true]{--y:translateY(calc(var(--lift) * var(--offset)));height:var(--initial-height)}[data-sonner-toast][data-removed=true][data-front=true][data-swipe-out=false]{--y:translateY(calc(var(--lift) * -100%));opacity:0}[data-sonner-toast][data-removed=true][data-front=false][data-swipe-out=false][data-expanded=true]{--y:translateY(calc(var(--lift) * var(--offset) + var(--lift) * -100%));opacity:0}[data-sonner-toast][data-removed=true][data-front=false][data-swipe-out=false][data-expanded=false]{--y:translateY(40%);opacity:0;transition:transform .5s,opacity .2s}[data-sonner-toast][data-removed=true][data-front=false]::before{height:calc(var(--initial-height) + 20%)}[data-sonner-toast][data-swiping=true]{transform:var(--y) translateY(var(--swipe-amount-y,0)) translateX(var(--swipe-amount-x,0));transition:none}[data-sonner-toast][data-swiped=true]{-webkit-user-select:none;user-select:none}[data-sonner-toast][data-swipe-out=true][data-y-position=bottom],[data-sonner-toast][data-swipe-out=true][data-y-position=top]{animation-duration:.2s;animation-timing-function:ease-out;animation-fill-mode:forwards}[data-sonner-toast][data-swipe-out=true][data-swipe-direction=left]{animation-name:swipe-out-left}[data-sonner-toast][data-swipe-out=true][data-swipe-direction=right]{animation-name:swipe-out-right}[data-sonner-toast][data-swipe-out=true][data-swipe-direction=up]{animation-name:swipe-out-up}[data-sonner-toast][data-swipe-out=true][data-swipe-direction=down]{animation-name:swipe-out-down}@keyframes swipe-out-left{from{transform:var(--y) translateX(var(--swipe-amount-x));opacity:1}to{transform:var(--y) translateX(calc(var(--swipe-amount-x) - 100%));opacity:0}}@keyframes swipe-out-right{from{transform:var(--y) translateX(var(--swipe-amount-x));opacity:1}to{transform:var(--y) translateX(calc(var(--swipe-amount-x) + 100%));opacity:0}}@keyframes swipe-out-up{from{transform:var(--y) translateY(var(--swipe-amount-y));opacity:1}to{transform:var(--y) translateY(calc(var(--swipe-amount-y) - 100%));opacity:0}}@keyframes swipe-out-down{from{transform:var(--y) translateY(var(--swipe-amount-y));opacity:1}to{transform:var(--y) translateY(calc(var(--swipe-amount-y) + 100%));opacity:0}}@media (max-width:600px){[data-sonner-toaster]{position:fixed;right:var(--mobile-offset-right);left:var(--mobile-offset-left);width:100%}[data-sonner-toaster][dir=rtl]{left:calc(var(--mobile-offset-left) * -1)}[data-sonner-toaster] [data-sonner-toast]{left:0;right:0;width:calc(100% - var(--mobile-offset-left) * 2)}[data-sonner-toaster][data-x-position=left]{left:var(--mobile-offset-left)}[data-sonner-toaster][data-y-position=bottom]{bottom:var(--mobile-offset-bottom)}[data-sonner-toaster][data-y-position=top]{top:var(--mobile-offset-top)}[data-sonner-toaster][data-x-position=center]{left:var(--mobile-offset-left);right:var(--mobile-offset-right);transform:none}}[data-sonner-toaster][data-sonner-theme=light]{--normal-bg:#fff;--normal-border:var(--gray4);--normal-text:var(--gray12);--success-bg:hsl(143, 85%, 96%);--success-border:hsl(145, 92%, 87%);--success-text:hsl(140, 100%, 27%);--info-bg:hsl(208, 100%, 97%);--info-border:hsl(221, 91%, 93%);--info-text:hsl(210, 92%, 45%);--warning-bg:hsl(49, 100%, 97%);--warning-border:hsl(49, 91%, 84%);--warning-text:hsl(31, 92%, 45%);--error-bg:hsl(359, 100%, 97%);--error-border:hsl(359, 100%, 94%);--error-text:hsl(360, 100%, 45%)}[data-sonner-toaster][data-sonner-theme=light] [data-sonner-toast][data-invert=true]{--normal-bg:#000;--normal-border:hsl(0, 0%, 20%);--normal-text:var(--gray1)}[data-sonner-toaster][data-sonner-theme=dark] [data-sonner-toast][data-invert=true]{--normal-bg:#fff;--normal-border:var(--gray3);--normal-text:var(--gray12)}[data-sonner-toaster][data-sonner-theme=dark]{--normal-bg:#000;--normal-bg-hover:hsl(0, 0%, 12%);--normal-border:hsl(0, 0%, 20%);--normal-border-hover:hsl(0, 0%, 25%);--normal-text:var(--gray1);--success-bg:hsl(150, 100%, 6%);--success-border:hsl(147, 100%, 12%);--success-text:hsl(150, 86%, 65%);--info-bg:hsl(215, 100%, 6%);--info-border:hsl(223, 43%, 17%);--info-text:hsl(216, 87%, 65%);--warning-bg:hsl(64, 100%, 6%);--warning-border:hsl(60, 100%, 9%);--warning-text:hsl(46, 87%, 65%);--error-bg:hsl(358, 76%, 10%);--error-border:hsl(357, 89%, 16%);--error-text:hsl(358, 100%, 81%)}[data-sonner-toaster][data-sonner-theme=dark] [data-sonner-toast] [data-close-button]{background:var(--normal-bg);border-color:var(--normal-border);color:var(--normal-text)}[data-sonner-toaster][data-sonner-theme=dark] [data-sonner-toast] [data-close-button]:hover{background:var(--normal-bg-hover);border-color:var(--normal-border-hover)}[data-rich-colors=true][data-sonner-toast][data-type=success]{background:var(--success-bg);border-color:var(--success-border);color:var(--success-text)}[data-rich-colors=true][data-sonner-toast][data-type=success] [data-close-button]{background:var(--success-bg);border-color:var(--success-border);color:var(--success-text)}[data-rich-colors=true][data-sonner-toast][data-type=info]{background:var(--info-bg);border-color:var(--info-border);color:var(--info-text)}[data-rich-colors=true][data-sonner-toast][data-type=info] [data-close-button]{background:var(--info-bg);border-color:var(--info-border);color:var(--info-text)}[data-rich-colors=true][data-sonner-toast][data-type=warning]{background:var(--warning-bg);border-color:var(--warning-border);color:var(--warning-text)}[data-rich-colors=true][data-sonner-toast][data-type=warning] [data-close-button]{background:var(--warning-bg);border-color:var(--warning-border);color:var(--warning-text)}[data-rich-colors=true][data-sonner-toast][data-type=error]{background:var(--error-bg);border-color:var(--error-border);color:var(--error-text)}[data-rich-colors=true][data-sonner-toast][data-type=error] [data-close-button]{background:var(--error-bg);border-color:var(--error-border);color:var(--error-text)}.sonner-loading-wrapper{--size:16px;height:var(--size);width:var(--size);position:absolute;inset:0;z-index:10}.sonner-loading-wrapper[data-visible=false]{transform-origin:center;animation:sonner-fade-out .2s ease forwards}.sonner-spinner{position:relative;top:50%;left:50%;height:var(--size);width:var(--size)}.sonner-loading-bar{animation:sonner-spin 1.2s linear infinite;background:var(--gray11);border-radius:6px;height:8%;left:-10%;position:absolute;top:-3.9%;width:24%}.sonner-loading-bar:first-child{animation-delay:-1.2s;transform:rotate(.0001deg) translate(146%)}.sonner-loading-bar:nth-child(2){animation-delay:-1.1s;transform:rotate(30deg) translate(146%)}.sonner-loading-bar:nth-child(3){animation-delay:-1s;transform:rotate(60deg) translate(146%)}.sonner-loading-bar:nth-child(4){animation-delay:-.9s;transform:rotate(90deg) translate(146%)}.sonner-loading-bar:nth-child(5){animation-delay:-.8s;transform:rotate(120deg) translate(146%)}.sonner-loading-bar:nth-child(6){animation-delay:-.7s;transform:rotate(150deg) translate(146%)}.sonner-loading-bar:nth-child(7){animation-delay:-.6s;transform:rotate(180deg) translate(146%)}.sonner-loading-bar:nth-child(8){animation-delay:-.5s;transform:rotate(210deg) translate(146%)}.sonner-loading-bar:nth-child(9){animation-delay:-.4s;transform:rotate(240deg) translate(146%)}.sonner-loading-bar:nth-child(10){animation-delay:-.3s;transform:rotate(270deg) translate(146%)}.sonner-loading-bar:nth-child(11){animation-delay:-.2s;transform:rotate(300deg) translate(146%)}.sonner-loading-bar:nth-child(12){animation-delay:-.1s;transform:rotate(330deg) translate(146%)}@keyframes sonner-fade-in{0%{opacity:0;transform:scale(.8)}100%{opacity:1;transform:scale(1)}}@keyframes sonner-fade-out{0%{opacity:1;transform:scale(1)}100%{opacity:0;transform:scale(.8)}}@keyframes sonner-spin{0%{opacity:1}100%{opacity:.15}}@media (prefers-reduced-motion){.sonner-loading-bar,[data-sonner-toast],[data-sonner-toast]>*{transition:none!important;animation:none!important}}.sonner-loader{position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);transform-origin:center;transition:opacity .2s,transform .2s}.sonner-loader[data-visible=false]{opacity:0;transform:scale(.8) translate(-50%,-50%)}`);
function he(e) {
  return e.label !== undefined;
}
var ge = 3;
var _e = `24px`;
var ve = `16px`;
var ye = 4000;
var be = 356;
var xe = 14;
var Se = 45;
var Ce = 200;
function P(...e) {
  return e.filter(Boolean).join(` `);
}
function we(e) {
  let [t, n] = e.split(`-`);
  let r = [];
  if (t) {
    r.push(t);
  }
  if (n) {
    r.push(n);
  }
  return r;
}
var F = e => {
  let {
    invert: t,
    toast: n,
    unstyled: r,
    interacting: i,
    setHeights: a,
    visibleToasts: o,
    heights: s,
    index: c,
    toasts: l,
    expanded: u,
    removeToast: d,
    defaultRichColors: f,
    closeButton: p,
    style: m,
    cancelButtonStyle: h,
    actionButtonStyle: g,
    className: _ = ``,
    descriptionClassName: v = ``,
    duration: y,
    position: b,
    gap: x,
    expandByDefault: S,
    classNames: C,
    icons: w,
    closeButtonAriaLabel: T = `Close toast`
  } = e;
  let [E, D] = k.useState(null);
  let [O, A] = k.useState(null);
  let [ee, te] = k.useState(false);
  let [ne, M] = k.useState(false);
  let [ie, ae] = k.useState(false);
  let [oe, le] = k.useState(false);
  let [ue, de] = k.useState(false);
  let [fe, pe] = k.useState(0);
  let [me, N] = k.useState(0);
  let ge = k.useRef(n.duration || y || ye);
  let _e = k.useRef(null);
  let ve = k.useRef(null);
  let be = c === 0;
  let xe = c + 1 <= o;
  let F = n.type;
  let Te = F ?? `default`;
  let I = n.dismissible !== false;
  let Ee = n.className || ``;
  let L = n.descriptionClassName || ``;
  let De = k.useMemo(() => s.findIndex(e => e.toastId === n.id) || 0, [s, n.id]);
  let R = k.useMemo(() => n.closeButton ?? p, [n.closeButton, p]);
  let z = k.useMemo(() => n.duration || y || ye, [n.duration, y]);
  let Oe = k.useRef(0);
  let ke = k.useRef(0);
  let Ae = k.useRef(0);
  let je = k.useRef(null);
  let [Me, Ne] = b.split(`-`);
  let Pe = k.useMemo(() => s.reduce((e, t, n) => n >= De ? e : e + t.height, 0), [s, De]);
  let Fe = ce();
  let Ie = k.useMemo(() => e.swipeDirections ?? we(b), [e.swipeDirections, b]);
  let Le = n.invert || t;
  let Re = F === `loading`;
  ke.current = k.useMemo(() => De * x + Pe, [De, Pe]);
  k.useEffect(() => {
    ge.current = z;
  }, [z]);
  k.useEffect(() => {
    te(true);
  }, []);
  k.useEffect(() => {
    let e = ve.current;
    if (e) {
      let t = e.getBoundingClientRect().height;
      N(t);
      a(e => [{
        toastId: n.id,
        height: t,
        position: n.position
      }, ...e]);
      return () => a(e => e.filter(e => e.toastId !== n.id));
    }
  }, [a, n.id]);
  k.useLayoutEffect(() => {
    if (!ee) {
      return;
    }
    let e = ve.current;
    let t = e.style.height;
    e.style.height = `auto`;
    let r = e.getBoundingClientRect().height;
    e.style.height = t;
    N(r);
    a(e => e.find(e => e.toastId === n.id) ? e.map(e => e.toastId === n.id ? {
      ...e,
      height: r
    } : e) : [{
      toastId: n.id,
      height: r,
      position: n.position
    }, ...e]);
  }, [ee, n.title, n.description, a, n.id, n.jsx, n.action, n.cancel]);
  let ze = k.useCallback(() => {
    M(true);
    pe(ke.current);
    a(e => e.filter(e => e.toastId !== n.id));
    setTimeout(() => {
      d(n);
    }, Ce);
  }, [n, d, a, ke]);
  k.useEffect(() => {
    if (n.promise && F === `loading` || n.duration === Infinity || n.type === `loading`) {
      return;
    }
    let e;
    if (u || i || Fe) {
      (() => {
        if (Ae.current < Oe.current) {
          let e = new Date().getTime() - Oe.current;
          ge.current -= e;
        }
        Ae.current = new Date().getTime();
      })();
    } else if (ge.current !== Infinity) {
      Oe.current = new Date().getTime();
      e = setTimeout(() => {
        if (n.onAutoClose != null) {
          n.onAutoClose.call(n, n);
        }
        ze();
      }, ge.current);
    }
    return () => clearTimeout(e);
  }, [u, i, n, F, Fe, ze]);
  k.useEffect(() => {
    if (n.delete) {
      ze();
      if (n.onDismiss != null) {
        n.onDismiss.call(n, n);
      }
    }
  }, [ze, n.delete]);
  function Be() {
    if (w?.loading) {
      return k.createElement(`div`, {
        className: P(C?.loader, n?.classNames?.loader, `sonner-loader`),
        "data-visible": F === `loading`
      }, w.loading);
    } else {
      return k.createElement(re, {
        className: P(C?.loader, n?.classNames?.loader),
        visible: F === `loading`
      });
    }
  }
  let Ve = n.icon || w?.[F] || j(F);
  return k.createElement(`li`, {
    tabIndex: 0,
    ref: ve,
    className: P(_, Ee, C?.toast, n?.classNames?.toast, C?.[Te], n?.classNames?.[Te]),
    "data-sonner-toast": ``,
    "data-rich-colors": n.richColors ?? f,
    "data-styled": !n.jsx && !n.unstyled && !r,
    "data-mounted": ee,
    "data-promise": !!n.promise,
    "data-swiped": ue,
    "data-removed": ne,
    "data-visible": xe,
    "data-y-position": Me,
    "data-x-position": Ne,
    "data-index": c,
    "data-front": be,
    "data-swiping": ie,
    "data-dismissible": I,
    "data-type": F,
    "data-invert": Le,
    "data-swipe-out": oe,
    "data-swipe-direction": O,
    "data-expanded": !!u || !!S && !!ee,
    "data-testid": n.testId,
    style: {
      "--index": c,
      "--toasts-before": c,
      "--z-index": l.length - c,
      "--offset": `${ne ? fe : ke.current}px`,
      "--initial-height": S ? `auto` : `${me}px`,
      ...m,
      ...n.style
    },
    onDragEnd: () => {
      ae(false);
      D(null);
      je.current = null;
    },
    onPointerDown: e => {
      if (e.button !== 2 && !Re && I) {
        _e.current = new Date();
        pe(ke.current);
        e.target.setPointerCapture(e.pointerId);
        if (e.target.tagName !== `BUTTON`) {
          ae(true);
          je.current = {
            x: e.clientX,
            y: e.clientY
          };
        }
      }
    },
    onPointerUp: () => {
      if (oe || !I) {
        return;
      }
      je.current = null;
      let e = Number(ve.current?.style.getPropertyValue(`--swipe-amount-x`).replace(`px`, ``) || 0);
      let t = Number(ve.current?.style.getPropertyValue(`--swipe-amount-y`).replace(`px`, ``) || 0);
      let r = new Date().getTime() - _e.current?.getTime();
      let i = E === `x` ? e : t;
      let a = Math.abs(i) / r;
      if ((E === `x` ? Ie.includes(e > 0 ? `right` : `left`) : Ie.includes(t > 0 ? `bottom` : `top`)) && (Math.abs(i) >= Se || a > 0.11)) {
        pe(ke.current);
        if (n.onDismiss != null) {
          n.onDismiss.call(n, n);
        }
        A(E === `x` ? e > 0 ? `right` : `left` : t > 0 ? `down` : `up`);
        ze();
        le(true);
        return;
      }
      var o;
      var s;
      if ((o = ve.current) != null) {
        o.style.setProperty(`--swipe-amount-x`, `0px`);
      }
      if ((s = ve.current) != null) {
        s.style.setProperty(`--swipe-amount-y`, `0px`);
      }
      de(false);
      ae(false);
      D(null);
    },
    onPointerMove: e => {
      var t;
      var n;
      if (!je.current || !I || window.getSelection()?.toString().length > 0) {
        return;
      }
      let r = e.clientY - je.current.y;
      let i = e.clientX - je.current.x;
      if (!E && (Math.abs(i) > 1 || Math.abs(r) > 1)) {
        D(Math.abs(i) > Math.abs(r) ? `x` : `y`);
      }
      let a = {
        x: 0,
        y: 0
      };
      let o = e => 1 / (1.5 + Math.abs(e) / 20);
      if (E === `y`) {
        if (Ie.includes(`top`) || Ie.includes(`bottom`)) {
          if (Ie.includes(`top`) && r < 0 || Ie.includes(`bottom`) && r > 0) {
            a.y = r;
          } else {
            let e = r * o(r);
            a.y = Math.abs(e) < Math.abs(r) ? e : r;
          }
        }
      } else if (E === `x` && (Ie.includes(`left`) || Ie.includes(`right`))) {
        if (Ie.includes(`left`) && i < 0 || Ie.includes(`right`) && i > 0) {
          a.x = i;
        } else {
          let e = i * o(i);
          a.x = Math.abs(e) < Math.abs(i) ? e : i;
        }
      }
      if (Math.abs(a.x) > 0 || Math.abs(a.y) > 0) {
        de(true);
      }
      if ((t = ve.current) != null) {
        t.style.setProperty(`--swipe-amount-x`, `${a.x}px`);
      }
      if ((n = ve.current) != null) {
        n.style.setProperty(`--swipe-amount-y`, `${a.y}px`);
      }
    }
  }, R && !n.jsx && F !== `loading` ? k.createElement(`button`, {
    "aria-label": T,
    "data-disabled": Re,
    "data-close-button": true,
    onClick: Re || !I ? () => {} : () => {
      ze();
      if (n.onDismiss != null) {
        n.onDismiss.call(n, n);
      }
    },
    className: P(C?.closeButton, n?.classNames?.closeButton)
  }, w?.close ?? se) : null, (F || n.icon || n.promise) && n.icon !== null && (w?.[F] !== null || n.icon) ? k.createElement(`div`, {
    "data-icon": ``,
    className: P(C?.icon, n?.classNames?.icon)
  }, F === `loading` ? n.icon || Be() : n.promise ? Be() : null, F === `loading` ? null : Ve) : null, k.createElement(`div`, {
    "data-content": ``,
    className: P(C?.content, n?.classNames?.content)
  }, k.createElement(`div`, {
    "data-title": ``,
    className: P(C?.title, n?.classNames?.title)
  }, n.jsx ? n.jsx : typeof n.title == `function` ? n.title() : n.title), n.description ? k.createElement(`div`, {
    "data-description": ``,
    className: P(v, L, C?.description, n?.classNames?.description)
  }, typeof n.description == `function` ? n.description() : n.description) : null), k.isValidElement(n.cancel) ? n.cancel : n.cancel && he(n.cancel) ? k.createElement(`button`, {
    "data-button": true,
    "data-cancel": true,
    style: n.cancelButtonStyle || h,
    onClick: e => {
      if (he(n.cancel) && I) {
        if (n.cancel.onClick != null) {
          n.cancel.onClick.call(n.cancel, e);
        }
        ze();
      }
    },
    className: P(C?.cancelButton, n?.classNames?.cancelButton)
  }, n.cancel.label) : null, k.isValidElement(n.action) ? n.action : n.action && he(n.action) ? k.createElement(`button`, {
    "data-button": true,
    "data-action": true,
    style: n.actionButtonStyle || g,
    onClick: e => {
      if (he(n.action)) {
        if (n.action.onClick != null) {
          n.action.onClick.call(n.action, e);
        }
        if (!e.defaultPrevented) {
          ze();
        }
      }
    },
    className: P(C?.actionButton, n?.classNames?.actionButton)
  }, n.action.label) : null);
};
function Te() {
  if (typeof window > `u` || typeof document > `u`) {
    return `ltr`;
  }
  let e = document.documentElement.getAttribute(`dir`);
  if (e === `auto` || !e) {
    return window.getComputedStyle(document.documentElement).direction;
  } else {
    return e;
  }
}
function I(e, t) {
  let n = {};
  [e, t].forEach((e, t) => {
    let r = t === 1;
    let i = r ? `--mobile-offset` : `--offset`;
    let a = r ? ve : _e;
    function o(e) {
      [`top`, `right`, `bottom`, `left`].forEach(t => {
        n[`${i}-${t}`] = typeof e == `number` ? `${e}px` : e;
      });
    }
    if (typeof e == `number` || typeof e == `string`) {
      o(e);
    } else if (typeof e == `object`) {
      [`top`, `right`, `bottom`, `left`].forEach(t => {
        if (e[t] === undefined) {
          n[`${i}-${t}`] = a;
        } else {
          n[`${i}-${t}`] = typeof e[t] == `number` ? `${e[t]}px` : e[t];
        }
      });
    } else {
      o(a);
    }
  });
  return n;
}
var Ee = k.forwardRef(function (e, t) {
  let {
    id: n,
    invert: r,
    position: i = `bottom-right`,
    hotkey: a = [`altKey`, `KeyT`],
    expand: o,
    closeButton: s,
    className: c,
    offset: l,
    mobileOffset: u,
    theme: d = `light`,
    richColors: f,
    duration: p,
    style: m,
    visibleToasts: h = ge,
    toastOptions: g,
    dir: _ = Te(),
    gap: v = xe,
    icons: y,
    customAriaLabel: b,
    containerAriaLabel: x = `Notifications`
  } = e;
  let [S, C] = k.useState([]);
  let w = k.useMemo(() => n ? S.filter(e => e.toasterId === n) : S.filter(e => !e.toasterId), [S, n]);
  let T = k.useMemo(() => Array.from(new Set([i].concat(w.filter(e => e.position).map(e => e.position)))), [w, i]);
  let [E, D] = k.useState([]);
  let [O, A] = k.useState(false);
  let [te, j] = k.useState(false);
  let [ne, re] = k.useState(d === `system` ? typeof window < `u` && window.matchMedia && window.matchMedia(`(prefers-color-scheme: dark)`).matches ? `dark` : `light` : d);
  let M = k.useRef(null);
  let ie = a.join(`+`).replace(/Key/g, ``).replace(/Digit/g, ``);
  let ae = k.useRef(null);
  let oe = k.useRef(false);
  let se = k.useCallback(e => {
    C(t => {
      if (!t.find(t => t.id === e.id)?.delete) {
        fe.dismiss(e.id);
      }
      return t.filter(({
        id: t
      }) => t !== e.id);
    });
  }, []);
  k.useEffect(() => fe.subscribe(e => {
    if (e.dismiss) {
      requestAnimationFrame(() => {
        C(t => t.map(t => t.id === e.id ? {
          ...t,
          delete: true
        } : t));
      });
      return;
    }
    setTimeout(() => {
      ee.flushSync(() => {
        C(t => {
          let n = t.findIndex(t => t.id === e.id);
          if (n === -1) {
            return [e, ...t];
          } else {
            return [...t.slice(0, n), {
              ...t[n],
              ...e
            }, ...t.slice(n + 1)];
          }
        });
      });
    });
  }), []);
  k.useEffect(() => {
    if (d !== `system`) {
      re(d);
      return;
    }
    if (d === `system`) {
      if (window.matchMedia && window.matchMedia(`(prefers-color-scheme: dark)`).matches) {
        re(`dark`);
      } else {
        re(`light`);
      }
    }
    if (typeof window > `u`) {
      return;
    }
    let e = window.matchMedia(`(prefers-color-scheme: dark)`);
    try {
      e.addEventListener(`change`, ({
        matches: e
      }) => {
        re(e ? `dark` : `light`);
      });
    } catch {
      e.addListener(({
        matches: e
      }) => {
        try {
          re(e ? `dark` : `light`);
        } catch (e) {
          console.error(e);
        }
      });
    }
  }, [d]);
  k.useEffect(() => {
    if (S.length <= 1) {
      A(false);
    }
  }, [S]);
  k.useEffect(() => {
    let e = e => {
      if (a.length > 0 && a.every(t => e[t] || e.code === t)) {
        var t;
        A(true);
        if ((t = M.current) != null) {
          t.focus();
        }
      }
      if (e.code === `Escape` && (document.activeElement === M.current || M.current?.contains(document.activeElement))) {
        A(false);
      }
    };
    document.addEventListener(`keydown`, e);
    return () => document.removeEventListener(`keydown`, e);
  }, [a]);
  k.useEffect(() => {
    if (M.current) {
      return () => {
        if (ae.current) {
          ae.current.focus({
            preventScroll: true
          });
          ae.current = null;
          oe.current = false;
        }
      };
    }
  }, [M.current]);
  return k.createElement(`section`, {
    ref: t,
    "aria-label": b ?? `${x} ${ie}`,
    tabIndex: -1,
    "aria-live": `polite`,
    "aria-relevant": `additions text`,
    "aria-atomic": `false`,
    suppressHydrationWarning: true,
    "data-react-aria-top-layer": true
  }, T.map((t, n) => {
    let [i, a] = t.split(`-`);
    if (w.length) {
      return k.createElement(`ol`, {
        key: t,
        dir: _ === `auto` ? Te() : _,
        tabIndex: -1,
        ref: M,
        className: c,
        "data-sonner-toaster": true,
        "data-sonner-theme": ne,
        "data-y-position": i,
        "data-x-position": a,
        style: {
          "--front-toast-height": `${E[0]?.height || 0}px`,
          "--width": `${be}px`,
          "--gap": `${v}px`,
          ...m,
          ...I(l, u)
        },
        onBlur: e => {
          if (oe.current && !e.currentTarget.contains(e.relatedTarget)) {
            oe.current = false;
            ae.current &&= (ae.current.focus({
              preventScroll: true
            }), null);
          }
        },
        onFocus: e => {
          if ((!(e.target instanceof HTMLElement) || e.target.dataset.dismissible !== `false`) && !oe.current) {
            oe.current = true;
            ae.current = e.relatedTarget;
          }
        },
        onMouseEnter: () => A(true),
        onMouseMove: () => A(true),
        onMouseLeave: () => {
          if (!te) {
            A(false);
          }
        },
        onDragEnd: () => A(false),
        onPointerDown: e => {
          if (!(e.target instanceof HTMLElement) || e.target.dataset.dismissible !== `false`) {
            j(true);
          }
        },
        onPointerUp: () => j(false)
      }, w.filter(e => !e.position && n === 0 || e.position === t).map((n, i) => k.createElement(F, {
        key: n.id,
        icons: y,
        index: i,
        toast: n,
        defaultRichColors: f,
        duration: g?.duration ?? p,
        className: g?.className,
        descriptionClassName: g?.descriptionClassName,
        invert: r,
        visibleToasts: h,
        closeButton: g?.closeButton ?? s,
        interacting: te,
        position: t,
        style: g?.style,
        unstyled: g?.unstyled,
        classNames: g?.classNames,
        cancelButtonStyle: g?.cancelButtonStyle,
        actionButtonStyle: g?.actionButtonStyle,
        closeButtonAriaLabel: g?.closeButtonAriaLabel,
        removeToast: se,
        toasts: w.filter(e => e.position == n.position),
        heights: E.filter(e => e.position == n.position),
        setHeights: D,
        expandByDefault: o,
        gap: v,
        expanded: O,
        swipeDirections: e.swipeDirections
      })));
    } else {
      return null;
    }
  }));
});
var L = E();
var De = ({
  ...e
}) => <Ee className={`toaster group`} toastOptions={{
  classNames: {
    toast: `group toast group-[.toaster]:bg-card group-[.toaster]:text-card-foreground group-[.toaster]:border-border group-[.toaster]:shadow-lg`,
    description: `group-[.toast]:text-muted-foreground`,
    actionButton: `group-[.toast]:bg-primary group-[.toast]:text-primary-foreground`,
    cancelButton: `group-[.toast]:bg-secondary group-[.toast]:text-secondary-foreground`
  }
}} {...e} />;
var R = `11111111-1111-4111-a111-111111111111`;
var z = `22222222-2222-4222-a222-222222222222`;
var Oe = `33333333-3333-4333-a333-333333333333`;
var ke = `44444444-4444-4444-a444-444444444444`;
function Ae() {
  let e = e => {
    let t = new Date();
    t.setDate(t.getDate() + e);
    return t.toISOString().slice(0, 10);
  };
  let t = e => {
    let t = new Date();
    t.setDate(t.getDate() + e);
    return t.toISOString();
  };
  return {
    _auth_users: [{
      id: z,
      email: `admin@planejadospro.com.br`,
      password: `admin`,
      full_name: `Carlos Eduardo Mendes`,
      tenant_id: R,
      created_at: t(-90)
    }, {
      id: Oe,
      email: `marceneiro@planejadospro.com.br`,
      password: `admin`,
      full_name: `Roberto Silveira (Oficina)`,
      tenant_id: R,
      created_at: t(-60)
    }, {
      id: ke,
      email: `orcamento@planejadospro.com.br`,
      password: `admin`,
      full_name: `Fernanda Lima (Projetos)`,
      tenant_id: R,
      created_at: t(-45)
    }],
    _storage: {
      logos: {},
      anexos: {}
    },
    tenants: [{
      id: R,
      name: `Marcenaria Artesanal Planejados Pro`,
      logo_url: null,
      documento: `12.345.678/0001-90`,
      telefone: `(11) 98765-4321`,
      email: `contato@planejadospro.com.br`,
      endereco: `Av. das Indústrias Moveleiras, 1500 - Galpão 04`,
      cidade: `São Paulo`,
      uf: `SP`,
      cep: `04567-000`,
      termos_contrato: `1. DO OBJETO: Prestação de serviços de marcenaria sob medida e montagem técnica especializada.
2. DO PRAZO: O prazo de entrega e montagem inicia-se após a aprovação do projeto executivo e conferência in loco das medidas.
3. DA GARANTIA: Garantia legal de 90 dias e garantia contratual de 3 (três) anos contra defeitos de fabricação e montagem de ferragens.
4. DO PAGAMENTO: Conforme as parcelas e datas estipuladas no cronograma financeiro aprovado.`,
      plano_nome: `PRO_ILIMITADO`,
      plano_status: `ativo`,
      faturamento_email: `financeiro@planejadospro.com.br`,
      faturamento_documento: `12.345.678/0001-90`,
      config_precos: {
        mdf_chapa_m2: 65,
        fita_metro: 4.5,
        hora_montagem: 85,
        margem_padrao: 35
      },
      created_at: t(-120),
      atualizado_em: t(-1)
    }],
    profiles: [{
      id: z,
      tenant_id: R,
      email: `admin@planejadospro.com.br`,
      full_name: `Carlos Eduardo Mendes`,
      telefone: `(11) 99876-5432`,
      avatar_url: null,
      ativo: true,
      created_at: t(-90),
      updated_at: t(-1)
    }, {
      id: Oe,
      tenant_id: R,
      email: `marceneiro@planejadospro.com.br`,
      full_name: `Roberto Silveira`,
      telefone: `(11) 98765-1122`,
      avatar_url: null,
      ativo: true,
      created_at: t(-60),
      updated_at: t(-2)
    }, {
      id: ke,
      tenant_id: R,
      email: `orcamento@planejadospro.com.br`,
      full_name: `Fernanda Lima`,
      telefone: `(11) 97654-3344`,
      avatar_url: null,
      ativo: true,
      created_at: t(-45),
      updated_at: t(-3)
    }],
    user_roles: [{
      id: `role-1`,
      user_id: z,
      tenant_id: R,
      role: `admin`,
      created_at: t(-90)
    }, {
      id: `role-2`,
      user_id: Oe,
      tenant_id: R,
      role: `marceneiro`,
      created_at: t(-60)
    }, {
      id: `role-3`,
      user_id: ke,
      tenant_id: R,
      role: `orcamentista`,
      created_at: t(-45)
    }],
    clientes: [{
      id: `cli-1`,
      tenant_id: R,
      nome: `Dra. Juliana Martins`,
      documento: `345.890.123-04`,
      email: `juliana.martins@hospitalcare.com.br`,
      telefone: `(11) 99123-4567`,
      endereco: `Rua Oscar Freire, 1420 - Apto 142`,
      cidade: `São Paulo`,
      uf: `SP`,
      cep: `01426-001`,
      observacoes: `Cliente exigente com acabamento em tons amadeirados e iluminação LED embutida.`,
      created_by: z,
      created_at: t(-40),
      updated_at: t(-5)
    }, {
      id: `cli-2`,
      tenant_id: R,
      nome: `Eng. Ricardo Vasconcellos`,
      documento: `198.765.432-11`,
      email: `ricardo.vasconcellos@engvanguard.com.br`,
      telefone: `(19) 98877-6655`,
      endereco: `Alameda dos Pinheiros, 85 - Alphaville`,
      cidade: `Campinas`,
      uf: `SP`,
      cep: `13098-400`,
      observacoes: `Casa em fase final de pintura. Projeto completo de cozinha e área gourmet.`,
      created_by: ke,
      created_at: t(-30),
      updated_at: t(-4)
    }, {
      id: `cli-3`,
      tenant_id: R,
      nome: `Mariana Duarte & Lucas`,
      documento: `456.123.789-55`,
      email: `mariana.duarte@gmail.com`,
      telefone: `(13) 99765-8899`,
      endereco: `Av. Bartolomeu de Gusmão, 45 - Edifício Acapulco`,
      cidade: `Santos`,
      uf: `SP`,
      cep: `11045-401`,
      observacoes: `Mobiliário marítimo com MDF naval resistente à umidade.`,
      created_by: z,
      created_at: t(-25),
      updated_at: t(-2)
    }, {
      id: `cli-4`,
      tenant_id: R,
      nome: `Clínica OdontoPrime (Dr. Renato)`,
      documento: `45.678.901/0001-23`,
      email: `administrativo@odontoprime.com.br`,
      telefone: `(11) 3289-4000`,
      endereco: `Av. Paulista, 2000 - Conjunto 1402`,
      cidade: `São Paulo`,
      uf: `SP`,
      cep: `01310-200`,
      observacoes: `Recepção de alto padrão com ripado em freijó e armários de consultório em laca branca.`,
      created_by: z,
      created_at: t(-50),
      updated_at: t(-1)
    }, {
      id: `cli-5`,
      tenant_id: R,
      nome: `Camila Siqueira`,
      documento: `234.567.890-88`,
      email: `camila.siqueira@arqstudio.com`,
      telefone: `(11) 98111-2233`,
      endereco: `Rua Fradique Coutinho, 980 - Vila Madalena`,
      cidade: `São Paulo`,
      uf: `SP`,
      cep: `05416-001`,
      observacoes: `Apartamento compacto tipo studio. Móveis multifuncionais e gavetões profundos.`,
      created_by: ke,
      created_at: t(-15),
      updated_at: t(-1)
    }],
    projetos: [{
      id: `proj-1`,
      tenant_id: R,
      cliente_id: `cli-1`,
      nome: `Apartamento 142 - Cozinha Gourmet & Suíte Master`,
      descricao: `Cozinha integrada com ilha central e torre quente, suíte master com closet espelhado.`,
      status: `montagem`,
      prioridade: 1,
      termos_contrato: `Entrega com montagem inclusa e limpeza pós-obra.`,
      data_inicio: e(-20),
      data_entrega_prevista: e(3),
      created_by: z,
      created_at: t(-20),
      updated_at: t(-1)
    }, {
      id: `proj-2`,
      tenant_id: R,
      cliente_id: `cli-2`,
      nome: `Residência Alphaville - Mobiliário Completo`,
      descricao: `Cozinha, área gourmet externa com churrasqueira, home theater e despensa.`,
      status: `projeto_corte`,
      prioridade: 2,
      termos_contrato: `Chapas com fita de borda PUR e corrediças telescópicas reforçadas.`,
      data_inicio: e(-14),
      data_entrega_prevista: e(12),
      created_by: ke,
      created_at: t(-14),
      updated_at: t(-2)
    }, {
      id: `proj-3`,
      tenant_id: R,
      cliente_id: `cli-4`,
      nome: `Consultório OdontoPrime - Recepção & Consultórios`,
      descricao: `Balcão recepção curvo, painéis ripados e bancadas para esterilização.`,
      status: `entrega`,
      prioridade: 1,
      termos_contrato: `Instalação aos finais de semana para não interromper atendimentos.`,
      data_inicio: e(-35),
      data_entrega_prevista: e(5),
      created_by: z,
      created_at: t(-35),
      updated_at: t(-1)
    }, {
      id: `proj-4`,
      tenant_id: R,
      cliente_id: `cli-3`,
      nome: `Cobertura Santos - Espaço Gourmet`,
      descricao: `Armários aéreos em MDF naval, bancada de apoio e nichos para bebidas.`,
      status: `medicao`,
      prioridade: 3,
      termos_contrato: `Aguardando confirmação de pontos de hidráulica e gás.`,
      data_inicio: e(-7),
      data_entrega_prevista: e(25),
      created_by: z,
      created_at: t(-7),
      updated_at: t(-3)
    }, {
      id: `proj-5`,
      tenant_id: R,
      cliente_id: `cli-5`,
      nome: `Studio Vila Madalena - Otimização Compacta`,
      descricao: `Cama retrátil, painel giratório de TV e armários suspensos.`,
      status: `concluido`,
      prioridade: 2,
      termos_contrato: `Projeto concluído e termo de entrega devidamente assinado.`,
      data_inicio: e(-50),
      data_entrega_prevista: e(-10),
      created_by: ke,
      created_at: t(-50),
      updated_at: t(-10)
    }],
    ambientes: [{
      id: `amb-1`,
      tenant_id: R,
      projeto_id: `proj-1`,
      nome: `Cozinha Gourmet`,
      tipo: `cozinha`,
      margem_percent: 35,
      ordem: 1,
      observacoes: `Ilha central com cooktop de indução e cuba esculpida.`,
      created_at: t(-20),
      updated_at: t(-2)
    }, {
      id: `amb-2`,
      tenant_id: R,
      projeto_id: `proj-1`,
      nome: `Suíte Master & Closet`,
      tipo: `quarto`,
      margem_percent: 30,
      ordem: 2,
      observacoes: `Portas de correr com espelho bronze e perfis champagne.`,
      created_at: t(-20),
      updated_at: t(-2)
    }, {
      id: `amb-3`,
      tenant_id: R,
      projeto_id: `proj-2`,
      nome: `Cozinha Integrada`,
      tipo: `cozinha`,
      margem_percent: 32,
      ordem: 1,
      observacoes: `MDF Louro Freijó combinado com Grafite Matt.`,
      created_at: t(-14),
      updated_at: t(-1)
    }, {
      id: `amb-4`,
      tenant_id: R,
      projeto_id: `proj-2`,
      nome: `Área Gourmet Externa`,
      tipo: `area_externa`,
      margem_percent: 40,
      ordem: 2,
      observacoes: `Ferragens em inox resistentes à intempérie.`,
      created_at: t(-14),
      updated_at: t(-1)
    }, {
      id: `amb-5`,
      tenant_id: R,
      projeto_id: `proj-3`,
      nome: `Recepção Principal`,
      tipo: `sala`,
      margem_percent: 35,
      ordem: 1,
      observacoes: `Painel ripado com logotipo iluminado e balcão de atendimento.`,
      created_at: t(-35),
      updated_at: t(-3)
    }, {
      id: `amb-6`,
      tenant_id: R,
      projeto_id: `proj-4`,
      nome: `Varanda Gourmet`,
      tipo: `area_externa`,
      margem_percent: 35,
      ordem: 1,
      observacoes: `Aguardando ajuste de caimento do piso para medição final.`,
      created_at: t(-7),
      updated_at: t(-1)
    }, {
      id: `amb-7`,
      tenant_id: R,
      projeto_id: `proj-5`,
      nome: `Ambiente Integrado Studio`,
      tipo: `sala`,
      margem_percent: 30,
      ordem: 1,
      observacoes: `Instalação concluída com sucesso.`,
      created_at: t(-50),
      updated_at: t(-10)
    }],
    medicoes: [{
      id: `med-1`,
      tenant_id: R,
      ambiente_id: `amb-1`,
      altura_cm: 270,
      largura_cm: 380,
      profundidade_cm: 290,
      desnivel_cm: 0.5,
      pontos_eletricos: 8,
      pontos_hidraulicos: 2,
      colunas_vigas: `Viga estrutural de 20cm no canto superior esquerdo`,
      observacoes: `Ponto de gás encanado na parede sul a 60cm do piso acabado.`,
      created_at: t(-20),
      updated_at: t(-5)
    }, {
      id: `med-2`,
      tenant_id: R,
      ambiente_id: `amb-2`,
      altura_cm: 265,
      largura_cm: 420,
      profundidade_cm: 350,
      desnivel_cm: 0.2,
      pontos_eletricos: 6,
      pontos_hidraulicos: 0,
      colunas_vigas: `Nenhuma viga aparente`,
      observacoes: `Circuito dedicado para fitas de LED internas nos nichos.`,
      created_at: t(-20),
      updated_at: t(-5)
    }, {
      id: `med-3`,
      tenant_id: R,
      ambiente_id: `amb-3`,
      altura_cm: 280,
      largura_cm: 450,
      profundidade_cm: 320,
      desnivel_cm: 0.8,
      pontos_eletricos: 10,
      pontos_hidraulicos: 3,
      colunas_vigas: `Coluna hidráulica de 15x15cm no canto leste`,
      observacoes: `Tomadas 20A para forno elétrico e micro-ondas na torre.`,
      created_at: t(-14),
      updated_at: t(-2)
    }, {
      id: `med-4`,
      tenant_id: R,
      ambiente_id: `amb-4`,
      altura_cm: 260,
      largura_cm: 360,
      profundidade_cm: 250,
      desnivel_cm: 1.2,
      pontos_eletricos: 5,
      pontos_hidraulicos: 1,
      colunas_vigas: `Pilar de sustentação redondo no centro da varanda`,
      observacoes: `Prever rodapé recuado em inox de 10cm.`,
      created_at: t(-14),
      updated_at: t(-2)
    }, {
      id: `med-5`,
      tenant_id: R,
      ambiente_id: `amb-5`,
      altura_cm: 290,
      largura_cm: 500,
      profundidade_cm: 400,
      desnivel_cm: 0,
      pontos_eletricos: 12,
      pontos_hidraulicos: 1,
      colunas_vigas: `Forro de gesso rebaixado com tabica metálica`,
      observacoes: `Passagem de cabeamento de rede estruturada no balcão.`,
      created_at: t(-35),
      updated_at: t(-3)
    }, {
      id: `med-6`,
      tenant_id: R,
      ambiente_id: `amb-6`,
      altura_cm: 255,
      largura_cm: 310,
      profundidade_cm: 220,
      desnivel_cm: 1.5,
      pontos_eletricos: 4,
      pontos_hidraulicos: 1,
      colunas_vigas: `Mureta de alvenaria com pingadeira`,
      observacoes: `Medição preliminar, confirmar após rejunte do piso.`,
      created_at: t(-7),
      updated_at: t(-1)
    }],
    checklists_tecnicos: [{
      id: `chk-1`,
      tenant_id: R,
      projeto_id: `proj-1`,
      elevador_tamanho: `2.10m x 1.40m x 1.20m (Carga máx 600kg)`,
      elevador_ok: true,
      tem_escada: true,
      escada_observacoes: `Painéis acima de 2.40m sobem pela escada de serviço sem curvas apertadas.`,
      estacionamento: `Vaga de carga e descarga no subsolo 1 liberada das 08h às 17h.`,
      horario_permitido: `Segunda a Sexta, das 08h às 17h. Sábados proibido.`,
      restricoes_condominio: `Uso obrigatório de proteção no piso do hall social e elevador acolchoado.`,
      acesso_observacoes: `Aviso prévio de 48h à portaria com RG de toda a equipe de montadores.`,
      concluido: true,
      created_at: t(-20),
      updated_at: t(-5)
    }, {
      id: `chk-2`,
      tenant_id: R,
      projeto_id: `proj-2`,
      elevador_tamanho: `Casa térrea (Sem elevador)`,
      elevador_ok: false,
      tem_escada: false,
      escada_observacoes: null,
      estacionamento: `Acesso direto pela rampa da garagem privativa.`,
      horario_permitido: `Segunda a Sábado, das 07h às 18h.`,
      restricoes_condominio: `Velocidade máxima no condomínio de 20 km/h.`,
      acesso_observacoes: `Acesso livre na portaria com cadastro biométrico prévio.`,
      concluido: true,
      created_at: t(-14),
      updated_at: t(-2)
    }],
    anexos: [{
      id: `anx-1`,
      tenant_id: R,
      projeto_id: `proj-1`,
      ambiente_id: `amb-1`,
      categoria: `croqui`,
      storage_path: `${R}/proj-1/croqui-cozinha.png`,
      nome_arquivo: `croqui-cozinha-ap142.png`,
      mime_type: `image/png`,
      tamanho_bytes: 540200,
      uploaded_by: z,
      created_at: t(-18)
    }, {
      id: `anx-2`,
      tenant_id: R,
      projeto_id: `proj-1`,
      ambiente_id: `amb-1`,
      categoria: `foto`,
      storage_path: `${R}/proj-1/foto-parede-cozinha.jpg`,
      nome_arquivo: `parede-hidraulica-cozinha.jpg`,
      mime_type: `image/jpeg`,
      tamanho_bytes: 1240000,
      uploaded_by: z,
      created_at: t(-19)
    }],
    materiais: [{
      id: `mat-1`,
      tenant_id: R,
      categoria: `chapa`,
      nome: `MDF Louro Freijó 18mm 2 Faces`,
      codigo: `MDF-FREIJO-18`,
      descricao: `Chapa MDF revestida padrão amadeirado nobre com textura sincronizada.`,
      unidade: `chapa`,
      cor: `Louro Freijó`,
      espessura_mm: 18,
      acabamento: `Madeirado Fosco`,
      custo_unitario: 285.5,
      preco_unitario: 420,
      estoque_minimo: 6,
      estoque_atual: 14,
      ativo: true,
      created_at: t(-100),
      updated_at: t(-2)
    }, {
      id: `mat-2`,
      tenant_id: R,
      categoria: `chapa`,
      nome: `MDF Branco Supremo 15mm 2 Faces`,
      codigo: `MDF-BRANCO-15`,
      descricao: `Chapa MDF branco padrão para caixaria estrutural e fundos.`,
      unidade: `chapa`,
      cor: `Branco Supremo`,
      espessura_mm: 15,
      acabamento: `Texturizado`,
      custo_unitario: 165,
      preco_unitario: 250,
      estoque_minimo: 10,
      estoque_atual: 22,
      ativo: true,
      created_at: t(-100),
      updated_at: t(-3)
    }, {
      id: `mat-3`,
      tenant_id: R,
      categoria: `chapa`,
      nome: `MDF Grafite Matt 18mm`,
      codigo: `MDF-GRAFITE-18`,
      descricao: `Chapa acetinada toque suave anti-marcas para frentes de armário.`,
      unidade: `chapa`,
      cor: `Grafite Matt`,
      espessura_mm: 18,
      acabamento: `Super Matt`,
      custo_unitario: 310,
      preco_unitario: 460,
      estoque_minimo: 5,
      estoque_atual: 3,
      ativo: true,
      created_at: t(-80),
      updated_at: t(-1)
    }, {
      id: `mat-4`,
      tenant_id: R,
      categoria: `ferragem`,
      nome: `Corrediça Oculta com Amortecedor 450mm`,
      codigo: `CORR-OCULTA-450`,
      descricao: `Corrediça slowmotion extração total com amortecimento integrado.`,
      unidade: `par`,
      cor: `Zincado`,
      espessura_mm: null,
      acabamento: `Galvanizado`,
      custo_unitario: 68.9,
      preco_unitario: 110,
      estoque_minimo: 15,
      estoque_atual: 8,
      ativo: true,
      created_at: t(-90),
      updated_at: t(-2)
    }, {
      id: `mat-5`,
      tenant_id: R,
      categoria: `ferragem`,
      nome: `Dobradiça 35mm Reta com Amortecedor Slow`,
      codigo: `DOB-SLOW-35-R`,
      descricao: `Dobradiça de montagem rápida clip-on com pistão amortecedor silencioso.`,
      unidade: `un`,
      cor: `Niquelado`,
      espessura_mm: null,
      acabamento: `Niquelado`,
      custo_unitario: 8.5,
      preco_unitario: 16,
      estoque_minimo: 50,
      estoque_atual: 84,
      ativo: true,
      created_at: t(-90),
      updated_at: t(-4)
    }, {
      id: `mat-6`,
      tenant_id: R,
      categoria: `ferragem`,
      nome: `Puxador Perfil Alumínio Champagne 3m`,
      codigo: `PUX-CHAMPAGNE-3M`,
      descricao: `Perfil gola tipo cava acabamento anodizado champagne fosco.`,
      unidade: `barra`,
      cor: `Champagne`,
      espessura_mm: null,
      acabamento: `Anodizado`,
      custo_unitario: 95,
      preco_unitario: 160,
      estoque_minimo: 4,
      estoque_atual: 9,
      ativo: true,
      created_at: t(-70),
      updated_at: t(-2)
    }, {
      id: `mat-7`,
      tenant_id: R,
      categoria: `consumivel`,
      nome: `Fita de Borda PVC 22x1mm Louro Freijó (Rolo 100m)`,
      codigo: `FITA-FREIJO-22`,
      descricao: `Fita PVC com textura idêntica ao MDF Freijó para colagem hotmelt.`,
      unidade: `rolo`,
      cor: `Louro Freijó`,
      espessura_mm: 1,
      acabamento: `Fosco`,
      custo_unitario: 140,
      preco_unitario: 220,
      estoque_minimo: 2,
      estoque_atual: 4,
      ativo: true,
      created_at: t(-80),
      updated_at: t(-2)
    }, {
      id: `mat-8`,
      tenant_id: R,
      categoria: `consumivel`,
      nome: `Cola Granulada Hotmelt Termofusível (Saco 25kg)`,
      codigo: `COLA-HOTMELT-25`,
      descricao: `Adesivo granulado especial para coladeiras de borda de alta velocidade.`,
      unidade: `saco`,
      cor: `Transparente`,
      espessura_mm: null,
      acabamento: null,
      custo_unitario: 420,
      preco_unitario: 580,
      estoque_minimo: 2,
      estoque_atual: 1,
      ativo: true,
      created_at: t(-60),
      updated_at: t(-1)
    }],
    movimentacoes_estoque: [{
      id: `mov-1`,
      tenant_id: R,
      material_id: `mat-1`,
      tipo: `entrada`,
      quantidade: 10,
      custo_unitario: 285.5,
      motivo: `Compra de reposição Duratex NF 18290`,
      projeto_id: null,
      created_by: z,
      created_at: t(-12)
    }, {
      id: `mov-2`,
      tenant_id: R,
      material_id: `mat-1`,
      tipo: `saida`,
      quantidade: 4,
      custo_unitario: 285.5,
      motivo: `Corte das frentes da Cozinha Gourmet`,
      projeto_id: `proj-1`,
      created_by: Oe,
      created_at: t(-8)
    }, {
      id: `mov-3`,
      tenant_id: R,
      material_id: `mat-4`,
      tipo: `saida`,
      quantidade: 12,
      custo_unitario: 68.9,
      motivo: `Gaveteiros e despensas Apartamento 142`,
      projeto_id: `proj-1`,
      created_by: Oe,
      created_at: t(-6)
    }, {
      id: `mov-4`,
      tenant_id: R,
      material_id: `mat-3`,
      tipo: `saida`,
      quantidade: 6,
      custo_unitario: 310,
      motivo: `Mobiliário Cozinha Alphaville`,
      projeto_id: `proj-2`,
      created_by: Oe,
      created_at: t(-3)
    }],
    retalhos: [{
      id: `ret-1`,
      tenant_id: R,
      material_id: `mat-1`,
      projeto_id: `proj-1`,
      largura_cm: 120,
      altura_cm: 65,
      espessura_mm: 18,
      quantidade: 2,
      local: `Prateleira A - Setor Freijó`,
      observacoes: `Sobra de corte lateral de torre quente, ótimo estado.`,
      consumido: false,
      created_at: t(-8),
      updated_at: t(-8)
    }, {
      id: `ret-2`,
      tenant_id: R,
      material_id: `mat-2`,
      projeto_id: `proj-2`,
      largura_cm: 180,
      altura_cm: 45,
      espessura_mm: 15,
      quantidade: 3,
      local: `Palete 2 - Fundos Brancos`,
      observacoes: `Perfeito para prateleiras internas de armário alto.`,
      consumido: false,
      created_at: t(-4),
      updated_at: t(-4)
    }],
    pecas: [{
      id: `peca-1`,
      tenant_id: R,
      ambiente_id: `amb-1`,
      material_id: `mat-1`,
      nome: `Lateral Esquerda Torre Quente`,
      tipo_chapa: `mdf`,
      espessura_mm: 18,
      comprimento_cm: 240,
      largura_cm: 60,
      quantidade: 1,
      sentido_veio: `comprimento`,
      fita_tipo: `pvc`,
      borda_topo: true,
      borda_base: true,
      borda_esquerda: true,
      borda_direita: true,
      ordem: 1,
      created_at: t(-15),
      updated_at: t(-5)
    }, {
      id: `peca-2`,
      tenant_id: R,
      ambiente_id: `amb-1`,
      material_id: `mat-1`,
      nome: `Frente Gavetao Inferior 800`,
      tipo_chapa: `mdf`,
      espessura_mm: 18,
      comprimento_cm: 79.5,
      largura_cm: 34,
      quantidade: 4,
      sentido_veio: `largura`,
      fita_tipo: `pvc`,
      borda_topo: true,
      borda_base: true,
      borda_esquerda: true,
      borda_direita: true,
      ordem: 2,
      created_at: t(-15),
      updated_at: t(-5)
    }, {
      id: `peca-3`,
      tenant_id: R,
      ambiente_id: `amb-1`,
      material_id: `mat-2`,
      nome: `Divisória Interna Balcão Pia`,
      tipo_chapa: `mdf`,
      espessura_mm: 15,
      comprimento_cm: 72,
      largura_cm: 55,
      quantidade: 2,
      sentido_veio: `sem_veio`,
      fita_tipo: `melamina`,
      borda_topo: true,
      borda_base: false,
      borda_esquerda: false,
      borda_direita: true,
      ordem: 3,
      created_at: t(-15),
      updated_at: t(-5)
    }],
    orcamentos: [{
      id: `orc-1`,
      tenant_id: R,
      projeto_id: `proj-1`,
      cliente_id: `cli-1`,
      versao: 1,
      status: `aprovado`,
      material_custo: 14200,
      ferragens_custo: 5800,
      perda_percent: 5,
      operacional_custo: 3200,
      montagem_horas: 32,
      montagem_valor_hora: 85,
      frete: 650,
      impostos_percent: 6,
      margem_percent: 35,
      subtotal: 26570,
      total: 42800,
      validade_dias: 15,
      observacoes: `Orçamento aprovado pelo cliente com 50% de entrada e saldo em 3x.`,
      created_by: z,
      created_at: t(-20),
      updated_at: t(-18)
    }, {
      id: `orc-2`,
      tenant_id: R,
      projeto_id: `proj-2`,
      cliente_id: `cli-2`,
      versao: 1,
      status: `aprovado`,
      material_custo: 28900,
      ferragens_custo: 11400,
      perda_percent: 5,
      operacional_custo: 6500,
      montagem_horas: 60,
      montagem_valor_hora: 85,
      frete: 1200,
      impostos_percent: 6,
      margem_percent: 35,
      subtotal: 53100,
      total: 84500,
      validade_dias: 20,
      observacoes: `Mobiliário residencial completo Alphaville Campinas.`,
      created_by: ke,
      created_at: t(-14),
      updated_at: t(-12)
    }, {
      id: `orc-3`,
      tenant_id: R,
      projeto_id: `proj-4`,
      cliente_id: `cli-3`,
      versao: 1,
      status: `enviado`,
      material_custo: 8200,
      ferragens_custo: 3100,
      perda_percent: 5,
      operacional_custo: 1800,
      montagem_horas: 16,
      montagem_valor_hora: 85,
      frete: 450,
      impostos_percent: 6,
      margem_percent: 35,
      subtotal: 14910,
      total: 23800,
      validade_dias: 10,
      observacoes: `Proposta enviada por e-mail e WhatsApp para os noivos.`,
      created_by: z,
      created_at: t(-5),
      updated_at: t(-3)
    }],
    orcamento_itens: [{
      id: `item-1`,
      tenant_id: R,
      orcamento_id: `orc-1`,
      ambiente_id: `amb-1`,
      ambiente_nome: `Cozinha Gourmet`,
      descricao: `Mobiliário completo de Cozinha: Ilha, Torre Quente e Armários Aéreos com amortecimento`,
      quantidade: 1,
      custo_unitario: 18200,
      valor_unitario: 28500,
      ordem: 1,
      created_at: t(-20),
      updated_at: t(-20)
    }, {
      id: `item-2`,
      tenant_id: R,
      orcamento_id: `orc-1`,
      ambiente_id: `amb-2`,
      ambiente_nome: `Suíte Master & Closet`,
      descricao: `Closet planejado com portas espelhadas, gaveteiros de veludo e nichos de calçados`,
      quantidade: 1,
      custo_unitario: 8370,
      valor_unitario: 14300,
      ordem: 2,
      created_at: t(-20),
      updated_at: t(-20)
    }, {
      id: `item-3`,
      tenant_id: R,
      orcamento_id: `orc-2`,
      ambiente_id: `amb-3`,
      ambiente_nome: `Cozinha Integrada`,
      descricao: `Armários sob medida com acabamento Grafite Matt e Louro Freijó`,
      quantidade: 1,
      custo_unitario: 32000,
      valor_unitario: 52000,
      ordem: 1,
      created_at: t(-14),
      updated_at: t(-14)
    }, {
      id: `item-4`,
      tenant_id: R,
      orcamento_id: `orc-2`,
      ambiente_id: `amb-4`,
      ambiente_nome: `Área Gourmet Externa`,
      descricao: `Bancadas em MDF naval e armários para área de churrasqueira`,
      quantidade: 1,
      custo_unitario: 21100,
      valor_unitario: 32500,
      ordem: 2,
      created_at: t(-14),
      updated_at: t(-14)
    }],
    ordens_servico: [{
      id: `os-1`,
      tenant_id: R,
      projeto_id: `proj-1`,
      numero: `OS-202609-0001`,
      status: `em_montagem`,
      data_prevista_entrega: e(3),
      data_entrega_real: null,
      montador_id: Oe,
      frete: 650,
      montagem_horas: 32,
      observacoes: `Montagem em andamento no Apto 142. Caixarias concluídas, iniciando instalação de frentes.`,
      created_by: z,
      created_at: t(-12),
      updated_at: t(-1)
    }, {
      id: `os-2`,
      tenant_id: R,
      projeto_id: `proj-2`,
      numero: `OS-202609-0002`,
      status: `furacao_borda`,
      data_prevista_entrega: e(12),
      data_entrega_real: null,
      montador_id: Oe,
      frete: 1200,
      montagem_horas: 60,
      observacoes: `Corte finalizado na seccionadora. Peças em processo de furação e fita de borda PUR.`,
      created_by: z,
      created_at: t(-7),
      updated_at: t(-2)
    }, {
      id: `os-3`,
      tenant_id: R,
      projeto_id: `proj-3`,
      numero: `OS-202609-0003`,
      status: `aguardando_montagem`,
      data_prevista_entrega: e(5),
      data_entrega_real: null,
      montador_id: Oe,
      frete: 800,
      montagem_horas: 24,
      observacoes: `Mobiliário embalado com plástico bolha e cantoneiras, pronto para transporte no sábado.`,
      created_by: z,
      created_at: t(-10),
      updated_at: t(-1)
    }, {
      id: `os-4`,
      tenant_id: R,
      projeto_id: `proj-5`,
      numero: `OS-202608-0012`,
      status: `concluido`,
      data_prevista_entrega: e(-10),
      data_entrega_real: e(-10),
      montador_id: Oe,
      frete: 400,
      montagem_horas: 16,
      observacoes: `Montagem finalizada e inspecionada. Cliente 100% satisfeito.`,
      created_by: z,
      created_at: t(-40),
      updated_at: t(-10)
    }],
    termos_conclusao: [{
      id: `trm-1`,
      tenant_id: R,
      projeto_id: `proj-5`,
      os_id: `os-4`,
      conteudo: `Declaro que recebi todos os móveis planejados contratados em perfeitas condições de uso, acabamento e funcionamento de portas, gavetas e acessórios, nada tendo a reclamar quanto à montagem.`,
      signatario_nome: `Camila Siqueira`,
      signatario_documento: `234.567.890-88`,
      assinatura_data: t(-10),
      assinado_em: t(-10),
      created_by: z,
      created_at: t(-10),
      updated_at: t(-10)
    }],
    fornecedores: [{
      id: `forn-1`,
      tenant_id: R,
      nome: `Duratex / Dexco Madeiras`,
      documento: `97.837.181/0001-47`,
      email: `pedidos.sp@dex.co`,
      telefone: `(11) 3179-7733`,
      endereco: `Av. Paulista, 1938 - Bela Vista`,
      cidade: `São Paulo`,
      uf: `SP`,
      cep: `01310-200`,
      observacoes: `Fornecedor oficial de MDFs Louro Freijó, Branco Supremo e Grafite.`,
      created_by: z,
      created_at: t(-100),
      updated_at: t(-10)
    }, {
      id: `forn-2`,
      tenant_id: R,
      nome: `FGV TN Ferragens do Brasil`,
      documento: `03.456.789/0001-01`,
      email: `vendas@fgvtn.com.br`,
      telefone: `(41) 2107-4000`,
      endereco: `Rua das Indústrias, 400 - CIC`,
      cidade: `Curitiba`,
      uf: `PR`,
      cep: `81260-000`,
      observacoes: `Corrediças slowmotion, dobradiças clip-on e pistões a gás.`,
      created_by: z,
      created_at: t(-95),
      updated_at: t(-5)
    }, {
      id: `forn-3`,
      tenant_id: R,
      nome: `Leo Madeiras Express`,
      documento: `61.345.678/0001-12`,
      email: `loja.moveis@leomadeiras.com.br`,
      telefone: `(11) 3838-5000`,
      endereco: `Rua do Gasômetro, 350 - Brás`,
      cidade: `São Paulo`,
      uf: `SP`,
      cep: `03004-000`,
      observacoes: `Compras de emergência, parafusos, colas e consumíveis.`,
      created_by: z,
      created_at: t(-80),
      updated_at: t(-2)
    }],
    categorias_financeiras: [{
      id: `cat-1`,
      tenant_id: R,
      nome: `Venda de Projetos e Móveis`,
      tipo: `receita`,
      cor: `#10b981`,
      ativo: true,
      created_at: t(-100),
      updated_at: t(-10)
    }, {
      id: `cat-2`,
      tenant_id: R,
      nome: `Serviços de Ajuste & Manutenção`,
      tipo: `receita`,
      cor: `#3b82f6`,
      ativo: true,
      created_at: t(-100),
      updated_at: t(-10)
    }, {
      id: `cat-3`,
      tenant_id: R,
      nome: `Compra de Chapas MDF e Madeira`,
      tipo: `despesa`,
      cor: `#ef4444`,
      ativo: true,
      created_at: t(-100),
      updated_at: t(-10)
    }, {
      id: `cat-4`,
      tenant_id: R,
      nome: `Ferragens e Acessórios`,
      tipo: `despesa`,
      cor: `#f59e0b`,
      ativo: true,
      created_at: t(-100),
      updated_at: t(-10)
    }, {
      id: `cat-5`,
      tenant_id: R,
      nome: `Mão de Obra e Diárias Montadores`,
      tipo: `despesa`,
      cor: `#8b5cf6`,
      ativo: true,
      created_at: t(-100),
      updated_at: t(-10)
    }, {
      id: `cat-6`,
      tenant_id: R,
      nome: `Frete e Logística de Entrega`,
      tipo: `despesa`,
      cor: `#ec4899`,
      ativo: true,
      created_at: t(-100),
      updated_at: t(-10)
    }],
    contratos: [{
      id: `ct-1`,
      tenant_id: R,
      projeto_id: `proj-1`,
      cliente_id: `cli-1`,
      orcamento_id: `orc-1`,
      numero: `CT-202609-0001`,
      status: `assinado`,
      valor_total: 42800,
      num_parcelas: 4,
      intervalo_dias: 30,
      primeiro_vencimento: e(-15),
      conteudo: `Contrato de fornecimento de móveis planejados para Cozinha Gourmet e Suíte Master.`,
      termos: `Pagamento em 4 parcelas iguais. Garantia estendida de 3 anos.`,
      observacoes: `Entrada paga à vista via PIX.`,
      signatario_nome: `Juliana Martins`,
      signatario_documento: `345.890.123-04`,
      assinatura_data: t(-18),
      assinado_em: t(-18),
      created_by: z,
      created_at: t(-18),
      updated_at: t(-18)
    }, {
      id: `ct-2`,
      tenant_id: R,
      projeto_id: `proj-2`,
      cliente_id: `cli-2`,
      orcamento_id: `orc-2`,
      numero: `CT-202609-0002`,
      status: `assinado`,
      valor_total: 84500,
      num_parcelas: 5,
      intervalo_dias: 30,
      primeiro_vencimento: e(-10),
      conteudo: `Contrato de projeto de marcenaria de alto padrão Residência Alphaville.`,
      termos: `Parcelamento em 5 vezes mensais conforme cronograma físico de entrega.`,
      observacoes: `Primeira parcela recebida no fechamento.`,
      signatario_nome: `Ricardo Vasconcellos`,
      signatario_documento: `198.765.432-11`,
      assinatura_data: t(-12),
      assinado_em: t(-12),
      created_by: ke,
      created_at: t(-12),
      updated_at: t(-12)
    }],
    lancamentos: [{
      id: `lan-1`,
      tenant_id: R,
      tipo: `receita`,
      status: `pago`,
      origem: `contrato`,
      descricao: `Parcela 1/4 do contrato CT-202609-0001 (Entrada)`,
      categoria_id: `cat-1`,
      contrato_id: `ct-1`,
      parcela_numero: 1,
      cliente_id: `cli-1`,
      fornecedor_id: null,
      projeto_id: `proj-1`,
      valor: 10700,
      vencimento: e(-15),
      pago_em: t(-15),
      valor_pago: 10700,
      forma_pagamento: `pix`,
      observacoes: `Comprovante PIX recebido no ato da assinatura.`,
      created_by: z,
      created_at: t(-18),
      updated_at: t(-15)
    }, {
      id: `lan-2`,
      tenant_id: R,
      tipo: `receita`,
      status: `previsto`,
      origem: `contrato`,
      descricao: `Parcela 2/4 do contrato CT-202609-0001`,
      categoria_id: `cat-1`,
      contrato_id: `ct-1`,
      parcela_numero: 2,
      cliente_id: `cli-1`,
      fornecedor_id: null,
      projeto_id: `proj-1`,
      valor: 10700,
      vencimento: e(15),
      pago_em: null,
      valor_pago: null,
      forma_pagamento: `transferencia`,
      observacoes: null,
      created_by: z,
      created_at: t(-18),
      updated_at: t(-18)
    }, {
      id: `lan-3`,
      tenant_id: R,
      tipo: `receita`,
      status: `previsto`,
      origem: `contrato`,
      descricao: `Parcela 3/4 do contrato CT-202609-0001`,
      categoria_id: `cat-1`,
      contrato_id: `ct-1`,
      parcela_numero: 3,
      cliente_id: `cli-1`,
      fornecedor_id: null,
      projeto_id: `proj-1`,
      valor: 10700,
      vencimento: e(45),
      pago_em: null,
      valor_pago: null,
      forma_pagamento: `transferencia`,
      observacoes: null,
      created_by: z,
      created_at: t(-18),
      updated_at: t(-18)
    }, {
      id: `lan-4`,
      tenant_id: R,
      tipo: `receita`,
      status: `pago`,
      origem: `contrato`,
      descricao: `Parcela 1/5 do contrato CT-202609-0002 (Entrada)`,
      categoria_id: `cat-1`,
      contrato_id: `ct-2`,
      parcela_numero: 1,
      cliente_id: `cli-2`,
      fornecedor_id: null,
      projeto_id: `proj-2`,
      valor: 16900,
      vencimento: e(-10),
      pago_em: t(-10),
      valor_pago: 16900,
      forma_pagamento: `pix`,
      observacoes: `Pago pontualmente.`,
      created_by: z,
      created_at: t(-12),
      updated_at: t(-10)
    }, {
      id: `lan-5`,
      tenant_id: R,
      tipo: `receita`,
      status: `previsto`,
      origem: `contrato`,
      descricao: `Parcela 2/5 do contrato CT-202609-0002`,
      categoria_id: `cat-1`,
      contrato_id: `ct-2`,
      parcela_numero: 2,
      cliente_id: `cli-2`,
      fornecedor_id: null,
      projeto_id: `proj-2`,
      valor: 16900,
      vencimento: e(20),
      pago_em: null,
      valor_pago: null,
      forma_pagamento: `boleto`,
      observacoes: null,
      created_by: z,
      created_at: t(-12),
      updated_at: t(-12)
    }, {
      id: `lan-6`,
      tenant_id: R,
      tipo: `despesa`,
      status: `pago`,
      origem: `manual`,
      descricao: `Compra de MDFs Freijó e Supremo - Duratex NF 18290`,
      categoria_id: `cat-3`,
      contrato_id: null,
      parcela_numero: null,
      cliente_id: null,
      fornecedor_id: `forn-1`,
      projeto_id: `proj-1`,
      valor: 7850,
      vencimento: e(-12),
      pago_em: t(-12),
      valor_pago: 7850,
      forma_pagamento: `boleto`,
      observacoes: `Faturado em 14 dias.`,
      created_by: z,
      created_at: t(-15),
      updated_at: t(-12)
    }, {
      id: `lan-7`,
      tenant_id: R,
      tipo: `despesa`,
      status: `pago`,
      origem: `manual`,
      descricao: `Ferragens e Corrediças Slow FGV - Pedido 5542`,
      categoria_id: `cat-4`,
      contrato_id: null,
      parcela_numero: null,
      cliente_id: null,
      fornecedor_id: `forn-2`,
      projeto_id: `proj-1`,
      valor: 3420,
      vencimento: e(-8),
      pago_em: t(-8),
      valor_pago: 3420,
      forma_pagamento: `pix`,
      observacoes: `Desconto de 5% à vista.`,
      created_by: z,
      created_at: t(-10),
      updated_at: t(-8)
    }, {
      id: `lan-8`,
      tenant_id: R,
      tipo: `despesa`,
      status: `previsto`,
      origem: `manual`,
      descricao: `Diária de montagem externa Alphaville - Equipe 2`,
      categoria_id: `cat-5`,
      contrato_id: null,
      parcela_numero: null,
      cliente_id: null,
      fornecedor_id: null,
      projeto_id: `proj-2`,
      valor: 2400,
      vencimento: e(14),
      pago_em: null,
      valor_pago: null,
      forma_pagamento: `pix`,
      observacoes: `Pagamento após conclusão e vistoria do cliente.`,
      created_by: z,
      created_at: t(-5),
      updated_at: t(-5)
    }],
    modulos_catalogo: [{
      id: `mod-1`,
      tenant_id: R,
      categoria: `vertical`,
      nome: `Armário vertical 300`,
      largura_mm: 300,
      altura_mm: 720,
      profundidade_mm: 450,
      portas: 1,
      gavetas: 0,
      cor: null,
      ordem: 10,
      ativo: true,
      created_at: t(-100),
      updated_at: t(-100)
    }, {
      id: `mod-2`,
      tenant_id: R,
      categoria: `vertical`,
      nome: `Armário vertical 600`,
      largura_mm: 600,
      altura_mm: 720,
      profundidade_mm: 450,
      portas: 2,
      gavetas: 0,
      cor: null,
      ordem: 30,
      ativo: true,
      created_at: t(-100),
      updated_at: t(-100)
    }, {
      id: `mod-3`,
      tenant_id: R,
      categoria: `horizontal`,
      nome: `Aéreo 600`,
      largura_mm: 600,
      altura_mm: 700,
      profundidade_mm: 350,
      portas: 2,
      gavetas: 0,
      cor: null,
      ordem: 10,
      ativo: true,
      created_at: t(-100),
      updated_at: t(-100)
    }, {
      id: `mod-4`,
      tenant_id: R,
      categoria: `horizontal`,
      nome: `Aéreo 800`,
      largura_mm: 800,
      altura_mm: 700,
      profundidade_mm: 350,
      portas: 2,
      gavetas: 0,
      cor: null,
      ordem: 20,
      ativo: true,
      created_at: t(-100),
      updated_at: t(-100)
    }, {
      id: `mod-5`,
      tenant_id: R,
      categoria: `gaveteiro`,
      nome: `Gaveteiro 600 (4 gavetas)`,
      largura_mm: 600,
      altura_mm: 720,
      profundidade_mm: 450,
      portas: 0,
      gavetas: 4,
      cor: null,
      ordem: 20,
      ativo: true,
      created_at: t(-100),
      updated_at: t(-100)
    }, {
      id: `mod-6`,
      tenant_id: R,
      categoria: `eletrodomestico`,
      nome: `Geladeira frost free`,
      largura_mm: 700,
      altura_mm: 1850,
      profundidade_mm: 700,
      portas: 2,
      gavetas: 0,
      cor: null,
      ordem: 30,
      ativo: true,
      created_at: t(-100),
      updated_at: t(-100)
    }, {
      id: `mod-7`,
      tenant_id: R,
      categoria: `eletrodomestico`,
      nome: `Pia 1200 com gabinete`,
      largura_mm: 1200,
      altura_mm: 900,
      profundidade_mm: 600,
      portas: 2,
      gavetas: 0,
      cor: null,
      ordem: 40,
      ativo: true,
      created_at: t(-100),
      updated_at: t(-100)
    }, {
      id: `mod-8`,
      tenant_id: R,
      categoria: `guarda_roupa`,
      nome: `Guarda-roupa 6 portas`,
      largura_mm: 2400,
      altura_mm: 2400,
      profundidade_mm: 600,
      portas: 6,
      gavetas: 0,
      cor: null,
      ordem: 10,
      ativo: true,
      created_at: t(-100),
      updated_at: t(-100)
    }],
    designs: [{
      id: `dsg-1`,
      tenant_id: R,
      projeto_id: `proj-1`,
      ambiente_id: `amb-1`,
      nome: `Estudo 3D - Cozinha Gourmet Integrada`,
      largura_mm: 3800,
      altura_mm: 2700,
      profundidade_mm: 2600,
      cena: {
        comodo: {
          largura: 3800,
          altura: 2700,
          profundidade: 2600,
          tipo: `cozinha`
        },
        cenario: {
          preset: `cozinha`,
          piso: ``,
          parede: ``
        },
        componentes: [{
          id: `comp-2`,
          tipo: `coifa`,
          parede: `fundo`,
          x: 1600,
          y: 1550,
          largura: 600,
          altura: 600,
          profundidade: 450,
          visivel: true
        }, {
          id: `comp-3`,
          tipo: `tomada`,
          parede: `fundo`,
          x: 1350,
          y: 1050,
          largura: 80,
          altura: 120,
          profundidade: 15,
          visivel: true
        }, {
          id: `comp-4`,
          tipo: `tomada`,
          parede: `fundo`,
          x: 2100,
          y: 1050,
          largura: 80,
          altura: 120,
          profundidade: 15,
          visivel: true
        }],
        modulos: [{
          id: `m-1`,
          catalogo_id: `mod-6`,
          nome: `Geladeira Frost Free`,
          categoria: `eletrodomestico`,
          x: 350,
          y: 925,
          z: 350,
          largura: 700,
          altura: 1850,
          profundidade: 700,
          rotacao: 0,
          cor: `#2f343b`,
          portas: 2,
          gavetas: 0,
          espessura: 15,
          prateleiras: 3,
          divisorias: 0,
          acabamentoCaixaria: `branco-tx`,
          acabamentoFrente: `grafite-silk`,
          puxador: `perfil_alca`,
          tipoPorta: `giro`,
          portasAbertas: false,
          visivel: true
        }, {
          id: `m-2`,
          catalogo_id: `mod-2`,
          nome: `Torre Quente / Forno`,
          categoria: `vertical`,
          x: 1000,
          y: 1050,
          z: 300,
          largura: 600,
          altura: 2100,
          profundidade: 600,
          rotacao: 0,
          cor: `#c89d6c`,
          portas: 2,
          gavetas: 2,
          espessura: 18,
          prateleiras: 2,
          divisorias: 1,
          acabamentoCaixaria: `branco-tx`,
          acabamentoFrente: `freijo-natural`,
          puxador: `perfil_alca`,
          tipoPorta: `giro`,
          portasAbertas: false,
          visivel: true
        }, {
          id: `m-3`,
          catalogo_id: `mod-5`,
          nome: `Gaveteiro Balcão Cooktop`,
          categoria: `gaveteiro`,
          x: 1600,
          y: 430,
          z: 300,
          largura: 600,
          altura: 860,
          profundidade: 600,
          rotacao: 0,
          cor: `#2f343b`,
          portas: 0,
          gavetas: 4,
          espessura: 18,
          prateleiras: 0,
          divisorias: 0,
          acabamentoCaixaria: `branco-tx`,
          acabamentoFrente: `grafite-silk`,
          puxador: `perfil_alca`,
          tipoPorta: `nenhuma`,
          portasAbertas: false,
          visivel: true
        }, {
          id: `m-4`,
          catalogo_id: `mod-7`,
          nome: `Pia 1200 com Gabinete`,
          categoria: `eletrodomestico`,
          x: 2500,
          y: 430,
          z: 300,
          largura: 1200,
          altura: 860,
          profundidade: 600,
          rotacao: 0,
          cor: `#c89d6c`,
          portas: 2,
          gavetas: 2,
          espessura: 18,
          prateleiras: 1,
          divisorias: 1,
          acabamentoCaixaria: `branco-tx`,
          acabamentoFrente: `freijo-natural`,
          puxador: `perfil_alca`,
          tipoPorta: `giro`,
          portasAbertas: false,
          visivel: true
        }, {
          id: `m-5`,
          catalogo_id: `mod-1`,
          nome: `Balcão Terminal 2 Portas`,
          categoria: `vertical`,
          x: 3450,
          y: 430,
          z: 300,
          largura: 700,
          altura: 860,
          profundidade: 600,
          rotacao: 0,
          cor: `#c89d6c`,
          portas: 2,
          gavetas: 0,
          espessura: 18,
          prateleiras: 2,
          divisorias: 0,
          acabamentoCaixaria: `branco-tx`,
          acabamentoFrente: `freijo-natural`,
          puxador: `perfil_alca`,
          tipoPorta: `giro`,
          portasAbertas: false,
          visivel: true
        }, {
          id: `m-6`,
          catalogo_id: `mod-3`,
          nome: `Aéreo Superior 900`,
          categoria: `horizontal`,
          x: 2350,
          y: 1850,
          z: 175,
          largura: 900,
          altura: 700,
          profundidade: 350,
          rotacao: 0,
          cor: `#c89d6c`,
          portas: 2,
          gavetas: 0,
          espessura: 18,
          prateleiras: 1,
          divisorias: 0,
          acabamentoCaixaria: `branco-tx`,
          acabamentoFrente: `freijo-natural`,
          puxador: `perfil_alca`,
          tipoPorta: `giro`,
          portasAbertas: false,
          visivel: true
        }, {
          id: `m-7`,
          catalogo_id: `mod-4`,
          nome: `Aéreo Superior 1000`,
          categoria: `horizontal`,
          x: 3300,
          y: 1850,
          z: 175,
          largura: 1000,
          altura: 700,
          profundidade: 350,
          rotacao: 0,
          cor: `#c89d6c`,
          portas: 2,
          gavetas: 0,
          espessura: 18,
          prateleiras: 2,
          divisorias: 1,
          acabamentoCaixaria: `branco-tx`,
          acabamentoFrente: `freijo-natural`,
          puxador: `perfil_alca`,
          tipoPorta: `giro`,
          portasAbertas: false,
          visivel: true
        }]
      },
      observacoes: `Cozinha completa com ilha, torre quente e aéreos iluminados.`,
      created_by: z,
      created_at: t(-18),
      updated_at: t(-5)
    }, {
      id: `dsg-2`,
      tenant_id: R,
      projeto_id: `proj-1`,
      ambiente_id: `amb-2`,
      nome: `Estudo 3D - Suíte Master & Closet`,
      largura_mm: 4200,
      altura_mm: 2650,
      profundidade_mm: 3500,
      cena: {
        comodo: {
          largura: 4200,
          altura: 2650,
          profundidade: 3500,
          tipo: `quarto`
        },
        cenario: {
          preset: `dormitorio`,
          piso: ``,
          parede: ``
        },
        componentes: [{
          id: `comp-q1`,
          tipo: `porta`,
          parede: `direita`,
          x: 1200,
          y: 1050,
          largura: 800,
          altura: 2100,
          profundidade: 35,
          visivel: true
        }, {
          id: `comp-q2`,
          tipo: `janela`,
          parede: `esquerda`,
          x: 1800,
          y: 1500,
          largura: 1400,
          altura: 1200,
          profundidade: 80,
          visivel: true
        }],
        modulos: [{
          id: `mq-1`,
          catalogo_id: `mod-8`,
          nome: `Guarda-Roupa 6 Portas Master`,
          categoria: `guarda_roupa`,
          x: 1200,
          y: 1200,
          z: 300,
          largura: 2400,
          altura: 2400,
          profundidade: 600,
          rotacao: 0,
          cor: `#baa082`,
          portas: 6,
          gavetas: 4,
          espessura: 18,
          prateleiras: 4,
          divisorias: 2,
          acabamentoCaixaria: `branco-tx`,
          acabamentoFrente: `carvalho-malva`,
          puxador: `perfil_alca`,
          tipoPorta: `giro`,
          portasAbertas: false,
          visivel: true
        }, {
          id: `mq-2`,
          catalogo_id: `mod-1`,
          nome: `Módulo Sapateira / Nichos`,
          categoria: `vertical`,
          x: 2700,
          y: 1200,
          z: 225,
          largura: 600,
          altura: 2400,
          profundidade: 450,
          rotacao: 0,
          cor: `#ded8cc`,
          portas: 1,
          gavetas: 2,
          espessura: 18,
          prateleiras: 5,
          divisorias: 0,
          acabamentoCaixaria: `branco-tx`,
          acabamentoFrente: `areia-suave`,
          puxador: `perfil_alca`,
          tipoPorta: `giro`,
          portasAbertas: false,
          visivel: true
        }, {
          id: `mq-3`,
          catalogo_id: null,
          nome: `Bancada Penteadeira / Make`,
          categoria: `mesa`,
          x: 3600,
          y: 380,
          z: 250,
          largura: 1200,
          altura: 760,
          profundidade: 500,
          rotacao: 0,
          cor: `#ded8cc`,
          portas: 0,
          gavetas: 3,
          espessura: 25,
          prateleiras: 0,
          divisorias: 0,
          acabamentoCaixaria: `branco-tx`,
          acabamentoFrente: `areia-suave`,
          puxador: `perfil_alca`,
          tipoPorta: `nenhuma`,
          portasAbertas: false,
          visivel: true
        }, {
          id: `mq-4`,
          catalogo_id: `mod-3`,
          nome: `Painel Superior com Espelho`,
          categoria: `horizontal`,
          x: 3600,
          y: 1650,
          z: 75,
          largura: 1200,
          altura: 900,
          profundidade: 150,
          rotacao: 0,
          cor: `#baa082`,
          portas: 1,
          gavetas: 0,
          espessura: 18,
          prateleiras: 2,
          divisorias: 0,
          acabamentoCaixaria: `branco-tx`,
          acabamentoFrente: `carvalho-malva`,
          puxador: `perfil_alca`,
          tipoPorta: `giro`,
          portasAbertas: false,
          visivel: true
        }]
      },
      observacoes: `Closet sofisticado com iluminação indireta nos nichos.`,
      created_by: z,
      created_at: t(-15),
      updated_at: t(-2)
    }, {
      id: `dsg-3`,
      tenant_id: R,
      projeto_id: `proj-2`,
      ambiente_id: `amb-3`,
      nome: `Estudo 3D - Home Theater & Estar Alphaville`,
      largura_mm: 4500,
      altura_mm: 2800,
      profundidade_mm: 3200,
      cena: {
        comodo: {
          largura: 4500,
          altura: 2800,
          profundidade: 3200,
          tipo: `sala`
        },
        cenario: {
          preset: `sala`,
          piso: ``,
          parede: ``
        },
        componentes: [{
          id: `comp-s1`,
          tipo: `tv`,
          parede: `fundo`,
          x: 2250,
          y: 1450,
          largura: 1650,
          altura: 950,
          profundidade: 60,
          visivel: true
        }, {
          id: `comp-s2`,
          tipo: `ar_condicionado`,
          parede: `direita`,
          x: 1500,
          y: 2400,
          largura: 900,
          altura: 300,
          profundidade: 220,
          visivel: true
        }],
        modulos: [{
          id: `ms-1`,
          catalogo_id: `mod-2`,
          nome: `Cristaleira Iluminada Esquerda`,
          categoria: `vertical`,
          x: 450,
          y: 1200,
          z: 225,
          largura: 600,
          altura: 2400,
          profundidade: 450,
          rotacao: 0,
          cor: `#2f343b`,
          portas: 2,
          gavetas: 0,
          espessura: 18,
          prateleiras: 5,
          divisorias: 0,
          acabamentoCaixaria: `branco-tx`,
          acabamentoFrente: `grafite-silk`,
          puxador: `perfil_alca`,
          tipoPorta: `giro`,
          portasAbertas: false,
          visivel: true
        }, {
          id: `ms-2`,
          catalogo_id: `mod-5`,
          nome: `Rack Suspenso Ripado Central`,
          categoria: `gaveteiro`,
          x: 2250,
          y: 450,
          z: 225,
          largura: 3000,
          altura: 500,
          profundidade: 450,
          rotacao: 0,
          cor: `#b88a53`,
          portas: 0,
          gavetas: 6,
          espessura: 18,
          prateleiras: 0,
          divisorias: 0,
          acabamentoCaixaria: `branco-tx`,
          acabamentoFrente: `louro-freijo`,
          puxador: `perfil_alca`,
          tipoPorta: `nenhuma`,
          portasAbertas: false,
          visivel: true
        }, {
          id: `ms-3`,
          catalogo_id: `mod-2`,
          nome: `Adega / Bar Vertical Direito`,
          categoria: `vertical`,
          x: 4050,
          y: 1200,
          z: 225,
          largura: 600,
          altura: 2400,
          profundidade: 450,
          rotacao: 0,
          cor: `#2f343b`,
          portas: 2,
          gavetas: 0,
          espessura: 18,
          prateleiras: 5,
          divisorias: 0,
          acabamentoCaixaria: `branco-tx`,
          acabamentoFrente: `grafite-silk`,
          puxador: `perfil_alca`,
          tipoPorta: `giro`,
          portasAbertas: false,
          visivel: true
        }]
      },
      observacoes: `Mobiliário para Home Theater com painel ripado e cristaleiras.`,
      created_by: ke,
      created_at: t(-10),
      updated_at: t(-1)
    }]
  };
}
var je = [`cozinha`, `quarto`, `sala`, `banheiro`, `escritorio`, `area_externa`, `outro`];
var Me = `outro`;
var Ne = {
  cozinha: `Cozinha`,
  quarto: `Quarto`,
  sala: `Sala`,
  banheiro: `Banheiro`,
  escritorio: `Escritório`,
  area_externa: `Área externa`,
  outro: `Outro`
};
var Pe = 2000;
var Fe = 1000;
var Ie = [{
  id: `cozinha-padrao`,
  nome: `Cozinha padrão`,
  tipo: `cozinha`,
  largura_cm: 300,
  altura_cm: 230,
  profundidade_cm: 60,
  margem_percent: 35
}, {
  id: `cozinha-compacta`,
  nome: `Cozinha compacta`,
  tipo: `cozinha`,
  largura_cm: 220,
  altura_cm: 220,
  profundidade_cm: 60,
  margem_percent: 35
}, {
  id: `quarto-guarda-roupa`,
  nome: `Quarto com guarda-roupa`,
  tipo: `quarto`,
  largura_cm: 300,
  altura_cm: 270,
  profundidade_cm: 65,
  margem_percent: 40
}, {
  id: `quarto-solteiro`,
  nome: `Quarto de solteiro`,
  tipo: `quarto`,
  largura_cm: 200,
  altura_cm: 250,
  profundidade_cm: 60,
  margem_percent: 40
}, {
  id: `closet`,
  nome: `Closet`,
  tipo: `quarto`,
  largura_cm: 400,
  altura_cm: 270,
  profundidade_cm: 65,
  margem_percent: 45
}, {
  id: `sala-home`,
  nome: `Sala com home`,
  tipo: `sala`,
  largura_cm: 350,
  altura_cm: 240,
  profundidade_cm: 45,
  margem_percent: 40
}, {
  id: `banheiro-gabinete`,
  nome: `Banheiro com gabinete`,
  tipo: `banheiro`,
  largura_cm: 100,
  altura_cm: 80,
  profundidade_cm: 50,
  margem_percent: 45
}, {
  id: `home-office`,
  nome: `Home office`,
  tipo: `escritorio`,
  largura_cm: 240,
  altura_cm: 240,
  profundidade_cm: 60,
  margem_percent: 40
}, {
  id: `area-churrasqueira`,
  nome: `Área com churrasqueira`,
  tipo: `area_externa`,
  largura_cm: 250,
  altura_cm: 220,
  profundidade_cm: 60,
  margem_percent: 35
}];
function Le(e) {
  return typeof e == `string` && je.includes(e);
}
var Re = {
  claro: {
    texto: `#14161a`,
    textoSuave: `#5b616b`,
    paredeFrente: `#f5f2ec`,
    paredeLado: `#e7e3da`,
    contorno: `#b9b2a5`,
    piso: `#efe9df`,
    acento: `#d97706`
  },
  escuro: {
    texto: `#eeebe6`,
    textoSuave: `#99958d`,
    paredeFrente: `#23262c`,
    paredeLado: `#1b1e23`,
    contorno: `#3a3e46`,
    piso: `#2a2d33`,
    acento: `#fbbf24`
  }
};
var ze = {
  largura: 960,
  altura: 620,
  margem: 56,
  areaX: 128,
  areaY: 112,
  areaLargura: 700,
  areaAltura: 300,
  cotaLarguraOffset: 44,
  cotaAlturaOffset: 34,
  rodapeOffset: 78,
  passoEtiqueta: 178,
  larguraEtiqueta: 120,
  alturaEtiqueta: 34,
  fonteTitulo: 22,
  fonteSubtitulo: 13,
  fonteCota: 13,
  fonteRotulo: 10,
  fonteValor: 13,
  fontePlaceholder: 14,
  placeholderLargura: 380,
  placeholderAltura: 240
};
var Be = Math.PI / 6;
function Ve(e) {
  let t = e === `compacta` ? 0.5 : 1;
  let n = t * 1.7;
  return {
    largura: ze.largura * t,
    altura: ze.altura * t,
    margem: ze.margem * t,
    areaX: ze.areaX * t,
    areaY: ze.areaY * t,
    areaLargura: ze.areaLargura * t,
    areaAltura: ze.areaAltura * t,
    cotaLarguraOffset: ze.cotaLarguraOffset * t,
    cotaAlturaOffset: ze.cotaAlturaOffset * t,
    rodapeOffset: ze.rodapeOffset * t,
    passoEtiqueta: ze.passoEtiqueta * t,
    larguraEtiqueta: ze.larguraEtiqueta * t,
    alturaEtiqueta: ze.alturaEtiqueta * t,
    fonteTitulo: ze.fonteTitulo * n,
    fonteSubtitulo: ze.fonteSubtitulo * n,
    fonteCota: ze.fonteCota * n,
    fonteRotulo: ze.fonteRotulo * n,
    fonteValor: ze.fonteValor * n,
    fontePlaceholder: ze.fontePlaceholder * n,
    placeholderLargura: ze.placeholderLargura * t,
    placeholderAltura: ze.placeholderAltura * t,
    maxEtiquetas: e === `compacta` ? 3 : 5
  };
}
function He(e) {
  return e.replace(/&/g, `&amp;`).replace(/</g, `&lt;`).replace(/>/g, `&gt;`).replace(/"/g, `&quot;`);
}
function Ue(e) {
  return String(Math.round(e * 100) / 100);
}
function We(e) {
  if (e == null) {
    return `-`;
  } else {
    return `${(Math.round(e * 100) / 100).toLocaleString(`pt-BR`, {
      maximumFractionDigits: 2
    })} cm`;
  }
}
function Ge(e) {
  return e.map(([e, t]) => `${Ue(e)},${Ue(t)}`).join(` `);
}
function Ke(e, t, n, r, i, a = false) {
  return `<line x1="${Ue(e)}" y1="${Ue(t)}" x2="${Ue(n)}" y2="${Ue(r)}" stroke="${i}" stroke-width="1.5"${a ? ` stroke-dasharray="4 4"` : ``} />`;
}
function qe(e, t, n, r, i, a) {
  let o = (e + t) / 2;
  let s = a * 0.45;
  return [Ke(e, n, t, n, i), Ke(e, n - s, e, n + s, i), Ke(t, n - s, t, n + s, i), `<text x="${Ue(o)}" y="${Ue(n - a * 0.75)}" fill="${i}" font-size="${Ue(a)}" font-weight="600" text-anchor="middle">${He(r)}</text>`].join(``);
}
function Je(e, t, n, r, i, a) {
  let o = (t + n) / 2;
  let s = a * 0.45;
  let c = a * 0.75;
  return [Ke(e, t, e, n, i), Ke(e - s, t, e + s, t, i), Ke(e - s, n, e + s, n, i), `<text x="${Ue(e - c)}" y="${Ue(o)}" fill="${i}" font-size="${Ue(a)}" font-weight="600" text-anchor="middle" transform="rotate(-90 ${Ue(e - c)} ${Ue(o)})">${He(r)}</text>`].join(``);
}
function Ye(e, t, n, r, i, a) {
  let o = Math.max(a.larguraEtiqueta, r.length * a.fonteValor * 0.62 + a.larguraEtiqueta * 0.25);
  let s = a.alturaEtiqueta;
  return [`<rect x="${Ue(e)}" y="${Ue(t)}" width="${Ue(o)}" height="${Ue(s)}" rx="${Ue(s * 0.18)}" fill="none" stroke="${i.contorno}" />`, `<text x="${Ue(e + s * 0.35)}" y="${Ue(t + s * 0.44)}" fill="${i.textoSuave}" font-size="${Ue(a.fonteRotulo)}" letter-spacing="0.04em">${He(n.toUpperCase())}</text>`, `<text x="${Ue(e + s * 0.35)}" y="${Ue(t + s * 0.82)}" fill="${i.texto}" font-size="${Ue(a.fonteValor)}" font-weight="600">${He(r)}</text>`].join(``);
}
function Xe(e, t = `claro`, n = `normal`) {
  let r = Re[t];
  let i = Ve(n);
  let a = i.areaY + i.areaAltura;
  let o = e.largura_cm ?? null;
  let s = e.altura_cm ?? null;
  let c = e.profundidade_cm ?? null;
  let l = o !== null && s !== null;
  let u = [];
  let d = ``;
  let f = ``;
  if (l) {
    let e = c ?? 0;
    let t = Math.min(i.areaLargura / (o + e * Math.cos(Be)), i.areaAltura / (s + e * Math.sin(Be)));
    let n = o * t;
    let l = s * t;
    let p = e * t;
    let m = p * Math.cos(Be);
    let h = p * Math.sin(Be);
    let g = i.areaX;
    let _ = a - l;
    u.push(`<polygon points="${Ge([[g + m, _ - h], [g + n + m, _ - h], [g + n + m, a - h], [g + m, a - h]])}" fill="${r.paredeFrente}" stroke="${r.contorno}" stroke-width="1.5" />`);
    u.push(`<polygon points="${Ge([[g, _], [g + m, _ - h], [g + m, a - h], [g, a]])}" fill="${r.paredeLado}" stroke="${r.contorno}" stroke-width="1.5" />`);
    u.push(`<polygon points="${Ge([[g, a], [g + m, a - h], [g + n + m, a - h], [g + n, a]])}" fill="${r.piso}" stroke="${r.contorno}" stroke-width="1.5" />`);
    d = qe(g, g + n, a + i.cotaLarguraOffset, We(o), r.acento, i.fonteCota);
    f = Je(g - i.cotaAlturaOffset, _, a, We(s), r.acento, i.fonteCota);
    if (c !== null) {
      let e = g + n + m;
      let t = a - h;
      u.push(Ke(g + n, a, e, t, r.acento, true), `<text x="${Ue(e + i.fonteCota * 0.6)}" y="${Ue(t - i.fonteCota * 0.45)}" fill="${r.acento}" font-size="${Ue(i.fonteCota)}" font-weight="600">${He(`prof. ${We(c)}`)}</text>`);
    }
  } else {
    let e = i.placeholderLargura;
    let t = i.placeholderAltura;
    let n = i.areaX + i.areaLargura * 0.08;
    let o = a - t;
    u.push(`<rect x="${Ue(n)}" y="${Ue(o)}" width="${Ue(e)}" height="${Ue(t)}" rx="${Ue(i.largura * 8 / ze.largura)}" fill="none" stroke="${r.contorno}" stroke-width="1.5" stroke-dasharray="8 6" />`, `<text x="${Ue(n + e / 2)}" y="${Ue(o + t / 2)}" fill="${r.textoSuave}" font-size="${Ue(i.fontePlaceholder)}" text-anchor="middle">Medidas do vão não registradas</text>`);
  }
  u.push(Ke(i.margem, a, i.largura - i.margem, a, r.contorno));
  let p = [];
  if (e.desnivel_cm !== null && e.desnivel_cm !== undefined && e.desnivel_cm !== 0) {
    p.push(`Desnível|${We(e.desnivel_cm)}`);
  }
  let m = e.pontos_eletricos ?? 0;
  let h = e.pontos_hidraulicos ?? 0;
  if (m > 0) {
    p.push(`Pontos elétricos|${m}`);
  }
  if (h > 0) {
    p.push(`Pontos hidráulicos|${h}`);
  }
  if (e.margem_percent !== null && e.margem_percent !== undefined) {
    p.push(`Markup|${Math.round(e.margem_percent * 100) / 100}%`);
  }
  let g = p.slice(0, i.maxEtiquetas).map((e, t) => {
    let [n, o] = e.split(`|`);
    return Ye(i.margem + t * i.passoEtiqueta, a + i.rodapeOffset, n, o, r, i);
  }).join(``);
  return [`<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 ${Ue(i.largura)} ${Ue(i.altura)}" width="${Ue(i.largura)}" height="${Ue(i.altura)}" role="img" aria-label="${He(`Mockup do ambiente ${e.nome}`)}">`, `<text x="${Ue(i.margem)}" y="${Ue(i.margem * 0.96)}" fill="${r.texto}" font-size="${Ue(i.fonteTitulo)}" font-weight="700">${He(e.nome)}</text>`, `<text x="${Ue(i.margem)}" y="${Ue(i.margem * 1.43)}" fill="${r.textoSuave}" font-size="${Ue(i.fonteSubtitulo)}">${He(Ne[e.tipo])} · vão em escala</text>`, u.join(``), d, f, g, `</svg>`].join(``);
}
function Ze(e, t = `claro`, n = `normal`) {
  return `data:image/svg+xml;charset=utf-8,${encodeURIComponent(Xe(e, t, n))}`;
}
var Qe = [`horizontal`];
var $e = [`vertical`, `horizontal`, `gaveteiro`, `eletrodomestico`, `mesa`, `guarda_roupa`, `complemento`];
function et(e, t) {
  let n = typeof e == `number` ? e : Number(e);
  if (Number.isFinite(n)) {
    return n;
  } else {
    return t;
  }
}
function tt(e) {
  if (typeof e == `string` && e !== ``) {
    return e;
  } else {
    return undefined;
  }
}
function nt(e) {
  if (!e || typeof e != `object`) {
    return null;
  }
  let t = e;
  let n = et(t.largura, 0);
  let r = et(t.altura, 0);
  let i = et(t.profundidade, 0);
  if (n <= 0 || r <= 0 || i <= 0) {
    return null;
  }
  let a = $e.includes(t.categoria) ? t.categoria : `vertical`;
  return {
    id: tt(t.id) ?? `modulo-${n}x${r}`,
    nome: tt(t.nome) ?? `Módulo`,
    categoria: a,
    largura: n,
    altura: r,
    profundidade: i,
    portas: Math.max(0, Math.trunc(et(t.portas, 0))),
    gavetas: Math.max(0, Math.trunc(et(t.gavetas, 0))),
    espessura: t.espessura === 18 || t.espessura === 25 ? Number(t.espessura) : 15,
    prateleiras: Math.max(0, Math.trunc(et(t.prateleiras, 1))),
    divisorias: Math.max(0, Math.trunc(et(t.divisorias, 0))),
    acabamentoCaixaria: tt(t.acabamentoCaixaria),
    acabamentoFrente: tt(t.acabamentoFrente),
    cor: tt(t.cor) ?? `#f5f2ec`,
    portasAbertas: t.portasAbertas === true,
    visivel: t.visivel !== false
  };
}
function rt(e) {
  let t = e.espessura ?? 15;
  let n = e.largura;
  let r = e.altura;
  let i = e.profundidade;
  let a = e.portas;
  let o = e.gavetas;
  let s = e.prateleiras ?? +(e.categoria === `vertical`);
  let c = e.divisorias ?? 0;
  let l = e.portasAbertas === true;
  let u = e.acabamentoCaixaria ?? e.cor ?? `branco-tx`;
  let d = e.acabamentoFrente ?? e.cor ?? `freijo-natural`;
  let f = [];
  let p = [];
  if (e.caixasDesenho && e.caixasDesenho.length > 0) {
    let a = Math.min(...e.caixasDesenho.map(e => e.x));
    let o = Math.max(...e.caixasDesenho.map(e => e.x + e.largura));
    let s = Math.min(...e.caixasDesenho.map(e => e.y));
    let c = Math.max(...e.caixasDesenho.map(e => e.y + e.altura));
    let m = Math.max(1, o - a);
    let h = Math.max(1, c - s);
    let g = t + 2;
    let _ = i - g;
    let v = -g / 2;
    let y = i / 2 - t / 2;
    f.push({
      id: `${e.id}-lat-esq`,
      moduloId: e.id,
      moduloNome: e.nome,
      nome: `Lateral Esquerda`,
      tipo: `lateral`,
      largura: _,
      altura: r,
      espessura: t,
      posRelativa: {
        x: -n / 2 + t / 2,
        y: 0,
        z: v
      },
      tamanho3D: {
        x: t,
        y: r,
        z: _
      },
      isFrente: false,
      isFundo: false,
      acabamento: u,
      fitaBorda: {
        topo: false,
        base: false,
        esquerda: true,
        direita: false
      }
    });
    f.push({
      id: `${e.id}-lat-dir`,
      moduloId: e.id,
      moduloNome: e.nome,
      nome: `Lateral Direita`,
      tipo: `lateral`,
      largura: _,
      altura: r,
      espessura: t,
      posRelativa: {
        x: n / 2 - t / 2,
        y: 0,
        z: v
      },
      tamanho3D: {
        x: t,
        y: r,
        z: _
      },
      isFrente: false,
      isFundo: false,
      acabamento: u,
      fitaBorda: {
        topo: false,
        base: false,
        esquerda: true,
        direita: false
      }
    });
    let b = n - t * 2;
    let x = r - t * 2;
    f.push({
      id: `${e.id}-base`,
      moduloId: e.id,
      moduloNome: e.nome,
      nome: `Base Inferior`,
      tipo: `base`,
      largura: b,
      altura: _,
      espessura: t,
      posRelativa: {
        x: 0,
        y: -r / 2 + t / 2,
        z: v
      },
      tamanho3D: {
        x: b,
        y: t,
        z: _
      },
      isFrente: false,
      isFundo: false,
      acabamento: u,
      fitaBorda: {
        topo: false,
        base: false,
        esquerda: true,
        direita: false
      }
    });
    f.push({
      id: `${e.id}-tampo`,
      moduloId: e.id,
      moduloNome: e.nome,
      nome: `Tampo Superior`,
      tipo: `tampo`,
      largura: b,
      altura: _,
      espessura: t,
      posRelativa: {
        x: 0,
        y: r / 2 - t / 2,
        z: v
      },
      tamanho3D: {
        x: b,
        y: t,
        z: _
      },
      isFrente: false,
      isFundo: false,
      acabamento: u,
      fitaBorda: {
        topo: false,
        base: false,
        esquerda: true,
        direita: false
      }
    });
    f.push({
      id: `${e.id}-fundo`,
      moduloId: e.id,
      moduloNome: e.nome,
      nome: `Fundo Traseiro 6mm`,
      tipo: `fundo`,
      largura: b + 12,
      altura: x + 12,
      espessura: 6,
      posRelativa: {
        x: 0,
        y: 0,
        z: -i / 2 + 3 + 10
      },
      tamanho3D: {
        x: b,
        y: x,
        z: 6
      },
      isFrente: false,
      isFundo: true,
      acabamento: u,
      fitaBorda: {
        topo: false,
        base: false,
        esquerda: false,
        direita: false
      }
    });
    Array.from(new Set(e.caixasDesenho.map(e => Math.round(e.x + e.largura)))).filter(e => e < o - 15).forEach((n, r) => {
      let i = n - (a + m / 2) + t / 2;
      f.push({
        id: `${e.id}-div-v-${r + 1}`,
        moduloId: e.id,
        moduloNome: e.nome,
        nome: `Divisória Vertical ${r + 1}`,
        tipo: `divisoria`,
        largura: _ - 10,
        altura: x,
        espessura: t,
        posRelativa: {
          x: i,
          y: 0,
          z: v + 5
        },
        tamanho3D: {
          x: t,
          y: x,
          z: _ - 10
        },
        isFrente: false,
        isFundo: false,
        acabamento: u,
        fitaBorda: {
          topo: false,
          base: false,
          esquerda: true,
          direita: false
        }
      });
    });
    Array.from(new Set(e.caixasDesenho.map(e => Math.round(e.y + e.altura)))).filter(e => e < c - 15).forEach((n, r) => {
      let i = s + h / 2 - n - t / 2;
      f.push({
        id: `${e.id}-prat-h-${r + 1}`,
        moduloId: e.id,
        moduloNome: e.nome,
        nome: `Prateleira / Divisão ${r + 1}`,
        tipo: `prateleira`,
        largura: b - 2,
        altura: _ - 15,
        espessura: t,
        posRelativa: {
          x: 0,
          y: i,
          z: v + 5
        },
        tamanho3D: {
          x: b - 2,
          y: t,
          z: _ - 15
        },
        isFrente: false,
        isFundo: false,
        acabamento: u,
        fitaBorda: {
          topo: false,
          base: false,
          esquerda: true,
          direita: false
        }
      });
    });
    e.caixasDesenho.forEach((n, r) => {
      let i = n.x + n.largura / 2 - (a + m / 2);
      let o = s + h / 2 - (n.y + n.altura / 2);
      let c = n.largura;
      let g = n.altura;
      let b = n.materialFrentes || d;
      let x = n.materialCorpo || u;
      if (n.preenchimento.includes(`gaveta`)) {
        let a = n.preenchimento.includes(`1-gaveta`) ? 1 : n.preenchimento.includes(`2-gavetas`) || n.preenchimento.includes(`2-gaveta`) ? 2 : n.preenchimento.includes(`3-gaveta`) ? 3 : n.preenchimento.includes(`4-gaveta`) ? 4 : 2;
        let s = (g - (a + 1) * 2) / a;
        for (let n = 0; n < a; n++) {
          let a = o - g / 2 + 2 + n * (s + 2) + s / 2;
          let u = l ? 250 : 0;
          f.push({
            id: `${e.id}-c${r}-gav-frente-${n + 1}`,
            moduloId: e.id,
            moduloNome: e.nome,
            nome: `Frente de Gaveta (Vão ${r + 1})`,
            tipo: `frente_gaveta`,
            largura: c - 4,
            altura: s,
            espessura: t,
            posRelativa: {
              x: i,
              y: a,
              z: y + u
            },
            tamanho3D: {
              x: c - 4,
              y: s,
              z: t
            },
            isFrente: true,
            isFundo: false,
            acabamento: b,
            fitaBorda: {
              topo: true,
              base: true,
              esquerda: true,
              direita: true
            }
          });
          p.push({
            id: `pux-c${r}-gav-${n + 1}`,
            tipo: `puxador`,
            posRelativa: {
              x: i,
              y: a,
              z: y + u + t / 2 + 5
            }
          });
          let d = Math.max(200, _ - 40);
          let m = Math.max(50, c - t * 2 - 26);
          let h = Math.max(40, s - 35);
          f.push({
            id: `${e.id}-c${r}-gav-corpo-${n + 1}`,
            moduloId: e.id,
            moduloNome: e.nome,
            nome: `Corpo da Gaveta (Vão ${r + 1})`,
            tipo: `corpo_gaveta`,
            largura: m,
            altura: d,
            espessura: t,
            posRelativa: {
              x: i,
              y: a - 10,
              z: v + u
            },
            tamanho3D: {
              x: m,
              y: h,
              z: d
            },
            isFrente: false,
            isFundo: false,
            acabamento: x,
            fitaBorda: {
              topo: true,
              base: false,
              esquerda: false,
              direita: false
            }
          });
        }
      } else if (n.preenchimento.includes(`porta`)) {
        let a = g - 4;
        let s = c - 4;
        let u = n.puxadorLado || `direita`;
        let d = u === `esquerda` ? i - s / 2 + 30 : i + s / 2 - 30;
        let m = u === `esquerda` ? i + s / 2 : i - s / 2;
        f.push({
          id: `${e.id}-c${r}-porta`,
          moduloId: e.id,
          moduloNome: e.nome,
          nome: `Porta (Vão ${r + 1})`,
          tipo: `porta`,
          largura: s,
          altura: a,
          espessura: t,
          posRelativa: {
            x: i,
            y: o,
            z: y
          },
          tamanho3D: {
            x: s,
            y: a,
            z: t
          },
          isFrente: true,
          isFundo: false,
          rotacaoPorta: l ? {
            angulo: u === `esquerda` ? Math.PI / 2.2 : -Math.PI / 2.2,
            eixo: `y`,
            pivot: {
              x: m,
              y: o,
              z: y
            }
          } : undefined,
          acabamento: b,
          fitaBorda: {
            topo: true,
            base: true,
            esquerda: true,
            direita: true
          }
        });
        p.push({
          id: `pux-c${r}-porta`,
          tipo: `puxador`,
          posRelativa: {
            x: d,
            y: o,
            z: y + t / 2 + 5
          }
        });
      }
    });
    return {
      pecas: f,
      ferragens: p
    };
  }
  let m = a > 0 || o > 0 ? t + 2 : 0;
  let h = i - m;
  let g = -m / 2;
  f.push({
    id: `${e.id}-lat-esq`,
    moduloId: e.id,
    moduloNome: e.nome,
    nome: `Lateral Esquerda`,
    tipo: `lateral`,
    largura: h,
    altura: r,
    espessura: t,
    posRelativa: {
      x: -n / 2 + t / 2,
      y: 0,
      z: g
    },
    tamanho3D: {
      x: t,
      y: r,
      z: h
    },
    isFrente: false,
    isFundo: false,
    acabamento: u,
    fitaBorda: {
      topo: false,
      base: false,
      esquerda: true,
      direita: false
    }
  });
  f.push({
    id: `${e.id}-lat-dir`,
    moduloId: e.id,
    moduloNome: e.nome,
    nome: `Lateral Direita`,
    tipo: `lateral`,
    largura: h,
    altura: r,
    espessura: t,
    posRelativa: {
      x: n / 2 - t / 2,
      y: 0,
      z: g
    },
    tamanho3D: {
      x: t,
      y: r,
      z: h
    },
    isFrente: false,
    isFundo: false,
    acabamento: u,
    fitaBorda: {
      topo: false,
      base: false,
      esquerda: true,
      direita: false
    }
  });
  let _ = n - t * 2;
  f.push({
    id: `${e.id}-base`,
    moduloId: e.id,
    moduloNome: e.nome,
    nome: `Base Inferior`,
    tipo: `base`,
    largura: _,
    altura: h,
    espessura: t,
    posRelativa: {
      x: 0,
      y: -r / 2 + t / 2,
      z: g
    },
    tamanho3D: {
      x: _,
      y: t,
      z: h
    },
    isFrente: false,
    isFundo: false,
    acabamento: u,
    fitaBorda: {
      topo: false,
      base: false,
      esquerda: true,
      direita: false
    }
  });
  let v = e.categoria === `horizontal`;
  f.push({
    id: `${e.id}-tampo`,
    moduloId: e.id,
    moduloNome: e.nome,
    nome: v ? `Tampo Superior Fechado` : `Tampo Estrutural`,
    tipo: `tampo`,
    largura: _,
    altura: h,
    espessura: t,
    posRelativa: {
      x: 0,
      y: r / 2 - t / 2,
      z: g
    },
    tamanho3D: {
      x: _,
      y: t,
      z: h
    },
    isFrente: false,
    isFundo: false,
    acabamento: u,
    fitaBorda: {
      topo: false,
      base: false,
      esquerda: true,
      direita: false
    }
  });
  [-n / 2 + t / 2, n / 2 - t / 2].forEach(e => {
    [-r / 2 + t / 2, r / 2 - t / 2].forEach(t => {
      p.push({
        id: `fix-${e}-${t}-frente`,
        tipo: `minifix`,
        posRelativa: {
          x: e,
          y: t,
          z: g + h / 3
        }
      });
      p.push({
        id: `fix-${e}-${t}-fundo`,
        tipo: `minifix`,
        posRelativa: {
          x: e,
          y: t,
          z: g - h / 3
        }
      });
    });
  });
  let y = r - t * 2;
  f.push({
    id: `${e.id}-fundo`,
    moduloId: e.id,
    moduloNome: e.nome,
    nome: `Fundo Traseiro 6mm`,
    tipo: `fundo`,
    largura: _ + 12,
    altura: y + 12,
    espessura: 6,
    posRelativa: {
      x: 0,
      y: 0,
      z: -i / 2 + 3 + 10
    },
    tamanho3D: {
      x: _,
      y,
      z: 6
    },
    isFrente: false,
    isFundo: true,
    acabamento: u,
    fitaBorda: {
      topo: false,
      base: false,
      esquerda: false,
      direita: false
    }
  });
  let b = (_ - c * t) / (c + 1);
  for (let n = 0; n < c; n++) {
    let r = -_ / 2 + (n + 1) * b + n * t + t / 2;
    f.push({
      id: `${e.id}-div-${n + 1}`,
      moduloId: e.id,
      moduloNome: e.nome,
      nome: `Divisória Vertical ${n + 1}`,
      tipo: `divisoria`,
      largura: h - 10,
      altura: y,
      espessura: t,
      posRelativa: {
        x: r,
        y: 0,
        z: g + 5
      },
      tamanho3D: {
        x: t,
        y,
        z: h - 10
      },
      isFrente: false,
      isFundo: false,
      acabamento: u,
      fitaBorda: {
        topo: false,
        base: false,
        esquerda: true,
        direita: false
      }
    });
  }
  if (s > 0) {
    let n = y / (s + 1);
    for (let r = 0; r < s; r++) {
      let i = -y / 2 + (r + 1) * n;
      f.push({
        id: `${e.id}-prat-${r + 1}`,
        moduloId: e.id,
        moduloNome: e.nome,
        nome: `Prateleira ${r + 1}`,
        tipo: `prateleira`,
        largura: _ - 2,
        altura: h - 15,
        espessura: t,
        posRelativa: {
          x: 0,
          y: i,
          z: g + 5
        },
        tamanho3D: {
          x: _ - 2,
          y: t,
          z: h - 15
        },
        isFrente: false,
        isFundo: false,
        acabamento: u,
        fitaBorda: {
          topo: false,
          base: false,
          esquerda: true,
          direita: false
        }
      });
      [-_ / 2 + 5, _ / 2 - 5].forEach(e => {
        p.push({
          id: `sp-${r}-${e}-frente`,
          tipo: `suporte_prateleira`,
          posRelativa: {
            x: e,
            y: i - 4,
            z: g + h / 3
          }
        });
        p.push({
          id: `sp-${r}-${e}-tras`,
          tipo: `suporte_prateleira`,
          posRelativa: {
            x: e,
            y: i - 4,
            z: g - h / 3
          }
        });
      });
    }
  }
  let x = i / 2 - t / 2;
  if (o > 0) {
    let i = (r - (o + 1) * 2) / o;
    for (let a = 0; a < o; a++) {
      let o = -r / 2 + 2 + a * (i + 2) + i / 2;
      let s = l ? 250 : 0;
      f.push({
        id: `${e.id}-gav-frente-${a + 1}`,
        moduloId: e.id,
        moduloNome: e.nome,
        nome: `Frente de Gaveta ${a + 1}`,
        tipo: `frente_gaveta`,
        largura: n - 4,
        altura: i,
        espessura: t,
        posRelativa: {
          x: 0,
          y: o,
          z: x + s
        },
        tamanho3D: {
          x: n - 4,
          y: i,
          z: t
        },
        isFrente: true,
        isFundo: false,
        acabamento: d,
        fitaBorda: {
          topo: true,
          base: true,
          esquerda: true,
          direita: true
        }
      });
      p.push({
        id: `pux-gav-${a + 1}`,
        tipo: `puxador`,
        posRelativa: {
          x: 0,
          y: o,
          z: x + s + t / 2 + 5
        }
      });
      let c = Math.max(250, h - 50);
      let m = i - 40;
      let v = _ - 26;
      f.push({
        id: `${e.id}-gav-corpo-${a + 1}`,
        moduloId: e.id,
        moduloNome: e.nome,
        nome: `Corpo da Gaveta ${a + 1}`,
        tipo: `corpo_gaveta`,
        largura: v,
        altura: c,
        espessura: t,
        posRelativa: {
          x: 0,
          y: o - 10,
          z: g + s
        },
        tamanho3D: {
          x: v,
          y: m,
          z: c
        },
        isFrente: false,
        isFundo: false,
        acabamento: u,
        fitaBorda: {
          topo: true,
          base: false,
          esquerda: false,
          direita: false
        }
      });
    }
  }
  if (a > 0) {
    let i = r - 4;
    let o = (n - (a + 1) * 2) / a;
    for (let s = 0; s < a; s++) {
      let a = -n / 2 + 2 + s * (o + 2) + o / 2;
      let c = s === 0 ? -n / 2 + 2 : n / 2 - 2;
      f.push({
        id: `${e.id}-porta-${s + 1}`,
        moduloId: e.id,
        moduloNome: e.nome,
        nome: `Porta ${s + 1}`,
        tipo: `porta`,
        largura: o,
        altura: i,
        espessura: t,
        posRelativa: {
          x: a,
          y: 0,
          z: x
        },
        tamanho3D: {
          x: o,
          y: i,
          z: t
        },
        isFrente: true,
        isFundo: false,
        rotacaoPorta: l ? {
          angulo: s === 0 ? -Math.PI / 2.2 : Math.PI / 2.2,
          eixo: `y`,
          pivot: {
            x: c,
            y: 0,
            z: x
          }
        } : undefined,
        acabamento: d,
        fitaBorda: {
          topo: true,
          base: true,
          esquerda: true,
          direita: true
        }
      });
      let u = s === 0 ? a + o / 2 - 25 : a - o / 2 + 25;
      p.push({
        id: `pux-porta-${s + 1}`,
        tipo: `puxador`,
        posRelativa: {
          x: u,
          y: 0,
          z: x + t / 2 + 5
        }
      });
      p.push({
        id: `dob-${s + 1}-sup`,
        tipo: `dobradica`,
        posRelativa: {
          x: c,
          y: r / 2 - 100,
          z: x
        }
      });
      p.push({
        id: `dob-${s + 1}-inf`,
        tipo: `dobradica`,
        posRelativa: {
          x: c,
          y: -r / 2 + 100,
          z: x
        }
      });
    }
  }
  if (!Qe.includes(e.categoria)) {
    [-n / 2 + 50, n / 2 - 50].forEach(e => {
      [-i / 2 + 50, i / 2 - 50].forEach(t => {
        p.push({
          id: `sapata-${e}-${t}`,
          tipo: `sapata`,
          posRelativa: {
            x: e,
            y: -r / 2,
            z: t
          }
        });
      });
    });
  }
  return {
    pecas: f,
    ferragens: p
  };
}
var it = {
  precoChapaMDF: 280,
  precoChapaFundo: 120,
  precoMetroFita: 2.5,
  precoDobradica: 12,
  precoCorredica: 35,
  precoPuxador: 25,
  precoMinifix: 3,
  precoParafuso: 0.5,
  precoSuporte: 1,
  precoSapata: 4,
  precoServicoPeca: 6.5,
  taxaMontagemBase: 180,
  margemPadrao: 30
};
function at(e, t = 30, n) {
  let r = {
    precoChapaMDF: Number(n?.precoChapaMDF) > 0 ? Number(n?.precoChapaMDF) : it.precoChapaMDF,
    precoChapaFundo: Number(n?.precoChapaFundo) > 0 ? Number(n?.precoChapaFundo) : it.precoChapaFundo,
    precoMetroFita: Number(n?.precoMetroFita) > 0 ? Number(n?.precoMetroFita) : it.precoMetroFita,
    precoDobradica: Number(n?.precoDobradica) >= 0 ? Number(n?.precoDobradica) : it.precoDobradica,
    precoCorredica: Number(n?.precoCorredica) >= 0 ? Number(n?.precoCorredica) : it.precoCorredica,
    precoPuxador: Number(n?.precoPuxador) >= 0 ? Number(n?.precoPuxador) : it.precoPuxador,
    precoMinifix: Number(n?.precoMinifix) >= 0 ? Number(n?.precoMinifix) : it.precoMinifix,
    precoParafuso: Number(n?.precoParafuso) >= 0 ? Number(n?.precoParafuso) : it.precoParafuso,
    precoSuporte: Number(n?.precoSuporte) >= 0 ? Number(n?.precoSuporte) : it.precoSuporte,
    precoSapata: Number(n?.precoSapata) >= 0 ? Number(n?.precoSapata) : it.precoSapata,
    precoServicoPeca: Number(n?.precoServicoPeca) >= 0 ? Number(n?.precoServicoPeca) : it.precoServicoPeca,
    taxaMontagemBase: Number(n?.taxaMontagemBase) >= 0 ? Number(n?.taxaMontagemBase) : it.taxaMontagemBase,
    margemPadrao: Number(n?.margemPadrao) >= 0 ? Number(n?.margemPadrao) : it.margemPadrao
  };
  let i = [];
  let a = 0;
  let o = 0;
  let s = 0;
  let c = 0;
  let l = 0;
  let u = 0;
  let d = 0;
  for (let t of e.modulos) {
    if (t.visivel === false) {
      continue;
    }
    let {
      pecas: e,
      ferragens: n
    } = rt(t);
    i.push(...e);
    for (let e of n) {
      if (e.tipo === `dobradica`) {
        a++;
      } else if (e.tipo === `puxador`) {
        s++;
      } else if (e.tipo === `minifix`) {
        c++;
        l += 2;
      } else if (e.tipo === `suporte_prateleira`) {
        u++;
      } else if (e.tipo === `sapata`) {
        d++;
      }
    }
    if (t.gavetas > 0) {
      o += t.gavetas;
      l += t.gavetas * 8;
    }
  }
  let f = 0;
  let p = 0;
  let m = 0;
  for (let e of i) {
    let t = e.largura * e.altura;
    if (e.isFundo) {
      p += t;
    } else {
      f += t;
      if (e.fitaBorda.topo) {
        m += e.largura;
      }
      if (e.fitaBorda.base) {
        m += e.largura;
      }
      if (e.fitaBorda.esquerda) {
        m += e.altura;
      }
      if (e.fitaBorda.direita) {
        m += e.altura;
      }
    }
  }
  let h = f / 1000000;
  let g = p / 1000000;
  let _ = Math.ceil(m / 1000);
  let v = Math.max(1, Math.ceil(h / 4.318));
  let y = v * r.precoChapaMDF + (g > 0 ? r.precoChapaFundo : 0);
  let b = _ * r.precoMetroFita;
  let x = [{
    chave: `dobradicas`,
    nome: `Dobradiças 35mm com Amortecedor`,
    quantidade: a,
    unidade: `un`,
    precoUnitario: r.precoDobradica,
    total: a * r.precoDobradica
  }, {
    chave: `corredicas`,
    nome: `Corrediças Telescópicas Reforçadas`,
    quantidade: o,
    unidade: `par`,
    precoUnitario: r.precoCorredica,
    total: o * r.precoCorredica
  }, {
    chave: `puxadores`,
    nome: `Puxadores Alumínio Perfil Cava/Gola`,
    quantidade: s,
    unidade: `un`,
    precoUnitario: r.precoPuxador,
    total: s * r.precoPuxador
  }, {
    chave: `minifix`,
    nome: `Conectores Minifix + Tambor 15mm`,
    quantidade: c,
    unidade: `un`,
    precoUnitario: r.precoMinifix,
    total: c * r.precoMinifix
  }, {
    chave: `parafusos`,
    nome: `Parafusos Estruturais 4.0 x 40mm`,
    quantidade: l,
    unidade: `un`,
    precoUnitario: r.precoParafuso,
    total: l * r.precoParafuso
  }, {
    chave: `suportes`,
    nome: `Suportes Metálicos de Prateleira`,
    quantidade: u,
    unidade: `un`,
    precoUnitario: r.precoSuporte,
    total: u * r.precoSuporte
  }, {
    chave: `sapatas`,
    nome: `Sapatas Niveladoras / Pés Reguláveis`,
    quantidade: d,
    unidade: `un`,
    precoUnitario: r.precoSapata,
    total: d * r.precoSapata
  }].filter(e => e.quantidade > 0);
  let S = x.reduce((e, t) => e + t.total, 0);
  let C = i.length * r.precoServicoPeca + r.taxaMontagemBase;
  let w = y + b + S + C;
  let T = typeof t == `number` && Number.isFinite(t) ? t : r.margemPadrao;
  let E = 1 + T / 100;
  let D = Math.round(w * E);
  return {
    totalPecas: i.length,
    listaPecas: i,
    areaMDFM2: Math.round(h * 100) / 100,
    areaFundoM2: Math.round(g * 100) / 100,
    chapasEstimadas: v,
    metrosFitaBorda: _,
    ferragens: x,
    custoMDF: y,
    custoFita: b,
    custoFerragens: S,
    custoServicos: C,
    custoTotal: w,
    precoVenda: D,
    margemPct: T,
    configPrecosUsada: r
  };
}
function ot(e) {
  return Math.round((e + 2.220446049250313e-16) * 100) / 100;
}
function st(e) {
  let t = ot(e.montagem_horas * e.montagem_valor_hora);
  let n = e.material_custo + e.ferragens_custo + e.operacional_custo + t + e.frete;
  let r = ot((e.material_custo + e.ferragens_custo) * e.perda_percent / 100);
  let i = ot(n + r);
  let a = ot(i * e.impostos_percent / 100);
  let o = i + a;
  let s = ot(o * (1 + e.margem_percent / 100));
  let c = ot(s - o);
  return {
    montagem_custo: t,
    perda_valor: r,
    subtotal: i,
    impostos_valor: a,
    total: s,
    lucro: c,
    margem_real_percent: s > 0 ? ot(c / s * 100) : 0
  };
}
var ct = `planejados_pro_mock_db_v4`;
var lt = `planejados_pro_mock_auth_v1`;
var ut = null;
function dt() {
  if (ut) {
    return ut;
  }
  try {
    let e = localStorage.getItem(ct);
    if (e) {
      ut = JSON.parse(e);
      return ut;
    }
  } catch (e) {
    console.error(`Erro ao carregar banco mock do localStorage:`, e);
  }
  ut = Ae();
  ft(ut);
  return ut;
}
function ft(e) {
  ut = e;
  try {
    localStorage.setItem(ct, JSON.stringify(e));
  } catch (e) {
    console.error(`Erro ao salvar banco mock no localStorage:`, e);
  }
}
function pt() {
  ut = Ae();
  ft(ut);
  return ut;
}
var mt = null;
var ht = [];
function gt() {
  try {
    let e = localStorage.getItem(lt);
    if (e) {
      let t = JSON.parse(e);
      if (t?.user) {
        return t;
      }
    }
  } catch {}
  let e = dt();
  let t = e._auth_users.find(e => e.id === `22222222-2222-4222-a222-222222222222`) || e._auth_users[0];
  if (t) {
    let e = {
      access_token: `mock-jwt-token-${t.id}`,
      token_type: `bearer`,
      expires_in: 604800,
      expires_at: Math.floor(Date.now() / 1000) + 604800,
      refresh_token: `mock-refresh-token`,
      user: {
        id: t.id,
        app_metadata: {
          provider: `email`,
          providers: [`email`]
        },
        user_metadata: {
          full_name: t.full_name
        },
        aud: `authenticated`,
        confirmation_sent_at: t.created_at,
        confirmed_at: t.created_at,
        created_at: t.created_at,
        email: t.email,
        email_confirmed_at: t.created_at,
        last_sign_in_at: new Date().toISOString(),
        phone: ``,
        role: `authenticated`,
        updated_at: new Date().toISOString()
      }
    };
    try {
      localStorage.setItem(lt, JSON.stringify(e));
    } catch {}
    return e;
  }
  return null;
}
mt = gt();
function _t(e, t) {
  mt = t;
  if (t) {
    try {
      localStorage.setItem(lt, JSON.stringify(t));
    } catch {}
  } else {
    try {
      localStorage.removeItem(lt);
    } catch {}
  }
  for (let n of ht) {
    try {
      n(e, t);
    } catch (e) {
      console.error(e);
    }
  }
}
function vt(e, t, n, r) {
  let i = {
    ...t
  };
  if (n.includes(`cliente:clientes`) || n.includes(`cliente:clientes(*)`)) {
    let e = t.cliente_id || t.id;
    let a = r.clientes.find(n => n.id === (t.cliente_id || e));
    i.cliente = a ? n.includes(`cliente:clientes(nome)`) ? {
      nome: a.nome
    } : n.includes(`cliente:clientes(id,nome,telefone)`) ? {
      id: a.id,
      nome: a.nome,
      telefone: a.telefone
    } : n.includes(`cliente:clientes(id,nome,documento)`) ? {
      id: a.id,
      nome: a.nome,
      documento: a.documento
    } : n.includes(`cliente:clientes(id,nome)`) ? {
      id: a.id,
      nome: a.nome
    } : a : null;
  }
  if (n.includes(`ambientes(count)`)) {
    i.ambientes = [{
      count: r.ambientes.filter(e => e.projeto_id === t.id).length
    }];
  } else if (n.includes(`ambientes(*)`)) {
    i.ambientes = r.ambientes.filter(e => e.projeto_id === t.id);
  }
  if (n.includes(`projeto:projetos`)) {
    let e = r.projetos.find(e => e.id === t.projeto_id);
    if (e) {
      let t = {
        id: e.id,
        nome: e.nome,
        status: e.status
      };
      if (n.includes(`cliente:clientes`)) {
        let n = r.clientes.find(t => t.id === e.cliente_id);
        t.cliente = n ? {
          id: n.id,
          nome: n.nome,
          telefone: n.telefone
        } : null;
      }
      i.projeto = t;
    } else {
      i.projeto = null;
    }
  }
  if (n.includes(`montador:profiles`)) {
    let e = r.profiles.find(e => e.id === t.montador_id);
    i.montador = e ? {
      id: e.id,
      full_name: e.full_name
    } : null;
  }
  if (n.includes(`material:materiais`)) {
    let e = r.materiais.find(e => e.id === t.material_id);
    i.material = e ? {
      id: e.id,
      nome: e.nome,
      cor: e.cor,
      custo_unitario: e.custo_unitario
    } : null;
  }
  if (n.includes(`categoria:categorias_financeiras`)) {
    let e = r.categorias_financeiras.find(e => e.id === t.categoria_id);
    i.categoria = e ? {
      id: e.id,
      nome: e.nome,
      cor: e.cor
    } : null;
  }
  if (n.includes(`fornecedor:fornecedores`)) {
    let e = r.fornecedores.find(e => e.id === t.fornecedor_id);
    i.fornecedor = e ? {
      id: e.id,
      nome: e.nome
    } : null;
  }
  if (n.includes(`contrato:contratos`)) {
    let e = r.contratos.find(e => e.id === t.contrato_id);
    i.contrato = e ? {
      id: e.id,
      numero: e.numero
    } : null;
  }
  if (n.includes(`orcamento:orcamentos`)) {
    let e = r.orcamentos.find(e => e.id === t.orcamento_id);
    i.orcamento = e ? {
      id: e.id,
      versao: e.versao,
      total: e.total
    } : null;
  }
  if (n.includes(`itens:orcamento_itens`)) {
    i.itens = r.orcamento_itens.filter(e => e.orcamento_id === t.id).sort((e, t) => e.ordem - t.ordem);
  }
  if (n.includes(`lancamentos:lancamentos`)) {
    i.lancamentos = r.lancamentos.filter(e => e.contrato_id === t.id).sort((e, t) => (e.parcela_numero ?? 0) - (t.parcela_numero ?? 0));
  }
  if (n.includes(`ambiente:ambientes`)) {
    let e = r.ambientes.find(e => e.id === t.ambiente_id);
    i.ambiente = e ? {
      id: e.id,
      nome: e.nome,
      tipo: e.tipo,
      margem_percent: e.margem_percent,
      projeto_id: e.projeto_id
    } : null;
  }
  return i;
}
var yt = class {
  tableName;
  selectCols = `*`;
  countMode = null;
  headOnly = false;
  filters = [];
  sortFn = null;
  limitCount = null;
  isSingle = false;
  isMaybeSingle = false;
  mutationType = `select`;
  insertPayload = null;
  updatePayload = null;
  constructor(e) {
    this.tableName = e;
  }
  select(e = `*`, t) {
    this.selectCols = e;
    if (t?.count) {
      this.countMode = t.count;
    }
    if (t?.head) {
      this.headOnly = t.head;
    }
    return this;
  }
  eq(e, t) {
    this.filters.push(n => {
      let r = n[e];
      return r !== undefined && String(r) === String(t);
    });
    return this;
  }
  neq(e, t) {
    this.filters.push(n => {
      let r = n[e];
      return String(r) !== String(t);
    });
    return this;
  }
  in(e, t) {
    this.filters.push(n => {
      let r = n[e];
      return t.map(String).includes(String(r));
    });
    return this;
  }
  gte(e, t) {
    this.filters.push(n => {
      let r = n[e];
      return r != null && r >= t;
    });
    return this;
  }
  lte(e, t) {
    this.filters.push(n => {
      let r = n[e];
      return r != null && r <= t;
    });
    return this;
  }
  ilike(e, t) {
    let n = t.replace(/%/g, ``).toLowerCase();
    this.filters.push(t => String(t[e] ?? ``).toLowerCase().includes(n));
    return this;
  }
  or(e) {
    let t = e.split(`,`).map(e => {
      let t = e.split(`.`);
      return {
        col: t[0],
        op: t[1],
        val: t.slice(2).join(`.`).replace(/%/g, ``).toLowerCase()
      };
    });
    this.filters.push(e => t.some(({
      col: t,
      op: n,
      val: r
    }) => {
      let i = String(e[t] ?? ``).toLowerCase();
      if (n === `ilike` || n === `like`) {
        return i.includes(r);
      } else {
        return n === `eq` && i === r;
      }
    }));
    return this;
  }
  order(e, t) {
    let n = t?.ascending ?? true;
    let r = this.sortFn;
    let i = (i, a) => {
      if (r) {
        let e = r(i, a);
        if (e !== 0) {
          return e;
        }
      }
      let o = i[e];
      let s = a[e];
      if (o === s) {
        return 0;
      } else if (o == null) {
        if (t?.nullsFirst) {
          return -1;
        } else {
          return 1;
        }
      } else if (s == null) {
        if (t?.nullsFirst) {
          return 1;
        } else {
          return -1;
        }
      } else if (typeof o == `number` && typeof s == `number`) {
        if (n) {
          return o - s;
        } else {
          return s - o;
        }
      } else if (n) {
        return String(o).localeCompare(String(s));
      } else {
        return String(s).localeCompare(String(o));
      }
    };
    this.sortFn = i;
    return this;
  }
  limit(e) {
    this.limitCount = e;
    return this;
  }
  single() {
    this.isSingle = true;
    return this;
  }
  maybeSingle() {
    this.isMaybeSingle = true;
    return this;
  }
  insert(e) {
    this.mutationType = `insert`;
    this.insertPayload = Array.isArray(e) ? e : [e];
    return this;
  }
  update(e) {
    this.mutationType = `update`;
    this.updatePayload = e;
    return this;
  }
  delete() {
    this.mutationType = `delete`;
    return this;
  }
  async execute() {
    let e = dt();
    let t = e[this.tableName] || [];
    let n = new Date().toISOString();
    mt?.user?.id;
    let r = R;
    if (this.mutationType === `insert`) {
      let i = this.insertPayload.map(e => {
        let t = e.id || crypto.randomUUID();
        let i = e.tenant_id || r;
        return {
          ...e,
          id: t,
          tenant_id: i,
          created_at: e.created_at || n,
          updated_at: e.updated_at || n
        };
      });
      t.push(...i);
      ft(e);
      let a = i.map(t => vt(this.tableName, t, this.selectCols, e));
      if (this.isSingle || this.isMaybeSingle) {
        return {
          data: a[0] ?? null,
          error: null
        };
      } else {
        return {
          data: Array.isArray(this.insertPayload) ? a : a[0],
          error: null
        };
      }
    }
    if (this.mutationType === `update`) {
      let r = [];
      t.forEach((e, t) => {
        if (this.filters.every(t => t(e))) {
          r.push(t);
        }
      });
      let i = [];
      for (let e of r) {
        t[e] = {
          ...t[e],
          ...this.updatePayload,
          updated_at: n
        };
        i.push(t[e]);
      }
      ft(e);
      let a = i.map(t => vt(this.tableName, t, this.selectCols, e));
      if (this.isSingle || this.isMaybeSingle) {
        return {
          data: a[0] ?? null,
          error: null
        };
      } else {
        return {
          data: a,
          error: null
        };
      }
    }
    if (this.mutationType === `delete`) {
      let n = [];
      let r = [];
      for (let e of t) {
        if (this.filters.every(t => t(e))) {
          r.push(e);
        } else {
          n.push(e);
        }
      }
      e[this.tableName] = n;
      ft(e);
      return {
        data: r,
        error: null
      };
    }
    let i = t.filter(e => this.filters.every(t => t(e)));
    let a = i.length;
    if (this.headOnly) {
      return {
        data: null,
        count: a,
        error: null
      };
    }
    if (this.sortFn) {
      i.sort(this.sortFn);
    }
    if (this.limitCount !== null) {
      i = i.slice(0, this.limitCount);
    }
    let o = i.map(t => vt(this.tableName, t, this.selectCols, e));
    if (this.isSingle) {
      if (o.length === 0) {
        return {
          data: null,
          error: {
            message: `Item não encontrado.`,
            code: `PGRST116`
          }
        };
      } else {
        return {
          data: o[0],
          count: a,
          error: null
        };
      }
    } else if (this.isMaybeSingle) {
      return {
        data: o[0] ?? null,
        count: a,
        error: null
      };
    } else {
      return {
        data: o,
        count: this.countMode ? a : null,
        error: null
      };
    }
  }
  then(e, t) {
    return this.execute().then(e, t);
  }
  catch(e) {
    return this.execute().catch(e);
  }
  finally(e) {
    return this.execute().finally(e);
  }
};
var bt = {
  from(e) {
    return new yt(e);
  },
  auth: {
    async getSession() {
      return {
        data: {
          session: mt
        },
        error: null
      };
    },
    async getUser(e) {
      return {
        data: {
          user: mt?.user ?? null
        },
        error: null
      };
    },
    async signInWithPassword({
      email: e,
      password: t
    }) {
      let n = dt();
      if (!n._auth_users.find(t => t.email.toLowerCase() === (e || ``).toLowerCase())) {
        let r = {
          id: crypto.randomUUID(),
          email: e || `usuario@planejadospro.com.br`,
          password: t || `admin`,
          full_name: (e || ``).split(`@`)[0] || `Usuário Demo`,
          tenant_id: R,
          created_at: new Date().toISOString()
        };
        n._auth_users.push(r);
        n.profiles.push({
          id: r.id,
          tenant_id: R,
          email: r.email,
          full_name: r.full_name,
          telefone: null,
          avatar_url: null,
          ativo: true,
          created_at: r.created_at,
          updated_at: r.created_at
        });
        n.user_roles.push({
          id: crypto.randomUUID(),
          user_id: r.id,
          tenant_id: R,
          role: `admin`,
          created_at: r.created_at
        });
        ft(n);
      }
      let r = n._auth_users.find(t => t.email.toLowerCase() === (e || ``).toLowerCase());
      let i = {
        access_token: `mock-jwt-token-${r.id}`,
        token_type: `bearer`,
        expires_in: 604800,
        expires_at: Math.floor(Date.now() / 1000) + 604800,
        refresh_token: `mock-refresh-token`,
        user: {
          id: r.id,
          app_metadata: {
            provider: `email`,
            providers: [`email`]
          },
          user_metadata: {
            full_name: r.full_name
          },
          aud: `authenticated`,
          confirmation_sent_at: r.created_at,
          confirmed_at: r.created_at,
          created_at: r.created_at,
          email: r.email,
          email_confirmed_at: r.created_at,
          last_sign_in_at: new Date().toISOString(),
          phone: ``,
          role: `authenticated`,
          updated_at: new Date().toISOString()
        }
      };
      _t(`SIGNED_IN`, i);
      return {
        data: {
          user: i.user,
          session: i
        },
        error: null
      };
    },
    async signUp(e) {
      let t = dt();
      let n = crypto.randomUUID();
      let r = crypto.randomUUID();
      let i = new Date().toISOString();
      let a = e.options?.data?.tenant_name || `Minha Marcenaria`;
      let o = e.options?.data?.full_name || e.email.split(`@`)[0];
      t.tenants.push({
        id: r,
        name: a,
        logo_url: null,
        documento: null,
        telefone: null,
        email: e.email,
        endereco: null,
        cidade: null,
        uf: null,
        cep: null,
        termos_contrato: null,
        plano_nome: `PRO_ILIMITADO`,
        plano_status: `ativo`,
        faturamento_email: e.email,
        faturamento_documento: null,
        config_precos: {
          mdf_chapa_m2: 65,
          fita_metro: 4.5,
          hora_montagem: 85,
          margem_padrao: 35
        },
        created_at: i,
        atualizado_em: i
      });
      t._auth_users.push({
        id: n,
        email: e.email,
        password: e.password || `admin`,
        full_name: o,
        tenant_id: r,
        created_at: i
      });
      t.profiles.push({
        id: n,
        tenant_id: r,
        email: e.email,
        full_name: o,
        telefone: null,
        avatar_url: null,
        ativo: true,
        created_at: i,
        updated_at: i
      });
      t.user_roles.push({
        id: crypto.randomUUID(),
        user_id: n,
        tenant_id: r,
        role: `admin`,
        created_at: i
      });
      ft(t);
      return {
        data: {
          user: {
            id: n,
            app_metadata: {
              provider: `email`,
              providers: [`email`]
            },
            user_metadata: {
              full_name: o,
              tenant_name: a
            },
            aud: `authenticated`,
            confirmation_sent_at: i,
            confirmed_at: i,
            created_at: i,
            email: e.email,
            email_confirmed_at: i,
            last_sign_in_at: i,
            phone: ``,
            role: `authenticated`,
            updated_at: i
          },
          session: null
        },
        error: null
      };
    },
    async signOut() {
      _t(`SIGNED_OUT`, null);
      return {
        error: null
      };
    },
    onAuthStateChange(e) {
      ht.push(e);
      return {
        data: {
          subscription: {
            unsubscribe: () => {
              let t = ht.indexOf(e);
              if (t !== -1) {
                ht.splice(t, 1);
              }
            }
          }
        }
      };
    },
    async resetPasswordForEmail(e) {
      return {
        data: {},
        error: null
      };
    },
    async updateUser(e) {
      if (mt?.user) {
        let t = dt();
        let n = t._auth_users.find(e => e.id === mt.user.id);
        if (n && e.password) {
          n.password = e.password;
          ft(t);
        }
      }
      return {
        data: {
          user: mt?.user ?? null
        },
        error: null
      };
    },
    admin: {
      async createUser(e) {
        let t = await bt.auth.signUp({
          email: e.email,
          password: e.password,
          options: {
            data: e.user_metadata
          }
        });
        return {
          data: {
            user: t.data.user
          },
          error: t.error
        };
      }
    }
  },
  async rpc(e, t = {}) {
    let n = dt();
    let r = new Date().toISOString();
    let i = r.slice(0, 10);
    switch (e) {
      case `get_user_tenant`:
        return {
          data: n.profiles.find(e => e.id === t._user_id)?.tenant_id ?? `11111111-1111-4111-a111-111111111111`,
          error: null
        };
      case `has_role`:
        return {
          data: !!n.user_roles.find(e => e.user_id === t._user_id && e.role === t._role),
          error: null
        };
      case `is_tenant_admin`:
        return {
          data: true,
          error: null
        };
      case `pode_gerir_financeiro`:
        return {
          data: true,
          error: null
        };
      case `proximo_numero_os`:
        {
          let e = r.slice(0, 7).replace(`-`, ``);
          let t = n.ordens_servico.filter(t => t.numero.startsWith(`OS-${e}`)).length;
          return {
            data: `OS-${e}-${String(t + 1).padStart(4, `0`)}`,
            error: null
          };
        }
      case `proximo_numero_contrato`:
        {
          let e = r.slice(0, 7).replace(`-`, ``);
          let t = n.contratos.filter(t => t.numero.startsWith(`CT-${e}`)).length;
          return {
            data: `CT-${e}-${String(t + 1).padStart(4, `0`)}`,
            error: null
          };
        }
      case `registrar_movimentacao`:
        {
          let e = n.materiais.find(e => e.id === t._material_id);
          if (!e) {
            return {
              data: null,
              error: {
                message: `Material não encontrado.`
              }
            };
          }
          let i = Number(t._quantidade) || 0;
          let a = t._tipo === `entrada` ? i : -i;
          e.estoque_atual = Math.max(0, e.estoque_atual + a);
          e.updated_at = r;
          let o = {
            id: crypto.randomUUID(),
            tenant_id: R,
            material_id: t._material_id,
            tipo: t._tipo,
            quantidade: i,
            custo_unitario: Number(t._custo_unitario) || e.custo_unitario,
            motivo: t._motivo ?? null,
            projeto_id: t._projeto_id ?? null,
            created_by: mt?.user?.id ?? `22222222-2222-4222-a222-222222222222`,
            created_at: r
          };
          n.movimentacoes_estoque.unshift(o);
          ft(n);
          return {
            data: o,
            error: null
          };
        }
      case `criar_contrato`:
        {
          let e = r.slice(0, 7).replace(`-`, ``);
          let a = n.contratos.filter(t => t.numero.startsWith(`CT-${e}`)).length;
          let o = `CT-${e}-${String(a + 1).padStart(4, `0`)}`;
          let s = Number(t._valor_total) || 0;
          let c = Number(t._num_parcelas) || 1;
          let l = Number(t._intervalo_dias) || 30;
          let u = t._primeiro_vencimento || i;
          let d = {
            id: crypto.randomUUID(),
            tenant_id: R,
            projeto_id: t._projeto_id,
            cliente_id: t._cliente_id,
            orcamento_id: t._orcamento_id ?? null,
            numero: o,
            status: `rascunho`,
            valor_total: s,
            num_parcelas: c,
            intervalo_dias: l,
            primeiro_vencimento: u,
            conteudo: t._conteudo ?? null,
            termos: t._termos ?? null,
            observacoes: t._observacoes ?? null,
            signatario_nome: null,
            signatario_documento: null,
            assinatura_data: null,
            assinado_em: null,
            created_by: mt?.user?.id ?? `22222222-2222-4222-a222-222222222222`,
            created_at: r,
            updated_at: r
          };
          n.contratos.unshift(d);
          let f = Math.floor(s / c * 100) / 100;
          let p = Math.round((s - f * c) * 100) / 100;
          let m = new Date(u);
          for (let e = 1; e <= c; e++) {
            let i = new Date(m);
            i.setDate(i.getDate() + (e - 1) * l);
            let a = i.toISOString().slice(0, 10);
            n.lancamentos.push({
              id: crypto.randomUUID(),
              tenant_id: R,
              tipo: `receita`,
              status: `previsto`,
              origem: `contrato`,
              descricao: `Parcela ${e}/${c} do contrato ${o}`,
              categoria_id: `cat-1`,
              contrato_id: d.id,
              parcela_numero: e,
              cliente_id: t._cliente_id,
              fornecedor_id: null,
              projeto_id: t._projeto_id,
              valor: e === c ? f + p : f,
              vencimento: a,
              pago_em: null,
              valor_pago: null,
              forma_pagamento: `pix`,
              observacoes: null,
              created_by: mt?.user?.id ?? `22222222-2222-4222-a222-222222222222`,
              created_at: r,
              updated_at: r
            });
          }
          ft(n);
          return {
            data: d,
            error: null
          };
        }
      case `assinar_contrato`:
        {
          let e = n.contratos.find(e => e.id === t._id);
          if (e) {
            e.status = `assinado`;
            e.signatario_nome = t._signatario_nome || e.signatario_nome;
            e.signatario_documento = t._signatario_documento || e.signatario_documento;
            e.assinatura_data = t._assinatura_data || r;
            e.assinado_em = r;
            e.updated_at = r;
            ft(n);
            return {
              data: e,
              error: null
            };
          } else {
            return {
              data: null,
              error: {
                message: `Contrato não encontrado.`
              }
            };
          }
        }
      case `cancelar_contrato`:
        {
          let e = n.contratos.find(e => e.id === t._id);
          if (!e) {
            return {
              data: null,
              error: {
                message: `Contrato não encontrado.`
              }
            };
          }
          e.status = `cancelado`;
          e.updated_at = r;
          for (let e of n.lancamentos) {
            if (e.contrato_id === t._id && e.status === `previsto`) {
              e.status = `cancelado`;
              e.updated_at = r;
            }
          }
          ft(n);
          return {
            data: e,
            error: null
          };
        }
      case `quitar_lancamento`:
        {
          let e = n.lancamentos.find(e => e.id === t._id);
          if (e) {
            e.status = `pago`;
            e.valor_pago = Number(t._valor_pago) || e.valor;
            e.forma_pagamento = t._forma ?? e.forma_pagamento ?? `pix`;
            e.pago_em = t._pago_em ?? r;
            e.updated_at = r;
            ft(n);
            return {
              data: e,
              error: null
            };
          } else {
            return {
              data: null,
              error: {
                message: `Lançamento não encontrado.`
              }
            };
          }
        }
      case `seed_catalogo_modulos`:
        return {
          data: n.modulos_catalogo.length,
          error: null
        };
      case `criar_ambiente_com_medicao`:
        {
          let e = n.ambientes.filter(e => e.projeto_id === t._projeto_id).length + 1;
          let i = {
            id: crypto.randomUUID(),
            tenant_id: R,
            projeto_id: t._projeto_id,
            nome: t._nome,
            tipo: t._tipo,
            margem_percent: Number(t._margem_percent) || 30,
            ordem: e,
            observacoes: t._observacoes ?? null,
            created_at: r,
            updated_at: r
          };
          n.ambientes.push(i);
          if (t._altura_cm || t._largura_cm || t._profundidade_cm) {
            n.medicoes.push({
              id: crypto.randomUUID(),
              tenant_id: R,
              ambiente_id: i.id,
              altura_cm: Number(t._altura_cm) || null,
              largura_cm: Number(t._largura_cm) || null,
              profundidade_cm: Number(t._profundidade_cm) || null,
              desnivel_cm: 0,
              pontos_eletricos: 0,
              pontos_hidraulicos: 0,
              colunas_vigas: null,
              observacoes: null,
              created_at: r,
              updated_at: r
            });
          }
          ft(n);
          return {
            data: i,
            error: null
          };
        }
      case `criar_orcamento_estudo`:
        {
          let e = n.designs.find(e => e.id === t._design_id);
          let i = n.projetos.find(t => t.id === e?.projeto_id);
          if (!e || !i) {
            return {
              data: null,
              error: {
                message: `Estudo não encontrado.`
              }
            };
          }
          let a = t._calculo || {};
          let o = n.orcamentos.filter(e => e.projeto_id === i.id).length + 1;
          let s = {
            id: crypto.randomUUID(),
            tenant_id: R,
            projeto_id: i.id,
            cliente_id: i.cliente_id,
            versao: o,
            status: `rascunho`,
            material_custo: Number(a.material_custo) || 0,
            ferragens_custo: Number(a.ferragens_custo) || 0,
            perda_percent: Number(a.perda_percent) || 5,
            operacional_custo: Number(a.operacional_custo) || 0,
            montagem_horas: Number(a.montagem_horas) || 0,
            montagem_valor_hora: Number(a.montagem_valor_hora) || 85,
            frete: Number(a.frete) || 0,
            impostos_percent: Number(a.impostos_percent) || 0,
            margem_percent: Number(a.margem_percent) || 30,
            subtotal: Number(a.subtotal) || 0,
            total: Number(a.total) || 0,
            validade_dias: Number(a.validade_dias) || 15,
            observacoes: a.observacoes ?? null,
            created_by: mt?.user?.id ?? `22222222-2222-4222-a222-222222222222`,
            created_at: r,
            updated_at: r
          };
          n.orcamentos.unshift(s);
          (Array.isArray(t._itens) ? t._itens : []).forEach((e, t) => {
            n.orcamento_itens.push({
              id: crypto.randomUUID(),
              tenant_id: R,
              orcamento_id: s.id,
              ambiente_id: e.ambiente_id || null,
              ambiente_nome: e.ambiente_nome || null,
              descricao: e.descricao || `Item ${t + 1}`,
              quantidade: Number(e.quantidade) || 1,
              custo_unitario: Number(e.custo_unitario) || 0,
              valor_unitario: Number(e.valor_unitario) || 0,
              ordem: t + 1,
              created_at: r,
              updated_at: r
            });
          });
          ft(n);
          return {
            data: s,
            error: null
          };
        }
      default:
        return {
          data: null,
          error: null
        };
    }
  },
  functions: {
    async invoke(e, t) {
      let n = dt();
      let r = t?.body ?? {};
      let i = new Date().toISOString();
      switch (e) {
        case `criar-ambiente`:
          {
            let e = await bt.rpc(`criar_ambiente_com_medicao`, {
              _projeto_id: r.projeto_id,
              _nome: r.nome,
              _tipo: r.tipo,
              _margem_percent: r.margem_percent,
              _altura_cm: r.altura_cm,
              _largura_cm: r.largura_cm,
              _profundidade_cm: r.profundidade_cm,
              _observacoes: r.observacoes
            });
            return {
              data: {
                ambiente: e.data
              },
              error: e.error
            };
          }
        case `orcamento-ambiente`:
          {
            let e = n.designs.find(e => e.id === r.design_id);
            if (!e) {
              return {
                data: null,
                error: {
                  message: `Estudo não encontrado.`
                }
              };
            }
            let t = e.ambiente_id ? n.ambientes.find(t => t.id === e.ambiente_id) : null;
            let i = t?.margem_percent ?? 30;
            let a = [];
            for (let t of e.cena?.modulos ?? []) {
              let e = nt(t);
              if (e) {
                a.push(e);
              }
            }
            let o = n.tenants.find(t => t.id === e.tenant_id)?.config_precos || null;
            let s = at({
              modulos: a
            }, i, o);
            let c = {
              material_custo: s.custoMDF + s.custoFita,
              ferragens_custo: s.custoFerragens,
              perda_percent: Number(r.perda_percent) || 5,
              operacional_custo: s.custoServicos + (Number(r.operacional_custo) || 0),
              montagem_horas: Number(r.montagem_horas) || 0,
              montagem_valor_hora: Number(r.montagem_valor_hora) || 85,
              frete: Number(r.frete) || 0,
              impostos_percent: Number(r.impostos_percent) || 0,
              margem_percent: i,
              validade_dias: Number(r.validade_dias) || 15,
              observacoes: r.observacoes?.trim() || null
            };
            let l = st(c);
            let u = [{
              ambiente_id: e.ambiente_id ?? ``,
              ambiente_nome: t?.nome ?? null,
              descricao: `Estudo 3D ${e.nome}`,
              quantidade: 1,
              custo_unitario: l.subtotal,
              valor_unitario: l.total
            }];
            let {
              data: d,
              error: f
            } = await bt.rpc(`criar_orcamento_estudo`, {
              _design_id: e.id,
              _calculo: {
                ...c,
                subtotal: l.subtotal,
                total: l.total
              },
              _itens: u
            });
            if (f) {
              return {
                data: null,
                error: f
              };
            } else {
              return {
                data: {
                  orcamento: d,
                  resumo: {
                    total_pecas: s.totalPecas,
                    chapas: s.chapasEstimadas,
                    area_mdf_m2: s.areaMDFM2,
                    metros_fita: s.metrosFitaBorda,
                    custo_total: l.subtotal,
                    margem_percent: i,
                    preco_venda: l.total
                  }
                },
                error: null
              };
            }
          }
        case `cadastro`:
          {
            let e = await bt.auth.signUp({
              email: r.email,
              password: r.password,
              options: {
                data: {
                  full_name: r.full_name,
                  tenant_name: r.tenant_name
                }
              }
            });
            return {
              data: {
                user: e.data.user
              },
              error: e.error
            };
          }
        case `criar-membro`:
          {
            let e = crypto.randomUUID();
            let t = R;
            n._auth_users.push({
              id: e,
              email: r.email,
              password: r.password || `admin`,
              full_name: r.full_name,
              tenant_id: t,
              created_at: i
            });
            n.profiles.push({
              id: e,
              tenant_id: t,
              email: r.email,
              full_name: r.full_name,
              telefone: null,
              avatar_url: null,
              ativo: true,
              created_at: i,
              updated_at: i
            });
            n.user_roles.push({
              id: crypto.randomUUID(),
              user_id: e,
              tenant_id: t,
              role: r.role || `marceneiro`,
              created_at: i
            });
            ft(n);
            return {
              data: {
                user: {
                  id: e,
                  email: r.email
                }
              },
              error: null
            };
          }
        case `ambiente-mockup`:
          {
            let e = n.ambientes.find(e => e.id === r.ambiente_id);
            let t = n.medicoes.find(e => e.ambiente_id === r.ambiente_id);
            if (e) {
              return {
                data: Xe({
                  nome: e.nome,
                  tipo: e.tipo,
                  largura_cm: t?.largura_cm ?? null,
                  altura_cm: t?.altura_cm ?? null,
                  profundidade_cm: t?.profundidade_cm ?? null,
                  desnivel_cm: t?.desnivel_cm ?? null,
                  pontos_eletricos: t?.pontos_eletricos ?? null,
                  pontos_hidraulicos: t?.pontos_hidraulicos ?? null,
                  margem_percent: e.margem_percent
                }, r.tema ?? `claro`, r.formato ?? `normal`),
                error: null
              };
            } else {
              return {
                data: null,
                error: {
                  message: `Ambiente não encontrado.`
                }
              };
            }
          }
        default:
          return {
            data: null,
            error: null
          };
      }
    }
  },
  storage: {
    from(e) {
      return {
        async upload(t, n, r) {
          let i = dt();
          i._storage[e] ||= {};
          return new Promise(r => {
            let a = new FileReader();
            a.onloadend = () => {
              i._storage[e][t] = a.result;
              ft(i);
              r({
                data: {
                  path: t
                },
                error: null
              });
            };
            a.onerror = () => {
              i._storage[e][t] = `data:image/svg+xml;utf8,<svg></svg>`;
              ft(i);
              r({
                data: {
                  path: t
                },
                error: null
              });
            };
            a.readAsDataURL(n);
          });
        },
        getPublicUrl(t) {
          return {
            data: {
              publicUrl: dt()._storage[e]?.[t] || `https://mock.planejadospro.local/${e}/${t}`
            }
          };
        },
        async createSignedUrl(t, n = 3600) {
          return {
            data: {
              signedUrl: dt()._storage[e]?.[t] || `https://mock.planejadospro.local/${e}/${t}`
            },
            error: null
          };
        },
        async remove(t) {
          let n = dt();
          if (n._storage[e]) {
            for (let r of t) {
              delete n._storage[e][r];
            }
            ft(n);
          }
          return {
            data: t,
            error: null
          };
        }
      };
    }
  }
};
var B = bt;
var xt = (0, k.createContext)(undefined);
function St({
  children: e
}) {
  let [t, n] = (0, k.useState)(null);
  let [r, i] = (0, k.useState)(null);
  let [a, o] = (0, k.useState)(null);
  let [s, c] = (0, k.useState)(null);
  let [l, u] = (0, k.useState)([]);
  let [d, f] = (0, k.useState)(true);
  let [p, m] = (0, k.useState)(false);
  let [h, g] = (0, k.useState)(false);
  let _ = (0, k.useCallback)(() => {
    o(null);
    c(null);
    u([]);
    m(false);
  }, []);
  let v = (0, k.useCallback)(async (e, t = 1) => {
    try {
      let [{
        data: t,
        error: n
      }, {
        data: r,
        error: i
      }] = await Promise.all([B.from(`profiles`).select(`tenant_id, full_name`).eq(`id`, e.id).maybeSingle(), B.from(`user_roles`).select(`role`).eq(`user_id`, e.id)]);
      if (n) {
        throw n;
      }
      if (i) {
        throw i;
      }
      if (!t) {
        m(true);
        o(null);
        c(null);
        u([]);
        return;
      }
      o(t.tenant_id);
      c(t.full_name);
      u((r ?? []).map(e => e.role) ?? []);
      m(false);
    } catch (n) {
      if ((n?.code === `PGRST303` || n?.message?.includes(`issued at future`)) && t <= 4) {
        setTimeout(() => {
          v(e, t + 1);
        }, t * 1000);
        return;
      }
      console.error(`Falha ao carregar contexto do usuário:`, n);
      m(true);
      o(null);
      c(null);
      u([]);
    }
  }, []);
  let y = (0, k.useCallback)(async () => {
    let {
      data: e
    } = await B.auth.getSession();
    n(e.session);
    i(e.session?.user ?? null);
    if (e.session?.user) {
      await v(e.session.user);
    } else {
      _();
    }
  }, [v, _]);
  (0, k.useEffect)(() => {
    let {
      data: e
    } = B.auth.onAuthStateChange((e, t) => {
      if (e === `PASSWORD_RECOVERY`) {
        g(true);
      }
      n(t);
      i(t?.user ?? null);
      if (t?.user) {
        v(t.user);
      } else {
        _();
      }
    });
    (async () => {
      await y();
      f(false);
    })();
    return () => e.subscription.unsubscribe();
  }, [v, _, y]);
  let b = (0, k.useCallback)(async () => {
    try {
      await B.auth.signOut();
      N.success(`Você saiu da conta.`);
    } catch (e) {
      console.error(`Erro ao encerrar sessão:`, e);
    } finally {
      n(null);
      i(null);
      _();
      window.location.hash = `#/login`;
    }
  }, [_]);
  let x = (0, k.useCallback)(e => (Array.isArray(e) ? e : [e]).some(e => l.includes(e)), [l]);
  let S = (0, k.useMemo)(() => ({
    session: t,
    user: r,
    tenantId: a,
    profileName: s,
    roles: l,
    loading: d,
    authError: p,
    recovery: h,
    isAdmin: l.includes(`admin`),
    hasRole: x,
    clearRecovery: () => g(false),
    signOut: b,
    refresh: y
  }), [t, r, a, s, l, d, p, h, x, b, y]);
  return <xt.Provider value={S}>{e}</xt.Provider>;
}
function Ct() {
  let e = (0, k.useContext)(xt);
  if (!e) {
    throw Error(`useAuth deve ser usado dentro de <AuthProvider>`);
  }
  return e;
}
function _Component98({
  children: e,
  requireRole: t
}) {
  let {
    session: n,
    roles: r,
    loading: i,
    authError: a
  } = Ct();
  let o = b();
  if (i) {
    return null;
  } else if (a && o.pathname !== `/auth-error`) {
    return <_Component to={`/auth-error`} replace={true} />;
  } else if (n) {
    if (t && !(Array.isArray(t) ? t : [t]).some(e => r.includes(e))) {
      return <_Component to={`/`} replace={true} />;
    } else {
      return <L.Fragment>{e}</L.Fragment>;
    }
  } else {
    return <_Component to={`/login`} replace={true} state={{
      from: o.pathname
    }} />;
  }
}
function Tt({
  children: e
}) {
  let {
    session: t,
    loading: n
  } = Ct();
  if (n) {
    return null;
  } else if (t) {
    return <_Component to={`/`} replace={true} />;
  } else {
    return <L.Fragment>{e}</L.Fragment>;
  }
}
var Et = e => e.replace(/([a-z0-9])([A-Z])/g, `$1-$2`).toLowerCase();
var Dt = (...e) => e.filter((e, t, n) => !!e && e.trim() !== `` && n.indexOf(e) === t).join(` `).trim();
var Ot = {
  xmlns: `http://www.w3.org/2000/svg`,
  width: 24,
  height: 24,
  viewBox: `0 0 24 24`,
  fill: `none`,
  stroke: `currentColor`,
  strokeWidth: 2,
  strokeLinecap: `round`,
  strokeLinejoin: `round`
};
var kt = (0, k.forwardRef)(({
  color: e = `currentColor`,
  size: t = 24,
  strokeWidth: n = 2,
  absoluteStrokeWidth: r,
  className: i = ``,
  children: a,
  iconNode: o,
  ...s
}, c) => (0, k.createElement)(`svg`, {
  ref: c,
  ...Ot,
  width: t,
  height: t,
  stroke: e,
  strokeWidth: r ? Number(n) * 24 / Number(t) : n,
  className: Dt(`lucide`, i),
  ...s
}, [...o.map(([e, t]) => (0, k.createElement)(e, t)), ...(Array.isArray(a) ? a : [a])]));
var V = (e, t) => {
  let n = (0, k.forwardRef)(({
    className: n,
    ...r
  }, i) => (0, k.createElement)(kt, {
    ref: i,
    iconNode: t,
    className: Dt(`lucide-${Et(e)}`, n),
    ...r
  }));
  n.displayName = `${e}`;
  return n;
};
var At = V(`AirVent`, [[`path`, {
  d: `M6 12H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2h-2`,
  key: `larmp2`
}], [`path`, {
  d: `M6 8h12`,
  key: `6g4wlu`
}], [`path`, {
  d: `M18.3 17.7a2.5 2.5 0 0 1-3.16 3.83 2.53 2.53 0 0 1-1.14-2V12`,
  key: `1bo8pg`
}], [`path`, {
  d: `M6.6 15.6A2 2 0 1 0 10 17v-5`,
  key: `t9h90c`
}]]);
var _Component49 = V(`ArrowDownLeft`, [[`path`, {
  d: `M17 7 7 17`,
  key: `15tmo1`
}], [`path`, {
  d: `M17 17H7V7`,
  key: `1org7z`
}]]);
var Mt = V(`ArrowLeft`, [[`path`, {
  d: `m12 19-7-7 7-7`,
  key: `1l729n`
}], [`path`, {
  d: `M19 12H5`,
  key: `x3x0zl`
}]]);
var Nt = V(`ArrowUpRight`, [[`path`, {
  d: `M7 7h10v10`,
  key: `1tivn9`
}], [`path`, {
  d: `M7 17 17 7`,
  key: `1vkiza`
}]]);
var Pt = V(`BedDouble`, [[`path`, {
  d: `M2 20v-8a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v8`,
  key: `1k78r4`
}], [`path`, {
  d: `M4 10V6a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v4`,
  key: `fb3tl2`
}], [`path`, {
  d: `M12 4v6`,
  key: `1dcgq2`
}], [`path`, {
  d: `M2 18h20`,
  key: `ajqnye`
}]]);
var Ft = V(`Bed`, [[`path`, {
  d: `M2 4v16`,
  key: `vw9hq8`
}], [`path`, {
  d: `M2 8h18a2 2 0 0 1 2 2v10`,
  key: `1dgv2r`
}], [`path`, {
  d: `M2 17h20`,
  key: `18nfp3`
}], [`path`, {
  d: `M6 8v9`,
  key: `1yriud`
}]]);
var It = V(`Blocks`, [[`rect`, {
  width: `7`,
  height: `7`,
  x: `14`,
  y: `3`,
  rx: `1`,
  key: `6d4xhi`
}], [`path`, {
  d: `M10 21V8a1 1 0 0 0-1-1H4a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-5a1 1 0 0 0-1-1H3`,
  key: `1fpvtg`
}]]);
var Lt = V(`Box`, [[`path`, {
  d: `M21 8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16Z`,
  key: `hh9hay`
}], [`path`, {
  d: `m3.3 7 8.7 5 8.7-5`,
  key: `g66t2b`
}], [`path`, {
  d: `M12 22V12`,
  key: `d0xqtd`
}]]);
var Rt = V(`Boxes`, [[`path`, {
  d: `M2.97 12.92A2 2 0 0 0 2 14.63v3.24a2 2 0 0 0 .97 1.71l3 1.8a2 2 0 0 0 2.06 0L12 19v-5.5l-5-3-4.03 2.42Z`,
  key: `lc1i9w`
}], [`path`, {
  d: `m7 16.5-4.74-2.85`,
  key: `1o9zyk`
}], [`path`, {
  d: `m7 16.5 5-3`,
  key: `va8pkn`
}], [`path`, {
  d: `M7 16.5v5.17`,
  key: `jnp8gn`
}], [`path`, {
  d: `M12 13.5V19l3.97 2.38a2 2 0 0 0 2.06 0l3-1.8a2 2 0 0 0 .97-1.71v-3.24a2 2 0 0 0-.97-1.71L17 10.5l-5 3Z`,
  key: `8zsnat`
}], [`path`, {
  d: `m17 16.5-5-3`,
  key: `8arw3v`
}], [`path`, {
  d: `m17 16.5 4.74-2.85`,
  key: `8rfmw`
}], [`path`, {
  d: `M17 16.5v5.17`,
  key: `k6z78m`
}], [`path`, {
  d: `M7.97 4.42A2 2 0 0 0 7 6.13v4.37l5 3 5-3V6.13a2 2 0 0 0-.97-1.71l-3-1.8a2 2 0 0 0-2.06 0l-3 1.8Z`,
  key: `1xygjf`
}], [`path`, {
  d: `M12 8 7.26 5.15`,
  key: `1vbdud`
}], [`path`, {
  d: `m12 8 4.74-2.85`,
  key: `3rx089`
}], [`path`, {
  d: `M12 13.5V8`,
  key: `1io7kd`
}]]);
var _Component92 = V(`Building2`, [[`path`, {
  d: `M6 22V4a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v18Z`,
  key: `1b4qmf`
}], [`path`, {
  d: `M6 12H4a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h2`,
  key: `i71pzd`
}], [`path`, {
  d: `M18 9h2a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2h-2`,
  key: `10jefs`
}], [`path`, {
  d: `M10 6h4`,
  key: `1itunk`
}], [`path`, {
  d: `M10 10h4`,
  key: `tcdvrf`
}], [`path`, {
  d: `M10 14h4`,
  key: `kelpxr`
}], [`path`, {
  d: `M10 18h4`,
  key: `1ulq68`
}]]);
var Bt = V(`Calculator`, [[`rect`, {
  width: `16`,
  height: `20`,
  x: `4`,
  y: `2`,
  rx: `2`,
  key: `1nb95v`
}], [`line`, {
  x1: `8`,
  x2: `16`,
  y1: `6`,
  y2: `6`,
  key: `x4nwl0`
}], [`line`, {
  x1: `16`,
  x2: `16`,
  y1: `14`,
  y2: `18`,
  key: `wjye3r`
}], [`path`, {
  d: `M16 10h.01`,
  key: `1m94wz`
}], [`path`, {
  d: `M12 10h.01`,
  key: `1nrarc`
}], [`path`, {
  d: `M8 10h.01`,
  key: `19clt8`
}], [`path`, {
  d: `M12 14h.01`,
  key: `1etili`
}], [`path`, {
  d: `M8 14h.01`,
  key: `6423bh`
}], [`path`, {
  d: `M12 18h.01`,
  key: `mhygvu`
}], [`path`, {
  d: `M8 18h.01`,
  key: `lrp35t`
}]]);
var Vt = V(`CalendarClock`, [[`path`, {
  d: `M21 7.5V6a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h3.5`,
  key: `1osxxc`
}], [`path`, {
  d: `M16 2v4`,
  key: `4m81vk`
}], [`path`, {
  d: `M8 2v4`,
  key: `1cmpym`
}], [`path`, {
  d: `M3 10h5`,
  key: `r794hk`
}], [`path`, {
  d: `M17.5 17.5 16 16.3V14`,
  key: `akvzfd`
}], [`circle`, {
  cx: `16`,
  cy: `16`,
  r: `6`,
  key: `qoo3c4`
}]]);
var Ht = V(`CalendarDays`, [[`path`, {
  d: `M8 2v4`,
  key: `1cmpym`
}], [`path`, {
  d: `M16 2v4`,
  key: `4m81vk`
}], [`rect`, {
  width: `18`,
  height: `18`,
  x: `3`,
  y: `4`,
  rx: `2`,
  key: `1hopcy`
}], [`path`, {
  d: `M3 10h18`,
  key: `8toen8`
}], [`path`, {
  d: `M8 14h.01`,
  key: `6423bh`
}], [`path`, {
  d: `M12 14h.01`,
  key: `1etili`
}], [`path`, {
  d: `M16 14h.01`,
  key: `1gbofw`
}], [`path`, {
  d: `M8 18h.01`,
  key: `lrp35t`
}], [`path`, {
  d: `M12 18h.01`,
  key: `mhygvu`
}], [`path`, {
  d: `M16 18h.01`,
  key: `kzsmim`
}]]);
var Ut = V(`Check`, [[`path`, {
  d: `M20 6 9 17l-5-5`,
  key: `1gmf2c`
}]]);
var Wt = V(`ChevronDown`, [[`path`, {
  d: `m6 9 6 6 6-6`,
  key: `qrunsl`
}]]);
var Gt = V(`ChevronUp`, [[`path`, {
  d: `m18 15-6-6-6 6`,
  key: `153udz`
}]]);
var Kt = V(`CircleCheck`, [[`circle`, {
  cx: `12`,
  cy: `12`,
  r: `10`,
  key: `1mglay`
}], [`path`, {
  d: `m9 12 2 2 4-4`,
  key: `dzmm74`
}]]);
var _Component53 = V(`CircleX`, [[`circle`, {
  cx: `12`,
  cy: `12`,
  r: `10`,
  key: `1mglay`
}], [`path`, {
  d: `m15 9-6 6`,
  key: `1uzhvr`
}], [`path`, {
  d: `m9 9 6 6`,
  key: `z0biqf`
}]]);
var Jt = V(`ClipboardCheck`, [[`rect`, {
  width: `8`,
  height: `4`,
  x: `8`,
  y: `2`,
  rx: `1`,
  ry: `1`,
  key: `tgr4d6`
}], [`path`, {
  d: `M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2`,
  key: `116196`
}], [`path`, {
  d: `m9 14 2 2 4-4`,
  key: `df797q`
}]]);
var Yt = V(`ClipboardList`, [[`rect`, {
  width: `8`,
  height: `4`,
  x: `8`,
  y: `2`,
  rx: `1`,
  ry: `1`,
  key: `tgr4d6`
}], [`path`, {
  d: `M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2`,
  key: `116196`
}], [`path`, {
  d: `M12 11h4`,
  key: `1jrz19`
}], [`path`, {
  d: `M12 16h4`,
  key: `n85exb`
}], [`path`, {
  d: `M8 11h.01`,
  key: `1dfujw`
}], [`path`, {
  d: `M8 16h.01`,
  key: `18s6g9`
}]]);
var Xt = V(`Coins`, [[`circle`, {
  cx: `8`,
  cy: `8`,
  r: `6`,
  key: `3yglwk`
}], [`path`, {
  d: `M18.09 10.37A6 6 0 1 1 10.34 18`,
  key: `t5s6rm`
}], [`path`, {
  d: `M7 6h1v4`,
  key: `1obek4`
}], [`path`, {
  d: `m16.71 13.88.7.71-2.82 2.82`,
  key: `1rbuyh`
}]]);
var Zt = V(`Columns2`, [[`rect`, {
  width: `18`,
  height: `18`,
  x: `3`,
  y: `3`,
  rx: `2`,
  key: `afitv7`
}], [`path`, {
  d: `M12 3v18`,
  key: `108xh3`
}]]);
var Qt = V(`Compass`, [[`path`, {
  d: `m16.24 7.76-1.804 5.411a2 2 0 0 1-1.265 1.265L7.76 16.24l1.804-5.411a2 2 0 0 1 1.265-1.265z`,
  key: `9ktpf1`
}], [`circle`, {
  cx: `12`,
  cy: `12`,
  r: `10`,
  key: `1mglay`
}]]);
var $t = V(`Copy`, [[`rect`, {
  width: `14`,
  height: `14`,
  x: `8`,
  y: `8`,
  rx: `2`,
  ry: `2`,
  key: `17jyea`
}], [`path`, {
  d: `M4 16c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2h10c1.1 0 2 .9 2 2`,
  key: `zix9uf`
}]]);
var _Component61 = V(`DoorOpen`, [[`path`, {
  d: `M13 4h3a2 2 0 0 1 2 2v14`,
  key: `hrm0s9`
}], [`path`, {
  d: `M2 20h3`,
  key: `1gaodv`
}], [`path`, {
  d: `M13 20h9`,
  key: `s90cdi`
}], [`path`, {
  d: `M10 12v.01`,
  key: `vx6srw`
}], [`path`, {
  d: `M13 4.562v16.157a1 1 0 0 1-1.242.97L5 20V5.562a2 2 0 0 1 1.515-1.94l4-1A2 2 0 0 1 13 4.561Z`,
  key: `199qr4`
}]]);
var _Component37 = V(`Download`, [[`path`, {
  d: `M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4`,
  key: `ih7n3h`
}], [`polyline`, {
  points: `7 10 12 15 17 10`,
  key: `2ggqvy`
}], [`line`, {
  x1: `12`,
  x2: `12`,
  y1: `15`,
  y2: `3`,
  key: `1vk2je`
}]]);
var _Component70 = V(`Droplets`, [[`path`, {
  d: `M7 16.3c2.2 0 4-1.83 4-4.05 0-1.16-.57-2.26-1.71-3.19S7.29 6.75 7 5.3c-.29 1.45-1.14 2.84-2.29 3.76S3 11.1 3 12.25c0 2.22 1.8 4.05 4 4.05z`,
  key: `1ptgy4`
}], [`path`, {
  d: `M12.56 6.6A10.97 10.97 0 0 0 14 3.02c.5 2.5 2 4.9 4 6.5s3 3.5 3 5.5a6.98 6.98 0 0 1-11.91 4.97`,
  key: `1sl1rz`
}]]);
var _Component2 = V(`EllipsisVertical`, [[`circle`, {
  cx: `12`,
  cy: `12`,
  r: `1`,
  key: `41hilf`
}], [`circle`, {
  cx: `12`,
  cy: `5`,
  r: `1`,
  key: `gxeob9`
}], [`circle`, {
  cx: `12`,
  cy: `19`,
  r: `1`,
  key: `lyex9k`
}]]);
var _Component45 = V(`Eraser`, [[`path`, {
  d: `m7 21-4.3-4.3c-1-1-1-2.5 0-3.4l9.6-9.6c1-1 2.5-1 3.4 0l5.6 5.6c1 1 1 2.5 0 3.4L13 21`,
  key: `182aya`
}], [`path`, {
  d: `M22 21H7`,
  key: `t4ddhn`
}], [`path`, {
  d: `m5 11 9 9`,
  key: `1mo9qw`
}]]);
var _Component12 = V(`EyeOff`, [[`path`, {
  d: `M10.733 5.076a10.744 10.744 0 0 1 11.205 6.575 1 1 0 0 1 0 .696 10.747 10.747 0 0 1-1.444 2.49`,
  key: `ct8e1f`
}], [`path`, {
  d: `M14.084 14.158a3 3 0 0 1-4.242-4.242`,
  key: `151rxh`
}], [`path`, {
  d: `M17.479 17.499a10.75 10.75 0 0 1-15.417-5.151 1 1 0 0 1 0-.696 10.75 10.75 0 0 1 4.446-5.143`,
  key: `13bj9a`
}], [`path`, {
  d: `m2 2 20 20`,
  key: `1ooewy`
}]]);
var _Component13 = V(`Eye`, [[`path`, {
  d: `M2.062 12.348a1 1 0 0 1 0-.696 10.75 10.75 0 0 1 19.876 0 1 1 0 0 1 0 .696 10.75 10.75 0 0 1-19.876 0`,
  key: `1nclc0`
}], [`circle`, {
  cx: `12`,
  cy: `12`,
  r: `3`,
  key: `1v7zrd`
}]]);
var _Component5 = V(`FilePenLine`, [[`path`, {
  d: `m18 5-2.414-2.414A2 2 0 0 0 14.172 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2`,
  key: `142zxg`
}], [`path`, {
  d: `M21.378 12.626a1 1 0 0 0-3.004-3.004l-4.01 4.012a2 2 0 0 0-.506.854l-.837 2.87a.5.5 0 0 0 .62.62l2.87-.837a2 2 0 0 0 .854-.506z`,
  key: `2t3380`
}], [`path`, {
  d: `M8 18h1`,
  key: `13wk12`
}]]);
var _Component74 = V(`FileSpreadsheet`, [[`path`, {
  d: `M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z`,
  key: `1rqfz7`
}], [`path`, {
  d: `M14 2v4a2 2 0 0 0 2 2h4`,
  key: `tnqrlb`
}], [`path`, {
  d: `M8 13h2`,
  key: `yr2amv`
}], [`path`, {
  d: `M14 13h2`,
  key: `un5t4a`
}], [`path`, {
  d: `M8 17h2`,
  key: `2yhykz`
}], [`path`, {
  d: `M14 17h2`,
  key: `10kma7`
}]]);
var un = V(`FileText`, [[`path`, {
  d: `M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z`,
  key: `1rqfz7`
}], [`path`, {
  d: `M14 2v4a2 2 0 0 0 2 2h4`,
  key: `tnqrlb`
}], [`path`, {
  d: `M10 9H8`,
  key: `b1mrlr`
}], [`path`, {
  d: `M16 13H8`,
  key: `t4e002`
}], [`path`, {
  d: `M16 17H8`,
  key: `z1uh3a`
}]]);
var _Component71 = V(`Flame`, [[`path`, {
  d: `M8.5 14.5A2.5 2.5 0 0 0 11 12c0-1.38-.5-2-1-3-1.072-2.143-.224-4.054 2-6 .5 2.5 2 4.9 4 6.5 2 1.6 3 3.5 3 5.5a7 7 0 1 1-14 0c0-1.153.433-2.294 1-3a2.5 2.5 0 0 0 2.5 2.5z`,
  key: `96xj49`
}]]);
var _Component4 = V(`FolderKanban`, [[`path`, {
  d: `M4 20h16a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2h-7.93a2 2 0 0 1-1.66-.9l-.82-1.2A2 2 0 0 0 7.93 3H4a2 2 0 0 0-2 2v13c0 1.1.9 2 2 2Z`,
  key: `1fr9dc`
}], [`path`, {
  d: `M8 10v4`,
  key: `tgpxqk`
}], [`path`, {
  d: `M12 10v2`,
  key: `hh53o1`
}], [`path`, {
  d: `M16 10v6`,
  key: `1d6xys`
}]]);
var _Component64 = V(`Frame`, [[`line`, {
  x1: `22`,
  x2: `2`,
  y1: `6`,
  y2: `6`,
  key: `15w7dq`
}], [`line`, {
  x1: `22`,
  x2: `2`,
  y1: `18`,
  y2: `18`,
  key: `1ip48p`
}], [`line`, {
  x1: `6`,
  x2: `6`,
  y1: `2`,
  y2: `22`,
  key: `a2lnyx`
}], [`line`, {
  x1: `18`,
  x2: `18`,
  y1: `2`,
  y2: `22`,
  key: `8vb6jd`
}]]);
var _Component67 = V(`Grid2x2`, [[`path`, {
  d: `M12 3v18`,
  key: `108xh3`
}], [`path`, {
  d: `M3 12h18`,
  key: `1i2n21`
}], [`rect`, {
  x: `3`,
  y: `3`,
  width: `18`,
  height: `18`,
  rx: `2`,
  key: `h1oib`
}]]);
var _Component59 = V(`Grid3x3`, [[`rect`, {
  width: `18`,
  height: `18`,
  x: `3`,
  y: `3`,
  rx: `2`,
  key: `afitv7`
}], [`path`, {
  d: `M3 9h18`,
  key: `1pudct`
}], [`path`, {
  d: `M3 15h18`,
  key: `5xshup`
}], [`path`, {
  d: `M9 3v18`,
  key: `fh3hqa`
}], [`path`, {
  d: `M15 3v18`,
  key: `14nvp0`
}]]);
var _Component75 = V(`Hammer`, [[`path`, {
  d: `m15 12-8.373 8.373a1 1 0 1 1-3-3L12 9`,
  key: `eefl8a`
}], [`path`, {
  d: `m18 15 4-4`,
  key: `16gjal`
}], [`path`, {
  d: `m21.5 11.5-1.914-1.914A2 2 0 0 1 19 8.172V7l-2.26-2.26a6 6 0 0 0-4.202-1.756L9 2.96l.92.82A6.18 6.18 0 0 1 12 8.4V10l2 2h1.172a2 2 0 0 1 1.414.586L18.5 14.5`,
  key: `b7pghm`
}]]);
var _n = V(`Image`, [[`rect`, {
  width: `18`,
  height: `18`,
  x: `3`,
  y: `3`,
  rx: `2`,
  ry: `2`,
  key: `1m3agn`
}], [`circle`, {
  cx: `9`,
  cy: `9`,
  r: `2`,
  key: `af1f0g`
}], [`path`, {
  d: `m21 15-3.086-3.086a2 2 0 0 0-2.828 0L6 21`,
  key: `1xmnt7`
}]]);
var _Component52 = V(`Info`, [[`circle`, {
  cx: `12`,
  cy: `12`,
  r: `10`,
  key: `1mglay`
}], [`path`, {
  d: `M12 16v-4`,
  key: `1dtifu`
}], [`path`, {
  d: `M12 8h.01`,
  key: `e9boi3`
}]]);
var _Component94 = V(`KeyRound`, [[`path`, {
  d: `M2.586 17.414A2 2 0 0 0 2 18.828V21a1 1 0 0 0 1 1h3a1 1 0 0 0 1-1v-1a1 1 0 0 1 1-1h1a1 1 0 0 0 1-1v-1a1 1 0 0 1 1-1h.172a2 2 0 0 0 1.414-.586l.814-.814a6.5 6.5 0 1 0-4-4z`,
  key: `1s6t7t`
}], [`circle`, {
  cx: `16.5`,
  cy: `7.5`,
  r: `.5`,
  fill: `currentColor`,
  key: `w0ekpg`
}]]);
var _Component66 = V(`Lamp`, [[`path`, {
  d: `M8 2h8l4 10H4L8 2Z`,
  key: `9dma5w`
}], [`path`, {
  d: `M12 12v6`,
  key: `3ahymv`
}], [`path`, {
  d: `M8 22v-2c0-1.1.9-2 2-2h4a2 2 0 0 1 2 2v2H8Z`,
  key: `mwf4oh`
}]]);
var _Component60 = V(`Layers`, [[`path`, {
  d: `M12.83 2.18a2 2 0 0 0-1.66 0L2.6 6.08a1 1 0 0 0 0 1.83l8.58 3.91a2 2 0 0 0 1.66 0l8.58-3.9a1 1 0 0 0 0-1.83z`,
  key: `zw3jo`
}], [`path`, {
  d: `M2 12a1 1 0 0 0 .58.91l8.6 3.91a2 2 0 0 0 1.65 0l8.58-3.9A1 1 0 0 0 22 12`,
  key: `1wduqc`
}], [`path`, {
  d: `M2 17a1 1 0 0 0 .58.91l8.6 3.91a2 2 0 0 0 1.65 0l8.58-3.9A1 1 0 0 0 22 17`,
  key: `kqbvx6`
}]]);
var Sn = V(`LayoutDashboard`, [[`rect`, {
  width: `7`,
  height: `9`,
  x: `3`,
  y: `3`,
  rx: `1`,
  key: `10lvy0`
}], [`rect`, {
  width: `7`,
  height: `5`,
  x: `14`,
  y: `3`,
  rx: `1`,
  key: `16une8`
}], [`rect`, {
  width: `7`,
  height: `9`,
  x: `14`,
  y: `12`,
  rx: `1`,
  key: `1hutg5`
}], [`rect`, {
  width: `7`,
  height: `5`,
  x: `3`,
  y: `16`,
  rx: `1`,
  key: `ldoo1y`
}]]);
var Cn = V(`LayoutGrid`, [[`rect`, {
  width: `7`,
  height: `7`,
  x: `3`,
  y: `3`,
  rx: `1`,
  key: `1g98yp`
}], [`rect`, {
  width: `7`,
  height: `7`,
  x: `14`,
  y: `3`,
  rx: `1`,
  key: `6d4xhi`
}], [`rect`, {
  width: `7`,
  height: `7`,
  x: `14`,
  y: `14`,
  rx: `1`,
  key: `nxv5o0`
}], [`rect`, {
  width: `7`,
  height: `7`,
  x: `3`,
  y: `14`,
  rx: `1`,
  key: `1bb6yr`
}]]);
var _Component38 = V(`LayoutList`, [[`rect`, {
  width: `7`,
  height: `7`,
  x: `3`,
  y: `3`,
  rx: `1`,
  key: `1g98yp`
}], [`rect`, {
  width: `7`,
  height: `7`,
  x: `3`,
  y: `14`,
  rx: `1`,
  key: `1bb6yr`
}], [`path`, {
  d: `M14 4h7`,
  key: `3xa0d5`
}], [`path`, {
  d: `M14 9h7`,
  key: `1icrd9`
}], [`path`, {
  d: `M14 15h7`,
  key: `1mj8o2`
}], [`path`, {
  d: `M14 20h7`,
  key: `11slyb`
}]]);
var Tn = V(`Library`, [[`path`, {
  d: `m16 6 4 14`,
  key: `ji33uf`
}], [`path`, {
  d: `M12 6v14`,
  key: `1n7gus`
}], [`path`, {
  d: `M8 8v12`,
  key: `1gg7y9`
}], [`path`, {
  d: `M4 4v16`,
  key: `6qkkli`
}]]);
var En = V(`Lightbulb`, [[`path`, {
  d: `M15 14c.2-1 .7-1.7 1.5-2.5 1-.9 1.5-2.2 1.5-3.5A6 6 0 0 0 6 8c0 1 .2 2.2 1.5 3.5.7.7 1.3 1.5 1.5 2.5`,
  key: `1gvzjb`
}], [`path`, {
  d: `M9 18h6`,
  key: `x1upvd`
}], [`path`, {
  d: `M10 22h4`,
  key: `ceow96`
}]]);
var Dn = V(`LoaderCircle`, [[`path`, {
  d: `M21 12a9 9 0 1 1-6.219-8.56`,
  key: `13zald`
}]]);
var On = V(`LockOpen`, [[`rect`, {
  width: `18`,
  height: `11`,
  x: `3`,
  y: `11`,
  rx: `2`,
  ry: `2`,
  key: `1w4ew1`
}], [`path`, {
  d: `M7 11V7a5 5 0 0 1 9.9-1`,
  key: `1mm8w8`
}]]);
var _Component57 = V(`Lock`, [[`rect`, {
  width: `18`,
  height: `11`,
  x: `3`,
  y: `11`,
  rx: `2`,
  ry: `2`,
  key: `1w4ew1`
}], [`path`, {
  d: `M7 11V7a5 5 0 0 1 10 0v4`,
  key: `fwvmzm`
}]]);
var An = V(`LogOut`, [[`path`, {
  d: `M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4`,
  key: `1uf3rs`
}], [`polyline`, {
  points: `16 17 21 12 16 7`,
  key: `1gabdz`
}], [`line`, {
  x1: `21`,
  x2: `9`,
  y1: `12`,
  y2: `12`,
  key: `1uyos4`
}]]);
var _Component62 = V(`Magnet`, [[`path`, {
  d: `m6 15-4-4 6.75-6.77a7.79 7.79 0 0 1 11 11L13 22l-4-4 6.39-6.36a2.14 2.14 0 0 0-3-3L6 15`,
  key: `1i3lhw`
}], [`path`, {
  d: `m5 8 4 4`,
  key: `j6kj7e`
}], [`path`, {
  d: `m12 15 4 4`,
  key: `lnac28`
}]]);
var Mn = V(`Maximize2`, [[`polyline`, {
  points: `15 3 21 3 21 9`,
  key: `mznyad`
}], [`polyline`, {
  points: `9 21 3 21 3 15`,
  key: `1avn1i`
}], [`line`, {
  x1: `21`,
  x2: `14`,
  y1: `3`,
  y2: `10`,
  key: `ota7mn`
}], [`line`, {
  x1: `3`,
  x2: `10`,
  y1: `21`,
  y2: `14`,
  key: `1atl0r`
}]]);
var Nn = V(`Menu`, [[`line`, {
  x1: `4`,
  x2: `20`,
  y1: `12`,
  y2: `12`,
  key: `1e0a9i`
}], [`line`, {
  x1: `4`,
  x2: `20`,
  y1: `6`,
  y2: `6`,
  key: `1owob3`
}], [`line`, {
  x1: `4`,
  x2: `20`,
  y1: `18`,
  y2: `18`,
  key: `yk5zj1`
}]]);
var Pn = V(`Monitor`, [[`rect`, {
  width: `20`,
  height: `14`,
  x: `2`,
  y: `3`,
  rx: `2`,
  key: `48i651`
}], [`line`, {
  x1: `8`,
  x2: `16`,
  y1: `21`,
  y2: `21`,
  key: `1svkeh`
}], [`line`, {
  x1: `12`,
  x2: `12`,
  y1: `17`,
  y2: `21`,
  key: `vw1qmm`
}]]);
var Fn = V(`Moon`, [[`path`, {
  d: `M12 3a6 6 0 0 0 9 9 9 9 0 1 1-9-9Z`,
  key: `a7tn18`
}]]);
var In = V(`MousePointer`, [[`path`, {
  d: `M12.586 12.586 19 19`,
  key: `ea5xo7`
}], [`path`, {
  d: `M3.688 3.037a.497.497 0 0 0-.651.651l6.5 15.999a.501.501 0 0 0 .947-.062l1.569-6.083a2 2 0 0 1 1.448-1.479l6.124-1.579a.5.5 0 0 0 .063-.947z`,
  key: `277e5u`
}]]);
var Ln = V(`Move`, [[`path`, {
  d: `M12 2v20`,
  key: `t6zp3m`
}], [`path`, {
  d: `m15 19-3 3-3-3`,
  key: `11eu04`
}], [`path`, {
  d: `m19 9 3 3-3 3`,
  key: `1mg7y2`
}], [`path`, {
  d: `M2 12h20`,
  key: `9i4pu4`
}], [`path`, {
  d: `m5 9-3 3 3 3`,
  key: `j64kie`
}], [`path`, {
  d: `m9 5 3-3 3 3`,
  key: `l8vdw6`
}]]);
var Rn = V(`PanelLeftClose`, [[`rect`, {
  width: `18`,
  height: `18`,
  x: `3`,
  y: `3`,
  rx: `2`,
  key: `afitv7`
}], [`path`, {
  d: `M9 3v18`,
  key: `fh3hqa`
}], [`path`, {
  d: `m16 15-3-3 3-3`,
  key: `14y99z`
}]]);
var _Component85 = V(`PanelLeft`, [[`rect`, {
  width: `18`,
  height: `18`,
  x: `3`,
  y: `3`,
  rx: `2`,
  key: `afitv7`
}], [`path`, {
  d: `M9 3v18`,
  key: `fh3hqa`
}]]);
var Bn = V(`PanelRightClose`, [[`rect`, {
  width: `18`,
  height: `18`,
  x: `3`,
  y: `3`,
  rx: `2`,
  key: `afitv7`
}], [`path`, {
  d: `M15 3v18`,
  key: `14nvp0`
}], [`path`, {
  d: `m8 9 3 3-3 3`,
  key: `12hl5m`
}]]);
var Vn = V(`PanelRight`, [[`rect`, {
  width: `18`,
  height: `18`,
  x: `3`,
  y: `3`,
  rx: `2`,
  key: `afitv7`
}], [`path`, {
  d: `M15 3v18`,
  key: `14nvp0`
}]]);
var Hn = V(`Paperclip`, [[`path`, {
  d: `M13.234 20.252 21 12.3`,
  key: `1cbrk9`
}], [`path`, {
  d: `m16 6-8.414 8.586a2 2 0 0 0 0 2.828 2 2 0 0 0 2.828 0l8.414-8.586a4 4 0 0 0 0-5.656 4 4 0 0 0-5.656 0l-8.415 8.585a6 6 0 1 0 8.486 8.486`,
  key: `1pkts6`
}]]);
var Un = V(`PenTool`, [[`path`, {
  d: `M15.707 21.293a1 1 0 0 1-1.414 0l-1.586-1.586a1 1 0 0 1 0-1.414l5.586-5.586a1 1 0 0 1 1.414 0l1.586 1.586a1 1 0 0 1 0 1.414z`,
  key: `nt11vn`
}], [`path`, {
  d: `m18 13-1.375-6.874a1 1 0 0 0-.746-.776L3.235 2.028a1 1 0 0 0-1.207 1.207L5.35 15.879a1 1 0 0 0 .776.746L13 18`,
  key: `15qc1e`
}], [`path`, {
  d: `m2.3 2.3 7.286 7.286`,
  key: `1wuzzi`
}], [`circle`, {
  cx: `11`,
  cy: `11`,
  r: `2`,
  key: `xmgehs`
}]]);
var Wn = V(`Pencil`, [[`path`, {
  d: `M21.174 6.812a1 1 0 0 0-3.986-3.987L3.842 16.174a2 2 0 0 0-.5.83l-1.321 4.352a.5.5 0 0 0 .623.622l4.353-1.32a2 2 0 0 0 .83-.497z`,
  key: `1a8usu`
}], [`path`, {
  d: `m15 5 4 4`,
  key: `1mk7zo`
}]]);
var Gn = V(`Percent`, [[`line`, {
  x1: `19`,
  x2: `5`,
  y1: `5`,
  y2: `19`,
  key: `1x9vlm`
}], [`circle`, {
  cx: `6.5`,
  cy: `6.5`,
  r: `2.5`,
  key: `4mh3h7`
}], [`circle`, {
  cx: `17.5`,
  cy: `17.5`,
  r: `2.5`,
  key: `1mdrzq`
}]]);
var Kn = V(`Plug`, [[`path`, {
  d: `M12 22v-5`,
  key: `1ega77`
}], [`path`, {
  d: `M9 8V2`,
  key: `14iosj`
}], [`path`, {
  d: `M15 8V2`,
  key: `18g5xt`
}], [`path`, {
  d: `M18 8v5a4 4 0 0 1-4 4h-4a4 4 0 0 1-4-4V8Z`,
  key: `osxo6l`
}]]);
var _Component10 = V(`Plus`, [[`path`, {
  d: `M5 12h14`,
  key: `1ays0h`
}], [`path`, {
  d: `M12 5v14`,
  key: `s699le`
}]]);
var Jn = V(`Printer`, [[`path`, {
  d: `M6 18H4a2 2 0 0 1-2-2v-5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2h-2`,
  key: `143wyd`
}], [`path`, {
  d: `M6 9V3a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v6`,
  key: `1itne7`
}], [`rect`, {
  x: `6`,
  y: `14`,
  width: `12`,
  height: `8`,
  rx: `1`,
  key: `1ue0tg`
}]]);
var Yn = V(`Redo2`, [[`path`, {
  d: `m15 14 5-5-5-5`,
  key: `12vg1m`
}], [`path`, {
  d: `M20 9H9.5A5.5 5.5 0 0 0 4 14.5A5.5 5.5 0 0 0 9.5 20H13`,
  key: `6uklza`
}]]);
var Xn = V(`RefreshCw`, [[`path`, {
  d: `M3 12a9 9 0 0 1 9-9 9.75 9.75 0 0 1 6.74 2.74L21 8`,
  key: `v9h5vc`
}], [`path`, {
  d: `M21 3v5h-5`,
  key: `1q7to0`
}], [`path`, {
  d: `M21 12a9 9 0 0 1-9 9 9.75 9.75 0 0 1-6.74-2.74L3 16`,
  key: `3uifl3`
}], [`path`, {
  d: `M8 16H3v5`,
  key: `1cv678`
}]]);
var Zn = V(`Refrigerator`, [[`path`, {
  d: `M5 6a4 4 0 0 1 4-4h6a4 4 0 0 1 4 4v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6Z`,
  key: `fpq118`
}], [`path`, {
  d: `M5 10h14`,
  key: `elsbfy`
}], [`path`, {
  d: `M15 7v6`,
  key: `1nx30x`
}]]);
var Qn = V(`RotateCcw`, [[`path`, {
  d: `M3 12a9 9 0 1 0 9-9 9.75 9.75 0 0 0-6.74 2.74L3 8`,
  key: `1357e3`
}], [`path`, {
  d: `M3 3v5h5`,
  key: `1xhq8a`
}]]);
var $n = V(`RotateCw`, [[`path`, {
  d: `M21 12a9 9 0 1 1-9-9c2.52 0 4.93 1 6.74 2.74L21 8`,
  key: `1p45f6`
}], [`path`, {
  d: `M21 3v5h-5`,
  key: `1q7to0`
}]]);
var _Component81 = V(`Rows2`, [[`rect`, {
  width: `18`,
  height: `18`,
  x: `3`,
  y: `3`,
  rx: `2`,
  key: `afitv7`
}], [`path`, {
  d: `M3 12h18`,
  key: `1i2n21`
}]]);
var _Component36 = V(`Ruler`, [[`path`, {
  d: `M21.3 15.3a2.4 2.4 0 0 1 0 3.4l-2.6 2.6a2.4 2.4 0 0 1-3.4 0L2.7 8.7a2.41 2.41 0 0 1 0-3.4l2.6-2.6a2.41 2.41 0 0 1 3.4 0Z`,
  key: `icamh8`
}], [`path`, {
  d: `m14.5 12.5 2-2`,
  key: `inckbg`
}], [`path`, {
  d: `m11.5 9.5 2-2`,
  key: `fmmyf7`
}], [`path`, {
  d: `m8.5 6.5 2-2`,
  key: `vc6u1g`
}], [`path`, {
  d: `m17.5 15.5 2-2`,
  key: `wo5hmg`
}]]);
var _Component84 = V(`Save`, [[`path`, {
  d: `M15.2 3a2 2 0 0 1 1.4.6l3.8 3.8a2 2 0 0 1 .6 1.4V19a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2z`,
  key: `1c8476`
}], [`path`, {
  d: `M17 21v-7a1 1 0 0 0-1-1H8a1 1 0 0 0-1 1v7`,
  key: `1ydtos`
}], [`path`, {
  d: `M7 3v4a1 1 0 0 0 1 1h7`,
  key: `t51u73`
}]]);
var _Component58 = V(`Scaling`, [[`path`, {
  d: `M12 3H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7`,
  key: `1m0v6g`
}], [`path`, {
  d: `M14 15H9v-5`,
  key: `pi4jk9`
}], [`path`, {
  d: `M16 3h5v5`,
  key: `1806ms`
}], [`path`, {
  d: `M21 3 9 15`,
  key: `15kdhq`
}]]);
var _Component72 = V(`Scissors`, [[`circle`, {
  cx: `6`,
  cy: `6`,
  r: `3`,
  key: `1lh9wr`
}], [`path`, {
  d: `M8.12 8.12 12 12`,
  key: `1alkpv`
}], [`path`, {
  d: `M20 4 8.12 15.88`,
  key: `xgtan2`
}], [`circle`, {
  cx: `6`,
  cy: `18`,
  r: `3`,
  key: `fqmcym`
}], [`path`, {
  d: `M14.8 14.8 20 20`,
  key: `ptml3r`
}]]);
var _Component22 = V(`Search`, [[`circle`, {
  cx: `11`,
  cy: `11`,
  r: `8`,
  key: `4ej97u`
}], [`path`, {
  d: `m21 21-4.3-4.3`,
  key: `1qie3q`
}]]);
var _Component7 = V(`Settings`, [[`path`, {
  d: `M12.22 2h-.44a2 2 0 0 0-2 2v.18a2 2 0 0 1-1 1.73l-.43.25a2 2 0 0 1-2 0l-.15-.08a2 2 0 0 0-2.73.73l-.22.38a2 2 0 0 0 .73 2.73l.15.1a2 2 0 0 1 1 1.72v.51a2 2 0 0 1-1 1.74l-.15.09a2 2 0 0 0-.73 2.73l.22.38a2 2 0 0 0 2.73.73l.15-.08a2 2 0 0 1 2 0l.43.25a2 2 0 0 1 1 1.73V20a2 2 0 0 0 2 2h.44a2 2 0 0 0 2-2v-.18a2 2 0 0 1 1-1.73l.43-.25a2 2 0 0 1 2 0l.15.08a2 2 0 0 0 2.73-.73l.22-.39a2 2 0 0 0-.73-2.73l-.15-.08a2 2 0 0 1-1-1.74v-.5a2 2 0 0 1 1-1.74l.15-.09a2 2 0 0 0 .73-2.73l-.22-.38a2 2 0 0 0-2.73-.73l-.15.08a2 2 0 0 1-2 0l-.43-.25a2 2 0 0 1-1-1.73V4a2 2 0 0 0-2-2z`,
  key: `1qme2f`
}], [`circle`, {
  cx: `12`,
  cy: `12`,
  r: `3`,
  key: `1v7zrd`
}]]);
var _Component20 = V(`ShieldAlert`, [[`path`, {
  d: `M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z`,
  key: `oel41y`
}], [`path`, {
  d: `M12 8v4`,
  key: `1got3b`
}], [`path`, {
  d: `M12 16h.01`,
  key: `1drbdi`
}]]);
var _Component95 = V(`ShieldCheck`, [[`path`, {
  d: `M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z`,
  key: `oel41y`
}], [`path`, {
  d: `m9 12 2 2 4-4`,
  key: `dzmm74`
}]]);
var _Component73 = V(`SlidersHorizontal`, [[`line`, {
  x1: `21`,
  x2: `14`,
  y1: `4`,
  y2: `4`,
  key: `obuewd`
}], [`line`, {
  x1: `10`,
  x2: `3`,
  y1: `4`,
  y2: `4`,
  key: `1q6298`
}], [`line`, {
  x1: `21`,
  x2: `12`,
  y1: `12`,
  y2: `12`,
  key: `1iu8h1`
}], [`line`, {
  x1: `8`,
  x2: `3`,
  y1: `12`,
  y2: `12`,
  key: `ntss68`
}], [`line`, {
  x1: `21`,
  x2: `16`,
  y1: `20`,
  y2: `20`,
  key: `14d8ph`
}], [`line`, {
  x1: `12`,
  x2: `3`,
  y1: `20`,
  y2: `20`,
  key: `m0wm8r`
}], [`line`, {
  x1: `14`,
  x2: `14`,
  y1: `2`,
  y2: `6`,
  key: `14e1ph`
}], [`line`, {
  x1: `8`,
  x2: `8`,
  y1: `10`,
  y2: `14`,
  key: `1i6ji0`
}], [`line`, {
  x1: `16`,
  x2: `16`,
  y1: `18`,
  y2: `22`,
  key: `1lctlv`
}]]);
var _Component17 = V(`Sparkles`, [[`path`, {
  d: `M9.937 15.5A2 2 0 0 0 8.5 14.063l-6.135-1.582a.5.5 0 0 1 0-.962L8.5 9.936A2 2 0 0 0 9.937 8.5l1.582-6.135a.5.5 0 0 1 .963 0L14.063 8.5A2 2 0 0 0 15.5 9.937l6.135 1.581a.5.5 0 0 1 0 .964L15.5 14.063a2 2 0 0 0-1.437 1.437l-1.582 6.135a.5.5 0 0 1-.963 0z`,
  key: `4pj2yx`
}], [`path`, {
  d: `M20 3v4`,
  key: `1olli1`
}], [`path`, {
  d: `M22 5h-4`,
  key: `1gvqau`
}], [`path`, {
  d: `M4 17v2`,
  key: `vumght`
}], [`path`, {
  d: `M5 18H3`,
  key: `zchphs`
}]]);
var _Component65 = V(`Square`, [[`rect`, {
  width: `18`,
  height: `18`,
  x: `3`,
  y: `3`,
  rx: `2`,
  key: `afitv7`
}]]);
var _Component16 = V(`Sun`, [[`circle`, {
  cx: `12`,
  cy: `12`,
  r: `4`,
  key: `4exip2`
}], [`path`, {
  d: `M12 2v2`,
  key: `tus03m`
}], [`path`, {
  d: `M12 20v2`,
  key: `1lh1kg`
}], [`path`, {
  d: `m4.93 4.93 1.41 1.41`,
  key: `149t6j`
}], [`path`, {
  d: `m17.66 17.66 1.41 1.41`,
  key: `ptbguv`
}], [`path`, {
  d: `M2 12h2`,
  key: `1t8f8n`
}], [`path`, {
  d: `M20 12h2`,
  key: `1q8mjw`
}], [`path`, {
  d: `m6.34 17.66-1.41 1.41`,
  key: `1m8zz5`
}], [`path`, {
  d: `m19.07 4.93-1.41 1.41`,
  key: `1shlcs`
}]]);
var _Component55 = V(`Timer`, [[`line`, {
  x1: `10`,
  x2: `14`,
  y1: `2`,
  y2: `2`,
  key: `14vaq8`
}], [`line`, {
  x1: `12`,
  x2: `15`,
  y1: `14`,
  y2: `11`,
  key: `17fdiu`
}], [`circle`, {
  cx: `12`,
  cy: `14`,
  r: `8`,
  key: `1e1u0o`
}]]);
var _Component26 = V(`Trash2`, [[`path`, {
  d: `M3 6h18`,
  key: `d0wm0j`
}], [`path`, {
  d: `M19 6v14c0 1-1 2-2 2H7c-1 0-2-1-2-2V6`,
  key: `4alrt4`
}], [`path`, {
  d: `M8 6V4c0-1 1-2 2-2h4c1 0 2 1 2 2v2`,
  key: `v07s0e`
}], [`line`, {
  x1: `10`,
  x2: `10`,
  y1: `11`,
  y2: `17`,
  key: `1uufr5`
}], [`line`, {
  x1: `14`,
  x2: `14`,
  y1: `11`,
  y2: `17`,
  key: `xtxkd`
}]]);
var _Component50 = V(`TriangleAlert`, [[`path`, {
  d: `m21.73 18-8-14a2 2 0 0 0-3.48 0l-8 14A2 2 0 0 0 4 21h16a2 2 0 0 0 1.73-3`,
  key: `wmoenq`
}], [`path`, {
  d: `M12 9v4`,
  key: `juzpu7`
}], [`path`, {
  d: `M12 17h.01`,
  key: `p32p05`
}]]);
var _Component69 = V(`Triangle`, [[`path`, {
  d: `M13.73 4a2 2 0 0 0-3.46 0l-8 14A2 2 0 0 0 4 21h16a2 2 0 0 0 1.73-3Z`,
  key: `14u9p9`
}]]);
var _r = V(`Truck`, [[`path`, {
  d: `M14 18V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v11a1 1 0 0 0 1 1h2`,
  key: `wrbu53`
}], [`path`, {
  d: `M15 18H9`,
  key: `1lyqi6`
}], [`path`, {
  d: `M19 18h2a1 1 0 0 0 1-1v-3.65a1 1 0 0 0-.22-.624l-3.48-4.35A1 1 0 0 0 17.52 8H14`,
  key: `lysw3i`
}], [`circle`, {
  cx: `17`,
  cy: `18`,
  r: `2`,
  key: `332jqn`
}], [`circle`, {
  cx: `7`,
  cy: `18`,
  r: `2`,
  key: `19iecd`
}]]);
var _Component68 = V(`Tv`, [[`rect`, {
  width: `20`,
  height: `15`,
  x: `2`,
  y: `7`,
  rx: `2`,
  ry: `2`,
  key: `10ag99`
}], [`polyline`, {
  points: `17 2 12 7 7 2`,
  key: `11pgbg`
}]]);
var _Component80 = V(`Undo2`, [[`path`, {
  d: `M9 14 4 9l5-5`,
  key: `102s5s`
}], [`path`, {
  d: `M4 9h10.5a5.5 5.5 0 0 1 5.5 5.5a5.5 5.5 0 0 1-5.5 5.5H11`,
  key: `f3b9sd`
}]]);
var _Component42 = V(`Upload`, [[`path`, {
  d: `M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4`,
  key: `ih7n3h`
}], [`polyline`, {
  points: `17 8 12 3 7 8`,
  key: `t8dd8p`
}], [`line`, {
  x1: `12`,
  x2: `12`,
  y1: `3`,
  y2: `15`,
  key: `widbto`
}]]);
var _Component93 = V(`UserCog`, [[`circle`, {
  cx: `18`,
  cy: `15`,
  r: `3`,
  key: `gjjjvw`
}], [`circle`, {
  cx: `9`,
  cy: `7`,
  r: `4`,
  key: `nufk8`
}], [`path`, {
  d: `M10 15H6a4 4 0 0 0-4 4v2`,
  key: `1nfge6`
}], [`path`, {
  d: `m21.7 16.4-.9-.3`,
  key: `12j9ji`
}], [`path`, {
  d: `m15.2 13.9-.9-.3`,
  key: `1fdjdi`
}], [`path`, {
  d: `m16.6 18.7.3-.9`,
  key: `heedtr`
}], [`path`, {
  d: `m19.1 12.2.3-.9`,
  key: `1af3ki`
}], [`path`, {
  d: `m19.6 18.7-.4-1`,
  key: `1x9vze`
}], [`path`, {
  d: `m16.8 12.3-.4-1`,
  key: `vqeiwj`
}], [`path`, {
  d: `m14.3 16.6 1-.4`,
  key: `1qlj63`
}], [`path`, {
  d: `m20.7 13.8 1-.4`,
  key: `1v5t8k`
}]]);
var Sr = V(`User`, [[`path`, {
  d: `M19 21v-2a4 4 0 0 0-4-4H9a4 4 0 0 0-4 4v2`,
  key: `975kel`
}], [`circle`, {
  cx: `12`,
  cy: `7`,
  r: `4`,
  key: `17ys0d`
}]]);
var Cr = V(`Users`, [[`path`, {
  d: `M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2`,
  key: `1yyitq`
}], [`circle`, {
  cx: `9`,
  cy: `7`,
  r: `4`,
  key: `nufk8`
}], [`path`, {
  d: `M22 21v-2a4 4 0 0 0-3-3.87`,
  key: `kshegd`
}], [`path`, {
  d: `M16 3.13a4 4 0 0 1 0 7.75`,
  key: `1da9ce`
}]]);
var _Component6 = V(`Wallet`, [[`path`, {
  d: `M19 7V4a1 1 0 0 0-1-1H5a2 2 0 0 0 0 4h15a1 1 0 0 1 1 1v4h-3a2 2 0 0 0 0 4h3a1 1 0 0 0 1-1v-2a1 1 0 0 0-1-1`,
  key: `18etb6`
}], [`path`, {
  d: `M3 5v14a2 2 0 0 0 2 2h15a1 1 0 0 0 1-1v-4`,
  key: `xoc0q4`
}]]);
var Tr = V(`Waves`, [[`path`, {
  d: `M2 6c.6.5 1.2 1 2.5 1C7 7 7 5 9.5 5c2.6 0 2.4 2 5 2 2.5 0 2.5-2 5-2 1.3 0 1.9.5 2.5 1`,
  key: `knzxuh`
}], [`path`, {
  d: `M2 12c.6.5 1.2 1 2.5 1 2.5 0 2.5-2 5-2 2.6 0 2.4 2 5 2 2.5 0 2.5-2 5-2 1.3 0 1.9.5 2.5 1`,
  key: `2jd2cc`
}], [`path`, {
  d: `M2 18c.6.5 1.2 1 2.5 1 2.5 0 2.5-2 5-2 2.6 0 2.4 2 5 2 2.5 0 2.5-2 5-2 1.3 0 1.9.5 2.5 1`,
  key: `rd2r6e`
}]]);
var Er = V(`Wrench`, [[`path`, {
  d: `M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.77-3.77a6 6 0 0 1-7.94 7.94l-6.91 6.91a2.12 2.12 0 0 1-3-3l6.91-6.91a6 6 0 0 1 7.94-7.94l-3.76 3.76z`,
  key: `cbrjhi`
}]]);
var Dr = V(`X`, [[`path`, {
  d: `M18 6 6 18`,
  key: `1bl5f8`
}], [`path`, {
  d: `m6 6 12 12`,
  key: `d8bk6v`
}]]);
async function Or() {
  let {
    data: e,
    error: t
  } = await B.from(`tenants`).select(`*`).limit(1).maybeSingle();
  if (t) {
    throw t;
  }
  return e;
}
async function kr(e) {
  let t = await Or();
  if (!t) {
    throw Error(`Marcenaria não encontrada`);
  }
  let {
    data: n,
    error: r
  } = await B.from(`tenants`).update(e).eq(`id`, t.id).select(`*`).single();
  if (r) {
    throw r;
  }
  return n;
}
async function Ar(e, t) {
  let n = `${t}/logo.${e.name.split(`.`).pop()?.toLowerCase() ?? `png`}`;
  let {
    error: r
  } = await B.storage.from(`logos`).upload(n, e, {
    upsert: true,
    cacheControl: `3600`
  });
  if (r) {
    throw r;
  }
  let {
    data: i
  } = B.storage.from(`logos`).getPublicUrl(n);
  return `${i.publicUrl}?v=${Date.now()}`;
}
async function jr(e) {
  let t = await Or();
  if (!t) {
    throw Error(`Marcenaria não encontrada`);
  }
  let {
    error: n
  } = await B.from(`tenants`).update({
    logo_url: e
  }).eq(`id`, t.id);
  if (n) {
    throw n;
  }
}
async function Mr() {
  let [{
    data: e,
    error: t
  }, {
    data: n,
    error: r
  }] = await Promise.all([B.from(`profiles`).select(`*`).order(`full_name`, {
    ascending: true
  }), B.from(`user_roles`).select(`*`)]);
  if (t) {
    throw t;
  }
  if (r) {
    throw r;
  }
  let i = new Map();
  for (let e of n ?? []) {
    let t = i.get(e.user_id) ?? [];
    t.push(e.role);
    i.set(e.user_id, t);
  }
  return (e ?? []).map(e => ({
    ...e,
    roles: i.get(e.id) ?? []
  }));
}
async function Nr(e, t) {
  let {
    data: n,
    error: r
  } = await B.from(`profiles`).update(t).eq(`id`, e).select(`*`).single();
  if (r) {
    throw r;
  }
  return n;
}
async function Pr(e) {
  let {
    data: t,
    error: n
  } = await B.functions.invoke(`criar-membro`, {
    body: e
  });
  if (n) {
    throw n;
  }
  if (t?.error) {
    throw Error(t.error);
  }
}
async function Fr(e, t) {
  let {
    data: n,
    error: r
  } = await B.from(`user_roles`).select(`id, role`).eq(`user_id`, e);
  if (r) {
    throw r;
  }
  let i = (n ?? []).filter(e => e.role !== t).map(e => e.id);
  if (i.length > 0) {
    let {
      error: e
    } = await B.from(`user_roles`).delete().in(`id`, i);
    if (e) {
      throw e;
    }
  }
  if (!(n ?? []).some(e => e.role === t)) {
    let {
      data: n,
      error: r
    } = await B.from(`profiles`).select(`tenant_id`).eq(`id`, e).single();
    if (r) {
      throw r;
    }
    let {
      error: i
    } = await B.from(`user_roles`).insert({
      user_id: e,
      tenant_id: n.tenant_id,
      role: t
    });
    if (i) {
      throw i;
    }
  }
}
var H = {
  tenant: [`tenant`],
  equipe: [`equipe`],
  dashboard: [`dashboard`],
  clientes: e => [`clientes`, e ?? ``],
  projetos: e => [`projetos`, e ?? {}],
  projeto: e => [`projeto`, e],
  medicao: e => [`medicao`, e],
  checklist: e => [`checklist`, e],
  anexos: e => [`anexos`, e],
  pecas: e => [`pecas`, e],
  pecasProjeto: e => [`pecas-projeto`, e],
  materiais: e => [`materiais`, e ?? {}],
  movimentacoes: e => [`movimentacoes`, e ?? ``],
  retalhos: e => [`retalhos`, e ?? `todos`],
  orcamentos: e => [`orcamentos`, e ?? ``],
  orcamento: e => [`orcamento`, e],
  ordens: e => [`ordens`, e ?? {}],
  ordem: e => [`ordem`, e],
  termos: e => [`termos`, e],
  contratos: e => [`contratos`, e ?? {}],
  contrato: e => [`contrato`, e],
  contratosProjeto: e => [`contratos-projeto`, e],
  lancamentos: e => [`lancamentos`, e ?? {}],
  categoriasFinanceiras: [`categorias-financeiras`],
  fornecedores: [`fornecedores`],
  catalogoModulos: [`catalogo-modulos`],
  designs: e => [`designs`, e ?? {}],
  design: e => [`design`, e]
};
function Ir() {
  return T({
    queryKey: H.tenant,
    queryFn: Or
  });
}
function Lr() {
  return T({
    queryKey: H.equipe,
    queryFn: Mr
  });
}
function Rr() {
  let e = C();
  return O({
    mutationFn: e => kr(e),
    onSuccess: () => {
      e.invalidateQueries({
        queryKey: H.tenant
      });
      N.success(`Dados da marcenaria atualizados.`);
    },
    onError: e => N.error(e.message)
  });
}
function zr() {
  let e = C();
  return O({
    mutationFn: async ({
      file: e,
      tenantId: t
    }) => {
      let n = await Ar(e, t);
      await jr(n);
      return n;
    },
    onSuccess: () => {
      e.invalidateQueries({
        queryKey: H.tenant
      });
      N.success(`Logotipo atualizado.`);
    },
    onError: e => N.error(e.message)
  });
}
function Br() {
  let e = C();
  return O({
    mutationFn: e => Pr(e),
    onSuccess: () => {
      e.invalidateQueries({
        queryKey: H.equipe
      });
      N.success(`Membro cadastrado.`);
    },
    onError: e => N.error(e.message)
  });
}
function Vr() {
  let e = C();
  return O({
    mutationFn: ({
      userId: e,
      role: t
    }) => Fr(e, t),
    onSuccess: () => {
      e.invalidateQueries({
        queryKey: H.equipe
      });
      N.success(`Perfil de acesso atualizado.`);
    },
    onError: e => N.error(e.message)
  });
}
function Hr(e) {
  let t = C();
  return O({
    mutationFn: t => {
      if (!e) {
        throw Error(`Sessão inválida`);
      }
      return Nr(e, t);
    },
    onSuccess: () => {
      t.invalidateQueries({
        queryKey: H.equipe
      });
      N.success(`Perfil atualizado.`);
    },
    onError: e => N.error(e.message)
  });
}
var Ur = `Planejados Pro`;
var Wr = {
  admin: `Administrador`,
  marceneiro: `Marceneiro`,
  orcamentista: `Orçamentista`,
  member: `Membro`
};
var Gr = [`admin`, `marceneiro`, `orcamentista`];
var Kr = [`admin`, `marceneiro`, `orcamentista`, `member`];
var qr = {
  medicao: `Medição`,
  projeto_corte: `Projeto/Corte`,
  montagem: `Montagem`,
  entrega: `Entrega`,
  concluido: `Concluído`,
  cancelado: `Cancelado`
};
var Jr = [`medicao`, `projeto_corte`, `montagem`, `entrega`, `concluido`];
var Yr = {
  medicao: `bg-stone-400 dark:bg-stone-500`,
  projeto_corte: `bg-amber-500 dark:bg-amber-400`,
  montagem: `bg-indigo-600 dark:bg-indigo-400`,
  entrega: `bg-sky-600 dark:bg-sky-400`,
  concluido: `bg-emerald-600 dark:bg-emerald-500`,
  cancelado: `bg-red-600 dark:bg-red-500`
};
var Xr = {
  aguardando_corte: `Aguardando corte`,
  furacao_borda: `Furação/Borda`,
  pre_montagem: `Pré-montagem`,
  aguardando_montagem: `Aguardando montagem`,
  em_montagem: `Em montagem`,
  concluido: `Concluído`,
  cancelado: `Cancelado`
};
var Zr = [`aguardando_corte`, `furacao_borda`, `pre_montagem`, `aguardando_montagem`, `em_montagem`, `concluido`];
var Qr = {
  aguardando_corte: `bg-stone-400 dark:bg-stone-500`,
  furacao_borda: `bg-amber-500 dark:bg-amber-400`,
  pre_montagem: `bg-amber-600 dark:bg-amber-500`,
  aguardando_montagem: `bg-sky-600 dark:bg-sky-400`,
  em_montagem: `bg-indigo-600 dark:bg-indigo-400`,
  concluido: `bg-emerald-600 dark:bg-emerald-500`,
  cancelado: `bg-red-600 dark:bg-red-500`
};
var $r = {
  rascunho: `Rascunho`,
  enviado: `Enviado`,
  aprovado: `Aprovado`,
  recusado: `Recusado`
};
var ei = {
  rascunho: `bg-stone-400 dark:bg-stone-500`,
  enviado: `bg-sky-600 dark:bg-sky-400`,
  aprovado: `bg-emerald-600 dark:bg-emerald-500`,
  recusado: `bg-red-600 dark:bg-red-500`
};
var ti = {
  chapa: `Chapas`,
  ferragem: `Ferragens`,
  consumivel: `Consumíveis`
};
var ni = {
  foto: `Foto`,
  pdf: `PDF`,
  croqui: `Croqui`,
  outro: `Outro`
};
var ri = {
  entrada: `Entrada`,
  saida: `Saída`
};
var ii = {
  mdf: `MDF`,
  mdp: `MDP`,
  compensado: `Compensado`,
  outro: `Outro`
};
var ai = {
  comprimento: `Comprimento`,
  largura: `Largura`,
  sem_veio: `Sem veio`
};
var oi = {
  lisa: `Lisa`,
  pvc: `PVC`,
  melamina: `Melamina`,
  abs: `ABS`,
  nenhuma: `Nenhuma`
};
var si = {
  comprimento_cm: 275,
  largura_cm: 185,
  espessura_mm: 18
};
var ci = `1. O prazo de entrega inicia após a aprovação formal do orçamento e medição final.
2. Alterações de projeto após aprovação podem gerar custos adicionais e novo prazo.
3. O cliente deve garantir acesso livre ao local na data agendada para montagem.
4. O saldo remanescente é devido na entrega e montagem dos móveis.`;
var li = {
  aguardando_corte: `Peças liberadas para a serra`,
  furacao_borda: `Furação e aplicação de fita de borda`,
  pre_montagem: `Conferência e pré-montagem em oficina`,
  aguardando_montagem: `Aguardando agenda do montador`,
  em_montagem: `Montagem em execução no cliente`,
  concluido: `Serviço finalizado e conferido`,
  cancelado: `Ordem cancelada`
};
var ui = {
  rascunho: `Rascunho`,
  enviado: `Enviado`,
  assinado: `Assinado`,
  encerrado: `Encerrado`,
  cancelado: `Cancelado`
};
var di = {
  rascunho: `bg-stone-400 dark:bg-stone-500`,
  enviado: `bg-sky-600 dark:bg-sky-400`,
  assinado: `bg-emerald-600 dark:bg-emerald-500`,
  encerrado: `bg-indigo-600 dark:bg-indigo-400`,
  cancelado: `bg-red-600 dark:bg-red-500`
};
var fi = [`rascunho`, `enviado`, `assinado`, `encerrado`];
var pi = {
  receita: `Receita`,
  despesa: `Despesa`
};
var mi = {
  previsto: `Previsto`,
  pago: `Pago`,
  cancelado: `Cancelado`
};
var hi = {
  previsto: `bg-stone-400 dark:bg-stone-500`,
  pago: `bg-emerald-600 dark:bg-emerald-500`,
  cancelado: `bg-red-600 dark:bg-red-500`
};
var gi = {
  dinheiro: `Dinheiro`,
  pix: `Pix`,
  transferencia: `Transferência`,
  boleto: `Boleto`,
  cartao_credito: `Cartão de crédito`,
  cartao_debito: `Cartão de débito`,
  cheque: `Cheque`,
  outro: `Outro`
};
var _i = [{
  dias: 30,
  label: `Mensal`
}, {
  dias: 15,
  label: `Quinzenal`
}, {
  dias: 7,
  label: `Semanal`
}];
var vi = {
  vertical: `Verticais`,
  horizontal: `Aéreos`,
  gaveteiro: `Gaveteiros`,
  eletrodomestico: `Eletrodomésticos`,
  mesa: `Mesas`,
  guarda_roupa: `Guarda-roupas`,
  complemento: `Complementos`
};
var yi = [`vertical`, `horizontal`, `gaveteiro`, `eletrodomestico`, `mesa`, `guarda_roupa`, `complemento`];
var bi = [{
  nome: `Branco`,
  hex: `#f5f2ec`
}, {
  nome: `Amarelo`,
  hex: `#f2b705`
}, {
  nome: `Verde`,
  hex: `#7fa650`
}, {
  nome: `Azul`,
  hex: `#4b7fa8`
}, {
  nome: `Madeira clara`,
  hex: `#d9b382`
}, {
  nome: `Madeira escura`,
  hex: `#8a5a37`
}, {
  nome: `Grafite`,
  hex: `#31363a`
}];
function xi(e) {
  var t;
  var n;
  var r = ``;
  if (typeof e == `string` || typeof e == `number`) {
    r += e;
  } else if (typeof e == `object`) {
    if (Array.isArray(e)) {
      var i = e.length;
      for (t = 0; t < i; t++) {
        if (e[t] && (n = xi(e[t]))) {
          if (r) {
            r += ` `;
          }
          r += n;
        }
      }
    } else {
      for (n in e) {
        if (e[n]) {
          if (r) {
            r += ` `;
          }
          r += n;
        }
      }
    }
  }
  return r;
}
function Si() {
  var e;
  var t;
  for (var n = 0, r = ``, i = arguments.length; n < i; n++) {
    if ((e = arguments[n]) && (t = xi(e))) {
      if (r) {
        r += ` `;
      }
      r += t;
    }
  }
  return r;
}
var Ci = (e, t) => {
  let n = Array(e.length + t.length);
  for (let t = 0; t < e.length; t++) {
    n[t] = e[t];
  }
  for (let r = 0; r < t.length; r++) {
    n[e.length + r] = t[r];
  }
  return n;
};
var wi = (e, t) => ({
  classGroupId: e,
  validator: t
});
var Ti = (e = new Map(), t = null, n) => ({
  nextPart: e,
  validators: t,
  classGroupId: n
});
var Ei = `-`;
var Di = [];
var Oi = `arbitrary..`;
var ki = e => {
  let t = Mi(e);
  let {
    conflictingClassGroups: n,
    conflictingClassGroupModifiers: r
  } = e;
  return {
    getClassGroupId: e => {
      if (e.startsWith(`[`) && e.endsWith(`]`)) {
        return ji(e);
      }
      let n = e.split(Ei);
      return Ai(n, +(n[0] === `` && n.length > 1), t);
    },
    getConflictingClassGroupIds: (e, t) => {
      if (t) {
        let t = r[e];
        let i = n[e];
        if (t) {
          if (i) {
            return Ci(i, t);
          } else {
            return t;
          }
        } else {
          return i || Di;
        }
      }
      return n[e] || Di;
    }
  };
};
var Ai = (e, t, n) => {
  if (e.length - t === 0) {
    return n.classGroupId;
  }
  let r = e[t];
  let i = n.nextPart.get(r);
  if (i) {
    let n = Ai(e, t + 1, i);
    if (n) {
      return n;
    }
  }
  let a = n.validators;
  if (a === null) {
    return;
  }
  let o = t === 0 ? e.join(Ei) : e.slice(t).join(Ei);
  let s = a.length;
  for (let e = 0; e < s; e++) {
    let t = a[e];
    if (t.validator(o)) {
      return t.classGroupId;
    }
  }
};
var ji = e => e.slice(1, -1).indexOf(`:`) === -1 ? undefined : (() => {
  let t = e.slice(1, -1);
  let n = t.indexOf(`:`);
  let r = t.slice(0, n);
  if (r) {
    return Oi + r;
  } else {
    return undefined;
  }
})();
var Mi = e => {
  let {
    theme: t,
    classGroups: n
  } = e;
  return Ni(n, t);
};
var Ni = (e, t) => {
  let n = Ti();
  for (let r in e) {
    let i = e[r];
    Pi(i, n, r, t);
  }
  return n;
};
var Pi = (e, t, n, r) => {
  let i = e.length;
  for (let a = 0; a < i; a++) {
    let i = e[a];
    Fi(i, t, n, r);
  }
};
var Fi = (e, t, n, r) => {
  if (typeof e == `string`) {
    Ii(e, t, n);
    return;
  }
  if (typeof e == `function`) {
    Li(e, t, n, r);
    return;
  }
  Ri(e, t, n, r);
};
var Ii = (e, t, n) => {
  let r = e === `` ? t : zi(t, e);
  r.classGroupId = n;
};
var Li = (e, t, n, r) => {
  if (Bi(e)) {
    Pi(e(r), t, n, r);
    return;
  }
  if (t.validators === null) {
    t.validators = [];
  }
  t.validators.push(wi(n, e));
};
var Ri = (e, t, n, r) => {
  let i = Object.entries(e);
  let a = i.length;
  for (let e = 0; e < a; e++) {
    let [a, o] = i[e];
    Pi(o, zi(t, a), n, r);
  }
};
var zi = (e, t) => {
  let n = e;
  let r = t.split(Ei);
  let i = r.length;
  for (let e = 0; e < i; e++) {
    let t = r[e];
    let i = n.nextPart.get(t);
    if (!i) {
      i = Ti();
      n.nextPart.set(t, i);
    }
    n = i;
  }
  return n;
};
var Bi = e => `isThemeGetter` in e && e.isThemeGetter === true;
var Vi = e => {
  if (e < 1) {
    return {
      get: () => undefined,
      set: () => {}
    };
  }
  let t = 0;
  let n = Object.create(null);
  let r = Object.create(null);
  let i = (i, a) => {
    n[i] = a;
    t++;
    if (t > e) {
      t = 0;
      r = n;
      n = Object.create(null);
    }
  };
  return {
    get(e) {
      let t = n[e];
      if (t !== undefined) {
        return t;
      }
      if ((t = r[e]) !== undefined) {
        i(e, t);
        return t;
      }
    },
    set(e, t) {
      if (e in n) {
        n[e] = t;
      } else {
        i(e, t);
      }
    }
  };
};
var Hi = `!`;
var Ui = `:`;
var Wi = [];
var Gi = (e, t, n, r, i) => ({
  modifiers: e,
  hasImportantModifier: t,
  baseClassName: n,
  maybePostfixModifierPosition: r,
  isExternal: i
});
var Ki = e => {
  let {
    prefix: t,
    experimentalParseClassName: n
  } = e;
  let r = e => {
    let t = [];
    let n = 0;
    let r = 0;
    let i = 0;
    let a;
    let o = e.length;
    for (let s = 0; s < o; s++) {
      let o = e[s];
      if (n === 0 && r === 0) {
        if (o === Ui) {
          t.push(e.slice(i, s));
          i = s + 1;
          continue;
        }
        if (o === `/`) {
          a = s;
          continue;
        }
      }
      if (o === `[`) {
        n++;
      } else if (o === `]`) {
        n--;
      } else if (o === `(`) {
        r++;
      } else if (o === `)`) {
        r--;
      }
    }
    let s = t.length === 0 ? e : e.slice(i);
    let c = s;
    let l = false;
    if (s.endsWith(Hi)) {
      c = s.slice(0, -1);
      l = true;
    } else if (s.startsWith(Hi)) {
      c = s.slice(1);
      l = true;
    }
    let u = a && a > i ? a - i : undefined;
    return Gi(t, l, c, u);
  };
  if (t) {
    let e = t + Ui;
    let n = r;
    r = t => t.startsWith(e) ? n(t.slice(e.length)) : Gi(Wi, false, t, undefined, true);
  }
  if (n) {
    let e = r;
    r = t => n({
      className: t,
      parseClassName: e
    });
  }
  return r;
};
var qi = e => {
  let t = new Map();
  e.orderSensitiveModifiers.forEach((e, n) => {
    t.set(e, 1000000 + n);
  });
  return e => {
    let n = [];
    let r = [];
    for (let i = 0; i < e.length; i++) {
      let a = e[i];
      let o = a[0] === `[`;
      let s = t.has(a);
      if (o || s) {
        if (r.length > 0) {
          r.sort();
          n.push(...r);
          r = [];
        }
        n.push(a);
      } else {
        r.push(a);
      }
    }
    if (r.length > 0) {
      r.sort();
      n.push(...r);
    }
    return n;
  };
};
var Ji = e => ({
  cache: Vi(e.cacheSize),
  parseClassName: Ki(e),
  sortModifiers: qi(e),
  postfixLookupClassGroupIds: Yi(e),
  ...ki(e)
});
var Yi = e => {
  let t = Object.create(null);
  let n = e.postfixLookupClassGroups;
  if (n) {
    for (let e = 0; e < n.length; e++) {
      t[n[e]] = true;
    }
  }
  return t;
};
var Xi = /\s+/;
var Zi = (e, t) => {
  let {
    parseClassName: n,
    getClassGroupId: r,
    getConflictingClassGroupIds: i,
    sortModifiers: a,
    postfixLookupClassGroupIds: o
  } = t;
  let s = [];
  let c = e.trim().split(Xi);
  let l = ``;
  for (let e = c.length - 1; e >= 0; --e) {
    let t = c[e];
    let {
      isExternal: u,
      modifiers: d,
      hasImportantModifier: f,
      baseClassName: p,
      maybePostfixModifierPosition: m
    } = n(t);
    if (u) {
      l = t + (l.length > 0 ? ` ${l}` : l);
      continue;
    }
    let h = !!m;
    let g;
    if (h) {
      g = r(p.substring(0, m));
      let e = g && o[g] ? r(p) : undefined;
      if (e && e !== g) {
        g = e;
        h = false;
      }
    } else {
      g = r(p);
    }
    if (!g) {
      if (!h) {
        l = t + (l.length > 0 ? ` ${l}` : l);
        continue;
      }
      g = r(p);
      if (!g) {
        l = t + (l.length > 0 ? ` ${l}` : l);
        continue;
      }
      h = false;
    }
    let _ = d.length === 0 ? `` : d.length === 1 ? d[0] : a(d).join(`:`);
    let v = f ? _ + Hi : _;
    let y = v + g;
    if (s.indexOf(y) > -1) {
      continue;
    }
    s.push(y);
    let b = i(g, h);
    for (let e = 0; e < b.length; ++e) {
      let t = b[e];
      s.push(v + t);
    }
    l = t + (l.length > 0 ? ` ${l}` : l);
  }
  return l;
};
var Qi = (...e) => {
  let t = 0;
  let n;
  let r;
  let i = ``;
  while (t < e.length) {
    if ((n = e[t++]) && (r = $i(n))) {
      if (i) {
        i += ` `;
      }
      i += r;
    }
  }
  return i;
};
var $i = e => {
  if (typeof e == `string`) {
    return e;
  }
  let t;
  let n = ``;
  for (let r = 0; r < e.length; r++) {
    if (e[r] && (t = $i(e[r]))) {
      if (n) {
        n += ` `;
      }
      n += t;
    }
  }
  return n;
};
var ea = (e, ...t) => {
  let n;
  let r;
  let i;
  let a;
  let o = o => {
    n = Ji(t.reduce((e, t) => t(e), e()));
    r = n.cache.get;
    i = n.cache.set;
    a = s;
    return s(o);
  };
  let s = e => {
    let t = r(e);
    if (t) {
      return t;
    }
    let a = Zi(e, n);
    i(e, a);
    return a;
  };
  a = o;
  return (...e) => a(Qi(...e));
};
var ta = [];
var na = e => {
  let t = t => t[e] || ta;
  t.isThemeGetter = true;
  t.themeKey = e;
  return t;
};
var ra = /^\[(?:(\w[\w-]*):)?(.+)\]$/i;
var ia = /^\((?:(\w[\w-]*):)?(.+)\)$/i;
var aa = /^\d+(?:\.\d+)?\/\d+(?:\.\d+)?$/;
var oa = /^(\d+(\.\d+)?)?(xs|sm|md|lg|xl)$/;
var sa = /\d+(%|px|r?em|[sdl]?v([hwib]|min|max)|pt|pc|in|cm|mm|cap|ch|ex|r?lh|cq(w|h|i|b|min|max))|\b(calc|min|max|clamp)\(.+\)|^0$/;
var ca = /^(rgba?|hsla?|hwb|(ok)?(lab|lch)|color-mix|color|light-dark)\(.+\)$/;
var la = /^(inset_)?-?((\d+)?\.?(\d+)[a-z]+|0)_-?((\d+)?\.?(\d+)[a-z]+|0)/;
var ua = /^(url|image|image-set|cross-fade|element|(repeating-)?(linear|radial|conic)-gradient)\(.+\)$/;
var da = e => aa.test(e);
var fa = e => !!e && !Number.isNaN(Number(e));
var pa = e => !!e && Number.isInteger(Number(e));
var ma = e => e.endsWith(`%`) && fa(e.slice(0, -1));
var ha = e => oa.test(e);
var ga = () => true;
var _a = e => sa.test(e) && !ca.test(e);
var va = () => false;
var ya = e => la.test(e);
var ba = e => ua.test(e);
var xa = e => !wa(e) && !Ma(e);
var Sa = e => e.startsWith(`@container`) && (e[10] === `/` && e[11] !== undefined || e[11] === `s` && e[16] !== undefined && e.startsWith(`-size/`, 10) || e[11] === `n` && e[18] !== undefined && e.startsWith(`-normal/`, 10));
var Ca = e => Ba(e, Wa, va);
var wa = e => ra.test(e);
var Ta = e => Ba(e, Ga, _a);
var Ea = e => Ba(e, Ka, fa);
var Da = e => Ba(e, Ja, ga);
var Oa = e => Ba(e, qa, va);
var ka = e => Ba(e, Ha, va);
var Aa = e => Ba(e, Ua, ba);
var ja = e => Ba(e, Ya, ya);
var Ma = e => ia.test(e);
var Na = e => Va(e, Ga);
var Pa = e => Va(e, qa);
var Fa = e => Va(e, Ha);
var Ia = e => Va(e, Wa);
var La = e => Va(e, Ua);
var Ra = e => Va(e, Ya, true);
var za = e => Va(e, Ja, true);
var Ba = (e, t, n) => {
  let r = ra.exec(e);
  if (r) {
    if (r[1]) {
      return t(r[1]);
    } else {
      return n(r[2]);
    }
  } else {
    return false;
  }
};
var Va = (e, t, n = false) => {
  let r = ia.exec(e);
  if (r) {
    if (r[1]) {
      return t(r[1]);
    } else {
      return n;
    }
  } else {
    return false;
  }
};
var Ha = e => e === `position` || e === `percentage`;
var Ua = e => e === `image` || e === `url`;
var Wa = e => e === `length` || e === `size` || e === `bg-size`;
var Ga = e => e === `length`;
var Ka = e => e === `number`;
var qa = e => e === `family-name`;
var Ja = e => e === `number` || e === `weight`;
var Ya = e => e === `shadow`;
var Xa = ea(() => {
  let e = na(`color`);
  let t = na(`font`);
  let n = na(`text`);
  let r = na(`font-weight`);
  let i = na(`tracking`);
  let a = na(`leading`);
  let o = na(`breakpoint`);
  let s = na(`container`);
  let c = na(`spacing`);
  let l = na(`radius`);
  let u = na(`shadow`);
  let d = na(`inset-shadow`);
  let f = na(`text-shadow`);
  let p = na(`drop-shadow`);
  let m = na(`blur`);
  let h = na(`perspective`);
  let g = na(`aspect`);
  let _ = na(`ease`);
  let v = na(`animate`);
  let y = () => [`auto`, `avoid`, `all`, `avoid-page`, `page`, `left`, `right`, `column`];
  let b = () => [`center`, `top`, `bottom`, `left`, `right`, `top-left`, `left-top`, `top-right`, `right-top`, `bottom-right`, `right-bottom`, `bottom-left`, `left-bottom`];
  let x = () => [...b(), Ma, wa];
  let S = () => [`auto`, `hidden`, `clip`, `visible`, `scroll`];
  let C = () => [`auto`, `contain`, `none`];
  let w = () => [Ma, wa, c];
  let T = () => [da, `full`, `auto`, ...w()];
  let E = () => [pa, `none`, `subgrid`, Ma, wa];
  let D = () => [`auto`, {
    span: [`full`, pa, Ma, wa]
  }, pa, Ma, wa];
  let O = () => [pa, `auto`, Ma, wa];
  let k = () => [`auto`, `min`, `max`, `fr`, Ma, wa];
  let A = () => [`start`, `end`, `center`, `between`, `around`, `evenly`, `stretch`, `baseline`, `center-safe`, `end-safe`];
  let ee = () => [`start`, `end`, `center`, `stretch`, `center-safe`, `end-safe`];
  let te = () => [`auto`, ...w()];
  let j = () => [da, `auto`, `full`, `dvw`, `dvh`, `lvw`, `lvh`, `svw`, `svh`, `min`, `max`, `fit`, ...w()];
  let ne = () => [s, da, `screen`, `full`, `dvw`, `lvw`, `svw`, `min`, `max`, `fit`, ...w()];
  let re = () => [da, `screen`, `full`, `lh`, `dvh`, `lvh`, `svh`, `min`, `max`, `fit`, ...w()];
  let M = () => [e, Ma, wa];
  let ie = () => [...b(), Fa, ka, {
    position: [Ma, wa]
  }];
  let ae = () => [`no-repeat`, {
    repeat: [``, `x`, `y`, `space`, `round`]
  }];
  let oe = () => [`auto`, `cover`, `contain`, Ia, Ca, {
    size: [Ma, wa]
  }];
  let se = () => [ma, Na, Ta];
  let ce = () => [``, `none`, `full`, l, Ma, wa];
  let le = () => [``, fa, Na, Ta];
  let ue = () => [`solid`, `dashed`, `dotted`, `double`];
  let de = () => [`normal`, `multiply`, `screen`, `overlay`, `darken`, `lighten`, `color-dodge`, `color-burn`, `hard-light`, `soft-light`, `difference`, `exclusion`, `hue`, `saturation`, `color`, `luminosity`];
  let fe = () => [fa, ma, Fa, ka];
  let pe = () => [``, `none`, m, Ma, wa];
  let me = () => [`none`, fa, Ma, wa];
  let N = () => [`none`, fa, Ma, wa];
  let he = () => [fa, Ma, wa];
  let ge = () => [da, `full`, ...w()];
  return {
    cacheSize: 500,
    theme: {
      animate: [`spin`, `ping`, `pulse`, `bounce`],
      aspect: [`video`],
      blur: [ha],
      breakpoint: [ha],
      color: [ga],
      container: [ha],
      "drop-shadow": [ha],
      ease: [`in`, `out`, `in-out`],
      font: [xa],
      "font-weight": [`thin`, `extralight`, `light`, `normal`, `medium`, `semibold`, `bold`, `extrabold`, `black`],
      "inset-shadow": [ha],
      leading: [`none`, `tight`, `snug`, `normal`, `relaxed`, `loose`],
      perspective: [`dramatic`, `near`, `normal`, `midrange`, `distant`, `none`],
      radius: [ha],
      shadow: [ha],
      spacing: [`px`, fa],
      text: [ha],
      "text-shadow": [ha],
      tracking: [`tighter`, `tight`, `normal`, `wide`, `wider`, `widest`]
    },
    classGroups: {
      aspect: [{
        aspect: [`auto`, `square`, da, wa, Ma, g]
      }],
      container: [`container`],
      "container-type": [{
        "@container": [``, `normal`, `size`, Ma, wa]
      }],
      "container-named": [Sa],
      columns: [{
        columns: [fa, `auto`, wa, Ma, s]
      }],
      "break-after": [{
        "break-after": y()
      }],
      "break-before": [{
        "break-before": y()
      }],
      "break-inside": [{
        "break-inside": [`auto`, `avoid`, `avoid-page`, `avoid-column`]
      }],
      "box-decoration": [{
        "box-decoration": [`slice`, `clone`]
      }],
      box: [{
        box: [`border`, `content`]
      }],
      display: [`block`, `inline-block`, `inline`, `flex`, `inline-flex`, `table`, `inline-table`, `table-caption`, `table-cell`, `table-column`, `table-column-group`, `table-footer-group`, `table-header-group`, `table-row-group`, `table-row`, `flow-root`, `grid`, `inline-grid`, `contents`, `list-item`, `hidden`],
      sr: [`sr-only`, `not-sr-only`],
      float: [{
        float: [`right`, `left`, `none`, `start`, `end`]
      }],
      clear: [{
        clear: [`left`, `right`, `both`, `none`, `start`, `end`]
      }],
      isolation: [`isolate`, `isolation-auto`],
      "object-fit": [{
        object: [`contain`, `cover`, `fill`, `none`, `scale-down`]
      }],
      "object-position": [{
        object: x()
      }],
      overflow: [{
        overflow: S()
      }],
      "overflow-x": [{
        "overflow-x": S()
      }],
      "overflow-y": [{
        "overflow-y": S()
      }],
      overscroll: [{
        overscroll: C()
      }],
      "overscroll-x": [{
        "overscroll-x": C()
      }],
      "overscroll-y": [{
        "overscroll-y": C()
      }],
      position: [`static`, `fixed`, `absolute`, `relative`, `sticky`],
      inset: [{
        inset: T()
      }],
      "inset-x": [{
        "inset-x": T()
      }],
      "inset-y": [{
        "inset-y": T()
      }],
      start: [{
        "inset-s": T(),
        start: T()
      }],
      end: [{
        "inset-e": T(),
        end: T()
      }],
      "inset-bs": [{
        "inset-bs": T()
      }],
      "inset-be": [{
        "inset-be": T()
      }],
      top: [{
        top: T()
      }],
      right: [{
        right: T()
      }],
      bottom: [{
        bottom: T()
      }],
      left: [{
        left: T()
      }],
      visibility: [`visible`, `invisible`, `collapse`],
      z: [{
        z: [pa, `auto`, Ma, wa]
      }],
      basis: [{
        basis: [da, `full`, `auto`, s, ...w()]
      }],
      "flex-direction": [{
        flex: [`row`, `row-reverse`, `col`, `col-reverse`]
      }],
      "flex-wrap": [{
        flex: [`nowrap`, `wrap`, `wrap-reverse`]
      }],
      flex: [{
        flex: [fa, da, `auto`, `initial`, `none`, wa]
      }],
      grow: [{
        grow: [``, fa, Ma, wa]
      }],
      shrink: [{
        shrink: [``, fa, Ma, wa]
      }],
      order: [{
        order: [pa, `first`, `last`, `none`, Ma, wa]
      }],
      "grid-cols": [{
        "grid-cols": E()
      }],
      "col-start-end": [{
        col: D()
      }],
      "col-start": [{
        "col-start": O()
      }],
      "col-end": [{
        "col-end": O()
      }],
      "grid-rows": [{
        "grid-rows": E()
      }],
      "row-start-end": [{
        row: D()
      }],
      "row-start": [{
        "row-start": O()
      }],
      "row-end": [{
        "row-end": O()
      }],
      "grid-flow": [{
        "grid-flow": [`row`, `col`, `dense`, `row-dense`, `col-dense`]
      }],
      "auto-cols": [{
        "auto-cols": k()
      }],
      "auto-rows": [{
        "auto-rows": k()
      }],
      gap: [{
        gap: w()
      }],
      "gap-x": [{
        "gap-x": w()
      }],
      "gap-y": [{
        "gap-y": w()
      }],
      "justify-content": [{
        justify: [...A(), `normal`]
      }],
      "justify-items": [{
        "justify-items": [...ee(), `normal`]
      }],
      "justify-self": [{
        "justify-self": [`auto`, ...ee()]
      }],
      "align-content": [{
        content: [`normal`, ...A()]
      }],
      "align-items": [{
        items: [...ee(), {
          baseline: [``, `last`]
        }]
      }],
      "align-self": [{
        self: [`auto`, ...ee(), {
          baseline: [``, `last`]
        }]
      }],
      "place-content": [{
        "place-content": A()
      }],
      "place-items": [{
        "place-items": [...ee(), `baseline`]
      }],
      "place-self": [{
        "place-self": [`auto`, ...ee()]
      }],
      p: [{
        p: w()
      }],
      px: [{
        px: w()
      }],
      py: [{
        py: w()
      }],
      ps: [{
        ps: w()
      }],
      pe: [{
        pe: w()
      }],
      pbs: [{
        pbs: w()
      }],
      pbe: [{
        pbe: w()
      }],
      pt: [{
        pt: w()
      }],
      pr: [{
        pr: w()
      }],
      pb: [{
        pb: w()
      }],
      pl: [{
        pl: w()
      }],
      m: [{
        m: te()
      }],
      mx: [{
        mx: te()
      }],
      my: [{
        my: te()
      }],
      ms: [{
        ms: te()
      }],
      me: [{
        me: te()
      }],
      mbs: [{
        mbs: te()
      }],
      mbe: [{
        mbe: te()
      }],
      mt: [{
        mt: te()
      }],
      mr: [{
        mr: te()
      }],
      mb: [{
        mb: te()
      }],
      ml: [{
        ml: te()
      }],
      "space-x": [{
        "space-x": w()
      }],
      "space-x-reverse": [`space-x-reverse`],
      "space-y": [{
        "space-y": w()
      }],
      "space-y-reverse": [`space-y-reverse`],
      size: [{
        size: j()
      }],
      "inline-size": [{
        inline: [`auto`, ...ne()]
      }],
      "min-inline-size": [{
        "min-inline": [`auto`, ...ne()]
      }],
      "max-inline-size": [{
        "max-inline": [`none`, ...ne()]
      }],
      "block-size": [{
        block: [`auto`, ...re()]
      }],
      "min-block-size": [{
        "min-block": [`auto`, ...re()]
      }],
      "max-block-size": [{
        "max-block": [`none`, ...re()]
      }],
      w: [{
        w: [s, `screen`, ...j()]
      }],
      "min-w": [{
        "min-w": [s, `screen`, `none`, ...j()]
      }],
      "max-w": [{
        "max-w": [s, `screen`, `none`, `prose`, {
          screen: [o]
        }, ...j()]
      }],
      h: [{
        h: [`screen`, `lh`, ...j()]
      }],
      "min-h": [{
        "min-h": [`screen`, `lh`, `none`, ...j()]
      }],
      "max-h": [{
        "max-h": [`screen`, `lh`, `none`, ...j()]
      }],
      "font-size": [{
        text: [`base`, n, Na, Ta]
      }],
      "font-smoothing": [`antialiased`, `subpixel-antialiased`],
      "font-style": [`italic`, `not-italic`],
      "font-weight": [{
        font: [r, za, Da]
      }],
      "font-stretch": [{
        "font-stretch": [`ultra-condensed`, `extra-condensed`, `condensed`, `semi-condensed`, `normal`, `semi-expanded`, `expanded`, `extra-expanded`, `ultra-expanded`, ma, wa]
      }],
      "font-family": [{
        font: [Pa, Oa, t]
      }],
      "font-features": [{
        "font-features": [wa]
      }],
      "fvn-normal": [`normal-nums`],
      "fvn-ordinal": [`ordinal`],
      "fvn-slashed-zero": [`slashed-zero`],
      "fvn-figure": [`lining-nums`, `oldstyle-nums`],
      "fvn-spacing": [`proportional-nums`, `tabular-nums`],
      "fvn-fraction": [`diagonal-fractions`, `stacked-fractions`],
      tracking: [{
        tracking: [i, Ma, wa]
      }],
      "line-clamp": [{
        "line-clamp": [fa, `none`, Ma, Ea]
      }],
      leading: [{
        leading: [`none`, a, ...w()]
      }],
      "list-image": [{
        "list-image": [`none`, Ma, wa]
      }],
      "list-style-position": [{
        list: [`inside`, `outside`]
      }],
      "list-style-type": [{
        list: [`disc`, `decimal`, `none`, Ma, wa]
      }],
      "text-alignment": [{
        text: [`left`, `center`, `right`, `justify`, `start`, `end`]
      }],
      "placeholder-color": [{
        placeholder: M()
      }],
      "text-color": [{
        text: M()
      }],
      "text-decoration": [`underline`, `overline`, `line-through`, `no-underline`],
      "text-decoration-style": [{
        decoration: [...ue(), `wavy`]
      }],
      "text-decoration-thickness": [{
        decoration: [fa, `from-font`, `auto`, Ma, Ta]
      }],
      "text-decoration-color": [{
        decoration: M()
      }],
      "underline-offset": [{
        "underline-offset": [fa, `auto`, Ma, wa]
      }],
      "text-transform": [`uppercase`, `lowercase`, `capitalize`, `normal-case`],
      "text-overflow": [`truncate`, `text-ellipsis`, `text-clip`],
      "text-wrap": [{
        text: [`wrap`, `nowrap`, `balance`, `pretty`]
      }],
      indent: [{
        indent: w()
      }],
      "tab-size": [{
        tab: [pa, Ma, wa]
      }],
      "vertical-align": [{
        align: [`baseline`, `top`, `middle`, `bottom`, `text-top`, `text-bottom`, `sub`, `super`, Ma, wa]
      }],
      whitespace: [{
        whitespace: [`normal`, `nowrap`, `pre`, `pre-line`, `pre-wrap`, `break-spaces`]
      }],
      break: [{
        break: [`normal`, `words`, `all`, `keep`]
      }],
      wrap: [{
        wrap: [`break-word`, `anywhere`, `normal`]
      }],
      hyphens: [{
        hyphens: [`none`, `manual`, `auto`]
      }],
      content: [{
        content: [`none`, Ma, wa]
      }],
      "bg-attachment": [{
        bg: [`fixed`, `local`, `scroll`]
      }],
      "bg-clip": [{
        "bg-clip": [`border`, `padding`, `content`, `text`]
      }],
      "bg-origin": [{
        "bg-origin": [`border`, `padding`, `content`]
      }],
      "bg-position": [{
        bg: ie()
      }],
      "bg-repeat": [{
        bg: ae()
      }],
      "bg-size": [{
        bg: oe()
      }],
      "bg-image": [{
        bg: [`none`, {
          linear: [{
            to: [`t`, `tr`, `r`, `br`, `b`, `bl`, `l`, `tl`]
          }, pa, Ma, wa],
          radial: [``, Ma, wa],
          conic: [``, pa, Ma, wa]
        }, La, Aa]
      }],
      "bg-color": [{
        bg: M()
      }],
      "gradient-from-pos": [{
        from: se()
      }],
      "gradient-via-pos": [{
        via: se()
      }],
      "gradient-to-pos": [{
        to: se()
      }],
      "gradient-from": [{
        from: M()
      }],
      "gradient-via": [{
        via: M()
      }],
      "gradient-to": [{
        to: M()
      }],
      rounded: [{
        rounded: ce()
      }],
      "rounded-s": [{
        "rounded-s": ce()
      }],
      "rounded-e": [{
        "rounded-e": ce()
      }],
      "rounded-t": [{
        "rounded-t": ce()
      }],
      "rounded-r": [{
        "rounded-r": ce()
      }],
      "rounded-b": [{
        "rounded-b": ce()
      }],
      "rounded-l": [{
        "rounded-l": ce()
      }],
      "rounded-ss": [{
        "rounded-ss": ce()
      }],
      "rounded-se": [{
        "rounded-se": ce()
      }],
      "rounded-ee": [{
        "rounded-ee": ce()
      }],
      "rounded-es": [{
        "rounded-es": ce()
      }],
      "rounded-tl": [{
        "rounded-tl": ce()
      }],
      "rounded-tr": [{
        "rounded-tr": ce()
      }],
      "rounded-br": [{
        "rounded-br": ce()
      }],
      "rounded-bl": [{
        "rounded-bl": ce()
      }],
      "border-w": [{
        border: le()
      }],
      "border-w-x": [{
        "border-x": le()
      }],
      "border-w-y": [{
        "border-y": le()
      }],
      "border-w-s": [{
        "border-s": le()
      }],
      "border-w-e": [{
        "border-e": le()
      }],
      "border-w-bs": [{
        "border-bs": le()
      }],
      "border-w-be": [{
        "border-be": le()
      }],
      "border-w-t": [{
        "border-t": le()
      }],
      "border-w-r": [{
        "border-r": le()
      }],
      "border-w-b": [{
        "border-b": le()
      }],
      "border-w-l": [{
        "border-l": le()
      }],
      "divide-x": [{
        "divide-x": le()
      }],
      "divide-x-reverse": [`divide-x-reverse`],
      "divide-y": [{
        "divide-y": le()
      }],
      "divide-y-reverse": [`divide-y-reverse`],
      "border-style": [{
        border: [...ue(), `hidden`, `none`]
      }],
      "divide-style": [{
        divide: [...ue(), `hidden`, `none`]
      }],
      "border-color": [{
        border: M()
      }],
      "border-color-x": [{
        "border-x": M()
      }],
      "border-color-y": [{
        "border-y": M()
      }],
      "border-color-s": [{
        "border-s": M()
      }],
      "border-color-e": [{
        "border-e": M()
      }],
      "border-color-bs": [{
        "border-bs": M()
      }],
      "border-color-be": [{
        "border-be": M()
      }],
      "border-color-t": [{
        "border-t": M()
      }],
      "border-color-r": [{
        "border-r": M()
      }],
      "border-color-b": [{
        "border-b": M()
      }],
      "border-color-l": [{
        "border-l": M()
      }],
      "divide-color": [{
        divide: M()
      }],
      "outline-style": [{
        outline: [...ue(), `none`, `hidden`]
      }],
      "outline-offset": [{
        "outline-offset": [fa, Ma, wa]
      }],
      "outline-w": [{
        outline: [``, fa, Na, Ta]
      }],
      "outline-color": [{
        outline: M()
      }],
      shadow: [{
        shadow: [``, `inner`, `none`, u, Ra, ja]
      }],
      "shadow-color": [{
        shadow: M()
      }],
      "inset-shadow": [{
        "inset-shadow": [`none`, d, Ra, ja]
      }],
      "inset-shadow-color": [{
        "inset-shadow": M()
      }],
      "ring-w": [{
        ring: le()
      }],
      "ring-w-inset": [`ring-inset`],
      "ring-color": [{
        ring: M()
      }],
      "ring-offset-w": [{
        "ring-offset": [fa, Ta]
      }],
      "ring-offset-color": [{
        "ring-offset": M()
      }],
      "inset-ring-w": [{
        "inset-ring": le()
      }],
      "inset-ring-color": [{
        "inset-ring": M()
      }],
      "text-shadow": [{
        "text-shadow": [`none`, f, Ra, ja]
      }],
      "text-shadow-color": [{
        "text-shadow": M()
      }],
      opacity: [{
        opacity: [fa, Ma, wa]
      }],
      "mix-blend": [{
        "mix-blend": [...de(), `plus-darker`, `plus-lighter`]
      }],
      "bg-blend": [{
        "bg-blend": de()
      }],
      "mask-clip": [{
        "mask-clip": [`border`, `padding`, `content`, `fill`, `stroke`, `view`]
      }, `mask-no-clip`],
      "mask-composite": [{
        mask: [`add`, `subtract`, `intersect`, `exclude`]
      }],
      "mask-image-linear-pos": [{
        "mask-linear": [fa]
      }],
      "mask-image-linear-from-pos": [{
        "mask-linear-from": fe()
      }],
      "mask-image-linear-to-pos": [{
        "mask-linear-to": fe()
      }],
      "mask-image-linear-from-color": [{
        "mask-linear-from": M()
      }],
      "mask-image-linear-to-color": [{
        "mask-linear-to": M()
      }],
      "mask-image-t-from-pos": [{
        "mask-t-from": fe()
      }],
      "mask-image-t-to-pos": [{
        "mask-t-to": fe()
      }],
      "mask-image-t-from-color": [{
        "mask-t-from": M()
      }],
      "mask-image-t-to-color": [{
        "mask-t-to": M()
      }],
      "mask-image-r-from-pos": [{
        "mask-r-from": fe()
      }],
      "mask-image-r-to-pos": [{
        "mask-r-to": fe()
      }],
      "mask-image-r-from-color": [{
        "mask-r-from": M()
      }],
      "mask-image-r-to-color": [{
        "mask-r-to": M()
      }],
      "mask-image-b-from-pos": [{
        "mask-b-from": fe()
      }],
      "mask-image-b-to-pos": [{
        "mask-b-to": fe()
      }],
      "mask-image-b-from-color": [{
        "mask-b-from": M()
      }],
      "mask-image-b-to-color": [{
        "mask-b-to": M()
      }],
      "mask-image-l-from-pos": [{
        "mask-l-from": fe()
      }],
      "mask-image-l-to-pos": [{
        "mask-l-to": fe()
      }],
      "mask-image-l-from-color": [{
        "mask-l-from": M()
      }],
      "mask-image-l-to-color": [{
        "mask-l-to": M()
      }],
      "mask-image-x-from-pos": [{
        "mask-x-from": fe()
      }],
      "mask-image-x-to-pos": [{
        "mask-x-to": fe()
      }],
      "mask-image-x-from-color": [{
        "mask-x-from": M()
      }],
      "mask-image-x-to-color": [{
        "mask-x-to": M()
      }],
      "mask-image-y-from-pos": [{
        "mask-y-from": fe()
      }],
      "mask-image-y-to-pos": [{
        "mask-y-to": fe()
      }],
      "mask-image-y-from-color": [{
        "mask-y-from": M()
      }],
      "mask-image-y-to-color": [{
        "mask-y-to": M()
      }],
      "mask-image-radial": [{
        "mask-radial": [Ma, wa]
      }],
      "mask-image-radial-from-pos": [{
        "mask-radial-from": fe()
      }],
      "mask-image-radial-to-pos": [{
        "mask-radial-to": fe()
      }],
      "mask-image-radial-from-color": [{
        "mask-radial-from": M()
      }],
      "mask-image-radial-to-color": [{
        "mask-radial-to": M()
      }],
      "mask-image-radial-shape": [{
        "mask-radial": [`circle`, `ellipse`]
      }],
      "mask-image-radial-size": [{
        "mask-radial": [{
          closest: [`side`, `corner`],
          farthest: [`side`, `corner`]
        }]
      }],
      "mask-image-radial-pos": [{
        "mask-radial-at": b()
      }],
      "mask-image-conic-pos": [{
        "mask-conic": [fa]
      }],
      "mask-image-conic-from-pos": [{
        "mask-conic-from": fe()
      }],
      "mask-image-conic-to-pos": [{
        "mask-conic-to": fe()
      }],
      "mask-image-conic-from-color": [{
        "mask-conic-from": M()
      }],
      "mask-image-conic-to-color": [{
        "mask-conic-to": M()
      }],
      "mask-mode": [{
        mask: [`alpha`, `luminance`, `match`]
      }],
      "mask-origin": [{
        "mask-origin": [`border`, `padding`, `content`, `fill`, `stroke`, `view`]
      }],
      "mask-position": [{
        mask: ie()
      }],
      "mask-repeat": [{
        mask: ae()
      }],
      "mask-size": [{
        mask: oe()
      }],
      "mask-type": [{
        "mask-type": [`alpha`, `luminance`]
      }],
      "mask-image": [{
        mask: [`none`, Ma, wa]
      }],
      filter: [{
        filter: [``, `none`, Ma, wa]
      }],
      blur: [{
        blur: pe()
      }],
      brightness: [{
        brightness: [fa, Ma, wa]
      }],
      contrast: [{
        contrast: [fa, Ma, wa]
      }],
      "drop-shadow": [{
        "drop-shadow": [``, `none`, p, Ra, ja]
      }],
      "drop-shadow-color": [{
        "drop-shadow": M()
      }],
      grayscale: [{
        grayscale: [``, fa, Ma, wa]
      }],
      "hue-rotate": [{
        "hue-rotate": [fa, Ma, wa]
      }],
      invert: [{
        invert: [``, fa, Ma, wa]
      }],
      saturate: [{
        saturate: [fa, Ma, wa]
      }],
      sepia: [{
        sepia: [``, fa, Ma, wa]
      }],
      "backdrop-filter": [{
        "backdrop-filter": [``, `none`, Ma, wa]
      }],
      "backdrop-blur": [{
        "backdrop-blur": pe()
      }],
      "backdrop-brightness": [{
        "backdrop-brightness": [fa, Ma, wa]
      }],
      "backdrop-contrast": [{
        "backdrop-contrast": [fa, Ma, wa]
      }],
      "backdrop-grayscale": [{
        "backdrop-grayscale": [``, fa, Ma, wa]
      }],
      "backdrop-hue-rotate": [{
        "backdrop-hue-rotate": [fa, Ma, wa]
      }],
      "backdrop-invert": [{
        "backdrop-invert": [``, fa, Ma, wa]
      }],
      "backdrop-opacity": [{
        "backdrop-opacity": [fa, Ma, wa]
      }],
      "backdrop-saturate": [{
        "backdrop-saturate": [fa, Ma, wa]
      }],
      "backdrop-sepia": [{
        "backdrop-sepia": [``, fa, Ma, wa]
      }],
      "border-collapse": [{
        border: [`collapse`, `separate`]
      }],
      "border-spacing": [{
        "border-spacing": w()
      }],
      "border-spacing-x": [{
        "border-spacing-x": w()
      }],
      "border-spacing-y": [{
        "border-spacing-y": w()
      }],
      "table-layout": [{
        table: [`auto`, `fixed`]
      }],
      caption: [{
        caption: [`top`, `bottom`]
      }],
      transition: [{
        transition: [``, `all`, `colors`, `opacity`, `shadow`, `transform`, `none`, Ma, wa]
      }],
      "transition-behavior": [{
        transition: [`normal`, `discrete`]
      }],
      duration: [{
        duration: [fa, `initial`, Ma, wa]
      }],
      ease: [{
        ease: [`linear`, `initial`, _, Ma, wa]
      }],
      delay: [{
        delay: [fa, Ma, wa]
      }],
      animate: [{
        animate: [`none`, v, Ma, wa]
      }],
      backface: [{
        backface: [`hidden`, `visible`]
      }],
      perspective: [{
        perspective: [h, Ma, wa]
      }],
      "perspective-origin": [{
        "perspective-origin": x()
      }],
      rotate: [{
        rotate: me()
      }],
      "rotate-x": [{
        "rotate-x": me()
      }],
      "rotate-y": [{
        "rotate-y": me()
      }],
      "rotate-z": [{
        "rotate-z": me()
      }],
      scale: [{
        scale: N()
      }],
      "scale-x": [{
        "scale-x": N()
      }],
      "scale-y": [{
        "scale-y": N()
      }],
      "scale-z": [{
        "scale-z": N()
      }],
      "scale-3d": [`scale-3d`],
      skew: [{
        skew: he()
      }],
      "skew-x": [{
        "skew-x": he()
      }],
      "skew-y": [{
        "skew-y": he()
      }],
      transform: [{
        transform: [Ma, wa, ``, `none`, `gpu`, `cpu`]
      }],
      "transform-origin": [{
        origin: x()
      }],
      "transform-style": [{
        transform: [`3d`, `flat`]
      }],
      translate: [{
        translate: ge()
      }],
      "translate-x": [{
        "translate-x": ge()
      }],
      "translate-y": [{
        "translate-y": ge()
      }],
      "translate-z": [{
        "translate-z": ge()
      }],
      "translate-none": [`translate-none`],
      zoom: [{
        zoom: [pa, Ma, wa]
      }],
      accent: [{
        accent: M()
      }],
      appearance: [{
        appearance: [`none`, `auto`]
      }],
      "caret-color": [{
        caret: M()
      }],
      "color-scheme": [{
        scheme: [`normal`, `dark`, `light`, `light-dark`, `only-dark`, `only-light`]
      }],
      cursor: [{
        cursor: [`auto`, `default`, `pointer`, `wait`, `text`, `move`, `help`, `not-allowed`, `none`, `context-menu`, `progress`, `cell`, `crosshair`, `vertical-text`, `alias`, `copy`, `no-drop`, `grab`, `grabbing`, `all-scroll`, `col-resize`, `row-resize`, `n-resize`, `e-resize`, `s-resize`, `w-resize`, `ne-resize`, `nw-resize`, `se-resize`, `sw-resize`, `ew-resize`, `ns-resize`, `nesw-resize`, `nwse-resize`, `zoom-in`, `zoom-out`, Ma, wa]
      }],
      "field-sizing": [{
        "field-sizing": [`fixed`, `content`]
      }],
      "pointer-events": [{
        "pointer-events": [`auto`, `none`]
      }],
      resize: [{
        resize: [`none`, ``, `y`, `x`]
      }],
      "scroll-behavior": [{
        scroll: [`auto`, `smooth`]
      }],
      "scrollbar-thumb-color": [{
        "scrollbar-thumb": M()
      }],
      "scrollbar-track-color": [{
        "scrollbar-track": M()
      }],
      "scrollbar-gutter": [{
        "scrollbar-gutter": [`auto`, `stable`, `both`]
      }],
      "scrollbar-w": [{
        scrollbar: [`auto`, `thin`, `none`]
      }],
      "scroll-m": [{
        "scroll-m": w()
      }],
      "scroll-mx": [{
        "scroll-mx": w()
      }],
      "scroll-my": [{
        "scroll-my": w()
      }],
      "scroll-ms": [{
        "scroll-ms": w()
      }],
      "scroll-me": [{
        "scroll-me": w()
      }],
      "scroll-mbs": [{
        "scroll-mbs": w()
      }],
      "scroll-mbe": [{
        "scroll-mbe": w()
      }],
      "scroll-mt": [{
        "scroll-mt": w()
      }],
      "scroll-mr": [{
        "scroll-mr": w()
      }],
      "scroll-mb": [{
        "scroll-mb": w()
      }],
      "scroll-ml": [{
        "scroll-ml": w()
      }],
      "scroll-p": [{
        "scroll-p": w()
      }],
      "scroll-px": [{
        "scroll-px": w()
      }],
      "scroll-py": [{
        "scroll-py": w()
      }],
      "scroll-ps": [{
        "scroll-ps": w()
      }],
      "scroll-pe": [{
        "scroll-pe": w()
      }],
      "scroll-pbs": [{
        "scroll-pbs": w()
      }],
      "scroll-pbe": [{
        "scroll-pbe": w()
      }],
      "scroll-pt": [{
        "scroll-pt": w()
      }],
      "scroll-pr": [{
        "scroll-pr": w()
      }],
      "scroll-pb": [{
        "scroll-pb": w()
      }],
      "scroll-pl": [{
        "scroll-pl": w()
      }],
      "snap-align": [{
        snap: [`start`, `end`, `center`, `align-none`]
      }],
      "snap-stop": [{
        snap: [`normal`, `always`]
      }],
      "snap-type": [{
        snap: [`none`, `x`, `y`, `both`]
      }],
      "snap-strictness": [{
        snap: [`mandatory`, `proximity`]
      }],
      touch: [{
        touch: [`auto`, `none`, `manipulation`]
      }],
      "touch-x": [{
        "touch-pan": [`x`, `left`, `right`]
      }],
      "touch-y": [{
        "touch-pan": [`y`, `up`, `down`]
      }],
      "touch-pz": [`touch-pinch-zoom`],
      select: [{
        select: [`none`, `text`, `all`, `auto`]
      }],
      "will-change": [{
        "will-change": [`auto`, `scroll`, `contents`, `transform`, Ma, wa]
      }],
      fill: [{
        fill: [`none`, ...M()]
      }],
      "stroke-w": [{
        stroke: [fa, Na, Ta, Ea]
      }],
      stroke: [{
        stroke: [`none`, ...M()]
      }],
      "forced-color-adjust": [{
        "forced-color-adjust": [`auto`, `none`]
      }]
    },
    conflictingClassGroups: {
      "container-named": [`container-type`],
      overflow: [`overflow-x`, `overflow-y`],
      overscroll: [`overscroll-x`, `overscroll-y`],
      inset: [`inset-x`, `inset-y`, `inset-bs`, `inset-be`, `start`, `end`, `top`, `right`, `bottom`, `left`],
      "inset-x": [`start`, `end`, `right`, `left`],
      "inset-y": [`inset-bs`, `inset-be`, `top`, `bottom`],
      flex: [`basis`, `grow`, `shrink`],
      gap: [`gap-x`, `gap-y`],
      p: [`px`, `py`, `ps`, `pe`, `pbs`, `pbe`, `pt`, `pr`, `pb`, `pl`],
      px: [`ps`, `pe`, `pr`, `pl`],
      py: [`pbs`, `pbe`, `pt`, `pb`],
      m: [`mx`, `my`, `ms`, `me`, `mbs`, `mbe`, `mt`, `mr`, `mb`, `ml`],
      mx: [`ms`, `me`, `mr`, `ml`],
      my: [`mbs`, `mbe`, `mt`, `mb`],
      size: [`w`, `h`],
      "font-size": [`leading`],
      "fvn-normal": [`fvn-ordinal`, `fvn-slashed-zero`, `fvn-figure`, `fvn-spacing`, `fvn-fraction`],
      "fvn-ordinal": [`fvn-normal`],
      "fvn-slashed-zero": [`fvn-normal`],
      "fvn-figure": [`fvn-normal`],
      "fvn-spacing": [`fvn-normal`],
      "fvn-fraction": [`fvn-normal`],
      "line-clamp": [`display`, `overflow`],
      rounded: [`rounded-s`, `rounded-e`, `rounded-t`, `rounded-r`, `rounded-b`, `rounded-l`, `rounded-ss`, `rounded-se`, `rounded-ee`, `rounded-es`, `rounded-tl`, `rounded-tr`, `rounded-br`, `rounded-bl`],
      "rounded-s": [`rounded-ss`, `rounded-es`],
      "rounded-e": [`rounded-se`, `rounded-ee`],
      "rounded-t": [`rounded-tl`, `rounded-tr`],
      "rounded-r": [`rounded-tr`, `rounded-br`],
      "rounded-b": [`rounded-br`, `rounded-bl`],
      "rounded-l": [`rounded-tl`, `rounded-bl`],
      "border-spacing": [`border-spacing-x`, `border-spacing-y`],
      "border-w": [`border-w-x`, `border-w-y`, `border-w-s`, `border-w-e`, `border-w-bs`, `border-w-be`, `border-w-t`, `border-w-r`, `border-w-b`, `border-w-l`],
      "border-w-x": [`border-w-s`, `border-w-e`, `border-w-r`, `border-w-l`],
      "border-w-y": [`border-w-bs`, `border-w-be`, `border-w-t`, `border-w-b`],
      "border-color": [`border-color-x`, `border-color-y`, `border-color-s`, `border-color-e`, `border-color-bs`, `border-color-be`, `border-color-t`, `border-color-r`, `border-color-b`, `border-color-l`],
      "border-color-x": [`border-color-s`, `border-color-e`, `border-color-r`, `border-color-l`],
      "border-color-y": [`border-color-bs`, `border-color-be`, `border-color-t`, `border-color-b`],
      translate: [`translate-x`, `translate-y`, `translate-none`],
      "translate-none": [`translate`, `translate-x`, `translate-y`, `translate-z`],
      "scroll-m": [`scroll-mx`, `scroll-my`, `scroll-ms`, `scroll-me`, `scroll-mbs`, `scroll-mbe`, `scroll-mt`, `scroll-mr`, `scroll-mb`, `scroll-ml`],
      "scroll-mx": [`scroll-ms`, `scroll-me`, `scroll-mr`, `scroll-ml`],
      "scroll-my": [`scroll-mbs`, `scroll-mbe`, `scroll-mt`, `scroll-mb`],
      "scroll-p": [`scroll-px`, `scroll-py`, `scroll-ps`, `scroll-pe`, `scroll-pbs`, `scroll-pbe`, `scroll-pt`, `scroll-pr`, `scroll-pb`, `scroll-pl`],
      "scroll-px": [`scroll-ps`, `scroll-pe`, `scroll-pr`, `scroll-pl`],
      "scroll-py": [`scroll-pbs`, `scroll-pbe`, `scroll-pt`, `scroll-pb`],
      touch: [`touch-x`, `touch-y`, `touch-pz`],
      "touch-x": [`touch`],
      "touch-y": [`touch`],
      "touch-pz": [`touch`]
    },
    conflictingClassGroupModifiers: {
      "font-size": [`leading`]
    },
    postfixLookupClassGroups: [`container-type`],
    orderSensitiveModifiers: [`*`, `**`, `after`, `backdrop`, `before`, `details-content`, `file`, `first-letter`, `first-line`, `marker`, `placeholder`, `selection`]
  };
});
function U(...e) {
  return Xa(Si(e));
}
function W(e) {
  let t = typeof e == `string` ? Number(e) : e ?? 0;
  return new Intl.NumberFormat(`pt-BR`, {
    style: `currency`,
    currency: `BRL`
  }).format(Number.isFinite(t) ? t : 0);
}
function Za(e, t = 2) {
  let n = typeof e == `string` ? Number(e) : e ?? 0;
  return new Intl.NumberFormat(`pt-BR`, {
    minimumFractionDigits: t,
    maximumFractionDigits: t
  }).format(Number.isFinite(n) ? n : 0);
}
function Qa(e) {
  if (e == null || e === ``) {
    return `-`;
  }
  let t = typeof e == `string` ? Number(e) : e;
  if (Number.isFinite(t)) {
    return `${Za(t, t % 1 == 0 ? 0 : 2)} cm`;
  } else {
    return `-`;
  }
}
function $a(e) {
  return `${Za(e, 2)} m²`;
}
function eo(e) {
  return `${Za(e, 1)}%`;
}
function to(e) {
  if (!e) {
    return `-`;
  }
  let t = typeof e == `string` ? new Date(e) : e;
  if (Number.isNaN(t.getTime())) {
    return `-`;
  } else {
    return new Intl.DateTimeFormat(`pt-BR`, {
      day: `2-digit`,
      month: `2-digit`,
      year: `numeric`
    }).format(t);
  }
}
function no(e) {
  if (!e) {
    return `-`;
  }
  let t = typeof e == `string` ? new Date(e) : e;
  if (Number.isNaN(t.getTime())) {
    return `-`;
  } else {
    return new Intl.DateTimeFormat(`pt-BR`, {
      day: `2-digit`,
      month: `2-digit`,
      year: `numeric`,
      hour: `2-digit`,
      minute: `2-digit`
    }).format(t);
  }
}
function ro(e) {
  if (!e || e <= 0) {
    return `-`;
  }
  let t = [`B`, `KB`, `MB`, `GB`];
  let n = Math.min(Math.floor(Math.log(e) / Math.log(1024)), t.length - 1);
  return `${Za(e / 1024 ** n, n === 0 ? 0 : 1)} ${t[n]}`;
}
function io(e) {
  return e.replace(/\D/g, ``);
}
function ao(e) {
  if (!e) {
    return `-`;
  }
  let t = io(e);
  if (t.length === 11) {
    return t.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, `$1.$2.$3-$4`);
  } else if (t.length === 14) {
    return t.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, `$1.$2.$3/$4-$5`);
  } else {
    return e;
  }
}
function oo(e) {
  if (!e) {
    return `-`;
  }
  let t = io(e);
  if (t.length === 11) {
    return t.replace(/(\d{2})(\d{5})(\d{4})/, `($1) $2-$3`);
  } else if (t.length === 10) {
    return t.replace(/(\d{2})(\d{4})(\d{4})/, `($1) $2-$3`);
  } else {
    return e;
  }
}
function so(e) {
  if (!e) {
    return `-`;
  }
  let t = io(e);
  if (t.length === 8) {
    return t.replace(/(\d{5})(\d{3})/, `$1-$2`);
  } else {
    return e;
  }
}
function co(e) {
  return e && e.trim().split(/\s+/).slice(0, 2).map(e => e[0]?.toUpperCase() ?? ``).join(``) || `?`;
}
function lo(e) {
  return `${e.getFullYear()}-${String(e.getMonth() + 1).padStart(2, `0`)}-${String(e.getDate()).padStart(2, `0`)}`;
}
function uo() {
  return lo(new Date());
}
function fo(e) {
  return new Date(`${e}T12:00:00`).toISOString();
}
var po = Object.defineProperty;
var mo = (e, t) => po(e, `name`, {
  value: t,
  configurable: true
});
function ho(e, t) {
  if (typeof e == `function`) {
    return e(t);
  }
  if (e != null) {
    e.current = t;
  }
}
mo(ho, `setRef`);
function go(...e) {
  return t => {
    let n = false;
    let r = e.map(e => {
      let r = ho(e, t);
      if (!n && typeof r == `function`) {
        n = true;
      }
      return r;
    });
    if (n) {
      return () => {
        for (let t = 0; t < r.length; t++) {
          let n = r[t];
          if (typeof n == `function`) {
            n();
          } else {
            ho(e[t], null);
          }
        }
      };
    }
  };
}
mo(go, `composeRefs`);
function _o(...e) {
  return k.useCallback(go(...e), e);
}
mo(_o, `useComposedRefs`);
var vo = Object.defineProperty;
var yo = (e, t) => vo(e, `name`, {
  value: t,
  configurable: true
});
function bo(e) {
  let t = k.forwardRef((t, n) => {
    let {
      children: r,
      ...i
    } = t;
    let a = null;
    let o = false;
    let s = [];
    if (ko(r) && typeof No == `function`) {
      r = No(r._payload);
    }
    k.Children.forEach(r, e => {
      if (Do(e)) {
        o = true;
        let t = e;
        let n = `child` in t.props ? t.props.child : t.props.children;
        if (ko(n) && typeof No == `function`) {
          n = No(n._payload);
        }
        a = wo(t, n);
        s.push(a?.props?.children);
      } else {
        s.push(e);
      }
    });
    if (a) {
      a = k.cloneElement(a, undefined, s);
    } else if (!o && k.Children.count(r) === 1 && k.isValidElement(r)) {
      a = r;
    }
    let c = a ? Eo(a) : undefined;
    let l = _o(n, c);
    if (!a) {
      if (r || r === 0) {
        if (k.isValidElement(r)) {
          return k.cloneElement(r, i);
        }
        return k.createElement(`span`, i, r);
      }
      return r;
    }
    let u = To(i, a.props ?? {});
    if (a.type !== k.Fragment) {
      u.ref = n ? l : c;
    }
    return k.cloneElement(a, u);
  });
  t.displayName = `${e}.Slot`;
  return t;
}
yo(bo, `createSlot`);
var xo = bo(`Slot`);
var So = Symbol.for(`radix.slottable`);
function Co(e) {
  let t = yo(e => `child` in e ? e.children(e.child) : e.children, `Slottable`);
  t.displayName = `${e}.Slottable`;
  t.__radixId = So;
  return t;
}
yo(Co, `createSlottable`);
var wo = yo((e, t) => {
  if (`child` in e.props) {
    let t = e.props.child;
    if (k.isValidElement(t)) {
      return k.cloneElement(t, undefined, e.props.children(t.props.children));
    } else {
      return null;
    }
  }
  if (k.isValidElement(t)) {
    return t;
  } else {
    return null;
  }
}, `getSlottableElementFromSlottable`);
function To(e, t) {
  let n = {
    ...t
  };
  for (let r in t) {
    let i = e[r];
    let a = t[r];
    if (/^on[A-Z]/.test(r)) {
      if (i && a) {
        n[r] = (...e) => {
          let t = a(...e);
          i(...e);
          return t;
        };
      } else if (i) {
        n[r] = i;
      }
    } else if (r === `style`) {
      n[r] = {
        ...i,
        ...a
      };
    } else if (r === `className`) {
      n[r] = [i, a].filter(Boolean).join(` `);
    }
  }
  return {
    ...e,
    ...n
  };
}
yo(To, `mergeProps`);
function Eo(e) {
  let t = Object.getOwnPropertyDescriptor(e.props, `ref`)?.get;
  let n = t && `isReactWarning` in t && t.isReactWarning;
  if (n) {
    return e.ref;
  } else {
    t = Object.getOwnPropertyDescriptor(e, `ref`)?.get;
    n = t && `isReactWarning` in t && t.isReactWarning;
    if (n) {
      return e.props.ref;
    } else {
      return e.props.ref || e.ref;
    }
  }
}
yo(Eo, `getElementRef`);
function Do(e) {
  return k.isValidElement(e) && typeof e.type == `function` && `__radixId` in e.type && e.type.__radixId === So;
}
yo(Do, `isSlottable`);
var Oo = Symbol.for(`react.lazy`);
function ko(e) {
  return typeof e == `object` && !!e && `$$typeof` in e && e.$$typeof === Oo && `_payload` in e && Ao(e._payload);
}
yo(ko, `isLazyComponent`);
function Ao(e) {
  return typeof e == `object` && !!e && `then` in e;
}
yo(Ao, `isPromiseLike`);
var jo = yo(e => `${e} failed to slot onto its children. Expected a single React element child or \`Slottable\`.`, `createSlotError`);
var Mo = yo(e => `${e} failed to slot onto its \`Slottable\`. Expected \`Slottable\` to receive a single React element child.`, `createSlottableError`);
var No = k.use;
var Po = e => typeof e == `boolean` ? `${e}` : e === 0 ? `0` : e;
var Fo = Si;
var Io = ((e, t) => n => {
  if (t?.variants == null) {
    return Fo(e, n?.class, n?.className);
  }
  let {
    variants: r,
    defaultVariants: i
  } = t;
  let a = Object.keys(r).map(e => {
    let t = n?.[e];
    let a = i?.[e];
    if (t === null) {
      return null;
    }
    let o = Po(t) || Po(a);
    return r[e][o];
  });
  let o = n && Object.entries(n).reduce((e, t) => {
    let [n, r] = t;
    if (r !== undefined) {
      e[n] = r;
    }
    return e;
  }, {});
  return Fo(e, a, t?.compoundVariants?.reduce((e, t) => {
    let {
      class: n,
      className: r,
      ...a
    } = t;
    if (Object.entries(a).every(e => {
      let [t, n] = e;
      if (Array.isArray(n)) {
        return n.includes({
          ...i,
          ...o
        }[t]);
      } else {
        return {
          ...i,
          ...o
        }[t] === n;
      }
    })) {
      return [...e, n, r];
    } else {
      return e;
    }
  }, []), n?.class, n?.className);
})(`inline-flex select-none items-center justify-center gap-2 whitespace-nowrap rounded-md text-sm font-medium transition-colors duration-150 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring/35 focus-visible:ring-offset-1 focus-visible:ring-offset-background disabled:pointer-events-none disabled:opacity-50 active:translate-y-px [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0`, {
  variants: {
    variant: {
      default: `bg-primary text-primary-foreground hover:bg-primary/90`,
      destructive: `bg-destructive text-white hover:bg-destructive/90`,
      outline: `border border-border bg-card text-foreground hover:bg-accent hover:text-accent-foreground`,
      secondary: `bg-secondary text-secondary-foreground hover:bg-secondary/70`,
      ghost: `text-muted-foreground hover:bg-accent hover:text-foreground`,
      link: `text-foreground underline decoration-border underline-offset-4 hover:decoration-foreground`
    },
    size: {
      default: `h-9 px-3.5`,
      sm: `h-8 rounded-md px-3 text-[13px]`,
      lg: `h-10 rounded-md px-5`,
      icon: `h-9 w-9`
    }
  },
  defaultVariants: {
    variant: `default`,
    size: `default`
  }
});
var G = k.forwardRef(({
  className: e,
  variant: t,
  size: n,
  asChild: r = false,
  ...i
}, a) => {
  let Comp = r ? xo : 'button';
  return <Comp className={U(Io({
    variant: t,
    size: n,
    className: e
  }))} ref={a} {...i} />;
});
G.displayName = `Button`;
function Lo({
  items: e,
  label: t = `Ações`,
  trigger: n,
  align: r = `right`
}) {
  let [i, a] = (0, k.useState)(false);
  let o = (0, k.useRef)(null);
  let s = (0, k.useRef)(null);
  let [c, l] = (0, k.useState)(null);
  let u = e.filter(e => !e.hidden);
  let d = () => {
    if (!o.current) {
      return;
    }
    let e = o.current.getBoundingClientRect();
    let t = r === `right` ? e.right - 208 : e.left;
    if (t < 8) {
      t = 8;
    }
    if (t + 208 > window.innerWidth - 8) {
      t = window.innerWidth - 208 - 8;
    }
    let n = e.bottom + 4;
    let i = u.length * 36 + 16;
    if (n + i > window.innerHeight - 8 && e.top - i > 8) {
      n = e.top - i - 4;
    }
    l({
      top: n,
      left: t
    });
  };
  (0, k.useLayoutEffect)(() => {
    if (i) {
      d();
    }
  }, [i, r, u.length]);
  (0, k.useEffect)(() => {
    if (!i) {
      return;
    }
    function e(e) {
      let t = e.target;
      if (!o.current?.contains(t) && !s.current?.contains(t)) {
        a(false);
      }
    }
    function t(e) {
      if (e.key === `Escape`) {
        a(false);
      }
    }
    function n() {
      a(false);
    }
    document.addEventListener(`mousedown`, e);
    document.addEventListener(`keydown`, t);
    window.addEventListener(`scroll`, n, true);
    window.addEventListener(`resize`, n);
    return () => {
      document.removeEventListener(`mousedown`, e);
      document.removeEventListener(`keydown`, t);
      window.removeEventListener(`scroll`, n, true);
      window.removeEventListener(`resize`, n);
    };
  }, [i]);
  if (u.length === 0) {
    return null;
  } else {
                    return <div className={`inline-block text-left`}><button ref={o} type={`button`} aria-label={t} aria-expanded={i} onClick={() => a(e => !e)} className={U(n ? `rounded-full transition-opacity duration-150 hover:opacity-90 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring/35` : `rounded-md p-1.5 text-muted-foreground transition-colors duration-150 hover:bg-accent hover:text-foreground`, !n && i && `bg-accent text-foreground`)}>{n ?? <_Component2 className={`h-4 w-4`} />}</button>{i && c && (0, ee.createPortal)(<div ref={s} style={{
        position: `fixed`,
        top: `${c.top}px`,
        left: `${c.left}px`,
        zIndex: 9999
      }} className={`w-52 origin-top animate-scale-in overflow-hidden rounded-lg border border-border bg-popover p-1 text-popover-foreground shadow-lg`}>{u.map(e => <button type={`button`} onClick={() => {
          a(false);
          e.onSelect();
        }} className={U(`flex w-full items-center gap-2 rounded-md px-2 py-1.5 text-left text-sm transition-colors duration-150 hover:bg-accent hover:text-accent-foreground [&_svg]:size-4 [&_svg]:text-muted-foreground`, e.destructive && `text-destructive hover:bg-destructive/10 hover:text-destructive [&_svg]:text-destructive`)} key={e.label}>{e.icon}{e.label}</button>)}</div>, document.body)}</div>;
  }
}
var Ro = `planejados-theme`;
var zo = `(prefers-color-scheme: dark)`;
var Bo = new Set();
function Vo() {
  if (typeof window > `u` || typeof window.matchMedia != `function`) {
    return false;
  } else {
    return window.matchMedia(zo).matches;
  }
}
function Ho(e) {
  if (e === `system`) {
    if (Vo()) {
      return `dark`;
    } else {
      return `light`;
    }
  } else {
    return e;
  }
}
function Uo() {
  try {
    let e = localStorage.getItem(Ro);
    if (e === `light` || e === `dark` || e === `system`) {
      return e;
    }
  } catch {}
  return `light`;
}
var Wo = Uo();
var Go = Ho(Wo);
function Ko(e) {
  document.documentElement.classList.toggle(`dark`, e === `dark`);
}
function qo() {
  Bo.forEach(e => e());
}
function Jo(e) {
  Wo = e;
  Go = Ho(e);
  Ko(Go);
  try {
    localStorage.setItem(Ro, e);
  } catch {}
  qo();
}
function Yo(e) {
  Bo.add(e);
  return () => Bo.delete(e);
}
if (typeof window < `u` && typeof window.matchMedia == `function`) {
  window.matchMedia(zo).addEventListener(`change`, () => {
    if (Wo === `system`) {
      Go = Ho(Wo);
      Ko(Go);
      qo();
    }
  });
}
function Xo() {
  let e = (0, k.useSyncExternalStore)(Yo, () => Wo, () => `light`);
  let t = (0, k.useSyncExternalStore)(Yo, () => Go, () => `light`);
  return {
    tema: e,
    resolvido: t,
    escuro: t === `dark`,
    definir: Jo,
    alternar: () => Jo(Go === `dark` ? `light` : `dark`)
  };
}
var Zo = [{
  valor: `light`,
  label: `Claro`,
  Icone: _Component16
}, {
  valor: `dark`,
  label: `Escuro`,
  Icone: Fn
}, {
  valor: `system`,
  label: `Sistema`,
  Icone: Pn
}];
function Qo({
  className: e
}) {
  let {
    tema: t,
    definir: n
  } = Xo();
    return <div role={`radiogroup`} aria-label={`Aparência`} className={U(`flex items-center gap-1 rounded-full border border-sidebar-border bg-sidebar-accent/50 p-1`, e)}>{Zo.map(({
      valor: e,
      label: r,
      Icone: _Component3
    }) => {
      let a = t === e;
            return <button type={`button`} role={`radio`} aria-checked={a} aria-label={r} title={r} onClick={() => n(e)} className={U(`grid h-8 flex-1 place-items-center rounded-full transition-colors duration-150 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring/40`, a ? `bg-card text-foreground shadow-[0_1px_2px_rgb(0_0_0/0.08)]` : `text-muted-foreground hover:text-foreground`)} key={e}><_Component3 className={`h-4 w-4`} /></button>;
    })}</div>;
}
var $o = [{
  itens: [{
    to: `/`,
    label: `Painel`,
    icon: <Sn />,
    end: true
  }, {
    to: `/clientes`,
    label: `Clientes`,
    icon: <Cr />
  }, {
    to: `/projetos`,
    label: `Projetos`,
    icon: <_Component4 />
  }, {
    to: `/designer`,
    label: `Designer 3D`,
    icon: <Lt />
  }]
}, {
  titulo: `Comercial`,
  itens: [{
    to: `/orcamentos`,
    label: `Orçamentos`,
    icon: <Bt />
  }, {
    to: `/contratos`,
    label: `Contratos`,
    icon: <_Component5 />
  }, {
    to: `/financeiro`,
    label: `Financeiro`,
    icon: <_Component6 />
  }]
}, {
  titulo: `Produção`,
  itens: [{
    to: `/estoque`,
    label: `Estoque`,
    icon: <Rt />
  }, {
    to: `/ordens`,
    label: `Ordens de serviço`,
    icon: <Yt />
  }]
}, {
  titulo: `Sistema`,
  itens: [{
    to: `/configuracoes`,
    label: `Configurações`,
    icon: <_Component7 />
  }]
}];
var es = {
  "/": `Painel`,
  "/clientes": `Clientes`,
  "/projetos": `Projetos`,
  "/designer": `Designer 3D`,
  "/estoque": `Estoque`,
  "/orcamentos": `Orçamentos`,
  "/ordens": `Ordens de serviço`,
  "/contratos": `Contratos`,
  "/financeiro": `Financeiro`,
  "/configuracoes": `Configurações`
};
var ts = new Intl.DateTimeFormat(`pt-BR`, {
  weekday: `long`,
  day: `2-digit`,
  month: `long`
});
function ns(e) {
  return es[`/${e.split(`/`)[1] ?? ``}`] ?? `Planejados Pro`;
}
function _Component9({
  logoUrl: e,
  nome: t
}) {
              return <div className={`flex items-center gap-2.5`}>{e ? <img src={e} alt={t ?? `Planejados Pro`} className={`h-8 w-8 rounded-[6px] border border-sidebar-border object-cover`} /> : <div className={`grid h-8 w-8 place-items-center rounded-[6px] bg-foreground text-[11px] font-bold text-background`}>{co(t ?? `Planejados Pro`)}</div>}<div className={`min-w-0`}><p className={`truncate text-[13px] font-semibold leading-tight`}>{t ?? `Planejados Pro`}</p><p className={`truncate text-[11px] text-muted-foreground`}>{Ur}</p></div></div>;
}
function _Component0({
  onNavigate: e
}) {
          return <nav className={`flex flex-1 flex-col gap-5 overflow-y-auto no-scrollbar`}>{$o.map((t, n) => <div className={`flex flex-col gap-1`} key={t.titulo ?? `grupo-${n}`}>{t.titulo && <p className={`px-2.5 pb-1 text-[11px] font-semibold text-muted-foreground`}>{t.titulo}</p>}{t.itens.map(t => <_Component8 to={t.to} end={t.end} onClick={e} className={({
        isActive: e
      }) => U(`flex items-center gap-2.5 rounded-lg px-2.5 py-2 text-[13px] font-medium transition-colors duration-150 [&_svg]:size-4 [&_svg]:shrink-0`, `focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring/30`, e ? `bg-sidebar-accent font-semibold text-foreground [&_svg]:text-primary` : `text-muted-foreground hover:bg-sidebar-accent/50 hover:text-foreground`)} key={t.to}>{t.icon}<span>{t.label}</span></_Component8>)}</div>)}</nav>;
}
function _Component1({
  nome: e,
  email: t
}) {
  let {
    signOut: n
  } = Ct();
                  return <div className={`mt-4 flex flex-col gap-4 border-t border-sidebar-border pt-4`}><div className={`flex flex-col gap-2`}><p className={`px-1 text-[10px] font-semibold uppercase tracking-wider text-muted-foreground/80`}>{`Aparência`}</p><Qo /></div><div className={`flex items-center gap-2.5 border-t border-sidebar-border pt-3`}><span className={`grid h-9 w-9 shrink-0 place-items-center rounded-full bg-sidebar-accent text-[11px] font-semibold text-foreground`}>{co(e)}</span><div className={`min-w-0 flex-1`}><p className={`truncate text-[13px] font-semibold leading-tight`}>{e}</p><p className={`truncate text-[11px] text-muted-foreground`}>{t}</p></div><G variant={`ghost`} size={`icon`} onClick={() => void n()} aria-label={`Sair da conta`} title={`Sair da conta`} className={`shrink-0 text-muted-foreground hover:text-foreground`}><An className={`h-4 w-4`} /></G></div></div>;
}
function _Component109({
  children: e
}) {
  let {
    user: t,
    signOut: n,
    profileName: r
  } = Ct();
  let {
    data: i
  } = Ir();
  let [a, o] = (0, k.useState)(false);
  let s = b();
  let c = f();
  let l = ns(s.pathname);
  let u = r?.trim() || t?.email?.split(`@`)[0] || `Usuário`;
  let d = t?.email ?? ``;
    let p = <span className={`grid h-8 w-8 place-items-center rounded-full border border-border bg-card text-[11px] font-semibold text-foreground`}>{co(u)}</span>;
                                        return <div className={`min-h-screen bg-background text-foreground`}><aside className={`fixed inset-y-0 left-0 z-40 hidden w-60 flex-col border-r border-sidebar-border bg-sidebar p-3 lg:flex`}><div className={`px-1 py-1`}><_Component9 logoUrl={i?.logo_url} nome={i?.name} /></div><div className={`mt-3 flex flex-1 flex-col overflow-hidden`}><_Component0 /></div><_Component1 nome={u} email={d} /></aside>{a && <div className={`fixed inset-0 z-50 lg:hidden`}><div className={`absolute inset-0 animate-fade-in bg-black/50`} onClick={() => o(false)} /><div className={`absolute inset-y-0 left-0 flex w-72 animate-fade-in flex-col border-r border-sidebar-border bg-sidebar p-4`}><div className={`flex items-center justify-between`}><_Component9 logoUrl={i?.logo_url} nome={i?.name} /><G variant={`ghost`} size={`icon`} onClick={() => o(false)} aria-label={`Fechar menu`}><Dr className={`h-4 w-4`} /></G></div><div className={`mt-3 h-1.5 w-full regua-trena opacity-40 text-primary pointer-events-none`} /><div className={`mt-4 flex flex-1 flex-col overflow-hidden`}><_Component0 onNavigate={() => o(false)} /></div><_Component1 nome={u} email={d} /></div></div>}<div className={`lg:pl-60`}><header className={`sticky top-0 z-30 border-b border-border bg-background/90 backdrop-blur-md`}><div className={`h-1.5 w-full regua-trena opacity-60 text-primary pointer-events-none`} /><div className={`flex h-15 items-center justify-between gap-3 px-4 sm:px-6`}><div className={`flex min-w-0 items-center gap-1`}><G variant={`ghost`} size={`icon`} className={`lg:hidden`} onClick={() => o(true)} aria-label={`Abrir menu`}><Nn className={`h-4 w-4`} /></G><div className={`min-w-0`}><h2 className={`titulo truncate text-[17px] leading-tight`}>{l}</h2><p className={`truncate text-[11px] text-muted-foreground`}>{ts.format(new Date())}</p></div></div><Lo align={`right`} label={`Conta`} trigger={p} items={[{
            label: `Meu perfil`,
            icon: <Sr className={`h-4 w-4`} />,
            onSelect: () => c(`/configuracoes`)
          }, {
            label: `Sair`,
            icon: <An className={`h-4 w-4`} />,
            destructive: true,
            onSelect: () => void n()
          }]} /></div></header><main className={`mx-auto w-full max-w-6xl px-4 py-7 sm:px-6 lg:px-8`} key={s.pathname}>{e}</main></div></div>;
}
var ss = 0.01;
var cs = 0.4;
function ls(e, t) {
  let n = [];
  let r = [...e].sort((e, t) => t.largura - e.largura || t.comprimento - e.comprimento);
  for (let e of r) {
    let r = Math.min(e.comprimento, t.comprimento_cm);
    let i = Math.min(e.largura, t.largura_cm);
    let a = false;
    for (let e of n) {
      for (let n of e.prateleiras) {
        if (i <= n.altura + ss && n.usado + r + cs <= t.comprimento_cm + ss) {
          n.usado += r + cs;
          a = true;
          break;
        }
      }
      if (a) {
        break;
      }
      if (e.alturaUsada + i + cs <= t.largura_cm + ss) {
        e.prateleiras.push({
          altura: i,
          usado: r + cs
        });
        e.alturaUsada += i + cs;
        a = true;
        break;
      }
    }
    if (!a) {
      n.push({
        prateleiras: [{
          altura: i,
          usado: r + cs
        }],
        alturaUsada: i + cs
      });
    }
  }
  return n;
}
function us(e, t = {
  comprimento_cm: 275,
  largura_cm: 185
}) {
  let n = new Map();
  for (let t of e) {
    let e = `${t.tipo_chapa}|${t.espessura_mm}|${t.material_id ?? `sem-material`}`;
    let r = n.get(e) ?? {
      pecas: [],
      tipo: t.tipo_chapa,
      espessura: t.espessura_mm
    };
    r.pecas.push(t);
    n.set(e, r);
  }
  let r = t.comprimento_cm * t.largura_cm / 10000;
  let i = [];
  let a = 0;
  let o = 0;
  let s = 0;
  let c = 0;
  let l = 0;
  for (let [e, u] of n.entries()) {
    let n = [];
    let d = 0;
    let f = 0;
    for (let e of u.pecas) {
      let t = Math.max(1, Math.round(e.quantidade));
      f += t;
      d += e.comprimento_cm * e.largura_cm * t / 10000;
      l += fs(e);
      for (let r = 0; r < t; r += 1) {
        n.push({
          comprimento: e.comprimento_cm,
          largura: e.largura_cm
        });
      }
    }
    let p = ls(n, t);
    let m = p.length * r;
    let h = u.pecas[0]?.material_nome ?? `${u.tipo.toUpperCase()} ${u.espessura}mm`;
    i.push({
      chave: e,
      rotulo: h,
      tipo_chapa: u.tipo,
      espessura_mm: u.espessura,
      pecas: f,
      chapas: p.length,
      areaPecasM2: ot(d),
      areaChapasM2: ot(m),
      aproveitamento: m > 0 ? ot(d / m * 100) : 0
    });
    a += p.length;
    o += f;
    s += d;
    c += m;
  }
  i.sort((e, t) => t.chapas - e.chapas || e.rotulo.localeCompare(t.rotulo));
  return {
    totalChapas: a,
    totalPecas: o,
    areaPecasM2: ot(s),
    areaChapasM2: ot(c),
    aproveitamento: c > 0 ? ot(s / c * 100) : 0,
    sobraM2: ot(c - s),
    grupos: i,
    fitaBordaCm: ot(l)
  };
}
function ds(e) {
  let t = [e.borda_topo && `topo`, e.borda_base && `base`, e.borda_esquerda && `esq.`, e.borda_direita && `dir.`].filter(Boolean);
  if (t.length > 0) {
    return t.join(`, `);
  } else {
    return `-`;
  }
}
function fs(e) {
  let t = 0;
  if (e.borda_topo) {
    t += e.comprimento_cm;
  }
  if (e.borda_base) {
    t += e.comprimento_cm;
  }
  if (e.borda_esquerda) {
    t += e.largura_cm;
  }
  if (e.borda_direita) {
    t += e.largura_cm;
  }
  return t * Math.max(1, Math.round(e.quantidade));
}
function ps(e, t, n = {
  comprimento_cm: 275,
  largura_cm: 185
}) {
  let r = new Map(t.map(e => [e.id, e]));
  let i = n.comprimento_cm * n.largura_cm / 10000;
  let a = 0;
  for (let t of e) {
    if (!t.material_id) {
      continue;
    }
    let e = r.get(t.material_id);
    if (!e) {
      continue;
    }
    let n = t.comprimento_cm * t.largura_cm * Math.max(1, t.quantidade) / 10000;
    let o = e.unidade.toLowerCase();
    a += o === `m2` || o === `m²` ? n * e.custo_unitario : o === `chapa` ? n / i * e.custo_unitario : e.custo_unitario * Math.max(1, t.quantidade);
  }
  return ot(a);
}
var ms = `ABCDEFGHIJKLMNOPQRSTUVWXYZ`;
function hs(e) {
  let t = e;
  let n = ``;
  do {
    n = ms[t % 26] + n;
    t = Math.floor(t / 26) - 1;
  } while (t >= 0);
  return n.padStart(2, `0`);
}
function gs(e) {
  return `${e.getFullYear()}-${String(e.getMonth() + 1).padStart(2, `0`)}-${String(e.getDate()).padStart(2, `0`)}`;
}
function _s(e, t, n, r) {
  let i = Math.max(1, Math.trunc(t));
  let a = ot(e / i);
  let o = ot(e - a * i);
  let s = new Date(`${n}T00:00:00`);
  return Array.from({
    length: i
  }, (e, t) => {
    let n = new Date(s);
    n.setDate(n.getDate() + t * r);
    return {
      numero: t + 1,
      vencimento: gs(n),
      valor: t === i - 1 ? ot(a + o) : a
    };
  });
}
function vs(e, t = new Date()) {
  let n = gs(t);
  let r = 0;
  let i = 0;
  let a = 0;
  let o = 0;
  let s = 0;
  let c = 0;
  for (let t of e) {
    if (t.status === `cancelado`) {
      continue;
    }
    let e = Number(t.valor ?? 0);
    let l = Number(t.valor_pago ?? (t.status === `pago` ? e : 0));
    let u = t.status === `previsto` && t.vencimento !== null && t.vencimento < n;
    if (t.tipo === `receita`) {
      if (t.status === `pago`) {
        i += l;
      } else {
        r += e;
        if (u) {
          s += e;
        }
      }
    } else if (t.status === `pago`) {
      o += l;
    } else {
      a += e;
      if (u) {
        c += e;
      }
    }
  }
  return {
    aReceber: ot(r),
    recebido: ot(i),
    aPagar: ot(a),
    pago: ot(o),
    receitasEmAtraso: ot(s),
    despesasEmAtraso: ot(c),
    saldoRealizado: ot(i - o),
    saldoProjetado: ot(r + i - a - o)
  };
}
async function ys(e) {
  let t = B.from(`materiais`).select(`*`).order(`nome`, {
    ascending: true
  });
  if (e?.categoria && e.categoria !== `todos`) {
    t = t.eq(`categoria`, e.categoria);
  }
  if (e?.somenteAtivos) {
    t = t.eq(`ativo`, true);
  }
  if (e?.busca && e.busca.trim().length > 0) {
    let n = e.busca.trim().replace(/[%,]/g, ``);
    t = t.or(`nome.ilike.%${n}%,codigo.ilike.%${n}%,cor.ilike.%${n}%`);
  }
  let {
    data: n,
    error: r
  } = await t;
  if (r) {
    throw r;
  }
  return n ?? [];
}
async function bs(e) {
  let {
    data: t,
    error: n
  } = await B.from(`materiais`).insert(e).select(`*`).single();
  if (n) {
    throw n;
  }
  return t;
}
async function xs(e, t) {
  let {
    data: n,
    error: r
  } = await B.from(`materiais`).update(t).eq(`id`, e).select(`*`).single();
  if (r) {
    throw r;
  }
  return n;
}
async function Ss(e) {
  let {
    error: t
  } = await B.from(`materiais`).delete().eq(`id`, e);
  if (t) {
    throw t;
  }
}
async function Cs(e) {
  let {
    data: t,
    error: n
  } = await B.rpc(`registrar_movimentacao`, {
    _material_id: e.material_id,
    _tipo: e.tipo,
    _quantidade: e.quantidade,
    _custo_unitario: e.custo_unitario ?? 0,
    _motivo: e.motivo ?? null,
    _projeto_id: e.projeto_id ?? null
  });
  if (n) {
    throw n;
  }
  return t;
}
async function ws(e, t = 100) {
  let n = B.from(`movimentacoes_estoque`).select(`*`).order(`created_at`, {
    ascending: false
  }).limit(t);
  if (e) {
    n = n.eq(`material_id`, e);
  }
  let {
    data: r,
    error: i
  } = await n;
  if (i) {
    throw i;
  }
  return r ?? [];
}
async function Ts() {
  let {
    data: e,
    error: t
  } = await B.from(`materiais`).select(`*`).eq(`ativo`, true).order(`nome`, {
    ascending: true
  });
  if (t) {
    throw t;
  }
  return (e ?? []).filter(e => Number(e.estoque_atual) <= Number(e.estoque_minimo));
}
async function Es(e) {
  let t = B.from(`retalhos`).select(`*`).order(`created_at`, {
    ascending: false
  });
  if (e?.consumido !== undefined) {
    t = t.eq(`consumido`, e.consumido);
  }
  let {
    data: n,
    error: r
  } = await t;
  if (r) {
    throw r;
  }
  return n ?? [];
}
async function Ds(e) {
  let {
    data: t,
    error: n
  } = await B.from(`retalhos`).insert(e).select(`*`).single();
  if (n) {
    throw n;
  }
  return t;
}
async function Os(e, t) {
  let {
    data: n,
    error: r
  } = await B.from(`retalhos`).update(t).eq(`id`, e).select(`*`).single();
  if (r) {
    throw r;
  }
  return n;
}
async function ks(e) {
  let {
    error: t
  } = await B.from(`retalhos`).delete().eq(`id`, e);
  if (t) {
    throw t;
  }
}
var As = [`concluido`, `cancelado`];
var js = [`concluido`, `cancelado`];
function Ms(e) {
  if (!e) {
    return false;
  }
  let t = new Date(`${e}T00:00:00`);
  let n = new Date();
  n.setHours(0, 0, 0, 0);
  let r = new Date(n);
  r.setDate(r.getDate() + 7);
  return t >= n && t <= r;
}
async function Ns() {
  let [e, t, n, r, i] = await Promise.all([B.from(`projetos`).select(`id,nome,status,updated_at,data_entrega_prevista, cliente:clientes(nome)`).order(`updated_at`, {
    ascending: false
  }), B.from(`ordens_servico`).select(`id,numero,status,data_prevista_entrega, projeto:projetos(nome, cliente:clientes(nome))`).order(`data_prevista_entrega`, {
    ascending: true,
    nullsFirst: false
  }), B.from(`clientes`).select(`id`, {
    count: `exact`,
    head: true
  }), Ts(), B.from(`lancamentos`).select(`tipo,status,valor,valor_pago,vencimento`)]);
  if (e.error) {
    throw e.error;
  }
  if (t.error) {
    throw t.error;
  }
  if (n.error) {
    throw n.error;
  }
  if (i.error) {
    throw i.error;
  }
  let a = e.data ?? [];
  let o = t.data ?? [];
  let s = a.filter(e => !As.includes(e.status)).slice(0, 6).map(e => ({
    id: e.id,
    nome: e.nome,
    status: e.status,
    updated_at: e.updated_at,
    cliente_nome: e.cliente?.nome ?? null
  }));
  let c = o.filter(e => !js.includes(e.status) && e.data_prevista_entrega).slice(0, 8).map(e => ({
    id: e.id,
    numero: e.numero,
    status: e.status,
    data_prevista_entrega: e.data_prevista_entrega,
    projeto_nome: e.projeto?.nome ?? null,
    cliente_nome: e.projeto?.cliente?.nome ?? null
  }));
  let l = vs(i.data ?? []);
  return {
    projetosAndamento: a.filter(e => !As.includes(e.status)).length,
    osPendentes: o.filter(e => !js.includes(e.status)).length,
    entregasSemana: o.filter(e => !js.includes(e.status) && Ms(e.data_prevista_entrega)).length,
    clientesTotal: n.count ?? 0,
    projetosAtivos: s,
    agenda: c,
    materiaisAlerta: r,
    financeiro: {
      aReceber: l.aReceber,
      emAtraso: l.receitasEmAtraso,
      saldoRealizado: l.saldoRealizado
    }
  };
}
function Ps() {
  return T({
    queryKey: H.dashboard,
    queryFn: Ns
  });
}
function Fs({
  title: e,
  description: t,
  actions: n,
  children: r
}) {
              return <div className={`flex flex-col gap-4`}><div className={`flex flex-col gap-3 sm:flex-row sm:items-start sm:justify-between`}><div className={`min-w-0 space-y-1.5`}><h1 className={`titulo text-[24px] leading-tight`}>{e}</h1>{t && <div className={`text-[13px] text-muted-foreground`}>{t}</div>}</div>{n && <div className={`flex flex-wrap items-center gap-2`}>{n}</div>}</div>{r}</div>;
}
var Is = {
  default: `text-foreground`,
  warning: `text-amber-700 dark:text-amber-400`,
  success: `text-emerald-700 dark:text-emerald-400`
};
function Ls({
  items: e,
  className: t
}) {
                  return <div className={U(`relative flex flex-col divide-y divide-border sm:flex-row sm:divide-x sm:divide-y-0`, t)}><div className={`absolute top-0 inset-x-0 h-1.5 regua-trena opacity-60 text-primary pointer-events-none`} />{e.map(e => <div className={`flex-1 px-5 pt-5 pb-4`} key={e.label}><p className={`text-[12px] font-medium text-muted-foreground`}>{e.label}</p><div className={`mt-1.5 flex items-baseline gap-2`}><span className={U(`numero text-[24px] font-semibold leading-none`, Is[e.tom ?? `default`])}>{e.value}</span>{e.delta && <span className={`text-xs text-muted-foreground`}>{e.delta}</span>}</div>{e.hint && <p className={`mt-1 text-[12px] text-muted-foreground`}>{e.hint}</p>}</div>)}</div>;
}
var Rs = k.forwardRef(({
  className: e,
  ...t
}, n) => <div ref={n} className={U(`rounded-[10px] border border-border bg-card text-card-foreground`, e)} {...t} />);
Rs.displayName = `Card`;
var _Component11 = k.forwardRef(({
  className: e,
  ...t
}, n) => <div ref={n} className={U(`flex flex-col gap-1 p-5`, e)} {...t} />);
_Component11.displayName = `CardHeader`;
var Bs = k.forwardRef(({
  className: e,
  ...t
}, n) => <div ref={n} className={U(`text-[13px] font-semibold tracking-tight`, e)} {...t} />);
Bs.displayName = `CardTitle`;
var Vs = k.forwardRef(({
  className: e,
  ...t
}, n) => <div ref={n} className={U(`text-[13px] text-muted-foreground`, e)} {...t} />);
Vs.displayName = `CardDescription`;
var Hs = k.forwardRef(({
  className: e,
  ...t
}, n) => <div ref={n} className={U(`p-5 pt-0`, e)} {...t} />);
Hs.displayName = `CardContent`;
var Us = k.forwardRef(({
  className: e,
  ...t
}, n) => <div ref={n} className={U(`flex items-center p-5 pt-0`, e)} {...t} />);
Us.displayName = `CardFooter`;
function Ws({
  icon: e,
  title: t,
  description: n,
  action: r,
  className: i
}) {
              return <div className={U(`flex flex-col items-center justify-center gap-3 rounded-[10px] border border-dashed border-border px-6 py-14 text-center`, i)}>{e && <div className={`grid h-9 w-9 place-items-center rounded-[6px] border border-border bg-card text-muted-foreground [&_svg]:h-4 [&_svg]:w-4`}>{e}</div>}<div className={`space-y-1`}><p className={`text-[13px] font-semibold`}>{t}</p>{n && <p className={`mx-auto max-w-sm text-[13px] text-muted-foreground`}>{n}</p>}</div>{r && <div className={`mt-1`}>{r}</div>}</div>;
}
function Gs({
  label: e,
  tone: t,
  className: n
}) {
      return <span className={U(`inline-flex items-center gap-1.5 whitespace-nowrap rounded-[5px] border border-border bg-card px-1.5 py-0.5 text-[11px] font-medium leading-4 text-muted-foreground`, n)}><span className={U(`h-1.5 w-1.5 shrink-0 rounded-full`, t)} aria-hidden={true} />{e}</span>;
}
function Ks(e) {
  return null;
}
function _Component97() {
  let e = f();
  let {
    data: t,
    isLoading: n
  } = Ps();
  let r = t?.materiaisAlerta.length ?? 0;
                                                                  return <div className={`space-y-7`}><Fs title={`Visão operacional`} description={n || !t ? `Carregando indicadores da marcenaria.` : `${Za(t.projetosAndamento, 0)} projetos em andamento e ${Za(t.entregasSemana, 0)} entregas nos próximos 7 dias.`} actions={<L.Fragment><G variant={`outline`} onClick={() => e(`/clientes?novo=1`)}><_Component10 className={`h-4 w-4`} />{`Cliente`}</G><G variant={`outline`} onClick={() => e(`/estoque?novo=1`)}><_Component10 className={`h-4 w-4`} />{`Entrada`}</G><G onClick={() => e(`/projetos?novo=1`)}><_Component10 className={`h-4 w-4`} />{`Novo projeto`}</G></L.Fragment>} />{n || !t ? <Ks className={`h-[104px]`} /> : <Rs className={`overflow-hidden`}><Ls items={[{
        label: `Projetos em andamento`,
        value: Za(t.projetosAndamento, 0)
      }, {
        label: `Ordens pendentes`,
        value: Za(t.osPendentes, 0)
      }, {
        label: `Entregas na semana`,
        value: Za(t.entregasSemana, 0)
      }, {
        label: `A receber`,
        value: W(t.financeiro.aReceber),
        hint: t.financeiro.emAtraso > 0 ? `${W(t.financeiro.emAtraso)} em atraso` : `Nada em atraso`,
        tom: t.financeiro.emAtraso > 0 ? `warning` : `default`
      }]} /></Rs>}<div className={`grid gap-6 lg:grid-cols-2`}><Rs className={`relative overflow-hidden`}><div className={`h-1.5 w-full regua-trena opacity-60 text-primary`} /><_Component11 className={`flex flex-row items-center justify-between space-y-0`}><Bs className={`flex items-center gap-2`}>{`Suprimentos abaixo do mínimo`}{r > 0 && <span className={`text-[11px] font-medium tabular-nums text-foreground`}>{r}</span>}</Bs><_ to={`/estoque`} className={`text-[13px] font-medium underline decoration-border underline-offset-4 hover:decoration-foreground`}>{`Ver estoque`}</_></_Component11><Hs className={`p-0`}>{n ? <div className={`px-5 pb-5`}><Ks className={`h-24`} /></div> : t && t.materiaisAlerta.length > 0 ? <ul className={`divide-y divide-border border-t border-border`}>{t.materiaisAlerta.slice(0, 5).map(e => <li className={`flex items-center justify-between gap-3 px-5 py-2.5`} key={e.id}><div className={`min-w-0`}><p className={`truncate text-[13px] font-medium`}>{e.nome}</p><p className={`truncate text-[11px] text-muted-foreground`}>{[e.cor, e.acabamento].filter(Boolean).join(`, `) || `Sem variação`}</p></div><span className={`whitespace-nowrap text-[12px] tabular-nums text-amber-700 dark:text-amber-400 font-mono font-medium`}>{Za(e.estoque_atual, 0)}{` de `}{Za(e.estoque_minimo, 0)}{` `}{e.unidade}</span></li>)}</ul> : <div className={`flex items-center gap-2 border-t border-border px-5 py-4 text-[13px] text-muted-foreground`}><Kt className={`h-4 w-4 text-emerald-600 dark:text-emerald-500`} />{`Nenhum insumo abaixo do estoque mínimo.`}</div>}</Hs></Rs><Rs className={`relative overflow-hidden`}><div className={`h-1.5 w-full regua-trena opacity-60 text-primary`} /><_Component11 className={`flex flex-row items-center justify-between space-y-0`}><Bs>{`Agenda de entregas`}</Bs><_ to={`/ordens`} className={`text-[13px] font-medium underline decoration-border underline-offset-4 hover:decoration-foreground`}>{`Ver ordens`}</_></_Component11><Hs className={`p-0`}>{n ? <div className={`px-5 pb-5`}><Ks className={`h-24`} /></div> : t && t.agenda.length > 0 ? <ul className={`divide-y divide-border border-t border-border`}>{t.agenda.map(e => <li key={e.id}><_ to={`/ordens/${e.id}`} className={`flex items-center gap-4 px-5 py-2.5 transition-colors duration-150 hover:bg-accent/40`}><span className={`w-24 shrink-0 font-mono text-[11px] text-muted-foreground`}>{e.numero}</span><div className={`min-w-0 flex-1`}><p className={`truncate text-[13px] font-medium`}>{e.projeto_nome ?? `Sem projeto`}</p><p className={`truncate text-[11px] text-muted-foreground`}>{e.cliente_nome ?? `Sem cliente`}</p></div><span className={`hidden shrink-0 items-center gap-1 text-[11px] tabular-nums text-muted-foreground sm:flex`}><Ht className={`h-3.5 w-3.5`} />{to(e.data_prevista_entrega)}</span><Gs label={Xr[e.status]} tone={Qr[e.status]} /></_></li>)}</ul> : <div className={`border-t border-border px-5 py-4`}><Ws className={`border-0 py-8`} title={`Sem entregas agendadas`} description={`As ordens com data prevista aparecem aqui.`} /></div>}</Hs></Rs></div><Rs className={`relative overflow-hidden`}><div className={`h-1.5 w-full regua-trena opacity-60 text-primary`} /><_Component11 className={`flex flex-row items-center justify-between space-y-0`}><Bs>{`Projetos ativos`}</Bs><_ to={`/projetos`} className={`text-[13px] font-medium underline decoration-border underline-offset-4 hover:decoration-foreground`}>{`Ver todos`}</_></_Component11><Hs className={`p-0`}>{n ? <div className={`px-5 pb-5`}><Ks className={`h-32`} /></div> : t && t.projetosAtivos.length > 0 ? <ul className={`divide-y divide-border border-t border-border`}>{t.projetosAtivos.map(e => <li key={e.id}><_ to={`/projetos/${e.id}`} className={`flex items-center justify-between gap-3 px-5 py-3 transition-colors duration-150 hover:bg-accent/40`}><div className={`flex min-w-0 items-center gap-3`}><span className={`grid h-7 w-7 shrink-0 place-items-center rounded-[6px] border border-border text-muted-foreground`}><_Component4 className={`h-3.5 w-3.5`} /></span><div className={`min-w-0`}><p className={`truncate text-[13px] font-medium`}>{e.nome}</p><p className={`truncate text-[11px] text-muted-foreground`}>{e.cliente_nome ?? `Sem cliente`}</p></div></div><Gs label={qr[e.status]} tone={Yr[e.status]} /></_></li>)}</ul> : <div className={`border-t border-border px-5 py-4`}><Ws className={`border-0 py-8`} title={`Nenhum projeto ativo`} description={`Crie um projeto para acompanhar medição, corte, montagem e entrega.`} action={<G size={`sm`} onClick={() => e(`/projetos?novo=1`)}><_Component10 className={`h-4 w-4`} />{`Novo projeto`}</G>} /></div>}</Hs></Rs></div>;
}
function Js(e) {
  return e.trim() !== `` && !Number.isNaN(Number(e.replace(`,`, `.`)));
}
function Ys(e) {
  return Number(e.replace(`,`, `.`));
}
var Xs = o().trim().refine(e => e === `` || Js(e), `Número inválido`);
var Zs = e => o().trim().refine(t => Js(t) && Ys(t) >= e, `Valor mínimo ${e}`);
var Qs = o().trim().refine(e => Js(e) && Ys(e) > 0, `Informe um valor maior que zero`);
var $s = o().trim().refine(e => Number.isInteger(Number(e)) && Number(e) > 0, `Informe um inteiro maior que zero`);
var ec = (e = 500) => o().trim().max(e);
var tc = c([o().trim().email(`E-mail inválido`), s(``)]);
var nc = t({
  email: o().trim().email(`E-mail inválido`),
  password: o().min(6, `Mínimo de 6 caracteres`)
});
var rc = t({
  full_name: o().trim().min(2, `Informe seu nome`).max(160),
  tenant_name: o().trim().min(2, `Informe o nome da marcenaria`).max(160),
  email: o().trim().email(`E-mail inválido`),
  password: o().min(6, `Mínimo de 6 caracteres`),
  confirmacao: o().min(6, `Confirme a senha`)
}).refine(e => e.password === e.confirmacao, {
  message: `As senhas não coincidem`,
  path: [`confirmacao`]
});
var ic = t({
  email: o().trim().min(1, `Informe seu e-mail`).email(`E-mail inválido`).max(255)
});
var ac = t({
  password: o().min(6, `Mínimo de 6 caracteres`),
  confirmacao: o().min(6, `Confirme a senha`)
}).refine(e => e.password === e.confirmacao, {
  message: `As senhas não coincidem`,
  path: [`confirmacao`]
});
var oc = t({
  nome: o().trim().min(2, `Informe o nome do cliente`).max(160),
  documento: ec(20),
  email: tc,
  telefone: ec(20),
  endereco: ec(300),
  cidade: ec(120),
  uf: ec(2),
  cep: ec(10),
  observacoes: ec(2000)
});
var sc = t({
  cliente_id: o().trim().min(1, `Selecione um cliente`),
  nome: o().trim().min(2, `Informe o nome do projeto`).max(160),
  descricao: ec(2000),
  status: a([`medicao`, `projeto_corte`, `montagem`, `entrega`, `concluido`, `cancelado`]),
  prioridade: a([`1`, `2`, `3`]),
  data_inicio: ec(20),
  data_entrega_prevista: ec(20),
  termos_contrato: ec(5000)
});
var cc = o().trim().refine(Le, `Selecione o tipo do ambiente`);
var lc = o().trim().refine(e => Js(e) && Ys(e) >= 0 && Ys(e) <= 200, `Margem entre 0% e 200%`);
var uc = o().trim().refine(e => e === `` || Js(e) && Ys(e) >= 10 && Ys(e) <= 2000, `Medida entre 10 e ${Pe} cm`);
t({
  nome: o().trim().min(2, `Informe o nome do ambiente`).max(120),
  tipo: cc,
  margem_percent: lc,
  observacoes: ec(Fe)
});
var dc = t({
  nome: o().trim().min(2, `Informe o nome do ambiente`).max(120),
  tipo: cc,
  margem_percent: lc,
  largura_cm: uc,
  altura_cm: uc,
  profundidade_cm: uc,
  observacoes: ec(Fe)
});
var fc = t({
  altura_cm: Xs,
  largura_cm: Xs,
  profundidade_cm: Xs,
  desnivel_cm: Xs,
  pontos_eletricos: Xs,
  pontos_hidraulicos: Xs,
  colunas_vigas: ec(2000),
  observacoes: ec(2000)
});
var pc = t({
  elevador_tamanho: ec(160),
  elevador_ok: l(),
  tem_escada: l(),
  escada_observacoes: ec(1000),
  estacionamento: ec(300),
  horario_permitido: ec(160),
  restricoes_condominio: ec(2000),
  acesso_observacoes: ec(2000),
  concluido: l()
});
var mc = t({
  categoria: a([`chapa`, `ferragem`, `consumivel`]),
  nome: o().trim().min(2, `Informe o nome do material`).max(160),
  codigo: ec(60),
  descricao: ec(1000),
  unidade: o().trim().min(1, `Informe a unidade`).max(10),
  cor: ec(60),
  espessura_mm: Xs,
  acabamento: ec(120),
  custo_unitario: Zs(0),
  preco_unitario: Zs(0),
  estoque_minimo: Zs(0),
  estoque_atual: Zs(0),
  ativo: l()
});
var hc = t({
  material_id: o().trim().min(1, `Selecione um material`),
  tipo: a([`entrada`, `saida`]),
  quantidade: Qs,
  custo_unitario: Zs(0),
  motivo: ec(300),
  projeto_id: c([o().trim(), s(``)])
});
var gc = t({
  material_id: o().trim().min(1, `Selecione um material`),
  projeto_id: c([o().trim(), s(``)]),
  largura_cm: Qs,
  altura_cm: Qs,
  espessura_mm: Xs,
  quantidade: $s,
  local: ec(160),
  observacoes: ec(1000),
  consumido: l()
});
var _c = t({
  nome: o().trim().min(1, `Informe o nome da peça`).max(160),
  material_id: c([o().trim(), s(``)]),
  tipo_chapa: a([`mdf`, `mdp`, `compensado`, `outro`]),
  espessura_mm: Qs,
  comprimento_cm: Qs,
  largura_cm: Qs,
  quantidade: $s,
  sentido_veio: a([`comprimento`, `largura`, `sem_veio`]),
  fita_tipo: a([`lisa`, `pvc`, `melamina`, `abs`, `nenhuma`]),
  borda_topo: l(),
  borda_base: l(),
  borda_esquerda: l(),
  borda_direita: l()
});
var vc = t({
  perda_percent: Zs(0),
  operacional_custo: Zs(0),
  montagem_horas: Zs(0),
  montagem_valor_hora: Zs(0),
  frete: Zs(0),
  impostos_percent: Zs(0),
  margem_percent: Zs(0),
  validade_dias: $s,
  observacoes: ec(4000)
});
var yc = t({
  descricao: o().trim().min(2, `Informe a descrição`).max(300),
  ambiente_nome: ec(120),
  quantidade: Qs,
  custo_unitario: Zs(0),
  valor_unitario: Zs(0)
});
var bc = t({
  projeto_id: o().trim().min(1, `Selecione um projeto`),
  status: a([`aguardando_corte`, `furacao_borda`, `pre_montagem`, `aguardando_montagem`, `em_montagem`, `concluido`, `cancelado`]),
  data_prevista_entrega: ec(20),
  montador_id: c([o().trim(), s(``)]),
  frete: Zs(0),
  montagem_horas: Zs(0),
  observacoes: ec(2000)
});
var xc = t({
  signatario_nome: o().trim().min(2, `Informe o nome do signatário`).max(160),
  signatario_documento: ec(20),
  conteudo: o().trim().min(10, `Informe o texto do termo`).max(8000),
  os_id: c([o().trim(), s(``)])
});
var Sc = t({
  name: o().trim().min(2, `Informe o nome da marcenaria`).max(160),
  documento: ec(20),
  telefone: ec(20),
  email: tc,
  endereco: ec(300),
  cidade: ec(120),
  uf: ec(2),
  cep: ec(10),
  termos_contrato: ec(8000),
  faturamento_email: tc,
  faturamento_documento: ec(20)
});
var Cc = t({
  full_name: o().trim().min(2, `Informe o nome`).max(160),
  email: o().trim().email(`E-mail inválido`),
  password: o().min(6, `Mínimo de 6 caracteres`),
  role: a([`admin`, `marceneiro`, `orcamentista`])
});
var wc = t({
  full_name: o().trim().min(2, `Informe seu nome`).max(160),
  telefone: ec(20)
});
var Tc = t({
  projeto_id: o().trim().min(1, `Selecione um projeto`),
  cliente_id: o().trim().min(1, `Selecione um cliente`),
  orcamento_id: c([o().trim(), s(``)]),
  valor_total: Qs,
  num_parcelas: $s,
  intervalo_dias: $s,
  primeiro_vencimento: o().trim().min(10, `Informe o primeiro vencimento`).max(20),
  conteudo: ec(8000),
  termos: ec(8000),
  observacoes: ec(4000)
});
var Ec = t({
  nome: o().trim().min(2, `Informe o nome do fornecedor`).max(160),
  documento: ec(20),
  email: tc,
  telefone: ec(20),
  endereco: ec(300),
  cidade: ec(120),
  uf: ec(2),
  cep: ec(10),
  observacoes: ec(2000)
});
var Dc = t({
  nome: o().trim().min(2, `Informe o nome da categoria`).max(120),
  tipo: a([`receita`, `despesa`]),
  cor: ec(20),
  ativo: l()
});
var Oc = t({
  tipo: a([`receita`, `despesa`]),
  descricao: o().trim().min(2, `Informe a descrição`).max(200),
  valor: Qs,
  vencimento: ec(20),
  categoria_id: c([o().trim(), s(``)]),
  fornecedor_id: c([o().trim(), s(``)]),
  cliente_id: c([o().trim(), s(``)]),
  projeto_id: c([o().trim(), s(``)]),
  forma_pagamento: c([a([`dinheiro`, `pix`, `transferencia`, `boleto`, `cartao_credito`, `cartao_debito`, `cheque`, `outro`]), s(``)]),
  observacoes: ec(2000),
  registrar_pagamento: l()
});
var kc = t({
  valor_pago: Qs,
  forma_pagamento: a([`dinheiro`, `pix`, `transferencia`, `boleto`, `cartao_credito`, `cartao_debito`, `cheque`, `outro`]),
  pago_em: o().trim().min(10, `Informe a data do pagamento`).max(20)
});
var Ac = t({
  nome: o().trim().min(2, `Informe o nome do estudo`).max(120),
  projeto_id: o().trim().min(1, `Selecione um projeto`),
  ambiente_id: c([o().trim(), s(``)]),
  largura_mm: Zs(300),
  altura_mm: Zs(300),
  profundidade_mm: Zs(200),
  observacoes: ec(2000)
});
var jc = t({
  nome: o().trim().min(2, `Informe o nome do módulo`).max(120),
  categoria: a([`vertical`, `horizontal`, `gaveteiro`, `eletrodomestico`, `mesa`, `guarda_roupa`, `complemento`]),
  largura_mm: Qs,
  altura_mm: Qs,
  profundidade_mm: Qs,
  portas: Xs,
  gavetas: Xs,
  cor: ec(20)
});
var Mc = t({
  precoChapaMDF: r().min(0, `Valor não pode ser negativo`),
  precoChapaFundo: r().min(0, `Valor não pode ser negativo`),
  precoMetroFita: r().min(0, `Valor não pode ser negativo`),
  precoDobradica: r().min(0, `Valor não pode ser negativo`),
  precoCorredica: r().min(0, `Valor não pode ser negativo`),
  precoPuxador: r().min(0, `Valor não pode ser negativo`),
  precoMinifix: r().min(0, `Valor não pode ser negativo`),
  precoParafuso: r().min(0, `Valor não pode ser negativo`),
  precoSuporte: r().min(0, `Valor não pode ser negativo`),
  precoSapata: r().min(0, `Valor não pode ser negativo`),
  precoServicoPeca: r().min(0, `Valor não pode ser negativo`),
  taxaMontagemBase: r().min(0, `Valor não pode ser negativo`),
  margemPadrao: r().min(0, `Valor não pode ser negativo`)
});
var K = k.forwardRef(({
  className: e,
  type: t,
  ...n
}, r) => <input type={t} ref={r} className={U(`flex h-9 w-full rounded-md border border-input bg-background px-3 py-1 text-sm text-foreground transition-[border-color,box-shadow] duration-150 placeholder:text-muted-foreground focus-visible:border-ring focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring/35 disabled:cursor-not-allowed disabled:bg-muted/60 disabled:text-muted-foreground disabled:opacity-70`, e)} {...n} />);
K.displayName = `Input`;
var Nc = k.forwardRef(({
  className: e,
  ...t
}, n) => {
  let [r, i] = k.useState(false);
      return <div className={`relative`}><K ref={n} type={r ? `text` : `password`} className={U(`pr-10`, e)} {...t} /><button type={`button`} tabIndex={-1} onClick={() => i(e => !e)} aria-label={r ? `Ocultar senha` : `Mostrar senha`} className={`absolute right-1 top-1/2 -translate-y-1/2 rounded-md p-1.5 text-muted-foreground transition-colors duration-150 hover:text-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring/30`}>{r ? <_Component12 className={`h-4 w-4`} /> : <_Component13 className={`h-4 w-4`} />}</button></div>;
});
Nc.displayName = `PasswordInput`;
var Pc = Object.defineProperty;
var Fc = (e, t) => Pc(e, `name`, {
  value: t,
  configurable: true
});
var Ic = [`a`, `button`, `div`, `form`, `h2`, `h3`, `img`, `input`, `label`, `li`, `nav`, `ol`, `p`, `select`, `span`, `svg`, `ul`].reduce((e, t) => {
  let n = bo(`Primitive.${t}`);
  let r = k.forwardRef((e, r) => {
    let {
      asChild: i,
      ...a
    } = e;
    let _Component14 = i ? n : t;
    if (typeof window < `u`) {
      window[Symbol.for(`radix-ui`)] = true;
    }
    return <_Component14 {...a} ref={r} />;
  });
  r.displayName = `Primitive.${t}`;
  return {
    ...e,
    [t]: r
  };
}, {});
function Lc(e, t) {
  if (e) {
    ee.flushSync(() => e.dispatchEvent(t));
  }
}
Fc(Lc, `dispatchDiscreteCustomEvent`);
var Rc = Object.defineProperty;
var _Component15 = k.forwardRef(((e, t) => Rc(e, `name`, {
  value: t,
  configurable: true
}))(function (e, t) {
  return <Ic.label {...e} ref={t} onMouseDown={t => {
    if (!t.target.closest(`button, input, select, textarea`)) {
      e.onMouseDown?.(t);
      if (!t.defaultPrevented && t.detail > 1) {
        t.preventDefault();
      }
    }
  }} />;
}, `Label`));
var Bc = k.forwardRef(({
  className: e,
  ...t
}, n) => <_Component15 ref={n} className={U(`text-[13px] font-medium leading-none text-foreground/90 peer-disabled:cursor-not-allowed peer-disabled:opacity-70`, e)} {...t} />);
Bc.displayName = _Component15.displayName;
function _Component19({
  label: e,
  htmlFor: t,
  error: n,
  hint: r,
  required: i,
  children: a,
  className: o
}) {
          return <div className={U(`space-y-1.5`, o)}>{e && <Bc htmlFor={t}>{e}{i && <span className={`ml-0.5 text-destructive`}>{`*`}</span>}</Bc>}{a}{n ? <p className={`text-xs text-destructive`}>{n}</p> : r ? <p className={`text-xs text-muted-foreground`}>{r}</p> : null}</div>;
}
function Vc() {
  let {
    escuro: e,
    alternar: t
  } = Xo();
  return <G variant={`ghost`} size={`icon`} onClick={t} aria-label={e ? `Ativar tema claro` : `Ativar tema escuro`} title={e ? `Tema claro` : `Tema escuro`}>{e ? <_Component16 className={`h-4 w-4`} /> : <Fn className={`h-4 w-4`} />}</G>;
}
var Hc = [{
  nome: `Cozinha Gourmet`,
  cota: `2.400 × 2.650 × 600 mm`,
  status: `medicao`
}, {
  nome: `Dormitório Master`,
  cota: `3.150 × 2.700 × 650 mm`,
  status: `projeto_corte`
}, {
  nome: `Painel Home & Estante`,
  cota: `2.200 × 2.400 × 380 mm`,
  status: `montagem`
}];
function Uc() {
              return <div className={`relative mt-8 overflow-hidden rounded-[10px] border border-border bg-card`}><Ls items={[{
      label: `Projetos em linha`,
      value: `12`
    }, {
      label: `Ordens de corte`,
      value: `4`
    }, {
      label: `Entregas da semana`,
      value: `3`
    }]} /><ul className={`divide-y divide-border border-t border-border`}>{Hc.map(e => <li className={`flex items-center justify-between gap-3 px-5 py-3`} key={e.nome}><div className={`min-w-0`}><p className={`truncate text-[13px] font-medium`}>{e.nome}</p><span className={`cota-badge mt-0.5 text-[10px] text-muted-foreground`}>{e.cota}</span></div><Gs label={qr[e.status]} tone={Yr[e.status]} /></li>)}</ul></div>;
}
function Wc({
  children: e
}) {
  return <div className={`min-h-screen lg:grid lg:grid-cols-2`}><main className={`flex min-h-screen flex-col bg-card px-5 py-6 sm:px-8`}><header className={`flex items-center justify-between gap-4`}><div className={`flex items-center gap-2.5`}><img src={`/icon.png`} alt={Ur} className={`h-9 w-9 rounded-lg border border-border bg-card object-contain p-0.5`} /><div className={`flex flex-col`}><span className={`text-[14px] font-bold tracking-tight leading-none`}>{Ur}</span><span className={`text-[10px] font-mono tracking-wider text-muted-foreground`}>{`SISTEMA MARCENARIA`}</span></div></div><Vc /></header><div className={`flex flex-1 items-center justify-center py-10`}><div className={`w-full max-w-[380px]`}>{e}</div></div><footer className={`text-[11px] text-muted-foreground`}>{`© `}{new Date().getFullYear()}{` `}{Ur}</footer></main><aside className={`hidden border-l border-border bg-background lg:block relative overflow-hidden`}><div className="login-aside-bg" style={{ backgroundImage: "url('/marcenaria_luxury_bg.jpg')", opacity: 0.12 }} /><div className="login-aside-overlay" /><div className={`relative z-10 flex h-full flex-col justify-center px-10 xl:px-16`}><div className={`max-w-md`}><h2 className={`titulo login-title text-[28px] font-bold leading-[1.15] text-foreground`}>{`Da medição à entrega, sem planilha.`}</h2></div><p className={`mt-5 max-w-sm login-subtitle text-[14px] font-medium leading-relaxed text-muted-foreground`}>{`Projetos por ambiente, plano de corte, estoque, orçamento e equipe num só lugar.`}</p><Uc /></div></aside></div>;
}
var Gc = [{
  role: `Administrador`,
  descricao: `Acesso total à marcenaria, financeiro e relatórios`,
  email: `admin@planejadospro.com.br`,
  password: `admin`,
  badge: `Admin Geral`,
  icon: _Component95,
  color: `from-amber-500/10 to-orange-500/10 border-amber-500/30 text-amber-600 dark:text-amber-400`
}, {
  role: `Marceneiro`,
  descricao: `Ordens de serviço, corte, montagem e estoque`,
  email: `marceneiro@planejadospro.com.br`,
  password: `admin`,
  badge: `Oficina & Montagem`,
  icon: _Component75,
  color: `from-blue-500/10 to-cyan-500/10 border-blue-500/30 text-blue-600 dark:text-blue-400`
}, {
  role: `Orçamentista`,
  descricao: `3D Designer, clientes, orçamentos e propostas`,
  email: `orcamento@planejadospro.com.br`,
  password: `admin`,
  badge: `Projetos & Vendas`,
  icon: Bt,
  color: `from-emerald-500/10 to-teal-500/10 border-emerald-500/30 text-emerald-600 dark:text-emerald-400`
}];
function Kc() {
  let e = f();
  let t = b();
  let {
    refresh: r
  } = Ct();
  let {
    register: a,
    handleSubmit: o,
    setValue: s,
    formState: {
      errors: c,
      isSubmitting: l
    }
  } = i({
    resolver: n(nc),
    defaultValues: {
      email: ``,
      password: ``
    }
  });
  async function u(n) {
    let {
      error: i
    } = await B.auth.signInWithPassword({
      email: n.email,
      password: n.password
    });
    if (i) {
      N.error(i.message.toLowerCase().includes(`invalid`) ? `E-mail ou senha incorretos.` : i.message);
      return;
    }
    await r();
    N.success(`Bem-vindo ao Planejados Pro DEMO!`);
    e(t.state?.from ?? `/`, {
      replace: true
    });
  }
  function d(e, t) {
    s(`email`, e, {
      shouldValidate: true
    });
    s(`password`, t, {
      shouldValidate: true
    });
    u({
      email: e,
      password: t
    });
  }
  function p() {
    pt();
    N.success(`Base DEMO restaurada com dados de exemplo!`);
  }
                            return <Wc><div className={`mb-6 space-y-1.5`}><div className={`inline-flex items-center gap-1.5 px-2.5 py-0.5 rounded-full text-xs font-medium bg-primary/10 text-primary border border-primary/20 mb-1`}><_Component17 className={`w-3.5 h-3.5`} /><span>{`Versão DEMO 100% Interativa`}</span></div><h1 className={`titulo text-[24px] leading-tight`}>{`Acesse sua conta`}</h1><p className={`text-[13px] text-muted-foreground`}>{`Entre com o e-mail e a senha da marcenaria ou escolha um perfil demo abaixo.`}</p></div><div className={`mb-6 p-3.5 rounded-xl border border-border/80 bg-muted/30 backdrop-blur-sm space-y-2.5`}><div className={`flex items-center justify-between`}><span className={`text-xs font-semibold text-foreground uppercase tracking-wider flex items-center gap-1.5`}><_Component17 className={`w-3.5 h-3.5 text-amber-500`} />{`Acesso Rápido (DEMO)`}</span><button type={`button`} onClick={p} title={`Restaurar dados de demonstração originais`} className={`text-[11px] text-muted-foreground hover:text-foreground flex items-center gap-1 transition-colors`}><Qn className={`w-3 h-3`} />{`Restaurar dados`}</button></div><div className={`grid gap-2`}>{Gc.map(e => {
          let _Component18 = e.icon;
                                                                                                    return <button type={`button`} disabled={l} onClick={() => d(e.email, e.password)} className={`w-full text-left p-2.5 rounded-lg border bg-gradient-to-r transition-all duration-150 hover:scale-[1.01] hover:shadow-sm active:scale-[0.99] flex items-center justify-between group ${e.color}`} key={e.email}><div className={`flex items-center gap-2.5`}><div className={`p-1.5 rounded-md bg-background/80 shadow-xs`}><_Component18 className={`w-4 h-4`} /></div><div><div className={`flex items-center gap-1.5`}><span className={`text-[13px] font-semibold text-foreground group-hover:text-primary transition-colors`}>{e.role}</span><span className={`text-[10px] px-1.5 py-0.2 rounded font-medium bg-background/60 text-muted-foreground`}>{e.badge}</span></div><p className={`text-[11px] text-muted-foreground line-clamp-1`}>{e.email}</p></div></div><span className={`text-[11px] font-medium text-primary opacity-0 group-hover:opacity-100 transition-opacity whitespace-nowrap pl-2`}>{`Entrar →`}</span></button>;
        })}</div></div><form onSubmit={o(u)} className={`space-y-4`}><_Component19 label={`E-mail`} htmlFor={`email`} error={c.email?.message} required={true}><K id={`email`} type={`email`} placeholder={`nome@exemplo.com`} autoComplete={`email`} autoFocus={true} disabled={l} {...a(`email`)} /></_Component19><_Component19 label={`Senha`} htmlFor={`password`} error={c.password?.message} required={true}><Nc id={`password`} autoComplete={`current-password`} disabled={l} {...a(`password`)} /></_Component19><div className={`flex justify-end`}><_ to={`/recuperar-senha`} className={`text-[13px] font-medium underline decoration-border underline-offset-4 transition-colors hover:decoration-foreground`}>{`Esqueceu a senha?`}</_></div><G type={`submit`} className={`w-full`} disabled={l}>{l && <Dn className={`h-4 w-4 animate-spin`} />}{l ? `Entrando...` : `Entrar com e-mail`}</G></form><p className={`mt-6 text-center text-[13px] text-muted-foreground`}>{`Não tem conta?`}{` `}<_ to={`/cadastro`} className={`font-medium underline decoration-border underline-offset-4 hover:decoration-foreground`}>{`Criar marcenaria`}</_></p></Wc>;
}
function _Component107() {
  let e = f();
  let {
    refresh: t
  } = Ct();
  let {
    register: r,
    handleSubmit: a,
    watch: o,
    formState: {
      errors: s,
      isSubmitting: c
    }
  } = i({
    resolver: n(rc),
    defaultValues: {
      full_name: ``,
      tenant_name: ``,
      email: ``,
      password: ``,
      confirmacao: ``
    }
  });
  let l = o(`password`) ?? ``;
  let u = [{
    texto: `Mínimo de 6 caracteres`,
    ok: l.length >= 6
  }, {
    texto: `As senhas coincidem`,
    ok: l.length > 0 && l === o(`confirmacao`)
  }];
  async function d(n) {
    let {
      data: r,
      error: i
    } = await B.functions.invoke(`cadastro`, {
      body: {
        full_name: n.full_name,
        tenant_name: n.tenant_name,
        email: n.email,
        password: n.password
      }
    });
    if (i || r?.error) {
      let e = r?.error ?? i?.message ?? ``;
      N.error(e.includes(`already`) ? `Este e-mail já está cadastrado.` : e || `Erro ao cadastrar`);
      return;
    }
    let {
      error: a
    } = await B.auth.signInWithPassword({
      email: n.email,
      password: n.password
    });
    if (a) {
      N.error(a.message);
      return;
    }
    await t();
    N.success(`Marcenaria criada com sucesso!`);
    e(`/`, {
      replace: true
    });
  }
                    return <Wc><div className={`mb-6 space-y-1.5`}><h1 className={`titulo text-[24px] leading-tight`}>{`Crie sua marcenaria`}</h1><p className={`text-[13px] text-muted-foreground`}>{`Seu espaço de trabalho isolado, pronto em segundos.`}</p></div><form onSubmit={a(d)} className={`space-y-4`}><div className={`grid gap-4 sm:grid-cols-2`}><_Component19 label={`Seu nome`} htmlFor={`full_name`} error={s.full_name?.message} required={true}><K id={`full_name`} autoComplete={`name`} autoFocus={true} disabled={c} {...r(`full_name`)} /></_Component19><_Component19 label={`Marcenaria`} htmlFor={`tenant_name`} error={s.tenant_name?.message} required={true}><K id={`tenant_name`} placeholder={`Ex: Marcenaria Silva`} autoComplete={`organization`} disabled={c} {...r(`tenant_name`)} /></_Component19></div><_Component19 label={`E-mail`} htmlFor={`email`} error={s.email?.message} required={true}><K id={`email`} type={`email`} placeholder={`nome@exemplo.com`} autoComplete={`email`} disabled={c} {...r(`email`)} /></_Component19><div className={`grid gap-4 sm:grid-cols-2`}><_Component19 label={`Senha`} htmlFor={`password`} error={s.password?.message} required={true}><Nc id={`password`} autoComplete={`new-password`} disabled={c} {...r(`password`)} /></_Component19><_Component19 label={`Confirmar`} htmlFor={`confirmacao`} error={s.confirmacao?.message} required={true}><Nc id={`confirmacao`} autoComplete={`new-password`} disabled={c} {...r(`confirmacao`)} /></_Component19></div><ul className={`space-y-1.5 rounded-lg border border-border bg-muted/40 p-3`}>{u.map(e => <li className={`flex items-center gap-2 text-[12px] text-muted-foreground`} key={e.texto}><Kt className={e.ok ? `h-3.5 w-3.5 text-emerald-500` : `h-3.5 w-3.5 text-muted-foreground/50`} />{e.texto}</li>)}</ul><G type={`submit`} className={`w-full`} disabled={c}>{c && <Dn className={`h-4 w-4 animate-spin`} />}{c ? `Criando...` : `Criar conta`}</G></form><p className={`mt-6 text-center text-[13px] text-muted-foreground`}>{`Já tem conta?`}{` `}<_ to={`/login`} className={`font-medium underline decoration-border underline-offset-4 hover:decoration-foreground`}>{`Entrar`}</_></p></Wc>;
}
function Jc() {
  let {
    register: e,
    handleSubmit: t,
    formState: {
      errors: r,
      isSubmitting: a,
      isSubmitSuccessful: o
    }
  } = i({
    resolver: n(ic),
    defaultValues: {
      email: ``
    }
  });
  async function s(e) {
    let {
      error: t
    } = await B.auth.resetPasswordForEmail(e.email, {
      redirectTo: `${window.location.origin}/`
    });
    if (t) {
      N.error(t.message);
      return;
    }
    N.success(`Link de recuperação enviado.`);
  }
  let c = o && !r.email;
                    return <Wc><_ to={`/login`} className={`mb-6 inline-flex items-center gap-1.5 text-[13px] font-medium text-muted-foreground transition-colors duration-150 hover:text-foreground`}><Mt className={`h-3.5 w-3.5`} />{`Voltar ao login`}</_><div className={`mb-6 space-y-1.5`}><h1 className={`titulo text-[24px] leading-tight`}>{`Recuperar senha`}</h1><p className={`text-[13px] text-muted-foreground`}>{`Informe seu e-mail e enviaremos um link de redefinição.`}</p></div>{c ? <div className={`space-y-5`}><div className={`flex gap-3 rounded-lg border border-emerald-500/30 bg-emerald-500/5 p-3.5`}><Kt className={`mt-0.5 h-4 w-4 shrink-0 text-emerald-500`} /><div className={`space-y-1`}><p className={`text-[13px] font-medium`}>{`Link enviado`}</p><p className={`text-[12px] text-muted-foreground`}>{`Se o e-mail existir, as instruções chegam em alguns minutos. Confira também a caixa de spam.`}</p></div></div><G asChild={true} variant={`outline`} className={`w-full`}><_ to={`/login`}>{`Voltar ao login`}</_></G></div> : <form onSubmit={t(s)} className={`space-y-4`} noValidate={true}><_Component19 label={`E-mail`} htmlFor={`email`} error={r.email?.message} required={true}><K id={`email`} type={`email`} placeholder={`nome@exemplo.com`} autoComplete={`email`} autoFocus={true} disabled={a} {...e(`email`)} /></_Component19><G type={`submit`} className={`w-full`} disabled={a}>{a && <Dn className={`h-4 w-4 animate-spin`} />}{a ? `Enviando...` : `Enviar link`}</G></form>}</Wc>;
}
function Yc() {
  let {
    clearRecovery: e
  } = Ct();
  let t = f();
  let {
    register: r,
    handleSubmit: a,
    watch: o,
    formState: {
      errors: s,
      isSubmitting: c
    }
  } = i({
    resolver: n(ac),
    defaultValues: {
      password: ``,
      confirmacao: ``
    }
  });
  let l = o(`password`) ?? ``;
  let u = [{
    texto: `Mínimo de 6 caracteres`,
    ok: l.length >= 6
  }, {
    texto: `As senhas coincidem`,
    ok: l.length > 0 && l === o(`confirmacao`)
  }];
  async function d(n) {
    let {
      error: r
    } = await B.auth.updateUser({
      password: n.password
    });
    if (r) {
      N.error(r.message);
      return;
    }
    e();
    N.success(`Senha redefinida. Use-a para entrar novamente.`);
    t(`/login`, {
      replace: true
    });
  }
              return <Wc><div className={`mb-6 space-y-1.5`}><h1 className={`titulo text-[24px] leading-tight`}>{`Definir nova senha`}</h1><p className={`text-[13px] text-muted-foreground`}>{`Escolha uma senha forte para a sua conta.`}</p></div><form onSubmit={a(d)} className={`space-y-4`}><_Component19 label={`Nova senha`} htmlFor={`password`} error={s.password?.message} required={true}><Nc id={`password`} autoComplete={`new-password`} autoFocus={true} disabled={c} {...r(`password`)} /></_Component19><_Component19 label={`Confirmar senha`} htmlFor={`confirmacao`} error={s.confirmacao?.message} required={true}><Nc id={`confirmacao`} autoComplete={`new-password`} disabled={c} {...r(`confirmacao`)} /></_Component19><ul className={`space-y-1.5 rounded-lg border border-border bg-muted/40 p-3`}>{u.map(e => <li className={`flex items-center gap-2 text-[12px] text-muted-foreground`} key={e.texto}><Kt className={e.ok ? `h-3.5 w-3.5 text-emerald-500` : `h-3.5 w-3.5 text-muted-foreground/50`} />{e.texto}</li>)}</ul><G type={`submit`} className={`w-full`} disabled={c}>{c && <Dn className={`h-4 w-4 animate-spin`} />}{c ? `Salvando...` : `Salvar nova senha`}</G></form></Wc>;
}
function Xc() {
  let {
    signOut: e
  } = Ct();
  let t = f();
            return <div className={`grid min-h-screen place-items-center bg-muted/30 px-4`}><Rs className={`w-full max-w-md p-6 text-center`}><div className={`mx-auto grid h-11 w-11 place-items-center rounded-full bg-destructive/10 text-destructive`}><_Component20 className={`h-5 w-5`} /></div><h1 className={`mt-4 text-[15px] font-semibold tracking-tight`}>{`Não foi possível validar seu acesso`}</h1><p className={`mt-1 text-[13px] text-muted-foreground`}>{`A sessão pode ter expirado ou o seu perfil ainda não está vinculado a uma marcenaria.`}</p><div className={`mt-5 flex flex-col gap-2 sm:flex-row sm:justify-center`}><G onClick={() => t(`/`)}><Xn className={`h-4 w-4`} />{`Tentar novamente`}</G><G variant={`outline`} onClick={() => void e()}><An className={`h-4 w-4`} />{`Sair da conta`}</G></div></Rs></div>;
}
function Zc() {
    return <div className={`py-12`}><Ws icon={<Qt className={`h-5 w-5`} />} title={`Página não encontrada`} description={`O endereço acessado não existe ou foi movido.`} action={<G asChild={true}><_ to={`/`}>{`Voltar ao painel`}</_></G>} /></div>;
}
async function Qc(e) {
  let t = B.from(`clientes`).select(`*`).order(`nome`, {
    ascending: true
  });
  if (e && e.trim().length > 0) {
    let n = e.trim().replace(/[%,]/g, ``);
    t = t.or(`nome.ilike.%${n}%,email.ilike.%${n}%,telefone.ilike.%${n}%`);
  }
  let {
    data: n,
    error: r
  } = await t;
  if (r) {
    throw r;
  }
  return n ?? [];
}
async function $c(e) {
  let {
    data: t,
    error: n
  } = await B.from(`clientes`).select(`*`).eq(`id`, e).single();
  if (n) {
    throw n;
  }
  return t;
}
async function el(e, t) {
  let {
    data: n,
    error: r
  } = await B.from(`clientes`).insert({
    ...e,
    created_by: t
  }).select(`*`).single();
  if (r) {
    throw r;
  }
  return n;
}
async function tl(e, t) {
  let {
    data: n,
    error: r
  } = await B.from(`clientes`).update(t).eq(`id`, e).select(`*`).single();
  if (r) {
    throw r;
  }
  return n;
}
async function nl(e) {
  let {
    error: t
  } = await B.from(`clientes`).delete().eq(`id`, e);
  if (t) {
    throw t;
  }
}
function rl(e) {
  return T({
    queryKey: H.clientes(e),
    queryFn: () => Qc(e)
  });
}
function il(e) {
  return T({
    queryKey: [`cliente`, e],
    queryFn: () => $c(e),
    enabled: !!e
  });
}
function al() {
  let e = C();
  let {
    user: t
  } = Ct();
  return O({
    mutationFn: e => el(e, t?.id ?? ``),
    onSuccess: () => {
      e.invalidateQueries({
        queryKey: [`clientes`]
      });
      e.invalidateQueries({
        queryKey: H.dashboard
      });
      N.success(`Cliente cadastrado.`);
    },
    onError: e => N.error(e.message)
  });
}
function ol() {
  let e = C();
  return O({
    mutationFn: ({
      id: e,
      payload: t
    }) => tl(e, t),
    onSuccess: (t, n) => {
      e.invalidateQueries({
        queryKey: [`clientes`]
      });
      e.invalidateQueries({
        queryKey: [`cliente`, n.id]
      });
      N.success(`Cliente atualizado.`);
    },
    onError: e => N.error(e.message)
  });
}
function sl() {
  let e = C();
  return O({
    mutationFn: e => nl(e),
    onSuccess: () => {
      e.invalidateQueries({
        queryKey: [`clientes`]
      });
      e.invalidateQueries({
        queryKey: [`projetos`]
      });
      e.invalidateQueries({
        queryKey: H.dashboard
      });
      N.success(`Cliente removido.`);
    },
    onError: e => N.error(e.message)
  });
}
var _Component28 = k.forwardRef(({
  className: e,
  ...t
}, n) => <div className={`relative w-full overflow-x-auto`}><table ref={n} className={U(`w-full caption-bottom text-[13px]`, e)} {...t} /></div>);
_Component28.displayName = `Table`;
var _Component25 = k.forwardRef(({
  className: e,
  ...t
}, n) => <thead ref={n} className={U(`border-b border-border bg-muted/40`, e)} {...t} />);
_Component25.displayName = `TableHeader`;
var _Component27 = k.forwardRef(({
  className: e,
  ...t
}, n) => <tbody ref={n} className={U(`divide-y divide-border`, e)} {...t} />);
_Component27.displayName = `TableBody`;
var _Component24 = k.forwardRef(({
  className: e,
  ...t
}, n) => <tr ref={n} className={U(`transition-colors duration-150 hover:bg-accent/40 data-[state=selected]:bg-accent/60`, e)} {...t} />);
_Component24.displayName = `TableRow`;
var J = k.forwardRef(({
  className: e,
  ...t
}, n) => <th ref={n} className={U(`h-9 whitespace-nowrap px-4 text-left align-middle text-[12px] font-medium text-muted-foreground`, e)} {...t} />);
J.displayName = `TableHead`;
var Y = k.forwardRef(({
  className: e,
  ...t
}, n) => <td ref={n} className={U(`px-4 py-3 align-middle`, e)} {...t} />);
Y.displayName = `TableCell`;
function _Component23(e) {
  return null;
}
var pl = {
  sm: `max-w-sm`,
  md: `max-w-lg`,
  lg: `max-w-2xl`,
  xl: `max-w-4xl`
};
function _Component21({
  open: e,
  onOpenChange: t,
  title: n,
  description: r,
  children: i,
  footer: a,
  size: o = `md`,
  contentClassName: s
}) {
  let c = (0, k.useRef)(null);
  (0, k.useEffect)(() => {
    let t = c.current;
    if (t) {
      if (e && !t.open) {
        t.showModal();
      }
      if (!e && t.open) {
        t.close();
      }
    }
  }, [e]);
                    return <dialog ref={c} onCancel={e => {
    e.preventDefault();
    t(false);
  }} onClick={e => {
    if (e.target === e.currentTarget) {
      t(false);
    }
  }} className={U(`m-auto w-[calc(100vw-2rem)] animate-scale-in rounded-[10px] border border-border bg-card p-0 text-card-foreground shadow-xl`, pl[o])}><div className={U(`flex flex-col`, s)}><div className={`flex items-start justify-between gap-4 border-b border-border px-5 py-4`}><div className={`min-w-0 space-y-1`}><h2 className={`titulo text-[16px] leading-tight`}>{n}</h2>{r && <p className={`text-[13px] text-muted-foreground`}>{r}</p>}</div><button type={`button`} onClick={() => t(false)} className={`-mr-1 rounded-md p-1.5 text-muted-foreground transition-colors duration-150 hover:bg-accent hover:text-foreground`} aria-label={`Fechar`}><Dr className={`h-4 w-4`} /></button></div><div className={`max-h-[70vh] overflow-y-auto p-5`}>{i}</div>{a && <div className={`flex justify-end gap-2 rounded-b-[10px] border-t border-border bg-muted/40 px-4 py-3`}>{a}</div>}</div></dialog>;
}
function _Component29({
  open: e,
  onOpenChange: t,
  title: n,
  description: r,
  confirmLabel: i = `Confirmar`,
  onConfirm: a,
  destructive: o = true
}) {
  let [s, c] = (0, k.useState)(false);
  async function l() {
    c(true);
    try {
      await a();
      t(false);
    } finally {
      c(false);
    }
  }
    return <_Component21 open={e} onOpenChange={t} title={n} description={r} size={`sm`} footer={<L.Fragment><G variant={`outline`} onClick={() => t(false)} disabled={s}>{`Cancelar`}</G><G variant={o ? `destructive` : `default`} onClick={l} disabled={s}>{s ? `Processando...` : i}</G></L.Fragment>}><p className={`text-sm text-muted-foreground`}>{`Esta ação não pode ser desfeita.`}</p></_Component21>;
}
var gl = e => {
  let t = e.trim();
  if (t === ``) {
    return null;
  } else {
    return t;
  }
};
var _l = e => Ys(e);
var vl = e => e.trim() === `` ? null : Ys(e);
var yl = e => e.trim() === `` ? 0 : Math.trunc(Ys(e));
var bl = e => e === `` ? null : e;
function xl(e) {
  return {
    nome: e.nome,
    documento: gl(e.documento),
    email: gl(e.email),
    telefone: gl(e.telefone),
    endereco: gl(e.endereco),
    cidade: gl(e.cidade),
    uf: e.uf ? e.uf.toUpperCase() : null,
    cep: gl(e.cep),
    observacoes: gl(e.observacoes)
  };
}
function Sl(e) {
  return {
    cliente_id: e.cliente_id,
    nome: e.nome,
    descricao: gl(e.descricao),
    status: e.status,
    prioridade: Number(e.prioridade),
    data_inicio: gl(e.data_inicio),
    data_entrega_prevista: gl(e.data_entrega_prevista),
    termos_contrato: gl(e.termos_contrato)
  };
}
function Cl(e) {
  return {
    nome: e.nome,
    tipo: e.tipo,
    margem_percent: _l(e.margem_percent),
    observacoes: gl(e.observacoes)
  };
}
function wl(e, t) {
  return {
    projeto_id: t,
    nome: e.nome,
    tipo: e.tipo,
    margem_percent: _l(e.margem_percent),
    altura_cm: vl(e.altura_cm),
    largura_cm: vl(e.largura_cm),
    profundidade_cm: vl(e.profundidade_cm),
    observacoes: gl(e.observacoes)
  };
}
function Tl(e) {
  return {
    altura_cm: vl(e.altura_cm),
    largura_cm: vl(e.largura_cm),
    profundidade_cm: vl(e.profundidade_cm),
    desnivel_cm: vl(e.desnivel_cm),
    pontos_eletricos: yl(e.pontos_eletricos),
    pontos_hidraulicos: yl(e.pontos_hidraulicos),
    colunas_vigas: gl(e.colunas_vigas),
    observacoes: gl(e.observacoes)
  };
}
function El(e) {
  return {
    elevador_tamanho: gl(e.elevador_tamanho),
    elevador_ok: e.elevador_ok,
    tem_escada: e.tem_escada,
    escada_observacoes: gl(e.escada_observacoes),
    estacionamento: gl(e.estacionamento),
    horario_permitido: gl(e.horario_permitido),
    restricoes_condominio: gl(e.restricoes_condominio),
    acesso_observacoes: gl(e.acesso_observacoes),
    concluido: e.concluido
  };
}
function Dl(e) {
  return {
    categoria: e.categoria,
    nome: e.nome,
    codigo: gl(e.codigo),
    descricao: gl(e.descricao),
    unidade: e.unidade,
    cor: gl(e.cor),
    espessura_mm: vl(e.espessura_mm),
    acabamento: gl(e.acabamento),
    custo_unitario: _l(e.custo_unitario),
    preco_unitario: _l(e.preco_unitario),
    estoque_minimo: _l(e.estoque_minimo),
    estoque_atual: _l(e.estoque_atual),
    ativo: e.ativo
  };
}
function Ol(e) {
  return {
    nome: e.nome,
    material_id: bl(e.material_id),
    tipo_chapa: e.tipo_chapa,
    espessura_mm: _l(e.espessura_mm),
    comprimento_cm: _l(e.comprimento_cm),
    largura_cm: _l(e.largura_cm),
    quantidade: Math.trunc(_l(e.quantidade)),
    sentido_veio: e.sentido_veio,
    fita_tipo: e.fita_tipo,
    borda_topo: e.borda_topo,
    borda_base: e.borda_base,
    borda_esquerda: e.borda_esquerda,
    borda_direita: e.borda_direita
  };
}
function kl(e) {
  return {
    material_id: e.material_id,
    projeto_id: bl(e.projeto_id),
    largura_cm: _l(e.largura_cm),
    altura_cm: _l(e.altura_cm),
    espessura_mm: vl(e.espessura_mm),
    quantidade: Math.trunc(_l(e.quantidade)),
    local: gl(e.local),
    observacoes: gl(e.observacoes),
    consumido: e.consumido
  };
}
function Al(e) {
  return {
    projeto_id: e.projeto_id,
    status: e.status,
    data_prevista_entrega: gl(e.data_prevista_entrega),
    montador_id: bl(e.montador_id),
    frete: _l(e.frete),
    montagem_horas: _l(e.montagem_horas),
    observacoes: gl(e.observacoes)
  };
}
function jl(e) {
  return {
    name: e.name,
    documento: gl(e.documento),
    telefone: gl(e.telefone),
    email: gl(e.email),
    endereco: gl(e.endereco),
    cidade: gl(e.cidade),
    uf: e.uf ? e.uf.toUpperCase() : null,
    cep: gl(e.cep),
    termos_contrato: gl(e.termos_contrato),
    faturamento_email: gl(e.faturamento_email),
    faturamento_documento: gl(e.faturamento_documento)
  };
}
function Ml(e) {
  return {
    full_name: e.full_name,
    telefone: gl(e.telefone)
  };
}
function Nl(e) {
  return {
    _projeto_id: e.projeto_id,
    _cliente_id: e.cliente_id,
    _orcamento_id: bl(e.orcamento_id),
    _valor_total: _l(e.valor_total),
    _num_parcelas: Math.trunc(_l(e.num_parcelas)),
    _primeiro_vencimento: gl(e.primeiro_vencimento),
    _intervalo_dias: Math.trunc(_l(e.intervalo_dias)),
    _conteudo: gl(e.conteudo),
    _termos: gl(e.termos),
    _observacoes: gl(e.observacoes)
  };
}
function Pl(e) {
  return {
    nome: e.nome,
    documento: gl(e.documento),
    email: gl(e.email),
    telefone: gl(e.telefone),
    endereco: gl(e.endereco),
    cidade: gl(e.cidade),
    uf: e.uf ? e.uf.toUpperCase() : null,
    cep: gl(e.cep),
    observacoes: gl(e.observacoes)
  };
}
function Fl(e) {
  return {
    nome: e.nome,
    tipo: e.tipo,
    cor: gl(e.cor),
    ativo: e.ativo
  };
}
function Il(e) {
  return {
    tipo: e.tipo,
    descricao: e.descricao,
    valor: _l(e.valor),
    vencimento: gl(e.vencimento),
    categoria_id: bl(e.categoria_id),
    fornecedor_id: bl(e.fornecedor_id),
    cliente_id: bl(e.cliente_id),
    projeto_id: bl(e.projeto_id),
    forma_pagamento: e.forma_pagamento === `` ? null : e.forma_pagamento,
    observacoes: gl(e.observacoes)
  };
}
function Ll(e) {
  let t = e.registrar_pagamento;
  let n = new Date().toISOString();
  return {
    tipo: e.tipo,
    status: t ? `pago` : `previsto`,
    origem: `manual`,
    descricao: e.descricao,
    valor: _l(e.valor),
    vencimento: gl(e.vencimento),
    categoria_id: bl(e.categoria_id),
    fornecedor_id: bl(e.fornecedor_id),
    cliente_id: bl(e.cliente_id),
    projeto_id: bl(e.projeto_id),
    forma_pagamento: e.forma_pagamento === `` ? null : e.forma_pagamento,
    observacoes: gl(e.observacoes),
    valor_pago: t ? _l(e.valor) : null,
    pago_em: t ? n : null
  };
}
var Rl = k.forwardRef(({
  className: e,
  ...t
}, n) => <textarea ref={n} className={U(`flex min-h-[76px] w-full resize-y rounded-md border border-input bg-background px-3 py-2 text-sm text-foreground transition-[border-color,box-shadow] duration-150 placeholder:text-muted-foreground focus-visible:border-ring focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring/35 disabled:cursor-not-allowed disabled:bg-muted/60 disabled:opacity-70`, e)} {...t} />);
Rl.displayName = `Textarea`;
var zl = {
  nome: ``,
  documento: ``,
  email: ``,
  telefone: ``,
  endereco: ``,
  cidade: ``,
  uf: ``,
  cep: ``,
  observacoes: ``
};
function Bl({
  open: e,
  onOpenChange: t,
  cliente: r
}) {
  let a = al();
  let o = ol();
  let {
    register: s,
    handleSubmit: c,
    reset: l,
    formState: {
      errors: u,
      isSubmitting: d
    }
  } = i({
    resolver: n(oc),
    defaultValues: zl
  });
  (0, k.useEffect)(() => {
    if (e) {
      l(r ? {
        nome: r.nome,
        documento: r.documento ?? ``,
        email: r.email ?? ``,
        telefone: r.telefone ?? ``,
        endereco: r.endereco ?? ``,
        cidade: r.cidade ?? ``,
        uf: r.uf ?? ``,
        cep: r.cep ?? ``,
        observacoes: r.observacoes ?? ``
      } : zl);
    }
  }, [e, r, l]);
  async function f(e) {
    let n = xl(e);
    if (r) {
      await o.mutateAsync({
        id: r.id,
        payload: n
      });
    } else {
      await a.mutateAsync(n);
    }
    t(false);
  }
      return <_Component21 open={e} onOpenChange={t} title={r ? `Editar cliente` : `Novo cliente`} description={`Dados de contato e endereço do imóvel.`} size={`lg`} footer={<L.Fragment><G variant={`outline`} onClick={() => t(false)} disabled={d}>{`Cancelar`}</G><G form={`cliente-form`} type={`submit`} disabled={d}>{d ? `Salvando...` : `Salvar`}</G></L.Fragment>}><form id={`cliente-form`} onSubmit={c(f)} className={`grid gap-4 sm:grid-cols-2`}><_Component19 label={`Nome`} htmlFor={`nome`} error={u.nome?.message} required={true} className={`sm:col-span-2`}><K id={`nome`} {...s(`nome`)} /></_Component19><_Component19 label={`CPF/CNPJ`} htmlFor={`documento`} error={u.documento?.message}><K id={`documento`} {...s(`documento`)} /></_Component19><_Component19 label={`Telefone`} htmlFor={`telefone`} error={u.telefone?.message}><K id={`telefone`} placeholder={`(11) 99999-9999`} {...s(`telefone`)} /></_Component19><_Component19 label={`E-mail`} htmlFor={`email`} error={u.email?.message} className={`sm:col-span-2`}><K id={`email`} type={`email`} {...s(`email`)} /></_Component19><_Component19 label={`Endereço da montagem`} htmlFor={`endereco`} error={u.endereco?.message} className={`sm:col-span-2`}><K id={`endereco`} {...s(`endereco`)} /></_Component19><_Component19 label={`Cidade`} htmlFor={`cidade`} error={u.cidade?.message}><K id={`cidade`} {...s(`cidade`)} /></_Component19><div className={`grid grid-cols-2 gap-4`}><_Component19 label={`UF`} htmlFor={`uf`} error={u.uf?.message}><K id={`uf`} maxLength={2} {...s(`uf`)} /></_Component19><_Component19 label={`CEP`} htmlFor={`cep`} error={u.cep?.message}><K id={`cep`} {...s(`cep`)} /></_Component19></div><_Component19 label={`Observações`} htmlFor={`observacoes`} error={u.observacoes?.message} className={`sm:col-span-2`}><Rl id={`observacoes`} rows={3} {...s(`observacoes`)} /></_Component19></form></_Component21>;
}
function Vl() {
  let e = f();
  let [t, n] = (0, k.useState)(``);
  let [r, i] = S();
  let [a, o] = (0, k.useState)(r.get(`novo`) === `1`);
  let [s, c] = (0, k.useState)(null);
  let [l, u] = (0, k.useState)(null);
  let {
    data: d,
    isLoading: p
  } = rl(t);
  let m = sl();
  function h() {
    c(null);
    o(true);
    if (r.has(`novo`)) {
      r.delete(`novo`);
      i(r, {
        replace: true
      });
    }
  }
        return <div className={`space-y-6`}><Fs title={`Clientes`} description={`Cadastro, contato e histórico de cada cliente.`} actions={<G onClick={h}><_Component10 className={`h-4 w-4`} />{`Novo cliente`}</G>}><div className={`relative max-w-sm`}><_Component22 className={`pointer-events-none absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-muted-foreground`} /><K value={t} onChange={e => n(e.target.value)} placeholder={`Buscar por nome, e-mail ou telefone`} className={`pl-9`} /></div></Fs>{p ? <_Component23 columns={4} /> : d && d.length > 0 ? <Rs className={`overflow-hidden`}><_Component28><_Component25><_Component24><J>{`Nome`}</J><J className={`hidden md:table-cell`}>{`Documento`}</J><J className={`hidden md:table-cell`}>{`Telefone`}</J><J className={`hidden lg:table-cell`}>{`Cidade`}</J><J className={`w-12 text-right`}>{`Ações`}</J></_Component24></_Component25><_Component27>{d.map(t => <_Component24 key={t.id}><Y><_ to={`/clientes/${t.id}`} className={`font-medium hover:underline`}>{t.nome}</_><p className={`text-xs text-muted-foreground`}>{t.email ?? `Sem e-mail`}</p></Y><Y className={`hidden md:table-cell text-muted-foreground`}>{ao(t.documento)}</Y><Y className={`hidden md:table-cell text-muted-foreground`}>{oo(t.telefone)}</Y><Y className={`hidden lg:table-cell text-muted-foreground`}>{t.cidade ?? `-`}</Y><Y className={`text-right`}><Lo items={[{
                label: `Ver ficha`,
                icon: <_Component13 className={`h-4 w-4`} />,
                onSelect: () => {
                  e(`/clientes/${t.id}`);
                }
              }, {
                label: `Editar`,
                icon: <Wn className={`h-4 w-4`} />,
                onSelect: () => {
                  c(t);
                  o(true);
                }
              }, {
                label: `Remover`,
                icon: <_Component26 className={`h-4 w-4`} />,
                destructive: true,
                onSelect: () => u(t)
              }]} /></Y></_Component24>)}</_Component27></_Component28></Rs> : <Ws icon={<Cr className={`h-8 w-8`} />} title={`Nenhum cliente cadastrado`} description={`Cadastre o primeiro cliente para iniciar um projeto.`} action={<G onClick={h}><_Component10 className={`h-4 w-4`} />{`Novo cliente`}</G>} />}<Bl open={a} onOpenChange={o} cliente={s} /><_Component29 open={!!l} onOpenChange={e => !e && u(null)} title={`Remover cliente`} description={l ? `Remover ${l.nome} e todos os projetos vinculados?` : undefined} confirmLabel={`Remover`} onConfirm={async () => {
      if (l) {
        await m.mutateAsync(l.id);
      }
    }} /></div>;
}
async function Hl(e) {
  let t = B.from(`projetos`).select(`*, cliente:clientes(id,nome,telefone), ambientes(count)`).order(`updated_at`, {
    ascending: false
  });
  if (e?.status && e.status !== `todos`) {
    t = t.eq(`status`, e.status);
  }
  if (e?.clienteId) {
    t = t.eq(`cliente_id`, e.clienteId);
  }
  if (e?.busca && e.busca.trim().length > 0) {
    let n = e.busca.trim().replace(/[%,]/g, ``);
    t = t.ilike(`nome`, `%${n}%`);
  }
  let {
    data: n,
    error: r
  } = await t;
  if (r) {
    throw r;
  }
  return (n ?? []).map(e => {
    let {
      ambientes: t,
      ...n
    } = e;
    return {
      ...n,
      total_ambientes: t?.[0]?.count ?? 0
    };
  });
}
async function Ul(e) {
  let {
    data: t,
    error: n
  } = await B.from(`projetos`).select(`*, cliente:clientes(*), ambientes(*)`).eq(`id`, e).order(`ordem`, {
    referencedTable: `ambientes`,
    ascending: true
  }).single();
  if (n) {
    throw n;
  }
  return t;
}
async function Wl(e, t) {
  let {
    data: n,
    error: r
  } = await B.from(`projetos`).insert({
    ...e,
    created_by: t
  }).select(`*`).single();
  if (r) {
    throw r;
  }
  return n;
}
async function Gl(e, t) {
  let {
    data: n,
    error: r
  } = await B.from(`projetos`).update(t).eq(`id`, e).select(`*`).single();
  if (r) {
    throw r;
  }
  return n;
}
async function Kl(e, t) {
  let {
    error: n
  } = await B.from(`projetos`).update({
    status: t
  }).eq(`id`, e);
  if (n) {
    throw n;
  }
}
async function ql(e) {
  let {
    error: t
  } = await B.from(`projetos`).delete().eq(`id`, e);
  if (t) {
    throw t;
  }
}
function Jl(e) {
  return T({
    queryKey: H.projetos(e),
    queryFn: () => Hl(e)
  });
}
function Yl(e) {
  return T({
    queryKey: H.projeto(e ?? ``),
    queryFn: () => Ul(e),
    enabled: !!e
  });
}
function Xl() {
  let e = C();
  let {
    user: t
  } = Ct();
  return O({
    mutationFn: e => Wl(e, t?.id ?? ``),
    onSuccess: () => {
      e.invalidateQueries({
        queryKey: [`projetos`]
      });
      e.invalidateQueries({
        queryKey: H.dashboard
      });
      N.success(`Projeto criado.`);
    },
    onError: e => N.error(e.message)
  });
}
function Zl(e) {
  let t = C();
  return O({
    mutationFn: t => Gl(e, t),
    onSuccess: () => {
      t.invalidateQueries({
        queryKey: [`projetos`]
      });
      t.invalidateQueries({
        queryKey: H.projeto(e ?? ``)
      });
      t.invalidateQueries({
        queryKey: H.dashboard
      });
      N.success(`Projeto atualizado.`);
    },
    onError: e => N.error(e.message)
  });
}
function Ql() {
  let e = C();
  return O({
    mutationFn: ({
      id: e,
      status: t
    }) => Kl(e, t),
    onSuccess: (t, n) => {
      e.invalidateQueries({
        queryKey: [`projetos`]
      });
      e.invalidateQueries({
        queryKey: H.projeto(n.id)
      });
      e.invalidateQueries({
        queryKey: H.dashboard
      });
      N.success(`Status atualizado.`);
    },
    onError: e => N.error(e.message)
  });
}
function $l() {
  let e = C();
  return O({
    mutationFn: e => ql(e),
    onSuccess: () => {
      e.invalidateQueries({
        queryKey: [`projetos`]
      });
      e.invalidateQueries({
        queryKey: H.dashboard
      });
      N.success(`Projeto removido.`);
    },
    onError: e => N.error(e.message)
  });
}
function _Component30({
  label: e,
  value: t
}) {
        return <div className={`flex flex-col`}><span className={`text-[11px] font-medium text-muted-foreground`}>{e}</span><span className={`text-sm`}>{t || `-`}</span></div>;
}
function _Component100() {
  let {
    id: e
  } = g();
  let t = f();
  let [n, r] = (0, k.useState)(false);
  let {
    data: i,
    isLoading: a
  } = il(e);
  let {
    data: o,
    isLoading: s
  } = Jl({
    clienteId: e
  });
  if (a) {
    return <Ks className={`h-64`} />;
  } else if (i) {
                                                return <div className={`space-y-6`}><Fs title={i.nome} description={`Ficha do cliente e projetos vinculados.`} actions={<L.Fragment><G variant={`outline`} onClick={() => t(`/clientes`)}><Mt className={`h-4 w-4`} />{`Voltar`}</G><G onClick={() => r(true)}><Wn className={`h-4 w-4`} />{`Editar`}</G></L.Fragment>} /><Rs><_Component11><Bs className={`text-base`}>{`Dados de contato`}</Bs></_Component11><Hs className={`grid gap-4 sm:grid-cols-3`}><_Component30 label={`Documento`} value={ao(i.documento)} /><_Component30 label={`Telefone`} value={oo(i.telefone)} /><_Component30 label={`E-mail`} value={i.email} /><_Component30 label={`Endereço`} value={i.endereco} /><_Component30 label={`Cidade`} value={[i.cidade, i.uf].filter(Boolean).join(` / `)} /><_Component30 label={`CEP`} value={so(i.cep)} />{i.observacoes && <div className={`sm:col-span-3`}><span className={`text-[11px] font-medium text-muted-foreground`}>{`Observações`}</span><p className={`whitespace-pre-line text-sm`}>{i.observacoes}</p></div>}</Hs></Rs><div className={`flex items-center justify-between`}><h2 className={`text-lg font-semibold`}>{`Projetos`}</h2><G variant={`outline`} onClick={() => t(`/projetos?novo=1`)}><_Component10 className={`h-4 w-4`} />{`Novo projeto`}</G></div>{s ? <Ks className={`h-40`} /> : o && o.length > 0 ? <div className={`grid gap-4 sm:grid-cols-2`}>{o.map(e => <_ to={`/projetos/${e.id}`} key={e.id}><Rs className={`h-full p-4 transition-colors hover:border-primary/40`}><div className={`flex items-start justify-between gap-3`}><div><p className={`font-medium`}>{e.nome}</p><p className={`text-xs text-muted-foreground`}>{e.total_ambientes}{` ambiente(s)`}</p></div><Gs label={qr[e.status]} tone={Yr[e.status]} /></div></Rs></_>)}</div> : <Ws icon={<_Component4 className={`h-8 w-8`} />} title={`Sem projetos para este cliente`} description={`Crie um projeto para organizar ambientes, medidas e produção.`} />}<Bl open={n} onOpenChange={r} cliente={i} /></div>;
  } else {
    return <Ws title={`Cliente não encontrado`} action={<G variant={`outline`} onClick={() => t(`/clientes`)}><Mt className={`h-4 w-4`} />{`Voltar`}</G>} />;
  }
}
function _Component32({
  tabs: e,
  value: t,
  onValueChange: n,
  className: r
}) {
    return <div role={`tablist`} className={U(`flex w-full flex-wrap items-end gap-x-4 gap-y-1 border-b border-border`, r)}>{e.map(e => {
      let r = t === e.value;
                  return <button role={`tab`} type={`button`} aria-selected={r} onClick={() => n(e.value)} className={U(`-mb-px inline-flex shrink-0 items-center gap-1.5 whitespace-nowrap border-b-2 px-0.5 pb-2 text-[13px] font-medium transition-colors duration-150`, r ? `border-foreground text-foreground` : `border-transparent text-muted-foreground hover:text-foreground`)} key={e.value}>{e.label}{e.count !== undefined && <span className={U(`rounded-[4px] px-1.5 text-[11px] tabular-nums leading-4`, r ? `bg-muted text-foreground` : `bg-muted text-muted-foreground`)}>{e.count}</span>}</button>;
    })}</div>;
}
var _Component31 = k.forwardRef(({
  className: e,
  wrapperClassName: t,
  children: n,
  ...r
}, i) => <div className={U(`relative`, t)}><select ref={i} className={U(`flex h-9 w-full appearance-none rounded-md border border-input bg-background px-3 py-1 pr-8 text-sm text-foreground transition-[border-color,box-shadow] duration-150 focus-visible:border-ring focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring/35 disabled:cursor-not-allowed disabled:bg-muted/60 disabled:text-muted-foreground disabled:opacity-70`, e)} {...r}>{n}</select><Wt className={`pointer-events-none absolute right-2.5 top-1/2 h-3.5 w-3.5 -translate-y-1/2 text-muted-foreground`} /></div>);
_Component31.displayName = `Select`;
function iu(e, t) {
  return {
    cliente_id: e?.cliente_id ?? t ?? ``,
    nome: e?.nome ?? ``,
    descricao: e?.descricao ?? ``,
    status: e?.status ?? `medicao`,
    prioridade: String(e?.prioridade ?? 2),
    data_inicio: e?.data_inicio ?? ``,
    data_entrega_prevista: e?.data_entrega_prevista ?? ``,
    termos_contrato: e?.termos_contrato ?? ci
  };
}
function _Component33({
  open: e,
  onOpenChange: t,
  projeto: r,
  clientePadrao: a
}) {
  let o = Xl();
  let s = Zl(r?.id);
  let {
    data: c
  } = rl();
  let {
    register: l,
    handleSubmit: u,
    reset: d,
    formState: {
      errors: f,
      isSubmitting: p
    }
  } = i({
    resolver: n(sc),
    defaultValues: iu(r, a)
  });
  (0, k.useEffect)(() => {
    if (e) {
      d(iu(r, a));
    }
  }, [e, r, a, d]);
  async function m(e) {
    let n = Sl(e);
    if (r) {
      await s.mutateAsync(n);
    } else {
      await o.mutateAsync(n);
    }
    t(false);
  }
                return <_Component21 open={e} onOpenChange={t} title={r ? `Editar projeto` : `Novo projeto`} description={`Status do pedido, prazos e termos contratuais.`} size={`lg`} footer={<L.Fragment><G variant={`outline`} onClick={() => t(false)} disabled={p}>{`Cancelar`}</G><G form={`projeto-form`} type={`submit`} disabled={p}>{p ? `Salvando...` : `Salvar`}</G></L.Fragment>}><form id={`projeto-form`} onSubmit={u(m)} className={`grid gap-4 sm:grid-cols-2`}><_Component19 label={`Cliente`} htmlFor={`cliente_id`} error={f.cliente_id?.message} required={true} className={`sm:col-span-2`}><_Component31 id={`cliente_id`} {...l(`cliente_id`)}><option value={``}>{`Selecione um cliente`}</option>{(c ?? []).map(e => <option value={e.id} key={e.id}>{e.nome}</option>)}</_Component31></_Component19><_Component19 label={`Nome do projeto`} htmlFor={`nome`} error={f.nome?.message} required={true} className={`sm:col-span-2`}><K id={`nome`} {...l(`nome`)} /></_Component19><_Component19 label={`Status`} htmlFor={`status`} error={f.status?.message}><_Component31 id={`status`} {...l(`status`)}>{Object.keys(qr).map(e => <option value={e} key={e}>{qr[e]}</option>)}</_Component31></_Component19><_Component19 label={`Prioridade`} htmlFor={`prioridade`} error={f.prioridade?.message}><_Component31 id={`prioridade`} {...l(`prioridade`)}><option value={`1`}>{`Alta`}</option><option value={`2`}>{`Média`}</option><option value={`3`}>{`Baixa`}</option></_Component31></_Component19><_Component19 label={`Início`} htmlFor={`data_inicio`} error={f.data_inicio?.message}><K id={`data_inicio`} type={`date`} {...l(`data_inicio`)} /></_Component19><_Component19 label={`Entrega prevista`} htmlFor={`data_entrega_prevista`} error={f.data_entrega_prevista?.message}><K id={`data_entrega_prevista`} type={`date`} {...l(`data_entrega_prevista`)} /></_Component19><_Component19 label={`Descrição`} htmlFor={`descricao`} error={f.descricao?.message} className={`sm:col-span-2`}><Rl id={`descricao`} rows={2} {...l(`descricao`)} /></_Component19><_Component19 label={`Termos contratuais padrão`} htmlFor={`termos_contrato`} error={f.termos_contrato?.message} className={`sm:col-span-2`}><Rl id={`termos_contrato`} rows={4} {...l(`termos_contrato`)} /></_Component19></form></_Component21>;
}
function _Component101() {
  let e = f();
  let [t, n] = S();
  let r = t.get(`cliente`) ?? undefined;
  let [i, a] = (0, k.useState)(``);
  let [o, s] = (0, k.useState)(`todos`);
  let [c, l] = (0, k.useState)(t.get(`novo`) === `1`);
  let [u, d] = (0, k.useState)(null);
  let [p, m] = (0, k.useState)(null);
  let {
    data: h,
    isLoading: g
  } = Jl();
  let v = $l();
  let y = (0, k.useMemo)(() => {
    let e = i.trim().toLowerCase();
    return (h ?? []).filter(t => {
      let n = o === `todos` || t.status === o;
      let r = e === `` || t.nome.toLowerCase().includes(e) || (t.cliente?.nome ?? ``).toLowerCase().includes(e);
      return n && r;
    });
  }, [h, o, i]);
  let b = (0, k.useMemo)(() => {
    let e = h ?? [];
    return {
      todos: e.length,
      medicao: e.filter(e => e.status === `medicao`).length,
      projeto_corte: e.filter(e => e.status === `projeto_corte`).length,
      montagem: e.filter(e => e.status === `montagem`).length,
      entrega: e.filter(e => e.status === `entrega`).length,
      concluido: e.filter(e => e.status === `concluido`).length,
      cancelado: e.filter(e => e.status === `cancelado`).length
    };
  }, [h]);
  function x() {
    d(null);
    l(true);
    if (t.has(`novo`)) {
      t.delete(`novo`);
      n(t, {
        replace: true
      });
    }
  }
                      return <div className={`space-y-6`}><Fs title={`Projetos`} description={`Pipeline de medição, corte, montagem e entrega.`} actions={<G onClick={x}><_Component10 className={`h-4 w-4`} />{`Novo projeto`}</G>}><div className={`flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between`}><_Component32 value={o} onValueChange={s} tabs={[{
          value: `todos`,
          label: `Todos`,
          count: b.todos
        }, {
          value: `medicao`,
          label: `Medição`,
          count: b.medicao
        }, {
          value: `projeto_corte`,
          label: `Projeto/Corte`,
          count: b.projeto_corte
        }, {
          value: `montagem`,
          label: `Montagem`,
          count: b.montagem
        }, {
          value: `entrega`,
          label: `Entrega`,
          count: b.entrega
        }, {
          value: `concluido`,
          label: `Concluídos`,
          count: b.concluido
        }]} /><div className={`relative w-full sm:max-w-xs`}><_Component22 className={`pointer-events-none absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-muted-foreground`} /><K value={i} onChange={e => a(e.target.value)} placeholder={`Buscar projeto ou cliente`} className={`pl-9`} /></div></div></Fs>{g ? <_Component23 /> : y.length > 0 ? <div className={`grid gap-4 sm:grid-cols-2 lg:grid-cols-3`}>{y.map(t => <Rs className={`flex flex-col gap-3 p-4 transition-colors duration-150 hover:border-primary/40`} key={t.id}><div className={`flex items-start justify-between gap-3`}><_ to={`/projetos/${t.id}`} className={`min-w-0 space-y-1`}><p className={`truncate font-medium hover:underline`}>{t.nome}</p><p className={`truncate text-xs text-muted-foreground`}>{t.cliente?.nome ?? `Sem cliente`}</p></_><Lo items={[{
            label: `Abrir projeto`,
            icon: <Cn className={`h-4 w-4`} />,
            onSelect: () => e(`/projetos/${t.id}`)
          }, {
            label: `Editar`,
            icon: <Wn className={`h-4 w-4`} />,
            onSelect: () => {
              d(t);
              l(true);
            }
          }, {
            label: `Remover`,
            icon: <_Component26 className={`h-4 w-4`} />,
            destructive: true,
            onSelect: () => m(t)
          }]} /></div><div className={`flex items-center justify-between gap-2`}><Gs label={qr[t.status]} tone={Yr[t.status]} /><span className={`inline-flex items-center gap-1 text-xs text-muted-foreground`}><_Component4 className={`h-3.5 w-3.5`} />{t.total_ambientes}</span></div>{t.data_entrega_prevista && <p className={`inline-flex items-center gap-1 text-xs text-muted-foreground`}><Ht className={`h-3.5 w-3.5`} />{`Entrega `}{to(t.data_entrega_prevista)}</p>}</Rs>)}</div> : <Ws icon={<_Component4 className={`h-8 w-8`} />} title={`Nenhum projeto encontrado`} description={`Ajuste os filtros ou crie um novo projeto.`} action={<G onClick={x}><_Component10 className={`h-4 w-4`} />{`Novo projeto`}</G>} />}<_Component33 open={c} onOpenChange={l} projeto={u} clientePadrao={r} /><_Component29 open={!!p} onOpenChange={e => !e && m(null)} title={`Remover projeto`} description={p ? `Remover "${p.nome}" e todo o detalhamento técnico?` : undefined} confirmLabel={`Remover`} onConfirm={async () => {
      if (p) {
        await v.mutateAsync(p.id);
      }
    }} /></div>;
}
var su = {
  not_authenticated: `Sessão expirada. Entre novamente.`,
  forbidden: `Seu perfil de acesso não permite esta ação.`,
  invalid_value: `Informe um valor maior que zero.`,
  invalid_installments: `O número de parcelas deve ficar entre 1 e 120.`,
  project_not_found: `Projeto não encontrado.`,
  client_not_found: `Cliente não encontrado.`,
  material_not_found: `Material não encontrado.`,
  contract_not_found: `Contrato não encontrado.`,
  entry_not_found: `Lançamento não encontrado.`,
  invalid_quantity: `A quantidade deve ser maior que zero.`,
  nome_invalido: `Informe o nome do ambiente.`,
  margem_invalida: `A margem deve ficar entre 0% e 200%.`,
  projeto_nao_encontrado: `Projeto não encontrado.`,
  estudo_nao_encontrado: `Estudo 3D não encontrado.`,
  ambiente_nao_encontrado: `Ambiente não encontrado.`,
  calculo_invalido: `Cálculo do orçamento inválido.`
};
function cu(e) {
  let t = e instanceof Error ? e.message : String(e);
  return su[t.split(`
`)[0].trim()] ?? t;
}
async function lu(e) {
  if (typeof e == `object` && e && `context` in e) {
    let t = e.context;
    if (t instanceof Response) {
      try {
        let e = await t.clone().json();
        if (e?.error) {
          return e.error;
        }
      } catch {}
    }
  }
  return cu(e);
}
async function uu(e) {
  let {
    data: t,
    error: n
  } = await B.functions.invoke(`criar-ambiente`, {
    body: e
  });
  if (n) {
    throw Error(await lu(n));
  }
  if (!t?.ambiente) {
    throw Error(`O ambiente não foi criado. Tente novamente.`);
  }
  return t.ambiente;
}
async function du(e, t) {
  let {
    data: n,
    error: r
  } = await B.from(`ambientes`).update(t).eq(`id`, e).select(`*`).single();
  if (r) {
    throw r;
  }
  return n;
}
async function fu(e) {
  let {
    error: t
  } = await B.from(`ambientes`).delete().eq(`id`, e);
  if (t) {
    throw t;
  }
}
async function pu(e, t = {}) {
  let {
    data: n,
    error: r
  } = await B.functions.invoke(`orcamento-ambiente`, {
    body: {
      design_id: e,
      ...t
    }
  });
  if (r) {
    throw Error(await lu(r));
  }
  if (!n?.orcamento) {
    throw Error(`O orçamento não foi gerado. Tente novamente.`);
  }
  return n;
}
async function mu(e, t = {}) {
  let {
    data: n,
    error: r
  } = await B.functions.invoke(`ambiente-mockup`, {
    body: {
      ambiente_id: e,
      tema: t.tema ?? `claro`,
      formato: `svg`
    }
  });
  if (r || !n) {
    throw Error(r?.message ?? `Não foi possível gerar o mockup.`);
  }
  let i = URL.createObjectURL(new Blob([n], {
    type: `image/svg+xml`
  }));
  let a = document.createElement(`a`);
  a.href = i;
  a.download = t.nomeArquivo ?? `mockup-ambiente.svg`;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(i);
}
function hu(e, t) {
  if (t) {
    e.invalidateQueries({
      queryKey: H.projeto(t)
    });
  }
  e.invalidateQueries({
    queryKey: [`projetos`]
  });
}
function gu(e) {
  let t = C();
  return O({
    mutationFn: e => uu(e),
    onSuccess: n => {
      hu(t, e ?? n.projeto_id);
      N.success(`Ambiente criado com as medidas do vão.`);
    },
    onError: e => N.error(cu(e))
  });
}
function _u(e) {
  let t = C();
  return O({
    mutationFn: ({
      id: e,
      payload: t
    }) => du(e, t),
    onSuccess: () => {
      hu(t, e);
      N.success(`Ambiente atualizado.`);
    },
    onError: e => N.error(cu(e))
  });
}
function vu(e) {
  let t = C();
  return O({
    mutationFn: e => fu(e),
    onSuccess: () => {
      hu(t, e);
      N.success(`Ambiente removido.`);
    },
    onError: e => N.error(cu(e))
  });
}
function yu(e) {
  let t = C();
  return O({
    mutationFn: t => pu(e, t),
    onSuccess: e => {
      t.invalidateQueries({
        queryKey: H.orcamentos()
      });
      if (e.orcamento.projeto_id) {
        t.invalidateQueries({
          queryKey: H.orcamentos(e.orcamento.projeto_id)
        });
        t.invalidateQueries({
          queryKey: H.projeto(e.orcamento.projeto_id)
        });
      }
      N.success(`Orçamento gerado a partir do estudo.`);
    },
    onError: e => N.error(cu(e))
  });
}
function bu() {
  return O({
    mutationFn: ({
      ambienteId: e,
      nome: t
    }) => mu(e, {
      nomeArquivo: `mockup-${t.toLowerCase().replace(/\s+/g, `-`)}.svg`
    }),
    onSuccess: () => N.success(`Mockup baixado.`),
    onError: e => N.error(cu(e))
  });
}
var xu = `anexos`;
async function Su(e) {
  let {
    data: t,
    error: n
  } = await B.from(`medicoes`).select(`*`).eq(`ambiente_id`, e).maybeSingle();
  if (n) {
    throw n;
  }
  return t;
}
async function Cu(e, t) {
  let n = await Su(e);
  if (n) {
    let {
      data: e,
      error: r
    } = await B.from(`medicoes`).update(t).eq(`id`, n.id).select(`*`).single();
    if (r) {
      throw r;
    }
    return e;
  }
  let {
    data: r,
    error: i
  } = await B.from(`medicoes`).insert({
    ...t,
    ambiente_id: e
  }).select(`*`).single();
  if (i) {
    throw i;
  }
  return r;
}
async function wu(e) {
  let {
    data: t,
    error: n
  } = await B.from(`checklists_tecnicos`).select(`*`).eq(`projeto_id`, e).maybeSingle();
  if (n) {
    throw n;
  }
  return t;
}
async function Tu(e, t) {
  let n = await wu(e);
  if (n) {
    let {
      data: e,
      error: r
    } = await B.from(`checklists_tecnicos`).update(t).eq(`id`, n.id).select(`*`).single();
    if (r) {
      throw r;
    }
    return e;
  }
  let {
    data: r,
    error: i
  } = await B.from(`checklists_tecnicos`).insert({
    ...t,
    projeto_id: e
  }).select(`*`).single();
  if (i) {
    throw i;
  }
  return r;
}
async function Eu(e) {
  let {
    data: t,
    error: n
  } = await B.from(`anexos`).select(`*`).eq(`projeto_id`, e).order(`created_at`, {
    ascending: false
  });
  if (n) {
    throw n;
  }
  return t ?? [];
}
async function Du(e) {
  let {
    file: t,
    tenantId: n,
    projetoId: r,
    ambienteId: i,
    categoria: a,
    userId: o
  } = e;
  let s = t.name.replace(/[^\w.-]+/g, `_`);
  let c = `${n}/${r}/${crypto.randomUUID()}-${s}`;
  let {
    error: l
  } = await B.storage.from(xu).upload(c, t, {
    cacheControl: `3600`,
    upsert: false
  });
  if (l) {
    throw l;
  }
  let {
    data: u,
    error: d
  } = await B.from(`anexos`).insert({
    projeto_id: r,
    ambiente_id: i ?? null,
    categoria: a,
    storage_path: c,
    nome_arquivo: t.name,
    mime_type: t.type || null,
    tamanho_bytes: t.size,
    uploaded_by: o
  }).select(`*`).single();
  if (d) {
    await B.storage.from(xu).remove([c]);
    throw d;
  }
  return u;
}
async function Ou(e) {
  let {
    error: t
  } = await B.storage.from(xu).remove([e.storage_path]);
  if (t) {
    throw t;
  }
  let {
    error: n
  } = await B.from(`anexos`).delete().eq(`id`, e.id);
  if (n) {
    throw n;
  }
}
async function ku(e, t = 3600) {
  let {
    data: n,
    error: r
  } = await B.storage.from(xu).createSignedUrl(e, t);
  if (r) {
    throw r;
  }
  return n.signedUrl;
}
function Au(e) {
  return T({
    queryKey: H.medicao(e ?? ``),
    queryFn: () => Su(e),
    enabled: !!e
  });
}
function ju(e) {
  let t = C();
  return O({
    mutationFn: t => Cu(e, t),
    onSuccess: () => {
      t.invalidateQueries({
        queryKey: H.medicao(e ?? ``)
      });
      N.success(`Medidas salvas.`);
    },
    onError: e => N.error(e.message)
  });
}
function Mu(e) {
  return T({
    queryKey: H.checklist(e ?? ``),
    queryFn: () => wu(e),
    enabled: !!e
  });
}
function Nu(e) {
  let t = C();
  return O({
    mutationFn: t => Tu(e, t),
    onSuccess: () => {
      t.invalidateQueries({
        queryKey: H.checklist(e ?? ``)
      });
      N.success(`Checklist técnico salvo.`);
    },
    onError: e => N.error(e.message)
  });
}
function Pu(e) {
  return T({
    queryKey: H.anexos(e ?? ``),
    queryFn: () => Eu(e),
    enabled: !!e
  });
}
function Fu(e) {
  let t = C();
  let {
    user: n,
    tenantId: r
  } = Ct();
  return O({
    mutationFn: t => Du({
      file: t.file,
      ambienteId: t.ambienteId ?? null,
      categoria: t.categoria,
      projetoId: e,
      tenantId: r,
      userId: n?.id ?? ``
    }),
    onSuccess: () => {
      t.invalidateQueries({
        queryKey: H.anexos(e ?? ``)
      });
      N.success(`Anexo enviado.`);
    },
    onError: e => N.error(e.message)
  });
}
function Iu(e) {
  let t = C();
  return O({
    mutationFn: e => Ou(e),
    onSuccess: () => {
      t.invalidateQueries({
        queryKey: H.anexos(e ?? ``)
      });
      N.success(`Anexo removido.`);
    },
    onError: e => N.error(e.message)
  });
}
async function Lu(e) {
  let {
    data: t,
    error: n
  } = await B.from(`pecas`).select(`*, material:materiais(id,nome,cor,custo_unitario)`).eq(`ambiente_id`, e).order(`ordem`, {
    ascending: true
  });
  if (n) {
    throw n;
  }
  return t ?? [];
}
async function Ru(e) {
  let {
    data: t,
    error: n
  } = await B.from(`ambientes`).select(`id`).eq(`projeto_id`, e);
  if (n) {
    throw n;
  }
  let r = (t ?? []).map(e => e.id);
  if (r.length === 0) {
    return [];
  }
  let {
    data: i,
    error: a
  } = await B.from(`pecas`).select(`*, material:materiais(id,nome,cor,custo_unitario)`).in(`ambiente_id`, r).order(`ambiente_id`, {
    ascending: true
  }).order(`ordem`, {
    ascending: true
  });
  if (a) {
    throw a;
  }
  return i ?? [];
}
async function zu(e, t) {
  let {
    count: n
  } = await B.from(`pecas`).select(`id`, {
    count: `exact`,
    head: true
  }).eq(`ambiente_id`, e);
  let {
    data: r,
    error: i
  } = await B.from(`pecas`).insert({
    ...t,
    ambiente_id: e,
    ordem: n ?? 0
  }).select(`*`).single();
  if (i) {
    throw i;
  }
  return r;
}
async function Bu(e, t) {
  let {
    data: n,
    error: r
  } = await B.from(`pecas`).update(t).eq(`id`, e).select(`*`).single();
  if (r) {
    throw r;
  }
  return n;
}
async function Vu(e) {
  let {
    error: t
  } = await B.from(`pecas`).delete().eq(`id`, e);
  if (t) {
    throw t;
  }
}
function Hu(e) {
  return T({
    queryKey: H.pecas(e ?? ``),
    queryFn: () => Lu(e),
    enabled: !!e
  });
}
function Uu(e) {
  return T({
    queryKey: H.pecasProjeto(e ?? ``),
    queryFn: () => Ru(e),
    enabled: !!e
  });
}
function Wu(e, t) {
  let n = C();
  return O({
    mutationFn: t => zu(e, t),
    onSuccess: () => {
      n.invalidateQueries({
        queryKey: H.pecas(e ?? ``)
      });
      if (t) {
        n.invalidateQueries({
          queryKey: H.pecasProjeto(t)
        });
      }
      N.success(`Peça adicionada.`);
    },
    onError: e => N.error(e.message)
  });
}
function Gu(e, t) {
  let n = C();
  return O({
    mutationFn: ({
      id: e,
      payload: t
    }) => Bu(e, t),
    onSuccess: () => {
      n.invalidateQueries({
        queryKey: H.pecas(e ?? ``)
      });
      if (t) {
        n.invalidateQueries({
          queryKey: H.pecasProjeto(t)
        });
      }
      N.success(`Peça atualizada.`);
    },
    onError: e => N.error(e.message)
  });
}
function Ku(e, t) {
  let n = C();
  return O({
    mutationFn: e => Vu(e),
    onSuccess: () => {
      n.invalidateQueries({
        queryKey: H.pecas(e ?? ``)
      });
      if (t) {
        n.invalidateQueries({
          queryKey: H.pecasProjeto(t)
        });
      }
      N.success(`Peça removida.`);
    },
    onError: e => N.error(e.message)
  });
}
function _Component34({
  entrada: e,
  tema: t,
  formato: n = `normal`,
  className: r
}) {
  let {
    escuro: i
  } = Xo();
  let a = t ?? (i ? `escuro` : `claro`);
  let {
    nome: o,
    tipo: s,
    largura_cm: c,
    altura_cm: l,
    profundidade_cm: u,
    desnivel_cm: d,
    pontos_eletricos: f,
    pontos_hidraulicos: p,
    margem_percent: m
  } = e;
  let h = (0, k.useMemo)(() => Ze({
    nome: o,
    tipo: s,
    largura_cm: c,
    altura_cm: l,
    profundidade_cm: u,
    desnivel_cm: d,
    pontos_eletricos: f,
    pontos_hidraulicos: p,
    margem_percent: m
  }, a, n), [o, s, c, l, u, d, f, p, m, a, n]);
    return <img src={h} alt={`Mockup do ambiente ${o}`} className={U(`block h-auto w-full`, r)} loading={`lazy`} />;
}
function Ju({
  exemplos: e,
  selecionadoId: t,
  onEscolher: n
}) {
    return <div className={`grid gap-2 sm:grid-cols-3 lg:grid-cols-4`}>{e.map(e => {
      let r = e.id === t;
                                          return <button type={`button`} title={`Usar as medidas de ${e.nome} como ponto de partida`} onClick={() => n(e)} className={U(`flex flex-col gap-2 rounded-[10px] border p-2 text-left transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring/35`, r ? `border-primary bg-accent` : `border-border bg-card hover:border-primary/50 hover:bg-accent/60`)} key={e.id}><span className={`block overflow-hidden rounded-md border border-border/60 bg-muted/30`}><_Component34 formato={`compacta`} entrada={{
            nome: e.nome,
            tipo: e.tipo,
            largura_cm: e.largura_cm,
            altura_cm: e.altura_cm,
            profundidade_cm: e.profundidade_cm,
            margem_percent: e.margem_percent
          }} /></span><span className={`min-w-0`}><span className={`block truncate text-[12px] font-medium text-foreground`}>{e.nome}</span><span className={`block text-[11px] text-muted-foreground`}>{Ne[e.tipo]}</span><span className={`numero mt-0.5 block text-[11px] text-muted-foreground`}>{e.largura_cm}{` × `}{e.altura_cm}{` × `}{e.profundidade_cm}{` cm`}</span></span></button>;
    })}</div>;
}
var Yu = {
  nome: ``,
  tipo: Me,
  margem_percent: `30`,
  largura_cm: ``,
  altura_cm: ``,
  profundidade_cm: ``,
  observacoes: ``
};
function Xu({
  open: e,
  onOpenChange: t,
  projetoId: r,
  ambiente: a,
  medicao: o,
  onCriado: s
}) {
  let c = !a;
  let l = gu(r);
  let u = _u(r);
  let {
    register: d,
    handleSubmit: f,
    reset: p,
    watch: m,
    formState: {
      errors: h
    }
  } = i({
    resolver: n(dc),
    defaultValues: Yu
  });
  (0, k.useEffect)(() => {
    if (e) {
      p(a ? {
        ...Yu,
        nome: a.nome,
        tipo: a.tipo,
        margem_percent: String(a.margem_percent),
        observacoes: a.observacoes ?? ``
      } : Yu);
    }
  }, [e, a, p]);
  let g = m(`nome`);
  let _ = m(`tipo`);
  let v = m(`margem_percent`);
  let y = m(`largura_cm`);
  let b = m(`altura_cm`);
  let x = m(`profundidade_cm`);
  let [S, C] = (0, k.useState)(null);
  function w(e) {
    C(e.id);
    p({
      ...Yu,
      nome: e.nome,
      tipo: e.tipo,
      margem_percent: String(e.margem_percent),
      largura_cm: String(e.largura_cm),
      altura_cm: String(e.altura_cm),
      profundidade_cm: String(e.profundidade_cm),
      observacoes: m(`observacoes`)
    });
  }
  let T = (0, k.useMemo)(() => ({
    nome: g.trim() || `Novo ambiente`,
    tipo: Le(_) ? _ : Me,
    largura_cm: c ? vl(y) : o?.largura_cm ?? null,
    altura_cm: c ? vl(b) : o?.altura_cm ?? null,
    profundidade_cm: c ? vl(x) : o?.profundidade_cm ?? null,
    desnivel_cm: c ? null : o?.desnivel_cm ?? null,
    pontos_eletricos: c ? 0 : o?.pontos_eletricos ?? 0,
    pontos_hidraulicos: c ? 0 : o?.pontos_hidraulicos ?? 0,
    margem_percent: _l(v || `0`)
  }), [c, g, _, v, y, b, x, o]);
  let E = l.isPending || u.isPending;
  async function D(e) {
    if (a) {
      await u.mutateAsync({
        id: a.id,
        payload: Cl(e)
      });
    } else {
      let t = await l.mutateAsync(wl(e, r));
      s?.(t);
    }
    t(false);
  }
                      return <_Component21 open={e} onOpenChange={t} title={a ? `Editar ambiente` : `Novo ambiente`} description={a ? `Altere o nome, o tipo e o markup do cômodo.` : `Informe as medidas que já tiver: dá para completar depois no levantamento.`} size={`xl`} footer={<L.Fragment><G variant={`outline`} onClick={() => t(false)} disabled={E}>{`Cancelar`}</G><G form={`ambiente-form`} type={`submit`} disabled={E}>{E ? `Salvando...` : `Salvar ambiente`}</G></L.Fragment>}><div className={`grid gap-5 lg:grid-cols-[minmax(0,1fr)_340px]`}><form id={`ambiente-form`} className={`grid content-start gap-4 sm:grid-cols-2`} onSubmit={f(D)}><_Component19 label={`Nome do ambiente`} htmlFor={`amb-nome`} error={h.nome?.message} required={true} className={`sm:col-span-2`}><K id={`amb-nome`} placeholder={`Ex: Cozinha`} {...d(`nome`)} /></_Component19><_Component19 label={`Tipo`} htmlFor={`amb-tipo`} error={h.tipo?.message}><_Component31 id={`amb-tipo`} {...d(`tipo`)}>{je.map(e => <option value={e} key={e}>{Ne[e]}</option>)}</_Component31></_Component19><_Component19 label={`Markup do ambiente (%)`} htmlFor={`amb-margem`} error={h.margem_percent?.message}><K id={`amb-margem`} inputMode={`decimal`} {...d(`margem_percent`)} /></_Component19>{c && <L.Fragment><_Component19 label={`Largura do vão (cm)`} htmlFor={`amb-largura`} error={h.largura_cm?.message}><K id={`amb-largura`} inputMode={`decimal`} {...d(`largura_cm`)} /></_Component19><_Component19 label={`Altura do vão (cm)`} htmlFor={`amb-altura`} error={h.altura_cm?.message}><K id={`amb-altura`} inputMode={`decimal`} {...d(`altura_cm`)} /></_Component19><_Component19 label={`Profundidade (cm)`} htmlFor={`amb-profundidade`} error={h.profundidade_cm?.message}><K id={`amb-profundidade`} inputMode={`decimal`} {...d(`profundidade_cm`)} /></_Component19></L.Fragment>}<_Component19 label={`Observações`} htmlFor={`amb-obs`} error={h.observacoes?.message} className={`sm:col-span-2`}><Rl id={`amb-obs`} rows={c ? 2 : 3} {...d(`observacoes`)} /></_Component19>{!c && <p className={`text-[12px] text-muted-foreground sm:col-span-2`}>{`As medidas do vão ficam em Medidas do vão, com desnível, pontos elétricos e hidráulicos.`}</p>}</form><div className={`rounded-[10px] border border-border bg-muted/30 p-3`}><p className={`pb-2 text-[11px] font-semibold text-muted-foreground`}>{`Mockup do vão`}</p><_Component34 entrada={T} className={`rounded-md`} /></div></div>{c && <div className={`mt-5 border-t border-border pt-4`}><div className={`flex flex-wrap items-baseline justify-between gap-2 pb-2`}><p className={`text-[12px] font-semibold text-foreground`}>{`Mockups de exemplo`}</p><p className={`text-[11px] text-muted-foreground`}>{`Medidas típicas de cômodo: clique para preencher e ajuste no levantamento.`}</p></div><Ju exemplos={Ie} selecionadoId={S} onEscolher={w} /></div>}</_Component21>;
}
var Zu = {
  altura_cm: ``,
  largura_cm: ``,
  profundidade_cm: ``,
  desnivel_cm: ``,
  pontos_eletricos: ``,
  pontos_hidraulicos: ``,
  colunas_vigas: ``,
  observacoes: ``
};
var Qu = e => e === null ? `` : String(e);
function $u({
  open: e,
  onOpenChange: t,
  ambiente: r
}) {
  let {
    data: a
  } = Au(e ? r?.id : undefined);
  let o = ju(r?.id);
  let {
    register: s,
    handleSubmit: c,
    reset: l,
    formState: {
      errors: u,
      isSubmitting: d
    }
  } = i({
    resolver: n(fc),
    defaultValues: Zu
  });
  (0, k.useEffect)(() => {
    if (e) {
      l(a ? {
        altura_cm: Qu(a.altura_cm),
        largura_cm: Qu(a.largura_cm),
        profundidade_cm: Qu(a.profundidade_cm),
        desnivel_cm: Qu(a.desnivel_cm),
        pontos_eletricos: String(a.pontos_eletricos),
        pontos_hidraulicos: String(a.pontos_hidraulicos),
        colunas_vigas: a.colunas_vigas ?? ``,
        observacoes: a.observacoes ?? ``
      } : Zu);
    }
  }, [e, a, l]);
  async function f(e) {
    await o.mutateAsync(Tl(e));
    t(false);
  }
    return <_Component21 open={e} onOpenChange={t} title={`Medidas do vão`} description={r ? `Levantamento técnico de ${r.nome}` : undefined} size={`lg`} footer={<L.Fragment><G variant={`outline`} onClick={() => t(false)} disabled={d}>{`Cancelar`}</G><G form={`medicao-form`} type={`submit`} disabled={d}>{d ? `Salvando...` : `Salvar medidas`}</G></L.Fragment>}><form id={`medicao-form`} onSubmit={c(f)} className={`grid gap-4 sm:grid-cols-2`}><_Component19 label={`Altura (cm)`} htmlFor={`altura_cm`} error={u.altura_cm?.message}><K id={`altura_cm`} inputMode={`decimal`} {...s(`altura_cm`)} /></_Component19><_Component19 label={`Largura (cm)`} htmlFor={`largura_cm`} error={u.largura_cm?.message}><K id={`largura_cm`} inputMode={`decimal`} {...s(`largura_cm`)} /></_Component19><_Component19 label={`Profundidade (cm)`} htmlFor={`profundidade_cm`} error={u.profundidade_cm?.message}><K id={`profundidade_cm`} inputMode={`decimal`} {...s(`profundidade_cm`)} /></_Component19><_Component19 label={`Desnível de piso (cm)`} htmlFor={`desnivel_cm`} error={u.desnivel_cm?.message}><K id={`desnivel_cm`} inputMode={`decimal`} {...s(`desnivel_cm`)} /></_Component19><_Component19 label={`Pontos elétricos`} htmlFor={`pontos_eletricos`} error={u.pontos_eletricos?.message}><K id={`pontos_eletricos`} inputMode={`numeric`} {...s(`pontos_eletricos`)} /></_Component19><_Component19 label={`Pontos hidráulicos`} htmlFor={`pontos_hidraulicos`} error={u.pontos_hidraulicos?.message}><K id={`pontos_hidraulicos`} inputMode={`numeric`} {...s(`pontos_hidraulicos`)} /></_Component19><_Component19 label={`Colunas / vigas`} htmlFor={`colunas_vigas`} error={u.colunas_vigas?.message} className={`sm:col-span-2`}><Rl id={`colunas_vigas`} rows={2} placeholder={`Ex: viga aparente a 2,10m, pilar de 30cm no canto`} {...s(`colunas_vigas`)} /></_Component19><_Component19 label={`Observações`} htmlFor={`observacoes`} error={u.observacoes?.message} className={`sm:col-span-2`}><Rl id={`observacoes`} rows={2} {...s(`observacoes`)} /></_Component19></form></_Component21>;
}
function ed(e) {
  return T({
    queryKey: H.materiais(e),
    queryFn: () => ys(e)
  });
}
function td() {
  let e = C();
  return O({
    mutationFn: e => bs(e),
    onSuccess: () => {
      e.invalidateQueries({
        queryKey: [`materiais`]
      });
      e.invalidateQueries({
        queryKey: H.dashboard
      });
      N.success(`Material cadastrado.`);
    },
    onError: e => N.error(e.message)
  });
}
function nd() {
  let e = C();
  return O({
    mutationFn: ({
      id: e,
      payload: t
    }) => xs(e, t),
    onSuccess: () => {
      e.invalidateQueries({
        queryKey: [`materiais`]
      });
      e.invalidateQueries({
        queryKey: H.dashboard
      });
      N.success(`Material atualizado.`);
    },
    onError: e => N.error(e.message)
  });
}
function rd() {
  let e = C();
  return O({
    mutationFn: e => Ss(e),
    onSuccess: () => {
      e.invalidateQueries({
        queryKey: [`materiais`]
      });
      e.invalidateQueries({
        queryKey: H.dashboard
      });
      N.success(`Material removido.`);
    },
    onError: e => N.error(e.message)
  });
}
function id(e) {
  return T({
    queryKey: H.movimentacoes(e),
    queryFn: () => ws(e)
  });
}
function ad() {
  let e = C();
  return O({
    mutationFn: Cs,
    onSuccess: () => {
      e.invalidateQueries({
        queryKey: [`materiais`]
      });
      e.invalidateQueries({
        queryKey: [`movimentacoes`]
      });
      e.invalidateQueries({
        queryKey: H.dashboard
      });
      N.success(`Movimentação registrada.`);
    },
    onError: e => N.error(e.message)
  });
}
function od(e) {
  return T({
    queryKey: H.retalhos(e),
    queryFn: () => Es({
      consumido: e
    })
  });
}
function sd() {
  let e = C();
  return O({
    mutationFn: e => Ds(e),
    onSuccess: () => {
      e.invalidateQueries({
        queryKey: [`retalhos`]
      });
      N.success(`Retalho registrado.`);
    },
    onError: e => N.error(e.message)
  });
}
function cd() {
  let e = C();
  return O({
    mutationFn: ({
      id: e,
      payload: t
    }) => Os(e, t),
    onSuccess: () => {
      e.invalidateQueries({
        queryKey: [`retalhos`]
      });
      N.success(`Retalho atualizado.`);
    },
    onError: e => N.error(e.message)
  });
}
function ld() {
  let e = C();
  return O({
    mutationFn: e => ks(e),
    onSuccess: () => {
      e.invalidateQueries({
        queryKey: [`retalhos`]
      });
      N.success(`Retalho removido.`);
    },
    onError: e => N.error(e.message)
  });
}
var _Component35 = k.forwardRef(({
  className: e,
  label: t,
  id: n,
  ...r
}, i) => <label htmlFor={n} className={U(`inline-flex cursor-pointer select-none items-center gap-2 text-sm text-foreground/90`, r.disabled && `cursor-not-allowed opacity-60`, e)}><span className={`relative grid h-4 w-4 shrink-0 place-items-center`}><input id={n} ref={i} type={`checkbox`} className={`peer h-4 w-4 appearance-none rounded-[4px] border border-input bg-background transition-colors duration-150 checked:border-primary checked:bg-primary focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring/30 disabled:cursor-not-allowed`} {...r} /><Ut className={`pointer-events-none absolute h-3 w-3 text-primary-foreground opacity-0 transition-opacity peer-checked:opacity-100`} /></span>{t}</label>);
_Component35.displayName = `Checkbox`;
var dd = {
  nome: ``,
  material_id: ``,
  tipo_chapa: `mdf`,
  espessura_mm: `18`,
  comprimento_cm: ``,
  largura_cm: ``,
  quantidade: `1`,
  sentido_veio: `comprimento`,
  fita_tipo: `nenhuma`,
  borda_topo: false,
  borda_base: false,
  borda_esquerda: false,
  borda_direita: false
};
function fd(e) {
  return ds(e);
}
function _Component39({
  open: e,
  onOpenChange: t,
  ambiente: r,
  projetoId: a
}) {
  let [o, s] = (0, k.useState)(null);
  let [c, l] = (0, k.useState)(false);
  let {
    data: u
  } = Hu(e ? r?.id : undefined);
  let {
    data: d
  } = ed({
    categoria: `chapa`
  });
  let f = Wu(r?.id, a);
  let p = Gu(r?.id, a);
  let m = Ku(r?.id, a);
  let {
    register: h,
    handleSubmit: g,
    reset: _,
    formState: {
      errors: v,
      isSubmitting: y
    }
  } = i({
    resolver: n(_c),
    defaultValues: dd
  });
  function b(e) {
    if (!e) {
      s(null);
      l(false);
      _(dd);
    }
    t(e);
  }
  function x() {
    s(null);
    _(dd);
    l(true);
  }
  function S(e) {
    s(e.id);
    _({
      nome: e.nome,
      material_id: e.material_id ?? ``,
      tipo_chapa: e.tipo_chapa,
      espessura_mm: String(e.espessura_mm),
      comprimento_cm: String(e.comprimento_cm),
      largura_cm: String(e.largura_cm),
      quantidade: String(e.quantidade),
      sentido_veio: e.sentido_veio,
      fita_tipo: e.fita_tipo,
      borda_topo: e.borda_topo,
      borda_base: e.borda_base,
      borda_esquerda: e.borda_esquerda,
      borda_direita: e.borda_direita
    });
    l(true);
  }
  async function C(e) {
    let t = Ol(e);
    if (o) {
      await p.mutateAsync({
        id: o,
        payload: t
      });
    } else {
      await f.mutateAsync(t);
    }
    l(false);
    s(null);
    _(dd);
  }
                                    return <_Component21 open={e} onOpenChange={b} title={`Peças do ambiente`} description={r ? `Plano de corte de ${r.nome}` : undefined} size={`xl`} footer={<G variant={`outline`} onClick={() => b(false)}>{`Fechar`}</G>}><div className={`space-y-4`}><div className={`flex justify-end`}><G size={`sm`} onClick={x}><_Component10 className={`h-4 w-4`} />{`Adicionar peça`}</G></div>{u && u.length > 0 ? <div className={`overflow-hidden rounded-lg border border-border`}><_Component28><_Component25><_Component24><J>{`Peça`}</J><J>{`Dimensões`}</J><J className={`hidden sm:table-cell`}>{`Chapa`}</J><J>{`Qtd`}</J><J className={`hidden md:table-cell`}>{`Veio`}</J><J className={`hidden lg:table-cell`}>{`Fita / bordas`}</J><J className={`w-20 text-right`}>{`Ações`}</J></_Component24></_Component25><_Component27>{u.map(e => <_Component24 key={e.id}><Y className={`font-medium`}>{e.nome}</Y><Y><span className={`cota-badge text-foreground`}>{e.comprimento_cm}{` × `}{e.largura_cm}{` `}<span className={`font-semibold text-primary`}>{`× `}{e.espessura_mm}{`mm`}</span></span></Y><Y className={`hidden sm:table-cell text-muted-foreground`}>{ii[e.tipo_chapa]}{e.material?.nome ? `, ${e.material.nome}` : ``}</Y><Y className={`tabular-nums`}>{e.quantidade}</Y><Y className={`hidden md:table-cell text-muted-foreground`}>{ai[e.sentido_veio]}</Y><Y className={`hidden lg:table-cell text-muted-foreground`}>{oi[e.fita_tipo]}{`, `}{fd(e)}</Y><Y className={`text-right`}><div className={`flex justify-end gap-1`}><G variant={`ghost`} size={`icon`} onClick={() => S(e)} aria-label={`Editar peça`}><Wn className={`h-3.5 w-3.5`} /></G><G variant={`ghost`} size={`icon`} onClick={() => m.mutate(e.id)} aria-label={`Remover peça`}><_Component26 className={`h-3.5 w-3.5 text-destructive`} /></G></div></Y></_Component24>)}</_Component27></_Component28></div> : <p className={`rounded-lg border border-dashed border-border p-6 text-center text-sm text-muted-foreground`}>{`Nenhuma peça cadastrada neste ambiente.`}</p>}{c && <form onSubmit={g(C)} className={`grid gap-4 rounded-lg border border-border p-4 sm:grid-cols-3`}><_Component19 label={`Nome da peça`} htmlFor={`peca-nome`} error={v.nome?.message} required={true} className={`sm:col-span-3`}><K id={`peca-nome`} placeholder={`Ex: Lateral esquerda`} {...h(`nome`)} /></_Component19><_Component19 label={`Material (chapa)`} htmlFor={`material_id`} error={v.material_id?.message}><_Component31 id={`material_id`} {...h(`material_id`)}><option value={``}>{`Sem vínculo`}</option>{(d ?? []).map(e => <option value={e.id} key={e.id}>{e.nome}{e.cor ? `, ${e.cor}` : ``}</option>)}</_Component31></_Component19><_Component19 label={`Tipo de chapa`} htmlFor={`tipo_chapa`} error={v.tipo_chapa?.message}><_Component31 id={`tipo_chapa`} {...h(`tipo_chapa`)}>{Object.keys(ii).map(e => <option value={e} key={e}>{ii[e]}</option>)}</_Component31></_Component19><_Component19 label={`Espessura (mm)`} htmlFor={`espessura_mm`} error={v.espessura_mm?.message}><K id={`espessura_mm`} inputMode={`decimal`} {...h(`espessura_mm`)} /></_Component19><_Component19 label={`Comprimento (cm)`} htmlFor={`comprimento_cm`} error={v.comprimento_cm?.message}><K id={`comprimento_cm`} inputMode={`decimal`} {...h(`comprimento_cm`)} /></_Component19><_Component19 label={`Largura (cm)`} htmlFor={`largura_cm`} error={v.largura_cm?.message}><K id={`largura_cm`} inputMode={`decimal`} {...h(`largura_cm`)} /></_Component19><_Component19 label={`Quantidade`} htmlFor={`quantidade`} error={v.quantidade?.message}><K id={`quantidade`} inputMode={`numeric`} {...h(`quantidade`)} /></_Component19><_Component19 label={`Sentido do veio`} htmlFor={`sentido_veio`} error={v.sentido_veio?.message}><_Component31 id={`sentido_veio`} {...h(`sentido_veio`)}>{Object.keys(ai).map(e => <option value={e} key={e}>{ai[e]}</option>)}</_Component31></_Component19><_Component19 label={`Tipo de fita de borda`} htmlFor={`fita_tipo`} error={v.fita_tipo?.message}><_Component31 id={`fita_tipo`} {...h(`fita_tipo`)}>{Object.keys(oi).map(e => <option value={e} key={e}>{oi[e]}</option>)}</_Component31></_Component19><div className={`sm:col-span-3`}><p className={`mb-2 text-sm font-medium`}>{`Lados com fita de borda`}</p><div className={`flex flex-wrap gap-4`}><_Component35 id={`borda_topo`} label={`Topo`} {...h(`borda_topo`)} /><_Component35 id={`borda_base`} label={`Base`} {...h(`borda_base`)} /><_Component35 id={`borda_esquerda`} label={`Esquerda`} {...h(`borda_esquerda`)} /><_Component35 id={`borda_direita`} label={`Direita`} {...h(`borda_direita`)} /></div></div><div className={`flex items-center justify-end gap-2 sm:col-span-3`}><G type={`button`} variant={`ghost`} onClick={() => {
            l(false);
            s(null);
            _(dd);
          }}>{`Cancelar`}</G><G type={`submit`} disabled={y}>{o ? `Salvar peça` : `Adicionar peça`}</G></div></form>}</div></_Component21>;
}
function _Component40({
  ambiente: e,
  onEditar: t,
  onRemover: n,
  onBaixarMockup: r
}) {
  let [i, a] = (0, k.useState)(false);
  let [o, s] = (0, k.useState)(false);
  let {
    data: c
  } = Au(e.id);
  let {
    data: l
  } = Hu(e.id);
  let u = c?.altura_cm != null || c?.largura_cm != null || c?.profundidade_cm != null;
                                      return <Rs className={`relative flex flex-col gap-4 overflow-hidden p-4`}><div className={`absolute inset-x-0 top-0 h-1.5 regua-trena text-primary opacity-60 pointer-events-none`} /><div className={`flex items-start justify-between gap-3`}><div className={`min-w-0 space-y-1`}><p className={`truncate font-semibold text-foreground`}>{e.nome}</p><p className={`text-[11px] text-muted-foreground`}>{Ne[e.tipo]}{` · markup `}{eo(e.margem_percent)}</p></div><Lo items={[{
        label: `Medidas do vão`,
        icon: <_Component36 className={`h-4 w-4`} />,
        onSelect: () => a(true)
      }, {
        label: `Peças / plano de corte`,
        icon: <It className={`h-4 w-4`} />,
        onSelect: () => s(true)
      }, {
        label: `Baixar mockup (SVG)`,
        icon: <_Component37 className={`h-4 w-4`} />,
        onSelect: r
      }, {
        label: `Editar ambiente`,
        icon: <_Component38 className={`h-4 w-4`} />,
        onSelect: t
      }, {
        label: `Remover`,
        icon: <_Component26 className={`h-4 w-4`} />,
        destructive: true,
        onSelect: n
      }]} /></div><div className={`overflow-hidden rounded-lg border border-border/60 bg-muted/30`}><_Component34 entrada={{
        nome: e.nome,
        tipo: e.tipo,
        largura_cm: c?.largura_cm ?? null,
        altura_cm: c?.altura_cm ?? null,
        profundidade_cm: c?.profundidade_cm ?? null,
        desnivel_cm: c?.desnivel_cm ?? null,
        pontos_eletricos: c?.pontos_eletricos ?? 0,
        pontos_hidraulicos: c?.pontos_hidraulicos ?? 0,
        margem_percent: e.margem_percent
      }} /></div><div className={`grid grid-cols-2 gap-3 text-sm`}><div className={`rounded-lg border border-border/60 bg-muted/30 p-2.5`}><div className={`flex items-center gap-1.5 text-[11px] font-medium text-muted-foreground`}><_Component36 className={`h-3.5 w-3.5 text-primary`} /><span>{`Medidas do vão`}</span></div>{u ? <p className={`cota-badge mt-1.5 text-[11px] font-semibold text-foreground`}>{c?.largura_cm == null ? `-` : Qa(c.largura_cm)}{` ×`}{` `}{c?.altura_cm == null ? `-` : Qa(c.altura_cm)}{` ×`}{` `}{c?.profundidade_cm == null ? `-` : Qa(c.profundidade_cm)}</p> : <p className={`mt-1 text-[12px] text-muted-foreground`}>{`Não registradas`}</p>}</div><div className={`rounded-lg border border-border/60 bg-muted/30 p-2.5`}><div className={`flex items-center gap-1.5 text-[11px] font-medium text-muted-foreground`}><It className={`h-3.5 w-3.5 text-primary`} /><span>{`Peças listadas`}</span></div><p className={`mt-1.5 font-mono text-[13px] font-semibold tabular-nums text-foreground`}>{l?.length ?? 0}{` `}<span className={`text-[11px] font-normal text-muted-foreground`}>{`peça(s)`}</span></p></div></div><div className={`flex gap-2`}><G variant={`outline`} size={`sm`} onClick={() => a(true)}><_Component36 className={`h-3.5 w-3.5 text-primary`} />{`Medidas do vão`}</G><G variant={`outline`} size={`sm`} onClick={() => s(true)}><It className={`h-3.5 w-3.5 text-primary`} />{`Plano de corte`}</G></div><$u open={i} onOpenChange={a} ambiente={e} /><_Component39 open={o} onOpenChange={s} ambiente={e} projetoId={e.projeto_id} /></Rs>;
}
function _Component46({
  projeto: e
}) {
  let [t, n] = (0, k.useState)(false);
  let [r, i] = (0, k.useState)(null);
  let [a, o] = (0, k.useState)(null);
  let s = vu(e.id);
  let c = bu();
  let {
    data: l
  } = Au(r?.id);
  function u() {
    i(null);
    n(true);
  }
        return <div className={`space-y-4`}><div className={`flex justify-end`}><G size={`sm`} onClick={u}><_Component10 className={`h-4 w-4`} />{`Novo ambiente`}</G></div>{e.ambientes.length > 0 ? <div className={`grid gap-4 sm:grid-cols-2 xl:grid-cols-3`}>{e.ambientes.map(e => <_Component40 ambiente={e} onEditar={() => {
        i(e);
        n(true);
      }} onRemover={() => o(e)} onBaixarMockup={() => c.mutate({
        ambienteId: e.id,
        nome: e.nome
      })} key={e.id} />)}</div> : <Ws icon={<_Component38 className={`h-8 w-8`} />} title={`Nenhum ambiente cadastrado`} description={`Adicione cômodos para registrar medidas, mockup e peças.`} action={<G size={`sm`} onClick={u}><_Component10 className={`h-4 w-4`} />{`Novo ambiente`}</G>} />}<Xu open={t} onOpenChange={n} projetoId={e.id} ambiente={r} medicao={r ? l ?? null : null} /><_Component29 open={!!a} onOpenChange={e => !e && o(null)} title={`Remover ambiente`} description={a ? `Remover "${a.nome}" com medidas e peças?` : undefined} confirmLabel={`Remover`} onConfirm={async () => {
      if (a) {
        await s.mutateAsync(a.id);
      }
    }} /></div>;
}
function gd(e, t, n = `text/csv;charset=utf-8;`) {
  let r = new Blob([t], {
    type: n
  });
  let i = URL.createObjectURL(r);
  let a = document.createElement(`a`);
  a.href = i;
  a.download = e;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(i);
}
function _d(e) {
  let t = String(e ?? ``);
  if (/[";\n]/.test(t)) {
    return `"${t.replace(/"/g, `""`)}"`;
  } else {
    return t;
  }
}
function vd(e, t) {
  return `﻿${[e, ...t].map(e => e.map(_d).join(`;`)).join(`\r
`)}`;
}
function yd(e, t) {
  let n = window.open(``, `_blank`, `width=900,height=700`);
  if (n) {
    n.document.write(`<!doctype html>
<html lang="pt-BR">
<head>
<meta charset="utf-8" />
<title>${e}</title>
<style>
  * { box-sizing: border-box; }
  body { font-family: Inter, Arial, sans-serif; margin: 24px; color: #111827; }
  h1 { font-size: 18px; margin: 0 0 4px; }
  h2 { font-size: 14px; margin: 24px 0 8px; }
  p.meta { color: #6b7280; font-size: 12px; margin: 0 0 16px; }
  table { width: 100%; border-collapse: collapse; font-size: 12px; }
  th, td { border: 1px solid #d1d5db; padding: 6px 8px; text-align: left; }
  th { background: #f3f4f6; text-transform: uppercase; font-size: 10px; letter-spacing: .04em; }
  .etiquetas { display: grid; grid-template-columns: repeat(3, 1fr); gap: 8px; margin-top: 12px; }
  .etiqueta { border: 1px solid #111827; border-radius: 6px; padding: 10px; page-break-inside: avoid; }
  .etiqueta .codigo { font-size: 20px; font-weight: 700; font-family: "JetBrains Mono", monospace; }
  .etiqueta .nome { font-size: 12px; margin: 2px 0 6px; }
  .etiqueta .dim { font-size: 11px; color: #374151; }
  @media print { body { margin: 8mm; } }
</style>
</head>
<body>${t}</body>
</html>`);
    n.document.close();
    n.focus();
    n.addEventListener(`afterprint`, () => n.close());
    setTimeout(() => n.print(), 250);
  }
}
var bd = {
  default: `text-foreground`,
  warning: `text-amber-700 dark:text-amber-400`,
  success: `text-emerald-700 dark:text-emerald-400`,
  info: `text-foreground`
};
function _Component41({
  label: e,
  value: t,
  icon: n,
  hint: r,
  tone: i = `default`
}) {
                return <Rs className={`relative overflow-hidden p-5`}><div className={`absolute top-0 inset-x-0 h-1.5 regua-trena opacity-60 text-primary pointer-events-none`} /><div className={`flex items-start justify-between gap-3`}><div className={`min-w-0 space-y-1.5`}><p className={`text-[12px] font-medium text-muted-foreground`}>{e}</p><p className={U(`numero text-[26px] font-semibold leading-none`, bd[i])}>{t}</p>{r && <p className={`text-[12px] text-muted-foreground`}>{r}</p>}</div>{n && <div className={`text-primary/70 [&_svg]:h-4 [&_svg]:w-4`}>{n}</div>}</div></Rs>;
}
function Sd({
  projeto: e
}) {
  let {
    data: t,
    isLoading: n
  } = Uu(e.id);
  let r = (0, k.useMemo)(() => {
    let t = new Map(e.ambientes.map(e => [e.id, e.nome]));
    return e => t.get(e) ?? `-`;
  }, [e.ambientes]);
  let i = (0, k.useMemo)(() => us((t ?? []).map(e => ({
    id: e.id,
    nome: e.nome,
    material_id: e.material_id,
    material_nome: e.material?.nome ?? null,
    tipo_chapa: e.tipo_chapa,
    espessura_mm: Number(e.espessura_mm),
    comprimento_cm: Number(e.comprimento_cm),
    largura_cm: Number(e.largura_cm),
    quantidade: e.quantidade,
    sentido_veio: e.sentido_veio,
    borda_topo: e.borda_topo,
    borda_base: e.borda_base,
    borda_esquerda: e.borda_esquerda,
    borda_direita: e.borda_direita
  })), {
    comprimento_cm: si.comprimento_cm,
    largura_cm: si.largura_cm
  }), [t]);
  let a = (0, k.useMemo)(() => (t ?? []).map((e, t) => ({
    peca: e,
    codigo: hs(t)
  })), [t]);
  function o() {
    let t = vd([`Codigo`, `Ambiente`, `Peca`, `Tipo`, `Material`, `Espessura(mm)`, `Comprimento(cm)`, `Largura(cm)`, `Qtd`, `Veio`, `Fita`, `Bordas`], a.map(({
      peca: e,
      codigo: t
    }) => [t, r(e.ambiente_id), e.nome, ii[e.tipo_chapa], e.material?.nome ?? `-`, Number(e.espessura_mm), Number(e.comprimento_cm), Number(e.largura_cm), e.quantidade, ai[e.sentido_veio], oi[e.fita_tipo], ds(e)]));
    gd(`plano-de-corte-${e.nome.replace(/\s+/g, `-`).toLowerCase()}.csv`, t);
  }
  function s() {
    let t = a.map(({
      peca: e,
      codigo: t
    }) => `
        <div class="etiqueta">
          <div class="codigo">${t}</div>
          <div class="nome">${e.nome} · ${r(e.ambiente_id)}</div>
          <div class="dim">${e.comprimento_cm} × ${e.largura_cm} × ${e.espessura_mm}mm · Qtd ${e.quantidade}</div>
          <div class="dim">${ii[e.tipo_chapa]}${e.material?.nome ? ` · ${e.material.nome}` : ``}</div>
          <div class="dim">Fita ${oi[e.fita_tipo]} · ${ds(e)}</div>
        </div>`).join(``);
    yd(`Etiquetas, ${e.nome}`, `<h1>${e.nome}</h1>
       <p class="meta">Etiquetas de identificação, ${a.length} peça(s)</p>
       <div class="etiquetas">${t}</div>`);
  }
  if (n) {
    return <Ks className={`h-64`} />;
  } else if (!t || t.length === 0) {
    return <Ws icon={<It className={`h-8 w-8`} />} title={`Nenhuma peça cadastrada`} description={`Adicione peças nos ambientes para calcular o consumo de chapas.`} />;
  } else {
                                                                    return <div className={`space-y-6`}><div className={`grid gap-4 sm:grid-cols-2 lg:grid-cols-4`}><_Component41 label={`Peças`} value={Za(i.totalPecas, 0)} icon={<It className={`h-4 w-4`} />} /><_Component41 label={`Chapas necessárias`} value={Za(i.totalChapas, 0)} tone={`info`} /><_Component41 label={`Aproveitamento`} value={eo(i.aproveitamento)} tone={`success`} hint={`Sobra de ${$a(i.sobraM2)}`} /><_Component41 label={`Fita de borda`} value={`${Za(i.fitaBordaCm / 100, 2)} m`} icon={<_Component36 className={`h-4 w-4`} />} /></div><Rs className={`relative overflow-hidden p-4`}><div className={`absolute top-0 inset-x-0 h-1.5 regua-trena opacity-60 text-primary pointer-events-none`} /><div className={`mb-3 flex flex-wrap items-center justify-between gap-2`}><div><h3 className={`font-semibold text-foreground`}>{`Consumo por chapa`}</h3><p className={`text-xs text-muted-foreground`}>{`Base: chapa padrão `}{si.comprimento_cm}{` × `}{si.largura_cm}{` cm`}</p></div><div className={`flex gap-2`}><G variant={`outline`} size={`sm`} onClick={o}><_Component37 className={`h-4 w-4`} />{`Exportar lista`}</G><G variant={`outline`} size={`sm`} onClick={s}><Jn className={`h-4 w-4`} />{`Imprimir etiquetas`}</G></div></div><div className={`overflow-hidden rounded-lg border border-border`}><_Component28><_Component25><_Component24><J>{`Material`}</J><J>{`Espessura`}</J><J>{`Peças`}</J><J>{`Chapas`}</J><J>{`Área peças`}</J><J>{`Aproveitamento`}</J></_Component24></_Component25><_Component27>{i.grupos.map(e => <_Component24 key={e.chave}><Y className={`font-medium`}>{e.rotulo}</Y><Y className={`tabular-nums text-muted-foreground`}>{e.espessura_mm}{` mm`}</Y><Y className={`tabular-nums`}>{e.pecas}</Y><Y className={`tabular-nums`}>{e.chapas}</Y><Y className={`tabular-nums text-muted-foreground`}>{$a(e.areaPecasM2)}</Y><Y className={`tabular-nums font-semibold`}>{eo(e.aproveitamento)}</Y></_Component24>)}</_Component27></_Component28></div></Rs><Rs className={`relative overflow-hidden`}><div className={`absolute top-0 inset-x-0 h-1.5 regua-trena opacity-60 text-primary pointer-events-none`} /><div className={`border-b border-border p-4`}><h3 className={`font-semibold text-foreground`}>{`Lista de peças e corte`}</h3><p className={`text-xs text-muted-foreground`}>{`Códigos de identificação técnica e fitas de borda por peça.`}</p></div><_Component28><_Component25><_Component24><J className={`w-16`}>{`Cód.`}</J><J>{`Peça`}</J><J className={`hidden sm:table-cell`}>{`Ambiente`}</J><J>{`Dimensões de corte`}</J><J>{`Qtd`}</J><J className={`hidden lg:table-cell`}>{`Fita / bordas`}</J></_Component24></_Component25><_Component27>{a.map(({
              peca: e,
              codigo: t
            }) => <_Component24 key={e.id}><Y><span className={`font-mono text-xs font-bold text-primary bg-primary/10 px-1.5 py-0.5 rounded border border-primary/20`}>{t}</span></Y><Y className={`font-medium`}>{e.nome}</Y><Y className={`hidden sm:table-cell text-muted-foreground`}>{r(e.ambiente_id)}</Y><Y><span className={`cota-badge text-foreground`}>{e.comprimento_cm}{` × `}{e.largura_cm}{` `}<span className={`font-semibold text-primary`}>{`× `}{e.espessura_mm}{`mm`}</span></span></Y><Y className={`font-mono font-semibold tabular-nums`}>{e.quantidade}</Y><Y className={`hidden lg:table-cell text-muted-foreground`}>{oi[e.fita_tipo]}{`, `}{ds(e)}</Y></_Component24>)}</_Component27></_Component28></Rs></div>;
  }
}
var Cd = {
  elevador_tamanho: ``,
  elevador_ok: false,
  tem_escada: false,
  escada_observacoes: ``,
  estacionamento: ``,
  horario_permitido: ``,
  restricoes_condominio: ``,
  acesso_observacoes: ``,
  concluido: false
};
function _Component47({
  projeto: e
}) {
  let {
    data: t,
    isLoading: r
  } = Mu(e.id);
  let a = Nu(e.id);
  let {
    register: o,
    handleSubmit: s,
    reset: c,
    formState: {
      isSubmitting: l
    }
  } = i({
    resolver: n(pc),
    defaultValues: Cd
  });
  (0, k.useEffect)(() => {
    if (t) {
      c({
        elevador_tamanho: t.elevador_tamanho ?? ``,
        elevador_ok: t.elevador_ok,
        tem_escada: t.tem_escada,
        escada_observacoes: t.escada_observacoes ?? ``,
        estacionamento: t.estacionamento ?? ``,
        horario_permitido: t.horario_permitido ?? ``,
        restricoes_condominio: t.restricoes_condominio ?? ``,
        acesso_observacoes: t.acesso_observacoes ?? ``,
        concluido: t.concluido
      });
    }
  }, [t, c]);
  async function u(e) {
    await a.mutateAsync(El(e));
  }
  if (r) {
    return <Ks className={`h-64`} />;
  } else {
                    return <form onSubmit={s(u)} className={`space-y-6`}><Rs><_Component11><Bs className={`flex items-center gap-2 text-base`}><Jt className={`h-4 w-4`} />{`Condições de acesso ao local`}</Bs></_Component11><Hs className={`grid gap-4 sm:grid-cols-2`}><_Component19 label={`Tamanho do elevador`} htmlFor={`elevador_tamanho`}><K id={`elevador_tamanho`} placeholder={`Ex: 1,20 × 1,40 × 2,20 m`} {...o(`elevador_tamanho`)} /></_Component19><_Component19 label={`Estacionamento / vaga de carga`} htmlFor={`estacionamento`}><K id={`estacionamento`} {...o(`estacionamento`)} /></_Component19><_Component19 label={`Horário permitido`} htmlFor={`horario_permitido`}><K id={`horario_permitido`} placeholder={`Ex: 8h às 17h, seg a sex`} {...o(`horario_permitido`)} /></_Component19><div className={`flex items-end gap-6`}><_Component35 id={`elevador_ok`} label={`Elevador atende`} {...o(`elevador_ok`)} /><_Component35 id={`tem_escada`} label={`Há escadas`} {...o(`tem_escada`)} /></div><_Component19 label={`Observações sobre escadas`} htmlFor={`escada_observacoes`} className={`sm:col-span-2`}><K id={`escada_observacoes`} {...o(`escada_observacoes`)} /></_Component19><_Component19 label={`Restrições do condomínio`} htmlFor={`restricoes_condominio`} className={`sm:col-span-2`}><Rl id={`restricoes_condominio`} rows={3} {...o(`restricoes_condominio`)} /></_Component19><_Component19 label={`Outras observações de acesso`} htmlFor={`acesso_observacoes`} className={`sm:col-span-2`}><Rl id={`acesso_observacoes`} rows={3} {...o(`acesso_observacoes`)} /></_Component19><div className={`sm:col-span-2`}><_Component35 id={`concluido`} label={`Checklist técnico concluído`} {...o(`concluido`)} /></div></Hs></Rs><div className={`flex justify-end`}><G type={`submit`} disabled={l}>{l ? `Salvando...` : `Salvar checklist`}</G></div></form>;
  }
}
var Td = {
  foto: _n,
  pdf: un,
  croqui: Un,
  outro: Hn
};
function Ed({
  projeto: e
}) {
  let t = (0, k.useRef)(null);
  let [n, r] = (0, k.useState)(`foto`);
  let [i, a] = (0, k.useState)(``);
  let [o, s] = (0, k.useState)(null);
  let {
    data: c,
    isLoading: l
  } = Pu(e.id);
  let u = Fu(e.id);
  let d = Iu(e.id);
  async function f(e) {
    if (e && e.length !== 0) {
      for (let t of Array.from(e)) {
        try {
          await u.mutateAsync({
            file: t,
            categoria: n,
            ambienteId: i || null
          });
        } catch {}
      }
      if (t.current) {
        t.current.value = ``;
      }
    }
  }
  async function p(e) {
    try {
      let t = await ku(e.storage_path);
      window.open(t, `_blank`, `noopener`);
    } catch (e) {
      N.error(e.message);
    }
  }
                            return <div className={`space-y-4`}><Rs className={`p-4`}><p className={`mb-3 text-sm font-medium`}>{`Novo anexo`}</p><div className={`flex flex-col gap-3 sm:flex-row sm:items-end`}><div className={`sm:w-56`}><label className={`mb-1 block text-xs text-muted-foreground`}>{`Categoria`}</label><_Component31 value={n} onChange={e => r(e.target.value)}>{Object.keys(ni).map(e => <option value={e} key={e}>{ni[e]}</option>)}</_Component31></div><div className={`sm:w-56`}><label className={`mb-1 block text-xs text-muted-foreground`}>{`Ambiente (opcional)`}</label><_Component31 value={i} onChange={e => a(e.target.value)}><option value={``}>{`Geral do projeto`}</option>{e.ambientes.map(e => <option value={e.id} key={e.id}>{e.nome}</option>)}</_Component31></div><input ref={t} type={`file`} multiple={true} className={`hidden`} accept={`image/*,application/pdf`} onChange={e => void f(e.target.files)} /><G onClick={() => t.current?.click()} disabled={u.isPending}><_Component42 className={`h-4 w-4`} />{u.isPending ? `Enviando...` : `Enviar arquivo`}</G></div><p className={`mt-2 text-xs text-muted-foreground`}>{`Fotos in loco, PDFs arquitetônicos e croquis. Tamanho sugerido até 20 MB.`}</p></Rs>{l ? <Ks className={`h-40`} /> : c && c.length > 0 ? <div className={`grid gap-3 sm:grid-cols-2 lg:grid-cols-3`}>{c.map(e => {
        let _Component43 = Td[e.categoria];
                                                        return <Rs className={`flex items-start justify-between gap-3 p-4`} key={e.id}><div className={`flex min-w-0 gap-3`}><div className={`rounded-lg bg-muted p-2 text-muted-foreground`}><_Component43 className={`h-4 w-4`} /></div><div className={`min-w-0`}><p className={`truncate text-sm font-medium`}>{e.nome_arquivo}</p><p className={`text-xs text-muted-foreground`}>{ni[e.categoria]}{`, `}{ro(e.tamanho_bytes)}</p><p className={`text-xs text-muted-foreground`}>{no(e.created_at)}</p></div></div><Lo items={[{
            label: `Abrir`,
            icon: <_Component37 className={`h-4 w-4`} />,
            onSelect: () => void p(e)
          }, {
            label: `Remover`,
            icon: <_Component26 className={`h-4 w-4`} />,
            destructive: true,
            onSelect: () => s(e)
          }]} /></Rs>;
      })}</div> : <Ws icon={<Hn className={`h-8 w-8`} />} title={`Nenhum anexo`} description={`Envie fotos e documentos para registrar o levantamento.`} />}<_Component29 open={!!o} onOpenChange={e => !e && s(null)} title={`Remover anexo`} description={o ? `Remover "${o.nome_arquivo}"?` : undefined} confirmLabel={`Remover`} onConfirm={async () => {
      if (o) {
        await d.mutateAsync(o);
      }
    }} /></div>;
}
async function Dd(e) {
  let t = B.from(`orcamentos`).select(`*, projeto:projetos(id,nome), cliente:clientes(id,nome)`).order(`created_at`, {
    ascending: false
  });
  if (e?.projetoId) {
    t = t.eq(`projeto_id`, e.projetoId);
  }
  let {
    data: n,
    error: r
  } = await t;
  if (r) {
    throw r;
  }
  return n ?? [];
}
async function Od(e) {
  let {
    data: t,
    error: n
  } = await B.from(`orcamentos`).select(`*, projeto:projetos(id,nome), cliente:clientes(id,nome), itens:orcamento_itens(*)`).eq(`id`, e).order(`ordem`, {
    referencedTable: `orcamento_itens`,
    ascending: true
  }).single();
  if (n) {
    throw n;
  }
  return t;
}
async function kd(e) {
  let {
    projetoId: t,
    clienteId: n,
    custos: r,
    materialCusto: i,
    ferragensCusto: a,
    userId: o
  } = e;
  let {
    data: s
  } = await B.from(`orcamentos`).select(`versao`).eq(`projeto_id`, t).order(`versao`, {
    ascending: false
  }).limit(1).maybeSingle();
  let c = st({
    ...r,
    material_custo: i,
    ferragens_custo: a
  });
  let {
    data: l,
    error: u
  } = await B.from(`orcamentos`).insert({
    projeto_id: t,
    cliente_id: n,
    versao: (s?.versao ?? 0) + 1,
    ...r,
    material_custo: i,
    ferragens_custo: a,
    subtotal: c.subtotal,
    total: c.total,
    created_by: o
  }).select(`*`).single();
  if (u) {
    throw u;
  }
  return l;
}
async function Ad(e, t) {
  let n = st(t);
  let {
    data: r,
    error: i
  } = await B.from(`orcamentos`).update({
    ...t,
    subtotal: n.subtotal,
    total: n.total
  }).eq(`id`, e).select(`*`).single();
  if (i) {
    throw i;
  }
  return r;
}
async function jd(e, t) {
  let {
    error: n
  } = await B.from(`orcamentos`).update({
    status: t
  }).eq(`id`, e);
  if (n) {
    throw n;
  }
}
async function Md(e) {
  let {
    error: t
  } = await B.from(`orcamentos`).delete().eq(`id`, e);
  if (t) {
    throw t;
  }
}
async function Nd(e, t) {
  let {
    count: n
  } = await B.from(`orcamento_itens`).select(`id`, {
    count: `exact`,
    head: true
  }).eq(`orcamento_id`, e);
  let {
    data: r,
    error: i
  } = await B.from(`orcamento_itens`).insert({
    ...t,
    orcamento_id: e,
    ordem: n ?? 0
  }).select(`*`).single();
  if (i) {
    throw i;
  }
  return r;
}
async function Pd(e, t) {
  let {
    data: n,
    error: r
  } = await B.from(`orcamento_itens`).update(t).eq(`id`, e).select(`*`).single();
  if (r) {
    throw r;
  }
  return n;
}
async function Fd(e) {
  let {
    error: t
  } = await B.from(`orcamento_itens`).delete().eq(`id`, e);
  if (t) {
    throw t;
  }
}
function Id(e) {
  return T({
    queryKey: H.orcamentos(e),
    queryFn: () => Dd(e ? {
      projetoId: e
    } : undefined)
  });
}
function Ld(e) {
  return T({
    queryKey: H.orcamento(e ?? ``),
    queryFn: () => Od(e),
    enabled: !!e
  });
}
function Rd() {
  let e = C();
  let {
    user: t
  } = Ct();
  return O({
    mutationFn: e => kd({
      ...e,
      userId: t?.id ?? ``
    }),
    onSuccess: () => {
      e.invalidateQueries({
        queryKey: [`orcamentos`]
      });
      N.success(`Orçamento criado.`);
    },
    onError: e => N.error(e.message)
  });
}
function zd(e) {
  let t = C();
  return O({
    mutationFn: t => Ad(e, t),
    onSuccess: () => {
      t.invalidateQueries({
        queryKey: [`orcamentos`]
      });
      t.invalidateQueries({
        queryKey: H.orcamento(e ?? ``)
      });
      N.success(`Orçamento recalculado.`);
    },
    onError: e => N.error(e.message)
  });
}
function Bd() {
  let e = C();
  return O({
    mutationFn: ({
      id: e,
      status: t
    }) => jd(e, t),
    onSuccess: (t, n) => {
      e.invalidateQueries({
        queryKey: [`orcamentos`]
      });
      e.invalidateQueries({
        queryKey: H.orcamento(n.id)
      });
      N.success(`Status do orçamento atualizado.`);
    },
    onError: e => N.error(e.message)
  });
}
function Vd() {
  let e = C();
  return O({
    mutationFn: e => Md(e),
    onSuccess: () => {
      e.invalidateQueries({
        queryKey: [`orcamentos`]
      });
      N.success(`Orçamento removido.`);
    },
    onError: e => N.error(e.message)
  });
}
function Hd(e) {
  let t = C();
  return O({
    mutationFn: t => Nd(e, t),
    onSuccess: () => {
      t.invalidateQueries({
        queryKey: H.orcamento(e ?? ``)
      });
      N.success(`Item adicionado.`);
    },
    onError: e => N.error(e.message)
  });
}
function Ud(e) {
  let t = C();
  return O({
    mutationFn: ({
      id: e,
      payload: t
    }) => Pd(e, t),
    onSuccess: () => {
      t.invalidateQueries({
        queryKey: H.orcamento(e ?? ``)
      });
    },
    onError: e => N.error(e.message)
  });
}
function Wd(e) {
  let t = C();
  return O({
    mutationFn: e => Fd(e),
    onSuccess: () => {
      t.invalidateQueries({
        queryKey: H.orcamento(e ?? ``)
      });
      N.success(`Item removido.`);
    },
    onError: e => N.error(e.message)
  });
}
function Gd({
  projeto: e
}) {
  let t = f();
  let {
    data: n,
    isLoading: r
  } = Id(e.id);
      return <div className={`space-y-4`}><div className={`flex justify-end`}><G size={`sm`} onClick={() => t(`/orcamentos?projeto=${e.id}&novo=1`)}><_Component10 className={`h-4 w-4`} />{`Novo orçamento`}</G></div>{r ? <Ks className={`h-40`} /> : n && n.length > 0 ? <Rs className={`overflow-hidden`}><_Component28><_Component25><_Component24><J>{`Versão`}</J><J>{`Status`}</J><J>{`Total`}</J><J className={`hidden sm:table-cell`}>{`Criado em`}</J><J className={`w-24 text-right`}>{`Ações`}</J></_Component24></_Component25><_Component27>{n.map(e => <_Component24 key={e.id}><Y className={`font-medium`}>{`v`}{e.versao}</Y><Y><Gs label={$r[e.status]} tone={ei[e.status]} /></Y><Y className={`tabular-nums`}>{W(e.total)}</Y><Y className={`hidden sm:table-cell text-muted-foreground`}>{to(e.created_at)}</Y><Y className={`text-right`}><G variant={`outline`} size={`sm`} onClick={() => t(`/orcamentos/${e.id}`)}>{`Abrir`}</G></Y></_Component24>)}</_Component27></_Component28></Rs> : <Ws icon={<Bt className={`h-8 w-8`} />} title={`Nenhum orçamento`} description={`Gere uma proposta comercial a partir das peças e custos do projeto.`} action={<G size={`sm`} onClick={() => t(`/orcamentos?projeto=${e.id}&novo=1`)}><_Component10 className={`h-4 w-4`} />{`Novo orçamento`}</G>} />}</div>;
}
var Kd = `*, projeto:projetos(id,nome,status), cliente:clientes(id,nome,documento), orcamento:orcamentos(id,versao,total)`;
async function qd(e) {
  let t = B.from(`contratos`).select(Kd).order(`created_at`, {
    ascending: false
  });
  if (e?.status && e.status !== `todos`) {
    t = t.eq(`status`, e.status);
  }
  if (e?.projetoId) {
    t = t.eq(`projeto_id`, e.projetoId);
  }
  if (e?.clienteId) {
    t = t.eq(`cliente_id`, e.clienteId);
  }
  if (e?.busca && e.busca.trim().length > 0) {
    let n = e.busca.trim().replace(/[%,]/g, ``);
    t = t.ilike(`numero`, `%${n}%`);
  }
  let {
    data: n,
    error: r
  } = await t;
  if (r) {
    throw r;
  }
  return n ?? [];
}
async function Jd(e) {
  let {
    data: t,
    error: n
  } = await B.from(`contratos`).select(`${Kd}, lancamentos:lancamentos(*)`).eq(`id`, e).order(`parcela_numero`, {
    referencedTable: `lancamentos`,
    ascending: true
  }).single();
  if (n) {
    throw n;
  }
  return t;
}
async function Yd(e) {
  let {
    data: t,
    error: n
  } = await B.rpc(`criar_contrato`, Nl(e));
  if (n) {
    throw n;
  }
  return t;
}
async function Xd(e, t) {
  let {
    data: n,
    error: r
  } = await B.from(`contratos`).update(t).eq(`id`, e).select(`*`).single();
  if (r) {
    throw r;
  }
  return n;
}
async function Zd(e) {
  let {
    data: t,
    error: n
  } = await B.rpc(`assinar_contrato`, {
    _id: e.id,
    _signatario_nome: e.signatarioNome,
    _signatario_documento: e.signatarioDocumento,
    _assinatura_data: e.assinaturaData
  });
  if (n) {
    throw n;
  }
  return t;
}
async function Qd(e) {
  let {
    data: t,
    error: n
  } = await B.rpc(`cancelar_contrato`, {
    _id: e
  });
  if (n) {
    throw n;
  }
  return t;
}
async function $d(e) {
  let {
    error: t
  } = await B.from(`contratos`).delete().eq(`id`, e);
  if (t) {
    throw t;
  }
}
async function ef(e) {
  let {
    data: t,
    error: n
  } = await B.from(`contratos`).select(`id, numero, status, valor_total, assinado_em`).eq(`projeto_id`, e).order(`created_at`, {
    ascending: false
  });
  if (n) {
    throw n;
  }
  return t ?? [];
}
function tf(e) {
  return T({
    queryKey: H.contratos(e),
    queryFn: () => qd(e)
  });
}
function nf(e) {
  return T({
    queryKey: H.contrato(e ?? ``),
    queryFn: () => Jd(e),
    enabled: !!e
  });
}
function rf(e) {
  return T({
    queryKey: H.contratosProjeto(e ?? ``),
    queryFn: () => ef(e),
    enabled: !!e
  });
}
function af() {
  let e = C();
  return O({
    mutationFn: e => Yd(e),
    onSuccess: () => {
      e.invalidateQueries({
        queryKey: [`contratos`]
      });
      e.invalidateQueries({
        queryKey: [`lancamentos`]
      });
      e.invalidateQueries({
        queryKey: H.dashboard
      });
      N.success(`Contrato criado com as parcelas.`);
    },
    onError: e => N.error(cu(e))
  });
}
function of(e) {
  let t = C();
  return O({
    mutationFn: t => Xd(e, t),
    onSuccess: () => {
      t.invalidateQueries({
        queryKey: [`contratos`]
      });
      t.invalidateQueries({
        queryKey: H.contrato(e ?? ``)
      });
      N.success(`Contrato atualizado.`);
    },
    onError: e => N.error(cu(e))
  });
}
function sf() {
  let e = C();
  return O({
    mutationFn: Zd,
    onSuccess: (t, n) => {
      e.invalidateQueries({
        queryKey: [`contratos`]
      });
      e.invalidateQueries({
        queryKey: H.contrato(n.id)
      });
      N.success(`Contrato assinado.`);
    },
    onError: e => N.error(cu(e))
  });
}
function cf() {
  let e = C();
  return O({
    mutationFn: e => Qd(e),
    onSuccess: (t, n) => {
      e.invalidateQueries({
        queryKey: [`contratos`]
      });
      e.invalidateQueries({
        queryKey: H.contrato(n)
      });
      e.invalidateQueries({
        queryKey: [`lancamentos`]
      });
      N.success(`Contrato cancelado e parcelas em aberto canceladas.`);
    },
    onError: e => N.error(cu(e))
  });
}
function lf() {
  let e = C();
  return O({
    mutationFn: e => $d(e),
    onSuccess: () => {
      e.invalidateQueries({
        queryKey: [`contratos`]
      });
      e.invalidateQueries({
        queryKey: [`lancamentos`]
      });
      e.invalidateQueries({
        queryKey: H.dashboard
      });
      N.success(`Contrato removido.`);
    },
    onError: e => N.error(cu(e))
  });
}
function uf(e, t, n, r) {
  return `Pelo presente instrumento particular, a CONTRATADA compromete-se a fabricar e instalar os moveis planejados do projeto "${e}" para o(a) CONTRATANTE ${t}, pelo valor total de ${n}, dividido em ${r} parcela(s) conforme o cronograma de pagamento anexo a este contrato. A CONTRATANTE declara estar ciente das medidas, do acabamento e do prazo de entrega acordados.`;
}
function _Component44({
  open: e,
  onOpenChange: t,
  projetoId: r,
  orcamentoId: a,
  valorInicial: o
}) {
  let s = f();
  let c = af();
  let {
    data: l
  } = Jl();
  let {
    data: u
  } = Ir();
  let {
    register: d,
    handleSubmit: p,
    reset: m,
    watch: h,
    setValue: g,
    formState: {
      errors: _,
      isSubmitting: v
    }
  } = i({
    resolver: n(Tc),
    defaultValues: {
      projeto_id: ``,
      cliente_id: ``,
      orcamento_id: ``,
      valor_total: ``,
      num_parcelas: `1`,
      intervalo_dias: `30`,
      primeiro_vencimento: uo(),
      conteudo: ``,
      termos: ``,
      observacoes: ``
    }
  });
  let y = h(`projeto_id`);
  let {
    data: b
  } = Id(y || undefined);
  let x = (0, k.useMemo)(() => (l ?? []).find(e => e.id === y), [l, y]);
  let S = _l(h(`valor_total`) || `0`);
  let C = Number(h(`num_parcelas`) || `1`);
  let w = Number(h(`intervalo_dias`) || `30`);
  let T = h(`primeiro_vencimento`) || uo();
  let E = (0, k.useMemo)(() => !S || !C ? [] : _s(S, C, T, w), [S, C, T, w]);
  (0, k.useEffect)(() => {
    if (!e) {
      return;
    }
    let t = r ? (l ?? []).find(e => e.id === r) : undefined;
    let n = o ? String(o) : ``;
    m({
      projeto_id: r ?? ``,
      cliente_id: t?.cliente_id ?? ``,
      orcamento_id: a ?? ``,
      valor_total: n,
      num_parcelas: `1`,
      intervalo_dias: `30`,
      primeiro_vencimento: uo(),
      conteudo: t ? uf(t.nome, t.cliente?.nome ?? `cliente`, o ? W(o) : `R$ 0,00`, `1`) : ``,
      termos: u?.termos_contrato ?? ``,
      observacoes: ``
    });
  }, [e, r, a, o, l, u, m]);
  async function D(e) {
    let n = await c.mutateAsync(e);
    t(false);
    s(`/contratos/${n.id}`);
  }
  let O = x?.cliente?.nome ?? `cliente`;
                      return <_Component21 open={e} onOpenChange={t} title={`Novo contrato`} description={`Gera o cronograma de parcelas no financeiro automaticamente.`} size={`xl`} footer={<L.Fragment><G variant={`outline`} onClick={() => t(false)} disabled={v}>{`Cancelar`}</G><G form={`contrato-form`} type={`submit`} disabled={v}>{v ? `Gerando...` : `Gerar contrato`}</G></L.Fragment>}><form id={`contrato-form`} onSubmit={p(D)} className={`grid gap-4 sm:grid-cols-3`}><input type={`hidden`} {...d(`cliente_id`)} /><_Component19 label={`Projeto`} htmlFor={`ct-projeto`} error={_.projeto_id?.message} required={true} className={`sm:col-span-2`}><_Component31 id={`ct-projeto`} value={h(`projeto_id`)} disabled={!!r} onChange={e => {
          let t = e.target.value;
          let n = (l ?? []).find(e => e.id === t);
          g(`projeto_id`, t);
          g(`cliente_id`, n?.cliente_id ?? ``);
          g(`orcamento_id`, ``);
          if (n) {
            g(`conteudo`, uf(n.nome, n.cliente?.nome ?? `cliente`, S ? W(S) : `R$ 0,00`, String(C)));
          }
        }}><option value={``}>{`Selecione um projeto`}</option>{(l ?? []).map(e => <option value={e.id} key={e.id}>{e.nome}{` (`}{e.cliente?.nome ?? `sem cliente`}{`)`}</option>)}</_Component31></_Component19><_Component19 label={`Cliente`} htmlFor={`ct-cliente`}><K id={`ct-cliente`} value={x?.cliente?.nome ?? ``} readOnly={true} disabled={true} /></_Component19><_Component19 label={`Orçamento aprovado`} htmlFor={`ct-orcamento`} error={_.orcamento_id?.message} hint={`Opcional. Preenche o valor total.`} className={`sm:col-span-2`}><_Component31 id={`ct-orcamento`} value={h(`orcamento_id`)} onChange={e => {
          let t = e.target.value;
          g(`orcamento_id`, t);
          let n = (b ?? []).find(e => e.id === t);
          if (n) {
            g(`valor_total`, String(n.total));
          }
        }}><option value={``}>{`Sem vínculo`}</option>{(b ?? []).map(e => <option value={e.id} key={e.id}>{`v`}{e.versao}{` - `}{W(e.total)}</option>)}</_Component31></_Component19><_Component19 label={`Valor total (R$)`} htmlFor={`ct-valor`} error={_.valor_total?.message} required={true}><K id={`ct-valor`} inputMode={`decimal`} {...d(`valor_total`)} /></_Component19><_Component19 label={`Parcelas`} htmlFor={`ct-parcelas`} error={_.num_parcelas?.message} required={true}><K id={`ct-parcelas`} inputMode={`numeric`} {...d(`num_parcelas`)} /></_Component19><_Component19 label={`Intervalo`} htmlFor={`ct-intervalo`} error={_.intervalo_dias?.message} required={true}><_Component31 id={`ct-intervalo`} {...d(`intervalo_dias`)}>{_i.map(e => <option value={e.dias} key={e.dias}>{e.label}{` (`}{e.dias}{` dias)`}</option>)}</_Component31></_Component19><_Component19 label={`1º vencimento`} htmlFor={`ct-vencimento`} error={_.primeiro_vencimento?.message} required={true}><K id={`ct-vencimento`} type={`date`} {...d(`primeiro_vencimento`)} /></_Component19><_Component19 label={`Conteúdo do contrato`} htmlFor={`ct-conteudo`} error={_.conteudo?.message} className={`sm:col-span-3`}><Rl id={`ct-conteudo`} rows={3} placeholder={uf(x?.nome ?? `projeto`, O, S ? W(S) : `R$ 0,00`, String(C))} {...d(`conteudo`)} /></_Component19><_Component19 label={`Termos e condições`} htmlFor={`ct-termos`} error={_.termos?.message} className={`sm:col-span-3`}><Rl id={`ct-termos`} rows={4} {...d(`termos`)} /></_Component19><_Component19 label={`Observações`} htmlFor={`ct-obs`} error={_.observacoes?.message} className={`sm:col-span-3`}><Rl id={`ct-obs`} rows={2} {...d(`observacoes`)} /></_Component19>{E.length > 0 && <div className={`sm:col-span-3`}><p className={`mb-2 text-[13px] font-medium`}>{`Cronograma previsto (`}{E.length}{` parcelas)`}</p><div className={`max-h-48 overflow-y-auto rounded-[10px] border border-border`}><_Component28><_Component25><_Component24><J className={`w-16`}>{`#`}</J><J>{`Vencimento`}</J><J className={`text-right`}>{`Valor`}</J></_Component24></_Component25><_Component27>{E.map(e => <_Component24 key={e.numero}><Y className={`numero text-muted-foreground`}>{e.numero}</Y><Y>{to(e.vencimento)}</Y><Y className={`numero text-right`}>{W(e.valor)}</Y></_Component24>)}</_Component27></_Component28></div></div>}</form></_Component21>;
}
function _Component48({
  projeto: e
}) {
  let t = f();
  let [n, r] = (0, k.useState)(false);
  let {
    data: i,
    isLoading: a
  } = rf(e.id);
  let o = (i ?? []).filter(e => e.status === `assinado`);
        return <div className={`space-y-4`}><div className={`flex flex-wrap items-center justify-between gap-3`}><p className={`text-[13px] text-muted-foreground`}>{o.length > 0 ? `${o.length} contrato(s) assinado(s), ${W(o.reduce((e, t) => e + Number(t.valor_total), 0))} em carteira.` : `Nenhum contrato assinado para este projeto.`}</p><G size={`sm`} onClick={() => r(true)}><_Component10 className={`h-4 w-4`} />{`Novo contrato`}</G></div>{a ? <_Component23 columns={4} /> : i && i.length > 0 ? <Rs className={`overflow-hidden`}><_Component28><_Component25><_Component24><J>{`Número`}</J><J>{`Valor`}</J><J>{`Status`}</J><J className={`hidden sm:table-cell`}>{`Assinatura`}</J><J className={`w-24 text-right`}>{`Ações`}</J></_Component24></_Component25><_Component27>{i.map(e => <_Component24 key={e.id}><Y className={`numero font-medium`}>{e.numero}</Y><Y className={`numero`}>{W(e.valor_total)}</Y><Y><Gs label={ui[e.status]} tone={di[e.status]} /></Y><Y className={`hidden sm:table-cell text-muted-foreground`}>{e.assinado_em ? to(e.assinado_em) : `-`}</Y><Y className={`text-right`}><G variant={`outline`} size={`sm`} onClick={() => t(`/contratos/${e.id}`)}>{`Abrir`}</G></Y></_Component24>)}</_Component27></_Component28></Rs> : <Ws icon={<_Component5 className={`h-4 w-4`} />} title={`Nenhum contrato`} description={`Gere o contrato deste projeto para liberar as parcelas no financeiro.`} action={<G size={`sm`} onClick={() => r(true)}><_Component10 className={`h-4 w-4`} />{`Novo contrato`}</G>} />}<_Component44 open={n} onOpenChange={r} projetoId={e.id} /></div>;
}
var pf = `*, projeto:projetos(id,nome,status,cliente:clientes(id,nome)), montador:profiles(id,full_name)`;
async function mf(e) {
  let t = B.from(`ordens_servico`).select(pf).order(`data_prevista_entrega`, {
    ascending: true,
    nullsFirst: false
  }).order(`created_at`, {
    ascending: false
  });
  if (e?.status && e.status !== `todos`) {
    t = t.eq(`status`, e.status);
  }
  if (e?.projetoId) {
    t = t.eq(`projeto_id`, e.projetoId);
  }
  let {
    data: n,
    error: r
  } = await t;
  if (r) {
    throw r;
  }
  return n ?? [];
}
async function hf(e) {
  let {
    data: t,
    error: n
  } = await B.from(`ordens_servico`).select(pf).eq(`id`, e).single();
  if (n) {
    throw n;
  }
  return t;
}
async function gf(e, t) {
  let {
    data: n,
    error: r
  } = await B.rpc(`proximo_numero_os`);
  if (r) {
    throw r;
  }
  let {
    data: i,
    error: a
  } = await B.from(`ordens_servico`).insert({
    ...e,
    numero: n,
    created_by: t
  }).select(`*`).single();
  if (a) {
    throw a;
  }
  return i;
}
async function _f(e, t) {
  let {
    data: n,
    error: r
  } = await B.from(`ordens_servico`).update(t).eq(`id`, e).select(`*`).single();
  if (r) {
    throw r;
  }
  return n;
}
async function vf(e, t) {
  let n = {
    status: t
  };
  if (t === `concluido`) {
    n.data_entrega_real = new Date().toISOString().slice(0, 10);
  }
  let {
    error: r
  } = await B.from(`ordens_servico`).update(n).eq(`id`, e);
  if (r) {
    throw r;
  }
}
async function yf(e) {
  let {
    error: t
  } = await B.from(`ordens_servico`).delete().eq(`id`, e);
  if (t) {
    throw t;
  }
}
async function bf(e) {
  let {
    data: t,
    error: n
  } = await B.from(`termos_conclusao`).select(`*`).eq(`projeto_id`, e).order(`assinado_em`, {
    ascending: false
  });
  if (n) {
    throw n;
  }
  return t ?? [];
}
async function xf(e, t) {
  let {
    data: n,
    error: r
  } = await B.from(`termos_conclusao`).insert({
    ...e,
    created_by: t
  }).select(`*`).single();
  if (r) {
    throw r;
  }
  return n;
}
async function Sf(e) {
  let {
    error: t
  } = await B.from(`termos_conclusao`).delete().eq(`id`, e);
  if (t) {
    throw t;
  }
}
function Cf(e) {
  return T({
    queryKey: H.ordens(e),
    queryFn: () => mf(e)
  });
}
function wf(e) {
  return T({
    queryKey: H.ordem(e ?? ``),
    queryFn: () => hf(e),
    enabled: !!e
  });
}
function Tf() {
  let e = C();
  let {
    user: t
  } = Ct();
  return O({
    mutationFn: e => gf(e, t?.id ?? ``),
    onSuccess: () => {
      e.invalidateQueries({
        queryKey: [`ordens`]
      });
      e.invalidateQueries({
        queryKey: H.dashboard
      });
      N.success(`Ordem de serviço criada.`);
    },
    onError: e => N.error(e.message)
  });
}
function Ef() {
  let e = C();
  return O({
    mutationFn: ({
      id: e,
      payload: t
    }) => _f(e, t),
    onSuccess: (t, n) => {
      e.invalidateQueries({
        queryKey: [`ordens`]
      });
      e.invalidateQueries({
        queryKey: H.ordem(n.id)
      });
      e.invalidateQueries({
        queryKey: H.dashboard
      });
      N.success(`Ordem de serviço atualizada.`);
    },
    onError: e => N.error(e.message)
  });
}
function Df() {
  let e = C();
  return O({
    mutationFn: ({
      id: e,
      status: t
    }) => vf(e, t),
    onSuccess: (t, n) => {
      e.invalidateQueries({
        queryKey: [`ordens`]
      });
      e.invalidateQueries({
        queryKey: H.ordem(n.id)
      });
      e.invalidateQueries({
        queryKey: H.dashboard
      });
      N.success(`Status da ordem atualizado.`);
    },
    onError: e => N.error(e.message)
  });
}
function Of() {
  let e = C();
  return O({
    mutationFn: e => yf(e),
    onSuccess: () => {
      e.invalidateQueries({
        queryKey: [`ordens`]
      });
      e.invalidateQueries({
        queryKey: H.dashboard
      });
      N.success(`Ordem de serviço removida.`);
    },
    onError: e => N.error(e.message)
  });
}
function kf(e) {
  return T({
    queryKey: H.termos(e ?? ``),
    queryFn: () => bf(e),
    enabled: !!e
  });
}
function Af(e) {
  let t = C();
  let {
    user: n
  } = Ct();
  return O({
    mutationFn: t => xf({
      ...t,
      projeto_id: e
    }, n?.id ?? ``),
    onSuccess: () => {
      t.invalidateQueries({
        queryKey: H.termos(e ?? ``)
      });
      N.success(`Termo de conclusão registrado.`);
    },
    onError: e => N.error(e.message)
  });
}
function jf(e) {
  let t = C();
  return O({
    mutationFn: e => Sf(e),
    onSuccess: () => {
      t.invalidateQueries({
        queryKey: H.termos(e ?? ``)
      });
      N.success(`Termo removido.`);
    },
    onError: e => N.error(e.message)
  });
}
function Mf({
  open: e,
  onOpenChange: t,
  projeto: r
}) {
  let a = Tf();
  let {
    data: o
  } = Lr();
  let {
    register: s,
    handleSubmit: c,
    reset: l,
    formState: {
      errors: u,
      isSubmitting: d
    }
  } = i({
    resolver: n(bc),
    defaultValues: {
      projeto_id: r.id,
      status: `aguardando_corte`,
      data_prevista_entrega: r.data_entrega_prevista ?? ``,
      montador_id: ``,
      frete: `0`,
      montagem_horas: `0`,
      observacoes: ``
    }
  });
  (0, k.useEffect)(() => {
    if (e) {
      l({
        projeto_id: r.id,
        status: `aguardando_corte`,
        data_prevista_entrega: r.data_entrega_prevista ?? ``,
        montador_id: ``,
        frete: `0`,
        montagem_horas: `0`,
        observacoes: ``
      });
    }
  }, [e, r, l]);
  async function f(e) {
    await a.mutateAsync(Al(e));
    t(false);
  }
            return <_Component21 open={e} onOpenChange={t} title={`Nova ordem de serviço`} description={`Produção de ${r.nome}`} footer={<L.Fragment><G variant={`outline`} onClick={() => t(false)} disabled={d}>{`Cancelar`}</G><G form={`ordem-form`} type={`submit`} disabled={d}>{d ? `Criando...` : `Criar ordem`}</G></L.Fragment>}><form id={`ordem-form`} onSubmit={c(f)} className={`grid gap-4 sm:grid-cols-2`}><input type={`hidden`} {...s(`projeto_id`)} /><_Component19 label={`Status inicial`} htmlFor={`os-status`} error={u.status?.message}><_Component31 id={`os-status`} {...s(`status`)}>{Zr.map(e => <option value={e} key={e}>{Xr[e]}</option>)}</_Component31></_Component19><_Component19 label={`Entrega prevista`} htmlFor={`os-entrega`} error={u.data_prevista_entrega?.message}><K id={`os-entrega`} type={`date`} {...s(`data_prevista_entrega`)} /></_Component19><_Component19 label={`Montador responsável`} htmlFor={`os-montador`} error={u.montador_id?.message}><_Component31 id={`os-montador`} {...s(`montador_id`)}><option value={``}>{`Definir depois`}</option>{(o ?? []).map(e => <option value={e.id} key={e.id}>{e.full_name ?? e.email}</option>)}</_Component31></_Component19><_Component19 label={`Horas de montagem`} htmlFor={`os-horas`} error={u.montagem_horas?.message}><K id={`os-horas`} inputMode={`decimal`} {...s(`montagem_horas`)} /></_Component19><_Component19 label={`Frete (R$)`} htmlFor={`os-frete`} error={u.frete?.message}><K id={`os-frete`} inputMode={`decimal`} {...s(`frete`)} /></_Component19><_Component19 label={`Observações`} htmlFor={`os-obs`} error={u.observacoes?.message} className={`sm:col-span-2`}><Rl id={`os-obs`} rows={3} {...s(`observacoes`)} /></_Component19></form></_Component21>;
}
function Nf({
  projeto: e
}) {
  let t = f();
  let [n, r] = (0, k.useState)(false);
  let {
    data: i,
    isLoading: a
  } = Cf({
    projetoId: e.id
  });
  let o = Df();
            return <div className={`space-y-4`}><div className={`flex justify-end`}><G size={`sm`} onClick={() => r(true)}><_Component10 className={`h-4 w-4`} />{`Nova ordem`}</G></div>{a ? <Ks className={`h-40`} /> : i && i.length > 0 ? <Rs className={`overflow-hidden`}><_Component28><_Component25><_Component24><J>{`Número`}</J><J>{`Fila de produção`}</J><J className={`hidden sm:table-cell`}>{`Entrega`}</J><J className={`hidden md:table-cell`}>{`Montador`}</J><J className={`w-24 text-right`}>{`Ações`}</J></_Component24></_Component25><_Component27>{i.map(e => <_Component24 key={e.id}><Y className={`font-medium`}>{e.numero}</Y><Y><div className={`flex items-center gap-2`}><Gs label={Xr[e.status]} tone={Qr[e.status]} /><_Component31 aria-label={`Alterar status`} className={`h-7 w-40 text-xs`} value={e.status} onChange={t => o.mutate({
                  id: e.id,
                  status: t.target.value
                })}>{Zr.map(e => <option value={e} key={e}>{Xr[e]}</option>)}<option value={`cancelado`}>{Xr.cancelado}</option></_Component31></div></Y><Y className={`hidden sm:table-cell text-muted-foreground`}>{to(e.data_prevista_entrega)}</Y><Y className={`hidden md:table-cell text-muted-foreground`}>{e.montador?.full_name ?? `-`}</Y><Y className={`text-right`}><G variant={`outline`} size={`sm`} onClick={() => t(`/ordens/${e.id}`)}>{`Abrir`}</G></Y></_Component24>)}</_Component27></_Component28></Rs> : <Ws icon={<Yt className={`h-8 w-8`} />} title={`Sem ordens de serviço`} description={`Crie uma ordem para acompanhar corte, bordas, pré-montagem e instalação.`} action={<G size={`sm`} onClick={() => r(true)}><_Component10 className={`h-4 w-4`} />{`Nova ordem`}</G>} />}<Mf open={n} onOpenChange={r} projeto={e} /></div>;
}
function Pf({
  onChange: e,
  className: t,
  height: n = 180
}) {
  let r = (0, k.useRef)(null);
  let i = (0, k.useRef)(false);
  let a = (0, k.useRef)(null);
  let [o, s] = (0, k.useState)(false);
  (0, k.useEffect)(() => {
    let e = r.current;
    if (!e) {
      return;
    }
    let t = window.devicePixelRatio || 1;
    e.width = e.clientWidth * t;
    e.height = n * t;
    let i = e.getContext(`2d`);
    if (i) {
      i.scale(t, t);
      i.lineWidth = 2;
      i.lineCap = `round`;
      i.lineJoin = `round`;
      i.strokeStyle = getComputedStyle(e).color || `#111827`;
    }
  }, [n]);
  function c(e) {
    let t = e.currentTarget.getBoundingClientRect();
    return {
      x: e.clientX - t.left,
      y: e.clientY - t.top
    };
  }
  function l(e) {
    e.currentTarget.setPointerCapture(e.pointerId);
    i.current = true;
    a.current = c(e);
  }
  function u(e) {
    if (!i.current) {
      return;
    }
    let t = r.current?.getContext(`2d`);
    let n = c(e);
    if (t && a.current) {
      t.beginPath();
      t.moveTo(a.current.x, a.current.y);
      t.lineTo(n.x, n.y);
      t.stroke();
      a.current = n;
      if (!o) {
        s(true);
      }
    }
  }
  function d() {
    if (!i.current) {
      return;
    }
    i.current = false;
    a.current = null;
    let t = r.current;
    if (t) {
      e(t.toDataURL(`image/png`));
    }
  }
  function f() {
    let t = r.current;
    let n = t?.getContext(`2d`);
    if (t && n) {
      n.clearRect(0, 0, t.width, t.height);
      s(false);
      e(null);
    }
  }
            return <div className={U(`space-y-2`, t)}><div className={`rounded-lg border border-dashed border-border bg-background p-1`}><canvas ref={r} style={{
        height: n,
        touchAction: `none`
      }} className={`w-full text-foreground`} onPointerDown={l} onPointerMove={u} onPointerUp={d} onPointerLeave={d} /></div><div className={`flex items-center justify-between`}><p className={`text-xs text-muted-foreground`}>{o ? `Assinatura capturada.` : `Assine no quadro acima.`}</p><G type={`button`} variant={`ghost`} size={`sm`} onClick={f} disabled={!o}><_Component45 className={`h-3.5 w-3.5`} />{`Limpar`}</G></div></div>;
}
function Ff(e) {
  return `Declaro que os móveis planejados do projeto "${e.nome}" foram entregues e montados no local, conferidos quanto a medidas, acabamento e funcionamento, estando de acordo com o que foi contratado. Declaro ainda ter recebido as orientações de uso, limpeza e conservação dos móveis.`;
}
function If({
  projeto: e
}) {
  let [t, r] = (0, k.useState)(false);
  let [a, o] = (0, k.useState)(null);
  let [s, c] = (0, k.useState)(null);
  let {
    data: l,
    isLoading: u
  } = kf(e.id);
  let {
    data: d
  } = Cf({
    projetoId: e.id
  });
  let {
    data: f
  } = Ir();
  let p = Af(e.id);
  let m = jf(e.id);
  let {
    register: h,
    handleSubmit: g,
    reset: _,
    formState: {
      errors: v,
      isSubmitting: y
    }
  } = i({
    resolver: n(xc),
    defaultValues: {
      signatario_nome: e.cliente?.nome ?? ``,
      signatario_documento: e.cliente?.documento ?? ``,
      os_id: ``,
      conteudo: Ff(e)
    }
  });
  (0, k.useEffect)(() => {
    if (t) {
      _({
        signatario_nome: e.cliente?.nome ?? ``,
        signatario_documento: e.cliente?.documento ?? ``,
        os_id: ``,
        conteudo: Ff(e)
      });
    }
  }, [t, e, _]);
  async function b(e) {
    if (!a) {
      N.error(`Colete a assinatura do cliente no quadro.`);
      return;
    }
    await p.mutateAsync({
      os_id: e.os_id || null,
      conteudo: e.conteudo,
      signatario_nome: e.signatario_nome,
      signatario_documento: e.signatario_documento || null,
      assinatura_data: a
    });
    r(false);
  }
  function x(t) {
    yd(`Termo de conclusão, ${e.nome}`, `<h1>Termo de conclusão de montagem</h1>
       <p class="meta">${f?.name ?? `Marcenaria`}${f?.documento ? ` · CNPJ/CPF ${ao(f.documento)}` : ``}</p>
       <table>
         <tr><th>Projeto</th><td>${e.nome}</td></tr>
         <tr><th>Cliente</th><td>${e.cliente?.nome ?? `-`}</td></tr>
         <tr><th>Signatário</th><td>${t.signatario_nome}${t.signatario_documento ? ` · ${ao(t.signatario_documento)}` : ``}</td></tr>
         <tr><th>Assinado em</th><td>${no(t.assinado_em)}</td></tr>
       </table>
       <h2>Declaração</h2>
       <p style="font-size:13px;line-height:1.6">${t.conteudo}</p>
       <h2>Assinatura do cliente</h2>
       ${t.assinatura_data ? `<img src="${t.assinatura_data}" alt="Assinatura" style="max-width:360px;border-bottom:1px solid #111827" />` : `<p>Sem assinatura registrada.</p>`}
       <p style="font-size:12px;color:#6b7280;margin-top:24px">Documento gerado eletronicamente por Planejados Pro.</p>`);
  }
                                  return <div className={`space-y-4`}><div className={`flex justify-end`}><G size={`sm`} onClick={() => {
        o(null);
        r(true);
      }}><_Component10 className={`h-4 w-4`} />{`Registrar termo`}</G></div>{u ? <Ks className={`h-40`} /> : l && l.length > 0 ? <div className={`space-y-3`}>{l.map(e => <Rs className={`p-4`} key={e.id}><div className={`flex flex-wrap items-start justify-between gap-3`}><div className={`space-y-1`}><p className={`flex items-center gap-2 font-medium`}><_Component5 className={`h-4 w-4 text-muted-foreground`} />{e.signatario_nome}{e.signatario_documento ? `, ${ao(e.signatario_documento)}` : ``}</p><p className={`text-xs text-muted-foreground`}>{`Assinado em `}{no(e.assinado_em)}</p><p className={`max-w-2xl text-sm text-muted-foreground`}>{e.conteudo}</p>{e.assinatura_data && <img src={e.assinatura_data} alt={`Assinatura do cliente`} className={`mt-2 h-20 rounded border border-border bg-background object-contain p-1`} />}</div><div className={`flex gap-2`}><G variant={`outline`} size={`sm`} onClick={() => x(e)}><Jn className={`h-4 w-4`} />{`Imprimir`}</G><G variant={`ghost`} size={`icon`} onClick={() => c(e)} aria-label={`Remover termo`}><_Component26 className={`h-4 w-4 text-destructive`} /></G></div></div></Rs>)}</div> : <Ws icon={<_Component5 className={`h-8 w-8`} />} title={`Nenhum termo de conclusão`} description={`Após a montagem, colete a assinatura do cliente na tela.`} />}<_Component21 open={t} onOpenChange={r} title={`Termo de conclusão digital`} description={`Confirme a entrega e colete a assinatura do cliente final.`} size={`lg`} footer={<L.Fragment><G variant={`outline`} onClick={() => r(false)} disabled={y}>{`Cancelar`}</G><G form={`termo-form`} type={`submit`} disabled={y}>{y ? `Registrando...` : `Registrar termo`}</G></L.Fragment>}><form id={`termo-form`} onSubmit={g(b)} className={`space-y-4`}><div className={`grid gap-4 sm:grid-cols-2`}><_Component19 label={`Nome do signatário`} htmlFor={`signatario_nome`} error={v.signatario_nome?.message} required={true}><K id={`signatario_nome`} {...h(`signatario_nome`)} /></_Component19><_Component19 label={`CPF do signatário`} htmlFor={`signatario_documento`} error={v.signatario_documento?.message}><K id={`signatario_documento`} {...h(`signatario_documento`)} /></_Component19></div><_Component19 label={`Ordem de serviço vinculada`} htmlFor={`os_id`} error={v.os_id?.message}><_Component31 id={`os_id`} {...h(`os_id`)}><option value={``}>{`Não vincular`}</option>{(d ?? []).map(e => <option value={e.id} key={e.id}>{e.numero}{` (`}{to(e.data_prevista_entrega)}{`)`}</option>)}</_Component31></_Component19><_Component19 label={`Texto do termo`} htmlFor={`conteudo`} error={v.conteudo?.message} required={true}><Rl id={`conteudo`} rows={6} {...h(`conteudo`)} /></_Component19><div><p className={`mb-2 text-sm font-medium`}>{`Assinatura do cliente`}</p><Pf onChange={o} /></div></form></_Component21><_Component29 open={!!s} onOpenChange={e => !e && c(null)} title={`Remover termo`} description={`O registro de assinatura será excluído permanentemente.`} confirmLabel={`Remover`} onConfirm={async () => {
      if (s) {
        await m.mutateAsync(s.id);
      }
    }} /></div>;
}
function Lf() {
  let {
    id: e
  } = g();
  let t = f();
  let [n, r] = (0, k.useState)(`ambientes`);
  let [i, a] = (0, k.useState)(false);
  let {
    data: o,
    isLoading: s
  } = Yl(e);
  let c = Ql();
  if (s) {
    return <Ks className={`h-64`} />;
  }
  if (!o) {
    return <Ws title={`Projeto não encontrado`} action={<G variant={`outline`} onClick={() => t(`/projetos`)}><Mt className={`h-4 w-4`} />{`Voltar`}</G>} />;
  }
  let l = Jr.indexOf(o.status);
              return <div className={`space-y-6`}><Fs title={o.nome} description={<span className={`flex flex-wrap items-center gap-x-4 gap-y-1`}><span className={`inline-flex items-center gap-1`}><Sr className={`h-3.5 w-3.5`} />{o.cliente?.nome ?? `Sem cliente`}</span><span className={`inline-flex items-center gap-1`}><Ht className={`h-3.5 w-3.5`} />{`Entrega prevista `}{to(o.data_entrega_prevista)}</span></span>} actions={<L.Fragment><G variant={`outline`} onClick={() => t(`/projetos`)}><Mt className={`h-4 w-4`} />{`Voltar`}</G><G onClick={() => a(true)}><Wn className={`h-4 w-4`} />{`Editar projeto`}</G></L.Fragment>} /><div className={`flex flex-wrap items-center gap-2`}>{Jr.map((e, t) => {
        let n = o.status === e;
                return <button type={`button`} onClick={() => c.mutate({
          id: o.id,
          status: e
        })} className={U(`rounded-full border px-3 py-1 text-xs font-medium transition-colors`, n ? `border-foreground bg-foreground text-background` : l > t ? `border-emerald-500/40 bg-emerald-500/10 text-emerald-600 dark:text-emerald-400` : `border-border text-muted-foreground hover:text-foreground`)} key={e}>{qr[e]}</button>;
      })}{o.status === `cancelado` && <span className={`rounded-full border border-rose-500/30 bg-rose-500/10 px-3 py-1 text-xs font-medium text-rose-600 dark:text-rose-400`}>{`Cancelado`}</span>}</div><_Component32 value={n} onValueChange={r} tabs={[{
      value: `ambientes`,
      label: `Ambientes`
    }, {
      value: `corte`,
      label: `Plano de corte`
    }, {
      value: `checklist`,
      label: `Checklist técnico`
    }, {
      value: `anexos`,
      label: `Anexos`
    }, {
      value: `orcamentos`,
      label: `Orçamentos`
    }, {
      value: `contratos`,
      label: `Contratos`
    }, {
      value: `producao`,
      label: `Produção`
    }, {
      value: `termo`,
      label: `Termo de conclusão`
    }]} />{n === `ambientes` && <_Component46 projeto={o} />}{n === `corte` && <Sd projeto={o} />}{n === `checklist` && <_Component47 projeto={o} />}{n === `anexos` && <Ed projeto={o} />}{n === `orcamentos` && <Gd projeto={o} />}{n === `contratos` && <_Component48 projeto={o} />}{n === `producao` && <Nf projeto={o} />}{n === `termo` && <If projeto={o} />}<_Component33 open={i} onOpenChange={a} projeto={o} /></div>;
}
var Rf = {
  categoria: `chapa`,
  nome: ``,
  codigo: ``,
  descricao: ``,
  unidade: `un`,
  cor: ``,
  espessura_mm: ``,
  acabamento: ``,
  custo_unitario: `0`,
  preco_unitario: `0`,
  estoque_minimo: `0`,
  estoque_atual: `0`,
  ativo: true
};
function _Component51({
  open: e,
  onOpenChange: t,
  material: r
}) {
  let a = td();
  let o = nd();
  let {
    register: s,
    handleSubmit: c,
    reset: l,
    formState: {
      errors: u,
      isSubmitting: d
    }
  } = i({
    resolver: n(mc),
    defaultValues: Rf
  });
  (0, k.useEffect)(() => {
    if (e) {
      l(r ? {
        categoria: r.categoria,
        nome: r.nome,
        codigo: r.codigo ?? ``,
        descricao: r.descricao ?? ``,
        unidade: r.unidade,
        cor: r.cor ?? ``,
        espessura_mm: r.espessura_mm === null ? `` : String(r.espessura_mm),
        acabamento: r.acabamento ?? ``,
        custo_unitario: String(r.custo_unitario),
        preco_unitario: String(r.preco_unitario),
        estoque_minimo: String(r.estoque_minimo),
        estoque_atual: String(r.estoque_atual),
        ativo: r.ativo
      } : Rf);
    }
  }, [e, r, l]);
  async function f(e) {
    let n = Dl(e);
    if (r) {
      await o.mutateAsync({
        id: r.id,
        payload: n
      });
    } else {
      await a.mutateAsync(n);
    }
    t(false);
  }
        return <_Component21 open={e} onOpenChange={t} title={r ? `Editar material` : `Novo material`} description={`Chapas, ferragens e consumíveis do catálogo.`} size={`lg`} footer={<L.Fragment><G variant={`outline`} onClick={() => t(false)} disabled={d}>{`Cancelar`}</G><G form={`material-form`} type={`submit`} disabled={d}>{d ? `Salvando...` : `Salvar`}</G></L.Fragment>}><form id={`material-form`} onSubmit={c(f)} className={`grid gap-4 sm:grid-cols-2`}><_Component19 label={`Categoria`} htmlFor={`categoria`} error={u.categoria?.message} required={true}><_Component31 id={`categoria`} {...s(`categoria`)}>{Object.keys(ti).map(e => <option value={e} key={e}>{ti[e]}</option>)}</_Component31></_Component19><_Component19 label={`Unidade`} htmlFor={`unidade`} error={u.unidade?.message} hint={`un, m², chapa, m, kg...`}><K id={`unidade`} {...s(`unidade`)} /></_Component19><_Component19 label={`Nome`} htmlFor={`material-nome`} error={u.nome?.message} required={true} className={`sm:col-span-2`}><K id={`material-nome`} {...s(`nome`)} /></_Component19><_Component19 label={`Código`} htmlFor={`codigo`} error={u.codigo?.message}><K id={`codigo`} {...s(`codigo`)} /></_Component19><_Component19 label={`Cor`} htmlFor={`cor`} error={u.cor?.message}><K id={`cor`} {...s(`cor`)} /></_Component19><_Component19 label={`Espessura (mm)`} htmlFor={`espessura_mm`} error={u.espessura_mm?.message}><K id={`espessura_mm`} inputMode={`decimal`} {...s(`espessura_mm`)} /></_Component19><_Component19 label={`Acabamento`} htmlFor={`acabamento`} error={u.acabamento?.message}><K id={`acabamento`} placeholder={`Ex: fosco, texturizado`} {...s(`acabamento`)} /></_Component19><_Component19 label={`Custo unitário (R$)`} htmlFor={`custo_unitario`} error={u.custo_unitario?.message} required={true}><K id={`custo_unitario`} inputMode={`decimal`} {...s(`custo_unitario`)} /></_Component19><_Component19 label={`Preço de venda (R$)`} htmlFor={`preco_unitario`} error={u.preco_unitario?.message} required={true}><K id={`preco_unitario`} inputMode={`decimal`} {...s(`preco_unitario`)} /></_Component19><_Component19 label={`Estoque mínimo`} htmlFor={`estoque_minimo`} error={u.estoque_minimo?.message} required={true}><K id={`estoque_minimo`} inputMode={`decimal`} {...s(`estoque_minimo`)} /></_Component19><_Component19 label={`Estoque atual`} htmlFor={`estoque_atual`} error={u.estoque_atual?.message} required={true}><K id={`estoque_atual`} inputMode={`decimal`} {...s(`estoque_atual`)} /></_Component19><_Component19 label={`Descrição`} htmlFor={`material-desc`} error={u.descricao?.message} className={`sm:col-span-2`}><Rl id={`material-desc`} rows={2} {...s(`descricao`)} /></_Component19><div className={`sm:col-span-2`}><_Component35 id={`ativo`} label={`Material ativo`} {...s(`ativo`)} /></div></form></_Component21>;
}
function Bf({
  open: e,
  onOpenChange: t,
  materialId: r = ``,
  projetoId: a = ``,
  tipoInicial: o = `entrada`
}) {
  let {
    data: s
  } = ed();
  let {
    data: c
  } = Jl();
  let l = ad();
  let {
    register: u,
    handleSubmit: d,
    reset: f,
    formState: {
      errors: p,
      isSubmitting: m
    }
  } = i({
    resolver: n(hc),
    defaultValues: {
      material_id: r,
      tipo: o,
      quantidade: ``,
      custo_unitario: `0`,
      motivo: ``,
      projeto_id: a
    }
  });
  (0, k.useEffect)(() => {
    if (e) {
      f({
        material_id: r,
        tipo: o,
        quantidade: ``,
        custo_unitario: `0`,
        motivo: ``,
        projeto_id: a
      });
    }
  }, [e, r, a, o, f]);
  async function h(e) {
    await l.mutateAsync({
      material_id: e.material_id,
      tipo: e.tipo,
      quantidade: _l(e.quantidade),
      custo_unitario: _l(e.custo_unitario),
      motivo: gl(e.motivo),
      projeto_id: e.projeto_id === `` ? null : e.projeto_id
    });
    t(false);
  }
                return <_Component21 open={e} onOpenChange={t} title={`Movimentação de estoque`} description={`Registre entradas por compra ou saídas vinculadas a um projeto.`} footer={<L.Fragment><G variant={`outline`} onClick={() => t(false)} disabled={m}>{`Cancelar`}</G><G form={`mov-form`} type={`submit`} disabled={m}>{m ? `Registrando...` : `Registrar`}</G></L.Fragment>}><form id={`mov-form`} onSubmit={d(h)} className={`grid gap-4 sm:grid-cols-2`}><_Component19 label={`Material`} htmlFor={`mov-material`} error={p.material_id?.message} required={true} className={`sm:col-span-2`}><_Component31 id={`mov-material`} {...u(`material_id`)}><option value={``}>{`Selecione um material`}</option>{(s ?? []).map(e => <option value={e.id} key={e.id}>{`[`}{ti[e.categoria]}{`] `}{e.nome}{e.cor ? `, ${e.cor}` : ``}{` (`}{e.unidade}{`)`}</option>)}</_Component31></_Component19><_Component19 label={`Tipo`} htmlFor={`mov-tipo`} error={p.tipo?.message}><_Component31 id={`mov-tipo`} {...u(`tipo`)}><option value={`entrada`}>{`Entrada`}</option><option value={`saida`}>{`Saída`}</option></_Component31></_Component19><_Component19 label={`Quantidade`} htmlFor={`mov-qtd`} error={p.quantidade?.message} required={true}><K id={`mov-qtd`} inputMode={`decimal`} {...u(`quantidade`)} /></_Component19><_Component19 label={`Custo unitário (R$)`} htmlFor={`mov-custo`} error={p.custo_unitario?.message}><K id={`mov-custo`} inputMode={`decimal`} {...u(`custo_unitario`)} /></_Component19><_Component19 label={`Projeto vinculado`} htmlFor={`mov-projeto`} error={p.projeto_id?.message}><_Component31 id={`mov-projeto`} {...u(`projeto_id`)}><option value={``}>{`Nenhum`}</option>{(c ?? []).map(e => <option value={e.id} key={e.id}>{e.nome}</option>)}</_Component31></_Component19><_Component19 label={`Motivo`} htmlFor={`mov-motivo`} error={p.motivo?.message} className={`sm:col-span-2`}><K id={`mov-motivo`} placeholder={`Ex: compra fornecedor, baixa para produção`} {...u(`motivo`)} /></_Component19></form></_Component21>;
}
var Vf = {
  material_id: ``,
  projeto_id: ``,
  largura_cm: ``,
  altura_cm: ``,
  espessura_mm: ``,
  quantidade: `1`,
  local: ``,
  observacoes: ``,
  consumido: false
};
function Hf({
  open: e,
  onOpenChange: t,
  retalho: r
}) {
  let a = sd();
  let o = cd();
  let {
    data: s
  } = ed({
    categoria: `chapa`
  });
  let {
    data: c
  } = Jl();
  let {
    register: l,
    handleSubmit: u,
    reset: d,
    formState: {
      errors: f,
      isSubmitting: p
    }
  } = i({
    resolver: n(gc),
    defaultValues: Vf
  });
  (0, k.useEffect)(() => {
    if (e) {
      d(r ? {
        material_id: r.material_id,
        projeto_id: r.projeto_id ?? ``,
        largura_cm: String(r.largura_cm),
        altura_cm: String(r.altura_cm),
        espessura_mm: r.espessura_mm === null ? `` : String(r.espessura_mm),
        quantidade: String(r.quantidade),
        local: r.local ?? ``,
        observacoes: r.observacoes ?? ``,
        consumido: r.consumido
      } : Vf);
    }
  }, [e, r, d]);
  async function m(e) {
    let n = kl(e);
    if (r) {
      await o.mutateAsync({
        id: r.id,
        payload: n
      });
    } else {
      await a.mutateAsync(n);
    }
    t(false);
  }
              return <_Component21 open={e} onOpenChange={t} title={r ? `Editar retalho` : `Novo retalho`} description={`Sobras de corte que podem ser reaproveitadas.`} footer={<L.Fragment><G variant={`outline`} onClick={() => t(false)} disabled={p}>{`Cancelar`}</G><G form={`retalho-form`} type={`submit`} disabled={p}>{p ? `Salvando...` : `Salvar`}</G></L.Fragment>}><form id={`retalho-form`} onSubmit={u(m)} className={`grid gap-4 sm:grid-cols-2`}><_Component19 label={`Material (chapa)`} htmlFor={`ret-material`} error={f.material_id?.message} required={true} className={`sm:col-span-2`}><_Component31 id={`ret-material`} {...l(`material_id`)}><option value={``}>{`Selecione`}</option>{(s ?? []).map(e => <option value={e.id} key={e.id}>{e.nome}{e.cor ? `, ${e.cor}` : ``}</option>)}</_Component31></_Component19><_Component19 label={`Projeto de origem`} htmlFor={`ret-projeto`} error={f.projeto_id?.message}><_Component31 id={`ret-projeto`} {...l(`projeto_id`)}><option value={``}>{`Nenhum`}</option>{(c ?? []).map(e => <option value={e.id} key={e.id}>{e.nome}</option>)}</_Component31></_Component19><_Component19 label={`Local de armazenamento`} htmlFor={`ret-local`} error={f.local?.message}><K id={`ret-local`} placeholder={`Ex: prateleira B2`} {...l(`local`)} /></_Component19><_Component19 label={`Largura (cm)`} htmlFor={`ret-largura`} error={f.largura_cm?.message} required={true}><K id={`ret-largura`} inputMode={`decimal`} {...l(`largura_cm`)} /></_Component19><_Component19 label={`Altura (cm)`} htmlFor={`ret-altura`} error={f.altura_cm?.message} required={true}><K id={`ret-altura`} inputMode={`decimal`} {...l(`altura_cm`)} /></_Component19><_Component19 label={`Espessura (mm)`} htmlFor={`ret-esp`} error={f.espessura_mm?.message}><K id={`ret-esp`} inputMode={`decimal`} {...l(`espessura_mm`)} /></_Component19><_Component19 label={`Quantidade`} htmlFor={`ret-qtd`} error={f.quantidade?.message} required={true}><K id={`ret-qtd`} inputMode={`numeric`} {...l(`quantidade`)} /></_Component19><_Component19 label={`Observações`} htmlFor={`ret-obs`} error={f.observacoes?.message} className={`sm:col-span-2`}><Rl id={`ret-obs`} rows={2} {...l(`observacoes`)} /></_Component19><div className={`sm:col-span-2`}><_Component35 id={`consumido`} label={`Já consumido`} {...l(`consumido`)} /></div></form></_Component21>;
}
function Uf() {
  let [e, t] = S();
  let [n, r] = (0, k.useState)(`materiais`);
  let [i, a] = (0, k.useState)(`todos`);
  let [o, s] = (0, k.useState)(``);
  let [c, l] = (0, k.useState)(false);
  let [u, d] = (0, k.useState)(null);
  let [f, p] = (0, k.useState)(e.get(`novo`) === `1`);
  let [m, h] = (0, k.useState)(``);
  let [g, _] = (0, k.useState)(null);
  let [v, y] = (0, k.useState)(false);
  let [b, x] = (0, k.useState)(null);
  let [C, w] = (0, k.useState)(null);
  let {
    data: T,
    isLoading: E
  } = ed();
  let {
    data: D,
    isLoading: O
  } = id();
  let {
    data: A,
    isLoading: ee
  } = od();
  let {
    data: te
  } = Jl();
  let j = rd();
  let ne = ld();
  let re = (0, k.useMemo)(() => {
    let e = new Map((T ?? []).map(e => [e.id, e.nome]));
    return t => e.get(t) ?? `-`;
  }, [T]);
  let M = (0, k.useMemo)(() => {
    let e = new Map((te ?? []).map(e => [e.id, e.nome]));
    return t => t ? e.get(t) ?? `-` : `-`;
  }, [te]);
  let ie = (0, k.useMemo)(() => {
    let e = o.trim().toLowerCase();
    return (T ?? []).filter(t => {
      let n = i === `todos` || t.categoria === i;
      let r = e === `` || t.nome.toLowerCase().includes(e) || (t.codigo ?? ``).toLowerCase().includes(e) || (t.cor ?? ``).toLowerCase().includes(e);
      return n && r;
    });
  }, [T, i, o]);
  let ae = (T ?? []).filter(e => e.ativo && Number(e.estoque_atual) <= Number(e.estoque_minimo)).length;
  function oe(n = ``) {
    h(n);
    p(true);
    if (e.has(`novo`)) {
      e.delete(`novo`);
      t(e, {
        replace: true
      });
    }
  }
                      return <div className={`space-y-6`}><Fs title={`Estoque e matéria-prima`} description={`Chapas, ferragens, consumíveis e reaproveitamento de retalhos.`} actions={<L.Fragment><G variant={`outline`} onClick={() => oe()}><_Component49 className={`h-4 w-4`} />{`Entrada/saída`}</G><G onClick={() => {
        d(null);
        l(true);
      }}><_Component10 className={`h-4 w-4`} />{`Novo material`}</G></L.Fragment>}><div className={`flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between`}><_Component32 value={n} onValueChange={r} tabs={[{
          value: `materiais`,
          label: `Materiais`,
          count: T?.length ?? 0
        }, {
          value: `movimentacoes`,
          label: `Movimentações`
        }, {
          value: `retalhos`,
          label: `Retalhos`,
          count: A?.length ?? 0
        }]} />{n === `materiais` && <div className={`flex flex-col gap-2 sm:flex-row`}><_Component31 wrapperClassName={`w-full sm:w-48`} value={i} onChange={e => a(e.target.value)}><option value={`todos`}>{`Todas as categorias`}</option>{Object.keys(ti).map(e => <option value={e} key={e}>{ti[e]}</option>)}</_Component31><div className={`relative w-full sm:w-64`}><_Component22 className={`pointer-events-none absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-muted-foreground`} /><K value={o} onChange={e => s(e.target.value)} placeholder={`Buscar material`} className={`pl-9`} /></div></div>}</div></Fs>{n === `materiais` && (E ? <_Component23 columns={5} /> : ie.length > 0 ? <L.Fragment>{ae > 0 && <div className={`flex items-center gap-2 rounded-lg border border-amber-500/30 bg-amber-500/10 px-3 py-2 text-sm text-amber-700 dark:text-amber-400`}><_Component50 className={`h-4 w-4`} />{ae}{` item(ns) abaixo do estoque mínimo.`}</div>}<Rs className={`overflow-hidden`}><_Component28><_Component25><_Component24><J>{`Material`}</J><J className={`hidden sm:table-cell`}>{`Categoria`}</J><J>{`Custo`}</J><J>{`Estoque`}</J><J className={`w-12 text-right`}>{`Ações`}</J></_Component24></_Component25><_Component27>{ie.map(e => {
              let t = Number(e.estoque_atual) <= Number(e.estoque_minimo);
                                                                      return <_Component24 key={e.id}><Y><p className={`font-medium`}>{e.nome}</p><p className={`text-xs text-muted-foreground`}>{[e.cor, e.espessura_mm ? `${e.espessura_mm}mm` : null, e.acabamento].filter(Boolean).join(`, `) || `-`}</p></Y><Y className={`hidden sm:table-cell text-muted-foreground`}>{ti[e.categoria]}</Y><Y className={`tabular-nums text-muted-foreground`}>{W(e.custo_unitario)}{`/`}{e.unidade}</Y><Y><span className={U(`tabular-nums`, t ? `text-amber-600 dark:text-amber-400` : ``)}>{Za(e.estoque_atual, 2)}{` `}{e.unidade}</span><span className={`block text-xs text-muted-foreground`}>{`mín. `}{Za(e.estoque_minimo, 2)}</span></Y><Y className={`text-right`}><Lo items={[{
                    label: `Registrar entrada`,
                    icon: <_Component49 className={`h-4 w-4`} />,
                    onSelect: () => oe(e.id)
                  }, {
                    label: `Editar`,
                    icon: <Wn className={`h-4 w-4`} />,
                    onSelect: () => {
                      d(e);
                      l(true);
                    }
                  }, {
                    label: `Remover`,
                    icon: <_Component26 className={`h-4 w-4`} />,
                    destructive: true,
                    onSelect: () => _(e)
                  }]} /></Y></_Component24>;
            })}</_Component27></_Component28></Rs></L.Fragment> : <Ws icon={<Rt className={`h-8 w-8`} />} title={`Nenhum material cadastrado`} description={`Cadastre chapas, ferragens e consumíveis para controlar o estoque.`} action={<G onClick={() => {
      d(null);
      l(true);
    }}><_Component10 className={`h-4 w-4`} />{`Novo material`}</G>} />)}{n === `movimentacoes` && (O ? <_Component23 columns={4} /> : D && D.length > 0 ? <Rs className={`overflow-hidden`}><_Component28><_Component25><_Component24><J>{`Data`}</J><J>{`Tipo`}</J><J>{`Material`}</J><J>{`Quantidade`}</J><J className={`hidden md:table-cell`}>{`Motivo`}</J><J className={`hidden lg:table-cell`}>{`Projeto`}</J></_Component24></_Component25><_Component27>{D.map(e => <_Component24 key={e.id}><Y className={`text-muted-foreground`}>{no(e.created_at)}</Y><Y><span className={U(`inline-flex items-center gap-1 text-sm font-medium`, e.tipo === `entrada` ? `text-emerald-600 dark:text-emerald-400` : `text-rose-600 dark:text-rose-400`)}>{e.tipo === `entrada` ? <_Component49 className={`h-3.5 w-3.5`} /> : <Nt className={`h-3.5 w-3.5`} />}{ri[e.tipo]}</span></Y><Y className={`font-medium`}>{re(e.material_id)}</Y><Y className={`tabular-nums`}>{Za(e.quantidade, 2)}</Y><Y className={`hidden md:table-cell text-muted-foreground`}>{e.motivo ?? `-`}</Y><Y className={`hidden lg:table-cell text-muted-foreground`}>{M(e.projeto_id)}</Y></_Component24>)}</_Component27></_Component28></Rs> : <Ws title={`Sem movimentações`} description={`Entradas e saídas de estoque aparecerão aqui.`} />)}{n === `retalhos` && <div className={`space-y-4`}><div className={`flex justify-end`}><G size={`sm`} onClick={() => {
          x(null);
          y(true);
        }}><_Component10 className={`h-4 w-4`} />{`Novo retalho`}</G></div>{ee ? <_Component23 columns={4} /> : A && A.length > 0 ? <Rs className={`overflow-hidden`}><_Component28><_Component25><_Component24><J>{`Material`}</J><J>{`Dimensões`}</J><J>{`Qtd`}</J><J className={`hidden sm:table-cell`}>{`Local`}</J><J>{`Situação`}</J><J className={`w-12 text-right`}>{`Ações`}</J></_Component24></_Component25><_Component27>{A.map(e => <_Component24 key={e.id}><Y className={`font-medium`}>{re(e.material_id)}</Y><Y className={`tabular-nums text-muted-foreground`}>{Qa(e.largura_cm)}{` × `}{Qa(e.altura_cm)}</Y><Y className={`tabular-nums`}>{e.quantidade}</Y><Y className={`hidden sm:table-cell text-muted-foreground`}>{e.local ?? `-`}</Y><Y><Gs label={e.consumido ? `Consumido` : `Disponível`} tone={e.consumido ? `bg-slate-500/10 text-slate-600 dark:text-slate-300 border-slate-500/20` : `bg-emerald-500/10 text-emerald-600 dark:text-emerald-400 border-emerald-500/20`} /></Y><Y className={`text-right`}><Lo items={[{
                  label: `Editar`,
                  icon: <Wn className={`h-4 w-4`} />,
                  onSelect: () => {
                    x(e);
                    y(true);
                  }
                }, {
                  label: `Remover`,
                  icon: <_Component26 className={`h-4 w-4`} />,
                  destructive: true,
                  onSelect: () => w(e)
                }]} /></Y></_Component24>)}</_Component27></_Component28></Rs> : <Ws title={`Nenhum retalho registrado`} description={`Registre sobras de cortes anteriores para reaproveitar.`} />}</div>}<_Component51 open={c} onOpenChange={l} material={u} /><Bf open={f} onOpenChange={p} materialId={m} tipoInicial={`entrada`} /><Hf open={v} onOpenChange={y} retalho={b} /><_Component29 open={!!g} onOpenChange={e => !e && _(null)} title={`Remover material`} description={g ? `Remover ${g.nome} do catálogo?` : undefined} confirmLabel={`Remover`} onConfirm={async () => {
      if (g) {
        await j.mutateAsync(g.id);
      }
    }} /><_Component29 open={!!C} onOpenChange={e => !e && w(null)} title={`Remover retalho`} confirmLabel={`Remover`} onConfirm={async () => {
      if (C) {
        await ne.mutateAsync(C.id);
      }
    }} /></div>;
}
var Wf = vc.extend({
  projeto_id: o().trim().min(1, `Selecione um projeto`),
  ferragens_custo: Zs(0)
});
var Gf = {
  projeto_id: ``,
  ferragens_custo: `0`,
  perda_percent: `5`,
  operacional_custo: `0`,
  montagem_horas: `0`,
  montagem_valor_hora: `0`,
  frete: `0`,
  impostos_percent: `0`,
  margem_percent: `30`,
  validade_dias: `15`,
  observacoes: ``
};
function Kf({
  open: e,
  onOpenChange: t,
  projetoId: r
}) {
  let {
    data: a
  } = Jl();
  let {
    data: o
  } = ed();
  let s = Rd();
  let {
    register: c,
    handleSubmit: l,
    reset: u,
    watch: d,
    formState: {
      errors: f,
      isSubmitting: p
    }
  } = i({
    resolver: n(Wf),
    defaultValues: Gf
  });
  let {
    data: m
  } = Uu(d(`projeto_id`) || undefined);
  (0, k.useEffect)(() => {
    if (e) {
      u({
        ...Gf,
        projeto_id: r ?? ``
      });
    }
  }, [e, r, u]);
  let h = (0, k.useMemo)(() => !m || !o ? 0 : ps(m.map(e => ({
    material_id: e.material_id,
    comprimento_cm: Number(e.comprimento_cm),
    largura_cm: Number(e.largura_cm),
    quantidade: e.quantidade
  })), o.map(e => ({
    id: e.id,
    unidade: e.unidade,
    custo_unitario: Number(e.custo_unitario)
  })), {
    comprimento_cm: si.comprimento_cm,
    largura_cm: si.largura_cm
  }), [m, o]);
  async function g(e) {
    let n = (a ?? []).find(t => t.id === e.projeto_id);
    if (!n) {
      return;
    }
    let r = {
      perda_percent: _l(e.perda_percent),
      operacional_custo: _l(e.operacional_custo),
      montagem_horas: _l(e.montagem_horas),
      montagem_valor_hora: _l(e.montagem_valor_hora),
      frete: _l(e.frete),
      impostos_percent: _l(e.impostos_percent),
      margem_percent: _l(e.margem_percent),
      validade_dias: Math.trunc(_l(e.validade_dias)),
      observacoes: e.observacoes.trim() === `` ? null : e.observacoes.trim()
    };
    await s.mutateAsync({
      projetoId: e.projeto_id,
      clienteId: n.cliente_id,
      custos: r,
      materialCusto: h,
      ferragensCusto: _l(e.ferragens_custo)
    });
    t(false);
  }
            return <_Component21 open={e} onOpenChange={t} title={`Novo orçamento`} description={`Custos internos de produção. O cliente não vê estes valores.`} size={`lg`} footer={<L.Fragment><G variant={`outline`} onClick={() => t(false)} disabled={p}>{`Cancelar`}</G><G form={`orcamento-form`} type={`submit`} disabled={p}>{p ? `Gerando...` : `Gerar orçamento`}</G></L.Fragment>}><form id={`orcamento-form`} onSubmit={l(g)} className={`grid gap-4 sm:grid-cols-3`}><_Component19 label={`Projeto`} htmlFor={`orc-projeto`} error={f.projeto_id?.message} required={true} className={`sm:col-span-3`}><_Component31 id={`orc-projeto`} {...c(`projeto_id`)}><option value={``}>{`Selecione um projeto`}</option>{(a ?? []).map(e => <option value={e.id} key={e.id}>{e.nome}{` (`}{e.cliente?.nome ?? `sem cliente`}{`)`}</option>)}</_Component31></_Component19><div className={`flex items-center gap-2 rounded-lg border border-border bg-muted/40 p-3 text-sm sm:col-span-3`}><_Component52 className={`h-4 w-4 text-muted-foreground`} />{`Custo de matéria-prima calculado a partir das peças:`}{` `}<span className={`font-semibold`}>{W(h)}</span></div><_Component19 label={`Ferragens (R$)`} htmlFor={`orc-ferragens`} error={f.ferragens_custo?.message}><K id={`orc-ferragens`} inputMode={`decimal`} {...c(`ferragens_custo`)} /></_Component19><_Component19 label={`Perda estimada (%)`} htmlFor={`orc-perda`} error={f.perda_percent?.message}><K id={`orc-perda`} inputMode={`decimal`} {...c(`perda_percent`)} /></_Component19><_Component19 label={`Custos operacionais (R$)`} htmlFor={`orc-oper`} error={f.operacional_custo?.message}><K id={`orc-oper`} inputMode={`decimal`} {...c(`operacional_custo`)} /></_Component19><_Component19 label={`Horas de montagem`} htmlFor={`orc-horas`} error={f.montagem_horas?.message}><K id={`orc-horas`} inputMode={`decimal`} {...c(`montagem_horas`)} /></_Component19><_Component19 label={`Valor/hora (R$)`} htmlFor={`orc-valorhora`} error={f.montagem_valor_hora?.message}><K id={`orc-valorhora`} inputMode={`decimal`} {...c(`montagem_valor_hora`)} /></_Component19><_Component19 label={`Frete (R$)`} htmlFor={`orc-frete`} error={f.frete?.message}><K id={`orc-frete`} inputMode={`decimal`} {...c(`frete`)} /></_Component19><_Component19 label={`Impostos (%)`} htmlFor={`orc-impostos`} error={f.impostos_percent?.message}><K id={`orc-impostos`} inputMode={`decimal`} {...c(`impostos_percent`)} /></_Component19><_Component19 label={`Margem de lucro (%)`} htmlFor={`orc-margem`} error={f.margem_percent?.message}><K id={`orc-margem`} inputMode={`decimal`} {...c(`margem_percent`)} /></_Component19><_Component19 label={`Validade (dias)`} htmlFor={`orc-validade`} error={f.validade_dias?.message}><K id={`orc-validade`} inputMode={`numeric`} {...c(`validade_dias`)} /></_Component19><_Component19 label={`Observações`} htmlFor={`orc-obs`} error={f.observacoes?.message} className={`sm:col-span-3`}><Rl id={`orc-obs`} rows={2} {...c(`observacoes`)} /></_Component19></form></_Component21>;
}
function _Component102() {
  let e = f();
  let [t, n] = S();
  let r = t.get(`projeto`) ?? undefined;
  let [i, a] = (0, k.useState)(t.get(`novo`) === `1`);
  let [o, s] = (0, k.useState)(null);
  let {
    data: c,
    isLoading: l
  } = Id();
  let u = Vd();
  function d() {
    a(true);
    if (t.has(`novo`)) {
      t.delete(`novo`);
      n(t, {
        replace: true
      });
    }
  }
      return <div className={`space-y-6`}><Fs title={`Orçamentos`} description={`Composição de custos, margem e propostas comerciais.`} actions={<G onClick={d}><_Component10 className={`h-4 w-4`} />{`Novo orçamento`}</G>} />{l ? <_Component23 columns={5} /> : c && c.length > 0 ? <Rs className={`overflow-hidden`}><_Component28><_Component25><_Component24><J>{`Projeto`}</J><J className={`hidden sm:table-cell`}>{`Cliente`}</J><J>{`Versão`}</J><J>{`Status`}</J><J>{`Total`}</J><J className={`hidden md:table-cell`}>{`Criado`}</J><J className={`w-12 text-right`}>{`Ações`}</J></_Component24></_Component25><_Component27>{c.map(t => <_Component24 key={t.id}><Y><button type={`button`} className={`font-medium hover:underline`} onClick={() => e(`/orcamentos/${t.id}`)}>{t.projeto?.nome ?? `-`}</button></Y><Y className={`hidden sm:table-cell text-muted-foreground`}>{t.cliente?.nome ?? `-`}</Y><Y className={`text-muted-foreground`}>{`v`}{t.versao}</Y><Y><Gs label={$r[t.status]} tone={ei[t.status]} /></Y><Y className={`tabular-nums`}>{W(t.total)}</Y><Y className={`hidden md:table-cell text-muted-foreground`}>{to(t.created_at)}</Y><Y className={`text-right`}><Lo items={[{
                label: `Abrir`,
                icon: <Bt className={`h-4 w-4`} />,
                onSelect: () => e(`/orcamentos/${t.id}`)
              }, {
                label: `Remover`,
                icon: <_Component26 className={`h-4 w-4`} />,
                destructive: true,
                onSelect: () => s(t)
              }]} /></Y></_Component24>)}</_Component27></_Component28></Rs> : <Ws icon={<Bt className={`h-8 w-8`} />} title={`Nenhum orçamento`} description={`Gere orçamentos a partir das peças e custos de cada projeto.`} action={<G onClick={d}><_Component10 className={`h-4 w-4`} />{`Novo orçamento`}</G>} />}<Kf open={i} onOpenChange={a} projetoId={r} /><_Component29 open={!!o} onOpenChange={e => !e && s(null)} title={`Remover orçamento`} confirmLabel={`Remover`} onConfirm={async () => {
      if (o) {
        await u.mutateAsync(o.id);
      }
    }} /></div>;
}
function Jf({
  orcamentoId: e,
  item: t,
  onDone: r
}) {
  let a = Hd(e);
  let o = Ud(e);
  let {
    register: s,
    handleSubmit: c,
    reset: l,
    formState: {
      errors: u,
      isSubmitting: d
    }
  } = i({
    resolver: n(yc),
    defaultValues: {
      descricao: ``,
      ambiente_nome: ``,
      quantidade: `1`,
      custo_unitario: `0`,
      valor_unitario: `0`
    }
  });
  (0, k.useEffect)(() => {
    l(t ? {
      descricao: t.descricao,
      ambiente_nome: t.ambiente_nome ?? ``,
      quantidade: String(t.quantidade),
      custo_unitario: String(t.custo_unitario),
      valor_unitario: String(t.valor_unitario)
    } : {
      descricao: ``,
      ambiente_nome: ``,
      quantidade: `1`,
      custo_unitario: `0`,
      valor_unitario: `0`
    });
  }, [t, l]);
  async function f(e) {
    let n = {
      descricao: e.descricao,
      ambiente_nome: e.ambiente_nome.trim() === `` ? null : e.ambiente_nome.trim(),
      quantidade: _l(e.quantidade),
      custo_unitario: _l(e.custo_unitario),
      valor_unitario: _l(e.valor_unitario)
    };
    if (t) {
      await o.mutateAsync({
        id: t.id,
        payload: n
      });
    } else {
      await a.mutateAsync(n);
    }
    r();
  }
        return <form onSubmit={c(f)} className={`grid gap-3 rounded-lg border border-border p-3 sm:grid-cols-5`}><_Component19 label={`Descrição`} htmlFor={`item-desc`} error={u.descricao?.message} className={`sm:col-span-2`}><K id={`item-desc`} placeholder={`Ex: Armário aéreo 3 portas`} {...s(`descricao`)} /></_Component19><_Component19 label={`Ambiente`} htmlFor={`item-amb`} error={u.ambiente_nome?.message}><K id={`item-amb`} {...s(`ambiente_nome`)} /></_Component19><_Component19 label={`Qtd`} htmlFor={`item-qtd`} error={u.quantidade?.message}><K id={`item-qtd`} inputMode={`decimal`} {...s(`quantidade`)} /></_Component19><_Component19 label={`Valor unit. (R$)`} htmlFor={`item-valor`} error={u.valor_unitario?.message}><K id={`item-valor`} inputMode={`decimal`} {...s(`valor_unitario`)} /></_Component19><input type={`hidden`} {...s(`custo_unitario`)} /><div className={`flex justify-end gap-2 sm:col-span-5`}><G type={`button`} variant={`ghost`} onClick={r}>{`Cancelar`}</G><G type={`submit`} disabled={d}>{t ? `Salvar item` : `Adicionar item`}</G></div></form>;
}
function Yf() {
  let {
    id: e
  } = g();
  let t = f();
  let {
    data: n,
    isLoading: r
  } = Ld(e);
  let {
    data: a
  } = Ir();
  let o = zd(e);
  let s = Bd();
  let c = Wd(e);
  let [l, u] = (0, k.useState)(false);
  let [d, p] = (0, k.useState)(null);
  let [m, h] = (0, k.useState)(false);
  let {
    register: _,
    handleSubmit: v,
    reset: y,
    watch: b,
    formState: {
      isSubmitting: x
    }
  } = i({
    defaultValues: {
      material_custo: `0`,
      ferragens_custo: `0`,
      perda_percent: `5`,
      operacional_custo: `0`,
      montagem_horas: `0`,
      montagem_valor_hora: `0`,
      frete: `0`,
      impostos_percent: `0`,
      margem_percent: `30`,
      validade_dias: `15`,
      observacoes: ``
    }
  });
  (0, k.useEffect)(() => {
    if (n) {
      y({
        material_custo: String(n.material_custo),
        ferragens_custo: String(n.ferragens_custo),
        perda_percent: String(n.perda_percent),
        operacional_custo: String(n.operacional_custo),
        montagem_horas: String(n.montagem_horas),
        montagem_valor_hora: String(n.montagem_valor_hora),
        frete: String(n.frete),
        impostos_percent: String(n.impostos_percent),
        margem_percent: String(n.margem_percent),
        validade_dias: String(n.validade_dias),
        observacoes: n.observacoes ?? ``
      });
    }
  }, [n, y]);
  let S = b();
  let C = (0, k.useMemo)(() => st({
    material_custo: _l(S.material_custo || `0`),
    ferragens_custo: _l(S.ferragens_custo || `0`),
    perda_percent: _l(S.perda_percent || `0`),
    operacional_custo: _l(S.operacional_custo || `0`),
    montagem_horas: _l(S.montagem_horas || `0`),
    montagem_valor_hora: _l(S.montagem_valor_hora || `0`),
    frete: _l(S.frete || `0`),
    impostos_percent: _l(S.impostos_percent || `0`),
    margem_percent: _l(S.margem_percent || `0`)
  }), [S]);
  let w = (0, k.useMemo)(() => (n?.itens ?? []).reduce((e, t) => e + Number(t.quantidade) * Number(t.valor_unitario), 0), [n]);
  if (r) {
    return <Ks className={`h-64`} />;
  }
  if (!n) {
    return <Ws title={`Orçamento não encontrado`} action={<G variant={`outline`} onClick={() => t(`/orcamentos`)}><Mt className={`h-4 w-4`} />{`Voltar`}</G>} />;
  }
  async function T(e) {
    let t = {
      material_custo: _l(e.material_custo),
      ferragens_custo: _l(e.ferragens_custo),
      perda_percent: _l(e.perda_percent),
      operacional_custo: _l(e.operacional_custo),
      montagem_horas: _l(e.montagem_horas),
      montagem_valor_hora: _l(e.montagem_valor_hora),
      frete: _l(e.frete),
      impostos_percent: _l(e.impostos_percent),
      margem_percent: _l(e.margem_percent),
      validade_dias: Math.trunc(_l(e.validade_dias)),
      observacoes: e.observacoes.trim() === `` ? null : e.observacoes.trim()
    };
    await o.mutateAsync(t);
  }
  function E() {
    if (!n) {
      return;
    }
    let e = new Map();
    for (let t of n.itens ?? []) {
      let n = t.ambiente_nome ?? `Geral`;
      e.set(n, [...(e.get(n) ?? []), t]);
    }
    let t = [...e.entries()].map(([e, t]) => `
        <h2>${e}</h2>
        <table>
          <thead><tr><th>Descrição</th><th>Qtd</th><th>Valor</th><th>Total</th></tr></thead>
          <tbody>
            ${t.map(e => `<tr><td>${e.descricao}</td><td>${Za(Number(e.quantidade), 2)}</td><td>${W(e.valor_unitario)}</td><td>${W(Number(e.quantidade) * Number(e.valor_unitario))}</td></tr>`).join(``)}
          </tbody>
        </table>`).join(``);
    let r = w > 0 ? w : Number(n.total);
    let i = new Date(n.created_at);
    i.setDate(i.getDate() + n.validade_dias);
    yd(`Proposta, ${n.projeto?.nome ?? ``}`, `<h1>Proposta comercial</h1>
       <p class="meta">${a?.name ?? `Marcenaria`}${a?.telefone ? ` · ${a.telefone}` : ``}${a?.email ? ` · ${a.email}` : ``}</p>
       <table>
         <tr><th>Projeto</th><td>${n.projeto?.nome ?? `-`}</td></tr>
         <tr><th>Cliente</th><td>${n.cliente?.nome ?? `-`}</td></tr>
         <tr><th>Proposta</th><td>v${n.versao} · válida até ${to(i.toISOString())}</td></tr>
       </table>
       ${t || `<p>Sem itens detalhados.</p>`}
       <h2>Investimento total</h2>
       <table><tr><th>Valor total</th><td style="font-size:16px;font-weight:700">${W(r)}</td></tr></table>
       ${n.observacoes ? `<h2>Observações</h2><p style="font-size:13px;line-height:1.6">${n.observacoes}</p>` : ``}
       ${n.projeto ? `<h2>Condições</h2><p style="font-size:13px;line-height:1.6;white-space:pre-line">${a?.termos_contrato ?? `Condições a combinar.`}</p>` : ``}
       <p style="font-size:12px;color:#6b7280;margin-top:24px">Proposta gerada por Planejados Pro em ${to(new Date().toISOString())}.</p>`);
  }
  function D() {
    if (n) {
      yd(`Orçamento interno, ${n.projeto?.nome ?? ``}`, `<h1>Orçamento interno de produção</h1>
       <p class="meta">Documento de uso interno, não enviar ao cliente.</p>
       <table>
         <tr><th>Projeto</th><td>${n.projeto?.nome ?? `-`}</td></tr>
         <tr><th>Cliente</th><td>${n.cliente?.nome ?? `-`}</td></tr>
         <tr><th>Versão</th><td>v${n.versao}</td></tr>
       </table>
       <h2>Composição de custos</h2>
       <table>
         <tr><th>Matéria-prima</th><td>${W(n.material_custo)}</td></tr>
         <tr><th>Ferragens</th><td>${W(n.ferragens_custo)}</td></tr>
         <tr><th>Perda estimada (${Za(n.perda_percent, 2)}%)</th><td>${W(C.perda_valor)}</td></tr>
         <tr><th>Custos operacionais</th><td>${W(n.operacional_custo)}</td></tr>
         <tr><th>Montagem</th><td>${W(C.montagem_custo)}</td></tr>
         <tr><th>Frete</th><td>${W(n.frete)}</td></tr>
         <tr><th>Subtotal</th><td>${W(C.subtotal)}</td></tr>
         <tr><th>Impostos</th><td>${W(C.impostos_valor)}</td></tr>
         <tr><th>Margem (${Za(n.margem_percent, 2)}%)</th><td>${W(C.lucro)}</td></tr>
         <tr><th>Total ao cliente</th><td style="font-weight:700">${W(C.total)}</td></tr>
       </table>`);
    }
  }
                                      return <div className={`space-y-6`}><Fs title={`Orçamento v${n.versao}`} description={`Orçamento de ${n.projeto?.nome ?? `projeto removido`} para ${n.cliente?.nome ?? `cliente removido`}`} actions={<L.Fragment><G variant={`outline`} onClick={() => t(`/orcamentos`)}><Mt className={`h-4 w-4`} />{`Voltar`}</G><G variant={`outline`} onClick={D}><Jn className={`h-4 w-4`} />{`Custo interno`}</G>{(n.status === `aprovado` || n.status === `enviado`) && n.projeto && <G variant={`outline`} onClick={() => h(true)}><_Component5 className={`h-4 w-4`} />{`Gerar contrato`}</G>}<G onClick={E}><Jn className={`h-4 w-4`} />{`Gerar proposta`}</G></L.Fragment>}><div className={`flex flex-wrap items-center gap-2`}><Gs label={$r[n.status]} tone={ei[n.status]} /><G variant={`outline`} size={`sm`} onClick={() => s.mutate({
          id: n.id,
          status: `enviado`
        })}>{`Marcar como enviado`}</G><G variant={`outline`} size={`sm`} onClick={() => s.mutate({
          id: n.id,
          status: `aprovado`
        })}><Kt className={`h-4 w-4`} />{`Aprovar`}</G><G variant={`outline`} size={`sm`} onClick={() => s.mutate({
          id: n.id,
          status: `recusado`
        })}><_Component53 className={`h-4 w-4`} />{`Recusar`}</G></div></Fs><div className={`grid gap-6 lg:grid-cols-[2fr_1fr]`}><div className={`space-y-6`}><Rs><_Component11 className={`flex flex-row items-center justify-between space-y-0`}><Bs className={`text-base`}>{`Itens da proposta`}</Bs><G size={`sm`} variant={`outline`} onClick={() => {
              p(null);
              u(true);
            }}><_Component10 className={`h-4 w-4`} />{`Adicionar item`}</G></_Component11><Hs className={`space-y-4`}>{l && <Jf orcamentoId={n.id} item={d} onDone={() => {
              u(false);
              p(null);
            }} />}{n.itens && n.itens.length > 0 ? <div className={`overflow-hidden rounded-lg border border-border`}><_Component28><_Component25><_Component24><J>{`Descrição`}</J><J>{`Ambiente`}</J><J>{`Qtd`}</J><J>{`Valor`}</J><J>{`Total`}</J><J className={`w-12 text-right`}>{`Ações`}</J></_Component24></_Component25><_Component27>{n.itens.map(e => <_Component24 key={e.id}><Y className={`font-medium`}>{e.descricao}</Y><Y className={`text-muted-foreground`}>{e.ambiente_nome ?? `-`}</Y><Y className={`tabular-nums`}>{Za(Number(e.quantidade), 2)}</Y><Y className={`tabular-nums`}>{W(e.valor_unitario)}</Y><Y className={`tabular-nums`}>{W(Number(e.quantidade) * Number(e.valor_unitario))}</Y><Y className={`text-right`}><div className={`flex justify-end gap-1`}><G variant={`ghost`} size={`icon`} aria-label={`Editar item`} onClick={() => {
                          p(e);
                          u(true);
                        }}><Wn className={`h-3.5 w-3.5`} /></G><G variant={`ghost`} size={`icon`} aria-label={`Remover item`} onClick={() => c.mutate(e.id)}><_Component26 className={`h-3.5 w-3.5 text-destructive`} /></G></div></Y></_Component24>)}</_Component27></_Component28></div> : <p className={`rounded-lg border border-dashed border-border p-6 text-center text-sm text-muted-foreground`}>{`Nenhum item descrito. Os itens aparecem na proposta comercial enviada ao cliente.`}</p>}<div className={`flex justify-end text-sm`}><span className={`text-muted-foreground`}>{`Total dos itens:\xA0`}</span><span className={`font-medium tabular-nums`}>{W(w)}</span></div></Hs></Rs><Rs><_Component11><Bs className={`flex items-center gap-2 text-base`}><Wn className={`h-4 w-4`} />{`Composição de custos`}</Bs></_Component11><Hs><form onSubmit={v(T)} className={`grid gap-4 sm:grid-cols-3`}><_Component19 label={`Matéria-prima (R$)`} htmlFor={`c-material`}><K id={`c-material`} inputMode={`decimal`} {..._(`material_custo`)} /></_Component19><_Component19 label={`Ferragens (R$)`} htmlFor={`c-ferragens`}><K id={`c-ferragens`} inputMode={`decimal`} {..._(`ferragens_custo`)} /></_Component19><_Component19 label={`Perda (%)`} htmlFor={`c-perda`}><K id={`c-perda`} inputMode={`decimal`} {..._(`perda_percent`)} /></_Component19><_Component19 label={`Operacional (R$)`} htmlFor={`c-oper`}><K id={`c-oper`} inputMode={`decimal`} {..._(`operacional_custo`)} /></_Component19><_Component19 label={`Horas de montagem`} htmlFor={`c-horas`}><K id={`c-horas`} inputMode={`decimal`} {..._(`montagem_horas`)} /></_Component19><_Component19 label={`Valor/hora (R$)`} htmlFor={`c-valorhora`}><K id={`c-valorhora`} inputMode={`decimal`} {..._(`montagem_valor_hora`)} /></_Component19><_Component19 label={`Frete (R$)`} htmlFor={`c-frete`}><K id={`c-frete`} inputMode={`decimal`} {..._(`frete`)} /></_Component19><_Component19 label={`Impostos (%)`} htmlFor={`c-impostos`}><K id={`c-impostos`} inputMode={`decimal`} {..._(`impostos_percent`)} /></_Component19><_Component19 label={`Margem (%)`} htmlFor={`c-margem`}><K id={`c-margem`} inputMode={`decimal`} {..._(`margem_percent`)} /></_Component19><_Component19 label={`Validade (dias)`} htmlFor={`c-validade`}><K id={`c-validade`} inputMode={`numeric`} {..._(`validade_dias`)} /></_Component19><_Component19 label={`Observações`} htmlFor={`c-obs`} className={`sm:col-span-2`}><Rl id={`c-obs`} rows={2} {..._(`observacoes`)} /></_Component19><div className={`flex items-end sm:col-span-3`}><G type={`submit`} disabled={x}>{x ? `Recalculando...` : `Salvar e recalcular`}</G></div></form></Hs></Rs></div><Rs className={`h-fit`}><_Component11><Bs className={`text-base`}>{`Resumo`}</Bs></_Component11><Hs className={`space-y-2 text-sm`}><Xf label={`Matéria-prima`} valor={W(_l(S.material_custo || `0`))} /><Xf label={`Ferragens`} valor={W(S.ferragens_custo || `0`)} /><Xf label={`Perda estimada`} valor={W(C.perda_valor)} /><Xf label={`Operacional`} valor={W(S.operacional_custo || `0`)} /><Xf label={`Montagem`} valor={W(C.montagem_custo)} /><Xf label={`Frete`} valor={W(S.frete || `0`)} /><div className={`my-2 border-t border-border`} /><Xf label={`Subtotal`} valor={W(C.subtotal)} /><Xf label={`Impostos`} valor={W(C.impostos_valor)} /><Xf label={`Lucro`} valor={W(C.lucro)} /><div className={`my-2 border-t border-border`} /><div className={`flex items-center justify-between`}><span className={`font-medium`}>{`Total`}</span><span className={`text-lg font-semibold tabular-nums`}>{W(C.total)}</span></div><p className={`text-xs text-muted-foreground`}>{`Margem real: `}{Za(C.margem_real_percent, 1)}{`%`}</p></Hs></Rs></div><_Component44 open={m} onOpenChange={h} projetoId={n.projeto?.id} orcamentoId={n.id} valorInicial={Number(n.total)} /></div>;
}
function Xf({
  label: e,
  valor: t
}) {
        return <div className={`flex items-center justify-between`}><span className={`text-muted-foreground`}>{e}</span><span className={`tabular-nums`}>{t}</span></div>;
}
function Zf(e) {
  return {
    projeto_id: e?.projeto_id ?? ``,
    status: e?.status ?? `aguardando_corte`,
    data_prevista_entrega: e?.data_prevista_entrega ?? ``,
    montador_id: e?.montador_id ?? ``,
    frete: String(e?.frete ?? 0),
    montagem_horas: String(e?.montagem_horas ?? 0),
    observacoes: e?.observacoes ?? ``
  };
}
function Qf({
  open: e,
  onOpenChange: t,
  ordem: r
}) {
  let a = Tf();
  let o = Ef();
  let {
    data: s
  } = Jl();
  let {
    data: c
  } = Lr();
  let {
    register: l,
    handleSubmit: u,
    reset: d,
    formState: {
      errors: f,
      isSubmitting: p
    }
  } = i({
    resolver: n(bc),
    defaultValues: Zf(r)
  });
  (0, k.useEffect)(() => {
    if (e) {
      d(Zf(r));
    }
  }, [e, r, d]);
  async function m(e) {
    let n = Al(e);
    if (r) {
      await o.mutateAsync({
        id: r.id,
        payload: n
      });
    } else {
      await a.mutateAsync(n);
    }
    t(false);
  }
                return <_Component21 open={e} onOpenChange={t} title={r ? `Editar ordem ${r.numero}` : `Nova ordem de serviço`} description={`Fila de produção e agenda de montagem.`} size={`lg`} footer={<L.Fragment><G variant={`outline`} onClick={() => t(false)} disabled={p}>{`Cancelar`}</G><G form={`ordem-global-form`} type={`submit`} disabled={p}>{p ? `Salvando...` : `Salvar`}</G></L.Fragment>}><form id={`ordem-global-form`} onSubmit={u(m)} className={`grid gap-4 sm:grid-cols-2`}><_Component19 label={`Projeto`} htmlFor={`og-projeto`} error={f.projeto_id?.message} required={true} className={`sm:col-span-2`}><_Component31 id={`og-projeto`} {...l(`projeto_id`)}><option value={``}>{`Selecione um projeto`}</option>{(s ?? []).map(e => <option value={e.id} key={e.id}>{e.nome}{` (`}{e.cliente?.nome ?? `sem cliente`}{`)`}</option>)}</_Component31></_Component19><_Component19 label={`Status`} htmlFor={`og-status`} error={f.status?.message}><_Component31 id={`og-status`} {...l(`status`)}>{Zr.map(e => <option value={e} key={e}>{Xr[e]}</option>)}<option value={`cancelado`}>{Xr.cancelado}</option></_Component31></_Component19><_Component19 label={`Entrega prevista`} htmlFor={`og-entrega`} error={f.data_prevista_entrega?.message}><K id={`og-entrega`} type={`date`} {...l(`data_prevista_entrega`)} /></_Component19><_Component19 label={`Montador responsável`} htmlFor={`og-montador`} error={f.montador_id?.message}><_Component31 id={`og-montador`} {...l(`montador_id`)}><option value={``}>{`Definir depois`}</option>{(c ?? []).map(e => <option value={e.id} key={e.id}>{e.full_name ?? e.email}</option>)}</_Component31></_Component19><_Component19 label={`Horas de montagem`} htmlFor={`og-horas`} error={f.montagem_horas?.message}><K id={`og-horas`} inputMode={`decimal`} {...l(`montagem_horas`)} /></_Component19><_Component19 label={`Frete (R$)`} htmlFor={`og-frete`} error={f.frete?.message}><K id={`og-frete`} inputMode={`decimal`} {...l(`frete`)} /></_Component19><_Component19 label={`Observações`} htmlFor={`og-obs`} error={f.observacoes?.message} className={`sm:col-span-2`}><Rl id={`og-obs`} rows={3} {...l(`observacoes`)} /></_Component19></form></_Component21>;
}
function $f(e) {
  if (!e.data_prevista_entrega || e.status === `concluido` || e.status === `cancelado`) {
    return false;
  } else {
    return new Date(`${e.data_prevista_entrega}T00:00:00`) < new Date(new Date().toDateString());
  }
}
function _Component103() {
  let e = f();
  let [t, n] = (0, k.useState)(`fila`);
  let [r, i] = (0, k.useState)(false);
  let [a, o] = (0, k.useState)(null);
  let [s, c] = (0, k.useState)(null);
  let {
    data: l,
    isLoading: u
  } = Cf();
  let d = Of();
  let p = (0, k.useMemo)(() => {
    let e = new Map();
    for (let t of l ?? []) {
      e.set(t.status, [...(e.get(t.status) ?? []), t]);
    }
    return e;
  }, [l]);
  let m = (l ?? []).filter(e => e.status !== `concluido` && e.status !== `cancelado`);
        return <div className={`space-y-6`}><Fs title={`Ordens de serviço`} description={`Fila de produção, agenda de montagem e instalação.`} actions={<G onClick={() => {
      o(null);
      i(true);
    }}><_Component10 className={`h-4 w-4`} />{`Nova ordem`}</G>}><_Component32 value={t} onValueChange={n} tabs={[{
        value: `fila`,
        label: `Fila de produção`,
        count: m.length
      }, {
        value: `agenda`,
        label: `Agenda de entregas`
      }]} /></Fs>{u ? <_Component23 columns={5} /> : !l || l.length === 0 ? <Ws icon={<Yt className={`h-8 w-8`} />} title={`Nenhuma ordem de serviço`} description={`Crie ordens para separar cut, bordas, pré-montagem e instalação.`} action={<G onClick={() => {
      o(null);
      i(true);
    }}><_Component10 className={`h-4 w-4`} />{`Nova ordem`}</G>} /> : t === `fila` ? <div className={`flex gap-4 overflow-x-auto pb-6 pt-2 items-start min-h-[540px]`}>{Zr.map(t => {
        let n = p.get(t) ?? [];
        let colBorder = t === `aguardando_corte` ? `#a8a29e` : t === `furacao_borda` ? `#f59e0b` : t === `pre_montagem` ? `#d97706` : t === `aguardando_montagem` ? `#0284c7` : t === `em_montagem` ? `#6366f1` : `#10b981`;
        return <div className={`w-[295px] min-w-[295px] shrink-0 rounded-xl border border-border/80 bg-stone-50/70 dark:bg-stone-900/40 p-3.5 shadow-xs space-y-3 flex flex-col`} style={{ borderTop: `3px solid ${colBorder}` }} key={t}>
          <div className={`flex items-center justify-between pb-2.5 border-b border-border/60`}>
            <div className={`flex items-center gap-2`}>
              <span className={U(`h-2.5 w-2.5 rounded-full ring-2 ring-background`, Qr[t])} />
              <p className={`text-xs font-bold uppercase tracking-wider text-foreground/90`}>{Xr[t]}</p>
            </div>
            <span className={`rounded-full bg-background px-2.5 py-0.5 text-[11px] font-bold text-foreground shadow-xs border border-border/60`}>{n.length}</span>
          </div>
          <div className={`space-y-2.5 flex-1`}>
            {n.map(t => <button type={`button`} onClick={() => e(`/ordens/${t.id}`)} className={U(`group block w-full rounded-xl border border-border bg-card p-3.5 text-left text-sm shadow-xs transition-all hover:border-primary/60 hover:shadow-md hover:-translate-y-0.5 space-y-2`, $f(t) && `border-rose-500/50 ring-1 ring-rose-500/20`)} key={t.id}>
              <div className={`flex items-center justify-between`}>
                <span className={`font-bold text-foreground text-sm group-hover:text-primary transition-colors`}>{t.numero}</span>
                {t.montador?.full_name ? <span className={`text-[10px] bg-muted/90 text-muted-foreground px-2 py-0.5 rounded-md font-medium truncate max-w-[110px]`}>{t.montador.full_name}</span> : <span className={`text-[10px] text-muted-foreground/70 font-mono`}>#{t.id}</span>}
              </div>
              <div className={`space-y-0.5`}>
                <p className={`truncate text-xs font-semibold text-foreground/90`}>{t.projeto?.nome ?? `-`}</p>
                <p className={`truncate text-[11px] text-muted-foreground`}>{t.projeto?.cliente?.nome ?? `Sem cliente vinculado`}</p>
              </div>
              {t.data_prevista_entrega && <div className={`pt-2 flex items-center justify-between border-t border-border/40 text-[11px]`}>
                <span className={`text-muted-foreground text-[10px] uppercase font-medium tracking-wide`}>Prazo:</span>
                <span className={U(`font-semibold tabular-nums text-xs`, $f(t) ? `text-rose-600` : `text-foreground/85`)}>{to(t.data_prevista_entrega)}</span>
              </div>}
            </button>)}
            {n.length === 0 && <div className={`rounded-xl border border-dashed border-border/80 py-9 text-center text-xs text-muted-foreground bg-background/30 font-medium`}>{`Nenhuma ordem`}</div>}
          </div>
        </div>;
      })}</div> : <Rs className={`overflow-hidden`}><_Component28><_Component25><_Component24><J>{`Número`}</J><J>{`Projeto`}</J><J className={`hidden sm:table-cell`}>{`Cliente`}</J><J>{`Entrega`}</J><J>{`Status`}</J><J className={`w-12 text-right`}>{`Ações`}</J></_Component24></_Component25><_Component27>{l.map(t => <_Component24 key={t.id}><Y><button type={`button`} className={`font-medium hover:underline`} onClick={() => e(`/ordens/${t.id}`)}>{t.numero}</button></Y><Y className={`text-muted-foreground`}>{t.projeto?.nome ?? `-`}</Y><Y className={`hidden sm:table-cell text-muted-foreground`}>{t.projeto?.cliente?.nome ?? `-`}</Y><Y className={U(`tabular-nums`, $f(t) && `text-rose-600`)}>{to(t.data_prevista_entrega)}</Y><Y><Gs label={Xr[t.status]} tone={Qr[t.status]} /></Y><Y className={`text-right`}><Lo items={[{
                label: `Abrir`,
                icon: <Vt className={`h-4 w-4`} />,
                onSelect: () => e(`/ordens/${t.id}`)
              }, {
                label: `Remover`,
                icon: <_Component26 className={`h-4 w-4`} />,
                destructive: true,
                onSelect: () => c(t)
              }]} /></Y></_Component24>)}</_Component27></_Component28></Rs>}<Qf open={r} onOpenChange={i} ordem={a} /><_Component29 open={!!s} onOpenChange={e => !e && c(null)} title={`Remover ordem de serviço`} description={s ? `Remover ${s.numero}?` : undefined} confirmLabel={`Remover`} onConfirm={async () => {
      if (s) {
        await d.mutateAsync(s.id);
      }
    }} /></div>;
}
function _Component104() {
  let {
    id: e
  } = g();
  let t = f();
  let [n, r] = (0, k.useState)(false);
  let {
    data: i,
    isLoading: a
  } = wf(e);
  let o = Df();
  if (a) {
    return <Ks className={`h-64`} />;
  } else if (i) {
                                        return <div className={`space-y-6`}><Fs title={i.numero} description={<button type={`button`} className={`text-[13px] font-medium underline decoration-border underline-offset-4 hover:decoration-foreground`} onClick={() => i.projeto && t(`/projetos/${i.projeto.id}`)}>{i.projeto?.nome ?? `Projeto removido`}</button>} actions={<L.Fragment><G variant={`outline`} onClick={() => t(`/ordens`)}><Mt className={`h-4 w-4`} />{`Voltar`}</G><G onClick={() => r(true)}><Wn className={`h-4 w-4`} />{`Editar ordem`}</G></L.Fragment>}><div className={`flex flex-wrap items-center gap-2`}>{Zr.map(e => {
            let t = i.status === e;
                        return <button type={`button`} onClick={() => o.mutate({
              id: i.id,
              status: e
            })} className={U(`rounded-full border px-3 py-1 text-xs font-medium transition-colors`, t ? `border-foreground bg-foreground text-background` : `border-border text-muted-foreground hover:text-foreground`)} key={e}>{Xr[e]}</button>;
          })}<button type={`button`} onClick={() => o.mutate({
            id: i.id,
            status: `cancelado`
          })} className={U(`rounded-full border px-3 py-1 text-xs font-medium transition-colors`, i.status === `cancelado` ? `border-rose-500 bg-rose-500 text-white` : `border-border text-muted-foreground hover:text-rose-600`)}>{Xr.cancelado}</button></div></Fs><div className={`grid gap-6 lg:grid-cols-[2fr_1fr]`}><Rs><_Component11><Bs className={`text-base`}>{`Detalhes da produção`}</Bs></_Component11><Hs className={`grid gap-4 sm:grid-cols-2`}><_Component54 icon={<Sr className={`h-4 w-4`} />} label={`Cliente`} value={i.projeto?.cliente?.nome ?? `-`} /><_Component54 icon={<Ht className={`h-4 w-4`} />} label={`Entrega prevista`} value={to(i.data_prevista_entrega)} /><_Component54 icon={<Ht className={`h-4 w-4`} />} label={`Entrega realizada`} value={to(i.data_entrega_real)} /><_Component54 icon={<Sr className={`h-4 w-4`} />} label={`Montador responsável`} value={i.montador?.full_name ?? `Não definido`} /><_Component54 icon={<_Component55 className={`h-4 w-4`} />} label={`Horas de montagem`} value={String(i.montagem_horas)} /><_Component54 icon={<_r className={`h-4 w-4`} />} label={`Frete`} value={W(i.frete)} />{i.observacoes && <div className={`sm:col-span-2`}><p className={`text-[11px] font-medium text-muted-foreground`}>{`Observações`}</p><p className={`whitespace-pre-line text-sm`}>{i.observacoes}</p></div>}</Hs></Rs><Rs className={`h-fit`}><_Component11><Bs className={`text-base`}>{`Situação`}</Bs></_Component11><Hs className={`space-y-3`}><Gs label={Xr[i.status]} tone={Qr[i.status]} /><p className={`text-sm text-muted-foreground`}>{li[i.status]}</p>{i.status === `concluido` && i.projeto && <G variant={`outline`} className={`w-full`} onClick={() => t(`/projetos/${i.projeto?.id}`)}>{`Registrar termo de conclusão`}</G>}</Hs></Rs></div><Qf open={n} onOpenChange={r} ordem={i} /></div>;
  } else {
    return <Ws title={`Ordem não encontrada`} action={<G variant={`outline`} onClick={() => t(`/ordens`)}><Mt className={`h-4 w-4`} />{`Voltar`}</G>} />;
  }
}
function _Component54({
  icon: e,
  label: t,
  value: n
}) {
            return <div className={`flex items-start gap-3`}><div className={`rounded-lg bg-muted p-2 text-muted-foreground`}>{e}</div><div><p className={`text-[11px] font-medium text-muted-foreground`}>{t}</p><p className={`text-sm font-medium`}>{n}</p></div></div>;
}
function _Component105() {
  let e = f();
  let [t, n] = S();
  let [r, i] = (0, k.useState)(``);
  let [a, o] = (0, k.useState)(`todos`);
  let [s, c] = (0, k.useState)(t.get(`novo`) === `1`);
  let [l, u] = (0, k.useState)(null);
  let {
    data: d,
    isLoading: p
  } = tf();
  let m = lf();
  let h = (0, k.useMemo)(() => {
    let e = r.trim().toLowerCase();
    return (d ?? []).filter(t => {
      let n = a === `todos` || t.status === a;
      let r = e === `` || t.numero.toLowerCase().includes(e) || (t.projeto?.nome ?? ``).toLowerCase().includes(e) || (t.cliente?.nome ?? ``).toLowerCase().includes(e);
      return n && r;
    });
  }, [d, a, r]);
  let g = (0, k.useMemo)(() => {
    let e = d ?? [];
    return {
      todos: e.length,
      rascunho: e.filter(e => e.status === `rascunho`).length,
      enviado: e.filter(e => e.status === `enviado`).length,
      assinado: e.filter(e => e.status === `assinado`).length,
      encerrado: e.filter(e => e.status === `encerrado`).length
    };
  }, [d]);
  let _ = (0, k.useMemo)(() => (d ?? []).filter(e => e.status === `assinado`), [d]);
  function v() {
    c(true);
    if (t.has(`novo`)) {
      t.delete(`novo`);
      n(t, {
        replace: true
      });
    }
  }
            return <div className={`space-y-6`}><Fs title={`Contratos`} description={p ? `Carregando contratos da marcenaria.` : `${_.length} contrato(s) assinado(s), ${W(_.reduce((e, t) => e + Number(t.valor_total), 0))} em carteira.`} actions={<G onClick={v}><_Component10 className={`h-4 w-4`} />{`Novo contrato`}</G>}><div className={`flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between`}><_Component32 value={a} onValueChange={o} tabs={[{
          value: `todos`,
          label: `Todos`,
          count: g.todos
        }, {
          value: `rascunho`,
          label: `Rascunho`,
          count: g.rascunho
        }, {
          value: `enviado`,
          label: `Enviado`,
          count: g.enviado
        }, {
          value: `assinado`,
          label: `Assinado`,
          count: g.assinado
        }, {
          value: `encerrado`,
          label: `Encerrado`,
          count: g.encerrado
        }]} /><div className={`relative w-full sm:max-w-xs`}><_Component22 className={`pointer-events-none absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-muted-foreground`} /><K value={r} onChange={e => i(e.target.value)} placeholder={`Buscar por número, projeto ou cliente`} className={`pl-9`} /></div></div></Fs>{p ? <_Component23 columns={5} /> : h.length > 0 ? <Rs className={`overflow-hidden`}><_Component28><_Component25><_Component24><J>{`Contrato`}</J><J className={`hidden sm:table-cell`}>{`Cliente`}</J><J className={`hidden md:table-cell`}>{`Parcelas`}</J><J>{`Valor`}</J><J>{`Status`}</J><J className={`w-12 text-right`}>{`Ações`}</J></_Component24></_Component25><_Component27>{h.map(t => <_Component24 key={t.id}><Y><button type={`button`} className={`numero text-[13px] font-medium hover:underline`} onClick={() => e(`/contratos/${t.id}`)}>{t.numero}</button><p className={`truncate text-[11px] text-muted-foreground`}>{t.projeto?.nome ?? `Sem projeto`}</p></Y><Y className={`hidden sm:table-cell text-muted-foreground`}>{t.cliente?.nome ?? `-`}</Y><Y className={`hidden md:table-cell text-muted-foreground`}>{t.num_parcelas}{` x `}{t.intervalo_dias}{` dias`}{t.assinado_em ? ` - assinado em ${to(t.assinado_em)}` : ``}</Y><Y className={`numero`}>{W(t.valor_total)}</Y><Y><Gs label={ui[t.status]} tone={di[t.status]} /></Y><Y className={`text-right`}><Lo items={[{
                label: `Abrir contrato`,
                icon: <_Component5 className={`h-4 w-4`} />,
                onSelect: () => e(`/contratos/${t.id}`)
              }, {
                label: `Remover`,
                icon: <_Component26 className={`h-4 w-4`} />,
                destructive: true,
                onSelect: () => u(t)
              }]} /></Y></_Component24>)}</_Component27></_Component28></Rs> : <Ws icon={<_Component5 className={`h-4 w-4`} />} title={`Nenhum contrato encontrado`} description={`Gere um contrato a partir de um projeto ou de um orçamento aprovado.`} action={<G onClick={v}><_Component10 className={`h-4 w-4`} />{`Novo contrato`}</G>} />}<_Component44 open={s} onOpenChange={c} /><_Component29 open={!!l} onOpenChange={e => !e && u(null)} title={`Remover contrato`} description={l ? `Remover ${l.numero} e as parcelas vinculadas no financeiro?` : undefined} confirmLabel={`Remover`} onConfirm={async () => {
      if (l) {
        await m.mutateAsync(l.id);
      }
    }} /></div>;
}
var ip = `*, categoria:categorias_financeiras(id,nome,cor), fornecedor:fornecedores(id,nome), cliente:clientes(id,nome), contrato:contratos(id,numero)`;
async function ap(e) {
  let t = B.from(`lancamentos`).select(ip).order(`vencimento`, {
    ascending: true,
    nullsFirst: false
  }).order(`created_at`, {
    ascending: false
  });
  if (e?.tipo && e.tipo !== `todos`) {
    t = t.eq(`tipo`, e.tipo);
  }
  if (e?.status && e.status !== `todos`) {
    t = t.eq(`status`, e.status);
  }
  if (e?.de) {
    t = t.gte(`vencimento`, e.de);
  }
  if (e?.ate) {
    t = t.lte(`vencimento`, e.ate);
  }
  if (e?.contratoId) {
    t = t.eq(`contrato_id`, e.contratoId);
  }
  if (e?.fornecedorId) {
    t = t.eq(`fornecedor_id`, e.fornecedorId);
  }
  if (e?.busca && e.busca.trim().length > 0) {
    let n = e.busca.trim().replace(/[%,]/g, ``);
    t = t.ilike(`descricao`, `%${n}%`);
  }
  let {
    data: n,
    error: r
  } = await t;
  if (r) {
    throw r;
  }
  return n ?? [];
}
async function op(e) {
  let {
    data: t,
    error: n
  } = await B.from(`lancamentos`).insert(e).select(`*`).single();
  if (n) {
    throw n;
  }
  return t;
}
async function sp(e, t) {
  let {
    data: n,
    error: r
  } = await B.from(`lancamentos`).update(t).eq(`id`, e).select(`*`).single();
  if (r) {
    throw r;
  }
  return n;
}
async function cp(e) {
  let {
    error: t
  } = await B.from(`lancamentos`).delete().eq(`id`, e);
  if (t) {
    throw t;
  }
}
async function lp(e) {
  let {
    data: t,
    error: n
  } = await B.rpc(`quitar_lancamento`, {
    _id: e.id,
    _valor_pago: e.valorPago,
    _forma: e.formaPagamento,
    _pago_em: e.pagoEm
  });
  if (n) {
    throw n;
  }
  return t;
}
async function up(e) {
  return sp(e, {
    status: `previsto`,
    valor_pago: null,
    pago_em: null
  });
}
async function dp(e) {
  return sp(e, {
    status: `cancelado`
  });
}
async function fp() {
  let {
    data: e,
    error: t
  } = await B.from(`categorias_financeiras`).select(`*`).order(`tipo`, {
    ascending: true
  }).order(`nome`, {
    ascending: true
  });
  if (t) {
    throw t;
  }
  return e ?? [];
}
async function pp(e) {
  let {
    data: t,
    error: n
  } = await B.from(`categorias_financeiras`).insert(e).select(`*`).single();
  if (n) {
    throw n;
  }
  return t;
}
async function mp(e, t) {
  let {
    data: n,
    error: r
  } = await B.from(`categorias_financeiras`).update(t).eq(`id`, e).select(`*`).single();
  if (r) {
    throw r;
  }
  return n;
}
async function hp(e) {
  let {
    error: t
  } = await B.from(`categorias_financeiras`).delete().eq(`id`, e);
  if (t) {
    throw t;
  }
}
async function gp() {
  let {
    data: e,
    error: t
  } = await B.from(`fornecedores`).select(`*`).order(`nome`, {
    ascending: true
  });
  if (t) {
    throw t;
  }
  return e ?? [];
}
async function _p(e) {
  let {
    data: t,
    error: n
  } = await B.from(`fornecedores`).insert(e).select(`*`).single();
  if (n) {
    throw n;
  }
  return t;
}
async function vp(e, t) {
  let {
    data: n,
    error: r
  } = await B.from(`fornecedores`).update(t).eq(`id`, e).select(`*`).single();
  if (r) {
    throw r;
  }
  return n;
}
async function yp(e) {
  let {
    error: t
  } = await B.from(`fornecedores`).delete().eq(`id`, e);
  if (t) {
    throw t;
  }
}
function bp(e) {
  e.invalidateQueries({
    queryKey: [`lancamentos`]
  });
  e.invalidateQueries({
    queryKey: [`contrato`]
  });
  e.invalidateQueries({
    queryKey: H.dashboard
  });
}
function xp(e) {
  return T({
    queryKey: H.lancamentos(e),
    queryFn: () => ap(e)
  });
}
function Sp() {
  let e = C();
  return O({
    mutationFn: e => op(e),
    onSuccess: () => {
      bp(e);
      N.success(`Lançamento registrado.`);
    },
    onError: e => N.error(cu(e))
  });
}
function Cp() {
  let e = C();
  return O({
    mutationFn: ({
      id: e,
      payload: t
    }) => sp(e, t),
    onSuccess: () => {
      bp(e);
      N.success(`Lançamento atualizado.`);
    },
    onError: e => N.error(cu(e))
  });
}
function wp() {
  let e = C();
  return O({
    mutationFn: e => cp(e),
    onSuccess: () => {
      bp(e);
      N.success(`Lançamento removido.`);
    },
    onError: e => N.error(cu(e))
  });
}
function Tp() {
  let e = C();
  return O({
    mutationFn: lp,
    onSuccess: () => {
      bp(e);
      N.success(`Baixa registrada.`);
    },
    onError: e => N.error(cu(e))
  });
}
function Ep() {
  let e = C();
  return O({
    mutationFn: ({
      id: e,
      status: t
    }) => t === `cancelado` ? dp(e) : up(e),
    onSuccess: (t, n) => {
      bp(e);
      N.success(n.status === `cancelado` ? `Lançamento cancelado.` : `Lançamento reaberto.`);
    },
    onError: e => N.error(cu(e))
  });
}
function Dp() {
  return T({
    queryKey: H.categoriasFinanceiras,
    queryFn: fp
  });
}
function Op() {
  let e = C();
  return O({
    mutationFn: e => pp(e),
    onSuccess: () => {
      e.invalidateQueries({
        queryKey: H.categoriasFinanceiras
      });
      N.success(`Categoria criada.`);
    },
    onError: e => N.error(cu(e))
  });
}
function kp() {
  let e = C();
  return O({
    mutationFn: ({
      id: e,
      payload: t
    }) => mp(e, t),
    onSuccess: () => {
      e.invalidateQueries({
        queryKey: H.categoriasFinanceiras
      });
      N.success(`Categoria atualizada.`);
    },
    onError: e => N.error(cu(e))
  });
}
function Ap() {
  let e = C();
  return O({
    mutationFn: e => hp(e),
    onSuccess: () => {
      e.invalidateQueries({
        queryKey: H.categoriasFinanceiras
      });
      N.success(`Categoria removida.`);
    },
    onError: e => N.error(cu(e))
  });
}
function jp() {
  return T({
    queryKey: H.fornecedores,
    queryFn: gp
  });
}
function Mp() {
  let e = C();
  return O({
    mutationFn: e => _p(e),
    onSuccess: () => {
      e.invalidateQueries({
        queryKey: H.fornecedores
      });
      N.success(`Fornecedor cadastrado.`);
    },
    onError: e => N.error(cu(e))
  });
}
function Np() {
  let e = C();
  return O({
    mutationFn: ({
      id: e,
      payload: t
    }) => vp(e, t),
    onSuccess: () => {
      e.invalidateQueries({
        queryKey: H.fornecedores
      });
      N.success(`Fornecedor atualizado.`);
    },
    onError: e => N.error(cu(e))
  });
}
function Pp() {
  let e = C();
  return O({
    mutationFn: e => yp(e),
    onSuccess: () => {
      e.invalidateQueries({
        queryKey: H.fornecedores
      });
      N.success(`Fornecedor removido.`);
    },
    onError: e => N.error(cu(e))
  });
}
var Fp = Object.keys(gi);
function Ip({
  open: e,
  onOpenChange: t,
  lancamento: r
}) {
  let a = Tp();
  let {
    register: o,
    handleSubmit: s,
    reset: c,
    formState: {
      errors: l,
      isSubmitting: u
    }
  } = i({
    resolver: n(kc),
    defaultValues: {
      valor_pago: ``,
      forma_pagamento: `pix`,
      pago_em: uo()
    }
  });
  (0, k.useEffect)(() => {
    if (e && r) {
      c({
        valor_pago: String(r.valor),
        forma_pagamento: r.forma_pagamento ?? `pix`,
        pago_em: uo()
      });
    }
  }, [e, r, c]);
  async function d(e) {
    if (r) {
      await a.mutateAsync({
        id: r.id,
        valorPago: _l(e.valor_pago),
        formaPagamento: e.forma_pagamento,
        pagoEm: fo(e.pago_em)
      });
      t(false);
    }
  }
      return <_Component21 open={e} onOpenChange={t} title={`Registrar baixa`} description={r ? `${r.descricao} - previsto ${W(r.valor)}` : undefined} footer={<L.Fragment><G variant={`outline`} onClick={() => t(false)} disabled={u}>{`Cancelar`}</G><G form={`quitar-form`} type={`submit`} disabled={u}>{u ? `Registrando...` : `Confirmar baixa`}</G></L.Fragment>}><form id={`quitar-form`} onSubmit={s(d)} className={`grid gap-4 sm:grid-cols-2`}><_Component19 label={`Valor pago (R$)`} htmlFor={`q-valor`} error={l.valor_pago?.message} required={true}><K id={`q-valor`} inputMode={`decimal`} {...o(`valor_pago`)} /></_Component19><_Component19 label={`Data do pagamento`} htmlFor={`q-data`} error={l.pago_em?.message} required={true}><K id={`q-data`} type={`date`} {...o(`pago_em`)} /></_Component19><_Component19 label={`Forma de pagamento`} htmlFor={`q-forma`} error={l.forma_pagamento?.message} required={true} className={`sm:col-span-2`}><_Component31 id={`q-forma`} {...o(`forma_pagamento`)}>{Fp.map(e => <option value={e} key={e}>{gi[e]}</option>)}</_Component31></_Component19></form></_Component21>;
}
function Lp({
  open: e,
  onOpenChange: t,
  contratoId: n,
  nomePadrao: r,
  documentoPadrao: i
}) {
  let a = sf();
  let [o, s] = (0, k.useState)(r);
  let [c, l] = (0, k.useState)(i);
  let [u, d] = (0, k.useState)(null);
  async function f() {
    if (!u) {
      N.error(`Colete a assinatura do cliente no quadro.`);
      return;
    }
    if (o.trim().length < 2) {
      N.error(`Informe o nome do signatário.`);
      return;
    }
    await a.mutateAsync({
      id: n,
      signatarioNome: o,
      signatarioDocumento: c.trim() === `` ? null : c,
      assinaturaData: u
    });
    t(false);
  }
          return <_Component21 open={e} onOpenChange={t} title={`Assinatura do contrato`} description={`Confirme o signatário e colete a assinatura na tela.`} size={`lg`} footer={<L.Fragment><G variant={`outline`} onClick={() => t(false)} disabled={a.isPending}>{`Cancelar`}</G><G onClick={() => void f()} disabled={a.isPending}>{a.isPending ? `Registrando...` : `Registrar assinatura`}</G></L.Fragment>}><div className={`space-y-4`}><div className={`grid gap-4 sm:grid-cols-2`}><_Component19 label={`Nome do signatário`} htmlFor={`sig-nome`} required={true}><K id={`sig-nome`} value={o} onChange={e => s(e.target.value)} /></_Component19><_Component19 label={`CPF do signatário`} htmlFor={`sig-doc`}><K id={`sig-doc`} value={c} onChange={e => l(e.target.value)} /></_Component19></div><div><p className={`mb-2 text-[13px] font-medium`}>{`Assinatura`}</p><Pf onChange={d} /></div></div></_Component21>;
}
function Rp() {
  let {
    id: e
  } = g();
  let t = f();
  let {
    hasRole: n
  } = Ct();
  let {
    data: r
  } = Ir();
  let i = n([`admin`, `orcamentista`]);
  let {
    data: a,
    isLoading: o
  } = nf(e);
  let s = of(e);
  let c = cf();
  let l = lf();
  let u = Ep();
  let [d, p] = (0, k.useState)(false);
  let [m, h] = (0, k.useState)(false);
  let [_, v] = (0, k.useState)(false);
  let [y, b] = (0, k.useState)(null);
  if (o) {
    return <Ks className={`h-64`} />;
  }
  if (!a) {
    return <Ws title={`Contrato não encontrado`} action={<G variant={`outline`} onClick={() => t(`/contratos`)}><Mt className={`h-4 w-4`} />{`Voltar`}</G>} />;
  }
  let x = a.lancamentos ?? [];
  let S = x.filter(e => e.status === `pago`);
  let C = S.reduce((e, t) => e + Number(t.valor_pago ?? t.valor), 0);
  function w() {
    if (!a) {
      return;
    }
    let e = x.map(e => `<tr><td>${e.parcela_numero ?? `-`}</td><td>${to(e.vencimento)}</td><td>${W(e.valor)}</td><td>${mi[e.status]}</td></tr>`).join(``);
    yd(`Contrato ${a.numero}`, `<h1>Contrato ${a.numero}</h1>
       <p class="meta">${r?.name ?? `Marcenaria`}${r?.documento ? ` - ${ao(r.documento)}` : ``}</p>
       <table>
         <tr><th>Projeto</th><td>${a.projeto?.nome ?? `-`}</td></tr>
         <tr><th>Cliente</th><td>${a.cliente?.nome ?? `-`}</td></tr>
         <tr><th>Valor total</th><td>${W(a.valor_total)}</td></tr>
         <tr><th>Parcelas</th><td>${a.num_parcelas} a cada ${a.intervalo_dias} dias</td></tr>
         <tr><th>Status</th><td>${ui[a.status]}</td></tr>
       </table>
       <h2>Objeto</h2>
       <p style="font-size:13px;line-height:1.6;white-space:pre-line">${a.conteudo ?? `Conforme acordado entre as partes.`}</p>
       <h2>Cronograma de pagamento</h2>
       <table><thead><tr><th>Parcela</th><th>Vencimento</th><th>Valor</th><th>Status</th></tr></thead><tbody>${e}</tbody></table>
       <h2>Termos e condições</h2>
       <p style="font-size:13px;line-height:1.6;white-space:pre-line">${a.termos ?? `Condições a combinar.`}</p>
       ${a.observacoes ? `<h2>Observações</h2><p style="font-size:13px;line-height:1.6;white-space:pre-line">${a.observacoes}</p>` : ``}
       <h2>Assinatura</h2>
       ${a.assinatura_data ? `<p style="font-size:12px;color:#6b7280">Assinado por ${a.signatario_nome ?? ``} em ${no(a.assinado_em)}</p><img src="${a.assinatura_data}" alt="Assinatura" style="max-width:360px;border-bottom:1px solid #111827" />` : `<p style='font-size:12px;color:#6b7280'>Contrato sem assinatura registrada.</p>`}`);
  }
                                                                return <div className={`space-y-6`}><Fs title={a.numero} description={`${a.projeto?.nome ?? `Sem projeto`} para ${a.cliente?.nome ?? `cliente`}`} actions={<L.Fragment><G variant={`outline`} onClick={() => t(`/contratos`)}><Mt className={`h-4 w-4`} />{`Voltar`}</G><G variant={`outline`} onClick={w}><Jn className={`h-4 w-4`} />{`Imprimir`}</G>{i && a.status !== `assinado` && a.status !== `cancelado` && <G onClick={() => p(true)}><_Component5 className={`h-4 w-4`} />{`Registrar assinatura`}</G>}</L.Fragment>}><div className={`flex flex-wrap items-center gap-2`}><Gs label={ui[a.status]} tone={di[a.status]} />{i && fi.filter(e => e !== `assinado`).map(e => <button type={`button`} disabled={e === a.status} onClick={() => s.mutate({
          status: e
        })} className={U(`rounded-full border px-3 py-1 text-[12px] font-medium transition-colors`, e === a.status ? `border-foreground bg-foreground text-background` : `border-border text-muted-foreground hover:text-foreground disabled:opacity-40`)} key={e}>{ui[e]}</button>)}{i && a.status !== `cancelado` && <G variant={`ghost`} size={`sm`} onClick={() => h(true)}><_Component53 className={`h-4 w-4`} />{`Cancelar contrato`}</G>}{i && <G variant={`ghost`} size={`sm`} onClick={() => v(true)}><_Component26 className={`h-4 w-4 text-destructive`} />{`Remover`}</G>}</div></Fs><div className={`grid gap-6 lg:grid-cols-[2fr_1fr]`}><Rs><_Component11><Bs>{`Parcelas`}</Bs></_Component11><Hs className={`p-0`}>{x.length > 0 ? <_Component28><_Component25><_Component24><J className={`w-14`}>{`#`}</J><J>{`Vencimento`}</J><J>{`Valor`}</J><J>{`Status`}</J><J className={`hidden md:table-cell`}>{`Pagamento`}</J><J className={`w-24 text-right`}>{`Ações`}</J></_Component24></_Component25><_Component27>{x.map(e => <_Component24 key={e.id}><Y className={`numero text-muted-foreground`}>{e.parcela_numero}</Y><Y>{to(e.vencimento)}</Y><Y className={`numero`}>{W(e.valor)}</Y><Y><Gs label={mi[e.status]} tone={hi[e.status]} /></Y><Y className={`hidden md:table-cell text-muted-foreground`}>{e.status === `pago` ? `${to(e.pago_em)}${e.forma_pagamento ? ` - ${gi[e.forma_pagamento]}` : ``}` : `-`}</Y><Y className={`text-right`}>{i && e.status !== `cancelado` && <div className={`flex justify-end gap-1`}>{e.status === `previsto` ? <G variant={`outline`} size={`sm`} onClick={() => b(e)}>{`Dar baixa`}</G> : <G variant={`ghost`} size={`sm`} onClick={() => u.mutate({
                      id: e.id,
                      status: `previsto`
                    })}><Qn className={`h-3.5 w-3.5`} />{`Reabrir`}</G>}</div>}</Y></_Component24>)}</_Component27></_Component28> : <div className={`p-5`}><Ws className={`border-0 py-8`} title={`Sem parcelas geradas`} description={`Contratos criados pelo sistema geram o cronograma automaticamente.`} /></div>}</Hs></Rs><div className={`space-y-6`}><Rs><_Component11><Bs>{`Resumo`}</Bs></_Component11><Hs className={`space-y-3 text-[13px]`}><div className={`flex items-center justify-between`}><span className={`text-muted-foreground`}>{`Valor total`}</span><span className={`numero`}>{W(a.valor_total)}</span></div><div className={`flex items-center justify-between`}><span className={`text-muted-foreground`}>{`Recebido`}</span><span className={`numero text-emerald-700 dark:text-emerald-400`}>{W(C)}</span></div><div className={`flex items-center justify-between border-t border-border pt-3`}><span className={`text-muted-foreground`}>{`Em aberto`}</span><span className={`numero font-medium`}>{W(Number(a.valor_total) - C)}</span></div><div className={`flex items-center justify-between`}><span className={`text-muted-foreground`}>{`Parcelas pagas`}</span><span className={`numero`}>{S.length}{` de `}{a.num_parcelas}</span></div><div className={`flex items-center justify-between`}><span className={`text-muted-foreground`}>{`1º vencimento`}</span><span>{to(a.primeiro_vencimento)}</span></div>{a.assinado_em && <div className={`flex items-center gap-2 border-t border-border pt-3 text-emerald-700 dark:text-emerald-400`}><Kt className={`h-4 w-4`} /><span>{`Assinado por `}{a.signatario_nome ?? `cliente`}{` em `}{no(a.assinado_em)}</span></div>}</Hs></Rs><Rs><_Component11><Bs>{`Objeto do contrato`}</Bs></_Component11><Hs className={`space-y-3 text-[13px] leading-relaxed text-muted-foreground`}><p className={`whitespace-pre-line`}>{a.conteudo ?? `Sem texto de objeto registrado.`}</p>{a.termos && <div><p className={`mb-1 font-medium text-foreground`}>{`Termos e condições`}</p><p className={`whitespace-pre-line`}>{a.termos}</p></div>}{a.observacoes && <div><p className={`mb-1 font-medium text-foreground`}>{`Observações`}</p><p className={`whitespace-pre-line`}>{a.observacoes}</p></div>}</Hs></Rs></div></div><Lp open={d} onOpenChange={p} contratoId={a.id} nomePadrao={a.cliente?.nome ?? ``} documentoPadrao={a.cliente?.documento ?? ``} key={d ? `aberto` : `fechado`} /><Ip open={!!y} onOpenChange={e => !e && b(null)} lancamento={y} /><_Component29 open={m} onOpenChange={h} title={`Cancelar contrato`} description={`As parcelas em aberto também serão canceladas.`} confirmLabel={`Cancelar contrato`} onConfirm={async () => {
      await c.mutateAsync(a.id);
    }} /><_Component29 open={_} onOpenChange={v} title={`Remover contrato`} description={`O contrato e as parcelas vinculadas serão excluídos.`} confirmLabel={`Remover`} onConfirm={async () => {
      await l.mutateAsync(a.id);
      t(`/contratos`);
    }} /></div>;
}
var zp = Object.keys(gi);
var Bp = {
  tipo: `despesa`,
  descricao: ``,
  valor: ``,
  vencimento: uo(),
  categoria_id: ``,
  fornecedor_id: ``,
  cliente_id: ``,
  projeto_id: ``,
  forma_pagamento: ``,
  observacoes: ``,
  registrar_pagamento: false
};
function Vp({
  open: e,
  onOpenChange: t,
  lancamento: r,
  tipoInicial: a = `despesa`
}) {
  let o = Sp();
  let s = Cp();
  let {
    data: c
  } = Dp();
  let {
    data: l
  } = jp();
  let {
    data: u
  } = rl();
  let {
    data: d
  } = Jl();
  let {
    register: f,
    handleSubmit: p,
    reset: m,
    watch: h,
    formState: {
      errors: g,
      isSubmitting: _
    }
  } = i({
    resolver: n(Oc),
    defaultValues: Bp
  });
  let v = h(`tipo`);
  let y = !!r;
  (0, k.useEffect)(() => {
    if (e) {
      m(r ? {
        tipo: r.tipo,
        descricao: r.descricao,
        valor: String(r.valor),
        vencimento: r.vencimento ?? uo(),
        categoria_id: r.categoria_id ?? ``,
        fornecedor_id: r.fornecedor_id ?? ``,
        cliente_id: r.cliente_id ?? ``,
        projeto_id: r.projeto_id ?? ``,
        forma_pagamento: r.forma_pagamento ?? ``,
        observacoes: r.observacoes ?? ``,
        registrar_pagamento: false
      } : {
        ...Bp,
        tipo: a
      });
    }
  }, [e, r, a, m]);
  async function b(e) {
    if (r) {
      await s.mutateAsync({
        id: r.id,
        payload: Il(e)
      });
    } else {
      await o.mutateAsync(Ll(e));
    }
    t(false);
  }
  let x = (c ?? []).filter(e => e.tipo === v);
                              return <_Component21 open={e} onOpenChange={t} title={y ? `Editar lançamento` : `Novo lançamento`} description={`Receitas e despesas da marcenaria em um único fluxo.`} size={`lg`} footer={<L.Fragment><G variant={`outline`} onClick={() => t(false)} disabled={_}>{`Cancelar`}</G><G form={`lancamento-form`} type={`submit`} disabled={_}>{_ ? `Salvando...` : y ? `Salvar lançamento` : `Registrar lançamento`}</G></L.Fragment>}><form id={`lancamento-form`} onSubmit={p(b)} className={`grid gap-4 sm:grid-cols-3`}><_Component19 label={`Tipo`} htmlFor={`lc-tipo`} error={g.tipo?.message} required={true}><_Component31 id={`lc-tipo`} {...f(`tipo`)}>{Object.keys(pi).map(e => <option value={e} key={e}>{pi[e]}</option>)}</_Component31></_Component19><_Component19 label={`Valor (R$)`} htmlFor={`lc-valor`} error={g.valor?.message} required={true}><K id={`lc-valor`} inputMode={`decimal`} {...f(`valor`)} /></_Component19><_Component19 label={`Vencimento`} htmlFor={`lc-venc`} error={g.vencimento?.message}><K id={`lc-venc`} type={`date`} {...f(`vencimento`)} /></_Component19><_Component19 label={`Descrição`} htmlFor={`lc-desc`} error={g.descricao?.message} required={true} className={`sm:col-span-3`}><K id={`lc-desc`} placeholder={`Ex: Compra de chapas MDF`} {...f(`descricao`)} /></_Component19><_Component19 label={`Categoria`} htmlFor={`lc-cat`} error={g.categoria_id?.message}><_Component31 id={`lc-cat`} {...f(`categoria_id`)}><option value={``}>{`Sem categoria`}</option>{x.map(e => <option value={e.id} key={e.id}>{e.nome}</option>)}</_Component31></_Component19>{v === `despesa` ? <_Component19 label={`Fornecedor`} htmlFor={`lc-forn`} error={g.fornecedor_id?.message}><_Component31 id={`lc-forn`} {...f(`fornecedor_id`)}><option value={``}>{`Sem fornecedor`}</option>{(l ?? []).map(e => <option value={e.id} key={e.id}>{e.nome}</option>)}</_Component31></_Component19> : <_Component19 label={`Cliente`} htmlFor={`lc-cli`} error={g.cliente_id?.message}><_Component31 id={`lc-cli`} {...f(`cliente_id`)}><option value={``}>{`Sem cliente`}</option>{(u ?? []).map(e => <option value={e.id} key={e.id}>{e.nome}</option>)}</_Component31></_Component19>}<_Component19 label={`Projeto`} htmlFor={`lc-proj`} error={g.projeto_id?.message}><_Component31 id={`lc-proj`} {...f(`projeto_id`)}><option value={``}>{`Sem projeto`}</option>{(d ?? []).map(e => <option value={e.id} key={e.id}>{e.nome}</option>)}</_Component31></_Component19><_Component19 label={`Forma de pagamento`} htmlFor={`lc-forma`} error={g.forma_pagamento?.message}><_Component31 id={`lc-forma`} {...f(`forma_pagamento`)}><option value={``}>{`A definir`}</option>{zp.map(e => <option value={e} key={e}>{gi[e]}</option>)}</_Component31></_Component19><_Component19 label={`Observações`} htmlFor={`lc-obs`} error={g.observacoes?.message} className={`sm:col-span-3`}><Rl id={`lc-obs`} rows={2} {...f(`observacoes`)} /></_Component19>{!y && <div className={`sm:col-span-3`}><_Component35 id={`lc-pago`} label={`Já ${v === `receita` ? `recebido` : `pago`} (registra a baixa agora)`} {...f(`registrar_pagamento`)} />{h(`registrar_pagamento`) && !h(`forma_pagamento`) && <p className={`mt-1 text-xs text-muted-foreground`}>{`Selecione a forma de pagamento para manter o histórico consistente.`}</p>}</div>}</form></_Component21>;
}
var Hp = {
  nome: ``,
  documento: ``,
  email: ``,
  telefone: ``,
  endereco: ``,
  cidade: ``,
  uf: ``,
  cep: ``,
  observacoes: ``
};
function Up({
  open: e,
  onOpenChange: t,
  fornecedor: r
}) {
  let a = Mp();
  let o = Np();
  let {
    register: s,
    handleSubmit: c,
    reset: l,
    formState: {
      errors: u,
      isSubmitting: d
    }
  } = i({
    resolver: n(Ec),
    defaultValues: Hp
  });
  (0, k.useEffect)(() => {
    if (e) {
      l(r ? {
        nome: r.nome,
        documento: r.documento ?? ``,
        email: r.email ?? ``,
        telefone: r.telefone ?? ``,
        endereco: r.endereco ?? ``,
        cidade: r.cidade ?? ``,
        uf: r.uf ?? ``,
        cep: r.cep ?? ``,
        observacoes: r.observacoes ?? ``
      } : Hp);
    }
  }, [e, r, l]);
  async function f(e) {
    let n = Pl(e);
    if (r) {
      await o.mutateAsync({
        id: r.id,
        payload: n
      });
    } else {
      await a.mutateAsync(n);
    }
    t(false);
  }
      return <_Component21 open={e} onOpenChange={t} title={r ? `Editar fornecedor` : `Novo fornecedor`} description={`Usado nas contas a pagar do financeiro.`} size={`lg`} footer={<L.Fragment><G variant={`outline`} onClick={() => t(false)} disabled={d}>{`Cancelar`}</G><G form={`fornecedor-form`} type={`submit`} disabled={d}>{d ? `Salvando...` : `Salvar`}</G></L.Fragment>}><form id={`fornecedor-form`} onSubmit={c(f)} className={`grid gap-4 sm:grid-cols-2`}><_Component19 label={`Nome`} htmlFor={`fn-nome`} error={u.nome?.message} required={true} className={`sm:col-span-2`}><K id={`fn-nome`} {...s(`nome`)} /></_Component19><_Component19 label={`CNPJ/CPF`} htmlFor={`fn-doc`} error={u.documento?.message}><K id={`fn-doc`} {...s(`documento`)} /></_Component19><_Component19 label={`Telefone`} htmlFor={`fn-tel`} error={u.telefone?.message}><K id={`fn-tel`} {...s(`telefone`)} /></_Component19><_Component19 label={`E-mail`} htmlFor={`fn-email`} error={u.email?.message} className={`sm:col-span-2`}><K id={`fn-email`} type={`email`} {...s(`email`)} /></_Component19><_Component19 label={`Endereço`} htmlFor={`fn-end`} error={u.endereco?.message} className={`sm:col-span-2`}><K id={`fn-end`} {...s(`endereco`)} /></_Component19><_Component19 label={`Cidade`} htmlFor={`fn-cidade`} error={u.cidade?.message}><K id={`fn-cidade`} {...s(`cidade`)} /></_Component19><div className={`grid grid-cols-2 gap-4`}><_Component19 label={`UF`} htmlFor={`fn-uf`} error={u.uf?.message}><K id={`fn-uf`} maxLength={2} {...s(`uf`)} /></_Component19><_Component19 label={`CEP`} htmlFor={`fn-cep`} error={u.cep?.message}><K id={`fn-cep`} {...s(`cep`)} /></_Component19></div><_Component19 label={`Observações`} htmlFor={`fn-obs`} error={u.observacoes?.message} className={`sm:col-span-2`}><Rl id={`fn-obs`} rows={2} {...s(`observacoes`)} /></_Component19></form></_Component21>;
}
var Wp = [{
  valor: ``,
  label: `Sem cor`
}, {
  valor: `#0f766e`,
  label: `Petrol`
}, {
  valor: `#0284c7`,
  label: `Azul`
}, {
  valor: `#4f46e5`,
  label: `Indigo`
}, {
  valor: `#15803d`,
  label: `Verde`
}, {
  valor: `#b45309`,
  label: `Âmbar`
}, {
  valor: `#b42318`,
  label: `Vermelho`
}, {
  valor: `#a21caf`,
  label: `Magenta`
}];
var Gp = {
  nome: ``,
  tipo: `despesa`,
  cor: ``,
  ativo: true
};
function Kp({
  open: e,
  onOpenChange: t,
  categoria: r
}) {
  let a = Op();
  let o = kp();
  let {
    register: s,
    handleSubmit: c,
    reset: l,
    watch: u,
    formState: {
      errors: d,
      isSubmitting: f
    }
  } = i({
    resolver: n(Dc),
    defaultValues: Gp
  });
  (0, k.useEffect)(() => {
    if (e) {
      l(r ? {
        nome: r.nome,
        tipo: r.tipo,
        cor: r.cor ?? ``,
        ativo: r.ativo
      } : Gp);
    }
  }, [e, r, l]);
  async function p(e) {
    let n = Fl(e);
    if (r) {
      await o.mutateAsync({
        id: r.id,
        payload: n
      });
    } else {
      await a.mutateAsync(n);
    }
    t(false);
  }
  let m = u(`cor`);
              return <_Component21 open={e} onOpenChange={t} title={r ? `Editar categoria` : `Nova categoria`} description={`Agrupa receitas e despesas para leitura dos relatórios.`} footer={<L.Fragment><G variant={`outline`} onClick={() => t(false)} disabled={f}>{`Cancelar`}</G><G form={`categoria-form`} type={`submit`} disabled={f}>{f ? `Salvando...` : `Salvar`}</G></L.Fragment>}><form id={`categoria-form`} onSubmit={c(p)} className={`grid gap-4 sm:grid-cols-2`}><_Component19 label={`Nome`} htmlFor={`cat-nome`} error={d.nome?.message} required={true} className={`sm:col-span-2`}><K id={`cat-nome`} placeholder={`Ex: Matéria-prima`} {...s(`nome`)} /></_Component19><_Component19 label={`Tipo`} htmlFor={`cat-tipo`} error={d.tipo?.message} required={true}><_Component31 id={`cat-tipo`} {...s(`tipo`)}>{Object.keys(pi).map(e => <option value={e} key={e}>{pi[e]}</option>)}</_Component31></_Component19><_Component19 label={`Cor de identificação`} htmlFor={`cat-cor`} error={d.cor?.message}><div className={`flex items-center gap-2`}><_Component31 id={`cat-cor`} {...s(`cor`)}>{Wp.map(e => <option value={e.valor} key={e.label}>{e.label}</option>)}</_Component31><span className={`h-9 w-9 shrink-0 rounded-md border border-border`} style={{
            backgroundColor: m || `transparent`
          }} aria-hidden={true} /></div></_Component19><div className={`sm:col-span-2`}><_Component35 id={`cat-ativo`} label={`Categoria ativa`} {...s(`ativo`)} /></div></form></_Component21>;
}
function _Component106() {
  let {
    hasRole: e
  } = Ct();
  let t = e([`admin`, `orcamentista`]);
  let [n, r] = (0, k.useState)(`resumo`);
  let [i, a] = (0, k.useState)(`todos`);
  let [o, s] = (0, k.useState)(`todos`);
  let [c, l] = (0, k.useState)(``);
  let [u, d] = (0, k.useState)(``);
  let [f, p] = (0, k.useState)(``);
  let [m, h] = (0, k.useState)(false);
  let [g, _] = (0, k.useState)(null);
  let [v, y] = (0, k.useState)(null);
  let [b, x] = (0, k.useState)(null);
  let [S, C] = (0, k.useState)(false);
  let [w, T] = (0, k.useState)(null);
  let [E, D] = (0, k.useState)(null);
  let [O, A] = (0, k.useState)(false);
  let [ee, te] = (0, k.useState)(null);
  let [j, ne] = (0, k.useState)(null);
  let re = (0, k.useMemo)(() => {
    let e = {};
    if (i !== `todos`) {
      e.tipo = i;
    }
    if (o !== `todos`) {
      e.status = o;
    }
    if (c) {
      e.de = c;
    }
    if (u) {
      e.ate = u;
    }
    if (f.trim().length > 0) {
      e.busca = f.trim();
    }
    return e;
  }, [i, o, c, u, f]);
  let {
    data: M,
    isLoading: ie
  } = xp();
  let {
    data: ae,
    isLoading: oe
  } = xp(re);
  let {
    data: se
  } = Dp();
  let {
    data: ce
  } = jp();
  let le = Ep();
  let ue = wp();
  let de = Pp();
  let fe = Ap();
  let pe = (0, k.useMemo)(() => vs(M ?? []), [M]);
  let me = (0, k.useMemo)(() => {
    let e = uo();
    return (M ?? []).filter(t => t.status === `previsto` && (t.vencimento ?? ``) >= e).slice(0, 8);
  }, [M]);
  let N = (0, k.useMemo)(() => {
    let e = uo();
    return (M ?? []).filter(t => t.status === `previsto` && t.vencimento !== null && t.vencimento < e);
  }, [M]);
  function he(e) {
    _(null);
    r(`lancamentos`);
    h(true);
    a(e);
  }
                                                                                          return <div className={`space-y-6`}><Fs title={`Financeiro`} description={ie ? `Carregando movimentações.` : `Saldo realizado de ${W(pe.saldoRealizado)} e projetado de ${W(pe.saldoProjetado)}.`} actions={t ? <L.Fragment><G variant={`outline`} onClick={() => he(`receita`)}><_Component49 className={`h-4 w-4`} />{`Nova receita`}</G><G onClick={() => he(`despesa`)}><_Component10 className={`h-4 w-4`} />{`Nova despesa`}</G></L.Fragment> : undefined}><_Component32 value={n} onValueChange={r} tabs={[{
        value: `resumo`,
        label: `Resumo`
      }, {
        value: `lancamentos`,
        label: `Lançamentos`,
        count: M?.length ?? 0
      }, {
        value: `cadastros`,
        label: `Cadastros`
      }]} /></Fs>{!t && <div className={`flex items-center gap-2 rounded-[10px] border border-border bg-muted/40 px-3 py-2 text-[13px] text-muted-foreground`}><_Component6 className={`h-4 w-4`} />{`Seu perfil pode consultar o financeiro, mas não registrar movimentações.`}</div>}{n === `resumo` && <div className={`space-y-6`}>{ie ? <_Component23 columns={4} rows={3} /> : <Rs className={`overflow-hidden`}><Ls items={[{
          label: `A receber`,
          value: W(pe.aReceber)
        }, {
          label: `Recebido`,
          value: W(pe.recebido),
          tom: `success`
        }, {
          label: `A pagar`,
          value: W(pe.aPagar)
        }, {
          label: `Pago`,
          value: W(pe.pago)
        }, {
          label: `Em atraso`,
          value: W(pe.receitasEmAtraso + pe.despesasEmAtraso),
          tom: pe.receitasEmAtraso + pe.despesasEmAtraso > 0 ? `warning` : `default`
        }]} /></Rs>}<div className={`grid gap-6 lg:grid-cols-2`}><Rs><_Component11><Bs>{`Próximos vencimentos`}</Bs></_Component11><Hs className={`p-0`}>{me.length > 0 ? <ul className={`divide-y divide-border border-t border-border`}>{me.map(e => <li className={`flex items-center justify-between gap-3 px-5 py-2.5`} key={e.id}><div className={`min-w-0`}><p className={`truncate text-[13px] font-medium`}>{e.descricao}</p><p className={`truncate text-[11px] text-muted-foreground`}>{to(e.vencimento)}{e.fornecedor?.nome ? ` - ${e.fornecedor.nome}` : ``}{e.cliente?.nome ? ` - ${e.cliente.nome}` : ``}</p></div><span className={U(`numero shrink-0 text-[13px]`, e.tipo === `receita` ? `text-emerald-700 dark:text-emerald-400` : `text-foreground`)}>{e.tipo === `receita` ? `+` : `-`}{` `}{W(e.valor)}</span></li>)}</ul> : <div className={`border-t border-border p-5`}><Ws className={`border-0 py-8`} title={`Nada a vencer`} description={`Lançamentos previstos com vencimento futuro aparecem aqui.`} /></div>}</Hs></Rs><Rs><_Component11 className={`flex flex-row items-center justify-between space-y-0`}><Bs className={`flex items-center gap-2`}><_Component50 className={`h-4 w-4 text-amber-600 dark:text-amber-400`} />{`Em atraso`}</Bs><span className={`numero text-[13px] text-amber-700 dark:text-amber-400`}>{W(pe.receitasEmAtraso + pe.despesasEmAtraso)}</span></_Component11><Hs className={`p-0`}>{N.length > 0 ? <ul className={`divide-y divide-border border-t border-border`}>{N.slice(0, 8).map(e => <li className={`flex items-center justify-between gap-3 px-5 py-2.5`} key={e.id}><div className={`min-w-0`}><p className={`truncate text-[13px] font-medium`}>{e.descricao}</p><p className={`truncate text-[11px] text-muted-foreground`}>{`venceu em `}{to(e.vencimento)}</p></div><span className={`numero shrink-0 text-[13px] text-amber-700 dark:text-amber-400`}>{W(e.valor)}</span></li>)}</ul> : <div className={`border-t border-border p-5`}><Ws className={`border-0 py-8`} title={`Nenhum lançamento atrasado`} description={`Previsões vencidas e ainda em aberto aparecem aqui.`} /></div>}</Hs></Rs></div></div>}{n === `lancamentos` && <div className={`space-y-4`}><div className={`flex flex-col gap-2 sm:flex-row sm:flex-wrap sm:items-center`}><_Component31 wrapperClassName={`w-full sm:w-40`} value={i} onChange={e => a(e.target.value)}><option value={`todos`}>{`Todos os tipos`}</option><option value={`receita`}>{`Receitas`}</option><option value={`despesa`}>{`Despesas`}</option></_Component31><_Component31 wrapperClassName={`w-full sm:w-40`} value={o} onChange={e => s(e.target.value)}><option value={`todos`}>{`Todos os status`}</option>{Object.keys(mi).map(e => <option value={e} key={e}>{mi[e]}</option>)}</_Component31><K type={`date`} className={`w-full sm:w-40`} value={c} onChange={e => l(e.target.value)} aria-label={`Vencimento inicial`} /><K type={`date`} className={`w-full sm:w-40`} value={u} onChange={e => d(e.target.value)} aria-label={`Vencimento final`} /><div className={`relative w-full sm:max-w-xs`}><_Component22 className={`pointer-events-none absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-muted-foreground`} /><K value={f} onChange={e => p(e.target.value)} placeholder={`Buscar descrição`} className={`pl-9`} /></div></div>{oe ? <_Component23 columns={6} /> : ae && ae.length > 0 ? <Rs className={`overflow-hidden`}><_Component28><_Component25><_Component24><J>{`Vencimento`}</J><J>{`Descrição`}</J><J className={`hidden md:table-cell`}>{`Categoria`}</J><J className={`hidden sm:table-cell`}>{`Origem`}</J><J className={`text-right`}>{`Valor`}</J><J>{`Status`}</J><J className={`w-12 text-right`}>{`Ações`}</J></_Component24></_Component25><_Component27>{ae.map(e => <_Component24 key={e.id}><Y className={`whitespace-nowrap text-muted-foreground`}>{to(e.vencimento)}</Y><Y><p className={`font-medium`}>{e.descricao}</p><p className={`truncate text-[11px] text-muted-foreground`}>{[e.fornecedor?.nome, e.cliente?.nome, e.contrato?.numero].filter(Boolean).join(` - `) || `-`}</p></Y><Y className={`hidden md:table-cell text-muted-foreground`}>{e.categoria?.nome ?? `-`}</Y><Y className={`hidden sm:table-cell text-muted-foreground`}>{e.origem === `contrato` ? `Contrato ${e.contrato?.numero ?? ``}` : `Manual`}</Y><Y className={U(`numero text-right`, e.tipo === `receita` ? `text-emerald-700 dark:text-emerald-400` : `text-foreground`)}>{e.tipo === `receita` ? `+` : `-`}{` `}{W(e.valor)}</Y><Y><Gs label={mi[e.status]} tone={hi[e.status]} /></Y><Y className={`text-right`}>{t && <Lo items={[{
                  label: e.tipo === `receita` ? `Receber` : `Pagar`,
                  icon: e.tipo === `receita` ? <_Component49 className={`h-4 w-4`} /> : <Nt className={`h-4 w-4`} />,
                  hidden: e.status !== `previsto`,
                  onSelect: () => y(e)
                }, {
                  label: `Editar`,
                  icon: <Wn className={`h-4 w-4`} />,
                  onSelect: () => {
                    _(e);
                    h(true);
                  }
                }, {
                  label: `Reabrir`,
                  icon: <Nt className={`h-4 w-4`} />,
                  hidden: e.status !== `pago`,
                  onSelect: () => le.mutate({
                    id: e.id,
                    status: `previsto`
                  })
                }, {
                  label: `Cancelar lançamento`,
                  icon: <_Component26 className={`h-4 w-4`} />,
                  hidden: e.status === `cancelado`,
                  onSelect: () => le.mutate({
                    id: e.id,
                    status: `cancelado`
                  })
                }, {
                  label: `Remover`,
                  icon: <_Component26 className={`h-4 w-4`} />,
                  destructive: true,
                  onSelect: () => x(e)
                }]} />}</Y></_Component24>)}</_Component27></_Component28></Rs> : <Ws icon={<_Component6 className={`h-4 w-4`} />} title={`Nenhum lançamento encontrado`} description={`Registre receitas e despesas para acompanhar o caixa da marcenaria.`} action={t ? <G onClick={() => he(`despesa`)}><_Component10 className={`h-4 w-4`} />{`Nova despesa`}</G> : undefined} />}</div>}{n === `cadastros` && <div className={`grid gap-6 lg:grid-cols-2`}><Rs><_Component11 className={`flex flex-row items-center justify-between space-y-0`}><Bs>{`Fornecedores`}</Bs>{t && <G size={`sm`} variant={`outline`} onClick={() => {
            T(null);
            C(true);
          }}><_Component10 className={`h-4 w-4`} />{`Novo`}</G>}</_Component11><Hs className={`p-0`}>{ce && ce.length > 0 ? <ul className={`divide-y divide-border border-t border-border`}>{ce.map(e => <li className={`flex items-center justify-between gap-3 px-5 py-2.5`} key={e.id}><div className={`min-w-0`}><p className={`truncate text-[13px] font-medium`}>{e.nome}</p><p className={`truncate text-[11px] text-muted-foreground`}>{[e.telefone, e.email].filter(Boolean).join(` - `) || `-`}</p></div>{t && <Lo items={[{
                label: `Editar`,
                icon: <Wn className={`h-4 w-4`} />,
                onSelect: () => {
                  T(e);
                  C(true);
                }
              }, {
                label: `Remover`,
                icon: <_Component26 className={`h-4 w-4`} />,
                destructive: true,
                onSelect: () => D(e)
              }]} />}</li>)}</ul> : <div className={`border-t border-border p-5`}><Ws className={`border-0 py-8`} title={`Nenhum fornecedor`} description={`Cadastre fornecedores para vincular as contas a pagar.`} /></div>}</Hs></Rs><Rs><_Component11 className={`flex flex-row items-center justify-between space-y-0`}><Bs>{`Categorias`}</Bs>{t && <G size={`sm`} variant={`outline`} onClick={() => {
            te(null);
            A(true);
          }}><_Component10 className={`h-4 w-4`} />{`Nova`}</G>}</_Component11><Hs className={`p-0`}>{se && se.length > 0 ? <ul className={`divide-y divide-border border-t border-border`}>{se.map(e => <li className={`flex items-center justify-between gap-3 px-5 py-2.5`} key={e.id}><div className={`flex min-w-0 items-center gap-2`}><span className={`h-2.5 w-2.5 shrink-0 rounded-full border border-border`} style={{
                  backgroundColor: e.cor ?? `transparent`
                }} aria-hidden={true} /><div className={`min-w-0`}><p className={`truncate text-[13px] font-medium`}>{e.nome}</p><p className={`text-[11px] text-muted-foreground`}>{pi[e.tipo]}{e.ativo ? `` : ` - inativa`}</p></div></div>{t && <Lo items={[{
                label: `Editar`,
                icon: <Wn className={`h-4 w-4`} />,
                onSelect: () => {
                  te(e);
                  A(true);
                }
              }, {
                label: `Remover`,
                icon: <_Component26 className={`h-4 w-4`} />,
                destructive: true,
                onSelect: () => ne(e)
              }]} />}</li>)}</ul> : <div className={`border-t border-border p-5`}><Ws className={`border-0 py-8`} title={`Nenhuma categoria`} description={`Categorias agrupam as movimentações nos relatórios.`} /></div>}</Hs></Rs></div>}<Vp open={m} onOpenChange={h} lancamento={g} tipoInicial={i === `todos` ? `despesa` : i} /><Ip open={!!v} onOpenChange={e => !e && y(null)} lancamento={v} /><Up open={S} onOpenChange={C} fornecedor={w} /><Kp open={O} onOpenChange={A} categoria={ee} /><_Component29 open={!!b} onOpenChange={e => !e && x(null)} title={`Remover lançamento`} description={b ? `Remover "${b.descricao}"?` : undefined} confirmLabel={`Remover`} onConfirm={async () => {
      if (b) {
        await ue.mutateAsync(b.id);
      }
    }} /><_Component29 open={!!E} onOpenChange={e => !e && D(null)} title={`Remover fornecedor`} description={E ? `Remover ${E.nome}?` : undefined} confirmLabel={`Remover`} onConfirm={async () => {
      if (E) {
        await de.mutateAsync(E.id);
      }
    }} /><_Component29 open={!!j} onOpenChange={e => !e && ne(null)} title={`Remover categoria`} description={j ? `Remover ${j.nome}?` : undefined} confirmLabel={`Remover`} onConfirm={async () => {
      if (j) {
        await fe.mutateAsync(j.id);
      }
    }} /></div>;
}
var Jp = `*, projeto:projetos(id,nome), ambiente:ambientes(id,nome,tipo,margem_percent,projeto_id)`;
async function Yp() {
  let {
    data: e,
    error: t
  } = await B.from(`modulos_catalogo`).select(`*`).eq(`ativo`, true).order(`categoria`, {
    ascending: true
  }).order(`ordem`, {
    ascending: true
  }).order(`largura_mm`, {
    ascending: true
  });
  if (t) {
    throw t;
  }
  return e ?? [];
}
async function Xp() {
  let {
    data: e,
    error: t
  } = await B.rpc(`seed_catalogo_modulos`);
  if (t) {
    throw t;
  }
  return e ?? 0;
}
async function Zp(e) {
  let {
    data: t,
    error: n
  } = await B.from(`modulos_catalogo`).insert(e).select(`*`).single();
  if (n) {
    if (n.code === `23505`) {
      let t = `${e.nome} (${Math.floor(100 + Math.random() * 900)})`;
      let n = await B.from(`modulos_catalogo`).insert({
        ...e,
        nome: t
      }).select(`*`).single();
      if (n.error) {
        throw n.error;
      }
      return n.data;
    }
    throw n;
  }
  return t;
}
async function Qp(e) {
  let {
    error: t
  } = await B.from(`modulos_catalogo`).delete().eq(`id`, e);
  if (t) {
    throw t;
  }
}
async function $p(e) {
  let t = B.from(`designs`).select(Jp).order(`updated_at`, {
    ascending: false
  });
  if (e?.projetoId) {
    t = t.eq(`projeto_id`, e.projetoId);
  }
  let {
    data: n,
    error: r
  } = await t;
  if (r) {
    throw r;
  }
  return n ?? [];
}
async function em(e) {
  let {
    data: t,
    error: n
  } = await B.from(`designs`).select(Jp).eq(`id`, e).single();
  if (n) {
    throw n;
  }
  return t;
}
async function tm(e) {
  let {
    data: t,
    error: n
  } = await B.from(`designs`).insert({
    ...e,
    cena: e.cena
  }).select(`*`).single();
  if (n) {
    throw n;
  }
  return t;
}
async function nm(e, t) {
  let {
    cena: n,
    ...r
  } = t;
  let i = {
    ...r
  };
  if (n !== undefined) {
    i.cena = n;
  }
  let {
    data: a,
    error: o
  } = await B.from(`designs`).update(i).eq(`id`, e).select(`*`).single();
  if (o) {
    throw o;
  }
  return a;
}
async function rm(e) {
  let {
    error: t
  } = await B.from(`designs`).delete().eq(`id`, e);
  if (t) {
    throw t;
  }
}
function im() {
  return T({
    queryKey: H.catalogoModulos,
    queryFn: Yp
  });
}
function am() {
  let e = C();
  return O({
    mutationFn: Xp,
    onSuccess: t => {
      e.invalidateQueries({
        queryKey: H.catalogoModulos
      });
      N.success(`${t} módulos adicionados à biblioteca.`);
    },
    onError: e => N.error(cu(e))
  });
}
function om() {
  let e = C();
  return O({
    mutationFn: e => Zp(e),
    onSuccess: () => {
      e.invalidateQueries({
        queryKey: H.catalogoModulos
      });
      N.success(`Módulo adicionado à biblioteca.`);
    },
    onError: e => N.error(cu(e))
  });
}
function sm() {
  let e = C();
  return O({
    mutationFn: Qp,
    onSuccess: () => {
      e.invalidateQueries({
        queryKey: H.catalogoModulos
      });
      N.success(`Módulo removido da biblioteca.`);
    },
    onError: e => N.error(cu(e))
  });
}
function cm(e) {
  return T({
    queryKey: H.designs(e),
    queryFn: () => $p(e)
  });
}
function lm(e) {
  return T({
    queryKey: H.design(e ?? ``),
    queryFn: () => em(e),
    enabled: !!e
  });
}
function um() {
  let e = C();
  let {
    user: t
  } = Ct();
  return O({
    mutationFn: e => tm({
      ...e,
      created_by: t?.id ?? ``
    }),
    onSuccess: () => {
      e.invalidateQueries({
        queryKey: [`designs`]
      });
      N.success(`Estudo 3D criado.`);
    },
    onError: e => N.error(cu(e))
  });
}
function dm(e) {
  let t = C();
  return O({
    mutationFn: t => nm(e, t),
    onSuccess: () => {
      t.invalidateQueries({
        queryKey: [`designs`]
      });
      t.invalidateQueries({
        queryKey: H.design(e ?? ``)
      });
      N.success(`Estudo 3D salvo.`);
    },
    onError: e => N.error(cu(e))
  });
}
function fm() {
  let e = C();
  return O({
    mutationFn: rm,
    onSuccess: () => {
      e.invalidateQueries({
        queryKey: [`designs`]
      });
      N.success(`Estudo 3D removido.`);
    },
    onError: e => N.error(cu(e))
  });
}
var pm = 10;
var mm = 6000;
var hm = 30;
var gm = {
  preset: `estudio`,
  piso: ``,
  parede: ``
};
var _m = {
  porta: {
    tipo: `porta`,
    nome: `Porta`,
    largura: 800,
    altura: 2100,
    profundidade: 35,
    alturaCentro: 1050,
    instalacao: `parede`
  },
  janela: {
    tipo: `janela`,
    nome: `Janela`,
    largura: 1200,
    altura: 1200,
    profundidade: 80,
    alturaCentro: 1500,
    instalacao: `parede`
  },
  cortina: {
    tipo: `cortina`,
    nome: `Cortina`,
    largura: 1800,
    altura: 2200,
    profundidade: 120,
    alturaCentro: 1250,
    instalacao: `teto`
  },
  tomada: {
    tipo: `tomada`,
    nome: `Tomada`,
    largura: 80,
    altura: 80,
    profundidade: 12,
    alturaCentro: 1100,
    instalacao: `parede`
  },
  interruptor: {
    tipo: `interruptor`,
    nome: `Interruptor`,
    largura: 80,
    altura: 80,
    profundidade: 10,
    alturaCentro: 1250,
    instalacao: `parede`
  },
  ponto_rede: {
    tipo: `ponto_rede`,
    nome: `Ponto de rede`,
    largura: 80,
    altura: 80,
    profundidade: 12,
    alturaCentro: 300,
    instalacao: `parede`
  },
  ar_condicionado: {
    tipo: `ar_condicionado`,
    nome: `Ar-condicionado`,
    largura: 900,
    altura: 300,
    profundidade: 200,
    alturaCentro: 2150,
    instalacao: `parede`
  },
  tv: {
    tipo: `tv`,
    nome: `TV`,
    largura: 1200,
    altura: 700,
    profundidade: 80,
    alturaCentro: 1300,
    instalacao: `parede`
  },
  espelho: {
    tipo: `espelho`,
    nome: `Espelho`,
    largura: 800,
    altura: 800,
    profundidade: 8,
    alturaCentro: 1600,
    instalacao: `parede`
  },
  coifa: {
    tipo: `coifa`,
    nome: `Coifa`,
    largura: 800,
    altura: 650,
    profundidade: 500,
    alturaCentro: 1700,
    instalacao: `teto`
  },
  geladeira: {
    tipo: `geladeira`,
    nome: `Geladeira`,
    largura: 700,
    altura: 1850,
    profundidade: 700,
    alturaCentro: 925,
    instalacao: `parede`
  },
  fogao: {
    tipo: `fogao`,
    nome: `Fogão 4 bocas`,
    largura: 600,
    altura: 850,
    profundidade: 600,
    alturaCentro: 425,
    instalacao: `parede`
  },
  torneira: {
    tipo: `torneira`,
    nome: `Torneira`,
    largura: 60,
    altura: 300,
    profundidade: 180,
    alturaCentro: 1020,
    instalacao: `bancada`
  },
  cuba: {
    tipo: `cuba`,
    nome: `Cuba`,
    largura: 500,
    altura: 180,
    profundidade: 400,
    alturaCentro: 880,
    instalacao: `bancada`
  },
  vaso: {
    tipo: `vaso`,
    nome: `Vaso sanitário`,
    largura: 380,
    altura: 780,
    profundidade: 650,
    alturaCentro: 390,
    instalacao: `parede`
  },
  box: {
    tipo: `box`,
    nome: `Box do chuveiro`,
    largura: 1200,
    altura: 2000,
    profundidade: 80,
    alturaCentro: 1000,
    instalacao: `parede`
  },
  cama_casal: {
    tipo: `cama_casal`,
    nome: `Cama de casal`,
    largura: 1380,
    altura: 550,
    profundidade: 1880,
    alturaCentro: 275,
    instalacao: `parede`
  },
  cama_solteiro: {
    tipo: `cama_solteiro`,
    nome: `Cama de solteiro`,
    largura: 880,
    altura: 500,
    profundidade: 1880,
    alturaCentro: 250,
    instalacao: `parede`
  }
};
var vm = {
  cozinha: [`porta`, `janela`, `tomada`, `interruptor`, `coifa`, `geladeira`, `fogao`, `torneira`, `cuba`],
  quarto: [`porta`, `janela`, `cortina`, `tomada`, `interruptor`, `ponto_rede`, `ar_condicionado`, `espelho`, `cama_casal`, `cama_solteiro`],
  sala: [`porta`, `janela`, `cortina`, `tomada`, `interruptor`, `ponto_rede`, `tv`, `ar_condicionado`],
  banheiro: [`porta`, `janela`, `tomada`, `interruptor`, `torneira`, `cuba`, `espelho`, `vaso`, `box`],
  escritorio: [`porta`, `janela`, `cortina`, `tomada`, `interruptor`, `ponto_rede`, `ar_condicionado`],
  area_externa: [`porta`, `janela`, `tomada`, `torneira`],
  outro: [`porta`, `janela`, `tomada`, `interruptor`, `ponto_rede`, `espelho`]
};
function ym(e, t) {
  if (e === `fundo`) {
    return t.largura;
  } else {
    return t.profundidade;
  }
}
function bm(e, t, n) {
  let r = _m[e];
  let i = ym(t, n);
  return {
    id: Sm(),
    tipo: e,
    parede: t,
    x: wm(i / 2),
    y: r.alturaCentro,
    largura: r.largura,
    altura: r.altura,
    profundidade: r.profundidade
  };
}
var xm = {
  modulos: [],
  cenario: gm
};
function Sm() {
  if (typeof crypto < `u` && typeof crypto.randomUUID == `function`) {
    return crypto.randomUUID();
  } else {
    return `m-${Date.now()}-${Math.round(Math.random() * 1000000)}`;
  }
}
function Cm() {
  return bi[0].hex;
}
function wm(e, t = pm) {
  return Math.round(e / t) * t;
}
function Tm(e, t, n) {
  if (n < t) {
    return t;
  } else {
    return Math.min(n, Math.max(t, e));
  }
}
function Em(e) {
  if (e.rotacao % 180 == 0) {
    return e.largura;
  } else {
    return e.profundidade;
  }
}
function Dm(e) {
  if (e.rotacao % 180 == 0) {
    return e.profundidade;
  } else {
    return e.largura;
  }
}
function Om(e, t) {
  let n = Number(e);
  if (Number.isFinite(n)) {
    return n;
  } else {
    return t;
  }
}
function km(e) {
  if (!e || typeof e != `object`) {
    return gm;
  }
  let t = e;
  return {
    preset: typeof t.preset == `string` && t.preset ? t.preset : gm.preset,
    piso: typeof t.piso == `string` ? t.piso : ``,
    parede: typeof t.parede == `string` ? t.parede : ``
  };
}
function Am(e) {
  if (!e || typeof e != `object`) {
    return;
  }
  let t = e;
  let n = Om(t.largura, 0);
  let r = Om(t.profundidade, 0);
  let i = Om(t.altura, 0);
  if (!(n <= 0) && !(r <= 0) && !(i <= 0)) {
    return {
      largura: n,
      profundidade: r,
      altura: i,
      tipo: je.includes(t.tipo) ? t.tipo : `outro`
    };
  }
}
var jm = Object.keys(_m);
var Mm = [`fundo`, `esquerda`, `direita`];
function Nm(e) {
  if (!Array.isArray(e)) {
    return [];
  }
  let t = [];
  for (let n of e) {
    if (!n || typeof n != `object`) {
      continue;
    }
    let e = n;
    if (!jm.includes(e.tipo)) {
      continue;
    }
    let r = e.tipo;
    t.push({
      id: typeof e.id == `string` && e.id ? e.id : Sm(),
      tipo: r,
      parede: Mm.includes(e.parede) ? e.parede : `fundo`,
      x: Om(e.x, 0),
      y: Om(e.y, 0),
      largura: Math.max(10, Om(e.largura, _m[r].largura)),
      altura: Math.max(10, Om(e.altura, _m[r].altura)),
      profundidade: Math.max(1, Om(e.profundidade, _m[r].profundidade)),
      visivel: e.visivel !== false,
      bloqueado: e.bloqueado === true
    });
  }
  return t;
}
function Pm(e) {
  if (!e || typeof e != `object`) {
    return {
      ...xm
    };
  }
  let t = e.modulos;
  let n = km(e.cenario);
  let r = Nm(e.componentes);
  let i = Am(e.comodo);
  if (!Array.isArray(t)) {
    return {
      modulos: [],
      cenario: n,
      componentes: r,
      comodo: i
    };
  }
  let a = [];
  for (let e of t) {
    if (!e || typeof e != `object`) {
      continue;
    }
    let t = e;
    let n = Math.trunc(Om(t.rotacao, 0));
    let r = Math.max(100, Om(t.profundidade, 450));
    let i = Math.max(0, Math.trunc(Om(t.portas, 0)));
    let o = Math.max(0, Math.trunc(Om(t.gavetas, 0)));
    a.push({
      id: typeof t.id == `string` && t.id ? t.id : Sm(),
      catalogo_id: typeof t.catalogo_id == `string` ? t.catalogo_id : null,
      nome: typeof t.nome == `string` && t.nome ? t.nome : `Módulo`,
      categoria: t.categoria ?? `vertical`,
      x: Om(t.x, 0),
      y: Om(t.y, 0),
      z: Om(t.z, r / 2),
      largura: Math.max(100, Om(t.largura, 400)),
      altura: Math.max(100, Om(t.altura, 720)),
      profundidade: r,
      rotacao: (n % 360 + 360) % 360,
      cor: typeof t.cor == `string` && t.cor ? t.cor : Cm(),
      portas: i,
      gavetas: o,
      espessura: t.espessura === 18 || t.espessura === 25 ? Number(t.espessura) : 15,
      prateleiras: typeof t.prateleiras == `number` ? Math.max(0, t.prateleiras) : 1,
      divisorias: typeof t.divisorias == `number` ? Math.max(0, t.divisorias) : 0,
      acabamentoCaixaria: typeof t.acabamentoCaixaria == `string` ? t.acabamentoCaixaria : `branco-tx`,
      acabamentoFrente: typeof t.acabamentoFrente == `string` ? t.acabamentoFrente : `freijo-natural`,
      puxador: t.puxador ?? `perfil_alca`,
      tipoPorta: t.tipoPorta ?? (i > 0 ? `giro` : `nenhuma`),
      portasAbertas: t.portasAbertas === true,
      visivel: t.visivel !== false,
      bloqueado: t.bloqueado === true
    });
  }
  return {
    modulos: a,
    cenario: n,
    componentes: r,
    comodo: i
  };
}
function Fm(e) {
  let t = Number(e.profundidade_mm);
  let n = e.portas ?? 0;
  let r = e.gavetas ?? 0;
  return {
    id: Sm(),
    catalogo_id: e.id,
    nome: e.nome,
    categoria: e.categoria,
    x: 0,
    y: 0,
    z: t / 2,
    largura: Number(e.largura_mm),
    altura: Number(e.altura_mm),
    profundidade: t,
    rotacao: 0,
    cor: e.cor ?? Cm(),
    portas: n,
    gavetas: r,
    espessura: 15,
    prateleiras: e.categoria === `vertical` ? 1 : e.categoria === `guarda_roupa` ? 3 : 0,
    divisorias: +(e.categoria === `guarda_roupa`),
    acabamentoCaixaria: `branco-tx`,
    acabamentoFrente: `freijo-natural`,
    puxador: `perfil_alca`,
    tipoPorta: n > 0 ? `giro` : `nenhuma`,
    portasAbertas: false
  };
}
function Im(e) {
  return {
    inicio: e.y - e.altura / 2,
    fim: e.y + e.altura / 2
  };
}
function Lm(e, t) {
  let n = Im(e);
  let r = Im(t);
  return n.inicio < r.fim - 1 && r.inicio < n.fim - 1;
}
function Rm(e) {
  return e.z ?? (e.rotacao % 180 == 0 ? e.profundidade : e.largura) / 2;
}
function zm(e, t, n) {
  let r = Qe.includes(n.categoria);
  let i = Em(n) / 2;
  let a = Dm(n) / 2;
  let o = t.profundidade ?? 2400;
  let s = r ? t.altura - n.altura / 2 : n.altura / 2;
  let c = Tm(Rm(n), a, Math.max(a, o - a));
  let l = {
    ...n,
    y: s,
    z: c
  };
  let u = e.modulos.filter(e => Lm(e, l)).reduce((e, t) => Math.max(e, t.x + Em(t) / 2), 0);
  let d = {
    ...l,
    x: u + i,
    z: c
  };
  return Vm({
    ...e,
    modulos: [...e.modulos, d]
  }, t, d.id).modulos.find(e => e.id === d.id) ?? d;
}
function Bm(e, t) {
  let n = typeof e.z == `number` && Number.isFinite(e.z) ? e.z : e.profundidade / 2;
  let r = (e.rotacao ?? 0) % 180 != 0;
  let i = r ? e.profundidade : e.largura;
  let a = r ? e.largura : e.profundidade;
  return {
    x: e.x,
    y: e.y,
    z: n,
    largura: i,
    altura: e.altura,
    profundidade: a
  };
}
function Vm(e, t, n) {
  let r = e.modulos.map(e => ({
    ...e
  }));
  let i = r.find(e => e.id === n);
  if (!i) {
    return {
      ...e,
      modulos: r
    };
  }
  let a = Math.max(t.largura, e.comodo?.largura ?? t.largura);
  let o = Math.max(t.altura, e.comodo?.altura ?? t.altura);
  let s = Math.max(t.profundidade ?? 600, e.comodo?.profundidade ?? 3000);
  let c = Em(i) / 2;
  let l = i.altura / 2;
  let u = Dm(i) / 2;
  i.x = Tm(wm(i.x), c, Math.max(c, a - c));
  i.y = Tm(wm(i.y), l, Math.max(l, o - l));
  i.z = Tm(wm(Rm(i)), u, Math.max(u, s - u));
  let d = r.filter(e => e.id !== n && e.visivel !== false);
  let f = e.componentes ?? [];
  let p = [];
  for (let e of d) {
    p.push({
      x: e.x,
      y: e.y,
      z: Rm(e),
      largura: Em(e),
      altura: e.altura,
      profundidade: Dm(e)
    });
  }
  let m = f.filter(e => e.tipo !== `cuba` && e.tipo !== `torneira` && e.tipo !== `tomada` && e.tipo !== `interruptor` && e.tipo !== `ponto_rede` && _m[e.tipo]?.instalacao !== `bancada`);
  for (let e of m) {
    p.push(Bm(e, t.largura));
  }
  for (let e = 0; e < 10; e++) {
    let e = false;
    for (let t of p) {
      let n = t.largura / 2;
      let r = t.altura / 2;
      let d = t.profundidade / 2;
      let f = c + n;
      let p = l + r;
      let m = u + d;
      let h = f - Math.abs(i.x - t.x);
      let g = p - Math.abs(i.y - t.y);
      let _ = m - Math.abs(i.z - t.z);
      if (h > 0.5 && g > 0.5 && _ > 0.5) {
        e = true;
        if (g <= h && g <= _) {
          if (i.y < t.y) {
            let e = t.y - r - l;
            if (e >= l) {
              i.y = e;
            } else {
              let e = t.y - r;
              if (e >= 100) {
                i.altura = wm(e);
                i.y = i.altura / 2;
              } else {
                i.y = l;
              }
            }
          } else {
            i.y = Tm(t.y + r + l, l, o - l);
          }
        } else if (h <= g && h <= _) {
          i.x = i.x < t.x ? Tm(t.x - n - c, c, a - c) : Tm(t.x + n + c, c, a - c);
        } else {
          i.z = i.z < t.z ? Tm(t.z - d - u, u, s - u) : Tm(t.z + d + u, u, s - u);
        }
        i.x = Tm(i.x, c, Math.max(c, a - c));
        i.y = Tm(i.y, l, Math.max(l, o - l));
        i.z = Tm(i.z, u, Math.max(u, s - u));
      }
    }
    if (!e) {
      break;
    }
  }
  i.x = wm(i.x);
  i.y = wm(i.y);
  i.z = wm(i.z);
  return {
    ...e,
    modulos: r
  };
}
function Hm(e, t, n) {
  let r = (e.componentes ?? []).map(e => ({
    ...e
  }));
  let i = r.find(e => e.id === n);
  if (!i) {
    return {
      ...e,
      componentes: r
    };
  }
  let a = (i.rotacao ?? 0) % 180 != 0;
  let o = a ? i.profundidade : i.largura;
  let s = a ? i.largura : i.profundidade;
  let c = o / 2;
  let l = i.altura / 2;
  let u = s / 2;
  i.x = Tm(wm(i.x), c, Math.max(c, t.largura - c));
  i.y = Tm(wm(i.y), l, Math.max(l, t.altura - l));
  i.z = Tm(wm(typeof i.z == `number` && Number.isFinite(i.z) ? i.z : u), u, Math.max(u, t.profundidade - u));
  return {
    ...e,
    componentes: r
  };
}
function Um(e, t, n, r) {
  let i = e.x;
  let a = e.y;
  let o = e.z ?? t.z;
  let s = false;
  let c = Em(t) / 2;
  let l = t.altura / 2;
  let u = Dm(t) / 2;
  let d = Math.max(r.profundidade ?? 600, 3000);
  let f = Math.max(r.largura, 3000);
  if (Math.abs(i - c) < hm) {
    i = c;
    s = true;
  } else if (Math.abs(i - (f - c)) < hm) {
    i = f - c;
    s = true;
  }
  if (Math.abs(a - l) < hm) {
    a = l;
    s = true;
  }
  if (Math.abs(o - u) < hm) {
    o = u;
    s = true;
  } else if (Math.abs(o - (d - u)) < hm) {
    o = d - u;
    s = true;
  }
  for (let e of n) {
    if (e.id === t.id || e.visivel === false) {
      continue;
    }
    let n = Em(e) / 2;
    let r = e.altura / 2;
    let d = Dm(e) / 2;
    let f = Math.abs(a - e.y) < l + r + 60;
    let p = Math.abs(o - e.z) < u + d + 60;
    let m = Math.abs(i - e.x) < c + n + 60;
    if (f && p) {
      let t = e.x + n + c;
      let r = e.x - n - c;
      if (Math.abs(i - t) < hm) {
        i = t;
        s = true;
      } else if (Math.abs(i - r) < hm) {
        i = r;
        s = true;
      } else if (Math.abs(i - e.x) < hm) {
        i = e.x;
        s = true;
      }
    }
    if (m && p) {
      let t = e.y + r + l;
      let n = e.y - r - l;
      let i = e.y + r - l;
      let o = e.y - r + l;
      if (Math.abs(a - t) < hm) {
        a = t;
        s = true;
      } else if (Math.abs(a - n) < hm) {
        a = n;
        s = true;
      } else if (Math.abs(a - i) < hm) {
        a = i;
        s = true;
      } else if (Math.abs(a - o) < hm) {
        a = o;
        s = true;
      }
    }
    if (m && f) {
      let t = e.z + d + u;
      let n = e.z - d - u;
      if (Math.abs(o - t) < hm) {
        o = t;
        s = true;
      } else if (Math.abs(o - n) < hm) {
        o = n;
        s = true;
      } else if (Math.abs(o - e.z) < hm) {
        o = e.z;
        s = true;
      }
    }
  }
  return {
    x: i,
    y: a,
    z: o,
    snapAtivo: s
  };
}
function Wm(e, t, n, r, i = true) {
  let a = e.modulos.find(e => e.id === n);
  if (!a) {
    return e;
  }
  let o = r.x;
  let s = r.y;
  let c = r.z ?? a.z;
  if (i) {
    let n = Um({
      x: o,
      y: s,
      z: c
    }, a, e.modulos, t);
    o = n.x;
    s = n.y;
    c = n.z;
  }
  let l = e.modulos.map(e => e.id === n ? {
    ...e,
    x: o,
    y: s,
    z: c
  } : e);
  return Vm({
    ...e,
    modulos: l
  }, t, n);
}
function Gm(e, t) {
  return e.modulos.reduce((e, n) => Vm(e, t, n.id), e);
}
function Km(e, t, n, r) {
  let i = e.modulos.map(e => e.id === n ? {
    ...e,
    ...r
  } : e);
  return Vm({
    ...e,
    modulos: i
  }, t, n);
}
function qm(e, t) {
  return {
    ...e,
    modulos: e.modulos.filter(e => e.id !== t)
  };
}
function Jm(e, t, n) {
  let r = e.modulos.find(e => e.id === n);
  if (!r) {
    return {
      cena: e,
      novoId: null
    };
  }
  let i = {
    ...r,
    id: Sm(),
    x: r.x + Em(r),
    z: r.z ?? Dm(r) / 2
  };
  return {
    cena: Vm({
      ...e,
      modulos: [...e.modulos, i]
    }, t, i.id),
    novoId: i.id
  };
}
function Ym(e, t, n) {
  let r = e.modulos.find(e => e.id === n);
  if (r) {
    return Km(e, t, n, {
      rotacao: (r.rotacao + 90) % 360
    });
  } else {
    return e;
  }
}
function Xm(e, t, n) {
  let r = e.componentes ?? [];
  let i = r.find(e => e.id === n);
  if (!i) {
    return e;
  }
  let a = ((i.rotacao ?? 0) + 90) % 360;
  let o = r.map(e => e.id === n ? {
    ...e,
    rotacao: a
  } : e);
  return Hm({
    ...e,
    componentes: o
  }, t, n);
}
function Zm(e, t, n) {
  let r = {};
  let i = 0;
  if (t.sinalX !== 0) {
    let a = wm(Tm(t.sinalX > 0 ? n.x + e.largura / 2 : e.largura / 2 - n.x, 100, mm));
    r.largura = a;
    i = (a - e.largura) / 2 * t.sinalX;
  }
  let a = 0;
  if (t.sinalY !== 0) {
    let i = wm(Tm(t.sinalY > 0 ? n.y + e.altura / 2 : e.altura / 2 - n.y, 100, mm));
    r.altura = i;
    a = (i - e.altura) / 2 * t.sinalY;
  }
  let o = e.rotacao * Math.PI / 180;
  if (r.largura !== undefined) {
    r.x = wm(e.x + Math.cos(o) * i);
    r.z = wm(e.z - Math.sin(o) * i);
  }
  if (r.altura !== undefined) {
    r.y = wm(e.y + a);
  }
  return r;
}
function Qm(e, t, n, r, i) {
  let a = e.modulos.find(e => e.id === n);
  if (!a) {
    return e;
  }
  if (r === `z`) {
    return Km(e, t, n, {
      z: (a.z ?? Dm(a) / 2) + i
    });
  }
  let o = (r === `x` ? a.x : a.y) + i;
  return Km(e, t, n, r === `x` ? {
    x: o
  } : {
    y: o
  });
}
function $m(e, t, n) {
  let r = wm(Tm(e.profundidade + t, 100, n));
  let i = (r - e.profundidade) / 2;
  let a = e.rotacao * Math.PI / 180;
  return {
    profundidade: r,
    x: wm(e.x + Math.sin(a) * i),
    z: wm(e.z + Math.cos(a) * i)
  };
}
function eh(e, t, n, r, i) {
  let a = {};
  if (t.sinalX !== 0) {
    let i = e.x - t.sinalX * e.largura / 2;
    let o = n.x >= i ? 1 : -1;
    let s = wm(Tm(Math.abs(n.x - i), 40, r));
    let c = wm(Tm(i + o * s / 2, s / 2, Math.max(s / 2, r - s / 2)));
    a.largura = s;
    a.x = c;
  }
  if (t.sinalY !== 0) {
    let r = e.y - t.sinalY * e.altura / 2;
    let o = n.y >= r ? 1 : -1;
    let s = wm(Tm(Math.abs(n.y - r), 40, i));
    let c = wm(Tm(r + o * s / 2, s / 2, Math.max(s / 2, i - s / 2)));
    a.altura = s;
    a.y = c;
  }
  return a;
}
function th(e) {
  return e.modulos.reduce((e, t) => Math.max(e, t.x + Em(t) / 2), 0);
}
function nh(e) {
  return e.modulos.map(e => ({
    id: e.id,
    inicio: e.x - Em(e) / 2,
    fim: e.x + Em(e) / 2
  })).sort((e, t) => e.inicio - t.inicio);
}
var rh = [{
  id: `cozinha`,
  nome: `Cozinha`,
  descricao: `Azulejo 30x60 na parede e porcelanato mármore no piso`,
  cenario: `cozinha`,
  comodo: {
    largura: 3600,
    profundidade: 2400,
    altura: 2700,
    tipo: `cozinha`
  },
  profundidadeTrabalho: 620
}, {
  id: `quarto`,
  nome: `Quarto`,
  descricao: `Parede lisa e piso laminado claro`,
  cenario: `dormitorio`,
  comodo: {
    largura: 3200,
    profundidade: 2800,
    altura: 2700,
    tipo: `quarto`
  },
  profundidadeTrabalho: 620
}, {
  id: `sala`,
  nome: `Sala`,
  descricao: `Papel de parede texturizado e laminado rústico`,
  cenario: `sala`,
  comodo: {
    largura: 4000,
    profundidade: 3200,
    altura: 2700,
    tipo: `sala`
  },
  profundidadeTrabalho: 500
}, {
  id: `escritorio`,
  nome: `Escritório`,
  descricao: `Papel de parede liso e laminado nogueira`,
  cenario: `escritorio`,
  comodo: {
    largura: 2800,
    profundidade: 2400,
    altura: 2700,
    tipo: `escritorio`
  },
  profundidadeTrabalho: 620
}, {
  id: `banheiro`,
  nome: `Banheiro`,
  descricao: `Azulejo 30x30 na parede e cerâmica 30x30 no piso`,
  cenario: `banheiro`,
  comodo: {
    largura: 1600,
    profundidade: 1800,
    altura: 2500,
    tipo: `banheiro`
  },
  profundidadeTrabalho: 520
}];
function ih(e) {
  let {
    comodo: t,
    profundidadeTrabalho: n
  } = e;
  return {
    cena: {
      modulos: [],
      componentes: [],
      comodo: t,
      cenario: {
        preset: e.cenario,
        piso: ``,
        parede: ``
      }
    },
    nicho: {
      largura: t.largura,
      altura: t.altura,
      profundidade: n
    },
    comodo: t
  };
}
var ah = {
  LEFT: 0,
  MIDDLE: 1,
  RIGHT: 2,
  ROTATE: 0,
  DOLLY: 1,
  PAN: 2
};
var oh = {
  ROTATE: 0,
  PAN: 1,
  DOLLY_PAN: 2,
  DOLLY_ROTATE: 3
};
var sh = 1000;
var ch = 1001;
var lh = 1002;
var uh = 1003;
var dh = 1004;
var fh = 1005;
var ph = 1006;
var mh = 1007;
var hh = 1008;
var gh = 1009;
var _h = 1010;
var vh = 1011;
var yh = 1012;
var bh = 1013;
var xh = 1014;
var Sh = 1015;
var Ch = 1016;
var wh = 1017;
var Th = 1018;
var Eh = 1020;
var Dh = 35902;
var Oh = 35899;
var kh = 1021;
var Ah = 1022;
var jh = 1023;
var Mh = 1026;
var Nh = 1027;
var Ph = 1028;
var Fh = 1029;
var Ih = 1030;
var Lh = 1031;
var Rh = 1033;
var zh = 33776;
var Bh = 33777;
var Vh = 33778;
var Hh = 33779;
var Uh = 35840;
var Wh = 35841;
var Gh = 35842;
var Kh = 35843;
var qh = 36196;
var Jh = 37492;
var Yh = 37496;
var Xh = 37488;
var Zh = 37489;
var Qh = 37490;
var $h = 37491;
var eg = 37808;
var tg = 37809;
var ng = 37810;
var rg = 37811;
var ig = 37812;
var ag = 37813;
var og = 37814;
var sg = 37815;
var cg = 37816;
var lg = 37817;
var ug = 37818;
var dg = 37819;
var fg = 37820;
var pg = 37821;
var mg = 36492;
var hg = 36494;
var gg = 36495;
var _g = 36283;
var vg = 36284;
var yg = 36285;
var bg = 36286;
var xg = 2300;
var Sg = 2301;
var Cg = 2302;
var wg = 2303;
var Tg = 2400;
var Eg = 2401;
var Dg = 2402;
var Og = 3200;
var kg = `srgb`;
var Ag = `srgb-linear`;
var jg = `linear`;
var Mg = `srgb`;
var Ng = 7680;
var Pg = 35044;
var Fg = 2000;
function Ig(e) {
  for (let t = e.length - 1; t >= 0; --t) {
    if (e[t] >= 65535) {
      return true;
    }
  }
  return false;
}
function Lg(e) {
  return ArrayBuffer.isView(e) && !(e instanceof DataView);
}
function Rg(e) {
  return document.createElementNS(`http://www.w3.org/1999/xhtml`, e);
}
function zg() {
  let e = Rg(`canvas`);
  e.style.display = `block`;
  return e;
}
var Bg = {};
function Vg(...e) {
  let t = `THREE.${e.shift()}`;
  console.log(t, ...e);
}
function Hg(e) {
  let t = e[0];
  if (typeof t == `string` && t.startsWith(`TSL:`)) {
    let t = e[1];
    if (t && t.isStackTrace) {
      e[0] += ` ${t.getLocation()}`;
    } else {
      e[1] = `Stack trace not available. Enable "THREE.Node.captureStackTrace" to capture stack traces.`;
    }
  }
  return e;
}
function Ug(...e) {
  e = Hg(e);
  let t = `THREE.${e.shift()}`;
  {
    let n = e[0];
    if (n && n.isStackTrace) {
      console.warn(n.getError(t));
    } else {
      console.warn(t, ...e);
    }
  }
}
function Wg(...e) {
  e = Hg(e);
  let t = `THREE.${e.shift()}`;
  {
    let n = e[0];
    if (n && n.isStackTrace) {
      console.error(n.getError(t));
    } else {
      console.error(t, ...e);
    }
  }
}
function Gg(...e) {
  let t = e.join(` `);
  if (!(t in Bg)) {
    Bg[t] = true;
    Ug(...e);
  }
}
function Kg(e, t, n) {
  return new Promise(function (r, i) {
    function a() {
      switch (e.clientWaitSync(t, e.SYNC_FLUSH_COMMANDS_BIT, 0)) {
        case e.WAIT_FAILED:
          i();
          break;
        case e.TIMEOUT_EXPIRED:
          setTimeout(a, n);
          break;
        default:
          r();
      }
    }
    setTimeout(a, n);
  });
}
var qg = {
  0: 1,
  2: 6,
  4: 7,
  3: 5,
  1: 0,
  6: 2,
  7: 4,
  5: 3
};
var Jg = class {
  addEventListener(e, t) {
    if (this._listeners === undefined) {
      this._listeners = {};
    }
    let n = this._listeners;
    if (n[e] === undefined) {
      n[e] = [];
    }
    if (n[e].indexOf(t) === -1) {
      n[e].push(t);
    }
  }
  hasEventListener(e, t) {
    let n = this._listeners;
    return n !== undefined && n[e] !== undefined && n[e].indexOf(t) !== -1;
  }
  removeEventListener(e, t) {
    let n = this._listeners;
    if (n === undefined) {
      return;
    }
    let r = n[e];
    if (r !== undefined) {
      let e = r.indexOf(t);
      if (e !== -1) {
        r.splice(e, 1);
      }
    }
  }
  dispatchEvent(e) {
    let t = this._listeners;
    if (t === undefined) {
      return;
    }
    let n = t[e.type];
    if (n !== undefined) {
      e.target = this;
      let t = n.slice(0);
      for (let n = 0, r = t.length; n < r; n++) {
        t[n].call(this, e);
      }
      e.target = null;
    }
  }
};
var Yg = `00.01.02.03.04.05.06.07.08.09.0a.0b.0c.0d.0e.0f.10.11.12.13.14.15.16.17.18.19.1a.1b.1c.1d.1e.1f.20.21.22.23.24.25.26.27.28.29.2a.2b.2c.2d.2e.2f.30.31.32.33.34.35.36.37.38.39.3a.3b.3c.3d.3e.3f.40.41.42.43.44.45.46.47.48.49.4a.4b.4c.4d.4e.4f.50.51.52.53.54.55.56.57.58.59.5a.5b.5c.5d.5e.5f.60.61.62.63.64.65.66.67.68.69.6a.6b.6c.6d.6e.6f.70.71.72.73.74.75.76.77.78.79.7a.7b.7c.7d.7e.7f.80.81.82.83.84.85.86.87.88.89.8a.8b.8c.8d.8e.8f.90.91.92.93.94.95.96.97.98.99.9a.9b.9c.9d.9e.9f.a0.a1.a2.a3.a4.a5.a6.a7.a8.a9.aa.ab.ac.ad.ae.af.b0.b1.b2.b3.b4.b5.b6.b7.b8.b9.ba.bb.bc.bd.be.bf.c0.c1.c2.c3.c4.c5.c6.c7.c8.c9.ca.cb.cc.cd.ce.cf.d0.d1.d2.d3.d4.d5.d6.d7.d8.d9.da.db.dc.dd.de.df.e0.e1.e2.e3.e4.e5.e6.e7.e8.e9.ea.eb.ec.ed.ee.ef.f0.f1.f2.f3.f4.f5.f6.f7.f8.f9.fa.fb.fc.fd.fe.ff`.split(`.`);
var Xg = 1234567;
var Zg = Math.PI / 180;
var Qg = 180 / Math.PI;
function $g() {
  let e = Math.random() * 4294967295 | 0;
  let t = Math.random() * 4294967295 | 0;
  let n = Math.random() * 4294967295 | 0;
  let r = Math.random() * 4294967295 | 0;
  return `${Yg[e & 255] + Yg[e >> 8 & 255] + Yg[e >> 16 & 255] + Yg[e >> 24 & 255]}-${Yg[t & 255]}${Yg[t >> 8 & 255]}-${Yg[t >> 16 & 15 | 64]}${Yg[t >> 24 & 255]}-${Yg[n & 63 | 128]}${Yg[n >> 8 & 255]}-${Yg[n >> 16 & 255]}${Yg[n >> 24 & 255]}${Yg[r & 255]}${Yg[r >> 8 & 255]}${Yg[r >> 16 & 255]}${Yg[r >> 24 & 255]}`.toLowerCase();
}
function e_(e, t, n) {
  return Math.max(t, Math.min(n, e));
}
function t_(e, t) {
  return (e % t + t) % t;
}
function n_(e, t, n, r, i) {
  return r + (e - t) * (i - r) / (n - t);
}
function r_(e, t, n) {
  if (e === t) {
    return 0;
  } else {
    return (n - e) / (t - e);
  }
}
function i_(e, t, n) {
  return (1 - n) * e + n * t;
}
function a_(e, t, n, r) {
  return i_(e, t, 1 - Math.exp(-n * r));
}
function o_(e, t = 1) {
  return t - Math.abs(t_(e, t * 2) - t);
}
function s_(e, t, n) {
  if (e <= t) {
    return 0;
  } else if (e >= n) {
    return 1;
  } else {
    e = (e - t) / (n - t);
    return e * e * (3 - e * 2);
  }
}
function c_(e, t, n) {
  if (e <= t) {
    return 0;
  } else if (e >= n) {
    return 1;
  } else {
    e = (e - t) / (n - t);
    return e * e * e * (e * (e * 6 - 15) + 10);
  }
}
function l_(e, t) {
  return e + Math.floor(Math.random() * (t - e + 1));
}
function u_(e, t) {
  return e + Math.random() * (t - e);
}
function d_(e) {
  return e * (0.5 - Math.random());
}
function f_(e) {
  if (e !== undefined) {
    Xg = e;
  }
  let t = Xg += 1831565813;
  t = Math.imul(t ^ t >>> 15, t | 1);
  t ^= t + Math.imul(t ^ t >>> 7, t | 61);
  return ((t ^ t >>> 14) >>> 0) / 4294967296;
}
function p_(e) {
  return e * Zg;
}
function m_(e) {
  return e * Qg;
}
function h_(e) {
  return e > 0 && Number.isInteger(e) && 2 ** Math.round(Math.log2(e)) === e;
}
function g_(e) {
  return 2 ** Math.ceil(Math.log(e) / Math.LN2);
}
function __(e) {
  return 2 ** Math.floor(Math.log(e) / Math.LN2);
}
function v_(e, t, n, r, i) {
  let a = Math.cos;
  let o = Math.sin;
  let s = a(n / 2);
  let c = o(n / 2);
  let l = a((t + r) / 2);
  let u = o((t + r) / 2);
  let d = a((t - r) / 2);
  let f = o((t - r) / 2);
  let p = a((r - t) / 2);
  let m = o((r - t) / 2);
  switch (i) {
    case `XYX`:
      e.set(s * u, c * d, c * f, s * l);
      break;
    case `YZY`:
      e.set(c * f, s * u, c * d, s * l);
      break;
    case `ZXZ`:
      e.set(c * d, c * f, s * u, s * l);
      break;
    case `XZX`:
      e.set(s * u, c * m, c * p, s * l);
      break;
    case `YXY`:
      e.set(c * p, s * u, c * m, s * l);
      break;
    case `ZYZ`:
      e.set(c * m, c * p, s * u, s * l);
      break;
    default:
      Ug(`MathUtils: .setQuaternionFromProperEuler() encountered an unknown order: ${i}`);
  }
}
function y_(e, t) {
  switch (t.constructor) {
    case Float32Array:
      return e;
    case Uint32Array:
      return e / 4294967295;
    case Uint16Array:
      return e / 65535;
    case Uint8Array:
    case Uint8ClampedArray:
      return e / 255;
    case Int32Array:
      return Math.max(e / 2147483647, -1);
    case Int16Array:
      return Math.max(e / 32767, -1);
    case Int8Array:
      return Math.max(e / 127, -1);
    default:
      throw Error(`THREE.MathUtils: Invalid component type.`);
  }
}
function b_(e, t) {
  switch (t.constructor) {
    case Float32Array:
      return e;
    case Uint32Array:
      return Math.round(e * 4294967295);
    case Uint16Array:
      return Math.round(e * 65535);
    case Uint8Array:
    case Uint8ClampedArray:
      return Math.round(e * 255);
    case Int32Array:
      return Math.round(e * 2147483647);
    case Int16Array:
      return Math.round(e * 32767);
    case Int8Array:
      return Math.round(e * 127);
    default:
      throw Error(`THREE.MathUtils: Invalid component type.`);
  }
}
var x_ = {
  DEG2RAD: Zg,
  RAD2DEG: Qg,
  generateUUID: $g,
  clamp: e_,
  euclideanModulo: t_,
  mapLinear: n_,
  inverseLerp: r_,
  lerp: i_,
  damp: a_,
  pingpong: o_,
  smoothstep: s_,
  smootherstep: c_,
  randInt: l_,
  randFloat: u_,
  randFloatSpread: d_,
  seededRandom: f_,
  degToRad: p_,
  radToDeg: m_,
  isPowerOfTwo: h_,
  ceilPowerOfTwo: g_,
  floorPowerOfTwo: __,
  setQuaternionFromProperEuler: v_,
  normalize: b_,
  denormalize: y_
};
var S_ = class e {
  static {
    e.prototype.isVector2 = true;
  }
  constructor(e = 0, t = 0) {
    this.x = e;
    this.y = t;
  }
  get width() {
    return this.x;
  }
  set width(e) {
    this.x = e;
  }
  get height() {
    return this.y;
  }
  set height(e) {
    this.y = e;
  }
  set(e, t) {
    this.x = e;
    this.y = t;
    return this;
  }
  setScalar(e) {
    this.x = e;
    this.y = e;
    return this;
  }
  setX(e) {
    this.x = e;
    return this;
  }
  setY(e) {
    this.y = e;
    return this;
  }
  setComponent(e, t) {
    switch (e) {
      case 0:
        this.x = t;
        break;
      case 1:
        this.y = t;
        break;
      default:
        throw Error(`THREE.Vector2: index is out of range: ${e}`);
    }
    return this;
  }
  getComponent(e) {
    switch (e) {
      case 0:
        return this.x;
      case 1:
        return this.y;
      default:
        throw Error(`THREE.Vector2: index is out of range: ${e}`);
    }
  }
  clone() {
    return new this.constructor(this.x, this.y);
  }
  copy(e) {
    this.x = e.x;
    this.y = e.y;
    return this;
  }
  add(e) {
    this.x += e.x;
    this.y += e.y;
    return this;
  }
  addScalar(e) {
    this.x += e;
    this.y += e;
    return this;
  }
  addVectors(e, t) {
    this.x = e.x + t.x;
    this.y = e.y + t.y;
    return this;
  }
  addScaledVector(e, t) {
    this.x += e.x * t;
    this.y += e.y * t;
    return this;
  }
  sub(e) {
    this.x -= e.x;
    this.y -= e.y;
    return this;
  }
  subScalar(e) {
    this.x -= e;
    this.y -= e;
    return this;
  }
  subVectors(e, t) {
    this.x = e.x - t.x;
    this.y = e.y - t.y;
    return this;
  }
  multiply(e) {
    this.x *= e.x;
    this.y *= e.y;
    return this;
  }
  multiplyScalar(e) {
    this.x *= e;
    this.y *= e;
    return this;
  }
  divide(e) {
    this.x /= e.x;
    this.y /= e.y;
    return this;
  }
  divideScalar(e) {
    return this.multiplyScalar(1 / e);
  }
  applyMatrix3(e) {
    let t = this.x;
    let n = this.y;
    let r = e.elements;
    this.x = r[0] * t + r[3] * n + r[6];
    this.y = r[1] * t + r[4] * n + r[7];
    return this;
  }
  min(e) {
    this.x = Math.min(this.x, e.x);
    this.y = Math.min(this.y, e.y);
    return this;
  }
  max(e) {
    this.x = Math.max(this.x, e.x);
    this.y = Math.max(this.y, e.y);
    return this;
  }
  clamp(e, t) {
    this.x = e_(this.x, e.x, t.x);
    this.y = e_(this.y, e.y, t.y);
    return this;
  }
  clampScalar(e, t) {
    this.x = e_(this.x, e, t);
    this.y = e_(this.y, e, t);
    return this;
  }
  clampLength(e, t) {
    let n = this.length();
    return this.divideScalar(n || 1).multiplyScalar(e_(n, e, t));
  }
  floor() {
    this.x = Math.floor(this.x);
    this.y = Math.floor(this.y);
    return this;
  }
  ceil() {
    this.x = Math.ceil(this.x);
    this.y = Math.ceil(this.y);
    return this;
  }
  round() {
    this.x = Math.round(this.x);
    this.y = Math.round(this.y);
    return this;
  }
  roundToZero() {
    this.x = Math.trunc(this.x);
    this.y = Math.trunc(this.y);
    return this;
  }
  negate() {
    this.x = -this.x;
    this.y = -this.y;
    return this;
  }
  dot(e) {
    return this.x * e.x + this.y * e.y;
  }
  cross(e) {
    return this.x * e.y - this.y * e.x;
  }
  lengthSq() {
    return this.x * this.x + this.y * this.y;
  }
  length() {
    return Math.sqrt(this.x * this.x + this.y * this.y);
  }
  manhattanLength() {
    return Math.abs(this.x) + Math.abs(this.y);
  }
  normalize() {
    return this.divideScalar(this.length() || 1);
  }
  angle() {
    return Math.atan2(-this.y, -this.x) + Math.PI;
  }
  angleTo(e) {
    let t = Math.sqrt(this.lengthSq() * e.lengthSq());
    if (t === 0) {
      return Math.PI / 2;
    }
    let n = this.dot(e) / t;
    return Math.acos(e_(n, -1, 1));
  }
  distanceTo(e) {
    return Math.sqrt(this.distanceToSquared(e));
  }
  distanceToSquared(e) {
    let t = this.x - e.x;
    let n = this.y - e.y;
    return t * t + n * n;
  }
  manhattanDistanceTo(e) {
    return Math.abs(this.x - e.x) + Math.abs(this.y - e.y);
  }
  setLength(e) {
    return this.normalize().multiplyScalar(e);
  }
  lerp(e, t) {
    this.x += (e.x - this.x) * t;
    this.y += (e.y - this.y) * t;
    return this;
  }
  lerpVectors(e, t, n) {
    this.x = e.x + (t.x - e.x) * n;
    this.y = e.y + (t.y - e.y) * n;
    return this;
  }
  equals(e) {
    return e.x === this.x && e.y === this.y;
  }
  fromArray(e, t = 0) {
    this.x = e[t];
    this.y = e[t + 1];
    return this;
  }
  toArray(e = [], t = 0) {
    e[t] = this.x;
    e[t + 1] = this.y;
    return e;
  }
  fromBufferAttribute(e, t) {
    this.x = e.getX(t);
    this.y = e.getY(t);
    return this;
  }
  rotateAround(e, t) {
    let n = Math.cos(t);
    let r = Math.sin(t);
    let i = this.x - e.x;
    let a = this.y - e.y;
    this.x = i * n - a * r + e.x;
    this.y = i * r + a * n + e.y;
    return this;
  }
  random() {
    this.x = Math.random();
    this.y = Math.random();
    return this;
  }
  *[Symbol.iterator]() {
    yield this.x;
    yield this.y;
  }
};
var C_ = class {
  constructor(e = 0, t = 0, n = 0, r = 1) {
    this.isQuaternion = true;
    this._x = e;
    this._y = t;
    this._z = n;
    this._w = r;
  }
  static slerpFlat(e, t, n, r, i, a, o) {
    let s = n[r + 0];
    let c = n[r + 1];
    let l = n[r + 2];
    let u = n[r + 3];
    let d = i[a + 0];
    let f = i[a + 1];
    let p = i[a + 2];
    let m = i[a + 3];
    if (u !== m || s !== d || c !== f || l !== p) {
      let e = s * d + c * f + l * p + u * m;
      if (e < 0) {
        d = -d;
        f = -f;
        p = -p;
        m = -m;
        e = -e;
      }
      let t = 1 - o;
      if (e < 0.9995) {
        let n = Math.acos(e);
        let r = Math.sin(n);
        t = Math.sin(t * n) / r;
        o = Math.sin(o * n) / r;
        s = s * t + d * o;
        c = c * t + f * o;
        l = l * t + p * o;
        u = u * t + m * o;
      } else {
        s = s * t + d * o;
        c = c * t + f * o;
        l = l * t + p * o;
        u = u * t + m * o;
        let e = 1 / Math.sqrt(s * s + c * c + l * l + u * u);
        s *= e;
        c *= e;
        l *= e;
        u *= e;
      }
    }
    e[t] = s;
    e[t + 1] = c;
    e[t + 2] = l;
    e[t + 3] = u;
  }
  static multiplyQuaternionsFlat(e, t, n, r, i, a) {
    let o = n[r];
    let s = n[r + 1];
    let c = n[r + 2];
    let l = n[r + 3];
    let u = i[a];
    let d = i[a + 1];
    let f = i[a + 2];
    let p = i[a + 3];
    e[t] = o * p + l * u + s * f - c * d;
    e[t + 1] = s * p + l * d + c * u - o * f;
    e[t + 2] = c * p + l * f + o * d - s * u;
    e[t + 3] = l * p - o * u - s * d - c * f;
    return e;
  }
  get x() {
    return this._x;
  }
  set x(e) {
    this._x = e;
    this._onChangeCallback();
  }
  get y() {
    return this._y;
  }
  set y(e) {
    this._y = e;
    this._onChangeCallback();
  }
  get z() {
    return this._z;
  }
  set z(e) {
    this._z = e;
    this._onChangeCallback();
  }
  get w() {
    return this._w;
  }
  set w(e) {
    this._w = e;
    this._onChangeCallback();
  }
  set(e, t, n, r) {
    this._x = e;
    this._y = t;
    this._z = n;
    this._w = r;
    this._onChangeCallback();
    return this;
  }
  clone() {
    return new this.constructor(this._x, this._y, this._z, this._w);
  }
  copy(e) {
    this._x = e.x;
    this._y = e.y;
    this._z = e.z;
    this._w = e.w;
    this._onChangeCallback();
    return this;
  }
  setFromEuler(e, t = true) {
    let n = e._x;
    let r = e._y;
    let i = e._z;
    let a = e._order;
    let o = Math.cos;
    let s = Math.sin;
    let c = o(n / 2);
    let l = o(r / 2);
    let u = o(i / 2);
    let d = s(n / 2);
    let f = s(r / 2);
    let p = s(i / 2);
    switch (a) {
      case `XYZ`:
        this._x = d * l * u + c * f * p;
        this._y = c * f * u - d * l * p;
        this._z = c * l * p + d * f * u;
        this._w = c * l * u - d * f * p;
        break;
      case `YXZ`:
        this._x = d * l * u + c * f * p;
        this._y = c * f * u - d * l * p;
        this._z = c * l * p - d * f * u;
        this._w = c * l * u + d * f * p;
        break;
      case `ZXY`:
        this._x = d * l * u - c * f * p;
        this._y = c * f * u + d * l * p;
        this._z = c * l * p + d * f * u;
        this._w = c * l * u - d * f * p;
        break;
      case `ZYX`:
        this._x = d * l * u - c * f * p;
        this._y = c * f * u + d * l * p;
        this._z = c * l * p - d * f * u;
        this._w = c * l * u + d * f * p;
        break;
      case `YZX`:
        this._x = d * l * u + c * f * p;
        this._y = c * f * u + d * l * p;
        this._z = c * l * p - d * f * u;
        this._w = c * l * u - d * f * p;
        break;
      case `XZY`:
        this._x = d * l * u - c * f * p;
        this._y = c * f * u - d * l * p;
        this._z = c * l * p + d * f * u;
        this._w = c * l * u + d * f * p;
        break;
      default:
        Ug(`Quaternion: .setFromEuler() encountered an unknown order: ${a}`);
    }
    if (t === true) {
      this._onChangeCallback();
    }
    return this;
  }
  setFromAxisAngle(e, t) {
    let n = t / 2;
    let r = Math.sin(n);
    this._x = e.x * r;
    this._y = e.y * r;
    this._z = e.z * r;
    this._w = Math.cos(n);
    this._onChangeCallback();
    return this;
  }
  setFromRotationMatrix(e) {
    let t = e.elements;
    let n = t[0];
    let r = t[4];
    let i = t[8];
    let a = t[1];
    let o = t[5];
    let s = t[9];
    let c = t[2];
    let l = t[6];
    let u = t[10];
    let d = n + o + u;
    if (d > 0) {
      let e = 0.5 / Math.sqrt(d + 1);
      this._w = 0.25 / e;
      this._x = (l - s) * e;
      this._y = (i - c) * e;
      this._z = (a - r) * e;
    } else if (n > o && n > u) {
      let e = Math.sqrt(1 + n - o - u) * 2;
      this._w = (l - s) / e;
      this._x = e * 0.25;
      this._y = (r + a) / e;
      this._z = (i + c) / e;
    } else if (o > u) {
      let e = Math.sqrt(1 + o - n - u) * 2;
      this._w = (i - c) / e;
      this._x = (r + a) / e;
      this._y = e * 0.25;
      this._z = (s + l) / e;
    } else {
      let e = Math.sqrt(1 + u - n - o) * 2;
      this._w = (a - r) / e;
      this._x = (i + c) / e;
      this._y = (s + l) / e;
      this._z = e * 0.25;
    }
    this._onChangeCallback();
    return this;
  }
  setFromUnitVectors(e, t) {
    let n = e.dot(t) + 1;
    if (n < 1e-8) {
      n = 0;
      if (Math.abs(e.x) > Math.abs(e.z)) {
        this._x = -e.y;
        this._y = e.x;
        this._z = 0;
        this._w = n;
      } else {
        this._x = 0;
        this._y = -e.z;
        this._z = e.y;
        this._w = n;
      }
    } else {
      this._x = e.y * t.z - e.z * t.y;
      this._y = e.z * t.x - e.x * t.z;
      this._z = e.x * t.y - e.y * t.x;
      this._w = n;
    }
    return this.normalize();
  }
  angleTo(e) {
    return Math.acos(Math.abs(e_(this.dot(e), -1, 1))) * 2;
  }
  rotateTowards(e, t) {
    let n = this.angleTo(e);
    if (n === 0) {
      return this;
    }
    let r = Math.min(1, t / n);
    this.slerp(e, r);
    return this;
  }
  identity() {
    return this.set(0, 0, 0, 1);
  }
  invert() {
    return this.conjugate();
  }
  conjugate() {
    this._x *= -1;
    this._y *= -1;
    this._z *= -1;
    this._onChangeCallback();
    return this;
  }
  dot(e) {
    return this._x * e._x + this._y * e._y + this._z * e._z + this._w * e._w;
  }
  lengthSq() {
    return this._x * this._x + this._y * this._y + this._z * this._z + this._w * this._w;
  }
  length() {
    return Math.sqrt(this._x * this._x + this._y * this._y + this._z * this._z + this._w * this._w);
  }
  normalize() {
    let e = this.length();
    if (e === 0) {
      this._x = 0;
      this._y = 0;
      this._z = 0;
      this._w = 1;
    } else {
      e = 1 / e;
      this._x *= e;
      this._y *= e;
      this._z *= e;
      this._w *= e;
    }
    this._onChangeCallback();
    return this;
  }
  multiply(e) {
    return this.multiplyQuaternions(this, e);
  }
  premultiply(e) {
    return this.multiplyQuaternions(e, this);
  }
  multiplyQuaternions(e, t) {
    let n = e._x;
    let r = e._y;
    let i = e._z;
    let a = e._w;
    let o = t._x;
    let s = t._y;
    let c = t._z;
    let l = t._w;
    this._x = n * l + a * o + r * c - i * s;
    this._y = r * l + a * s + i * o - n * c;
    this._z = i * l + a * c + n * s - r * o;
    this._w = a * l - n * o - r * s - i * c;
    this._onChangeCallback();
    return this;
  }
  slerp(e, t) {
    let n = e._x;
    let r = e._y;
    let i = e._z;
    let a = e._w;
    let o = this.dot(e);
    if (o < 0) {
      n = -n;
      r = -r;
      i = -i;
      a = -a;
      o = -o;
    }
    let s = 1 - t;
    if (o < 0.9995) {
      let e = Math.acos(o);
      let c = Math.sin(e);
      s = Math.sin(s * e) / c;
      t = Math.sin(t * e) / c;
      this._x = this._x * s + n * t;
      this._y = this._y * s + r * t;
      this._z = this._z * s + i * t;
      this._w = this._w * s + a * t;
      this._onChangeCallback();
    } else {
      this._x = this._x * s + n * t;
      this._y = this._y * s + r * t;
      this._z = this._z * s + i * t;
      this._w = this._w * s + a * t;
      this.normalize();
    }
    return this;
  }
  slerpQuaternions(e, t, n) {
    return this.copy(e).slerp(t, n);
  }
  random() {
    let e = Math.PI * 2 * Math.random();
    let t = Math.PI * 2 * Math.random();
    let n = Math.random();
    let r = Math.sqrt(1 - n);
    let i = Math.sqrt(n);
    return this.set(r * Math.sin(e), r * Math.cos(e), i * Math.sin(t), i * Math.cos(t));
  }
  equals(e) {
    return e._x === this._x && e._y === this._y && e._z === this._z && e._w === this._w;
  }
  fromArray(e, t = 0) {
    this._x = e[t];
    this._y = e[t + 1];
    this._z = e[t + 2];
    this._w = e[t + 3];
    this._onChangeCallback();
    return this;
  }
  toArray(e = [], t = 0) {
    e[t] = this._x;
    e[t + 1] = this._y;
    e[t + 2] = this._z;
    e[t + 3] = this._w;
    return e;
  }
  fromBufferAttribute(e, t) {
    this._x = e.getX(t);
    this._y = e.getY(t);
    this._z = e.getZ(t);
    this._w = e.getW(t);
    this._onChangeCallback();
    return this;
  }
  toJSON() {
    return this.toArray();
  }
  _onChange(e) {
    this._onChangeCallback = e;
    return this;
  }
  _onChangeCallback() {}
  *[Symbol.iterator]() {
    yield this._x;
    yield this._y;
    yield this._z;
    yield this._w;
  }
};
var X = class e {
  static {
    e.prototype.isVector3 = true;
  }
  constructor(e = 0, t = 0, n = 0) {
    this.x = e;
    this.y = t;
    this.z = n;
  }
  set(e, t, n = this.z) {
    this.x = e;
    this.y = t;
    this.z = n;
    return this;
  }
  setScalar(e) {
    this.x = e;
    this.y = e;
    this.z = e;
    return this;
  }
  setX(e) {
    this.x = e;
    return this;
  }
  setY(e) {
    this.y = e;
    return this;
  }
  setZ(e) {
    this.z = e;
    return this;
  }
  setComponent(e, t) {
    switch (e) {
      case 0:
        this.x = t;
        break;
      case 1:
        this.y = t;
        break;
      case 2:
        this.z = t;
        break;
      default:
        throw Error(`THREE.Vector3: index is out of range: ${e}`);
    }
    return this;
  }
  getComponent(e) {
    switch (e) {
      case 0:
        return this.x;
      case 1:
        return this.y;
      case 2:
        return this.z;
      default:
        throw Error(`THREE.Vector3: index is out of range: ${e}`);
    }
  }
  clone() {
    return new this.constructor(this.x, this.y, this.z);
  }
  copy(e) {
    this.x = e.x;
    this.y = e.y;
    this.z = e.z;
    return this;
  }
  add(e) {
    this.x += e.x;
    this.y += e.y;
    this.z += e.z;
    return this;
  }
  addScalar(e) {
    this.x += e;
    this.y += e;
    this.z += e;
    return this;
  }
  addVectors(e, t) {
    this.x = e.x + t.x;
    this.y = e.y + t.y;
    this.z = e.z + t.z;
    return this;
  }
  addScaledVector(e, t) {
    this.x += e.x * t;
    this.y += e.y * t;
    this.z += e.z * t;
    return this;
  }
  sub(e) {
    this.x -= e.x;
    this.y -= e.y;
    this.z -= e.z;
    return this;
  }
  subScalar(e) {
    this.x -= e;
    this.y -= e;
    this.z -= e;
    return this;
  }
  subVectors(e, t) {
    this.x = e.x - t.x;
    this.y = e.y - t.y;
    this.z = e.z - t.z;
    return this;
  }
  multiply(e) {
    this.x *= e.x;
    this.y *= e.y;
    this.z *= e.z;
    return this;
  }
  multiplyScalar(e) {
    this.x *= e;
    this.y *= e;
    this.z *= e;
    return this;
  }
  multiplyVectors(e, t) {
    this.x = e.x * t.x;
    this.y = e.y * t.y;
    this.z = e.z * t.z;
    return this;
  }
  applyEuler(e) {
    return this.applyQuaternion(T_.setFromEuler(e));
  }
  applyAxisAngle(e, t) {
    return this.applyQuaternion(T_.setFromAxisAngle(e, t));
  }
  applyMatrix3(e) {
    let t = this.x;
    let n = this.y;
    let r = this.z;
    let i = e.elements;
    this.x = i[0] * t + i[3] * n + i[6] * r;
    this.y = i[1] * t + i[4] * n + i[7] * r;
    this.z = i[2] * t + i[5] * n + i[8] * r;
    return this;
  }
  applyNormalMatrix(e) {
    return this.applyMatrix3(e).normalize();
  }
  applyMatrix4(e) {
    let t = this.x;
    let n = this.y;
    let r = this.z;
    let i = e.elements;
    let a = 1 / (i[3] * t + i[7] * n + i[11] * r + i[15]);
    this.x = (i[0] * t + i[4] * n + i[8] * r + i[12]) * a;
    this.y = (i[1] * t + i[5] * n + i[9] * r + i[13]) * a;
    this.z = (i[2] * t + i[6] * n + i[10] * r + i[14]) * a;
    return this;
  }
  applyQuaternion(e) {
    let t = this.x;
    let n = this.y;
    let r = this.z;
    let i = e.x;
    let a = e.y;
    let o = e.z;
    let s = e.w;
    let c = (a * r - o * n) * 2;
    let l = (o * t - i * r) * 2;
    let u = (i * n - a * t) * 2;
    this.x = t + s * c + a * u - o * l;
    this.y = n + s * l + o * c - i * u;
    this.z = r + s * u + i * l - a * c;
    return this;
  }
  project(e) {
    return this.applyMatrix4(e.matrixWorldInverse).applyMatrix4(e.projectionMatrix);
  }
  unproject(e) {
    return this.applyMatrix4(e.projectionMatrixInverse).applyMatrix4(e.matrixWorld);
  }
  transformDirection(e) {
    let t = this.x;
    let n = this.y;
    let r = this.z;
    let i = e.elements;
    this.x = i[0] * t + i[4] * n + i[8] * r;
    this.y = i[1] * t + i[5] * n + i[9] * r;
    this.z = i[2] * t + i[6] * n + i[10] * r;
    return this.normalize();
  }
  divide(e) {
    this.x /= e.x;
    this.y /= e.y;
    this.z /= e.z;
    return this;
  }
  divideScalar(e) {
    return this.multiplyScalar(1 / e);
  }
  min(e) {
    this.x = Math.min(this.x, e.x);
    this.y = Math.min(this.y, e.y);
    this.z = Math.min(this.z, e.z);
    return this;
  }
  max(e) {
    this.x = Math.max(this.x, e.x);
    this.y = Math.max(this.y, e.y);
    this.z = Math.max(this.z, e.z);
    return this;
  }
  clamp(e, t) {
    this.x = e_(this.x, e.x, t.x);
    this.y = e_(this.y, e.y, t.y);
    this.z = e_(this.z, e.z, t.z);
    return this;
  }
  clampScalar(e, t) {
    this.x = e_(this.x, e, t);
    this.y = e_(this.y, e, t);
    this.z = e_(this.z, e, t);
    return this;
  }
  clampLength(e, t) {
    let n = this.length();
    return this.divideScalar(n || 1).multiplyScalar(e_(n, e, t));
  }
  floor() {
    this.x = Math.floor(this.x);
    this.y = Math.floor(this.y);
    this.z = Math.floor(this.z);
    return this;
  }
  ceil() {
    this.x = Math.ceil(this.x);
    this.y = Math.ceil(this.y);
    this.z = Math.ceil(this.z);
    return this;
  }
  round() {
    this.x = Math.round(this.x);
    this.y = Math.round(this.y);
    this.z = Math.round(this.z);
    return this;
  }
  roundToZero() {
    this.x = Math.trunc(this.x);
    this.y = Math.trunc(this.y);
    this.z = Math.trunc(this.z);
    return this;
  }
  negate() {
    this.x = -this.x;
    this.y = -this.y;
    this.z = -this.z;
    return this;
  }
  dot(e) {
    return this.x * e.x + this.y * e.y + this.z * e.z;
  }
  lengthSq() {
    return this.x * this.x + this.y * this.y + this.z * this.z;
  }
  length() {
    return Math.sqrt(this.x * this.x + this.y * this.y + this.z * this.z);
  }
  manhattanLength() {
    return Math.abs(this.x) + Math.abs(this.y) + Math.abs(this.z);
  }
  normalize() {
    return this.divideScalar(this.length() || 1);
  }
  setLength(e) {
    return this.normalize().multiplyScalar(e);
  }
  lerp(e, t) {
    this.x += (e.x - this.x) * t;
    this.y += (e.y - this.y) * t;
    this.z += (e.z - this.z) * t;
    return this;
  }
  lerpVectors(e, t, n) {
    this.x = e.x + (t.x - e.x) * n;
    this.y = e.y + (t.y - e.y) * n;
    this.z = e.z + (t.z - e.z) * n;
    return this;
  }
  cross(e) {
    return this.crossVectors(this, e);
  }
  crossVectors(e, t) {
    let n = e.x;
    let r = e.y;
    let i = e.z;
    let a = t.x;
    let o = t.y;
    let s = t.z;
    this.x = r * s - i * o;
    this.y = i * a - n * s;
    this.z = n * o - r * a;
    return this;
  }
  projectOnVector(e) {
    let t = e.lengthSq();
    if (t === 0) {
      return this.set(0, 0, 0);
    }
    let n = e.dot(this) / t;
    return this.copy(e).multiplyScalar(n);
  }
  projectOnPlane(e) {
    w_.copy(this).projectOnVector(e);
    return this.sub(w_);
  }
  reflect(e) {
    return this.sub(w_.copy(e).multiplyScalar(this.dot(e) * 2));
  }
  angleTo(e) {
    let t = Math.sqrt(this.lengthSq() * e.lengthSq());
    if (t === 0) {
      return Math.PI / 2;
    }
    let n = this.dot(e) / t;
    return Math.acos(e_(n, -1, 1));
  }
  distanceTo(e) {
    return Math.sqrt(this.distanceToSquared(e));
  }
  distanceToSquared(e) {
    let t = this.x - e.x;
    let n = this.y - e.y;
    let r = this.z - e.z;
    return t * t + n * n + r * r;
  }
  manhattanDistanceTo(e) {
    return Math.abs(this.x - e.x) + Math.abs(this.y - e.y) + Math.abs(this.z - e.z);
  }
  setFromSpherical(e) {
    return this.setFromSphericalCoords(e.radius, e.phi, e.theta);
  }
  setFromSphericalCoords(e, t, n) {
    let r = Math.sin(t) * e;
    this.x = r * Math.sin(n);
    this.y = Math.cos(t) * e;
    this.z = r * Math.cos(n);
    return this;
  }
  setFromCylindrical(e) {
    return this.setFromCylindricalCoords(e.radius, e.theta, e.y);
  }
  setFromCylindricalCoords(e, t, n) {
    this.x = e * Math.sin(t);
    this.y = n;
    this.z = e * Math.cos(t);
    return this;
  }
  setFromMatrixPosition(e) {
    let t = e.elements;
    this.x = t[12];
    this.y = t[13];
    this.z = t[14];
    return this;
  }
  setFromMatrixScale(e) {
    let t = this.setFromMatrixColumn(e, 0).length();
    let n = this.setFromMatrixColumn(e, 1).length();
    let r = this.setFromMatrixColumn(e, 2).length();
    this.x = t;
    this.y = n;
    this.z = r;
    return this;
  }
  setFromMatrixColumn(e, t) {
    return this.fromArray(e.elements, t * 4);
  }
  setFromMatrix3Column(e, t) {
    return this.fromArray(e.elements, t * 3);
  }
  setFromEuler(e) {
    this.x = e._x;
    this.y = e._y;
    this.z = e._z;
    return this;
  }
  setFromColor(e) {
    this.x = e.r;
    this.y = e.g;
    this.z = e.b;
    return this;
  }
  equals(e) {
    return e.x === this.x && e.y === this.y && e.z === this.z;
  }
  fromArray(e, t = 0) {
    this.x = e[t];
    this.y = e[t + 1];
    this.z = e[t + 2];
    return this;
  }
  toArray(e = [], t = 0) {
    e[t] = this.x;
    e[t + 1] = this.y;
    e[t + 2] = this.z;
    return e;
  }
  fromBufferAttribute(e, t) {
    this.x = e.getX(t);
    this.y = e.getY(t);
    this.z = e.getZ(t);
    return this;
  }
  random() {
    this.x = Math.random();
    this.y = Math.random();
    this.z = Math.random();
    return this;
  }
  randomDirection() {
    let e = Math.random() * Math.PI * 2;
    let t = Math.random() * 2 - 1;
    let n = Math.sqrt(1 - t * t);
    this.x = n * Math.cos(e);
    this.y = t;
    this.z = n * Math.sin(e);
    return this;
  }
  *[Symbol.iterator]() {
    yield this.x;
    yield this.y;
    yield this.z;
  }
};
var w_ = new X();
var T_ = new C_();
var E_ = class e {
  static {
    e.prototype.isMatrix3 = true;
  }
  constructor(e, t, n, r, i, a, o, s, c) {
    this.elements = [1, 0, 0, 0, 1, 0, 0, 0, 1];
    if (e !== undefined) {
      this.set(e, t, n, r, i, a, o, s, c);
    }
  }
  set(e, t, n, r, i, a, o, s, c) {
    let l = this.elements;
    l[0] = e;
    l[1] = r;
    l[2] = o;
    l[3] = t;
    l[4] = i;
    l[5] = s;
    l[6] = n;
    l[7] = a;
    l[8] = c;
    return this;
  }
  identity() {
    this.set(1, 0, 0, 0, 1, 0, 0, 0, 1);
    return this;
  }
  copy(e) {
    let t = this.elements;
    let n = e.elements;
    t[0] = n[0];
    t[1] = n[1];
    t[2] = n[2];
    t[3] = n[3];
    t[4] = n[4];
    t[5] = n[5];
    t[6] = n[6];
    t[7] = n[7];
    t[8] = n[8];
    return this;
  }
  extractBasis(e, t, n) {
    e.setFromMatrix3Column(this, 0);
    t.setFromMatrix3Column(this, 1);
    n.setFromMatrix3Column(this, 2);
    return this;
  }
  setFromMatrix4(e) {
    let t = e.elements;
    this.set(t[0], t[4], t[8], t[1], t[5], t[9], t[2], t[6], t[10]);
    return this;
  }
  multiply(e) {
    return this.multiplyMatrices(this, e);
  }
  premultiply(e) {
    return this.multiplyMatrices(e, this);
  }
  multiplyMatrices(e, t) {
    let n = e.elements;
    let r = t.elements;
    let i = this.elements;
    let a = n[0];
    let o = n[3];
    let s = n[6];
    let c = n[1];
    let l = n[4];
    let u = n[7];
    let d = n[2];
    let f = n[5];
    let p = n[8];
    let m = r[0];
    let h = r[3];
    let g = r[6];
    let _ = r[1];
    let v = r[4];
    let y = r[7];
    let b = r[2];
    let x = r[5];
    let S = r[8];
    i[0] = a * m + o * _ + s * b;
    i[3] = a * h + o * v + s * x;
    i[6] = a * g + o * y + s * S;
    i[1] = c * m + l * _ + u * b;
    i[4] = c * h + l * v + u * x;
    i[7] = c * g + l * y + u * S;
    i[2] = d * m + f * _ + p * b;
    i[5] = d * h + f * v + p * x;
    i[8] = d * g + f * y + p * S;
    return this;
  }
  multiplyScalar(e) {
    let t = this.elements;
    t[0] *= e;
    t[3] *= e;
    t[6] *= e;
    t[1] *= e;
    t[4] *= e;
    t[7] *= e;
    t[2] *= e;
    t[5] *= e;
    t[8] *= e;
    return this;
  }
  determinant() {
    let e = this.elements;
    let t = e[0];
    let n = e[1];
    let r = e[2];
    let i = e[3];
    let a = e[4];
    let o = e[5];
    let s = e[6];
    let c = e[7];
    let l = e[8];
    return t * a * l - t * o * c - n * i * l + n * o * s + r * i * c - r * a * s;
  }
  invert() {
    let e = this.elements;
    let t = e[0];
    let n = e[1];
    let r = e[2];
    let i = e[3];
    let a = e[4];
    let o = e[5];
    let s = e[6];
    let c = e[7];
    let l = e[8];
    let u = l * a - o * c;
    let d = o * s - l * i;
    let f = c * i - a * s;
    let p = t * u + n * d + r * f;
    if (p === 0) {
      return this.set(0, 0, 0, 0, 0, 0, 0, 0, 0);
    }
    let m = 1 / p;
    e[0] = u * m;
    e[1] = (r * c - l * n) * m;
    e[2] = (o * n - r * a) * m;
    e[3] = d * m;
    e[4] = (l * t - r * s) * m;
    e[5] = (r * i - o * t) * m;
    e[6] = f * m;
    e[7] = (n * s - c * t) * m;
    e[8] = (a * t - n * i) * m;
    return this;
  }
  transpose() {
    let e;
    let t = this.elements;
    e = t[1];
    t[1] = t[3];
    t[3] = e;
    e = t[2];
    t[2] = t[6];
    t[6] = e;
    e = t[5];
    t[5] = t[7];
    t[7] = e;
    return this;
  }
  getNormalMatrix(e) {
    return this.setFromMatrix4(e).invert().transpose();
  }
  transposeIntoArray(e) {
    let t = this.elements;
    e[0] = t[0];
    e[1] = t[3];
    e[2] = t[6];
    e[3] = t[1];
    e[4] = t[4];
    e[5] = t[7];
    e[6] = t[2];
    e[7] = t[5];
    e[8] = t[8];
    return this;
  }
  setUvTransform(e, t, n, r, i, a, o) {
    let s = Math.cos(i);
    let c = Math.sin(i);
    this.set(n * s, n * c, -n * (s * a + c * o) + a + e, -r * c, r * s, -r * (-c * a + s * o) + o + t, 0, 0, 1);
    return this;
  }
  scale(e, t) {
    Gg(`Matrix3: .scale() is deprecated. Use .makeScale() instead.`);
    this.premultiply(D_.makeScale(e, t));
    return this;
  }
  rotate(e) {
    Gg(`Matrix3: .rotate() is deprecated. Use .makeRotation() instead.`);
    this.premultiply(D_.makeRotation(-e));
    return this;
  }
  translate(e, t) {
    Gg(`Matrix3: .translate() is deprecated. Use .makeTranslation() instead.`);
    this.premultiply(D_.makeTranslation(e, t));
    return this;
  }
  makeTranslation(e, t) {
    if (e.isVector2) {
      this.set(1, 0, e.x, 0, 1, e.y, 0, 0, 1);
    } else {
      this.set(1, 0, e, 0, 1, t, 0, 0, 1);
    }
    return this;
  }
  makeRotation(e) {
    let t = Math.cos(e);
    let n = Math.sin(e);
    this.set(t, -n, 0, n, t, 0, 0, 0, 1);
    return this;
  }
  makeScale(e, t) {
    this.set(e, 0, 0, 0, t, 0, 0, 0, 1);
    return this;
  }
  equals(e) {
    let t = this.elements;
    let n = e.elements;
    for (let e = 0; e < 9; e++) {
      if (t[e] !== n[e]) {
        return false;
      }
    }
    return true;
  }
  fromArray(e, t = 0) {
    for (let n = 0; n < 9; n++) {
      this.elements[n] = e[n + t];
    }
    return this;
  }
  toArray(e = [], t = 0) {
    let n = this.elements;
    e[t] = n[0];
    e[t + 1] = n[1];
    e[t + 2] = n[2];
    e[t + 3] = n[3];
    e[t + 4] = n[4];
    e[t + 5] = n[5];
    e[t + 6] = n[6];
    e[t + 7] = n[7];
    e[t + 8] = n[8];
    return e;
  }
  clone() {
    return new this.constructor().fromArray(this.elements);
  }
};
var D_ = new E_();
var O_ = new E_().set(0.4123908, 0.3575843, 0.1804808, 0.212639, 0.7151687, 0.0721923, 0.0193308, 0.1191948, 0.9505322);
var k_ = new E_().set(3.2409699, -1.5373832, -0.4986108, -0.9692436, 1.8759675, 0.0415551, 0.0556301, -0.203977, 1.0569715);
function A_() {
  let e = {
    enabled: true,
    workingColorSpace: Ag,
    spaces: {},
    convert: function (e, t, n) {
      if (this.enabled === false || t === n || !t || !n) {
        return e;
      } else {
        if (this.spaces[t].transfer === `srgb`) {
          e.r = M_(e.r);
          e.g = M_(e.g);
          e.b = M_(e.b);
        }
        if (this.spaces[t].primaries !== this.spaces[n].primaries) {
          e.applyMatrix3(this.spaces[t].toXYZ);
          e.applyMatrix3(this.spaces[n].fromXYZ);
        }
        if (this.spaces[n].transfer === `srgb`) {
          e.r = N_(e.r);
          e.g = N_(e.g);
          e.b = N_(e.b);
        }
        return e;
      }
    },
    workingToColorSpace: function (e, t) {
      return this.convert(e, this.workingColorSpace, t);
    },
    colorSpaceToWorking: function (e, t) {
      return this.convert(e, t, this.workingColorSpace);
    },
    getPrimaries: function (e) {
      return this.spaces[e].primaries;
    },
    getTransfer: function (e) {
      if (e === ``) {
        return jg;
      } else {
        return this.spaces[e].transfer;
      }
    },
    getToneMappingMode: function (e) {
      return this.spaces[e].outputColorSpaceConfig.toneMappingMode || `standard`;
    },
    getLuminanceCoefficients: function (e, t = this.workingColorSpace) {
      return e.fromArray(this.spaces[t].luminanceCoefficients);
    },
    define: function (e) {
      Object.assign(this.spaces, e);
    },
    _getMatrix: function (e, t, n) {
      return e.copy(this.spaces[t].toXYZ).multiply(this.spaces[n].fromXYZ);
    },
    _getDrawingBufferColorSpace: function (e) {
      return this.spaces[e].outputColorSpaceConfig.drawingBufferColorSpace;
    },
    _getUnpackColorSpace: function (e = this.workingColorSpace) {
      return this.spaces[e].workingColorSpaceConfig.unpackColorSpace;
    },
    fromWorkingColorSpace: function (t, n) {
      Gg(`ColorManagement: .fromWorkingColorSpace() has been renamed to .workingToColorSpace().`);
      return e.workingToColorSpace(t, n);
    },
    toWorkingColorSpace: function (t, n) {
      Gg(`ColorManagement: .toWorkingColorSpace() has been renamed to .colorSpaceToWorking().`);
      return e.colorSpaceToWorking(t, n);
    }
  };
  let t = [0.64, 0.33, 0.3, 0.6, 0.15, 0.06];
  let n = [0.2126, 0.7152, 0.0722];
  let r = [0.3127, 0.329];
  e.define({
    [Ag]: {
      primaries: t,
      whitePoint: r,
      transfer: jg,
      toXYZ: O_,
      fromXYZ: k_,
      luminanceCoefficients: n,
      workingColorSpaceConfig: {
        unpackColorSpace: kg
      },
      outputColorSpaceConfig: {
        drawingBufferColorSpace: kg
      }
    },
    [kg]: {
      primaries: t,
      whitePoint: r,
      transfer: Mg,
      toXYZ: O_,
      fromXYZ: k_,
      luminanceCoefficients: n,
      outputColorSpaceConfig: {
        drawingBufferColorSpace: kg
      }
    }
  });
  return e;
}
var j_ = A_();
function M_(e) {
  if (e < 0.04045) {
    return e * 0.0773993808;
  } else {
    return (e * 0.9478672986 + 0.0521327014) ** 2.4;
  }
}
function N_(e) {
  if (e < 0.0031308) {
    return e * 12.92;
  } else {
    return e ** 0.41666 * 1.055 - 0.055;
  }
}
var P_;
var F_ = class {
  static getDataURL(e, t = `image/png`) {
    if (/^data:/i.test(e.src) || typeof HTMLCanvasElement > `u`) {
      return e.src;
    }
    let n;
    if (e instanceof HTMLCanvasElement) {
      n = e;
    } else {
      if (P_ === undefined) {
        P_ = Rg(`canvas`);
      }
      P_.width = e.width;
      P_.height = e.height;
      let t = P_.getContext(`2d`);
      if (e instanceof ImageData) {
        t.putImageData(e, 0, 0);
      } else {
        t.drawImage(e, 0, 0, e.width, e.height);
      }
      n = P_;
    }
    return n.toDataURL(t);
  }
  static sRGBToLinear(e) {
    if (typeof HTMLImageElement < `u` && e instanceof HTMLImageElement || typeof HTMLCanvasElement < `u` && e instanceof HTMLCanvasElement || typeof ImageBitmap < `u` && e instanceof ImageBitmap) {
      let t = Rg(`canvas`);
      t.width = e.width;
      t.height = e.height;
      let n = t.getContext(`2d`);
      n.drawImage(e, 0, 0, e.width, e.height);
      let r = n.getImageData(0, 0, e.width, e.height);
      let i = r.data;
      for (let e = 0; e < i.length; e++) {
        i[e] = M_(i[e] / 255) * 255;
      }
      n.putImageData(r, 0, 0);
      return t;
    }
    if (e.data) {
      let t = e.data.slice(0);
      for (let e = 0; e < t.length; e++) {
        if (t instanceof Uint8Array || t instanceof Uint8ClampedArray) {
          t[e] = Math.floor(M_(t[e] / 255) * 255);
        } else {
          t[e] = M_(t[e]);
        }
      }
      return {
        data: t,
        width: e.width,
        height: e.height
      };
    }
    Ug(`ImageUtils.sRGBToLinear(): Unsupported image type. No color space conversion applied.`);
    return e;
  }
};
var I_ = 0;
var L_ = class {
  constructor(e = null) {
    this.isTextureSource = true;
    Object.defineProperty(this, "id", {
      value: I_++
    });
    this.uuid = $g();
    this.data = e;
    this.dataReady = true;
    this.version = 0;
  }
  getSize(e) {
    let t = this.data;
    if (typeof HTMLVideoElement < `u` && t instanceof HTMLVideoElement) {
      e.set(t.videoWidth, t.videoHeight, 0);
    } else if (typeof VideoFrame < `u` && t instanceof VideoFrame) {
      e.set(t.displayWidth, t.displayHeight, 0);
    } else if (t === null) {
      e.set(0, 0, 0);
    } else {
      e.set(t.width, t.height, t.depth || 0);
    }
    return e;
  }
  set needsUpdate(e) {
    if (e === true) {
      this.version++;
    }
  }
  toJSON(e) {
    let t = e === undefined || typeof e == `string`;
    if (!t && e.images[this.uuid] !== undefined) {
      return e.images[this.uuid];
    }
    let n = {
      uuid: this.uuid,
      url: ``
    };
    let r = this.data;
    if (r !== null) {
      let e;
      if (Array.isArray(r)) {
        e = [];
        for (let t = 0, n = r.length; t < n; t++) {
          if (r[t].isDataTexture) {
            e.push(R_(r[t].image));
          } else {
            e.push(R_(r[t]));
          }
        }
      } else {
        e = R_(r);
      }
      n.url = e;
    }
    if (!t) {
      e.images[this.uuid] = n;
    }
    return n;
  }
};
function R_(e) {
  if (typeof HTMLImageElement < `u` && e instanceof HTMLImageElement || typeof HTMLCanvasElement < `u` && e instanceof HTMLCanvasElement || typeof ImageBitmap < `u` && e instanceof ImageBitmap) {
    return F_.getDataURL(e);
  } else if (e.data) {
    return {
      data: Array.from(e.data),
      width: e.width,
      height: e.height,
      type: e.data.constructor.name
    };
  } else {
    Ug(`Texture: Unable to serialize Texture.`);
    return {};
  }
}
var z_ = 0;
var B_ = new X();
var V_ = class e extends Jg {
  constructor(t = e.DEFAULT_IMAGE, n = e.DEFAULT_MAPPING, r = ch, i = ch, a = ph, o = hh, s = jh, c = gh, l = e.DEFAULT_ANISOTROPY, u = ``) {
    super();
    this.isTexture = true;
    Object.defineProperty(this, "id", {
      value: z_++
    });
    this.uuid = $g();
    this.name = ``;
    this.source = new L_(t);
    this.mipmaps = [];
    this.mapping = n;
    this.channel = 0;
    this.wrapS = r;
    this.wrapT = i;
    this.magFilter = a;
    this.minFilter = o;
    this.anisotropy = l;
    this.format = s;
    this.internalFormat = null;
    this.type = c;
    this.offset = new S_(0, 0);
    this.repeat = new S_(1, 1);
    this.center = new S_(0, 0);
    this.rotation = 0;
    this.matrixAutoUpdate = true;
    this.matrix = new E_();
    this.generateMipmaps = true;
    this.premultiplyAlpha = false;
    this.flipY = true;
    this.unpackAlignment = 4;
    this.colorSpace = u;
    this.userData = {};
    this.updateRanges = [];
    this.version = 0;
    this.onUpdate = null;
    this.renderTarget = null;
    this.isRenderTargetTexture = false;
    this.isArrayTexture = !!t && !!t.depth && !!(t.depth > 1);
    this.pmremVersion = 0;
    this.normalized = false;
  }
  get width() {
    return this.source.getSize(B_).x;
  }
  get height() {
    return this.source.getSize(B_).y;
  }
  get depth() {
    return this.source.getSize(B_).z;
  }
  get image() {
    return this.source.data;
  }
  set image(e) {
    this.source.data = e;
  }
  updateMatrix() {
    this.matrix.setUvTransform(this.offset.x, this.offset.y, this.repeat.x, this.repeat.y, this.rotation, this.center.x, this.center.y);
  }
  addUpdateRange(e, t) {
    this.updateRanges.push({
      start: e,
      count: t
    });
  }
  clearUpdateRanges() {
    this.updateRanges.length = 0;
  }
  clone() {
    return new this.constructor().copy(this);
  }
  copy(e) {
    this.name = e.name;
    this.source = e.source;
    this.mipmaps = e.mipmaps.slice(0);
    this.mapping = e.mapping;
    this.channel = e.channel;
    this.wrapS = e.wrapS;
    this.wrapT = e.wrapT;
    this.magFilter = e.magFilter;
    this.minFilter = e.minFilter;
    this.anisotropy = e.anisotropy;
    this.format = e.format;
    this.internalFormat = e.internalFormat;
    this.type = e.type;
    this.normalized = e.normalized;
    this.offset.copy(e.offset);
    this.repeat.copy(e.repeat);
    this.center.copy(e.center);
    this.rotation = e.rotation;
    this.matrixAutoUpdate = e.matrixAutoUpdate;
    this.matrix.copy(e.matrix);
    this.generateMipmaps = e.generateMipmaps;
    this.premultiplyAlpha = e.premultiplyAlpha;
    this.flipY = e.flipY;
    this.unpackAlignment = e.unpackAlignment;
    this.colorSpace = e.colorSpace;
    this.renderTarget = e.renderTarget;
    this.isRenderTargetTexture = e.isRenderTargetTexture;
    this.isArrayTexture = e.isArrayTexture;
    this.userData = JSON.parse(JSON.stringify(e.userData));
    this.needsUpdate = true;
    return this;
  }
  setValues(e) {
    for (let t in e) {
      let n = e[t];
      if (n === undefined) {
        Ug(`Texture.setValues(): parameter '${t}' has value of undefined.`);
        continue;
      }
      let r = this[t];
      if (r === undefined) {
        Ug(`Texture.setValues(): property '${t}' does not exist.`);
        continue;
      }
      if (r && n && r.isVector2 && n.isVector2 || r && n && r.isVector3 && n.isVector3 || r && n && r.isMatrix3 && n.isMatrix3) {
        r.copy(n);
      } else {
        this[t] = n;
      }
    }
  }
  toJSON(e) {
    let t = e === undefined || typeof e == `string`;
    if (!t && e.textures[this.uuid] !== undefined) {
      return e.textures[this.uuid];
    }
    let n = {
      metadata: {
        version: 4.7,
        type: `Texture`,
        generator: `Texture.toJSON`
      },
      uuid: this.uuid,
      name: this.name,
      image: this.source.toJSON(e).uuid,
      mapping: this.mapping,
      channel: this.channel,
      repeat: [this.repeat.x, this.repeat.y],
      offset: [this.offset.x, this.offset.y],
      center: [this.center.x, this.center.y],
      rotation: this.rotation,
      wrap: [this.wrapS, this.wrapT],
      format: this.format,
      internalFormat: this.internalFormat,
      type: this.type,
      normalized: this.normalized,
      colorSpace: this.colorSpace,
      minFilter: this.minFilter,
      magFilter: this.magFilter,
      anisotropy: this.anisotropy,
      flipY: this.flipY,
      generateMipmaps: this.generateMipmaps,
      premultiplyAlpha: this.premultiplyAlpha,
      unpackAlignment: this.unpackAlignment
    };
    if (Object.keys(this.userData).length > 0) {
      n.userData = this.userData;
    }
    if (!t) {
      e.textures[this.uuid] = n;
    }
    return n;
  }
  dispose() {
    this.dispatchEvent({
      type: `dispose`
    });
  }
  transformUv(e) {
    if (this.mapping !== 300) {
      return e;
    }
    e.applyMatrix3(this.matrix);
    if (e.x < 0 || e.x > 1) {
      switch (this.wrapS) {
        case sh:
          e.x -= Math.floor(e.x);
          break;
        case ch:
          e.x = e.x < 0 ? 0 : 1;
          break;
        case lh:
          if (Math.abs(Math.floor(e.x) % 2) === 1) {
            e.x = Math.ceil(e.x) - e.x;
          } else {
            e.x -= Math.floor(e.x);
          }
      }
    }
    if (e.y < 0 || e.y > 1) {
      switch (this.wrapT) {
        case sh:
          e.y -= Math.floor(e.y);
          break;
        case ch:
          e.y = e.y < 0 ? 0 : 1;
          break;
        case lh:
          if (Math.abs(Math.floor(e.y) % 2) === 1) {
            e.y = Math.ceil(e.y) - e.y;
          } else {
            e.y -= Math.floor(e.y);
          }
      }
    }
    if (this.flipY) {
      e.y = 1 - e.y;
    }
    return e;
  }
  set needsUpdate(e) {
    if (e === true) {
      this.version++;
      this.source.needsUpdate = true;
    }
  }
  set needsPMREMUpdate(e) {
    if (e === true) {
      this.pmremVersion++;
    }
  }
};
V_.DEFAULT_IMAGE = null;
V_.DEFAULT_MAPPING = 300;
V_.DEFAULT_ANISOTROPY = 1;
var H_ = class e {
  static {
    e.prototype.isVector4 = true;
  }
  constructor(e = 0, t = 0, n = 0, r = 1) {
    this.x = e;
    this.y = t;
    this.z = n;
    this.w = r;
  }
  get width() {
    return this.z;
  }
  set width(e) {
    this.z = e;
  }
  get height() {
    return this.w;
  }
  set height(e) {
    this.w = e;
  }
  set(e, t, n, r) {
    this.x = e;
    this.y = t;
    this.z = n;
    this.w = r;
    return this;
  }
  setScalar(e) {
    this.x = e;
    this.y = e;
    this.z = e;
    this.w = e;
    return this;
  }
  setX(e) {
    this.x = e;
    return this;
  }
  setY(e) {
    this.y = e;
    return this;
  }
  setZ(e) {
    this.z = e;
    return this;
  }
  setW(e) {
    this.w = e;
    return this;
  }
  setComponent(e, t) {
    switch (e) {
      case 0:
        this.x = t;
        break;
      case 1:
        this.y = t;
        break;
      case 2:
        this.z = t;
        break;
      case 3:
        this.w = t;
        break;
      default:
        throw Error(`THREE.Vector4: index is out of range: ${e}`);
    }
    return this;
  }
  getComponent(e) {
    switch (e) {
      case 0:
        return this.x;
      case 1:
        return this.y;
      case 2:
        return this.z;
      case 3:
        return this.w;
      default:
        throw Error(`THREE.Vector4: index is out of range: ${e}`);
    }
  }
  clone() {
    return new this.constructor(this.x, this.y, this.z, this.w);
  }
  copy(e) {
    this.x = e.x;
    this.y = e.y;
    this.z = e.z;
    this.w = e.w === undefined ? 1 : e.w;
    return this;
  }
  add(e) {
    this.x += e.x;
    this.y += e.y;
    this.z += e.z;
    this.w += e.w;
    return this;
  }
  addScalar(e) {
    this.x += e;
    this.y += e;
    this.z += e;
    this.w += e;
    return this;
  }
  addVectors(e, t) {
    this.x = e.x + t.x;
    this.y = e.y + t.y;
    this.z = e.z + t.z;
    this.w = e.w + t.w;
    return this;
  }
  addScaledVector(e, t) {
    this.x += e.x * t;
    this.y += e.y * t;
    this.z += e.z * t;
    this.w += e.w * t;
    return this;
  }
  sub(e) {
    this.x -= e.x;
    this.y -= e.y;
    this.z -= e.z;
    this.w -= e.w;
    return this;
  }
  subScalar(e) {
    this.x -= e;
    this.y -= e;
    this.z -= e;
    this.w -= e;
    return this;
  }
  subVectors(e, t) {
    this.x = e.x - t.x;
    this.y = e.y - t.y;
    this.z = e.z - t.z;
    this.w = e.w - t.w;
    return this;
  }
  multiply(e) {
    this.x *= e.x;
    this.y *= e.y;
    this.z *= e.z;
    this.w *= e.w;
    return this;
  }
  multiplyScalar(e) {
    this.x *= e;
    this.y *= e;
    this.z *= e;
    this.w *= e;
    return this;
  }
  applyMatrix4(e) {
    let t = this.x;
    let n = this.y;
    let r = this.z;
    let i = this.w;
    let a = e.elements;
    this.x = a[0] * t + a[4] * n + a[8] * r + a[12] * i;
    this.y = a[1] * t + a[5] * n + a[9] * r + a[13] * i;
    this.z = a[2] * t + a[6] * n + a[10] * r + a[14] * i;
    this.w = a[3] * t + a[7] * n + a[11] * r + a[15] * i;
    return this;
  }
  divide(e) {
    this.x /= e.x;
    this.y /= e.y;
    this.z /= e.z;
    this.w /= e.w;
    return this;
  }
  divideScalar(e) {
    return this.multiplyScalar(1 / e);
  }
  setAxisAngleFromQuaternion(e) {
    this.w = Math.acos(e.w) * 2;
    let t = Math.sqrt(1 - e.w * e.w);
    if (t < 0.0001) {
      this.x = 1;
      this.y = 0;
      this.z = 0;
    } else {
      this.x = e.x / t;
      this.y = e.y / t;
      this.z = e.z / t;
    }
    return this;
  }
  setAxisAngleFromRotationMatrix(e) {
    let t;
    let n;
    let r;
    let i;
    let a = 0.01;
    let o = 0.1;
    let s = e.elements;
    let c = s[0];
    let l = s[4];
    let u = s[8];
    let d = s[1];
    let f = s[5];
    let p = s[9];
    let m = s[2];
    let h = s[6];
    let g = s[10];
    if (Math.abs(l - d) < a && Math.abs(u - m) < a && Math.abs(p - h) < a) {
      if (Math.abs(l + d) < o && Math.abs(u + m) < o && Math.abs(p + h) < o && Math.abs(c + f + g - 3) < o) {
        this.set(1, 0, 0, 0);
        return this;
      }
      t = Math.PI;
      let e = (c + 1) / 2;
      let s = (f + 1) / 2;
      let _ = (g + 1) / 2;
      let v = (l + d) / 4;
      let y = (u + m) / 4;
      let b = (p + h) / 4;
      if (e > s && e > _) {
        if (e < a) {
          n = 0;
          r = 0.707106781;
          i = 0.707106781;
        } else {
          n = Math.sqrt(e);
          r = v / n;
          i = y / n;
        }
      } else if (s > _) {
        if (s < a) {
          n = 0.707106781;
          r = 0;
          i = 0.707106781;
        } else {
          r = Math.sqrt(s);
          n = v / r;
          i = b / r;
        }
      } else if (_ < a) {
        n = 0.707106781;
        r = 0.707106781;
        i = 0;
      } else {
        i = Math.sqrt(_);
        n = y / i;
        r = b / i;
      }
      this.set(n, r, i, t);
      return this;
    }
    let _ = Math.sqrt((h - p) * (h - p) + (u - m) * (u - m) + (d - l) * (d - l));
    if (Math.abs(_) < 0.001) {
      _ = 1;
    }
    this.x = (h - p) / _;
    this.y = (u - m) / _;
    this.z = (d - l) / _;
    this.w = Math.acos((c + f + g - 1) / 2);
    return this;
  }
  setFromMatrixPosition(e) {
    let t = e.elements;
    this.x = t[12];
    this.y = t[13];
    this.z = t[14];
    this.w = t[15];
    return this;
  }
  min(e) {
    this.x = Math.min(this.x, e.x);
    this.y = Math.min(this.y, e.y);
    this.z = Math.min(this.z, e.z);
    this.w = Math.min(this.w, e.w);
    return this;
  }
  max(e) {
    this.x = Math.max(this.x, e.x);
    this.y = Math.max(this.y, e.y);
    this.z = Math.max(this.z, e.z);
    this.w = Math.max(this.w, e.w);
    return this;
  }
  clamp(e, t) {
    this.x = e_(this.x, e.x, t.x);
    this.y = e_(this.y, e.y, t.y);
    this.z = e_(this.z, e.z, t.z);
    this.w = e_(this.w, e.w, t.w);
    return this;
  }
  clampScalar(e, t) {
    this.x = e_(this.x, e, t);
    this.y = e_(this.y, e, t);
    this.z = e_(this.z, e, t);
    this.w = e_(this.w, e, t);
    return this;
  }
  clampLength(e, t) {
    let n = this.length();
    return this.divideScalar(n || 1).multiplyScalar(e_(n, e, t));
  }
  floor() {
    this.x = Math.floor(this.x);
    this.y = Math.floor(this.y);
    this.z = Math.floor(this.z);
    this.w = Math.floor(this.w);
    return this;
  }
  ceil() {
    this.x = Math.ceil(this.x);
    this.y = Math.ceil(this.y);
    this.z = Math.ceil(this.z);
    this.w = Math.ceil(this.w);
    return this;
  }
  round() {
    this.x = Math.round(this.x);
    this.y = Math.round(this.y);
    this.z = Math.round(this.z);
    this.w = Math.round(this.w);
    return this;
  }
  roundToZero() {
    this.x = Math.trunc(this.x);
    this.y = Math.trunc(this.y);
    this.z = Math.trunc(this.z);
    this.w = Math.trunc(this.w);
    return this;
  }
  negate() {
    this.x = -this.x;
    this.y = -this.y;
    this.z = -this.z;
    this.w = -this.w;
    return this;
  }
  dot(e) {
    return this.x * e.x + this.y * e.y + this.z * e.z + this.w * e.w;
  }
  lengthSq() {
    return this.x * this.x + this.y * this.y + this.z * this.z + this.w * this.w;
  }
  length() {
    return Math.sqrt(this.x * this.x + this.y * this.y + this.z * this.z + this.w * this.w);
  }
  manhattanLength() {
    return Math.abs(this.x) + Math.abs(this.y) + Math.abs(this.z) + Math.abs(this.w);
  }
  normalize() {
    return this.divideScalar(this.length() || 1);
  }
  setLength(e) {
    return this.normalize().multiplyScalar(e);
  }
  lerp(e, t) {
    this.x += (e.x - this.x) * t;
    this.y += (e.y - this.y) * t;
    this.z += (e.z - this.z) * t;
    this.w += (e.w - this.w) * t;
    return this;
  }
  lerpVectors(e, t, n) {
    this.x = e.x + (t.x - e.x) * n;
    this.y = e.y + (t.y - e.y) * n;
    this.z = e.z + (t.z - e.z) * n;
    this.w = e.w + (t.w - e.w) * n;
    return this;
  }
  equals(e) {
    return e.x === this.x && e.y === this.y && e.z === this.z && e.w === this.w;
  }
  fromArray(e, t = 0) {
    this.x = e[t];
    this.y = e[t + 1];
    this.z = e[t + 2];
    this.w = e[t + 3];
    return this;
  }
  toArray(e = [], t = 0) {
    e[t] = this.x;
    e[t + 1] = this.y;
    e[t + 2] = this.z;
    e[t + 3] = this.w;
    return e;
  }
  fromBufferAttribute(e, t) {
    this.x = e.getX(t);
    this.y = e.getY(t);
    this.z = e.getZ(t);
    this.w = e.getW(t);
    return this;
  }
  random() {
    this.x = Math.random();
    this.y = Math.random();
    this.z = Math.random();
    this.w = Math.random();
    return this;
  }
  *[Symbol.iterator]() {
    yield this.x;
    yield this.y;
    yield this.z;
    yield this.w;
  }
};
var U_ = class extends Jg {
  constructor(e = 1, t = 1, n = {}) {
    super();
    n = Object.assign({
      generateMipmaps: false,
      internalFormat: null,
      minFilter: ph,
      depthBuffer: true,
      stencilBuffer: false,
      resolveColorBuffer: true,
      resolveDepthBuffer: true,
      resolveStencilBuffer: true,
      storeMultisampledColorBuffer: true,
      storeMultisampledDepthBuffer: true,
      storeMultisampledStencilBuffer: true,
      depthTexture: null,
      samples: 0,
      count: 1,
      depth: 1,
      multiview: false,
      useArrayDepthTexture: false
    }, n);
    this.isRenderTarget = true;
    this.width = e;
    this.height = t;
    this.depth = n.depth;
    this.scissor = new H_(0, 0, e, t);
    this.scissorTest = false;
    this.viewport = new H_(0, 0, e, t);
    this.textures = [];
    let r = new V_({
      width: e,
      height: t,
      depth: n.depth
    });
    let i = n.count;
    for (let e = 0; e < i; e++) {
      this.textures[e] = r.clone();
      this.textures[e].isRenderTargetTexture = true;
      this.textures[e].renderTarget = this;
    }
    this._setTextureOptions(n);
    this.depthBuffer = n.depthBuffer;
    this.stencilBuffer = n.stencilBuffer;
    this.resolveColorBuffer = n.resolveColorBuffer;
    this.resolveDepthBuffer = n.resolveDepthBuffer;
    this.resolveStencilBuffer = n.resolveStencilBuffer;
    this.storeMultisampledColorBuffer = n.storeMultisampledColorBuffer;
    this.storeMultisampledDepthBuffer = n.storeMultisampledDepthBuffer;
    this.storeMultisampledStencilBuffer = n.storeMultisampledStencilBuffer;
    this._depthTexture = null;
    this.depthTexture = n.depthTexture;
    this.samples = n.samples;
    this.multiview = n.multiview;
    this.useArrayDepthTexture = n.useArrayDepthTexture;
  }
  _setTextureOptions(e = {}) {
    let t = {
      minFilter: ph,
      generateMipmaps: false,
      flipY: false,
      internalFormat: null
    };
    if (e.mapping !== undefined) {
      t.mapping = e.mapping;
    }
    if (e.wrapS !== undefined) {
      t.wrapS = e.wrapS;
    }
    if (e.wrapT !== undefined) {
      t.wrapT = e.wrapT;
    }
    if (e.wrapR !== undefined) {
      t.wrapR = e.wrapR;
    }
    if (e.magFilter !== undefined) {
      t.magFilter = e.magFilter;
    }
    if (e.minFilter !== undefined) {
      t.minFilter = e.minFilter;
    }
    if (e.format !== undefined) {
      t.format = e.format;
    }
    if (e.type !== undefined) {
      t.type = e.type;
    }
    if (e.anisotropy !== undefined) {
      t.anisotropy = e.anisotropy;
    }
    if (e.colorSpace !== undefined) {
      t.colorSpace = e.colorSpace;
    }
    if (e.flipY !== undefined) {
      t.flipY = e.flipY;
    }
    if (e.generateMipmaps !== undefined) {
      t.generateMipmaps = e.generateMipmaps;
    }
    if (e.internalFormat !== undefined) {
      t.internalFormat = e.internalFormat;
    }
    for (let e = 0; e < this.textures.length; e++) {
      this.textures[e].setValues(t);
    }
  }
  get texture() {
    return this.textures[0];
  }
  set texture(e) {
    this.textures[0] = e;
  }
  set depthTexture(e) {
    if (this._depthTexture !== null && this._depthTexture.renderTarget === this) {
      this._depthTexture.renderTarget = null;
    }
    if (e !== null && e.renderTarget === null) {
      e.renderTarget = this;
    }
    this._depthTexture = e;
  }
  get depthTexture() {
    return this._depthTexture;
  }
  setSize(e, t, n = 1) {
    if (this.width !== e || this.height !== t || this.depth !== n) {
      this.width = e;
      this.height = t;
      this.depth = n;
      for (let r = 0, i = this.textures.length; r < i; r++) {
        this.textures[r].image.width = e;
        this.textures[r].image.height = t;
        this.textures[r].image.depth = n;
        if (this.textures[r].isData3DTexture !== true) {
          this.textures[r].isArrayTexture = this.textures[r].image.depth > 1;
        }
      }
      this.dispose();
    }
    this.viewport.set(0, 0, e, t);
    this.scissor.set(0, 0, e, t);
  }
  clone() {
    return new this.constructor().copy(this);
  }
  copy(e) {
    this.width = e.width;
    this.height = e.height;
    this.depth = e.depth;
    this.scissor.copy(e.scissor);
    this.scissorTest = e.scissorTest;
    this.viewport.copy(e.viewport);
    this.textures.length = 0;
    for (let t = 0, n = e.textures.length; t < n; t++) {
      this.textures[t] = e.textures[t].clone();
      this.textures[t].isRenderTargetTexture = true;
      this.textures[t].renderTarget = this;
      let n = Object.assign({}, e.textures[t].image);
      this.textures[t].source = new L_(n);
    }
    this.depthBuffer = e.depthBuffer;
    this.stencilBuffer = e.stencilBuffer;
    this.resolveColorBuffer = e.resolveColorBuffer;
    this.resolveDepthBuffer = e.resolveDepthBuffer;
    this.resolveStencilBuffer = e.resolveStencilBuffer;
    this.storeMultisampledColorBuffer = e.storeMultisampledColorBuffer;
    this.storeMultisampledDepthBuffer = e.storeMultisampledDepthBuffer;
    this.storeMultisampledStencilBuffer = e.storeMultisampledStencilBuffer;
    if (e.depthTexture !== null) {
      if (e.depthTexture.renderTarget === e) {
        let t = e.depthTexture.clone();
        t.renderTarget = null;
        this.depthTexture = t;
      } else {
        this.depthTexture = e.depthTexture;
      }
    }
    this.samples = e.samples;
    this.multiview = e.multiview;
    this.useArrayDepthTexture = e.useArrayDepthTexture;
    return this;
  }
  dispose() {
    this.dispatchEvent({
      type: `dispose`
    });
  }
};
var W_ = class extends U_ {
  constructor(e = 1, t = 1, n = {}) {
    super(e, t, n);
    this.isWebGLRenderTarget = true;
  }
};
var G_ = class extends V_ {
  constructor(e = null, t = 1, n = 1, r = 1) {
    super(null);
    this.isDataArrayTexture = true;
    this.image = {
      data: e,
      width: t,
      height: n,
      depth: r
    };
    this.magFilter = uh;
    this.minFilter = uh;
    this.wrapR = ch;
    this.generateMipmaps = false;
    this.flipY = false;
    this.unpackAlignment = 1;
    this.layerUpdates = new Set();
  }
  copy(e) {
    super.copy(e);
    this.wrapR = e.wrapR;
    return this;
  }
  addLayerUpdate(e) {
    this.layerUpdates.add(e);
  }
  clearLayerUpdates() {
    this.layerUpdates.clear();
  }
};
var K_ = class extends V_ {
  constructor(e = null, t = 1, n = 1, r = 1) {
    super(null);
    this.isData3DTexture = true;
    this.image = {
      data: e,
      width: t,
      height: n,
      depth: r
    };
    this.magFilter = uh;
    this.minFilter = uh;
    this.wrapR = ch;
    this.generateMipmaps = false;
    this.flipY = false;
    this.unpackAlignment = 1;
  }
  copy(e) {
    super.copy(e);
    this.wrapR = e.wrapR;
    return this;
  }
};
var q_ = class e {
  static {
    e.prototype.isMatrix4 = true;
  }
  constructor(e, t, n, r, i, a, o, s, c, l, u, d, f, p, m, h) {
    this.elements = [1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1];
    if (e !== undefined) {
      this.set(e, t, n, r, i, a, o, s, c, l, u, d, f, p, m, h);
    }
  }
  set(e, t, n, r, i, a, o, s, c, l, u, d, f, p, m, h) {
    let g = this.elements;
    g[0] = e;
    g[4] = t;
    g[8] = n;
    g[12] = r;
    g[1] = i;
    g[5] = a;
    g[9] = o;
    g[13] = s;
    g[2] = c;
    g[6] = l;
    g[10] = u;
    g[14] = d;
    g[3] = f;
    g[7] = p;
    g[11] = m;
    g[15] = h;
    return this;
  }
  identity() {
    this.set(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
    return this;
  }
  clone() {
    return new e().fromArray(this.elements);
  }
  copy(e) {
    let t = this.elements;
    let n = e.elements;
    t[0] = n[0];
    t[1] = n[1];
    t[2] = n[2];
    t[3] = n[3];
    t[4] = n[4];
    t[5] = n[5];
    t[6] = n[6];
    t[7] = n[7];
    t[8] = n[8];
    t[9] = n[9];
    t[10] = n[10];
    t[11] = n[11];
    t[12] = n[12];
    t[13] = n[13];
    t[14] = n[14];
    t[15] = n[15];
    return this;
  }
  copyPosition(e) {
    let t = this.elements;
    let n = e.elements;
    t[12] = n[12];
    t[13] = n[13];
    t[14] = n[14];
    return this;
  }
  setFromMatrix3(e) {
    let t = e.elements;
    this.set(t[0], t[3], t[6], 0, t[1], t[4], t[7], 0, t[2], t[5], t[8], 0, 0, 0, 0, 1);
    return this;
  }
  extractBasis(e, t, n) {
    if (this.determinantAffine() === 0) {
      e.set(1, 0, 0);
      t.set(0, 1, 0);
      n.set(0, 0, 1);
      return this;
    } else {
      e.setFromMatrixColumn(this, 0);
      t.setFromMatrixColumn(this, 1);
      n.setFromMatrixColumn(this, 2);
      return this;
    }
  }
  makeBasis(e, t, n) {
    this.set(e.x, t.x, n.x, 0, e.y, t.y, n.y, 0, e.z, t.z, n.z, 0, 0, 0, 0, 1);
    return this;
  }
  extractRotation(e) {
    if (e.determinantAffine() === 0) {
      return this.identity();
    }
    let t = this.elements;
    let n = e.elements;
    let r = 1 / J_.setFromMatrixColumn(e, 0).length();
    let i = 1 / J_.setFromMatrixColumn(e, 1).length();
    let a = 1 / J_.setFromMatrixColumn(e, 2).length();
    t[0] = n[0] * r;
    t[1] = n[1] * r;
    t[2] = n[2] * r;
    t[3] = 0;
    t[4] = n[4] * i;
    t[5] = n[5] * i;
    t[6] = n[6] * i;
    t[7] = 0;
    t[8] = n[8] * a;
    t[9] = n[9] * a;
    t[10] = n[10] * a;
    t[11] = 0;
    t[12] = 0;
    t[13] = 0;
    t[14] = 0;
    t[15] = 1;
    return this;
  }
  makeRotationFromEuler(e) {
    let t = this.elements;
    let n = e.x;
    let r = e.y;
    let i = e.z;
    let a = Math.cos(n);
    let o = Math.sin(n);
    let s = Math.cos(r);
    let c = Math.sin(r);
    let l = Math.cos(i);
    let u = Math.sin(i);
    if (e.order === `XYZ`) {
      let e = a * l;
      let n = a * u;
      let r = o * l;
      let i = o * u;
      t[0] = s * l;
      t[4] = -s * u;
      t[8] = c;
      t[1] = n + r * c;
      t[5] = e - i * c;
      t[9] = -o * s;
      t[2] = i - e * c;
      t[6] = r + n * c;
      t[10] = a * s;
    } else if (e.order === `YXZ`) {
      let e = s * l;
      let n = s * u;
      let r = c * l;
      let i = c * u;
      t[0] = e + i * o;
      t[4] = r * o - n;
      t[8] = a * c;
      t[1] = a * u;
      t[5] = a * l;
      t[9] = -o;
      t[2] = n * o - r;
      t[6] = i + e * o;
      t[10] = a * s;
    } else if (e.order === `ZXY`) {
      let e = s * l;
      let n = s * u;
      let r = c * l;
      let i = c * u;
      t[0] = e - i * o;
      t[4] = -a * u;
      t[8] = r + n * o;
      t[1] = n + r * o;
      t[5] = a * l;
      t[9] = i - e * o;
      t[2] = -a * c;
      t[6] = o;
      t[10] = a * s;
    } else if (e.order === `ZYX`) {
      let e = a * l;
      let n = a * u;
      let r = o * l;
      let i = o * u;
      t[0] = s * l;
      t[4] = r * c - n;
      t[8] = e * c + i;
      t[1] = s * u;
      t[5] = i * c + e;
      t[9] = n * c - r;
      t[2] = -c;
      t[6] = o * s;
      t[10] = a * s;
    } else if (e.order === `YZX`) {
      let e = a * s;
      let n = a * c;
      let r = o * s;
      let i = o * c;
      t[0] = s * l;
      t[4] = i - e * u;
      t[8] = r * u + n;
      t[1] = u;
      t[5] = a * l;
      t[9] = -o * l;
      t[2] = -c * l;
      t[6] = n * u + r;
      t[10] = e - i * u;
    } else if (e.order === `XZY`) {
      let e = a * s;
      let n = a * c;
      let r = o * s;
      let i = o * c;
      t[0] = s * l;
      t[4] = -u;
      t[8] = c * l;
      t[1] = e * u + i;
      t[5] = a * l;
      t[9] = n * u - r;
      t[2] = r * u - n;
      t[6] = o * l;
      t[10] = i * u + e;
    }
    t[3] = 0;
    t[7] = 0;
    t[11] = 0;
    t[12] = 0;
    t[13] = 0;
    t[14] = 0;
    t[15] = 1;
    return this;
  }
  makeRotationFromQuaternion(e) {
    return this.compose(X_, e, Z_);
  }
  lookAt(e, t, n) {
    let r = this.elements;
    ev.subVectors(e, t);
    if (ev.lengthSq() === 0) {
      ev.z = 1;
    }
    ev.normalize();
    Q_.crossVectors(n, ev);
    if (Q_.lengthSq() === 0) {
      if (Math.abs(n.z) === 1) {
        ev.x += 0.0001;
      } else {
        ev.z += 0.0001;
      }
      ev.normalize();
      Q_.crossVectors(n, ev);
    }
    Q_.normalize();
    $_.crossVectors(ev, Q_);
    r[0] = Q_.x;
    r[4] = $_.x;
    r[8] = ev.x;
    r[1] = Q_.y;
    r[5] = $_.y;
    r[9] = ev.y;
    r[2] = Q_.z;
    r[6] = $_.z;
    r[10] = ev.z;
    return this;
  }
  multiply(e) {
    return this.multiplyMatrices(this, e);
  }
  premultiply(e) {
    return this.multiplyMatrices(e, this);
  }
  multiplyMatrices(e, t) {
    let n = e.elements;
    let r = t.elements;
    let i = this.elements;
    let a = n[0];
    let o = n[4];
    let s = n[8];
    let c = n[12];
    let l = n[1];
    let u = n[5];
    let d = n[9];
    let f = n[13];
    let p = n[2];
    let m = n[6];
    let h = n[10];
    let g = n[14];
    let _ = n[3];
    let v = n[7];
    let y = n[11];
    let b = n[15];
    let x = r[0];
    let S = r[4];
    let C = r[8];
    let w = r[12];
    let T = r[1];
    let E = r[5];
    let D = r[9];
    let O = r[13];
    let k = r[2];
    let A = r[6];
    let ee = r[10];
    let te = r[14];
    let j = r[3];
    let ne = r[7];
    let re = r[11];
    let M = r[15];
    i[0] = a * x + o * T + s * k + c * j;
    i[4] = a * S + o * E + s * A + c * ne;
    i[8] = a * C + o * D + s * ee + c * re;
    i[12] = a * w + o * O + s * te + c * M;
    i[1] = l * x + u * T + d * k + f * j;
    i[5] = l * S + u * E + d * A + f * ne;
    i[9] = l * C + u * D + d * ee + f * re;
    i[13] = l * w + u * O + d * te + f * M;
    i[2] = p * x + m * T + h * k + g * j;
    i[6] = p * S + m * E + h * A + g * ne;
    i[10] = p * C + m * D + h * ee + g * re;
    i[14] = p * w + m * O + h * te + g * M;
    i[3] = _ * x + v * T + y * k + b * j;
    i[7] = _ * S + v * E + y * A + b * ne;
    i[11] = _ * C + v * D + y * ee + b * re;
    i[15] = _ * w + v * O + y * te + b * M;
    return this;
  }
  multiplyScalar(e) {
    let t = this.elements;
    t[0] *= e;
    t[4] *= e;
    t[8] *= e;
    t[12] *= e;
    t[1] *= e;
    t[5] *= e;
    t[9] *= e;
    t[13] *= e;
    t[2] *= e;
    t[6] *= e;
    t[10] *= e;
    t[14] *= e;
    t[3] *= e;
    t[7] *= e;
    t[11] *= e;
    t[15] *= e;
    return this;
  }
  determinant() {
    let e = this.elements;
    let t = e[0];
    let n = e[4];
    let r = e[8];
    let i = e[12];
    let a = e[1];
    let o = e[5];
    let s = e[9];
    let c = e[13];
    let l = e[2];
    let u = e[6];
    let d = e[10];
    let f = e[14];
    let p = e[3];
    let m = e[7];
    let h = e[11];
    let g = e[15];
    let _ = s * f - c * d;
    let v = o * f - c * u;
    let y = o * d - s * u;
    let b = a * f - c * l;
    let x = a * d - s * l;
    let S = a * u - o * l;
    return t * (m * _ - h * v + g * y) - n * (p * _ - h * b + g * x) + r * (p * v - m * b + g * S) - i * (p * y - m * x + h * S);
  }
  determinantAffine() {
    let e = this.elements;
    let t = e[0];
    let n = e[4];
    let r = e[8];
    let i = e[1];
    let a = e[5];
    let o = e[9];
    let s = e[2];
    let c = e[6];
    let l = e[10];
    return t * (a * l - o * c) - n * (i * l - o * s) + r * (i * c - a * s);
  }
  transpose() {
    let e = this.elements;
    let t;
    t = e[1];
    e[1] = e[4];
    e[4] = t;
    t = e[2];
    e[2] = e[8];
    e[8] = t;
    t = e[6];
    e[6] = e[9];
    e[9] = t;
    t = e[3];
    e[3] = e[12];
    e[12] = t;
    t = e[7];
    e[7] = e[13];
    e[13] = t;
    t = e[11];
    e[11] = e[14];
    e[14] = t;
    return this;
  }
  setPosition(e, t, n) {
    let r = this.elements;
    if (e.isVector3) {
      r[12] = e.x;
      r[13] = e.y;
      r[14] = e.z;
    } else {
      r[12] = e;
      r[13] = t;
      r[14] = n;
    }
    return this;
  }
  invert() {
    let e = this.elements;
    let t = e[0];
    let n = e[1];
    let r = e[2];
    let i = e[3];
    let a = e[4];
    let o = e[5];
    let s = e[6];
    let c = e[7];
    let l = e[8];
    let u = e[9];
    let d = e[10];
    let f = e[11];
    let p = e[12];
    let m = e[13];
    let h = e[14];
    let g = e[15];
    let _ = t * o - n * a;
    let v = t * s - r * a;
    let y = t * c - i * a;
    let b = n * s - r * o;
    let x = n * c - i * o;
    let S = r * c - i * s;
    let C = l * m - u * p;
    let w = l * h - d * p;
    let T = l * g - f * p;
    let E = u * h - d * m;
    let D = u * g - f * m;
    let O = d * g - f * h;
    let k = _ * O - v * D + y * E + b * T - x * w + S * C;
    if (k === 0) {
      return this.set(0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0);
    }
    let A = 1 / k;
    e[0] = (o * O - s * D + c * E) * A;
    e[1] = (r * D - n * O - i * E) * A;
    e[2] = (m * S - h * x + g * b) * A;
    e[3] = (d * x - u * S - f * b) * A;
    e[4] = (s * T - a * O - c * w) * A;
    e[5] = (t * O - r * T + i * w) * A;
    e[6] = (h * y - p * S - g * v) * A;
    e[7] = (l * S - d * y + f * v) * A;
    e[8] = (a * D - o * T + c * C) * A;
    e[9] = (n * T - t * D - i * C) * A;
    e[10] = (p * x - m * y + g * _) * A;
    e[11] = (u * y - l * x - f * _) * A;
    e[12] = (o * w - a * E - s * C) * A;
    e[13] = (t * E - n * w + r * C) * A;
    e[14] = (m * v - p * b - h * _) * A;
    e[15] = (l * b - u * v + d * _) * A;
    return this;
  }
  scale(e) {
    let t = this.elements;
    let n = e.x;
    let r = e.y;
    let i = e.z;
    t[0] *= n;
    t[4] *= r;
    t[8] *= i;
    t[1] *= n;
    t[5] *= r;
    t[9] *= i;
    t[2] *= n;
    t[6] *= r;
    t[10] *= i;
    t[3] *= n;
    t[7] *= r;
    t[11] *= i;
    return this;
  }
  getMaxScaleOnAxis() {
    let e = this.elements;
    let t = e[0] * e[0] + e[1] * e[1] + e[2] * e[2];
    let n = e[4] * e[4] + e[5] * e[5] + e[6] * e[6];
    let r = e[8] * e[8] + e[9] * e[9] + e[10] * e[10];
    return Math.sqrt(Math.max(t, n, r));
  }
  makeTranslation(e, t, n) {
    if (e.isVector3) {
      this.set(1, 0, 0, e.x, 0, 1, 0, e.y, 0, 0, 1, e.z, 0, 0, 0, 1);
    } else {
      this.set(1, 0, 0, e, 0, 1, 0, t, 0, 0, 1, n, 0, 0, 0, 1);
    }
    return this;
  }
  makeRotationX(e) {
    let t = Math.cos(e);
    let n = Math.sin(e);
    this.set(1, 0, 0, 0, 0, t, -n, 0, 0, n, t, 0, 0, 0, 0, 1);
    return this;
  }
  makeRotationY(e) {
    let t = Math.cos(e);
    let n = Math.sin(e);
    this.set(t, 0, n, 0, 0, 1, 0, 0, -n, 0, t, 0, 0, 0, 0, 1);
    return this;
  }
  makeRotationZ(e) {
    let t = Math.cos(e);
    let n = Math.sin(e);
    this.set(t, -n, 0, 0, n, t, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
    return this;
  }
  makeRotationAxis(e, t) {
    let n = Math.cos(t);
    let r = Math.sin(t);
    let i = 1 - n;
    let a = e.x;
    let o = e.y;
    let s = e.z;
    let c = i * a;
    let l = i * o;
    this.set(c * a + n, c * o - r * s, c * s + r * o, 0, c * o + r * s, l * o + n, l * s - r * a, 0, c * s - r * o, l * s + r * a, i * s * s + n, 0, 0, 0, 0, 1);
    return this;
  }
  makeScale(e, t, n) {
    this.set(e, 0, 0, 0, 0, t, 0, 0, 0, 0, n, 0, 0, 0, 0, 1);
    return this;
  }
  makeShear(e, t, n, r, i, a) {
    this.set(1, n, i, 0, e, 1, a, 0, t, r, 1, 0, 0, 0, 0, 1);
    return this;
  }
  compose(e, t, n) {
    let r = this.elements;
    let i = t._x;
    let a = t._y;
    let o = t._z;
    let s = t._w;
    let c = i + i;
    let l = a + a;
    let u = o + o;
    let d = i * c;
    let f = i * l;
    let p = i * u;
    let m = a * l;
    let h = a * u;
    let g = o * u;
    let _ = s * c;
    let v = s * l;
    let y = s * u;
    let b = n.x;
    let x = n.y;
    let S = n.z;
    r[0] = (1 - (m + g)) * b;
    r[1] = (f + y) * b;
    r[2] = (p - v) * b;
    r[3] = 0;
    r[4] = (f - y) * x;
    r[5] = (1 - (d + g)) * x;
    r[6] = (h + _) * x;
    r[7] = 0;
    r[8] = (p + v) * S;
    r[9] = (h - _) * S;
    r[10] = (1 - (d + m)) * S;
    r[11] = 0;
    r[12] = e.x;
    r[13] = e.y;
    r[14] = e.z;
    r[15] = 1;
    return this;
  }
  decompose(e, t, n) {
    let r = this.elements;
    e.x = r[12];
    e.y = r[13];
    e.z = r[14];
    let i = this.determinantAffine();
    if (i === 0) {
      n.set(1, 1, 1);
      t.identity();
      return this;
    }
    let a = J_.set(r[0], r[1], r[2]).length();
    let o = J_.set(r[4], r[5], r[6]).length();
    let s = J_.set(r[8], r[9], r[10]).length();
    if (i < 0) {
      a = -a;
    }
    Y_.copy(this);
    let c = 1 / a;
    let l = 1 / o;
    let u = 1 / s;
    Y_.elements[0] *= c;
    Y_.elements[1] *= c;
    Y_.elements[2] *= c;
    Y_.elements[4] *= l;
    Y_.elements[5] *= l;
    Y_.elements[6] *= l;
    Y_.elements[8] *= u;
    Y_.elements[9] *= u;
    Y_.elements[10] *= u;
    t.setFromRotationMatrix(Y_);
    n.x = a;
    n.y = o;
    n.z = s;
    return this;
  }
  makePerspective(e, t, n, r, i, a, o = Fg, s = false) {
    let c = this.elements;
    let l = i * 2 / (t - e);
    let u = i * 2 / (n - r);
    let d = (t + e) / (t - e);
    let f = (n + r) / (n - r);
    let p;
    let m;
    if (s) {
      p = i / (a - i);
      m = a * i / (a - i);
    } else if (o === 2000) {
      p = -(a + i) / (a - i);
      m = a * -2 * i / (a - i);
    } else if (o === 2001) {
      p = -a / (a - i);
      m = -a * i / (a - i);
    } else {
      throw Error(`THREE.Matrix4.makePerspective(): Invalid coordinate system: ${o}`);
    }
    c[0] = l;
    c[4] = 0;
    c[8] = d;
    c[12] = 0;
    c[1] = 0;
    c[5] = u;
    c[9] = f;
    c[13] = 0;
    c[2] = 0;
    c[6] = 0;
    c[10] = p;
    c[14] = m;
    c[3] = 0;
    c[7] = 0;
    c[11] = -1;
    c[15] = 0;
    return this;
  }
  makeOrthographic(e, t, n, r, i, a, o = Fg, s = false) {
    let c = this.elements;
    let l = 2 / (t - e);
    let u = 2 / (n - r);
    let d = -(t + e) / (t - e);
    let f = -(n + r) / (n - r);
    let p;
    let m;
    if (s) {
      p = 1 / (a - i);
      m = a / (a - i);
    } else if (o === 2000) {
      p = -2 / (a - i);
      m = -(a + i) / (a - i);
    } else if (o === 2001) {
      p = -1 / (a - i);
      m = -i / (a - i);
    } else {
      throw Error(`THREE.Matrix4.makeOrthographic(): Invalid coordinate system: ${o}`);
    }
    c[0] = l;
    c[4] = 0;
    c[8] = 0;
    c[12] = d;
    c[1] = 0;
    c[5] = u;
    c[9] = 0;
    c[13] = f;
    c[2] = 0;
    c[6] = 0;
    c[10] = p;
    c[14] = m;
    c[3] = 0;
    c[7] = 0;
    c[11] = 0;
    c[15] = 1;
    return this;
  }
  equals(e) {
    let t = this.elements;
    let n = e.elements;
    for (let e = 0; e < 16; e++) {
      if (t[e] !== n[e]) {
        return false;
      }
    }
    return true;
  }
  fromArray(e, t = 0) {
    for (let n = 0; n < 16; n++) {
      this.elements[n] = e[n + t];
    }
    return this;
  }
  toArray(e = [], t = 0) {
    let n = this.elements;
    e[t] = n[0];
    e[t + 1] = n[1];
    e[t + 2] = n[2];
    e[t + 3] = n[3];
    e[t + 4] = n[4];
    e[t + 5] = n[5];
    e[t + 6] = n[6];
    e[t + 7] = n[7];
    e[t + 8] = n[8];
    e[t + 9] = n[9];
    e[t + 10] = n[10];
    e[t + 11] = n[11];
    e[t + 12] = n[12];
    e[t + 13] = n[13];
    e[t + 14] = n[14];
    e[t + 15] = n[15];
    return e;
  }
};
var J_ = new X();
var Y_ = new q_();
var X_ = new X(0, 0, 0);
var Z_ = new X(1, 1, 1);
var Q_ = new X();
var $_ = new X();
var ev = new X();
var tv = new q_();
var nv = new C_();
var rv = class e {
  constructor(t = 0, n = 0, r = 0, i = e.DEFAULT_ORDER) {
    this.isEuler = true;
    this._x = t;
    this._y = n;
    this._z = r;
    this._order = i;
  }
  get x() {
    return this._x;
  }
  set x(e) {
    this._x = e;
    this._onChangeCallback();
  }
  get y() {
    return this._y;
  }
  set y(e) {
    this._y = e;
    this._onChangeCallback();
  }
  get z() {
    return this._z;
  }
  set z(e) {
    this._z = e;
    this._onChangeCallback();
  }
  get order() {
    return this._order;
  }
  set order(e) {
    this._order = e;
    this._onChangeCallback();
  }
  set(e, t, n, r = this._order) {
    this._x = e;
    this._y = t;
    this._z = n;
    this._order = r;
    this._onChangeCallback();
    return this;
  }
  clone() {
    return new this.constructor(this._x, this._y, this._z, this._order);
  }
  copy(e) {
    this._x = e._x;
    this._y = e._y;
    this._z = e._z;
    this._order = e._order;
    this._onChangeCallback();
    return this;
  }
  setFromRotationMatrix(e, t = this._order, n = true) {
    let r = e.elements;
    let i = r[0];
    let a = r[4];
    let o = r[8];
    let s = r[1];
    let c = r[5];
    let l = r[9];
    let u = r[2];
    let d = r[6];
    let f = r[10];
    switch (t) {
      case `XYZ`:
        this._y = Math.asin(e_(o, -1, 1));
        if (Math.abs(o) < 0.9999999) {
          this._x = Math.atan2(-l, f);
          this._z = Math.atan2(-a, i);
        } else {
          this._x = Math.atan2(d, c);
          this._z = 0;
        }
        break;
      case `YXZ`:
        this._x = Math.asin(-e_(l, -1, 1));
        if (Math.abs(l) < 0.9999999) {
          this._y = Math.atan2(o, f);
          this._z = Math.atan2(s, c);
        } else {
          this._y = Math.atan2(-u, i);
          this._z = 0;
        }
        break;
      case `ZXY`:
        this._x = Math.asin(e_(d, -1, 1));
        if (Math.abs(d) < 0.9999999) {
          this._y = Math.atan2(-u, f);
          this._z = Math.atan2(-a, c);
        } else {
          this._y = 0;
          this._z = Math.atan2(s, i);
        }
        break;
      case `ZYX`:
        this._y = Math.asin(-e_(u, -1, 1));
        if (Math.abs(u) < 0.9999999) {
          this._x = Math.atan2(d, f);
          this._z = Math.atan2(s, i);
        } else {
          this._x = 0;
          this._z = Math.atan2(-a, c);
        }
        break;
      case `YZX`:
        this._z = Math.asin(e_(s, -1, 1));
        if (Math.abs(s) < 0.9999999) {
          this._x = Math.atan2(-l, c);
          this._y = Math.atan2(-u, i);
        } else {
          this._x = 0;
          this._y = Math.atan2(o, f);
        }
        break;
      case `XZY`:
        this._z = Math.asin(-e_(a, -1, 1));
        if (Math.abs(a) < 0.9999999) {
          this._x = Math.atan2(d, c);
          this._y = Math.atan2(o, i);
        } else {
          this._x = Math.atan2(-l, f);
          this._y = 0;
        }
        break;
      default:
        Ug(`Euler: .setFromRotationMatrix() encountered an unknown order: ${t}`);
    }
    this._order = t;
    if (n === true) {
      this._onChangeCallback();
    }
    return this;
  }
  setFromQuaternion(e, t, n) {
    tv.makeRotationFromQuaternion(e);
    return this.setFromRotationMatrix(tv, t, n);
  }
  setFromVector3(e, t = this._order) {
    return this.set(e.x, e.y, e.z, t);
  }
  reorder(e) {
    nv.setFromEuler(this);
    return this.setFromQuaternion(nv, e);
  }
  equals(e) {
    return e._x === this._x && e._y === this._y && e._z === this._z && e._order === this._order;
  }
  fromArray(e) {
    this._x = e[0];
    this._y = e[1];
    this._z = e[2];
    if (e[3] !== undefined) {
      this._order = e[3];
    }
    this._onChangeCallback();
    return this;
  }
  toArray(e = [], t = 0) {
    e[t] = this._x;
    e[t + 1] = this._y;
    e[t + 2] = this._z;
    e[t + 3] = this._order;
    return e;
  }
  _onChange(e) {
    this._onChangeCallback = e;
    return this;
  }
  _onChangeCallback() {}
  *[Symbol.iterator]() {
    yield this._x;
    yield this._y;
    yield this._z;
    yield this._order;
  }
};
rv.DEFAULT_ORDER = `XYZ`;
var iv = class {
  constructor() {
    this.mask = 1;
  }
  set(e) {
    this.mask = (1 << e | 0) >>> 0;
  }
  enable(e) {
    this.mask |= 1 << e | 0;
  }
  enableAll() {
    this.mask = -1;
  }
  toggle(e) {
    this.mask ^= 1 << e | 0;
  }
  disable(e) {
    this.mask &= ~(1 << e | 0);
  }
  disableAll() {
    this.mask = 0;
  }
  test(e) {
    return (this.mask & e.mask) !== 0;
  }
  isEnabled(e) {
    return !!(this.mask & (1 << e | 0));
  }
};
var av = 0;
var ov = new X();
var sv = new C_();
var cv = new q_();
var lv = new X();
var uv = new X();
var dv = new X();
var fv = new C_();
var pv = new X(1, 0, 0);
var mv = new X(0, 1, 0);
var hv = new X(0, 0, 1);
var gv = {
  type: `added`
};
var _v = {
  type: `removed`
};
var vv = {
  type: `childadded`,
  child: null
};
var yv = {
  type: `childremoved`,
  child: null
};
var bv = class e extends Jg {
  constructor() {
    super();
    this.isObject3D = true;
    Object.defineProperty(this, "id", {
      value: av++
    });
    this.uuid = $g();
    this.name = ``;
    this.type = `Object3D`;
    this.parent = null;
    this.children = [];
    this.up = e.DEFAULT_UP.clone();
    let t = new X();
    let n = new rv();
    let r = new C_();
    let i = new X(1, 1, 1);
    function a() {
      r.setFromEuler(n, false);
    }
    function o() {
      n.setFromQuaternion(r, undefined, false);
    }
    n._onChange(a);
    r._onChange(o);
    Object.defineProperties(this, {
      position: {
        configurable: true,
        enumerable: true,
        value: t
      },
      rotation: {
        configurable: true,
        enumerable: true,
        value: n
      },
      quaternion: {
        configurable: true,
        enumerable: true,
        value: r
      },
      scale: {
        configurable: true,
        enumerable: true,
        value: i
      },
      modelViewMatrix: {
        value: new q_()
      },
      normalMatrix: {
        value: new E_()
      }
    });
    this.matrix = new q_();
    this.matrixWorld = new q_();
    this.matrixAutoUpdate = e.DEFAULT_MATRIX_AUTO_UPDATE;
    this.matrixWorldAutoUpdate = e.DEFAULT_MATRIX_WORLD_AUTO_UPDATE;
    this.matrixWorldNeedsUpdate = false;
    this.layers = new iv();
    this.visible = true;
    this.castShadow = false;
    this.receiveShadow = false;
    this.frustumCulled = true;
    this.renderOrder = 0;
    this.animations = [];
    this.customDepthMaterial = undefined;
    this.customDistanceMaterial = undefined;
    this.static = false;
    this.userData = {};
    this.pivot = null;
  }
  onBeforeShadow() {}
  onAfterShadow() {}
  onBeforeRender() {}
  onAfterRender() {}
  applyMatrix4(e) {
    if (this.matrixAutoUpdate) {
      this.updateMatrix();
    }
    this.matrix.premultiply(e);
    this.matrix.decompose(this.position, this.quaternion, this.scale);
  }
  applyQuaternion(e) {
    this.quaternion.premultiply(e);
    return this;
  }
  setRotationFromAxisAngle(e, t) {
    this.quaternion.setFromAxisAngle(e, t);
  }
  setRotationFromEuler(e) {
    this.quaternion.setFromEuler(e, true);
  }
  setRotationFromMatrix(e) {
    this.quaternion.setFromRotationMatrix(e);
  }
  setRotationFromQuaternion(e) {
    this.quaternion.copy(e);
  }
  rotateOnAxis(e, t) {
    sv.setFromAxisAngle(e, t);
    this.quaternion.multiply(sv);
    return this;
  }
  rotateOnWorldAxis(e, t) {
    sv.setFromAxisAngle(e, t);
    this.quaternion.premultiply(sv);
    return this;
  }
  rotateX(e) {
    return this.rotateOnAxis(pv, e);
  }
  rotateY(e) {
    return this.rotateOnAxis(mv, e);
  }
  rotateZ(e) {
    return this.rotateOnAxis(hv, e);
  }
  translateOnAxis(e, t) {
    ov.copy(e).applyQuaternion(this.quaternion);
    this.position.add(ov.multiplyScalar(t));
    return this;
  }
  translateX(e) {
    return this.translateOnAxis(pv, e);
  }
  translateY(e) {
    return this.translateOnAxis(mv, e);
  }
  translateZ(e) {
    return this.translateOnAxis(hv, e);
  }
  localToWorld(e) {
    this.updateWorldMatrix(true, false);
    return e.applyMatrix4(this.matrixWorld);
  }
  worldToLocal(e) {
    this.updateWorldMatrix(true, false);
    return e.applyMatrix4(cv.copy(this.matrixWorld).invert());
  }
  lookAt(e, t, n) {
    if (e.isVector3) {
      lv.copy(e);
    } else {
      lv.set(e, t, n);
    }
    let r = this.parent;
    this.updateWorldMatrix(true, false);
    uv.setFromMatrixPosition(this.matrixWorld);
    if (this.isCamera || this.isLight) {
      cv.lookAt(uv, lv, this.up);
    } else {
      cv.lookAt(lv, uv, this.up);
    }
    this.quaternion.setFromRotationMatrix(cv);
    if (r) {
      cv.extractRotation(r.matrixWorld);
      sv.setFromRotationMatrix(cv);
      this.quaternion.premultiply(sv.invert());
    }
  }
  add(e) {
    if (arguments.length > 1) {
      for (let e = 0; e < arguments.length; e++) {
        this.add(arguments[e]);
      }
      return this;
    }
    if (e === this) {
      Wg(`Object3D.add: object can't be added as a child of itself.`, e);
      return this;
    } else {
      if (e && e.isObject3D) {
        e.removeFromParent();
        e.parent = this;
        this.children.push(e);
        e.dispatchEvent(gv);
        vv.child = e;
        this.dispatchEvent(vv);
        vv.child = null;
      } else {
        Wg(`Object3D.add: object not an instance of THREE.Object3D.`, e);
      }
      return this;
    }
  }
  remove(e) {
    if (arguments.length > 1) {
      for (let e = 0; e < arguments.length; e++) {
        this.remove(arguments[e]);
      }
      return this;
    }
    let t = this.children.indexOf(e);
    if (t !== -1) {
      e.parent = null;
      this.children.splice(t, 1);
      e.dispatchEvent(_v);
      yv.child = e;
      this.dispatchEvent(yv);
      yv.child = null;
    }
    return this;
  }
  removeFromParent() {
    let e = this.parent;
    if (e !== null) {
      e.remove(this);
    }
    return this;
  }
  clear() {
    return this.remove(...this.children);
  }
  attach(e) {
    this.updateWorldMatrix(true, false);
    cv.copy(this.matrixWorld).invert();
    if (e.parent !== null) {
      e.parent.updateWorldMatrix(true, false);
      cv.multiply(e.parent.matrixWorld);
    }
    e.applyMatrix4(cv);
    e.removeFromParent();
    e.parent = this;
    this.children.push(e);
    e.updateWorldMatrix(false, true);
    e.dispatchEvent(gv);
    vv.child = e;
    this.dispatchEvent(vv);
    vv.child = null;
    return this;
  }
  getObjectById(e) {
    return this.getObjectByProperty(`id`, e);
  }
  getObjectByName(e) {
    return this.getObjectByProperty(`name`, e);
  }
  getObjectByProperty(e, t) {
    if (this[e] === t) {
      return this;
    }
    for (let n = 0, r = this.children.length; n < r; n++) {
      let r = this.children[n].getObjectByProperty(e, t);
      if (r !== undefined) {
        return r;
      }
    }
  }
  getObjectsByProperty(e, t, n = []) {
    if (this[e] === t) {
      n.push(this);
    }
    let r = this.children;
    for (let i = 0, a = r.length; i < a; i++) {
      r[i].getObjectsByProperty(e, t, n);
    }
    return n;
  }
  getWorldPosition(e) {
    this.updateWorldMatrix(true, false);
    return e.setFromMatrixPosition(this.matrixWorld);
  }
  getWorldQuaternion(e) {
    this.updateWorldMatrix(true, false);
    this.matrixWorld.decompose(uv, e, dv);
    return e;
  }
  getWorldScale(e) {
    this.updateWorldMatrix(true, false);
    this.matrixWorld.decompose(uv, fv, e);
    return e;
  }
  getWorldDirection(e) {
    this.updateWorldMatrix(true, false);
    let t = this.matrixWorld.elements;
    return e.set(t[8], t[9], t[10]).normalize();
  }
  raycast() {}
  intersectsFrustum() {}
  traverse(e) {
    e(this);
    let t = this.children;
    for (let n = 0, r = t.length; n < r; n++) {
      t[n].traverse(e);
    }
  }
  traverseVisible(e) {
    if (this.visible === false) {
      return;
    }
    e(this);
    let t = this.children;
    for (let n = 0, r = t.length; n < r; n++) {
      t[n].traverseVisible(e);
    }
  }
  traverseAncestors(e) {
    let t = this.parent;
    if (t !== null) {
      e(t);
      t.traverseAncestors(e);
    }
  }
  updateMatrix() {
    this.matrix.compose(this.position, this.quaternion, this.scale);
    let e = this.pivot;
    if (e !== null) {
      let t = e.x;
      let n = e.y;
      let r = e.z;
      let i = this.matrix.elements;
      i[12] += t - i[0] * t - i[4] * n - i[8] * r;
      i[13] += n - i[1] * t - i[5] * n - i[9] * r;
      i[14] += r - i[2] * t - i[6] * n - i[10] * r;
    }
    this.matrixWorldNeedsUpdate = true;
  }
  updateMatrixWorld(e) {
    if (this.matrixAutoUpdate) {
      this.updateMatrix();
    }
    if (this.matrixWorldNeedsUpdate || e) {
      if (this.matrixWorldAutoUpdate === true) {
        if (this.parent === null) {
          this.matrixWorld.copy(this.matrix);
        } else {
          this.matrixWorld.multiplyMatrices(this.parent.matrixWorld, this.matrix);
        }
      }
      this.matrixWorldNeedsUpdate = false;
      e = true;
    }
    let t = this.children;
    for (let n = 0, r = t.length; n < r; n++) {
      t[n].updateMatrixWorld(e);
    }
  }
  updateWorldMatrix(e, t, n = false) {
    let r = this.parent;
    if (e === true && r !== null) {
      r.updateWorldMatrix(true, false);
    }
    if (this.matrixAutoUpdate) {
      this.updateMatrix();
    }
    if (this.matrixWorldNeedsUpdate || n) {
      if (this.matrixWorldAutoUpdate === true) {
        if (this.parent === null) {
          this.matrixWorld.copy(this.matrix);
        } else {
          this.matrixWorld.multiplyMatrices(this.parent.matrixWorld, this.matrix);
        }
      }
      this.matrixWorldNeedsUpdate = false;
      n = true;
    }
    if (t === true) {
      let e = this.children;
      for (let t = 0, r = e.length; t < r; t++) {
        e[t].updateWorldMatrix(false, true, n);
      }
    }
  }
  toJSON(e) {
    let t = e === undefined || typeof e == `string`;
    let n = {};
    if (t) {
      e = {
        geometries: {},
        materials: {},
        textures: {},
        images: {},
        shapes: {},
        skeletons: {},
        animations: {},
        nodes: {}
      };
      n.metadata = {
        version: 4.7,
        type: `Object`,
        generator: `Object3D.toJSON`
      };
    }
    let r = {
      uuid: this.uuid,
      type: this.type,
      name: this.name,
      castShadow: this.castShadow,
      receiveShadow: this.receiveShadow,
      visible: this.visible,
      frustumCulled: this.frustumCulled,
      renderOrder: this.renderOrder,
      static: this.static,
      matrixAutoUpdate: this.matrixAutoUpdate
    };
    if (Object.keys(this.userData).length > 0) {
      r.userData = this.userData;
    }
    r.layers = this.layers.mask;
    r.matrix = this.matrix.toArray();
    r.up = this.up.toArray();
    if (this.pivot !== null) {
      r.pivot = this.pivot.toArray();
    }
    if (this.morphTargetDictionary !== undefined) {
      r.morphTargetDictionary = Object.assign({}, this.morphTargetDictionary);
    }
    if (this.morphTargetInfluences !== undefined) {
      r.morphTargetInfluences = this.morphTargetInfluences.slice();
    }
    if (this.isInstancedMesh) {
      r.type = `InstancedMesh`;
      r.count = this.count;
      r.instanceMatrix = this.instanceMatrix.toJSON();
      if (this.instanceColor !== null) {
        r.instanceColor = this.instanceColor.toJSON();
      }
    }
    if (this.isBatchedMesh) {
      r.type = `BatchedMesh`;
      r.perObjectFrustumCulled = this.perObjectFrustumCulled;
      r.sortObjects = this.sortObjects;
      r.drawRanges = this._drawRanges;
      r.reservedRanges = this._reservedRanges;
      r.geometryInfo = this._geometryInfo.map(e => ({
        ...e,
        boundingBox: e.boundingBox ? e.boundingBox.toJSON() : undefined,
        boundingSphere: e.boundingSphere ? e.boundingSphere.toJSON() : undefined
      }));
      r.instanceInfo = this._instanceInfo.map(e => ({
        ...e
      }));
      r.availableInstanceIds = this._availableInstanceIds.slice();
      r.availableGeometryIds = this._availableGeometryIds.slice();
      r.nextIndexStart = this._nextIndexStart;
      r.nextVertexStart = this._nextVertexStart;
      r.geometryCount = this._geometryCount;
      r.maxInstanceCount = this._maxInstanceCount;
      r.maxVertexCount = this._maxVertexCount;
      r.maxIndexCount = this._maxIndexCount;
      r.geometryInitialized = this._geometryInitialized;
      r.matricesTexture = this._matricesTexture.toJSON(e);
      r.indirectTexture = this._indirectTexture.toJSON(e);
      if (this._colorsTexture !== null) {
        r.colorsTexture = this._colorsTexture.toJSON(e);
      }
      if (this.boundingSphere !== null) {
        r.boundingSphere = this.boundingSphere.toJSON();
      }
      if (this.boundingBox !== null) {
        r.boundingBox = this.boundingBox.toJSON();
      }
    }
    function i(t, n) {
      if (t[n.uuid] === undefined) {
        t[n.uuid] = n.toJSON(e);
      }
      return n.uuid;
    }
    if (this.isScene) {
      if (this.background) {
        if (this.background.isColor) {
          r.background = this.background.toJSON();
        } else if (this.background.isTexture) {
          r.background = this.background.toJSON(e).uuid;
        }
      }
      if (this.environment && this.environment.isTexture && this.environment.isRenderTargetTexture !== true) {
        r.environment = this.environment.toJSON(e).uuid;
      }
    } else if (this.isMesh || this.isLine || this.isPoints) {
      r.geometry = i(e.geometries, this.geometry);
      let t = this.geometry.parameters;
      if (t !== undefined && t.shapes !== undefined) {
        let n = t.shapes;
        if (Array.isArray(n)) {
          for (let t = 0, r = n.length; t < r; t++) {
            let r = n[t];
            i(e.shapes, r);
          }
        } else {
          i(e.shapes, n);
        }
      }
    }
    if (this.isSkinnedMesh) {
      r.bindMode = this.bindMode;
      r.bindMatrix = this.bindMatrix.toArray();
      if (this.skeleton !== undefined) {
        i(e.skeletons, this.skeleton);
        r.skeleton = this.skeleton.uuid;
      }
    }
    if (this.material !== undefined) {
      if (Array.isArray(this.material)) {
        let t = [];
        for (let n = 0, r = this.material.length; n < r; n++) {
          t.push(i(e.materials, this.material[n]));
        }
        r.material = t;
      } else {
        r.material = i(e.materials, this.material);
      }
    }
    if (this.children.length > 0) {
      r.children = [];
      for (let t = 0; t < this.children.length; t++) {
        r.children.push(this.children[t].toJSON(e).object);
      }
    }
    if (this.animations.length > 0) {
      r.animations = [];
      for (let t = 0; t < this.animations.length; t++) {
        let n = this.animations[t];
        r.animations.push(i(e.animations, n));
      }
    }
    if (t) {
      let t = a(e.geometries);
      let r = a(e.materials);
      let i = a(e.textures);
      let o = a(e.images);
      let s = a(e.shapes);
      let c = a(e.skeletons);
      let l = a(e.animations);
      let u = a(e.nodes);
      if (t.length > 0) {
        n.geometries = t;
      }
      if (r.length > 0) {
        n.materials = r;
      }
      if (i.length > 0) {
        n.textures = i;
      }
      if (o.length > 0) {
        n.images = o;
      }
      if (s.length > 0) {
        n.shapes = s;
      }
      if (c.length > 0) {
        n.skeletons = c;
      }
      if (l.length > 0) {
        n.animations = l;
      }
      if (u.length > 0) {
        n.nodes = u;
      }
    }
    n.object = r;
    return n;
    function a(e) {
      let t = [];
      for (let n in e) {
        let r = e[n];
        delete r.metadata;
        t.push(r);
      }
      return t;
    }
  }
  clone(e) {
    return new this.constructor().copy(this, e);
  }
  copy(e, t = true) {
    this.name = e.name;
    this.up.copy(e.up);
    this.position.copy(e.position);
    this.rotation.order = e.rotation.order;
    this.quaternion.copy(e.quaternion);
    this.scale.copy(e.scale);
    this.pivot = e.pivot === null ? null : e.pivot.clone();
    this.matrix.copy(e.matrix);
    this.matrixWorld.copy(e.matrixWorld);
    this.matrixAutoUpdate = e.matrixAutoUpdate;
    this.matrixWorldAutoUpdate = e.matrixWorldAutoUpdate;
    this.matrixWorldNeedsUpdate = e.matrixWorldNeedsUpdate;
    this.layers.mask = e.layers.mask;
    this.visible = e.visible;
    this.castShadow = e.castShadow;
    this.receiveShadow = e.receiveShadow;
    this.frustumCulled = e.frustumCulled;
    this.renderOrder = e.renderOrder;
    this.static = e.static;
    this.animations = e.animations.slice();
    this.userData = JSON.parse(JSON.stringify(e.userData));
    if (t === true) {
      for (let t = 0; t < e.children.length; t++) {
        let n = e.children[t];
        this.add(n.clone());
      }
    }
    return this;
  }
  dispose() {
    this.dispatchEvent({
      type: `dispose`
    });
  }
};
bv.DEFAULT_UP = new X(0, 1, 0);
bv.DEFAULT_MATRIX_AUTO_UPDATE = true;
bv.DEFAULT_MATRIX_WORLD_AUTO_UPDATE = true;
var xv = class extends bv {
  constructor() {
    super();
    this.isGroup = true;
    this.type = `Group`;
  }
};
var Sv = {
  type: `move`
};
var Cv = class {
  constructor() {
    this._targetRay = null;
    this._grip = null;
    this._hand = null;
  }
  getHandSpace() {
    if (this._hand === null) {
      this._hand = new xv();
      this._hand.matrixAutoUpdate = false;
      this._hand.visible = false;
      this._hand.joints = {};
      this._hand.inputState = {
        pinching: false
      };
    }
    return this._hand;
  }
  getTargetRaySpace() {
    if (this._targetRay === null) {
      this._targetRay = new xv();
      this._targetRay.matrixAutoUpdate = false;
      this._targetRay.visible = false;
      this._targetRay.hasLinearVelocity = false;
      this._targetRay.linearVelocity = new X();
      this._targetRay.hasAngularVelocity = false;
      this._targetRay.angularVelocity = new X();
    }
    return this._targetRay;
  }
  getGripSpace() {
    if (this._grip === null) {
      this._grip = new xv();
      this._grip.matrixAutoUpdate = false;
      this._grip.visible = false;
      this._grip.hasLinearVelocity = false;
      this._grip.linearVelocity = new X();
      this._grip.hasAngularVelocity = false;
      this._grip.angularVelocity = new X();
      this._grip.eventsEnabled = false;
    }
    return this._grip;
  }
  dispatchEvent(e) {
    if (this._targetRay !== null) {
      this._targetRay.dispatchEvent(e);
    }
    if (this._grip !== null) {
      this._grip.dispatchEvent(e);
    }
    if (this._hand !== null) {
      this._hand.dispatchEvent(e);
    }
    return this;
  }
  connect(e) {
    if (e && e.hand) {
      let t = this._hand;
      if (t) {
        for (let n of e.hand.values()) {
          this._getHandJoint(t, n);
        }
      }
    }
    this.dispatchEvent({
      type: `connected`,
      data: e
    });
    return this;
  }
  disconnect(e) {
    this.dispatchEvent({
      type: `disconnected`,
      data: e
    });
    if (this._targetRay !== null) {
      this._targetRay.visible = false;
    }
    if (this._grip !== null) {
      this._grip.visible = false;
    }
    if (this._hand !== null) {
      this._hand.visible = false;
    }
    return this;
  }
  update(e, t, n) {
    let r = null;
    let i = null;
    let a = null;
    let o = this._targetRay;
    let s = this._grip;
    let c = this._hand;
    if (e && t.session.visibilityState !== `visible-blurred`) {
      if (c && e.hand) {
        a = true;
        for (let r of e.hand.values()) {
          let e = t.getJointPose(r, n);
          let i = this._getHandJoint(c, r);
          if (e !== null) {
            i.matrix.fromArray(e.transform.matrix);
            i.matrix.decompose(i.position, i.rotation, i.scale);
            i.matrixWorldNeedsUpdate = true;
            i.jointRadius = e.radius;
          }
          i.visible = e !== null;
        }
        let r = c.joints[`index-finger-tip`];
        let i = c.joints[`thumb-tip`];
        let o = r.position.distanceTo(i.position);
        if (c.inputState.pinching && o > 0.025) {
          c.inputState.pinching = false;
          this.dispatchEvent({
            type: `pinchend`,
            handedness: e.handedness,
            target: this
          });
        } else if (!c.inputState.pinching && o <= 0.015) {
          c.inputState.pinching = true;
          this.dispatchEvent({
            type: `pinchstart`,
            handedness: e.handedness,
            target: this
          });
        }
      } else if (s !== null && e.gripSpace) {
        i = t.getPose(e.gripSpace, n);
        if (i !== null) {
          s.matrix.fromArray(i.transform.matrix);
          s.matrix.decompose(s.position, s.rotation, s.scale);
          s.matrixWorldNeedsUpdate = true;
          if (i.linearVelocity) {
            s.hasLinearVelocity = true;
            s.linearVelocity.copy(i.linearVelocity);
          } else {
            s.hasLinearVelocity = false;
          }
          if (i.angularVelocity) {
            s.hasAngularVelocity = true;
            s.angularVelocity.copy(i.angularVelocity);
          } else {
            s.hasAngularVelocity = false;
          }
          if (s.eventsEnabled) {
            s.dispatchEvent({
              type: `gripUpdated`,
              data: e,
              target: this
            });
          }
        }
      }
      if (o !== null) {
        r = t.getPose(e.targetRaySpace, n);
        if (r === null && i !== null) {
          r = i;
        }
        if (r !== null) {
          o.matrix.fromArray(r.transform.matrix);
          o.matrix.decompose(o.position, o.rotation, o.scale);
          o.matrixWorldNeedsUpdate = true;
          if (r.linearVelocity) {
            o.hasLinearVelocity = true;
            o.linearVelocity.copy(r.linearVelocity);
          } else {
            o.hasLinearVelocity = false;
          }
          if (r.angularVelocity) {
            o.hasAngularVelocity = true;
            o.angularVelocity.copy(r.angularVelocity);
          } else {
            o.hasAngularVelocity = false;
          }
          this.dispatchEvent(Sv);
        }
      }
    }
    if (o !== null) {
      o.visible = r !== null;
    }
    if (s !== null) {
      s.visible = i !== null;
    }
    if (c !== null) {
      c.visible = a !== null;
    }
    return this;
  }
  _getHandJoint(e, t) {
    if (e.joints[t.jointName] === undefined) {
      let n = new xv();
      n.matrixAutoUpdate = false;
      n.visible = false;
      e.joints[t.jointName] = n;
      e.add(n);
    }
    return e.joints[t.jointName];
  }
};
var wv = {
  aliceblue: 15792383,
  antiquewhite: 16444375,
  aqua: 65535,
  aquamarine: 8388564,
  azure: 15794175,
  beige: 16119260,
  bisque: 16770244,
  black: 0,
  blanchedalmond: 16772045,
  blue: 255,
  blueviolet: 9055202,
  brown: 10824234,
  burlywood: 14596231,
  cadetblue: 6266528,
  chartreuse: 8388352,
  chocolate: 13789470,
  coral: 16744272,
  cornflowerblue: 6591981,
  cornsilk: 16775388,
  crimson: 14423100,
  cyan: 65535,
  darkblue: 139,
  darkcyan: 35723,
  darkgoldenrod: 12092939,
  darkgray: 11119017,
  darkgreen: 25600,
  darkgrey: 11119017,
  darkkhaki: 12433259,
  darkmagenta: 9109643,
  darkolivegreen: 5597999,
  darkorange: 16747520,
  darkorchid: 10040012,
  darkred: 9109504,
  darksalmon: 15308410,
  darkseagreen: 9419919,
  darkslateblue: 4734347,
  darkslategray: 3100495,
  darkslategrey: 3100495,
  darkturquoise: 52945,
  darkviolet: 9699539,
  deeppink: 16716947,
  deepskyblue: 49151,
  dimgray: 6908265,
  dimgrey: 6908265,
  dodgerblue: 2003199,
  firebrick: 11674146,
  floralwhite: 16775920,
  forestgreen: 2263842,
  fuchsia: 16711935,
  gainsboro: 14474460,
  ghostwhite: 16316671,
  gold: 16766720,
  goldenrod: 14329120,
  gray: 8421504,
  green: 32768,
  greenyellow: 11403055,
  grey: 8421504,
  honeydew: 15794160,
  hotpink: 16738740,
  indianred: 13458524,
  indigo: 4915330,
  ivory: 16777200,
  khaki: 15787660,
  lavender: 15132410,
  lavenderblush: 16773365,
  lawngreen: 8190976,
  lemonchiffon: 16775885,
  lightblue: 11393254,
  lightcoral: 15761536,
  lightcyan: 14745599,
  lightgoldenrodyellow: 16448210,
  lightgray: 13882323,
  lightgreen: 9498256,
  lightgrey: 13882323,
  lightpink: 16758465,
  lightsalmon: 16752762,
  lightseagreen: 2142890,
  lightskyblue: 8900346,
  lightslategray: 7833753,
  lightslategrey: 7833753,
  lightsteelblue: 11584734,
  lightyellow: 16777184,
  lime: 65280,
  limegreen: 3329330,
  linen: 16445670,
  magenta: 16711935,
  maroon: 8388608,
  mediumaquamarine: 6737322,
  mediumblue: 205,
  mediumorchid: 12211667,
  mediumpurple: 9662683,
  mediumseagreen: 3978097,
  mediumslateblue: 8087790,
  mediumspringgreen: 64154,
  mediumturquoise: 4772300,
  mediumvioletred: 13047173,
  midnightblue: 1644912,
  mintcream: 16121850,
  mistyrose: 16770273,
  moccasin: 16770229,
  navajowhite: 16768685,
  navy: 128,
  oldlace: 16643558,
  olive: 8421376,
  olivedrab: 7048739,
  orange: 16753920,
  orangered: 16729344,
  orchid: 14315734,
  palegoldenrod: 15657130,
  palegreen: 10025880,
  paleturquoise: 11529966,
  palevioletred: 14381203,
  papayawhip: 16773077,
  peachpuff: 16767673,
  peru: 13468991,
  pink: 16761035,
  plum: 14524637,
  powderblue: 11591910,
  purple: 8388736,
  rebeccapurple: 6697881,
  red: 16711680,
  rosybrown: 12357519,
  royalblue: 4286945,
  saddlebrown: 9127187,
  salmon: 16416882,
  sandybrown: 16032864,
  seagreen: 3050327,
  seashell: 16774638,
  sienna: 10506797,
  silver: 12632256,
  skyblue: 8900331,
  slateblue: 6970061,
  slategray: 7372944,
  slategrey: 7372944,
  snow: 16775930,
  springgreen: 65407,
  steelblue: 4620980,
  tan: 13808780,
  teal: 32896,
  thistle: 14204888,
  tomato: 16737095,
  turquoise: 4251856,
  violet: 15631086,
  wheat: 16113331,
  white: 16777215,
  whitesmoke: 16119285,
  yellow: 16776960,
  yellowgreen: 10145074
};
var Tv = {
  h: 0,
  s: 0,
  l: 0
};
var Ev = {
  h: 0,
  s: 0,
  l: 0
};
function Dv(e, t, n) {
  if (n < 0) {
    n += 1;
  }
  if (n > 1) {
    --n;
  }
  if (n < 1 / 6) {
    return e + (t - e) * 6 * n;
  } else if (n < 1 / 2) {
    return t;
  } else if (n < 2 / 3) {
    return e + (t - e) * 6 * (2 / 3 - n);
  } else {
    return e;
  }
}
var Ov = class {
  constructor(e, t, n) {
    this.isColor = true;
    this.r = 1;
    this.g = 1;
    this.b = 1;
    return this.set(e, t, n);
  }
  set(e, t, n) {
    if (t === undefined && n === undefined) {
      let t = e;
      if (t && t.isColor) {
        this.copy(t);
      } else if (typeof t == `number`) {
        this.setHex(t);
      } else if (typeof t == `string`) {
        this.setStyle(t);
      }
    } else {
      this.setRGB(e, t, n);
    }
    return this;
  }
  setScalar(e) {
    this.r = e;
    this.g = e;
    this.b = e;
    return this;
  }
  setHex(e, t = kg) {
    e = Math.floor(e);
    this.r = (e >> 16 & 255) / 255;
    this.g = (e >> 8 & 255) / 255;
    this.b = (e & 255) / 255;
    j_.colorSpaceToWorking(this, t);
    return this;
  }
  setRGB(e, t, n, r = j_.workingColorSpace) {
    this.r = e;
    this.g = t;
    this.b = n;
    j_.colorSpaceToWorking(this, r);
    return this;
  }
  setHSL(e, t, n, r = j_.workingColorSpace) {
    e = t_(e, 1);
    t = e_(t, 0, 1);
    n = e_(n, 0, 1);
    if (t === 0) {
      this.r = this.g = this.b = n;
    } else {
      let r = n <= 0.5 ? n * (1 + t) : n + t - n * t;
      let i = n * 2 - r;
      this.r = Dv(i, r, e + 1 / 3);
      this.g = Dv(i, r, e);
      this.b = Dv(i, r, e - 1 / 3);
    }
    j_.colorSpaceToWorking(this, r);
    return this;
  }
  setStyle(e, t = kg) {
    function n(t) {
      if (t !== undefined && parseFloat(t) < 1) {
        Ug(`Color: Alpha component of ${e} will be ignored.`);
      }
    }
    let r;
    if (r = /^(\w+)\(([^\)]*)\)/.exec(e)) {
      let i;
      let a = r[1];
      let o = r[2];
      switch (a) {
        case `rgb`:
        case `rgba`:
          if (i = /^\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*(?:,\s*(\d*\.?\d+)\s*)?$/.exec(o)) {
            n(i[4]);
            return this.setRGB(Math.min(255, parseInt(i[1], 10)) / 255, Math.min(255, parseInt(i[2], 10)) / 255, Math.min(255, parseInt(i[3], 10)) / 255, t);
          }
          if (i = /^\s*(\d+)\%\s*,\s*(\d+)\%\s*,\s*(\d+)\%\s*(?:,\s*(\d*\.?\d+)\s*)?$/.exec(o)) {
            n(i[4]);
            return this.setRGB(Math.min(100, parseInt(i[1], 10)) / 100, Math.min(100, parseInt(i[2], 10)) / 100, Math.min(100, parseInt(i[3], 10)) / 100, t);
          }
          break;
        case `hsl`:
        case `hsla`:
          if (i = /^\s*(\d*\.?\d+)\s*,\s*(\d*\.?\d+)\%\s*,\s*(\d*\.?\d+)\%\s*(?:,\s*(\d*\.?\d+)\s*)?$/.exec(o)) {
            n(i[4]);
            return this.setHSL(parseFloat(i[1]) / 360, parseFloat(i[2]) / 100, parseFloat(i[3]) / 100, t);
          }
          break;
        default:
          Ug(`Color: Unknown color model ${e}`);
      }
    } else if (r = /^\#([A-Fa-f\d]+)$/.exec(e)) {
      let n = r[1];
      let i = n.length;
      if (i === 3) {
        return this.setRGB(parseInt(n.charAt(0), 16) / 15, parseInt(n.charAt(1), 16) / 15, parseInt(n.charAt(2), 16) / 15, t);
      }
      if (i === 6) {
        return this.setHex(parseInt(n, 16), t);
      }
      Ug(`Color: Invalid hex color ${e}`);
    } else if (e && e.length > 0) {
      return this.setColorName(e, t);
    }
    return this;
  }
  setColorName(e, t = kg) {
    let n = wv[e.toLowerCase()];
    if (n === undefined) {
      Ug(`Color: Unknown color ${e}`);
    } else {
      this.setHex(n, t);
    }
    return this;
  }
  clone() {
    return new this.constructor(this.r, this.g, this.b);
  }
  copy(e) {
    this.r = e.r;
    this.g = e.g;
    this.b = e.b;
    return this;
  }
  copySRGBToLinear(e) {
    this.r = M_(e.r);
    this.g = M_(e.g);
    this.b = M_(e.b);
    return this;
  }
  copyLinearToSRGB(e) {
    this.r = N_(e.r);
    this.g = N_(e.g);
    this.b = N_(e.b);
    return this;
  }
  convertSRGBToLinear() {
    this.copySRGBToLinear(this);
    return this;
  }
  convertLinearToSRGB() {
    this.copyLinearToSRGB(this);
    return this;
  }
  getHex(e = kg) {
    j_.workingToColorSpace(kv.copy(this), e);
    return Math.round(e_(kv.r * 255, 0, 255)) * 65536 + Math.round(e_(kv.g * 255, 0, 255)) * 256 + Math.round(e_(kv.b * 255, 0, 255));
  }
  getHexString(e = kg) {
    return `000000${this.getHex(e).toString(16)}`.slice(-6);
  }
  getHSL(e, t = j_.workingColorSpace) {
    j_.workingToColorSpace(kv.copy(this), t);
    let n = kv.r;
    let r = kv.g;
    let i = kv.b;
    let a = Math.max(n, r, i);
    let o = Math.min(n, r, i);
    let s;
    let c;
    let l = (o + a) / 2;
    if (o === a) {
      s = 0;
      c = 0;
    } else {
      let e = a - o;
      c = l <= 0.5 ? e / (a + o) : e / (2 - a - o);
      switch (a) {
        case n:
          s = (r - i) / e + (r < i ? 6 : 0);
          break;
        case r:
          s = (i - n) / e + 2;
          break;
        case i:
          s = (n - r) / e + 4;
      }
      s /= 6;
    }
    e.h = s;
    e.s = c;
    e.l = l;
    return e;
  }
  getRGB(e, t = j_.workingColorSpace) {
    j_.workingToColorSpace(kv.copy(this), t);
    e.r = kv.r;
    e.g = kv.g;
    e.b = kv.b;
    return e;
  }
  getStyle(e = kg) {
    j_.workingToColorSpace(kv.copy(this), e);
    let t = kv.r;
    let n = kv.g;
    let r = kv.b;
    if (e === `srgb`) {
      return `rgb(${Math.round(t * 255)},${Math.round(n * 255)},${Math.round(r * 255)})`;
    } else {
      return `color(${e} ${t.toFixed(3)} ${n.toFixed(3)} ${r.toFixed(3)})`;
    }
  }
  offsetHSL(e, t, n) {
    this.getHSL(Tv);
    return this.setHSL(Tv.h + e, Tv.s + t, Tv.l + n);
  }
  add(e) {
    this.r += e.r;
    this.g += e.g;
    this.b += e.b;
    return this;
  }
  addColors(e, t) {
    this.r = e.r + t.r;
    this.g = e.g + t.g;
    this.b = e.b + t.b;
    return this;
  }
  addScalar(e) {
    this.r += e;
    this.g += e;
    this.b += e;
    return this;
  }
  sub(e) {
    this.r = Math.max(0, this.r - e.r);
    this.g = Math.max(0, this.g - e.g);
    this.b = Math.max(0, this.b - e.b);
    return this;
  }
  multiply(e) {
    this.r *= e.r;
    this.g *= e.g;
    this.b *= e.b;
    return this;
  }
  multiplyScalar(e) {
    this.r *= e;
    this.g *= e;
    this.b *= e;
    return this;
  }
  lerp(e, t) {
    this.r += (e.r - this.r) * t;
    this.g += (e.g - this.g) * t;
    this.b += (e.b - this.b) * t;
    return this;
  }
  lerpColors(e, t, n) {
    this.r = e.r + (t.r - e.r) * n;
    this.g = e.g + (t.g - e.g) * n;
    this.b = e.b + (t.b - e.b) * n;
    return this;
  }
  lerpHSL(e, t) {
    this.getHSL(Tv);
    e.getHSL(Ev);
    let n = i_(Tv.h, Ev.h, t);
    let r = i_(Tv.s, Ev.s, t);
    let i = i_(Tv.l, Ev.l, t);
    this.setHSL(n, r, i);
    return this;
  }
  setFromVector3(e) {
    this.r = e.x;
    this.g = e.y;
    this.b = e.z;
    return this;
  }
  applyMatrix3(e) {
    let t = this.r;
    let n = this.g;
    let r = this.b;
    let i = e.elements;
    this.r = i[0] * t + i[3] * n + i[6] * r;
    this.g = i[1] * t + i[4] * n + i[7] * r;
    this.b = i[2] * t + i[5] * n + i[8] * r;
    return this;
  }
  equals(e) {
    return e.r === this.r && e.g === this.g && e.b === this.b;
  }
  fromArray(e, t = 0) {
    this.r = e[t];
    this.g = e[t + 1];
    this.b = e[t + 2];
    return this;
  }
  toArray(e = [], t = 0) {
    e[t] = this.r;
    e[t + 1] = this.g;
    e[t + 2] = this.b;
    return e;
  }
  fromBufferAttribute(e, t) {
    this.r = e.getX(t);
    this.g = e.getY(t);
    this.b = e.getZ(t);
    return this;
  }
  toJSON() {
    return this.getHex();
  }
  *[Symbol.iterator]() {
    yield this.r;
    yield this.g;
    yield this.b;
  }
};
var kv = new Ov();
Ov.NAMES = wv;
var Av = class extends bv {
  constructor() {
    super();
    this.isScene = true;
    this.type = `Scene`;
    this.background = null;
    this.environment = null;
    this.fog = null;
    this.backgroundBlurriness = 0;
    this.backgroundIntensity = 1;
    this.backgroundRotation = new rv();
    this.environmentIntensity = 1;
    this.environmentRotation = new rv();
    this.overrideMaterial = null;
    if (typeof __THREE_DEVTOOLS__ < `u`) {
      __THREE_DEVTOOLS__.dispatchEvent(new CustomEvent(`observe`, {
        detail: this
      }));
    }
  }
  copy(e, t) {
    super.copy(e, t);
    if (e.background !== null) {
      this.background = e.background.clone();
    }
    if (e.environment !== null) {
      this.environment = e.environment.clone();
    }
    if (e.fog !== null) {
      this.fog = e.fog.clone();
    }
    this.backgroundBlurriness = e.backgroundBlurriness;
    this.backgroundIntensity = e.backgroundIntensity;
    this.backgroundRotation.copy(e.backgroundRotation);
    this.environmentIntensity = e.environmentIntensity;
    this.environmentRotation.copy(e.environmentRotation);
    if (e.overrideMaterial !== null) {
      this.overrideMaterial = e.overrideMaterial.clone();
    }
    this.matrixAutoUpdate = e.matrixAutoUpdate;
    return this;
  }
  toJSON(e) {
    let t = super.toJSON(e);
    if (this.fog !== null) {
      t.object.fog = this.fog.toJSON();
    }
    t.object.backgroundBlurriness = this.backgroundBlurriness;
    t.object.backgroundIntensity = this.backgroundIntensity;
    t.object.backgroundRotation = this.backgroundRotation.toArray();
    t.object.environmentIntensity = this.environmentIntensity;
    t.object.environmentRotation = this.environmentRotation.toArray();
    return t;
  }
};
var jv = new X();
var Mv = new X();
var Nv = new X();
var Pv = new X();
var Fv = new X();
var Iv = new X();
var Lv = new X();
var Rv = new X();
var zv = new X();
var Bv = new X();
var Vv = new H_();
var Hv = new H_();
var Uv = new H_();
var Wv = class e {
  constructor(e = new X(), t = new X(), n = new X()) {
    this.a = e;
    this.b = t;
    this.c = n;
  }
  static getNormal(e, t, n, r) {
    r.subVectors(n, t);
    jv.subVectors(e, t);
    r.cross(jv);
    let i = r.lengthSq();
    if (i > 0) {
      return r.multiplyScalar(1 / Math.sqrt(i));
    } else {
      return r.set(0, 0, 0);
    }
  }
  static getBarycoord(e, t, n, r, i) {
    jv.subVectors(r, t);
    Mv.subVectors(n, t);
    Nv.subVectors(e, t);
    let a = jv.dot(jv);
    let o = jv.dot(Mv);
    let s = jv.dot(Nv);
    let c = Mv.dot(Mv);
    let l = Mv.dot(Nv);
    let u = a * c - o * o;
    if (u === 0) {
      i.set(0, 0, 0);
      return null;
    }
    let d = 1 / u;
    let f = (c * s - o * l) * d;
    let p = (a * l - o * s) * d;
    return i.set(1 - f - p, p, f);
  }
  static containsPoint(e, t, n, r) {
    return this.getBarycoord(e, t, n, r, Pv) !== null && Pv.x >= 0 && Pv.y >= 0 && Pv.x + Pv.y <= 1;
  }
  static getInterpolation(e, t, n, r, i, a, o, s) {
    if (this.getBarycoord(e, t, n, r, Pv) === null) {
      s.x = 0;
      s.y = 0;
      if (`z` in s) {
        s.z = 0;
      }
      if (`w` in s) {
        s.w = 0;
      }
      return null;
    } else {
      s.setScalar(0);
      s.addScaledVector(i, Pv.x);
      s.addScaledVector(a, Pv.y);
      s.addScaledVector(o, Pv.z);
      return s;
    }
  }
  static getInterpolatedAttribute(e, t, n, r, i, a) {
    Vv.setScalar(0);
    Hv.setScalar(0);
    Uv.setScalar(0);
    Vv.fromBufferAttribute(e, t);
    Hv.fromBufferAttribute(e, n);
    Uv.fromBufferAttribute(e, r);
    a.setScalar(0);
    a.addScaledVector(Vv, i.x);
    a.addScaledVector(Hv, i.y);
    a.addScaledVector(Uv, i.z);
    return a;
  }
  static isFrontFacing(e, t, n, r) {
    jv.subVectors(n, t);
    Mv.subVectors(e, t);
    return jv.cross(Mv).dot(r) < 0;
  }
  set(e, t, n) {
    this.a.copy(e);
    this.b.copy(t);
    this.c.copy(n);
    return this;
  }
  setFromPointsAndIndices(e, t, n, r) {
    this.a.copy(e[t]);
    this.b.copy(e[n]);
    this.c.copy(e[r]);
    return this;
  }
  setFromAttributeAndIndices(e, t, n, r) {
    this.a.fromBufferAttribute(e, t);
    this.b.fromBufferAttribute(e, n);
    this.c.fromBufferAttribute(e, r);
    return this;
  }
  clone() {
    return new this.constructor().copy(this);
  }
  copy(e) {
    this.a.copy(e.a);
    this.b.copy(e.b);
    this.c.copy(e.c);
    return this;
  }
  getArea() {
    jv.subVectors(this.c, this.b);
    Mv.subVectors(this.a, this.b);
    return jv.cross(Mv).length() * 0.5;
  }
  getMidpoint(e) {
    return e.addVectors(this.a, this.b).add(this.c).multiplyScalar(1 / 3);
  }
  getNormal(t) {
    return e.getNormal(this.a, this.b, this.c, t);
  }
  getPlane(e) {
    return e.setFromCoplanarPoints(this.a, this.b, this.c);
  }
  getBarycoord(t, n) {
    return e.getBarycoord(t, this.a, this.b, this.c, n);
  }
  getInterpolation(t, n, r, i, a) {
    return e.getInterpolation(t, this.a, this.b, this.c, n, r, i, a);
  }
  containsPoint(t) {
    return e.containsPoint(t, this.a, this.b, this.c);
  }
  isFrontFacing(t) {
    return e.isFrontFacing(this.a, this.b, this.c, t);
  }
  intersectsBox(e) {
    return e.intersectsTriangle(this);
  }
  closestPointToPoint(e, t) {
    let n = this.a;
    let r = this.b;
    let i = this.c;
    let a;
    let o;
    Fv.subVectors(r, n);
    Iv.subVectors(i, n);
    Rv.subVectors(e, n);
    let s = Fv.dot(Rv);
    let c = Iv.dot(Rv);
    if (s <= 0 && c <= 0) {
      return t.copy(n);
    }
    zv.subVectors(e, r);
    let l = Fv.dot(zv);
    let u = Iv.dot(zv);
    if (l >= 0 && u <= l) {
      return t.copy(r);
    }
    let d = s * u - l * c;
    if (d <= 0 && s >= 0 && l <= 0) {
      a = s / (s - l);
      return t.copy(n).addScaledVector(Fv, a);
    }
    Bv.subVectors(e, i);
    let f = Fv.dot(Bv);
    let p = Iv.dot(Bv);
    if (p >= 0 && f <= p) {
      return t.copy(i);
    }
    let m = f * c - s * p;
    if (m <= 0 && c >= 0 && p <= 0) {
      o = c / (c - p);
      return t.copy(n).addScaledVector(Iv, o);
    }
    let h = l * p - f * u;
    if (h <= 0 && u - l >= 0 && f - p >= 0) {
      Lv.subVectors(i, r);
      o = (u - l) / (u - l + (f - p));
      return t.copy(r).addScaledVector(Lv, o);
    }
    let g = 1 / (h + m + d);
    a = m * g;
    o = d * g;
    return t.copy(n).addScaledVector(Fv, a).addScaledVector(Iv, o);
  }
  equals(e) {
    return e.a.equals(this.a) && e.b.equals(this.b) && e.c.equals(this.c);
  }
};
var Gv = class {
  constructor(e = new X(Infinity, Infinity, Infinity), t = new X(-Infinity, -Infinity, -Infinity)) {
    this.isBox3 = true;
    this.min = e;
    this.max = t;
  }
  set(e, t) {
    this.min.copy(e);
    this.max.copy(t);
    return this;
  }
  setFromArray(e) {
    this.makeEmpty();
    for (let t = 0, n = e.length; t < n; t += 3) {
      this.expandByPoint(qv.fromArray(e, t));
    }
    return this;
  }
  setFromBufferAttribute(e) {
    this.makeEmpty();
    for (let t = 0, n = e.count; t < n; t++) {
      this.expandByPoint(qv.fromBufferAttribute(e, t));
    }
    return this;
  }
  setFromPoints(e) {
    this.makeEmpty();
    for (let t = 0, n = e.length; t < n; t++) {
      this.expandByPoint(e[t]);
    }
    return this;
  }
  setFromCenterAndSize(e, t) {
    let n = qv.copy(t).multiplyScalar(0.5);
    this.min.copy(e).sub(n);
    this.max.copy(e).add(n);
    return this;
  }
  setFromObject(e, t = false) {
    this.makeEmpty();
    return this.expandByObject(e, t);
  }
  clone() {
    return new this.constructor().copy(this);
  }
  copy(e) {
    this.min.copy(e.min);
    this.max.copy(e.max);
    return this;
  }
  makeEmpty() {
    this.min.x = this.min.y = this.min.z = Infinity;
    this.max.x = this.max.y = this.max.z = -Infinity;
    return this;
  }
  isEmpty() {
    return this.max.x < this.min.x || this.max.y < this.min.y || this.max.z < this.min.z;
  }
  getCenter(e) {
    if (this.isEmpty()) {
      return e.set(0, 0, 0);
    } else {
      return e.addVectors(this.min, this.max).multiplyScalar(0.5);
    }
  }
  getSize(e) {
    if (this.isEmpty()) {
      return e.set(0, 0, 0);
    } else {
      return e.subVectors(this.max, this.min);
    }
  }
  expandByPoint(e) {
    this.min.min(e);
    this.max.max(e);
    return this;
  }
  expandByVector(e) {
    this.min.sub(e);
    this.max.add(e);
    return this;
  }
  expandByScalar(e) {
    this.min.addScalar(-e);
    this.max.addScalar(e);
    return this;
  }
  expandByObject(e, t = false) {
    e.updateWorldMatrix(false, false);
    let n = e.geometry;
    if (n !== undefined) {
      let r = n.getAttribute(`position`);
      if (t === true && r !== undefined && e.isInstancedMesh !== true) {
        for (let t = 0, n = r.count; t < n; t++) {
          if (e.isMesh === true) {
            e.getVertexPosition(t, qv);
          } else {
            qv.fromBufferAttribute(r, t);
          }
          qv.applyMatrix4(e.matrixWorld);
          this.expandByPoint(qv);
        }
      } else {
        if (e.boundingBox === undefined) {
          if (n.boundingBox === null) {
            n.computeBoundingBox();
          }
          Jv.copy(n.boundingBox);
        } else {
          if (e.boundingBox === null) {
            e.computeBoundingBox();
          }
          Jv.copy(e.boundingBox);
        }
        Jv.applyMatrix4(e.matrixWorld);
        this.union(Jv);
      }
    }
    let r = e.children;
    for (let e = 0, n = r.length; e < n; e++) {
      this.expandByObject(r[e], t);
    }
    return this;
  }
  containsPoint(e) {
    return e.x >= this.min.x && e.x <= this.max.x && e.y >= this.min.y && e.y <= this.max.y && e.z >= this.min.z && e.z <= this.max.z;
  }
  containsBox(e) {
    return this.min.x <= e.min.x && e.max.x <= this.max.x && this.min.y <= e.min.y && e.max.y <= this.max.y && this.min.z <= e.min.z && e.max.z <= this.max.z;
  }
  getParameter(e, t) {
    return t.set((e.x - this.min.x) / (this.max.x - this.min.x), (e.y - this.min.y) / (this.max.y - this.min.y), (e.z - this.min.z) / (this.max.z - this.min.z));
  }
  intersectsBox(e) {
    return e.max.x >= this.min.x && e.min.x <= this.max.x && e.max.y >= this.min.y && e.min.y <= this.max.y && e.max.z >= this.min.z && e.min.z <= this.max.z;
  }
  intersectsSphere(e) {
    this.clampPoint(e.center, qv);
    return qv.distanceToSquared(e.center) <= e.radius * e.radius;
  }
  intersectsPlane(e) {
    let t;
    let n;
    if (e.normal.x > 0) {
      t = e.normal.x * this.min.x;
      n = e.normal.x * this.max.x;
    } else {
      t = e.normal.x * this.max.x;
      n = e.normal.x * this.min.x;
    }
    if (e.normal.y > 0) {
      t += e.normal.y * this.min.y;
      n += e.normal.y * this.max.y;
    } else {
      t += e.normal.y * this.max.y;
      n += e.normal.y * this.min.y;
    }
    if (e.normal.z > 0) {
      t += e.normal.z * this.min.z;
      n += e.normal.z * this.max.z;
    } else {
      t += e.normal.z * this.max.z;
      n += e.normal.z * this.min.z;
    }
    return t <= -e.constant && n >= -e.constant;
  }
  intersectsTriangle(e) {
    if (this.isEmpty()) {
      return false;
    }
    this.getCenter(ty);
    ny.subVectors(this.max, ty);
    Yv.subVectors(e.a, ty);
    Xv.subVectors(e.b, ty);
    Zv.subVectors(e.c, ty);
    Qv.subVectors(Xv, Yv);
    $v.subVectors(Zv, Xv);
    ey.subVectors(Yv, Zv);
    let t = [0, -Qv.z, Qv.y, 0, -$v.z, $v.y, 0, -ey.z, ey.y, Qv.z, 0, -Qv.x, $v.z, 0, -$v.x, ey.z, 0, -ey.x, -Qv.y, Qv.x, 0, -$v.y, $v.x, 0, -ey.y, ey.x, 0];
    if (!ay(t, Yv, Xv, Zv, ny) || (t = [1, 0, 0, 0, 1, 0, 0, 0, 1], !ay(t, Yv, Xv, Zv, ny))) {
      return false;
    } else {
      ry.crossVectors(Qv, $v);
      t = [ry.x, ry.y, ry.z];
      return ay(t, Yv, Xv, Zv, ny);
    }
  }
  clampPoint(e, t) {
    return t.copy(e).clamp(this.min, this.max);
  }
  distanceToPoint(e) {
    return this.clampPoint(e, qv).distanceTo(e);
  }
  getBoundingSphere(e) {
    if (this.isEmpty()) {
      e.makeEmpty();
    } else {
      this.getCenter(e.center);
      e.radius = this.getSize(qv).length() * 0.5;
    }
    return e;
  }
  intersect(e) {
    this.min.max(e.min);
    this.max.min(e.max);
    if (this.isEmpty()) {
      this.makeEmpty();
    }
    return this;
  }
  union(e) {
    this.min.min(e.min);
    this.max.max(e.max);
    return this;
  }
  applyMatrix4(e) {
    if (this.isEmpty()) {
      return this;
    } else {
      Kv[0].set(this.min.x, this.min.y, this.min.z).applyMatrix4(e);
      Kv[1].set(this.min.x, this.min.y, this.max.z).applyMatrix4(e);
      Kv[2].set(this.min.x, this.max.y, this.min.z).applyMatrix4(e);
      Kv[3].set(this.min.x, this.max.y, this.max.z).applyMatrix4(e);
      Kv[4].set(this.max.x, this.min.y, this.min.z).applyMatrix4(e);
      Kv[5].set(this.max.x, this.min.y, this.max.z).applyMatrix4(e);
      Kv[6].set(this.max.x, this.max.y, this.min.z).applyMatrix4(e);
      Kv[7].set(this.max.x, this.max.y, this.max.z).applyMatrix4(e);
      this.setFromPoints(Kv);
      return this;
    }
  }
  translate(e) {
    this.min.add(e);
    this.max.add(e);
    return this;
  }
  equals(e) {
    return e.min.equals(this.min) && e.max.equals(this.max);
  }
  toJSON() {
    return {
      min: this.min.toArray(),
      max: this.max.toArray()
    };
  }
  fromJSON(e) {
    this.min.fromArray(e.min);
    this.max.fromArray(e.max);
    return this;
  }
};
var Kv = [new X(), new X(), new X(), new X(), new X(), new X(), new X(), new X()];
var qv = new X();
var Jv = new Gv();
var Yv = new X();
var Xv = new X();
var Zv = new X();
var Qv = new X();
var $v = new X();
var ey = new X();
var ty = new X();
var ny = new X();
var ry = new X();
var iy = new X();
function ay(e, t, n, r, i) {
  for (let a = 0, o = e.length - 3; a <= o; a += 3) {
    iy.fromArray(e, a);
    let o = i.x * Math.abs(iy.x) + i.y * Math.abs(iy.y) + i.z * Math.abs(iy.z);
    let s = t.dot(iy);
    let c = n.dot(iy);
    let l = r.dot(iy);
    if (Math.max(-Math.max(s, c, l), Math.min(s, c, l)) > o) {
      return false;
    }
  }
  return true;
}
var oy = new X();
var sy = new S_();
var cy = 0;
var ly = class extends Jg {
  constructor(e, t, n = false) {
    super();
    if (Array.isArray(e)) {
      throw TypeError(`THREE.BufferAttribute: array should be a Typed Array.`);
    }
    this.isBufferAttribute = true;
    Object.defineProperty(this, "id", {
      value: cy++
    });
    this.name = ``;
    this.array = e;
    this.itemSize = t;
    this.count = e === undefined ? 0 : e.length / t;
    this.normalized = n;
    this.usage = Pg;
    this.updateRanges = [];
    this.gpuType = Sh;
    this.version = 0;
  }
  onUploadCallback() {}
  set needsUpdate(e) {
    if (e === true) {
      this.version++;
    }
  }
  setUsage(e) {
    this.usage = e;
    return this;
  }
  addUpdateRange(e, t) {
    this.updateRanges.push({
      start: e,
      count: t
    });
  }
  clearUpdateRanges() {
    this.updateRanges.length = 0;
  }
  copy(e) {
    this.name = e.name;
    this.array = new e.array.constructor(e.array);
    this.itemSize = e.itemSize;
    this.count = e.count;
    this.normalized = e.normalized;
    this.usage = e.usage;
    this.gpuType = e.gpuType;
    return this;
  }
  copyAt(e, t, n) {
    e *= this.itemSize;
    n *= t.itemSize;
    for (let r = 0, i = this.itemSize; r < i; r++) {
      this.array[e + r] = t.array[n + r];
    }
    return this;
  }
  copyArray(e) {
    this.array.set(e);
    return this;
  }
  applyMatrix3(e) {
    if (this.itemSize === 2) {
      for (let t = 0, n = this.count; t < n; t++) {
        sy.fromBufferAttribute(this, t);
        sy.applyMatrix3(e);
        this.setXY(t, sy.x, sy.y);
      }
    } else if (this.itemSize === 3) {
      for (let t = 0, n = this.count; t < n; t++) {
        oy.fromBufferAttribute(this, t);
        oy.applyMatrix3(e);
        this.setXYZ(t, oy.x, oy.y, oy.z);
      }
    }
    return this;
  }
  applyMatrix4(e) {
    for (let t = 0, n = this.count; t < n; t++) {
      oy.fromBufferAttribute(this, t);
      oy.applyMatrix4(e);
      this.setXYZ(t, oy.x, oy.y, oy.z);
    }
    return this;
  }
  applyNormalMatrix(e) {
    for (let t = 0, n = this.count; t < n; t++) {
      oy.fromBufferAttribute(this, t);
      oy.applyNormalMatrix(e);
      this.setXYZ(t, oy.x, oy.y, oy.z);
    }
    return this;
  }
  transformDirection(e) {
    for (let t = 0, n = this.count; t < n; t++) {
      oy.fromBufferAttribute(this, t);
      oy.transformDirection(e);
      this.setXYZ(t, oy.x, oy.y, oy.z);
    }
    return this;
  }
  set(e, t = 0) {
    this.array.set(e, t);
    return this;
  }
  getComponent(e, t) {
    let n = this.array[e * this.itemSize + t];
    if (this.normalized) {
      n = y_(n, this.array);
    }
    return n;
  }
  setComponent(e, t, n) {
    if (this.normalized) {
      n = b_(n, this.array);
    }
    this.array[e * this.itemSize + t] = n;
    return this;
  }
  getX(e) {
    let t = this.array[e * this.itemSize];
    if (this.normalized) {
      t = y_(t, this.array);
    }
    return t;
  }
  setX(e, t) {
    if (this.normalized) {
      t = b_(t, this.array);
    }
    this.array[e * this.itemSize] = t;
    return this;
  }
  getY(e) {
    let t = this.array[e * this.itemSize + 1];
    if (this.normalized) {
      t = y_(t, this.array);
    }
    return t;
  }
  setY(e, t) {
    if (this.normalized) {
      t = b_(t, this.array);
    }
    this.array[e * this.itemSize + 1] = t;
    return this;
  }
  getZ(e) {
    let t = this.array[e * this.itemSize + 2];
    if (this.normalized) {
      t = y_(t, this.array);
    }
    return t;
  }
  setZ(e, t) {
    if (this.normalized) {
      t = b_(t, this.array);
    }
    this.array[e * this.itemSize + 2] = t;
    return this;
  }
  getW(e) {
    let t = this.array[e * this.itemSize + 3];
    if (this.normalized) {
      t = y_(t, this.array);
    }
    return t;
  }
  setW(e, t) {
    if (this.normalized) {
      t = b_(t, this.array);
    }
    this.array[e * this.itemSize + 3] = t;
    return this;
  }
  setXY(e, t, n) {
    e *= this.itemSize;
    if (this.normalized) {
      t = b_(t, this.array);
      n = b_(n, this.array);
    }
    this.array[e + 0] = t;
    this.array[e + 1] = n;
    return this;
  }
  setXYZ(e, t, n, r) {
    e *= this.itemSize;
    if (this.normalized) {
      t = b_(t, this.array);
      n = b_(n, this.array);
      r = b_(r, this.array);
    }
    this.array[e + 0] = t;
    this.array[e + 1] = n;
    this.array[e + 2] = r;
    return this;
  }
  setXYZW(e, t, n, r, i) {
    e *= this.itemSize;
    if (this.normalized) {
      t = b_(t, this.array);
      n = b_(n, this.array);
      r = b_(r, this.array);
      i = b_(i, this.array);
    }
    this.array[e + 0] = t;
    this.array[e + 1] = n;
    this.array[e + 2] = r;
    this.array[e + 3] = i;
    return this;
  }
  onUpload(e) {
    this.onUploadCallback = e;
    return this;
  }
  clone() {
    return new this.constructor(this.array, this.itemSize).copy(this);
  }
  toJSON() {
    let e = {
      itemSize: this.itemSize,
      type: this.array.constructor.name,
      array: Array.from(this.array),
      normalized: this.normalized
    };
    e.name = this.name;
    e.usage = this.usage;
    e.gpuType = this.gpuType;
    return e;
  }
  dispose() {
    this.dispatchEvent({
      type: `dispose`
    });
  }
};
var uy = class extends ly {
  constructor(e, t, n) {
    super(new Uint16Array(e), t, n);
  }
};
var dy = class extends ly {
  constructor(e, t, n) {
    super(new Uint32Array(e), t, n);
  }
};
var fy = class extends ly {
  constructor(e, t, n) {
    super(new Float32Array(e), t, n);
  }
};
var py = new Gv();
var my = new X();
var hy = new X();
var gy = class {
  constructor(e = new X(), t = -1) {
    this.isSphere = true;
    this.center = e;
    this.radius = t;
  }
  set(e, t) {
    this.center.copy(e);
    this.radius = t;
    return this;
  }
  setFromPoints(e, t) {
    let n = this.center;
    if (t === undefined) {
      py.setFromPoints(e).getCenter(n);
    } else {
      n.copy(t);
    }
    let r = 0;
    for (let t = 0, i = e.length; t < i; t++) {
      r = Math.max(r, n.distanceToSquared(e[t]));
    }
    this.radius = Math.sqrt(r);
    return this;
  }
  copy(e) {
    this.center.copy(e.center);
    this.radius = e.radius;
    return this;
  }
  isEmpty() {
    return this.radius < 0;
  }
  makeEmpty() {
    this.center.set(0, 0, 0);
    this.radius = -1;
    return this;
  }
  containsPoint(e) {
    return e.distanceToSquared(this.center) <= this.radius * this.radius;
  }
  distanceToPoint(e) {
    return e.distanceTo(this.center) - this.radius;
  }
  intersectsSphere(e) {
    let t = this.radius + e.radius;
    return e.center.distanceToSquared(this.center) <= t * t;
  }
  intersectsBox(e) {
    return e.intersectsSphere(this);
  }
  intersectsPlane(e) {
    return Math.abs(e.distanceToPoint(this.center)) <= this.radius;
  }
  clampPoint(e, t) {
    let n = this.center.distanceToSquared(e);
    t.copy(e);
    if (n > this.radius * this.radius) {
      t.sub(this.center).normalize();
      t.multiplyScalar(this.radius).add(this.center);
    }
    return t;
  }
  getBoundingBox(e) {
    if (this.isEmpty()) {
      e.makeEmpty();
      return e;
    } else {
      e.set(this.center, this.center);
      e.expandByScalar(this.radius);
      return e;
    }
  }
  applyMatrix4(e) {
    this.center.applyMatrix4(e);
    this.radius *= e.getMaxScaleOnAxis();
    return this;
  }
  translate(e) {
    this.center.add(e);
    return this;
  }
  expandByPoint(e) {
    if (this.isEmpty()) {
      this.center.copy(e);
      this.radius = 0;
      return this;
    }
    my.subVectors(e, this.center);
    let t = my.lengthSq();
    if (t > this.radius * this.radius) {
      let e = Math.sqrt(t);
      let n = (e - this.radius) * 0.5;
      this.center.addScaledVector(my, n / e);
      this.radius += n;
    }
    return this;
  }
  union(e) {
    if (e.isEmpty()) {
      return this;
    } else if (this.isEmpty()) {
      this.copy(e);
      return this;
    } else {
      if (this.center.equals(e.center) === true) {
        this.radius = Math.max(this.radius, e.radius);
      } else {
        hy.subVectors(e.center, this.center).setLength(e.radius);
        this.expandByPoint(my.copy(e.center).add(hy));
        this.expandByPoint(my.copy(e.center).sub(hy));
      }
      return this;
    }
  }
  equals(e) {
    return e.center.equals(this.center) && e.radius === this.radius;
  }
  clone() {
    return new this.constructor().copy(this);
  }
  toJSON() {
    return {
      radius: this.radius,
      center: this.center.toArray()
    };
  }
  fromJSON(e) {
    this.radius = e.radius;
    this.center.fromArray(e.center);
    return this;
  }
};
var _y = 0;
var vy = new q_();
var yy = new bv();
var by = new X();
var xy = new Gv();
var Sy = new Gv();
var Cy = new X();
var wy = class e extends Jg {
  constructor() {
    super();
    this.isBufferGeometry = true;
    Object.defineProperty(this, "id", {
      value: _y++
    });
    this.uuid = $g();
    this.name = ``;
    this.type = `BufferGeometry`;
    this.index = null;
    this.indirect = null;
    this.indirectOffset = 0;
    this.attributes = {};
    this.morphAttributes = {};
    this.morphTargetsRelative = false;
    this.groups = [];
    this.boundingBox = null;
    this.boundingSphere = null;
    this.drawRange = {
      start: 0,
      count: Infinity
    };
    this.userData = {};
    this._transformed = false;
  }
  getIndex() {
    return this.index;
  }
  setIndex(e) {
    this.index = Array.isArray(e) ? new (Ig(e) ? dy : uy)(e, 1) : e;
    return this;
  }
  setIndirect(e, t = 0) {
    this.indirect = e;
    this.indirectOffset = t;
    return this;
  }
  getIndirect() {
    return this.indirect;
  }
  getAttribute(e) {
    return this.attributes[e];
  }
  setAttribute(e, t) {
    this.attributes[e] = t;
    return this;
  }
  deleteAttribute(e) {
    delete this.attributes[e];
    return this;
  }
  hasAttribute(e) {
    return this.attributes[e] !== undefined;
  }
  addGroup(e, t, n = 0) {
    this.groups.push({
      start: e,
      count: t,
      materialIndex: n
    });
  }
  clearGroups() {
    this.groups = [];
  }
  setDrawRange(e, t) {
    this.drawRange.start = e;
    this.drawRange.count = t;
  }
  applyMatrix4(e) {
    let t = this.attributes.position;
    if (t !== undefined) {
      t.applyMatrix4(e);
      t.needsUpdate = true;
    }
    let n = this.attributes.normal;
    if (n !== undefined) {
      let t = new E_().getNormalMatrix(e);
      n.applyNormalMatrix(t);
      n.needsUpdate = true;
    }
    let r = this.attributes.tangent;
    if (r !== undefined) {
      r.transformDirection(e);
      r.needsUpdate = true;
    }
    if (this.boundingBox !== null) {
      this.computeBoundingBox();
    }
    if (this.boundingSphere !== null) {
      this.computeBoundingSphere();
    }
    this._transformed = true;
    return this;
  }
  applyQuaternion(e) {
    vy.makeRotationFromQuaternion(e);
    this.applyMatrix4(vy);
    return this;
  }
  rotateX(e) {
    vy.makeRotationX(e);
    this.applyMatrix4(vy);
    return this;
  }
  rotateY(e) {
    vy.makeRotationY(e);
    this.applyMatrix4(vy);
    return this;
  }
  rotateZ(e) {
    vy.makeRotationZ(e);
    this.applyMatrix4(vy);
    return this;
  }
  translate(e, t, n) {
    vy.makeTranslation(e, t, n);
    this.applyMatrix4(vy);
    return this;
  }
  scale(e, t, n) {
    vy.makeScale(e, t, n);
    this.applyMatrix4(vy);
    return this;
  }
  lookAt(e) {
    yy.lookAt(e);
    yy.updateMatrix();
    this.applyMatrix4(yy.matrix);
    return this;
  }
  center() {
    this.computeBoundingBox();
    this.boundingBox.getCenter(by).negate();
    this.translate(by.x, by.y, by.z);
    return this;
  }
  setFromPoints(e) {
    let t = this.getAttribute(`position`);
    if (t === undefined) {
      let t = [];
      for (let n = 0, r = e.length; n < r; n++) {
        let r = e[n];
        t.push(r.x, r.y, r.z || 0);
      }
      this.setAttribute(`position`, new fy(t, 3));
    } else {
      let n = Math.min(e.length, t.count);
      for (let r = 0; r < n; r++) {
        let n = e[r];
        t.setXYZ(r, n.x, n.y, n.z || 0);
      }
      if (e.length > t.count) {
        Ug(`BufferGeometry: Buffer size too small for points data. Use .dispose() and create a new geometry.`);
      }
      t.needsUpdate = true;
    }
    return this;
  }
  computeBoundingBox() {
    if (this.boundingBox === null) {
      this.boundingBox = new Gv();
    }
    let e = this.attributes.position;
    let t = this.morphAttributes.position;
    if (e && e.isGLBufferAttribute) {
      Wg(`BufferGeometry.computeBoundingBox(): GLBufferAttribute requires a manual bounding box.`, this);
      this.boundingBox.set(new X(-Infinity, -Infinity, -Infinity), new X(Infinity, Infinity, Infinity));
      return;
    }
    if (e !== undefined) {
      this.boundingBox.setFromBufferAttribute(e);
      if (t) {
        for (let e = 0, n = t.length; e < n; e++) {
          let n = t[e];
          xy.setFromBufferAttribute(n);
          if (this.morphTargetsRelative) {
            Cy.addVectors(this.boundingBox.min, xy.min);
            this.boundingBox.expandByPoint(Cy);
            Cy.addVectors(this.boundingBox.max, xy.max);
            this.boundingBox.expandByPoint(Cy);
          } else {
            this.boundingBox.expandByPoint(xy.min);
            this.boundingBox.expandByPoint(xy.max);
          }
        }
      }
    } else {
      this.boundingBox.makeEmpty();
    }
    if (isNaN(this.boundingBox.min.x) || isNaN(this.boundingBox.min.y) || isNaN(this.boundingBox.min.z)) {
      Wg(`BufferGeometry.computeBoundingBox(): Computed min/max have NaN values. The "position" attribute is likely to have NaN values.`, this);
    }
  }
  computeBoundingSphere() {
    if (this.boundingSphere === null) {
      this.boundingSphere = new gy();
    }
    let e = this.attributes.position;
    let t = this.morphAttributes.position;
    if (e && e.isGLBufferAttribute) {
      Wg(`BufferGeometry.computeBoundingSphere(): GLBufferAttribute requires a manual bounding sphere.`, this);
      this.boundingSphere.set(new X(), Infinity);
      return;
    }
    if (e) {
      let n = this.boundingSphere.center;
      xy.setFromBufferAttribute(e);
      if (t) {
        for (let e = 0, n = t.length; e < n; e++) {
          let n = t[e];
          Sy.setFromBufferAttribute(n);
          if (this.morphTargetsRelative) {
            Cy.addVectors(xy.min, Sy.min);
            xy.expandByPoint(Cy);
            Cy.addVectors(xy.max, Sy.max);
            xy.expandByPoint(Cy);
          } else {
            xy.expandByPoint(Sy.min);
            xy.expandByPoint(Sy.max);
          }
        }
      }
      xy.getCenter(n);
      let r = 0;
      for (let t = 0, i = e.count; t < i; t++) {
        Cy.fromBufferAttribute(e, t);
        r = Math.max(r, n.distanceToSquared(Cy));
      }
      if (t) {
        for (let i = 0, a = t.length; i < a; i++) {
          let a = t[i];
          let o = this.morphTargetsRelative;
          for (let t = 0, i = a.count; t < i; t++) {
            Cy.fromBufferAttribute(a, t);
            if (o) {
              by.fromBufferAttribute(e, t);
              Cy.add(by);
            }
            r = Math.max(r, n.distanceToSquared(Cy));
          }
        }
      }
      this.boundingSphere.radius = Math.sqrt(r);
      if (isNaN(this.boundingSphere.radius)) {
        Wg(`BufferGeometry.computeBoundingSphere(): Computed radius is NaN. The "position" attribute is likely to have NaN values.`, this);
      }
    }
  }
  computeTangents() {
    let e = this.index;
    let t = this.attributes;
    if (e === null || t.position === undefined || t.normal === undefined || t.uv === undefined) {
      Wg(`BufferGeometry: .computeTangents() failed. Missing required attributes (index, position, normal or uv)`);
      return;
    }
    let n = t.position;
    let r = t.normal;
    let i = t.uv;
    let a = this.getAttribute(`tangent`);
    if (a === undefined || a.count !== n.count) {
      a = new ly(new Float32Array(n.count * 4), 4);
      this.setAttribute(`tangent`, a);
    }
    let o = [];
    let s = [];
    for (let e = 0; e < n.count; e++) {
      o[e] = new X();
      s[e] = new X();
    }
    let c = new X();
    let l = new X();
    let u = new X();
    let d = new S_();
    let f = new S_();
    let p = new S_();
    let m = new X();
    let h = new X();
    function g(e, t, r) {
      c.fromBufferAttribute(n, e);
      l.fromBufferAttribute(n, t);
      u.fromBufferAttribute(n, r);
      d.fromBufferAttribute(i, e);
      f.fromBufferAttribute(i, t);
      p.fromBufferAttribute(i, r);
      l.sub(c);
      u.sub(c);
      f.sub(d);
      p.sub(d);
      let a = 1 / (f.x * p.y - p.x * f.y);
      if (isFinite(a)) {
        m.copy(l).multiplyScalar(p.y).addScaledVector(u, -f.y).multiplyScalar(a);
        h.copy(u).multiplyScalar(f.x).addScaledVector(l, -p.x).multiplyScalar(a);
        o[e].add(m);
        o[t].add(m);
        o[r].add(m);
        s[e].add(h);
        s[t].add(h);
        s[r].add(h);
      }
    }
    let _ = this.groups;
    if (_.length === 0) {
      _ = [{
        start: 0,
        count: e.count
      }];
    }
    for (let t = 0, n = _.length; t < n; ++t) {
      let n = _[t];
      let r = n.start;
      let i = n.count;
      for (let t = r, n = r + i; t < n; t += 3) {
        g(e.getX(t + 0), e.getX(t + 1), e.getX(t + 2));
      }
    }
    let v = new X();
    let y = new X();
    let b = new X();
    let x = new X();
    function S(e) {
      b.fromBufferAttribute(r, e);
      x.copy(b);
      let t = o[e];
      v.copy(t);
      v.sub(b.multiplyScalar(b.dot(t))).normalize();
      y.crossVectors(x, t);
      let n = y.dot(s[e]) < 0 ? -1 : 1;
      a.setXYZW(e, v.x, v.y, v.z, n);
    }
    for (let t = 0, n = _.length; t < n; ++t) {
      let n = _[t];
      let r = n.start;
      let i = n.count;
      for (let t = r, n = r + i; t < n; t += 3) {
        S(e.getX(t + 0));
        S(e.getX(t + 1));
        S(e.getX(t + 2));
      }
    }
    this._transformed = true;
  }
  computeVertexNormals() {
    let e = this.index;
    let t = this.getAttribute(`position`);
    if (t !== undefined) {
      let n = this.getAttribute(`normal`);
      if (n === undefined || n.count !== t.count) {
        n = new ly(new Float32Array(t.count * 3), 3);
        this.setAttribute(`normal`, n);
      } else {
        for (let e = 0, t = n.count; e < t; e++) {
          n.setXYZ(e, 0, 0, 0);
        }
      }
      let r = new X();
      let i = new X();
      let a = new X();
      let o = new X();
      let s = new X();
      let c = new X();
      let l = new X();
      let u = new X();
      if (e) {
        for (let d = 0, f = e.count; d < f; d += 3) {
          let f = e.getX(d + 0);
          let p = e.getX(d + 1);
          let m = e.getX(d + 2);
          r.fromBufferAttribute(t, f);
          i.fromBufferAttribute(t, p);
          a.fromBufferAttribute(t, m);
          l.subVectors(a, i);
          u.subVectors(r, i);
          l.cross(u);
          o.fromBufferAttribute(n, f);
          s.fromBufferAttribute(n, p);
          c.fromBufferAttribute(n, m);
          o.add(l);
          s.add(l);
          c.add(l);
          n.setXYZ(f, o.x, o.y, o.z);
          n.setXYZ(p, s.x, s.y, s.z);
          n.setXYZ(m, c.x, c.y, c.z);
        }
      } else {
        for (let e = 0, o = t.count; e < o; e += 3) {
          r.fromBufferAttribute(t, e + 0);
          i.fromBufferAttribute(t, e + 1);
          a.fromBufferAttribute(t, e + 2);
          l.subVectors(a, i);
          u.subVectors(r, i);
          l.cross(u);
          n.setXYZ(e + 0, l.x, l.y, l.z);
          n.setXYZ(e + 1, l.x, l.y, l.z);
          n.setXYZ(e + 2, l.x, l.y, l.z);
        }
      }
      this.normalizeNormals();
      n.needsUpdate = true;
    }
  }
  normalizeNormals() {
    let e = this.attributes.normal;
    for (let t = 0, n = e.count; t < n; t++) {
      Cy.fromBufferAttribute(e, t);
      Cy.normalize();
      e.setXYZ(t, Cy.x, Cy.y, Cy.z);
    }
  }
  toNonIndexed() {
    function t(e, t) {
      let n = e.array;
      let r = e.itemSize;
      let i = e.normalized;
      let a = new n.constructor(t.length * r);
      let o = 0;
      let s = 0;
      for (let i = 0, c = t.length; i < c; i++) {
        o = e.isInterleavedBufferAttribute ? t[i] * e.data.stride + e.offset : t[i] * r;
        for (let e = 0; e < r; e++) {
          a[s++] = n[o++];
        }
      }
      return new ly(a, r, i);
    }
    if (this.index === null) {
      Ug(`BufferGeometry.toNonIndexed(): BufferGeometry is already non-indexed.`);
      return this;
    }
    let n = new e();
    let r = this.index.array;
    let i = this.attributes;
    for (let e in i) {
      let a = i[e];
      let o = t(a, r);
      n.setAttribute(e, o);
    }
    let a = this.morphAttributes;
    for (let e in a) {
      let i = [];
      let o = a[e];
      for (let e = 0, n = o.length; e < n; e++) {
        let n = o[e];
        let a = t(n, r);
        i.push(a);
      }
      n.morphAttributes[e] = i;
    }
    n.morphTargetsRelative = this.morphTargetsRelative;
    let o = this.groups;
    for (let e = 0, t = o.length; e < t; e++) {
      let t = o[e];
      n.addGroup(t.start, t.count, t.materialIndex);
    }
    return n;
  }
  toJSON() {
    let e = {
      metadata: {
        version: 4.7,
        type: `BufferGeometry`,
        generator: `BufferGeometry.toJSON`
      }
    };
    e.uuid = this.uuid;
    e.type = this.parameters !== undefined && this._transformed === true ? `BufferGeometry` : this.type;
    e.name = this.name;
    if (Object.keys(this.userData).length > 0) {
      e.userData = this.userData;
    }
    if (this.parameters !== undefined && this._transformed !== true) {
      let t = this.parameters;
      for (let n in t) {
        if (t[n] !== undefined) {
          e[n] = t[n];
        }
      }
      return e;
    }
    e.data = {
      attributes: {}
    };
    let t = this.index;
    if (t !== null) {
      e.data.index = {
        type: t.array.constructor.name,
        array: Array.prototype.slice.call(t.array)
      };
    }
    let n = this.attributes;
    for (let t in n) {
      let r = n[t];
      e.data.attributes[t] = r.toJSON(e.data);
    }
    let r = {};
    let i = false;
    for (let t in this.morphAttributes) {
      let n = this.morphAttributes[t];
      let a = [];
      for (let t = 0, r = n.length; t < r; t++) {
        let r = n[t];
        a.push(r.toJSON(e.data));
      }
      if (a.length > 0) {
        r[t] = a;
        i = true;
      }
    }
    if (i) {
      e.data.morphAttributes = r;
      e.data.morphTargetsRelative = this.morphTargetsRelative;
    }
    let a = this.groups;
    if (a.length > 0) {
      e.data.groups = JSON.parse(JSON.stringify(a));
    }
    let o = this.boundingSphere;
    if (o !== null) {
      e.data.boundingSphere = o.toJSON();
    }
    return e;
  }
  clone() {
    return new this.constructor().copy(this);
  }
  copy(e) {
    this.index = null;
    this.attributes = {};
    this.morphAttributes = {};
    this.groups = [];
    this.boundingBox = null;
    this.boundingSphere = null;
    let t = {};
    this.name = e.name;
    let n = e.index;
    if (n !== null) {
      this.setIndex(n.clone());
    }
    let r = e.attributes;
    for (let e in r) {
      let n = r[e];
      this.setAttribute(e, n.clone(t));
    }
    let i = e.morphAttributes;
    for (let e in i) {
      let n = [];
      let r = i[e];
      for (let e = 0, i = r.length; e < i; e++) {
        n.push(r[e].clone(t));
      }
      this.morphAttributes[e] = n;
    }
    this.morphTargetsRelative = e.morphTargetsRelative;
    let a = e.groups;
    for (let e = 0, t = a.length; e < t; e++) {
      let t = a[e];
      this.addGroup(t.start, t.count, t.materialIndex);
    }
    let o = e.boundingBox;
    if (o !== null) {
      this.boundingBox = o.clone();
    }
    let s = e.boundingSphere;
    if (s !== null) {
      this.boundingSphere = s.clone();
    }
    this.drawRange.start = e.drawRange.start;
    this.drawRange.count = e.drawRange.count;
    this.userData = e.userData;
    this._transformed = e._transformed;
    return this;
  }
  dispose() {
    this.dispatchEvent({
      type: `dispose`
    });
  }
};
var Ty = class {
  constructor(e, t) {
    this.isInterleavedBuffer = true;
    this.array = e;
    this.stride = t;
    this.count = e === undefined ? 0 : e.length / t;
    this.usage = Pg;
    this.updateRanges = [];
    this.version = 0;
    this.uuid = $g();
  }
  onUploadCallback() {}
  set needsUpdate(e) {
    if (e === true) {
      this.version++;
    }
  }
  setUsage(e) {
    this.usage = e;
    return this;
  }
  addUpdateRange(e, t) {
    this.updateRanges.push({
      start: e,
      count: t
    });
  }
  clearUpdateRanges() {
    this.updateRanges.length = 0;
  }
  copy(e) {
    this.array = new e.array.constructor(e.array);
    this.count = e.count;
    this.stride = e.stride;
    this.usage = e.usage;
    return this;
  }
  copyAt(e, t, n) {
    e *= this.stride;
    n *= t.stride;
    for (let r = 0, i = this.stride; r < i; r++) {
      this.array[e + r] = t.array[n + r];
    }
    return this;
  }
  set(e, t = 0) {
    this.array.set(e, t);
    return this;
  }
  clone(e) {
    if (e.arrayBuffers === undefined) {
      e.arrayBuffers = {};
    }
    if (this.array.buffer._uuid === undefined) {
      this.array.buffer._uuid = $g();
    }
    if (e.arrayBuffers[this.array.buffer._uuid] === undefined) {
      e.arrayBuffers[this.array.buffer._uuid] = this.array.slice(0).buffer;
    }
    let t = new this.array.constructor(e.arrayBuffers[this.array.buffer._uuid]);
    let n = new this.constructor(t, this.stride);
    n.setUsage(this.usage);
    return n;
  }
  onUpload(e) {
    this.onUploadCallback = e;
    return this;
  }
  toJSON(e) {
    if (e.arrayBuffers === undefined) {
      e.arrayBuffers = {};
    }
    if (this.array.buffer._uuid === undefined) {
      this.array.buffer._uuid = $g();
    }
    if (e.arrayBuffers[this.array.buffer._uuid] === undefined) {
      e.arrayBuffers[this.array.buffer._uuid] = Array.from(new Uint32Array(this.array.buffer));
    }
    let t = {
      uuid: this.uuid,
      buffer: this.array.buffer._uuid,
      type: this.array.constructor.name,
      stride: this.stride
    };
    t.usage = this.usage;
    return t;
  }
};
var Ey = new X();
var Dy = class e {
  constructor(e, t, n, r = false) {
    this.isInterleavedBufferAttribute = true;
    this.name = ``;
    this.data = e;
    this.itemSize = t;
    this.offset = n;
    this.normalized = r;
  }
  get count() {
    return this.data.count;
  }
  get array() {
    return this.data.array;
  }
  set needsUpdate(e) {
    this.data.needsUpdate = e;
  }
  applyMatrix4(e) {
    for (let t = 0, n = this.data.count; t < n; t++) {
      Ey.fromBufferAttribute(this, t);
      Ey.applyMatrix4(e);
      this.setXYZ(t, Ey.x, Ey.y, Ey.z);
    }
    return this;
  }
  applyNormalMatrix(e) {
    for (let t = 0, n = this.count; t < n; t++) {
      Ey.fromBufferAttribute(this, t);
      Ey.applyNormalMatrix(e);
      this.setXYZ(t, Ey.x, Ey.y, Ey.z);
    }
    return this;
  }
  transformDirection(e) {
    for (let t = 0, n = this.count; t < n; t++) {
      Ey.fromBufferAttribute(this, t);
      Ey.transformDirection(e);
      this.setXYZ(t, Ey.x, Ey.y, Ey.z);
    }
    return this;
  }
  getComponent(e, t) {
    let n = this.array[e * this.data.stride + this.offset + t];
    if (this.normalized) {
      n = y_(n, this.array);
    }
    return n;
  }
  setComponent(e, t, n) {
    if (this.normalized) {
      n = b_(n, this.array);
    }
    this.data.array[e * this.data.stride + this.offset + t] = n;
    return this;
  }
  setX(e, t) {
    if (this.normalized) {
      t = b_(t, this.array);
    }
    this.data.array[e * this.data.stride + this.offset] = t;
    return this;
  }
  setY(e, t) {
    if (this.normalized) {
      t = b_(t, this.array);
    }
    this.data.array[e * this.data.stride + this.offset + 1] = t;
    return this;
  }
  setZ(e, t) {
    if (this.normalized) {
      t = b_(t, this.array);
    }
    this.data.array[e * this.data.stride + this.offset + 2] = t;
    return this;
  }
  setW(e, t) {
    if (this.normalized) {
      t = b_(t, this.array);
    }
    this.data.array[e * this.data.stride + this.offset + 3] = t;
    return this;
  }
  getX(e) {
    let t = this.data.array[e * this.data.stride + this.offset];
    if (this.normalized) {
      t = y_(t, this.array);
    }
    return t;
  }
  getY(e) {
    let t = this.data.array[e * this.data.stride + this.offset + 1];
    if (this.normalized) {
      t = y_(t, this.array);
    }
    return t;
  }
  getZ(e) {
    let t = this.data.array[e * this.data.stride + this.offset + 2];
    if (this.normalized) {
      t = y_(t, this.array);
    }
    return t;
  }
  getW(e) {
    let t = this.data.array[e * this.data.stride + this.offset + 3];
    if (this.normalized) {
      t = y_(t, this.array);
    }
    return t;
  }
  setXY(e, t, n) {
    e = e * this.data.stride + this.offset;
    if (this.normalized) {
      t = b_(t, this.array);
      n = b_(n, this.array);
    }
    this.data.array[e + 0] = t;
    this.data.array[e + 1] = n;
    return this;
  }
  setXYZ(e, t, n, r) {
    e = e * this.data.stride + this.offset;
    if (this.normalized) {
      t = b_(t, this.array);
      n = b_(n, this.array);
      r = b_(r, this.array);
    }
    this.data.array[e + 0] = t;
    this.data.array[e + 1] = n;
    this.data.array[e + 2] = r;
    return this;
  }
  setXYZW(e, t, n, r, i) {
    e = e * this.data.stride + this.offset;
    if (this.normalized) {
      t = b_(t, this.array);
      n = b_(n, this.array);
      r = b_(r, this.array);
      i = b_(i, this.array);
    }
    this.data.array[e + 0] = t;
    this.data.array[e + 1] = n;
    this.data.array[e + 2] = r;
    this.data.array[e + 3] = i;
    return this;
  }
  clone(t) {
    if (t === undefined) {
      Vg(`InterleavedBufferAttribute.clone(): Cloning an interleaved buffer attribute will de-interleave buffer data.`);
      let e = [];
      for (let t = 0; t < this.count; t++) {
        let n = t * this.data.stride + this.offset;
        for (let t = 0; t < this.itemSize; t++) {
          e.push(this.data.array[n + t]);
        }
      }
      return new ly(new this.array.constructor(e), this.itemSize, this.normalized);
    }
    if (t.interleavedBuffers === undefined) {
      t.interleavedBuffers = {};
    }
    if (t.interleavedBuffers[this.data.uuid] === undefined) {
      t.interleavedBuffers[this.data.uuid] = this.data.clone(t);
    }
    return new e(t.interleavedBuffers[this.data.uuid], this.itemSize, this.offset, this.normalized);
  }
  toJSON(e) {
    if (e === undefined) {
      Vg(`InterleavedBufferAttribute.toJSON(): Serializing an interleaved buffer attribute will de-interleave buffer data.`);
      let e = [];
      for (let t = 0; t < this.count; t++) {
        let n = t * this.data.stride + this.offset;
        for (let t = 0; t < this.itemSize; t++) {
          e.push(this.data.array[n + t]);
        }
      }
      return {
        itemSize: this.itemSize,
        type: this.array.constructor.name,
        array: e,
        normalized: this.normalized
      };
    }
    if (e.interleavedBuffers === undefined) {
      e.interleavedBuffers = {};
    }
    if (e.interleavedBuffers[this.data.uuid] === undefined) {
      e.interleavedBuffers[this.data.uuid] = this.data.toJSON(e);
    }
    return {
      isInterleavedBufferAttribute: true,
      itemSize: this.itemSize,
      data: this.data.uuid,
      offset: this.offset,
      normalized: this.normalized
    };
  }
};
var Oy = new X();
var ky = new X();
var Ay = new E_();
var jy = class {
  constructor(e = new X(1, 0, 0), t = 0) {
    this.isPlane = true;
    this.normal = e;
    this.constant = t;
  }
  set(e, t) {
    this.normal.copy(e);
    this.constant = t;
    return this;
  }
  setComponents(e, t, n, r) {
    this.normal.set(e, t, n);
    this.constant = r;
    return this;
  }
  setFromNormalAndCoplanarPoint(e, t) {
    this.normal.copy(e);
    this.constant = -t.dot(this.normal);
    return this;
  }
  setFromCoplanarPoints(e, t, n) {
    let r = Oy.subVectors(n, t).cross(ky.subVectors(e, t)).normalize();
    this.setFromNormalAndCoplanarPoint(r, e);
    return this;
  }
  copy(e) {
    this.normal.copy(e.normal);
    this.constant = e.constant;
    return this;
  }
  normalize() {
    let e = 1 / this.normal.length();
    this.normal.multiplyScalar(e);
    this.constant *= e;
    return this;
  }
  negate() {
    this.constant *= -1;
    this.normal.negate();
    return this;
  }
  distanceToPoint(e) {
    return this.normal.dot(e) + this.constant;
  }
  distanceToSphere(e) {
    return this.distanceToPoint(e.center) - e.radius;
  }
  projectPoint(e, t) {
    return t.copy(e).addScaledVector(this.normal, -this.distanceToPoint(e));
  }
  intersectLine(e, t, n = true) {
    let r = e.delta(Oy);
    let i = this.normal.dot(r);
    if (i === 0) {
      if (this.distanceToPoint(e.start) === 0) {
        return t.copy(e.start);
      } else {
        return null;
      }
    }
    let a = -(e.start.dot(this.normal) + this.constant) / i;
    if (n === true && (a < 0 || a > 1)) {
      return null;
    } else {
      return t.copy(e.start).addScaledVector(r, a);
    }
  }
  intersectsLine(e) {
    let t = this.distanceToPoint(e.start);
    let n = this.distanceToPoint(e.end);
    return t < 0 && n > 0 || n < 0 && t > 0;
  }
  intersectsBox(e) {
    return e.intersectsPlane(this);
  }
  intersectsSphere(e) {
    return e.intersectsPlane(this);
  }
  coplanarPoint(e) {
    return e.copy(this.normal).multiplyScalar(-this.constant);
  }
  applyMatrix4(e, t) {
    let n = t || Ay.getNormalMatrix(e);
    let r = this.coplanarPoint(Oy).applyMatrix4(e);
    let i = this.normal.applyMatrix3(n).normalize();
    this.constant = -r.dot(i);
    return this;
  }
  translate(e) {
    this.constant -= e.dot(this.normal);
    return this;
  }
  equals(e) {
    return e.normal.equals(this.normal) && e.constant === this.constant;
  }
  clone() {
    return new this.constructor().copy(this);
  }
  toJSON() {
    return {
      normal: this.normal.toArray(),
      constant: this.constant
    };
  }
  fromJSON(e) {
    this.normal.fromArray(e.normal);
    this.constant = e.constant;
    return this;
  }
};
var My = 0;
var Ny = class extends Jg {
  constructor() {
    super();
    this.isMaterial = true;
    Object.defineProperty(this, "id", {
      value: My++
    });
    this.uuid = $g();
    this.name = ``;
    this.type = `Material`;
    this.blending = 1;
    this.side = 0;
    this.vertexColors = false;
    this.opacity = 1;
    this.transparent = false;
    this.alphaHash = false;
    this.blendSrc = 204;
    this.blendDst = 205;
    this.blendEquation = 100;
    this.blendSrcAlpha = null;
    this.blendDstAlpha = null;
    this.blendEquationAlpha = null;
    this.blendColor = new Ov(0, 0, 0);
    this.blendAlpha = 0;
    this.depthFunc = 3;
    this.depthTest = true;
    this.depthWrite = true;
    this.stencilWriteMask = 255;
    this.stencilFunc = 519;
    this.stencilRef = 0;
    this.stencilFuncMask = 255;
    this.stencilFail = Ng;
    this.stencilZFail = Ng;
    this.stencilZPass = Ng;
    this.stencilWrite = false;
    this.clippingPlanes = null;
    this.clipIntersection = false;
    this.clipShadows = false;
    this.shadowSide = null;
    this.colorWrite = true;
    this.precision = null;
    this.polygonOffset = false;
    this.polygonOffsetFactor = 0;
    this.polygonOffsetUnits = 0;
    this.dithering = false;
    this.alphaToCoverage = false;
    this.premultipliedAlpha = false;
    this.forceSinglePass = false;
    this.allowOverride = true;
    this.visible = true;
    this.toneMapped = true;
    this.userData = {};
    this.version = 0;
    this._alphaTest = 0;
  }
  get alphaTest() {
    return this._alphaTest;
  }
  set alphaTest(e) {
    if (this._alphaTest > 0 != e > 0) {
      this.version++;
    }
    this._alphaTest = e;
  }
  onBeforeRender() {}
  onBeforeCompile() {}
  customProgramCacheKey() {
    return this.onBeforeCompile.toString();
  }
  setValues(e) {
    if (e !== undefined) {
      for (let t in e) {
        let n = e[t];
        if (n === undefined) {
          Ug(`Material: parameter '${t}' has value of undefined.`);
          continue;
        }
        let r = this[t];
        if (r === undefined) {
          Ug(`Material: '${t}' is not a property of THREE.${this.type}.`);
          continue;
        }
        if (r && r.isColor) {
          r.set(n);
        } else if (r && r.isVector2 && n && n.isVector2 || r && r.isEuler && n && n.isEuler || r && r.isVector3 && n && n.isVector3) {
          r.copy(n);
        } else {
          this[t] = n;
        }
      }
    }
  }
  toJSON(e) {
    let t = e === undefined || typeof e == `string`;
    if (t) {
      e = {
        textures: {},
        images: {}
      };
    }
    let n = {
      metadata: {
        version: 4.7,
        type: `Material`,
        generator: `Material.toJSON`
      }
    };
    n.uuid = this.uuid;
    n.type = this.type;
    n.blending = this.blending;
    n.side = this.side;
    n.shadowSide = this.shadowSide;
    n.vertexColors = this.vertexColors;
    n.opacity = this.opacity;
    n.transparent = this.transparent;
    n.blendSrc = this.blendSrc;
    n.blendDst = this.blendDst;
    n.blendEquation = this.blendEquation;
    n.blendSrcAlpha = this.blendSrcAlpha;
    n.blendDstAlpha = this.blendDstAlpha;
    n.blendEquationAlpha = this.blendEquationAlpha;
    n.blendColor = this.blendColor.getHex();
    n.blendAlpha = this.blendAlpha;
    n.depthFunc = this.depthFunc;
    n.depthTest = this.depthTest;
    n.depthWrite = this.depthWrite;
    n.colorWrite = this.colorWrite;
    n.clipIntersection = this.clipIntersection;
    n.clipShadows = this.clipShadows;
    n.stencilWriteMask = this.stencilWriteMask;
    n.stencilFunc = this.stencilFunc;
    n.stencilRef = this.stencilRef;
    n.stencilFuncMask = this.stencilFuncMask;
    n.stencilFail = this.stencilFail;
    n.stencilZFail = this.stencilZFail;
    n.stencilZPass = this.stencilZPass;
    n.stencilWrite = this.stencilWrite;
    n.polygonOffset = this.polygonOffset;
    n.polygonOffsetFactor = this.polygonOffsetFactor;
    n.polygonOffsetUnits = this.polygonOffsetUnits;
    n.dithering = this.dithering;
    n.alphaTest = this.alphaTest;
    n.alphaHash = this.alphaHash;
    n.alphaToCoverage = this.alphaToCoverage;
    n.premultipliedAlpha = this.premultipliedAlpha;
    n.forceSinglePass = this.forceSinglePass;
    n.allowOverride = this.allowOverride;
    n.visible = this.visible;
    n.toneMapped = this.toneMapped;
    n.name = this.name;
    if (this.color && this.color.isColor) {
      n.color = this.color.getHex();
    }
    if (this.roughness !== undefined) {
      n.roughness = this.roughness;
    }
    if (this.metalness !== undefined) {
      n.metalness = this.metalness;
    }
    if (this.sheen !== undefined) {
      n.sheen = this.sheen;
    }
    if (this.sheenColor && this.sheenColor.isColor) {
      n.sheenColor = this.sheenColor.getHex();
    }
    if (this.sheenRoughness !== undefined) {
      n.sheenRoughness = this.sheenRoughness;
    }
    if (this.emissive && this.emissive.isColor) {
      n.emissive = this.emissive.getHex();
    }
    if (this.emissiveIntensity !== undefined) {
      n.emissiveIntensity = this.emissiveIntensity;
    }
    if (this.specular && this.specular.isColor) {
      n.specular = this.specular.getHex();
    }
    if (this.specularIntensity !== undefined) {
      n.specularIntensity = this.specularIntensity;
    }
    if (this.specularColor && this.specularColor.isColor) {
      n.specularColor = this.specularColor.getHex();
    }
    if (this.shininess !== undefined) {
      n.shininess = this.shininess;
    }
    if (this.clearcoat !== undefined) {
      n.clearcoat = this.clearcoat;
    }
    if (this.clearcoatRoughness !== undefined) {
      n.clearcoatRoughness = this.clearcoatRoughness;
    }
    if (this.clearcoatMap && this.clearcoatMap.isTexture) {
      n.clearcoatMap = this.clearcoatMap.toJSON(e).uuid;
    }
    if (this.clearcoatRoughnessMap && this.clearcoatRoughnessMap.isTexture) {
      n.clearcoatRoughnessMap = this.clearcoatRoughnessMap.toJSON(e).uuid;
    }
    if (this.clearcoatNormalMap && this.clearcoatNormalMap.isTexture) {
      n.clearcoatNormalMap = this.clearcoatNormalMap.toJSON(e).uuid;
      n.clearcoatNormalScale = this.clearcoatNormalScale.toArray();
    }
    if (this.sheenColorMap && this.sheenColorMap.isTexture) {
      n.sheenColorMap = this.sheenColorMap.toJSON(e).uuid;
    }
    if (this.sheenRoughnessMap && this.sheenRoughnessMap.isTexture) {
      n.sheenRoughnessMap = this.sheenRoughnessMap.toJSON(e).uuid;
    }
    if (this.dispersion !== undefined) {
      n.dispersion = this.dispersion;
    }
    if (this.retroreflectivity !== undefined) {
      n.retroreflectivity = this.retroreflectivity;
    }
    if (this.iridescence !== undefined) {
      n.iridescence = this.iridescence;
    }
    if (this.iridescenceIOR !== undefined) {
      n.iridescenceIOR = this.iridescenceIOR;
    }
    if (this.iridescenceThicknessRange !== undefined) {
      n.iridescenceThicknessRange = this.iridescenceThicknessRange;
    }
    if (this.iridescenceMap && this.iridescenceMap.isTexture) {
      n.iridescenceMap = this.iridescenceMap.toJSON(e).uuid;
    }
    if (this.iridescenceThicknessMap && this.iridescenceThicknessMap.isTexture) {
      n.iridescenceThicknessMap = this.iridescenceThicknessMap.toJSON(e).uuid;
    }
    if (this.anisotropy !== undefined) {
      n.anisotropy = this.anisotropy;
    }
    if (this.anisotropyRotation !== undefined) {
      n.anisotropyRotation = this.anisotropyRotation;
    }
    if (this.anisotropyMap && this.anisotropyMap.isTexture) {
      n.anisotropyMap = this.anisotropyMap.toJSON(e).uuid;
    }
    if (this.map && this.map.isTexture) {
      n.map = this.map.toJSON(e).uuid;
    }
    if (this.matcap && this.matcap.isTexture) {
      n.matcap = this.matcap.toJSON(e).uuid;
    }
    if (this.alphaMap && this.alphaMap.isTexture) {
      n.alphaMap = this.alphaMap.toJSON(e).uuid;
    }
    if (this.lightMap && this.lightMap.isTexture) {
      n.lightMap = this.lightMap.toJSON(e).uuid;
      n.lightMapIntensity = this.lightMapIntensity;
    }
    if (this.aoMap && this.aoMap.isTexture) {
      n.aoMap = this.aoMap.toJSON(e).uuid;
      n.aoMapIntensity = this.aoMapIntensity;
    }
    if (this.bumpMap && this.bumpMap.isTexture) {
      n.bumpMap = this.bumpMap.toJSON(e).uuid;
      n.bumpScale = this.bumpScale;
    }
    if (this.normalMap && this.normalMap.isTexture) {
      n.normalMap = this.normalMap.toJSON(e).uuid;
      n.normalMapType = this.normalMapType;
      n.normalScale = this.normalScale.toArray();
    }
    if (this.displacementMap && this.displacementMap.isTexture) {
      n.displacementMap = this.displacementMap.toJSON(e).uuid;
      n.displacementScale = this.displacementScale;
      n.displacementBias = this.displacementBias;
    }
    if (this.roughnessMap && this.roughnessMap.isTexture) {
      n.roughnessMap = this.roughnessMap.toJSON(e).uuid;
    }
    if (this.metalnessMap && this.metalnessMap.isTexture) {
      n.metalnessMap = this.metalnessMap.toJSON(e).uuid;
    }
    if (this.emissiveMap && this.emissiveMap.isTexture) {
      n.emissiveMap = this.emissiveMap.toJSON(e).uuid;
    }
    if (this.specularMap && this.specularMap.isTexture) {
      n.specularMap = this.specularMap.toJSON(e).uuid;
    }
    if (this.specularIntensityMap && this.specularIntensityMap.isTexture) {
      n.specularIntensityMap = this.specularIntensityMap.toJSON(e).uuid;
    }
    if (this.specularColorMap && this.specularColorMap.isTexture) {
      n.specularColorMap = this.specularColorMap.toJSON(e).uuid;
    }
    if (this.envMap && this.envMap.isTexture) {
      n.envMap = this.envMap.toJSON(e).uuid;
      if (this.combine !== undefined) {
        n.combine = this.combine;
      }
    }
    if (this.envMapRotation !== undefined) {
      n.envMapRotation = this.envMapRotation.toArray();
    }
    if (this.envMapIntensity !== undefined) {
      n.envMapIntensity = this.envMapIntensity;
    }
    if (this.reflectivity !== undefined) {
      n.reflectivity = this.reflectivity;
    }
    if (this.refractionRatio !== undefined) {
      n.refractionRatio = this.refractionRatio;
    }
    if (this.gradientMap && this.gradientMap.isTexture) {
      n.gradientMap = this.gradientMap.toJSON(e).uuid;
    }
    if (this.transmission !== undefined) {
      n.transmission = this.transmission;
    }
    if (this.transmissionMap && this.transmissionMap.isTexture) {
      n.transmissionMap = this.transmissionMap.toJSON(e).uuid;
    }
    if (this.thickness !== undefined) {
      n.thickness = this.thickness;
    }
    if (this.thicknessMap && this.thicknessMap.isTexture) {
      n.thicknessMap = this.thicknessMap.toJSON(e).uuid;
    }
    if (this.attenuationDistance !== undefined) {
      n.attenuationDistance = this.attenuationDistance;
    }
    if (this.attenuationColor !== undefined) {
      n.attenuationColor = this.attenuationColor.getHex();
    }
    if (this.size !== undefined) {
      n.size = this.size;
    }
    if (this.sizeAttenuation !== undefined) {
      n.sizeAttenuation = this.sizeAttenuation;
    }
    if (Array.isArray(this.clippingPlanes) && this.clippingPlanes.length > 0) {
      n.clippingPlanes = this.clippingPlanes.map(e => e.toJSON());
    }
    if (this.rotation !== undefined) {
      n.rotation = this.rotation;
    }
    if (this.depthPacking !== undefined) {
      n.depthPacking = this.depthPacking;
    }
    if (this.linewidth !== undefined) {
      n.linewidth = this.linewidth;
    }
    if (this.linecap !== undefined) {
      n.linecap = this.linecap;
    }
    if (this.linejoin !== undefined) {
      n.linejoin = this.linejoin;
    }
    if (this.dashSize !== undefined) {
      n.dashSize = this.dashSize;
    }
    if (this.gapSize !== undefined) {
      n.gapSize = this.gapSize;
    }
    if (this.scale !== undefined) {
      n.scale = this.scale;
    }
    if (this.wireframe !== undefined) {
      n.wireframe = this.wireframe;
    }
    if (this.wireframeLinewidth !== undefined) {
      n.wireframeLinewidth = this.wireframeLinewidth;
    }
    if (this.wireframeLinecap !== undefined) {
      n.wireframeLinecap = this.wireframeLinecap;
    }
    if (this.wireframeLinejoin !== undefined) {
      n.wireframeLinejoin = this.wireframeLinejoin;
    }
    if (this.flatShading !== undefined) {
      n.flatShading = this.flatShading;
    }
    if (this.fog !== undefined) {
      n.fog = this.fog;
    }
    if (Object.keys(this.userData).length > 0) {
      n.userData = this.userData;
    }
    function r(e) {
      let t = [];
      for (let n in e) {
        let r = e[n];
        delete r.metadata;
        t.push(r);
      }
      return t;
    }
    if (t) {
      let t = r(e.textures);
      let i = r(e.images);
      if (t.length > 0) {
        n.textures = t;
      }
      if (i.length > 0) {
        n.images = i;
      }
    }
    return n;
  }
  fromJSON(e, t) {
    if (e.uuid !== undefined) {
      this.uuid = e.uuid;
    }
    if (e.name !== undefined) {
      this.name = e.name;
    }
    if (e.color !== undefined && this.color !== undefined) {
      this.color.setHex(e.color);
    }
    if (e.roughness !== undefined) {
      this.roughness = e.roughness;
    }
    if (e.metalness !== undefined) {
      this.metalness = e.metalness;
    }
    if (e.sheen !== undefined) {
      this.sheen = e.sheen;
    }
    if (e.sheenColor !== undefined) {
      this.sheenColor = new Ov().setHex(e.sheenColor);
    }
    if (e.sheenRoughness !== undefined) {
      this.sheenRoughness = e.sheenRoughness;
    }
    if (e.emissive !== undefined && this.emissive !== undefined) {
      this.emissive.setHex(e.emissive);
    }
    if (e.specular !== undefined && this.specular !== undefined) {
      this.specular.setHex(e.specular);
    }
    if (e.specularIntensity !== undefined) {
      this.specularIntensity = e.specularIntensity;
    }
    if (e.specularColor !== undefined && this.specularColor !== undefined) {
      this.specularColor.setHex(e.specularColor);
    }
    if (e.shininess !== undefined) {
      this.shininess = e.shininess;
    }
    if (e.clearcoat !== undefined) {
      this.clearcoat = e.clearcoat;
    }
    if (e.clearcoatRoughness !== undefined) {
      this.clearcoatRoughness = e.clearcoatRoughness;
    }
    if (e.dispersion !== undefined) {
      this.dispersion = e.dispersion;
    }
    if (e.retroreflectivity !== undefined) {
      this.retroreflectivity = e.retroreflectivity;
    }
    if (e.iridescence !== undefined) {
      this.iridescence = e.iridescence;
    }
    if (e.iridescenceIOR !== undefined) {
      this.iridescenceIOR = e.iridescenceIOR;
    }
    if (e.iridescenceThicknessRange !== undefined) {
      this.iridescenceThicknessRange = e.iridescenceThicknessRange;
    }
    if (e.transmission !== undefined) {
      this.transmission = e.transmission;
    }
    if (e.thickness !== undefined) {
      this.thickness = e.thickness;
    }
    if (e.attenuationDistance !== undefined) {
      this.attenuationDistance = e.attenuationDistance;
    }
    if (e.attenuationColor !== undefined && this.attenuationColor !== undefined) {
      this.attenuationColor.setHex(e.attenuationColor);
    }
    if (e.anisotropy !== undefined) {
      this.anisotropy = e.anisotropy;
    }
    if (e.anisotropyRotation !== undefined) {
      this.anisotropyRotation = e.anisotropyRotation;
    }
    if (e.fog !== undefined) {
      this.fog = e.fog;
    }
    if (e.flatShading !== undefined) {
      this.flatShading = e.flatShading;
    }
    if (e.blending !== undefined) {
      this.blending = e.blending;
    }
    if (e.combine !== undefined) {
      this.combine = e.combine;
    }
    if (e.side !== undefined) {
      this.side = e.side;
    }
    if (e.shadowSide !== undefined) {
      this.shadowSide = e.shadowSide;
    }
    if (e.opacity !== undefined) {
      this.opacity = e.opacity;
    }
    if (e.transparent !== undefined) {
      this.transparent = e.transparent;
    }
    if (e.alphaTest !== undefined) {
      this.alphaTest = e.alphaTest;
    }
    if (e.alphaHash !== undefined) {
      this.alphaHash = e.alphaHash;
    }
    if (e.depthFunc !== undefined) {
      this.depthFunc = e.depthFunc;
    }
    if (e.depthTest !== undefined) {
      this.depthTest = e.depthTest;
    }
    if (e.depthWrite !== undefined) {
      this.depthWrite = e.depthWrite;
    }
    if (e.colorWrite !== undefined) {
      this.colorWrite = e.colorWrite;
    }
    if (e.clippingPlanes !== undefined) {
      this.clippingPlanes = e.clippingPlanes.map(e => new jy().fromJSON(e));
    }
    if (e.clipIntersection !== undefined) {
      this.clipIntersection = e.clipIntersection;
    }
    if (e.clipShadows !== undefined) {
      this.clipShadows = e.clipShadows;
    }
    if (e.depthPacking !== undefined) {
      this.depthPacking = e.depthPacking;
    }
    if (e.blendSrc !== undefined) {
      this.blendSrc = e.blendSrc;
    }
    if (e.blendDst !== undefined) {
      this.blendDst = e.blendDst;
    }
    if (e.blendEquation !== undefined) {
      this.blendEquation = e.blendEquation;
    }
    if (e.blendSrcAlpha !== undefined) {
      this.blendSrcAlpha = e.blendSrcAlpha;
    }
    if (e.blendDstAlpha !== undefined) {
      this.blendDstAlpha = e.blendDstAlpha;
    }
    if (e.blendEquationAlpha !== undefined) {
      this.blendEquationAlpha = e.blendEquationAlpha;
    }
    if (e.blendColor !== undefined && this.blendColor !== undefined) {
      this.blendColor.setHex(e.blendColor);
    }
    if (e.blendAlpha !== undefined) {
      this.blendAlpha = e.blendAlpha;
    }
    if (e.stencilWriteMask !== undefined) {
      this.stencilWriteMask = e.stencilWriteMask;
    }
    if (e.stencilFunc !== undefined) {
      this.stencilFunc = e.stencilFunc;
    }
    if (e.stencilRef !== undefined) {
      this.stencilRef = e.stencilRef;
    }
    if (e.stencilFuncMask !== undefined) {
      this.stencilFuncMask = e.stencilFuncMask;
    }
    if (e.stencilFail !== undefined) {
      this.stencilFail = e.stencilFail;
    }
    if (e.stencilZFail !== undefined) {
      this.stencilZFail = e.stencilZFail;
    }
    if (e.stencilZPass !== undefined) {
      this.stencilZPass = e.stencilZPass;
    }
    if (e.stencilWrite !== undefined) {
      this.stencilWrite = e.stencilWrite;
    }
    if (e.wireframe !== undefined) {
      this.wireframe = e.wireframe;
    }
    if (e.wireframeLinewidth !== undefined) {
      this.wireframeLinewidth = e.wireframeLinewidth;
    }
    if (e.wireframeLinecap !== undefined) {
      this.wireframeLinecap = e.wireframeLinecap;
    }
    if (e.wireframeLinejoin !== undefined) {
      this.wireframeLinejoin = e.wireframeLinejoin;
    }
    if (e.rotation !== undefined) {
      this.rotation = e.rotation;
    }
    if (e.linewidth !== undefined) {
      this.linewidth = e.linewidth;
    }
    if (e.linecap !== undefined) {
      this.linecap = e.linecap;
    }
    if (e.linejoin !== undefined) {
      this.linejoin = e.linejoin;
    }
    if (e.dashSize !== undefined) {
      this.dashSize = e.dashSize;
    }
    if (e.gapSize !== undefined) {
      this.gapSize = e.gapSize;
    }
    if (e.scale !== undefined) {
      this.scale = e.scale;
    }
    if (e.polygonOffset !== undefined) {
      this.polygonOffset = e.polygonOffset;
    }
    if (e.polygonOffsetFactor !== undefined) {
      this.polygonOffsetFactor = e.polygonOffsetFactor;
    }
    if (e.polygonOffsetUnits !== undefined) {
      this.polygonOffsetUnits = e.polygonOffsetUnits;
    }
    if (e.dithering !== undefined) {
      this.dithering = e.dithering;
    }
    if (e.alphaToCoverage !== undefined) {
      this.alphaToCoverage = e.alphaToCoverage;
    }
    if (e.premultipliedAlpha !== undefined) {
      this.premultipliedAlpha = e.premultipliedAlpha;
    }
    if (e.forceSinglePass !== undefined) {
      this.forceSinglePass = e.forceSinglePass;
    }
    if (e.allowOverride !== undefined) {
      this.allowOverride = e.allowOverride;
    }
    if (e.visible !== undefined) {
      this.visible = e.visible;
    }
    if (e.toneMapped !== undefined) {
      this.toneMapped = e.toneMapped;
    }
    if (e.userData !== undefined) {
      this.userData = e.userData;
    }
    if (e.vertexColors !== undefined) {
      this.vertexColors = typeof e.vertexColors == `number` ? e.vertexColors > 0 : e.vertexColors;
    }
    if (e.size !== undefined) {
      this.size = e.size;
    }
    if (e.sizeAttenuation !== undefined) {
      this.sizeAttenuation = e.sizeAttenuation;
    }
    if (e.map !== undefined) {
      this.map = t[e.map] || null;
    }
    if (e.matcap !== undefined) {
      this.matcap = t[e.matcap] || null;
    }
    if (e.alphaMap !== undefined) {
      this.alphaMap = t[e.alphaMap] || null;
    }
    if (e.bumpMap !== undefined) {
      this.bumpMap = t[e.bumpMap] || null;
    }
    if (e.bumpScale !== undefined) {
      this.bumpScale = e.bumpScale;
    }
    if (e.normalMap !== undefined) {
      this.normalMap = t[e.normalMap] || null;
    }
    if (e.normalMapType !== undefined) {
      this.normalMapType = e.normalMapType;
    }
    if (e.normalScale !== undefined) {
      let t = e.normalScale;
      if (Array.isArray(t) === false) {
        t = [t, t];
      }
      this.normalScale = new S_().fromArray(t);
    }
    if (e.displacementMap !== undefined) {
      this.displacementMap = t[e.displacementMap] || null;
    }
    if (e.displacementScale !== undefined) {
      this.displacementScale = e.displacementScale;
    }
    if (e.displacementBias !== undefined) {
      this.displacementBias = e.displacementBias;
    }
    if (e.roughnessMap !== undefined) {
      this.roughnessMap = t[e.roughnessMap] || null;
    }
    if (e.metalnessMap !== undefined) {
      this.metalnessMap = t[e.metalnessMap] || null;
    }
    if (e.emissiveMap !== undefined) {
      this.emissiveMap = t[e.emissiveMap] || null;
    }
    if (e.emissiveIntensity !== undefined) {
      this.emissiveIntensity = e.emissiveIntensity;
    }
    if (e.specularMap !== undefined) {
      this.specularMap = t[e.specularMap] || null;
    }
    if (e.specularIntensityMap !== undefined) {
      this.specularIntensityMap = t[e.specularIntensityMap] || null;
    }
    if (e.specularColorMap !== undefined) {
      this.specularColorMap = t[e.specularColorMap] || null;
    }
    if (e.envMap !== undefined) {
      this.envMap = t[e.envMap] || null;
    }
    if (e.envMapRotation !== undefined) {
      this.envMapRotation.fromArray(e.envMapRotation);
    }
    if (e.envMapIntensity !== undefined) {
      this.envMapIntensity = e.envMapIntensity;
    }
    if (e.reflectivity !== undefined) {
      this.reflectivity = e.reflectivity;
    }
    if (e.refractionRatio !== undefined) {
      this.refractionRatio = e.refractionRatio;
    }
    if (e.lightMap !== undefined) {
      this.lightMap = t[e.lightMap] || null;
    }
    if (e.lightMapIntensity !== undefined) {
      this.lightMapIntensity = e.lightMapIntensity;
    }
    if (e.aoMap !== undefined) {
      this.aoMap = t[e.aoMap] || null;
    }
    if (e.aoMapIntensity !== undefined) {
      this.aoMapIntensity = e.aoMapIntensity;
    }
    if (e.gradientMap !== undefined) {
      this.gradientMap = t[e.gradientMap] || null;
    }
    if (e.clearcoatMap !== undefined) {
      this.clearcoatMap = t[e.clearcoatMap] || null;
    }
    if (e.clearcoatRoughnessMap !== undefined) {
      this.clearcoatRoughnessMap = t[e.clearcoatRoughnessMap] || null;
    }
    if (e.clearcoatNormalMap !== undefined) {
      this.clearcoatNormalMap = t[e.clearcoatNormalMap] || null;
    }
    if (e.clearcoatNormalScale !== undefined) {
      this.clearcoatNormalScale = new S_().fromArray(e.clearcoatNormalScale);
    }
    if (e.iridescenceMap !== undefined) {
      this.iridescenceMap = t[e.iridescenceMap] || null;
    }
    if (e.iridescenceThicknessMap !== undefined) {
      this.iridescenceThicknessMap = t[e.iridescenceThicknessMap] || null;
    }
    if (e.transmissionMap !== undefined) {
      this.transmissionMap = t[e.transmissionMap] || null;
    }
    if (e.thicknessMap !== undefined) {
      this.thicknessMap = t[e.thicknessMap] || null;
    }
    if (e.anisotropyMap !== undefined) {
      this.anisotropyMap = t[e.anisotropyMap] || null;
    }
    if (e.sheenColorMap !== undefined) {
      this.sheenColorMap = t[e.sheenColorMap] || null;
    }
    if (e.sheenRoughnessMap !== undefined) {
      this.sheenRoughnessMap = t[e.sheenRoughnessMap] || null;
    }
    return this;
  }
  clone() {
    return new this.constructor().copy(this);
  }
  copy(e) {
    this.name = e.name;
    this.blending = e.blending;
    this.side = e.side;
    this.vertexColors = e.vertexColors;
    this.opacity = e.opacity;
    this.transparent = e.transparent;
    this.blendSrc = e.blendSrc;
    this.blendDst = e.blendDst;
    this.blendEquation = e.blendEquation;
    this.blendSrcAlpha = e.blendSrcAlpha;
    this.blendDstAlpha = e.blendDstAlpha;
    this.blendEquationAlpha = e.blendEquationAlpha;
    this.blendColor.copy(e.blendColor);
    this.blendAlpha = e.blendAlpha;
    this.depthFunc = e.depthFunc;
    this.depthTest = e.depthTest;
    this.depthWrite = e.depthWrite;
    this.stencilWriteMask = e.stencilWriteMask;
    this.stencilFunc = e.stencilFunc;
    this.stencilRef = e.stencilRef;
    this.stencilFuncMask = e.stencilFuncMask;
    this.stencilFail = e.stencilFail;
    this.stencilZFail = e.stencilZFail;
    this.stencilZPass = e.stencilZPass;
    this.stencilWrite = e.stencilWrite;
    let t = e.clippingPlanes;
    let n = null;
    if (t !== null) {
      let e = t.length;
      n = Array(e);
      for (let r = 0; r !== e; ++r) {
        n[r] = t[r].clone();
      }
    }
    this.clippingPlanes = n;
    this.clipIntersection = e.clipIntersection;
    this.clipShadows = e.clipShadows;
    this.shadowSide = e.shadowSide;
    this.colorWrite = e.colorWrite;
    this.precision = e.precision;
    this.polygonOffset = e.polygonOffset;
    this.polygonOffsetFactor = e.polygonOffsetFactor;
    this.polygonOffsetUnits = e.polygonOffsetUnits;
    this.dithering = e.dithering;
    this.alphaTest = e.alphaTest;
    this.alphaHash = e.alphaHash;
    this.alphaToCoverage = e.alphaToCoverage;
    this.premultipliedAlpha = e.premultipliedAlpha;
    this.forceSinglePass = e.forceSinglePass;
    this.allowOverride = e.allowOverride;
    this.visible = e.visible;
    this.toneMapped = e.toneMapped;
    this.userData = JSON.parse(JSON.stringify(e.userData));
    return this;
  }
  dispose() {
    this.dispatchEvent({
      type: `dispose`
    });
  }
  set needsUpdate(e) {
    if (e === true) {
      this.version++;
    }
  }
};
var Py = class extends Ny {
  constructor(e) {
    super();
    this.isSpriteMaterial = true;
    this.type = `SpriteMaterial`;
    this.color = new Ov(16777215);
    this.map = null;
    this.alphaMap = null;
    this.rotation = 0;
    this.sizeAttenuation = true;
    this.transparent = true;
    this.fog = true;
    this.setValues(e);
  }
  copy(e) {
    super.copy(e);
    this.color.copy(e.color);
    this.map = e.map;
    this.alphaMap = e.alphaMap;
    this.rotation = e.rotation;
    this.sizeAttenuation = e.sizeAttenuation;
    this.fog = e.fog;
    return this;
  }
};
var Fy;
var Iy = new X();
var Ly = new X();
var Ry = new X();
var zy = new S_();
var By = new S_();
var Vy = new q_();
var Hy = new X();
var Uy = new X();
var Wy = new X();
var Gy = new S_();
var Ky = new S_();
var qy = new S_();
var Jy = class extends bv {
  constructor(e = new Py()) {
    super();
    this.isSprite = true;
    this.type = `Sprite`;
    if (Fy === undefined) {
      Fy = new wy();
      let e = new Ty(new Float32Array([-0.5, -0.5, 0, 0, 0, 0.5, -0.5, 0, 1, 0, 0.5, 0.5, 0, 1, 1, -0.5, 0.5, 0, 0, 1]), 5);
      Fy.setIndex([0, 1, 2, 0, 2, 3]);
      Fy.setAttribute(`position`, new Dy(e, 3, 0, false));
      Fy.setAttribute(`uv`, new Dy(e, 2, 3, false));
    }
    this.geometry = Fy;
    this.material = e;
    this.center = new S_(0.5, 0.5);
    this.count = 1;
  }
  intersectsFrustum(e) {
    return e.intersectsSprite(this);
  }
  raycast(e, t) {
    if (e.camera === null) {
      Wg(`Sprite: "Raycaster.camera" needs to be set in order to raycast against sprites.`);
    }
    Ly.setFromMatrixScale(this.matrixWorld);
    Vy.copy(e.camera.matrixWorld);
    this.modelViewMatrix.multiplyMatrices(e.camera.matrixWorldInverse, this.matrixWorld);
    Ry.setFromMatrixPosition(this.modelViewMatrix);
    if (e.camera.isPerspectiveCamera && this.material.sizeAttenuation === false) {
      Ly.multiplyScalar(-Ry.z);
    }
    let n = this.material.rotation;
    let r;
    let i;
    if (n !== 0) {
      i = Math.cos(n);
      r = Math.sin(n);
    }
    let a = this.center;
    Yy(Hy.set(-0.5, -0.5, 0), Ry, a, Ly, r, i);
    Yy(Uy.set(0.5, -0.5, 0), Ry, a, Ly, r, i);
    Yy(Wy.set(0.5, 0.5, 0), Ry, a, Ly, r, i);
    Gy.set(0, 0);
    Ky.set(1, 0);
    qy.set(1, 1);
    let o = e.ray.intersectTriangle(Hy, Uy, Wy, false, Iy);
    if (o === null && (Yy(Uy.set(-0.5, 0.5, 0), Ry, a, Ly, r, i), Ky.set(0, 1), o = e.ray.intersectTriangle(Hy, Wy, Uy, false, Iy), o === null)) {
      return;
    }
    let s = e.ray.origin.distanceTo(Iy);
    if (!(s < e.near) && !(s > e.far)) {
      t.push({
        distance: s,
        point: Iy.clone(),
        uv: Wv.getInterpolation(Iy, Hy, Uy, Wy, Gy, Ky, qy, new S_()),
        face: null,
        object: this
      });
    }
  }
  copy(e, t) {
    super.copy(e, t);
    if (e.center !== undefined) {
      this.center.copy(e.center);
    }
    this.material = e.material;
    return this;
  }
};
function Yy(e, t, n, r, i, a) {
  zy.subVectors(e, n).addScalar(0.5).multiply(r);
  if (i === undefined) {
    By.copy(zy);
  } else {
    By.x = a * zy.x - i * zy.y;
    By.y = i * zy.x + a * zy.y;
  }
  e.copy(t);
  e.x += By.x;
  e.y += By.y;
  e.applyMatrix4(Vy);
}
var Xy = new X();
var Zy = new X();
var Qy = new X();
var $y = new X();
var eb = class {
  constructor(e = new X(), t = new X(0, 0, -1)) {
    this.origin = e;
    this.direction = t;
  }
  set(e, t) {
    this.origin.copy(e);
    this.direction.copy(t);
    return this;
  }
  copy(e) {
    this.origin.copy(e.origin);
    this.direction.copy(e.direction);
    return this;
  }
  at(e, t) {
    return t.copy(this.origin).addScaledVector(this.direction, e);
  }
  lookAt(e) {
    this.direction.copy(e).sub(this.origin).normalize();
    return this;
  }
  recast(e) {
    this.origin.copy(this.at(e, Xy));
    return this;
  }
  closestPointToPoint(e, t) {
    t.subVectors(e, this.origin);
    let n = t.dot(this.direction);
    if (n < 0) {
      return t.copy(this.origin);
    } else {
      return t.copy(this.origin).addScaledVector(this.direction, n);
    }
  }
  distanceToPoint(e) {
    return Math.sqrt(this.distanceSqToPoint(e));
  }
  distanceSqToPoint(e) {
    let t = Xy.subVectors(e, this.origin).dot(this.direction);
    if (t < 0) {
      return this.origin.distanceToSquared(e);
    } else {
      Xy.copy(this.origin).addScaledVector(this.direction, t);
      return Xy.distanceToSquared(e);
    }
  }
  distanceSqToSegment(e, t, n, r) {
    Zy.copy(e).add(t).multiplyScalar(0.5);
    Qy.copy(t).sub(e).normalize();
    $y.copy(this.origin).sub(Zy);
    let i = e.distanceTo(t) * 0.5;
    let a = -this.direction.dot(Qy);
    let o = $y.dot(this.direction);
    let s = -$y.dot(Qy);
    let c = $y.lengthSq();
    let l = Math.abs(1 - a * a);
    let u;
    let d;
    let f;
    let p;
    if (l > 0) {
      u = a * s - o;
      d = a * o - s;
      p = i * l;
      if (u >= 0) {
        if (d >= -p) {
          if (d <= p) {
            let e = 1 / l;
            u *= e;
            d *= e;
            f = u * (u + a * d + o * 2) + d * (a * u + d + s * 2) + c;
          } else {
            d = i;
            u = Math.max(0, -(a * d + o));
            f = -u * u + d * (d + s * 2) + c;
          }
        } else {
          d = -i;
          u = Math.max(0, -(a * d + o));
          f = -u * u + d * (d + s * 2) + c;
        }
      } else if (d <= -p) {
        u = Math.max(0, -(-a * i + o));
        d = u > 0 ? -i : Math.min(Math.max(-i, -s), i);
        f = -u * u + d * (d + s * 2) + c;
      } else if (d <= p) {
        u = 0;
        d = Math.min(Math.max(-i, -s), i);
        f = d * (d + s * 2) + c;
      } else {
        u = Math.max(0, -(a * i + o));
        d = u > 0 ? i : Math.min(Math.max(-i, -s), i);
        f = -u * u + d * (d + s * 2) + c;
      }
    } else {
      d = a > 0 ? -i : i;
      u = Math.max(0, -(a * d + o));
      f = -u * u + d * (d + s * 2) + c;
    }
    if (n) {
      n.copy(this.origin).addScaledVector(this.direction, u);
    }
    if (r) {
      r.copy(Zy).addScaledVector(Qy, d);
    }
    return f;
  }
  intersectSphere(e, t) {
    if (e.radius < 0) {
      return null;
    }
    Xy.subVectors(e.center, this.origin);
    let n = Xy.dot(this.direction);
    let r = Xy.dot(Xy) - n * n;
    let i = e.radius * e.radius;
    if (r > i) {
      return null;
    }
    let a = Math.sqrt(i - r);
    let o = n - a;
    let s = n + a;
    if (s < 0) {
      return null;
    } else if (o < 0) {
      return this.at(s, t);
    } else {
      return this.at(o, t);
    }
  }
  intersectsSphere(e) {
    if (e.radius < 0) {
      return false;
    } else {
      return this.distanceSqToPoint(e.center) <= e.radius * e.radius;
    }
  }
  distanceToPlane(e) {
    let t = e.normal.dot(this.direction);
    if (t === 0) {
      if (e.distanceToPoint(this.origin) === 0) {
        return 0;
      } else {
        return null;
      }
    }
    let n = -(this.origin.dot(e.normal) + e.constant) / t;
    if (n >= 0) {
      return n;
    } else {
      return null;
    }
  }
  intersectPlane(e, t) {
    let n = this.distanceToPlane(e);
    if (n === null) {
      return null;
    } else {
      return this.at(n, t);
    }
  }
  intersectsPlane(e) {
    let t = e.distanceToPoint(this.origin);
    return t === 0 || e.normal.dot(this.direction) * t < 0;
  }
  intersectBox(e, t) {
    let n;
    let r;
    let i;
    let a;
    let o;
    let s;
    let c = 1 / this.direction.x;
    let l = 1 / this.direction.y;
    let u = 1 / this.direction.z;
    let d = this.origin;
    if (c >= 0) {
      n = (e.min.x - d.x) * c;
      r = (e.max.x - d.x) * c;
    } else {
      n = (e.max.x - d.x) * c;
      r = (e.min.x - d.x) * c;
    }
    if (l >= 0) {
      i = (e.min.y - d.y) * l;
      a = (e.max.y - d.y) * l;
    } else {
      i = (e.max.y - d.y) * l;
      a = (e.min.y - d.y) * l;
    }
    if (n > a || i > r || ((i > n || isNaN(n)) && (n = i), (a < r || isNaN(r)) && (r = a), u >= 0 ? (o = (e.min.z - d.z) * u, s = (e.max.z - d.z) * u) : (o = (e.max.z - d.z) * u, s = (e.min.z - d.z) * u), n > s || o > r) || ((o > n || n !== n) && (n = o), (s < r || r !== r) && (r = s), r < 0)) {
      return null;
    } else {
      return this.at(n >= 0 ? n : r, t);
    }
  }
  intersectsBox(e) {
    return this.intersectBox(e, Xy) !== null;
  }
  intersectTriangle(e, t, n, r, i) {
    let a = this.origin;
    let o = this.direction;
    let s = o.x;
    let c = o.y;
    let l = o.z;
    let u = e.x - a.x;
    let d = e.y - a.y;
    let f = e.z - a.z;
    let p = t.x - a.x;
    let m = t.y - a.y;
    let h = t.z - a.z;
    let g = n.x - a.x;
    let _ = n.y - a.y;
    let v = n.z - a.z;
    let y = Math.abs(s);
    let b = Math.abs(c);
    let x = Math.abs(l);
    let S;
    let C;
    let w;
    let T;
    let E;
    let D;
    let O;
    let k;
    let A;
    let ee;
    let te;
    let j;
    if (y >= b && y >= x) {
      w = s;
      D = u;
      A = p;
      j = g;
      if (s >= 0) {
        S = c;
        C = l;
        T = d;
        E = f;
        O = m;
        k = h;
        ee = _;
        te = v;
      } else {
        S = l;
        C = c;
        T = f;
        E = d;
        O = h;
        k = m;
        ee = v;
        te = _;
      }
    } else if (b >= x) {
      w = c;
      D = d;
      A = m;
      j = _;
      if (c >= 0) {
        S = l;
        C = s;
        T = f;
        E = u;
        O = h;
        k = p;
        ee = v;
        te = g;
      } else {
        S = s;
        C = l;
        T = u;
        E = f;
        O = p;
        k = h;
        ee = g;
        te = v;
      }
    } else {
      w = l;
      D = f;
      A = h;
      j = v;
      if (l >= 0) {
        S = s;
        C = c;
        T = u;
        E = d;
        O = p;
        k = m;
        ee = g;
        te = _;
      } else {
        S = c;
        C = s;
        T = d;
        E = u;
        O = m;
        k = p;
        ee = _;
        te = g;
      }
    }
    if (w === 0) {
      return null;
    }
    let ne = S / w;
    let re = C / w;
    let M = 1 / w;
    let ie = T - ne * D;
    let ae = E - re * D;
    let oe = O - ne * A;
    let se = k - re * A;
    let ce = ee - ne * j;
    let le = te - re * j;
    let ue = ce * se - le * oe;
    let de = ie * le - ae * ce;
    let fe = oe * ae - se * ie;
    if (r) {
      if (ue < 0 || de < 0 || fe < 0) {
        return null;
      }
    } else if ((ue < 0 || de < 0 || fe < 0) && (ue > 0 || de > 0 || fe > 0)) {
      return null;
    }
    let pe = ue + de + fe;
    if (pe === 0) {
      return null;
    }
    let me = M * (ue * D + de * A + fe * j);
    if (pe > 0 ? me < 0 : me > 0) {
      return null;
    } else {
      return this.at(me / pe, i);
    }
  }
  applyMatrix4(e) {
    this.origin.applyMatrix4(e);
    this.direction.transformDirection(e);
    return this;
  }
  equals(e) {
    return e.origin.equals(this.origin) && e.direction.equals(this.direction);
  }
  clone() {
    return new this.constructor().copy(this);
  }
};
var tb = class extends Ny {
  constructor(e) {
    super();
    this.isMeshBasicMaterial = true;
    this.type = `MeshBasicMaterial`;
    this.color = new Ov(16777215);
    this.map = null;
    this.lightMap = null;
    this.lightMapIntensity = 1;
    this.aoMap = null;
    this.aoMapIntensity = 1;
    this.specularMap = null;
    this.alphaMap = null;
    this.envMap = null;
    this.envMapRotation = new rv();
    this.combine = 0;
    this.reflectivity = 1;
    this.refractionRatio = 0.98;
    this.wireframe = false;
    this.wireframeLinewidth = 1;
    this.wireframeLinecap = `round`;
    this.wireframeLinejoin = `round`;
    this.fog = true;
    this.setValues(e);
  }
  copy(e) {
    super.copy(e);
    this.color.copy(e.color);
    this.map = e.map;
    this.lightMap = e.lightMap;
    this.lightMapIntensity = e.lightMapIntensity;
    this.aoMap = e.aoMap;
    this.aoMapIntensity = e.aoMapIntensity;
    this.specularMap = e.specularMap;
    this.alphaMap = e.alphaMap;
    this.envMap = e.envMap;
    this.envMapRotation.copy(e.envMapRotation);
    this.combine = e.combine;
    this.reflectivity = e.reflectivity;
    this.refractionRatio = e.refractionRatio;
    this.wireframe = e.wireframe;
    this.wireframeLinewidth = e.wireframeLinewidth;
    this.wireframeLinecap = e.wireframeLinecap;
    this.wireframeLinejoin = e.wireframeLinejoin;
    this.fog = e.fog;
    return this;
  }
};
var nb = new q_();
var rb = new eb();
var ib = new gy();
var ab = new X();
var ob = new X();
var sb = new X();
var cb = new X();
var lb = new X();
var ub = new X();
var db = new X();
var fb = new X();
var pb = class extends bv {
  constructor(e = new wy(), t = new tb()) {
    super();
    this.isMesh = true;
    this.type = `Mesh`;
    this.geometry = e;
    this.material = t;
    this.morphTargetDictionary = undefined;
    this.morphTargetInfluences = undefined;
    this.count = 1;
    this.updateMorphTargets();
  }
  copy(e, t) {
    super.copy(e, t);
    if (e.morphTargetInfluences !== undefined) {
      this.morphTargetInfluences = e.morphTargetInfluences.slice();
    }
    if (e.morphTargetDictionary !== undefined) {
      this.morphTargetDictionary = Object.assign({}, e.morphTargetDictionary);
    }
    this.material = Array.isArray(e.material) ? e.material.slice() : e.material;
    this.geometry = e.geometry;
    return this;
  }
  updateMorphTargets() {
    let e = this.geometry.morphAttributes;
    let t = Object.keys(e);
    if (t.length > 0) {
      let n = e[t[0]];
      if (n !== undefined) {
        this.morphTargetInfluences = [];
        this.morphTargetDictionary = {};
        for (let e = 0, t = n.length; e < t; e++) {
          let t = n[e].name || String(e);
          this.morphTargetInfluences.push(0);
          this.morphTargetDictionary[t] = e;
        }
      }
    }
  }
  getVertexPosition(e, t) {
    let n = this.geometry;
    let r = n.attributes.position;
    let i = n.morphAttributes.position;
    let a = n.morphTargetsRelative;
    t.fromBufferAttribute(r, e);
    let o = this.morphTargetInfluences;
    if (i && o) {
      ub.set(0, 0, 0);
      for (let n = 0, r = i.length; n < r; n++) {
        let r = o[n];
        let s = i[n];
        if (r !== 0) {
          lb.fromBufferAttribute(s, e);
          if (a) {
            ub.addScaledVector(lb, r);
          } else {
            ub.addScaledVector(lb.sub(t), r);
          }
        }
      }
      t.add(ub);
    }
    return t;
  }
  intersectsFrustum(e) {
    return e.intersectsObject(this);
  }
  raycast(e, t) {
    let n = this.geometry;
    let r = this.material;
    let i = this.matrixWorld;
    if (r !== undefined) {
      if (n.boundingSphere === null) {
        n.computeBoundingSphere();
      }
      ib.copy(n.boundingSphere);
      ib.applyMatrix4(i);
      rb.copy(e.ray).recast(e.near);
      if (ib.containsPoint(rb.origin) !== false || rb.intersectSphere(ib, ab) !== null && !(rb.origin.distanceToSquared(ab) > (e.far - e.near) ** 2)) {
        nb.copy(i).invert();
        rb.copy(e.ray).applyMatrix4(nb);
        if (n.boundingBox === null || rb.intersectsBox(n.boundingBox) !== false) {
          this._computeIntersections(e, t, rb);
        }
      }
    }
  }
  _computeIntersections(e, t, n) {
    let r;
    let i = this.geometry;
    let a = this.material;
    let o = i.index;
    let s = i.attributes.position;
    let c = i.attributes.uv;
    let l = i.attributes.uv1;
    let u = i.attributes.normal;
    let d = i.groups;
    let f = i.drawRange;
    if (o !== null) {
      if (Array.isArray(a)) {
        for (let i = 0, s = d.length; i < s; i++) {
          let s = d[i];
          let p = a[s.materialIndex];
          let m = Math.max(s.start, f.start);
          let h = Math.min(o.count, Math.min(s.start + s.count, f.start + f.count));
          for (let i = m, a = h; i < a; i += 3) {
            let a = o.getX(i);
            let d = o.getX(i + 1);
            let f = o.getX(i + 2);
            r = hb(this, p, e, n, c, l, u, a, d, f);
            if (r) {
              r.faceIndex = Math.floor(i / 3);
              r.face.materialIndex = s.materialIndex;
              t.push(r);
            }
          }
        }
      } else {
        let i = Math.max(0, f.start);
        let s = Math.min(o.count, f.start + f.count);
        for (let d = i, f = s; d < f; d += 3) {
          let i = o.getX(d);
          let s = o.getX(d + 1);
          let f = o.getX(d + 2);
          r = hb(this, a, e, n, c, l, u, i, s, f);
          if (r) {
            r.faceIndex = Math.floor(d / 3);
            t.push(r);
          }
        }
      }
    } else if (s !== undefined) {
      if (Array.isArray(a)) {
        for (let i = 0, o = d.length; i < o; i++) {
          let o = d[i];
          let p = a[o.materialIndex];
          let m = Math.max(o.start, f.start);
          let h = Math.min(s.count, Math.min(o.start + o.count, f.start + f.count));
          for (let i = m, a = h; i < a; i += 3) {
            let a = i;
            let s = i + 1;
            let d = i + 2;
            r = hb(this, p, e, n, c, l, u, a, s, d);
            if (r) {
              r.faceIndex = Math.floor(i / 3);
              r.face.materialIndex = o.materialIndex;
              t.push(r);
            }
          }
        }
      } else {
        let i = Math.max(0, f.start);
        let o = Math.min(s.count, f.start + f.count);
        for (let s = i, d = o; s < d; s += 3) {
          let i = s;
          let o = s + 1;
          let d = s + 2;
          r = hb(this, a, e, n, c, l, u, i, o, d);
          if (r) {
            r.faceIndex = Math.floor(s / 3);
            t.push(r);
          }
        }
      }
    }
  }
};
function mb(e, t, n, r, i, a, o, s) {
  let c;
  c = t.side === 1 ? r.intersectTriangle(o, a, i, true, s) : r.intersectTriangle(i, a, o, t.side === 0, s);
  if (c === null) {
    return null;
  }
  fb.copy(s);
  fb.applyMatrix4(e.matrixWorld);
  let l = n.ray.origin.distanceTo(fb);
  if (l < n.near || l > n.far) {
    return null;
  } else {
    return {
      distance: l,
      point: fb.clone(),
      object: e
    };
  }
}
function hb(e, t, n, r, i, a, o, s, c, l) {
  e.getVertexPosition(s, ob);
  e.getVertexPosition(c, sb);
  e.getVertexPosition(l, cb);
  let u = mb(e, t, n, r, ob, sb, cb, db);
  if (u) {
    let e = new X();
    Wv.getBarycoord(db, ob, sb, cb, e);
    if (i) {
      u.uv = Wv.getInterpolatedAttribute(i, s, c, l, e, new S_());
    }
    if (a) {
      u.uv1 = Wv.getInterpolatedAttribute(a, s, c, l, e, new S_());
    }
    if (o) {
      u.normal = Wv.getInterpolatedAttribute(o, s, c, l, e, new X());
      if (u.normal.dot(r.direction) > 0) {
        u.normal.multiplyScalar(-1);
      }
    }
    let t = {
      a: s,
      b: c,
      c: l,
      normal: new X(),
      materialIndex: 0
    };
    Wv.getNormal(ob, sb, cb, t.normal);
    u.face = t;
    u.barycoord = e;
  }
  return u;
}
var gb = class extends V_ {
  constructor(e = null, t = 1, n = 1, r, i, a, o, s, c = uh, l = uh, u, d) {
    super(null, a, o, s, c, l, r, i, u, d);
    this.isDataTexture = true;
    this.image = {
      data: e,
      width: t,
      height: n
    };
    this.generateMipmaps = false;
    this.flipY = false;
    this.unpackAlignment = 1;
  }
};
var _b = new gy();
var vb = new S_(0.5, 0.5);
var yb = new X();
var bb = class {
  constructor(e = new jy(), t = new jy(), n = new jy(), r = new jy(), i = new jy(), a = new jy()) {
    this.planes = [e, t, n, r, i, a];
  }
  set(e, t, n, r, i, a) {
    let o = this.planes;
    o[0].copy(e);
    o[1].copy(t);
    o[2].copy(n);
    o[3].copy(r);
    o[4].copy(i);
    o[5].copy(a);
    return this;
  }
  copy(e) {
    let t = this.planes;
    for (let n = 0; n < 6; n++) {
      t[n].copy(e.planes[n]);
    }
    return this;
  }
  setFromProjectionMatrix(e, t = Fg, n = false) {
    let r = this.planes;
    let i = e.elements;
    let a = i[0];
    let o = i[1];
    let s = i[2];
    let c = i[3];
    let l = i[4];
    let u = i[5];
    let d = i[6];
    let f = i[7];
    let p = i[8];
    let m = i[9];
    let h = i[10];
    let g = i[11];
    let _ = i[12];
    let v = i[13];
    let y = i[14];
    let b = i[15];
    r[0].setComponents(c - a, f - l, g - p, b - _).normalize();
    r[1].setComponents(c + a, f + l, g + p, b + _).normalize();
    r[2].setComponents(c + o, f + u, g + m, b + v).normalize();
    r[3].setComponents(c - o, f - u, g - m, b - v).normalize();
    if (n) {
      r[4].setComponents(s, d, h, y).normalize();
      r[5].setComponents(c - s, f - d, g - h, b - y).normalize();
    } else {
      r[4].setComponents(c - s, f - d, g - h, b - y).normalize();
      if (t === 2000) {
        r[5].setComponents(c + s, f + d, g + h, b + y).normalize();
      } else if (t === 2001) {
        r[5].setComponents(s, d, h, y).normalize();
      } else {
        throw Error(`THREE.Frustum.setFromProjectionMatrix(): Invalid coordinate system: ${t}`);
      }
    }
    return this;
  }
  intersectsObject(e) {
    if (e.boundingSphere !== undefined) {
      if (e.boundingSphere === null) {
        e.computeBoundingSphere();
      }
      _b.copy(e.boundingSphere).applyMatrix4(e.matrixWorld);
    } else {
      let t = e.geometry;
      if (t.boundingSphere === null) {
        t.computeBoundingSphere();
      }
      _b.copy(t.boundingSphere).applyMatrix4(e.matrixWorld);
    }
    return this.intersectsSphere(_b);
  }
  intersectsSprite(e) {
    _b.center.set(0, 0, 0);
    _b.radius = 0.7071067811865476 + vb.distanceTo(e.center);
    _b.applyMatrix4(e.matrixWorld);
    return this.intersectsSphere(_b);
  }
  intersectsSphere(e) {
    let t = this.planes;
    let n = e.center;
    let r = -e.radius;
    for (let e = 0; e < 6; e++) {
      if (t[e].distanceToPoint(n) < r) {
        return false;
      }
    }
    return true;
  }
  intersectsBox(e) {
    let t = this.planes;
    for (let n = 0; n < 6; n++) {
      let r = t[n];
      yb.x = r.normal.x > 0 ? e.max.x : e.min.x;
      yb.y = r.normal.y > 0 ? e.max.y : e.min.y;
      yb.z = r.normal.z > 0 ? e.max.z : e.min.z;
      if (r.distanceToPoint(yb) < 0) {
        return false;
      }
    }
    return true;
  }
  containsPoint(e) {
    let t = this.planes;
    for (let n = 0; n < 6; n++) {
      if (t[n].distanceToPoint(e) < 0) {
        return false;
      }
    }
    return true;
  }
  clone() {
    return new this.constructor().copy(this);
  }
};
var xb = class extends Ny {
  constructor(e) {
    super();
    this.isLineBasicMaterial = true;
    this.type = `LineBasicMaterial`;
    this.color = new Ov(16777215);
    this.map = null;
    this.linewidth = 1;
    this.linecap = `round`;
    this.linejoin = `round`;
    this.fog = true;
    this.setValues(e);
  }
  copy(e) {
    super.copy(e);
    this.color.copy(e.color);
    this.map = e.map;
    this.linewidth = e.linewidth;
    this.linecap = e.linecap;
    this.linejoin = e.linejoin;
    this.fog = e.fog;
    return this;
  }
};
var Sb = new X();
var Cb = new X();
var wb = new q_();
var Tb = new eb();
var Eb = new gy();
var Db = new X();
var Ob = new X();
var kb = class extends bv {
  constructor(e = new wy(), t = new xb()) {
    super();
    this.isLine = true;
    this.type = `Line`;
    this.geometry = e;
    this.material = t;
    this.morphTargetDictionary = undefined;
    this.morphTargetInfluences = undefined;
    this.updateMorphTargets();
  }
  copy(e, t) {
    super.copy(e, t);
    this.material = Array.isArray(e.material) ? e.material.slice() : e.material;
    this.geometry = e.geometry;
    return this;
  }
  computeLineDistances() {
    let e = this.geometry;
    if (e.index === null) {
      let t = e.attributes.position;
      let n = [0];
      for (let e = 1, r = t.count; e < r; e++) {
        Sb.fromBufferAttribute(t, e - 1);
        Cb.fromBufferAttribute(t, e);
        n[e] = n[e - 1];
        n[e] += Sb.distanceTo(Cb);
      }
      e.setAttribute(`lineDistance`, new fy(n, 1));
    } else {
      Ug(`Line.computeLineDistances(): Computation only possible with non-indexed BufferGeometry.`);
    }
    return this;
  }
  intersectsFrustum(e) {
    return e.intersectsObject(this);
  }
  raycast(e, t) {
    let n = this.geometry;
    let r = this.matrixWorld;
    let i = e.params.Line.threshold;
    let a = n.drawRange;
    if (n.boundingSphere === null) {
      n.computeBoundingSphere();
    }
    Eb.copy(n.boundingSphere);
    Eb.applyMatrix4(r);
    Eb.radius += i;
    if (e.ray.intersectsSphere(Eb) === false) {
      return;
    }
    wb.copy(r).invert();
    Tb.copy(e.ray).applyMatrix4(wb);
    let o = i / ((this.scale.x + this.scale.y + this.scale.z) / 3);
    let s = o * o;
    let c = this.isLineSegments ? 2 : 1;
    let l = n.index;
    let u = n.attributes.position;
    if (l !== null) {
      let n = Math.max(0, a.start);
      let r = Math.min(l.count, a.start + a.count);
      for (let i = n, a = r - 1; i < a; i += c) {
        let n = l.getX(i);
        let r = l.getX(i + 1);
        let a = Ab(this, e, Tb, s, n, r, i);
        if (a) {
          t.push(a);
        }
      }
      if (this.isLineLoop) {
        let i = l.getX(r - 1);
        let a = l.getX(n);
        let o = Ab(this, e, Tb, s, i, a, r - 1);
        if (o) {
          t.push(o);
        }
      }
    } else {
      let n = Math.max(0, a.start);
      let r = Math.min(u.count, a.start + a.count);
      for (let i = n, a = r - 1; i < a; i += c) {
        let n = Ab(this, e, Tb, s, i, i + 1, i);
        if (n) {
          t.push(n);
        }
      }
      if (this.isLineLoop) {
        let i = Ab(this, e, Tb, s, r - 1, n, r - 1);
        if (i) {
          t.push(i);
        }
      }
    }
  }
  updateMorphTargets() {
    let e = this.geometry.morphAttributes;
    let t = Object.keys(e);
    if (t.length > 0) {
      let n = e[t[0]];
      if (n !== undefined) {
        this.morphTargetInfluences = [];
        this.morphTargetDictionary = {};
        for (let e = 0, t = n.length; e < t; e++) {
          let t = n[e].name || String(e);
          this.morphTargetInfluences.push(0);
          this.morphTargetDictionary[t] = e;
        }
      }
    }
  }
};
function Ab(e, t, n, r, i, a, o) {
  let s = e.geometry.attributes.position;
  Sb.fromBufferAttribute(s, i);
  Cb.fromBufferAttribute(s, a);
  if (n.distanceSqToSegment(Sb, Cb, Db, Ob) > r) {
    return;
  }
  Db.applyMatrix4(e.matrixWorld);
  let c = t.ray.origin.distanceTo(Db);
  if (!(c < t.near) && !(c > t.far)) {
    return {
      distance: c,
      point: Ob.clone().applyMatrix4(e.matrixWorld),
      index: o,
      face: null,
      faceIndex: null,
      barycoord: null,
      object: e
    };
  }
}
var jb = new X();
var Mb = new X();
var Nb = class extends kb {
  constructor(e, t) {
    super(e, t);
    this.isLineSegments = true;
    this.type = `LineSegments`;
  }
  computeLineDistances() {
    let e = this.geometry;
    if (e.index === null) {
      let t = e.attributes.position;
      let n = [];
      for (let e = 0, r = t.count; e < r; e += 2) {
        jb.fromBufferAttribute(t, e);
        Mb.fromBufferAttribute(t, e + 1);
        n[e] = e === 0 ? 0 : n[e - 1];
        n[e + 1] = n[e] + jb.distanceTo(Mb);
      }
      e.setAttribute(`lineDistance`, new fy(n, 1));
    } else {
      Ug(`LineSegments.computeLineDistances(): Computation only possible with non-indexed BufferGeometry.`);
    }
    return this;
  }
};
var Pb = class extends V_ {
  constructor(e = [], t = 301, n, r, i, a, o, s, c, l) {
    super(e, t, n, r, i, a, o, s, c, l);
    this.isCubeTexture = true;
    this.flipY = false;
  }
  get images() {
    return this.image;
  }
  set images(e) {
    this.image = e;
  }
};
var Fb = class extends V_ {
  constructor(e, t, n, r, i, a, o, s, c) {
    super(e, t, n, r, i, a, o, s, c);
    this.isCanvasTexture = true;
    this.needsUpdate = true;
  }
};
var Ib = class extends V_ {
  constructor(e, t, n = xh, r, i, a, o = uh, s = uh, c, l = Mh, u = 1) {
    if (l !== 1026 && l !== 1027) {
      throw Error(`THREE.DepthTexture: format must be either THREE.DepthFormat or THREE.DepthStencilFormat`);
    }
    super({
      width: e,
      height: t,
      depth: u
    }, r, i, a, o, s, l, n, c);
    this.isDepthTexture = true;
    this.flipY = false;
    this.generateMipmaps = false;
    this.compareFunction = null;
  }
  copy(e) {
    super.copy(e);
    this.source = new L_(Object.assign({}, e.image));
    this.compareFunction = e.compareFunction;
    return this;
  }
  toJSON(e) {
    let t = super.toJSON(e);
    t.compareFunction = this.compareFunction;
    return t;
  }
};
var Lb = class extends Ib {
  constructor(e, t = xh, n = 301, r, i, a = uh, o = uh, s, c = Mh) {
    let l = {
      width: e,
      height: e,
      depth: 1
    };
    let u = [l, l, l, l, l, l];
    super(e, e, t, n, r, i, a, o, s, c);
    this.image = u;
    this.isCubeDepthTexture = true;
    this.isCubeTexture = true;
  }
  get images() {
    return this.image;
  }
  set images(e) {
    this.image = e;
  }
};
var Rb = class extends V_ {
  constructor(e = null) {
    super();
    this.sourceTexture = e;
    this.isExternalTexture = true;
  }
  copy(e) {
    super.copy(e);
    this.sourceTexture = e.sourceTexture;
    return this;
  }
};
var zb = class e extends wy {
  constructor(e = 1, t = 1, n = 1, r = 1, i = 1, a = 1) {
    super();
    this.type = `BoxGeometry`;
    this.parameters = {
      width: e,
      height: t,
      depth: n,
      widthSegments: r,
      heightSegments: i,
      depthSegments: a
    };
    let o = this;
    r = Math.floor(r);
    i = Math.floor(i);
    a = Math.floor(a);
    let s = [];
    let c = [];
    let l = [];
    let u = [];
    let d = 0;
    let f = 0;
    p(`z`, `y`, `x`, -1, -1, n, t, e, a, i, 0);
    p(`z`, `y`, `x`, 1, -1, n, t, -e, a, i, 1);
    p(`x`, `z`, `y`, 1, 1, e, n, t, r, a, 2);
    p(`x`, `z`, `y`, 1, -1, e, n, -t, r, a, 3);
    p(`x`, `y`, `z`, 1, -1, e, t, n, r, i, 4);
    p(`x`, `y`, `z`, -1, -1, e, t, -n, r, i, 5);
    this.setIndex(s);
    this.setAttribute(`position`, new fy(c, 3));
    this.setAttribute(`normal`, new fy(l, 3));
    this.setAttribute(`uv`, new fy(u, 2));
    function p(e, t, n, r, i, a, p, m, h, g, _) {
      let v = a / h;
      let y = p / g;
      let b = a / 2;
      let x = p / 2;
      let S = m / 2;
      let C = h + 1;
      let w = g + 1;
      let T = 0;
      let E = 0;
      let D = new X();
      for (let a = 0; a < w; a++) {
        let o = a * y - x;
        for (let s = 0; s < C; s++) {
          D[e] = (s * v - b) * r;
          D[t] = o * i;
          D[n] = S;
          c.push(D.x, D.y, D.z);
          D[e] = 0;
          D[t] = 0;
          D[n] = m > 0 ? 1 : -1;
          l.push(D.x, D.y, D.z);
          u.push(s / h);
          u.push(1 - a / g);
          T += 1;
        }
      }
      for (let e = 0; e < g; e++) {
        for (let t = 0; t < h; t++) {
          let n = d + t + C * e;
          let r = d + t + C * (e + 1);
          let i = d + (t + 1) + C * (e + 1);
          let a = d + (t + 1) + C * e;
          s.push(n, r, a);
          s.push(r, i, a);
          E += 6;
        }
      }
      o.addGroup(f, E, _);
      f += E;
      d += T;
    }
  }
  copy(e) {
    super.copy(e);
    this.parameters = Object.assign({}, e.parameters);
    return this;
  }
  static fromJSON(t) {
    return new e(t.width, t.height, t.depth, t.widthSegments, t.heightSegments, t.depthSegments);
  }
};
var Bb = class e extends wy {
  constructor(e = 1, t = 1, n = 1, r = 32, i = 1, a = false, o = 0, s = Math.PI * 2) {
    super();
    this.type = `CylinderGeometry`;
    this.parameters = {
      radiusTop: e,
      radiusBottom: t,
      height: n,
      radialSegments: r,
      heightSegments: i,
      openEnded: a,
      thetaStart: o,
      thetaLength: s
    };
    let c = this;
    r = Math.floor(r);
    i = Math.floor(i);
    let l = [];
    let u = [];
    let d = [];
    let f = [];
    let p = 0;
    let m = [];
    let h = n / 2;
    let g = 0;
    _();
    if (a === false) {
      if (e > 0) {
        v(true);
      }
      if (t > 0) {
        v(false);
      }
    }
    this.setIndex(l);
    this.setAttribute(`position`, new fy(u, 3));
    this.setAttribute(`normal`, new fy(d, 3));
    this.setAttribute(`uv`, new fy(f, 2));
    function _() {
      let a = new X();
      let _ = new X();
      let v = 0;
      let y = (t - e) / n;
      for (let c = 0; c <= i; c++) {
        let l = [];
        let g = c / i;
        let v = g * (t - e) + e;
        for (let e = 0; e <= r; e++) {
          let t = e / r;
          let i = t * s + o;
          let c = Math.sin(i);
          let m = Math.cos(i);
          _.x = v * c;
          _.y = -g * n + h;
          _.z = v * m;
          u.push(_.x, _.y, _.z);
          a.set(c, y, m).normalize();
          d.push(a.x, a.y, a.z);
          f.push(t, 1 - g);
          l.push(p++);
        }
        m.push(l);
      }
      for (let n = 0; n < r; n++) {
        for (let r = 0; r < i; r++) {
          let a = m[r][n];
          let o = m[r + 1][n];
          let s = m[r + 1][n + 1];
          let c = m[r][n + 1];
          if (e > 0 || r !== 0) {
            l.push(a, o, c);
            v += 3;
          }
          if (t > 0 || r !== i - 1) {
            l.push(o, s, c);
            v += 3;
          }
        }
      }
      c.addGroup(g, v, 0);
      g += v;
    }
    function v(n) {
      let i = p;
      let a = new S_();
      let m = new X();
      let _ = 0;
      let v = n === true ? e : t;
      let y = n === true ? 1 : -1;
      for (let e = 1; e <= r; e++) {
        u.push(0, h * y, 0);
        d.push(0, y, 0);
        f.push(0.5, 0.5);
        p++;
      }
      let b = p;
      for (let e = 0; e <= r; e++) {
        let t = e / r * s + o;
        let n = Math.cos(t);
        let i = Math.sin(t);
        m.x = v * i;
        m.y = h * y;
        m.z = v * n;
        u.push(m.x, m.y, m.z);
        d.push(0, y, 0);
        a.x = n * 0.5 + 0.5;
        a.y = i * 0.5 * y + 0.5;
        f.push(a.x, a.y);
        p++;
      }
      for (let e = 0; e < r; e++) {
        let t = i + e;
        let r = b + e;
        if (n === true) {
          l.push(r, r + 1, t);
        } else {
          l.push(r + 1, r, t);
        }
        _ += 3;
      }
      c.addGroup(g, _, n === true ? 1 : 2);
      g += _;
    }
  }
  copy(e) {
    super.copy(e);
    this.parameters = Object.assign({}, e.parameters);
    return this;
  }
  static fromJSON(t) {
    return new e(t.radiusTop, t.radiusBottom, t.height, t.radialSegments, t.heightSegments, t.openEnded, t.thetaStart, t.thetaLength);
  }
};
var Vb = new X();
var Hb = new X();
var Ub = new X();
var Wb = new Wv();
var Gb = class extends wy {
  constructor(e = null, t = 1) {
    super();
    this.type = `EdgesGeometry`;
    this.parameters = {
      geometry: e,
      thresholdAngle: t
    };
    if (e !== null) {
      let n = 10000;
      let r = Math.cos(Zg * t);
      let i = e.getIndex();
      let a = e.getAttribute(`position`);
      let o = i ? i.count : a.count;
      let s = [0, 0, 0];
      let c = [`a`, `b`, `c`];
      let l = [,,,];
      let u = {};
      let d = [];
      for (let e = 0; e < o; e += 3) {
        if (i) {
          s[0] = i.getX(e);
          s[1] = i.getX(e + 1);
          s[2] = i.getX(e + 2);
        } else {
          s[0] = e;
          s[1] = e + 1;
          s[2] = e + 2;
        }
        let {
          a: t,
          b: o,
          c: f
        } = Wb;
        t.fromBufferAttribute(a, s[0]);
        o.fromBufferAttribute(a, s[1]);
        f.fromBufferAttribute(a, s[2]);
        Wb.getNormal(Ub);
        l[0] = `${Math.round(t.x * n)},${Math.round(t.y * n)},${Math.round(t.z * n)}`;
        l[1] = `${Math.round(o.x * n)},${Math.round(o.y * n)},${Math.round(o.z * n)}`;
        l[2] = `${Math.round(f.x * n)},${Math.round(f.y * n)},${Math.round(f.z * n)}`;
        if (l[0] !== l[1] && l[1] !== l[2] && l[2] !== l[0]) {
          for (let e = 0; e < 3; e++) {
            let t = (e + 1) % 3;
            let n = l[e];
            let i = l[t];
            let a = Wb[c[e]];
            let o = Wb[c[t]];
            let f = `${n}_${i}`;
            let p = `${i}_${n}`;
            if (p in u && u[p]) {
              if (Ub.dot(u[p].normal) <= r) {
                d.push(a.x, a.y, a.z);
                d.push(o.x, o.y, o.z);
              }
              u[p] = null;
            } else if (!(f in u)) {
              u[f] = {
                index0: s[e],
                index1: s[t],
                normal: Ub.clone()
              };
            }
          }
        }
      }
      for (let e in u) {
        if (u[e]) {
          let {
            index0: t,
            index1: n
          } = u[e];
          Vb.fromBufferAttribute(a, t);
          Hb.fromBufferAttribute(a, n);
          d.push(Vb.x, Vb.y, Vb.z);
          d.push(Hb.x, Hb.y, Hb.z);
        }
      }
      this.setAttribute(`position`, new fy(d, 3));
    }
  }
  copy(e) {
    super.copy(e);
    this.parameters = Object.assign({}, e.parameters);
    return this;
  }
};
var Kb = class e extends wy {
  constructor(e = 1, t = 1, n = 1, r = 1) {
    super();
    this.type = `PlaneGeometry`;
    this.parameters = {
      width: e,
      height: t,
      widthSegments: n,
      heightSegments: r
    };
    let i = e / 2;
    let a = t / 2;
    let o = Math.floor(n);
    let s = Math.floor(r);
    let c = o + 1;
    let l = s + 1;
    let u = e / o;
    let d = t / s;
    let f = [];
    let p = [];
    let m = [];
    let h = [];
    for (let e = 0; e < l; e++) {
      let t = e * d - a;
      for (let n = 0; n < c; n++) {
        let r = n * u - i;
        p.push(r, -t, 0);
        m.push(0, 0, 1);
        h.push(n / o);
        h.push(1 - e / s);
      }
    }
    for (let e = 0; e < s; e++) {
      for (let t = 0; t < o; t++) {
        let n = t + c * e;
        let r = t + c * (e + 1);
        let i = t + 1 + c * (e + 1);
        let a = t + 1 + c * e;
        f.push(n, r, a);
        f.push(r, i, a);
      }
    }
    this.setIndex(f);
    this.setAttribute(`position`, new fy(p, 3));
    this.setAttribute(`normal`, new fy(m, 3));
    this.setAttribute(`uv`, new fy(h, 2));
  }
  copy(e) {
    super.copy(e);
    this.parameters = Object.assign({}, e.parameters);
    return this;
  }
  static fromJSON(t) {
    return new e(t.width, t.height, t.widthSegments, t.heightSegments);
  }
};
var qb = class e extends wy {
  constructor(e = 1, t = 0.4, n = 12, r = 48, i = Math.PI * 2, a = 0, o = Math.PI * 2) {
    super();
    this.type = `TorusGeometry`;
    this.parameters = {
      radius: e,
      tube: t,
      radialSegments: n,
      tubularSegments: r,
      arc: i,
      thetaStart: a,
      thetaLength: o
    };
    n = Math.floor(n);
    r = Math.floor(r);
    let s = [];
    let c = [];
    let l = [];
    let u = [];
    let d = new X();
    let f = new X();
    let p = new X();
    for (let s = 0; s <= n; s++) {
      let m = a + s / n * o;
      for (let a = 0; a <= r; a++) {
        let o = a / r * i;
        f.x = (e + t * Math.cos(m)) * Math.cos(o);
        f.y = (e + t * Math.cos(m)) * Math.sin(o);
        f.z = t * Math.sin(m);
        c.push(f.x, f.y, f.z);
        d.x = e * Math.cos(o);
        d.y = e * Math.sin(o);
        p.subVectors(f, d).normalize();
        l.push(p.x, p.y, p.z);
        u.push(a / r);
        u.push(s / n);
      }
    }
    for (let e = 1; e <= n; e++) {
      for (let t = 1; t <= r; t++) {
        let n = (r + 1) * e + t - 1;
        let i = (r + 1) * (e - 1) + t - 1;
        let a = (r + 1) * (e - 1) + t;
        let o = (r + 1) * e + t;
        s.push(n, i, o);
        s.push(i, a, o);
      }
    }
    this.setIndex(s);
    this.setAttribute(`position`, new fy(c, 3));
    this.setAttribute(`normal`, new fy(l, 3));
    this.setAttribute(`uv`, new fy(u, 2));
  }
  copy(e) {
    super.copy(e);
    this.parameters = Object.assign({}, e.parameters);
    return this;
  }
  static fromJSON(t) {
    return new e(t.radius, t.tube, t.radialSegments, t.tubularSegments, t.arc, t.thetaStart, t.thetaLength);
  }
};
function Jb(e) {
  let t = {};
  for (let n in e) {
    t[n] = {};
    for (let r in e[n]) {
      let i = e[n][r];
      if (Xb(i)) {
        if (i.isRenderTargetTexture) {
          Ug(`UniformsUtils: Textures of render targets cannot be cloned via cloneUniforms() or mergeUniforms().`);
          t[n][r] = null;
        } else {
          t[n][r] = i.clone();
        }
      } else if (Array.isArray(i)) {
        if (Xb(i[0])) {
          let e = [];
          for (let t = 0, n = i.length; t < n; t++) {
            e[t] = i[t].clone();
          }
          t[n][r] = e;
        } else {
          t[n][r] = i.slice();
        }
      } else {
        t[n][r] = i;
      }
    }
  }
  return t;
}
function Yb(e) {
  let t = {};
  for (let n = 0; n < e.length; n++) {
    let r = Jb(e[n]);
    for (let e in r) {
      t[e] = r[e];
    }
  }
  return t;
}
function Xb(e) {
  return e && (e.isColor || e.isMatrix3 || e.isMatrix4 || e.isVector2 || e.isVector3 || e.isVector4 || e.isTexture || e.isQuaternion);
}
function Zb(e) {
  let t = [];
  for (let n = 0; n < e.length; n++) {
    t.push(e[n].clone());
  }
  return t;
}
function Qb(e) {
  let t = e.getRenderTarget();
  if (t === null) {
    return e.outputColorSpace;
  } else if (t.isXRRenderTarget === true) {
    return t.texture.colorSpace;
  } else {
    return j_.workingColorSpace;
  }
}
var $b = {
  clone: Jb,
  merge: Yb
};
var ex = `void main() {
	gl_Position = projectionMatrix * modelViewMatrix * vec4( position, 1.0 );
}`;
var tx = `void main() {
	gl_FragColor = vec4( 1.0, 0.0, 0.0, 1.0 );
}`;
var nx = class extends Ny {
  constructor(e) {
    super();
    this.isShaderMaterial = true;
    this.type = `ShaderMaterial`;
    this.defines = {};
    this.uniforms = {};
    this.uniformsGroups = [];
    this.vertexShader = ex;
    this.fragmentShader = tx;
    this.linewidth = 1;
    this.wireframe = false;
    this.wireframeLinewidth = 1;
    this.fog = false;
    this.lights = false;
    this.clipping = false;
    this.forceSinglePass = true;
    this.extensions = {
      clipCullDistance: false,
      multiDraw: false
    };
    this.defaultAttributeValues = {
      color: [1, 1, 1],
      uv: [0, 0],
      uv1: [0, 0]
    };
    this.index0AttributeName = undefined;
    this.uniformsNeedUpdate = false;
    this.glslVersion = null;
    if (e !== undefined) {
      this.setValues(e);
    }
  }
  copy(e) {
    super.copy(e);
    this.fragmentShader = e.fragmentShader;
    this.vertexShader = e.vertexShader;
    this.uniforms = Jb(e.uniforms);
    this.uniformsGroups = Zb(e.uniformsGroups);
    this.defines = Object.assign({}, e.defines);
    this.wireframe = e.wireframe;
    this.wireframeLinewidth = e.wireframeLinewidth;
    this.fog = e.fog;
    this.lights = e.lights;
    this.clipping = e.clipping;
    this.extensions = Object.assign({}, e.extensions);
    this.glslVersion = e.glslVersion;
    this.defaultAttributeValues = Object.assign({}, e.defaultAttributeValues);
    this.index0AttributeName = e.index0AttributeName;
    this.uniformsNeedUpdate = e.uniformsNeedUpdate;
    return this;
  }
  toJSON(e) {
    let t = super.toJSON(e);
    t.glslVersion = this.glslVersion;
    t.uniforms = {};
    for (let n in this.uniforms) {
      let r = this.uniforms[n].value;
      if (r && r.isTexture) {
        t.uniforms[n] = {
          type: `t`,
          value: r.toJSON(e).uuid
        };
      } else if (r && r.isColor) {
        t.uniforms[n] = {
          type: `c`,
          value: r.getHex()
        };
      } else if (r && r.isVector2) {
        t.uniforms[n] = {
          type: `v2`,
          value: r.toArray()
        };
      } else if (r && r.isVector3) {
        t.uniforms[n] = {
          type: `v3`,
          value: r.toArray()
        };
      } else if (r && r.isVector4) {
        t.uniforms[n] = {
          type: `v4`,
          value: r.toArray()
        };
      } else if (r && r.isMatrix3) {
        t.uniforms[n] = {
          type: `m3`,
          value: r.toArray()
        };
      } else if (r && r.isMatrix4) {
        t.uniforms[n] = {
          type: `m4`,
          value: r.toArray()
        };
      } else {
        t.uniforms[n] = {
          value: r
        };
      }
    }
    if (Object.keys(this.defines).length > 0) {
      t.defines = this.defines;
    }
    t.vertexShader = this.vertexShader;
    t.fragmentShader = this.fragmentShader;
    t.lights = this.lights;
    t.clipping = this.clipping;
    let n = {};
    for (let e in this.extensions) {
      if (this.extensions[e] === true) {
        n[e] = true;
      }
    }
    if (Object.keys(n).length > 0) {
      t.extensions = n;
    }
    return t;
  }
  fromJSON(e, t) {
    super.fromJSON(e, t);
    if (e.uniforms !== undefined) {
      for (let n in e.uniforms) {
        let r = e.uniforms[n];
        this.uniforms[n] = {};
        switch (r.type) {
          case `t`:
            this.uniforms[n].value = t[r.value] || null;
            break;
          case `c`:
            this.uniforms[n].value = new Ov().setHex(r.value);
            break;
          case `v2`:
            this.uniforms[n].value = new S_().fromArray(r.value);
            break;
          case `v3`:
            this.uniforms[n].value = new X().fromArray(r.value);
            break;
          case `v4`:
            this.uniforms[n].value = new H_().fromArray(r.value);
            break;
          case `m3`:
            this.uniforms[n].value = new E_().fromArray(r.value);
            break;
          case `m4`:
            this.uniforms[n].value = new q_().fromArray(r.value);
            break;
          default:
            this.uniforms[n].value = r.value;
        }
      }
    }
    if (e.defines !== undefined) {
      this.defines = e.defines;
    }
    if (e.vertexShader !== undefined) {
      this.vertexShader = e.vertexShader;
    }
    if (e.fragmentShader !== undefined) {
      this.fragmentShader = e.fragmentShader;
    }
    if (e.glslVersion !== undefined) {
      this.glslVersion = e.glslVersion;
    }
    if (e.extensions !== undefined) {
      for (let t in e.extensions) {
        this.extensions[t] = e.extensions[t];
      }
    }
    if (e.lights !== undefined) {
      this.lights = e.lights;
    }
    if (e.clipping !== undefined) {
      this.clipping = e.clipping;
    }
    return this;
  }
};
var rx = class extends nx {
  constructor(e) {
    super(e);
    this.isRawShaderMaterial = true;
    this.type = `RawShaderMaterial`;
  }
};
var ix = class extends Ny {
  constructor(e) {
    super();
    this.isMeshStandardMaterial = true;
    this.type = `MeshStandardMaterial`;
    this.defines = {
      STANDARD: ``
    };
    this.color = new Ov(16777215);
    this.roughness = 1;
    this.metalness = 0;
    this.map = null;
    this.lightMap = null;
    this.lightMapIntensity = 1;
    this.aoMap = null;
    this.aoMapIntensity = 1;
    this.emissive = new Ov(0);
    this.emissiveIntensity = 1;
    this.emissiveMap = null;
    this.bumpMap = null;
    this.bumpScale = 1;
    this.normalMap = null;
    this.normalMapType = 0;
    this.normalScale = new S_(1, 1);
    this.displacementMap = null;
    this.displacementScale = 1;
    this.displacementBias = 0;
    this.roughnessMap = null;
    this.metalnessMap = null;
    this.alphaMap = null;
    this.envMap = null;
    this.envMapRotation = new rv();
    this.envMapIntensity = 1;
    this.wireframe = false;
    this.wireframeLinewidth = 1;
    this.wireframeLinecap = `round`;
    this.wireframeLinejoin = `round`;
    this.flatShading = false;
    this.fog = true;
    this.setValues(e);
  }
  copy(e) {
    super.copy(e);
    this.defines = {
      STANDARD: ``
    };
    this.color.copy(e.color);
    this.roughness = e.roughness;
    this.metalness = e.metalness;
    this.map = e.map;
    this.lightMap = e.lightMap;
    this.lightMapIntensity = e.lightMapIntensity;
    this.aoMap = e.aoMap;
    this.aoMapIntensity = e.aoMapIntensity;
    this.emissive.copy(e.emissive);
    this.emissiveMap = e.emissiveMap;
    this.emissiveIntensity = e.emissiveIntensity;
    this.bumpMap = e.bumpMap;
    this.bumpScale = e.bumpScale;
    this.normalMap = e.normalMap;
    this.normalMapType = e.normalMapType;
    this.normalScale.copy(e.normalScale);
    this.displacementMap = e.displacementMap;
    this.displacementScale = e.displacementScale;
    this.displacementBias = e.displacementBias;
    this.roughnessMap = e.roughnessMap;
    this.metalnessMap = e.metalnessMap;
    this.alphaMap = e.alphaMap;
    this.envMap = e.envMap;
    this.envMapRotation.copy(e.envMapRotation);
    this.envMapIntensity = e.envMapIntensity;
    this.wireframe = e.wireframe;
    this.wireframeLinewidth = e.wireframeLinewidth;
    this.wireframeLinecap = e.wireframeLinecap;
    this.wireframeLinejoin = e.wireframeLinejoin;
    this.flatShading = e.flatShading;
    this.fog = e.fog;
    return this;
  }
};
var ax = class extends Ny {
  constructor(e) {
    super();
    this.isMeshDepthMaterial = true;
    this.type = `MeshDepthMaterial`;
    this.depthPacking = Og;
    this.map = null;
    this.alphaMap = null;
    this.displacementMap = null;
    this.displacementScale = 1;
    this.displacementBias = 0;
    this.wireframe = false;
    this.wireframeLinewidth = 1;
    this.setValues(e);
  }
  copy(e) {
    super.copy(e);
    this.depthPacking = e.depthPacking;
    this.map = e.map;
    this.alphaMap = e.alphaMap;
    this.displacementMap = e.displacementMap;
    this.displacementScale = e.displacementScale;
    this.displacementBias = e.displacementBias;
    this.wireframe = e.wireframe;
    this.wireframeLinewidth = e.wireframeLinewidth;
    return this;
  }
};
var ox = class extends Ny {
  constructor(e) {
    super();
    this.isMeshDistanceMaterial = true;
    this.type = `MeshDistanceMaterial`;
    this.map = null;
    this.alphaMap = null;
    this.displacementMap = null;
    this.displacementScale = 1;
    this.displacementBias = 0;
    this.setValues(e);
  }
  copy(e) {
    super.copy(e);
    this.map = e.map;
    this.alphaMap = e.alphaMap;
    this.displacementMap = e.displacementMap;
    this.displacementScale = e.displacementScale;
    this.displacementBias = e.displacementBias;
    return this;
  }
};
function sx(e, t) {
  if (!e || e.constructor === t) {
    return e;
  } else if (typeof t.BYTES_PER_ELEMENT == `number`) {
    return new t(e);
  } else {
    return Array.prototype.slice.call(e);
  }
}
function cx(e) {
  return e !== undefined && e.inTangents !== undefined && e.outTangents !== undefined;
}
var lx = class {
  constructor(e, t, n, r) {
    this.parameterPositions = e;
    this._cachedIndex = 0;
    this.resultBuffer = r === undefined ? new t.constructor(n) : r;
    this.sampleValues = t;
    this.valueSize = n;
    this.settings = null;
    this.DefaultSettings_ = {};
  }
  evaluate(e) {
    let t = this.parameterPositions;
    let n = this._cachedIndex;
    let r = t[n];
    let i = t[n - 1];
    validate_interval: {
      seek: {
        let a;
        linear_scan: {
          forward_scan: if (!(e < r)) {
            for (let a = n + 2;;) {
              if (r === undefined) {
                if (e < i) {
                  break forward_scan;
                }
                n = t.length;
                this._cachedIndex = n;
                return this.copySampleValue_(n - 1);
              }
              if (n === a) {
                break;
              }
              i = r;
              r = t[++n];
              if (e < r) {
                break seek;
              }
            }
            a = t.length;
            break linear_scan;
          }
          if (!(e >= i)) {
            let o = t[1];
            if (e < o) {
              n = 2;
              i = o;
            }
            for (let a = n - 2;;) {
              if (i === undefined) {
                this._cachedIndex = 0;
                return this.copySampleValue_(0);
              }
              if (n === a) {
                break;
              }
              r = i;
              i = t[--n - 1];
              if (e >= i) {
                break seek;
              }
            }
            a = n;
            n = 0;
            break linear_scan;
          }
          break validate_interval;
        }
        while (n < a) {
          let r = n + a >>> 1;
          if (e < t[r]) {
            a = r;
          } else {
            n = r + 1;
          }
        }
        r = t[n];
        i = t[n - 1];
        if (i === undefined) {
          this._cachedIndex = 0;
          return this.copySampleValue_(0);
        }
        if (r === undefined) {
          n = t.length;
          this._cachedIndex = n;
          return this.copySampleValue_(n - 1);
        }
      }
      this._cachedIndex = n;
      this.intervalChanged_(n, i, r);
    }
    return this.interpolate_(n, i, e, r);
  }
  getSettings_() {
    return this.settings || this.DefaultSettings_;
  }
  copySampleValue_(e) {
    let t = this.resultBuffer;
    let n = this.sampleValues;
    let r = this.valueSize;
    let i = e * r;
    for (let e = 0; e !== r; ++e) {
      t[e] = n[i + e];
    }
    return t;
  }
  interpolate_() {
    throw Error(`THREE.Interpolant: Call to abstract method.`);
  }
  intervalChanged_() {}
};
var ux = class extends lx {
  constructor(e, t, n, r) {
    super(e, t, n, r);
    this._weightPrev = -0;
    this._offsetPrev = -0;
    this._weightNext = -0;
    this._offsetNext = -0;
    this.DefaultSettings_ = {
      endingStart: Tg,
      endingEnd: Tg
    };
  }
  intervalChanged_(e, t, n) {
    let r = this.parameterPositions;
    let i = e - 2;
    let a = e + 1;
    let o = r[i];
    let s = r[a];
    if (o === undefined) {
      switch (this.getSettings_().endingStart) {
        case Eg:
          i = e;
          o = t * 2 - n;
          break;
        case Dg:
          i = r.length - 2;
          o = t + r[i] - r[i + 1];
          break;
        default:
          i = e;
          o = n;
      }
    }
    if (s === undefined) {
      switch (this.getSettings_().endingEnd) {
        case Eg:
          a = e;
          s = n * 2 - t;
          break;
        case Dg:
          a = 1;
          s = n + r[1] - r[0];
          break;
        default:
          a = e - 1;
          s = t;
      }
    }
    let c = (n - t) * 0.5;
    let l = this.valueSize;
    this._weightPrev = c / (t - o);
    this._weightNext = c / (s - n);
    this._offsetPrev = i * l;
    this._offsetNext = a * l;
  }
  interpolate_(e, t, n, r) {
    let i = this.resultBuffer;
    let a = this.sampleValues;
    let o = this.valueSize;
    let s = e * o;
    let c = s - o;
    let l = this._offsetPrev;
    let u = this._offsetNext;
    let d = this._weightPrev;
    let f = this._weightNext;
    let p = (n - t) / (r - t);
    let m = p * p;
    let h = m * p;
    let g = -d * h + d * 2 * m - d * p;
    let _ = (1 + d) * h + (-1.5 - d * 2) * m + (-0.5 + d) * p + 1;
    let v = (-1 - f) * h + (1.5 + f) * m + p * 0.5;
    let y = f * h - f * m;
    for (let e = 0; e !== o; ++e) {
      i[e] = g * a[l + e] + _ * a[c + e] + v * a[s + e] + y * a[u + e];
    }
    return i;
  }
};
var dx = class extends lx {
  constructor(e, t, n, r) {
    super(e, t, n, r);
  }
  interpolate_(e, t, n, r) {
    let i = this.resultBuffer;
    let a = this.sampleValues;
    let o = this.valueSize;
    let s = e * o;
    let c = s - o;
    let l = (n - t) / (r - t);
    let u = 1 - l;
    for (let e = 0; e !== o; ++e) {
      i[e] = a[c + e] * u + a[s + e] * l;
    }
    return i;
  }
};
var fx = class extends lx {
  constructor(e, t, n, r) {
    super(e, t, n, r);
  }
  interpolate_(e) {
    return this.copySampleValue_(e - 1);
  }
};
var px = class extends lx {
  interpolate_(e, t, n, r) {
    let i = this.resultBuffer;
    let a = this.sampleValues;
    let o = this.valueSize;
    let s = e * o;
    let c = s - o;
    let l = this.inTangents;
    let u = this.outTangents;
    if (!l || !u) {
      let e = (n - t) / (r - t);
      let l = 1 - e;
      for (let t = 0; t !== o; ++t) {
        i[t] = a[c + t] * l + a[s + t] * e;
      }
      return i;
    }
    let d = o * 2;
    let f = e - 1;
    for (let p = 0; p !== o; ++p) {
      let o = a[c + p];
      let m = a[s + p];
      let h = f * d + p * 2;
      let g = u[h];
      let _ = u[h + 1];
      let v = e * d + p * 2;
      let y = l[v];
      let b = l[v + 1];
      let x = gx(n, t, g, y, r);
      i[p] = mx(x, o, _, b, m);
    }
    return i;
  }
};
function mx(e, t, n, r, i) {
  let a = 1 - e;
  return a * a * a * t + a * 3 * a * e * n + a * 3 * e * e * r + e * e * e * i;
}
function hx(e, t, n, r, i) {
  let a = 1 - e;
  return a * 3 * a * (n - t) + a * 6 * e * (r - n) + e * 3 * e * (i - r);
}
function gx(e, t, n, r, i) {
  let a = (e - t) / (i - t);
  for (let o = 0; o < 8; o++) {
    let o = mx(a, t, n, r, i) - e;
    if (Math.abs(o) < 1e-10) {
      break;
    }
    let s = hx(a, t, n, r, i);
    if (Math.abs(s) < 1e-10) {
      break;
    }
    a = Math.max(0, Math.min(1, a - o / s));
  }
  return a;
}
var _x = class {
  constructor(e, t, n, r) {
    if (e === undefined) {
      throw Error(`THREE.KeyframeTrack: track name is undefined`);
    }
    if (t === undefined || t.length === 0) {
      throw Error(`THREE.KeyframeTrack: no keyframes in track named ${e}`);
    }
    this.name = e;
    this.times = sx(t, this.TimeBufferType);
    this.values = sx(n, this.ValueBufferType);
    this.setInterpolation(r || this.DefaultInterpolation);
  }
  static toJSON(e) {
    let t = e.constructor;
    let n;
    if (t.toJSON !== this.toJSON) {
      n = t.toJSON(e);
    } else {
      n = {
        name: e.name,
        times: sx(e.times, Array),
        values: sx(e.values, Array)
      };
      let t = e.getInterpolation();
      if (t !== e.DefaultInterpolation) {
        n.interpolation = t;
      }
      if (cx(e.settings)) {
        n.settings = {
          inTangents: sx(e.settings.inTangents, Array),
          outTangents: sx(e.settings.outTangents, Array)
        };
      }
    }
    n.type = e.ValueTypeName;
    return n;
  }
  InterpolantFactoryMethodDiscrete(e) {
    return new fx(this.times, this.values, this.getValueSize(), e);
  }
  InterpolantFactoryMethodLinear(e) {
    return new dx(this.times, this.values, this.getValueSize(), e);
  }
  InterpolantFactoryMethodSmooth(e) {
    return new ux(this.times, this.values, this.getValueSize(), e);
  }
  InterpolantFactoryMethodBezier(e) {
    let t = new px(this.times, this.values, this.getValueSize(), e);
    if (this.settings) {
      t.inTangents = this.settings.inTangents;
      t.outTangents = this.settings.outTangents;
    }
    return t;
  }
  setInterpolation(e) {
    let t;
    switch (e) {
      case xg:
        t = this.InterpolantFactoryMethodDiscrete;
        break;
      case Sg:
        t = this.InterpolantFactoryMethodLinear;
        break;
      case Cg:
        t = this.InterpolantFactoryMethodSmooth;
        break;
      case wg:
        t = this.InterpolantFactoryMethodBezier;
    }
    if (t === undefined) {
      let t = `unsupported interpolation for ${this.ValueTypeName} keyframe track named ${this.name}`;
      if (this.createInterpolant === undefined) {
        if (e !== this.DefaultInterpolation) {
          this.setInterpolation(this.DefaultInterpolation);
        } else {
          throw Error(t);
        }
      }
      Ug(`KeyframeTrack:`, t);
      return this;
    }
    this.createInterpolant = t;
    return this;
  }
  getInterpolation() {
    switch (this.createInterpolant) {
      case this.InterpolantFactoryMethodDiscrete:
        return xg;
      case this.InterpolantFactoryMethodLinear:
        return Sg;
      case this.InterpolantFactoryMethodSmooth:
        return Cg;
      case this.InterpolantFactoryMethodBezier:
        return wg;
    }
  }
  getValueSize() {
    return this.values.length / this.times.length;
  }
  shift(e) {
    if (e !== 0) {
      let t = this.times;
      for (let n = 0, r = t.length; n !== r; ++n) {
        t[n] += e;
      }
    }
    return this;
  }
  scale(e) {
    if (e !== 1) {
      let t = this.times;
      for (let n = 0, r = t.length; n !== r; ++n) {
        t[n] *= e;
      }
      if (cx(this.settings)) {
        vx(this.settings.inTangents, e);
        vx(this.settings.outTangents, e);
      }
    }
    return this;
  }
  trim(e, t) {
    let n = this.times;
    let r = n.length;
    let i = 0;
    let a = r - 1;
    while (i !== r && n[i] < e) {
      ++i;
    }
    while (a !== -1 && n[a] > t) {
      --a;
    }
    ++a;
    if (i !== 0 || a !== r) {
      if (i >= a) {
        a = Math.max(a, 1);
        i = a - 1;
      }
      let e = this.getValueSize();
      this.times = n.slice(i, a);
      this.values = this.values.slice(i * e, a * e);
    }
    return this;
  }
  validate() {
    let e = true;
    let t = this.getValueSize();
    if (t - Math.floor(t) !== 0) {
      Wg(`KeyframeTrack: Invalid value size in track.`, this);
      e = false;
    }
    let n = this.times;
    let r = this.values;
    let i = n.length;
    if (i === 0) {
      Wg(`KeyframeTrack: Track is empty.`, this);
      e = false;
    }
    let a = null;
    for (let t = 0; t !== i; t++) {
      let r = n[t];
      if (typeof r == `number` && isNaN(r)) {
        Wg(`KeyframeTrack: Time is not a valid number.`, this, t, r);
        e = false;
        break;
      }
      if (a !== null && a > r) {
        Wg(`KeyframeTrack: Out of order keys.`, this, t, r, a);
        e = false;
        break;
      }
      a = r;
    }
    if (r !== undefined && Lg(r)) {
      for (let t = 0, n = r.length; t !== n; ++t) {
        let n = r[t];
        if (isNaN(n)) {
          Wg(`KeyframeTrack: Value is not a valid number.`, this, t, n);
          e = false;
          break;
        }
      }
    }
    return e;
  }
  optimize() {
    let e = this.times.slice();
    let t = this.values.slice();
    let n = this.getValueSize();
    let r = this.getInterpolation() === Cg;
    let i = e.length - 1;
    let a = 1;
    for (let o = 1; o < i; ++o) {
      let i = false;
      let s = e[o];
      if (s !== e[o + 1] && (o !== 1 || s !== e[0])) {
        if (r) {
          i = true;
        } else {
          let e = o * n;
          let r = e - n;
          let a = e + n;
          for (let o = 0; o !== n; ++o) {
            let n = t[e + o];
            if (n !== t[r + o] || n !== t[a + o]) {
              i = true;
              break;
            }
          }
        }
      }
      if (i) {
        if (o !== a) {
          e[a] = e[o];
          let r = o * n;
          let i = a * n;
          for (let e = 0; e !== n; ++e) {
            t[i + e] = t[r + e];
          }
        }
        ++a;
      }
    }
    if (i > 0) {
      e[a] = e[i];
      for (let e = i * n, r = a * n, o = 0; o !== n; ++o) {
        t[r + o] = t[e + o];
      }
      ++a;
    }
    if (a === e.length) {
      this.times = e;
      this.values = t;
    } else {
      this.times = e.slice(0, a);
      this.values = t.slice(0, a * n);
    }
    return this;
  }
  clone() {
    let e = this.times.slice();
    let t = this.values.slice();
    let n = this.constructor;
    let r = new n(this.name, e, t);
    r.createInterpolant = this.createInterpolant;
    if (cx(this.settings)) {
      r.settings = {
        inTangents: this.settings.inTangents.slice(),
        outTangents: this.settings.outTangents.slice()
      };
    }
    return r;
  }
};
function vx(e, t) {
  for (let n = 0, r = e.length; n !== r; n += 2) {
    e[n] *= t;
  }
}
_x.prototype.ValueTypeName = ``;
_x.prototype.TimeBufferType = Float32Array;
_x.prototype.ValueBufferType = Float32Array;
_x.prototype.DefaultInterpolation = Sg;
var yx = class extends _x {
  constructor(e, t, n) {
    super(e, t, n);
  }
};
yx.prototype.ValueTypeName = `bool`;
yx.prototype.ValueBufferType = Array;
yx.prototype.DefaultInterpolation = xg;
yx.prototype.InterpolantFactoryMethodLinear = undefined;
yx.prototype.InterpolantFactoryMethodSmooth = undefined;
var bx = class extends _x {
  constructor(e, t, n, r) {
    super(e, t, n, r);
  }
};
bx.prototype.ValueTypeName = `color`;
var xx = class extends _x {
  constructor(e, t, n, r) {
    super(e, t, n, r);
  }
};
xx.prototype.ValueTypeName = `number`;
var Sx = class extends lx {
  constructor(e, t, n, r) {
    super(e, t, n, r);
  }
  interpolate_(e, t, n, r) {
    let i = this.resultBuffer;
    let a = this.sampleValues;
    let o = this.valueSize;
    let s = (n - t) / (r - t);
    let c = e * o;
    for (let e = c + o; c !== e; c += 4) {
      C_.slerpFlat(i, 0, a, c - o, a, c, s);
    }
    return i;
  }
};
var Cx = class extends _x {
  constructor(e, t, n, r) {
    super(e, t, n, r);
  }
  InterpolantFactoryMethodLinear(e) {
    return new Sx(this.times, this.values, this.getValueSize(), e);
  }
};
Cx.prototype.ValueTypeName = `quaternion`;
Cx.prototype.InterpolantFactoryMethodSmooth = undefined;
var wx = class extends _x {
  constructor(e, t, n) {
    super(e, t, n);
  }
};
wx.prototype.ValueTypeName = `string`;
wx.prototype.ValueBufferType = Array;
wx.prototype.DefaultInterpolation = xg;
wx.prototype.InterpolantFactoryMethodLinear = undefined;
wx.prototype.InterpolantFactoryMethodSmooth = undefined;
var Tx = class extends _x {
  constructor(e, t, n, r) {
    super(e, t, n, r);
  }
};
Tx.prototype.ValueTypeName = `vector`;
var Ex = {
  enabled: false,
  files: {},
  add: function (e, t) {
    if (this.enabled !== false) {
      if (!Dx(e)) {
        this.files[e] = t;
      }
    }
  },
  get: function (e) {
    if (this.enabled !== false && !Dx(e)) {
      return this.files[e];
    }
  },
  remove: function (e) {
    delete this.files[e];
  },
  clear: function () {
    this.files = {};
  }
};
function Dx(e) {
  try {
    let t = e.slice(e.indexOf(`:`) + 1);
    return new URL(t).protocol === `blob:`;
  } catch {
    return false;
  }
}
var Ox = new class {
  constructor(e, t, n) {
    let r = this;
    let i = false;
    let a = 0;
    let o = 0;
    let s;
    let c = [];
    this.onStart = undefined;
    this.onLoad = e;
    this.onProgress = t;
    this.onError = n;
    this._abortController = null;
    this.itemStart = function (e) {
      o++;
      if (i === false && r.onStart !== undefined) {
        r.onStart(e, a, o);
      }
      i = true;
    };
    this.itemEnd = function (e) {
      a++;
      if (r.onProgress !== undefined) {
        r.onProgress(e, a, o);
      }
      if (a === o) {
        i = false;
        if (r.onLoad !== undefined) {
          r.onLoad();
        }
      }
    };
    this.itemError = function (e) {
      if (r.onError !== undefined) {
        r.onError(e);
      }
    };
    this.resolveURL = function (e) {
      e = e.normalize(`NFC`);
      if (s) {
        return s(e);
      } else {
        return e;
      }
    };
    this.setURLModifier = function (e) {
      s = e;
      return this;
    };
    this.addHandler = function (e, t) {
      c.push(e, t);
      return this;
    };
    this.removeHandler = function (e) {
      let t = c.indexOf(e);
      if (t !== -1) {
        c.splice(t, 2);
      }
      return this;
    };
    this.getHandler = function (e) {
      for (let t = 0, n = c.length; t < n; t += 2) {
        let n = c[t];
        let r = c[t + 1];
        if (n.global) {
          n.lastIndex = 0;
        }
        if (n.test(e)) {
          return r;
        }
      }
      return null;
    };
    this.abort = function () {
      this.abortController.abort();
      this._abortController = null;
      return this;
    };
  }
  get abortController() {
    this._abortController ||= new AbortController();
    return this._abortController;
  }
}();
var kx = class {
  constructor(e) {
    this.manager = e === undefined ? Ox : e;
    this.crossOrigin = `anonymous`;
    this.withCredentials = false;
    this.path = ``;
    this.resourcePath = ``;
    this.requestHeader = {};
    if (typeof __THREE_DEVTOOLS__ < `u`) {
      __THREE_DEVTOOLS__.dispatchEvent(new CustomEvent(`observe`, {
        detail: this
      }));
    }
  }
  load() {}
  loadAsync(e, t) {
    let n = this;
    return new Promise(function (r, i) {
      n.load(e, r, t, i);
    });
  }
  parse() {}
  setCrossOrigin(e) {
    this.crossOrigin = e;
    return this;
  }
  setWithCredentials(e) {
    this.withCredentials = e;
    return this;
  }
  setPath(e) {
    this.path = e;
    return this;
  }
  setResourcePath(e) {
    this.resourcePath = e;
    return this;
  }
  setRequestHeader(e) {
    this.requestHeader = e;
    return this;
  }
  abort() {
    return this;
  }
};
kx.DEFAULT_MATERIAL_NAME = `__DEFAULT`;
var Ax = new WeakMap();
var jx = class extends kx {
  constructor(e) {
    super(e);
  }
  load(e, t, n, r) {
    if (this.path !== undefined) {
      e = this.path + e;
    }
    e = this.manager.resolveURL(e);
    let i = this;
    let a = Ex.get(`image:${e}`);
    if (a !== undefined) {
      if (a.complete === true) {
        i.manager.itemStart(e);
        setTimeout(function () {
          if (t) {
            t(a);
          }
          i.manager.itemEnd(e);
        }, 0);
      } else {
        let e = Ax.get(a);
        if (e === undefined) {
          e = [];
          Ax.set(a, e);
        }
        e.push({
          onLoad: t,
          onError: r
        });
      }
      return a;
    }
    let o = Rg(`img`);
    function s() {
      l();
      if (t) {
        t(this);
      }
      let n = Ax.get(this) || [];
      for (let e = 0; e < n.length; e++) {
        let t = n[e];
        if (t.onLoad) {
          t.onLoad(this);
        }
      }
      Ax.delete(this);
      i.manager.itemEnd(e);
    }
    function c(t) {
      l();
      if (r) {
        r(t);
      }
      Ex.remove(`image:${e}`);
      let n = Ax.get(this) || [];
      for (let e = 0; e < n.length; e++) {
        let r = n[e];
        if (r.onError) {
          r.onError(t);
        }
      }
      Ax.delete(this);
      i.manager.itemError(e);
      i.manager.itemEnd(e);
    }
    function l() {
      o.removeEventListener(`load`, s, false);
      o.removeEventListener(`error`, c, false);
    }
    o.addEventListener(`load`, s, false);
    o.addEventListener(`error`, c, false);
    if (e.slice(0, 5) !== `data:` && this.crossOrigin !== undefined) {
      o.crossOrigin = this.crossOrigin;
    }
    Ex.add(`image:${e}`, o);
    i.manager.itemStart(e);
    o.src = e;
    return o;
  }
};
var Mx = class extends kx {
  constructor(e) {
    super(e);
  }
  load(e, t, n, r) {
    let i = new V_();
    let a = new jx(this.manager);
    a.setCrossOrigin(this.crossOrigin);
    a.setPath(this.path);
    a.load(e, function (e) {
      i.image = e;
      i.needsUpdate = true;
      if (t !== undefined) {
        t(i);
      }
    }, n, r);
    return i;
  }
};
var Nx = class extends bv {
  constructor(e, t = 1) {
    super();
    this.isLight = true;
    this.type = `Light`;
    this.color = new Ov(e);
    this.intensity = t;
  }
  copy(e, t) {
    super.copy(e, t);
    this.color.copy(e.color);
    this.intensity = e.intensity;
    return this;
  }
  toJSON(e) {
    let t = super.toJSON(e);
    t.object.color = this.color.getHex();
    t.object.intensity = this.intensity;
    return t;
  }
};
var Px = class extends Nx {
  constructor(e, t, n) {
    super(e, n);
    this.isHemisphereLight = true;
    this.type = `HemisphereLight`;
    this.position.copy(bv.DEFAULT_UP);
    this.updateMatrix();
    this.groundColor = new Ov(t);
  }
  copy(e, t) {
    super.copy(e, t);
    this.groundColor.copy(e.groundColor);
    return this;
  }
  toJSON(e) {
    let t = super.toJSON(e);
    t.object.groundColor = this.groundColor.getHex();
    return t;
  }
};
var Fx = new q_();
var Ix = new X();
var Lx = new X();
var Rx = class {
  constructor(e) {
    this.camera = e;
    this.intensity = 1;
    this.bias = 0;
    this.biasNode = null;
    this.normalBias = 0;
    this.radius = 1;
    this.blurSamples = 8;
    this.mapSize = new S_(512, 512);
    this.mapType = gh;
    this.map = null;
    this.mapPass = null;
    this.matrix = new q_();
    this.autoUpdate = true;
    this.needsUpdate = false;
    this._frustum = new bb();
    this._frameExtents = new S_(1, 1);
    this._viewportCount = 1;
    this._viewports = [new H_(0, 0, 1, 1)];
  }
  getViewportCount() {
    return this._viewportCount;
  }
  getCamera() {
    return this.camera;
  }
  getFrustum() {
    return this._frustum;
  }
  updateMatrices(e) {
    let t = this.camera;
    Ix.setFromMatrixPosition(e.matrixWorld);
    t.position.copy(Ix);
    Lx.setFromMatrixPosition(e.target.matrixWorld);
    t.lookAt(Lx);
    t.updateMatrixWorld();
    this._updateMatrix(t, this.matrix, this._frustum);
  }
  _updateMatrix(e, t, n, r) {
    Fx.multiplyMatrices(e.projectionMatrix, e.matrixWorldInverse);
    n.setFromProjectionMatrix(Fx, e.coordinateSystem, e.reversedDepth);
    let i = this._frameExtents;
    let a = r ? r.z / i.x : 1;
    let o = r ? r.w / i.y : 1;
    let s = r ? r.x / i.x : 0;
    let c = r ? r.y / i.y : 0;
    if (e.coordinateSystem === 2001 || e.reversedDepth) {
      t.set(a * 0.5, 0, 0, a * 0.5 + s, 0, o * 0.5, 0, o * 0.5 + c, 0, 0, 1, 0, 0, 0, 0, 1);
    } else {
      t.set(a * 0.5, 0, 0, a * 0.5 + s, 0, o * 0.5, 0, o * 0.5 + c, 0, 0, 0.5, 0.5, 0, 0, 0, 1);
    }
    t.multiply(Fx);
  }
  getViewport(e) {
    return this._viewports[e];
  }
  getFrameExtents() {
    return this._frameExtents;
  }
  dispose() {
    if (this.map) {
      this.map.dispose();
    }
    if (this.mapPass) {
      this.mapPass.dispose();
    }
  }
  copy(e) {
    this.camera = e.camera.clone();
    this.intensity = e.intensity;
    this.bias = e.bias;
    this.radius = e.radius;
    this.autoUpdate = e.autoUpdate;
    this.needsUpdate = e.needsUpdate;
    this.normalBias = e.normalBias;
    this.blurSamples = e.blurSamples;
    this.mapSize.copy(e.mapSize);
    this.biasNode = e.biasNode;
    return this;
  }
  clone() {
    return new this.constructor().copy(this);
  }
  toJSON() {
    let e = {
      intensity: this.intensity,
      bias: this.bias,
      normalBias: this.normalBias,
      radius: this.radius,
      blurSamples: this.blurSamples
    };
    e.mapSize = this.mapSize.toArray();
    e.camera = this.camera.toJSON(false).object;
    delete e.camera.matrix;
    return e;
  }
};
var zx = new X();
var Bx = new C_();
var Vx = new X();
var Hx = class extends bv {
  constructor() {
    super();
    this.isCamera = true;
    this.type = `Camera`;
    this.matrixWorldInverse = new q_();
    this.projectionMatrix = new q_();
    this.projectionMatrixInverse = new q_();
    this.coordinateSystem = Fg;
    this._reversedDepth = false;
  }
  get reversedDepth() {
    return this._reversedDepth;
  }
  copy(e, t) {
    super.copy(e, t);
    this.matrixWorldInverse.copy(e.matrixWorldInverse);
    this.projectionMatrix.copy(e.projectionMatrix);
    this.projectionMatrixInverse.copy(e.projectionMatrixInverse);
    this.coordinateSystem = e.coordinateSystem;
    return this;
  }
  getWorldDirection(e) {
    return super.getWorldDirection(e).negate();
  }
  updateMatrixWorld(e) {
    super.updateMatrixWorld(e);
    this.matrixWorld.decompose(zx, Bx, Vx);
    if (Vx.x === 1 && Vx.y === 1 && Vx.z === 1) {
      this.matrixWorldInverse.copy(this.matrixWorld).invert();
    } else {
      this.matrixWorldInverse.compose(zx, Bx, Vx.set(1, 1, 1)).invert();
    }
  }
  updateWorldMatrix(e, t, n = false) {
    super.updateWorldMatrix(e, t, n);
    this.matrixWorld.decompose(zx, Bx, Vx);
    if (Vx.x === 1 && Vx.y === 1 && Vx.z === 1) {
      this.matrixWorldInverse.copy(this.matrixWorld).invert();
    } else {
      this.matrixWorldInverse.compose(zx, Bx, Vx.set(1, 1, 1)).invert();
    }
  }
  clone() {
    return new this.constructor().copy(this);
  }
};
var Ux = new X();
var Wx = new S_();
var Gx = new S_();
var Kx = class extends Hx {
  constructor(e = 50, t = 1, n = 0.1, r = 2000) {
    super();
    this.isPerspectiveCamera = true;
    this.type = `PerspectiveCamera`;
    this.fov = e;
    this.zoom = 1;
    this.near = n;
    this.far = r;
    this.focus = 10;
    this.aspect = t;
    this.view = null;
    this.filmGauge = 35;
    this.filmOffset = 0;
    this.updateProjectionMatrix();
  }
  copy(e, t) {
    super.copy(e, t);
    this.fov = e.fov;
    this.zoom = e.zoom;
    this.near = e.near;
    this.far = e.far;
    this.focus = e.focus;
    this.aspect = e.aspect;
    this.view = e.view === null ? null : Object.assign({}, e.view);
    this.filmGauge = e.filmGauge;
    this.filmOffset = e.filmOffset;
    return this;
  }
  setFocalLength(e) {
    let t = this.getFilmHeight() * 0.5 / e;
    this.fov = Qg * 2 * Math.atan(t);
    this.updateProjectionMatrix();
  }
  getFocalLength() {
    let e = Math.tan(Zg * 0.5 * this.fov);
    return this.getFilmHeight() * 0.5 / e;
  }
  getEffectiveFOV() {
    return Qg * 2 * Math.atan(Math.tan(Zg * 0.5 * this.fov) / this.zoom);
  }
  getFilmWidth() {
    return this.filmGauge * Math.min(this.aspect, 1);
  }
  getFilmHeight() {
    return this.filmGauge / Math.max(this.aspect, 1);
  }
  getViewBounds(e, t, n) {
    Ux.set(-1, -1, 0.5).applyMatrix4(this.projectionMatrixInverse);
    t.set(Ux.x, Ux.y).multiplyScalar(-e / Ux.z);
    Ux.set(1, 1, 0.5).applyMatrix4(this.projectionMatrixInverse);
    n.set(Ux.x, Ux.y).multiplyScalar(-e / Ux.z);
  }
  getViewSize(e, t) {
    this.getViewBounds(e, Wx, Gx);
    return t.subVectors(Gx, Wx);
  }
  setViewOffset(e, t, n, r, i, a) {
    this.aspect = e / t;
    if (this.view === null) {
      this.view = {
        enabled: true,
        fullWidth: 1,
        fullHeight: 1,
        offsetX: 0,
        offsetY: 0,
        width: 1,
        height: 1
      };
    }
    this.view.enabled = true;
    this.view.fullWidth = e;
    this.view.fullHeight = t;
    this.view.offsetX = n;
    this.view.offsetY = r;
    this.view.width = i;
    this.view.height = a;
    this.updateProjectionMatrix();
  }
  clearViewOffset() {
    if (this.view !== null) {
      this.view.enabled = false;
    }
    this.updateProjectionMatrix();
  }
  updateProjectionMatrix() {
    let e = this.near;
    let t = e * Math.tan(Zg * 0.5 * this.fov) / this.zoom;
    let n = t * 2;
    let r = this.aspect * n;
    let i = r * -0.5;
    let a = this.view;
    if (this.view !== null && this.view.enabled) {
      let e = a.fullWidth;
      let o = a.fullHeight;
      i += a.offsetX * r / e;
      t -= a.offsetY * n / o;
      r *= a.width / e;
      n *= a.height / o;
    }
    let o = this.filmOffset;
    if (o !== 0) {
      i += e * o / this.getFilmWidth();
    }
    this.projectionMatrix.makePerspective(i, i + r, t, t - n, e, this.far, this.coordinateSystem, this.reversedDepth);
    this.projectionMatrixInverse.copy(this.projectionMatrix).invert();
  }
  toJSON(e) {
    let t = super.toJSON(e);
    t.object.fov = this.fov;
    t.object.zoom = this.zoom;
    t.object.near = this.near;
    t.object.far = this.far;
    t.object.focus = this.focus;
    t.object.aspect = this.aspect;
    if (this.view !== null) {
      t.object.view = Object.assign({}, this.view);
    }
    t.object.filmGauge = this.filmGauge;
    t.object.filmOffset = this.filmOffset;
    return t;
  }
};
var qx = class extends Hx {
  constructor(e = -1, t = 1, n = 1, r = -1, i = 0.1, a = 2000) {
    super();
    this.isOrthographicCamera = true;
    this.type = `OrthographicCamera`;
    this.zoom = 1;
    this.view = null;
    this.left = e;
    this.right = t;
    this.top = n;
    this.bottom = r;
    this.near = i;
    this.far = a;
    this.updateProjectionMatrix();
  }
  copy(e, t) {
    super.copy(e, t);
    this.left = e.left;
    this.right = e.right;
    this.top = e.top;
    this.bottom = e.bottom;
    this.near = e.near;
    this.far = e.far;
    this.zoom = e.zoom;
    this.view = e.view === null ? null : Object.assign({}, e.view);
    return this;
  }
  setViewOffset(e, t, n, r, i, a) {
    if (this.view === null) {
      this.view = {
        enabled: true,
        fullWidth: 1,
        fullHeight: 1,
        offsetX: 0,
        offsetY: 0,
        width: 1,
        height: 1
      };
    }
    this.view.enabled = true;
    this.view.fullWidth = e;
    this.view.fullHeight = t;
    this.view.offsetX = n;
    this.view.offsetY = r;
    this.view.width = i;
    this.view.height = a;
    this.updateProjectionMatrix();
  }
  clearViewOffset() {
    if (this.view !== null) {
      this.view.enabled = false;
    }
    this.updateProjectionMatrix();
  }
  updateProjectionMatrix() {
    let e = (this.right - this.left) / (this.zoom * 2);
    let t = (this.top - this.bottom) / (this.zoom * 2);
    let n = (this.right + this.left) / 2;
    let r = (this.top + this.bottom) / 2;
    let i = n - e;
    let a = n + e;
    let o = r + t;
    let s = r - t;
    if (this.view !== null && this.view.enabled) {
      let e = (this.right - this.left) / this.view.fullWidth / this.zoom;
      let t = (this.top - this.bottom) / this.view.fullHeight / this.zoom;
      i += e * this.view.offsetX;
      a = i + e * this.view.width;
      o -= t * this.view.offsetY;
      s = o - t * this.view.height;
    }
    this.projectionMatrix.makeOrthographic(i, a, o, s, this.near, this.far, this.coordinateSystem, this.reversedDepth);
    this.projectionMatrixInverse.copy(this.projectionMatrix).invert();
  }
  toJSON(e) {
    let t = super.toJSON(e);
    t.object.zoom = this.zoom;
    t.object.left = this.left;
    t.object.right = this.right;
    t.object.top = this.top;
    t.object.bottom = this.bottom;
    t.object.near = this.near;
    t.object.far = this.far;
    if (this.view !== null) {
      t.object.view = Object.assign({}, this.view);
    }
    return t;
  }
};
var Jx = class extends Rx {
  constructor() {
    super(new qx(-5, 5, 5, -5, 0.5, 500));
    this.isDirectionalLightShadow = true;
  }
};
var Yx = class extends Nx {
  constructor(e, t) {
    super(e, t);
    this.isDirectionalLight = true;
    this.type = `DirectionalLight`;
    this.position.copy(bv.DEFAULT_UP);
    this.updateMatrix();
    this.target = new bv();
    this.shadow = new Jx();
  }
  dispose() {
    super.dispose();
    this.shadow.dispose();
  }
  copy(e) {
    super.copy(e);
    this.target = e.target.clone();
    this.shadow = e.shadow.clone();
    return this;
  }
  toJSON(e) {
    let t = super.toJSON(e);
    t.object.shadow = this.shadow.toJSON();
    t.object.target = this.target.uuid;
    return t;
  }
};
var Xx = -90;
var Zx = 1;
var Qx = class extends bv {
  constructor(e, t, n) {
    super();
    this.type = `CubeCamera`;
    this.renderTarget = n;
    this.coordinateSystem = null;
    this.activeMipmapLevel = 0;
    let r = new Kx(Xx, Zx, e, t);
    r.layers = this.layers;
    this.add(r);
    let i = new Kx(Xx, Zx, e, t);
    i.layers = this.layers;
    this.add(i);
    let a = new Kx(Xx, Zx, e, t);
    a.layers = this.layers;
    this.add(a);
    let o = new Kx(Xx, Zx, e, t);
    o.layers = this.layers;
    this.add(o);
    let s = new Kx(Xx, Zx, e, t);
    s.layers = this.layers;
    this.add(s);
    let c = new Kx(Xx, Zx, e, t);
    c.layers = this.layers;
    this.add(c);
  }
  updateCoordinateSystem() {
    let e = this.coordinateSystem;
    let t = this.children.concat();
    let [n, r, i, a, o, s] = t;
    for (let e of t) {
      this.remove(e);
    }
    if (e === 2000) {
      n.up.set(0, 1, 0);
      n.lookAt(1, 0, 0);
      r.up.set(0, 1, 0);
      r.lookAt(-1, 0, 0);
      i.up.set(0, 0, -1);
      i.lookAt(0, 1, 0);
      a.up.set(0, 0, 1);
      a.lookAt(0, -1, 0);
      o.up.set(0, 1, 0);
      o.lookAt(0, 0, 1);
      s.up.set(0, 1, 0);
      s.lookAt(0, 0, -1);
    } else if (e === 2001) {
      n.up.set(0, -1, 0);
      n.lookAt(-1, 0, 0);
      r.up.set(0, -1, 0);
      r.lookAt(1, 0, 0);
      i.up.set(0, 0, 1);
      i.lookAt(0, 1, 0);
      a.up.set(0, 0, -1);
      a.lookAt(0, -1, 0);
      o.up.set(0, -1, 0);
      o.lookAt(0, 0, 1);
      s.up.set(0, -1, 0);
      s.lookAt(0, 0, -1);
    } else {
      throw Error(`THREE.CubeCamera.updateCoordinateSystem(): Invalid coordinate system: ${e}`);
    }
    for (let e of t) {
      this.add(e);
      e.updateMatrixWorld();
    }
  }
  update(e, t) {
    if (this.parent === null) {
      this.updateMatrixWorld();
    }
    let {
      renderTarget: n,
      activeMipmapLevel: r
    } = this;
    if (this.coordinateSystem !== e.coordinateSystem) {
      this.coordinateSystem = e.coordinateSystem;
      this.updateCoordinateSystem();
    }
    let [i, a, o, s, c, l] = this.children;
    let u = e.getRenderTarget();
    let d = e.getActiveCubeFace();
    let f = e.getActiveMipmapLevel();
    let p = e.xr.enabled;
    e.xr.enabled = false;
    let m = n.texture.generateMipmaps;
    n.texture.generateMipmaps = false;
    let h = false;
    h = e.isWebGLRenderer === true ? e.state.buffers.depth.getReversed() : e.reversedDepthBuffer;
    e.setRenderTarget(n, 0, r);
    if (h && e.autoClear === false) {
      e.clearDepth();
    }
    e.render(t, i);
    e.setRenderTarget(n, 1, r);
    if (h && e.autoClear === false) {
      e.clearDepth();
    }
    e.render(t, a);
    e.setRenderTarget(n, 2, r);
    if (h && e.autoClear === false) {
      e.clearDepth();
    }
    e.render(t, o);
    e.setRenderTarget(n, 3, r);
    if (h && e.autoClear === false) {
      e.clearDepth();
    }
    e.render(t, s);
    e.setRenderTarget(n, 4, r);
    if (h && e.autoClear === false) {
      e.clearDepth();
    }
    e.render(t, c);
    n.texture.generateMipmaps = m;
    e.setRenderTarget(n, 5, r);
    if (h && e.autoClear === false) {
      e.clearDepth();
    }
    e.render(t, l);
    e.setRenderTarget(u, d, f);
    e.xr.enabled = p;
    n.texture.needsPMREMUpdate = true;
  }
};
var $x = class extends Kx {
  constructor(e = []) {
    super();
    this.isArrayCamera = true;
    this.isMultiViewCamera = false;
    this.cameras = e;
  }
};
var eS = `\\[\\]\\.:\\/`;
var tS = RegExp(`[\\[\\]\\.:\\/]`, `g`);
var nS = `[^\\[\\]\\.:\\/]`;
var rS = `[^${eS.replace(`\\.`, ``)}]`;
var iS = `((?:WC+[\\/:])*)`.replace(`WC`, nS);
var aS = `(WCOD+)?`.replace(`WCOD`, rS);
var oS = `(?:\\.(WC+)(?:\\[(.+)\\])?)?`.replace(`WC`, nS);
var sS = `\\.(WC+)(?:\\[(.+)\\])?`.replace(`WC`, nS);
var cS = RegExp(`^${iS}${aS}${oS}${sS}$`);
var lS = [`material`, `materials`, `bones`, `map`];
var uS = class {
  constructor(e, t, n) {
    let r = n || dS.parseTrackName(t);
    this._targetGroup = e;
    this._bindings = e.subscribe_(t, r);
  }
  getValue(e, t) {
    this.bind();
    let n = this._targetGroup.nCachedObjects_;
    let r = this._bindings[n];
    if (r !== undefined) {
      r.getValue(e, t);
    }
  }
  setValue(e, t) {
    let n = this._bindings;
    for (let r = this._targetGroup.nCachedObjects_, i = n.length; r !== i; ++r) {
      n[r].setValue(e, t);
    }
  }
  bind() {
    let e = this._bindings;
    for (let t = this._targetGroup.nCachedObjects_, n = e.length; t !== n; ++t) {
      e[t].bind();
    }
  }
  unbind() {
    let e = this._bindings;
    for (let t = this._targetGroup.nCachedObjects_, n = e.length; t !== n; ++t) {
      e[t].unbind();
    }
  }
};
var dS = class e {
  constructor(t, n, r) {
    this.path = n;
    this.parsedPath = r || e.parseTrackName(n);
    this.node = e.findNode(t, this.parsedPath.nodeName);
    this.rootNode = t;
    this.getValue = this._getValue_unbound;
    this.setValue = this._setValue_unbound;
  }
  static create(t, n, r) {
    if (t && t.isAnimationObjectGroup) {
      return new e.Composite(t, n, r);
    } else {
      return new e(t, n, r);
    }
  }
  static sanitizeNodeName(e) {
    return e.replace(/\s/g, `_`).replace(tS, ``);
  }
  static parseTrackName(e) {
    let t = cS.exec(e);
    if (t === null) {
      throw Error(`THREE.PropertyBinding: Cannot parse trackName: ${e}`);
    }
    let n = {
      nodeName: t[2],
      objectName: t[3],
      objectIndex: t[4],
      propertyName: t[5],
      propertyIndex: t[6]
    };
    let r = n.nodeName && n.nodeName.lastIndexOf(`.`);
    if (r !== undefined && r !== -1) {
      let e = n.nodeName.substring(r + 1);
      if (lS.indexOf(e) !== -1) {
        n.nodeName = n.nodeName.substring(0, r);
        n.objectName = e;
      }
    }
    if (n.propertyName === null || n.propertyName.length === 0) {
      throw Error(`THREE.PropertyBinding: can not parse propertyName from trackName: ${e}`);
    }
    return n;
  }
  static findNode(e, t) {
    if (t === undefined || t === `` || t === `.` || t === -1 || t === e.name || t === e.uuid) {
      return e;
    }
    if (e.skeleton) {
      let n = e.skeleton.getBoneByName(t);
      if (n !== undefined) {
        return n;
      }
    }
    if (e.children) {
      let n = function (e) {
        for (let r = 0; r < e.length; r++) {
          let i = e[r];
          if (i.name === t || i.uuid === t) {
            return i;
          }
          let a = n(i.children);
          if (a) {
            return a;
          }
        }
        return null;
      };
      let r = n(e.children);
      if (r) {
        return r;
      }
    }
    return null;
  }
  _getValue_unavailable() {}
  _setValue_unavailable() {}
  _getValue_direct(e, t) {
    e[t] = this.targetObject[this.propertyName];
  }
  _getValue_array(e, t) {
    let n = this.resolvedProperty;
    for (let r = 0, i = n.length; r !== i; ++r) {
      e[t++] = n[r];
    }
  }
  _getValue_arrayElement(e, t) {
    e[t] = this.resolvedProperty[this.propertyIndex];
  }
  _getValue_toArray(e, t) {
    this.resolvedProperty.toArray(e, t);
  }
  _setValue_direct(e, t) {
    this.targetObject[this.propertyName] = e[t];
  }
  _setValue_direct_setNeedsUpdate(e, t) {
    this.targetObject[this.propertyName] = e[t];
    this.targetObject.needsUpdate = true;
  }
  _setValue_direct_setMatrixWorldNeedsUpdate(e, t) {
    this.targetObject[this.propertyName] = e[t];
    this.targetObject.matrixWorldNeedsUpdate = true;
  }
  _setValue_array(e, t) {
    let n = this.resolvedProperty;
    for (let r = 0, i = n.length; r !== i; ++r) {
      n[r] = e[t++];
    }
  }
  _setValue_array_setNeedsUpdate(e, t) {
    let n = this.resolvedProperty;
    for (let r = 0, i = n.length; r !== i; ++r) {
      n[r] = e[t++];
    }
    this.targetObject.needsUpdate = true;
  }
  _setValue_array_setMatrixWorldNeedsUpdate(e, t) {
    let n = this.resolvedProperty;
    for (let r = 0, i = n.length; r !== i; ++r) {
      n[r] = e[t++];
    }
    this.targetObject.matrixWorldNeedsUpdate = true;
  }
  _setValue_arrayElement(e, t) {
    this.resolvedProperty[this.propertyIndex] = e[t];
  }
  _setValue_arrayElement_setNeedsUpdate(e, t) {
    this.resolvedProperty[this.propertyIndex] = e[t];
    this.targetObject.needsUpdate = true;
  }
  _setValue_arrayElement_setMatrixWorldNeedsUpdate(e, t) {
    this.resolvedProperty[this.propertyIndex] = e[t];
    this.targetObject.matrixWorldNeedsUpdate = true;
  }
  _setValue_fromArray(e, t) {
    this.resolvedProperty.fromArray(e, t);
  }
  _setValue_fromArray_setNeedsUpdate(e, t) {
    this.resolvedProperty.fromArray(e, t);
    this.targetObject.needsUpdate = true;
  }
  _setValue_fromArray_setMatrixWorldNeedsUpdate(e, t) {
    this.resolvedProperty.fromArray(e, t);
    this.targetObject.matrixWorldNeedsUpdate = true;
  }
  _getValue_unbound(e, t) {
    this.bind();
    this.getValue(e, t);
  }
  _setValue_unbound(e, t) {
    this.bind();
    this.setValue(e, t);
  }
  bind() {
    let t = this.node;
    let n = this.parsedPath;
    let r = n.objectName;
    let i = n.propertyName;
    let a = n.propertyIndex;
    if (!t) {
      t = e.findNode(this.rootNode, n.nodeName);
      this.node = t;
    }
    this.getValue = this._getValue_unavailable;
    this.setValue = this._setValue_unavailable;
    if (!t) {
      Ug(`PropertyBinding: No target node found for track: ${this.path}.`);
      return;
    }
    if (r) {
      let e = n.objectIndex;
      switch (r) {
        case `materials`:
          if (!t.material) {
            Wg(`PropertyBinding: Can not bind to material as node does not have a material.`, this);
            return;
          }
          if (!t.material.materials) {
            Wg(`PropertyBinding: Can not bind to material.materials as node.material does not have a materials array.`, this);
            return;
          }
          t = t.material.materials;
          break;
        case `bones`:
          if (!t.skeleton) {
            Wg(`PropertyBinding: Can not bind to bones as node does not have a skeleton.`, this);
            return;
          }
          t = t.skeleton.bones;
          for (let n = 0; n < t.length; n++) {
            if (t[n].name === e) {
              e = n;
              break;
            }
          }
          break;
        case `map`:
          if (`map` in t) {
            t = t.map;
            break;
          }
          if (!t.material) {
            Wg(`PropertyBinding: Can not bind to material as node does not have a material.`, this);
            return;
          }
          if (!t.material.map) {
            Wg(`PropertyBinding: Can not bind to material.map as node.material does not have a map.`, this);
            return;
          }
          t = t.material.map;
          break;
        default:
          if (t[r] === undefined) {
            Wg(`PropertyBinding: Can not bind to objectName of node undefined.`, this);
            return;
          }
          t = t[r];
      }
      if (e !== undefined) {
        if (t[e] === undefined) {
          Wg(`PropertyBinding: Trying to bind to objectIndex of objectName, but is undefined.`, this, t);
          return;
        }
        t = t[e];
      }
    }
    let o = t[i];
    if (o === undefined) {
      let e = n.nodeName;
      Wg(`PropertyBinding: Trying to update property for track: ${e}.${i} but it wasn't found.`, t);
      return;
    }
    let s = this.Versioning.None;
    this.targetObject = t;
    if (t.isMaterial === true) {
      s = this.Versioning.NeedsUpdate;
    } else if (t.isObject3D === true) {
      s = this.Versioning.MatrixWorldNeedsUpdate;
    }
    let c = this.BindingType.Direct;
    if (a !== undefined) {
      if (i === `morphTargetInfluences`) {
        if (!t.geometry) {
          Wg(`PropertyBinding: Can not bind to morphTargetInfluences because node does not have a geometry.`, this);
          return;
        }
        if (!t.geometry.morphAttributes) {
          Wg(`PropertyBinding: Can not bind to morphTargetInfluences because node does not have a geometry.morphAttributes.`, this);
          return;
        }
        if (t.morphTargetDictionary[a] !== undefined) {
          a = t.morphTargetDictionary[a];
        }
      }
      c = this.BindingType.ArrayElement;
      this.resolvedProperty = o;
      this.propertyIndex = a;
    } else if (o.fromArray !== undefined && o.toArray !== undefined) {
      c = this.BindingType.HasFromToArray;
      this.resolvedProperty = o;
    } else if (Array.isArray(o)) {
      c = this.BindingType.EntireArray;
      this.resolvedProperty = o;
    } else {
      this.propertyName = i;
    }
    this.getValue = this.GetterByBindingType[c];
    this.setValue = this.SetterByBindingTypeAndVersioning[c][s];
  }
  unbind() {
    this.node = null;
    this.getValue = this._getValue_unbound;
    this.setValue = this._setValue_unbound;
  }
};
dS.Composite = uS;
dS.prototype.BindingType = {
  Direct: 0,
  EntireArray: 1,
  ArrayElement: 2,
  HasFromToArray: 3
};
dS.prototype.Versioning = {
  None: 0,
  NeedsUpdate: 1,
  MatrixWorldNeedsUpdate: 2
};
dS.prototype.GetterByBindingType = [dS.prototype._getValue_direct, dS.prototype._getValue_array, dS.prototype._getValue_arrayElement, dS.prototype._getValue_toArray];
dS.prototype.SetterByBindingTypeAndVersioning = [[dS.prototype._setValue_direct, dS.prototype._setValue_direct_setNeedsUpdate, dS.prototype._setValue_direct_setMatrixWorldNeedsUpdate], [dS.prototype._setValue_array, dS.prototype._setValue_array_setNeedsUpdate, dS.prototype._setValue_array_setMatrixWorldNeedsUpdate], [dS.prototype._setValue_arrayElement, dS.prototype._setValue_arrayElement_setNeedsUpdate, dS.prototype._setValue_arrayElement_setMatrixWorldNeedsUpdate], [dS.prototype._setValue_fromArray, dS.prototype._setValue_fromArray_setNeedsUpdate, dS.prototype._setValue_fromArray_setMatrixWorldNeedsUpdate]];
var fS = new q_();
var pS = class {
  constructor(e, t, n = 0, r = Infinity) {
    this.ray = new eb(e, t);
    this.near = n;
    this.far = r;
    this.camera = null;
    this.layers = new iv();
    this.params = {
      Mesh: {},
      Line: {
        threshold: 1
      },
      LOD: {},
      Points: {
        threshold: 1
      },
      Sprite: {}
    };
  }
  set(e, t) {
    this.ray.set(e, t);
  }
  setFromCamera(e, t) {
    if (t.isPerspectiveCamera) {
      this.ray.origin.setFromMatrixPosition(t.matrixWorld);
      this.ray.direction.set(e.x, e.y, 0.5).unproject(t).sub(this.ray.origin).normalize();
      this.camera = t;
    } else if (t.isOrthographicCamera) {
      this.ray.origin.set(e.x, e.y, t.projectionMatrix.elements[14]).unproject(t);
      this.ray.direction.set(0, 0, -1).transformDirection(t.matrixWorld);
      this.camera = t;
    } else {
      Wg(`Raycaster: Unsupported camera type: ${t.type}`);
    }
  }
  setFromXRController(e) {
    fS.identity().extractRotation(e.matrixWorld);
    this.ray.origin.setFromMatrixPosition(e.matrixWorld);
    this.ray.direction.set(0, 0, -1).applyMatrix4(fS);
    return this;
  }
  intersectObject(e, t = true, n = []) {
    hS(e, this, n, t);
    n.sort(mS);
    return n;
  }
  intersectObjects(e, t = true, n = []) {
    for (let r = 0, i = e.length; r < i; r++) {
      hS(e[r], this, n, t);
    }
    n.sort(mS);
    return n;
  }
};
function mS(e, t) {
  return e.distance - t.distance;
}
function hS(e, t, n, r) {
  let i = true;
  if (e.layers.test(t.layers) && e.raycast(t, n) === false) {
    i = false;
  }
  if (i === true && r === true) {
    let r = e.children;
    for (let e = 0, i = r.length; e < i; e++) {
      hS(r[e], t, n, true);
    }
  }
}
var gS = class {
  constructor(e = 1, t = 0, n = 0) {
    this.radius = e;
    this.phi = t;
    this.theta = n;
  }
  set(e, t, n) {
    this.radius = e;
    this.phi = t;
    this.theta = n;
    return this;
  }
  copy(e) {
    this.radius = e.radius;
    this.phi = e.phi;
    this.theta = e.theta;
    return this;
  }
  makeSafe() {
    let e = 0.000001;
    this.phi = e_(this.phi, e, Math.PI - e);
    return this;
  }
  setFromVector3(e) {
    return this.setFromCartesianCoords(e.x, e.y, e.z);
  }
  setFromCartesianCoords(e, t, n) {
    this.radius = Math.sqrt(e * e + t * t + n * n);
    if (this.radius === 0) {
      this.theta = 0;
      this.phi = 0;
    } else {
      this.theta = Math.atan2(e, n);
      this.phi = Math.acos(e_(t / this.radius, -1, 1));
    }
    return this;
  }
  clone() {
    return new this.constructor().copy(this);
  }
};
(class e {
  static {
    e.prototype.isMatrix2 = true;
  }
  constructor(e, t, n, r) {
    this.elements = [1, 0, 0, 1];
    if (e !== undefined) {
      this.set(e, t, n, r);
    }
  }
  identity() {
    this.set(1, 0, 0, 1);
    return this;
  }
  fromArray(e, t = 0) {
    for (let n = 0; n < 4; n++) {
      this.elements[n] = e[n + t];
    }
    return this;
  }
  set(e, t, n, r) {
    let i = this.elements;
    i[0] = e;
    i[2] = t;
    i[1] = n;
    i[3] = r;
    return this;
  }
});
var _S = class extends Jg {
  constructor(e, t = null) {
    super();
    this.object = e;
    this.domElement = t;
    this.enabled = true;
    this.state = -1;
    this.keys = {};
    this.mouseButtons = {
      LEFT: null,
      MIDDLE: null,
      RIGHT: null
    };
    this.touches = {
      ONE: null,
      TWO: null
    };
  }
  connect(e) {
    if (this.domElement !== null) {
      this.disconnect();
    }
    this.domElement = e;
  }
  disconnect() {}
  dispose() {}
  update() {}
};
function vS(e, t, n, r) {
  let i = yS(r);
  switch (n) {
    case kh:
      return e * t;
    case Ph:
      return e * t / i.components * i.byteLength;
    case Fh:
      return e * t / i.components * i.byteLength;
    case Ih:
      return e * t * 2 / i.components * i.byteLength;
    case Lh:
      return e * t * 2 / i.components * i.byteLength;
    case Ah:
      return e * t * 3 / i.components * i.byteLength;
    case jh:
      return e * t * 4 / i.components * i.byteLength;
    case Rh:
      return e * t * 4 / i.components * i.byteLength;
    case zh:
    case Bh:
      return Math.floor((e + 3) / 4) * Math.floor((t + 3) / 4) * 8;
    case Vh:
    case Hh:
      return Math.floor((e + 3) / 4) * Math.floor((t + 3) / 4) * 16;
    case Wh:
    case Kh:
      return Math.max(e, 16) * Math.max(t, 8) / 4;
    case Uh:
    case Gh:
      return Math.max(e, 8) * Math.max(t, 8) / 2;
    case qh:
    case Jh:
    case Xh:
    case Zh:
      return Math.floor((e + 3) / 4) * Math.floor((t + 3) / 4) * 8;
    case Yh:
    case Qh:
    case $h:
      return Math.floor((e + 3) / 4) * Math.floor((t + 3) / 4) * 16;
    case eg:
      return Math.floor((e + 3) / 4) * Math.floor((t + 3) / 4) * 16;
    case tg:
      return Math.floor((e + 4) / 5) * Math.floor((t + 3) / 4) * 16;
    case ng:
      return Math.floor((e + 4) / 5) * Math.floor((t + 4) / 5) * 16;
    case rg:
      return Math.floor((e + 5) / 6) * Math.floor((t + 4) / 5) * 16;
    case ig:
      return Math.floor((e + 5) / 6) * Math.floor((t + 5) / 6) * 16;
    case ag:
      return Math.floor((e + 7) / 8) * Math.floor((t + 4) / 5) * 16;
    case og:
      return Math.floor((e + 7) / 8) * Math.floor((t + 5) / 6) * 16;
    case sg:
      return Math.floor((e + 7) / 8) * Math.floor((t + 7) / 8) * 16;
    case cg:
      return Math.floor((e + 9) / 10) * Math.floor((t + 4) / 5) * 16;
    case lg:
      return Math.floor((e + 9) / 10) * Math.floor((t + 5) / 6) * 16;
    case ug:
      return Math.floor((e + 9) / 10) * Math.floor((t + 7) / 8) * 16;
    case dg:
      return Math.floor((e + 9) / 10) * Math.floor((t + 9) / 10) * 16;
    case fg:
      return Math.floor((e + 11) / 12) * Math.floor((t + 9) / 10) * 16;
    case pg:
      return Math.floor((e + 11) / 12) * Math.floor((t + 11) / 12) * 16;
    case mg:
    case hg:
    case gg:
      return Math.ceil(e / 4) * Math.ceil(t / 4) * 16;
    case _g:
    case vg:
      return Math.ceil(e / 4) * Math.ceil(t / 4) * 8;
    case yg:
    case bg:
      return Math.ceil(e / 4) * Math.ceil(t / 4) * 16;
  }
  throw Error(`Unable to determine texture byte length for ${n} format.`);
}
function yS(e) {
  switch (e) {
    case gh:
    case _h:
      return {
        byteLength: 1,
        components: 1
      };
    case yh:
    case vh:
    case Ch:
      return {
        byteLength: 2,
        components: 1
      };
    case wh:
    case Th:
      return {
        byteLength: 2,
        components: 4
      };
    case xh:
    case bh:
    case Sh:
      return {
        byteLength: 4,
        components: 1
      };
    case Dh:
    case Oh:
      return {
        byteLength: 4,
        components: 3
      };
  }
  throw Error(`THREE.TextureUtils: Unknown texture type ${e}.`);
}
if (typeof __THREE_DEVTOOLS__ < `u`) {
  __THREE_DEVTOOLS__.dispatchEvent(new CustomEvent(`register`, {
    detail: {
      revision: `186`
    }
  }));
}
if (typeof window < `u`) {
  if (window.__THREE__) {
    Ug(`WARNING: Multiple instances of Three.js being imported.`);
  } else {
    window.__THREE__ = `186`;
  }
}
function bS() {
  let e = null;
  let t = false;
  let n = null;
  let r = null;
  function i(t, a) {
    r = e.requestAnimationFrame(i);
    n(t, a);
  }
  return {
    start: function () {
      if (t !== true && n !== null && e !== null) {
        r = e.requestAnimationFrame(i);
        t = true;
      }
    },
    stop: function () {
      if (e !== null) {
        e.cancelAnimationFrame(r);
      }
      t = false;
    },
    setAnimationLoop: function (e) {
      n = e;
    },
    setContext: function (t) {
      e = t;
    }
  };
}
function xS(e) {
  let t = new WeakMap();
  function n(t, n) {
    let r = t.array;
    let i = t.usage;
    let a = r.byteLength;
    let o = e.createBuffer();
    e.bindBuffer(n, o);
    e.bufferData(n, r, i);
    t.onUploadCallback();
    let s;
    if (r instanceof Float32Array) {
      s = e.FLOAT;
    } else if (typeof Float16Array < `u` && r instanceof Float16Array) {
      s = e.HALF_FLOAT;
    } else if (r instanceof Uint16Array) {
      s = t.isFloat16BufferAttribute ? e.HALF_FLOAT : e.UNSIGNED_SHORT;
    } else if (r instanceof Int16Array) {
      s = e.SHORT;
    } else if (r instanceof Uint32Array) {
      s = e.UNSIGNED_INT;
    } else if (r instanceof Int32Array) {
      s = e.INT;
    } else if (r instanceof Int8Array) {
      s = e.BYTE;
    } else if (r instanceof Uint8Array) {
      s = e.UNSIGNED_BYTE;
    } else if (r instanceof Uint8ClampedArray) {
      s = e.UNSIGNED_BYTE;
    } else {
      throw Error(`THREE.WebGLAttributes: Unsupported buffer data format: ${r}`);
    }
    return {
      buffer: o,
      type: s,
      bytesPerElement: r.BYTES_PER_ELEMENT,
      version: t.version,
      size: a
    };
  }
  function r(t, n, r) {
    let i = n.array;
    let a = n.updateRanges;
    e.bindBuffer(r, t);
    if (a.length === 0) {
      e.bufferSubData(r, 0, i);
    } else {
      a.sort((e, t) => e.start - t.start);
      let t = 0;
      for (let e = 1; e < a.length; e++) {
        let n = a[t];
        let r = a[e];
        if (r.start <= n.start + n.count + 1) {
          n.count = Math.max(n.count, r.start + r.count - n.start);
        } else {
          ++t;
          a[t] = r;
        }
      }
      a.length = t + 1;
      for (let t = 0, n = a.length; t < n; t++) {
        let n = a[t];
        e.bufferSubData(r, n.start * i.BYTES_PER_ELEMENT, i, n.start, n.count);
      }
      n.clearUpdateRanges();
    }
    n.onUploadCallback();
  }
  function i(e) {
    if (e.isInterleavedBufferAttribute) {
      e = e.data;
    }
    return t.get(e);
  }
  function a(n) {
    if (n.isInterleavedBufferAttribute) {
      n = n.data;
    }
    let r = t.get(n);
    if (r) {
      e.deleteBuffer(r.buffer);
      t.delete(n);
    }
  }
  function o(e, i) {
    if (e.isInterleavedBufferAttribute) {
      e = e.data;
    }
    if (e.isGLBufferAttribute) {
      let n = t.get(e);
      if (!n || n.version < e.version) {
        t.set(e, {
          buffer: e.buffer,
          type: e.type,
          bytesPerElement: e.elementSize,
          version: e.version
        });
      }
      return;
    }
    let a = t.get(e);
    if (a === undefined) {
      t.set(e, n(e, i));
    } else if (a.version < e.version) {
      if (a.size !== e.array.byteLength) {
        throw Error(`THREE.WebGLAttributes: The size of the buffer attribute's array buffer does not match the original size. Resizing buffer attributes is not supported.`);
      }
      r(a.buffer, e, i);
      a.version = e.version;
    }
  }
  return {
    get: i,
    remove: a,
    update: o
  };
}
var SS = {
  alphahash_fragment: `#ifdef USE_ALPHAHASH
	if ( diffuseColor.a < getAlphaHashThreshold( vPosition ) ) discard;
#endif`,
  alphahash_pars_fragment: `#ifdef USE_ALPHAHASH
	const float ALPHA_HASH_SCALE = 0.05;
	float hash2D( vec2 value ) {
		return fract( 1.0e4 * sin( 17.0 * value.x + 0.1 * value.y ) * ( 0.1 + abs( sin( 13.0 * value.y + value.x ) ) ) );
	}
	float hash3D( vec3 value ) {
		return hash2D( vec2( hash2D( value.xy ), value.z ) );
	}
	float getAlphaHashThreshold( vec3 position ) {
		float maxDeriv = max(
			length( dFdx( position.xyz ) ),
			length( dFdy( position.xyz ) )
		);
		float pixScale = 1.0 / ( ALPHA_HASH_SCALE * maxDeriv );
		vec2 pixScales = vec2(
			exp2( floor( log2( pixScale ) ) ),
			exp2( ceil( log2( pixScale ) ) )
		);
		vec2 alpha = vec2(
			hash3D( floor( pixScales.x * position.xyz ) ),
			hash3D( floor( pixScales.y * position.xyz ) )
		);
		float lerpFactor = fract( log2( pixScale ) );
		float x = ( 1.0 - lerpFactor ) * alpha.x + lerpFactor * alpha.y;
		float a = min( lerpFactor, 1.0 - lerpFactor );
		vec3 cases = vec3(
			x * x / ( 2.0 * a * ( 1.0 - a ) ),
			( x - 0.5 * a ) / ( 1.0 - a ),
			1.0 - ( ( 1.0 - x ) * ( 1.0 - x ) / ( 2.0 * a * ( 1.0 - a ) ) )
		);
		float threshold = ( x < ( 1.0 - a ) )
			? ( ( x < a ) ? cases.x : cases.y )
			: cases.z;
		return clamp( threshold , 1.0e-6, 1.0 );
	}
#endif`,
  alphamap_fragment: `#ifdef USE_ALPHAMAP
	diffuseColor.a *= texture2D( alphaMap, vAlphaMapUv ).g;
#endif`,
  alphamap_pars_fragment: `#ifdef USE_ALPHAMAP
	uniform sampler2D alphaMap;
#endif`,
  alphatest_fragment: `#ifdef USE_ALPHATEST
	#ifdef ALPHA_TO_COVERAGE
	diffuseColor.a = smoothstep( alphaTest, alphaTest + fwidth( diffuseColor.a ), diffuseColor.a );
	if ( diffuseColor.a == 0.0 ) discard;
	#else
	if ( diffuseColor.a < alphaTest ) discard;
	#endif
#endif`,
  alphatest_pars_fragment: `#ifdef USE_ALPHATEST
	uniform float alphaTest;
#endif`,
  aomap_fragment: `#ifdef USE_AOMAP
	float ambientOcclusion = ( texture2D( aoMap, vAoMapUv ).r - 1.0 ) * aoMapIntensity + 1.0;
	reflectedLight.indirectDiffuse *= ambientOcclusion;
	#if defined( USE_CLEARCOAT ) 
		clearcoatSpecularIndirect *= ambientOcclusion;
	#endif
	#if defined( USE_SHEEN ) 
		sheenSpecularIndirect *= ambientOcclusion;
	#endif
	#if defined( USE_ENVMAP ) && defined( STANDARD )
		float dotNV = saturate( dot( geometryNormal, geometryViewDir ) );
		reflectedLight.indirectSpecular *= computeSpecularOcclusion( dotNV, ambientOcclusion, material.roughness );
	#endif
#endif`,
  aomap_pars_fragment: `#ifdef USE_AOMAP
	uniform sampler2D aoMap;
	uniform float aoMapIntensity;
#endif`,
  batching_pars_vertex: `#ifdef USE_BATCHING
	#if ! defined( GL_ANGLE_multi_draw )
	#define gl_DrawID _gl_DrawID
	uniform int _gl_DrawID;
	#endif
	uniform highp sampler2D batchingTexture;
	uniform highp usampler2D batchingIdTexture;
	mat4 getBatchingMatrix( const in float i ) {
		int size = textureSize( batchingTexture, 0 ).x;
		int j = int( i ) * 4;
		int x = j % size;
		int y = j / size;
		vec4 v1 = texelFetch( batchingTexture, ivec2( x, y ), 0 );
		vec4 v2 = texelFetch( batchingTexture, ivec2( x + 1, y ), 0 );
		vec4 v3 = texelFetch( batchingTexture, ivec2( x + 2, y ), 0 );
		vec4 v4 = texelFetch( batchingTexture, ivec2( x + 3, y ), 0 );
		return mat4( v1, v2, v3, v4 );
	}
	float getIndirectIndex( const in int i ) {
		int size = textureSize( batchingIdTexture, 0 ).x;
		int x = i % size;
		int y = i / size;
		return float( texelFetch( batchingIdTexture, ivec2( x, y ), 0 ).r );
	}
#endif
#ifdef USE_BATCHING_COLOR
	uniform sampler2D batchingColorTexture;
	vec4 getBatchingColor( const in float i ) {
		int size = textureSize( batchingColorTexture, 0 ).x;
		int j = int( i );
		int x = j % size;
		int y = j / size;
		return texelFetch( batchingColorTexture, ivec2( x, y ), 0 );
	}
#endif`,
  batching_vertex: `#ifdef USE_BATCHING
	mat4 batchingMatrix = getBatchingMatrix( getIndirectIndex( gl_DrawID ) );
#endif`,
  begin_vertex: `vec3 transformed = vec3( position );
#ifdef USE_ALPHAHASH
	vPosition = vec3( position );
#endif`,
  beginnormal_vertex: `vec3 objectNormal = vec3( normal );
#ifdef USE_TANGENT
	vec3 objectTangent = vec3( tangent.xyz );
#endif`,
  bsdfs: `float G_BlinnPhong_Implicit( ) {
	return 0.25;
}
float D_BlinnPhong( const in float shininess, const in float dotNH ) {
	return RECIPROCAL_PI * ( shininess * 0.5 + 1.0 ) * pow( dotNH, shininess );
}
vec3 BRDF_BlinnPhong( const in vec3 lightDir, const in vec3 viewDir, const in vec3 normal, const in vec3 specularColor, const in float shininess ) {
	vec3 halfDir = normalize( lightDir + viewDir );
	float dotNH = saturate( dot( normal, halfDir ) );
	float dotVH = saturate( dot( viewDir, halfDir ) );
	vec3 F = F_Schlick( specularColor, 1.0, dotVH );
	float G = G_BlinnPhong_Implicit( );
	float D = D_BlinnPhong( shininess, dotNH );
	return F * ( G * D );
} // validated`,
  iridescence_fragment: `#ifdef USE_IRIDESCENCE
	const mat3 XYZ_TO_REC709 = mat3(
		 3.2404542, -0.9692660,  0.0556434,
		-1.5371385,  1.8760108, -0.2040259,
		-0.4985314,  0.0415560,  1.0572252
	);
	vec3 Fresnel0ToIor( vec3 fresnel0 ) {
		vec3 sqrtF0 = sqrt( fresnel0 );
		return ( vec3( 1.0 ) + sqrtF0 ) / ( vec3( 1.0 ) - sqrtF0 );
	}
	vec3 IorToFresnel0( vec3 transmittedIor, float incidentIor ) {
		return pow2( ( transmittedIor - vec3( incidentIor ) ) / ( transmittedIor + vec3( incidentIor ) ) );
	}
	float IorToFresnel0( float transmittedIor, float incidentIor ) {
		return pow2( ( transmittedIor - incidentIor ) / ( transmittedIor + incidentIor ));
	}
	vec3 evalSensitivity( float OPD, vec3 shift ) {
		float phase = 2.0 * PI * OPD * 1.0e-9;
		vec3 val = vec3( 5.4856e-13, 4.4201e-13, 5.2481e-13 );
		vec3 pos = vec3( 1.6810e+06, 1.7953e+06, 2.2084e+06 );
		vec3 var = vec3( 4.3278e+09, 9.3046e+09, 6.6121e+09 );
		vec3 xyz = val * sqrt( 2.0 * PI * var ) * cos( pos * phase + shift ) * exp( - pow2( phase ) * var );
		xyz.x += 9.7470e-14 * sqrt( 2.0 * PI * 4.5282e+09 ) * cos( 2.2399e+06 * phase + shift[ 0 ] ) * exp( - 4.5282e+09 * pow2( phase ) );
		xyz /= 1.0685e-7;
		vec3 rgb = XYZ_TO_REC709 * xyz;
		return rgb;
	}
	vec3 evalIridescence( float outsideIOR, float eta2, float cosTheta1, float thinFilmThickness, vec3 baseF0 ) {
		vec3 I;
		float iridescenceIOR = mix( outsideIOR, eta2, smoothstep( 0.0, 0.03, thinFilmThickness ) );
		float sinTheta2Sq = pow2( outsideIOR / iridescenceIOR ) * ( 1.0 - pow2( cosTheta1 ) );
		float cosTheta2Sq = 1.0 - sinTheta2Sq;
		if ( cosTheta2Sq < 0.0 ) {
			return vec3( 1.0 );
		}
		float cosTheta2 = sqrt( cosTheta2Sq );
		float R0 = IorToFresnel0( iridescenceIOR, outsideIOR );
		float R12 = F_Schlick( R0, 1.0, cosTheta1 );
		float T121 = 1.0 - R12;
		float phi12 = 0.0;
		if ( iridescenceIOR < outsideIOR ) phi12 = PI;
		float phi21 = PI - phi12;
		vec3 baseIOR = Fresnel0ToIor( clamp( baseF0, 0.0, 0.9999 ) );		vec3 R1 = IorToFresnel0( baseIOR, iridescenceIOR );
		vec3 R23 = F_Schlick( R1, 1.0, cosTheta2 );
		vec3 phi23 = vec3( 0.0 );
		if ( baseIOR[ 0 ] < iridescenceIOR ) phi23[ 0 ] = PI;
		if ( baseIOR[ 1 ] < iridescenceIOR ) phi23[ 1 ] = PI;
		if ( baseIOR[ 2 ] < iridescenceIOR ) phi23[ 2 ] = PI;
		float OPD = 2.0 * iridescenceIOR * thinFilmThickness * cosTheta2;
		vec3 phi = vec3( phi21 ) + phi23;
		vec3 R123 = clamp( R12 * R23, 1e-5, 0.9999 );
		vec3 r123 = sqrt( R123 );
		vec3 Rs = pow2( T121 ) * R23 / ( vec3( 1.0 ) - R123 );
		vec3 C0 = R12 + Rs;
		I = C0;
		vec3 Cm = Rs - T121;
		for ( int m = 1; m <= 2; ++ m ) {
			Cm *= r123;
			vec3 Sm = 2.0 * evalSensitivity( float( m ) * OPD, float( m ) * phi );
			I += Cm * Sm;
		}
		return max( I, vec3( 0.0 ) );
	}
#endif`,
  bumpmap_pars_fragment: `#ifdef USE_BUMPMAP
	uniform sampler2D bumpMap;
	uniform float bumpScale;
	vec2 dHdxy_fwd() {
		vec2 dSTdx = dFdx( vBumpMapUv );
		vec2 dSTdy = dFdy( vBumpMapUv );
		float Hll = bumpScale * texture2D( bumpMap, vBumpMapUv ).x;
		float dBx = bumpScale * texture2D( bumpMap, vBumpMapUv + dSTdx ).x - Hll;
		float dBy = bumpScale * texture2D( bumpMap, vBumpMapUv + dSTdy ).x - Hll;
		return vec2( dBx, dBy );
	}
	vec3 perturbNormalArb( vec3 surf_pos, vec3 surf_norm, vec2 dHdxy, float faceDirection ) {
		vec3 vSigmaX = normalize( dFdx( surf_pos.xyz ) );
		vec3 vSigmaY = normalize( dFdy( surf_pos.xyz ) );
		vec3 vN = surf_norm;
		vec3 R1 = cross( vSigmaY, vN );
		vec3 R2 = cross( vN, vSigmaX );
		float fDet = dot( vSigmaX, R1 ) * faceDirection;
		vec3 vGrad = sign( fDet ) * ( dHdxy.x * R1 + dHdxy.y * R2 );
		return normalize( abs( fDet ) * surf_norm - vGrad );
	}
#endif`,
  clipping_planes_fragment: `#if NUM_CLIPPING_PLANES > 0
	vec4 plane;
	#ifdef ALPHA_TO_COVERAGE
		float distanceToPlane, distanceGradient;
		float clipOpacity = 1.0;
		#pragma unroll_loop_start
		for ( int i = 0; i < UNION_CLIPPING_PLANES; i ++ ) {
			plane = clippingPlanes[ i ];
			distanceToPlane = - dot( vClipPosition, plane.xyz ) + plane.w;
			distanceGradient = fwidth( distanceToPlane ) / 2.0;
			clipOpacity *= smoothstep( - distanceGradient, distanceGradient, distanceToPlane );
			if ( clipOpacity == 0.0 ) discard;
		}
		#pragma unroll_loop_end
		#if UNION_CLIPPING_PLANES < NUM_CLIPPING_PLANES
			float unionClipOpacity = 1.0;
			#pragma unroll_loop_start
			for ( int i = UNION_CLIPPING_PLANES; i < NUM_CLIPPING_PLANES; i ++ ) {
				plane = clippingPlanes[ i ];
				distanceToPlane = - dot( vClipPosition, plane.xyz ) + plane.w;
				distanceGradient = fwidth( distanceToPlane ) / 2.0;
				unionClipOpacity *= 1.0 - smoothstep( - distanceGradient, distanceGradient, distanceToPlane );
			}
			#pragma unroll_loop_end
			clipOpacity *= 1.0 - unionClipOpacity;
		#endif
		diffuseColor.a *= clipOpacity;
		if ( diffuseColor.a == 0.0 ) discard;
	#else
		#pragma unroll_loop_start
		for ( int i = 0; i < UNION_CLIPPING_PLANES; i ++ ) {
			plane = clippingPlanes[ i ];
			if ( dot( vClipPosition, plane.xyz ) > plane.w ) discard;
		}
		#pragma unroll_loop_end
		#if UNION_CLIPPING_PLANES < NUM_CLIPPING_PLANES
			bool clipped = true;
			#pragma unroll_loop_start
			for ( int i = UNION_CLIPPING_PLANES; i < NUM_CLIPPING_PLANES; i ++ ) {
				plane = clippingPlanes[ i ];
				clipped = ( dot( vClipPosition, plane.xyz ) > plane.w ) && clipped;
			}
			#pragma unroll_loop_end
			if ( clipped ) discard;
		#endif
	#endif
#endif`,
  clipping_planes_pars_fragment: `#if NUM_CLIPPING_PLANES > 0
	varying vec3 vClipPosition;
	uniform vec4 clippingPlanes[ NUM_CLIPPING_PLANES ];
#endif`,
  clipping_planes_pars_vertex: `#if NUM_CLIPPING_PLANES > 0
	varying vec3 vClipPosition;
#endif`,
  clipping_planes_vertex: `#if NUM_CLIPPING_PLANES > 0
	vClipPosition = - mvPosition.xyz;
#endif`,
  color_fragment: `#if defined( USE_COLOR ) || defined( USE_COLOR_ALPHA )
	diffuseColor *= vColor;
#endif`,
  color_pars_fragment: `#if defined( USE_COLOR ) || defined( USE_COLOR_ALPHA )
	varying vec4 vColor;
#endif`,
  color_pars_vertex: `#if defined( USE_COLOR ) || defined( USE_COLOR_ALPHA ) || defined( USE_INSTANCING_COLOR ) || defined( USE_BATCHING_COLOR )
	varying vec4 vColor;
#endif`,
  color_vertex: `#if defined( USE_COLOR ) || defined( USE_COLOR_ALPHA ) || defined( USE_INSTANCING_COLOR ) || defined( USE_BATCHING_COLOR )
	vColor = vec4( 1.0 );
#endif
#ifdef USE_COLOR_ALPHA
	vColor *= color;
#elif defined( USE_COLOR )
	vColor.rgb *= color;
#endif
#ifdef USE_INSTANCING_COLOR
	vColor.rgb *= instanceColor.rgb;
#endif
#ifdef USE_BATCHING_COLOR
	vColor *= getBatchingColor( getIndirectIndex( gl_DrawID ) );
#endif`,
  common: `#define PI 3.141592653589793
#define PI2 6.283185307179586
#define PI_HALF 1.5707963267948966
#define RECIPROCAL_PI 0.3183098861837907
#define RECIPROCAL_PI2 0.15915494309189535
#define EPSILON 1e-6
#ifndef saturate
#define saturate( a ) clamp( a, 0.0, 1.0 )
#endif
#define whiteComplement( a ) ( 1.0 - saturate( a ) )
float pow2( const in float x ) { return x*x; }
vec3 pow2( const in vec3 x ) { return x*x; }
float pow3( const in float x ) { return x*x*x; }
float pow4( const in float x ) { float x2 = x*x; return x2*x2; }
float max3( const in vec3 v ) { return max( max( v.x, v.y ), v.z ); }
float average( const in vec3 v ) { return dot( v, vec3( 0.3333333 ) ); }
highp float rand( const in vec2 uv ) {
	const highp float a = 12.9898, b = 78.233, c = 43758.5453;
	highp float dt = dot( uv.xy, vec2( a,b ) ), sn = mod( dt, PI );
	return fract( sin( sn ) * c );
}
#ifdef HIGH_PRECISION
	float precisionSafeLength( vec3 v ) { return length( v ); }
#else
	float precisionSafeLength( vec3 v ) {
		float maxComponent = max3( abs( v ) );
		return length( v / maxComponent ) * maxComponent;
	}
#endif
struct IncidentLight {
	vec3 color;
	vec3 direction;
	bool visible;
};
struct ReflectedLight {
	vec3 directDiffuse;
	vec3 directSpecular;
	vec3 indirectDiffuse;
	vec3 indirectSpecular;
};
#ifdef USE_ALPHAHASH
	varying vec3 vPosition;
#endif
vec3 transformDirection( in vec3 dir, in mat4 matrix ) {
	return normalize( ( matrix * vec4( dir, 0.0 ) ).xyz );
}
#define inverseTransformDirection transformDirectionByInverseViewMatrix
vec3 transformNormalByInverseViewMatrix( in vec3 normal, in mat4 viewMatrix ) {
	return normalize( ( vec4( normal, 0.0 ) * viewMatrix ).xyz );
}
vec3 transformDirectionByInverseViewMatrix( in vec3 dir, in mat4 viewMatrix ) {
	return normalize( ( vec4( dir, 0.0 ) * viewMatrix ).xyz );
}
bool isPerspectiveMatrix( mat4 m ) {
	return m[ 2 ][ 3 ] == - 1.0;
}
vec2 equirectUv( in vec3 dir ) {
	float u = atan( dir.z, dir.x ) * RECIPROCAL_PI2 + 0.5;
	float v = asin( clamp( dir.y, - 1.0, 1.0 ) ) * RECIPROCAL_PI + 0.5;
	return vec2( u, v );
}
vec3 BRDF_Lambert( const in vec3 diffuseColor ) {
	return RECIPROCAL_PI * diffuseColor;
}
vec3 F_Schlick( const in vec3 f0, const in float f90, const in float dotVH ) {
	float fresnel = exp2( ( - 5.55473 * dotVH - 6.98316 ) * dotVH );
	return f0 * ( 1.0 - fresnel ) + ( f90 * fresnel );
}
float F_Schlick( const in float f0, const in float f90, const in float dotVH ) {
	float fresnel = exp2( ( - 5.55473 * dotVH - 6.98316 ) * dotVH );
	return f0 * ( 1.0 - fresnel ) + ( f90 * fresnel );
} // validated`,
  cube_uv_reflection_fragment: `#ifdef ENVMAP_TYPE_CUBE_UV
	#define cubeUV_minMipLevel 4.0
	#define cubeUV_minTileSize 16.0
	float getFace( vec3 direction ) {
		vec3 absDirection = abs( direction );
		float face = - 1.0;
		if ( absDirection.x > absDirection.z ) {
			if ( absDirection.x > absDirection.y )
				face = direction.x > 0.0 ? 0.0 : 3.0;
			else
				face = direction.y > 0.0 ? 1.0 : 4.0;
		} else {
			if ( absDirection.z > absDirection.y )
				face = direction.z > 0.0 ? 2.0 : 5.0;
			else
				face = direction.y > 0.0 ? 1.0 : 4.0;
		}
		return face;
	}
	vec2 getUV( vec3 direction, float face ) {
		vec2 uv;
		if ( face == 0.0 ) {
			uv = vec2( direction.z, direction.y ) / abs( direction.x );
		} else if ( face == 1.0 ) {
			uv = vec2( - direction.x, - direction.z ) / abs( direction.y );
		} else if ( face == 2.0 ) {
			uv = vec2( - direction.x, direction.y ) / abs( direction.z );
		} else if ( face == 3.0 ) {
			uv = vec2( - direction.z, direction.y ) / abs( direction.x );
		} else if ( face == 4.0 ) {
			uv = vec2( - direction.x, direction.z ) / abs( direction.y );
		} else {
			uv = vec2( direction.x, direction.y ) / abs( direction.z );
		}
		return 0.5 * ( uv + 1.0 );
	}
	vec3 bilinearCubeUV( sampler2D envMap, vec3 direction, float mipInt ) {
		float face = getFace( direction );
		float filterInt = max( cubeUV_minMipLevel - mipInt, 0.0 );
		mipInt = max( mipInt, cubeUV_minMipLevel );
		float faceSize = exp2( mipInt );
		highp vec2 uv = getUV( direction, face ) * ( faceSize - 2.0 ) + 1.0;
		if ( face > 2.0 ) {
			uv.y += faceSize;
			face -= 3.0;
		}
		uv.x += face * faceSize;
		uv.x += filterInt * 3.0 * cubeUV_minTileSize;
		uv.y += 4.0 * ( exp2( CUBEUV_MAX_MIP ) - faceSize );
		uv.x *= CUBEUV_TEXEL_WIDTH;
		uv.y *= CUBEUV_TEXEL_HEIGHT;
		#ifdef texture2DGradEXT
			return texture2DGradEXT( envMap, uv, vec2( 0.0 ), vec2( 0.0 ) ).rgb;
		#else
			return texture2D( envMap, uv ).rgb;
		#endif
	}
	#define cubeUV_r0 1.0
	#define cubeUV_m0 - 2.0
	#define cubeUV_r1 0.8
	#define cubeUV_m1 - 1.0
	#define cubeUV_r4 0.4
	#define cubeUV_m4 2.0
	#define cubeUV_r5 0.305
	#define cubeUV_m5 3.0
	#define cubeUV_r6 0.21
	#define cubeUV_m6 4.0
	float roughnessToMip( float roughness ) {
		float mip = 0.0;
		if ( roughness >= cubeUV_r1 ) {
			mip = ( cubeUV_r0 - roughness ) * ( cubeUV_m1 - cubeUV_m0 ) / ( cubeUV_r0 - cubeUV_r1 ) + cubeUV_m0;
		} else if ( roughness >= cubeUV_r4 ) {
			mip = ( cubeUV_r1 - roughness ) * ( cubeUV_m4 - cubeUV_m1 ) / ( cubeUV_r1 - cubeUV_r4 ) + cubeUV_m1;
		} else if ( roughness >= cubeUV_r5 ) {
			mip = ( cubeUV_r4 - roughness ) * ( cubeUV_m5 - cubeUV_m4 ) / ( cubeUV_r4 - cubeUV_r5 ) + cubeUV_m4;
		} else if ( roughness >= cubeUV_r6 ) {
			mip = ( cubeUV_r5 - roughness ) * ( cubeUV_m6 - cubeUV_m5 ) / ( cubeUV_r5 - cubeUV_r6 ) + cubeUV_m5;
		} else {
			mip = - 2.0 * log2( 1.16 * roughness );		}
		return mip;
	}
	vec4 textureCubeUV( sampler2D envMap, vec3 sampleDir, float roughness ) {
		float mip = clamp( roughnessToMip( roughness ), cubeUV_m0, CUBEUV_MAX_MIP );
		float mipF = fract( mip );
		float mipInt = floor( mip );
		vec3 color0 = bilinearCubeUV( envMap, sampleDir, mipInt );
		if ( mipF == 0.0 ) {
			return vec4( color0, 1.0 );
		} else {
			vec3 color1 = bilinearCubeUV( envMap, sampleDir, mipInt + 1.0 );
			return vec4( mix( color0, color1, mipF ), 1.0 );
		}
	}
#endif`,
  defaultnormal_vertex: `vec3 transformedNormal = objectNormal;
#ifdef USE_TANGENT
	vec3 transformedTangent = objectTangent;
#endif
#ifdef USE_BATCHING
	mat3 bm = mat3( batchingMatrix );
	transformedNormal /= vec3( dot( bm[ 0 ], bm[ 0 ] ), dot( bm[ 1 ], bm[ 1 ] ), dot( bm[ 2 ], bm[ 2 ] ) );
	transformedNormal = bm * transformedNormal;
	#ifdef USE_TANGENT
		transformedTangent = bm * transformedTangent;
	#endif
#endif
#ifdef USE_INSTANCING
	mat3 im = mat3( instanceMatrix );
	transformedNormal /= vec3( dot( im[ 0 ], im[ 0 ] ), dot( im[ 1 ], im[ 1 ] ), dot( im[ 2 ], im[ 2 ] ) );
	transformedNormal = im * transformedNormal;
	#ifdef USE_TANGENT
		transformedTangent = im * transformedTangent;
	#endif
#endif
transformedNormal = normalMatrix * transformedNormal;
#ifdef FLIP_SIDED
	transformedNormal = - transformedNormal;
#endif
#ifdef USE_TANGENT
	transformedTangent = ( modelViewMatrix * vec4( transformedTangent, 0.0 ) ).xyz;
#endif`,
  displacementmap_pars_vertex: `#ifdef USE_DISPLACEMENTMAP
	uniform sampler2D displacementMap;
	uniform float displacementScale;
	uniform float displacementBias;
#endif`,
  displacementmap_vertex: `#ifdef USE_DISPLACEMENTMAP
	transformed += normalize( objectNormal ) * ( texture2D( displacementMap, vDisplacementMapUv ).x * displacementScale + displacementBias );
#endif`,
  emissivemap_fragment: `#ifdef USE_EMISSIVEMAP
	vec4 emissiveColor = texture2D( emissiveMap, vEmissiveMapUv );
	#ifdef DECODE_VIDEO_TEXTURE_EMISSIVE
		emissiveColor = sRGBTransferEOTF( emissiveColor );
	#endif
	totalEmissiveRadiance *= emissiveColor.rgb;
#endif`,
  emissivemap_pars_fragment: `#ifdef USE_EMISSIVEMAP
	uniform sampler2D emissiveMap;
#endif`,
  colorspace_fragment: `gl_FragColor = linearToOutputTexel( gl_FragColor );`,
  colorspace_pars_fragment: `vec4 LinearTransferOETF( in vec4 value ) {
	return value;
}
vec4 sRGBTransferEOTF( in vec4 value ) {
	return vec4( mix( pow( value.rgb * 0.9478672986 + vec3( 0.0521327014 ), vec3( 2.4 ) ), value.rgb * 0.0773993808, vec3( lessThanEqual( value.rgb, vec3( 0.04045 ) ) ) ), value.a );
}
vec4 sRGBTransferOETF( in vec4 value ) {
	return vec4( mix( pow( value.rgb, vec3( 0.41666 ) ) * 1.055 - vec3( 0.055 ), value.rgb * 12.92, vec3( lessThanEqual( value.rgb, vec3( 0.0031308 ) ) ) ), value.a );
}`,
  envmap_fragment: `#ifdef USE_ENVMAP
	#ifdef ENV_WORLDPOS
		vec3 cameraToFrag;
		if ( isOrthographic ) {
			cameraToFrag = normalize( vec3( - viewMatrix[ 0 ][ 2 ], - viewMatrix[ 1 ][ 2 ], - viewMatrix[ 2 ][ 2 ] ) );
		} else {
			cameraToFrag = normalize( vWorldPosition - cameraPosition );
		}
		vec3 worldNormal = transformNormalByInverseViewMatrix( normal, viewMatrix );
		#ifdef ENVMAP_MODE_REFLECTION
			vec3 reflectVec = reflect( cameraToFrag, worldNormal );
		#else
			vec3 reflectVec = refract( cameraToFrag, worldNormal, refractionRatio );
		#endif
	#else
		vec3 reflectVec = vReflect;
	#endif
	#ifdef ENVMAP_TYPE_CUBE
		vec4 envColor = textureCube( envMap, envMapRotation * reflectVec );
		#ifdef ENVMAP_BLENDING_MULTIPLY
			outgoingLight = mix( outgoingLight, outgoingLight * envColor.xyz, specularStrength * reflectivity );
		#elif defined( ENVMAP_BLENDING_MIX )
			outgoingLight = mix( outgoingLight, envColor.xyz, specularStrength * reflectivity );
		#elif defined( ENVMAP_BLENDING_ADD )
			outgoingLight += envColor.xyz * specularStrength * reflectivity;
		#endif
	#endif
#endif`,
  envmap_common_pars_fragment: `#ifdef USE_ENVMAP
	uniform float envMapIntensity;
	uniform mat3 envMapRotation;
	#ifdef ENVMAP_TYPE_CUBE
		uniform samplerCube envMap;
	#else
		uniform sampler2D envMap;
	#endif
#endif`,
  envmap_pars_fragment: `#ifdef USE_ENVMAP
	uniform float reflectivity;
	#if defined( USE_BUMPMAP ) || defined( USE_NORMALMAP ) || defined( PHONG ) || defined( LAMBERT )
		#define ENV_WORLDPOS
	#endif
	#ifdef ENV_WORLDPOS
		varying vec3 vWorldPosition;
		uniform float refractionRatio;
	#else
		varying vec3 vReflect;
	#endif
#endif`,
  envmap_pars_vertex: `#ifdef USE_ENVMAP
	#if defined( USE_BUMPMAP ) || defined( USE_NORMALMAP ) || defined( PHONG ) || defined( LAMBERT )
		#define ENV_WORLDPOS
	#endif
	#ifdef ENV_WORLDPOS
		
		varying vec3 vWorldPosition;
	#else
		varying vec3 vReflect;
		uniform float refractionRatio;
	#endif
#endif`,
  envmap_physical_pars_fragment: `#ifdef USE_ENVMAP
	vec3 getIBLIrradiance( const in vec3 normal ) {
		#ifdef ENVMAP_TYPE_CUBE_UV
			vec3 worldNormal = transformNormalByInverseViewMatrix( normal, viewMatrix );
			vec4 envMapColor = textureCubeUV( envMap, envMapRotation * worldNormal, 1.0 );
			return PI * envMapColor.rgb * envMapIntensity;
		#else
			return vec3( 0.0 );
		#endif
	}
	vec3 getIBLRadiance( const in vec3 viewDir, const in vec3 normal, const in float roughness ) {
		#ifdef ENVMAP_TYPE_CUBE_UV
			vec3 reflectVec = reflect( - viewDir, normal );
			reflectVec = normalize( mix( reflectVec, normal, pow4( roughness ) ) );
			reflectVec = transformDirectionByInverseViewMatrix( reflectVec, viewMatrix );
			vec4 envMapColor = textureCubeUV( envMap, envMapRotation * reflectVec, roughness );
			return envMapColor.rgb * envMapIntensity;
		#else
			return vec3( 0.0 );
		#endif
	}
	#ifdef USE_RETROREFLECTION
		vec3 getIBLRetroRadiance( const in vec3 viewDir, const in vec3 normal, const in float roughness ) {
			#ifdef ENVMAP_TYPE_CUBE_UV
				vec3 retroVec = normalize( mix( viewDir, normal, pow4( roughness ) ) );
				retroVec = transformDirectionByInverseViewMatrix( retroVec, viewMatrix );
				vec4 envMapColor = textureCubeUV( envMap, envMapRotation * retroVec, roughness );
				return envMapColor.rgb * envMapIntensity;
			#else
				return vec3( 0.0 );
			#endif
		}
	#endif
	#ifdef USE_ANISOTROPY
		vec3 getIBLAnisotropyRadiance( const in vec3 viewDir, const in vec3 normal, const in float roughness, const in vec3 bitangent, const in float anisotropy ) {
			#ifdef ENVMAP_TYPE_CUBE_UV
				vec3 bentNormal = cross( bitangent, viewDir );
				bentNormal = normalize( cross( bentNormal, bitangent ) );
				bentNormal = normalize( mix( bentNormal, normal, pow2( pow2( 1.0 - anisotropy * ( 1.0 - roughness ) ) ) ) );
				return getIBLRadiance( viewDir, bentNormal, roughness );
			#else
				return vec3( 0.0 );
			#endif
		}
		#ifdef USE_RETROREFLECTION
			vec3 getIBLAnisotropyRetroRadiance( const in vec3 viewDir, const in vec3 normal, const in float roughness, const in vec3 bitangent, const in float anisotropy ) {
				#ifdef ENVMAP_TYPE_CUBE_UV
					vec3 bentNormal = cross( bitangent, viewDir );
					bentNormal = normalize( cross( bentNormal, bitangent ) );
					bentNormal = normalize( mix( bentNormal, normal, pow2( pow2( 1.0 - anisotropy * ( 1.0 - roughness ) ) ) ) );
					return getIBLRetroRadiance( viewDir, bentNormal, roughness );
				#else
					return vec3( 0.0 );
				#endif
			}
		#endif
	#endif
#endif`,
  envmap_vertex: `#ifdef USE_ENVMAP
	#ifdef ENV_WORLDPOS
		vWorldPosition = worldPosition.xyz;
	#else
		vec3 cameraToVertex;
		if ( isOrthographic ) {
			cameraToVertex = normalize( vec3( - viewMatrix[ 0 ][ 2 ], - viewMatrix[ 1 ][ 2 ], - viewMatrix[ 2 ][ 2 ] ) );
		} else {
			cameraToVertex = normalize( worldPosition.xyz - cameraPosition );
		}
		vec3 worldNormal = transformNormalByInverseViewMatrix( transformedNormal, viewMatrix );
		#ifdef ENVMAP_MODE_REFLECTION
			vReflect = reflect( cameraToVertex, worldNormal );
		#else
			vReflect = refract( cameraToVertex, worldNormal, refractionRatio );
		#endif
	#endif
#endif`,
  fog_vertex: `#ifdef USE_FOG
	vFogDepth = - mvPosition.z;
#endif`,
  fog_pars_vertex: `#ifdef USE_FOG
	varying float vFogDepth;
#endif`,
  fog_fragment: `#ifdef USE_FOG
	#ifdef FOG_EXP2
		float fogFactor = 1.0 - exp( - fogDensity * fogDensity * vFogDepth * vFogDepth );
	#else
		float fogFactor = smoothstep( fogNear, fogFar, vFogDepth );
	#endif
	gl_FragColor.rgb = mix( gl_FragColor.rgb, fogColor, fogFactor );
#endif`,
  fog_pars_fragment: `#ifdef USE_FOG
	uniform vec3 fogColor;
	varying float vFogDepth;
	#ifdef FOG_EXP2
		uniform float fogDensity;
	#else
		uniform float fogNear;
		uniform float fogFar;
	#endif
#endif`,
  gradientmap_pars_fragment: `#ifdef USE_GRADIENTMAP
	uniform sampler2D gradientMap;
#endif
vec3 getGradientIrradiance( vec3 normal, vec3 lightDirection ) {
	float dotNL = dot( normal, lightDirection );
	vec2 coord = vec2( dotNL * 0.5 + 0.5, 0.0 );
	#ifdef USE_GRADIENTMAP
		return vec3( texture2D( gradientMap, coord ).r );
	#else
		vec2 fw = fwidth( coord ) * 0.5;
		return mix( vec3( 0.7 ), vec3( 1.0 ), smoothstep( 0.7 - fw.x, 0.7 + fw.x, coord.x ) );
	#endif
}`,
  lightmap_pars_fragment: `#ifdef USE_LIGHTMAP
	uniform sampler2D lightMap;
	uniform float lightMapIntensity;
#endif`,
  lights_lambert_fragment: `LambertMaterial material;
material.diffuseColor = diffuseColor.rgb;
material.specularStrength = specularStrength;`,
  lights_lambert_pars_fragment: `varying vec3 vViewPosition;
struct LambertMaterial {
	vec3 diffuseColor;
	float specularStrength;
};
void RE_Direct_Lambert( const in IncidentLight directLight, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in LambertMaterial material, inout ReflectedLight reflectedLight ) {
	float dotNL = saturate( dot( geometryNormal, directLight.direction ) );
	vec3 irradiance = dotNL * directLight.color;
	reflectedLight.directDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );
}
void RE_IndirectDiffuse_Lambert( const in vec3 irradiance, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in LambertMaterial material, inout ReflectedLight reflectedLight ) {
	reflectedLight.indirectDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );
}
#define RE_Direct				RE_Direct_Lambert
#define RE_IndirectDiffuse		RE_IndirectDiffuse_Lambert`,
  lights_pars_begin: `uniform bool receiveShadow;
uniform vec3 ambientLightColor;
#if defined( USE_LIGHT_PROBES )
	uniform vec3 lightProbe[ 9 ];
#endif
vec3 shGetIrradianceAt( in vec3 normal, in vec3 shCoefficients[ 9 ] ) {
	float x = normal.x, y = normal.y, z = normal.z;
	vec3 result = shCoefficients[ 0 ] * 0.886227;
	result += shCoefficients[ 1 ] * 2.0 * 0.511664 * y;
	result += shCoefficients[ 2 ] * 2.0 * 0.511664 * z;
	result += shCoefficients[ 3 ] * 2.0 * 0.511664 * x;
	result += shCoefficients[ 4 ] * 2.0 * 0.429043 * x * y;
	result += shCoefficients[ 5 ] * 2.0 * 0.429043 * y * z;
	result += shCoefficients[ 6 ] * ( 0.743125 * z * z - 0.247708 );
	result += shCoefficients[ 7 ] * 2.0 * 0.429043 * x * z;
	result += shCoefficients[ 8 ] * 0.429043 * ( x * x - y * y );
	return result;
}
vec3 getLightProbeIrradiance( const in vec3 lightProbe[ 9 ], const in vec3 normal ) {
	vec3 worldNormal = transformNormalByInverseViewMatrix( normal, viewMatrix );
	vec3 irradiance = shGetIrradianceAt( worldNormal, lightProbe );
	return irradiance;
}
vec3 getAmbientLightIrradiance( const in vec3 ambientLightColor ) {
	vec3 irradiance = ambientLightColor;
	return irradiance;
}
float getDistanceAttenuation( const in float lightDistance, const in float cutoffDistance, const in float decayExponent ) {
	float distanceFalloff = 1.0 / max( pow( lightDistance, decayExponent ), 0.01 );
	if ( cutoffDistance > 0.0 ) {
		distanceFalloff *= pow2( saturate( 1.0 - pow4( lightDistance / cutoffDistance ) ) );
	}
	return distanceFalloff;
}
float getSpotAttenuation( const in float coneCosine, const in float penumbraCosine, const in float angleCosine ) {
	return smoothstep( coneCosine, penumbraCosine, angleCosine );
}
#if NUM_SUN_LIGHTS > 0
	struct SunLight {
		vec3 direction;
		vec3 color;
	};
	uniform SunLight sunLights[ NUM_SUN_LIGHTS ];
	void getSunLightInfo( const in SunLight sunLight, out IncidentLight light ) {
		light.color = sunLight.color;
		light.direction = sunLight.direction;
		light.visible = true;
	}
#endif
#if NUM_DIR_LIGHTS > 0
	struct DirectionalLight {
		vec3 direction;
		vec3 color;
	};
	uniform DirectionalLight directionalLights[ NUM_DIR_LIGHTS ];
	void getDirectionalLightInfo( const in DirectionalLight directionalLight, out IncidentLight light ) {
		light.color = directionalLight.color;
		light.direction = directionalLight.direction;
		light.visible = true;
	}
#endif
#if NUM_POINT_LIGHTS > 0
	struct PointLight {
		vec3 position;
		vec3 color;
		float distance;
		float decay;
	};
	uniform PointLight pointLights[ NUM_POINT_LIGHTS ];
	void getPointLightInfo( const in PointLight pointLight, const in vec3 geometryPosition, out IncidentLight light ) {
		vec3 lVector = pointLight.position - geometryPosition;
		light.direction = normalize( lVector );
		float lightDistance = length( lVector );
		light.color = pointLight.color;
		light.color *= getDistanceAttenuation( lightDistance, pointLight.distance, pointLight.decay );
		light.visible = ( light.color != vec3( 0.0 ) );
	}
#endif
#if NUM_SPOT_LIGHTS > 0
	struct SpotLight {
		vec3 position;
		vec3 direction;
		vec3 color;
		float distance;
		float decay;
		float coneCos;
		float penumbraCos;
	};
	uniform SpotLight spotLights[ NUM_SPOT_LIGHTS ];
	void getSpotLightInfo( const in SpotLight spotLight, const in vec3 geometryPosition, out IncidentLight light ) {
		vec3 lVector = spotLight.position - geometryPosition;
		light.direction = normalize( lVector );
		float angleCos = dot( light.direction, spotLight.direction );
		float spotAttenuation = getSpotAttenuation( spotLight.coneCos, spotLight.penumbraCos, angleCos );
		if ( spotAttenuation > 0.0 ) {
			float lightDistance = length( lVector );
			light.color = spotLight.color * spotAttenuation;
			light.color *= getDistanceAttenuation( lightDistance, spotLight.distance, spotLight.decay );
			light.visible = ( light.color != vec3( 0.0 ) );
		} else {
			light.color = vec3( 0.0 );
			light.visible = false;
		}
	}
#endif
#if NUM_RECT_AREA_LIGHTS > 0
	struct RectAreaLight {
		vec3 color;
		vec3 position;
		vec3 halfWidth;
		vec3 halfHeight;
	};
	uniform sampler2D ltc_1;	uniform sampler2D ltc_2;
	uniform RectAreaLight rectAreaLights[ NUM_RECT_AREA_LIGHTS ];
#endif
#if NUM_HEMI_LIGHTS > 0
	struct HemisphereLight {
		vec3 direction;
		vec3 skyColor;
		vec3 groundColor;
	};
	uniform HemisphereLight hemisphereLights[ NUM_HEMI_LIGHTS ];
	vec3 getHemisphereLightIrradiance( const in HemisphereLight hemiLight, const in vec3 normal ) {
		float dotNL = dot( normal, hemiLight.direction );
		float hemiDiffuseWeight = 0.5 * dotNL + 0.5;
		vec3 irradiance = mix( hemiLight.groundColor, hemiLight.skyColor, hemiDiffuseWeight );
		return irradiance;
	}
#endif
#include <lightprobes_pars_fragment>`,
  lights_toon_fragment: `ToonMaterial material;
material.diffuseColor = diffuseColor.rgb;`,
  lights_toon_pars_fragment: `varying vec3 vViewPosition;
struct ToonMaterial {
	vec3 diffuseColor;
};
void RE_Direct_Toon( const in IncidentLight directLight, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in ToonMaterial material, inout ReflectedLight reflectedLight ) {
	vec3 irradiance = getGradientIrradiance( geometryNormal, directLight.direction ) * directLight.color;
	reflectedLight.directDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );
}
void RE_IndirectDiffuse_Toon( const in vec3 irradiance, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in ToonMaterial material, inout ReflectedLight reflectedLight ) {
	reflectedLight.indirectDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );
}
#define RE_Direct				RE_Direct_Toon
#define RE_IndirectDiffuse		RE_IndirectDiffuse_Toon`,
  lights_phong_fragment: `BlinnPhongMaterial material;
material.diffuseColor = diffuseColor.rgb;
material.specularColor = specular;
material.specularShininess = shininess;
material.specularStrength = specularStrength;`,
  lights_phong_pars_fragment: `varying vec3 vViewPosition;
struct BlinnPhongMaterial {
	vec3 diffuseColor;
	vec3 specularColor;
	float specularShininess;
	float specularStrength;
};
void RE_Direct_BlinnPhong( const in IncidentLight directLight, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in BlinnPhongMaterial material, inout ReflectedLight reflectedLight ) {
	float dotNL = saturate( dot( geometryNormal, directLight.direction ) );
	vec3 irradiance = dotNL * directLight.color;
	reflectedLight.directDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );
	reflectedLight.directSpecular += irradiance * BRDF_BlinnPhong( directLight.direction, geometryViewDir, geometryNormal, material.specularColor, material.specularShininess ) * material.specularStrength;
}
void RE_IndirectDiffuse_BlinnPhong( const in vec3 irradiance, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in BlinnPhongMaterial material, inout ReflectedLight reflectedLight ) {
	reflectedLight.indirectDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );
}
#define RE_Direct				RE_Direct_BlinnPhong
#define RE_IndirectDiffuse		RE_IndirectDiffuse_BlinnPhong`,
  lights_physical_fragment: `PhysicalMaterial material;
material.diffuseColor = diffuseColor.rgb;
material.diffuseContribution = diffuseColor.rgb * ( 1.0 - metalnessFactor );
material.metalness = metalnessFactor;
vec3 dxy = max( abs( dFdx( nonPerturbedNormal ) ), abs( dFdy( nonPerturbedNormal ) ) );
float geometryRoughness = max( max( dxy.x, dxy.y ), dxy.z );
material.roughness = max( roughnessFactor, 0.0525 );material.roughness += geometryRoughness;
material.roughness = min( material.roughness, 1.0 );
#ifdef IOR
	material.ior = ior;
	#ifdef USE_SPECULAR
		float specularIntensityFactor = specularIntensity;
		vec3 specularColorFactor = specularColor;
		#ifdef USE_SPECULAR_COLORMAP
			specularColorFactor *= texture2D( specularColorMap, vSpecularColorMapUv ).rgb;
		#endif
		#ifdef USE_SPECULAR_INTENSITYMAP
			specularIntensityFactor *= texture2D( specularIntensityMap, vSpecularIntensityMapUv ).a;
		#endif
		material.specularF90 = mix( specularIntensityFactor, 1.0, metalnessFactor );
	#else
		float specularIntensityFactor = 1.0;
		vec3 specularColorFactor = vec3( 1.0 );
		material.specularF90 = 1.0;
	#endif
	material.specularColor = min( pow2( ( material.ior - 1.0 ) / ( material.ior + 1.0 ) ) * specularColorFactor, vec3( 1.0 ) ) * specularIntensityFactor;
	material.specularColorBlended = mix( material.specularColor, diffuseColor.rgb, metalnessFactor );
#else
	material.specularColor = vec3( 0.04 );
	material.specularColorBlended = mix( material.specularColor, diffuseColor.rgb, metalnessFactor );
	material.specularF90 = 1.0;
#endif
#ifdef USE_CLEARCOAT
	material.clearcoat = clearcoat;
	material.clearcoatRoughness = clearcoatRoughness;
	material.clearcoatF0 = vec3( 0.04 );
	material.clearcoatF90 = 1.0;
	#ifdef USE_CLEARCOATMAP
		material.clearcoat *= texture2D( clearcoatMap, vClearcoatMapUv ).x;
	#endif
	#ifdef USE_CLEARCOAT_ROUGHNESSMAP
		material.clearcoatRoughness *= texture2D( clearcoatRoughnessMap, vClearcoatRoughnessMapUv ).y;
	#endif
	material.clearcoat = saturate( material.clearcoat );	material.clearcoatRoughness = max( material.clearcoatRoughness, 0.0525 );
	material.clearcoatRoughness += geometryRoughness;
	material.clearcoatRoughness = min( material.clearcoatRoughness, 1.0 );
#endif
#ifdef USE_DISPERSION
	material.dispersion = dispersion;
#endif
#ifdef USE_RETROREFLECTION
	material.retroreflectivity = retroreflectivity;
#endif
#ifdef USE_IRIDESCENCE
	material.iridescence = iridescence;
	material.iridescenceIOR = iridescenceIOR;
	#ifdef USE_IRIDESCENCEMAP
		material.iridescence *= texture2D( iridescenceMap, vIridescenceMapUv ).r;
	#endif
	#ifdef USE_IRIDESCENCE_THICKNESSMAP
		material.iridescenceThickness = (iridescenceThicknessMaximum - iridescenceThicknessMinimum) * texture2D( iridescenceThicknessMap, vIridescenceThicknessMapUv ).g + iridescenceThicknessMinimum;
	#else
		material.iridescenceThickness = iridescenceThicknessMaximum;
	#endif
#endif
#ifdef USE_SHEEN
	material.sheenColor = sheenColor;
	#ifdef USE_SHEEN_COLORMAP
		material.sheenColor *= texture2D( sheenColorMap, vSheenColorMapUv ).rgb;
	#endif
	material.sheenRoughness = clamp( sheenRoughness, 0.0001, 1.0 );
	#ifdef USE_SHEEN_ROUGHNESSMAP
		material.sheenRoughness *= texture2D( sheenRoughnessMap, vSheenRoughnessMapUv ).a;
	#endif
#endif
#ifdef USE_ANISOTROPY
	#ifdef USE_ANISOTROPYMAP
		mat2 anisotropyMat = mat2( anisotropyVector.x, anisotropyVector.y, - anisotropyVector.y, anisotropyVector.x );
		vec3 anisotropyPolar = texture2D( anisotropyMap, vAnisotropyMapUv ).rgb;
		vec2 anisotropyV = anisotropyMat * normalize( 2.0 * anisotropyPolar.rg - vec2( 1.0 ) ) * anisotropyPolar.b;
	#else
		vec2 anisotropyV = anisotropyVector;
	#endif
	material.anisotropy = length( anisotropyV );
	if( material.anisotropy == 0.0 ) {
		anisotropyV = vec2( 1.0, 0.0 );
	} else {
		anisotropyV /= material.anisotropy;
		material.anisotropy = saturate( material.anisotropy );
	}
	material.alphaT = mix( pow2( material.roughness ), 1.0, pow2( material.anisotropy ) );
	material.anisotropyT = tbn[ 0 ] * anisotropyV.x + tbn[ 1 ] * anisotropyV.y;
	material.anisotropyB = tbn[ 1 ] * anisotropyV.x - tbn[ 0 ] * anisotropyV.y;
#endif`,
  lights_physical_pars_fragment: `uniform sampler2D dfgLUT;
struct PhysicalMaterial {
	vec3 diffuseColor;
	vec3 diffuseContribution;
	vec3 specularColor;
	vec3 specularColorBlended;
	float roughness;
	float metalness;
	float specularF90;
	float dispersion;
	vec2 dfg;
	vec3 multiScatteringCompensation;
	#ifdef USE_RETROREFLECTION
		float retroreflectivity;
	#endif
	#ifdef USE_CLEARCOAT
		float clearcoat;
		float clearcoatRoughness;
		vec3 clearcoatF0;
		float clearcoatF90;
	#endif
	#ifdef USE_IRIDESCENCE
		float iridescence;
		float iridescenceIOR;
		float iridescenceThickness;
		vec3 iridescenceFresnel;
		vec3 iridescenceF0Dielectric;
		vec3 iridescenceF0Metallic;
	#endif
	#ifdef USE_SHEEN
		vec3 sheenColor;
		float sheenRoughness;
	#endif
	#ifdef IOR
		float ior;
	#endif
	#ifdef USE_TRANSMISSION
		float transmission;
		float transmissionAlpha;
		float thickness;
		float attenuationDistance;
		vec3 attenuationColor;
	#endif
	#ifdef USE_ANISOTROPY
		float anisotropy;
		float alphaT;
		vec3 anisotropyT;
		vec3 anisotropyB;
	#endif
};
vec3 clearcoatSpecularDirect = vec3( 0.0 );
vec3 clearcoatSpecularIndirect = vec3( 0.0 );
vec3 sheenSpecularDirect = vec3( 0.0 );
vec3 sheenSpecularIndirect = vec3(0.0 );
vec3 Schlick_to_F0( const in vec3 f, const in float f90, const in float dotVH ) {
    float x = clamp( 1.0 - dotVH, 0.0, 1.0 );
    float x2 = x * x;
    float x5 = clamp( x * x2 * x2, 0.0, 0.9999 );
    return ( f - vec3( f90 ) * x5 ) / ( 1.0 - x5 );
}
float V_GGX_SmithCorrelated( const in float alpha, const in float dotNL, const in float dotNV ) {
	float a2 = pow2( alpha );
	float gv = dotNL * sqrt( a2 + ( 1.0 - a2 ) * pow2( dotNV ) );
	float gl = dotNV * sqrt( a2 + ( 1.0 - a2 ) * pow2( dotNL ) );
	return 0.5 / max( gv + gl, EPSILON );
}
float D_GGX( const in float alpha, const in float dotNH ) {
	float a2 = pow2( alpha );
	float denom = pow2( dotNH ) * ( a2 - 1.0 ) + 1.0;
	return RECIPROCAL_PI * a2 / pow2( denom );
}
#ifdef USE_ANISOTROPY
	float V_GGX_SmithCorrelated_Anisotropic( const in float alphaT, const in float alphaB, const in float dotTV, const in float dotBV, const in float dotTL, const in float dotBL, const in float dotNV, const in float dotNL ) {
		float gv = dotNL * length( vec3( alphaT * dotTV, alphaB * dotBV, dotNV ) );
		float gl = dotNV * length( vec3( alphaT * dotTL, alphaB * dotBL, dotNL ) );
		return 0.5 / max( gv + gl, EPSILON );
	}
	float D_GGX_Anisotropic( const in float alphaT, const in float alphaB, const in float dotNH, const in float dotTH, const in float dotBH ) {
		float a2 = alphaT * alphaB;
		highp vec3 v = vec3( alphaB * dotTH, alphaT * dotBH, a2 * dotNH );
		highp float v2 = dot( v, v );
		float w2 = a2 / v2;
		return RECIPROCAL_PI * a2 * pow2 ( w2 );
	}
#endif
#ifdef USE_CLEARCOAT
	vec3 BRDF_GGX_Clearcoat( const in vec3 lightDir, const in vec3 viewDir, const in vec3 normal, const in PhysicalMaterial material) {
		vec3 f0 = material.clearcoatF0;
		float f90 = material.clearcoatF90;
		float roughness = material.clearcoatRoughness;
		float alpha = pow2( roughness );
		vec3 halfDir = normalize( lightDir + viewDir );
		float dotNL = saturate( dot( normal, lightDir ) );
		float dotNV = saturate( dot( normal, viewDir ) );
		float dotNH = saturate( dot( normal, halfDir ) );
		float dotVH = saturate( dot( viewDir, halfDir ) );
		vec3 F = F_Schlick( f0, f90, dotVH );
		float V = V_GGX_SmithCorrelated( alpha, dotNL, dotNV );
		float D = D_GGX( alpha, dotNH );
		return F * ( V * D );
	}
#endif
vec3 BRDF_GGX( const in vec3 lightDir, const in vec3 viewDir, const in vec3 normal, const in PhysicalMaterial material ) {
	vec3 f0 = material.specularColorBlended;
	float f90 = material.specularF90;
	float roughness = material.roughness;
	float alpha = pow2( roughness );
	vec3 halfDir = normalize( lightDir + viewDir );
	float dotNL = saturate( dot( normal, lightDir ) );
	float dotNV = saturate( dot( normal, viewDir ) );
	float dotNH = saturate( dot( normal, halfDir ) );
	float dotVH = saturate( dot( viewDir, halfDir ) );
	vec3 F = F_Schlick( f0, f90, dotVH );
	#ifdef USE_IRIDESCENCE
		F = mix( F, material.iridescenceFresnel, material.iridescence );
	#endif
	#ifdef USE_ANISOTROPY
		float dotTL = dot( material.anisotropyT, lightDir );
		float dotTV = dot( material.anisotropyT, viewDir );
		float dotTH = dot( material.anisotropyT, halfDir );
		float dotBL = dot( material.anisotropyB, lightDir );
		float dotBV = dot( material.anisotropyB, viewDir );
		float dotBH = dot( material.anisotropyB, halfDir );
		float V = V_GGX_SmithCorrelated_Anisotropic( material.alphaT, alpha, dotTV, dotBV, dotTL, dotBL, dotNV, dotNL );
		float D = D_GGX_Anisotropic( material.alphaT, alpha, dotNH, dotTH, dotBH );
	#else
		float V = V_GGX_SmithCorrelated( alpha, dotNL, dotNV );
		float D = D_GGX( alpha, dotNH );
	#endif
	return F * ( V * D );
}
vec2 LTC_Uv( const in vec3 N, const in vec3 V, const in float roughness ) {
	const float LUT_SIZE = 64.0;
	const float LUT_SCALE = ( LUT_SIZE - 1.0 ) / LUT_SIZE;
	const float LUT_BIAS = 0.5 / LUT_SIZE;
	float dotNV = saturate( dot( N, V ) );
	vec2 uv = vec2( roughness, sqrt( 1.0 - dotNV ) );
	uv = uv * LUT_SCALE + LUT_BIAS;
	return uv;
}
float LTC_ClippedSphereFormFactor( const in vec3 f ) {
	float l = length( f );
	return max( ( l * l + f.z ) / ( l + 1.0 ), 0.0 );
}
vec3 LTC_EdgeVectorFormFactor( const in vec3 v1, const in vec3 v2 ) {
	float x = dot( v1, v2 );
	float y = abs( x );
	float a = 0.8543985 + ( 0.4965155 + 0.0145206 * y ) * y;
	float b = 3.4175940 + ( 4.1616724 + y ) * y;
	float v = a / b;
	float theta_sintheta = ( x > 0.0 ) ? v : 0.5 * inversesqrt( max( 1.0 - x * x, 1e-7 ) ) - v;
	return cross( v1, v2 ) * theta_sintheta;
}
vec3 LTC_Evaluate( const in vec3 N, const in vec3 V, const in vec3 P, const in mat3 mInv, const in vec3 rectCoords[ 4 ] ) {
	vec3 v1 = rectCoords[ 1 ] - rectCoords[ 0 ];
	vec3 v2 = rectCoords[ 3 ] - rectCoords[ 0 ];
	vec3 lightNormal = cross( v1, v2 );
	if( dot( lightNormal, P - rectCoords[ 0 ] ) < 0.0 ) return vec3( 0.0 );
	vec3 T1, T2;
	T1 = normalize( V - N * dot( V, N ) );
	T2 = - cross( N, T1 );
	mat3 mat = mInv * transpose( mat3( T1, T2, N ) );
	vec3 coords[ 4 ];
	coords[ 0 ] = mat * ( rectCoords[ 0 ] - P );
	coords[ 1 ] = mat * ( rectCoords[ 1 ] - P );
	coords[ 2 ] = mat * ( rectCoords[ 2 ] - P );
	coords[ 3 ] = mat * ( rectCoords[ 3 ] - P );
	coords[ 0 ] = normalize( coords[ 0 ] );
	coords[ 1 ] = normalize( coords[ 1 ] );
	coords[ 2 ] = normalize( coords[ 2 ] );
	coords[ 3 ] = normalize( coords[ 3 ] );
	vec3 vectorFormFactor = vec3( 0.0 );
	vectorFormFactor += LTC_EdgeVectorFormFactor( coords[ 0 ], coords[ 1 ] );
	vectorFormFactor += LTC_EdgeVectorFormFactor( coords[ 1 ], coords[ 2 ] );
	vectorFormFactor += LTC_EdgeVectorFormFactor( coords[ 2 ], coords[ 3 ] );
	vectorFormFactor += LTC_EdgeVectorFormFactor( coords[ 3 ], coords[ 0 ] );
	float result = LTC_ClippedSphereFormFactor( vectorFormFactor );
	return vec3( result );
}
#if defined( USE_SHEEN )
float D_Charlie( float roughness, float dotNH ) {
	float alpha = pow2( roughness );
	float invAlpha = 1.0 / alpha;
	float cos2h = dotNH * dotNH;
	float sin2h = max( 1.0 - cos2h, 0.0078125 );
	return ( 2.0 + invAlpha ) * pow( sin2h, invAlpha * 0.5 ) / ( 2.0 * PI );
}
float V_Neubelt( float dotNV, float dotNL ) {
	return saturate( 1.0 / ( 4.0 * ( dotNL + dotNV - dotNL * dotNV ) ) );
}
vec3 BRDF_Sheen( const in vec3 lightDir, const in vec3 viewDir, const in vec3 normal, vec3 sheenColor, const in float sheenRoughness ) {
	vec3 halfDir = normalize( lightDir + viewDir );
	float dotNL = saturate( dot( normal, lightDir ) );
	float dotNV = saturate( dot( normal, viewDir ) );
	float dotNH = saturate( dot( normal, halfDir ) );
	float D = D_Charlie( sheenRoughness, dotNH );
	float V = V_Neubelt( dotNV, dotNL );
	return sheenColor * ( D * V );
}
#endif
float IBLSheenBRDF( const in vec3 normal, const in vec3 viewDir, const in float roughness ) {
	float dotNV = saturate( dot( normal, viewDir ) );
	float r2 = roughness * roughness;
	float rInv = 1.0 / ( roughness + 0.1 );
	float a = -1.9362 + 1.0678 * roughness + 0.4573 * r2 - 0.8469 * rInv;
	float b = -0.6014 + 0.5538 * roughness - 0.4670 * r2 - 0.1255 * rInv;
	float DG = exp( a * dotNV + b );
	return saturate( DG );
}
vec3 EnvironmentBRDF( const in vec3 normal, const in vec3 viewDir, const in vec3 specularColor, const in float specularF90, const in float roughness ) {
	float dotNV = saturate( dot( normal, viewDir ) );
	vec2 fab = texture2D( dfgLUT, vec2( roughness, dotNV ) ).rg;
	return specularColor * fab.x + specularF90 * fab.y;
}
#ifdef USE_IRIDESCENCE
void computeMultiscatteringIridescence( const in vec2 fab, const in vec3 specularColor, const in float specularF90, const in float iridescence, const in vec3 iridescenceF0, inout vec3 singleScatter, inout vec3 multiScatter ) {
#else
void computeMultiscattering( const in vec2 fab, const in vec3 specularColor, const in float specularF90, inout vec3 singleScatter, inout vec3 multiScatter ) {
#endif
	#ifdef USE_IRIDESCENCE
		vec3 Fr = mix( specularColor, iridescenceF0, iridescence );
	#else
		vec3 Fr = specularColor;
	#endif
	vec3 FssEss = Fr * fab.x + specularF90 * fab.y;
	float Ess = fab.x + fab.y;
	float Ems = 1.0 - Ess;
	vec3 Favg = Fr + ( 1.0 - Fr ) * 0.047619;	vec3 Fms = FssEss * Favg / ( 1.0 - Ems * Favg );
	singleScatter += FssEss;
	multiScatter += Fms * Ems;
}
#if NUM_RECT_AREA_LIGHTS > 0
	void RE_Direct_RectArea_Physical( const in RectAreaLight rectAreaLight, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in PhysicalMaterial material, inout ReflectedLight reflectedLight ) {
		vec3 normal = geometryNormal;
		vec3 viewDir = geometryViewDir;
		vec3 position = geometryPosition;
		vec3 lightPos = rectAreaLight.position;
		vec3 halfWidth = rectAreaLight.halfWidth;
		vec3 halfHeight = rectAreaLight.halfHeight;
		vec3 lightColor = rectAreaLight.color;
		float roughness = material.roughness;
		vec3 rectCoords[ 4 ];
		rectCoords[ 0 ] = lightPos + halfWidth - halfHeight;		rectCoords[ 1 ] = lightPos - halfWidth - halfHeight;
		rectCoords[ 2 ] = lightPos - halfWidth + halfHeight;
		rectCoords[ 3 ] = lightPos + halfWidth + halfHeight;
		vec2 uv = LTC_Uv( normal, viewDir, roughness );
		vec4 t1 = texture2D( ltc_1, uv );
		vec4 t2 = texture2D( ltc_2, uv );
		mat3 mInv = mat3(
			vec3( t1.x, 0, t1.y ),
			vec3(    0, 1,    0 ),
			vec3( t1.z, 0, t1.w )
		);
		vec3 fresnel = ( material.specularColorBlended * t2.x + ( material.specularF90 - material.specularColorBlended ) * t2.y );
		reflectedLight.directSpecular += lightColor * fresnel * LTC_Evaluate( normal, viewDir, position, mInv, rectCoords );
		reflectedLight.directDiffuse += lightColor * material.diffuseContribution * LTC_Evaluate( normal, viewDir, position, mat3( 1.0 ), rectCoords );
		#ifdef USE_CLEARCOAT
			vec3 Ncc = geometryClearcoatNormal;
			vec2 uvClearcoat = LTC_Uv( Ncc, viewDir, material.clearcoatRoughness );
			vec4 t1Clearcoat = texture2D( ltc_1, uvClearcoat );
			vec4 t2Clearcoat = texture2D( ltc_2, uvClearcoat );
			mat3 mInvClearcoat = mat3(
				vec3( t1Clearcoat.x, 0, t1Clearcoat.y ),
				vec3(             0, 1,             0 ),
				vec3( t1Clearcoat.z, 0, t1Clearcoat.w )
			);
			vec3 fresnelClearcoat = material.clearcoatF0 * t2Clearcoat.x + ( material.clearcoatF90 - material.clearcoatF0 ) * t2Clearcoat.y;
			clearcoatSpecularDirect += lightColor * fresnelClearcoat * LTC_Evaluate( Ncc, viewDir, position, mInvClearcoat, rectCoords );
		#endif
	}
#endif
void RE_Direct_Physical( const in IncidentLight directLight, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in PhysicalMaterial material, inout ReflectedLight reflectedLight ) {
	float dotNL = saturate( dot( geometryNormal, directLight.direction ) );
	vec3 irradiance = dotNL * directLight.color;
	#ifdef USE_CLEARCOAT
		float dotNLcc = saturate( dot( geometryClearcoatNormal, directLight.direction ) );
		vec3 ccIrradiance = dotNLcc * directLight.color;
		clearcoatSpecularDirect += ccIrradiance * BRDF_GGX_Clearcoat( directLight.direction, geometryViewDir, geometryClearcoatNormal, material );
	#endif
	#ifdef USE_SHEEN
 
 		sheenSpecularDirect += irradiance * BRDF_Sheen( directLight.direction, geometryViewDir, geometryNormal, material.sheenColor, material.sheenRoughness );
 
 		float sheenAlbedoV = IBLSheenBRDF( geometryNormal, geometryViewDir, material.sheenRoughness );
 		float sheenAlbedoL = IBLSheenBRDF( geometryNormal, directLight.direction, material.sheenRoughness );
 
 		float sheenEnergyComp = 1.0 - max3( material.sheenColor ) * max( sheenAlbedoV, sheenAlbedoL );
 
 		irradiance *= sheenEnergyComp;
 
 	#endif
	vec3 specularBRDF = BRDF_GGX( directLight.direction, geometryViewDir, geometryNormal, material );
	#ifdef USE_RETROREFLECTION
		vec3 retroViewDir = reflect( - geometryViewDir, geometryNormal );
		vec3 retroSpecularBRDF = BRDF_GGX( directLight.direction, retroViewDir, geometryNormal, material );
		specularBRDF = mix( specularBRDF, retroSpecularBRDF, saturate( material.retroreflectivity ) );
	#endif
	reflectedLight.directSpecular += irradiance * specularBRDF * material.multiScatteringCompensation;
	vec3 halfDir = normalize( directLight.direction + geometryViewDir );
	float dotVH = saturate( dot( geometryViewDir, halfDir ) );
	vec3 F = F_Schlick( material.specularColor, material.specularF90, dotVH );
	#ifdef USE_RETROREFLECTION
		vec3 retroHalfDir = normalize( directLight.direction + retroViewDir );
		float dotRetroVH = saturate( dot( retroViewDir, retroHalfDir ) );
		vec3 retroF = F_Schlick( material.specularColor, material.specularF90, dotRetroVH );
		F = mix( F, retroF, saturate( material.retroreflectivity ) );
	#endif
	reflectedLight.directDiffuse += irradiance * BRDF_Lambert( material.diffuseContribution ) * ( 1.0 - F );
}
void RE_IndirectDiffuse_Physical( const in vec3 irradiance, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in PhysicalMaterial material, inout ReflectedLight reflectedLight ) {
	vec3 singleScattering = vec3( 0.0 );
	vec3 multiScattering = vec3( 0.0 );
	#ifdef USE_IRIDESCENCE
		computeMultiscatteringIridescence( material.dfg, material.specularColor, material.specularF90, material.iridescence, material.iridescenceF0Dielectric, singleScattering, multiScattering );
	#else
		computeMultiscattering( material.dfg, material.specularColor, material.specularF90, singleScattering, multiScattering );
	#endif
	vec3 diffuse = irradiance * BRDF_Lambert( material.diffuseContribution ) * ( 1.0 - singleScattering - multiScattering );
	#ifdef USE_SHEEN
		float sheenAlbedo = IBLSheenBRDF( geometryNormal, geometryViewDir, material.sheenRoughness );
		sheenSpecularIndirect += irradiance * material.sheenColor * sheenAlbedo * RECIPROCAL_PI;
		float sheenEnergyComp = 1.0 - max3( material.sheenColor ) * sheenAlbedo;
		diffuse *= sheenEnergyComp;
	#endif
	reflectedLight.indirectDiffuse += diffuse;
}
void RE_IndirectSpecular_Physical( const in vec3 radiance, const in vec3 irradiance, const in vec3 clearcoatRadiance, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in PhysicalMaterial material, inout ReflectedLight reflectedLight) {
	#ifdef USE_CLEARCOAT
		clearcoatSpecularIndirect += clearcoatRadiance * EnvironmentBRDF( geometryClearcoatNormal, geometryViewDir, material.clearcoatF0, material.clearcoatF90, material.clearcoatRoughness );
	#endif
	#ifdef USE_SHEEN
		sheenSpecularIndirect += irradiance * material.sheenColor * IBLSheenBRDF( geometryNormal, geometryViewDir, material.sheenRoughness ) * RECIPROCAL_PI;
 	#endif
	vec3 singleScatteringDielectric = vec3( 0.0 );
	vec3 multiScatteringDielectric = vec3( 0.0 );
	vec3 singleScatteringMetallic = vec3( 0.0 );
	vec3 multiScatteringMetallic = vec3( 0.0 );
	#ifdef USE_IRIDESCENCE
		computeMultiscatteringIridescence( material.dfg, material.specularColor, material.specularF90, material.iridescence, material.iridescenceF0Dielectric, singleScatteringDielectric, multiScatteringDielectric );
		computeMultiscatteringIridescence( material.dfg, material.diffuseColor, material.specularF90, material.iridescence, material.iridescenceF0Metallic, singleScatteringMetallic, multiScatteringMetallic );
	#else
		computeMultiscattering( material.dfg, material.specularColor, material.specularF90, singleScatteringDielectric, multiScatteringDielectric );
		computeMultiscattering( material.dfg, material.diffuseColor, material.specularF90, singleScatteringMetallic, multiScatteringMetallic );
	#endif
	vec3 singleScattering = mix( singleScatteringDielectric, singleScatteringMetallic, material.metalness );
	vec3 multiScattering = mix( multiScatteringDielectric, multiScatteringMetallic, material.metalness );
	vec3 totalScatteringDielectric = singleScatteringDielectric + multiScatteringDielectric;
	vec3 diffuse = material.diffuseContribution * ( 1.0 - totalScatteringDielectric );
	vec3 cosineWeightedIrradiance = irradiance * RECIPROCAL_PI;
	vec3 indirectSpecular = radiance * singleScattering;
	indirectSpecular += multiScattering * cosineWeightedIrradiance;
	vec3 indirectDiffuse = diffuse * cosineWeightedIrradiance;
	#ifdef USE_SHEEN
		float sheenAlbedo = IBLSheenBRDF( geometryNormal, geometryViewDir, material.sheenRoughness );
		float sheenEnergyComp = 1.0 - max3( material.sheenColor ) * sheenAlbedo;
		indirectSpecular *= sheenEnergyComp;
		indirectDiffuse *= sheenEnergyComp;
	#endif
	reflectedLight.indirectSpecular += indirectSpecular;
	reflectedLight.indirectDiffuse += indirectDiffuse;
}
#define RE_Direct				RE_Direct_Physical
#define RE_Direct_RectArea		RE_Direct_RectArea_Physical
#define RE_IndirectDiffuse		RE_IndirectDiffuse_Physical
#define RE_IndirectSpecular		RE_IndirectSpecular_Physical
float computeSpecularOcclusion( const in float dotNV, const in float ambientOcclusion, const in float roughness ) {
	return saturate( pow( dotNV + ambientOcclusion, exp2( - 16.0 * roughness - 1.0 ) ) - 1.0 + ambientOcclusion );
}`,
  lights_fragment_begin: `
vec3 geometryPosition = - vViewPosition;
vec3 geometryNormal = normal;
vec3 geometryViewDir = ( isOrthographic ) ? vec3( 0, 0, 1 ) : normalize( vViewPosition );
vec3 geometryClearcoatNormal = vec3( 0.0 );
#ifdef USE_CLEARCOAT
	geometryClearcoatNormal = clearcoatNormal;
#endif
#ifdef USE_IRIDESCENCE
	float dotNVi = saturate( dot( normal, geometryViewDir ) );
	if ( material.iridescenceThickness == 0.0 ) {
		material.iridescence = 0.0;
	} else {
		material.iridescence = saturate( material.iridescence );
	}
	if ( material.iridescence > 0.0 ) {
		vec3 iridescenceFresnelDielectric = evalIridescence( 1.0, material.iridescenceIOR, dotNVi, material.iridescenceThickness, material.specularColor );
		vec3 iridescenceFresnelMetallic = evalIridescence( 1.0, material.iridescenceIOR, dotNVi, material.iridescenceThickness, material.diffuseColor );
		material.iridescenceFresnel = mix( iridescenceFresnelDielectric, iridescenceFresnelMetallic, material.metalness );
		material.iridescenceF0Dielectric = Schlick_to_F0( iridescenceFresnelDielectric, 1.0, dotNVi );
		material.iridescenceF0Metallic = Schlick_to_F0( iridescenceFresnelMetallic, 1.0, dotNVi );
	}
#endif
#ifdef STANDARD
	float dotNVms = saturate( dot( geometryNormal, geometryViewDir ) );
	material.dfg = texture2D( dfgLUT, vec2( material.roughness, dotNVms ) ).rg;
	#if ( NUM_SUN_LIGHTS > 0 || NUM_DIR_LIGHTS > 0 || NUM_POINT_LIGHTS > 0 || NUM_SPOT_LIGHTS > 0 )
		float EssMs = material.dfg.x + material.dfg.y;
		material.multiScatteringCompensation = 1.0 + material.specularColorBlended * ( 1.0 / EssMs - 1.0 );
	#endif
#endif
IncidentLight directLight;
#if ( NUM_POINT_LIGHTS > 0 ) && defined( RE_Direct )
	PointLight pointLight;
	#if defined( USE_SHADOWMAP ) && NUM_POINT_LIGHT_SHADOWS > 0
	PointLightShadow pointLightShadow;
	#endif
	#pragma unroll_loop_start
	for ( int i = 0; i < NUM_POINT_LIGHTS; i ++ ) {
		pointLight = pointLights[ i ];
		getPointLightInfo( pointLight, geometryPosition, directLight );
		#if defined( USE_SHADOWMAP ) && ( UNROLLED_LOOP_INDEX < NUM_POINT_LIGHT_SHADOWS ) && ( defined( SHADOWMAP_TYPE_PCF ) || defined( SHADOWMAP_TYPE_BASIC ) )
		pointLightShadow = pointLightShadows[ i ];
		directLight.color *= ( directLight.visible && receiveShadow ) ? getPointShadow( pointShadowMap[ i ], pointLightShadow.shadowMapSize, pointLightShadow.shadowIntensity, pointLightShadow.shadowBias, pointLightShadow.shadowRadius, vPointShadowCoord[ i ], pointLightShadow.shadowCameraNear, pointLightShadow.shadowCameraFar ) : 1.0;
		#endif
		RE_Direct( directLight, geometryPosition, geometryNormal, geometryViewDir, geometryClearcoatNormal, material, reflectedLight );
	}
	#pragma unroll_loop_end
#endif
#if ( NUM_SPOT_LIGHTS > 0 ) && defined( RE_Direct )
	SpotLight spotLight;
	vec4 spotColor;
	vec3 spotLightCoord;
	bool inSpotLightMap;
	#if defined( USE_SHADOWMAP ) && NUM_SPOT_LIGHT_SHADOWS > 0
	SpotLightShadow spotLightShadow;
	#endif
	#pragma unroll_loop_start
	for ( int i = 0; i < NUM_SPOT_LIGHTS; i ++ ) {
		spotLight = spotLights[ i ];
		getSpotLightInfo( spotLight, geometryPosition, directLight );
		#if ( UNROLLED_LOOP_INDEX < NUM_SPOT_LIGHT_SHADOWS_WITH_MAPS )
		#define SPOT_LIGHT_MAP_INDEX UNROLLED_LOOP_INDEX
		#elif ( UNROLLED_LOOP_INDEX < NUM_SPOT_LIGHT_SHADOWS )
		#define SPOT_LIGHT_MAP_INDEX NUM_SPOT_LIGHT_MAPS
		#else
		#define SPOT_LIGHT_MAP_INDEX ( UNROLLED_LOOP_INDEX - NUM_SPOT_LIGHT_SHADOWS + NUM_SPOT_LIGHT_SHADOWS_WITH_MAPS )
		#endif
		#if ( SPOT_LIGHT_MAP_INDEX < NUM_SPOT_LIGHT_MAPS )
			spotLightCoord = vSpotLightCoord[ i ].xyz / vSpotLightCoord[ i ].w;
			inSpotLightMap = all( lessThan( abs( spotLightCoord * 2. - 1. ), vec3( 1.0 ) ) );
			spotColor = texture2D( spotLightMap[ SPOT_LIGHT_MAP_INDEX ], spotLightCoord.xy );
			directLight.color = inSpotLightMap ? directLight.color * spotColor.rgb : directLight.color;
		#endif
		#undef SPOT_LIGHT_MAP_INDEX
		#if defined( USE_SHADOWMAP ) && ( UNROLLED_LOOP_INDEX < NUM_SPOT_LIGHT_SHADOWS )
		spotLightShadow = spotLightShadows[ i ];
		directLight.color *= ( directLight.visible && receiveShadow ) ? getShadow( spotShadowMap[ i ], spotLightShadow.shadowMapSize, spotLightShadow.shadowIntensity, spotLightShadow.shadowBias, spotLightShadow.shadowRadius, vSpotLightCoord[ i ] ) : 1.0;
		#endif
		RE_Direct( directLight, geometryPosition, geometryNormal, geometryViewDir, geometryClearcoatNormal, material, reflectedLight );
	}
	#pragma unroll_loop_end
#endif
#if ( NUM_SUN_LIGHTS > 0 ) && defined( RE_Direct )
	SunLight sunLight;
	#if defined( USE_SHADOWMAP ) && NUM_SUN_LIGHT_SHADOWS > 0
	SunLightShadow sunLightShadow;
	#endif
	#pragma unroll_loop_start
	for ( int i = 0; i < NUM_SUN_LIGHTS; i ++ ) {
		sunLight = sunLights[ i ];
		getSunLightInfo( sunLight, directLight );
		#if defined( USE_SHADOWMAP ) && ( UNROLLED_LOOP_INDEX < NUM_SUN_LIGHT_SHADOWS )
		sunLightShadow = sunLightShadows[ i ];
		directLight.color *= ( directLight.visible && receiveShadow ) ? getSunShadow( sunShadowMap[ i ], sunLightShadow, UNROLLED_LOOP_INDEX ) : 1.0;
		#endif
		RE_Direct( directLight, geometryPosition, geometryNormal, geometryViewDir, geometryClearcoatNormal, material, reflectedLight );
	}
	#pragma unroll_loop_end
#endif
#if ( NUM_DIR_LIGHTS > 0 ) && defined( RE_Direct )
	DirectionalLight directionalLight;
	#if defined( USE_SHADOWMAP ) && NUM_DIR_LIGHT_SHADOWS > 0
	DirectionalLightShadow directionalLightShadow;
	#endif
	#pragma unroll_loop_start
	for ( int i = 0; i < NUM_DIR_LIGHTS; i ++ ) {
		directionalLight = directionalLights[ i ];
		getDirectionalLightInfo( directionalLight, directLight );
		#if defined( USE_SHADOWMAP ) && ( UNROLLED_LOOP_INDEX < NUM_DIR_LIGHT_SHADOWS )
		directionalLightShadow = directionalLightShadows[ i ];
		directLight.color *= ( directLight.visible && receiveShadow ) ? getShadow( directionalShadowMap[ i ], directionalLightShadow.shadowMapSize, directionalLightShadow.shadowIntensity, directionalLightShadow.shadowBias, directionalLightShadow.shadowRadius, vDirectionalShadowCoord[ i ] ) : 1.0;
		#endif
		RE_Direct( directLight, geometryPosition, geometryNormal, geometryViewDir, geometryClearcoatNormal, material, reflectedLight );
	}
	#pragma unroll_loop_end
#endif
#if ( NUM_RECT_AREA_LIGHTS > 0 ) && defined( RE_Direct_RectArea )
	RectAreaLight rectAreaLight;
	#pragma unroll_loop_start
	for ( int i = 0; i < NUM_RECT_AREA_LIGHTS; i ++ ) {
		rectAreaLight = rectAreaLights[ i ];
		RE_Direct_RectArea( rectAreaLight, geometryPosition, geometryNormal, geometryViewDir, geometryClearcoatNormal, material, reflectedLight );
	}
	#pragma unroll_loop_end
#endif
#if defined( RE_IndirectDiffuse )
	vec3 iblIrradiance = vec3( 0.0 );
	vec3 irradiance = getAmbientLightIrradiance( ambientLightColor );
	#if defined( USE_LIGHT_PROBES )
		irradiance += getLightProbeIrradiance( lightProbe, geometryNormal );
	#endif
	#if ( NUM_HEMI_LIGHTS > 0 )
		#pragma unroll_loop_start
		for ( int i = 0; i < NUM_HEMI_LIGHTS; i ++ ) {
			irradiance += getHemisphereLightIrradiance( hemisphereLights[ i ], geometryNormal );
		}
		#pragma unroll_loop_end
	#endif
	#ifdef USE_LIGHT_PROBES_GRID
		vec3 probeWorldPos = ( ( vec4( geometryPosition, 1.0 ) - viewMatrix[ 3 ] ) * viewMatrix ).xyz;
		vec3 probeWorldNormal = transformNormalByInverseViewMatrix( geometryNormal, viewMatrix );
		irradiance += getLightProbeGridIrradiance( probeWorldPos, probeWorldNormal );
	#endif
#endif
#if defined( RE_IndirectSpecular )
	vec3 radiance = vec3( 0.0 );
	vec3 clearcoatRadiance = vec3( 0.0 );
#endif`,
  lights_fragment_maps: `#if defined( RE_IndirectDiffuse )
	#ifdef USE_LIGHTMAP
		vec4 lightMapTexel = texture2D( lightMap, vLightMapUv );
		vec3 lightMapIrradiance = lightMapTexel.rgb * lightMapIntensity;
		irradiance += lightMapIrradiance;
	#endif
	#if defined( USE_ENVMAP ) && defined( ENVMAP_TYPE_CUBE_UV )
		#if defined( STANDARD ) || defined( LAMBERT ) || defined( PHONG )
			iblIrradiance += getIBLIrradiance( geometryNormal );
		#endif
	#endif
#endif
#if defined( USE_ENVMAP ) && defined( RE_IndirectSpecular )
	#ifdef USE_ANISOTROPY
		vec3 iblRadiance = getIBLAnisotropyRadiance( geometryViewDir, geometryNormal, material.roughness, material.anisotropyB, material.anisotropy );
	#else
		vec3 iblRadiance = getIBLRadiance( geometryViewDir, geometryNormal, material.roughness );
	#endif
	#ifdef USE_RETROREFLECTION
		#ifdef USE_ANISOTROPY
			vec3 retroIBLRadiance = getIBLAnisotropyRetroRadiance( geometryViewDir, geometryNormal, material.roughness, material.anisotropyB, material.anisotropy );
		#else
			vec3 retroIBLRadiance = getIBLRetroRadiance( geometryViewDir, geometryNormal, material.roughness );
		#endif
		iblRadiance = mix( iblRadiance, retroIBLRadiance, saturate( material.retroreflectivity ) );
	#endif
	radiance += iblRadiance;
	#ifdef USE_CLEARCOAT
		clearcoatRadiance += getIBLRadiance( geometryViewDir, geometryClearcoatNormal, material.clearcoatRoughness );
	#endif
#endif`,
  lights_fragment_end: `#if defined( RE_IndirectDiffuse )
	#if defined( LAMBERT ) || defined( PHONG )
		irradiance += iblIrradiance;
	#endif
	RE_IndirectDiffuse( irradiance, geometryPosition, geometryNormal, geometryViewDir, geometryClearcoatNormal, material, reflectedLight );
#endif
#if defined( RE_IndirectSpecular )
	RE_IndirectSpecular( radiance, iblIrradiance, clearcoatRadiance, geometryPosition, geometryNormal, geometryViewDir, geometryClearcoatNormal, material, reflectedLight );
#endif`,
  lightprobes_pars_fragment: `#ifdef USE_LIGHT_PROBES_GRID
uniform highp sampler3D probesSH;
uniform vec3 probesMin;
uniform vec3 probesMax;
uniform vec3 probesResolution;
vec3 getLightProbeGridIrradiance( vec3 worldPos, vec3 worldNormal ) {
	vec3 res = probesResolution;
	vec3 gridRange = probesMax - probesMin;
	vec3 resMinusOne = res - 1.0;
	vec3 probeSpacing = gridRange / resMinusOne;
	vec3 samplePos = worldPos + worldNormal * probeSpacing * 0.5;
	vec3 uvw = clamp( ( samplePos - probesMin ) / gridRange, 0.0, 1.0 );
	uvw = uvw * resMinusOne / res + 0.5 / res;
	float nz          = res.z;
	float paddedSlices = nz + 2.0;
	float atlasDepth  = 7.0 * paddedSlices;
	float uvZBase     = uvw.z * nz + 1.0;
	vec4 s0 = texture( probesSH, vec3( uvw.xy, ( uvZBase                       ) / atlasDepth ) );
	vec4 s1 = texture( probesSH, vec3( uvw.xy, ( uvZBase +       paddedSlices   ) / atlasDepth ) );
	vec4 s2 = texture( probesSH, vec3( uvw.xy, ( uvZBase + 2.0 * paddedSlices   ) / atlasDepth ) );
	vec4 s3 = texture( probesSH, vec3( uvw.xy, ( uvZBase + 3.0 * paddedSlices   ) / atlasDepth ) );
	vec4 s4 = texture( probesSH, vec3( uvw.xy, ( uvZBase + 4.0 * paddedSlices   ) / atlasDepth ) );
	vec4 s5 = texture( probesSH, vec3( uvw.xy, ( uvZBase + 5.0 * paddedSlices   ) / atlasDepth ) );
	vec4 s6 = texture( probesSH, vec3( uvw.xy, ( uvZBase + 6.0 * paddedSlices   ) / atlasDepth ) );
	vec3 c0 = s0.xyz;
	vec3 c1 = vec3( s0.w, s1.xy );
	vec3 c2 = vec3( s1.zw, s2.x );
	vec3 c3 = s2.yzw;
	vec3 c4 = s3.xyz;
	vec3 c5 = vec3( s3.w, s4.xy );
	vec3 c6 = vec3( s4.zw, s5.x );
	vec3 c7 = s5.yzw;
	vec3 c8 = s6.xyz;
	float x = worldNormal.x, y = worldNormal.y, z = worldNormal.z;
	vec3 result = c0 * 0.886227;
	result += c1 * 2.0 * 0.511664 * y;
	result += c2 * 2.0 * 0.511664 * z;
	result += c3 * 2.0 * 0.511664 * x;
	result += c4 * 2.0 * 0.429043 * x * y;
	result += c5 * 2.0 * 0.429043 * y * z;
	result += c6 * ( 0.743125 * z * z - 0.247708 );
	result += c7 * 2.0 * 0.429043 * x * z;
	result += c8 * 0.429043 * ( x * x - y * y );
	return max( result, vec3( 0.0 ) );
}
#endif`,
  logdepthbuf_fragment: `#if defined( USE_LOGARITHMIC_DEPTH_BUFFER )
	gl_FragDepth = vIsPerspective == 0.0 ? gl_FragCoord.z : log2( vFragDepth ) * logDepthBufFC * 0.5;
#endif`,
  logdepthbuf_pars_fragment: `#if defined( USE_LOGARITHMIC_DEPTH_BUFFER )
	uniform float logDepthBufFC;
	varying float vFragDepth;
	varying float vIsPerspective;
#endif`,
  logdepthbuf_pars_vertex: `#ifdef USE_LOGARITHMIC_DEPTH_BUFFER
	varying float vFragDepth;
	varying float vIsPerspective;
#endif`,
  logdepthbuf_vertex: `#ifdef USE_LOGARITHMIC_DEPTH_BUFFER
	vFragDepth = 1.0 + gl_Position.w;
	vIsPerspective = float( isPerspectiveMatrix( projectionMatrix ) );
#endif`,
  map_fragment: `#ifdef USE_MAP
	vec4 sampledDiffuseColor = texture2D( map, vMapUv );
	#ifdef DECODE_VIDEO_TEXTURE
		sampledDiffuseColor = sRGBTransferEOTF( sampledDiffuseColor );
	#endif
	diffuseColor *= sampledDiffuseColor;
#endif`,
  map_pars_fragment: `#ifdef USE_MAP
	uniform sampler2D map;
#endif`,
  map_particle_fragment: `#if defined( USE_MAP ) || defined( USE_ALPHAMAP )
	#if defined( USE_POINTS_UV )
		vec2 uv = vUv;
	#else
		vec2 uv = ( uvTransform * vec3( gl_PointCoord.x, 1.0 - gl_PointCoord.y, 1 ) ).xy;
	#endif
#endif
#ifdef USE_MAP
	diffuseColor *= texture2D( map, uv );
#endif
#ifdef USE_ALPHAMAP
	diffuseColor.a *= texture2D( alphaMap, uv ).g;
#endif`,
  map_particle_pars_fragment: `#if defined( USE_POINTS_UV )
	varying vec2 vUv;
#else
	#if defined( USE_MAP ) || defined( USE_ALPHAMAP )
		uniform mat3 uvTransform;
	#endif
#endif
#ifdef USE_MAP
	uniform sampler2D map;
#endif
#ifdef USE_ALPHAMAP
	uniform sampler2D alphaMap;
#endif`,
  metalnessmap_fragment: `float metalnessFactor = metalness;
#ifdef USE_METALNESSMAP
	vec4 texelMetalness = texture2D( metalnessMap, vMetalnessMapUv );
	metalnessFactor *= texelMetalness.b;
#endif`,
  metalnessmap_pars_fragment: `#ifdef USE_METALNESSMAP
	uniform sampler2D metalnessMap;
#endif`,
  morphinstance_vertex: `#ifdef USE_INSTANCING_MORPH
	float morphTargetInfluences[ MORPHTARGETS_COUNT ];
	float morphTargetBaseInfluence = texelFetch( morphTexture, ivec2( 0, gl_InstanceID ), 0 ).r;
	for ( int i = 0; i < MORPHTARGETS_COUNT; i ++ ) {
		morphTargetInfluences[i] =  texelFetch( morphTexture, ivec2( i + 1, gl_InstanceID ), 0 ).r;
	}
#endif`,
  morphcolor_vertex: `#if defined( USE_MORPHCOLORS )
	vColor *= morphTargetBaseInfluence;
	for ( int i = 0; i < MORPHTARGETS_COUNT; i ++ ) {
		#if defined( USE_COLOR_ALPHA )
			if ( morphTargetInfluences[ i ] != 0.0 ) vColor += getMorph( gl_VertexID, i, 2 ) * morphTargetInfluences[ i ];
		#elif defined( USE_COLOR )
			if ( morphTargetInfluences[ i ] != 0.0 ) vColor += getMorph( gl_VertexID, i, 2 ).rgb * morphTargetInfluences[ i ];
		#endif
	}
#endif`,
  morphnormal_vertex: `#ifdef USE_MORPHNORMALS
	objectNormal *= morphTargetBaseInfluence;
	for ( int i = 0; i < MORPHTARGETS_COUNT; i ++ ) {
		if ( morphTargetInfluences[ i ] != 0.0 ) objectNormal += getMorph( gl_VertexID, i, 1 ).xyz * morphTargetInfluences[ i ];
	}
#endif`,
  morphtarget_pars_vertex: `#ifdef USE_MORPHTARGETS
	#ifndef USE_INSTANCING_MORPH
		uniform float morphTargetBaseInfluence;
		uniform float morphTargetInfluences[ MORPHTARGETS_COUNT ];
	#endif
	uniform sampler2DArray morphTargetsTexture;
	uniform ivec2 morphTargetsTextureSize;
	vec4 getMorph( const in int vertexIndex, const in int morphTargetIndex, const in int offset ) {
		int texelIndex = vertexIndex * MORPHTARGETS_TEXTURE_STRIDE + offset;
		int y = texelIndex / morphTargetsTextureSize.x;
		int x = texelIndex - y * morphTargetsTextureSize.x;
		ivec3 morphUV = ivec3( x, y, morphTargetIndex );
		return texelFetch( morphTargetsTexture, morphUV, 0 );
	}
#endif`,
  morphtarget_vertex: `#ifdef USE_MORPHTARGETS
	transformed *= morphTargetBaseInfluence;
	for ( int i = 0; i < MORPHTARGETS_COUNT; i ++ ) {
		if ( morphTargetInfluences[ i ] != 0.0 ) transformed += getMorph( gl_VertexID, i, 0 ).xyz * morphTargetInfluences[ i ];
	}
#endif`,
  normal_fragment_begin: `float faceDirection = gl_FrontFacing ? 1.0 : - 1.0;
#ifdef FLAT_SHADED
	vec3 fdx = dFdx( vViewPosition );
	vec3 fdy = dFdy( vViewPosition );
	vec3 normal = normalize( cross( fdx, fdy ) );
#else
	vec3 normal = normalize( vNormal );
	#ifdef DOUBLE_SIDED
		normal *= faceDirection;
	#endif
#endif
#if defined( USE_NORMALMAP_TANGENTSPACE ) || defined( USE_CLEARCOAT_NORMALMAP ) || defined( USE_ANISOTROPY )
	#ifdef USE_TANGENT
		mat3 tbn = mat3( normalize( vTangent ), normalize( vBitangent ), normal );
	#else
		mat3 tbn = getTangentFrame( - vViewPosition, normal,
		#if defined( USE_NORMALMAP )
			vNormalMapUv
		#elif defined( USE_CLEARCOAT_NORMALMAP )
			vClearcoatNormalMapUv
		#else
			vUv
		#endif
		);
	#endif
	#ifdef DOUBLE_SIDED
		tbn[0] *= faceDirection;
		tbn[1] *= faceDirection;
	#endif
#endif
#ifdef USE_CLEARCOAT_NORMALMAP
	#ifdef USE_TANGENT
		mat3 tbn2 = mat3( normalize( vTangent ), normalize( vBitangent ), normal );
	#else
		mat3 tbn2 = getTangentFrame( - vViewPosition, normal, vClearcoatNormalMapUv );
	#endif
	#ifdef DOUBLE_SIDED
		tbn2[0] *= faceDirection;
		tbn2[1] *= faceDirection;
	#endif
#endif
vec3 nonPerturbedNormal = normal;`,
  normal_fragment_maps: `#ifdef USE_NORMALMAP_OBJECTSPACE
	normal = texture2D( normalMap, vNormalMapUv ).xyz * 2.0 - 1.0;
	#ifdef FLIP_SIDED
		normal = - normal;
	#endif
	#ifdef DOUBLE_SIDED
		normal = normal * faceDirection;
	#endif
	normal = normalize( normalMatrix * normal );
#elif defined( USE_NORMALMAP_TANGENTSPACE )
	vec3 mapN = texture2D( normalMap, vNormalMapUv ).xyz * 2.0 - 1.0;
	#if defined( USE_PACKED_NORMALMAP )
		mapN = vec3( mapN.xy, sqrt( saturate( 1.0 - dot( mapN.xy, mapN.xy ) ) ) );
	#endif
	mapN.xy *= normalScale;
	normal = normalize( tbn * mapN );
#elif defined( USE_BUMPMAP )
	normal = perturbNormalArb( - vViewPosition, normal, dHdxy_fwd(), faceDirection );
#endif`,
  normal_pars_fragment: `#ifndef FLAT_SHADED
	varying vec3 vNormal;
	#ifdef USE_TANGENT
		varying vec3 vTangent;
		varying vec3 vBitangent;
	#endif
#endif`,
  normal_pars_vertex: `#ifndef FLAT_SHADED
	varying vec3 vNormal;
	#ifdef USE_TANGENT
		varying vec3 vTangent;
		varying vec3 vBitangent;
	#endif
#endif`,
  normal_vertex: `#ifndef FLAT_SHADED
	vNormal = normalize( transformedNormal );
	#ifdef USE_TANGENT
		vTangent = normalize( transformedTangent );
		vBitangent = normalize( cross( vNormal, vTangent ) * tangent.w );
		#ifdef FLIP_SIDED
			vBitangent = - vBitangent;
		#endif
	#endif
#endif`,
  normalmap_pars_fragment: `#ifdef USE_NORMALMAP
	uniform sampler2D normalMap;
	uniform vec2 normalScale;
#endif
#ifdef USE_NORMALMAP_OBJECTSPACE
	uniform mat3 normalMatrix;
#endif
#if ! defined ( USE_TANGENT ) && ( defined ( USE_NORMALMAP_TANGENTSPACE ) || defined ( USE_CLEARCOAT_NORMALMAP ) || defined( USE_ANISOTROPY ) )
	mat3 getTangentFrame( vec3 eye_pos, vec3 surf_norm, vec2 uv ) {
		vec3 q0 = dFdx( eye_pos.xyz );
		vec3 q1 = dFdy( eye_pos.xyz );
		vec2 st0 = dFdx( uv.st );
		vec2 st1 = dFdy( uv.st );
		vec3 N = surf_norm;
		vec3 q1perp = cross( q1, N );
		vec3 q0perp = cross( N, q0 );
		vec3 T = q1perp * st0.x + q0perp * st1.x;
		vec3 B = q1perp * st0.y + q0perp * st1.y;
		float det = max( dot( T, T ), dot( B, B ) );
		float scale = ( det == 0.0 ) ? 0.0 : inversesqrt( det );
		return mat3( T * scale, B * scale, N );
	}
#endif`,
  clearcoat_normal_fragment_begin: `#ifdef USE_CLEARCOAT
	vec3 clearcoatNormal = nonPerturbedNormal;
#endif`,
  clearcoat_normal_fragment_maps: `#ifdef USE_CLEARCOAT_NORMALMAP
	vec3 clearcoatMapN = texture2D( clearcoatNormalMap, vClearcoatNormalMapUv ).xyz * 2.0 - 1.0;
	clearcoatMapN.xy *= clearcoatNormalScale;
	clearcoatNormal = normalize( tbn2 * clearcoatMapN );
#endif`,
  clearcoat_pars_fragment: `#ifdef USE_CLEARCOATMAP
	uniform sampler2D clearcoatMap;
#endif
#ifdef USE_CLEARCOAT_NORMALMAP
	uniform sampler2D clearcoatNormalMap;
	uniform vec2 clearcoatNormalScale;
#endif
#ifdef USE_CLEARCOAT_ROUGHNESSMAP
	uniform sampler2D clearcoatRoughnessMap;
#endif`,
  iridescence_pars_fragment: `#ifdef USE_IRIDESCENCEMAP
	uniform sampler2D iridescenceMap;
#endif
#ifdef USE_IRIDESCENCE_THICKNESSMAP
	uniform sampler2D iridescenceThicknessMap;
#endif`,
  opaque_fragment: `#ifdef OPAQUE
diffuseColor.a = 1.0;
#endif
#ifdef USE_TRANSMISSION
diffuseColor.a *= material.transmissionAlpha;
#endif
gl_FragColor = vec4( outgoingLight, diffuseColor.a );`,
  packing: `vec3 packNormalToRGB( const in vec3 normal ) {
	return normalize( normal ) * 0.5 + 0.5;
}
vec3 unpackRGBToNormal( const in vec3 rgb ) {
	return 2.0 * rgb.xyz - 1.0;
}
const float PackUpscale = 256. / 255.;const float UnpackDownscale = 255. / 256.;const float ShiftRight8 = 1. / 256.;
const float Inv255 = 1. / 255.;
const vec4 PackFactors = vec4( 1.0, 256.0, 256.0 * 256.0, 256.0 * 256.0 * 256.0 );
const vec2 UnpackFactors2 = vec2( UnpackDownscale, 1.0 / PackFactors.g );
const vec3 UnpackFactors3 = vec3( UnpackDownscale / PackFactors.rg, 1.0 / PackFactors.b );
const vec4 UnpackFactors4 = vec4( UnpackDownscale / PackFactors.rgb, 1.0 / PackFactors.a );
vec4 packDepthToRGBA( const in float v ) {
	if( v <= 0.0 )
		return vec4( 0., 0., 0., 0. );
	if( v >= 1.0 )
		return vec4( 1., 1., 1., 1. );
	float vuf;
	float af = modf( v * PackFactors.a, vuf );
	float bf = modf( vuf * ShiftRight8, vuf );
	float gf = modf( vuf * ShiftRight8, vuf );
	return vec4( vuf * Inv255, gf * PackUpscale, bf * PackUpscale, af );
}
vec3 packDepthToRGB( const in float v ) {
	if( v <= 0.0 )
		return vec3( 0., 0., 0. );
	if( v >= 1.0 )
		return vec3( 1., 1., 1. );
	float vuf;
	float bf = modf( v * PackFactors.b, vuf );
	float gf = modf( vuf * ShiftRight8, vuf );
	return vec3( vuf * Inv255, gf * PackUpscale, bf );
}
vec2 packDepthToRG( const in float v ) {
	if( v <= 0.0 )
		return vec2( 0., 0. );
	if( v >= 1.0 )
		return vec2( 1., 1. );
	float vuf;
	float gf = modf( v * 256., vuf );
	return vec2( vuf * Inv255, gf );
}
float unpackRGBAToDepth( const in vec4 v ) {
	return dot( v, UnpackFactors4 );
}
float unpackRGBToDepth( const in vec3 v ) {
	return dot( v, UnpackFactors3 );
}
float unpackRGToDepth( const in vec2 v ) {
	return v.r * UnpackFactors2.r + v.g * UnpackFactors2.g;
}
vec4 pack2HalfToRGBA( const in vec2 v ) {
	vec4 r = vec4( v.x, fract( v.x * 255.0 ), v.y, fract( v.y * 255.0 ) );
	return vec4( r.x - r.y / 255.0, r.y, r.z - r.w / 255.0, r.w );
}
vec2 unpackRGBATo2Half( const in vec4 v ) {
	return vec2( v.x + ( v.y / 255.0 ), v.z + ( v.w / 255.0 ) );
}
float viewZToOrthographicDepth( const in float viewZ, const in float near, const in float far ) {
	return ( viewZ + near ) / ( near - far );
}
float orthographicDepthToViewZ( const in float depth, const in float near, const in float far ) {
	#ifdef USE_REVERSED_DEPTH_BUFFER
	
		return depth * ( far - near ) - far;
	#else
		return depth * ( near - far ) - near;
	#endif
}
float viewZToPerspectiveDepth( const in float viewZ, const in float near, const in float far ) {
	return ( ( near + viewZ ) * far ) / ( ( far - near ) * viewZ );
}
float perspectiveDepthToViewZ( const in float depth, const in float near, const in float far ) {
	
	#ifdef USE_REVERSED_DEPTH_BUFFER
		return ( near * far ) / ( ( near - far ) * depth - near );
	#else
		return ( near * far ) / ( ( far - near ) * depth - far );
	#endif
}`,
  premultiplied_alpha_fragment: `#ifdef PREMULTIPLIED_ALPHA
	gl_FragColor.rgb *= gl_FragColor.a;
#endif`,
  project_vertex: `vec4 mvPosition = vec4( transformed, 1.0 );
#ifdef USE_BATCHING
	mvPosition = batchingMatrix * mvPosition;
#endif
#ifdef USE_INSTANCING
	mvPosition = instanceMatrix * mvPosition;
#endif
mvPosition = modelViewMatrix * mvPosition;
gl_Position = projectionMatrix * mvPosition;`,
  dithering_fragment: `#ifdef DITHERING
	gl_FragColor.rgb = dithering( gl_FragColor.rgb );
#endif`,
  dithering_pars_fragment: `#ifdef DITHERING
	vec3 dithering( vec3 color ) {
		float grid_position = rand( gl_FragCoord.xy );
		vec3 dither_shift_RGB = vec3( 0.25 / 255.0, -0.25 / 255.0, 0.25 / 255.0 );
		dither_shift_RGB = mix( 2.0 * dither_shift_RGB, -2.0 * dither_shift_RGB, grid_position );
		return color + dither_shift_RGB;
	}
#endif`,
  roughnessmap_fragment: `float roughnessFactor = roughness;
#ifdef USE_ROUGHNESSMAP
	vec4 texelRoughness = texture2D( roughnessMap, vRoughnessMapUv );
	roughnessFactor *= texelRoughness.g;
#endif`,
  roughnessmap_pars_fragment: `#ifdef USE_ROUGHNESSMAP
	uniform sampler2D roughnessMap;
#endif`,
  shadowmap_pars_fragment: `#if NUM_SPOT_LIGHT_COORDS > 0
	varying vec4 vSpotLightCoord[ NUM_SPOT_LIGHT_COORDS ];
#endif
#if NUM_SPOT_LIGHT_MAPS > 0
	uniform sampler2D spotLightMap[ NUM_SPOT_LIGHT_MAPS ];
#endif
#ifdef USE_SHADOWMAP
	#if NUM_SUN_LIGHT_SHADOWS > 0
		#define SUN_LIGHT_CASCADES 2
		#if defined( SHADOWMAP_TYPE_PCF )
			uniform sampler2DShadow sunShadowMap[ NUM_SUN_LIGHT_SHADOWS ];
		#else
			uniform sampler2D sunShadowMap[ NUM_SUN_LIGHT_SHADOWS ];
		#endif
		uniform mat4 sunShadowMatrix[ NUM_SUN_LIGHT_SHADOWS * SUN_LIGHT_CASCADES ];
		uniform vec4 sunShadowCascade[ NUM_SUN_LIGHT_SHADOWS * SUN_LIGHT_CASCADES ];
		varying vec4 vSunShadowWorldPosition;
		varying vec3 vSunShadowWorldNormal;
		struct SunLightShadow {
			float shadowIntensity;
			float shadowBias;
			float shadowNormalBias;
			float shadowRadius;
			vec2 shadowMapSize;
		};
		uniform SunLightShadow sunLightShadows[ NUM_SUN_LIGHT_SHADOWS ];
	#endif
	#if NUM_DIR_LIGHT_SHADOWS > 0
		#if defined( SHADOWMAP_TYPE_PCF )
			uniform sampler2DShadow directionalShadowMap[ NUM_DIR_LIGHT_SHADOWS ];
		#else
			uniform sampler2D directionalShadowMap[ NUM_DIR_LIGHT_SHADOWS ];
		#endif
		varying vec4 vDirectionalShadowCoord[ NUM_DIR_LIGHT_SHADOWS ];
		struct DirectionalLightShadow {
			float shadowIntensity;
			float shadowBias;
			float shadowNormalBias;
			float shadowRadius;
			vec2 shadowMapSize;
		};
		uniform DirectionalLightShadow directionalLightShadows[ NUM_DIR_LIGHT_SHADOWS ];
	#endif
	#if NUM_SPOT_LIGHT_SHADOWS > 0
		#if defined( SHADOWMAP_TYPE_PCF )
			uniform sampler2DShadow spotShadowMap[ NUM_SPOT_LIGHT_SHADOWS ];
		#else
			uniform sampler2D spotShadowMap[ NUM_SPOT_LIGHT_SHADOWS ];
		#endif
		struct SpotLightShadow {
			float shadowIntensity;
			float shadowBias;
			float shadowNormalBias;
			float shadowRadius;
			vec2 shadowMapSize;
		};
		uniform SpotLightShadow spotLightShadows[ NUM_SPOT_LIGHT_SHADOWS ];
	#endif
	#if NUM_POINT_LIGHT_SHADOWS > 0
		#if defined( SHADOWMAP_TYPE_PCF )
			uniform samplerCubeShadow pointShadowMap[ NUM_POINT_LIGHT_SHADOWS ];
		#elif defined( SHADOWMAP_TYPE_BASIC )
			uniform samplerCube pointShadowMap[ NUM_POINT_LIGHT_SHADOWS ];
		#endif
		varying vec4 vPointShadowCoord[ NUM_POINT_LIGHT_SHADOWS ];
		struct PointLightShadow {
			float shadowIntensity;
			float shadowBias;
			float shadowNormalBias;
			float shadowRadius;
			vec2 shadowMapSize;
			float shadowCameraNear;
			float shadowCameraFar;
		};
		uniform PointLightShadow pointLightShadows[ NUM_POINT_LIGHT_SHADOWS ];
	#endif
	#if defined( SHADOWMAP_TYPE_PCF )
		float interleavedGradientNoise( vec2 position ) {
			return fract( 52.9829189 * fract( dot( position, vec2( 0.06711056, 0.00583715 ) ) ) );
		}
		vec2 vogelDiskSample( int sampleIndex, int samplesCount, float phi ) {
			const float goldenAngle = 2.399963229728653;
			float r = sqrt( ( float( sampleIndex ) + 0.5 ) / float( samplesCount ) );
			float theta = float( sampleIndex ) * goldenAngle + phi;
			return vec2( cos( theta ), sin( theta ) ) * r;
		}
	#endif
	#if defined( SHADOWMAP_TYPE_PCF )
		float getShadow( sampler2DShadow shadowMap, vec2 shadowMapSize, float shadowIntensity, float shadowBias, float shadowRadius, vec4 shadowCoord ) {
			float shadow = 1.0;
			shadowCoord.xyz /= shadowCoord.w;
			shadowCoord.z += shadowBias;
			bool inFrustum = shadowCoord.x >= 0.0 && shadowCoord.x <= 1.0 && shadowCoord.y >= 0.0 && shadowCoord.y <= 1.0;
			bool frustumTest = inFrustum && shadowCoord.z <= 1.0;
			if ( frustumTest ) {
				vec2 texelSize = vec2( 1.0 ) / shadowMapSize;
				float radius = shadowRadius * texelSize.x;
				float phi = interleavedGradientNoise( gl_FragCoord.xy ) * PI2;
				shadow = (
					texture( shadowMap, vec3( shadowCoord.xy + vogelDiskSample( 0, 5, phi ) * radius, shadowCoord.z ) ) +
					texture( shadowMap, vec3( shadowCoord.xy + vogelDiskSample( 1, 5, phi ) * radius, shadowCoord.z ) ) +
					texture( shadowMap, vec3( shadowCoord.xy + vogelDiskSample( 2, 5, phi ) * radius, shadowCoord.z ) ) +
					texture( shadowMap, vec3( shadowCoord.xy + vogelDiskSample( 3, 5, phi ) * radius, shadowCoord.z ) ) +
					texture( shadowMap, vec3( shadowCoord.xy + vogelDiskSample( 4, 5, phi ) * radius, shadowCoord.z ) )
				) * 0.2;
			}
			return mix( 1.0, shadow, shadowIntensity );
		}
	#elif defined( SHADOWMAP_TYPE_VSM )
		float getShadow( sampler2D shadowMap, vec2 shadowMapSize, float shadowIntensity, float shadowBias, float shadowRadius, vec4 shadowCoord ) {
			float shadow = 1.0;
			shadowCoord.xyz /= shadowCoord.w;
			#ifdef USE_REVERSED_DEPTH_BUFFER
				shadowCoord.z -= shadowBias;
			#else
				shadowCoord.z += shadowBias;
			#endif
			bool inFrustum = shadowCoord.x >= 0.0 && shadowCoord.x <= 1.0 && shadowCoord.y >= 0.0 && shadowCoord.y <= 1.0;
			bool frustumTest = inFrustum && shadowCoord.z <= 1.0;
			if ( frustumTest ) {
				vec2 distribution = texture2D( shadowMap, shadowCoord.xy ).rg;
				float mean = distribution.x;
				float variance = distribution.y * distribution.y;
				#ifdef USE_REVERSED_DEPTH_BUFFER
					float hard_shadow = step( mean, shadowCoord.z );
				#else
					float hard_shadow = step( shadowCoord.z, mean );
				#endif
				
				if ( hard_shadow == 1.0 ) {
					shadow = 1.0;
				} else {
					variance = max( variance, 0.0000001 );
					float d = shadowCoord.z - mean;
					float p_max = variance / ( variance + d * d );
					p_max = clamp( ( p_max - 0.3 ) / 0.65, 0.0, 1.0 );
					shadow = max( hard_shadow, p_max );
				}
			}
			return mix( 1.0, shadow, shadowIntensity );
		}
	#else
		float getShadow( sampler2D shadowMap, vec2 shadowMapSize, float shadowIntensity, float shadowBias, float shadowRadius, vec4 shadowCoord ) {
			float shadow = 1.0;
			shadowCoord.xyz /= shadowCoord.w;
			#ifdef USE_REVERSED_DEPTH_BUFFER
				shadowCoord.z -= shadowBias;
			#else
				shadowCoord.z += shadowBias;
			#endif
			bool inFrustum = shadowCoord.x >= 0.0 && shadowCoord.x <= 1.0 && shadowCoord.y >= 0.0 && shadowCoord.y <= 1.0;
			bool frustumTest = inFrustum && shadowCoord.z <= 1.0;
			if ( frustumTest ) {
				float depth = texture2D( shadowMap, shadowCoord.xy ).r;
				#ifdef USE_REVERSED_DEPTH_BUFFER
					shadow = step( depth, shadowCoord.z );
				#else
					shadow = step( shadowCoord.z, depth );
				#endif
			}
			return mix( 1.0, shadow, shadowIntensity );
		}
	#endif
	#if NUM_SUN_LIGHT_SHADOWS > 0
		float getSunShadow(
			#if defined( SHADOWMAP_TYPE_PCF )
				sampler2DShadow shadowMap,
			#else
				sampler2D shadowMap,
			#endif
			SunLightShadow sunLightShadow,
			int shadowIndex
		) {
			vec4 shadowWorldPosition = vec4( vSunShadowWorldPosition.xyz + vSunShadowWorldNormal * sunLightShadow.shadowNormalBias, 1.0 );
			float viewDepth = vSunShadowWorldPosition.w;
			int cascadeOffset = shadowIndex * SUN_LIGHT_CASCADES;
			float shadow = 1.0;
			for ( int i = SUN_LIGHT_CASCADES - 1; i >= 0; i -- ) {
				vec4 cascade = sunShadowCascade[ cascadeOffset + i ];
				if ( viewDepth >= cascade.x && viewDepth < cascade.y ) {
					float cascadeShadow = getShadow(
						shadowMap,
						sunLightShadow.shadowMapSize,
						sunLightShadow.shadowIntensity,
						sunLightShadow.shadowBias,
						sunLightShadow.shadowRadius,
						sunShadowMatrix[ cascadeOffset + i ] * shadowWorldPosition
					);
					shadow = mix( cascadeShadow, shadow, smoothstep( cascade.z, cascade.y, viewDepth ) );
				}
			}
			return shadow;
		}
	#endif
	#if NUM_POINT_LIGHT_SHADOWS > 0
	#if defined( SHADOWMAP_TYPE_PCF )
	float getPointShadow( samplerCubeShadow shadowMap, vec2 shadowMapSize, float shadowIntensity, float shadowBias, float shadowRadius, vec4 shadowCoord, float shadowCameraNear, float shadowCameraFar ) {
		float shadow = 1.0;
		vec3 lightToPosition = shadowCoord.xyz;
		vec3 bd3D = normalize( lightToPosition );
		vec3 absVec = abs( lightToPosition );
		float viewSpaceZ = max( max( absVec.x, absVec.y ), absVec.z );
		if ( viewSpaceZ - shadowCameraFar <= 0.0 && viewSpaceZ - shadowCameraNear >= 0.0 ) {
			#ifdef USE_REVERSED_DEPTH_BUFFER
				float dp = ( shadowCameraNear * ( shadowCameraFar - viewSpaceZ ) ) / ( viewSpaceZ * ( shadowCameraFar - shadowCameraNear ) );
				dp -= shadowBias;
			#else
				float dp = ( shadowCameraFar * ( viewSpaceZ - shadowCameraNear ) ) / ( viewSpaceZ * ( shadowCameraFar - shadowCameraNear ) );
				dp += shadowBias;
			#endif
			float texelSize = shadowRadius / shadowMapSize.x;
			vec3 absDir = abs( bd3D );
			vec3 tangent = absDir.x > absDir.z ? vec3( 0.0, 1.0, 0.0 ) : vec3( 1.0, 0.0, 0.0 );
			tangent = normalize( cross( bd3D, tangent ) );
			vec3 bitangent = cross( bd3D, tangent );
			float phi = interleavedGradientNoise( gl_FragCoord.xy ) * PI2;
			vec2 sample0 = vogelDiskSample( 0, 5, phi );
			vec2 sample1 = vogelDiskSample( 1, 5, phi );
			vec2 sample2 = vogelDiskSample( 2, 5, phi );
			vec2 sample3 = vogelDiskSample( 3, 5, phi );
			vec2 sample4 = vogelDiskSample( 4, 5, phi );
			shadow = (
				texture( shadowMap, vec4( bd3D + ( tangent * sample0.x + bitangent * sample0.y ) * texelSize, dp ) ) +
				texture( shadowMap, vec4( bd3D + ( tangent * sample1.x + bitangent * sample1.y ) * texelSize, dp ) ) +
				texture( shadowMap, vec4( bd3D + ( tangent * sample2.x + bitangent * sample2.y ) * texelSize, dp ) ) +
				texture( shadowMap, vec4( bd3D + ( tangent * sample3.x + bitangent * sample3.y ) * texelSize, dp ) ) +
				texture( shadowMap, vec4( bd3D + ( tangent * sample4.x + bitangent * sample4.y ) * texelSize, dp ) )
			) * 0.2;
		}
		return mix( 1.0, shadow, shadowIntensity );
	}
	#elif defined( SHADOWMAP_TYPE_BASIC )
	float getPointShadow( samplerCube shadowMap, vec2 shadowMapSize, float shadowIntensity, float shadowBias, float shadowRadius, vec4 shadowCoord, float shadowCameraNear, float shadowCameraFar ) {
		float shadow = 1.0;
		vec3 lightToPosition = shadowCoord.xyz;
		vec3 absVec = abs( lightToPosition );
		float viewSpaceZ = max( max( absVec.x, absVec.y ), absVec.z );
		if ( viewSpaceZ - shadowCameraFar <= 0.0 && viewSpaceZ - shadowCameraNear >= 0.0 ) {
			float dp = ( shadowCameraFar * ( viewSpaceZ - shadowCameraNear ) ) / ( viewSpaceZ * ( shadowCameraFar - shadowCameraNear ) );
			dp += shadowBias;
			vec3 bd3D = normalize( lightToPosition );
			float depth = textureCube( shadowMap, bd3D ).r;
			#ifdef USE_REVERSED_DEPTH_BUFFER
				depth = 1.0 - depth;
			#endif
			shadow = step( dp, depth );
		}
		return mix( 1.0, shadow, shadowIntensity );
	}
	#endif
	#endif
#endif`,
  shadowmap_pars_vertex: `#if NUM_SPOT_LIGHT_COORDS > 0
	uniform mat4 spotLightMatrix[ NUM_SPOT_LIGHT_COORDS ];
	varying vec4 vSpotLightCoord[ NUM_SPOT_LIGHT_COORDS ];
#endif
#ifdef USE_SHADOWMAP
	#if NUM_SUN_LIGHT_SHADOWS > 0
		varying vec4 vSunShadowWorldPosition;
		varying vec3 vSunShadowWorldNormal;
	#endif
	#if NUM_DIR_LIGHT_SHADOWS > 0
		uniform mat4 directionalShadowMatrix[ NUM_DIR_LIGHT_SHADOWS ];
		varying vec4 vDirectionalShadowCoord[ NUM_DIR_LIGHT_SHADOWS ];
		struct DirectionalLightShadow {
			float shadowIntensity;
			float shadowBias;
			float shadowNormalBias;
			float shadowRadius;
			vec2 shadowMapSize;
		};
		uniform DirectionalLightShadow directionalLightShadows[ NUM_DIR_LIGHT_SHADOWS ];
	#endif
	#if NUM_SPOT_LIGHT_SHADOWS > 0
		struct SpotLightShadow {
			float shadowIntensity;
			float shadowBias;
			float shadowNormalBias;
			float shadowRadius;
			vec2 shadowMapSize;
		};
		uniform SpotLightShadow spotLightShadows[ NUM_SPOT_LIGHT_SHADOWS ];
	#endif
	#if NUM_POINT_LIGHT_SHADOWS > 0
		uniform mat4 pointShadowMatrix[ NUM_POINT_LIGHT_SHADOWS ];
		varying vec4 vPointShadowCoord[ NUM_POINT_LIGHT_SHADOWS ];
		struct PointLightShadow {
			float shadowIntensity;
			float shadowBias;
			float shadowNormalBias;
			float shadowRadius;
			vec2 shadowMapSize;
			float shadowCameraNear;
			float shadowCameraFar;
		};
		uniform PointLightShadow pointLightShadows[ NUM_POINT_LIGHT_SHADOWS ];
	#endif
#endif`,
  shadowmap_vertex: `#if ( defined( USE_SHADOWMAP ) && ( NUM_DIR_LIGHT_SHADOWS > 0 || NUM_SUN_LIGHT_SHADOWS > 0 || NUM_POINT_LIGHT_SHADOWS > 0 ) ) || ( NUM_SPOT_LIGHT_COORDS > 0 )
	#ifdef HAS_NORMAL
		vec3 shadowWorldNormal = transformNormalByInverseViewMatrix( transformedNormal, viewMatrix );
	#else
		vec3 shadowWorldNormal = vec3( 0.0 );
	#endif
	vec4 shadowWorldPosition;
#endif
#if defined( USE_SHADOWMAP )
	#if NUM_SUN_LIGHT_SHADOWS > 0
		vSunShadowWorldPosition = vec4( worldPosition.xyz, - mvPosition.z );
		vSunShadowWorldNormal = shadowWorldNormal;
	#endif
	#if NUM_DIR_LIGHT_SHADOWS > 0
		#pragma unroll_loop_start
		for ( int i = 0; i < NUM_DIR_LIGHT_SHADOWS; i ++ ) {
			shadowWorldPosition = worldPosition + vec4( shadowWorldNormal * directionalLightShadows[ i ].shadowNormalBias, 0 );
			vDirectionalShadowCoord[ i ] = directionalShadowMatrix[ i ] * shadowWorldPosition;
		}
		#pragma unroll_loop_end
	#endif
	#if NUM_POINT_LIGHT_SHADOWS > 0
		#pragma unroll_loop_start
		for ( int i = 0; i < NUM_POINT_LIGHT_SHADOWS; i ++ ) {
			shadowWorldPosition = worldPosition + vec4( shadowWorldNormal * pointLightShadows[ i ].shadowNormalBias, 0 );
			vPointShadowCoord[ i ] = pointShadowMatrix[ i ] * shadowWorldPosition;
		}
		#pragma unroll_loop_end
	#endif
#endif
#if NUM_SPOT_LIGHT_COORDS > 0
	#pragma unroll_loop_start
	for ( int i = 0; i < NUM_SPOT_LIGHT_COORDS; i ++ ) {
		shadowWorldPosition = worldPosition;
		#if ( defined( USE_SHADOWMAP ) && UNROLLED_LOOP_INDEX < NUM_SPOT_LIGHT_SHADOWS )
			shadowWorldPosition.xyz += shadowWorldNormal * spotLightShadows[ i ].shadowNormalBias;
		#endif
		vSpotLightCoord[ i ] = spotLightMatrix[ i ] * shadowWorldPosition;
	}
	#pragma unroll_loop_end
#endif`,
  shadowmask_pars_fragment: `float getShadowMask() {
	float shadow = 1.0;
	#ifdef USE_SHADOWMAP
	#if NUM_SUN_LIGHT_SHADOWS > 0
	SunLightShadow sunLight;
	#pragma unroll_loop_start
	for ( int i = 0; i < NUM_SUN_LIGHT_SHADOWS; i ++ ) {
		sunLight = sunLightShadows[ i ];
		shadow *= receiveShadow ? getSunShadow( sunShadowMap[ i ], sunLight, UNROLLED_LOOP_INDEX ) : 1.0;
	}
	#pragma unroll_loop_end
	#endif
	#if NUM_DIR_LIGHT_SHADOWS > 0
	DirectionalLightShadow directionalLight;
	#pragma unroll_loop_start
	for ( int i = 0; i < NUM_DIR_LIGHT_SHADOWS; i ++ ) {
		directionalLight = directionalLightShadows[ i ];
		shadow *= receiveShadow ? getShadow( directionalShadowMap[ i ], directionalLight.shadowMapSize, directionalLight.shadowIntensity, directionalLight.shadowBias, directionalLight.shadowRadius, vDirectionalShadowCoord[ i ] ) : 1.0;
	}
	#pragma unroll_loop_end
	#endif
	#if NUM_SPOT_LIGHT_SHADOWS > 0
	SpotLightShadow spotLight;
	#pragma unroll_loop_start
	for ( int i = 0; i < NUM_SPOT_LIGHT_SHADOWS; i ++ ) {
		spotLight = spotLightShadows[ i ];
		shadow *= receiveShadow ? getShadow( spotShadowMap[ i ], spotLight.shadowMapSize, spotLight.shadowIntensity, spotLight.shadowBias, spotLight.shadowRadius, vSpotLightCoord[ i ] ) : 1.0;
	}
	#pragma unroll_loop_end
	#endif
	#if NUM_POINT_LIGHT_SHADOWS > 0 && ( defined( SHADOWMAP_TYPE_PCF ) || defined( SHADOWMAP_TYPE_BASIC ) )
	PointLightShadow pointLight;
	#pragma unroll_loop_start
	for ( int i = 0; i < NUM_POINT_LIGHT_SHADOWS; i ++ ) {
		pointLight = pointLightShadows[ i ];
		shadow *= receiveShadow ? getPointShadow( pointShadowMap[ i ], pointLight.shadowMapSize, pointLight.shadowIntensity, pointLight.shadowBias, pointLight.shadowRadius, vPointShadowCoord[ i ], pointLight.shadowCameraNear, pointLight.shadowCameraFar ) : 1.0;
	}
	#pragma unroll_loop_end
	#endif
	#endif
	return shadow;
}`,
  skinbase_vertex: `#ifdef USE_SKINNING
	mat4 boneMatX = getBoneMatrix( skinIndex.x );
	mat4 boneMatY = getBoneMatrix( skinIndex.y );
	mat4 boneMatZ = getBoneMatrix( skinIndex.z );
	mat4 boneMatW = getBoneMatrix( skinIndex.w );
#endif`,
  skinning_pars_vertex: `#ifdef USE_SKINNING
	uniform mat4 bindMatrix;
	uniform mat4 bindMatrixInverse;
	uniform highp sampler2D boneTexture;
	mat4 getBoneMatrix( const in float i ) {
		int size = textureSize( boneTexture, 0 ).x;
		int j = int( i ) * 4;
		int x = j % size;
		int y = j / size;
		vec4 v1 = texelFetch( boneTexture, ivec2( x, y ), 0 );
		vec4 v2 = texelFetch( boneTexture, ivec2( x + 1, y ), 0 );
		vec4 v3 = texelFetch( boneTexture, ivec2( x + 2, y ), 0 );
		vec4 v4 = texelFetch( boneTexture, ivec2( x + 3, y ), 0 );
		return mat4( v1, v2, v3, v4 );
	}
#endif`,
  skinning_vertex: `#ifdef USE_SKINNING
	vec4 skinVertex = bindMatrix * vec4( transformed, 1.0 );
	vec4 skinned = vec4( 0.0 );
	skinned += boneMatX * skinVertex * skinWeight.x;
	skinned += boneMatY * skinVertex * skinWeight.y;
	skinned += boneMatZ * skinVertex * skinWeight.z;
	skinned += boneMatW * skinVertex * skinWeight.w;
	transformed = ( bindMatrixInverse * skinned ).xyz;
#endif`,
  skinnormal_vertex: `#ifdef USE_SKINNING
	mat4 skinMatrix = mat4( 0.0 );
	skinMatrix += skinWeight.x * boneMatX;
	skinMatrix += skinWeight.y * boneMatY;
	skinMatrix += skinWeight.z * boneMatZ;
	skinMatrix += skinWeight.w * boneMatW;
	skinMatrix = bindMatrixInverse * skinMatrix * bindMatrix;
	objectNormal = vec4( skinMatrix * vec4( objectNormal, 0.0 ) ).xyz;
	#ifdef USE_TANGENT
		objectTangent = vec4( skinMatrix * vec4( objectTangent, 0.0 ) ).xyz;
	#endif
#endif`,
  specularmap_fragment: `float specularStrength;
#ifdef USE_SPECULARMAP
	vec4 texelSpecular = texture2D( specularMap, vSpecularMapUv );
	specularStrength = texelSpecular.r;
#else
	specularStrength = 1.0;
#endif`,
  specularmap_pars_fragment: `#ifdef USE_SPECULARMAP
	uniform sampler2D specularMap;
#endif`,
  tonemapping_fragment: `#if defined( TONE_MAPPING )
	gl_FragColor.rgb = toneMapping( gl_FragColor.rgb );
#endif`,
  tonemapping_pars_fragment: `#ifndef saturate
#define saturate( a ) clamp( a, 0.0, 1.0 )
#endif
uniform float toneMappingExposure;
vec3 LinearToneMapping( vec3 color ) {
	return saturate( toneMappingExposure * color );
}
vec3 ReinhardToneMapping( vec3 color ) {
	color *= toneMappingExposure;
	return saturate( color / ( vec3( 1.0 ) + color ) );
}
vec3 CineonToneMapping( vec3 color ) {
	color *= toneMappingExposure;
	color = max( vec3( 0.0 ), color - 0.004 );
	return pow( ( color * ( 6.2 * color + 0.5 ) ) / ( color * ( 6.2 * color + 1.7 ) + 0.06 ), vec3( 2.2 ) );
}
vec3 RRTAndODTFit( vec3 v ) {
	vec3 a = v * ( v + 0.0245786 ) - 0.000090537;
	vec3 b = v * ( 0.983729 * v + 0.4329510 ) + 0.238081;
	return a / b;
}
vec3 ACESFilmicToneMapping( vec3 color ) {
	const mat3 ACESInputMat = mat3(
		vec3( 0.59719, 0.07600, 0.02840 ),		vec3( 0.35458, 0.90834, 0.13383 ),
		vec3( 0.04823, 0.01566, 0.83777 )
	);
	const mat3 ACESOutputMat = mat3(
		vec3(  1.60475, -0.10208, -0.00327 ),		vec3( -0.53108,  1.10813, -0.07276 ),
		vec3( -0.07367, -0.00605,  1.07602 )
	);
	color *= toneMappingExposure / 0.6;
	color = ACESInputMat * color;
	color = RRTAndODTFit( color );
	color = ACESOutputMat * color;
	return saturate( color );
}
const mat3 LINEAR_REC2020_TO_LINEAR_SRGB = mat3(
	vec3( 1.6605, - 0.1246, - 0.0182 ),
	vec3( - 0.5876, 1.1329, - 0.1006 ),
	vec3( - 0.0728, - 0.0083, 1.1187 )
);
const mat3 LINEAR_SRGB_TO_LINEAR_REC2020 = mat3(
	vec3( 0.6274, 0.0691, 0.0164 ),
	vec3( 0.3293, 0.9195, 0.0880 ),
	vec3( 0.0433, 0.0113, 0.8956 )
);
vec3 agxDefaultContrastApprox( vec3 x ) {
	vec3 x2 = x * x;
	vec3 x4 = x2 * x2;
	return + 15.5 * x4 * x2
		- 40.14 * x4 * x
		+ 31.96 * x4
		- 6.868 * x2 * x
		+ 0.4298 * x2
		+ 0.1191 * x
		- 0.00232;
}
vec3 AgXToneMapping( vec3 color ) {
	const mat3 AgXInsetMatrix = mat3(
		vec3( 0.856627153315983, 0.137318972929847, 0.11189821299995 ),
		vec3( 0.0951212405381588, 0.761241990602591, 0.0767994186031903 ),
		vec3( 0.0482516061458583, 0.101439036467562, 0.811302368396859 )
	);
	const mat3 AgXOutsetMatrix = mat3(
		vec3( 1.1271005818144368, - 0.1413297634984383, - 0.14132976349843826 ),
		vec3( - 0.11060664309660323, 1.157823702216272, - 0.11060664309660294 ),
		vec3( - 0.016493938717834573, - 0.016493938717834257, 1.2519364065950405 )
	);
	const float AgxMinEv = - 12.47393;	const float AgxMaxEv = 4.026069;
	color *= toneMappingExposure;
	color = LINEAR_SRGB_TO_LINEAR_REC2020 * color;
	color = AgXInsetMatrix * color;
	color = max( color, 1e-10 );	color = log2( color );
	color = ( color - AgxMinEv ) / ( AgxMaxEv - AgxMinEv );
	color = clamp( color, 0.0, 1.0 );
	color = agxDefaultContrastApprox( color );
	color = AgXOutsetMatrix * color;
	color = pow( max( vec3( 0.0 ), color ), vec3( 2.2 ) );
	color = LINEAR_REC2020_TO_LINEAR_SRGB * color;
	color = clamp( color, 0.0, 1.0 );
	return color;
}
vec3 NeutralToneMapping( vec3 color ) {
	const float StartCompression = 0.8 - 0.04;
	const float Desaturation = 0.15;
	color *= toneMappingExposure;
	float x = min( color.r, min( color.g, color.b ) );
	float offset = x < 0.08 ? x - 6.25 * x * x : 0.04;
	color -= offset;
	float peak = max( color.r, max( color.g, color.b ) );
	if ( peak < StartCompression ) return color;
	float d = 1. - StartCompression;
	float newPeak = 1. - d * d / ( peak + d - StartCompression );
	color *= newPeak / peak;
	float g = 1. - 1. / ( Desaturation * ( peak - newPeak ) + 1. );
	return mix( color, vec3( newPeak ), g );
}
vec3 CustomToneMapping( vec3 color ) { return color; }`,
  transmission_fragment: `#ifdef USE_TRANSMISSION
	material.transmission = transmission;
	material.transmissionAlpha = 1.0;
	material.thickness = thickness;
	material.attenuationDistance = attenuationDistance;
	material.attenuationColor = attenuationColor;
	#ifdef USE_TRANSMISSIONMAP
		material.transmission *= texture2D( transmissionMap, vTransmissionMapUv ).r;
	#endif
	#ifdef USE_THICKNESSMAP
		material.thickness *= texture2D( thicknessMap, vThicknessMapUv ).g;
	#endif
	vec3 pos = vWorldPosition;
	vec3 v = normalize( cameraPosition - pos );
	vec3 n = transformNormalByInverseViewMatrix( normal, viewMatrix );
	vec4 transmitted = getIBLVolumeRefraction(
		n, v, material.roughness, material.diffuseContribution, material.specularColorBlended, material.specularF90,
		pos, modelMatrix, viewMatrix, projectionMatrix, material.dispersion, material.ior, material.thickness,
		material.attenuationColor, material.attenuationDistance );
	material.transmissionAlpha = mix( material.transmissionAlpha, transmitted.a, material.transmission );
	totalDiffuse = mix( totalDiffuse, transmitted.rgb, material.transmission );
#endif`,
  transmission_pars_fragment: `#ifdef USE_TRANSMISSION
	uniform float transmission;
	uniform float thickness;
	uniform float attenuationDistance;
	uniform vec3 attenuationColor;
	#ifdef USE_TRANSMISSIONMAP
		uniform sampler2D transmissionMap;
	#endif
	#ifdef USE_THICKNESSMAP
		uniform sampler2D thicknessMap;
	#endif
	uniform vec2 transmissionSamplerSize;
	uniform sampler2D transmissionSamplerMap;
	uniform mat4 modelMatrix;
	uniform mat4 projectionMatrix;
	varying vec3 vWorldPosition;
	float w0( float a ) {
		return ( 1.0 / 6.0 ) * ( a * ( a * ( - a + 3.0 ) - 3.0 ) + 1.0 );
	}
	float w1( float a ) {
		return ( 1.0 / 6.0 ) * ( a *  a * ( 3.0 * a - 6.0 ) + 4.0 );
	}
	float w2( float a ){
		return ( 1.0 / 6.0 ) * ( a * ( a * ( - 3.0 * a + 3.0 ) + 3.0 ) + 1.0 );
	}
	float w3( float a ) {
		return ( 1.0 / 6.0 ) * ( a * a * a );
	}
	float g0( float a ) {
		return w0( a ) + w1( a );
	}
	float g1( float a ) {
		return w2( a ) + w3( a );
	}
	float h0( float a ) {
		return - 1.0 + w1( a ) / ( w0( a ) + w1( a ) );
	}
	float h1( float a ) {
		return 1.0 + w3( a ) / ( w2( a ) + w3( a ) );
	}
	vec4 bicubic( sampler2D tex, vec2 uv, vec4 texelSize, float lod ) {
		uv = uv * texelSize.zw + 0.5;
		vec2 iuv = floor( uv );
		vec2 fuv = fract( uv );
		float g0x = g0( fuv.x );
		float g1x = g1( fuv.x );
		float h0x = h0( fuv.x );
		float h1x = h1( fuv.x );
		float h0y = h0( fuv.y );
		float h1y = h1( fuv.y );
		vec2 p0 = ( vec2( iuv.x + h0x, iuv.y + h0y ) - 0.5 ) * texelSize.xy;
		vec2 p1 = ( vec2( iuv.x + h1x, iuv.y + h0y ) - 0.5 ) * texelSize.xy;
		vec2 p2 = ( vec2( iuv.x + h0x, iuv.y + h1y ) - 0.5 ) * texelSize.xy;
		vec2 p3 = ( vec2( iuv.x + h1x, iuv.y + h1y ) - 0.5 ) * texelSize.xy;
		return g0( fuv.y ) * ( g0x * textureLod( tex, p0, lod ) + g1x * textureLod( tex, p1, lod ) ) +
			g1( fuv.y ) * ( g0x * textureLod( tex, p2, lod ) + g1x * textureLod( tex, p3, lod ) );
	}
	vec4 textureBicubic( sampler2D sampler, vec2 uv, float lod ) {
		vec2 fLodSize = vec2( textureSize( sampler, int( lod ) ) );
		vec2 cLodSize = vec2( textureSize( sampler, int( lod + 1.0 ) ) );
		vec2 fLodSizeInv = 1.0 / fLodSize;
		vec2 cLodSizeInv = 1.0 / cLodSize;
		vec4 fSample = bicubic( sampler, uv, vec4( fLodSizeInv, fLodSize ), floor( lod ) );
		vec4 cSample = bicubic( sampler, uv, vec4( cLodSizeInv, cLodSize ), ceil( lod ) );
		return mix( fSample, cSample, fract( lod ) );
	}
	vec3 getVolumeTransmissionRay( const in vec3 n, const in vec3 v, const in float thickness, const in float ior, const in mat4 modelMatrix ) {
		vec3 refractionVector = refract( - v, normalize( n ), 1.0 / ior );
		vec3 modelScale;
		modelScale.x = length( vec3( modelMatrix[ 0 ].xyz ) );
		modelScale.y = length( vec3( modelMatrix[ 1 ].xyz ) );
		modelScale.z = length( vec3( modelMatrix[ 2 ].xyz ) );
		return normalize( refractionVector ) * thickness * modelScale;
	}
	float applyIorToRoughness( const in float roughness, const in float ior ) {
		return roughness * clamp( ior * 2.0 - 2.0, 0.0, 1.0 );
	}
	vec4 getTransmissionSample( const in vec2 fragCoord, const in float roughness, const in float ior ) {
		float lod = log2( transmissionSamplerSize.x ) * applyIorToRoughness( roughness, ior );
		return textureBicubic( transmissionSamplerMap, fragCoord.xy, lod );
	}
	vec3 volumeAttenuation( const in float transmissionDistance, const in vec3 attenuationColor, const in float attenuationDistance ) {
		if ( isinf( attenuationDistance ) ) {
			return vec3( 1.0 );
		} else {
			vec3 attenuationCoefficient = -log( attenuationColor ) / attenuationDistance;
			vec3 transmittance = exp( - attenuationCoefficient * transmissionDistance );			return transmittance;
		}
	}
	vec4 getIBLVolumeRefraction( const in vec3 n, const in vec3 v, const in float roughness, const in vec3 diffuseColor,
		const in vec3 specularColor, const in float specularF90, const in vec3 position, const in mat4 modelMatrix,
		const in mat4 viewMatrix, const in mat4 projMatrix, const in float dispersion, const in float ior, const in float thickness,
		const in vec3 attenuationColor, const in float attenuationDistance ) {
		vec4 transmittedLight;
		vec3 transmittance;
		#ifdef USE_DISPERSION
			float halfSpread = ( ior - 1.0 ) * 0.025 * dispersion;
			vec3 iors = vec3( ior - halfSpread, ior, ior + halfSpread );
			for ( int i = 0; i < 3; i ++ ) {
				vec3 transmissionRay = getVolumeTransmissionRay( n, v, thickness, iors[ i ], modelMatrix );
				vec3 refractedRayExit = position + transmissionRay;
				vec4 ndcPos = projMatrix * viewMatrix * vec4( refractedRayExit, 1.0 );
				vec2 refractionCoords = ndcPos.xy / ndcPos.w;
				refractionCoords += 1.0;
				refractionCoords /= 2.0;
				vec4 transmissionSample = getTransmissionSample( refractionCoords, roughness, iors[ i ] );
				transmittedLight[ i ] = transmissionSample[ i ];
				transmittedLight.a += transmissionSample.a;
				transmittance[ i ] = diffuseColor[ i ] * volumeAttenuation( length( transmissionRay ), attenuationColor, attenuationDistance )[ i ];
			}
			transmittedLight.a /= 3.0;
		#else
			vec3 transmissionRay = getVolumeTransmissionRay( n, v, thickness, ior, modelMatrix );
			vec3 refractedRayExit = position + transmissionRay;
			vec4 ndcPos = projMatrix * viewMatrix * vec4( refractedRayExit, 1.0 );
			vec2 refractionCoords = ndcPos.xy / ndcPos.w;
			refractionCoords += 1.0;
			refractionCoords /= 2.0;
			transmittedLight = getTransmissionSample( refractionCoords, roughness, ior );
			transmittance = diffuseColor * volumeAttenuation( length( transmissionRay ), attenuationColor, attenuationDistance );
		#endif
		vec3 attenuatedColor = transmittance * transmittedLight.rgb;
		vec3 F = EnvironmentBRDF( n, v, specularColor, specularF90, roughness );
		float transmittanceFactor = ( transmittance.r + transmittance.g + transmittance.b ) / 3.0;
		return vec4( ( 1.0 - F ) * attenuatedColor, 1.0 - ( 1.0 - transmittedLight.a ) * transmittanceFactor );
	}
#endif`,
  uv_pars_fragment: `#if defined( USE_UV ) || defined( USE_ANISOTROPY )
	varying vec2 vUv;
#endif
#ifdef USE_MAP
	varying vec2 vMapUv;
#endif
#ifdef USE_ALPHAMAP
	varying vec2 vAlphaMapUv;
#endif
#ifdef USE_LIGHTMAP
	varying vec2 vLightMapUv;
#endif
#ifdef USE_AOMAP
	varying vec2 vAoMapUv;
#endif
#ifdef USE_BUMPMAP
	varying vec2 vBumpMapUv;
#endif
#ifdef USE_NORMALMAP
	varying vec2 vNormalMapUv;
#endif
#ifdef USE_EMISSIVEMAP
	varying vec2 vEmissiveMapUv;
#endif
#ifdef USE_METALNESSMAP
	varying vec2 vMetalnessMapUv;
#endif
#ifdef USE_ROUGHNESSMAP
	varying vec2 vRoughnessMapUv;
#endif
#ifdef USE_ANISOTROPYMAP
	varying vec2 vAnisotropyMapUv;
#endif
#ifdef USE_CLEARCOATMAP
	varying vec2 vClearcoatMapUv;
#endif
#ifdef USE_CLEARCOAT_NORMALMAP
	varying vec2 vClearcoatNormalMapUv;
#endif
#ifdef USE_CLEARCOAT_ROUGHNESSMAP
	varying vec2 vClearcoatRoughnessMapUv;
#endif
#ifdef USE_IRIDESCENCEMAP
	varying vec2 vIridescenceMapUv;
#endif
#ifdef USE_IRIDESCENCE_THICKNESSMAP
	varying vec2 vIridescenceThicknessMapUv;
#endif
#ifdef USE_SHEEN_COLORMAP
	varying vec2 vSheenColorMapUv;
#endif
#ifdef USE_SHEEN_ROUGHNESSMAP
	varying vec2 vSheenRoughnessMapUv;
#endif
#ifdef USE_SPECULARMAP
	varying vec2 vSpecularMapUv;
#endif
#ifdef USE_SPECULAR_COLORMAP
	varying vec2 vSpecularColorMapUv;
#endif
#ifdef USE_SPECULAR_INTENSITYMAP
	varying vec2 vSpecularIntensityMapUv;
#endif
#ifdef USE_TRANSMISSIONMAP
	uniform mat3 transmissionMapTransform;
	varying vec2 vTransmissionMapUv;
#endif
#ifdef USE_THICKNESSMAP
	uniform mat3 thicknessMapTransform;
	varying vec2 vThicknessMapUv;
#endif`,
  uv_pars_vertex: `#if defined( USE_UV ) || defined( USE_ANISOTROPY )
	varying vec2 vUv;
#endif
#ifdef USE_MAP
	uniform mat3 mapTransform;
	varying vec2 vMapUv;
#endif
#ifdef USE_ALPHAMAP
	uniform mat3 alphaMapTransform;
	varying vec2 vAlphaMapUv;
#endif
#ifdef USE_LIGHTMAP
	uniform mat3 lightMapTransform;
	varying vec2 vLightMapUv;
#endif
#ifdef USE_AOMAP
	uniform mat3 aoMapTransform;
	varying vec2 vAoMapUv;
#endif
#ifdef USE_BUMPMAP
	uniform mat3 bumpMapTransform;
	varying vec2 vBumpMapUv;
#endif
#ifdef USE_NORMALMAP
	uniform mat3 normalMapTransform;
	varying vec2 vNormalMapUv;
#endif
#ifdef USE_DISPLACEMENTMAP
	uniform mat3 displacementMapTransform;
	varying vec2 vDisplacementMapUv;
#endif
#ifdef USE_EMISSIVEMAP
	uniform mat3 emissiveMapTransform;
	varying vec2 vEmissiveMapUv;
#endif
#ifdef USE_METALNESSMAP
	uniform mat3 metalnessMapTransform;
	varying vec2 vMetalnessMapUv;
#endif
#ifdef USE_ROUGHNESSMAP
	uniform mat3 roughnessMapTransform;
	varying vec2 vRoughnessMapUv;
#endif
#ifdef USE_ANISOTROPYMAP
	uniform mat3 anisotropyMapTransform;
	varying vec2 vAnisotropyMapUv;
#endif
#ifdef USE_CLEARCOATMAP
	uniform mat3 clearcoatMapTransform;
	varying vec2 vClearcoatMapUv;
#endif
#ifdef USE_CLEARCOAT_NORMALMAP
	uniform mat3 clearcoatNormalMapTransform;
	varying vec2 vClearcoatNormalMapUv;
#endif
#ifdef USE_CLEARCOAT_ROUGHNESSMAP
	uniform mat3 clearcoatRoughnessMapTransform;
	varying vec2 vClearcoatRoughnessMapUv;
#endif
#ifdef USE_SHEEN_COLORMAP
	uniform mat3 sheenColorMapTransform;
	varying vec2 vSheenColorMapUv;
#endif
#ifdef USE_SHEEN_ROUGHNESSMAP
	uniform mat3 sheenRoughnessMapTransform;
	varying vec2 vSheenRoughnessMapUv;
#endif
#ifdef USE_IRIDESCENCEMAP
	uniform mat3 iridescenceMapTransform;
	varying vec2 vIridescenceMapUv;
#endif
#ifdef USE_IRIDESCENCE_THICKNESSMAP
	uniform mat3 iridescenceThicknessMapTransform;
	varying vec2 vIridescenceThicknessMapUv;
#endif
#ifdef USE_SPECULARMAP
	uniform mat3 specularMapTransform;
	varying vec2 vSpecularMapUv;
#endif
#ifdef USE_SPECULAR_COLORMAP
	uniform mat3 specularColorMapTransform;
	varying vec2 vSpecularColorMapUv;
#endif
#ifdef USE_SPECULAR_INTENSITYMAP
	uniform mat3 specularIntensityMapTransform;
	varying vec2 vSpecularIntensityMapUv;
#endif
#ifdef USE_TRANSMISSIONMAP
	uniform mat3 transmissionMapTransform;
	varying vec2 vTransmissionMapUv;
#endif
#ifdef USE_THICKNESSMAP
	uniform mat3 thicknessMapTransform;
	varying vec2 vThicknessMapUv;
#endif`,
  uv_vertex: `#if defined( USE_UV ) || defined( USE_ANISOTROPY )
	vUv = vec3( uv, 1 ).xy;
#endif
#ifdef USE_MAP
	vMapUv = ( mapTransform * vec3( MAP_UV, 1 ) ).xy;
#endif
#ifdef USE_ALPHAMAP
	vAlphaMapUv = ( alphaMapTransform * vec3( ALPHAMAP_UV, 1 ) ).xy;
#endif
#ifdef USE_LIGHTMAP
	vLightMapUv = ( lightMapTransform * vec3( LIGHTMAP_UV, 1 ) ).xy;
#endif
#ifdef USE_AOMAP
	vAoMapUv = ( aoMapTransform * vec3( AOMAP_UV, 1 ) ).xy;
#endif
#ifdef USE_BUMPMAP
	vBumpMapUv = ( bumpMapTransform * vec3( BUMPMAP_UV, 1 ) ).xy;
#endif
#ifdef USE_NORMALMAP
	vNormalMapUv = ( normalMapTransform * vec3( NORMALMAP_UV, 1 ) ).xy;
#endif
#ifdef USE_DISPLACEMENTMAP
	vDisplacementMapUv = ( displacementMapTransform * vec3( DISPLACEMENTMAP_UV, 1 ) ).xy;
#endif
#ifdef USE_EMISSIVEMAP
	vEmissiveMapUv = ( emissiveMapTransform * vec3( EMISSIVEMAP_UV, 1 ) ).xy;
#endif
#ifdef USE_METALNESSMAP
	vMetalnessMapUv = ( metalnessMapTransform * vec3( METALNESSMAP_UV, 1 ) ).xy;
#endif
#ifdef USE_ROUGHNESSMAP
	vRoughnessMapUv = ( roughnessMapTransform * vec3( ROUGHNESSMAP_UV, 1 ) ).xy;
#endif
#ifdef USE_ANISOTROPYMAP
	vAnisotropyMapUv = ( anisotropyMapTransform * vec3( ANISOTROPYMAP_UV, 1 ) ).xy;
#endif
#ifdef USE_CLEARCOATMAP
	vClearcoatMapUv = ( clearcoatMapTransform * vec3( CLEARCOATMAP_UV, 1 ) ).xy;
#endif
#ifdef USE_CLEARCOAT_NORMALMAP
	vClearcoatNormalMapUv = ( clearcoatNormalMapTransform * vec3( CLEARCOAT_NORMALMAP_UV, 1 ) ).xy;
#endif
#ifdef USE_CLEARCOAT_ROUGHNESSMAP
	vClearcoatRoughnessMapUv = ( clearcoatRoughnessMapTransform * vec3( CLEARCOAT_ROUGHNESSMAP_UV, 1 ) ).xy;
#endif
#ifdef USE_IRIDESCENCEMAP
	vIridescenceMapUv = ( iridescenceMapTransform * vec3( IRIDESCENCEMAP_UV, 1 ) ).xy;
#endif
#ifdef USE_IRIDESCENCE_THICKNESSMAP
	vIridescenceThicknessMapUv = ( iridescenceThicknessMapTransform * vec3( IRIDESCENCE_THICKNESSMAP_UV, 1 ) ).xy;
#endif
#ifdef USE_SHEEN_COLORMAP
	vSheenColorMapUv = ( sheenColorMapTransform * vec3( SHEEN_COLORMAP_UV, 1 ) ).xy;
#endif
#ifdef USE_SHEEN_ROUGHNESSMAP
	vSheenRoughnessMapUv = ( sheenRoughnessMapTransform * vec3( SHEEN_ROUGHNESSMAP_UV, 1 ) ).xy;
#endif
#ifdef USE_SPECULARMAP
	vSpecularMapUv = ( specularMapTransform * vec3( SPECULARMAP_UV, 1 ) ).xy;
#endif
#ifdef USE_SPECULAR_COLORMAP
	vSpecularColorMapUv = ( specularColorMapTransform * vec3( SPECULAR_COLORMAP_UV, 1 ) ).xy;
#endif
#ifdef USE_SPECULAR_INTENSITYMAP
	vSpecularIntensityMapUv = ( specularIntensityMapTransform * vec3( SPECULAR_INTENSITYMAP_UV, 1 ) ).xy;
#endif
#ifdef USE_TRANSMISSIONMAP
	vTransmissionMapUv = ( transmissionMapTransform * vec3( TRANSMISSIONMAP_UV, 1 ) ).xy;
#endif
#ifdef USE_THICKNESSMAP
	vThicknessMapUv = ( thicknessMapTransform * vec3( THICKNESSMAP_UV, 1 ) ).xy;
#endif`,
  worldpos_vertex: `#if defined( USE_ENVMAP ) || defined( DISTANCE ) || defined ( USE_SHADOWMAP ) || defined ( USE_TRANSMISSION ) || NUM_SPOT_LIGHT_COORDS > 0
	vec4 worldPosition = vec4( transformed, 1.0 );
	#ifdef USE_BATCHING
		worldPosition = batchingMatrix * worldPosition;
	#endif
	#ifdef USE_INSTANCING
		worldPosition = instanceMatrix * worldPosition;
	#endif
	worldPosition = modelMatrix * worldPosition;
#endif`,
  background_vert: `varying vec2 vUv;
uniform mat3 uvTransform;
void main() {
	vUv = ( uvTransform * vec3( uv, 1 ) ).xy;
	gl_Position = vec4( position.xy, 1.0, 1.0 );
}`,
  background_frag: `uniform sampler2D t2D;
uniform float backgroundIntensity;
varying vec2 vUv;
void main() {
	vec4 texColor = texture2D( t2D, vUv );
	#ifdef DECODE_VIDEO_TEXTURE
		texColor = vec4( mix( pow( texColor.rgb * 0.9478672986 + vec3( 0.0521327014 ), vec3( 2.4 ) ), texColor.rgb * 0.0773993808, vec3( lessThanEqual( texColor.rgb, vec3( 0.04045 ) ) ) ), texColor.w );
	#endif
	texColor.rgb *= backgroundIntensity;
	gl_FragColor = texColor;
	#include <tonemapping_fragment>
	#include <colorspace_fragment>
}`,
  backgroundCube_vert: `varying vec3 vWorldDirection;
#include <common>
void main() {
	vWorldDirection = transformDirection( position, modelMatrix );
	#include <begin_vertex>
	#include <project_vertex>
	gl_Position.z = gl_Position.w;
}`,
  backgroundCube_frag: `#ifdef ENVMAP_TYPE_CUBE
	uniform samplerCube envMap;
#elif defined( ENVMAP_TYPE_CUBE_UV )
	uniform sampler2D envMap;
#endif
uniform float backgroundBlurriness;
uniform float backgroundIntensity;
uniform mat3 backgroundRotation;
varying vec3 vWorldDirection;
#include <cube_uv_reflection_fragment>
void main() {
	#ifdef ENVMAP_TYPE_CUBE
		vec4 texColor = textureCube( envMap, backgroundRotation * vWorldDirection );
	#elif defined( ENVMAP_TYPE_CUBE_UV )
		vec4 texColor = textureCubeUV( envMap, backgroundRotation * vWorldDirection, backgroundBlurriness );
	#else
		vec4 texColor = vec4( 0.0, 0.0, 0.0, 1.0 );
	#endif
	texColor.rgb *= backgroundIntensity;
	gl_FragColor = texColor;
	#include <tonemapping_fragment>
	#include <colorspace_fragment>
}`,
  cube_vert: `varying vec3 vWorldDirection;
#include <common>
void main() {
	vWorldDirection = transformDirection( position, modelMatrix );
	#include <begin_vertex>
	#include <project_vertex>
	gl_Position.z = gl_Position.w;
}`,
  cube_frag: `uniform samplerCube tCube;
uniform float tFlip;
uniform float opacity;
varying vec3 vWorldDirection;
void main() {
	vec4 texColor = textureCube( tCube, vec3( tFlip * vWorldDirection.x, vWorldDirection.yz ) );
	gl_FragColor = texColor;
	gl_FragColor.a *= opacity;
	#include <tonemapping_fragment>
	#include <colorspace_fragment>
}`,
  depth_vert: `#include <common>
#include <batching_pars_vertex>
#include <uv_pars_vertex>
#include <displacementmap_pars_vertex>
#include <morphtarget_pars_vertex>
#include <skinning_pars_vertex>
#include <logdepthbuf_pars_vertex>
#include <clipping_planes_pars_vertex>
varying vec2 vHighPrecisionZW;
void main() {
	#include <uv_vertex>
	#include <batching_vertex>
	#include <skinbase_vertex>
	#include <morphinstance_vertex>
	#ifdef USE_DISPLACEMENTMAP
		#include <beginnormal_vertex>
		#include <morphnormal_vertex>
		#include <skinnormal_vertex>
	#endif
	#include <begin_vertex>
	#include <morphtarget_vertex>
	#include <skinning_vertex>
	#include <displacementmap_vertex>
	#include <project_vertex>
	#include <logdepthbuf_vertex>
	#include <clipping_planes_vertex>
	vHighPrecisionZW = gl_Position.zw;
}`,
  depth_frag: `#if DEPTH_PACKING == 3200
	uniform float opacity;
#endif
#include <common>
#include <packing>
#include <uv_pars_fragment>
#include <map_pars_fragment>
#include <alphamap_pars_fragment>
#include <alphatest_pars_fragment>
#include <alphahash_pars_fragment>
#include <logdepthbuf_pars_fragment>
#include <clipping_planes_pars_fragment>
varying vec2 vHighPrecisionZW;
void main() {
	vec4 diffuseColor = vec4( 1.0 );
	#include <clipping_planes_fragment>
	#if DEPTH_PACKING == 3200
		diffuseColor.a = opacity;
	#endif
	#include <map_fragment>
	#include <alphamap_fragment>
	#include <alphatest_fragment>
	#include <alphahash_fragment>
	#include <logdepthbuf_fragment>
	#ifdef USE_REVERSED_DEPTH_BUFFER
		float fragCoordZ = vHighPrecisionZW[ 0 ] / vHighPrecisionZW[ 1 ];
	#else
		float fragCoordZ = 0.5 * vHighPrecisionZW[ 0 ] / vHighPrecisionZW[ 1 ] + 0.5;
	#endif
	#if DEPTH_PACKING == 3200
		gl_FragColor = vec4( vec3( 1.0 - fragCoordZ ), opacity );
	#elif DEPTH_PACKING == 3201
		gl_FragColor = packDepthToRGBA( fragCoordZ );
	#elif DEPTH_PACKING == 3202
		gl_FragColor = vec4( packDepthToRGB( fragCoordZ ), 1.0 );
	#elif DEPTH_PACKING == 3203
		gl_FragColor = vec4( packDepthToRG( fragCoordZ ), 0.0, 1.0 );
	#endif
}`,
  distance_vert: `#define DISTANCE
varying vec3 vWorldPosition;
#include <common>
#include <batching_pars_vertex>
#include <uv_pars_vertex>
#include <displacementmap_pars_vertex>
#include <morphtarget_pars_vertex>
#include <skinning_pars_vertex>
#include <clipping_planes_pars_vertex>
void main() {
	#include <uv_vertex>
	#include <batching_vertex>
	#include <skinbase_vertex>
	#include <morphinstance_vertex>
	#ifdef USE_DISPLACEMENTMAP
		#include <beginnormal_vertex>
		#include <morphnormal_vertex>
		#include <skinnormal_vertex>
	#endif
	#include <begin_vertex>
	#include <morphtarget_vertex>
	#include <skinning_vertex>
	#include <displacementmap_vertex>
	#include <project_vertex>
	#include <worldpos_vertex>
	#include <clipping_planes_vertex>
	vWorldPosition = worldPosition.xyz;
}`,
  distance_frag: `#define DISTANCE
uniform vec3 referencePosition;
uniform float nearDistance;
uniform float farDistance;
varying vec3 vWorldPosition;
#include <common>
#include <uv_pars_fragment>
#include <map_pars_fragment>
#include <alphamap_pars_fragment>
#include <alphatest_pars_fragment>
#include <alphahash_pars_fragment>
#include <clipping_planes_pars_fragment>
void main() {
	vec4 diffuseColor = vec4( 1.0 );
	#include <clipping_planes_fragment>
	#include <map_fragment>
	#include <alphamap_fragment>
	#include <alphatest_fragment>
	#include <alphahash_fragment>
	float dist = length( vWorldPosition - referencePosition );
	dist = ( dist - nearDistance ) / ( farDistance - nearDistance );
	dist = saturate( dist );
	gl_FragColor = vec4( dist, 0.0, 0.0, 1.0 );
}`,
  equirect_vert: `varying vec3 vWorldDirection;
#include <common>
void main() {
	vWorldDirection = transformDirection( position, modelMatrix );
	#include <begin_vertex>
	#include <project_vertex>
}`,
  equirect_frag: `uniform sampler2D tEquirect;
varying vec3 vWorldDirection;
#include <common>
void main() {
	vec3 direction = normalize( vWorldDirection );
	vec2 sampleUV = equirectUv( direction );
	gl_FragColor = texture2D( tEquirect, sampleUV );
	#include <tonemapping_fragment>
	#include <colorspace_fragment>
}`,
  linedashed_vert: `uniform float scale;
attribute float lineDistance;
varying float vLineDistance;
#include <common>
#include <uv_pars_vertex>
#include <color_pars_vertex>
#include <fog_pars_vertex>
#include <morphtarget_pars_vertex>
#include <logdepthbuf_pars_vertex>
#include <clipping_planes_pars_vertex>
void main() {
	vLineDistance = scale * lineDistance;
	#include <uv_vertex>
	#include <color_vertex>
	#include <morphinstance_vertex>
	#include <morphcolor_vertex>
	#include <begin_vertex>
	#include <morphtarget_vertex>
	#include <project_vertex>
	#include <logdepthbuf_vertex>
	#include <clipping_planes_vertex>
	#include <fog_vertex>
}`,
  linedashed_frag: `uniform vec3 diffuse;
uniform float opacity;
uniform float dashSize;
uniform float totalSize;
varying float vLineDistance;
#include <common>
#include <color_pars_fragment>
#include <uv_pars_fragment>
#include <map_pars_fragment>
#include <fog_pars_fragment>
#include <logdepthbuf_pars_fragment>
#include <clipping_planes_pars_fragment>
void main() {
	vec4 diffuseColor = vec4( diffuse, opacity );
	#include <clipping_planes_fragment>
	if ( mod( vLineDistance, totalSize ) > dashSize ) {
		discard;
	}
	vec3 outgoingLight = vec3( 0.0 );
	#include <logdepthbuf_fragment>
	#include <map_fragment>
	#include <color_fragment>
	outgoingLight = diffuseColor.rgb;
	#include <opaque_fragment>
	#include <tonemapping_fragment>
	#include <colorspace_fragment>
	#include <fog_fragment>
	#include <premultiplied_alpha_fragment>
}`,
  meshbasic_vert: `#include <common>
#include <batching_pars_vertex>
#include <uv_pars_vertex>
#include <envmap_pars_vertex>
#include <color_pars_vertex>
#include <fog_pars_vertex>
#include <morphtarget_pars_vertex>
#include <skinning_pars_vertex>
#include <logdepthbuf_pars_vertex>
#include <clipping_planes_pars_vertex>
void main() {
	#include <uv_vertex>
	#include <color_vertex>
	#include <morphinstance_vertex>
	#include <morphcolor_vertex>
	#include <batching_vertex>
	#if defined ( USE_ENVMAP ) || defined ( USE_SKINNING )
		#include <beginnormal_vertex>
		#include <morphnormal_vertex>
		#include <skinbase_vertex>
		#include <skinnormal_vertex>
		#include <defaultnormal_vertex>
	#endif
	#include <begin_vertex>
	#include <morphtarget_vertex>
	#include <skinning_vertex>
	#include <project_vertex>
	#include <logdepthbuf_vertex>
	#include <clipping_planes_vertex>
	#include <worldpos_vertex>
	#include <envmap_vertex>
	#include <fog_vertex>
}`,
  meshbasic_frag: `uniform vec3 diffuse;
uniform float opacity;
#ifndef FLAT_SHADED
	varying vec3 vNormal;
#endif
#include <common>
#include <dithering_pars_fragment>
#include <color_pars_fragment>
#include <uv_pars_fragment>
#include <map_pars_fragment>
#include <alphamap_pars_fragment>
#include <alphatest_pars_fragment>
#include <alphahash_pars_fragment>
#include <aomap_pars_fragment>
#include <lightmap_pars_fragment>
#include <envmap_common_pars_fragment>
#include <envmap_pars_fragment>
#include <fog_pars_fragment>
#include <specularmap_pars_fragment>
#include <logdepthbuf_pars_fragment>
#include <clipping_planes_pars_fragment>
void main() {
	vec4 diffuseColor = vec4( diffuse, opacity );
	#include <clipping_planes_fragment>
	#include <logdepthbuf_fragment>
	#include <map_fragment>
	#include <color_fragment>
	#include <alphamap_fragment>
	#include <alphatest_fragment>
	#include <alphahash_fragment>
	#include <specularmap_fragment>
	ReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );
	#ifdef USE_LIGHTMAP
		vec4 lightMapTexel = texture2D( lightMap, vLightMapUv );
		reflectedLight.indirectDiffuse += lightMapTexel.rgb * lightMapIntensity * RECIPROCAL_PI;
	#else
		reflectedLight.indirectDiffuse += vec3( 1.0 );
	#endif
	#include <aomap_fragment>
	reflectedLight.indirectDiffuse *= diffuseColor.rgb;
	vec3 outgoingLight = reflectedLight.indirectDiffuse;
	#include <envmap_fragment>
	#include <opaque_fragment>
	#include <tonemapping_fragment>
	#include <colorspace_fragment>
	#include <fog_fragment>
	#include <premultiplied_alpha_fragment>
	#include <dithering_fragment>
}`,
  meshlambert_vert: `#define LAMBERT
varying vec3 vViewPosition;
#include <common>
#include <batching_pars_vertex>
#include <uv_pars_vertex>
#include <displacementmap_pars_vertex>
#include <envmap_pars_vertex>
#include <color_pars_vertex>
#include <fog_pars_vertex>
#include <normal_pars_vertex>
#include <morphtarget_pars_vertex>
#include <skinning_pars_vertex>
#include <shadowmap_pars_vertex>
#include <logdepthbuf_pars_vertex>
#include <clipping_planes_pars_vertex>
void main() {
	#include <uv_vertex>
	#include <color_vertex>
	#include <morphinstance_vertex>
	#include <morphcolor_vertex>
	#include <batching_vertex>
	#include <beginnormal_vertex>
	#include <morphnormal_vertex>
	#include <skinbase_vertex>
	#include <skinnormal_vertex>
	#include <defaultnormal_vertex>
	#include <normal_vertex>
	#include <begin_vertex>
	#include <morphtarget_vertex>
	#include <skinning_vertex>
	#include <displacementmap_vertex>
	#include <project_vertex>
	#include <logdepthbuf_vertex>
	#include <clipping_planes_vertex>
	vViewPosition = - mvPosition.xyz;
	#include <worldpos_vertex>
	#include <envmap_vertex>
	#include <shadowmap_vertex>
	#include <fog_vertex>
}`,
  meshlambert_frag: `#define LAMBERT
uniform vec3 diffuse;
uniform vec3 emissive;
uniform float opacity;
#include <common>
#include <dithering_pars_fragment>
#include <color_pars_fragment>
#include <uv_pars_fragment>
#include <map_pars_fragment>
#include <alphamap_pars_fragment>
#include <alphatest_pars_fragment>
#include <alphahash_pars_fragment>
#include <aomap_pars_fragment>
#include <lightmap_pars_fragment>
#include <emissivemap_pars_fragment>
#include <cube_uv_reflection_fragment>
#include <envmap_common_pars_fragment>
#include <envmap_pars_fragment>
#include <envmap_physical_pars_fragment>
#include <fog_pars_fragment>
#include <bsdfs>
#include <lights_pars_begin>
#include <normal_pars_fragment>
#include <lights_lambert_pars_fragment>
#include <shadowmap_pars_fragment>
#include <bumpmap_pars_fragment>
#include <normalmap_pars_fragment>
#include <specularmap_pars_fragment>
#include <logdepthbuf_pars_fragment>
#include <clipping_planes_pars_fragment>
void main() {
	vec4 diffuseColor = vec4( diffuse, opacity );
	#include <clipping_planes_fragment>
	ReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );
	vec3 totalEmissiveRadiance = emissive;
	#include <logdepthbuf_fragment>
	#include <map_fragment>
	#include <color_fragment>
	#include <alphamap_fragment>
	#include <alphatest_fragment>
	#include <alphahash_fragment>
	#include <specularmap_fragment>
	#include <normal_fragment_begin>
	#include <normal_fragment_maps>
	#include <emissivemap_fragment>
	#include <lights_lambert_fragment>
	#include <lights_fragment_begin>
	#include <lights_fragment_maps>
	#include <lights_fragment_end>
	#include <aomap_fragment>
	vec3 outgoingLight = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse + totalEmissiveRadiance;
	#include <envmap_fragment>
	#include <opaque_fragment>
	#include <tonemapping_fragment>
	#include <colorspace_fragment>
	#include <fog_fragment>
	#include <premultiplied_alpha_fragment>
	#include <dithering_fragment>
}`,
  meshmatcap_vert: `#define MATCAP
varying vec3 vViewPosition;
#include <common>
#include <batching_pars_vertex>
#include <uv_pars_vertex>
#include <color_pars_vertex>
#include <displacementmap_pars_vertex>
#include <fog_pars_vertex>
#include <normal_pars_vertex>
#include <morphtarget_pars_vertex>
#include <skinning_pars_vertex>
#include <logdepthbuf_pars_vertex>
#include <clipping_planes_pars_vertex>
void main() {
	#include <uv_vertex>
	#include <color_vertex>
	#include <morphinstance_vertex>
	#include <morphcolor_vertex>
	#include <batching_vertex>
	#include <beginnormal_vertex>
	#include <morphnormal_vertex>
	#include <skinbase_vertex>
	#include <skinnormal_vertex>
	#include <defaultnormal_vertex>
	#include <normal_vertex>
	#include <begin_vertex>
	#include <morphtarget_vertex>
	#include <skinning_vertex>
	#include <displacementmap_vertex>
	#include <project_vertex>
	#include <logdepthbuf_vertex>
	#include <clipping_planes_vertex>
	#include <fog_vertex>
	vViewPosition = - mvPosition.xyz;
}`,
  meshmatcap_frag: `#define MATCAP
uniform vec3 diffuse;
uniform float opacity;
uniform sampler2D matcap;
varying vec3 vViewPosition;
#include <common>
#include <dithering_pars_fragment>
#include <color_pars_fragment>
#include <uv_pars_fragment>
#include <map_pars_fragment>
#include <alphamap_pars_fragment>
#include <alphatest_pars_fragment>
#include <alphahash_pars_fragment>
#include <fog_pars_fragment>
#include <normal_pars_fragment>
#include <bumpmap_pars_fragment>
#include <normalmap_pars_fragment>
#include <logdepthbuf_pars_fragment>
#include <clipping_planes_pars_fragment>
void main() {
	vec4 diffuseColor = vec4( diffuse, opacity );
	#include <clipping_planes_fragment>
	#include <logdepthbuf_fragment>
	#include <map_fragment>
	#include <color_fragment>
	#include <alphamap_fragment>
	#include <alphatest_fragment>
	#include <alphahash_fragment>
	#include <normal_fragment_begin>
	#include <normal_fragment_maps>
	vec3 viewDir = normalize( vViewPosition );
	vec3 x = normalize( vec3( viewDir.z, 0.0, - viewDir.x ) );
	vec3 y = cross( viewDir, x );
	vec2 uv = vec2( dot( x, normal ), dot( y, normal ) ) * 0.495 + 0.5;
	#ifdef USE_MATCAP
		vec4 matcapColor = texture2D( matcap, uv );
	#else
		vec4 matcapColor = vec4( vec3( mix( 0.2, 0.8, uv.y ) ), 1.0 );
	#endif
	vec3 outgoingLight = diffuseColor.rgb * matcapColor.rgb;
	#include <opaque_fragment>
	#include <tonemapping_fragment>
	#include <colorspace_fragment>
	#include <fog_fragment>
	#include <premultiplied_alpha_fragment>
	#include <dithering_fragment>
}`,
  meshnormal_vert: `#define NORMAL
#if defined( FLAT_SHADED ) || defined( USE_BUMPMAP ) || defined( USE_NORMALMAP_TANGENTSPACE )
	varying vec3 vViewPosition;
#endif
#include <common>
#include <batching_pars_vertex>
#include <uv_pars_vertex>
#include <displacementmap_pars_vertex>
#include <normal_pars_vertex>
#include <morphtarget_pars_vertex>
#include <skinning_pars_vertex>
#include <logdepthbuf_pars_vertex>
#include <clipping_planes_pars_vertex>
void main() {
	#include <uv_vertex>
	#include <batching_vertex>
	#include <beginnormal_vertex>
	#include <morphinstance_vertex>
	#include <morphnormal_vertex>
	#include <skinbase_vertex>
	#include <skinnormal_vertex>
	#include <defaultnormal_vertex>
	#include <normal_vertex>
	#include <begin_vertex>
	#include <morphtarget_vertex>
	#include <skinning_vertex>
	#include <displacementmap_vertex>
	#include <project_vertex>
	#include <logdepthbuf_vertex>
	#include <clipping_planes_vertex>
#if defined( FLAT_SHADED ) || defined( USE_BUMPMAP ) || defined( USE_NORMALMAP_TANGENTSPACE )
	vViewPosition = - mvPosition.xyz;
#endif
}`,
  meshnormal_frag: `#define NORMAL
uniform float opacity;
#if defined( FLAT_SHADED ) || defined( USE_BUMPMAP ) || defined( USE_NORMALMAP_TANGENTSPACE )
	varying vec3 vViewPosition;
#endif
#include <uv_pars_fragment>
#include <normal_pars_fragment>
#include <bumpmap_pars_fragment>
#include <normalmap_pars_fragment>
#include <logdepthbuf_pars_fragment>
#include <clipping_planes_pars_fragment>
void main() {
	vec4 diffuseColor = vec4( 0.0, 0.0, 0.0, opacity );
	#include <clipping_planes_fragment>
	#include <logdepthbuf_fragment>
	#include <normal_fragment_begin>
	#include <normal_fragment_maps>
	gl_FragColor = vec4( normalize( normal ) * 0.5 + 0.5, diffuseColor.a );
	#ifdef OPAQUE
		gl_FragColor.a = 1.0;
	#endif
}`,
  meshphong_vert: `#define PHONG
varying vec3 vViewPosition;
#include <common>
#include <batching_pars_vertex>
#include <uv_pars_vertex>
#include <displacementmap_pars_vertex>
#include <envmap_pars_vertex>
#include <color_pars_vertex>
#include <fog_pars_vertex>
#include <normal_pars_vertex>
#include <morphtarget_pars_vertex>
#include <skinning_pars_vertex>
#include <shadowmap_pars_vertex>
#include <logdepthbuf_pars_vertex>
#include <clipping_planes_pars_vertex>
void main() {
	#include <uv_vertex>
	#include <color_vertex>
	#include <morphcolor_vertex>
	#include <batching_vertex>
	#include <beginnormal_vertex>
	#include <morphinstance_vertex>
	#include <morphnormal_vertex>
	#include <skinbase_vertex>
	#include <skinnormal_vertex>
	#include <defaultnormal_vertex>
	#include <normal_vertex>
	#include <begin_vertex>
	#include <morphtarget_vertex>
	#include <skinning_vertex>
	#include <displacementmap_vertex>
	#include <project_vertex>
	#include <logdepthbuf_vertex>
	#include <clipping_planes_vertex>
	vViewPosition = - mvPosition.xyz;
	#include <worldpos_vertex>
	#include <envmap_vertex>
	#include <shadowmap_vertex>
	#include <fog_vertex>
}`,
  meshphong_frag: `#define PHONG
uniform vec3 diffuse;
uniform vec3 emissive;
uniform vec3 specular;
uniform float shininess;
uniform float opacity;
#include <common>
#include <dithering_pars_fragment>
#include <color_pars_fragment>
#include <uv_pars_fragment>
#include <map_pars_fragment>
#include <alphamap_pars_fragment>
#include <alphatest_pars_fragment>
#include <alphahash_pars_fragment>
#include <aomap_pars_fragment>
#include <lightmap_pars_fragment>
#include <emissivemap_pars_fragment>
#include <cube_uv_reflection_fragment>
#include <envmap_common_pars_fragment>
#include <envmap_pars_fragment>
#include <envmap_physical_pars_fragment>
#include <fog_pars_fragment>
#include <bsdfs>
#include <lights_pars_begin>
#include <normal_pars_fragment>
#include <lights_phong_pars_fragment>
#include <shadowmap_pars_fragment>
#include <bumpmap_pars_fragment>
#include <normalmap_pars_fragment>
#include <specularmap_pars_fragment>
#include <logdepthbuf_pars_fragment>
#include <clipping_planes_pars_fragment>
void main() {
	vec4 diffuseColor = vec4( diffuse, opacity );
	#include <clipping_planes_fragment>
	ReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );
	vec3 totalEmissiveRadiance = emissive;
	#include <logdepthbuf_fragment>
	#include <map_fragment>
	#include <color_fragment>
	#include <alphamap_fragment>
	#include <alphatest_fragment>
	#include <alphahash_fragment>
	#include <specularmap_fragment>
	#include <normal_fragment_begin>
	#include <normal_fragment_maps>
	#include <emissivemap_fragment>
	#include <lights_phong_fragment>
	#include <lights_fragment_begin>
	#include <lights_fragment_maps>
	#include <lights_fragment_end>
	#include <aomap_fragment>
	vec3 outgoingLight = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse + reflectedLight.directSpecular + reflectedLight.indirectSpecular + totalEmissiveRadiance;
	#include <envmap_fragment>
	#include <opaque_fragment>
	#include <tonemapping_fragment>
	#include <colorspace_fragment>
	#include <fog_fragment>
	#include <premultiplied_alpha_fragment>
	#include <dithering_fragment>
}`,
  meshphysical_vert: `#define STANDARD
varying vec3 vViewPosition;
#ifdef USE_TRANSMISSION
	varying vec3 vWorldPosition;
#endif
#include <common>
#include <batching_pars_vertex>
#include <uv_pars_vertex>
#include <displacementmap_pars_vertex>
#include <color_pars_vertex>
#include <fog_pars_vertex>
#include <normal_pars_vertex>
#include <morphtarget_pars_vertex>
#include <skinning_pars_vertex>
#include <shadowmap_pars_vertex>
#include <logdepthbuf_pars_vertex>
#include <clipping_planes_pars_vertex>
void main() {
	#include <uv_vertex>
	#include <color_vertex>
	#include <morphinstance_vertex>
	#include <morphcolor_vertex>
	#include <batching_vertex>
	#include <beginnormal_vertex>
	#include <morphnormal_vertex>
	#include <skinbase_vertex>
	#include <skinnormal_vertex>
	#include <defaultnormal_vertex>
	#include <normal_vertex>
	#include <begin_vertex>
	#include <morphtarget_vertex>
	#include <skinning_vertex>
	#include <displacementmap_vertex>
	#include <project_vertex>
	#include <logdepthbuf_vertex>
	#include <clipping_planes_vertex>
	vViewPosition = - mvPosition.xyz;
	#include <worldpos_vertex>
	#include <shadowmap_vertex>
	#include <fog_vertex>
#ifdef USE_TRANSMISSION
	vWorldPosition = worldPosition.xyz;
#endif
}`,
  meshphysical_frag: `#define STANDARD
#ifdef PHYSICAL
	#define IOR
	#define USE_SPECULAR
#endif
uniform vec3 diffuse;
uniform vec3 emissive;
uniform float roughness;
uniform float metalness;
uniform float opacity;
#ifdef IOR
	uniform float ior;
#endif
#ifdef USE_SPECULAR
	uniform float specularIntensity;
	uniform vec3 specularColor;
	#ifdef USE_SPECULAR_COLORMAP
		uniform sampler2D specularColorMap;
	#endif
	#ifdef USE_SPECULAR_INTENSITYMAP
		uniform sampler2D specularIntensityMap;
	#endif
#endif
#ifdef USE_CLEARCOAT
	uniform float clearcoat;
	uniform float clearcoatRoughness;
#endif
#ifdef USE_DISPERSION
	uniform float dispersion;
#endif
#ifdef USE_RETROREFLECTION
	uniform float retroreflectivity;
#endif
#ifdef USE_IRIDESCENCE
	uniform float iridescence;
	uniform float iridescenceIOR;
	uniform float iridescenceThicknessMinimum;
	uniform float iridescenceThicknessMaximum;
#endif
#ifdef USE_SHEEN
	uniform vec3 sheenColor;
	uniform float sheenRoughness;
	#ifdef USE_SHEEN_COLORMAP
		uniform sampler2D sheenColorMap;
	#endif
	#ifdef USE_SHEEN_ROUGHNESSMAP
		uniform sampler2D sheenRoughnessMap;
	#endif
#endif
#ifdef USE_ANISOTROPY
	uniform vec2 anisotropyVector;
	#ifdef USE_ANISOTROPYMAP
		uniform sampler2D anisotropyMap;
	#endif
#endif
varying vec3 vViewPosition;
#include <common>
#include <dithering_pars_fragment>
#include <color_pars_fragment>
#include <uv_pars_fragment>
#include <map_pars_fragment>
#include <alphamap_pars_fragment>
#include <alphatest_pars_fragment>
#include <alphahash_pars_fragment>
#include <aomap_pars_fragment>
#include <lightmap_pars_fragment>
#include <emissivemap_pars_fragment>
#include <iridescence_fragment>
#include <cube_uv_reflection_fragment>
#include <envmap_common_pars_fragment>
#include <envmap_physical_pars_fragment>
#include <fog_pars_fragment>
#include <lights_pars_begin>
#include <normal_pars_fragment>
#include <lights_physical_pars_fragment>
#include <transmission_pars_fragment>
#include <shadowmap_pars_fragment>
#include <bumpmap_pars_fragment>
#include <normalmap_pars_fragment>
#include <clearcoat_pars_fragment>
#include <iridescence_pars_fragment>
#include <roughnessmap_pars_fragment>
#include <metalnessmap_pars_fragment>
#include <logdepthbuf_pars_fragment>
#include <clipping_planes_pars_fragment>
void main() {
	vec4 diffuseColor = vec4( diffuse, opacity );
	#include <clipping_planes_fragment>
	ReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );
	vec3 totalEmissiveRadiance = emissive;
	#include <logdepthbuf_fragment>
	#include <map_fragment>
	#include <color_fragment>
	#include <alphamap_fragment>
	#include <alphatest_fragment>
	#include <alphahash_fragment>
	#include <roughnessmap_fragment>
	#include <metalnessmap_fragment>
	#include <normal_fragment_begin>
	#include <normal_fragment_maps>
	#include <clearcoat_normal_fragment_begin>
	#include <clearcoat_normal_fragment_maps>
	#include <emissivemap_fragment>
	#include <lights_physical_fragment>
	#include <lights_fragment_begin>
	#include <lights_fragment_maps>
	#include <lights_fragment_end>
	#include <aomap_fragment>
	vec3 totalDiffuse = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse;
	vec3 totalSpecular = reflectedLight.directSpecular + reflectedLight.indirectSpecular;
	#include <transmission_fragment>
	vec3 outgoingLight = totalDiffuse + totalSpecular + totalEmissiveRadiance;
	#ifdef USE_SHEEN
 
		outgoingLight = outgoingLight + sheenSpecularDirect + sheenSpecularIndirect;
 
 	#endif
	#ifdef USE_CLEARCOAT
		float dotNVcc = saturate( dot( geometryClearcoatNormal, geometryViewDir ) );
		vec3 Fcc = F_Schlick( material.clearcoatF0, material.clearcoatF90, dotNVcc );
		outgoingLight = outgoingLight * ( 1.0 - material.clearcoat * Fcc ) + ( clearcoatSpecularDirect + clearcoatSpecularIndirect ) * material.clearcoat;
	#endif
	#include <opaque_fragment>
	#include <tonemapping_fragment>
	#include <colorspace_fragment>
	#include <fog_fragment>
	#include <premultiplied_alpha_fragment>
	#include <dithering_fragment>
}`,
  meshtoon_vert: `#define TOON
varying vec3 vViewPosition;
#include <common>
#include <batching_pars_vertex>
#include <uv_pars_vertex>
#include <displacementmap_pars_vertex>
#include <color_pars_vertex>
#include <fog_pars_vertex>
#include <normal_pars_vertex>
#include <morphtarget_pars_vertex>
#include <skinning_pars_vertex>
#include <shadowmap_pars_vertex>
#include <logdepthbuf_pars_vertex>
#include <clipping_planes_pars_vertex>
void main() {
	#include <uv_vertex>
	#include <color_vertex>
	#include <morphinstance_vertex>
	#include <morphcolor_vertex>
	#include <batching_vertex>
	#include <beginnormal_vertex>
	#include <morphnormal_vertex>
	#include <skinbase_vertex>
	#include <skinnormal_vertex>
	#include <defaultnormal_vertex>
	#include <normal_vertex>
	#include <begin_vertex>
	#include <morphtarget_vertex>
	#include <skinning_vertex>
	#include <displacementmap_vertex>
	#include <project_vertex>
	#include <logdepthbuf_vertex>
	#include <clipping_planes_vertex>
	vViewPosition = - mvPosition.xyz;
	#include <worldpos_vertex>
	#include <shadowmap_vertex>
	#include <fog_vertex>
}`,
  meshtoon_frag: `#define TOON
uniform vec3 diffuse;
uniform vec3 emissive;
uniform float opacity;
#include <common>
#include <dithering_pars_fragment>
#include <color_pars_fragment>
#include <uv_pars_fragment>
#include <map_pars_fragment>
#include <alphamap_pars_fragment>
#include <alphatest_pars_fragment>
#include <alphahash_pars_fragment>
#include <aomap_pars_fragment>
#include <lightmap_pars_fragment>
#include <emissivemap_pars_fragment>
#include <gradientmap_pars_fragment>
#include <fog_pars_fragment>
#include <bsdfs>
#include <lights_pars_begin>
#include <normal_pars_fragment>
#include <lights_toon_pars_fragment>
#include <shadowmap_pars_fragment>
#include <bumpmap_pars_fragment>
#include <normalmap_pars_fragment>
#include <logdepthbuf_pars_fragment>
#include <clipping_planes_pars_fragment>
void main() {
	vec4 diffuseColor = vec4( diffuse, opacity );
	#include <clipping_planes_fragment>
	ReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );
	vec3 totalEmissiveRadiance = emissive;
	#include <logdepthbuf_fragment>
	#include <map_fragment>
	#include <color_fragment>
	#include <alphamap_fragment>
	#include <alphatest_fragment>
	#include <alphahash_fragment>
	#include <normal_fragment_begin>
	#include <normal_fragment_maps>
	#include <emissivemap_fragment>
	#include <lights_toon_fragment>
	#include <lights_fragment_begin>
	#include <lights_fragment_maps>
	#include <lights_fragment_end>
	#include <aomap_fragment>
	vec3 outgoingLight = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse + totalEmissiveRadiance;
	#include <opaque_fragment>
	#include <tonemapping_fragment>
	#include <colorspace_fragment>
	#include <fog_fragment>
	#include <premultiplied_alpha_fragment>
	#include <dithering_fragment>
}`,
  points_vert: `uniform float size;
uniform float scale;
#include <common>
#include <color_pars_vertex>
#include <fog_pars_vertex>
#include <morphtarget_pars_vertex>
#include <logdepthbuf_pars_vertex>
#include <clipping_planes_pars_vertex>
#ifdef USE_POINTS_UV
	varying vec2 vUv;
	uniform mat3 uvTransform;
#endif
void main() {
	#ifdef USE_POINTS_UV
		vUv = ( uvTransform * vec3( uv, 1 ) ).xy;
	#endif
	#include <color_vertex>
	#include <morphinstance_vertex>
	#include <morphcolor_vertex>
	#include <begin_vertex>
	#include <morphtarget_vertex>
	#include <project_vertex>
	gl_PointSize = size;
	#ifdef USE_SIZEATTENUATION
		bool isPerspective = isPerspectiveMatrix( projectionMatrix );
		if ( isPerspective ) gl_PointSize *= ( scale / - mvPosition.z );
	#endif
	#include <logdepthbuf_vertex>
	#include <clipping_planes_vertex>
	#include <worldpos_vertex>
	#include <fog_vertex>
}`,
  points_frag: `uniform vec3 diffuse;
uniform float opacity;
#include <common>
#include <color_pars_fragment>
#include <map_particle_pars_fragment>
#include <alphatest_pars_fragment>
#include <alphahash_pars_fragment>
#include <fog_pars_fragment>
#include <logdepthbuf_pars_fragment>
#include <clipping_planes_pars_fragment>
void main() {
	vec4 diffuseColor = vec4( diffuse, opacity );
	#include <clipping_planes_fragment>
	vec3 outgoingLight = vec3( 0.0 );
	#include <logdepthbuf_fragment>
	#include <map_particle_fragment>
	#include <color_fragment>
	#include <alphatest_fragment>
	#include <alphahash_fragment>
	outgoingLight = diffuseColor.rgb;
	#include <opaque_fragment>
	#include <tonemapping_fragment>
	#include <colorspace_fragment>
	#include <fog_fragment>
	#include <premultiplied_alpha_fragment>
}`,
  shadow_vert: `#include <common>
#include <batching_pars_vertex>
#include <fog_pars_vertex>
#include <morphtarget_pars_vertex>
#include <skinning_pars_vertex>
#include <logdepthbuf_pars_vertex>
#include <shadowmap_pars_vertex>
void main() {
	#include <batching_vertex>
	#include <beginnormal_vertex>
	#include <morphinstance_vertex>
	#include <morphnormal_vertex>
	#include <skinbase_vertex>
	#include <skinnormal_vertex>
	#include <defaultnormal_vertex>
	#include <begin_vertex>
	#include <morphtarget_vertex>
	#include <skinning_vertex>
	#include <project_vertex>
	#include <logdepthbuf_vertex>
	#include <worldpos_vertex>
	#include <shadowmap_vertex>
	#include <fog_vertex>
}`,
  shadow_frag: `uniform vec3 color;
uniform float opacity;
#include <common>
#include <fog_pars_fragment>
#include <bsdfs>
#include <lights_pars_begin>
#include <logdepthbuf_pars_fragment>
#include <shadowmap_pars_fragment>
#include <shadowmask_pars_fragment>
void main() {
	#include <logdepthbuf_fragment>
	gl_FragColor = vec4( color, opacity * ( 1.0 - getShadowMask() ) );
	#include <tonemapping_fragment>
	#include <colorspace_fragment>
	#include <fog_fragment>
	#include <premultiplied_alpha_fragment>
}`,
  sprite_vert: `uniform float rotation;
uniform vec2 center;
#include <common>
#include <uv_pars_vertex>
#include <fog_pars_vertex>
#include <logdepthbuf_pars_vertex>
#include <clipping_planes_pars_vertex>
void main() {
	#include <uv_vertex>
	vec4 mvPosition = modelViewMatrix[ 3 ];
	vec2 scale = vec2( length( modelMatrix[ 0 ].xyz ), length( modelMatrix[ 1 ].xyz ) );
	#ifndef USE_SIZEATTENUATION
		bool isPerspective = isPerspectiveMatrix( projectionMatrix );
		if ( isPerspective ) scale *= - mvPosition.z;
	#endif
	vec2 alignedPosition = ( position.xy - ( center - vec2( 0.5 ) ) ) * scale;
	vec2 rotatedPosition;
	rotatedPosition.x = cos( rotation ) * alignedPosition.x - sin( rotation ) * alignedPosition.y;
	rotatedPosition.y = sin( rotation ) * alignedPosition.x + cos( rotation ) * alignedPosition.y;
	mvPosition.xy += rotatedPosition;
	gl_Position = projectionMatrix * mvPosition;
	#include <logdepthbuf_vertex>
	#include <clipping_planes_vertex>
	#include <fog_vertex>
}`,
  sprite_frag: `uniform vec3 diffuse;
uniform float opacity;
#include <common>
#include <uv_pars_fragment>
#include <map_pars_fragment>
#include <alphamap_pars_fragment>
#include <alphatest_pars_fragment>
#include <alphahash_pars_fragment>
#include <fog_pars_fragment>
#include <logdepthbuf_pars_fragment>
#include <clipping_planes_pars_fragment>
void main() {
	vec4 diffuseColor = vec4( diffuse, opacity );
	#include <clipping_planes_fragment>
	vec3 outgoingLight = vec3( 0.0 );
	#include <logdepthbuf_fragment>
	#include <map_fragment>
	#include <alphamap_fragment>
	#include <alphatest_fragment>
	#include <alphahash_fragment>
	outgoingLight = diffuseColor.rgb;
	#include <opaque_fragment>
	#include <tonemapping_fragment>
	#include <colorspace_fragment>
	#include <fog_fragment>
}`
};
var Z = {
  common: {
    diffuse: {
      value: new Ov(16777215)
    },
    opacity: {
      value: 1
    },
    map: {
      value: null
    },
    mapTransform: {
      value: new E_()
    },
    alphaMap: {
      value: null
    },
    alphaMapTransform: {
      value: new E_()
    },
    alphaTest: {
      value: 0
    }
  },
  specularmap: {
    specularMap: {
      value: null
    },
    specularMapTransform: {
      value: new E_()
    }
  },
  envmap: {
    envMap: {
      value: null
    },
    envMapRotation: {
      value: new E_()
    },
    reflectivity: {
      value: 1
    },
    ior: {
      value: 1.5
    },
    refractionRatio: {
      value: 0.98
    },
    dfgLUT: {
      value: null
    }
  },
  aomap: {
    aoMap: {
      value: null
    },
    aoMapIntensity: {
      value: 1
    },
    aoMapTransform: {
      value: new E_()
    }
  },
  lightmap: {
    lightMap: {
      value: null
    },
    lightMapIntensity: {
      value: 1
    },
    lightMapTransform: {
      value: new E_()
    }
  },
  bumpmap: {
    bumpMap: {
      value: null
    },
    bumpMapTransform: {
      value: new E_()
    },
    bumpScale: {
      value: 1
    }
  },
  normalmap: {
    normalMap: {
      value: null
    },
    normalMapTransform: {
      value: new E_()
    },
    normalScale: {
      value: new S_(1, 1)
    }
  },
  displacementmap: {
    displacementMap: {
      value: null
    },
    displacementMapTransform: {
      value: new E_()
    },
    displacementScale: {
      value: 1
    },
    displacementBias: {
      value: 0
    }
  },
  emissivemap: {
    emissiveMap: {
      value: null
    },
    emissiveMapTransform: {
      value: new E_()
    }
  },
  metalnessmap: {
    metalnessMap: {
      value: null
    },
    metalnessMapTransform: {
      value: new E_()
    }
  },
  roughnessmap: {
    roughnessMap: {
      value: null
    },
    roughnessMapTransform: {
      value: new E_()
    }
  },
  gradientmap: {
    gradientMap: {
      value: null
    }
  },
  fog: {
    fogDensity: {
      value: 0.00025
    },
    fogNear: {
      value: 1
    },
    fogFar: {
      value: 2000
    },
    fogColor: {
      value: new Ov(16777215)
    }
  },
  lights: {
    ambientLightColor: {
      value: []
    },
    lightProbe: {
      value: []
    },
    sunLights: {
      value: [],
      properties: {
        direction: {},
        color: {}
      }
    },
    sunLightShadows: {
      value: [],
      properties: {
        shadowIntensity: 1,
        shadowBias: {},
        shadowNormalBias: {},
        shadowRadius: {},
        shadowMapSize: {}
      }
    },
    sunShadowMatrix: {
      value: []
    },
    sunShadowCascade: {
      value: []
    },
    directionalLights: {
      value: [],
      properties: {
        direction: {},
        color: {}
      }
    },
    directionalLightShadows: {
      value: [],
      properties: {
        shadowIntensity: 1,
        shadowBias: {},
        shadowNormalBias: {},
        shadowRadius: {},
        shadowMapSize: {}
      }
    },
    directionalShadowMatrix: {
      value: []
    },
    spotLights: {
      value: [],
      properties: {
        color: {},
        position: {},
        direction: {},
        distance: {},
        coneCos: {},
        penumbraCos: {},
        decay: {}
      }
    },
    spotLightShadows: {
      value: [],
      properties: {
        shadowIntensity: 1,
        shadowBias: {},
        shadowNormalBias: {},
        shadowRadius: {},
        shadowMapSize: {}
      }
    },
    spotLightMap: {
      value: []
    },
    spotLightMatrix: {
      value: []
    },
    pointLights: {
      value: [],
      properties: {
        color: {},
        position: {},
        decay: {},
        distance: {}
      }
    },
    pointLightShadows: {
      value: [],
      properties: {
        shadowIntensity: 1,
        shadowBias: {},
        shadowNormalBias: {},
        shadowRadius: {},
        shadowMapSize: {},
        shadowCameraNear: {},
        shadowCameraFar: {}
      }
    },
    pointShadowMatrix: {
      value: []
    },
    hemisphereLights: {
      value: [],
      properties: {
        direction: {},
        skyColor: {},
        groundColor: {}
      }
    },
    rectAreaLights: {
      value: [],
      properties: {
        color: {},
        position: {},
        width: {},
        height: {}
      }
    },
    ltc_1: {
      value: null
    },
    ltc_2: {
      value: null
    },
    probesSH: {
      value: null
    },
    probesMin: {
      value: new X()
    },
    probesMax: {
      value: new X()
    },
    probesResolution: {
      value: new X()
    }
  },
  points: {
    diffuse: {
      value: new Ov(16777215)
    },
    opacity: {
      value: 1
    },
    size: {
      value: 1
    },
    scale: {
      value: 1
    },
    map: {
      value: null
    },
    alphaMap: {
      value: null
    },
    alphaMapTransform: {
      value: new E_()
    },
    alphaTest: {
      value: 0
    },
    uvTransform: {
      value: new E_()
    }
  },
  sprite: {
    diffuse: {
      value: new Ov(16777215)
    },
    opacity: {
      value: 1
    },
    center: {
      value: new S_(0.5, 0.5)
    },
    rotation: {
      value: 0
    },
    map: {
      value: null
    },
    mapTransform: {
      value: new E_()
    },
    alphaMap: {
      value: null
    },
    alphaMapTransform: {
      value: new E_()
    },
    alphaTest: {
      value: 0
    }
  }
};
var CS = {
  basic: {
    uniforms: Yb([Z.common, Z.specularmap, Z.envmap, Z.aomap, Z.lightmap, Z.fog]),
    vertexShader: SS.meshbasic_vert,
    fragmentShader: SS.meshbasic_frag
  },
  lambert: {
    uniforms: Yb([Z.common, Z.specularmap, Z.envmap, Z.aomap, Z.lightmap, Z.emissivemap, Z.bumpmap, Z.normalmap, Z.displacementmap, Z.fog, Z.lights, {
      emissive: {
        value: new Ov(0)
      },
      envMapIntensity: {
        value: 1
      }
    }]),
    vertexShader: SS.meshlambert_vert,
    fragmentShader: SS.meshlambert_frag
  },
  phong: {
    uniforms: Yb([Z.common, Z.specularmap, Z.envmap, Z.aomap, Z.lightmap, Z.emissivemap, Z.bumpmap, Z.normalmap, Z.displacementmap, Z.fog, Z.lights, {
      emissive: {
        value: new Ov(0)
      },
      specular: {
        value: new Ov(1118481)
      },
      shininess: {
        value: 30
      },
      envMapIntensity: {
        value: 1
      }
    }]),
    vertexShader: SS.meshphong_vert,
    fragmentShader: SS.meshphong_frag
  },
  standard: {
    uniforms: Yb([Z.common, Z.envmap, Z.aomap, Z.lightmap, Z.emissivemap, Z.bumpmap, Z.normalmap, Z.displacementmap, Z.roughnessmap, Z.metalnessmap, Z.fog, Z.lights, {
      emissive: {
        value: new Ov(0)
      },
      roughness: {
        value: 1
      },
      metalness: {
        value: 0
      },
      envMapIntensity: {
        value: 1
      }
    }]),
    vertexShader: SS.meshphysical_vert,
    fragmentShader: SS.meshphysical_frag
  },
  toon: {
    uniforms: Yb([Z.common, Z.aomap, Z.lightmap, Z.emissivemap, Z.bumpmap, Z.normalmap, Z.displacementmap, Z.gradientmap, Z.fog, Z.lights, {
      emissive: {
        value: new Ov(0)
      }
    }]),
    vertexShader: SS.meshtoon_vert,
    fragmentShader: SS.meshtoon_frag
  },
  matcap: {
    uniforms: Yb([Z.common, Z.bumpmap, Z.normalmap, Z.displacementmap, Z.fog, {
      matcap: {
        value: null
      }
    }]),
    vertexShader: SS.meshmatcap_vert,
    fragmentShader: SS.meshmatcap_frag
  },
  points: {
    uniforms: Yb([Z.points, Z.fog]),
    vertexShader: SS.points_vert,
    fragmentShader: SS.points_frag
  },
  dashed: {
    uniforms: Yb([Z.common, Z.fog, {
      scale: {
        value: 1
      },
      dashSize: {
        value: 1
      },
      totalSize: {
        value: 2
      }
    }]),
    vertexShader: SS.linedashed_vert,
    fragmentShader: SS.linedashed_frag
  },
  depth: {
    uniforms: Yb([Z.common, Z.displacementmap]),
    vertexShader: SS.depth_vert,
    fragmentShader: SS.depth_frag
  },
  normal: {
    uniforms: Yb([Z.common, Z.bumpmap, Z.normalmap, Z.displacementmap, {
      opacity: {
        value: 1
      }
    }]),
    vertexShader: SS.meshnormal_vert,
    fragmentShader: SS.meshnormal_frag
  },
  sprite: {
    uniforms: Yb([Z.sprite, Z.fog]),
    vertexShader: SS.sprite_vert,
    fragmentShader: SS.sprite_frag
  },
  background: {
    uniforms: {
      uvTransform: {
        value: new E_()
      },
      t2D: {
        value: null
      },
      backgroundIntensity: {
        value: 1
      }
    },
    vertexShader: SS.background_vert,
    fragmentShader: SS.background_frag
  },
  backgroundCube: {
    uniforms: {
      envMap: {
        value: null
      },
      backgroundBlurriness: {
        value: 0
      },
      backgroundIntensity: {
        value: 1
      },
      backgroundRotation: {
        value: new E_()
      }
    },
    vertexShader: SS.backgroundCube_vert,
    fragmentShader: SS.backgroundCube_frag
  },
  cube: {
    uniforms: {
      tCube: {
        value: null
      },
      tFlip: {
        value: -1
      },
      opacity: {
        value: 1
      }
    },
    vertexShader: SS.cube_vert,
    fragmentShader: SS.cube_frag
  },
  equirect: {
    uniforms: {
      tEquirect: {
        value: null
      }
    },
    vertexShader: SS.equirect_vert,
    fragmentShader: SS.equirect_frag
  },
  distance: {
    uniforms: Yb([Z.common, Z.displacementmap, {
      referencePosition: {
        value: new X()
      },
      nearDistance: {
        value: 1
      },
      farDistance: {
        value: 1000
      }
    }]),
    vertexShader: SS.distance_vert,
    fragmentShader: SS.distance_frag
  },
  shadow: {
    uniforms: Yb([Z.lights, Z.fog, {
      color: {
        value: new Ov(0)
      },
      opacity: {
        value: 1
      }
    }]),
    vertexShader: SS.shadow_vert,
    fragmentShader: SS.shadow_frag
  }
};
CS.physical = {
  uniforms: Yb([CS.standard.uniforms, {
    clearcoat: {
      value: 0
    },
    clearcoatMap: {
      value: null
    },
    clearcoatMapTransform: {
      value: new E_()
    },
    clearcoatNormalMap: {
      value: null
    },
    clearcoatNormalMapTransform: {
      value: new E_()
    },
    clearcoatNormalScale: {
      value: new S_(1, 1)
    },
    clearcoatRoughness: {
      value: 0
    },
    clearcoatRoughnessMap: {
      value: null
    },
    clearcoatRoughnessMapTransform: {
      value: new E_()
    },
    dispersion: {
      value: 0
    },
    retroreflectivity: {
      value: 0
    },
    iridescence: {
      value: 0
    },
    iridescenceMap: {
      value: null
    },
    iridescenceMapTransform: {
      value: new E_()
    },
    iridescenceIOR: {
      value: 1.3
    },
    iridescenceThicknessMinimum: {
      value: 100
    },
    iridescenceThicknessMaximum: {
      value: 400
    },
    iridescenceThicknessMap: {
      value: null
    },
    iridescenceThicknessMapTransform: {
      value: new E_()
    },
    sheen: {
      value: 0
    },
    sheenColor: {
      value: new Ov(0)
    },
    sheenColorMap: {
      value: null
    },
    sheenColorMapTransform: {
      value: new E_()
    },
    sheenRoughness: {
      value: 1
    },
    sheenRoughnessMap: {
      value: null
    },
    sheenRoughnessMapTransform: {
      value: new E_()
    },
    transmission: {
      value: 0
    },
    transmissionMap: {
      value: null
    },
    transmissionMapTransform: {
      value: new E_()
    },
    transmissionSamplerSize: {
      value: new S_()
    },
    transmissionSamplerMap: {
      value: null
    },
    thickness: {
      value: 0
    },
    thicknessMap: {
      value: null
    },
    thicknessMapTransform: {
      value: new E_()
    },
    attenuationDistance: {
      value: 0
    },
    attenuationColor: {
      value: new Ov(0)
    },
    specularColor: {
      value: new Ov(1, 1, 1)
    },
    specularColorMap: {
      value: null
    },
    specularColorMapTransform: {
      value: new E_()
    },
    specularIntensity: {
      value: 1
    },
    specularIntensityMap: {
      value: null
    },
    specularIntensityMapTransform: {
      value: new E_()
    },
    anisotropyVector: {
      value: new S_()
    },
    anisotropyMap: {
      value: null
    },
    anisotropyMapTransform: {
      value: new E_()
    }
  }]),
  vertexShader: SS.meshphysical_vert,
  fragmentShader: SS.meshphysical_frag
};
var wS = {
  r: 0,
  b: 0,
  g: 0
};
var TS = new q_();
var ES = new E_();
ES.set(-1, 0, 0, 0, 1, 0, 0, 0, 1);
function DS(e, t, n, r, i, a) {
  let o = new Ov(0);
  let s = i === true ? 0 : 1;
  let c;
  let l;
  let u = null;
  let d = 0;
  let f = null;
  function p(e) {
    let n = e.isScene === true ? e.background : null;
    if (n && n.isTexture) {
      let r = e.backgroundBlurriness > 0;
      n = t.get(n, r);
    }
    return n;
  }
  function m(t) {
    let r = false;
    let i = p(t);
    if (i === null) {
      g(o, s);
    } else if (i && i.isColor) {
      g(i, 1);
      r = true;
    }
    let c = e.xr.getEnvironmentBlendMode();
    if (c === `additive`) {
      n.buffers.color.setClear(0, 0, 0, 1, a);
    } else if (c === `alpha-blend`) {
      n.buffers.color.setClear(0, 0, 0, 0, a);
    }
    if (e.autoClear || r) {
      n.buffers.depth.setTest(true);
      n.buffers.depth.setMask(true);
      n.buffers.color.setMask(true);
      e.clear(e.autoClearColor, e.autoClearDepth, e.autoClearStencil);
    }
  }
  function h(t, n) {
    let i = p(n);
    if (i && (i.isCubeTexture || i.mapping === 306)) {
      if (l === undefined) {
        l = new pb(new zb(1, 1, 1), new nx({
          name: `BackgroundCubeMaterial`,
          uniforms: Jb(CS.backgroundCube.uniforms),
          vertexShader: CS.backgroundCube.vertexShader,
          fragmentShader: CS.backgroundCube.fragmentShader,
          side: 1,
          depthTest: false,
          depthWrite: false,
          fog: false,
          allowOverride: false
        }));
        l.geometry.deleteAttribute(`normal`);
        l.geometry.deleteAttribute(`uv`);
        l.onBeforeRender = function (e, t, n) {
          this.matrixWorld.copyPosition(n.matrixWorld);
        };
        Object.defineProperty(l.material, "envMap", {
          get: function () {
            return this.uniforms.envMap.value;
          }
        });
        r.update(l);
      }
      l.material.uniforms.envMap.value = i;
      l.material.uniforms.backgroundBlurriness.value = n.backgroundBlurriness;
      l.material.uniforms.backgroundIntensity.value = n.backgroundIntensity;
      l.material.uniforms.backgroundRotation.value.setFromMatrix4(TS.makeRotationFromEuler(n.backgroundRotation)).transpose();
      if (i.isCubeTexture && i.isRenderTargetTexture === false) {
        l.material.uniforms.backgroundRotation.value.premultiply(ES);
      }
      l.material.toneMapped = j_.getTransfer(i.colorSpace) !== Mg;
      if (u !== i || d !== i.version || f !== e.toneMapping) {
        l.material.needsUpdate = true;
        u = i;
        d = i.version;
        f = e.toneMapping;
      }
      l.layers.enableAll();
      t.unshift(l, l.geometry, l.material, 0, 0, null);
    } else if (i && i.isTexture) {
      if (c === undefined) {
        c = new pb(new Kb(2, 2), new nx({
          name: `BackgroundMaterial`,
          uniforms: Jb(CS.background.uniforms),
          vertexShader: CS.background.vertexShader,
          fragmentShader: CS.background.fragmentShader,
          side: 0,
          depthTest: false,
          depthWrite: false,
          fog: false,
          allowOverride: false
        }));
        c.geometry.deleteAttribute(`normal`);
        Object.defineProperty(c.material, "map", {
          get: function () {
            return this.uniforms.t2D.value;
          }
        });
        r.update(c);
      }
      c.material.uniforms.t2D.value = i;
      c.material.uniforms.backgroundIntensity.value = n.backgroundIntensity;
      c.material.toneMapped = j_.getTransfer(i.colorSpace) !== Mg;
      if (i.matrixAutoUpdate === true) {
        i.updateMatrix();
      }
      c.material.uniforms.uvTransform.value.copy(i.matrix);
      if (u !== i || d !== i.version || f !== e.toneMapping) {
        c.material.needsUpdate = true;
        u = i;
        d = i.version;
        f = e.toneMapping;
      }
      c.layers.enableAll();
      t.unshift(c, c.geometry, c.material, 0, 0, null);
    }
  }
  function g(t, r) {
    t.getRGB(wS, Qb(e));
    n.buffers.color.setClear(wS.r, wS.g, wS.b, r, a);
  }
  function _() {
    if (l !== undefined) {
      l.geometry.dispose();
      l.material.dispose();
      l = undefined;
    }
    if (c !== undefined) {
      c.geometry.dispose();
      c.material.dispose();
      c = undefined;
    }
  }
  return {
    getClearColor: function () {
      return o;
    },
    setClearColor: function (e, t = 1) {
      o.set(e);
      s = t;
      g(o, s);
    },
    getClearAlpha: function () {
      return s;
    },
    setClearAlpha: function (e) {
      s = e;
      g(o, s);
    },
    render: m,
    addToRenderList: h,
    dispose: _
  };
}
function OS(e, t) {
  let n = e.getParameter(e.MAX_VERTEX_ATTRIBS);
  let r = {};
  let i = f(null);
  let a = i;
  let o = false;
  function s(n, r, i, s, c) {
    let u = false;
    let f = d(n, s, i, r);
    if (a !== f) {
      a = f;
      l(a.object);
    }
    u = p(n, s, i, c);
    if (u) {
      m(n, s, i, c);
    }
    if (c !== null) {
      t.update(c, e.ELEMENT_ARRAY_BUFFER);
    }
    if (u || o) {
      o = false;
      b(n, r, i, s);
      if (c !== null) {
        e.bindBuffer(e.ELEMENT_ARRAY_BUFFER, t.get(c).buffer);
      }
    }
  }
  function c() {
    return e.createVertexArray();
  }
  function l(t) {
    return e.bindVertexArray(t);
  }
  function u(t) {
    return e.deleteVertexArray(t);
  }
  function d(e, t, n, i) {
    let a = i.wireframe === true;
    let o = r[t.id];
    if (o === undefined) {
      o = {};
      r[t.id] = o;
    }
    let s = e.isInstancedMesh === true ? e.id : 0;
    let l = o[s];
    if (l === undefined) {
      l = {};
      o[s] = l;
    }
    let u = l[n.id];
    if (u === undefined) {
      u = {};
      l[n.id] = u;
    }
    let d = u[a];
    if (d === undefined) {
      d = f(c());
      u[a] = d;
    }
    return d;
  }
  function f(e) {
    let t = [];
    let r = [];
    let i = [];
    for (let e = 0; e < n; e++) {
      t[e] = 0;
      r[e] = 0;
      i[e] = 0;
    }
    return {
      geometry: null,
      program: null,
      wireframe: false,
      newAttributes: t,
      enabledAttributes: r,
      attributeDivisors: i,
      object: e,
      attributes: {},
      index: null
    };
  }
  function p(e, t, n, r) {
    let i = a.attributes;
    let o = t.attributes;
    let s = 0;
    let c = n.getAttributes();
    for (let t in c) {
      if (c[t].location >= 0) {
        let n = i[t];
        let r = o[t];
        if (r === undefined) {
          if (t === `instanceMatrix` && e.instanceMatrix) {
            r = e.instanceMatrix;
          }
          if (t === `instanceColor` && e.instanceColor) {
            r = e.instanceColor;
          }
        }
        if (n === undefined || n.attribute !== r || r && n.data !== r.data) {
          return true;
        }
        s++;
      }
    }
    return a.attributesNum !== s || a.index !== r;
  }
  function m(e, t, n, r) {
    let i = {};
    let o = t.attributes;
    let s = 0;
    let c = n.getAttributes();
    for (let t in c) {
      if (c[t].location >= 0) {
        let n = o[t];
        if (n === undefined) {
          if (t === `instanceMatrix` && e.instanceMatrix) {
            n = e.instanceMatrix;
          }
          if (t === `instanceColor` && e.instanceColor) {
            n = e.instanceColor;
          }
        }
        let r = {
          attribute: n
        };
        if (n && n.data) {
          r.data = n.data;
        }
        i[t] = r;
        s++;
      }
    }
    a.attributes = i;
    a.attributesNum = s;
    a.index = r;
  }
  function h() {
    let e = a.newAttributes;
    for (let t = 0, n = e.length; t < n; t++) {
      e[t] = 0;
    }
  }
  function g(e) {
    _(e, 0);
  }
  function _(t, n) {
    let r = a.newAttributes;
    let i = a.enabledAttributes;
    let o = a.attributeDivisors;
    r[t] = 1;
    if (i[t] === 0) {
      e.enableVertexAttribArray(t);
      i[t] = 1;
    }
    if (o[t] !== n) {
      e.vertexAttribDivisor(t, n);
      o[t] = n;
    }
  }
  function v() {
    let t = a.newAttributes;
    let n = a.enabledAttributes;
    for (let r = 0, i = n.length; r < i; r++) {
      if (n[r] !== t[r]) {
        e.disableVertexAttribArray(r);
        n[r] = 0;
      }
    }
  }
  function y(t, n, r, i, a, o, s) {
    if (s === true) {
      e.vertexAttribIPointer(t, n, r, a, o);
    } else {
      e.vertexAttribPointer(t, n, r, i, a, o);
    }
  }
  function b(n, r, i, a) {
    h();
    let o = a.attributes;
    let s = i.getAttributes();
    let c = r.defaultAttributeValues;
    for (let r in s) {
      let i = s[r];
      if (i.location >= 0) {
        let s = o[r];
        if (s === undefined) {
          if (r === `instanceMatrix` && n.instanceMatrix) {
            s = n.instanceMatrix;
          }
          if (r === `instanceColor` && n.instanceColor) {
            s = n.instanceColor;
          }
        }
        if (s !== undefined) {
          let r = s.normalized;
          let o = s.itemSize;
          let c = t.get(s);
          if (c === undefined) {
            continue;
          }
          let l = c.buffer;
          let u = c.type;
          let d = c.bytesPerElement;
          let f = u === e.INT || u === e.UNSIGNED_INT || s.gpuType === 1013;
          if (s.isInterleavedBufferAttribute) {
            let t = s.data;
            let c = t.stride;
            let p = s.offset;
            if (t.isInstancedInterleavedBuffer) {
              for (let e = 0; e < i.locationSize; e++) {
                _(i.location + e, t.meshPerAttribute);
              }
              if (n.isInstancedMesh !== true && a._maxInstanceCount === undefined) {
                a._maxInstanceCount = t.meshPerAttribute * t.count;
              }
            } else {
              for (let e = 0; e < i.locationSize; e++) {
                g(i.location + e);
              }
            }
            e.bindBuffer(e.ARRAY_BUFFER, l);
            for (let e = 0; e < i.locationSize; e++) {
              y(i.location + e, o / i.locationSize, u, r, c * d, (p + o / i.locationSize * e) * d, f);
            }
          } else {
            if (s.isInstancedBufferAttribute) {
              for (let e = 0; e < i.locationSize; e++) {
                _(i.location + e, s.meshPerAttribute);
              }
              if (n.isInstancedMesh !== true && a._maxInstanceCount === undefined) {
                a._maxInstanceCount = s.meshPerAttribute * s.count;
              }
            } else {
              for (let e = 0; e < i.locationSize; e++) {
                g(i.location + e);
              }
            }
            e.bindBuffer(e.ARRAY_BUFFER, l);
            for (let e = 0; e < i.locationSize; e++) {
              y(i.location + e, o / i.locationSize, u, r, o * d, o / i.locationSize * e * d, f);
            }
          }
        } else if (c !== undefined) {
          let t = c[r];
          if (t !== undefined) {
            switch (t.length) {
              case 2:
                e.vertexAttrib2fv(i.location, t);
                break;
              case 3:
                e.vertexAttrib3fv(i.location, t);
                break;
              case 4:
                e.vertexAttrib4fv(i.location, t);
                break;
              default:
                e.vertexAttrib1fv(i.location, t);
            }
          }
        }
      }
    }
    v();
  }
  function x() {
    T();
    for (let e in r) {
      let t = r[e];
      for (let e in t) {
        let n = t[e];
        for (let e in n) {
          let t = n[e];
          for (let e in t) {
            u(t[e].object);
            delete t[e];
          }
          delete n[e];
        }
      }
      delete r[e];
    }
  }
  function S(e) {
    if (r[e.id] === undefined) {
      return;
    }
    let t = r[e.id];
    for (let e in t) {
      let n = t[e];
      for (let e in n) {
        let t = n[e];
        for (let e in t) {
          u(t[e].object);
          delete t[e];
        }
        delete n[e];
      }
    }
    delete r[e.id];
  }
  function C(e) {
    for (let t in r) {
      let n = r[t];
      for (let t in n) {
        let r = n[t];
        if (r[e.id] === undefined) {
          continue;
        }
        let i = r[e.id];
        for (let e in i) {
          u(i[e].object);
          delete i[e];
        }
        delete r[e.id];
      }
    }
  }
  function w(e) {
    for (let t in r) {
      let n = r[t];
      let i = e.isInstancedMesh === true ? e.id : 0;
      let a = n[i];
      if (a !== undefined) {
        for (let e in a) {
          let t = a[e];
          for (let e in t) {
            u(t[e].object);
            delete t[e];
          }
          delete a[e];
        }
        delete n[i];
        if (Object.keys(n).length === 0) {
          delete r[t];
        }
      }
    }
  }
  function T() {
    E();
    o = true;
    if (a !== i) {
      a = i;
      l(a.object);
    }
  }
  function E() {
    i.geometry = null;
    i.program = null;
    i.wireframe = false;
  }
  return {
    setup: s,
    reset: T,
    resetDefaultState: E,
    dispose: x,
    releaseStatesOfGeometry: S,
    releaseStatesOfObject: w,
    releaseStatesOfProgram: C,
    initAttributes: h,
    enableAttribute: g,
    disableUnusedAttributes: v
  };
}
function kS(e, t, n) {
  let r;
  function i(e) {
    r = e;
  }
  function a(t, i) {
    e.drawArrays(r, t, i);
    n.update(i, r, 1);
  }
  function o(t, i, a) {
    if (a !== 0) {
      e.drawArraysInstanced(r, t, i, a);
      n.update(i, r, a);
    }
  }
  function s(e, i, a) {
    if (a === 0) {
      return;
    }
    t.get(`WEBGL_multi_draw`).multiDrawArraysWEBGL(r, e, 0, i, 0, a);
    let o = 0;
    for (let e = 0; e < a; e++) {
      o += i[e];
    }
    n.update(o, r, 1);
  }
  this.setMode = i;
  this.render = a;
  this.renderInstances = o;
  this.renderMultiDraw = s;
}
function AS(e, t, n, r) {
  let i;
  function a() {
    if (i !== undefined) {
      return i;
    }
    if (t.has(`EXT_texture_filter_anisotropic`) === true) {
      let n = t.get(`EXT_texture_filter_anisotropic`);
      i = e.getParameter(n.MAX_TEXTURE_MAX_ANISOTROPY_EXT);
    } else {
      i = 0;
    }
    return i;
  }
  function o(t) {
    return t === 1023 || r.convert(t) === e.getParameter(e.IMPLEMENTATION_COLOR_READ_FORMAT);
  }
  function s(n) {
    let i = n === 1016 && (t.has(`EXT_color_buffer_half_float`) || t.has(`EXT_color_buffer_float`));
    return n === 1009 || n === 1015 || !!i || r.convert(n) === e.getParameter(e.IMPLEMENTATION_COLOR_READ_TYPE);
  }
  function c(t) {
    if (t === `highp`) {
      if (e.getShaderPrecisionFormat(e.VERTEX_SHADER, e.HIGH_FLOAT).precision > 0 && e.getShaderPrecisionFormat(e.FRAGMENT_SHADER, e.HIGH_FLOAT).precision > 0) {
        return `highp`;
      }
      t = `mediump`;
    }
    if (t === `mediump` && e.getShaderPrecisionFormat(e.VERTEX_SHADER, e.MEDIUM_FLOAT).precision > 0 && e.getShaderPrecisionFormat(e.FRAGMENT_SHADER, e.MEDIUM_FLOAT).precision > 0) {
      return `mediump`;
    } else {
      return `lowp`;
    }
  }
  let l = n.precision === undefined ? `highp` : n.precision;
  let u = c(l);
  if (u !== l) {
    Ug(`WebGLRenderer:`, l, `not supported, using`, u, `instead.`);
    l = u;
  }
  let d = n.logarithmicDepthBuffer === true;
  let f = n.reversedDepthBuffer === true && t.has(`EXT_clip_control`);
  if (n.reversedDepthBuffer === true && f === false) {
    Ug(`WebGLRenderer: Unable to use reversed depth buffer due to missing EXT_clip_control extension. Fallback to default depth buffer.`);
  }
  let p = e.getParameter(e.MAX_TEXTURE_IMAGE_UNITS);
  let m = e.getParameter(e.MAX_VERTEX_TEXTURE_IMAGE_UNITS);
  let h = e.getParameter(e.MAX_TEXTURE_SIZE);
  let g = e.getParameter(e.MAX_CUBE_MAP_TEXTURE_SIZE);
  let _ = e.getParameter(e.MAX_VERTEX_ATTRIBS);
  let v = e.getParameter(e.MAX_VERTEX_UNIFORM_VECTORS);
  let y = e.getParameter(e.MAX_VARYING_VECTORS);
  let b = e.getParameter(e.MAX_FRAGMENT_UNIFORM_VECTORS);
  let x = e.getParameter(e.MAX_SAMPLES);
  let S = e.getParameter(e.SAMPLES);
  return {
    isWebGL2: true,
    getMaxAnisotropy: a,
    getMaxPrecision: c,
    textureFormatReadable: o,
    textureTypeReadable: s,
    precision: l,
    logarithmicDepthBuffer: d,
    reversedDepthBuffer: f,
    maxTextures: p,
    maxVertexTextures: m,
    maxTextureSize: h,
    maxCubemapSize: g,
    maxAttributes: _,
    maxVertexUniforms: v,
    maxVaryings: y,
    maxFragmentUniforms: b,
    maxSamples: x,
    samples: S
  };
}
function jS(e) {
  let t = this;
  let n = null;
  let r = 0;
  let i = false;
  let a = false;
  let o = new jy();
  let s = new E_();
  let c = {
    value: null,
    needsUpdate: false
  };
  this.uniform = c;
  this.numPlanes = 0;
  this.numIntersection = 0;
  this.init = function (e, t) {
    let n = e.length !== 0 || t || r !== 0 || i;
    i = t;
    r = e.length;
    return n;
  };
  this.beginShadows = function () {
    a = true;
    u(null);
  };
  this.endShadows = function () {
    a = false;
  };
  this.setGlobalState = function (e, t) {
    n = u(e, t, 0);
  };
  this.setState = function (t, o, s) {
    let d = t.clippingPlanes;
    let f = t.clipIntersection;
    let p = t.clipShadows;
    let m = e.get(t);
    if (!i || d === null || d.length === 0 || a && !p) {
      if (a) {
        u(null);
      } else {
        l();
      }
    } else {
      let e = a ? 0 : r;
      let t = e * 4;
      let i = m.clippingState || null;
      c.value = i;
      i = u(d, o, t, s);
      for (let e = 0; e !== t; ++e) {
        i[e] = n[e];
      }
      m.clippingState = i;
      this.numIntersection = f ? this.numPlanes : 0;
      this.numPlanes += e;
    }
  };
  function l() {
    if (c.value !== n) {
      c.value = n;
      c.needsUpdate = r > 0;
    }
    t.numPlanes = r;
    t.numIntersection = 0;
  }
  function u(e, n, r, i) {
    let a = e === null ? 0 : e.length;
    let l = null;
    if (a !== 0) {
      l = c.value;
      if (i !== true || l === null) {
        let t = r + a * 4;
        let i = n.matrixWorldInverse;
        s.getNormalMatrix(i);
        if (l === null || l.length < t) {
          l = new Float32Array(t);
        }
        for (let t = 0, n = r; t !== a; ++t, n += 4) {
          o.copy(e[t]).applyMatrix4(i, s);
          o.normal.toArray(l, n);
          l[n + 3] = o.constant;
        }
      }
      c.value = l;
      c.needsUpdate = true;
    }
    t.numPlanes = a;
    t.numIntersection = 0;
    return l;
  }
}
var MS = 4;
var NS = 6;
var PS = 20;
var FS = 256;
var IS = new qx();
var LS = new Ov();
var RS = null;
var zS = 0;
var BS = 0;
var VS = false;
var HS = new X();
var US = new X();
var WS = class {
  constructor(e) {
    this._renderer = e;
    this._pingPongRenderTarget = null;
    this._lodMax = 0;
    this._cubeSize = 0;
    this._sizeLods = [];
    this._lodMeshes = [];
    this._backgroundBox = null;
    this._cubemapMaterial = null;
    this._equirectMaterial = null;
    this._blurMaterial = null;
    this._ggxMaterial = null;
  }
  fromScene(e, t = 0, n = 0.1, r = 100, i = {}) {
    let {
      size: a = 256,
      position: o = HS
    } = i;
    RS = this._renderer.getRenderTarget();
    zS = this._renderer.getActiveCubeFace();
    BS = this._renderer.getActiveMipmapLevel();
    VS = this._renderer.xr.enabled;
    this._renderer.xr.enabled = false;
    this._setSize(a);
    let s = this._allocateTargets();
    s.depthBuffer = true;
    this._sceneToCubeUV(e, n, r, s, o);
    if (t > 0) {
      this._blur(s, 0, 0, t);
    }
    this._applyPMREM(s);
    this._cleanup(s);
    return s;
  }
  fromEquirectangular(e, t = null) {
    return this._fromTexture(e, t);
  }
  fromCubemap(e, t = null) {
    return this._fromTexture(e, t);
  }
  compileCubemapShader() {
    if (this._cubemapMaterial === null) {
      this._cubemapMaterial = ZS();
      this._compileMaterial(this._cubemapMaterial);
    }
  }
  compileEquirectangularShader() {
    if (this._equirectMaterial === null) {
      this._equirectMaterial = XS();
      this._compileMaterial(this._equirectMaterial);
    }
  }
  dispose() {
    this._dispose();
    if (this._cubemapMaterial !== null) {
      this._cubemapMaterial.dispose();
    }
    if (this._equirectMaterial !== null) {
      this._equirectMaterial.dispose();
    }
    if (this._backgroundBox !== null) {
      this._backgroundBox.geometry.dispose();
      this._backgroundBox.material.dispose();
    }
  }
  _setSize(e) {
    this._lodMax = Math.floor(Math.log2(e));
    this._cubeSize = 2 ** this._lodMax;
  }
  _dispose() {
    if (this._blurMaterial !== null) {
      this._blurMaterial.dispose();
    }
    if (this._ggxMaterial !== null) {
      this._ggxMaterial.dispose();
    }
    if (this._pingPongRenderTarget !== null) {
      this._pingPongRenderTarget.dispose();
    }
    for (let e = 0; e < this._lodMeshes.length; e++) {
      this._lodMeshes[e].geometry.dispose();
    }
  }
  _cleanup(e) {
    this._renderer.setRenderTarget(RS, zS, BS);
    this._renderer.xr.enabled = VS;
    e.scissorTest = false;
    qS(e, 0, 0, e.width, e.height);
  }
  _fromTexture(e, t) {
    if (e.mapping === 301 || e.mapping === 302) {
      this._setSize(e.image.length === 0 ? 16 : e.image[0].width || e.image[0].image.width);
    } else {
      this._setSize(e.image.width / 4);
    }
    RS = this._renderer.getRenderTarget();
    zS = this._renderer.getActiveCubeFace();
    BS = this._renderer.getActiveMipmapLevel();
    VS = this._renderer.xr.enabled;
    this._renderer.xr.enabled = false;
    let n = t || this._allocateTargets();
    this._textureToCubeUV(e, n);
    this._applyPMREM(n);
    this._cleanup(n);
    return n;
  }
  _allocateTargets() {
    let e = Math.max(this._cubeSize, 112) * 3;
    let t = this._cubeSize * 4;
    let n = {
      magFilter: ph,
      minFilter: ph,
      generateMipmaps: false,
      type: Ch,
      format: jh,
      colorSpace: Ag,
      depthBuffer: false
    };
    let r = KS(e, t, n);
    if (this._pingPongRenderTarget === null || this._pingPongRenderTarget.width !== e || this._pingPongRenderTarget.height !== t) {
      if (this._pingPongRenderTarget !== null) {
        this._dispose();
      }
      this._pingPongRenderTarget = KS(e, t, n);
      let {
        _lodMax: r
      } = this;
      ({
        lodMeshes: this._lodMeshes,
        sizeLods: this._sizeLods
      } = GS(r));
      this._blurMaterial = YS(r, e, t);
      this._ggxMaterial = JS(r, e, t);
    }
    return r;
  }
  _compileMaterial(e) {
    let t = new pb(new wy(), e);
    this._renderer.compile(t, IS);
  }
  _sceneToCubeUV(e, t, n, r, i) {
    let a = new Kx(90, 1, t, n);
    let o = [1, -1, 1, 1, 1, 1];
    let s = [1, 1, 1, -1, -1, -1];
    let c = this._renderer;
    let l = c.autoClear;
    let u = c.toneMapping;
    c.getClearColor(LS);
    c.toneMapping = 0;
    c.autoClear = false;
    if (c.state.buffers.depth.getReversed()) {
      c.setRenderTarget(r);
      c.clearDepth();
      c.setRenderTarget(null);
    }
    if (this._backgroundBox === null) {
      this._backgroundBox = new pb(new zb(), new tb({
        name: `PMREM.Background`,
        side: 1,
        depthWrite: false,
        depthTest: false
      }));
    }
    let d = this._backgroundBox;
    let f = d.material;
    let p = false;
    let m = e.background;
    if (m) {
      if (m.isColor) {
        f.color.copy(m);
        e.background = null;
        p = true;
      }
    } else {
      f.color.copy(LS);
      p = true;
    }
    for (let t = 0; t < 6; t++) {
      let n = t % 3;
      if (n === 0) {
        a.up.set(0, o[t], 0);
        a.position.set(i.x, i.y, i.z);
        a.lookAt(i.x + s[t], i.y, i.z);
      } else if (n === 1) {
        a.up.set(0, 0, o[t]);
        a.position.set(i.x, i.y, i.z);
        a.lookAt(i.x, i.y + s[t], i.z);
      } else {
        a.up.set(0, o[t], 0);
        a.position.set(i.x, i.y, i.z);
        a.lookAt(i.x, i.y, i.z + s[t]);
      }
      let l = this._cubeSize;
      qS(r, n * l, t > 2 ? l : 0, l, l);
      c.setRenderTarget(r);
      if (p) {
        c.render(d, a);
      }
      c.render(e, a);
    }
    c.toneMapping = u;
    c.autoClear = l;
    e.background = m;
  }
  _textureToCubeUV(e, t) {
    let n = this._renderer;
    let r = e.mapping === 301 || e.mapping === 302;
    if (r) {
      if (this._cubemapMaterial === null) {
        this._cubemapMaterial = ZS();
      }
      this._cubemapMaterial.uniforms.flipEnvMap.value = e.isRenderTargetTexture === false ? -1 : 1;
    } else if (this._equirectMaterial === null) {
      this._equirectMaterial = XS();
    }
    let i = r ? this._cubemapMaterial : this._equirectMaterial;
    let a = this._lodMeshes[0];
    a.material = i;
    let o = i.uniforms;
    o.envMap.value = e;
    let s = this._cubeSize;
    qS(t, 0, 0, s * 3, s * 2);
    n.setRenderTarget(t);
    n.render(a, IS);
  }
  _applyPMREM(e) {
    let t = this._renderer;
    let n = t.autoClear;
    t.autoClear = false;
    let r = this._lodMeshes.length;
    for (let t = 1; t < r; t++) {
      this._applyGGXFilter(e, t - 1, t);
    }
    t.autoClear = n;
  }
  _applyGGXFilter(e, t, n) {
    let r = this._renderer;
    let i = this._pingPongRenderTarget;
    let a = this._ggxMaterial;
    let o = this._lodMeshes[n];
    o.material = a;
    let s = a.uniforms;
    let c = n / (this._lodMeshes.length - 1);
    let l = t / (this._lodMeshes.length - 1);
    let u = Math.sqrt(c * c - l * l) * (c * 1.25);
    let {
      _lodMax: d
    } = this;
    let f = this._sizeLods[n];
    let p = f * 3 * (n > d - MS ? n - d + MS : 0);
    let m = (this._cubeSize - f) * 4;
    s.envMap.value = e.texture;
    s.roughness.value = u;
    s.mipInt.value = d - t;
    qS(i, p, m, f * 3, f * 2);
    r.setRenderTarget(i);
    r.render(o, IS);
    s.envMap.value = i.texture;
    s.roughness.value = 0;
    s.mipInt.value = d - n;
    qS(e, p, m, f * 3, f * 2);
    r.setRenderTarget(e);
    r.render(o, IS);
  }
  _blur(e, t, n, r) {
    let i = this._pingPongRenderTarget;
    let a = Math.min(r, Math.PI) / Math.SQRT2;
    this._blurPass(e, i, t, n, a);
    this._blurPass(i, e, n, n, a);
  }
  _blurPass(e, t, n, r, i) {
    let a = this._renderer;
    let o = this._blurMaterial;
    let s = this._lodMeshes[r];
    s.material = o;
    let c = o.uniforms;
    c.envMap.value = e.texture;
    c.sigma.value = i;
    c.mipInt.value = this._lodMax - n;
    let l = this._sizeLods[r];
    qS(t, l * 3 * (r > this._lodMax - MS ? r - this._lodMax + MS : 0), (this._cubeSize - l) * 4, l * 3, l * 2);
    a.setRenderTarget(t);
    a.render(s, IS);
  }
};
function GS(e) {
  let t = [];
  let n = [];
  let r = e;
  let i = e - MS + 1 + NS;
  for (let e = 0; e < i; e++) {
    let e = 2 ** r;
    t.push(e);
    let i = 1 / (e - 2);
    let a = -i;
    let o = 1 + i;
    let s = [a, a, o, a, o, o, a, a, o, o, a, o];
    let c = new Float32Array(108);
    let l = new Float32Array(108);
    for (let e = 0; e < 6; e++) {
      let t = e % 3 * 2 / 3 - 1;
      let n = e > 2 ? 0 : -1;
      let r = [t, n, 0, t + 2 / 3, n, 0, t + 2 / 3, n + 1, 0, t, n, 0, t + 2 / 3, n + 1, 0, t, n + 1, 0];
      c.set(r, e * 18);
      for (let t = 0; t < 6; t++) {
        let n = s[t * 2] * 2 - 1;
        let r = s[t * 2 + 1] * 2 - 1;
        if (e === 0) {
          US.set(1, r, n);
        } else if (e === 1) {
          US.set(-n, 1, -r);
        } else if (e === 2) {
          US.set(-n, r, 1);
        } else if (e === 3) {
          US.set(-1, r, -n);
        } else if (e === 4) {
          US.set(-n, -1, r);
        } else {
          US.set(n, r, -1);
        }
        US.toArray(l, (e * 6 + t) * 3);
      }
    }
    let u = new wy();
    u.setAttribute(`position`, new ly(c, 3));
    u.setAttribute(`outputDirection`, new ly(l, 3));
    n.push(new pb(u, null));
    if (r > MS) {
      r--;
    }
  }
  return {
    lodMeshes: n,
    sizeLods: t
  };
}
function KS(e, t, n) {
  let r = new W_(e, t, n);
  r.texture.mapping = 306;
  r.texture.name = `PMREM.cubeUv`;
  r.scissorTest = true;
  return r;
}
function qS(e, t, n, r, i) {
  e.viewport.set(t, n, r, i);
  e.scissor.set(t, n, r, i);
}
function JS(e, t, n) {
  return new nx({
    name: `PMREMGGXConvolution`,
    defines: {
      GGX_SAMPLES: FS,
      CUBEUV_TEXEL_WIDTH: 1 / t,
      CUBEUV_TEXEL_HEIGHT: 1 / n,
      CUBEUV_MAX_MIP: `${e}.0`
    },
    uniforms: {
      envMap: {
        value: null
      },
      roughness: {
        value: 0
      },
      mipInt: {
        value: 0
      }
    },
    vertexShader: QS(),
    fragmentShader: `

			precision highp float;
			precision highp int;

			varying vec3 vOutputDirection;

			uniform sampler2D envMap;
			uniform float roughness;
			uniform float mipInt;

			#define ENVMAP_TYPE_CUBE_UV
			#include <cube_uv_reflection_fragment>

			#define PI 3.14159265359

			// Van der Corput radical inverse
			float radicalInverse_VdC(uint bits) {
				bits = (bits << 16u) | (bits >> 16u);
				bits = ((bits & 0x55555555u) << 1u) | ((bits & 0xAAAAAAAAu) >> 1u);
				bits = ((bits & 0x33333333u) << 2u) | ((bits & 0xCCCCCCCCu) >> 2u);
				bits = ((bits & 0x0F0F0F0Fu) << 4u) | ((bits & 0xF0F0F0F0u) >> 4u);
				bits = ((bits & 0x00FF00FFu) << 8u) | ((bits & 0xFF00FF00u) >> 8u);
				return float(bits) * 2.3283064365386963e-10; // / 0x100000000
			}

			// Hammersley sequence
			vec2 hammersley(uint i, uint N) {
				return vec2(float(i) / float(N), radicalInverse_VdC(i));
			}

			// GGX VNDF importance sampling (Eric Heitz 2018)
			// "Sampling the GGX Distribution of Visible Normals"
			// https://jcgt.org/published/0007/04/01/
			vec3 importanceSampleGGX_VNDF(vec2 Xi, vec3 V, float roughness) {
				float alpha = roughness * roughness;

				// Section 4.1: Orthonormal basis
				vec3 T1 = vec3(1.0, 0.0, 0.0);
				vec3 T2 = cross(V, T1);

				// Section 4.2: Parameterization of projected area
				float r = sqrt(Xi.x);
				float phi = 2.0 * PI * Xi.y;
				float t1 = r * cos(phi);
				float t2 = r * sin(phi);
				float s = 0.5 * (1.0 + V.z);
				t2 = (1.0 - s) * sqrt(1.0 - t1 * t1) + s * t2;

				// Section 4.3: Reprojection onto hemisphere
				vec3 Nh = t1 * T1 + t2 * T2 + sqrt(max(0.0, 1.0 - t1 * t1 - t2 * t2)) * V;

				// Section 3.4: Transform back to ellipsoid configuration
				return normalize(vec3(alpha * Nh.x, alpha * Nh.y, max(0.0, Nh.z)));
			}

			void main() {
				vec3 N = normalize(vOutputDirection);
				vec3 V = N; // Assume view direction equals normal for pre-filtering

				vec3 prefilteredColor = vec3(0.0);
				float totalWeight = 0.0;

				// For very low roughness, just sample the environment directly
				if (roughness < 0.001) {
					gl_FragColor = vec4(bilinearCubeUV(envMap, N, mipInt), 1.0);
					return;
				}

				// Tangent space basis for VNDF sampling
				vec3 up = abs(N.z) < 0.999 ? vec3(0.0, 0.0, 1.0) : vec3(1.0, 0.0, 0.0);
				vec3 tangent = normalize(cross(up, N));
				vec3 bitangent = cross(N, tangent);

				for(uint i = 0u; i < uint(GGX_SAMPLES); i++) {
					vec2 Xi = hammersley(i, uint(GGX_SAMPLES));

					// For PMREM, V = N, so in tangent space V is always (0, 0, 1)
					vec3 H_tangent = importanceSampleGGX_VNDF(Xi, vec3(0.0, 0.0, 1.0), roughness);

					// Transform H back to world space
					vec3 H = normalize(tangent * H_tangent.x + bitangent * H_tangent.y + N * H_tangent.z);
					vec3 L = normalize(2.0 * dot(V, H) * H - V);

					float NdotL = max(dot(N, L), 0.0);

					if(NdotL > 0.0) {
						// Sample environment at fixed mip level
						// VNDF importance sampling handles the distribution filtering
						vec3 sampleColor = bilinearCubeUV(envMap, L, mipInt);

						// Weight by NdotL for the split-sum approximation
						// VNDF PDF naturally accounts for the visible microfacet distribution
						prefilteredColor += sampleColor * NdotL;
						totalWeight += NdotL;
					}
				}

				if (totalWeight > 0.0) {
					prefilteredColor = prefilteredColor / totalWeight;
				}

				gl_FragColor = vec4(prefilteredColor, 1.0);
			}
		`,
    blending: 0,
    depthTest: false,
    depthWrite: false
  });
}
function YS(e, t, n) {
  return new nx({
    name: `SphericalGaussianBlur`,
    defines: {
      SAMPLES: PS,
      CUBEUV_TEXEL_WIDTH: 1 / t,
      CUBEUV_TEXEL_HEIGHT: 1 / n,
      CUBEUV_MAX_MIP: `${e}.0`
    },
    uniforms: {
      envMap: {
        value: null
      },
      sigma: {
        value: 0
      },
      mipInt: {
        value: 0
      }
    },
    vertexShader: QS(),
    fragmentShader: `

			precision highp float;
			precision highp int;

			varying vec3 vOutputDirection;

			uniform sampler2D envMap;
			uniform float sigma;
			uniform float mipInt;

			#define ENVMAP_TYPE_CUBE_UV
			#include <cube_uv_reflection_fragment>

			#define PI 3.14159265359
			#define GOLDEN_ANGLE 2.39996322973

			void main() {

				if ( sigma == 0.0 ) {

					gl_FragColor = vec4( bilinearCubeUV( envMap, vOutputDirection, mipInt ), 1.0 );
					return;

				}

				vec3 outputDirection = normalize( vOutputDirection );

				vec3 up = abs( outputDirection.z ) < 0.999 ? vec3( 0.0, 0.0, 1.0 ) : vec3( 1.0, 0.0, 0.0 );
				vec3 tangent = normalize( cross( up, outputDirection ) );
				vec3 bitangent = cross( outputDirection, tangent );

				// Truncate the kernel at three standard deviations or at the antipode.
				float thetaMax = min( 3.0 * sigma, PI );
				float truncation = 1.0 - exp( - 0.5 * thetaMax * thetaMax / ( sigma * sigma ) );

				vec3 accumColor = vec3( 0.0 );
				float accumWeight = 0.0;

				for ( int i = 0; i < SAMPLES; i ++ ) {

					// Stratified inverse-CDF sampling of the Gaussian, placed on a golden-angle spiral.
					float stratum = ( float( i ) + 0.5 ) / float( SAMPLES );
					float theta = sigma * sqrt( - 2.0 * log( 1.0 - stratum * truncation ) );
					float phi = float( i ) * GOLDEN_ANGLE;

					vec3 offset = cos( phi ) * tangent + sin( phi ) * bitangent;
					vec3 sampleDirection = cos( theta ) * outputDirection + sin( theta ) * offset;

					// Correct the planar sample density to solid angle.
					float weight = sin( theta ) / theta;

					accumColor += weight * bilinearCubeUV( envMap, sampleDirection, mipInt );
					accumWeight += weight;

				}

				gl_FragColor = vec4( accumColor / accumWeight, 1.0 );

			}
		`,
    blending: 0,
    depthTest: false,
    depthWrite: false
  });
}
function XS() {
  return new nx({
    name: `EquirectangularToCubeUV`,
    uniforms: {
      envMap: {
        value: null
      }
    },
    vertexShader: QS(),
    fragmentShader: `

			precision mediump float;
			precision mediump int;

			varying vec3 vOutputDirection;

			uniform sampler2D envMap;

			#include <common>

			void main() {

				vec3 outputDirection = normalize( vOutputDirection );
				vec2 uv = equirectUv( outputDirection );

				gl_FragColor = vec4( texture2D ( envMap, uv ).rgb, 1.0 );

			}
		`,
    blending: 0,
    depthTest: false,
    depthWrite: false
  });
}
function ZS() {
  return new nx({
    name: `CubemapToCubeUV`,
    uniforms: {
      envMap: {
        value: null
      },
      flipEnvMap: {
        value: -1
      }
    },
    vertexShader: QS(),
    fragmentShader: `

			precision mediump float;
			precision mediump int;

			uniform float flipEnvMap;

			varying vec3 vOutputDirection;

			uniform samplerCube envMap;

			void main() {

				gl_FragColor = textureCube( envMap, vec3( flipEnvMap * vOutputDirection.x, vOutputDirection.yz ) );

			}
		`,
    blending: 0,
    depthTest: false,
    depthWrite: false
  });
}
function QS() {
  return `

		precision mediump float;
		precision mediump int;

		attribute vec3 outputDirection;

		varying vec3 vOutputDirection;

		void main() {

			vOutputDirection = outputDirection;
			gl_Position = vec4( position, 1.0 );

		}
	`;
}
var $S = class extends W_ {
  constructor(e = 1, t = {}) {
    super(e, e, t);
    this.isWebGLCubeRenderTarget = true;
    let n = {
      width: e,
      height: e,
      depth: 1
    };
    let r = [n, n, n, n, n, n];
    this.texture = new Pb(r);
    this._setTextureOptions(t);
    this.texture.isRenderTargetTexture = true;
  }
  fromEquirectangularTexture(e, t) {
    this.texture.type = t.type;
    this.texture.colorSpace = t.colorSpace;
    this.texture.generateMipmaps = t.generateMipmaps;
    this.texture.minFilter = t.minFilter;
    this.texture.magFilter = t.magFilter;
    let n = {
      uniforms: {
        tEquirect: {
          value: null
        }
      },
      vertexShader: `

				varying vec3 vWorldDirection;

				vec3 transformDirection( in vec3 dir, in mat4 matrix ) {

					return normalize( ( matrix * vec4( dir, 0.0 ) ).xyz );

				}

				void main() {

					vWorldDirection = transformDirection( position, modelMatrix );

					#include <begin_vertex>
					#include <project_vertex>

				}
			`,
      fragmentShader: `

				uniform sampler2D tEquirect;

				varying vec3 vWorldDirection;

				#include <common>

				void main() {

					vec3 direction = normalize( vWorldDirection );

					vec2 sampleUV = equirectUv( direction );

					gl_FragColor = texture2D( tEquirect, sampleUV );

				}
			`
    };
    let r = new zb(5, 5, 5);
    let i = new nx({
      name: `CubemapFromEquirect`,
      uniforms: Jb(n.uniforms),
      vertexShader: n.vertexShader,
      fragmentShader: n.fragmentShader,
      side: 1,
      blending: 0
    });
    i.uniforms.tEquirect.value = t;
    let a = new pb(r, i);
    let o = t.minFilter;
    if (t.minFilter === 1008) {
      t.minFilter = ph;
    }
    new Qx(1, 10, this).update(e, a);
    t.minFilter = o;
    a.geometry.dispose();
    a.material.dispose();
    return this;
  }
  clear(e, t = true, n = true, r = true) {
    let i = e.getRenderTarget();
    for (let i = 0; i < 6; i++) {
      e.setRenderTarget(this, i);
      e.clear(t, n, r);
    }
    e.setRenderTarget(i);
  }
};
function eC(e) {
  let t = new WeakMap();
  let n = new WeakMap();
  let r = null;
  function i(e, t = false) {
    if (e == null) {
      return null;
    } else if (t) {
      return o(e);
    } else {
      return a(e);
    }
  }
  function a(n) {
    if (n && n.isTexture) {
      let r = n.mapping;
      if (r === 303 || r === 304) {
        if (t.has(n)) {
          let e = t.get(n).texture;
          return s(e, n.mapping);
        }
        {
          let r = n.image;
          if (r && r.height > 0) {
            let i = new $S(r.height);
            i.fromEquirectangularTexture(e, n);
            t.set(n, i);
            n.addEventListener(`dispose`, l);
            return s(i.texture, n.mapping);
          }
          return null;
        }
      }
    }
    return n;
  }
  function o(t) {
    if (t && t.isTexture) {
      let i = t.mapping;
      let a = i === 303 || i === 304;
      let o = i === 301 || i === 302;
      if (a || o) {
        let i = n.get(t);
        let s = i === undefined ? 0 : i.texture.pmremVersion;
        if (t.isRenderTargetTexture && t.pmremVersion !== s) {
          if (r === null) {
            r = new WS(e);
          }
          i = a ? r.fromEquirectangular(t, i) : r.fromCubemap(t, i);
          i.texture.pmremVersion = t.pmremVersion;
          n.set(t, i);
          return i.texture;
        }
        if (i !== undefined) {
          return i.texture;
        }
        {
          let s = t.image;
          if (a && s && s.height > 0 || o && s && c(s)) {
            if (r === null) {
              r = new WS(e);
            }
            i = a ? r.fromEquirectangular(t) : r.fromCubemap(t);
            i.texture.pmremVersion = t.pmremVersion;
            n.set(t, i);
            t.addEventListener(`dispose`, u);
            return i.texture;
          } else {
            return null;
          }
        }
      }
    }
    return t;
  }
  function s(e, t) {
    if (t === 303) {
      e.mapping = 301;
    } else if (t === 304) {
      e.mapping = 302;
    }
    return e;
  }
  function c(e) {
    let t = 0;
    for (let n = 0; n < 6; n++) {
      if (e[n] !== undefined) {
        t++;
      }
    }
    return t === 6;
  }
  function l(e) {
    let n = e.target;
    n.removeEventListener(`dispose`, l);
    let r = t.get(n);
    if (r !== undefined) {
      t.delete(n);
      r.dispose();
    }
  }
  function u(e) {
    let t = e.target;
    t.removeEventListener(`dispose`, u);
    let r = n.get(t);
    if (r !== undefined) {
      n.delete(t);
      r.dispose();
    }
  }
  function d() {
    t = new WeakMap();
    n = new WeakMap();
    if (r !== null) {
      r.dispose();
      r = null;
    }
  }
  return {
    get: i,
    dispose: d
  };
}
function tC(e) {
  let t = {};
  function n(n) {
    if (t[n] !== undefined) {
      return t[n];
    }
    let r = e.getExtension(n);
    t[n] = r;
    return r;
  }
  return {
    has: function (e) {
      return n(e) !== null;
    },
    init: function () {
      n(`EXT_color_buffer_float`);
      n(`WEBGL_clip_cull_distance`);
      n(`OES_texture_float_linear`);
      n(`EXT_color_buffer_half_float`);
      n(`WEBGL_multisampled_render_to_texture`);
      n(`WEBGL_render_shared_exponent`);
    },
    get: function (e) {
      let t = n(e);
      if (t === null) {
        Gg(`WebGLRenderer: ${e} extension not supported.`);
      }
      return t;
    }
  };
}
function nC(e, t, n, r) {
  let i = {};
  let a = new WeakMap();
  function o(e) {
    let s = e.target;
    if (s.index !== null) {
      t.remove(s.index);
    }
    for (let e in s.attributes) {
      t.remove(s.attributes[e]);
    }
    s.removeEventListener(`dispose`, o);
    delete i[s.id];
    let c = a.get(s);
    if (c) {
      t.remove(c);
      a.delete(s);
    }
    r.releaseStatesOfGeometry(s);
    if (s.isInstancedBufferGeometry === true) {
      delete s._maxInstanceCount;
    }
    n.memory.geometries--;
  }
  function s(e, t) {
    if (i[t.id] === true) {
      return t;
    } else {
      t.addEventListener(`dispose`, o);
      i[t.id] = true;
      n.memory.geometries++;
      return t;
    }
  }
  function c(n) {
    let r = n.attributes;
    for (let n in r) {
      t.update(r[n], e.ARRAY_BUFFER);
    }
  }
  function l(e) {
    let n = [];
    let r = e.index;
    let i = e.attributes.position;
    let o = 0;
    if (i === undefined) {
      return;
    }
    if (r !== null) {
      let e = r.array;
      o = r.version;
      for (let t = 0, r = e.length; t < r; t += 3) {
        let r = e[t + 0];
        let i = e[t + 1];
        let a = e[t + 2];
        n.push(r, i, i, a, a, r);
      }
    } else {
      let e = i.array;
      o = i.version;
      for (let t = 0, r = e.length / 3 - 1; t < r; t += 3) {
        let e = t + 0;
        let r = t + 1;
        let i = t + 2;
        n.push(e, r, r, i, i, e);
      }
    }
    let s = new (i.count >= 65535 ? dy : uy)(n, 1);
    s.version = o;
    let c = a.get(e);
    if (c) {
      t.remove(c);
    }
    a.set(e, s);
  }
  function u(e) {
    let t = a.get(e);
    if (t) {
      let n = e.index;
      if (n !== null && t.version < n.version) {
        l(e);
      }
    } else {
      l(e);
    }
    return a.get(e);
  }
  return {
    get: s,
    update: c,
    getWireframeAttribute: u
  };
}
function rC(e, t, n) {
  let r;
  function i(e) {
    r = e;
  }
  let a;
  let o;
  function s(e) {
    a = e.type;
    o = e.bytesPerElement;
  }
  function c(t, i) {
    e.drawElements(r, i, a, t * o);
    n.update(i, r, 1);
  }
  function l(t, i, s) {
    if (s !== 0) {
      e.drawElementsInstanced(r, i, a, t * o, s);
      n.update(i, r, s);
    }
  }
  function u(e, i, o) {
    if (o === 0) {
      return;
    }
    t.get(`WEBGL_multi_draw`).multiDrawElementsWEBGL(r, i, 0, a, e, 0, o);
    let s = 0;
    for (let e = 0; e < o; e++) {
      s += i[e];
    }
    n.update(s, r, 1);
  }
  this.setMode = i;
  this.setIndex = s;
  this.render = c;
  this.renderInstances = l;
  this.renderMultiDraw = u;
}
function iC(e) {
  let t = {
    geometries: 0,
    textures: 0
  };
  let n = {
    frame: 0,
    calls: 0,
    triangles: 0,
    points: 0,
    lines: 0
  };
  function r(t, r, i) {
    n.calls++;
    switch (r) {
      case e.TRIANGLES:
        n.triangles += t / 3 * i;
        break;
      case e.LINES:
        n.lines += t / 2 * i;
        break;
      case e.LINE_STRIP:
        n.lines += i * (t - 1);
        break;
      case e.LINE_LOOP:
        n.lines += i * t;
        break;
      case e.POINTS:
        n.points += i * t;
        break;
      default:
        Wg(`WebGLInfo: Unknown draw mode:`, r);
    }
  }
  function i() {
    n.calls = 0;
    n.triangles = 0;
    n.points = 0;
    n.lines = 0;
  }
  return {
    memory: t,
    render: n,
    programs: null,
    autoReset: true,
    reset: i,
    update: r
  };
}
function aC(e, t, n) {
  let r = new WeakMap();
  let i = new H_();
  function a(a, o, s) {
    let c = a.morphTargetInfluences;
    let l = o.morphAttributes.position || o.morphAttributes.normal || o.morphAttributes.color;
    let u = l === undefined ? 0 : l.length;
    let d = r.get(o);
    if (d === undefined || d.count !== u) {
      if (d !== undefined) {
        d.texture.dispose();
      }
      let e = o.morphAttributes.position !== undefined;
      let n = o.morphAttributes.normal !== undefined;
      let a = o.morphAttributes.color !== undefined;
      let s = o.morphAttributes.position || [];
      let c = o.morphAttributes.normal || [];
      let l = o.morphAttributes.color || [];
      let f = 0;
      if (e === true) {
        f = 1;
      }
      if (n === true) {
        f = 2;
      }
      if (a === true) {
        f = 3;
      }
      let p = o.attributes.position.count * f;
      let m = 1;
      if (p > t.maxTextureSize) {
        m = Math.ceil(p / t.maxTextureSize);
        p = t.maxTextureSize;
      }
      let h = new Float32Array(p * m * 4 * u);
      let g = new G_(h, p, m, u);
      g.type = Sh;
      g.needsUpdate = true;
      let _ = f * 4;
      for (let t = 0; t < u; t++) {
        let r = s[t];
        let o = c[t];
        let u = l[t];
        let d = p * m * 4 * t;
        for (let t = 0; t < r.count; t++) {
          let s = t * _;
          if (e === true) {
            i.fromBufferAttribute(r, t);
            h[d + s + 0] = i.x;
            h[d + s + 1] = i.y;
            h[d + s + 2] = i.z;
            h[d + s + 3] = 0;
          }
          if (n === true) {
            i.fromBufferAttribute(o, t);
            h[d + s + 4] = i.x;
            h[d + s + 5] = i.y;
            h[d + s + 6] = i.z;
            h[d + s + 7] = 0;
          }
          if (a === true) {
            i.fromBufferAttribute(u, t);
            h[d + s + 8] = i.x;
            h[d + s + 9] = i.y;
            h[d + s + 10] = i.z;
            h[d + s + 11] = u.itemSize === 4 ? i.w : 1;
          }
        }
      }
      d = {
        count: u,
        texture: g,
        size: new S_(p, m)
      };
      r.set(o, d);
      function v() {
        g.dispose();
        r.delete(o);
        o.removeEventListener(`dispose`, v);
      }
      o.addEventListener(`dispose`, v);
    }
    if (a.isInstancedMesh === true && a.morphTexture !== null) {
      s.getUniforms().setValue(e, `morphTexture`, a.morphTexture, n);
    } else {
      let t = 0;
      for (let e = 0; e < c.length; e++) {
        t += c[e];
      }
      let n = o.morphTargetsRelative ? 1 : 1 - t;
      s.getUniforms().setValue(e, `morphTargetBaseInfluence`, n);
      s.getUniforms().setValue(e, `morphTargetInfluences`, c);
    }
    s.getUniforms().setValue(e, `morphTargetsTexture`, d.texture, n);
    s.getUniforms().setValue(e, `morphTargetsTextureSize`, d.size);
  }
  return {
    update: a
  };
}
function oC(e, t, n, r, i) {
  let a = new WeakMap();
  function o(r) {
    let o = i.render.frame;
    let s = r.geometry;
    let l = t.get(r, s);
    if (a.get(l) !== o) {
      t.update(l);
      a.set(l, o);
    }
    if (r.isInstancedMesh) {
      if (r.hasEventListener(`dispose`, c) === false) {
        r.addEventListener(`dispose`, c);
      }
      if (a.get(r) !== o) {
        n.update(r.instanceMatrix, e.ARRAY_BUFFER);
        if (r.instanceColor !== null) {
          n.update(r.instanceColor, e.ARRAY_BUFFER);
        }
        a.set(r, o);
      }
    }
    if (r.isSkinnedMesh) {
      let e = r.skeleton;
      if (a.get(e) !== o) {
        e.update();
        a.set(e, o);
      }
    }
    return l;
  }
  function s() {
    a = new WeakMap();
  }
  function c(e) {
    let t = e.target;
    t.removeEventListener(`dispose`, c);
    r.releaseStatesOfObject(t);
    n.remove(t.instanceMatrix);
    if (t.instanceColor !== null) {
      n.remove(t.instanceColor);
    }
  }
  return {
    update: o,
    dispose: s
  };
}
var sC = {
  1: `LINEAR_TONE_MAPPING`,
  2: `REINHARD_TONE_MAPPING`,
  3: `CINEON_TONE_MAPPING`,
  4: `ACES_FILMIC_TONE_MAPPING`,
  6: `AGX_TONE_MAPPING`,
  7: `NEUTRAL_TONE_MAPPING`,
  5: `CUSTOM_TONE_MAPPING`
};
function cC(e, t, n, r, i, a) {
  let o = new W_(t, n, {
    type: e,
    depthBuffer: i,
    stencilBuffer: a,
    samples: r ? 4 : 0,
    storeMultisampledDepthBuffer: false,
    storeMultisampledStencilBuffer: false,
    resolveDepthBuffer: false,
    resolveStencilBuffer: false
  });
  let s = null;
  let c = null;
  let l = new wy();
  l.setAttribute(`position`, new fy([-1, 3, 0, -1, -1, 0, 3, -1, 0], 3));
  l.setAttribute(`uv`, new fy([0, 2, 0, 0, 2, 0], 2));
  let u = new rx({
    uniforms: {
      tDiffuse: {
        value: null
      }
    },
    vertexShader: `
			precision highp float;

			uniform mat4 modelViewMatrix;
			uniform mat4 projectionMatrix;

			attribute vec3 position;
			attribute vec2 uv;

			varying vec2 vUv;

			void main() {
				vUv = uv;
				gl_Position = projectionMatrix * modelViewMatrix * vec4( position, 1.0 );
			}`,
    fragmentShader: `
			precision highp float;

			uniform sampler2D tDiffuse;

			varying vec2 vUv;

			#include <tonemapping_pars_fragment>
			#include <colorspace_pars_fragment>

			void main() {
				gl_FragColor = texture2D( tDiffuse, vUv );

				#ifdef LINEAR_TONE_MAPPING
					gl_FragColor.rgb = LinearToneMapping( gl_FragColor.rgb );
				#elif defined( REINHARD_TONE_MAPPING )
					gl_FragColor.rgb = ReinhardToneMapping( gl_FragColor.rgb );
				#elif defined( CINEON_TONE_MAPPING )
					gl_FragColor.rgb = CineonToneMapping( gl_FragColor.rgb );
				#elif defined( ACES_FILMIC_TONE_MAPPING )
					gl_FragColor.rgb = ACESFilmicToneMapping( gl_FragColor.rgb );
				#elif defined( AGX_TONE_MAPPING )
					gl_FragColor.rgb = AgXToneMapping( gl_FragColor.rgb );
				#elif defined( NEUTRAL_TONE_MAPPING )
					gl_FragColor.rgb = NeutralToneMapping( gl_FragColor.rgb );
				#elif defined( CUSTOM_TONE_MAPPING )
					gl_FragColor.rgb = CustomToneMapping( gl_FragColor.rgb );
				#endif

				#ifdef SRGB_TRANSFER
					gl_FragColor = sRGBTransferOETF( gl_FragColor );
				#endif
			}`,
    depthTest: false,
    depthWrite: false
  });
  let d = new pb(l, u);
  let f = new qx(-1, 1, 1, -1, 0, 1);
  let p = null;
  let m = null;
  let h = false;
  let g;
  let _ = null;
  let v = [];
  let y = false;
  this.setSize = function (e, t) {
    o.setSize(e, t);
    if (s !== null) {
      s.setSize(e, t);
    }
    if (c !== null) {
      c.setSize(e, t);
    }
    for (let n = 0; n < v.length; n++) {
      let r = v[n];
      if (r.setSize) {
        r.setSize(e, t);
      }
    }
  };
  this.setEffects = function (e) {
    v = e;
    y = v.length > 0 && v[0].isRenderPass === true;
    let t = o.width;
    let n = o.height;
    if (v.length > 0 && s === null) {
      s = new W_(t, n, {
        type: Ch,
        depthBuffer: false,
        stencilBuffer: false
      });
      c = new W_(t, n, {
        type: Ch,
        depthBuffer: false,
        stencilBuffer: false
      });
    }
    for (let e = 0; e < v.length; e++) {
      let r = v[e];
      if (r.setSize) {
        r.setSize(t, n);
      }
    }
  };
  this.begin = function (e, t) {
    if (h || e.toneMapping === 0 && v.length === 0) {
      return false;
    }
    _ = t;
    if (t !== null) {
      let e = t.width;
      let n = t.height;
      if (o.width !== e || o.height !== n) {
        this.setSize(e, n);
      }
    }
    if (y === false) {
      e.setRenderTarget(o);
    }
    g = e.toneMapping;
    e.toneMapping = 0;
    return true;
  };
  this.hasRenderPass = function () {
    return y;
  };
  this.end = function (e, t) {
    e.toneMapping = g;
    h = true;
    let n = o;
    let r = s;
    for (let i = 0; i < v.length; i++) {
      let a = v[i];
      if (a.enabled !== false) {
        a.render(e, r, n, t);
        if (a.needsSwap !== false) {
          n = r;
          r = r === s ? c : s;
        }
      }
    }
    if (p !== e.outputColorSpace || m !== e.toneMapping) {
      p = e.outputColorSpace;
      m = e.toneMapping;
      u.defines = {};
      if (j_.getTransfer(p) === `srgb`) {
        u.defines.SRGB_TRANSFER = ``;
      }
      let t = sC[m];
      if (t) {
        u.defines[t] = ``;
      }
      u.needsUpdate = true;
    }
    u.uniforms.tDiffuse.value = n.texture;
    e.setRenderTarget(_);
    e.render(d, f);
    _ = null;
    h = false;
  };
  this.isCompositing = function () {
    return h;
  };
  this.dispose = function () {
    o.dispose();
    if (s !== null) {
      s.dispose();
    }
    if (c !== null) {
      c.dispose();
    }
    l.dispose();
    u.dispose();
  };
}
var lC = new V_();
var uC = new Ib(1, 1);
var dC = new G_();
var fC = new K_();
var pC = new Pb();
var mC = [];
var hC = [];
var gC = new Float32Array(16);
var _C = new Float32Array(9);
var vC = new Float32Array(4);
function yC(e, t, n) {
  let r = e[0];
  if (r <= 0 || r > 0) {
    return e;
  }
  let i = t * n;
  let a = mC[i];
  if (a === undefined) {
    a = new Float32Array(i);
    mC[i] = a;
  }
  if (t !== 0) {
    r.toArray(a, 0);
    for (let r = 1, i = 0; r !== t; ++r) {
      i += n;
      e[r].toArray(a, i);
    }
  }
  return a;
}
function bC(e, t) {
  if (e.length !== t.length) {
    return false;
  }
  for (let n = 0, r = e.length; n < r; n++) {
    if (e[n] !== t[n]) {
      return false;
    }
  }
  return true;
}
function xC(e, t) {
  for (let n = 0, r = t.length; n < r; n++) {
    e[n] = t[n];
  }
}
function SC(e, t) {
  let n = hC[t];
  if (n === undefined) {
    n = new Int32Array(t);
    hC[t] = n;
  }
  for (let r = 0; r !== t; ++r) {
    n[r] = e.allocateTextureUnit();
  }
  return n;
}
function CC(e, t) {
  let n = this.cache;
  if (n[0] !== t) {
    e.uniform1f(this.addr, t);
    n[0] = t;
  }
}
function wC(e, t) {
  let n = this.cache;
  if (t.x !== undefined) {
    if (n[0] !== t.x || n[1] !== t.y) {
      e.uniform2f(this.addr, t.x, t.y);
      n[0] = t.x;
      n[1] = t.y;
    }
  } else {
    if (bC(n, t)) {
      return;
    }
    e.uniform2fv(this.addr, t);
    xC(n, t);
  }
}
function TC(e, t) {
  let n = this.cache;
  if (t.x !== undefined) {
    if (n[0] !== t.x || n[1] !== t.y || n[2] !== t.z) {
      e.uniform3f(this.addr, t.x, t.y, t.z);
      n[0] = t.x;
      n[1] = t.y;
      n[2] = t.z;
    }
  } else if (t.r !== undefined) {
    if (n[0] !== t.r || n[1] !== t.g || n[2] !== t.b) {
      e.uniform3f(this.addr, t.r, t.g, t.b);
      n[0] = t.r;
      n[1] = t.g;
      n[2] = t.b;
    }
  } else {
    if (bC(n, t)) {
      return;
    }
    e.uniform3fv(this.addr, t);
    xC(n, t);
  }
}
function EC(e, t) {
  let n = this.cache;
  if (t.x !== undefined) {
    if (n[0] !== t.x || n[1] !== t.y || n[2] !== t.z || n[3] !== t.w) {
      e.uniform4f(this.addr, t.x, t.y, t.z, t.w);
      n[0] = t.x;
      n[1] = t.y;
      n[2] = t.z;
      n[3] = t.w;
    }
  } else {
    if (bC(n, t)) {
      return;
    }
    e.uniform4fv(this.addr, t);
    xC(n, t);
  }
}
function DC(e, t) {
  let n = this.cache;
  let r = t.elements;
  if (r === undefined) {
    if (bC(n, t)) {
      return;
    }
    e.uniformMatrix2fv(this.addr, false, t);
    xC(n, t);
  } else {
    if (bC(n, r)) {
      return;
    }
    vC.set(r);
    e.uniformMatrix2fv(this.addr, false, vC);
    xC(n, r);
  }
}
function OC(e, t) {
  let n = this.cache;
  let r = t.elements;
  if (r === undefined) {
    if (bC(n, t)) {
      return;
    }
    e.uniformMatrix3fv(this.addr, false, t);
    xC(n, t);
  } else {
    if (bC(n, r)) {
      return;
    }
    _C.set(r);
    e.uniformMatrix3fv(this.addr, false, _C);
    xC(n, r);
  }
}
function kC(e, t) {
  let n = this.cache;
  let r = t.elements;
  if (r === undefined) {
    if (bC(n, t)) {
      return;
    }
    e.uniformMatrix4fv(this.addr, false, t);
    xC(n, t);
  } else {
    if (bC(n, r)) {
      return;
    }
    gC.set(r);
    e.uniformMatrix4fv(this.addr, false, gC);
    xC(n, r);
  }
}
function AC(e, t) {
  let n = this.cache;
  if (n[0] !== t) {
    e.uniform1i(this.addr, t);
    n[0] = t;
  }
}
function jC(e, t) {
  let n = this.cache;
  if (t.x !== undefined) {
    if (n[0] !== t.x || n[1] !== t.y) {
      e.uniform2i(this.addr, t.x, t.y);
      n[0] = t.x;
      n[1] = t.y;
    }
  } else {
    if (bC(n, t)) {
      return;
    }
    e.uniform2iv(this.addr, t);
    xC(n, t);
  }
}
function MC(e, t) {
  let n = this.cache;
  if (t.x !== undefined) {
    if (n[0] !== t.x || n[1] !== t.y || n[2] !== t.z) {
      e.uniform3i(this.addr, t.x, t.y, t.z);
      n[0] = t.x;
      n[1] = t.y;
      n[2] = t.z;
    }
  } else {
    if (bC(n, t)) {
      return;
    }
    e.uniform3iv(this.addr, t);
    xC(n, t);
  }
}
function NC(e, t) {
  let n = this.cache;
  if (t.x !== undefined) {
    if (n[0] !== t.x || n[1] !== t.y || n[2] !== t.z || n[3] !== t.w) {
      e.uniform4i(this.addr, t.x, t.y, t.z, t.w);
      n[0] = t.x;
      n[1] = t.y;
      n[2] = t.z;
      n[3] = t.w;
    }
  } else {
    if (bC(n, t)) {
      return;
    }
    e.uniform4iv(this.addr, t);
    xC(n, t);
  }
}
function PC(e, t) {
  let n = this.cache;
  if (n[0] !== t) {
    e.uniform1ui(this.addr, t);
    n[0] = t;
  }
}
function FC(e, t) {
  let n = this.cache;
  if (t.x !== undefined) {
    if (n[0] !== t.x || n[1] !== t.y) {
      e.uniform2ui(this.addr, t.x, t.y);
      n[0] = t.x;
      n[1] = t.y;
    }
  } else {
    if (bC(n, t)) {
      return;
    }
    e.uniform2uiv(this.addr, t);
    xC(n, t);
  }
}
function IC(e, t) {
  let n = this.cache;
  if (t.x !== undefined) {
    if (n[0] !== t.x || n[1] !== t.y || n[2] !== t.z) {
      e.uniform3ui(this.addr, t.x, t.y, t.z);
      n[0] = t.x;
      n[1] = t.y;
      n[2] = t.z;
    }
  } else {
    if (bC(n, t)) {
      return;
    }
    e.uniform3uiv(this.addr, t);
    xC(n, t);
  }
}
function LC(e, t) {
  let n = this.cache;
  if (t.x !== undefined) {
    if (n[0] !== t.x || n[1] !== t.y || n[2] !== t.z || n[3] !== t.w) {
      e.uniform4ui(this.addr, t.x, t.y, t.z, t.w);
      n[0] = t.x;
      n[1] = t.y;
      n[2] = t.z;
      n[3] = t.w;
    }
  } else {
    if (bC(n, t)) {
      return;
    }
    e.uniform4uiv(this.addr, t);
    xC(n, t);
  }
}
function RC(e, t, n) {
  let r = this.cache;
  let i = n.allocateTextureUnit();
  if (r[0] !== i) {
    e.uniform1i(this.addr, i);
    r[0] = i;
  }
  let a;
  if (this.type === e.SAMPLER_2D_SHADOW) {
    uC.compareFunction = n.isReversedDepthBuffer() ? 518 : 515;
    a = uC;
  } else {
    a = lC;
  }
  n.setTexture2D(t || a, i);
}
function zC(e, t, n) {
  let r = this.cache;
  let i = n.allocateTextureUnit();
  if (r[0] !== i) {
    e.uniform1i(this.addr, i);
    r[0] = i;
  }
  n.setTexture3D(t || fC, i);
}
function BC(e, t, n) {
  let r = this.cache;
  let i = n.allocateTextureUnit();
  if (r[0] !== i) {
    e.uniform1i(this.addr, i);
    r[0] = i;
  }
  n.setTextureCube(t || pC, i);
}
function VC(e, t, n) {
  let r = this.cache;
  let i = n.allocateTextureUnit();
  if (r[0] !== i) {
    e.uniform1i(this.addr, i);
    r[0] = i;
  }
  n.setTexture2DArray(t || dC, i);
}
function HC(e) {
  switch (e) {
    case 5126:
      return CC;
    case 35664:
      return wC;
    case 35665:
      return TC;
    case 35666:
      return EC;
    case 35674:
      return DC;
    case 35675:
      return OC;
    case 35676:
      return kC;
    case 5124:
    case 35670:
      return AC;
    case 35667:
    case 35671:
      return jC;
    case 35668:
    case 35672:
      return MC;
    case 35669:
    case 35673:
      return NC;
    case 5125:
      return PC;
    case 36294:
      return FC;
    case 36295:
      return IC;
    case 36296:
      return LC;
    case 35678:
    case 36198:
    case 36298:
    case 36306:
    case 35682:
      return RC;
    case 35679:
    case 36299:
    case 36307:
      return zC;
    case 35680:
    case 36300:
    case 36308:
    case 36293:
      return BC;
    case 36289:
    case 36303:
    case 36311:
    case 36292:
      return VC;
  }
}
function UC(e, t) {
  e.uniform1fv(this.addr, t);
}
function WC(e, t) {
  let n = yC(t, this.size, 2);
  e.uniform2fv(this.addr, n);
}
function GC(e, t) {
  let n = yC(t, this.size, 3);
  e.uniform3fv(this.addr, n);
}
function KC(e, t) {
  let n = yC(t, this.size, 4);
  e.uniform4fv(this.addr, n);
}
function qC(e, t) {
  let n = yC(t, this.size, 4);
  e.uniformMatrix2fv(this.addr, false, n);
}
function JC(e, t) {
  let n = yC(t, this.size, 9);
  e.uniformMatrix3fv(this.addr, false, n);
}
function YC(e, t) {
  let n = yC(t, this.size, 16);
  e.uniformMatrix4fv(this.addr, false, n);
}
function XC(e, t) {
  e.uniform1iv(this.addr, t);
}
function ZC(e, t) {
  e.uniform2iv(this.addr, t);
}
function QC(e, t) {
  e.uniform3iv(this.addr, t);
}
function $C(e, t) {
  e.uniform4iv(this.addr, t);
}
function ew(e, t) {
  e.uniform1uiv(this.addr, t);
}
function tw(e, t) {
  e.uniform2uiv(this.addr, t);
}
function nw(e, t) {
  e.uniform3uiv(this.addr, t);
}
function rw(e, t) {
  e.uniform4uiv(this.addr, t);
}
function iw(e, t, n) {
  let r = this.cache;
  let i = t.length;
  let a = SC(n, i);
  if (!bC(r, a)) {
    e.uniform1iv(this.addr, a);
    xC(r, a);
  }
  let o;
  o = this.type === e.SAMPLER_2D_SHADOW ? uC : lC;
  for (let e = 0; e !== i; ++e) {
    n.setTexture2D(t[e] || o, a[e]);
  }
}
function aw(e, t, n) {
  let r = this.cache;
  let i = t.length;
  let a = SC(n, i);
  if (!bC(r, a)) {
    e.uniform1iv(this.addr, a);
    xC(r, a);
  }
  for (let e = 0; e !== i; ++e) {
    n.setTexture3D(t[e] || fC, a[e]);
  }
}
function ow(e, t, n) {
  let r = this.cache;
  let i = t.length;
  let a = SC(n, i);
  if (!bC(r, a)) {
    e.uniform1iv(this.addr, a);
    xC(r, a);
  }
  for (let e = 0; e !== i; ++e) {
    n.setTextureCube(t[e] || pC, a[e]);
  }
}
function sw(e, t, n) {
  let r = this.cache;
  let i = t.length;
  let a = SC(n, i);
  if (!bC(r, a)) {
    e.uniform1iv(this.addr, a);
    xC(r, a);
  }
  for (let e = 0; e !== i; ++e) {
    n.setTexture2DArray(t[e] || dC, a[e]);
  }
}
function cw(e) {
  switch (e) {
    case 5126:
      return UC;
    case 35664:
      return WC;
    case 35665:
      return GC;
    case 35666:
      return KC;
    case 35674:
      return qC;
    case 35675:
      return JC;
    case 35676:
      return YC;
    case 5124:
    case 35670:
      return XC;
    case 35667:
    case 35671:
      return ZC;
    case 35668:
    case 35672:
      return QC;
    case 35669:
    case 35673:
      return $C;
    case 5125:
      return ew;
    case 36294:
      return tw;
    case 36295:
      return nw;
    case 36296:
      return rw;
    case 35678:
    case 36198:
    case 36298:
    case 36306:
    case 35682:
      return iw;
    case 35679:
    case 36299:
    case 36307:
      return aw;
    case 35680:
    case 36300:
    case 36308:
    case 36293:
      return ow;
    case 36289:
    case 36303:
    case 36311:
    case 36292:
      return sw;
  }
}
var lw = class {
  constructor(e, t, n) {
    this.id = e;
    this.addr = n;
    this.cache = [];
    this.type = t.type;
    this.setValue = HC(t.type);
  }
};
var uw = class {
  constructor(e, t, n) {
    this.id = e;
    this.addr = n;
    this.cache = [];
    this.type = t.type;
    this.size = t.size;
    this.setValue = cw(t.type);
  }
};
var dw = class {
  constructor(e) {
    this.id = e;
    this.seq = [];
    this.map = {};
  }
  setValue(e, t, n) {
    let r = this.seq;
    for (let i = 0, a = r.length; i !== a; ++i) {
      let a = r[i];
      a.setValue(e, t[a.id], n);
    }
  }
};
var fw = /(\w+)(\])?(\[|\.)?/g;
function pw(e, t) {
  e.seq.push(t);
  e.map[t.id] = t;
}
function mw(e, t, n) {
  let r = e.name;
  let i = r.length;
  for (fw.lastIndex = 0;;) {
    let a = fw.exec(r);
    let o = fw.lastIndex;
    let s = a[1];
    let c = a[2] === `]`;
    let l = a[3];
    if (c) {
      s |= 0;
    }
    if (l === undefined || l === `[` && o + 2 === i) {
      pw(n, l === undefined ? new lw(s, e, t) : new uw(s, e, t));
      break;
    }
    {
      let e = n.map[s];
      if (e === undefined) {
        e = new dw(s);
        pw(n, e);
      }
      n = e;
    }
  }
}
var hw = class {
  constructor(e, t) {
    this.seq = [];
    this.map = {};
    let n = e.getProgramParameter(t, e.ACTIVE_UNIFORMS);
    for (let r = 0; r < n; ++r) {
      let n = e.getActiveUniform(t, r);
      mw(n, e.getUniformLocation(t, n.name), this);
    }
    let r = [];
    let i = [];
    for (let t of this.seq) {
      if (t.type === e.SAMPLER_2D_SHADOW || t.type === e.SAMPLER_CUBE_SHADOW || t.type === e.SAMPLER_2D_ARRAY_SHADOW) {
        r.push(t);
      } else {
        i.push(t);
      }
    }
    if (r.length > 0) {
      this.seq = r.concat(i);
    }
  }
  setValue(e, t, n, r) {
    let i = this.map[t];
    if (i !== undefined) {
      i.setValue(e, n, r);
    }
  }
  setOptional(e, t, n) {
    let r = t[n];
    if (r !== undefined) {
      this.setValue(e, n, r);
    }
  }
  static upload(e, t, n, r) {
    for (let i = 0, a = t.length; i !== a; ++i) {
      let a = t[i];
      let o = n[a.id];
      if (o.needsUpdate !== false) {
        a.setValue(e, o.value, r);
      }
    }
  }
  static seqWithValue(e, t) {
    let n = [];
    for (let r = 0, i = e.length; r !== i; ++r) {
      let i = e[r];
      if (i.id in t) {
        n.push(i);
      }
    }
    return n;
  }
};
function gw(e, t, n) {
  let r = e.createShader(t);
  e.shaderSource(r, n);
  e.compileShader(r);
  return r;
}
var _w = 37297;
var vw = 0;
function yw(e, t) {
  let n = e.split(`
`);
  let r = [];
  let i = Math.max(t - 6, 0);
  let a = Math.min(t + 6, n.length);
  for (let e = i; e < a; e++) {
    let i = e + 1;
    r.push(`${i === t ? `>` : ` `} ${i}: ${n[e]}`);
  }
  return r.join(`
`);
}
var bw = new E_();
function xw(e) {
  j_._getMatrix(bw, j_.workingColorSpace, e);
  let t = `mat3( ${bw.elements.map(e => e.toFixed(4))} )`;
  switch (j_.getTransfer(e)) {
    case jg:
      return [t, `LinearTransferOETF`];
    case Mg:
      return [t, `sRGBTransferOETF`];
    default:
      Ug(`WebGLProgram: Unsupported color space: `, e);
      return [t, `LinearTransferOETF`];
  }
}
function Sw(e, t, n) {
  let r = e.getShaderParameter(t, e.COMPILE_STATUS);
  let i = (e.getShaderInfoLog(t) || ``).trim();
  if (r && i === ``) {
    return ``;
  }
  let a = /ERROR: 0:(\d+)/.exec(i);
  if (a) {
    let r = parseInt(a[1]);
    return `${n.toUpperCase()}

${i}

${yw(e.getShaderSource(t), r)}`;
  }
  return i;
}
function Cw(e, t) {
  let n = xw(t);
  return [`vec4 ${e}( vec4 value ) {`, `	return ${n[1]}( vec4( value.rgb * ${n[0]}, value.a ) );`, `}`].join(`
`);
}
var ww = {
  1: `Linear`,
  2: `Reinhard`,
  3: `Cineon`,
  4: `ACESFilmic`,
  6: `AgX`,
  7: `Neutral`,
  5: `Custom`
};
function Tw(e, t) {
  let n = ww[t];
  if (n === undefined) {
    Ug(`WebGLProgram: Unsupported toneMapping:`, t);
    return `vec3 ${e}( vec3 color ) { return LinearToneMapping( color ); }`;
  } else {
    return `vec3 ${e}( vec3 color ) { return ${n}ToneMapping( color ); }`;
  }
}
var Ew = new X();
function Dw() {
  j_.getLuminanceCoefficients(Ew);
  return [`float luminance( const in vec3 rgb ) {`, `	const vec3 weights = vec3( ${Ew.x.toFixed(4)}, ${Ew.y.toFixed(4)}, ${Ew.z.toFixed(4)} );`, `	return dot( weights, rgb );`, `}`].join(`
`);
}
function Ow(e) {
  return [e.extensionClipCullDistance ? `#extension GL_ANGLE_clip_cull_distance : require` : ``, e.extensionMultiDraw ? `#extension GL_ANGLE_multi_draw : require` : ``].filter(jw).join(`
`);
}
function kw(e) {
  let t = [];
  for (let n in e) {
    let r = e[n];
    if (r !== false) {
      t.push(`#define ${n} ${r}`);
    }
  }
  return t.join(`
`);
}
function Aw(e, t) {
  let n = {};
  let r = e.getProgramParameter(t, e.ACTIVE_ATTRIBUTES);
  for (let i = 0; i < r; i++) {
    let r = e.getActiveAttrib(t, i);
    let a = r.name;
    let o = 1;
    if (r.type === e.FLOAT_MAT2) {
      o = 2;
    }
    if (r.type === e.FLOAT_MAT3) {
      o = 3;
    }
    if (r.type === e.FLOAT_MAT4) {
      o = 4;
    }
    n[a] = {
      type: r.type,
      location: e.getAttribLocation(t, a),
      locationSize: o
    };
  }
  return n;
}
function jw(e) {
  return e !== ``;
}
function Mw(e, t) {
  let n = t.numSpotLightShadows + t.numSpotLightMaps - t.numSpotLightShadowsWithMaps;
  return e.replace(/NUM_SUN_LIGHTS/g, t.numSunLights).replace(/NUM_DIR_LIGHTS/g, t.numDirLights).replace(/NUM_SPOT_LIGHTS/g, t.numSpotLights).replace(/NUM_SPOT_LIGHT_MAPS/g, t.numSpotLightMaps).replace(/NUM_SPOT_LIGHT_COORDS/g, n).replace(/NUM_RECT_AREA_LIGHTS/g, t.numRectAreaLights).replace(/NUM_POINT_LIGHTS/g, t.numPointLights).replace(/NUM_HEMI_LIGHTS/g, t.numHemiLights).replace(/NUM_SUN_LIGHT_SHADOWS/g, t.numSunLightShadows).replace(/NUM_DIR_LIGHT_SHADOWS/g, t.numDirLightShadows).replace(/NUM_SPOT_LIGHT_SHADOWS_WITH_MAPS/g, t.numSpotLightShadowsWithMaps).replace(/NUM_SPOT_LIGHT_SHADOWS/g, t.numSpotLightShadows).replace(/NUM_POINT_LIGHT_SHADOWS/g, t.numPointLightShadows);
}
function Nw(e, t) {
  return e.replace(/NUM_CLIPPING_PLANES/g, t.numClippingPlanes).replace(/UNION_CLIPPING_PLANES/g, t.numClippingPlanes - t.numClipIntersection);
}
var Pw = /^[ \t]*#include +<([\w\d./]+)>/gm;
function Fw(e) {
  return e.replace(Pw, Lw);
}
var Iw = new Map();
function Lw(e, t) {
  let n = SS[t];
  if (n === undefined) {
    let e = Iw.get(t);
    if (e !== undefined) {
      n = SS[e];
      Ug(`WebGLRenderer: Shader chunk "%s" has been deprecated. Use "%s" instead.`, t, e);
    } else {
      throw Error(`THREE.WebGLProgram: Can not resolve #include <${t}>`);
    }
  }
  return Fw(n);
}
var Rw = /#pragma unroll_loop_start\s+for\s*\(\s*int\s+i\s*=\s*(\d+)\s*;\s*i\s*<\s*(\d+)\s*;\s*i\s*\+\+\s*\)\s*{([\s\S]+?)}\s+#pragma unroll_loop_end/g;
function zw(e) {
  return e.replace(Rw, Bw);
}
function Bw(e, t, n, r) {
  let i = ``;
  for (let e = parseInt(t); e < parseInt(n); e++) {
    i += r.replace(/\[\s*i\s*\]/g, `[ ${e} ]`).replace(/UNROLLED_LOOP_INDEX/g, e);
  }
  return i;
}
function Vw(e) {
  let t = `precision ${e.precision} float;
	precision ${e.precision} int;
	precision ${e.precision} sampler2D;
	precision ${e.precision} samplerCube;
	precision ${e.precision} sampler3D;
	precision ${e.precision} sampler2DArray;
	precision ${e.precision} sampler2DShadow;
	precision ${e.precision} samplerCubeShadow;
	precision ${e.precision} sampler2DArrayShadow;
	precision ${e.precision} isampler2D;
	precision ${e.precision} isampler3D;
	precision ${e.precision} isamplerCube;
	precision ${e.precision} isampler2DArray;
	precision ${e.precision} usampler2D;
	precision ${e.precision} usampler3D;
	precision ${e.precision} usamplerCube;
	precision ${e.precision} usampler2DArray;
	`;
  if (e.precision === `highp`) {
    t += `
#define HIGH_PRECISION`;
  } else if (e.precision === `mediump`) {
    t += `
#define MEDIUM_PRECISION`;
  } else if (e.precision === `lowp`) {
    t += `
#define LOW_PRECISION`;
  }
  return t;
}
var Hw = {
  1: `SHADOWMAP_TYPE_PCF`,
  3: `SHADOWMAP_TYPE_VSM`
};
function Uw(e) {
  return Hw[e.shadowMapType] || `SHADOWMAP_TYPE_BASIC`;
}
var Ww = {
  301: `ENVMAP_TYPE_CUBE`,
  302: `ENVMAP_TYPE_CUBE`,
  306: `ENVMAP_TYPE_CUBE_UV`
};
function Gw(e) {
  if (e.envMap === false) {
    return `ENVMAP_TYPE_CUBE`;
  } else {
    return Ww[e.envMapMode] || `ENVMAP_TYPE_CUBE`;
  }
}
var Kw = {
  302: `ENVMAP_MODE_REFRACTION`
};
function qw(e) {
  if (e.envMap === false) {
    return `ENVMAP_MODE_REFLECTION`;
  } else {
    return Kw[e.envMapMode] || `ENVMAP_MODE_REFLECTION`;
  }
}
var Jw = {
  0: `ENVMAP_BLENDING_MULTIPLY`,
  1: `ENVMAP_BLENDING_MIX`,
  2: `ENVMAP_BLENDING_ADD`
};
function Yw(e) {
  if (e.envMap === false) {
    return `ENVMAP_BLENDING_NONE`;
  } else {
    return Jw[e.combine] || `ENVMAP_BLENDING_NONE`;
  }
}
function Xw(e) {
  let t = e.envMapCubeUVHeight;
  if (t === null) {
    return null;
  }
  let n = Math.log2(t) - 2;
  let r = 1 / t;
  return {
    texelWidth: 1 / (Math.max(2 ** n, 112) * 3),
    texelHeight: r,
    maxMip: n
  };
}
function Zw(e, t, n, r) {
  let i = e.getContext();
  let a = n.defines;
  let o = n.vertexShader;
  let s = n.fragmentShader;
  let c = Uw(n);
  let l = Gw(n);
  let u = qw(n);
  let d = Yw(n);
  let f = Xw(n);
  let p = Ow(n);
  let m = kw(a);
  let h = i.createProgram();
  let g;
  let _;
  let v = n.glslVersion ? `#version ${n.glslVersion}
` : ``;
  if (n.isRawShaderMaterial) {
    g = [`#define SHADER_TYPE ${n.shaderType}`, `#define SHADER_NAME ${n.shaderName}`, m].filter(jw).join(`
`);
    if (g.length > 0) {
      g += `
`;
    }
    _ = [`#define SHADER_TYPE ${n.shaderType}`, `#define SHADER_NAME ${n.shaderName}`, m].filter(jw).join(`
`);
    if (_.length > 0) {
      _ += `
`;
    }
  } else {
    g = [Vw(n), `#define SHADER_TYPE ${n.shaderType}`, `#define SHADER_NAME ${n.shaderName}`, m, n.extensionClipCullDistance ? `#define USE_CLIP_DISTANCE` : ``, n.batching ? `#define USE_BATCHING` : ``, n.batchingColor ? `#define USE_BATCHING_COLOR` : ``, n.instancing ? `#define USE_INSTANCING` : ``, n.instancingColor ? `#define USE_INSTANCING_COLOR` : ``, n.instancingMorph ? `#define USE_INSTANCING_MORPH` : ``, n.useFog && n.fog ? `#define USE_FOG` : ``, n.useFog && n.fogExp2 ? `#define FOG_EXP2` : ``, n.map ? `#define USE_MAP` : ``, n.envMap ? `#define USE_ENVMAP` : ``, n.envMap ? `#define ${u}` : ``, n.lightMap ? `#define USE_LIGHTMAP` : ``, n.aoMap ? `#define USE_AOMAP` : ``, n.bumpMap ? `#define USE_BUMPMAP` : ``, n.normalMap ? `#define USE_NORMALMAP` : ``, n.normalMapObjectSpace ? `#define USE_NORMALMAP_OBJECTSPACE` : ``, n.normalMapTangentSpace ? `#define USE_NORMALMAP_TANGENTSPACE` : ``, n.displacementMap ? `#define USE_DISPLACEMENTMAP` : ``, n.emissiveMap ? `#define USE_EMISSIVEMAP` : ``, n.anisotropy ? `#define USE_ANISOTROPY` : ``, n.anisotropyMap ? `#define USE_ANISOTROPYMAP` : ``, n.clearcoatMap ? `#define USE_CLEARCOATMAP` : ``, n.clearcoatRoughnessMap ? `#define USE_CLEARCOAT_ROUGHNESSMAP` : ``, n.clearcoatNormalMap ? `#define USE_CLEARCOAT_NORMALMAP` : ``, n.iridescenceMap ? `#define USE_IRIDESCENCEMAP` : ``, n.iridescenceThicknessMap ? `#define USE_IRIDESCENCE_THICKNESSMAP` : ``, n.specularMap ? `#define USE_SPECULARMAP` : ``, n.specularColorMap ? `#define USE_SPECULAR_COLORMAP` : ``, n.specularIntensityMap ? `#define USE_SPECULAR_INTENSITYMAP` : ``, n.roughnessMap ? `#define USE_ROUGHNESSMAP` : ``, n.metalnessMap ? `#define USE_METALNESSMAP` : ``, n.alphaMap ? `#define USE_ALPHAMAP` : ``, n.alphaHash ? `#define USE_ALPHAHASH` : ``, n.transmission ? `#define USE_TRANSMISSION` : ``, n.transmissionMap ? `#define USE_TRANSMISSIONMAP` : ``, n.thicknessMap ? `#define USE_THICKNESSMAP` : ``, n.sheenColorMap ? `#define USE_SHEEN_COLORMAP` : ``, n.sheenRoughnessMap ? `#define USE_SHEEN_ROUGHNESSMAP` : ``, n.mapUv ? `#define MAP_UV ${n.mapUv}` : ``, n.alphaMapUv ? `#define ALPHAMAP_UV ${n.alphaMapUv}` : ``, n.lightMapUv ? `#define LIGHTMAP_UV ${n.lightMapUv}` : ``, n.aoMapUv ? `#define AOMAP_UV ${n.aoMapUv}` : ``, n.emissiveMapUv ? `#define EMISSIVEMAP_UV ${n.emissiveMapUv}` : ``, n.bumpMapUv ? `#define BUMPMAP_UV ${n.bumpMapUv}` : ``, n.normalMapUv ? `#define NORMALMAP_UV ${n.normalMapUv}` : ``, n.displacementMapUv ? `#define DISPLACEMENTMAP_UV ${n.displacementMapUv}` : ``, n.metalnessMapUv ? `#define METALNESSMAP_UV ${n.metalnessMapUv}` : ``, n.roughnessMapUv ? `#define ROUGHNESSMAP_UV ${n.roughnessMapUv}` : ``, n.anisotropyMapUv ? `#define ANISOTROPYMAP_UV ${n.anisotropyMapUv}` : ``, n.clearcoatMapUv ? `#define CLEARCOATMAP_UV ${n.clearcoatMapUv}` : ``, n.clearcoatNormalMapUv ? `#define CLEARCOAT_NORMALMAP_UV ${n.clearcoatNormalMapUv}` : ``, n.clearcoatRoughnessMapUv ? `#define CLEARCOAT_ROUGHNESSMAP_UV ${n.clearcoatRoughnessMapUv}` : ``, n.iridescenceMapUv ? `#define IRIDESCENCEMAP_UV ${n.iridescenceMapUv}` : ``, n.iridescenceThicknessMapUv ? `#define IRIDESCENCE_THICKNESSMAP_UV ${n.iridescenceThicknessMapUv}` : ``, n.sheenColorMapUv ? `#define SHEEN_COLORMAP_UV ${n.sheenColorMapUv}` : ``, n.sheenRoughnessMapUv ? `#define SHEEN_ROUGHNESSMAP_UV ${n.sheenRoughnessMapUv}` : ``, n.specularMapUv ? `#define SPECULARMAP_UV ${n.specularMapUv}` : ``, n.specularColorMapUv ? `#define SPECULAR_COLORMAP_UV ${n.specularColorMapUv}` : ``, n.specularIntensityMapUv ? `#define SPECULAR_INTENSITYMAP_UV ${n.specularIntensityMapUv}` : ``, n.transmissionMapUv ? `#define TRANSMISSIONMAP_UV ${n.transmissionMapUv}` : ``, n.thicknessMapUv ? `#define THICKNESSMAP_UV ${n.thicknessMapUv}` : ``, n.vertexTangents && n.flatShading === false ? `#define USE_TANGENT` : ``, n.vertexNormals ? `#define HAS_NORMAL` : ``, n.vertexColors ? `#define USE_COLOR` : ``, n.vertexAlphas ? `#define USE_COLOR_ALPHA` : ``, n.vertexUv1s ? `#define USE_UV1` : ``, n.vertexUv2s ? `#define USE_UV2` : ``, n.vertexUv3s ? `#define USE_UV3` : ``, n.pointsUvs ? `#define USE_POINTS_UV` : ``, n.flatShading ? `#define FLAT_SHADED` : ``, n.skinning ? `#define USE_SKINNING` : ``, n.morphTargets ? `#define USE_MORPHTARGETS` : ``, n.morphNormals && n.flatShading === false ? `#define USE_MORPHNORMALS` : ``, n.morphColors ? `#define USE_MORPHCOLORS` : ``, n.morphTargetsCount > 0 ? `#define MORPHTARGETS_TEXTURE_STRIDE ${n.morphTextureStride}` : ``, n.morphTargetsCount > 0 ? `#define MORPHTARGETS_COUNT ${n.morphTargetsCount}` : ``, n.doubleSided ? `#define DOUBLE_SIDED` : ``, n.flipSided ? `#define FLIP_SIDED` : ``, n.shadowMapEnabled ? `#define USE_SHADOWMAP` : ``, n.shadowMapEnabled ? `#define ${c}` : ``, n.sizeAttenuation ? `#define USE_SIZEATTENUATION` : ``, n.numLightProbes > 0 ? `#define USE_LIGHT_PROBES` : ``, n.logarithmicDepthBuffer ? `#define USE_LOGARITHMIC_DEPTH_BUFFER` : ``, n.reversedDepthBuffer ? `#define USE_REVERSED_DEPTH_BUFFER` : ``, `uniform mat4 modelMatrix;`, `uniform mat4 modelViewMatrix;`, `uniform mat4 projectionMatrix;`, `uniform mat4 viewMatrix;`, `uniform mat3 normalMatrix;`, `uniform vec3 cameraPosition;`, `uniform bool isOrthographic;`, `#ifdef USE_INSTANCING`, `	attribute mat4 instanceMatrix;`, `#endif`, `#ifdef USE_INSTANCING_COLOR`, `	attribute vec3 instanceColor;`, `#endif`, `#ifdef USE_INSTANCING_MORPH`, `	uniform sampler2D morphTexture;`, `#endif`, `attribute vec3 position;`, `attribute vec3 normal;`, `attribute vec2 uv;`, `#ifdef USE_UV1`, `	attribute vec2 uv1;`, `#endif`, `#ifdef USE_UV2`, `	attribute vec2 uv2;`, `#endif`, `#ifdef USE_UV3`, `	attribute vec2 uv3;`, `#endif`, `#ifdef USE_TANGENT`, `	attribute vec4 tangent;`, `#endif`, `#if defined( USE_COLOR_ALPHA )`, `	attribute vec4 color;`, `#elif defined( USE_COLOR )`, `	attribute vec3 color;`, `#endif`, `#ifdef USE_SKINNING`, `	attribute vec4 skinIndex;`, `	attribute vec4 skinWeight;`, `#endif`, `
`].filter(jw).join(`
`);
    _ = [Vw(n), `#define SHADER_TYPE ${n.shaderType}`, `#define SHADER_NAME ${n.shaderName}`, m, n.useFog && n.fog ? `#define USE_FOG` : ``, n.useFog && n.fogExp2 ? `#define FOG_EXP2` : ``, n.alphaToCoverage ? `#define ALPHA_TO_COVERAGE` : ``, n.map ? `#define USE_MAP` : ``, n.matcap ? `#define USE_MATCAP` : ``, n.envMap ? `#define USE_ENVMAP` : ``, n.envMap ? `#define ${l}` : ``, n.envMap ? `#define ${u}` : ``, n.envMap ? `#define ${d}` : ``, f ? `#define CUBEUV_TEXEL_WIDTH ${f.texelWidth}` : ``, f ? `#define CUBEUV_TEXEL_HEIGHT ${f.texelHeight}` : ``, f ? `#define CUBEUV_MAX_MIP ${f.maxMip}.0` : ``, n.lightMap ? `#define USE_LIGHTMAP` : ``, n.aoMap ? `#define USE_AOMAP` : ``, n.bumpMap ? `#define USE_BUMPMAP` : ``, n.normalMap ? `#define USE_NORMALMAP` : ``, n.normalMapObjectSpace ? `#define USE_NORMALMAP_OBJECTSPACE` : ``, n.normalMapTangentSpace ? `#define USE_NORMALMAP_TANGENTSPACE` : ``, n.packedNormalMap ? `#define USE_PACKED_NORMALMAP` : ``, n.emissiveMap ? `#define USE_EMISSIVEMAP` : ``, n.anisotropy ? `#define USE_ANISOTROPY` : ``, n.anisotropyMap ? `#define USE_ANISOTROPYMAP` : ``, n.clearcoat ? `#define USE_CLEARCOAT` : ``, n.clearcoatMap ? `#define USE_CLEARCOATMAP` : ``, n.clearcoatRoughnessMap ? `#define USE_CLEARCOAT_ROUGHNESSMAP` : ``, n.clearcoatNormalMap ? `#define USE_CLEARCOAT_NORMALMAP` : ``, n.dispersion ? `#define USE_DISPERSION` : ``, n.retroreflection ? `#define USE_RETROREFLECTION` : ``, n.iridescence ? `#define USE_IRIDESCENCE` : ``, n.iridescenceMap ? `#define USE_IRIDESCENCEMAP` : ``, n.iridescenceThicknessMap ? `#define USE_IRIDESCENCE_THICKNESSMAP` : ``, n.specularMap ? `#define USE_SPECULARMAP` : ``, n.specularColorMap ? `#define USE_SPECULAR_COLORMAP` : ``, n.specularIntensityMap ? `#define USE_SPECULAR_INTENSITYMAP` : ``, n.roughnessMap ? `#define USE_ROUGHNESSMAP` : ``, n.metalnessMap ? `#define USE_METALNESSMAP` : ``, n.alphaMap ? `#define USE_ALPHAMAP` : ``, n.alphaTest ? `#define USE_ALPHATEST` : ``, n.alphaHash ? `#define USE_ALPHAHASH` : ``, n.sheen ? `#define USE_SHEEN` : ``, n.sheenColorMap ? `#define USE_SHEEN_COLORMAP` : ``, n.sheenRoughnessMap ? `#define USE_SHEEN_ROUGHNESSMAP` : ``, n.transmission ? `#define USE_TRANSMISSION` : ``, n.transmissionMap ? `#define USE_TRANSMISSIONMAP` : ``, n.thicknessMap ? `#define USE_THICKNESSMAP` : ``, n.vertexTangents && n.flatShading === false ? `#define USE_TANGENT` : ``, n.vertexColors || n.instancingColor ? `#define USE_COLOR` : ``, n.vertexAlphas || n.batchingColor ? `#define USE_COLOR_ALPHA` : ``, n.vertexUv1s ? `#define USE_UV1` : ``, n.vertexUv2s ? `#define USE_UV2` : ``, n.vertexUv3s ? `#define USE_UV3` : ``, n.pointsUvs ? `#define USE_POINTS_UV` : ``, n.gradientMap ? `#define USE_GRADIENTMAP` : ``, n.flatShading ? `#define FLAT_SHADED` : ``, n.doubleSided ? `#define DOUBLE_SIDED` : ``, n.flipSided ? `#define FLIP_SIDED` : ``, n.shadowMapEnabled ? `#define USE_SHADOWMAP` : ``, n.shadowMapEnabled ? `#define ${c}` : ``, n.premultipliedAlpha ? `#define PREMULTIPLIED_ALPHA` : ``, n.numLightProbes > 0 ? `#define USE_LIGHT_PROBES` : ``, n.numLightProbeGrids > 0 ? `#define USE_LIGHT_PROBES_GRID` : ``, n.decodeVideoTexture ? `#define DECODE_VIDEO_TEXTURE` : ``, n.decodeVideoTextureEmissive ? `#define DECODE_VIDEO_TEXTURE_EMISSIVE` : ``, n.logarithmicDepthBuffer ? `#define USE_LOGARITHMIC_DEPTH_BUFFER` : ``, n.reversedDepthBuffer ? `#define USE_REVERSED_DEPTH_BUFFER` : ``, `uniform mat4 viewMatrix;`, `uniform vec3 cameraPosition;`, `uniform bool isOrthographic;`, n.toneMapping === 0 ? `` : `#define TONE_MAPPING`, n.toneMapping === 0 ? `` : SS.tonemapping_pars_fragment, n.toneMapping === 0 ? `` : Tw(`toneMapping`, n.toneMapping), n.dithering ? `#define DITHERING` : ``, n.opaque ? `#define OPAQUE` : ``, SS.colorspace_pars_fragment, Cw(`linearToOutputTexel`, n.outputColorSpace), Dw(), n.useDepthPacking ? `#define DEPTH_PACKING ${n.depthPacking}` : ``, `
`].filter(jw).join(`
`);
  }
  o = Fw(o);
  o = Mw(o, n);
  o = Nw(o, n);
  s = Fw(s);
  s = Mw(s, n);
  s = Nw(s, n);
  o = zw(o);
  s = zw(s);
  if (n.isRawShaderMaterial !== true) {
    v = `#version 300 es
`;
    g = `${[p, `#define attribute in`, `#define varying out`, `#define texture2D texture`].join(`
`)}
${g}`;
    _ = `${[`#define varying in`, n.glslVersion === `300 es` ? `` : `layout(location = 0) out highp vec4 pc_fragColor;`, n.glslVersion === `300 es` ? `` : `#define gl_FragColor pc_fragColor`, `#define gl_FragDepthEXT gl_FragDepth`, `#define texture2D texture`, `#define textureCube texture`, `#define texture2DProj textureProj`, `#define texture2DLodEXT textureLod`, `#define texture2DProjLodEXT textureProjLod`, `#define textureCubeLodEXT textureLod`, `#define texture2DGradEXT textureGrad`, `#define texture2DProjGradEXT textureProjGrad`, `#define textureCubeGradEXT textureGrad`].join(`
`)}
${_}`;
  }
  let y = v + g + o;
  let b = v + _ + s;
  let x = gw(i, i.VERTEX_SHADER, y);
  let S = gw(i, i.FRAGMENT_SHADER, b);
  i.attachShader(h, x);
  i.attachShader(h, S);
  if (n.index0AttributeName === undefined) {
    if (n.hasPositionAttribute === true) {
      i.bindAttribLocation(h, 0, `position`);
    }
  } else {
    i.bindAttribLocation(h, 0, n.index0AttributeName);
  }
  i.linkProgram(h);
  function C(t) {
    if (e.debug.checkShaderErrors) {
      let n = i.getProgramInfoLog(h) || ``;
      let r = i.getShaderInfoLog(x) || ``;
      let a = i.getShaderInfoLog(S) || ``;
      let o = n.trim();
      let s = r.trim();
      let c = a.trim();
      let l = true;
      let u = true;
      if (i.getProgramParameter(h, i.LINK_STATUS) === false) {
        l = false;
        if (typeof e.debug.onShaderError == `function`) {
          e.debug.onShaderError(i, h, x, S);
        } else {
          let e = Sw(i, x, `vertex`);
          let n = Sw(i, S, `fragment`);
          Wg(`WebGLProgram: Shader Error ${i.getError()} - VALIDATE_STATUS ${i.getProgramParameter(h, i.VALIDATE_STATUS)}

Material Name: ${t.name}
Material Type: ${t.type}

Program Info Log: ${o}
${e}
${n}`);
        }
      } else if (o === ``) {
        if (s === `` || c === ``) {
          u = false;
        }
      } else {
        Ug(`WebGLProgram: Program Info Log:`, o);
      }
      if (u) {
        t.diagnostics = {
          runnable: l,
          programLog: o,
          vertexShader: {
            log: s,
            prefix: g
          },
          fragmentShader: {
            log: c,
            prefix: _
          }
        };
      }
    }
    i.deleteShader(x);
    i.deleteShader(S);
    w = new hw(i, h);
    T = Aw(i, h);
  }
  let w;
  this.getUniforms = function () {
    if (w === undefined) {
      C(this);
    }
    return w;
  };
  let T;
  this.getAttributes = function () {
    if (T === undefined) {
      C(this);
    }
    return T;
  };
  let E = n.rendererExtensionParallelShaderCompile === false;
  this.isReady = function () {
    if (E === false) {
      E = i.getProgramParameter(h, _w);
    }
    return E;
  };
  this.destroy = function () {
    r.releaseStatesOfProgram(this);
    i.deleteProgram(h);
    this.program = undefined;
  };
  this.type = n.shaderType;
  this.name = n.shaderName;
  this.id = vw++;
  this.cacheKey = t;
  this.usedTimes = 1;
  this.program = h;
  this.vertexShader = x;
  this.fragmentShader = S;
  return this;
}
var Qw = 0;
var $w = class {
  constructor() {
    this.shaderCache = new Map();
    this.materialCache = new Map();
  }
  update(e, t, n) {
    let r = this._getShaderCacheForMaterial(e);
    if (r.has(t) === false) {
      r.add(t);
      t.usedTimes++;
    }
    if (r.has(n) === false) {
      r.add(n);
      n.usedTimes++;
    }
    return this;
  }
  remove(e) {
    let t = this.materialCache.get(e);
    for (let e of t) {
      e.usedTimes--;
      if (e.usedTimes === 0) {
        this.shaderCache.delete(e.code);
      }
    }
    this.materialCache.delete(e);
    return this;
  }
  getVertexShaderStage(e) {
    return this._getShaderStage(e.vertexShader);
  }
  getFragmentShaderStage(e) {
    return this._getShaderStage(e.fragmentShader);
  }
  dispose() {
    this.shaderCache.clear();
    this.materialCache.clear();
  }
  _getShaderCacheForMaterial(e) {
    let t = this.materialCache;
    let n = t.get(e);
    if (n === undefined) {
      n = new Set();
      t.set(e, n);
    }
    return n;
  }
  _getShaderStage(e) {
    let t = this.shaderCache;
    let n = t.get(e);
    if (n === undefined) {
      n = new eT(e);
      t.set(e, n);
    }
    return n;
  }
};
var eT = class {
  constructor(e) {
    this.id = Qw++;
    this.code = e;
    this.usedTimes = 0;
  }
};
function tT(e) {
  return e === 1030 || e === 37490 || e === 36285;
}
function nT(e, t, n, r, i, a) {
  let o = new iv();
  let s = new $w();
  let c = new Set();
  let l = [];
  let u = new Map();
  let d = r.logarithmicDepthBuffer;
  let f = r.precision;
  let p = {
    MeshDepthMaterial: `depth`,
    MeshDistanceMaterial: `distance`,
    MeshNormalMaterial: `normal`,
    MeshBasicMaterial: `basic`,
    MeshLambertMaterial: `lambert`,
    MeshPhongMaterial: `phong`,
    MeshToonMaterial: `toon`,
    MeshStandardMaterial: `physical`,
    MeshPhysicalMaterial: `physical`,
    MeshMatcapMaterial: `matcap`,
    LineBasicMaterial: `basic`,
    LineDashedMaterial: `dashed`,
    PointsMaterial: `points`,
    ShadowMaterial: `shadow`,
    SpriteMaterial: `sprite`
  };
  function m(e) {
    c.add(e);
    if (e === 0) {
      return `uv`;
    } else {
      return `uv${e}`;
    }
  }
  function h(i, o, l, u, h, g) {
    let _ = u.fog;
    let v = h.geometry;
    let y = i.isMeshStandardMaterial || i.isMeshLambertMaterial || i.isMeshPhongMaterial ? u.environment : null;
    let b = i.isMeshStandardMaterial || i.isMeshLambertMaterial && !i.envMap || i.isMeshPhongMaterial && !i.envMap;
    let x = t.get(i.envMap || y, b);
    let S = x && x.mapping === 306 ? x.image.height : null;
    let C = p[i.type];
    if (i.precision !== null) {
      f = r.getMaxPrecision(i.precision);
      if (f !== i.precision) {
        Ug(`WebGLProgram.getParameters:`, i.precision, `not supported, using`, f, `instead.`);
      }
    }
    let w = v.morphAttributes.position || v.morphAttributes.normal || v.morphAttributes.color;
    let T = w === undefined ? 0 : w.length;
    let E = 0;
    if (v.morphAttributes.position !== undefined) {
      E = 1;
    }
    if (v.morphAttributes.normal !== undefined) {
      E = 2;
    }
    if (v.morphAttributes.color !== undefined) {
      E = 3;
    }
    let D;
    let O;
    let k;
    let A;
    if (C) {
      let e = CS[C];
      D = e.vertexShader;
      O = e.fragmentShader;
    } else {
      D = i.vertexShader;
      O = i.fragmentShader;
      let e = s.getVertexShaderStage(i);
      let t = s.getFragmentShaderStage(i);
      s.update(i, e, t);
      k = e.id;
      A = t.id;
    }
    let ee = e.getRenderTarget();
    let te = e.state.buffers.depth.getReversed();
    let j = h.isInstancedMesh === true;
    let ne = h.isBatchedMesh === true;
    let re = !!i.map;
    let M = !!i.matcap;
    let ie = !!x;
    let ae = !!i.aoMap;
    let oe = !!i.lightMap;
    let se = !!i.bumpMap && i.wireframe === false;
    let ce = !!i.normalMap;
    let le = !!i.displacementMap;
    let ue = !!i.emissiveMap;
    let de = !!i.metalnessMap;
    let fe = !!i.roughnessMap;
    let pe = i.anisotropy > 0;
    let me = i.clearcoat > 0;
    let N = i.dispersion > 0;
    let he = i.retroreflectivity > 0;
    let ge = i.iridescence > 0;
    let _e = i.sheen > 0;
    let ve = i.transmission > 0;
    let ye = pe && !!i.anisotropyMap;
    let be = me && !!i.clearcoatMap;
    let xe = me && !!i.clearcoatNormalMap;
    let Se = me && !!i.clearcoatRoughnessMap;
    let Ce = ge && !!i.iridescenceMap;
    let P = ge && !!i.iridescenceThicknessMap;
    let we = _e && !!i.sheenColorMap;
    let F = _e && !!i.sheenRoughnessMap;
    let Te = !!i.specularMap;
    let I = !!i.specularColorMap;
    let Ee = !!i.specularIntensityMap;
    let L = ve && !!i.transmissionMap;
    let De = ve && !!i.thicknessMap;
    let R = !!i.gradientMap;
    let z = !!i.alphaMap;
    let Oe = i.alphaTest > 0;
    let ke = !!i.alphaHash;
    let Ae = !!i.extensions;
    let je = 0;
    if (i.toneMapped && (ee === null || ee.isXRRenderTarget === true)) {
      je = e.toneMapping;
    }
    let Me = {
      shaderID: C,
      shaderType: i.type,
      shaderName: i.name,
      vertexShader: D,
      fragmentShader: O,
      defines: i.defines,
      customVertexShaderID: k,
      customFragmentShaderID: A,
      isRawShaderMaterial: i.isRawShaderMaterial === true,
      glslVersion: i.glslVersion,
      precision: f,
      batching: ne,
      batchingColor: ne && h._colorsTexture !== null,
      instancing: j,
      instancingColor: j && h.instanceColor !== null,
      instancingMorph: j && h.morphTexture !== null,
      outputColorSpace: ee === null ? e.outputColorSpace : ee.isXRRenderTarget === true ? ee.texture.colorSpace : j_.workingColorSpace,
      alphaToCoverage: !!i.alphaToCoverage,
      map: re,
      matcap: M,
      envMap: ie,
      envMapMode: ie && x.mapping,
      envMapCubeUVHeight: S,
      aoMap: ae,
      lightMap: oe,
      bumpMap: se,
      normalMap: ce,
      displacementMap: le,
      emissiveMap: ue,
      normalMapObjectSpace: ce && i.normalMapType === 1,
      normalMapTangentSpace: ce && i.normalMapType === 0,
      packedNormalMap: ce && i.normalMapType === 0 && tT(i.normalMap.format),
      metalnessMap: de,
      roughnessMap: fe,
      anisotropy: pe,
      anisotropyMap: ye,
      clearcoat: me,
      clearcoatMap: be,
      clearcoatNormalMap: xe,
      clearcoatRoughnessMap: Se,
      dispersion: N,
      retroreflection: he,
      iridescence: ge,
      iridescenceMap: Ce,
      iridescenceThicknessMap: P,
      sheen: _e,
      sheenColorMap: we,
      sheenRoughnessMap: F,
      specularMap: Te,
      specularColorMap: I,
      specularIntensityMap: Ee,
      transmission: ve,
      transmissionMap: L,
      thicknessMap: De,
      gradientMap: R,
      opaque: i.transparent === false && i.blending === 1 && i.alphaToCoverage === false,
      alphaMap: z,
      alphaTest: Oe,
      alphaHash: ke,
      combine: i.combine,
      mapUv: re && m(i.map.channel),
      aoMapUv: ae && m(i.aoMap.channel),
      lightMapUv: oe && m(i.lightMap.channel),
      bumpMapUv: se && m(i.bumpMap.channel),
      normalMapUv: ce && m(i.normalMap.channel),
      displacementMapUv: le && m(i.displacementMap.channel),
      emissiveMapUv: ue && m(i.emissiveMap.channel),
      metalnessMapUv: de && m(i.metalnessMap.channel),
      roughnessMapUv: fe && m(i.roughnessMap.channel),
      anisotropyMapUv: ye && m(i.anisotropyMap.channel),
      clearcoatMapUv: be && m(i.clearcoatMap.channel),
      clearcoatNormalMapUv: xe && m(i.clearcoatNormalMap.channel),
      clearcoatRoughnessMapUv: Se && m(i.clearcoatRoughnessMap.channel),
      iridescenceMapUv: Ce && m(i.iridescenceMap.channel),
      iridescenceThicknessMapUv: P && m(i.iridescenceThicknessMap.channel),
      sheenColorMapUv: we && m(i.sheenColorMap.channel),
      sheenRoughnessMapUv: F && m(i.sheenRoughnessMap.channel),
      specularMapUv: Te && m(i.specularMap.channel),
      specularColorMapUv: I && m(i.specularColorMap.channel),
      specularIntensityMapUv: Ee && m(i.specularIntensityMap.channel),
      transmissionMapUv: L && m(i.transmissionMap.channel),
      thicknessMapUv: De && m(i.thicknessMap.channel),
      alphaMapUv: z && m(i.alphaMap.channel),
      vertexTangents: !!v.attributes.tangent && (ce || pe),
      vertexNormals: !!v.attributes.normal,
      vertexColors: i.vertexColors,
      vertexAlphas: i.vertexColors === true && !!v.attributes.color && v.attributes.color.itemSize === 4,
      pointsUvs: h.isPoints === true && !!v.attributes.uv && (re || z),
      fog: !!_,
      useFog: i.fog === true,
      fogExp2: !!_ && _.isFogExp2,
      flatShading: i.wireframe === false && (i.flatShading === true || v.attributes.normal === undefined && ce === false && (i.isMeshLambertMaterial || i.isMeshPhongMaterial || i.isMeshStandardMaterial || i.isMeshPhysicalMaterial)),
      sizeAttenuation: i.sizeAttenuation === true,
      logarithmicDepthBuffer: d,
      reversedDepthBuffer: te,
      skinning: h.isSkinnedMesh === true,
      hasPositionAttribute: v.attributes.position !== undefined,
      morphTargets: v.morphAttributes.position !== undefined,
      morphNormals: v.morphAttributes.normal !== undefined,
      morphColors: v.morphAttributes.color !== undefined,
      morphTargetsCount: T,
      morphTextureStride: E,
      numSunLights: o.sun.length,
      numDirLights: o.directional.length,
      numPointLights: o.point.length,
      numSpotLights: o.spot.length,
      numSpotLightMaps: o.spotLightMap.length,
      numRectAreaLights: o.rectArea.length,
      numHemiLights: o.hemi.length,
      numSunLightShadows: o.sunShadowMap.length,
      numDirLightShadows: o.directionalShadowMap.length,
      numPointLightShadows: o.pointShadowMap.length,
      numSpotLightShadows: o.spotShadowMap.length,
      numSpotLightShadowsWithMaps: o.numSpotLightShadowsWithMaps,
      numLightProbes: o.numLightProbes,
      numLightProbeGrids: g.length,
      numClippingPlanes: a.numPlanes,
      numClipIntersection: a.numIntersection,
      dithering: i.dithering,
      shadowMapEnabled: e.shadowMap.enabled && l.length > 0,
      shadowMapType: e.shadowMap.type,
      toneMapping: je,
      decodeVideoTexture: re && i.map.isVideoTexture === true && j_.getTransfer(i.map.colorSpace) === `srgb`,
      decodeVideoTextureEmissive: ue && i.emissiveMap.isVideoTexture === true && j_.getTransfer(i.emissiveMap.colorSpace) === `srgb`,
      premultipliedAlpha: i.premultipliedAlpha,
      doubleSided: i.side === 2,
      flipSided: i.side === 1,
      useDepthPacking: i.depthPacking >= 0,
      depthPacking: i.depthPacking || 0,
      index0AttributeName: i.index0AttributeName,
      extensionClipCullDistance: Ae && i.extensions.clipCullDistance === true && n.has(`WEBGL_clip_cull_distance`),
      extensionMultiDraw: (Ae && i.extensions.multiDraw === true || ne) && n.has(`WEBGL_multi_draw`),
      rendererExtensionParallelShaderCompile: n.has(`KHR_parallel_shader_compile`),
      customProgramCacheKey: i.customProgramCacheKey()
    };
    Me.vertexUv1s = c.has(1);
    Me.vertexUv2s = c.has(2);
    Me.vertexUv3s = c.has(3);
    c.clear();
    return Me;
  }
  function g(t) {
    let n = [];
    if (t.shaderID) {
      n.push(t.shaderID);
    } else {
      n.push(t.customVertexShaderID);
      n.push(t.customFragmentShaderID);
    }
    if (t.defines !== undefined) {
      for (let e in t.defines) {
        n.push(e);
        n.push(t.defines[e]);
      }
    }
    if (t.isRawShaderMaterial === false) {
      _(n, t);
      v(n, t);
      n.push(e.outputColorSpace);
    }
    n.push(t.customProgramCacheKey);
    return n.join();
  }
  function _(e, t) {
    e.push(t.precision);
    e.push(t.outputColorSpace);
    e.push(t.envMapMode);
    e.push(t.envMapCubeUVHeight);
    e.push(t.mapUv);
    e.push(t.alphaMapUv);
    e.push(t.lightMapUv);
    e.push(t.aoMapUv);
    e.push(t.bumpMapUv);
    e.push(t.normalMapUv);
    e.push(t.displacementMapUv);
    e.push(t.emissiveMapUv);
    e.push(t.metalnessMapUv);
    e.push(t.roughnessMapUv);
    e.push(t.anisotropyMapUv);
    e.push(t.clearcoatMapUv);
    e.push(t.clearcoatNormalMapUv);
    e.push(t.clearcoatRoughnessMapUv);
    e.push(t.iridescenceMapUv);
    e.push(t.iridescenceThicknessMapUv);
    e.push(t.sheenColorMapUv);
    e.push(t.sheenRoughnessMapUv);
    e.push(t.specularMapUv);
    e.push(t.specularColorMapUv);
    e.push(t.specularIntensityMapUv);
    e.push(t.transmissionMapUv);
    e.push(t.thicknessMapUv);
    e.push(t.combine);
    e.push(t.fogExp2);
    e.push(t.sizeAttenuation);
    e.push(t.morphTargetsCount);
    e.push(t.morphAttributeCount);
    e.push(t.numSunLights);
    e.push(t.numDirLights);
    e.push(t.numPointLights);
    e.push(t.numSpotLights);
    e.push(t.numSpotLightMaps);
    e.push(t.numHemiLights);
    e.push(t.numRectAreaLights);
    e.push(t.numSunLightShadows);
    e.push(t.numDirLightShadows);
    e.push(t.numPointLightShadows);
    e.push(t.numSpotLightShadows);
    e.push(t.numSpotLightShadowsWithMaps);
    e.push(t.numLightProbes);
    e.push(t.shadowMapType);
    e.push(t.toneMapping);
    e.push(t.numClippingPlanes);
    e.push(t.numClipIntersection);
    e.push(t.depthPacking);
  }
  function v(e, t) {
    o.disableAll();
    if (t.instancing) {
      o.enable(0);
    }
    if (t.instancingColor) {
      o.enable(1);
    }
    if (t.instancingMorph) {
      o.enable(2);
    }
    if (t.matcap) {
      o.enable(3);
    }
    if (t.envMap) {
      o.enable(4);
    }
    if (t.normalMapObjectSpace) {
      o.enable(5);
    }
    if (t.normalMapTangentSpace) {
      o.enable(6);
    }
    if (t.clearcoat) {
      o.enable(7);
    }
    if (t.iridescence) {
      o.enable(8);
    }
    if (t.alphaTest) {
      o.enable(9);
    }
    if (t.vertexColors) {
      o.enable(10);
    }
    if (t.vertexAlphas) {
      o.enable(11);
    }
    if (t.vertexUv1s) {
      o.enable(12);
    }
    if (t.vertexUv2s) {
      o.enable(13);
    }
    if (t.vertexUv3s) {
      o.enable(14);
    }
    if (t.vertexTangents) {
      o.enable(15);
    }
    if (t.anisotropy) {
      o.enable(16);
    }
    if (t.alphaHash) {
      o.enable(17);
    }
    if (t.batching) {
      o.enable(18);
    }
    if (t.dispersion) {
      o.enable(19);
    }
    if (t.retroreflection) {
      o.enable(24);
    }
    if (t.batchingColor) {
      o.enable(20);
    }
    if (t.gradientMap) {
      o.enable(21);
    }
    if (t.packedNormalMap) {
      o.enable(22);
    }
    if (t.vertexNormals) {
      o.enable(23);
    }
    e.push(o.mask);
    o.disableAll();
    if (t.fog) {
      o.enable(0);
    }
    if (t.useFog) {
      o.enable(1);
    }
    if (t.flatShading) {
      o.enable(2);
    }
    if (t.logarithmicDepthBuffer) {
      o.enable(3);
    }
    if (t.reversedDepthBuffer) {
      o.enable(4);
    }
    if (t.skinning) {
      o.enable(5);
    }
    if (t.morphTargets) {
      o.enable(6);
    }
    if (t.morphNormals) {
      o.enable(7);
    }
    if (t.morphColors) {
      o.enable(8);
    }
    if (t.premultipliedAlpha) {
      o.enable(9);
    }
    if (t.shadowMapEnabled) {
      o.enable(10);
    }
    if (t.doubleSided) {
      o.enable(11);
    }
    if (t.flipSided) {
      o.enable(12);
    }
    if (t.useDepthPacking) {
      o.enable(13);
    }
    if (t.dithering) {
      o.enable(14);
    }
    if (t.transmission) {
      o.enable(15);
    }
    if (t.sheen) {
      o.enable(16);
    }
    if (t.opaque) {
      o.enable(17);
    }
    if (t.pointsUvs) {
      o.enable(18);
    }
    if (t.decodeVideoTexture) {
      o.enable(19);
    }
    if (t.decodeVideoTextureEmissive) {
      o.enable(20);
    }
    if (t.alphaToCoverage) {
      o.enable(21);
    }
    if (t.numLightProbeGrids > 0) {
      o.enable(22);
    }
    if (t.hasPositionAttribute) {
      o.enable(23);
    }
    e.push(o.mask);
  }
  function y(e) {
    let t = p[e.type];
    let n;
    if (t) {
      let e = CS[t];
      n = $b.clone(e.uniforms);
    } else {
      n = e.uniforms;
    }
    return n;
  }
  function b(t, n) {
    let r = u.get(n);
    if (r === undefined) {
      r = new Zw(e, n, t, i);
      l.push(r);
      u.set(n, r);
    } else {
      ++r.usedTimes;
    }
    return r;
  }
  function x(e) {
    if (--e.usedTimes === 0) {
      let t = l.indexOf(e);
      l[t] = l[l.length - 1];
      l.pop();
      u.delete(e.cacheKey);
      e.destroy();
    }
  }
  function S(e) {
    s.remove(e);
  }
  function C() {
    s.dispose();
  }
  return {
    getParameters: h,
    getProgramCacheKey: g,
    getUniforms: y,
    acquireProgram: b,
    releaseProgram: x,
    releaseShaderCache: S,
    programs: l,
    dispose: C
  };
}
function rT() {
  let e = new WeakMap();
  function t(t) {
    return e.has(t);
  }
  function n(t) {
    let n = e.get(t);
    if (n === undefined) {
      n = {};
      e.set(t, n);
    }
    return n;
  }
  function r(t) {
    e.delete(t);
  }
  function i(t, n, r) {
    e.get(t)[n] = r;
  }
  function a() {
    e = new WeakMap();
  }
  return {
    has: t,
    get: n,
    remove: r,
    update: i,
    dispose: a
  };
}
function iT(e, t) {
  if (e.groupOrder === t.groupOrder) {
    if (e.renderOrder === t.renderOrder) {
      if (e.material.id === t.material.id) {
        if (e.materialVariant === t.materialVariant) {
          if (e.z === t.z) {
            return e.id - t.id;
          } else {
            return e.z - t.z;
          }
        } else {
          return e.materialVariant - t.materialVariant;
        }
      } else {
        return e.material.id - t.material.id;
      }
    } else {
      return e.renderOrder - t.renderOrder;
    }
  } else {
    return e.groupOrder - t.groupOrder;
  }
}
function aT(e, t) {
  if (e.groupOrder === t.groupOrder) {
    if (e.renderOrder === t.renderOrder) {
      if (e.z === t.z) {
        return e.id - t.id;
      } else {
        return t.z - e.z;
      }
    } else {
      return e.renderOrder - t.renderOrder;
    }
  } else {
    return e.groupOrder - t.groupOrder;
  }
}
function oT() {
  let e = [];
  let t = 0;
  let n = [];
  let r = [];
  let i = [];
  function a() {
    t = 0;
    n.length = 0;
    r.length = 0;
    i.length = 0;
  }
  function o(e) {
    let t = 0;
    if (e.isInstancedMesh) {
      t += 2;
    }
    if (e.isSkinnedMesh) {
      t += 1;
    }
    return t;
  }
  function s(n, r, i, a, s, c) {
    let l = e[t];
    if (l === undefined) {
      l = {
        id: n.id,
        object: n,
        geometry: r,
        material: i,
        materialVariant: o(n),
        groupOrder: a,
        renderOrder: n.renderOrder,
        z: s,
        group: c
      };
      e[t] = l;
    } else {
      l.id = n.id;
      l.object = n;
      l.geometry = r;
      l.material = i;
      l.materialVariant = o(n);
      l.groupOrder = a;
      l.renderOrder = n.renderOrder;
      l.z = s;
      l.group = c;
    }
    t++;
    return l;
  }
  function c(e, t, a, o, c, l, u) {
    if (u.reversedDepth === true) {
      c = -c;
    }
    let d = s(e, t, a, o, c, l);
    if (a.transmission > 0) {
      r.push(d);
    } else if (a.transparent === true) {
      i.push(d);
    } else {
      n.push(d);
    }
  }
  function l(e, t, a, o, c, l) {
    let u = s(e, t, a, o, c, l);
    if (a.transmission > 0) {
      r.unshift(u);
    } else if (a.transparent === true) {
      i.unshift(u);
    } else {
      n.unshift(u);
    }
  }
  function u(e, t) {
    if (n.length > 1) {
      n.sort(e || iT);
    }
    if (r.length > 1) {
      r.sort(t || aT);
    }
    if (i.length > 1) {
      i.sort(t || aT);
    }
  }
  function d() {
    for (let n = t, r = e.length; n < r; n++) {
      let t = e[n];
      if (t.id === null) {
        break;
      }
      t.id = null;
      t.object = null;
      t.geometry = null;
      t.material = null;
      t.group = null;
    }
  }
  return {
    opaque: n,
    transmissive: r,
    transparent: i,
    init: a,
    push: c,
    unshift: l,
    finish: d,
    sort: u
  };
}
function sT() {
  let e = new WeakMap();
  function t(t, n) {
    let r = e.get(t);
    let i;
    if (r === undefined) {
      i = new oT();
      e.set(t, [i]);
    } else if (n >= r.length) {
      i = new oT();
      r.push(i);
    } else {
      i = r[n];
    }
    return i;
  }
  function n() {
    e = new WeakMap();
  }
  return {
    get: t,
    dispose: n
  };
}
function cT() {
  let e = {};
  return {
    get: function (t) {
      if (e[t.id] !== undefined) {
        return e[t.id];
      }
      let n;
      switch (t.type) {
        case `SunLight`:
        case `DirectionalLight`:
          n = {
            direction: new X(),
            color: new Ov()
          };
          break;
        case `SpotLight`:
          n = {
            position: new X(),
            direction: new X(),
            color: new Ov(),
            distance: 0,
            coneCos: 0,
            penumbraCos: 0,
            decay: 0
          };
          break;
        case `PointLight`:
          n = {
            position: new X(),
            color: new Ov(),
            distance: 0,
            decay: 0
          };
          break;
        case `HemisphereLight`:
          n = {
            direction: new X(),
            skyColor: new Ov(),
            groundColor: new Ov()
          };
          break;
        case `RectAreaLight`:
          n = {
            color: new Ov(),
            position: new X(),
            halfWidth: new X(),
            halfHeight: new X()
          };
      }
      e[t.id] = n;
      return n;
    }
  };
}
function lT() {
  let e = {};
  return {
    get: function (t) {
      if (e[t.id] !== undefined) {
        return e[t.id];
      }
      let n;
      switch (t.type) {
        case `SunLight`:
        case `DirectionalLight`:
          n = {
            shadowIntensity: 1,
            shadowBias: 0,
            shadowNormalBias: 0,
            shadowRadius: 1,
            shadowMapSize: new S_()
          };
          break;
        case `SpotLight`:
          n = {
            shadowIntensity: 1,
            shadowBias: 0,
            shadowNormalBias: 0,
            shadowRadius: 1,
            shadowMapSize: new S_()
          };
          break;
        case `PointLight`:
          n = {
            shadowIntensity: 1,
            shadowBias: 0,
            shadowNormalBias: 0,
            shadowRadius: 1,
            shadowMapSize: new S_(),
            shadowCameraNear: 1,
            shadowCameraFar: 1000
          };
      }
      e[t.id] = n;
      return n;
    }
  };
}
var uT = 0;
function dT(e, t) {
  return (t.castShadow ? 2 : 0) - (e.castShadow ? 2 : 0) + +!!t.map - !!e.map;
}
function fT(e) {
  let t = new cT();
  let n = lT();
  let r = {
    version: 0,
    hash: {
      sunLength: -1,
      directionalLength: -1,
      pointLength: -1,
      spotLength: -1,
      rectAreaLength: -1,
      hemiLength: -1,
      numSunShadows: -1,
      numDirectionalShadows: -1,
      numPointShadows: -1,
      numSpotShadows: -1,
      numSpotMaps: -1,
      numLightProbes: -1
    },
    ambient: [0, 0, 0],
    probe: [],
    sun: [],
    sunShadow: [],
    sunShadowMap: [],
    sunShadowMatrix: [],
    sunShadowCascade: [],
    directional: [],
    directionalShadow: [],
    directionalShadowMap: [],
    directionalShadowMatrix: [],
    spot: [],
    spotLightMap: [],
    spotShadow: [],
    spotShadowMap: [],
    spotLightMatrix: [],
    rectArea: [],
    rectAreaLTC1: null,
    rectAreaLTC2: null,
    point: [],
    pointShadow: [],
    pointShadowMap: [],
    pointShadowMatrix: [],
    hemi: [],
    numSpotLightShadowsWithMaps: 0,
    numLightProbes: 0
  };
  for (let e = 0; e < 9; e++) {
    r.probe.push(new X());
  }
  let i = new X();
  let a = new q_();
  let o = new q_();
  function s(i) {
    let a = 0;
    let o = 0;
    let s = 0;
    for (let e = 0; e < 9; e++) {
      r.probe[e].set(0, 0, 0);
    }
    let c = 0;
    let l = 0;
    let u = 0;
    let d = 0;
    let f = 0;
    let p = 0;
    let m = 0;
    let h = 0;
    let g = 0;
    let _ = 0;
    let v = 0;
    let y = 0;
    let b = 0;
    let x = 0;
    i.sort(dT);
    for (let e = 0, S = i.length; e < S; e++) {
      let S = i[e];
      let C = S.color;
      let w = S.intensity;
      let T = S.distance;
      let E = null;
      if (S.shadow && S.shadow.map) {
        E = S.shadow.map.texture.format === 1030 ? S.shadow.map.texture : S.shadow.map.depthTexture || S.shadow.map.texture;
      }
      if (S.isAmbientLight) {
        a += C.r * w;
        o += C.g * w;
        s += C.b * w;
      } else if (S.isLightProbe) {
        for (let e = 0; e < 9; e++) {
          r.probe[e].addScaledVector(S.sh.coefficients[e], w);
        }
        x++;
      } else if (S.isSunLight) {
        let e = t.get(S);
        e.color.copy(S.color).multiplyScalar(S.intensity);
        if (S.castShadow) {
          let e = S.shadow;
          let t = n.get(S);
          t.shadowIntensity = e.intensity;
          t.shadowBias = e.bias;
          t.shadowNormalBias = e.normalBias;
          t.shadowRadius = e.radius;
          t.shadowMapSize.copy(e.mapSize).multiply(e.getFrameExtents());
          r.sunShadow[l] = t;
          r.sunShadowMap[l] = E;
          let i = e.getViewportCount();
          for (let t = 0; t < i; t++) {
            r.sunShadowMatrix[u + t] = e.getMatrix(t);
            r.sunShadowCascade[u + t] = e._cascadeData[t];
          }
          u += i;
          l++;
        }
        r.sun[c] = e;
        c++;
      } else if (S.isDirectionalLight) {
        let e = t.get(S);
        e.color.copy(S.color).multiplyScalar(S.intensity);
        if (S.castShadow) {
          let e = S.shadow;
          let t = n.get(S);
          t.shadowIntensity = e.intensity;
          t.shadowBias = e.bias;
          t.shadowNormalBias = e.normalBias;
          t.shadowRadius = e.radius;
          t.shadowMapSize = e.mapSize;
          r.directionalShadow[d] = t;
          r.directionalShadowMap[d] = E;
          r.directionalShadowMatrix[d] = S.shadow.matrix;
          g++;
        }
        r.directional[d] = e;
        d++;
      } else if (S.isSpotLight) {
        let e = t.get(S);
        e.position.setFromMatrixPosition(S.matrixWorld);
        e.color.copy(C).multiplyScalar(w);
        e.distance = T;
        e.coneCos = Math.cos(S.angle);
        e.penumbraCos = Math.cos(S.angle * (1 - S.penumbra));
        e.decay = S.decay;
        r.spot[p] = e;
        let i = S.shadow;
        if (S.map) {
          r.spotLightMap[y] = S.map;
          y++;
          i.updateMatrices(S);
          if (S.castShadow) {
            b++;
          }
        }
        r.spotLightMatrix[p] = i.matrix;
        if (S.castShadow) {
          let e = n.get(S);
          e.shadowIntensity = i.intensity;
          e.shadowBias = i.bias;
          e.shadowNormalBias = i.normalBias;
          e.shadowRadius = i.radius;
          e.shadowMapSize = i.mapSize;
          r.spotShadow[p] = e;
          r.spotShadowMap[p] = E;
          v++;
        }
        p++;
      } else if (S.isRectAreaLight) {
        let e = t.get(S);
        e.color.copy(C).multiplyScalar(w);
        e.halfWidth.set(S.width * 0.5, 0, 0);
        e.halfHeight.set(0, S.height * 0.5, 0);
        r.rectArea[m] = e;
        m++;
      } else if (S.isPointLight) {
        let e = t.get(S);
        e.color.copy(S.color).multiplyScalar(S.intensity);
        e.distance = S.distance;
        e.decay = S.decay;
        if (S.castShadow) {
          let e = S.shadow;
          let t = n.get(S);
          t.shadowIntensity = e.intensity;
          t.shadowBias = e.bias;
          t.shadowNormalBias = e.normalBias;
          t.shadowRadius = e.radius;
          t.shadowMapSize = e.mapSize;
          t.shadowCameraNear = e.camera.near;
          t.shadowCameraFar = e.camera.far;
          r.pointShadow[f] = t;
          r.pointShadowMap[f] = E;
          r.pointShadowMatrix[f] = S.shadow.matrix;
          _++;
        }
        r.point[f] = e;
        f++;
      } else if (S.isHemisphereLight) {
        let e = t.get(S);
        e.skyColor.copy(S.color).multiplyScalar(w);
        e.groundColor.copy(S.groundColor).multiplyScalar(w);
        r.hemi[h] = e;
        h++;
      }
    }
    if (m > 0) {
      if (e.has(`OES_texture_float_linear`) === true) {
        r.rectAreaLTC1 = Z.LTC_FLOAT_1;
        r.rectAreaLTC2 = Z.LTC_FLOAT_2;
      } else {
        r.rectAreaLTC1 = Z.LTC_HALF_1;
        r.rectAreaLTC2 = Z.LTC_HALF_2;
      }
    }
    r.ambient[0] = a;
    r.ambient[1] = o;
    r.ambient[2] = s;
    let S = r.hash;
    if (S.sunLength !== c || S.directionalLength !== d || S.pointLength !== f || S.spotLength !== p || S.rectAreaLength !== m || S.hemiLength !== h || S.numSunShadows !== l || S.numDirectionalShadows !== g || S.numPointShadows !== _ || S.numSpotShadows !== v || S.numSpotMaps !== y || S.numLightProbes !== x) {
      r.sun.length = c;
      r.directional.length = d;
      r.spot.length = p;
      r.rectArea.length = m;
      r.point.length = f;
      r.hemi.length = h;
      r.sunShadow.length = l;
      r.sunShadowMap.length = l;
      r.sunShadowMatrix.length = u;
      r.sunShadowCascade.length = u;
      r.directionalShadow.length = g;
      r.directionalShadowMap.length = g;
      r.directionalShadowMatrix.length = g;
      r.pointShadow.length = _;
      r.pointShadowMap.length = _;
      r.pointShadowMatrix.length = _;
      r.spotShadow.length = v;
      r.spotShadowMap.length = v;
      r.spotLightMatrix.length = v + y - b;
      r.spotLightMap.length = y;
      r.numSpotLightShadowsWithMaps = b;
      r.numLightProbes = x;
      S.sunLength = c;
      S.directionalLength = d;
      S.pointLength = f;
      S.spotLength = p;
      S.rectAreaLength = m;
      S.hemiLength = h;
      S.numSunShadows = l;
      S.numDirectionalShadows = g;
      S.numPointShadows = _;
      S.numSpotShadows = v;
      S.numSpotMaps = y;
      S.numLightProbes = x;
      r.version = uT++;
    }
  }
  function c(e, t) {
    let n = 0;
    let s = 0;
    let c = 0;
    let l = 0;
    let u = 0;
    let d = 0;
    let f = t.matrixWorldInverse;
    for (let t = 0, p = e.length; t < p; t++) {
      let p = e[t];
      if (p.isSunLight) {
        let e = r.sun[n];
        e.direction.setFromMatrixPosition(p.matrixWorld);
        e.direction.transformDirection(f);
        n++;
      } else if (p.isDirectionalLight) {
        let e = r.directional[s];
        e.direction.setFromMatrixPosition(p.matrixWorld);
        i.setFromMatrixPosition(p.target.matrixWorld);
        e.direction.sub(i);
        e.direction.transformDirection(f);
        s++;
      } else if (p.isSpotLight) {
        let e = r.spot[l];
        e.position.setFromMatrixPosition(p.matrixWorld);
        e.position.applyMatrix4(f);
        e.direction.setFromMatrixPosition(p.matrixWorld);
        i.setFromMatrixPosition(p.target.matrixWorld);
        e.direction.sub(i);
        e.direction.transformDirection(f);
        l++;
      } else if (p.isRectAreaLight) {
        let e = r.rectArea[u];
        e.position.setFromMatrixPosition(p.matrixWorld);
        e.position.applyMatrix4(f);
        o.identity();
        a.copy(p.matrixWorld);
        a.premultiply(f);
        o.extractRotation(a);
        e.halfWidth.set(p.width * 0.5, 0, 0);
        e.halfHeight.set(0, p.height * 0.5, 0);
        e.halfWidth.applyMatrix4(o);
        e.halfHeight.applyMatrix4(o);
        u++;
      } else if (p.isPointLight) {
        let e = r.point[c];
        e.position.setFromMatrixPosition(p.matrixWorld);
        e.position.applyMatrix4(f);
        c++;
      } else if (p.isHemisphereLight) {
        let e = r.hemi[d];
        e.direction.setFromMatrixPosition(p.matrixWorld);
        e.direction.transformDirection(f);
        d++;
      }
    }
  }
  return {
    setup: s,
    setupView: c,
    state: r
  };
}
function pT(e) {
  let t = new fT(e);
  let n = [];
  let r = [];
  let i = [];
  function a(e) {
    d.camera = e;
    n.length = 0;
    r.length = 0;
    i.length = 0;
  }
  function o(e) {
    n.push(e);
  }
  function s(e) {
    r.push(e);
  }
  function c(e) {
    i.push(e);
  }
  function l() {
    t.setup(n);
  }
  function u(e) {
    t.setupView(n, e);
  }
  let d = {
    lightsArray: n,
    shadowsArray: r,
    lightProbeGridArray: i,
    camera: null,
    lights: t,
    transmissionRenderTarget: {},
    textureUnits: 0
  };
  return {
    init: a,
    state: d,
    setupLights: l,
    setupLightsView: u,
    pushLight: o,
    pushShadow: s,
    pushLightProbeGrid: c
  };
}
function mT(e) {
  let t = new WeakMap();
  function n(n, r = 0) {
    let i = t.get(n);
    let a;
    if (i === undefined) {
      a = new pT(e);
      t.set(n, [a]);
    } else if (r >= i.length) {
      a = new pT(e);
      i.push(a);
    } else {
      a = i[r];
    }
    return a;
  }
  function r() {
    t = new WeakMap();
  }
  return {
    get: n,
    dispose: r
  };
}
var hT = `void main() {
	gl_Position = vec4( position, 1.0 );
}`;
var gT = `uniform sampler2D shadow_pass;
uniform vec2 resolution;
uniform float radius;
void main() {
	const float samples = float( VSM_SAMPLES );
	float mean = 0.0;
	float squared_mean = 0.0;
	float uvStride = samples <= 1.0 ? 0.0 : 2.0 / ( samples - 1.0 );
	float uvStart = samples <= 1.0 ? 0.0 : - 1.0;
	for ( float i = 0.0; i < samples; i ++ ) {
		float uvOffset = uvStart + i * uvStride;
		#ifdef HORIZONTAL_PASS
			vec2 distribution = texture2D( shadow_pass, ( gl_FragCoord.xy + vec2( uvOffset, 0.0 ) * radius ) / resolution ).rg;
			mean += distribution.x;
			squared_mean += distribution.y * distribution.y + distribution.x * distribution.x;
		#else
			float depth = texture2D( shadow_pass, ( gl_FragCoord.xy + vec2( 0.0, uvOffset ) * radius ) / resolution ).r;
			mean += depth;
			squared_mean += depth * depth;
		#endif
	}
	mean = mean / samples;
	squared_mean = squared_mean / samples;
	float std_dev = sqrt( max( 0.0, squared_mean - mean * mean ) );
	gl_FragColor = vec4( mean, std_dev, 0.0, 1.0 );
}`;
var _T = [new X(1, 0, 0), new X(-1, 0, 0), new X(0, 1, 0), new X(0, -1, 0), new X(0, 0, 1), new X(0, 0, -1)];
var vT = [new X(0, -1, 0), new X(0, -1, 0), new X(0, 0, 1), new X(0, 0, -1), new X(0, -1, 0), new X(0, -1, 0)];
var yT = new q_();
var bT = new X();
var xT = new X();
function ST(e, t, n) {
  let r = new bb();
  let i = new S_();
  let a = new S_();
  let o = new H_();
  let s = new ax();
  let c = new ox();
  let l = {};
  let u = n.maxTextureSize;
  let d = {
    0: 1,
    1: 0,
    2: 2
  };
  let f = new nx({
    defines: {
      VSM_SAMPLES: 8
    },
    uniforms: {
      shadow_pass: {
        value: null
      },
      resolution: {
        value: new S_()
      },
      radius: {
        value: 4
      }
    },
    vertexShader: hT,
    fragmentShader: gT
  });
  let p = f.clone();
  p.defines.HORIZONTAL_PASS = 1;
  let m = new wy();
  m.setAttribute(`position`, new ly(new Float32Array([-1, -1, 0.5, 3, -1, 0.5, -1, 3, 0.5]), 3));
  let h = new pb(m, f);
  let g = this;
  this.enabled = false;
  this.autoUpdate = true;
  this.needsUpdate = false;
  this.type = 1;
  let _ = this.type;
  this.render = function (t, n, s) {
    if (g.enabled === false || g.autoUpdate === false && g.needsUpdate === false || t.length === 0) {
      return;
    }
    if (this.type === 2) {
      Ug(`WebGLShadowMap: PCFSoftShadowMap has been removed. Using PCFShadowMap instead.`);
      this.type = 1;
    }
    let c = e.getRenderTarget();
    let l = e.getActiveCubeFace();
    let d = e.getActiveMipmapLevel();
    let f = e.state;
    f.setBlending(0);
    if (f.buffers.depth.getReversed() === true) {
      f.buffers.color.setClear(0, 0, 0, 0);
    } else {
      f.buffers.color.setClear(1, 1, 1, 1);
    }
    f.buffers.depth.setTest(true);
    f.setScissorTest(false);
    let p = _ !== this.type;
    if (p) {
      n.traverse(function (e) {
        if (e.material) {
          if (Array.isArray(e.material)) {
            e.material.forEach(e => e.needsUpdate = true);
          } else {
            e.material.needsUpdate = true;
          }
        }
      });
    }
    for (let c = 0, l = t.length; c < l; c++) {
      let l = t[c];
      let d = l.shadow;
      if (d === undefined) {
        Ug(`WebGLShadowMap:`, l, `has no shadow.`);
        continue;
      }
      if (d.autoUpdate === false && d.needsUpdate === false) {
        continue;
      }
      i.copy(d.mapSize);
      let m = d.getFrameExtents();
      i.multiply(m);
      a.copy(d.mapSize);
      if (i.x > u || i.y > u) {
        if (i.x > u) {
          a.x = Math.floor(u / m.x);
          i.x = a.x * m.x;
          d.mapSize.x = a.x;
        }
        if (i.y > u) {
          a.y = Math.floor(u / m.y);
          i.y = a.y * m.y;
          d.mapSize.y = a.y;
        }
      }
      let h = e.state.buffers.depth.getReversed();
      d.camera._reversedDepth = h;
      if (d.map === null || p === true) {
        if (d.map !== null) {
          if (d.map.depthTexture !== null) {
            d.map.depthTexture.dispose();
            d.map.depthTexture = null;
          }
          d.map.dispose();
        }
        if (this.type === 3) {
          if (l.isPointLight) {
            Ug(`WebGLShadowMap: VSM shadow maps are not supported for PointLights. Use PCF or BasicShadowMap instead.`);
            continue;
          }
          d.map = new W_(i.x, i.y, {
            format: Ih,
            type: Ch,
            minFilter: ph,
            magFilter: ph,
            generateMipmaps: false
          });
          d.map.texture.name = `${l.name}.shadowMap`;
          d.map.depthTexture = new Ib(i.x, i.y, Sh);
          d.map.depthTexture.name = `${l.name}.shadowMapDepth`;
          d.map.depthTexture.format = Mh;
          d.map.depthTexture.compareFunction = null;
          d.map.depthTexture.minFilter = uh;
          d.map.depthTexture.magFilter = uh;
        } else {
          if (l.isPointLight) {
            d.map = new $S(i.x);
            d.map.depthTexture = new Lb(i.x, xh);
          } else {
            d.map = new W_(i.x, i.y);
            d.map.depthTexture = new Ib(i.x, i.y, xh);
          }
          d.map.depthTexture.name = `${l.name}.shadowMap`;
          d.map.depthTexture.format = Mh;
          if (this.type === 1) {
            d.map.depthTexture.compareFunction = h ? 518 : 515;
            d.map.depthTexture.minFilter = ph;
            d.map.depthTexture.magFilter = ph;
          } else {
            d.map.depthTexture.compareFunction = null;
            d.map.depthTexture.minFilter = uh;
            d.map.depthTexture.magFilter = uh;
          }
        }
        d.camera.updateProjectionMatrix();
      }
      if (d.map.isWebGLCubeRenderTarget !== true && (d.map.width !== i.x || d.map.height !== i.y)) {
        d.map.setSize(i.x, i.y);
      }
      let g = d.map.isWebGLCubeRenderTarget ? 6 : d.getViewportCount();
      if (l.isPointLight !== true) {
        d.updateMatrices(l, s);
      }
      for (let t = 0; t < g; t++) {
        let i = d.getCamera(t);
        if (l.isPointLight) {
          let e = d.camera;
          let n = d.matrix;
          let r = l.distance || e.far;
          if (r !== e.far) {
            e.far = r;
            e.updateProjectionMatrix();
          }
          bT.setFromMatrixPosition(l.matrixWorld);
          e.position.copy(bT);
          xT.copy(e.position);
          xT.add(_T[t]);
          e.up.copy(vT[t]);
          e.lookAt(xT);
          e.updateMatrixWorld();
          n.makeTranslation(-bT.x, -bT.y, -bT.z);
          yT.multiplyMatrices(e.projectionMatrix, e.matrixWorldInverse);
          d._frustum.setFromProjectionMatrix(yT, e.coordinateSystem, e.reversedDepth);
        }
        if (d.map.isWebGLCubeRenderTarget) {
          e.setRenderTarget(d.map, t);
          e.clear();
        } else {
          if (t === 0) {
            e.setRenderTarget(d.map);
            e.clear();
          }
          let n = d.getViewport(t);
          o.set(a.x * n.x, a.y * n.y, a.x * n.z, a.y * n.w);
          f.viewport(o);
        }
        r = d.getFrustum(t);
        b(n, s, i, l, this.type);
      }
      if (d.isPointLightShadow !== true && this.type === 3) {
        v(d, s);
      }
      d.needsUpdate = false;
    }
    _ = this.type;
    g.needsUpdate = false;
    e.setRenderTarget(c, l, d);
  };
  function v(n, r) {
    let a = t.update(h);
    if (f.defines.VSM_SAMPLES !== n.blurSamples) {
      f.defines.VSM_SAMPLES = n.blurSamples;
      p.defines.VSM_SAMPLES = n.blurSamples;
      f.needsUpdate = true;
      p.needsUpdate = true;
    }
    if (n.mapPass === null) {
      n.mapPass = new W_(i.x, i.y, {
        format: Ih,
        type: Ch
      });
    } else if (n.mapPass.width !== n.map.width || n.mapPass.height !== n.map.height) {
      n.mapPass.setSize(n.map.width, n.map.height);
    }
    f.uniforms.shadow_pass.value = n.map.depthTexture;
    f.uniforms.resolution.value.set(n.map.width, n.map.height);
    f.uniforms.radius.value = n.radius;
    e.setRenderTarget(n.mapPass);
    e.clear();
    e.renderBufferDirect(r, null, a, f, h, null);
    p.uniforms.shadow_pass.value = n.mapPass.texture;
    p.uniforms.resolution.value.set(n.map.width, n.map.height);
    p.uniforms.radius.value = n.radius;
    e.setRenderTarget(n.map);
    e.clear();
    e.renderBufferDirect(r, null, a, p, h, null);
  }
  function y(t, n, r, i) {
    let a = null;
    let o = r.isPointLight === true ? t.customDistanceMaterial : t.customDepthMaterial;
    if (o !== undefined) {
      a = o;
    } else {
      a = r.isPointLight === true ? c : s;
      if (e.localClippingEnabled && n.clipShadows === true && Array.isArray(n.clippingPlanes) && n.clippingPlanes.length !== 0 || n.displacementMap && n.displacementScale !== 0 || n.alphaMap && n.alphaTest > 0 || n.map && n.alphaTest > 0 || n.alphaToCoverage === true) {
        let e = a.uuid;
        let t = n.uuid;
        let r = l[e];
        if (r === undefined) {
          r = {};
          l[e] = r;
        }
        let i = r[t];
        if (i === undefined) {
          i = a.clone();
          r[t] = i;
          n.addEventListener(`dispose`, x);
        }
        a = i;
      }
    }
    a.visible = n.visible;
    a.wireframe = n.wireframe;
    if (i === 3) {
      a.side = n.shadowSide === null ? n.side : n.shadowSide;
    } else {
      a.side = n.shadowSide === null ? d[n.side] : n.shadowSide;
    }
    a.alphaMap = n.alphaMap;
    a.alphaTest = n.alphaToCoverage === true ? 0.5 : n.alphaTest;
    a.map = n.map;
    a.clipShadows = n.clipShadows;
    a.clippingPlanes = n.clippingPlanes;
    a.clipIntersection = n.clipIntersection;
    a.displacementMap = n.displacementMap;
    a.displacementScale = n.displacementScale;
    a.displacementBias = n.displacementBias;
    a.wireframeLinewidth = n.wireframeLinewidth;
    a.linewidth = n.linewidth;
    if (r.isPointLight === true && a.isMeshDistanceMaterial === true) {
      let t = e.properties.get(a);
      t.light = r;
    }
    return a;
  }
  function b(n, i, a, o, s) {
    if (n.visible === false) {
      return;
    }
    if (n.layers.test(i.layers) && (n.isMesh || n.isLine || n.isPoints) && (n.castShadow || n.receiveShadow && s === 3) && (!n.frustumCulled || n.intersectsFrustum(r))) {
      n.modelViewMatrix.multiplyMatrices(a.matrixWorldInverse, n.matrixWorld);
      let r = t.update(n);
      let c = n.material;
      if (Array.isArray(c)) {
        let t = r.groups;
        for (let l = 0, u = t.length; l < u; l++) {
          let u = t[l];
          let d = c[u.materialIndex];
          if (d && d.visible) {
            let t = y(n, d, o, s);
            n.onBeforeShadow(e, n, i, a, r, t, u);
            e.renderBufferDirect(a, null, r, t, n, u);
            n.onAfterShadow(e, n, i, a, r, t, u);
          }
        }
      } else if (c.visible) {
        let t = y(n, c, o, s);
        n.onBeforeShadow(e, n, i, a, r, t, null);
        e.renderBufferDirect(a, null, r, t, n, null);
        n.onAfterShadow(e, n, i, a, r, t, null);
      }
    }
    let c = n.children;
    for (let e = 0, t = c.length; e < t; e++) {
      b(c[e], i, a, o, s);
    }
  }
  function x(e) {
    e.target.removeEventListener(`dispose`, x);
    for (let t in l) {
      let n = l[t];
      let r = e.target.uuid;
      if (r in n) {
        n[r].dispose();
        delete n[r];
      }
    }
  }
}
function CT(e, t) {
  function n() {
    let t = false;
    let n = new H_();
    let r = null;
    let i = new H_(0, 0, 0, 0);
    return {
      setMask: function (n) {
        if (r !== n && !t) {
          e.colorMask(n, n, n, n);
          r = n;
        }
      },
      setLocked: function (e) {
        t = e;
      },
      setClear: function (t, r, a, o, s) {
        if (s === true) {
          t *= o;
          r *= o;
          a *= o;
        }
        n.set(t, r, a, o);
        if (i.equals(n) === false) {
          e.clearColor(t, r, a, o);
          i.copy(n);
        }
      },
      reset: function () {
        t = false;
        r = null;
        i.set(-1, 0, 0, 0);
      }
    };
  }
  function r() {
    let n = false;
    let r = false;
    let i = null;
    let a = null;
    let o = null;
    return {
      setReversed: function (e) {
        if (r !== e) {
          let n = t.get(`EXT_clip_control`);
          if (e) {
            n.clipControlEXT(n.LOWER_LEFT_EXT, n.ZERO_TO_ONE_EXT);
          } else {
            n.clipControlEXT(n.LOWER_LEFT_EXT, n.NEGATIVE_ONE_TO_ONE_EXT);
          }
          r = e;
          let i = o;
          o = null;
          this.setClear(i);
        }
      },
      getReversed: function () {
        return r;
      },
      setTest: function (t) {
        if (t) {
          de(e.DEPTH_TEST);
        } else {
          fe(e.DEPTH_TEST);
        }
      },
      setMask: function (t) {
        if (i !== t && !n) {
          e.depthMask(t);
          i = t;
        }
      },
      setFunc: function (t) {
        if (r) {
          t = qg[t];
        }
        if (a !== t) {
          switch (t) {
            case 0:
              e.depthFunc(e.NEVER);
              break;
            case 1:
              e.depthFunc(e.ALWAYS);
              break;
            case 2:
              e.depthFunc(e.LESS);
              break;
            case 3:
              e.depthFunc(e.LEQUAL);
              break;
            case 4:
              e.depthFunc(e.EQUAL);
              break;
            case 5:
              e.depthFunc(e.GEQUAL);
              break;
            case 6:
              e.depthFunc(e.GREATER);
              break;
            case 7:
              e.depthFunc(e.NOTEQUAL);
              break;
            default:
              e.depthFunc(e.LEQUAL);
          }
          a = t;
        }
      },
      setLocked: function (e) {
        n = e;
      },
      setClear: function (t) {
        if (o !== t) {
          o = t;
          if (r) {
            t = 1 - t;
          }
          e.clearDepth(t);
        }
      },
      reset: function () {
        n = false;
        i = null;
        a = null;
        o = null;
        r = false;
      }
    };
  }
  function i() {
    let t = false;
    let n = null;
    let r = null;
    let i = null;
    let a = null;
    let o = null;
    let s = null;
    let c = null;
    let l = null;
    return {
      setTest: function (n) {
        if (!t) {
          if (n) {
            de(e.STENCIL_TEST);
          } else {
            fe(e.STENCIL_TEST);
          }
        }
      },
      setMask: function (r) {
        if (n !== r && !t) {
          e.stencilMask(r);
          n = r;
        }
      },
      setFunc: function (t, n, o) {
        if (r !== t || i !== n || a !== o) {
          e.stencilFunc(t, n, o);
          r = t;
          i = n;
          a = o;
        }
      },
      setOp: function (t, n, r) {
        if (o !== t || s !== n || c !== r) {
          e.stencilOp(t, n, r);
          o = t;
          s = n;
          c = r;
        }
      },
      setLocked: function (e) {
        t = e;
      },
      setClear: function (t) {
        if (l !== t) {
          e.clearStencil(t);
          l = t;
        }
      },
      reset: function () {
        t = false;
        n = null;
        r = null;
        i = null;
        a = null;
        o = null;
        s = null;
        c = null;
        l = null;
      }
    };
  }
  let a = new n();
  let o = new r();
  let s = new i();
  let c = new WeakMap();
  let l = new WeakMap();
  let u = {};
  let d = {};
  let f = {};
  let p = new WeakMap();
  let m = [];
  let h = null;
  let g = false;
  let _ = null;
  let v = null;
  let y = null;
  let b = null;
  let x = null;
  let S = null;
  let C = null;
  let w = new Ov(0, 0, 0);
  let T = 0;
  let E = false;
  let D = null;
  let O = null;
  let k = null;
  let A = null;
  let ee = null;
  let te = e.getParameter(e.MAX_COMBINED_TEXTURE_IMAGE_UNITS);
  let j = false;
  let ne = 0;
  let re = e.getParameter(e.VERSION);
  if (re.indexOf(`WebGL`) === -1) {
    if (re.indexOf(`OpenGL ES`) !== -1) {
      ne = parseFloat(/^OpenGL ES (\d)/.exec(re)[1]);
      j = ne >= 2;
    }
  } else {
    ne = parseFloat(/^WebGL (\d)/.exec(re)[1]);
    j = ne >= 1;
  }
  let M = null;
  let ie = {};
  let ae = e.getParameter(e.SCISSOR_BOX);
  let oe = e.getParameter(e.VIEWPORT);
  let se = new H_().fromArray(ae);
  let ce = new H_().fromArray(oe);
  function le(t, n, r, i) {
    let a = new Uint8Array(4);
    let o = e.createTexture();
    e.bindTexture(t, o);
    e.texParameteri(t, e.TEXTURE_MIN_FILTER, e.NEAREST);
    e.texParameteri(t, e.TEXTURE_MAG_FILTER, e.NEAREST);
    for (let o = 0; o < r; o++) {
      if (t === e.TEXTURE_3D || t === e.TEXTURE_2D_ARRAY) {
        e.texImage3D(n, 0, e.RGBA, 1, 1, i, 0, e.RGBA, e.UNSIGNED_BYTE, a);
      } else {
        e.texImage2D(n + o, 0, e.RGBA, 1, 1, 0, e.RGBA, e.UNSIGNED_BYTE, a);
      }
    }
    return o;
  }
  let ue = {};
  ue[e.TEXTURE_2D] = le(e.TEXTURE_2D, e.TEXTURE_2D, 1);
  ue[e.TEXTURE_CUBE_MAP] = le(e.TEXTURE_CUBE_MAP, e.TEXTURE_CUBE_MAP_POSITIVE_X, 6);
  ue[e.TEXTURE_2D_ARRAY] = le(e.TEXTURE_2D_ARRAY, e.TEXTURE_2D_ARRAY, 1, 1);
  ue[e.TEXTURE_3D] = le(e.TEXTURE_3D, e.TEXTURE_3D, 1, 1);
  a.setClear(0, 0, 0, 1);
  o.setClear(1);
  s.setClear(0);
  de(e.DEPTH_TEST);
  o.setFunc(3);
  ye(false);
  be(1);
  de(e.CULL_FACE);
  _e(0);
  function de(t) {
    if (u[t] !== true) {
      e.enable(t);
      u[t] = true;
    }
  }
  function fe(t) {
    if (u[t] !== false) {
      e.disable(t);
      u[t] = false;
    }
  }
  function pe(t, n) {
    return f[t] !== n && (e.bindFramebuffer(t, n), f[t] = n, t === e.DRAW_FRAMEBUFFER && (f[e.FRAMEBUFFER] = n), t === e.FRAMEBUFFER && (f[e.DRAW_FRAMEBUFFER] = n), true);
  }
  function me(t, n) {
    let r = m;
    let i = false;
    if (t) {
      r = p.get(n);
      if (r === undefined) {
        r = [];
        p.set(n, r);
      }
      let a = t.textures;
      if (r.length !== a.length || r[0] !== e.COLOR_ATTACHMENT0) {
        for (let t = 0, n = a.length; t < n; t++) {
          r[t] = e.COLOR_ATTACHMENT0 + t;
        }
        r.length = a.length;
        i = true;
      }
    } else if (r[0] !== e.BACK) {
      r[0] = e.BACK;
      i = true;
    }
    if (i) {
      e.drawBuffers(r);
    }
  }
  function N(t) {
    return h !== t && (e.useProgram(t), h = t, true);
  }
  let he = {
    100: e.FUNC_ADD,
    101: e.FUNC_SUBTRACT,
    102: e.FUNC_REVERSE_SUBTRACT
  };
  he[103] = e.MIN;
  he[104] = e.MAX;
  let ge = {
    200: e.ZERO,
    201: e.ONE,
    202: e.SRC_COLOR,
    204: e.SRC_ALPHA,
    210: e.SRC_ALPHA_SATURATE,
    208: e.DST_COLOR,
    206: e.DST_ALPHA,
    203: e.ONE_MINUS_SRC_COLOR,
    205: e.ONE_MINUS_SRC_ALPHA,
    209: e.ONE_MINUS_DST_COLOR,
    207: e.ONE_MINUS_DST_ALPHA,
    211: e.CONSTANT_COLOR,
    212: e.ONE_MINUS_CONSTANT_COLOR,
    213: e.CONSTANT_ALPHA,
    214: e.ONE_MINUS_CONSTANT_ALPHA
  };
  function _e(t, n, r, i, a, o, s, c, l, u) {
    if (t === 0) {
      if (g === true) {
        fe(e.BLEND);
        g = false;
      }
      return;
    }
    if (g === false) {
      de(e.BLEND);
      g = true;
    }
    if (t !== 5) {
      if (t !== _ || u !== E) {
        if (v !== 100 || x !== 100) {
          e.blendEquation(e.FUNC_ADD);
          v = 100;
          x = 100;
        }
        if (u) {
          switch (t) {
            case 1:
              e.blendFuncSeparate(e.ONE, e.ONE_MINUS_SRC_ALPHA, e.ONE, e.ONE_MINUS_SRC_ALPHA);
              break;
            case 2:
              e.blendFunc(e.ONE, e.ONE);
              break;
            case 3:
              e.blendFuncSeparate(e.ZERO, e.ONE_MINUS_SRC_COLOR, e.ZERO, e.ONE);
              break;
            case 4:
              e.blendFuncSeparate(e.DST_COLOR, e.ONE_MINUS_SRC_ALPHA, e.ZERO, e.ONE);
              break;
            default:
              Wg(`WebGLState: Invalid blending: `, t);
          }
        } else {
          switch (t) {
            case 1:
              e.blendFuncSeparate(e.SRC_ALPHA, e.ONE_MINUS_SRC_ALPHA, e.ONE, e.ONE_MINUS_SRC_ALPHA);
              break;
            case 2:
              e.blendFuncSeparate(e.SRC_ALPHA, e.ONE, e.ONE, e.ONE);
              break;
            case 3:
              Wg(`WebGLState: SubtractiveBlending requires material.premultipliedAlpha = true`);
              break;
            case 4:
              Wg(`WebGLState: MultiplyBlending requires material.premultipliedAlpha = true`);
              break;
            default:
              Wg(`WebGLState: Invalid blending: `, t);
          }
        }
        y = null;
        b = null;
        S = null;
        C = null;
        w.set(0, 0, 0);
        T = 0;
        _ = t;
        E = u;
      }
      return;
    }
    a ||= n;
    o ||= r;
    s ||= i;
    if (n !== v || a !== x) {
      e.blendEquationSeparate(he[n], he[a]);
      v = n;
      x = a;
    }
    if (r !== y || i !== b || o !== S || s !== C) {
      e.blendFuncSeparate(ge[r], ge[i], ge[o], ge[s]);
      y = r;
      b = i;
      S = o;
      C = s;
    }
    if (c.equals(w) === false || l !== T) {
      e.blendColor(c.r, c.g, c.b, l);
      w.copy(c);
      T = l;
    }
    _ = t;
    E = false;
  }
  function ve(t, n) {
    if (t.side === 2) {
      fe(e.CULL_FACE);
    } else {
      de(e.CULL_FACE);
    }
    let r = t.side === 1;
    if (n) {
      r = !r;
    }
    ye(r);
    if (t.blending === 1 && t.transparent === false) {
      _e(0);
    } else {
      _e(t.blending, t.blendEquation, t.blendSrc, t.blendDst, t.blendEquationAlpha, t.blendSrcAlpha, t.blendDstAlpha, t.blendColor, t.blendAlpha, t.premultipliedAlpha);
    }
    o.setFunc(t.depthFunc);
    o.setTest(t.depthTest);
    o.setMask(t.depthWrite);
    a.setMask(t.colorWrite);
    let i = t.stencilWrite;
    s.setTest(i);
    if (i) {
      s.setMask(t.stencilWriteMask);
      s.setFunc(t.stencilFunc, t.stencilRef, t.stencilFuncMask);
      s.setOp(t.stencilFail, t.stencilZFail, t.stencilZPass);
    }
    Se(t.polygonOffset, t.polygonOffsetFactor, t.polygonOffsetUnits);
    if (t.alphaToCoverage === true) {
      de(e.SAMPLE_ALPHA_TO_COVERAGE);
    } else {
      fe(e.SAMPLE_ALPHA_TO_COVERAGE);
    }
  }
  function ye(t) {
    if (D !== t) {
      if (t) {
        e.frontFace(e.CW);
      } else {
        e.frontFace(e.CCW);
      }
      D = t;
    }
  }
  function be(t) {
    if (t === 0) {
      fe(e.CULL_FACE);
    } else {
      de(e.CULL_FACE);
      if (t !== O) {
        if (t === 1) {
          e.cullFace(e.BACK);
        } else if (t === 2) {
          e.cullFace(e.FRONT);
        } else {
          e.cullFace(e.FRONT_AND_BACK);
        }
      }
    }
    O = t;
  }
  function xe(t) {
    if (t !== k) {
      if (j) {
        e.lineWidth(t);
      }
      k = t;
    }
  }
  function Se(t, n, r) {
    if (t) {
      de(e.POLYGON_OFFSET_FILL);
      if (A !== n || ee !== r) {
        A = n;
        ee = r;
        if (o.getReversed()) {
          n = -n;
        }
        e.polygonOffset(n, r);
      }
    } else {
      fe(e.POLYGON_OFFSET_FILL);
    }
  }
  function Ce(t) {
    if (t) {
      de(e.SCISSOR_TEST);
    } else {
      fe(e.SCISSOR_TEST);
    }
  }
  function P(t = e.TEXTURE0 + te - 1) {
    if (M !== t) {
      e.activeTexture(t);
      M = t;
    }
  }
  function we(t, n, r = M === null ? e.TEXTURE0 + te - 1 : M) {
    let i = ie[r];
    if (i === undefined) {
      i = {
        type: undefined,
        texture: undefined
      };
      ie[r] = i;
    }
    if (i.type !== t || i.texture !== n) {
      if (M !== r) {
        e.activeTexture(r);
        M = r;
      }
      e.bindTexture(t, n || ue[t]);
      i.type = t;
      i.texture = n;
    }
  }
  function F() {
    let t = ie[M];
    if (t !== undefined && t.type !== undefined) {
      e.bindTexture(t.type, null);
      t.type = undefined;
      t.texture = undefined;
    }
  }
  function Te() {
    try {
      e.compressedTexImage2D(...arguments);
    } catch (e) {
      Wg(`WebGLState:`, e);
    }
  }
  function I() {
    try {
      e.compressedTexImage3D(...arguments);
    } catch (e) {
      Wg(`WebGLState:`, e);
    }
  }
  function Ee() {
    try {
      e.texSubImage2D(...arguments);
    } catch (e) {
      Wg(`WebGLState:`, e);
    }
  }
  function L() {
    try {
      e.texSubImage3D(...arguments);
    } catch (e) {
      Wg(`WebGLState:`, e);
    }
  }
  function De() {
    try {
      e.compressedTexSubImage2D(...arguments);
    } catch (e) {
      Wg(`WebGLState:`, e);
    }
  }
  function R() {
    try {
      e.compressedTexSubImage3D(...arguments);
    } catch (e) {
      Wg(`WebGLState:`, e);
    }
  }
  function z() {
    try {
      e.texStorage2D(...arguments);
    } catch (e) {
      Wg(`WebGLState:`, e);
    }
  }
  function Oe() {
    try {
      e.texStorage3D(...arguments);
    } catch (e) {
      Wg(`WebGLState:`, e);
    }
  }
  function ke() {
    try {
      e.texImage2D(...arguments);
    } catch (e) {
      Wg(`WebGLState:`, e);
    }
  }
  function Ae() {
    try {
      e.texImage3D(...arguments);
    } catch (e) {
      Wg(`WebGLState:`, e);
    }
  }
  function je(t) {
    if (d[t] === undefined) {
      return e.getParameter(t);
    } else {
      return d[t];
    }
  }
  function Me(t, n) {
    if (d[t] !== n) {
      e.pixelStorei(t, n);
      d[t] = n;
    }
  }
  function Ne(t) {
    if (se.equals(t) === false) {
      e.scissor(t.x, t.y, t.z, t.w);
      se.copy(t);
    }
  }
  function Pe(t) {
    if (ce.equals(t) === false) {
      e.viewport(t.x, t.y, t.z, t.w);
      ce.copy(t);
    }
  }
  function Fe(t, n) {
    let r = l.get(n);
    if (r === undefined) {
      r = new WeakMap();
      l.set(n, r);
    }
    let i = r.get(t);
    if (i === undefined) {
      i = e.getUniformBlockIndex(n, t.name);
      r.set(t, i);
    }
  }
  function Ie(t, n) {
    let r = l.get(n).get(t);
    if (c.get(n) !== r) {
      e.uniformBlockBinding(n, r, t.__bindingPointIndex);
      c.set(n, r);
    }
  }
  function Le() {
    e.disable(e.BLEND);
    e.disable(e.CULL_FACE);
    e.disable(e.DEPTH_TEST);
    e.disable(e.POLYGON_OFFSET_FILL);
    e.disable(e.SCISSOR_TEST);
    e.disable(e.STENCIL_TEST);
    e.disable(e.SAMPLE_ALPHA_TO_COVERAGE);
    e.blendEquation(e.FUNC_ADD);
    e.blendFunc(e.ONE, e.ZERO);
    e.blendFuncSeparate(e.ONE, e.ZERO, e.ONE, e.ZERO);
    e.blendColor(0, 0, 0, 0);
    e.colorMask(true, true, true, true);
    e.clearColor(0, 0, 0, 0);
    e.depthMask(true);
    e.depthFunc(e.LESS);
    o.setReversed(false);
    e.clearDepth(1);
    e.stencilMask(4294967295);
    e.stencilFunc(e.ALWAYS, 0, 4294967295);
    e.stencilOp(e.KEEP, e.KEEP, e.KEEP);
    e.clearStencil(0);
    e.cullFace(e.BACK);
    e.frontFace(e.CCW);
    e.polygonOffset(0, 0);
    e.activeTexture(e.TEXTURE0);
    e.bindFramebuffer(e.FRAMEBUFFER, null);
    e.bindFramebuffer(e.DRAW_FRAMEBUFFER, null);
    e.bindFramebuffer(e.READ_FRAMEBUFFER, null);
    e.useProgram(null);
    e.lineWidth(1);
    e.scissor(0, 0, e.canvas.width, e.canvas.height);
    e.viewport(0, 0, e.canvas.width, e.canvas.height);
    e.pixelStorei(e.PACK_ALIGNMENT, 4);
    e.pixelStorei(e.UNPACK_ALIGNMENT, 4);
    e.pixelStorei(e.UNPACK_FLIP_Y_WEBGL, false);
    e.pixelStorei(e.UNPACK_PREMULTIPLY_ALPHA_WEBGL, false);
    e.pixelStorei(e.UNPACK_COLORSPACE_CONVERSION_WEBGL, e.BROWSER_DEFAULT_WEBGL);
    e.pixelStorei(e.PACK_ROW_LENGTH, 0);
    e.pixelStorei(e.PACK_SKIP_PIXELS, 0);
    e.pixelStorei(e.PACK_SKIP_ROWS, 0);
    e.pixelStorei(e.UNPACK_ROW_LENGTH, 0);
    e.pixelStorei(e.UNPACK_IMAGE_HEIGHT, 0);
    e.pixelStorei(e.UNPACK_SKIP_PIXELS, 0);
    e.pixelStorei(e.UNPACK_SKIP_ROWS, 0);
    e.pixelStorei(e.UNPACK_SKIP_IMAGES, 0);
    u = {};
    d = {};
    M = null;
    ie = {};
    f = {};
    p = new WeakMap();
    m = [];
    h = null;
    g = false;
    _ = null;
    v = null;
    y = null;
    b = null;
    x = null;
    S = null;
    C = null;
    w = new Ov(0, 0, 0);
    T = 0;
    E = false;
    D = null;
    O = null;
    k = null;
    A = null;
    ee = null;
    se.set(0, 0, e.canvas.width, e.canvas.height);
    ce.set(0, 0, e.canvas.width, e.canvas.height);
    a.reset();
    o.reset();
    s.reset();
  }
  return {
    buffers: {
      color: a,
      depth: o,
      stencil: s
    },
    enable: de,
    disable: fe,
    bindFramebuffer: pe,
    drawBuffers: me,
    useProgram: N,
    setBlending: _e,
    setMaterial: ve,
    setFlipSided: ye,
    setCullFace: be,
    setLineWidth: xe,
    setPolygonOffset: Se,
    setScissorTest: Ce,
    activeTexture: P,
    bindTexture: we,
    unbindTexture: F,
    compressedTexImage2D: Te,
    compressedTexImage3D: I,
    texImage2D: ke,
    texImage3D: Ae,
    pixelStorei: Me,
    getParameter: je,
    updateUBOMapping: Fe,
    uniformBlockBinding: Ie,
    texStorage2D: z,
    texStorage3D: Oe,
    texSubImage2D: Ee,
    texSubImage3D: L,
    compressedTexSubImage2D: De,
    compressedTexSubImage3D: R,
    scissor: Ne,
    viewport: Pe,
    reset: Le
  };
}
function wT(e, t, n, r, i, a, o) {
  let s = t.has(`WEBGL_multisampled_render_to_texture`) ? t.get(`WEBGL_multisampled_render_to_texture`) : null;
  let c = typeof navigator > `u` ? false : /OculusBrowser/g.test(navigator.userAgent);
  let l = new S_();
  let u = new WeakMap();
  let d = new Set();
  let f;
  let p = new WeakMap();
  let m = false;
  try {
    m = typeof OffscreenCanvas < `u` && new OffscreenCanvas(1, 1).getContext(`2d`) !== null;
  } catch {}
  function h(e, t) {
    if (m) {
      return new OffscreenCanvas(e, t);
    } else {
      return Rg(`canvas`);
    }
  }
  function g(e, t, n) {
    let r = 1;
    let i = Te(e);
    if (i.width > n || i.height > n) {
      r = n / Math.max(i.width, i.height);
    }
    if (r < 1) {
      if (typeof HTMLImageElement < `u` && e instanceof HTMLImageElement || typeof HTMLCanvasElement < `u` && e instanceof HTMLCanvasElement || typeof ImageBitmap < `u` && e instanceof ImageBitmap || typeof VideoFrame < `u` && e instanceof VideoFrame) {
        let n = Math.floor(r * i.width);
        let a = Math.floor(r * i.height);
        if (f === undefined) {
          f = h(n, a);
        }
        let o = t ? h(n, a) : f;
        o.width = n;
        o.height = a;
        o.getContext(`2d`).drawImage(e, 0, 0, n, a);
        Ug(`WebGLRenderer: Texture has been resized from (${i.width}x${i.height}) to (${n}x${a}).`);
        return o;
      }
      if (`data` in e) {
        Ug(`WebGLRenderer: Image in DataTexture is too big (${i.width}x${i.height}).`);
      }
      return e;
    }
    return e;
  }
  function _(e) {
    return e.generateMipmaps;
  }
  function v(t) {
    e.generateMipmap(t);
  }
  function y(t) {
    if (t.isWebGLCubeRenderTarget) {
      return e.TEXTURE_CUBE_MAP;
    } else if (t.isWebGL3DRenderTarget) {
      return e.TEXTURE_3D;
    } else if (t.isWebGLArrayRenderTarget || t.isCompressedArrayTexture) {
      return e.TEXTURE_2D_ARRAY;
    } else {
      return e.TEXTURE_2D;
    }
  }
  function b(n, r, i, a, o, s = false) {
    if (n !== null) {
      if (e[n] !== undefined) {
        return e[n];
      }
      Ug(`WebGLRenderer: Attempt to use non-existing WebGL internal format '${n}'`);
    }
    let c;
    if (a) {
      c = t.get(`EXT_texture_norm16`);
      if (!c) {
        Ug(`WebGLRenderer: Unable to use normalized textures without EXT_texture_norm16 extension`);
      }
    }
    let l = r;
    if (r === e.RED) {
      if (i === e.FLOAT) {
        l = e.R32F;
      }
      if (i === e.HALF_FLOAT) {
        l = e.R16F;
      }
      if (i === e.UNSIGNED_BYTE) {
        l = e.R8;
      }
      if (i === e.UNSIGNED_SHORT && c) {
        l = c.R16_EXT;
      }
      if (i === e.SHORT && c) {
        l = c.R16_SNORM_EXT;
      }
    }
    if (r === e.RED_INTEGER) {
      if (i === e.UNSIGNED_BYTE) {
        l = e.R8UI;
      }
      if (i === e.UNSIGNED_SHORT) {
        l = e.R16UI;
      }
      if (i === e.UNSIGNED_INT) {
        l = e.R32UI;
      }
      if (i === e.BYTE) {
        l = e.R8I;
      }
      if (i === e.SHORT) {
        l = e.R16I;
      }
      if (i === e.INT) {
        l = e.R32I;
      }
    }
    if (r === e.RG) {
      if (i === e.FLOAT) {
        l = e.RG32F;
      }
      if (i === e.HALF_FLOAT) {
        l = e.RG16F;
      }
      if (i === e.UNSIGNED_BYTE) {
        l = e.RG8;
      }
      if (i === e.UNSIGNED_SHORT && c) {
        l = c.RG16_EXT;
      }
      if (i === e.SHORT && c) {
        l = c.RG16_SNORM_EXT;
      }
    }
    if (r === e.RG_INTEGER) {
      if (i === e.UNSIGNED_BYTE) {
        l = e.RG8UI;
      }
      if (i === e.UNSIGNED_SHORT) {
        l = e.RG16UI;
      }
      if (i === e.UNSIGNED_INT) {
        l = e.RG32UI;
      }
      if (i === e.BYTE) {
        l = e.RG8I;
      }
      if (i === e.SHORT) {
        l = e.RG16I;
      }
      if (i === e.INT) {
        l = e.RG32I;
      }
    }
    if (r === e.RGB_INTEGER) {
      if (i === e.UNSIGNED_BYTE) {
        l = e.RGB8UI;
      }
      if (i === e.UNSIGNED_SHORT) {
        l = e.RGB16UI;
      }
      if (i === e.UNSIGNED_INT) {
        l = e.RGB32UI;
      }
      if (i === e.BYTE) {
        l = e.RGB8I;
      }
      if (i === e.SHORT) {
        l = e.RGB16I;
      }
      if (i === e.INT) {
        l = e.RGB32I;
      }
    }
    if (r === e.RGBA_INTEGER) {
      if (i === e.UNSIGNED_BYTE) {
        l = e.RGBA8UI;
      }
      if (i === e.UNSIGNED_SHORT) {
        l = e.RGBA16UI;
      }
      if (i === e.UNSIGNED_INT) {
        l = e.RGBA32UI;
      }
      if (i === e.BYTE) {
        l = e.RGBA8I;
      }
      if (i === e.SHORT) {
        l = e.RGBA16I;
      }
      if (i === e.INT) {
        l = e.RGBA32I;
      }
    }
    if (r === e.RGB) {
      if (i === e.UNSIGNED_SHORT && c) {
        l = c.RGB16_EXT;
      }
      if (i === e.SHORT && c) {
        l = c.RGB16_SNORM_EXT;
      }
      if (i === e.UNSIGNED_INT_5_9_9_9_REV) {
        l = e.RGB9_E5;
      }
      if (i === e.UNSIGNED_INT_10F_11F_11F_REV) {
        l = e.R11F_G11F_B10F;
      }
    }
    if (r === e.RGBA) {
      let t = s ? jg : j_.getTransfer(o);
      if (i === e.FLOAT) {
        l = e.RGBA32F;
      }
      if (i === e.HALF_FLOAT) {
        l = e.RGBA16F;
      }
      if (i === e.UNSIGNED_BYTE) {
        l = t === `srgb` ? e.SRGB8_ALPHA8 : e.RGBA8;
      }
      if (i === e.UNSIGNED_SHORT && c) {
        l = c.RGBA16_EXT;
      }
      if (i === e.SHORT && c) {
        l = c.RGBA16_SNORM_EXT;
      }
      if (i === e.UNSIGNED_SHORT_4_4_4_4) {
        l = e.RGBA4;
      }
      if (i === e.UNSIGNED_SHORT_5_5_5_1) {
        l = e.RGB5_A1;
      }
    }
    if (l === e.R16F || l === e.R32F || l === e.RG16F || l === e.RG32F || l === e.RGBA16F || l === e.RGBA32F) {
      t.get(`EXT_color_buffer_float`);
    }
    return l;
  }
  function x(t, n) {
    let r;
    if (t) {
      if (n === null || n === 1014 || n === 1020) {
        r = e.DEPTH24_STENCIL8;
      } else if (n === 1015) {
        r = e.DEPTH32F_STENCIL8;
      } else if (n === 1012) {
        r = e.DEPTH24_STENCIL8;
        Ug(`DepthTexture: 16 bit depth attachment is not supported with stencil. Using 24-bit attachment.`);
      }
    } else if (n === null || n === 1014 || n === 1020) {
      r = e.DEPTH_COMPONENT24;
    } else if (n === 1015) {
      r = e.DEPTH_COMPONENT32F;
    } else if (n === 1012) {
      r = e.DEPTH_COMPONENT16;
    }
    return r;
  }
  function S(e, t) {
    if (_(e) === true || e.isFramebufferTexture && e.minFilter !== 1003 && e.minFilter !== 1006) {
      return Math.log2(Math.max(t.width, t.height)) + 1;
    } else if (e.mipmaps !== undefined && e.mipmaps.length > 0) {
      return e.mipmaps.length;
    } else if (e.isCompressedTexture && Array.isArray(e.image)) {
      return t.mipmaps.length;
    } else {
      return 1;
    }
  }
  function C(e) {
    let t = e.target;
    t.removeEventListener(`dispose`, C);
    T(t);
    if (t.isVideoTexture) {
      u.delete(t);
    }
    if (t.isHTMLTexture) {
      d.delete(t);
    }
  }
  function w(e) {
    let t = e.target;
    t.removeEventListener(`dispose`, w);
    D(t);
  }
  function T(e) {
    let t = r.get(e);
    if (t.__webglInit === undefined) {
      return;
    }
    let n = e.source;
    let i = p.get(n);
    if (i) {
      let r = i[t.__cacheKey];
      r.usedTimes--;
      if (r.usedTimes === 0) {
        E(e);
      }
      if (Object.keys(i).length === 0) {
        p.delete(n);
      }
    }
    r.remove(e);
  }
  function E(t) {
    let n = r.get(t);
    e.deleteTexture(n.__webglTexture);
    let i = t.source;
    let a = p.get(i);
    delete a[n.__cacheKey];
    o.memory.textures--;
  }
  function D(t) {
    let n = r.get(t);
    if (t.depthTexture) {
      t.depthTexture.dispose();
      r.remove(t.depthTexture);
    }
    if (t.isWebGLCubeRenderTarget) {
      for (let t = 0; t < 6; t++) {
        if (Array.isArray(n.__webglFramebuffer[t])) {
          for (let r = 0; r < n.__webglFramebuffer[t].length; r++) {
            e.deleteFramebuffer(n.__webglFramebuffer[t][r]);
          }
        } else {
          e.deleteFramebuffer(n.__webglFramebuffer[t]);
        }
        if (n.__webglDepthbuffer) {
          e.deleteRenderbuffer(n.__webglDepthbuffer[t]);
        }
      }
    } else {
      if (Array.isArray(n.__webglFramebuffer)) {
        for (let t = 0; t < n.__webglFramebuffer.length; t++) {
          e.deleteFramebuffer(n.__webglFramebuffer[t]);
        }
      } else {
        e.deleteFramebuffer(n.__webglFramebuffer);
      }
      if (n.__webglDepthbuffer) {
        e.deleteRenderbuffer(n.__webglDepthbuffer);
      }
      if (n.__webglMultisampledFramebuffer) {
        e.deleteFramebuffer(n.__webglMultisampledFramebuffer);
      }
      if (n.__webglColorRenderbuffer) {
        for (let t = 0; t < n.__webglColorRenderbuffer.length; t++) {
          if (n.__webglColorRenderbuffer[t]) {
            e.deleteRenderbuffer(n.__webglColorRenderbuffer[t]);
          }
        }
      }
      if (n.__webglDepthRenderbuffer) {
        e.deleteRenderbuffer(n.__webglDepthRenderbuffer);
      }
    }
    let i = t.textures;
    for (let t = 0, n = i.length; t < n; t++) {
      let n = r.get(i[t]);
      if (n.__webglTexture) {
        e.deleteTexture(n.__webglTexture);
        o.memory.textures--;
      }
      r.remove(i[t]);
    }
    r.remove(t);
  }
  let O = 0;
  function k() {
    O = 0;
  }
  function A() {
    return O;
  }
  function ee(e) {
    O = e;
  }
  function te() {
    let e = O;
    if (e >= i.maxTextures) {
      Ug(`WebGLTextures: Trying to use ${e + 1} texture units while this GPU supports only ${i.maxTextures}`);
    }
    O += 1;
    return e;
  }
  function j(e) {
    let t = [];
    t.push(e.wrapS);
    t.push(e.wrapT);
    t.push(e.wrapR || 0);
    t.push(e.magFilter);
    t.push(e.minFilter);
    t.push(e.anisotropy);
    t.push(e.internalFormat);
    t.push(e.format);
    t.push(e.type);
    t.push(e.generateMipmaps);
    t.push(e.premultiplyAlpha);
    t.push(e.flipY);
    t.push(e.unpackAlignment);
    t.push(e.colorSpace);
    return t.join();
  }
  function ne(t, i) {
    let a = r.get(t);
    if (t.isVideoTexture) {
      we(t);
    }
    if (t.isRenderTargetTexture === false && t.isExternalTexture !== true && t.version > 0 && a.__version !== t.version) {
      let e = t.image;
      if (e === null) {
        Ug(`WebGLRenderer: Texture marked for update but no image data found.`);
      } else if (e.complete === false) {
        Ug(`WebGLRenderer: Texture marked for update but image is incomplete`);
      } else {
        fe(a, t, i);
        return;
      }
    } else if (t.isExternalTexture) {
      a.__webglTexture = t.sourceTexture ? t.sourceTexture : null;
    }
    n.bindTexture(e.TEXTURE_2D, a.__webglTexture, e.TEXTURE0 + i);
  }
  function re(t, i) {
    let a = r.get(t);
    if (t.isRenderTargetTexture === false && t.version > 0 && a.__version !== t.version) {
      fe(a, t, i);
      return;
    }
    if (t.isExternalTexture) {
      a.__webglTexture = t.sourceTexture ? t.sourceTexture : null;
    }
    n.bindTexture(e.TEXTURE_2D_ARRAY, a.__webglTexture, e.TEXTURE0 + i);
  }
  function M(t, i) {
    let a = r.get(t);
    if (t.isRenderTargetTexture === false && t.version > 0 && a.__version !== t.version) {
      fe(a, t, i);
      return;
    }
    n.bindTexture(e.TEXTURE_3D, a.__webglTexture, e.TEXTURE0 + i);
  }
  function ie(t, i) {
    let a = r.get(t);
    if (t.isCubeDepthTexture !== true && t.version > 0 && a.__version !== t.version) {
      pe(a, t, i);
      return;
    }
    n.bindTexture(e.TEXTURE_CUBE_MAP, a.__webglTexture, e.TEXTURE0 + i);
  }
  let ae = {
    [sh]: e.REPEAT,
    [ch]: e.CLAMP_TO_EDGE,
    [lh]: e.MIRRORED_REPEAT
  };
  let oe = {
    [uh]: e.NEAREST,
    [dh]: e.NEAREST_MIPMAP_NEAREST,
    [fh]: e.NEAREST_MIPMAP_LINEAR,
    [ph]: e.LINEAR,
    [mh]: e.LINEAR_MIPMAP_NEAREST,
    [hh]: e.LINEAR_MIPMAP_LINEAR
  };
  let se = {
    512: e.NEVER,
    519: e.ALWAYS,
    513: e.LESS,
    515: e.LEQUAL,
    514: e.EQUAL,
    518: e.GEQUAL,
    516: e.GREATER,
    517: e.NOTEQUAL
  };
  function ce(n, a) {
    if (a.type === 1015 && t.has(`OES_texture_float_linear`) === false && (a.magFilter === 1006 || a.magFilter === 1007 || a.magFilter === 1005 || a.magFilter === 1008 || a.minFilter === 1006 || a.minFilter === 1007 || a.minFilter === 1005 || a.minFilter === 1008)) {
      Ug(`WebGLRenderer: Unable to use linear filtering with floating point textures. OES_texture_float_linear not supported on this device.`);
    }
    e.texParameteri(n, e.TEXTURE_WRAP_S, ae[a.wrapS]);
    e.texParameteri(n, e.TEXTURE_WRAP_T, ae[a.wrapT]);
    if (n === e.TEXTURE_3D || n === e.TEXTURE_2D_ARRAY) {
      e.texParameteri(n, e.TEXTURE_WRAP_R, ae[a.wrapR]);
    }
    e.texParameteri(n, e.TEXTURE_MAG_FILTER, oe[a.magFilter]);
    e.texParameteri(n, e.TEXTURE_MIN_FILTER, oe[a.minFilter]);
    if (a.compareFunction) {
      e.texParameteri(n, e.TEXTURE_COMPARE_MODE, e.COMPARE_REF_TO_TEXTURE);
      e.texParameteri(n, e.TEXTURE_COMPARE_FUNC, se[a.compareFunction]);
    }
    if (t.has(`EXT_texture_filter_anisotropic`) === true) {
      if (a.magFilter === 1003 || a.minFilter !== 1005 && a.minFilter !== 1008 || a.type === 1015 && t.has(`OES_texture_float_linear`) === false) {
        return;
      }
      if (a.anisotropy > 1 || r.get(a).__currentAnisotropy) {
        let o = t.get(`EXT_texture_filter_anisotropic`);
        e.texParameterf(n, o.TEXTURE_MAX_ANISOTROPY_EXT, Math.min(a.anisotropy, i.getMaxAnisotropy()));
        r.get(a).__currentAnisotropy = a.anisotropy;
      }
    }
  }
  function le(t, n) {
    let r = false;
    if (t.__webglInit === undefined) {
      t.__webglInit = true;
      n.addEventListener(`dispose`, C);
    }
    let i = n.source;
    let a = p.get(i);
    if (a === undefined) {
      a = {};
      p.set(i, a);
    }
    let s = j(n);
    if (s !== t.__cacheKey) {
      if (a[s] === undefined) {
        a[s] = {
          texture: e.createTexture(),
          usedTimes: 0
        };
        o.memory.textures++;
        r = true;
      }
      a[s].usedTimes++;
      let i = a[t.__cacheKey];
      if (i !== undefined) {
        a[t.__cacheKey].usedTimes--;
        if (i.usedTimes === 0) {
          E(n);
        }
      }
      t.__cacheKey = s;
      t.__webglTexture = a[s].texture;
    }
    return r;
  }
  function ue(e, t, n) {
    return Math.floor(Math.floor(e / n) / t);
  }
  function de(t, r, i, a) {
    let o = t.updateRanges;
    if (o.length === 0) {
      n.texSubImage2D(e.TEXTURE_2D, 0, 0, 0, r.width, r.height, i, a, r.data);
    } else {
      o.sort((e, t) => e.start - t.start);
      let s = 0;
      for (let e = 1; e < o.length; e++) {
        let t = o[s];
        let n = o[e];
        let i = t.start + t.count;
        let a = ue(n.start, r.width, 4);
        let c = ue(t.start, r.width, 4);
        if (n.start <= i + 1 && a === c && ue(n.start + n.count - 1, r.width, 4) === a) {
          t.count = Math.max(t.count, n.start + n.count - t.start);
        } else {
          ++s;
          o[s] = n;
        }
      }
      o.length = s + 1;
      let c = n.getParameter(e.UNPACK_ROW_LENGTH);
      let l = n.getParameter(e.UNPACK_SKIP_PIXELS);
      let u = n.getParameter(e.UNPACK_SKIP_ROWS);
      n.pixelStorei(e.UNPACK_ROW_LENGTH, r.width);
      for (let t = 0, s = o.length; t < s; t++) {
        let s = o[t];
        let c = Math.floor(s.start / 4);
        let l = Math.ceil(s.count / 4);
        let u = c % r.width;
        let d = Math.floor(c / r.width);
        let f = l;
        n.pixelStorei(e.UNPACK_SKIP_PIXELS, u);
        n.pixelStorei(e.UNPACK_SKIP_ROWS, d);
        n.texSubImage2D(e.TEXTURE_2D, 0, u, d, f, 1, i, a, r.data);
      }
      t.clearUpdateRanges();
      n.pixelStorei(e.UNPACK_ROW_LENGTH, c);
      n.pixelStorei(e.UNPACK_SKIP_PIXELS, l);
      n.pixelStorei(e.UNPACK_SKIP_ROWS, u);
    }
  }
  function fe(t, o, s) {
    let c = e.TEXTURE_2D;
    if (o.isDataArrayTexture || o.isCompressedArrayTexture) {
      c = e.TEXTURE_2D_ARRAY;
    }
    if (o.isData3DTexture) {
      c = e.TEXTURE_3D;
    }
    let l = le(t, o);
    let u = o.source;
    n.bindTexture(c, t.__webglTexture, e.TEXTURE0 + s);
    let f = r.get(u);
    if (u.version !== f.__version || l === true) {
      n.activeTexture(e.TEXTURE0 + s);
      if (!(typeof ImageBitmap < `u`) || !(o.image instanceof ImageBitmap)) {
        let t = j_.getPrimaries(j_.workingColorSpace);
        let r = o.colorSpace === `` ? null : j_.getPrimaries(o.colorSpace);
        let i = o.colorSpace === `` || t === r ? e.NONE : e.BROWSER_DEFAULT_WEBGL;
        n.pixelStorei(e.UNPACK_FLIP_Y_WEBGL, o.flipY);
        n.pixelStorei(e.UNPACK_PREMULTIPLY_ALPHA_WEBGL, o.premultiplyAlpha);
        n.pixelStorei(e.UNPACK_COLORSPACE_CONVERSION_WEBGL, i);
      }
      n.pixelStorei(e.UNPACK_ALIGNMENT, o.unpackAlignment);
      let t = g(o.image, false, i.maxTextureSize);
      t = F(o, t);
      let r = a.convert(o.format, o.colorSpace);
      let p = a.convert(o.type);
      let m = b(o.internalFormat, r, p, o.normalized, o.colorSpace, o.isVideoTexture);
      ce(c, o);
      let h;
      let y = o.mipmaps;
      let C = o.isVideoTexture !== true;
      let w = f.__version === undefined || l === true;
      let T = u.dataReady;
      let E = S(o, t);
      if (o.isDepthTexture) {
        m = x(o.format === Nh, o.type);
        if (w) {
          if (C) {
            n.texStorage2D(e.TEXTURE_2D, 1, m, t.width, t.height);
          } else {
            n.texImage2D(e.TEXTURE_2D, 0, m, t.width, t.height, 0, r, p, null);
          }
        }
      } else if (o.isDataTexture) {
        if (y.length > 0) {
          if (C && w) {
            n.texStorage2D(e.TEXTURE_2D, E, m, y[0].width, y[0].height);
          }
          for (let t = 0, i = y.length; t < i; t++) {
            h = y[t];
            if (C) {
              if (T) {
                n.texSubImage2D(e.TEXTURE_2D, t, 0, 0, h.width, h.height, r, p, h.data);
              }
            } else {
              n.texImage2D(e.TEXTURE_2D, t, m, h.width, h.height, 0, r, p, h.data);
            }
          }
          o.generateMipmaps = false;
        } else if (C) {
          if (w) {
            n.texStorage2D(e.TEXTURE_2D, E, m, t.width, t.height);
          }
          if (T) {
            de(o, t, r, p);
          }
        } else {
          n.texImage2D(e.TEXTURE_2D, 0, m, t.width, t.height, 0, r, p, t.data);
        }
      } else if (o.isCompressedTexture) {
        if (o.isCompressedArrayTexture) {
          if (C && w) {
            n.texStorage3D(e.TEXTURE_2D_ARRAY, E, m, y[0].width, y[0].height, t.depth);
          }
          for (let i = 0, a = y.length; i < a; i++) {
            h = y[i];
            if (o.format !== 1023) {
              if (r !== null) {
                if (C) {
                  if (T) {
                    if (o.layerUpdates.size > 0) {
                      let t = vS(h.width, h.height, o.format, o.type);
                      for (let a of o.layerUpdates) {
                        let o = h.data.subarray(a * t / h.data.BYTES_PER_ELEMENT, (a + 1) * t / h.data.BYTES_PER_ELEMENT);
                        n.compressedTexSubImage3D(e.TEXTURE_2D_ARRAY, i, 0, 0, a, h.width, h.height, 1, r, o);
                      }
                    } else {
                      n.compressedTexSubImage3D(e.TEXTURE_2D_ARRAY, i, 0, 0, 0, h.width, h.height, t.depth, r, h.data);
                    }
                  }
                } else {
                  n.compressedTexImage3D(e.TEXTURE_2D_ARRAY, i, m, h.width, h.height, t.depth, 0, h.data, 0, 0);
                }
              } else {
                Ug(`WebGLRenderer: Attempt to load unsupported compressed texture format in .uploadTexture()`);
              }
            } else if (C) {
              if (T) {
                n.texSubImage3D(e.TEXTURE_2D_ARRAY, i, 0, 0, 0, h.width, h.height, t.depth, r, p, h.data);
              }
            } else {
              n.texImage3D(e.TEXTURE_2D_ARRAY, i, m, h.width, h.height, t.depth, 0, r, p, h.data);
            }
          }
          if (o.layerUpdates.size > 0) {
            o.clearLayerUpdates();
          }
        } else {
          if (C && w) {
            n.texStorage2D(e.TEXTURE_2D, E, m, y[0].width, y[0].height);
          }
          for (let t = 0, i = y.length; t < i; t++) {
            h = y[t];
            if (o.format === 1023) {
              if (C) {
                if (T) {
                  n.texSubImage2D(e.TEXTURE_2D, t, 0, 0, h.width, h.height, r, p, h.data);
                }
              } else {
                n.texImage2D(e.TEXTURE_2D, t, m, h.width, h.height, 0, r, p, h.data);
              }
            } else if (r === null) {
              Ug(`WebGLRenderer: Attempt to load unsupported compressed texture format in .uploadTexture()`);
            } else if (C) {
              if (T) {
                n.compressedTexSubImage2D(e.TEXTURE_2D, t, 0, 0, h.width, h.height, r, h.data);
              }
            } else {
              n.compressedTexImage2D(e.TEXTURE_2D, t, m, h.width, h.height, 0, h.data);
            }
          }
        }
      } else if (o.isDataArrayTexture) {
        if (C) {
          if (w) {
            n.texStorage3D(e.TEXTURE_2D_ARRAY, E, m, t.width, t.height, t.depth);
          }
          if (T) {
            if (o.layerUpdates.size > 0) {
              let i = vS(t.width, t.height, o.format, o.type);
              for (let a of o.layerUpdates) {
                let o = t.data.subarray(a * i / t.data.BYTES_PER_ELEMENT, (a + 1) * i / t.data.BYTES_PER_ELEMENT);
                n.texSubImage3D(e.TEXTURE_2D_ARRAY, 0, 0, 0, a, t.width, t.height, 1, r, p, o);
              }
              o.clearLayerUpdates();
            } else {
              n.texSubImage3D(e.TEXTURE_2D_ARRAY, 0, 0, 0, 0, t.width, t.height, t.depth, r, p, t.data);
            }
          }
        } else {
          n.texImage3D(e.TEXTURE_2D_ARRAY, 0, m, t.width, t.height, t.depth, 0, r, p, t.data);
        }
      } else if (o.isData3DTexture) {
        if (C) {
          if (w) {
            n.texStorage3D(e.TEXTURE_3D, E, m, t.width, t.height, t.depth);
          }
          if (T) {
            n.texSubImage3D(e.TEXTURE_3D, 0, 0, 0, 0, t.width, t.height, t.depth, r, p, t.data);
          }
        } else {
          n.texImage3D(e.TEXTURE_3D, 0, m, t.width, t.height, t.depth, 0, r, p, t.data);
        }
      } else if (o.isFramebufferTexture) {
        if (w) {
          if (C) {
            n.texStorage2D(e.TEXTURE_2D, E, m, t.width, t.height);
          } else {
            let i = t.width;
            let a = t.height;
            for (let t = 0; t < E; t++) {
              n.texImage2D(e.TEXTURE_2D, t, m, i, a, 0, r, p, null);
              i >>= 1;
              a >>= 1;
            }
          }
        }
      } else if (o.isHTMLTexture) {
        if (`texElementImage2D` in e) {
          let n = e.canvas;
          if (!n.hasAttribute(`layoutsubtree`)) {
            n.setAttribute(`layoutsubtree`, `true`);
          }
          if (t.parentNode !== n) {
            n.appendChild(t);
            d.add(o);
            n.onpaint = e => {
              let t = e.changedElements;
              for (let e of d) {
                if (t.includes(e.image)) {
                  e.needsUpdate = true;
                }
              }
            };
            n.requestPaint();
            return;
          }
          if (e.texElementImage2D.length === 3) {
            e.texElementImage2D(e.TEXTURE_2D, e.RGBA8, t);
          } else {
            let n = e.RGBA;
            let r = e.RGBA;
            let i = e.UNSIGNED_BYTE;
            e.texElementImage2D(e.TEXTURE_2D, 0, n, r, i, t);
          }
          e.texParameteri(e.TEXTURE_2D, e.TEXTURE_MIN_FILTER, e.LINEAR);
          e.texParameteri(e.TEXTURE_2D, e.TEXTURE_WRAP_S, e.CLAMP_TO_EDGE);
          e.texParameteri(e.TEXTURE_2D, e.TEXTURE_WRAP_T, e.CLAMP_TO_EDGE);
        }
      } else if (y.length > 0) {
        if (C && w) {
          let t = Te(y[0]);
          n.texStorage2D(e.TEXTURE_2D, E, m, t.width, t.height);
        }
        for (let t = 0, i = y.length; t < i; t++) {
          h = y[t];
          if (C) {
            if (T) {
              n.texSubImage2D(e.TEXTURE_2D, t, 0, 0, r, p, h);
            }
          } else {
            n.texImage2D(e.TEXTURE_2D, t, m, r, p, h);
          }
        }
        o.generateMipmaps = false;
      } else if (C) {
        if (w) {
          let r = Te(t);
          n.texStorage2D(e.TEXTURE_2D, E, m, r.width, r.height);
        }
        if (T) {
          n.texSubImage2D(e.TEXTURE_2D, 0, 0, 0, r, p, t);
        }
      } else {
        n.texImage2D(e.TEXTURE_2D, 0, m, r, p, t);
      }
      if (_(o)) {
        v(c);
      }
      f.__version = u.version;
      if (o.onUpdate) {
        o.onUpdate(o);
      }
    }
    t.__version = o.version;
  }
  function pe(t, o, s) {
    if (o.image.length !== 6) {
      return;
    }
    let c = le(t, o);
    let l = o.source;
    n.bindTexture(e.TEXTURE_CUBE_MAP, t.__webglTexture, e.TEXTURE0 + s);
    let u = r.get(l);
    if (l.version !== u.__version || c === true) {
      n.activeTexture(e.TEXTURE0 + s);
      let t = j_.getPrimaries(j_.workingColorSpace);
      let r = o.colorSpace === `` ? null : j_.getPrimaries(o.colorSpace);
      let d = o.colorSpace === `` || t === r ? e.NONE : e.BROWSER_DEFAULT_WEBGL;
      n.pixelStorei(e.UNPACK_FLIP_Y_WEBGL, o.flipY);
      n.pixelStorei(e.UNPACK_PREMULTIPLY_ALPHA_WEBGL, o.premultiplyAlpha);
      n.pixelStorei(e.UNPACK_ALIGNMENT, o.unpackAlignment);
      n.pixelStorei(e.UNPACK_COLORSPACE_CONVERSION_WEBGL, d);
      let f = o.isCompressedTexture || o.image[0].isCompressedTexture;
      let p = o.image[0] && o.image[0].isDataTexture;
      let m = [];
      for (let e = 0; e < 6; e++) {
        if (!f && !p) {
          m[e] = g(o.image[e], true, i.maxCubemapSize);
        } else {
          m[e] = p ? o.image[e].image : o.image[e];
        }
        m[e] = F(o, m[e]);
      }
      let h = m[0];
      let y = a.convert(o.format, o.colorSpace);
      let x = a.convert(o.type);
      let C = b(o.internalFormat, y, x, o.normalized, o.colorSpace);
      let w = o.isVideoTexture !== true;
      let T = u.__version === undefined || c === true;
      let E = l.dataReady;
      let D = S(o, h);
      ce(e.TEXTURE_CUBE_MAP, o);
      let O;
      if (f) {
        if (w && T) {
          n.texStorage2D(e.TEXTURE_CUBE_MAP, D, C, h.width, h.height);
        }
        for (let t = 0; t < 6; t++) {
          O = m[t].mipmaps;
          for (let r = 0; r < O.length; r++) {
            let i = O[r];
            if (o.format === 1023) {
              if (w) {
                if (E) {
                  n.texSubImage2D(e.TEXTURE_CUBE_MAP_POSITIVE_X + t, r, 0, 0, i.width, i.height, y, x, i.data);
                }
              } else {
                n.texImage2D(e.TEXTURE_CUBE_MAP_POSITIVE_X + t, r, C, i.width, i.height, 0, y, x, i.data);
              }
            } else if (y === null) {
              Ug(`WebGLRenderer: Attempt to load unsupported compressed texture format in .setTextureCube()`);
            } else if (w) {
              if (E) {
                n.compressedTexSubImage2D(e.TEXTURE_CUBE_MAP_POSITIVE_X + t, r, 0, 0, i.width, i.height, y, i.data);
              }
            } else {
              n.compressedTexImage2D(e.TEXTURE_CUBE_MAP_POSITIVE_X + t, r, C, i.width, i.height, 0, i.data);
            }
          }
        }
      } else {
        O = o.mipmaps;
        if (w && T) {
          if (O.length > 0) {
            D++;
          }
          let t = Te(m[0]);
          n.texStorage2D(e.TEXTURE_CUBE_MAP, D, C, t.width, t.height);
        }
        for (let t = 0; t < 6; t++) {
          if (p) {
            if (w) {
              if (E) {
                n.texSubImage2D(e.TEXTURE_CUBE_MAP_POSITIVE_X + t, 0, 0, 0, m[t].width, m[t].height, y, x, m[t].data);
              }
            } else {
              n.texImage2D(e.TEXTURE_CUBE_MAP_POSITIVE_X + t, 0, C, m[t].width, m[t].height, 0, y, x, m[t].data);
            }
            for (let r = 0; r < O.length; r++) {
              let i = O[r].image[t].image;
              if (w) {
                if (E) {
                  n.texSubImage2D(e.TEXTURE_CUBE_MAP_POSITIVE_X + t, r + 1, 0, 0, i.width, i.height, y, x, i.data);
                }
              } else {
                n.texImage2D(e.TEXTURE_CUBE_MAP_POSITIVE_X + t, r + 1, C, i.width, i.height, 0, y, x, i.data);
              }
            }
          } else {
            if (w) {
              if (E) {
                n.texSubImage2D(e.TEXTURE_CUBE_MAP_POSITIVE_X + t, 0, 0, 0, y, x, m[t]);
              }
            } else {
              n.texImage2D(e.TEXTURE_CUBE_MAP_POSITIVE_X + t, 0, C, y, x, m[t]);
            }
            for (let r = 0; r < O.length; r++) {
              let i = O[r];
              if (w) {
                if (E) {
                  n.texSubImage2D(e.TEXTURE_CUBE_MAP_POSITIVE_X + t, r + 1, 0, 0, y, x, i.image[t]);
                }
              } else {
                n.texImage2D(e.TEXTURE_CUBE_MAP_POSITIVE_X + t, r + 1, C, y, x, i.image[t]);
              }
            }
          }
        }
      }
      if (_(o)) {
        v(e.TEXTURE_CUBE_MAP);
      }
      u.__version = l.version;
      if (o.onUpdate) {
        o.onUpdate(o);
      }
    }
    t.__version = o.version;
  }
  function me(t, i, o, c, l, u) {
    let d = a.convert(o.format, o.colorSpace);
    let f = a.convert(o.type);
    let p = b(o.internalFormat, d, f, o.normalized, o.colorSpace);
    let m = r.get(i);
    let h = r.get(o);
    h.__renderTarget = i;
    if (!m.__hasExternalTextures) {
      let t = Math.max(1, i.width >> u);
      let r = Math.max(1, i.height >> u);
      if (l === e.TEXTURE_3D || l === e.TEXTURE_2D_ARRAY) {
        n.texImage3D(l, u, p, t, r, i.depth, 0, d, f, null);
      } else {
        n.texImage2D(l, u, p, t, r, 0, d, f, null);
      }
    }
    n.bindFramebuffer(e.FRAMEBUFFER, t);
    if (P(i)) {
      s.framebufferTexture2DMultisampleEXT(e.FRAMEBUFFER, c, l, h.__webglTexture, 0, Ce(i));
    } else if (l === e.TEXTURE_2D || l >= e.TEXTURE_CUBE_MAP_POSITIVE_X && l <= e.TEXTURE_CUBE_MAP_NEGATIVE_Z) {
      e.framebufferTexture2D(e.FRAMEBUFFER, c, l, h.__webglTexture, u);
    }
    n.bindFramebuffer(e.FRAMEBUFFER, null);
  }
  function N(t, n, r) {
    e.bindRenderbuffer(e.RENDERBUFFER, t);
    if (n.depthBuffer) {
      let i = n.depthTexture;
      let a = i && i.isDepthTexture ? i.type : null;
      let o = x(n.stencilBuffer, a);
      let c = n.stencilBuffer ? e.DEPTH_STENCIL_ATTACHMENT : e.DEPTH_ATTACHMENT;
      if (P(n)) {
        s.renderbufferStorageMultisampleEXT(e.RENDERBUFFER, Ce(n), o, n.width, n.height);
      } else if (r) {
        e.renderbufferStorageMultisample(e.RENDERBUFFER, Ce(n), o, n.width, n.height);
      } else {
        e.renderbufferStorage(e.RENDERBUFFER, o, n.width, n.height);
      }
      e.framebufferRenderbuffer(e.FRAMEBUFFER, c, e.RENDERBUFFER, t);
    } else {
      let t = n.textures;
      for (let i = 0; i < t.length; i++) {
        let o = t[i];
        let c = a.convert(o.format, o.colorSpace);
        let l = a.convert(o.type);
        let u = b(o.internalFormat, c, l, o.normalized, o.colorSpace);
        if (P(n)) {
          s.renderbufferStorageMultisampleEXT(e.RENDERBUFFER, Ce(n), u, n.width, n.height);
        } else if (r) {
          e.renderbufferStorageMultisample(e.RENDERBUFFER, Ce(n), u, n.width, n.height);
        } else {
          e.renderbufferStorage(e.RENDERBUFFER, u, n.width, n.height);
        }
      }
    }
    e.bindRenderbuffer(e.RENDERBUFFER, null);
  }
  function he(t, i, o) {
    let c = i.isWebGLCubeRenderTarget === true;
    n.bindFramebuffer(e.FRAMEBUFFER, t);
    if (!i.depthTexture || !i.depthTexture.isDepthTexture) {
      throw Error(`THREE.WebGLTextures: renderTarget.depthTexture must be an instance of THREE.DepthTexture.`);
    }
    let l = r.get(i.depthTexture);
    l.__renderTarget = i;
    if (!l.__webglTexture || i.depthTexture.image.width !== i.width || i.depthTexture.image.height !== i.height) {
      i.depthTexture.image.width = i.width;
      i.depthTexture.image.height = i.height;
      i.depthTexture.needsUpdate = true;
    }
    if (c) {
      if (l.__webglInit === undefined) {
        l.__webglInit = true;
        i.depthTexture.addEventListener(`dispose`, C);
      }
      if (l.__webglTexture === undefined) {
        l.__webglTexture = e.createTexture();
        n.bindTexture(e.TEXTURE_CUBE_MAP, l.__webglTexture);
        ce(e.TEXTURE_CUBE_MAP, i.depthTexture);
        let t = a.convert(i.depthTexture.format);
        let r = a.convert(i.depthTexture.type);
        let o;
        if (i.depthTexture.format === 1026) {
          o = e.DEPTH_COMPONENT24;
        } else if (i.depthTexture.format === 1027) {
          o = e.DEPTH24_STENCIL8;
        }
        for (let n = 0; n < 6; n++) {
          e.texImage2D(e.TEXTURE_CUBE_MAP_POSITIVE_X + n, 0, o, i.width, i.height, 0, t, r, null);
        }
      }
    } else {
      ne(i.depthTexture, 0);
    }
    let u = l.__webglTexture;
    let d = Ce(i);
    let f = c ? e.TEXTURE_CUBE_MAP_POSITIVE_X + o : e.TEXTURE_2D;
    let p = i.depthTexture.format === 1027 ? e.DEPTH_STENCIL_ATTACHMENT : e.DEPTH_ATTACHMENT;
    if (i.depthTexture.format === 1026) {
      if (P(i)) {
        s.framebufferTexture2DMultisampleEXT(e.FRAMEBUFFER, p, f, u, 0, d);
      } else {
        e.framebufferTexture2D(e.FRAMEBUFFER, p, f, u, 0);
      }
    } else if (i.depthTexture.format === 1027) {
      if (P(i)) {
        s.framebufferTexture2DMultisampleEXT(e.FRAMEBUFFER, p, f, u, 0, d);
      } else {
        e.framebufferTexture2D(e.FRAMEBUFFER, p, f, u, 0);
      }
    } else {
      throw Error(`THREE.WebGLTextures: Unknown depthTexture format.`);
    }
  }
  function ge(t) {
    let i = r.get(t);
    let a = t.isWebGLCubeRenderTarget === true;
    if (i.__boundDepthTexture !== t.depthTexture) {
      let e = t.depthTexture;
      if (i.__depthDisposeCallback) {
        i.__depthDisposeCallback();
      }
      if (e) {
        let t = () => {
          delete i.__boundDepthTexture;
          delete i.__depthDisposeCallback;
          e.removeEventListener(`dispose`, t);
        };
        e.addEventListener(`dispose`, t);
        i.__depthDisposeCallback = t;
      }
      i.__boundDepthTexture = e;
    }
    if (t.depthTexture && !i.__autoAllocateDepthBuffer) {
      if (a) {
        for (let e = 0; e < 6; e++) {
          he(i.__webglFramebuffer[e], t, e);
        }
      } else {
        let e = t.texture.mipmaps;
        if (e && e.length > 0) {
          he(i.__webglFramebuffer[0], t, 0);
        } else {
          he(i.__webglFramebuffer, t, 0);
        }
      }
    } else if (a) {
      i.__webglDepthbuffer = [];
      for (let r = 0; r < 6; r++) {
        n.bindFramebuffer(e.FRAMEBUFFER, i.__webglFramebuffer[r]);
        if (i.__webglDepthbuffer[r] === undefined) {
          i.__webglDepthbuffer[r] = e.createRenderbuffer();
          N(i.__webglDepthbuffer[r], t, false);
        } else {
          let n = t.stencilBuffer ? e.DEPTH_STENCIL_ATTACHMENT : e.DEPTH_ATTACHMENT;
          let a = i.__webglDepthbuffer[r];
          e.bindRenderbuffer(e.RENDERBUFFER, a);
          e.framebufferRenderbuffer(e.FRAMEBUFFER, n, e.RENDERBUFFER, a);
        }
      }
    } else {
      let r = t.texture.mipmaps;
      if (r && r.length > 0) {
        n.bindFramebuffer(e.FRAMEBUFFER, i.__webglFramebuffer[0]);
      } else {
        n.bindFramebuffer(e.FRAMEBUFFER, i.__webglFramebuffer);
      }
      if (i.__webglDepthbuffer === undefined) {
        i.__webglDepthbuffer = e.createRenderbuffer();
        N(i.__webglDepthbuffer, t, false);
      } else {
        let n = t.stencilBuffer ? e.DEPTH_STENCIL_ATTACHMENT : e.DEPTH_ATTACHMENT;
        let r = i.__webglDepthbuffer;
        e.bindRenderbuffer(e.RENDERBUFFER, r);
        e.framebufferRenderbuffer(e.FRAMEBUFFER, n, e.RENDERBUFFER, r);
      }
    }
    n.bindFramebuffer(e.FRAMEBUFFER, null);
  }
  function _e(t, n, i) {
    let a = r.get(t);
    if (n !== undefined) {
      me(a.__webglFramebuffer, t, t.texture, e.COLOR_ATTACHMENT0, e.TEXTURE_2D, 0);
    }
    if (i !== undefined) {
      ge(t);
    }
  }
  function ve(t) {
    let i = t.texture;
    let s = r.get(t);
    let c = r.get(i);
    t.addEventListener(`dispose`, w);
    let l = t.textures;
    let u = t.isWebGLCubeRenderTarget === true;
    let d = l.length > 1;
    if (!d) {
      if (c.__webglTexture === undefined) {
        c.__webglTexture = e.createTexture();
      }
      c.__version = i.version;
      o.memory.textures++;
    }
    if (u) {
      s.__webglFramebuffer = [];
      for (let t = 0; t < 6; t++) {
        if (i.mipmaps && i.mipmaps.length > 0) {
          s.__webglFramebuffer[t] = [];
          for (let n = 0; n < i.mipmaps.length; n++) {
            s.__webglFramebuffer[t][n] = e.createFramebuffer();
          }
        } else {
          s.__webglFramebuffer[t] = e.createFramebuffer();
        }
      }
    } else {
      if (i.mipmaps && i.mipmaps.length > 0) {
        s.__webglFramebuffer = [];
        for (let t = 0; t < i.mipmaps.length; t++) {
          s.__webglFramebuffer[t] = e.createFramebuffer();
        }
      } else {
        s.__webglFramebuffer = e.createFramebuffer();
      }
      if (d) {
        for (let t = 0, n = l.length; t < n; t++) {
          let n = r.get(l[t]);
          if (n.__webglTexture === undefined) {
            n.__webglTexture = e.createTexture();
            o.memory.textures++;
          }
        }
      }
      if (t.samples > 0 && P(t) === false) {
        s.__webglMultisampledFramebuffer = e.createFramebuffer();
        s.__webglColorRenderbuffer = [];
        n.bindFramebuffer(e.FRAMEBUFFER, s.__webglMultisampledFramebuffer);
        for (let n = 0; n < l.length; n++) {
          let r = l[n];
          s.__webglColorRenderbuffer[n] = e.createRenderbuffer();
          e.bindRenderbuffer(e.RENDERBUFFER, s.__webglColorRenderbuffer[n]);
          let i = a.convert(r.format, r.colorSpace);
          let o = a.convert(r.type);
          let c = b(r.internalFormat, i, o, r.normalized, r.colorSpace, t.isXRRenderTarget === true);
          let u = Ce(t);
          e.renderbufferStorageMultisample(e.RENDERBUFFER, u, c, t.width, t.height);
          e.framebufferRenderbuffer(e.FRAMEBUFFER, e.COLOR_ATTACHMENT0 + n, e.RENDERBUFFER, s.__webglColorRenderbuffer[n]);
        }
        e.bindRenderbuffer(e.RENDERBUFFER, null);
        if (t.depthBuffer) {
          s.__webglDepthRenderbuffer = e.createRenderbuffer();
          N(s.__webglDepthRenderbuffer, t, true);
        }
        n.bindFramebuffer(e.FRAMEBUFFER, null);
      }
    }
    if (u) {
      n.bindTexture(e.TEXTURE_CUBE_MAP, c.__webglTexture);
      ce(e.TEXTURE_CUBE_MAP, i);
      for (let n = 0; n < 6; n++) {
        if (i.mipmaps && i.mipmaps.length > 0) {
          for (let r = 0; r < i.mipmaps.length; r++) {
            me(s.__webglFramebuffer[n][r], t, i, e.COLOR_ATTACHMENT0, e.TEXTURE_CUBE_MAP_POSITIVE_X + n, r);
          }
        } else {
          me(s.__webglFramebuffer[n], t, i, e.COLOR_ATTACHMENT0, e.TEXTURE_CUBE_MAP_POSITIVE_X + n, 0);
        }
      }
      if (_(i)) {
        v(e.TEXTURE_CUBE_MAP);
      }
      n.unbindTexture();
    } else if (d) {
      for (let i = 0, a = l.length; i < a; i++) {
        let a = l[i];
        let o = r.get(a);
        let c = e.TEXTURE_2D;
        if (t.isWebGL3DRenderTarget || t.isWebGLArrayRenderTarget) {
          c = t.isWebGL3DRenderTarget ? e.TEXTURE_3D : e.TEXTURE_2D_ARRAY;
        }
        n.bindTexture(c, o.__webglTexture);
        ce(c, a);
        me(s.__webglFramebuffer, t, a, e.COLOR_ATTACHMENT0 + i, c, 0);
        if (_(a)) {
          v(c);
        }
      }
      n.unbindTexture();
    } else {
      let r = e.TEXTURE_2D;
      if (t.isWebGL3DRenderTarget || t.isWebGLArrayRenderTarget) {
        r = t.isWebGL3DRenderTarget ? e.TEXTURE_3D : e.TEXTURE_2D_ARRAY;
      }
      n.bindTexture(r, c.__webglTexture);
      ce(r, i);
      if (i.mipmaps && i.mipmaps.length > 0) {
        for (let n = 0; n < i.mipmaps.length; n++) {
          me(s.__webglFramebuffer[n], t, i, e.COLOR_ATTACHMENT0, r, n);
        }
      } else {
        me(s.__webglFramebuffer, t, i, e.COLOR_ATTACHMENT0, r, 0);
      }
      if (_(i)) {
        v(r);
      }
      n.unbindTexture();
    }
    if (t.depthBuffer) {
      ge(t);
    }
  }
  function ye(e) {
    let t = e.textures;
    for (let i = 0, a = t.length; i < a; i++) {
      let a = t[i];
      if (_(a)) {
        let t = y(e);
        let i = r.get(a).__webglTexture;
        n.bindTexture(t, i);
        v(t);
        n.unbindTexture();
      }
    }
  }
  let be = [];
  let xe = [];
  function Se(t) {
    if (t.samples > 0) {
      if (P(t) === false) {
        let i = t.textures;
        let a = t.width;
        let o = t.height;
        let s = e.COLOR_BUFFER_BIT;
        let l = t.stencilBuffer ? e.DEPTH_STENCIL_ATTACHMENT : e.DEPTH_ATTACHMENT;
        let u = r.get(t);
        let d = i.length > 1;
        if (d) {
          for (let t = 0; t < i.length; t++) {
            n.bindFramebuffer(e.FRAMEBUFFER, u.__webglMultisampledFramebuffer);
            e.framebufferRenderbuffer(e.FRAMEBUFFER, e.COLOR_ATTACHMENT0 + t, e.RENDERBUFFER, null);
            n.bindFramebuffer(e.FRAMEBUFFER, u.__webglFramebuffer);
            e.framebufferTexture2D(e.DRAW_FRAMEBUFFER, e.COLOR_ATTACHMENT0 + t, e.TEXTURE_2D, null, 0);
          }
        }
        n.bindFramebuffer(e.READ_FRAMEBUFFER, u.__webglMultisampledFramebuffer);
        let f = t.texture.mipmaps;
        if (f && f.length > 0) {
          n.bindFramebuffer(e.DRAW_FRAMEBUFFER, u.__webglFramebuffer[0]);
        } else {
          n.bindFramebuffer(e.DRAW_FRAMEBUFFER, u.__webglFramebuffer);
        }
        for (let n = 0; n < i.length; n++) {
          if (t.resolveDepthBuffer) {
            if (t.depthBuffer) {
              s |= e.DEPTH_BUFFER_BIT;
            }
            if (t.stencilBuffer && t.resolveStencilBuffer) {
              s |= e.STENCIL_BUFFER_BIT;
            }
          }
          if (d) {
            e.framebufferRenderbuffer(e.READ_FRAMEBUFFER, e.COLOR_ATTACHMENT0, e.RENDERBUFFER, u.__webglColorRenderbuffer[n]);
            let t = r.get(i[n]).__webglTexture;
            e.framebufferTexture2D(e.DRAW_FRAMEBUFFER, e.COLOR_ATTACHMENT0, e.TEXTURE_2D, t, 0);
          }
          e.blitFramebuffer(0, 0, a, o, 0, 0, a, o, s, e.NEAREST);
          if (c === true) {
            be.length = 0;
            xe.length = 0;
            be.push(e.COLOR_ATTACHMENT0 + n);
            if (t.depthBuffer && t.storeMultisampledDepthBuffer === false) {
              be.push(l);
              xe.push(l);
              e.invalidateFramebuffer(e.DRAW_FRAMEBUFFER, xe);
            }
            e.invalidateFramebuffer(e.READ_FRAMEBUFFER, be);
          }
        }
        n.bindFramebuffer(e.READ_FRAMEBUFFER, null);
        n.bindFramebuffer(e.DRAW_FRAMEBUFFER, null);
        if (d) {
          for (let t = 0; t < i.length; t++) {
            n.bindFramebuffer(e.FRAMEBUFFER, u.__webglMultisampledFramebuffer);
            e.framebufferRenderbuffer(e.FRAMEBUFFER, e.COLOR_ATTACHMENT0 + t, e.RENDERBUFFER, u.__webglColorRenderbuffer[t]);
            let a = r.get(i[t]).__webglTexture;
            n.bindFramebuffer(e.FRAMEBUFFER, u.__webglFramebuffer);
            e.framebufferTexture2D(e.DRAW_FRAMEBUFFER, e.COLOR_ATTACHMENT0 + t, e.TEXTURE_2D, a, 0);
          }
        }
        n.bindFramebuffer(e.DRAW_FRAMEBUFFER, u.__webglMultisampledFramebuffer);
      } else if (t.depthBuffer && t.storeMultisampledDepthBuffer === false && c) {
        let n = t.stencilBuffer ? e.DEPTH_STENCIL_ATTACHMENT : e.DEPTH_ATTACHMENT;
        e.invalidateFramebuffer(e.DRAW_FRAMEBUFFER, [n]);
      }
    }
  }
  function Ce(e) {
    return Math.min(i.maxSamples, e.samples);
  }
  function P(e) {
    let n = r.get(e);
    return e.samples > 0 && t.has(`WEBGL_multisampled_render_to_texture`) === true && n.__useRenderToTexture !== false;
  }
  function we(e) {
    let t = o.render.frame;
    if (u.get(e) !== t) {
      u.set(e, t);
      e.update();
    }
  }
  function F(e, t) {
    let n = e.colorSpace;
    let r = e.format;
    let i = e.type;
    if (e.isCompressedTexture !== true && e.isVideoTexture !== true) {
      if (n !== `srgb-linear` && n !== ``) {
        if (j_.getTransfer(n) === `srgb`) {
          if (r !== 1023 || i !== 1009) {
            Ug(`WebGLTextures: sRGB encoded textures have to use RGBAFormat and UnsignedByteType.`);
          }
        } else {
          Wg(`WebGLTextures: Unsupported texture color space:`, n);
        }
      }
    }
    return t;
  }
  function Te(e) {
    if (typeof HTMLImageElement < `u` && e instanceof HTMLImageElement) {
      l.width = e.naturalWidth || e.width;
      l.height = e.naturalHeight || e.height;
    } else if (typeof VideoFrame < `u` && e instanceof VideoFrame) {
      l.width = e.displayWidth;
      l.height = e.displayHeight;
    } else {
      l.width = e.width;
      l.height = e.height;
    }
    return l;
  }
  this.allocateTextureUnit = te;
  this.resetTextureUnits = k;
  this.getTextureUnits = A;
  this.setTextureUnits = ee;
  this.setTexture2D = ne;
  this.setTexture2DArray = re;
  this.setTexture3D = M;
  this.setTextureCube = ie;
  this.rebindTextures = _e;
  this.setupRenderTarget = ve;
  this.updateRenderTargetMipmap = ye;
  this.updateMultisampleRenderTarget = Se;
  this.setupDepthRenderbuffer = ge;
  this.setupFrameBufferTexture = me;
  this.useMultisampledRTT = P;
  this.isReversedDepthBuffer = function () {
    return n.buffers.depth.getReversed();
  };
}
function TT(e, t) {
  function n(n, r = ``) {
    let i;
    let a = j_.getTransfer(r);
    if (n === 1009) {
      return e.UNSIGNED_BYTE;
    }
    if (n === 1017) {
      return e.UNSIGNED_SHORT_4_4_4_4;
    }
    if (n === 1018) {
      return e.UNSIGNED_SHORT_5_5_5_1;
    }
    if (n === 35902) {
      return e.UNSIGNED_INT_5_9_9_9_REV;
    }
    if (n === 35899) {
      return e.UNSIGNED_INT_10F_11F_11F_REV;
    }
    if (n === 1010) {
      return e.BYTE;
    }
    if (n === 1011) {
      return e.SHORT;
    }
    if (n === 1012) {
      return e.UNSIGNED_SHORT;
    }
    if (n === 1013) {
      return e.INT;
    }
    if (n === 1014) {
      return e.UNSIGNED_INT;
    }
    if (n === 1015) {
      return e.FLOAT;
    }
    if (n === 1016) {
      return e.HALF_FLOAT;
    }
    if (n === 1021) {
      return e.ALPHA;
    }
    if (n === 1022) {
      return e.RGB;
    }
    if (n === 1023) {
      return e.RGBA;
    }
    if (n === 1026) {
      return e.DEPTH_COMPONENT;
    }
    if (n === 1027) {
      return e.DEPTH_STENCIL;
    }
    if (n === 1028) {
      return e.RED;
    }
    if (n === 1029) {
      return e.RED_INTEGER;
    }
    if (n === 1030) {
      return e.RG;
    }
    if (n === 1031) {
      return e.RG_INTEGER;
    }
    if (n === 1033) {
      return e.RGBA_INTEGER;
    }
    if (n === 33776 || n === 33777 || n === 33778 || n === 33779) {
      if (a === `srgb`) {
        i = t.get(`WEBGL_compressed_texture_s3tc_srgb`);
        if (i !== null) {
          if (n === 33776) {
            return i.COMPRESSED_SRGB_S3TC_DXT1_EXT;
          }
          if (n === 33777) {
            return i.COMPRESSED_SRGB_ALPHA_S3TC_DXT1_EXT;
          }
          if (n === 33778) {
            return i.COMPRESSED_SRGB_ALPHA_S3TC_DXT3_EXT;
          }
          if (n === 33779) {
            return i.COMPRESSED_SRGB_ALPHA_S3TC_DXT5_EXT;
          }
        } else {
          return null;
        }
      } else {
        i = t.get(`WEBGL_compressed_texture_s3tc`);
        if (i !== null) {
          if (n === 33776) {
            return i.COMPRESSED_RGB_S3TC_DXT1_EXT;
          }
          if (n === 33777) {
            return i.COMPRESSED_RGBA_S3TC_DXT1_EXT;
          }
          if (n === 33778) {
            return i.COMPRESSED_RGBA_S3TC_DXT3_EXT;
          }
          if (n === 33779) {
            return i.COMPRESSED_RGBA_S3TC_DXT5_EXT;
          }
        } else {
          return null;
        }
      }
    }
    if (n === 35840 || n === 35841 || n === 35842 || n === 35843) {
      i = t.get(`WEBGL_compressed_texture_pvrtc`);
      if (i !== null) {
        if (n === 35840) {
          return i.COMPRESSED_RGB_PVRTC_4BPPV1_IMG;
        }
        if (n === 35841) {
          return i.COMPRESSED_RGB_PVRTC_2BPPV1_IMG;
        }
        if (n === 35842) {
          return i.COMPRESSED_RGBA_PVRTC_4BPPV1_IMG;
        }
        if (n === 35843) {
          return i.COMPRESSED_RGBA_PVRTC_2BPPV1_IMG;
        }
      } else {
        return null;
      }
    }
    if (n === 36196 || n === 37492 || n === 37496 || n === 37488 || n === 37489 || n === 37490 || n === 37491) {
      i = t.get(`WEBGL_compressed_texture_etc`);
      if (i !== null) {
        if (n === 36196 || n === 37492) {
          if (a === `srgb`) {
            return i.COMPRESSED_SRGB8_ETC2;
          } else {
            return i.COMPRESSED_RGB8_ETC2;
          }
        }
        if (n === 37496) {
          if (a === `srgb`) {
            return i.COMPRESSED_SRGB8_ALPHA8_ETC2_EAC;
          } else {
            return i.COMPRESSED_RGBA8_ETC2_EAC;
          }
        }
        if (n === 37488) {
          return i.COMPRESSED_R11_EAC;
        }
        if (n === 37489) {
          return i.COMPRESSED_SIGNED_R11_EAC;
        }
        if (n === 37490) {
          return i.COMPRESSED_RG11_EAC;
        }
        if (n === 37491) {
          return i.COMPRESSED_SIGNED_RG11_EAC;
        }
      } else {
        return null;
      }
    }
    if (n === 37808 || n === 37809 || n === 37810 || n === 37811 || n === 37812 || n === 37813 || n === 37814 || n === 37815 || n === 37816 || n === 37817 || n === 37818 || n === 37819 || n === 37820 || n === 37821) {
      i = t.get(`WEBGL_compressed_texture_astc`);
      if (i !== null) {
        if (n === 37808) {
          if (a === `srgb`) {
            return i.COMPRESSED_SRGB8_ALPHA8_ASTC_4x4_KHR;
          } else {
            return i.COMPRESSED_RGBA_ASTC_4x4_KHR;
          }
        }
        if (n === 37809) {
          if (a === `srgb`) {
            return i.COMPRESSED_SRGB8_ALPHA8_ASTC_5x4_KHR;
          } else {
            return i.COMPRESSED_RGBA_ASTC_5x4_KHR;
          }
        }
        if (n === 37810) {
          if (a === `srgb`) {
            return i.COMPRESSED_SRGB8_ALPHA8_ASTC_5x5_KHR;
          } else {
            return i.COMPRESSED_RGBA_ASTC_5x5_KHR;
          }
        }
        if (n === 37811) {
          if (a === `srgb`) {
            return i.COMPRESSED_SRGB8_ALPHA8_ASTC_6x5_KHR;
          } else {
            return i.COMPRESSED_RGBA_ASTC_6x5_KHR;
          }
        }
        if (n === 37812) {
          if (a === `srgb`) {
            return i.COMPRESSED_SRGB8_ALPHA8_ASTC_6x6_KHR;
          } else {
            return i.COMPRESSED_RGBA_ASTC_6x6_KHR;
          }
        }
        if (n === 37813) {
          if (a === `srgb`) {
            return i.COMPRESSED_SRGB8_ALPHA8_ASTC_8x5_KHR;
          } else {
            return i.COMPRESSED_RGBA_ASTC_8x5_KHR;
          }
        }
        if (n === 37814) {
          if (a === `srgb`) {
            return i.COMPRESSED_SRGB8_ALPHA8_ASTC_8x6_KHR;
          } else {
            return i.COMPRESSED_RGBA_ASTC_8x6_KHR;
          }
        }
        if (n === 37815) {
          if (a === `srgb`) {
            return i.COMPRESSED_SRGB8_ALPHA8_ASTC_8x8_KHR;
          } else {
            return i.COMPRESSED_RGBA_ASTC_8x8_KHR;
          }
        }
        if (n === 37816) {
          if (a === `srgb`) {
            return i.COMPRESSED_SRGB8_ALPHA8_ASTC_10x5_KHR;
          } else {
            return i.COMPRESSED_RGBA_ASTC_10x5_KHR;
          }
        }
        if (n === 37817) {
          if (a === `srgb`) {
            return i.COMPRESSED_SRGB8_ALPHA8_ASTC_10x6_KHR;
          } else {
            return i.COMPRESSED_RGBA_ASTC_10x6_KHR;
          }
        }
        if (n === 37818) {
          if (a === `srgb`) {
            return i.COMPRESSED_SRGB8_ALPHA8_ASTC_10x8_KHR;
          } else {
            return i.COMPRESSED_RGBA_ASTC_10x8_KHR;
          }
        }
        if (n === 37819) {
          if (a === `srgb`) {
            return i.COMPRESSED_SRGB8_ALPHA8_ASTC_10x10_KHR;
          } else {
            return i.COMPRESSED_RGBA_ASTC_10x10_KHR;
          }
        }
        if (n === 37820) {
          if (a === `srgb`) {
            return i.COMPRESSED_SRGB8_ALPHA8_ASTC_12x10_KHR;
          } else {
            return i.COMPRESSED_RGBA_ASTC_12x10_KHR;
          }
        }
        if (n === 37821) {
          if (a === `srgb`) {
            return i.COMPRESSED_SRGB8_ALPHA8_ASTC_12x12_KHR;
          } else {
            return i.COMPRESSED_RGBA_ASTC_12x12_KHR;
          }
        }
      } else {
        return null;
      }
    }
    if (n === 36492 || n === 36494 || n === 36495) {
      i = t.get(`EXT_texture_compression_bptc`);
      if (i !== null) {
        if (n === 36492) {
          if (a === `srgb`) {
            return i.COMPRESSED_SRGB_ALPHA_BPTC_UNORM_EXT;
          } else {
            return i.COMPRESSED_RGBA_BPTC_UNORM_EXT;
          }
        }
        if (n === 36494) {
          return i.COMPRESSED_RGB_BPTC_SIGNED_FLOAT_EXT;
        }
        if (n === 36495) {
          return i.COMPRESSED_RGB_BPTC_UNSIGNED_FLOAT_EXT;
        }
      } else {
        return null;
      }
    }
    if (n === 36283 || n === 36284 || n === 36285 || n === 36286) {
      i = t.get(`EXT_texture_compression_rgtc`);
      if (i !== null) {
        if (n === 36283) {
          return i.COMPRESSED_RED_RGTC1_EXT;
        }
        if (n === 36284) {
          return i.COMPRESSED_SIGNED_RED_RGTC1_EXT;
        }
        if (n === 36285) {
          return i.COMPRESSED_RED_GREEN_RGTC2_EXT;
        }
        if (n === 36286) {
          return i.COMPRESSED_SIGNED_RED_GREEN_RGTC2_EXT;
        }
      } else {
        return null;
      }
    }
    if (n === 1020) {
      return e.UNSIGNED_INT_24_8;
    } else if (e[n] === undefined) {
      return null;
    } else {
      return e[n];
    }
  }
  return {
    convert: n
  };
}
var ET = `
void main() {

	gl_Position = vec4( position, 1.0 );

}`;
var DT = `
uniform sampler2DArray depthColor;
uniform float depthWidth;
uniform float depthHeight;

void main() {

	vec2 coord = vec2( gl_FragCoord.x / depthWidth, gl_FragCoord.y / depthHeight );

	if ( coord.x >= 1.0 ) {

		gl_FragDepth = texture( depthColor, vec3( coord.x - 1.0, coord.y, 1 ) ).r;

	} else {

		gl_FragDepth = texture( depthColor, vec3( coord.x, coord.y, 0 ) ).r;

	}

}`;
var OT = class {
  constructor() {
    this.texture = null;
    this.mesh = null;
    this.depthNear = 0;
    this.depthFar = 0;
  }
  init(e, t) {
    if (this.texture === null) {
      let n = new Rb(e.texture);
      if (e.depthNear !== t.depthNear || e.depthFar !== t.depthFar) {
        this.depthNear = e.depthNear;
        this.depthFar = e.depthFar;
      }
      this.texture = n;
    }
  }
  getMesh(e) {
    if (this.texture !== null && this.mesh === null) {
      let t = e.cameras[0].viewport;
      let n = new nx({
        vertexShader: ET,
        fragmentShader: DT,
        uniforms: {
          depthColor: {
            value: this.texture
          },
          depthWidth: {
            value: t.z
          },
          depthHeight: {
            value: t.w
          }
        }
      });
      this.mesh = new pb(new Kb(20, 20), n);
    }
    return this.mesh;
  }
  reset() {
    this.texture = null;
    this.mesh = null;
  }
  getDepthTexture() {
    return this.texture;
  }
};
var kT = class extends Jg {
  constructor(e, t) {
    super();
    let n = this;
    let r = null;
    let i = 1;
    let a = null;
    let o = `local-floor`;
    let s = 1;
    let c = null;
    let l = null;
    let u = null;
    let d = null;
    let f = null;
    let p = null;
    let m = typeof XRWebGLBinding < `u`;
    let h = new OT();
    let g = {};
    let _ = t.getContextAttributes();
    let v = null;
    let y = null;
    let b = [];
    let x = [];
    let S = new S_();
    let C = null;
    let w = null;
    let T = new Kx();
    T.viewport = new H_();
    let E = new Kx();
    E.viewport = new H_();
    let D = [T, E];
    let O = new $x();
    let k = null;
    let A = null;
    this.cameraAutoUpdate = true;
    this.enabled = false;
    this.isPresenting = false;
    this.getController = function (e) {
      let t = b[e];
      if (t === undefined) {
        t = new Cv();
        b[e] = t;
      }
      return t.getTargetRaySpace();
    };
    this.getControllerGrip = function (e) {
      let t = b[e];
      if (t === undefined) {
        t = new Cv();
        b[e] = t;
      }
      return t.getGripSpace();
    };
    this.getHand = function (e) {
      let t = b[e];
      if (t === undefined) {
        t = new Cv();
        b[e] = t;
      }
      return t.getHandSpace();
    };
    function ee(e) {
      let t = x.indexOf(e.inputSource);
      if (t === -1) {
        return;
      }
      let n = b[t];
      if (n !== undefined) {
        n.update(e.inputSource, e.frame, c || a);
        n.dispatchEvent({
          type: e.type,
          data: e.inputSource
        });
      }
    }
    function te() {
      r.removeEventListener(`select`, ee);
      r.removeEventListener(`selectstart`, ee);
      r.removeEventListener(`selectend`, ee);
      r.removeEventListener(`squeeze`, ee);
      r.removeEventListener(`squeezestart`, ee);
      r.removeEventListener(`squeezeend`, ee);
      r.removeEventListener(`end`, te);
      r.removeEventListener(`inputsourceschange`, j);
      for (let e = 0; e < b.length; e++) {
        let t = x[e];
        if (t !== null) {
          x[e] = null;
          b[e].disconnect(t);
        }
      }
      k = null;
      A = null;
      h.reset();
      for (let e in g) {
        delete g[e];
      }
      e.setRenderTarget(v);
      f = null;
      d = null;
      u = null;
      r = null;
      y = null;
      ce.stop();
      n.isPresenting = false;
      e.setPixelRatio(C);
      e.setSize(S.width, S.height, false);
      if (w !== null) {
        let e = w.camera;
        e.fov = w.fov;
        e.zoom = w.zoom;
        e.updateProjectionMatrix();
        w = null;
      }
      n.dispatchEvent({
        type: `sessionend`
      });
    }
    this.setFramebufferScaleFactor = function (e) {
      i = e;
      if (n.isPresenting === true) {
        Ug(`WebXRManager: Cannot change framebuffer scale while presenting.`);
      }
    };
    this.setReferenceSpaceType = function (e) {
      o = e;
      if (n.isPresenting === true) {
        Ug(`WebXRManager: Cannot change reference space type while presenting.`);
      }
    };
    this.getReferenceSpace = function () {
      return c || a;
    };
    this.setReferenceSpace = function (e) {
      c = e;
    };
    this.getBaseLayer = function () {
      if (d === null) {
        return f;
      } else {
        return d;
      }
    };
    this.getBinding = function () {
      if (u === null && m) {
        u = new XRWebGLBinding(r, t);
      }
      return u;
    };
    this.getFrame = function () {
      return p;
    };
    this.getSession = function () {
      return r;
    };
    this.setSession = async function (l) {
      r = l;
      if (r !== null) {
        v = e.getRenderTarget();
        r.addEventListener(`select`, ee);
        r.addEventListener(`selectstart`, ee);
        r.addEventListener(`selectend`, ee);
        r.addEventListener(`squeeze`, ee);
        r.addEventListener(`squeezestart`, ee);
        r.addEventListener(`squeezeend`, ee);
        r.addEventListener(`end`, te);
        r.addEventListener(`inputsourceschange`, j);
        if (_.xrCompatible !== true) {
          await t.makeXRCompatible();
        }
        C = e.getPixelRatio();
        e.getSize(S);
        if (m && `createProjectionLayer` in XRWebGLBinding.prototype) {
          let n = null;
          let a = null;
          let o = null;
          if (_.depth) {
            o = _.stencil ? t.DEPTH24_STENCIL8 : t.DEPTH_COMPONENT24;
            n = _.stencil ? Nh : Mh;
            a = _.stencil ? Eh : xh;
          }
          let s = {
            colorFormat: t.RGBA8,
            depthFormat: o,
            scaleFactor: i
          };
          u = this.getBinding();
          d = u.createProjectionLayer(s);
          r.updateRenderState({
            layers: [d]
          });
          e.setPixelRatio(1);
          e.setSize(d.textureWidth, d.textureHeight, false);
          y = new W_(d.textureWidth, d.textureHeight, {
            format: jh,
            type: gh,
            depthTexture: new Ib(d.textureWidth, d.textureHeight, a, undefined, undefined, undefined, undefined, undefined, undefined, n),
            stencilBuffer: _.stencil,
            colorSpace: e.outputColorSpace,
            samples: _.antialias ? 4 : 0,
            resolveDepthBuffer: d.ignoreDepthValues === false,
            resolveStencilBuffer: d.ignoreDepthValues === false,
            storeMultisampledDepthBuffer: d.ignoreDepthValues === false,
            storeMultisampledStencilBuffer: d.ignoreDepthValues === false
          });
        } else {
          let n = {
            antialias: _.antialias,
            alpha: true,
            depth: _.depth,
            stencil: _.stencil,
            framebufferScaleFactor: i
          };
          f = new XRWebGLLayer(r, t, n);
          r.updateRenderState({
            baseLayer: f
          });
          e.setPixelRatio(1);
          e.setSize(f.framebufferWidth, f.framebufferHeight, false);
          y = new W_(f.framebufferWidth, f.framebufferHeight, {
            format: jh,
            type: gh,
            colorSpace: e.outputColorSpace,
            stencilBuffer: _.stencil,
            resolveDepthBuffer: f.ignoreDepthValues === false,
            resolveStencilBuffer: f.ignoreDepthValues === false,
            storeMultisampledDepthBuffer: f.ignoreDepthValues === false,
            storeMultisampledStencilBuffer: f.ignoreDepthValues === false
          });
        }
        y.isXRRenderTarget = true;
        this.setFoveation(s);
        c = null;
        a = await r.requestReferenceSpace(o);
        ce.setContext(r);
        ce.start();
        n.isPresenting = true;
        n.dispatchEvent({
          type: `sessionstart`
        });
      }
    };
    this.getEnvironmentBlendMode = function () {
      if (r !== null) {
        return r.environmentBlendMode;
      }
    };
    this.getDepthTexture = function () {
      return h.getDepthTexture();
    };
    function j(e) {
      for (let t = 0; t < e.removed.length; t++) {
        let n = e.removed[t];
        let r = x.indexOf(n);
        if (r >= 0) {
          x[r] = null;
          b[r].disconnect(n);
        }
      }
      for (let t = 0; t < e.added.length; t++) {
        let n = e.added[t];
        let r = x.indexOf(n);
        if (r === -1) {
          for (let e = 0; e < b.length; e++) {
            if (e >= x.length) {
              x.push(n);
              r = e;
              break;
            } else if (x[e] === null) {
              x[e] = n;
              r = e;
              break;
            }
          }
          if (r === -1) {
            break;
          }
        }
        let i = b[r];
        if (i) {
          i.connect(n);
        }
      }
    }
    let ne = new X();
    let re = new X();
    function M(e, t, n) {
      ne.setFromMatrixPosition(t.matrixWorld);
      re.setFromMatrixPosition(n.matrixWorld);
      let r = ne.distanceTo(re);
      let i = t.projectionMatrix.elements;
      let a = n.projectionMatrix.elements;
      let o = i[14] / (i[10] - 1);
      let s = i[14] / (i[10] + 1);
      let c = (i[9] + 1) / i[5];
      let l = (i[9] - 1) / i[5];
      let u = (i[8] - 1) / i[0];
      let d = (a[8] + 1) / a[0];
      let f = o * u;
      let p = o * d;
      let m = r / (-u + d);
      let h = m * -u;
      t.matrixWorld.decompose(e.position, e.quaternion, e.scale);
      e.translateX(h);
      e.translateZ(m);
      e.matrixWorld.compose(e.position, e.quaternion, e.scale);
      e.matrixWorldInverse.copy(e.matrixWorld).invert();
      if (i[10] === -1) {
        e.projectionMatrix.copy(t.projectionMatrix);
        e.projectionMatrixInverse.copy(t.projectionMatrixInverse);
      } else {
        let t = o + m;
        let n = s + m;
        let i = f - h;
        let a = p + (r - h);
        let u = c * s / n * t;
        let d = l * s / n * t;
        e.projectionMatrix.makePerspective(i, a, u, d, t, n);
        e.projectionMatrixInverse.copy(e.projectionMatrix).invert();
      }
    }
    function ie(e, t) {
      if (t === null) {
        e.matrixWorld.copy(e.matrix);
      } else {
        e.matrixWorld.multiplyMatrices(t.matrixWorld, e.matrix);
      }
      e.matrixWorldInverse.copy(e.matrixWorld).invert();
    }
    this.updateCamera = function (e) {
      if (r === null) {
        return;
      }
      let t = e.near;
      let n = e.far;
      if (h.texture !== null) {
        if (h.depthNear > 0) {
          t = h.depthNear;
        }
        if (h.depthFar > 0) {
          n = h.depthFar;
        }
      }
      O.near = E.near = T.near = t;
      O.far = E.far = T.far = n;
      if (k !== O.near || A !== O.far) {
        r.updateRenderState({
          depthNear: O.near,
          depthFar: O.far
        });
        k = O.near;
        A = O.far;
      }
      O.layers.mask = e.layers.mask | 6;
      T.layers.mask = O.layers.mask & -5;
      E.layers.mask = O.layers.mask & -3;
      let i = e.parent;
      let a = O.cameras;
      ie(O, i);
      for (let e = 0; e < a.length; e++) {
        ie(a[e], i);
      }
      if (a.length === 2) {
        M(O, T, E);
      } else {
        O.projectionMatrix.copy(T.projectionMatrix);
      }
      if (w === null && e.isPerspectiveCamera) {
        w = {
          camera: e,
          fov: e.fov,
          zoom: e.zoom
        };
      }
      ae(e, O, i);
    };
    function ae(e, t, n) {
      if (n === null) {
        e.matrix.copy(t.matrixWorld);
      } else {
        e.matrix.copy(n.matrixWorld);
        e.matrix.invert();
        e.matrix.multiply(t.matrixWorld);
      }
      e.matrix.decompose(e.position, e.quaternion, e.scale);
      e.updateMatrixWorld(true);
      e.projectionMatrix.copy(t.projectionMatrix);
      e.projectionMatrixInverse.copy(t.projectionMatrixInverse);
      if (e.isPerspectiveCamera) {
        e.fov = Qg * 2 * Math.atan(1 / e.projectionMatrix.elements[5]);
        e.zoom = 1;
      }
    }
    this.getCamera = function () {
      return O;
    };
    this.getFoveation = function () {
      if (d !== null || f !== null) {
        return s;
      }
    };
    this.setFoveation = function (e) {
      s = e;
      if (d !== null) {
        d.fixedFoveation = e;
      }
      if (f !== null && f.fixedFoveation !== undefined) {
        f.fixedFoveation = e;
      }
    };
    this.hasDepthSensing = function () {
      return h.texture !== null;
    };
    this.getDepthSensingMesh = function () {
      return h.getMesh(O);
    };
    this.getCameraTexture = function (e) {
      return g[e];
    };
    let oe = null;
    function se(t, i) {
      l = i.getViewerPose(c || a);
      p = i;
      if (l !== null) {
        let t = l.views;
        if (f !== null) {
          e.setRenderTargetFramebuffer(y, f.framebuffer);
          e.setRenderTarget(y);
        }
        let i = false;
        if (t.length !== O.cameras.length) {
          O.cameras.length = 0;
          i = true;
        }
        for (let n = 0; n < t.length; n++) {
          let r = t[n];
          let a = null;
          if (f !== null) {
            a = f.getViewport(r);
          } else {
            let t = u.getViewSubImage(d, r);
            a = t.viewport;
            if (n === 0) {
              e.setRenderTargetTextures(y, t.colorTexture, t.depthStencilTexture);
              e.setRenderTarget(y);
            }
          }
          let o = D[n];
          if (o === undefined) {
            o = new Kx();
            o.layers.enable(n);
            o.viewport = new H_();
            D[n] = o;
          }
          o.matrix.fromArray(r.transform.matrix);
          o.matrix.decompose(o.position, o.quaternion, o.scale);
          o.projectionMatrix.fromArray(r.projectionMatrix);
          o.projectionMatrixInverse.copy(o.projectionMatrix).invert();
          o.viewport.set(a.x, a.y, a.width, a.height);
          if (n === 0) {
            O.matrix.copy(o.matrix);
            O.matrix.decompose(O.position, O.quaternion, O.scale);
          }
          if (i === true) {
            O.cameras.push(o);
          }
        }
        let a = r.enabledFeatures;
        if (a && a.includes(`depth-sensing`) && r.depthUsage == `gpu-optimized` && m) {
          u = n.getBinding();
          let e = u.getDepthInformation(t[0]);
          if (e && e.isValid && e.texture) {
            h.init(e, r.renderState);
          }
        }
        if (a && a.includes(`camera-access`) && m) {
          e.state.unbindTexture();
          u = n.getBinding();
          for (let e = 0; e < t.length; e++) {
            let n = t[e].camera;
            if (n) {
              let e = g[n];
              if (!e) {
                e = new Rb();
                g[n] = e;
              }
              let t = u.getCameraImage(n);
              e.sourceTexture = t;
            }
          }
        }
      }
      for (let e = 0; e < b.length; e++) {
        let t = x[e];
        let n = b[e];
        if (t !== null && n !== undefined) {
          n.update(t, i, c || a);
        }
      }
      if (oe) {
        oe(t, i);
      }
      if (i.detectedPlanes) {
        n.dispatchEvent({
          type: `planesdetected`,
          data: i
        });
      }
      p = null;
    }
    let ce = new bS();
    ce.setAnimationLoop(se);
    this.setAnimationLoop = function (e) {
      oe = e;
    };
    this.dispose = function () {};
  }
};
var AT = new q_();
var jT = new E_();
jT.set(-1, 0, 0, 0, 1, 0, 0, 0, 1);
function MT(e, t) {
  function n(e, t) {
    if (e.matrixAutoUpdate === true) {
      e.updateMatrix();
    }
    t.value.copy(e.matrix);
  }
  function r(t, n) {
    n.color.getRGB(t.fogColor.value, Qb(e));
    if (n.isFog) {
      t.fogNear.value = n.near;
      t.fogFar.value = n.far;
    } else if (n.isFogExp2) {
      t.fogDensity.value = n.density;
    }
  }
  function i(e, t, n, r, i) {
    if (t.isNodeMaterial) {
      t.uniformsNeedUpdate = false;
    } else if (t.isMeshBasicMaterial) {
      a(e, t);
    } else if (t.isMeshLambertMaterial) {
      a(e, t);
      if (t.envMap) {
        e.envMapIntensity.value = t.envMapIntensity;
      }
    } else if (t.isMeshToonMaterial) {
      a(e, t);
      d(e, t);
    } else if (t.isMeshPhongMaterial) {
      a(e, t);
      u(e, t);
      if (t.envMap) {
        e.envMapIntensity.value = t.envMapIntensity;
      }
    } else if (t.isMeshStandardMaterial) {
      a(e, t);
      f(e, t);
      if (t.isMeshPhysicalMaterial) {
        p(e, t, i);
      }
    } else if (t.isMeshMatcapMaterial) {
      a(e, t);
      m(e, t);
    } else if (t.isMeshDepthMaterial) {
      a(e, t);
    } else if (t.isMeshDistanceMaterial) {
      a(e, t);
      h(e, t);
    } else if (t.isMeshNormalMaterial) {
      a(e, t);
    } else if (t.isLineBasicMaterial) {
      o(e, t);
      if (t.isLineDashedMaterial) {
        s(e, t);
      }
    } else if (t.isPointsMaterial) {
      c(e, t, n, r);
    } else if (t.isSpriteMaterial) {
      l(e, t);
    } else if (t.isShadowMaterial) {
      e.color.value.copy(t.color);
      e.opacity.value = t.opacity;
    } else if (t.isShaderMaterial) {
      t.uniformsNeedUpdate = false;
    }
  }
  function a(e, r) {
    e.opacity.value = r.opacity;
    if (r.color) {
      e.diffuse.value.copy(r.color);
    }
    if (r.emissive) {
      e.emissive.value.copy(r.emissive).multiplyScalar(r.emissiveIntensity);
    }
    if (r.map) {
      e.map.value = r.map;
      n(r.map, e.mapTransform);
    }
    if (r.alphaMap) {
      e.alphaMap.value = r.alphaMap;
      n(r.alphaMap, e.alphaMapTransform);
    }
    if (r.bumpMap) {
      e.bumpMap.value = r.bumpMap;
      n(r.bumpMap, e.bumpMapTransform);
      e.bumpScale.value = r.bumpScale;
      if (r.side === 1) {
        e.bumpScale.value *= -1;
      }
    }
    if (r.normalMap) {
      e.normalMap.value = r.normalMap;
      n(r.normalMap, e.normalMapTransform);
      e.normalScale.value.copy(r.normalScale);
      if (r.side === 1) {
        e.normalScale.value.negate();
      }
    }
    if (r.displacementMap) {
      e.displacementMap.value = r.displacementMap;
      n(r.displacementMap, e.displacementMapTransform);
      e.displacementScale.value = r.displacementScale;
      e.displacementBias.value = r.displacementBias;
    }
    if (r.emissiveMap) {
      e.emissiveMap.value = r.emissiveMap;
      n(r.emissiveMap, e.emissiveMapTransform);
    }
    if (r.specularMap) {
      e.specularMap.value = r.specularMap;
      n(r.specularMap, e.specularMapTransform);
    }
    if (r.alphaTest > 0) {
      e.alphaTest.value = r.alphaTest;
    }
    let i = t.get(r);
    let a = i.envMap;
    let o = i.envMapRotation;
    if (a) {
      e.envMap.value = a;
      e.envMapRotation.value.setFromMatrix4(AT.makeRotationFromEuler(o)).transpose();
      if (a.isCubeTexture && a.isRenderTargetTexture === false) {
        e.envMapRotation.value.premultiply(jT);
      }
      e.reflectivity.value = r.reflectivity;
      e.ior.value = r.ior;
      e.refractionRatio.value = r.refractionRatio;
    }
    if (r.lightMap) {
      e.lightMap.value = r.lightMap;
      e.lightMapIntensity.value = r.lightMapIntensity;
      n(r.lightMap, e.lightMapTransform);
    }
    if (r.aoMap) {
      e.aoMap.value = r.aoMap;
      e.aoMapIntensity.value = r.aoMapIntensity;
      n(r.aoMap, e.aoMapTransform);
    }
  }
  function o(e, t) {
    e.diffuse.value.copy(t.color);
    e.opacity.value = t.opacity;
    if (t.map) {
      e.map.value = t.map;
      n(t.map, e.mapTransform);
    }
  }
  function s(e, t) {
    e.dashSize.value = t.dashSize;
    e.totalSize.value = t.dashSize + t.gapSize;
    e.scale.value = t.scale;
  }
  function c(e, t, r, i) {
    e.diffuse.value.copy(t.color);
    e.opacity.value = t.opacity;
    e.size.value = t.size * r;
    e.scale.value = i * 0.5;
    if (t.map) {
      e.map.value = t.map;
      n(t.map, e.uvTransform);
    }
    if (t.alphaMap) {
      e.alphaMap.value = t.alphaMap;
      n(t.alphaMap, e.alphaMapTransform);
    }
    if (t.alphaTest > 0) {
      e.alphaTest.value = t.alphaTest;
    }
  }
  function l(e, t) {
    e.diffuse.value.copy(t.color);
    e.opacity.value = t.opacity;
    e.rotation.value = t.rotation;
    if (t.map) {
      e.map.value = t.map;
      n(t.map, e.mapTransform);
    }
    if (t.alphaMap) {
      e.alphaMap.value = t.alphaMap;
      n(t.alphaMap, e.alphaMapTransform);
    }
    if (t.alphaTest > 0) {
      e.alphaTest.value = t.alphaTest;
    }
  }
  function u(e, t) {
    e.specular.value.copy(t.specular);
    e.shininess.value = Math.max(t.shininess, 0.0001);
  }
  function d(e, t) {
    if (t.gradientMap) {
      e.gradientMap.value = t.gradientMap;
    }
  }
  function f(e, t) {
    e.metalness.value = t.metalness;
    if (t.metalnessMap) {
      e.metalnessMap.value = t.metalnessMap;
      n(t.metalnessMap, e.metalnessMapTransform);
    }
    e.roughness.value = t.roughness;
    if (t.roughnessMap) {
      e.roughnessMap.value = t.roughnessMap;
      n(t.roughnessMap, e.roughnessMapTransform);
    }
    if (t.envMap) {
      e.envMapIntensity.value = t.envMapIntensity;
    }
  }
  function p(e, t, r) {
    e.ior.value = t.ior;
    if (t.sheen > 0) {
      e.sheenColor.value.copy(t.sheenColor).multiplyScalar(t.sheen);
      e.sheenRoughness.value = t.sheenRoughness;
      if (t.sheenColorMap) {
        e.sheenColorMap.value = t.sheenColorMap;
        n(t.sheenColorMap, e.sheenColorMapTransform);
      }
      if (t.sheenRoughnessMap) {
        e.sheenRoughnessMap.value = t.sheenRoughnessMap;
        n(t.sheenRoughnessMap, e.sheenRoughnessMapTransform);
      }
    }
    if (t.clearcoat > 0) {
      e.clearcoat.value = t.clearcoat;
      e.clearcoatRoughness.value = t.clearcoatRoughness;
      if (t.clearcoatMap) {
        e.clearcoatMap.value = t.clearcoatMap;
        n(t.clearcoatMap, e.clearcoatMapTransform);
      }
      if (t.clearcoatRoughnessMap) {
        e.clearcoatRoughnessMap.value = t.clearcoatRoughnessMap;
        n(t.clearcoatRoughnessMap, e.clearcoatRoughnessMapTransform);
      }
      if (t.clearcoatNormalMap) {
        e.clearcoatNormalMap.value = t.clearcoatNormalMap;
        n(t.clearcoatNormalMap, e.clearcoatNormalMapTransform);
        e.clearcoatNormalScale.value.copy(t.clearcoatNormalScale);
        if (t.side === 1) {
          e.clearcoatNormalScale.value.negate();
        }
      }
    }
    if (t.dispersion > 0) {
      e.dispersion.value = t.dispersion;
    }
    if (t.retroreflectivity > 0) {
      e.retroreflectivity.value = t.retroreflectivity;
    }
    if (t.iridescence > 0) {
      e.iridescence.value = t.iridescence;
      e.iridescenceIOR.value = t.iridescenceIOR;
      e.iridescenceThicknessMinimum.value = t.iridescenceThicknessRange[0];
      e.iridescenceThicknessMaximum.value = t.iridescenceThicknessRange[1];
      if (t.iridescenceMap) {
        e.iridescenceMap.value = t.iridescenceMap;
        n(t.iridescenceMap, e.iridescenceMapTransform);
      }
      if (t.iridescenceThicknessMap) {
        e.iridescenceThicknessMap.value = t.iridescenceThicknessMap;
        n(t.iridescenceThicknessMap, e.iridescenceThicknessMapTransform);
      }
    }
    if (t.transmission > 0) {
      e.transmission.value = t.transmission;
      e.transmissionSamplerMap.value = r.texture;
      e.transmissionSamplerSize.value.set(r.width, r.height);
      if (t.transmissionMap) {
        e.transmissionMap.value = t.transmissionMap;
        n(t.transmissionMap, e.transmissionMapTransform);
      }
      e.thickness.value = t.thickness;
      if (t.thicknessMap) {
        e.thicknessMap.value = t.thicknessMap;
        n(t.thicknessMap, e.thicknessMapTransform);
      }
      e.attenuationDistance.value = t.attenuationDistance;
      e.attenuationColor.value.copy(t.attenuationColor);
    }
    if (t.anisotropy > 0) {
      e.anisotropyVector.value.set(t.anisotropy * Math.cos(t.anisotropyRotation), t.anisotropy * Math.sin(t.anisotropyRotation));
      if (t.anisotropyMap) {
        e.anisotropyMap.value = t.anisotropyMap;
        n(t.anisotropyMap, e.anisotropyMapTransform);
      }
    }
    e.specularIntensity.value = t.specularIntensity;
    e.specularColor.value.copy(t.specularColor);
    if (t.specularColorMap) {
      e.specularColorMap.value = t.specularColorMap;
      n(t.specularColorMap, e.specularColorMapTransform);
    }
    if (t.specularIntensityMap) {
      e.specularIntensityMap.value = t.specularIntensityMap;
      n(t.specularIntensityMap, e.specularIntensityMapTransform);
    }
  }
  function m(e, t) {
    if (t.matcap) {
      e.matcap.value = t.matcap;
    }
  }
  function h(e, n) {
    let r = t.get(n).light;
    e.referencePosition.value.setFromMatrixPosition(r.matrixWorld);
    e.nearDistance.value = r.shadow.camera.near;
    e.farDistance.value = r.shadow.camera.far;
  }
  return {
    refreshFogUniforms: r,
    refreshMaterialUniforms: i
  };
}
function NT(e, t, n, r) {
  let i = {};
  let a = {};
  let o = [];
  let s = e.getParameter(e.MAX_UNIFORM_BUFFER_BINDINGS);
  function c(e, t) {
    let n = t.program;
    r.uniformBlockBinding(e, n);
  }
  function l(e, n) {
    let o = i[e.id];
    if (o === undefined) {
      g(e);
      o = u(e);
      i[e.id] = o;
      e.addEventListener(`dispose`, v);
    }
    let s = n.program;
    r.updateUBOMapping(e, s);
    let c = t.render.frame;
    if (a[e.id] !== c) {
      f(e);
      a[e.id] = c;
    }
  }
  function u(t) {
    let n = d();
    t.__bindingPointIndex = n;
    let r = e.createBuffer();
    let i = t.__size;
    let a = t.usage;
    e.bindBuffer(e.UNIFORM_BUFFER, r);
    e.bufferData(e.UNIFORM_BUFFER, i, a);
    e.bindBuffer(e.UNIFORM_BUFFER, null);
    e.bindBufferBase(e.UNIFORM_BUFFER, n, r);
    return r;
  }
  function d() {
    for (let e = 0; e < s; e++) {
      if (o.indexOf(e) === -1) {
        o.push(e);
        return e;
      }
    }
    Wg(`WebGLRenderer: Maximum number of simultaneously usable uniforms groups reached.`);
    return 0;
  }
  function f(t) {
    let n = i[t.id];
    let r = t.uniforms;
    let a = t.__cache;
    e.bindBuffer(e.UNIFORM_BUFFER, n);
    for (let e = 0, t = r.length; e < t; e++) {
      let t = r[e];
      if (Array.isArray(t)) {
        for (let n = 0, r = t.length; n < r; n++) {
          p(t[n], e, n, a);
        }
      } else {
        p(t, e, 0, a);
      }
    }
    e.bindBuffer(e.UNIFORM_BUFFER, null);
  }
  function p(t, n, r, i) {
    if (h(t, n, r, i) === true) {
      let n = t.__offset;
      let r = t.value;
      if (Array.isArray(r)) {
        let e = 0;
        for (let n = 0; n < r.length; n++) {
          let i = r[n];
          let a = _(i);
          m(i, t.__data, e);
          if (typeof i != `number` && typeof i != `boolean` && !i.isMatrix3 && !ArrayBuffer.isView(i)) {
            e += a.storage / Float32Array.BYTES_PER_ELEMENT;
          }
        }
      } else {
        m(r, t.__data, 0);
      }
      e.bufferSubData(e.UNIFORM_BUFFER, n, t.__data);
    }
  }
  function m(e, t, n) {
    if (typeof e == `number` || typeof e == `boolean`) {
      t[0] = e;
    } else if (e.isMatrix3) {
      t[0] = e.elements[0];
      t[1] = e.elements[1];
      t[2] = e.elements[2];
      t[3] = 0;
      t[4] = e.elements[3];
      t[5] = e.elements[4];
      t[6] = e.elements[5];
      t[7] = 0;
      t[8] = e.elements[6];
      t[9] = e.elements[7];
      t[10] = e.elements[8];
      t[11] = 0;
    } else if (ArrayBuffer.isView(e)) {
      t.set(new e.constructor(e.buffer, e.byteOffset, t.length));
    } else {
      e.toArray(t, n);
    }
  }
  function h(e, t, n, r) {
    let i = e.value;
    let a = `${t}_${n}`;
    if (r[a] === undefined) {
      r[a] = typeof i == `number` || typeof i == `boolean` ? i : ArrayBuffer.isView(i) ? i.slice() : i.clone();
      return true;
    }
    {
      let e = r[a];
      if (typeof i == `number` || typeof i == `boolean`) {
        if (e !== i) {
          r[a] = i;
          return true;
        }
      } else if (ArrayBuffer.isView(i)) {
        return true;
      } else if (e.equals(i) === false) {
        e.copy(i);
        return true;
      }
    }
    return false;
  }
  function g(e) {
    let t = e.uniforms;
    let n = 0;
    for (let e = 0, r = t.length; e < r; e++) {
      let r = Array.isArray(t[e]) ? t[e] : [t[e]];
      for (let e = 0, t = r.length; e < t; e++) {
        let t = r[e];
        let i = Array.isArray(t.value) ? t.value : [t.value];
        for (let e = 0, r = i.length; e < r; e++) {
          let r = i[e];
          let a = _(r);
          let o = n % 16;
          let s = o % a.boundary;
          let c = o + s;
          n += s;
          if (c !== 0 && 16 - c < a.storage) {
            n += 16 - c;
          }
          t.__data = new Float32Array(a.storage / Float32Array.BYTES_PER_ELEMENT);
          t.__offset = n;
          n += a.storage;
        }
      }
    }
    let r = n % 16;
    if (r > 0) {
      n += 16 - r;
    }
    e.__size = n;
    e.__cache = {};
    return this;
  }
  function _(e) {
    let t = {
      boundary: 0,
      storage: 0
    };
    if (typeof e == `number` || typeof e == `boolean`) {
      t.boundary = 4;
      t.storage = 4;
    } else if (e.isVector2) {
      t.boundary = 8;
      t.storage = 8;
    } else if (e.isVector3 || e.isColor) {
      t.boundary = 16;
      t.storage = 12;
    } else if (e.isVector4) {
      t.boundary = 16;
      t.storage = 16;
    } else if (e.isMatrix3) {
      t.boundary = 48;
      t.storage = 48;
    } else if (e.isMatrix4) {
      t.boundary = 64;
      t.storage = 64;
    } else if (e.isTexture) {
      Ug(`WebGLRenderer: Texture samplers can not be part of an uniforms group.`);
    } else if (ArrayBuffer.isView(e)) {
      t.boundary = 16;
      t.storage = e.byteLength;
    } else {
      Ug(`WebGLRenderer: Unsupported uniform value type.`, e);
    }
    return t;
  }
  function v(t) {
    let n = t.target;
    n.removeEventListener(`dispose`, v);
    let r = o.indexOf(n.__bindingPointIndex);
    o.splice(r, 1);
    e.deleteBuffer(i[n.id]);
    delete i[n.id];
    delete a[n.id];
  }
  function y() {
    for (let t in i) {
      e.deleteBuffer(i[t]);
    }
    o = [];
    i = {};
    a = {};
  }
  return {
    bind: c,
    update: l,
    dispose: y
  };
}
var PT = new Uint16Array([12469, 15057, 12620, 14925, 13266, 14620, 13807, 14376, 14323, 13990, 14545, 13625, 14713, 13328, 14840, 12882, 14931, 12528, 14996, 12233, 15039, 11829, 15066, 11525, 15080, 11295, 15085, 10976, 15082, 10705, 15073, 10495, 13880, 14564, 13898, 14542, 13977, 14430, 14158, 14124, 14393, 13732, 14556, 13410, 14702, 12996, 14814, 12596, 14891, 12291, 14937, 11834, 14957, 11489, 14958, 11194, 14943, 10803, 14921, 10506, 14893, 10278, 14858, 9960, 14484, 14039, 14487, 14025, 14499, 13941, 14524, 13740, 14574, 13468, 14654, 13106, 14743, 12678, 14818, 12344, 14867, 11893, 14889, 11509, 14893, 11180, 14881, 10751, 14852, 10428, 14812, 10128, 14765, 9754, 14712, 9466, 14764, 13480, 14764, 13475, 14766, 13440, 14766, 13347, 14769, 13070, 14786, 12713, 14816, 12387, 14844, 11957, 14860, 11549, 14868, 11215, 14855, 10751, 14825, 10403, 14782, 10044, 14729, 9651, 14666, 9352, 14599, 9029, 14967, 12835, 14966, 12831, 14963, 12804, 14954, 12723, 14936, 12564, 14917, 12347, 14900, 11958, 14886, 11569, 14878, 11247, 14859, 10765, 14828, 10401, 14784, 10011, 14727, 9600, 14660, 9289, 14586, 8893, 14508, 8533, 15111, 12234, 15110, 12234, 15104, 12216, 15092, 12156, 15067, 12010, 15028, 11776, 14981, 11500, 14942, 11205, 14902, 10752, 14861, 10393, 14812, 9991, 14752, 9570, 14682, 9252, 14603, 8808, 14519, 8445, 14431, 8145, 15209, 11449, 15208, 11451, 15202, 11451, 15190, 11438, 15163, 11384, 15117, 11274, 15055, 10979, 14994, 10648, 14932, 10343, 14871, 9936, 14803, 9532, 14729, 9218, 14645, 8742, 14556, 8381, 14461, 8020, 14365, 7603, 15273, 10603, 15272, 10607, 15267, 10619, 15256, 10631, 15231, 10614, 15182, 10535, 15118, 10389, 15042, 10167, 14963, 9787, 14883, 9447, 14800, 9115, 14710, 8665, 14615, 8318, 14514, 7911, 14411, 7507, 14279, 7198, 15314, 9675, 15313, 9683, 15309, 9712, 15298, 9759, 15277, 9797, 15229, 9773, 15166, 9668, 15084, 9487, 14995, 9274, 14898, 8910, 14800, 8539, 14697, 8234, 14590, 7790, 14479, 7409, 14367, 7067, 14178, 6621, 15337, 8619, 15337, 8631, 15333, 8677, 15325, 8769, 15305, 8871, 15264, 8940, 15202, 8909, 15119, 8775, 15022, 8565, 14916, 8328, 14804, 8009, 14688, 7614, 14569, 7287, 14448, 6888, 14321, 6483, 14088, 6171, 15350, 7402, 15350, 7419, 15347, 7480, 15340, 7613, 15322, 7804, 15287, 7973, 15229, 8057, 15148, 8012, 15046, 7846, 14933, 7611, 14810, 7357, 14682, 7069, 14552, 6656, 14421, 6316, 14251, 5948, 14007, 5528, 15356, 5942, 15356, 5977, 15353, 6119, 15348, 6294, 15332, 6551, 15302, 6824, 15249, 7044, 15171, 7122, 15070, 7050, 14949, 6861, 14818, 6611, 14679, 6349, 14538, 6067, 14398, 5651, 14189, 5311, 13935, 4958, 15359, 4123, 15359, 4153, 15356, 4296, 15353, 4646, 15338, 5160, 15311, 5508, 15263, 5829, 15188, 6042, 15088, 6094, 14966, 6001, 14826, 5796, 14678, 5543, 14527, 5287, 14377, 4985, 14133, 4586, 13869, 4257, 15360, 1563, 15360, 1642, 15358, 2076, 15354, 2636, 15341, 3350, 15317, 4019, 15273, 4429, 15203, 4732, 15105, 4911, 14981, 4932, 14836, 4818, 14679, 4621, 14517, 4386, 14359, 4156, 14083, 3795, 13808, 3437, 15360, 122, 15360, 137, 15358, 285, 15355, 636, 15344, 1274, 15322, 2177, 15281, 2765, 15215, 3223, 15120, 3451, 14995, 3569, 14846, 3567, 14681, 3466, 14511, 3305, 14344, 3121, 14037, 2800, 13753, 2467, 15360, 0, 15360, 1, 15359, 21, 15355, 89, 15346, 253, 15325, 479, 15287, 796, 15225, 1148, 15133, 1492, 15008, 1749, 14856, 1882, 14685, 1886, 14506, 1783, 14324, 1608, 13996, 1398, 13702, 1183]);
var FT = null;
function IT() {
  if (FT === null) {
    FT = new gb(PT, 16, 16, Ih, Ch);
    FT.name = `DFG_LUT`;
    FT.minFilter = ph;
    FT.magFilter = ph;
    FT.wrapS = ch;
    FT.wrapT = ch;
    FT.generateMipmaps = false;
    FT.needsUpdate = true;
  }
  return FT;
}
var LT = class {
  constructor(e = {}) {
    let {
      canvas: t = zg(),
      context: n = null,
      depth: r = true,
      stencil: i = false,
      alpha: a = false,
      antialias: o = false,
      premultipliedAlpha: s = true,
      preserveDrawingBuffer: c = false,
      powerPreference: l = `default`,
      failIfMajorPerformanceCaveat: u = false,
      reversedDepthBuffer: d = false,
      outputBufferType: f = gh
    } = e;
    this.isWebGLRenderer = true;
    let p;
    if (n !== null) {
      if (typeof WebGLRenderingContext < `u` && n instanceof WebGLRenderingContext) {
        throw Error(`THREE.WebGLRenderer: WebGL 1 is not supported since r163.`);
      }
      p = n.getContextAttributes().alpha;
    } else {
      p = a;
    }
    let m = f;
    let h = new Set([Rh, Lh, Fh]);
    let g = new Set([gh, xh, yh, Eh, wh, Th]);
    let _ = new Uint32Array(4);
    let v = new Int32Array(4);
    let y = new X();
    let b = null;
    let x = null;
    let S = [];
    let C = [];
    let w = null;
    this.domElement = t;
    this.debug = {
      checkShaderErrors: true,
      diagnostics: {
        keywords: false
      },
      onShaderError: null
    };
    this.autoClear = true;
    this.autoClearColor = true;
    this.autoClearDepth = true;
    this.autoClearStencil = true;
    this.sortObjects = true;
    this.clippingPlanes = [];
    this.localClippingEnabled = false;
    this.toneMapping = 0;
    this.toneMappingExposure = 1;
    this.transmissionResolutionScale = 1;
    let T = this;
    let E = false;
    let D = null;
    let O = null;
    let k = null;
    let A = null;
    this._outputColorSpace = kg;
    let ee = 0;
    let te = 0;
    let j = null;
    let ne = -1;
    let re = null;
    let M = new H_();
    let ie = new H_();
    let ae = null;
    let oe = new Ov(0);
    let se = 0;
    let ce = t.width;
    let le = t.height;
    let ue = 1;
    let de = null;
    let fe = null;
    let pe = new H_(0, 0, ce, le);
    let me = new H_(0, 0, ce, le);
    let N = false;
    let he = new bb();
    let ge = false;
    let _e = false;
    let ve = new q_();
    let ye = new X();
    let be = new H_();
    let xe = {
      background: null,
      fog: null,
      environment: null,
      overrideMaterial: null,
      isScene: true
    };
    let Se = false;
    function Ce() {
      if (j === null) {
        return ue;
      } else {
        return 1;
      }
    }
    let P = n;
    function we(e, n) {
      return t.getContext(e, n);
    }
    let F;
    let Te;
    let I;
    let Ee;
    let L;
    let De;
    let R;
    let z;
    let Oe;
    let ke;
    let Ae;
    let je;
    let Me;
    let Ne;
    let Pe;
    let Fe;
    let Ie;
    let Le;
    let Re;
    let ze;
    let Be;
    let Ve;
    let He;
    try {
      let e = {
        alpha: true,
        depth: r,
        stencil: i,
        antialias: o,
        premultipliedAlpha: s,
        preserveDrawingBuffer: c,
        powerPreference: l,
        failIfMajorPerformanceCaveat: u
      };
      if (`setAttribute` in t) {
        t.setAttribute(`data-engine`, `three.js r186`);
      }
      t.addEventListener(`webglcontextlost`, Ge, false);
      t.addEventListener(`webglcontextrestored`, Ke, false);
      t.addEventListener(`webglcontextcreationerror`, qe, false);
      if (P === null) {
        let t = `webgl2`;
        P = we(t, e);
        if (P === null) {
          throw we(t) ? Error(`THREE.WebGLRenderer: Error creating WebGL context with your selected attributes.`) : Error(`THREE.WebGLRenderer: Error creating WebGL context.`);
        }
      }
      Ue();
    } catch (e) {
      t.removeEventListener(`webglcontextlost`, Ge, false);
      t.removeEventListener(`webglcontextrestored`, Ke, false);
      t.removeEventListener(`webglcontextcreationerror`, qe, false);
      Wg(`WebGLRenderer: ${e.message}`);
      throw e;
    }
    function Ue() {
      F = new tC(P);
      F.init();
      Be = new TT(P, F);
      Te = new AS(P, F, e, Be);
      I = new CT(P, F);
      if (Te.reversedDepthBuffer && d) {
        I.buffers.depth.setReversed(true);
      }
      O = P.createFramebuffer();
      k = P.createFramebuffer();
      A = P.createFramebuffer();
      Ee = new iC(P);
      L = new rT();
      De = new wT(P, F, I, L, Te, Be, Ee);
      R = new eC(T);
      z = new xS(P);
      Ve = new OS(P, z);
      Oe = new nC(P, z, Ee, Ve);
      ke = new oC(P, Oe, z, Ve, Ee);
      Le = new aC(P, Te, De);
      Pe = new jS(L);
      Ae = new nT(T, R, F, Te, Ve, Pe);
      je = new MT(T, L);
      Me = new sT();
      Ne = new mT(F);
      Ie = new DS(T, R, I, ke, p, s);
      Fe = new ST(T, ke, Te);
      He = new NT(P, Ee, Te, I);
      Re = new kS(P, F, Ee);
      ze = new rC(P, F, Ee);
      Ee.programs = Ae.programs;
      T.capabilities = Te;
      T.extensions = F;
      T.properties = L;
      T.renderLists = Me;
      T.shadowMap = Fe;
      T.state = I;
      T.info = Ee;
    }
    if (m !== 1009) {
      w = new cC(m, t.width, t.height, o, r, i);
    }
    let We = new kT(T, P);
    this.xr = We;
    this.getContext = function () {
      return P;
    };
    this.getContextAttributes = function () {
      return P.getContextAttributes();
    };
    this.forceContextLoss = function () {
      let e = F.get(`WEBGL_lose_context`);
      if (e) {
        e.loseContext();
      }
    };
    this.forceContextRestore = function () {
      let e = F.get(`WEBGL_lose_context`);
      if (e) {
        e.restoreContext();
      }
    };
    this.getPixelRatio = function () {
      return ue;
    };
    this.setPixelRatio = function (e) {
      if (e !== undefined) {
        ue = e;
        this.setSize(ce, le, false);
      }
    };
    this.getSize = function (e) {
      return e.set(ce, le);
    };
    this.setSize = function (e, n, r = true) {
      if (We.isPresenting) {
        Ug(`WebGLRenderer: Can't change size while VR device is presenting.`);
        return;
      }
      ce = e;
      le = n;
      t.width = Math.floor(e * ue);
      t.height = Math.floor(n * ue);
      if (r === true) {
        t.style.width = `${e}px`;
        t.style.height = `${n}px`;
      }
      if (w !== null) {
        w.setSize(t.width, t.height);
      }
      this.setViewport(0, 0, e, n);
    };
    this.getDrawingBufferSize = function (e) {
      return e.set(ce * ue, le * ue).floor();
    };
    this.setDrawingBufferSize = function (e, n, r) {
      ce = e;
      le = n;
      ue = r;
      t.width = Math.floor(e * r);
      t.height = Math.floor(n * r);
      this.setViewport(0, 0, e, n);
    };
    this.setEffects = function (e) {
      if (m === 1009) {
        Wg(`WebGLRenderer: setEffects() requires outputBufferType set to HalfFloatType or FloatType.`);
        return;
      }
      if (e) {
        for (let t = 0; t < e.length; t++) {
          if (e[t].isOutputPass === true) {
            Ug(`WebGLRenderer: OutputPass is not needed in setEffects(). Tone mapping and color space conversion are applied automatically.`);
            break;
          }
        }
      }
      w.setEffects(e || []);
    };
    this.getCurrentViewport = function (e) {
      return e.copy(M);
    };
    this.getViewport = function (e) {
      return e.copy(pe);
    };
    this.setViewport = function (e, t, n, r) {
      if (e.isVector4) {
        pe.set(e.x, e.y, e.z, e.w);
      } else {
        pe.set(e, t, n, r);
      }
      I.viewport(M.copy(pe).multiplyScalar(ue).round());
    };
    this.getScissor = function (e) {
      return e.copy(me);
    };
    this.setScissor = function (e, t, n, r) {
      if (e.isVector4) {
        me.set(e.x, e.y, e.z, e.w);
      } else {
        me.set(e, t, n, r);
      }
      I.scissor(ie.copy(me).multiplyScalar(ue).round());
    };
    this.getScissorTest = function () {
      return N;
    };
    this.setScissorTest = function (e) {
      I.setScissorTest(N = e);
    };
    this.setOpaqueSort = function (e) {
      de = e;
    };
    this.setTransparentSort = function (e) {
      fe = e;
    };
    this.getClearColor = function (e) {
      return e.copy(Ie.getClearColor());
    };
    this.setClearColor = function () {
      Ie.setClearColor(...arguments);
    };
    this.getClearAlpha = function () {
      return Ie.getClearAlpha();
    };
    this.setClearAlpha = function () {
      Ie.setClearAlpha(...arguments);
    };
    this.clear = function (e = true, t = true, n = true) {
      let r = 0;
      if (e) {
        let e = false;
        if (j !== null) {
          let t = j.texture.format;
          e = h.has(t);
        }
        if (e) {
          let e = j.texture.type;
          let t = g.has(e);
          let n = Ie.getClearColor();
          let r = Ie.getClearAlpha();
          let i = n.r;
          let a = n.g;
          let o = n.b;
          if (t) {
            _[0] = i;
            _[1] = a;
            _[2] = o;
            _[3] = r;
            P.clearBufferuiv(P.COLOR, 0, _);
          } else {
            v[0] = i;
            v[1] = a;
            v[2] = o;
            v[3] = r;
            P.clearBufferiv(P.COLOR, 0, v);
          }
        } else {
          r |= P.COLOR_BUFFER_BIT;
        }
      }
      if (t) {
        r |= P.DEPTH_BUFFER_BIT;
        this.state.buffers.depth.setMask(true);
      }
      if (n) {
        r |= P.STENCIL_BUFFER_BIT;
        this.state.buffers.stencil.setMask(4294967295);
      }
      if (r !== 0) {
        P.clear(r);
      }
    };
    this.clearColor = function () {
      this.clear(true, false, false);
    };
    this.clearDepth = function () {
      this.clear(false, true, false);
    };
    this.clearStencil = function () {
      this.clear(false, false, true);
    };
    this.setNodesHandler = function (e) {
      e.setRenderer(this);
      D = e;
    };
    this.dispose = function () {
      t.removeEventListener(`webglcontextlost`, Ge, false);
      t.removeEventListener(`webglcontextrestored`, Ke, false);
      t.removeEventListener(`webglcontextcreationerror`, qe, false);
      Ie.dispose();
      Me.dispose();
      Ne.dispose();
      L.dispose();
      R.dispose();
      ke.dispose();
      Ve.dispose();
      He.dispose();
      Ae.dispose();
      We.dispose();
      We.removeEventListener(`sessionstart`, et);
      We.removeEventListener(`sessionend`, tt);
      nt.stop();
    };
    function Ge(e) {
      e.preventDefault();
      Vg(`WebGLRenderer: Context Lost.`);
      E = true;
    }
    function Ke() {
      Vg(`WebGLRenderer: Context Restored.`);
      E = false;
      let e = Ee.autoReset;
      let t = Fe.enabled;
      let n = Fe.autoUpdate;
      let r = Fe.needsUpdate;
      let i = Fe.type;
      Ue();
      Ee.autoReset = e;
      Fe.enabled = t;
      Fe.autoUpdate = n;
      Fe.needsUpdate = r;
      Fe.type = i;
    }
    function qe(e) {
      Wg(`WebGLRenderer: A WebGL context could not be created. Reason: `, e.statusMessage);
    }
    function Je(e) {
      let t = e.target;
      t.removeEventListener(`dispose`, Je);
      Ye(t);
    }
    function Ye(e) {
      Xe(e);
      L.remove(e);
    }
    function Xe(e) {
      let t = L.get(e).programs;
      if (t !== undefined) {
        t.forEach(function (e) {
          Ae.releaseProgram(e);
        });
        if (e.isShaderMaterial) {
          Ae.releaseShaderCache(e);
        }
      }
    }
    this.renderBufferDirect = function (e, t, n, r, i, a) {
      if (t === null) {
        t = xe;
      }
      let o = i.isMesh && i.matrixWorld.determinantAffine() < 0;
      let s = ft(e, t, n, r, i);
      I.setMaterial(r, o);
      let c = n.index;
      let l = 1;
      if (r.wireframe === true) {
        c = Oe.getWireframeAttribute(n);
        if (c === undefined) {
          return;
        }
        l = 2;
      }
      let u = n.drawRange;
      let d = n.attributes.position;
      let f = u.start * l;
      let p = (u.start + u.count) * l;
      if (a !== null) {
        f = Math.max(f, a.start * l);
        p = Math.min(p, (a.start + a.count) * l);
      }
      if (c === null) {
        if (d != null) {
          f = Math.max(f, 0);
          p = Math.min(p, d.count);
        }
      } else {
        f = Math.max(f, 0);
        p = Math.min(p, c.count);
      }
      let m = p - f;
      if (m < 0 || m === Infinity) {
        return;
      }
      Ve.setup(i, r, s, n, c);
      let h;
      let g = Re;
      if (c !== null) {
        h = z.get(c);
        g = ze;
        g.setIndex(h);
      }
      if (i.isMesh) {
        if (r.wireframe === true) {
          I.setLineWidth(r.wireframeLinewidth * Ce());
          g.setMode(P.LINES);
        } else {
          g.setMode(P.TRIANGLES);
        }
      } else if (i.isLine) {
        let e = r.linewidth;
        if (e === undefined) {
          e = 1;
        }
        I.setLineWidth(e * Ce());
        if (i.isLineSegments) {
          g.setMode(P.LINES);
        } else if (i.isLineLoop) {
          g.setMode(P.LINE_LOOP);
        } else {
          g.setMode(P.LINE_STRIP);
        }
      } else if (i.isPoints) {
        g.setMode(P.POINTS);
      } else if (i.isSprite) {
        g.setMode(P.TRIANGLES);
      }
      if (i.isBatchedMesh) {
        if (F.get(`WEBGL_multi_draw`)) {
          g.renderMultiDraw(i._multiDrawStarts, i._multiDrawCounts, i._multiDrawCount);
        } else {
          let e = i._multiDrawStarts;
          let t = i._multiDrawCounts;
          let n = i._multiDrawCount;
          let a = c ? z.get(c).bytesPerElement : 1;
          let o = L.get(r).currentProgram.getUniforms();
          for (let r = 0; r < n; r++) {
            o.setValue(P, `_gl_DrawID`, r);
            g.render(e[r] / a, t[r]);
          }
        }
      } else if (i.isInstancedMesh) {
        g.renderInstances(f, m, i.count);
      } else if (n.isInstancedBufferGeometry) {
        let e = n._maxInstanceCount === undefined ? Infinity : n._maxInstanceCount;
        let t = Math.min(n.instanceCount, e);
        g.renderInstances(f, m, t);
      } else {
        g.render(f, m);
      }
    };
    function Ze(e, t, n, r) {
      if (D !== null && e.isNodeMaterial) {
        D.setObject(r, e);
      }
      if (ge === true) {
        Pe.setState(e, n, false);
      }
      if (e.transparent === true && e.side === 2 && e.forceSinglePass === false) {
        e.side = 1;
        e.needsUpdate = true;
        ct(e, t, r);
        e.side = 0;
        e.needsUpdate = true;
        ct(e, t, r);
        e.side = 2;
      } else {
        ct(e, t, r);
      }
    }
    this.compile = function (e, t, n = null) {
      if (n === null) {
        n = e;
      }
      if (D !== null) {
        D.renderStart(e, t, n);
      }
      x = Ne.get(n);
      x.init(t);
      C.push(x);
      n.traverseVisible(function (e) {
        if (e.isLight && e.layers.test(t.layers)) {
          x.pushLight(e);
          if (e.castShadow) {
            x.pushShadow(e);
          }
        }
      });
      if (e !== n) {
        e.traverseVisible(function (e) {
          if (e.isLight && e.layers.test(t.layers)) {
            x.pushLight(e);
            if (e.castShadow) {
              x.pushShadow(e);
            }
          }
        });
      }
      x.setupLights();
      if (D !== null) {
        D.updateLights(x.state.lightsArray);
      }
      _e = this.localClippingEnabled;
      ge = Pe.init(this.clippingPlanes, _e);
      if (ge === true) {
        Pe.setGlobalState(this.clippingPlanes, t);
      }
      if (D !== null) {
        Fe.render(x.state.shadowsArray, n, t);
      }
      let r = new Set();
      e.traverse(function (e) {
        if (!e.isMesh && !e.isPoints && !e.isLine && !e.isSprite) {
          return;
        }
        let i = e.material;
        if (i) {
          if (Array.isArray(i)) {
            for (let a = 0; a < i.length; a++) {
              let o = i[a];
              Ze(o, n, t, e);
              r.add(o);
            }
          } else {
            Ze(i, n, t, e);
            r.add(i);
          }
        }
      });
      x = C.pop();
      if (D !== null) {
        D.renderEnd();
      }
      return r;
    };
    this.compileAsync = function (e, t, n = null) {
      let r = this.compile(e, t, n);
      return new Promise(t => {
        function n() {
          r.forEach(function (e) {
            let t = L.get(e).currentProgram;
            if (t === undefined || t.isReady()) {
              r.delete(e);
            }
          });
          if (r.size === 0) {
            t(e);
            return;
          }
          setTimeout(n, 10);
        }
        if (F.get(`KHR_parallel_shader_compile`) === null) {
          setTimeout(n, 10);
        } else {
          n();
        }
      });
    };
    let Qe = null;
    function $e(e) {
      if (Qe) {
        Qe(e);
      }
    }
    function et() {
      nt.stop();
    }
    function tt() {
      nt.start();
    }
    let nt = new bS();
    nt.setAnimationLoop($e);
    if (typeof self < `u`) {
      nt.setContext(self);
    }
    this.setAnimationLoop = function (e) {
      Qe = e;
      We.setAnimationLoop(e);
      if (e === null) {
        nt.stop();
      } else {
        nt.start();
      }
    };
    We.addEventListener(`sessionstart`, et);
    We.addEventListener(`sessionend`, tt);
    this.render = function (e, t) {
      if (t !== undefined && t.isCamera !== true) {
        Wg(`WebGLRenderer.render: camera is not an instance of THREE.Camera.`);
        return;
      }
      if (E === true) {
        return;
      }
      if (D !== null) {
        D.renderStart(e, t);
      }
      let n = We.enabled === true && We.isPresenting === true;
      let r = w !== null && (j === null || n) && w.begin(T, j);
      if (e.matrixWorldAutoUpdate === true) {
        e.updateMatrixWorld();
      }
      if (t.parent === null && t.matrixWorldAutoUpdate === true) {
        t.updateMatrixWorld();
      }
      if (We.enabled === true && We.isPresenting === true && (w === null || w.isCompositing() === false)) {
        if (We.cameraAutoUpdate === true) {
          We.updateCamera(t);
        }
        t = We.getCamera();
      }
      if (e.isScene === true) {
        e.onBeforeRender(T, e, t, j);
      }
      x = Ne.get(e, C.length);
      x.init(t);
      x.state.textureUnits = De.getTextureUnits();
      C.push(x);
      ve.multiplyMatrices(t.projectionMatrix, t.matrixWorldInverse);
      he.setFromProjectionMatrix(ve, Fg, t.reversedDepth);
      _e = this.localClippingEnabled;
      ge = Pe.init(this.clippingPlanes, _e);
      b = Me.get(e, S.length);
      b.init();
      S.push(b);
      if (We.enabled === true && We.isPresenting === true) {
        let e = T.xr.getDepthSensingMesh();
        if (e !== null) {
          rt(e, t, -Infinity, T.sortObjects);
        }
      }
      rt(e, t, 0, T.sortObjects);
      b.finish();
      if (D !== null) {
        D.updateLights(x.state.lightsArray);
      }
      if (T.sortObjects === true) {
        b.sort(de, fe);
      }
      Se = We.enabled === false || We.isPresenting === false || We.hasDepthSensing() === false;
      if (Se) {
        Ie.addToRenderList(b, e);
      }
      this.info.render.frame++;
      if (this.info.autoReset === true) {
        this.info.reset();
      }
      if (ge === true) {
        Pe.beginShadows();
      }
      let i = x.state.shadowsArray;
      Fe.render(i, e, t);
      if (ge === true) {
        Pe.endShadows();
      }
      if ((r && w.hasRenderPass()) === false) {
        let n = b.opaque;
        let r = b.transmissive;
        x.setupLights();
        if (t.isArrayCamera) {
          let i = t.cameras;
          if (r.length > 0) {
            for (let t = 0, a = i.length; t < a; t++) {
              let a = i[t];
              at(n, r, e, a);
            }
          }
          if (Se) {
            Ie.render(e);
          }
          for (let t = 0, n = i.length; t < n; t++) {
            let n = i[t];
            it(b, e, n, n.viewport);
          }
        } else {
          if (r.length > 0) {
            at(n, r, e, t);
          }
          if (Se) {
            Ie.render(e);
          }
          it(b, e, t);
        }
      }
      if (j !== null && te === 0) {
        De.updateMultisampleRenderTarget(j);
        De.updateRenderTargetMipmap(j);
      }
      if (r) {
        w.end(T);
      }
      if (e.isScene === true) {
        e.onAfterRender(T, e, t);
      }
      Ve.resetDefaultState();
      ne = -1;
      re = null;
      C.pop();
      if (C.length > 0) {
        x = C[C.length - 1];
        De.setTextureUnits(x.state.textureUnits);
        if (ge === true) {
          Pe.setGlobalState(T.clippingPlanes, x.state.camera);
        }
      } else {
        x = null;
      }
      S.pop();
      b = S.length > 0 ? S[S.length - 1] : null;
      if (D !== null) {
        D.renderEnd();
      }
    };
    function rt(e, t, n, r) {
      if (e.visible === false) {
        return;
      }
      if (e.layers.test(t.layers)) {
        if (e.isGroup) {
          n = e.renderOrder;
        } else if (e.isLOD) {
          if (e.autoUpdate === true) {
            e.update(t);
          }
        } else if (e.isLightProbeGrid) {
          x.pushLightProbeGrid(e);
        } else if (e.isLight) {
          x.pushLight(e);
          if (e.castShadow) {
            x.pushShadow(e);
          }
        } else if (e.isSprite) {
          if (!e.frustumCulled || e.intersectsFrustum(he)) {
            if (r) {
              be.setFromMatrixPosition(e.matrixWorld).applyMatrix4(ve);
            }
            let i = ke.update(e);
            let a = e.material;
            if (a.visible) {
              b.push(e, i, a, n, be.z, null, t);
            }
          }
        } else if ((e.isMesh || e.isLine || e.isPoints) && (!e.frustumCulled || e.intersectsFrustum(he))) {
          let i = ke.update(e);
          let a = e.material;
          if (r) {
            if (e.boundingSphere === undefined) {
              if (i.boundingSphere === null) {
                i.computeBoundingSphere();
              }
              be.copy(i.boundingSphere.center);
            } else {
              if (e.boundingSphere === null) {
                e.computeBoundingSphere();
              }
              be.copy(e.boundingSphere.center);
            }
            be.applyMatrix4(e.matrixWorld).applyMatrix4(ve);
          }
          if (Array.isArray(a)) {
            let r = i.groups;
            for (let o = 0, s = r.length; o < s; o++) {
              let s = r[o];
              let c = a[s.materialIndex];
              if (c && c.visible) {
                b.push(e, i, c, n, be.z, s, t);
              }
            }
          } else if (a.visible) {
            b.push(e, i, a, n, be.z, null, t);
          }
        }
      }
      let i = e.children;
      for (let e = 0, a = i.length; e < a; e++) {
        rt(i[e], t, n, r);
      }
    }
    function it(e, t, n, r) {
      let {
        opaque: i,
        transmissive: a,
        transparent: o
      } = e;
      x.setupLightsView(n);
      if (ge === true) {
        Pe.setGlobalState(T.clippingPlanes, n);
      }
      if (r) {
        I.viewport(M.copy(r));
      }
      if (i.length > 0) {
        ot(i, t, n);
      }
      if (a.length > 0) {
        ot(a, t, n);
      }
      if (o.length > 0) {
        ot(o, t, n);
      }
      I.buffers.depth.setTest(true);
      I.buffers.depth.setMask(true);
      I.buffers.color.setMask(true);
      I.setPolygonOffset(false);
    }
    function at(e, t, n, r) {
      if ((n.isScene === true ? n.overrideMaterial : null) !== null) {
        return;
      }
      if (x.state.transmissionRenderTarget[r.id] === undefined) {
        let e = F.has(`EXT_color_buffer_half_float`) || F.has(`EXT_color_buffer_float`);
        x.state.transmissionRenderTarget[r.id] = new W_(1, 1, {
          generateMipmaps: true,
          type: e ? Ch : gh,
          minFilter: hh,
          samples: Math.max(4, Te.samples),
          stencilBuffer: i,
          resolveDepthBuffer: false,
          resolveStencilBuffer: false,
          storeMultisampledDepthBuffer: false,
          storeMultisampledStencilBuffer: false,
          colorSpace: j_.workingColorSpace
        });
      }
      let a = x.state.transmissionRenderTarget[r.id];
      let o = r.viewport || M;
      a.setSize(o.z * T.transmissionResolutionScale, o.w * T.transmissionResolutionScale);
      let s = T.getRenderTarget();
      let c = T.getActiveCubeFace();
      let l = T.getActiveMipmapLevel();
      T.setRenderTarget(a);
      T.getClearColor(oe);
      se = T.getClearAlpha();
      if (se < 1) {
        T.setClearColor(16777215, 0.5);
      }
      T.clear();
      if (Se) {
        Ie.render(n);
      }
      let u = T.toneMapping;
      T.toneMapping = 0;
      let d = r.viewport;
      if (r.viewport !== undefined) {
        r.viewport = undefined;
      }
      x.setupLightsView(r);
      if (ge === true) {
        Pe.setGlobalState(T.clippingPlanes, r);
      }
      ot(e, n, r);
      De.updateMultisampleRenderTarget(a);
      De.updateRenderTargetMipmap(a);
      if (F.has(`WEBGL_multisampled_render_to_texture`) === false) {
        let e = false;
        for (let i = 0, a = t.length; i < a; i++) {
          let {
            object: a,
            geometry: o,
            material: s,
            group: c
          } = t[i];
          if (s.side === 2 && a.layers.test(r.layers)) {
            let t = s.side;
            s.side = 1;
            s.needsUpdate = true;
            st(a, n, r, o, s, c);
            s.side = t;
            s.needsUpdate = true;
            e = true;
          }
        }
        if (e === true) {
          De.updateMultisampleRenderTarget(a);
          De.updateRenderTargetMipmap(a);
        }
      }
      T.setRenderTarget(s, c, l);
      T.setClearColor(oe, se);
      if (d !== undefined) {
        r.viewport = d;
      }
      T.toneMapping = u;
    }
    function ot(e, t, n) {
      let r = t.isScene === true ? t.overrideMaterial : null;
      for (let i = 0, a = e.length; i < a; i++) {
        let a = e[i];
        let {
          object: o,
          geometry: s,
          group: c
        } = a;
        let l = a.material;
        if (l.allowOverride === true && r !== null) {
          l = r;
        }
        if (o.layers.test(n.layers)) {
          st(o, t, n, s, l, c);
        }
      }
    }
    function st(e, t, n, r, i, a) {
      if (D !== null && i.isNodeMaterial) {
        D.setObject(e, i);
      }
      e.onBeforeRender(T, t, n, r, i, a);
      e.modelViewMatrix.multiplyMatrices(n.matrixWorldInverse, e.matrixWorld);
      e.normalMatrix.getNormalMatrix(e.modelViewMatrix);
      i.onBeforeRender(T, t, n, r, e, a);
      if (i.transparent === true && i.side === 2 && i.forceSinglePass === false) {
        i.side = 1;
        i.needsUpdate = true;
        T.renderBufferDirect(n, t, r, i, e, a);
        i.side = 0;
        i.needsUpdate = true;
        T.renderBufferDirect(n, t, r, i, e, a);
        i.side = 2;
      } else {
        T.renderBufferDirect(n, t, r, i, e, a);
      }
      e.onAfterRender(T, t, n, r, i, a);
    }
    function ct(e, t, n) {
      if (t.isScene !== true) {
        t = xe;
      }
      let r = L.get(e);
      let i = x.state.lights;
      let a = x.state.shadowsArray;
      let o = i.state.version;
      let s = Ae.getParameters(e, i.state, a, t, n, x.state.lightProbeGridArray);
      let c = Ae.getProgramCacheKey(s);
      let l = r.programs;
      r.environment = e.isMeshStandardMaterial || e.isMeshLambertMaterial || e.isMeshPhongMaterial ? t.environment : null;
      r.fog = t.fog;
      let u = e.isMeshStandardMaterial || e.isMeshLambertMaterial && !e.envMap || e.isMeshPhongMaterial && !e.envMap;
      r.envMap = R.get(e.envMap || r.environment, u);
      r.envMapRotation = r.environment !== null && e.envMap === null ? t.environmentRotation : e.envMapRotation;
      if (l === undefined) {
        e.addEventListener(`dispose`, Je);
        l = new Map();
        r.programs = l;
      }
      let d = l.get(c);
      if (d !== undefined) {
        if (r.currentProgram === d && r.lightsStateVersion === o) {
          ut(e, s);
          return d;
        }
      } else {
        s.uniforms = Ae.getUniforms(e);
        if (D !== null && e.isNodeMaterial) {
          D.build(e, n, s);
        }
        e.onBeforeCompile(s, T);
        d = Ae.acquireProgram(s, c);
        l.set(c, d);
        r.uniforms = s.uniforms;
      }
      let f = r.uniforms;
      if (!e.isShaderMaterial && !e.isRawShaderMaterial || e.clipping === true) {
        f.clippingPlanes = Pe.uniform;
      }
      ut(e, s);
      r.needsLights = mt(e);
      r.lightsStateVersion = o;
      if (r.needsLights) {
        f.ambientLightColor.value = i.state.ambient;
        f.lightProbe.value = i.state.probe;
        f.sunLights.value = i.state.sun;
        f.sunLightShadows.value = i.state.sunShadow;
        f.directionalLights.value = i.state.directional;
        f.directionalLightShadows.value = i.state.directionalShadow;
        f.spotLights.value = i.state.spot;
        f.spotLightShadows.value = i.state.spotShadow;
        f.rectAreaLights.value = i.state.rectArea;
        f.ltc_1.value = i.state.rectAreaLTC1;
        f.ltc_2.value = i.state.rectAreaLTC2;
        f.pointLights.value = i.state.point;
        f.pointLightShadows.value = i.state.pointShadow;
        f.hemisphereLights.value = i.state.hemi;
        f.sunShadowMatrix.value = i.state.sunShadowMatrix;
        f.sunShadowCascade.value = i.state.sunShadowCascade;
        f.directionalShadowMatrix.value = i.state.directionalShadowMatrix;
        f.spotLightMatrix.value = i.state.spotLightMatrix;
        f.spotLightMap.value = i.state.spotLightMap;
        f.pointShadowMatrix.value = i.state.pointShadowMatrix;
      }
      r.lightProbeGrid = x.state.lightProbeGridArray.length > 0;
      r.currentProgram = d;
      r.uniformsList = null;
      return d;
    }
    function lt(e) {
      if (e.uniformsList === null) {
        let t = e.currentProgram.getUniforms();
        e.uniformsList = hw.seqWithValue(t.seq, e.uniforms);
      }
      return e.uniformsList;
    }
    function ut(e, t) {
      let n = L.get(e);
      n.outputColorSpace = t.outputColorSpace;
      n.batching = t.batching;
      n.batchingColor = t.batchingColor;
      n.instancing = t.instancing;
      n.instancingColor = t.instancingColor;
      n.instancingMorph = t.instancingMorph;
      n.skinning = t.skinning;
      n.morphTargets = t.morphTargets;
      n.morphNormals = t.morphNormals;
      n.morphColors = t.morphColors;
      n.morphTargetsCount = t.morphTargetsCount;
      n.numClippingPlanes = t.numClippingPlanes;
      n.numIntersection = t.numClipIntersection;
      n.vertexAlphas = t.vertexAlphas;
      n.vertexTangents = t.vertexTangents;
      n.toneMapping = t.toneMapping;
    }
    function dt(e, t) {
      if (e.length === 0) {
        return null;
      }
      if (e.length === 1) {
        if (e[0].texture === null) {
          return null;
        } else {
          return e[0];
        }
      }
      y.setFromMatrixPosition(t.matrixWorld);
      for (let t = 0, n = e.length; t < n; t++) {
        let n = e[t];
        if (n.texture !== null && n.boundingBox.containsPoint(y)) {
          return n;
        }
      }
      return null;
    }
    function ft(e, t, n, r, i) {
      if (t.isScene !== true) {
        t = xe;
      }
      De.resetTextureUnits();
      let a = t.fog;
      let o = r.isMeshStandardMaterial || r.isMeshLambertMaterial || r.isMeshPhongMaterial ? t.environment : null;
      let s = j === null ? T.outputColorSpace : j.isXRRenderTarget === true ? j.texture.colorSpace : j_.workingColorSpace;
      let c = r.isMeshStandardMaterial || r.isMeshLambertMaterial && !r.envMap || r.isMeshPhongMaterial && !r.envMap;
      let l = R.get(r.envMap || o, c);
      let u = r.vertexColors === true && !!n.attributes.color && n.attributes.color.itemSize === 4;
      let d = !!n.attributes.tangent && (!!r.normalMap || r.anisotropy > 0);
      let f = !!n.morphAttributes.position;
      let p = !!n.morphAttributes.normal;
      let m = !!n.morphAttributes.color;
      let h = 0;
      if (r.toneMapped && (j === null || j.isXRRenderTarget === true)) {
        h = T.toneMapping;
      }
      let g = n.morphAttributes.position || n.morphAttributes.normal || n.morphAttributes.color;
      let _ = g === undefined ? 0 : g.length;
      let v = L.get(r);
      let y = x.state.lights;
      if (ge === true && (_e === true || e !== re)) {
        let t = e === re && r.id === ne;
        Pe.setState(r, e, t);
      }
      let b = false;
      if (r.version === v.__version) {
        if (v.needsLights && v.lightsStateVersion !== y.state.version) {
          b = true;
        } else if (v.outputColorSpace === s) {
          if (i.isBatchedMesh && v.batching === false || !i.isBatchedMesh && v.batching === true || i.isBatchedMesh && v.batchingColor === true && i._colorsTexture === null || i.isBatchedMesh && v.batchingColor === false && i._colorsTexture !== null || i.isInstancedMesh && v.instancing === false || !i.isInstancedMesh && v.instancing === true || i.isSkinnedMesh && v.skinning === false || !i.isSkinnedMesh && v.skinning === true || i.isInstancedMesh && v.instancingColor === true && i.instanceColor === null || i.isInstancedMesh && v.instancingColor === false && i.instanceColor !== null || i.isInstancedMesh && v.instancingMorph === true && i.morphTexture === null || i.isInstancedMesh && v.instancingMorph === false && i.morphTexture !== null) {
            b = true;
          } else if (v.envMap === l) {
            if (r.fog === true && v.fog !== a || v.numClippingPlanes !== undefined && (v.numClippingPlanes !== Pe.numPlanes || v.numIntersection !== Pe.numIntersection)) {
              b = true;
            } else if (v.vertexAlphas === u && v.vertexTangents === d && v.morphTargets === f && v.morphNormals === p && v.morphColors === m && v.toneMapping === h && v.morphTargetsCount === _) {
              if (!!v.lightProbeGrid != x.state.lightProbeGridArray.length > 0) {
                b = true;
              }
            } else {
              b = true;
            }
          } else {
            b = true;
          }
        } else {
          b = true;
        }
      } else {
        b = true;
        v.__version = r.version;
      }
      let S = v.currentProgram;
      if (b === true) {
        S = ct(r, t, i);
        if (D && r.isNodeMaterial) {
          D.onUpdateProgram(r, S, v);
        }
      }
      let C = false;
      let w = false;
      let E = false;
      let O = S.getUniforms();
      let k = v.uniforms;
      if (I.useProgram(S.program)) {
        C = true;
        w = true;
        E = true;
      }
      if (r.id !== ne) {
        ne = r.id;
        w = true;
      }
      if (v.needsLights) {
        let e = dt(x.state.lightProbeGridArray, i);
        if (v.lightProbeGrid !== e) {
          v.lightProbeGrid = e;
          w = true;
        }
      }
      if (C || re !== e) {
        if (I.buffers.depth.getReversed() && e.reversedDepth !== true) {
          e._reversedDepth = true;
          e.updateProjectionMatrix();
        }
        O.setValue(P, `projectionMatrix`, e.projectionMatrix);
        O.setValue(P, `viewMatrix`, e.matrixWorldInverse);
        let t = O.map.cameraPosition;
        if (t !== undefined) {
          t.setValue(P, ye.setFromMatrixPosition(e.matrixWorld));
        }
        if (Te.logarithmicDepthBuffer) {
          O.setValue(P, `logDepthBufFC`, 2 / (Math.log(e.far + 1) / Math.LN2));
        }
        if (r.isMeshPhongMaterial || r.isMeshToonMaterial || r.isMeshLambertMaterial || r.isMeshBasicMaterial || r.isMeshStandardMaterial || r.isShaderMaterial) {
          O.setValue(P, `isOrthographic`, e.isOrthographicCamera === true);
        }
        if (re !== e) {
          re = e;
          w = true;
          E = true;
        }
      }
      if (v.needsLights) {
        if (y.state.sunShadowMap.length > 0) {
          O.setValue(P, `sunShadowMap`, y.state.sunShadowMap, De);
        }
        if (y.state.directionalShadowMap.length > 0) {
          O.setValue(P, `directionalShadowMap`, y.state.directionalShadowMap, De);
        }
        if (y.state.spotShadowMap.length > 0) {
          O.setValue(P, `spotShadowMap`, y.state.spotShadowMap, De);
        }
        if (y.state.pointShadowMap.length > 0) {
          O.setValue(P, `pointShadowMap`, y.state.pointShadowMap, De);
        }
      }
      if (i.isSkinnedMesh) {
        O.setOptional(P, i, `bindMatrix`);
        O.setOptional(P, i, `bindMatrixInverse`);
        let e = i.skeleton;
        if (e) {
          if (e.boneTexture === null) {
            e.computeBoneTexture();
          }
          O.setValue(P, `boneTexture`, e.boneTexture, De);
        }
      }
      if (i.isBatchedMesh) {
        O.setOptional(P, i, `batchingTexture`);
        O.setValue(P, `batchingTexture`, i._matricesTexture, De);
        O.setOptional(P, i, `batchingIdTexture`);
        O.setValue(P, `batchingIdTexture`, i._indirectTexture, De);
        O.setOptional(P, i, `batchingColorTexture`);
        if (i._colorsTexture !== null) {
          O.setValue(P, `batchingColorTexture`, i._colorsTexture, De);
        }
      }
      let A = n.morphAttributes;
      if (A.position !== undefined || A.normal !== undefined || A.color !== undefined) {
        Le.update(i, n, S);
      }
      if (w || v.receiveShadow !== i.receiveShadow) {
        v.receiveShadow = i.receiveShadow;
        O.setValue(P, `receiveShadow`, i.receiveShadow);
      }
      if ((r.isMeshStandardMaterial || r.isMeshLambertMaterial || r.isMeshPhongMaterial) && r.envMap === null && t.environment !== null) {
        k.envMapIntensity.value = t.environmentIntensity;
      }
      if (k.dfgLUT !== undefined) {
        k.dfgLUT.value = IT();
      }
      if (w) {
        O.setValue(P, `toneMappingExposure`, T.toneMappingExposure);
        if (v.needsLights) {
          pt(k, E);
        }
        if (a && r.fog === true) {
          je.refreshFogUniforms(k, a);
        }
        je.refreshMaterialUniforms(k, r, ue, le, x.state.transmissionRenderTarget[e.id]);
        if (v.needsLights && v.lightProbeGrid) {
          let e = v.lightProbeGrid;
          k.probesSH.value = e.texture;
          k.probesMin.value.copy(e.boundingBox.min);
          k.probesMax.value.copy(e.boundingBox.max);
          k.probesResolution.value.copy(e.resolution);
        }
        hw.upload(P, lt(v), k, De);
      }
      if (r.isShaderMaterial && r.uniformsNeedUpdate === true) {
        hw.upload(P, lt(v), k, De);
        r.uniformsNeedUpdate = false;
      }
      if (r.isSpriteMaterial) {
        O.setValue(P, `center`, i.center);
      }
      O.setValue(P, `modelViewMatrix`, i.modelViewMatrix);
      O.setValue(P, `normalMatrix`, i.normalMatrix);
      O.setValue(P, `modelMatrix`, i.matrixWorld);
      if (r.uniformsGroups !== undefined) {
        let e = r.uniformsGroups;
        for (let t = 0, n = e.length; t < n; t++) {
          let n = e[t];
          He.update(n, S);
          He.bind(n, S);
        }
      }
      return S;
    }
    function pt(e, t) {
      e.ambientLightColor.needsUpdate = t;
      e.lightProbe.needsUpdate = t;
      e.sunLights.needsUpdate = t;
      e.sunLightShadows.needsUpdate = t;
      e.directionalLights.needsUpdate = t;
      e.directionalLightShadows.needsUpdate = t;
      e.pointLights.needsUpdate = t;
      e.pointLightShadows.needsUpdate = t;
      e.spotLights.needsUpdate = t;
      e.spotLightShadows.needsUpdate = t;
      e.rectAreaLights.needsUpdate = t;
      e.hemisphereLights.needsUpdate = t;
    }
    function mt(e) {
      return e.isMeshLambertMaterial || e.isMeshToonMaterial || e.isMeshPhongMaterial || e.isMeshStandardMaterial || e.isShadowMaterial || e.isShaderMaterial && e.lights === true;
    }
    this.getActiveCubeFace = function () {
      return ee;
    };
    this.getActiveMipmapLevel = function () {
      return te;
    };
    this.getRenderTarget = function () {
      return j;
    };
    this.setRenderTargetTextures = function (e, t, n) {
      let r = L.get(e);
      r.__autoAllocateDepthBuffer = e.resolveDepthBuffer === false;
      if (r.__autoAllocateDepthBuffer === false) {
        r.__useRenderToTexture = false;
      }
      L.get(e.texture).__webglTexture = t;
      L.get(e.depthTexture).__webglTexture = r.__autoAllocateDepthBuffer ? undefined : n;
      r.__hasExternalTextures = true;
    };
    this.setRenderTargetFramebuffer = function (e, t) {
      let n = L.get(e);
      n.__webglFramebuffer = t;
      n.__useDefaultFramebuffer = t === undefined;
    };
    this.setRenderTarget = function (e, t = 0, n = 0) {
      j = e;
      ee = t;
      te = n;
      let r = null;
      let i = false;
      let a = false;
      if (e) {
        let o = L.get(e);
        if (o.__useDefaultFramebuffer !== undefined) {
          I.bindFramebuffer(P.FRAMEBUFFER, o.__webglFramebuffer);
          M.copy(e.viewport);
          ie.copy(e.scissor);
          ae = e.scissorTest;
          I.viewport(M);
          I.scissor(ie);
          I.setScissorTest(ae);
          ne = -1;
          return;
        }
        if (o.__webglFramebuffer === undefined) {
          De.setupRenderTarget(e);
        } else if (o.__hasExternalTextures) {
          De.rebindTextures(e, L.get(e.texture).__webglTexture, L.get(e.depthTexture).__webglTexture);
        } else if (e.depthBuffer) {
          let t = e.depthTexture;
          if (o.__boundDepthTexture !== t) {
            if (t !== null && L.has(t) && (e.width !== t.image.width || e.height !== t.image.height)) {
              throw Error(`THREE.WebGLRenderer: Attached DepthTexture is initialized to the incorrect size.`);
            }
            De.setupDepthRenderbuffer(e);
          }
        }
        let s = e.texture;
        if (s.isData3DTexture || s.isDataArrayTexture || s.isCompressedArrayTexture) {
          a = true;
        }
        let c = L.get(e).__webglFramebuffer;
        if (e.isWebGLCubeRenderTarget) {
          r = Array.isArray(c[t]) ? c[t][n] : c[t];
          i = true;
        } else {
          r = e.samples > 0 && De.useMultisampledRTT(e) === false ? L.get(e).__webglMultisampledFramebuffer : Array.isArray(c) ? c[n] : c;
        }
        M.copy(e.viewport);
        ie.copy(e.scissor);
        ae = e.scissorTest;
      } else {
        M.copy(pe).multiplyScalar(ue).floor();
        ie.copy(me).multiplyScalar(ue).floor();
        ae = N;
      }
      if (n !== 0) {
        r = O;
      }
      if (I.bindFramebuffer(P.FRAMEBUFFER, r)) {
        I.drawBuffers(e, r);
      }
      I.viewport(M);
      I.scissor(ie);
      I.setScissorTest(ae);
      if (i) {
        let r = L.get(e.texture);
        P.framebufferTexture2D(P.FRAMEBUFFER, P.COLOR_ATTACHMENT0, P.TEXTURE_CUBE_MAP_POSITIVE_X + t, r.__webglTexture, n);
      } else if (a) {
        let r = t;
        for (let t = 0; t < e.textures.length; t++) {
          let i = L.get(e.textures[t]);
          P.framebufferTextureLayer(P.FRAMEBUFFER, P.COLOR_ATTACHMENT0 + t, i.__webglTexture, n, r);
        }
      } else if (e !== null && n !== 0) {
        let t = L.get(e.texture);
        P.framebufferTexture2D(P.FRAMEBUFFER, P.COLOR_ATTACHMENT0, P.TEXTURE_2D, t.__webglTexture, n);
      }
      ne = -1;
    };
    function ht(e) {
      let t = L.get(e);
      if (t.__readFormat !== e.format || t.__readType !== e.type) {
        t.__readFormat = e.format;
        t.__readType = e.type;
        t.__formatReadable = Te.textureFormatReadable(e.format);
        t.__typeReadable = Te.textureTypeReadable(e.type);
      }
      return t;
    }
    this.readRenderTargetPixels = function (e, t, n, r, i, a, o, s = 0) {
      if (!e || !e.isWebGLRenderTarget) {
        Wg(`WebGLRenderer.readRenderTargetPixels: renderTarget is not THREE.WebGLRenderTarget.`);
        return;
      }
      let c = L.get(e).__webglFramebuffer;
      if (e.isWebGLCubeRenderTarget && o !== undefined) {
        c = c[o];
      }
      if (c) {
        I.bindFramebuffer(P.FRAMEBUFFER, c);
        try {
          let o = e.textures[s];
          let c = o.format;
          let l = o.type;
          if (e.textures.length > 1) {
            P.readBuffer(P.COLOR_ATTACHMENT0 + s);
          }
          let u = ht(o);
          if (u.__formatReadable === false) {
            Wg(`WebGLRenderer.readRenderTargetPixels: renderTarget is not in RGBA or implementation defined format.`);
            return;
          }
          if (u.__typeReadable === false) {
            Wg(`WebGLRenderer.readRenderTargetPixels: renderTarget is not in UnsignedByteType or implementation defined type.`);
            return;
          }
          if (t >= 0 && t <= e.width - r && n >= 0 && n <= e.height - i) {
            P.readPixels(t, n, r, i, Be.convert(c), Be.convert(l), a);
          }
        } finally {
          let e = j === null ? null : L.get(j).__webglFramebuffer;
          I.bindFramebuffer(P.FRAMEBUFFER, e);
        }
      }
    };
    this.readRenderTargetPixelsAsync = async function (e, t, n, r, i, a, o, s = 0) {
      if (!e || !e.isWebGLRenderTarget) {
        throw Error(`THREE.WebGLRenderer.readRenderTargetPixels: renderTarget is not THREE.WebGLRenderTarget.`);
      }
      let c = L.get(e).__webglFramebuffer;
      if (e.isWebGLCubeRenderTarget && o !== undefined) {
        c = c[o];
      }
      if (c) {
        if (t >= 0 && t <= e.width - r && n >= 0 && n <= e.height - i) {
          I.bindFramebuffer(P.FRAMEBUFFER, c);
          let o = e.textures[s];
          let l = o.format;
          let u = o.type;
          if (e.textures.length > 1) {
            P.readBuffer(P.COLOR_ATTACHMENT0 + s);
          }
          let d = ht(o);
          if (d.__formatReadable === false) {
            throw Error(`THREE.WebGLRenderer.readRenderTargetPixelsAsync: renderTarget is not in RGBA or implementation defined format.`);
          }
          if (d.__typeReadable === false) {
            throw Error(`THREE.WebGLRenderer.readRenderTargetPixelsAsync: renderTarget is not in UnsignedByteType or implementation defined type.`);
          }
          let f = P.createBuffer();
          P.bindBuffer(P.PIXEL_PACK_BUFFER, f);
          P.bufferData(P.PIXEL_PACK_BUFFER, a.byteLength, P.STREAM_READ);
          P.readPixels(t, n, r, i, Be.convert(l), Be.convert(u), 0);
          P.bindBuffer(P.PIXEL_PACK_BUFFER, null);
          let p = j === null ? null : L.get(j).__webglFramebuffer;
          I.bindFramebuffer(P.FRAMEBUFFER, p);
          let m = P.fenceSync(P.SYNC_GPU_COMMANDS_COMPLETE, 0);
          P.flush();
          await Kg(P, m, 4);
          P.bindBuffer(P.PIXEL_PACK_BUFFER, f);
          P.getBufferSubData(P.PIXEL_PACK_BUFFER, 0, a);
          P.bindBuffer(P.PIXEL_PACK_BUFFER, null);
          P.deleteBuffer(f);
          P.deleteSync(m);
          return a;
        }
        throw Error(`THREE.WebGLRenderer.readRenderTargetPixelsAsync: requested read bounds are out of range.`);
      }
    };
    this.copyFramebufferToTexture = function (e, t = null, n = 0) {
      let r = 2 ** -n;
      let i = Math.floor(e.image.width * r);
      let a = Math.floor(e.image.height * r);
      let o = t === null ? 0 : t.x;
      let s = t === null ? 0 : t.y;
      De.setTexture2D(e, 0);
      P.copyTexSubImage2D(P.TEXTURE_2D, n, 0, 0, o, s, i, a);
      I.unbindTexture();
    };
    this.copyTextureToTexture = function (e, t, n = null, r = null, i = 0, a = 0) {
      let o;
      let s;
      let c;
      let l;
      let u;
      let d;
      let f;
      let p;
      let m;
      let h = e.isCompressedTexture ? e.mipmaps[a] : e.image;
      if (n !== null) {
        o = n.max.x - n.min.x;
        s = n.max.y - n.min.y;
        c = n.isBox3 ? n.max.z - n.min.z : 1;
        l = n.min.x;
        u = n.min.y;
        d = n.isBox3 ? n.min.z : 0;
      } else {
        let t = 2 ** -i;
        o = Math.floor(h.width * t);
        s = Math.floor(h.height * t);
        c = e.isDataArrayTexture ? h.depth : e.isData3DTexture ? Math.floor(h.depth * t) : 1;
        l = 0;
        u = 0;
        d = 0;
      }
      if (r === null) {
        f = 0;
        p = 0;
        m = 0;
      } else {
        f = r.x;
        p = r.y;
        m = r.z;
      }
      let g = Be.convert(t.format);
      let _ = Be.convert(t.type);
      let v;
      if (t.isData3DTexture) {
        De.setTexture3D(t, 0);
        v = P.TEXTURE_3D;
      } else if (t.isDataArrayTexture || t.isCompressedArrayTexture) {
        De.setTexture2DArray(t, 0);
        v = P.TEXTURE_2D_ARRAY;
      } else {
        De.setTexture2D(t, 0);
        v = P.TEXTURE_2D;
      }
      I.activeTexture(P.TEXTURE0);
      I.pixelStorei(P.UNPACK_FLIP_Y_WEBGL, t.flipY);
      I.pixelStorei(P.UNPACK_PREMULTIPLY_ALPHA_WEBGL, t.premultiplyAlpha);
      I.pixelStorei(P.UNPACK_ALIGNMENT, t.unpackAlignment);
      let y = I.getParameter(P.UNPACK_ROW_LENGTH);
      let b = I.getParameter(P.UNPACK_IMAGE_HEIGHT);
      let x = I.getParameter(P.UNPACK_SKIP_PIXELS);
      let S = I.getParameter(P.UNPACK_SKIP_ROWS);
      let C = I.getParameter(P.UNPACK_SKIP_IMAGES);
      I.pixelStorei(P.UNPACK_ROW_LENGTH, h.width);
      I.pixelStorei(P.UNPACK_IMAGE_HEIGHT, h.height);
      I.pixelStorei(P.UNPACK_SKIP_PIXELS, l);
      I.pixelStorei(P.UNPACK_SKIP_ROWS, u);
      I.pixelStorei(P.UNPACK_SKIP_IMAGES, d);
      let w = e.isDataArrayTexture || e.isData3DTexture;
      let T = t.isDataArrayTexture || t.isData3DTexture;
      if (e.isDepthTexture) {
        let n = L.get(e);
        let r = L.get(t);
        let h = L.get(n.__renderTarget);
        let g = L.get(r.__renderTarget);
        I.bindFramebuffer(P.READ_FRAMEBUFFER, h.__webglFramebuffer);
        I.bindFramebuffer(P.DRAW_FRAMEBUFFER, g.__webglFramebuffer);
        for (let n = 0; n < c; n++) {
          if (w) {
            P.framebufferTextureLayer(P.READ_FRAMEBUFFER, P.COLOR_ATTACHMENT0, L.get(e).__webglTexture, i, d + n);
            P.framebufferTextureLayer(P.DRAW_FRAMEBUFFER, P.COLOR_ATTACHMENT0, L.get(t).__webglTexture, a, m + n);
          }
          P.blitFramebuffer(l, u, o, s, f, p, o, s, P.DEPTH_BUFFER_BIT, P.NEAREST);
        }
        I.bindFramebuffer(P.READ_FRAMEBUFFER, null);
        I.bindFramebuffer(P.DRAW_FRAMEBUFFER, null);
      } else if (i !== 0 || e.isRenderTargetTexture || L.has(e)) {
        let n = L.get(e);
        let r = L.get(t);
        I.bindFramebuffer(P.READ_FRAMEBUFFER, k);
        I.bindFramebuffer(P.DRAW_FRAMEBUFFER, A);
        for (let e = 0; e < c; e++) {
          if (w) {
            P.framebufferTextureLayer(P.READ_FRAMEBUFFER, P.COLOR_ATTACHMENT0, n.__webglTexture, i, d + e);
          } else {
            P.framebufferTexture2D(P.READ_FRAMEBUFFER, P.COLOR_ATTACHMENT0, P.TEXTURE_2D, n.__webglTexture, i);
          }
          if (T) {
            P.framebufferTextureLayer(P.DRAW_FRAMEBUFFER, P.COLOR_ATTACHMENT0, r.__webglTexture, a, m + e);
          } else {
            P.framebufferTexture2D(P.DRAW_FRAMEBUFFER, P.COLOR_ATTACHMENT0, P.TEXTURE_2D, r.__webglTexture, a);
          }
          if (i === 0) {
            if (T) {
              P.copyTexSubImage3D(v, a, f, p, m + e, l, u, o, s);
            } else {
              P.copyTexSubImage2D(v, a, f, p, l, u, o, s);
            }
          } else {
            P.blitFramebuffer(l, u, o, s, f, p, o, s, P.COLOR_BUFFER_BIT, P.NEAREST);
          }
        }
        I.bindFramebuffer(P.READ_FRAMEBUFFER, null);
        I.bindFramebuffer(P.DRAW_FRAMEBUFFER, null);
      } else if (T) {
        if (e.isDataTexture || e.isData3DTexture) {
          P.texSubImage3D(v, a, f, p, m, o, s, c, g, _, h.data);
        } else if (t.isCompressedArrayTexture) {
          P.compressedTexSubImage3D(v, a, f, p, m, o, s, c, g, h.data);
        } else {
          P.texSubImage3D(v, a, f, p, m, o, s, c, g, _, h);
        }
      } else if (e.isDataTexture) {
        P.texSubImage2D(P.TEXTURE_2D, a, f, p, o, s, g, _, h.data);
      } else if (e.isCompressedTexture) {
        P.compressedTexSubImage2D(P.TEXTURE_2D, a, f, p, h.width, h.height, g, h.data);
      } else {
        P.texSubImage2D(P.TEXTURE_2D, a, f, p, o, s, g, _, h);
      }
      I.pixelStorei(P.UNPACK_ROW_LENGTH, y);
      I.pixelStorei(P.UNPACK_IMAGE_HEIGHT, b);
      I.pixelStorei(P.UNPACK_SKIP_PIXELS, x);
      I.pixelStorei(P.UNPACK_SKIP_ROWS, S);
      I.pixelStorei(P.UNPACK_SKIP_IMAGES, C);
      if (a === 0 && t.generateMipmaps) {
        P.generateMipmap(v);
      }
      I.unbindTexture();
    };
    this.initRenderTarget = function (e) {
      if (L.get(e).__webglFramebuffer === undefined) {
        De.setupRenderTarget(e);
      }
    };
    this.initTexture = function (e) {
      if (e.isCubeTexture) {
        De.setTextureCube(e, 0);
      } else if (e.isData3DTexture) {
        De.setTexture3D(e, 0);
      } else if (e.isDataArrayTexture || e.isCompressedArrayTexture) {
        De.setTexture2DArray(e, 0);
      } else {
        De.setTexture2D(e, 0);
      }
      I.unbindTexture();
    };
    this.resetState = function () {
      ee = 0;
      te = 0;
      j = null;
      I.reset();
      Ve.reset();
    };
    if (typeof __THREE_DEVTOOLS__ < `u`) {
      __THREE_DEVTOOLS__.dispatchEvent(new CustomEvent(`observe`, {
        detail: this
      }));
    }
  }
  get coordinateSystem() {
    return Fg;
  }
  get outputColorSpace() {
    return this._outputColorSpace;
  }
  set outputColorSpace(e) {
    this._outputColorSpace = e;
    let t = this.getContext();
    t.drawingBufferColorSpace = j_._getDrawingBufferColorSpace(e);
    t.unpackColorSpace = j_._getUnpackColorSpace();
  }
};
var RT = [{
  id: `branco-tx`,
  nome: `Branco TX`,
  categoria: `monolitico`,
  hex: `#f7f7f5`,
  rugosidade: 0.65,
  metalicidade: 0.02,
  descricao: `MDF Branco textura suave padrão da marcenaria moderna`
}, {
  id: `grafite-silk`,
  nome: `Grafite Silk`,
  categoria: `monolitico`,
  hex: `#2f343b`,
  rugosidade: 0.55,
  metalicidade: 0.05,
  descricao: `Cinza grafite sofisticado acabamento acetinado`
}, {
  id: `preto-fosco`,
  nome: `Preto Fosco Absoluto`,
  categoria: `monolitico`,
  hex: `#181a1c`,
  rugosidade: 0.7,
  metalicidade: 0.02,
  descricao: `Preto acetinado antirreflexo e antimanchas`
}, {
  id: `areia-suave`,
  nome: `Areia Acetinado`,
  categoria: `monolitico`,
  hex: `#ded8cc`,
  rugosidade: 0.6,
  metalicidade: 0.02,
  descricao: `Tom neutro quente para ambientes clean`
}, {
  id: `verde-sage`,
  nome: `Verde Sage`,
  categoria: `monolitico`,
  hex: `#58695d`,
  rugosidade: 0.6,
  metalicidade: 0.03,
  descricao: `Verde oliva sutil muito utilizado em cozinhas de luxo`
}, {
  id: `azul-petroleo`,
  nome: `Azul Petróleo`,
  categoria: `monolitico`,
  hex: `#2c4553`,
  rugosidade: 0.58,
  metalicidade: 0.04,
  descricao: `Azul profundo elegante para frentes e tampos`
}, {
  id: `freijo-natural`,
  nome: `Freijó Natural`,
  categoria: `madeira`,
  hex: `#c89d6c`,
  texturaUrl: `/textures/FL-W101.svg`,
  rugosidade: 0.45,
  metalicidade: 0.02,
  repeticao: [2, 2],
  descricao: `Veios lineares suaves e tonalidade clássica`
}, {
  id: `carvalho-malva`,
  nome: `Carvalho Malva`,
  categoria: `madeira`,
  hex: `#baa082`,
  texturaUrl: `/textures/FL-W201.svg`,
  rugosidade: 0.5,
  metalicidade: 0.02,
  repeticao: [2, 2],
  descricao: `Carvalho nobre de tons amenos e veios claros`
}, {
  id: `carvalho-catedral`,
  nome: `Carvalho Catedral`,
  categoria: `madeira`,
  hex: `#a37e56`,
  texturaUrl: `/textures/FL-W302.svg`,
  rugosidade: 0.48,
  metalicidade: 0.02,
  repeticao: [2, 2],
  descricao: `Desenho catedral marcado de alta expressividade`
}, {
  id: `louro-freijo`,
  nome: `Louro Freijó Dourado`,
  categoria: `madeira`,
  hex: `#b88a53`,
  texturaUrl: `/textures/FL-W402.svg`,
  rugosidade: 0.46,
  metalicidade: 0.02,
  repeticao: [2, 2],
  descricao: `Tonalidade dourada e veios rústicos requintados`
}, {
  id: `nogal-terracota`,
  nome: `Nogal Escuro`,
  categoria: `madeira`,
  hex: `#5c3f28`,
  texturaUrl: `/textures/FL-W602.svg`,
  rugosidade: 0.42,
  metalicidade: 0.03,
  repeticao: [2, 2],
  descricao: `Nogueira escura imponente para salas e dormitórios`
}, {
  id: `itauba-clara`,
  nome: `Itaúba Serena`,
  categoria: `madeira`,
  hex: `#d5b48e`,
  texturaUrl: `/textures/FL-W802.svg`,
  rugosidade: 0.52,
  metalicidade: 0.01,
  repeticao: [2, 2],
  descricao: `Madeira clara com suave variação de veios`
}, {
  id: `marmore-calacatta`,
  nome: `Mármore Calacatta Ouro`,
  categoria: `pedra`,
  hex: `#f0eeea`,
  texturaUrl: `/textures/FL-S101.svg`,
  rugosidade: 0.18,
  metalicidade: 0.08,
  repeticao: [1.5, 1.5],
  descricao: `Fundo branco puro com veios dourados e cinzas`
}, {
  id: `marmore-carrara`,
  nome: `Mármore Carrara Nero`,
  categoria: `pedra`,
  hex: `#232629`,
  texturaUrl: `/textures/FL-S301.svg`,
  rugosidade: 0.22,
  metalicidade: 0.06,
  repeticao: [1.5, 1.5],
  descricao: `Mármore negro com veios brancos contrastantes`
}, {
  id: `concreto-urbano`,
  nome: `Concreto Urbano`,
  categoria: `pedra`,
  hex: `#949594`,
  texturaUrl: `/textures/FL-S402.svg`,
  rugosidade: 0.75,
  metalicidade: 0.02,
  repeticao: [2, 2],
  descricao: `Estilo industrial com textura mineral e porosa`
}, {
  id: `granito-sao-gabriel`,
  nome: `Granito São Gabriel`,
  categoria: `pedra`,
  hex: `#2b2e31`,
  texturaUrl: `/textures/FL-S502.svg`,
  rugosidade: 0.35,
  metalicidade: 0.05,
  repeticao: [2, 2],
  descricao: `Granito escuro com granulometria fina homogênea`
}, {
  id: `vidro-incolor`,
  nome: `Vidro Incolor`,
  categoria: `especial`,
  hex: `#dce8ec`,
  rugosidade: 0.05,
  metalicidade: 0.1,
  descricao: `Vidro transparente temperado para portas de armários`
}, {
  id: `espelho-prata`,
  nome: `Espelho Cristal`,
  categoria: `especial`,
  hex: `#e2e6ea`,
  rugosidade: 0.02,
  metalicidade: 0.95,
  descricao: `Espelho de alta refletividade para portas de correr`
}];
function zT(e) {
  return UT.find(t => t.id === e) ?? UT[0];
}
function BT(e) {
  if (e) {
    return GT.find(t => t.id === e);
  }
}
function VT(e) {
  if (e) {
    return WT.find(t => t.id === e);
  }
}
function HT(e, t, n) {
  return [Math.max(1, Math.round(e / n[0])), Math.max(1, Math.round(t / n[1]))];
}
var UT = [{
  id: `estudio`,
  nome: `Parede lisa`,
  tipo: `outro`,
  parede: `#f0ede6`,
  paredeEscura: `#1c1f24`,
  paredePadrao: `parede-lisa-branca`,
  pisoCor: `#e5dfd5`,
  pisoCorEscura: `#14171a`,
  pisoPadrao: `laminado-carvalho`,
  temParedes: true
}, {
  id: `dormitorio`,
  nome: `Quarto`,
  tipo: `quarto`,
  parede: `#e7e2d8`,
  paredeEscura: `#221f1b`,
  paredePadrao: `parede-lisa-branca`,
  pisoCor: `#ded6c8`,
  pisoCorEscura: `#171613`,
  pisoPadrao: `laminado-claro`,
  temParedes: true
}, {
  id: `cozinha`,
  nome: `Cozinha`,
  tipo: `cozinha`,
  parede: `#eef0f0`,
  paredeEscura: `#1b1e20`,
  paredePadrao: `parede-azulejo-30x60`,
  pisoCor: `#e6e8e6`,
  pisoCorEscura: `#141717`,
  pisoPadrao: `porcelanato-carrara`,
  temParedes: true
}, {
  id: `banheiro`,
  nome: `Banheiro`,
  tipo: `banheiro`,
  parede: `#e9eef0`,
  paredeEscura: `#181d1f`,
  paredePadrao: `parede-azulejo-30x30`,
  pisoCor: `#e2e7e8`,
  pisoCorEscura: `#131718`,
  pisoPadrao: `azulejo-30x30`,
  temParedes: true
}, {
  id: `sala`,
  nome: `Sala`,
  tipo: `sala`,
  parede: `#e8e4dd`,
  paredeEscura: `#1f1d1a`,
  paredePadrao: `parede-grain-1000`,
  pisoCor: `#ded4c4`,
  pisoCorEscura: `#181510`,
  pisoPadrao: `laminado-rustico`,
  temParedes: true
}, {
  id: `escritorio`,
  nome: `Escritório`,
  tipo: `escritorio`,
  parede: `#e4e5e7`,
  paredeEscura: `#1a1d21`,
  paredePadrao: `parede-papel-1000`,
  pisoCor: `#d3ccbf`,
  pisoCorEscura: `#16150f`,
  pisoPadrao: `laminado-nogueira`,
  temParedes: true
}, {
  id: `sem-cenario`,
  nome: `Sem cenário`,
  tipo: `outro`,
  parede: `#f0ede6`,
  paredeEscura: `#1c1f24`,
  paredePadrao: ``,
  pisoCor: `#e5dfd5`,
  pisoCorEscura: `#14171a`,
  pisoPadrao: ``,
  temParedes: false
}];
var WT = [{
  id: `laminado-carvalho`,
  nome: `Laminado Carvalho`,
  url: `/textures/laminate-1.svg`,
  dimensaoCm: [120, 20],
  repeticao: [4, 4]
}, {
  id: `laminado-nogueira`,
  nome: `Laminado Nogueira`,
  url: `/textures/laminate-2.svg`,
  dimensaoCm: [120, 20],
  repeticao: [4, 4]
}, {
  id: `laminado-claro`,
  nome: `Laminado Bege Claro`,
  url: `/textures/laminate-3.svg`,
  dimensaoCm: [120, 20],
  repeticao: [4, 4]
}, {
  id: `laminado-rustico`,
  nome: `Laminado Rústico`,
  url: `/textures/laminado-4.svg`,
  dimensaoCm: [120, 20],
  repeticao: [4, 4]
}, {
  id: `laminado-escuro`,
  nome: `Laminado Escuro`,
  url: `/textures/laminado-5.svg`,
  dimensaoCm: [120, 20],
  repeticao: [4, 4]
}, {
  id: `porcelanato-carrara`,
  nome: `Porcelanato Mármore 60x60`,
  url: `/textures/piso-porcelanato-60x60.svg`,
  dimensaoCm: [60, 60],
  repeticao: [5, 5]
}, {
  id: `porcelanato-marmore`,
  nome: `Porcelanato 30x60`,
  url: `/textures/piso-porcelanato-30x60.svg`,
  dimensaoCm: [30, 60],
  repeticao: [8, 8]
}, {
  id: `porcelanato-30x60`,
  nome: `Porcelanato 30x60`,
  url: `/textures/piso-porcelanato-30x60.svg`,
  dimensaoCm: [30, 60],
  repeticao: [8, 8]
}, {
  id: `azulejo-30x30`,
  nome: `Cerâmica 30x30`,
  url: `/textures/piso-azulejo-30x30.svg`,
  dimensaoCm: [30, 30],
  repeticao: [10, 10]
}, {
  id: `azulejo-30x60`,
  nome: `Cerâmica 30x60`,
  url: `/textures/piso-azulejo-30x60.svg`,
  dimensaoCm: [30, 60],
  repeticao: [8, 8]
}];
var GT = [{
  id: `parede-lisa-branca`,
  nome: `Parede lisa branca`,
  url: `/textures/parede-lisa-branca.svg`,
  dimensaoCm: [200, 200],
  repeticao: [2, 2]
}, {
  id: `parede-azulejo-30x60`,
  nome: `Azulejo 30x60`,
  url: `/textures/parede-azulejo-30x60.svg`,
  dimensaoCm: [30, 60],
  repeticao: [8, 4]
}, {
  id: `parede-azulejo-30x30`,
  nome: `Azulejo 30x30`,
  url: `/textures/parede-azulejo-30x30.svg`,
  dimensaoCm: [30, 30],
  repeticao: [10, 8]
}, {
  id: `parede-papel-1000`,
  nome: `Papel de parede liso`,
  url: `/textures/parede-papel-1000.svg`,
  dimensaoCm: [100, 100],
  repeticao: [3, 2]
}, {
  id: `parede-grain-1000`,
  nome: `Papel de parede texturizado`,
  url: `/textures/parede-grain-1000.svg`,
  dimensaoCm: [100, 100],
  repeticao: [3, 2]
}];
var KT = new Mx();
var qT = new Map();
function JT(e, t = [1, 1]) {
  if (!e) return null;
  let url = e.replace(/\.(webp|jpg)$/i, '.svg');
  let n = `${url}-${t[0]}x${t[1]}`;
  let r = qT.get(n);
  if (r) {
    return r;
  }
  let i = KT.load(url, () => {
    i.needsUpdate = true;
  });
  i.wrapS = sh;
  i.wrapT = sh;
  i.repeat.set(t[0], t[1]);
  i.colorSpace = kg;
  qT.set(n, i);
  return i;
}
function YT(e) {
  return RT.find(t => t.id === e) || RT.find(t => t.hex.toLowerCase() === e.toLowerCase()) || {
    id: `custom`,
    nome: `Cor Personalizada`,
    categoria: `monolitico`,
    hex: e.startsWith(`#`) ? e : `#f7f7f5`,
    rugosidade: 0.6,
    metalicidade: 0.02
  };
}
function XT({
  modulo: e,
  className: t
}) {
  let n = Number(e.largura_mm) / Number(e.altura_mm);
  let r = Math.max(34, Math.min(120, 100 / n));
  let i = e.cor ?? Cm();
  let a = Math.max(0, e.portas);
  let o = Math.max(0, e.gavetas);
  let s = Array.from({
    length: Math.max(0, a - 1)
  }, (e, t) => (t + 1) / a * 100);
  let c = Array.from({
    length: Math.max(0, o - 1)
  }, (e, t) => (t + 1) / o * r);
          return <svg viewBox={`0 0 100 ${r}`} className={U(`h-full w-full`, t)} role={`img`} aria-label={e.nome}><rect x={`1.5`} y={`1.5`} width={97} height={r - 3} rx={`2`} fill={i} stroke={`currentColor`} strokeOpacity={`0.35`} strokeWidth={`1`} />{s.map(e => <line x1={e} y1={`1.5`} x2={e} y2={r - 1.5} stroke={`currentColor`} strokeOpacity={`0.3`} strokeWidth={`1`} key={`porta-${e}`} />)}{c.map(e => <line x1={`1.5`} y1={e} x2={98.5} y2={e} stroke={`currentColor`} strokeOpacity={`0.3`} strokeWidth={`1`} key={`gaveta-${e}`} />)}</svg>;
}
var ZT = {
  nome: ``,
  projeto_id: ``,
  ambiente_id: ``,
  largura_mm: `3000`,
  altura_mm: `2300`,
  profundidade_mm: `600`,
  observacoes: ``
};
function QT({
  open: e,
  onOpenChange: t,
  modelo: r
}) {
  let a = f();
  let o = um();
  let {
    data: s
  } = Jl();
  let [c, l] = (0, k.useState)(false);
  let {
    register: u,
    handleSubmit: d,
    reset: p,
    watch: m,
    setValue: h,
    formState: {
      errors: g,
      isSubmitting: _
    }
  } = i({
    resolver: n(Ac),
    defaultValues: ZT
  });
  let v = m(`projeto_id`);
  let y = m(`ambiente_id`);
  let {
    data: b
  } = Yl(v || undefined);
  let x = (0, k.useMemo)(() => b?.ambientes ?? [], [b]);
  let [S, C] = (0, k.useState)(null);
  function w(e) {
    C(e);
    if (e) {
      h(`nome`, e.nome);
      h(`largura_mm`, String(e.comodo.largura));
      h(`altura_mm`, String(e.comodo.altura));
      h(`profundidade_mm`, String(e.profundidadeTrabalho));
    }
  }
  let T = (0, k.useMemo)(() => x.find(e => e.id === y) ?? null, [x, y]);
  let {
    data: E
  } = Au(y || undefined);
  (0, k.useEffect)(() => {
    if (e) {
      p(ZT);
    }
  }, [e, p]);
  (0, k.useEffect)(() => {
    if (!E) {
      return;
    }
    let e = e => e === null ? null : String(Math.round(e * 10));
    let t = e(E.largura_cm);
    let n = e(E.altura_cm);
    let r = e(E.profundidade_cm);
    if (t) {
      h(`largura_mm`, t);
    }
    if (n) {
      h(`altura_mm`, n);
    }
    if (r) {
      h(`profundidade_mm`, r);
    }
  }, [E, h]);
  async function D(e) {
    let n = {
      largura: _l(e.largura_mm),
      altura: _l(e.altura_mm),
      profundidade: _l(e.profundidade_mm)
    };
    let i = S ? ih(S).cena : r ? {
      ...xm,
      modulos: [zm(xm, n, Fm(r))]
    } : xm;
    let s = await o.mutateAsync({
      nome: e.nome,
      projeto_id: e.projeto_id,
      ambiente_id: bl(e.ambiente_id),
      largura_mm: n.largura,
      altura_mm: n.altura,
      profundidade_mm: n.profundidade,
      cena: i,
      observacoes: e.observacoes.trim() === `` ? null : e.observacoes
    });
    t(false);
    a(`/designer/${s.id}`);
  }
                                        return <L.Fragment><_Component21 open={e} onOpenChange={t} title={`Novo estudo 3D`} description={`O estudo fica vinculado ao projeto e ao ambiente escolhidos.`} size={`xl`} footer={<L.Fragment><G variant={`outline`} onClick={() => t(false)} disabled={_}>{`Cancelar`}</G><G form={`design-form`} type={`submit`} disabled={_}>{_ ? `Criando...` : `Criar e abrir editor`}</G></L.Fragment>}><div className={`grid gap-5 lg:grid-cols-[minmax(0,1fr)_340px]`}><form id={`design-form`} onSubmit={d(D)} className={`grid content-start gap-4 sm:grid-cols-3`}>{r && <div className={`flex items-center gap-3 rounded-[10px] border border-border bg-muted/40 p-3 sm:col-span-3`}><span className={`grid h-12 w-16 shrink-0 place-items-center text-foreground`}><XT modulo={r} className={`max-h-12`} /></span><div className={`min-w-0`}><p className={`text-[12px] font-medium`}>{`Começando pelo modelo`}</p><p className={`truncate text-[12px] text-muted-foreground`}>{r.nome}</p></div></div>}<_Component19 label={`Nome do estudo`} htmlFor={`d-nome`} error={g.nome?.message} required={true} className={`sm:col-span-3`}><K id={`d-nome`} placeholder={`Ex: Cozinha - parede A`} {...u(`nome`)} /></_Component19><div className={`sm:col-span-3`}><p className={`pb-2 text-[11px] font-semibold uppercase tracking-wider text-muted-foreground`}>{`Ambiente do estudo (opcional)`}</p><div className={`grid gap-2 sm:grid-cols-3`}>{rh.map(e => {
                let t = UT.find(t => t.id === e.cenario);
                let n = BT(t?.paredePadrao);
                let r = VT(t?.pisoPadrao);
                let i = S?.id === e.id;
                                                                                                                                                return <button type={`button`} onClick={() => w(i ? null : e)} className={U(`flex gap-2 rounded-[10px] border p-2 text-left transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring/35`, i ? `border-primary bg-accent` : `border-border bg-card hover:border-primary/50`)} key={e.id}><span className={`flex h-12 w-9 shrink-0 flex-col overflow-hidden rounded border border-border`} aria-hidden={true}><span className={`h-[55%] w-full`} style={n ? {
                      backgroundImage: `url(${n.url})`,
                      backgroundSize: `cover`,
                      backgroundPosition: `center`
                    } : {
                      backgroundColor: t?.parede ?? `#e8e4dd`
                    }} /><span className={`h-[45%] w-full border-t border-border/60`} style={r ? {
                      backgroundImage: `url(${r.url})`,
                      backgroundSize: `cover`,
                      backgroundPosition: `center`
                    } : {
                      backgroundColor: t?.pisoCor ?? `#ded4c4`
                    }} /></span><span className={`min-w-0`}><span className={`block truncate text-[12px] font-semibold text-foreground`}>{e.nome}</span><span className={`numero block text-[10px] text-muted-foreground`}>{e.comodo.largura / 10}{` × `}{e.comodo.profundidade / 10}{` × `}{e.comodo.altura / 10}{` cm`}</span><span className={`mt-0.5 block text-[10px] text-muted-foreground`}>{e.descricao}</span></span></button>;
              })}</div><p className={`pt-1.5 text-[11px] text-muted-foreground`}>{S ? `${S.nome} entra só como ambiente: paredes, piso e medidas. Você desenha os móveis e adiciona as peças.` : `Escolha um ambiente para o estudo nascer com as paredes e o piso certos. Nenhum móvel entra automaticamente.`}</p></div><_Component19 label={`Projeto`} htmlFor={`d-projeto`} error={g.projeto_id?.message} required={true} className={`sm:col-span-2`}><_Component31 id={`d-projeto`} value={v} onChange={e => {
              h(`projeto_id`, e.target.value);
              h(`ambiente_id`, ``);
            }}><option value={``}>{`Selecione um projeto`}</option>{(s ?? []).map(e => <option value={e.id} key={e.id}>{e.nome}{` (`}{e.cliente?.nome ?? `sem cliente`}{`)`}</option>)}</_Component31></_Component19><_Component19 label={`Ambiente`} htmlFor={`d-ambiente`} error={g.ambiente_id?.message} hint={T ? `${Ne[T.tipo]} · markup ${eo(T.margem_percent)}` : undefined}><div className={`flex gap-2`}><_Component31 id={`d-ambiente`} disabled={!v} {...u(`ambiente_id`)}><option value={``}>{`Sem ambiente`}</option>{x.map(e => <option value={e.id} key={e.id}>{e.nome}</option>)}</_Component31><G type={`button`} variant={`outline`} size={`icon`} className={`shrink-0`} disabled={!v} onClick={() => l(true)} title={`Criar ambiente neste projeto`} aria-label={`Criar ambiente neste projeto`}><_Component10 className={`h-4 w-4`} /></G></div></_Component19><_Component19 label={`Largura do vão (mm)`} htmlFor={`d-largura`} error={g.largura_mm?.message} required={true}><K id={`d-largura`} inputMode={`numeric`} {...u(`largura_mm`)} /></_Component19><_Component19 label={`Altura do vão (mm)`} htmlFor={`d-altura`} error={g.altura_mm?.message} required={true}><K id={`d-altura`} inputMode={`numeric`} {...u(`altura_mm`)} /></_Component19><_Component19 label={`Profundidade (mm)`} htmlFor={`d-profundidade`} error={g.profundidade_mm?.message} required={true}><K id={`d-profundidade`} inputMode={`numeric`} {...u(`profundidade_mm`)} /></_Component19><_Component19 label={`Observações`} htmlFor={`d-obs`} error={g.observacoes?.message} className={`sm:col-span-3`}><Rl id={`d-obs`} rows={2} {...u(`observacoes`)} /></_Component19></form><div className={`rounded-[10px] border border-border bg-muted/30 p-3`}><p className={`pb-2 text-[11px] font-semibold text-muted-foreground`}>{T ? `Ambiente escolhido` : `Ambiente do projeto`}</p>{T ? <_Component34 entrada={{
            nome: T.nome,
            tipo: T.tipo,
            largura_cm: E?.largura_cm ?? null,
            altura_cm: E?.altura_cm ?? null,
            profundidade_cm: E?.profundidade_cm ?? null,
            desnivel_cm: E?.desnivel_cm ?? null,
            pontos_eletricos: E?.pontos_eletricos ?? 0,
            pontos_hidraulicos: E?.pontos_hidraulicos ?? 0,
            margem_percent: T.margem_percent
          }} className={`rounded-md`} /> : <p className={`rounded-md border border-dashed border-border p-3 text-[12px] text-muted-foreground`}>{v ? `Escolha um cômodo para o estudo herdar o mockup, as medidas do vão e o markup. Se o projeto ainda não tem cômodos, crie pelo botão ao lado do campo.` : `Selecione um projeto para ver os cômodos disponíveis.`}</p>}</div></div></_Component21>{c && v && <Xu open={c} onOpenChange={l} projetoId={v} onCriado={e => h(`ambiente_id`, e.id)} />}</L.Fragment>;
}
function $T() {
  let e = f();
  let [t, n] = (0, k.useState)(`estudos`);
  let [r, i] = (0, k.useState)(`todos`);
  let [a, o] = (0, k.useState)(false);
  let [s, c] = (0, k.useState)(null);
  let [l, u] = (0, k.useState)(null);
  let {
    data: d,
    isLoading: p
  } = cm();
  let {
    data: m,
    isLoading: h
  } = im();
  let g = am();
  let _ = fm();
  let v = (0, k.useMemo)(() => r === `todos` ? m ?? [] : (m ?? []).filter(e => e.categoria === r), [m, r]);
  function y(e) {
    c(e ?? null);
    o(true);
  }
                                            return <div className={`space-y-6`}><Fs title={`Designer 3D`} description={p ? `Carregando estudos 3D.` : `${d?.length ?? 0} estudo(s) e ${m?.length ?? 0} modelos na biblioteca.`} actions={<G onClick={() => y()}><_Component10 className={`h-4 w-4`} />{`Novo estudo`}</G>}><_Component32 value={t} onValueChange={n} tabs={[{
        value: `estudos`,
        label: `Meus estudos`,
        count: d?.length ?? 0
      }, {
        value: `modelos`,
        label: `Modelos prontos`,
        count: m?.length ?? 0
      }]} /></Fs>{t === `estudos` && <L.Fragment>{p ? null : d && d.length > 0 ? <div className={`grid gap-4 sm:grid-cols-2 lg:grid-cols-3`}>{d.map(t => <Rs className={`flex flex-col gap-3 p-4 transition-colors duration-150 hover:border-primary/40`} key={t.id}><div className={`flex items-start justify-between gap-2`}><div className={`min-w-0`}><p className={`truncate text-[13px] font-medium`}>{t.nome}</p><p className={`truncate text-[11px] text-muted-foreground`}>{t.projeto?.nome ?? `Sem projeto`}{t.ambiente ? ` - ${t.ambiente.nome}` : ``}</p></div><Lo items={[{
              label: `Abrir editor`,
              onSelect: () => e(`/designer/${t.id}`)
            }, {
              label: `Remover`,
              icon: <_Component26 className={`h-4 w-4`} />,
              destructive: true,
              onSelect: () => u(t)
            }]} /></div><div className={`flex items-center gap-3 rounded-[10px] border border-border bg-muted/40 p-2`}><span className={`grid h-12 w-16 place-items-center text-foreground`}><Rt className={`h-5 w-5`} /></span><span className={`numero min-w-0 text-[11px] text-muted-foreground`}>{Za(t.largura_mm, 0)}{` × `}{Za(t.altura_mm, 0)}{` ×`}{` `}{Za(t.profundidade_mm, 0)}{` mm`}</span></div><div className={`mt-auto flex items-center justify-between gap-2`}><span className={`text-[11px] text-muted-foreground`}>{`atualizado em `}{to(t.updated_at)}</span><G variant={`outline`} size={`sm`} onClick={() => e(`/designer/${t.id}`)}>{`Abrir`}</G></div></Rs>)}</div> : <Ws icon={<Rt className={`h-4 w-4`} />} title={`Nenhum estudo 3D`} description={`Crie um estudo vinculado ao projeto para montar o layout, cotar medidas e fechar o orçamento.`} action={<G onClick={() => y()}><_Component10 className={`h-4 w-4`} />{`Novo estudo`}</G>} />}</L.Fragment>}{t === `modelos` && <div className={`space-y-4`}><div className={`flex flex-wrap items-center gap-2`}><button type={`button`} onClick={() => i(`todos`)} className={r === `todos` ? `rounded-[6px] bg-foreground px-2.5 py-1 text-[12px] font-medium text-background` : `rounded-[6px] border border-border px-2.5 py-1 text-[12px] font-medium text-muted-foreground hover:text-foreground`}>{`Todos`}</button>{yi.map(e => <button type={`button`} onClick={() => i(e)} className={r === e ? `rounded-[6px] bg-foreground px-2.5 py-1 text-[12px] font-medium text-background` : `rounded-[6px] border border-border px-2.5 py-1 text-[12px] font-medium text-muted-foreground hover:text-foreground`} key={e}>{vi[e]}</button>)}</div>{h ? null : v.length > 0 ? <div className={`grid grid-cols-2 gap-4 sm:grid-cols-3 lg:grid-cols-4`}>{v.map(e => <button type={`button`} onClick={() => y(e)} className={`flex flex-col gap-3 rounded-[10px] border border-border bg-card p-3 text-left transition-colors duration-150 hover:border-primary/40 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring/35`} title={`Criar estudo com ${e.nome}`} key={e.id}><span className={`grid h-24 place-items-center text-foreground`}><XT modulo={e} className={`max-h-24`} /></span><span className={`min-w-0`}><span className={`block truncate text-[12px] font-medium leading-tight`}>{e.nome}</span><span className={`numero block text-[10px] text-muted-foreground`}>{Za(e.largura_mm, 0)}{` × `}{Za(e.altura_mm, 0)}{` ×`}{` `}{Za(e.profundidade_mm, 0)}{` mm`}</span></span></button>)}</div> : <Ws icon={<Tn className={`h-4 w-4`} />} title={`Biblioteca vazia`} description={`Carregue a biblioteca padrão com armários, aéreos, gaveteiros e eletrodomésticos.`} action={<G onClick={() => g.mutate()} disabled={g.isPending}><_Component17 className={`h-4 w-4`} />{g.isPending ? `Carregando...` : `Carregar biblioteca padrão`}</G>} />}</div>}<QT open={a} onOpenChange={o} modelo={s} /><_Component29 open={!!l} onOpenChange={e => !e && u(null)} title={`Remover estudo 3D`} description={l ? `Remover "${l.nome}"?` : undefined} confirmLabel={`Remover`} onConfirm={async () => {
      if (l) {
        await _.mutateAsync(l.id);
      }
    }} /></div>;
}
function eE(e, t, n) {
  let r = zm(e, t, Fm(n));
  let i = Vm({
    ...e,
    modulos: [...e.modulos, r]
  }, t, r.id);
  return {
    cena: i,
    modulo: i.modulos.find(e => e.id === r.id) ?? r
  };
}
function tE(e, t, n, r) {
  let i = Fm(n);
  let a = {
    ...i,
    x: r.x,
    y: r.y,
    z: r.z ?? i.z
  };
  let o = Vm({
    ...e,
    modulos: [...e.modulos, a]
  }, t, a.id);
  return {
    cena: o,
    modulo: o.modulos.find(e => e.id === a.id) ?? a
  };
}
function nE(e, t) {
  let n = ih(t);
  return {
    cena: Gm({
      modulos: e.modulos,
      componentes: e.componentes ?? [],
      comodo: n.comodo,
      cenario: n.cena.cenario
    }, n.nicho),
    nicho: n.nicho,
    comodo: n.comodo
  };
}
function rE(e, t, n) {
  let r = {
    ...t,
    ...n
  };
  return {
    cena: {
      ...e,
      comodo: r
    },
    comodo: r
  };
}
function iE(e, t, n, r) {
  let i = bm(t, n, r);
  let a = Hm({
    ...e,
    componentes: [...(e.componentes ?? []), i]
  }, r, i.id);
  return {
    cena: a,
    componente: (a.componentes ?? []).find(e => e.id === i.id) ?? i
  };
}
function aE(e, t, n, r) {
  let i = (e.componentes ?? []).map(e => e.id === t ? {
    ...e,
    ...n
  } : e);
  let a = r ?? e.comodo ?? {
    largura: 3000,
    profundidade: 2400,
    altura: 2700,
    tipo: `outro`
  };
  return Hm({
    ...e,
    componentes: i
  }, a, t);
}
function oE(e, t) {
  return {
    ...e,
    componentes: (e.componentes ?? []).filter(e => e.id !== t)
  };
}
function sE(e, t) {
  let n = zT(t.preset).tipo;
  return {
    ...e,
    cenario: t,
    comodo: e.comodo ? {
      ...e.comodo,
      tipo: n
    } : e.comodo
  };
}
function cE(e) {
  return {
    ...e,
    modulos: [],
    componentes: []
  };
}
var lE = {
  type: `change`
};
var uE = {
  type: `start`
};
var dE = {
  type: `end`
};
var fE = new eb();
var pE = new jy();
var mE = Math.cos(x_.DEG2RAD * 70);
var hE = new X();
var gE = Math.PI * 2;
var _E = {
  NONE: -1,
  ROTATE: 0,
  DOLLY: 1,
  PAN: 2,
  TOUCH_ROTATE: 3,
  TOUCH_PAN: 4,
  TOUCH_DOLLY_PAN: 5,
  TOUCH_DOLLY_ROTATE: 6
};
var vE = 0.000001;
var yE = class extends _S {
  constructor(e, t = null) {
    super(e, t);
    this.state = _E.NONE;
    this.target = new X();
    this.cursor = new X();
    this.minDistance = 0;
    this.maxDistance = Infinity;
    this.minZoom = 0;
    this.maxZoom = Infinity;
    this.minTargetRadius = 0;
    this.maxTargetRadius = Infinity;
    this.minPolarAngle = 0;
    this.maxPolarAngle = Math.PI;
    this.minAzimuthAngle = -Infinity;
    this.maxAzimuthAngle = Infinity;
    this.enableDamping = false;
    this.dampingFactor = 0.05;
    this.enableZoom = true;
    this.zoomSpeed = 1;
    this.enableRotate = true;
    this.rotateSpeed = 1;
    this.keyRotateSpeed = 1;
    this.enablePan = true;
    this.panSpeed = 1;
    this.screenSpacePanning = true;
    this.keyPanSpeed = 7;
    this.zoomToCursor = false;
    this.autoRotate = false;
    this.autoRotateSpeed = 2;
    this.keys = {
      LEFT: `ArrowLeft`,
      UP: `ArrowUp`,
      RIGHT: `ArrowRight`,
      BOTTOM: `ArrowDown`
    };
    this.mouseButtons = {
      LEFT: ah.ROTATE,
      MIDDLE: ah.DOLLY,
      RIGHT: ah.PAN
    };
    this.touches = {
      ONE: oh.ROTATE,
      TWO: oh.DOLLY_PAN
    };
    this.target0 = this.target.clone();
    this.position0 = this.object.position.clone();
    this.zoom0 = this.object.zoom;
    this._cursorStyle = `auto`;
    this._domElementKeyEvents = null;
    this._lastPosition = new X();
    this._lastQuaternion = new C_();
    this._lastTargetPosition = new X();
    this._quat = new C_().setFromUnitVectors(e.up, new X(0, 1, 0));
    this._quatInverse = this._quat.clone().invert();
    this._spherical = new gS();
    this._sphericalDelta = new gS();
    this._scale = 1;
    this._panOffset = new X();
    this._rotateStart = new S_();
    this._rotateEnd = new S_();
    this._rotateDelta = new S_();
    this._panStart = new S_();
    this._panEnd = new S_();
    this._panDelta = new S_();
    this._dollyStart = new S_();
    this._dollyEnd = new S_();
    this._dollyDelta = new S_();
    this._dollyDirection = new X();
    this._mouse = new S_();
    this._performCursorZoom = false;
    this._pointers = [];
    this._pointerPositions = {};
    this._controlActive = false;
    this._onPointerMove = xE.bind(this);
    this._onPointerDown = bE.bind(this);
    this._onPointerUp = SE.bind(this);
    this._onContextMenu = kE.bind(this);
    this._onMouseWheel = TE.bind(this);
    this._onKeyDown = EE.bind(this);
    this._onTouchStart = DE.bind(this);
    this._onTouchMove = OE.bind(this);
    this._onMouseDown = CE.bind(this);
    this._onMouseMove = wE.bind(this);
    this._interceptControlDown = AE.bind(this);
    this._interceptControlUp = jE.bind(this);
    if (this.domElement !== null) {
      this.connect(this.domElement);
    }
    this.update();
  }
  set cursorStyle(e) {
    this._cursorStyle = e;
    if (e === `grab`) {
      this.domElement.style.cursor = `grab`;
    } else {
      this.domElement.style.cursor = `auto`;
    }
  }
  get cursorStyle() {
    return this._cursorStyle;
  }
  connect(e) {
    super.connect(e);
    this.domElement.addEventListener(`pointerdown`, this._onPointerDown);
    this.domElement.addEventListener(`pointercancel`, this._onPointerUp);
    this.domElement.addEventListener(`contextmenu`, this._onContextMenu);
    this.domElement.addEventListener(`wheel`, this._onMouseWheel, {
      passive: false
    });
    this.domElement.getRootNode().addEventListener(`keydown`, this._interceptControlDown, {
      passive: true,
      capture: true
    });
    this.domElement.style.touchAction = `none`;
  }
  disconnect() {
    this.state = _E.NONE;
    this.domElement.removeEventListener(`pointerdown`, this._onPointerDown);
    this.domElement.ownerDocument.removeEventListener(`pointermove`, this._onPointerMove);
    this.domElement.ownerDocument.removeEventListener(`pointerup`, this._onPointerUp);
    this.domElement.removeEventListener(`pointercancel`, this._onPointerUp);
    this.domElement.removeEventListener(`wheel`, this._onMouseWheel);
    this.domElement.removeEventListener(`contextmenu`, this._onContextMenu);
    this.stopListenToKeyEvents();
    let e = this.domElement.getRootNode();
    e.removeEventListener(`keydown`, this._interceptControlDown, {
      capture: true
    });
    e.removeEventListener(`keyup`, this._interceptControlUp, {
      capture: true
    });
    this._controlActive = false;
    this._pointers.length = 0;
    this._pointerPositions = {};
    this.domElement.style.touchAction = ``;
    this.domElement.style.cursor = `auto`;
  }
  dispose() {
    this.disconnect();
  }
  getPolarAngle() {
    return this._spherical.phi;
  }
  getAzimuthalAngle() {
    return this._spherical.theta;
  }
  getDistance() {
    return this.object.position.distanceTo(this.target);
  }
  listenToKeyEvents(e) {
    e.addEventListener(`keydown`, this._onKeyDown);
    this._domElementKeyEvents = e;
  }
  stopListenToKeyEvents() {
    if (this._domElementKeyEvents !== null) {
      this._domElementKeyEvents.removeEventListener(`keydown`, this._onKeyDown);
      this._domElementKeyEvents = null;
    }
  }
  saveState() {
    this.target0.copy(this.target);
    this.position0.copy(this.object.position);
    this.zoom0 = this.object.zoom;
  }
  reset() {
    this.target.copy(this.target0);
    this.object.position.copy(this.position0);
    this.object.zoom = this.zoom0;
    this.object.updateProjectionMatrix();
    this.dispatchEvent(lE);
    this.update();
    this.state = _E.NONE;
  }
  pan(e, t) {
    this._pan(e, t);
    this.update();
  }
  dollyIn(e) {
    this._dollyIn(e);
    this.update();
  }
  dollyOut(e) {
    this._dollyOut(e);
    this.update();
  }
  rotateLeft(e) {
    this._rotateLeft(e);
    this.update();
  }
  rotateUp(e) {
    this._rotateUp(e);
    this.update();
  }
  update(e = null) {
    let t = this.object.position;
    hE.copy(t).sub(this.target);
    hE.applyQuaternion(this._quat);
    this._spherical.setFromVector3(hE);
    if (this.autoRotate && this.state === _E.NONE) {
      this._rotateLeft(this._getAutoRotationAngle(e));
    }
    if (this.enableDamping) {
      this._spherical.theta += this._sphericalDelta.theta * this.dampingFactor;
      this._spherical.phi += this._sphericalDelta.phi * this.dampingFactor;
    } else {
      this._spherical.theta += this._sphericalDelta.theta;
      this._spherical.phi += this._sphericalDelta.phi;
    }
    let n = this.minAzimuthAngle;
    let r = this.maxAzimuthAngle;
    if (isFinite(n) && isFinite(r)) {
      if (n < -Math.PI) {
        n += gE;
      } else if (n > Math.PI) {
        n -= gE;
      }
      if (r < -Math.PI) {
        r += gE;
      } else if (r > Math.PI) {
        r -= gE;
      }
      if (n <= r) {
        this._spherical.theta = Math.max(n, Math.min(r, this._spherical.theta));
      } else {
        this._spherical.theta = this._spherical.theta > (n + r) / 2 ? Math.max(n, this._spherical.theta) : Math.min(r, this._spherical.theta);
      }
    }
    this._spherical.phi = Math.max(this.minPolarAngle, Math.min(this.maxPolarAngle, this._spherical.phi));
    this._spherical.makeSafe();
    if (this.enableDamping === true) {
      this.target.addScaledVector(this._panOffset, this.dampingFactor);
    } else {
      this.target.add(this._panOffset);
    }
    this.target.sub(this.cursor);
    this.target.clampLength(this.minTargetRadius, this.maxTargetRadius);
    this.target.add(this.cursor);
    let i = false;
    if (this.zoomToCursor && this._performCursorZoom || this.object.isOrthographicCamera) {
      this._spherical.radius = this._clampDistance(this._spherical.radius);
    } else {
      let e = this._spherical.radius;
      this._spherical.radius = this._clampDistance(this._spherical.radius * this._scale);
      i = e != this._spherical.radius;
    }
    hE.setFromSpherical(this._spherical);
    hE.applyQuaternion(this._quatInverse);
    t.copy(this.target).add(hE);
    this.object.lookAt(this.target);
    if (this.enableDamping === true) {
      this._sphericalDelta.theta *= 1 - this.dampingFactor;
      this._sphericalDelta.phi *= 1 - this.dampingFactor;
      this._panOffset.multiplyScalar(1 - this.dampingFactor);
    } else {
      this._sphericalDelta.set(0, 0, 0);
      this._panOffset.set(0, 0, 0);
    }
    if (this.zoomToCursor && this._performCursorZoom) {
      let e = null;
      if (this.object.isPerspectiveCamera) {
        let t = hE.length();
        e = this._clampDistance(t * this._scale);
        let n = t - e;
        this.object.position.addScaledVector(this._dollyDirection, n);
        this.object.updateMatrixWorld();
        i = !!n;
      } else if (this.object.isOrthographicCamera) {
        let t = new X(this._mouse.x, this._mouse.y, 0);
        t.unproject(this.object);
        let n = this.object.zoom;
        this.object.zoom = Math.max(this.minZoom, Math.min(this.maxZoom, this.object.zoom / this._scale));
        this.object.updateProjectionMatrix();
        i = n !== this.object.zoom;
        let r = new X(this._mouse.x, this._mouse.y, 0);
        r.unproject(this.object);
        this.object.position.sub(r).add(t);
        this.object.updateMatrixWorld();
        e = hE.length();
      } else {
        console.warn(`WARNING: OrbitControls.js encountered an unknown camera type - zoom to cursor disabled.`);
        this.zoomToCursor = false;
      }
      if (e !== null) {
        if (this.screenSpacePanning) {
          this.target.set(0, 0, -1).transformDirection(this.object.matrix).multiplyScalar(e).add(this.object.position);
        } else {
          fE.origin.copy(this.object.position);
          fE.direction.set(0, 0, -1).transformDirection(this.object.matrix);
          if (Math.abs(this.object.up.dot(fE.direction)) < mE) {
            this.object.lookAt(this.target);
          } else {
            pE.setFromNormalAndCoplanarPoint(this.object.up, this.target);
            fE.intersectPlane(pE, this.target);
          }
        }
      }
    } else if (this.object.isOrthographicCamera) {
      let e = this.object.zoom;
      this.object.zoom = Math.max(this.minZoom, Math.min(this.maxZoom, this.object.zoom / this._scale));
      if (e !== this.object.zoom) {
        this.object.updateProjectionMatrix();
        i = true;
      }
    }
    this._scale = 1;
    this._performCursorZoom = false;
    if (i || this._lastPosition.distanceToSquared(this.object.position) > vE || (1 - this._lastQuaternion.dot(this.object.quaternion)) * 8 > vE || this._lastTargetPosition.distanceToSquared(this.target) > vE) {
      this.dispatchEvent(lE);
      this._lastPosition.copy(this.object.position);
      this._lastQuaternion.copy(this.object.quaternion);
      this._lastTargetPosition.copy(this.target);
      return true;
    } else {
      return false;
    }
  }
  _getAutoRotationAngle(e) {
    if (e === null) {
      return gE / 60 / 60 * this.autoRotateSpeed;
    } else {
      return gE / 60 * this.autoRotateSpeed * e;
    }
  }
  _getZoomScale(e) {
    let t = Math.abs(e * 0.01);
    return 0.95 ** (this.zoomSpeed * t);
  }
  _rotateLeft(e) {
    this._sphericalDelta.theta -= e;
  }
  _rotateUp(e) {
    this._sphericalDelta.phi -= e;
  }
  _panLeft(e, t) {
    hE.setFromMatrixColumn(t, 0);
    hE.multiplyScalar(-e);
    this._panOffset.add(hE);
  }
  _panUp(e, t) {
    if (this.screenSpacePanning === true) {
      hE.setFromMatrixColumn(t, 1);
    } else {
      hE.setFromMatrixColumn(t, 0);
      hE.crossVectors(this.object.up, hE);
    }
    hE.multiplyScalar(e);
    this._panOffset.add(hE);
  }
  _pan(e, t) {
    let n = this.domElement;
    if (this.object.isPerspectiveCamera) {
      let r = this.object.position;
      hE.copy(r).sub(this.target);
      let i = hE.length();
      i *= Math.tan(this.object.fov / 2 * Math.PI / 180);
      this._panLeft(e * 2 * i / n.clientHeight, this.object.matrix);
      this._panUp(t * 2 * i / n.clientHeight, this.object.matrix);
    } else if (this.object.isOrthographicCamera) {
      this._panLeft(e * (this.object.right - this.object.left) / this.object.zoom / n.clientWidth, this.object.matrix);
      this._panUp(t * (this.object.top - this.object.bottom) / this.object.zoom / n.clientHeight, this.object.matrix);
    } else {
      console.warn(`WARNING: OrbitControls.js encountered an unknown camera type - pan disabled.`);
      this.enablePan = false;
    }
  }
  _dollyOut(e) {
    if (this.object.isPerspectiveCamera || this.object.isOrthographicCamera) {
      this._scale /= e;
    } else {
      console.warn(`WARNING: OrbitControls.js encountered an unknown camera type - dolly/zoom disabled.`);
      this.enableZoom = false;
    }
  }
  _dollyIn(e) {
    if (this.object.isPerspectiveCamera || this.object.isOrthographicCamera) {
      this._scale *= e;
    } else {
      console.warn(`WARNING: OrbitControls.js encountered an unknown camera type - dolly/zoom disabled.`);
      this.enableZoom = false;
    }
  }
  _updateZoomParameters(e, t) {
    if (!this.zoomToCursor) {
      return;
    }
    this._performCursorZoom = true;
    let n = this.domElement.getBoundingClientRect();
    let r = e - n.left;
    let i = t - n.top;
    let a = n.width;
    let o = n.height;
    this._mouse.x = r / a * 2 - 1;
    this._mouse.y = -(i / o) * 2 + 1;
    this._dollyDirection.set(this._mouse.x, this._mouse.y, 1).unproject(this.object).sub(this.object.position).normalize();
  }
  _clampDistance(e) {
    return Math.max(this.minDistance, Math.min(this.maxDistance, e));
  }
  _handleMouseDownRotate(e) {
    this._rotateStart.set(e.clientX, e.clientY);
  }
  _handleMouseDownDolly(e) {
    this._updateZoomParameters(e.clientX, e.clientX);
    this._dollyStart.set(e.clientX, e.clientY);
  }
  _handleMouseDownPan(e) {
    this._panStart.set(e.clientX, e.clientY);
  }
  _handleMouseMoveRotate(e) {
    this._rotateEnd.set(e.clientX, e.clientY);
    this._rotateDelta.subVectors(this._rotateEnd, this._rotateStart).multiplyScalar(this.rotateSpeed);
    let t = this.domElement;
    this._rotateLeft(gE * this._rotateDelta.x / t.clientHeight);
    this._rotateUp(gE * this._rotateDelta.y / t.clientHeight);
    this._rotateStart.copy(this._rotateEnd);
    this.update();
  }
  _handleMouseMoveDolly(e) {
    this._dollyEnd.set(e.clientX, e.clientY);
    this._dollyDelta.subVectors(this._dollyEnd, this._dollyStart);
    if (this._dollyDelta.y > 0) {
      this._dollyOut(this._getZoomScale(this._dollyDelta.y));
    } else if (this._dollyDelta.y < 0) {
      this._dollyIn(this._getZoomScale(this._dollyDelta.y));
    }
    this._dollyStart.copy(this._dollyEnd);
    this.update();
  }
  _handleMouseMovePan(e) {
    this._panEnd.set(e.clientX, e.clientY);
    this._panDelta.subVectors(this._panEnd, this._panStart).multiplyScalar(this.panSpeed);
    this._pan(this._panDelta.x, this._panDelta.y);
    this._panStart.copy(this._panEnd);
    this.update();
  }
  _handleMouseWheel(e) {
    this._updateZoomParameters(e.clientX, e.clientY);
    if (e.deltaY < 0) {
      this._dollyIn(this._getZoomScale(e.deltaY));
    } else if (e.deltaY > 0) {
      this._dollyOut(this._getZoomScale(e.deltaY));
    }
    this.update();
  }
  _handleKeyDown(e) {
    let t = false;
    switch (e.code) {
      case this.keys.UP:
        if (e.ctrlKey || e.metaKey || e.shiftKey) {
          if (this.enableRotate) {
            this._rotateUp(gE * this.keyRotateSpeed / this.domElement.clientHeight);
          }
        } else if (this.enablePan) {
          this._pan(0, this.keyPanSpeed);
        }
        t = true;
        break;
      case this.keys.BOTTOM:
        if (e.ctrlKey || e.metaKey || e.shiftKey) {
          if (this.enableRotate) {
            this._rotateUp(-gE * this.keyRotateSpeed / this.domElement.clientHeight);
          }
        } else if (this.enablePan) {
          this._pan(0, -this.keyPanSpeed);
        }
        t = true;
        break;
      case this.keys.LEFT:
        if (e.ctrlKey || e.metaKey || e.shiftKey) {
          if (this.enableRotate) {
            this._rotateLeft(gE * this.keyRotateSpeed / this.domElement.clientHeight);
          }
        } else if (this.enablePan) {
          this._pan(this.keyPanSpeed, 0);
        }
        t = true;
        break;
      case this.keys.RIGHT:
        if (e.ctrlKey || e.metaKey || e.shiftKey) {
          if (this.enableRotate) {
            this._rotateLeft(-gE * this.keyRotateSpeed / this.domElement.clientHeight);
          }
        } else if (this.enablePan) {
          this._pan(-this.keyPanSpeed, 0);
        }
        t = true;
    }
    if (t) {
      e.preventDefault();
      this.update();
    }
  }
  _handleTouchStartRotate(e) {
    if (this._pointers.length === 1) {
      this._rotateStart.set(e.pageX, e.pageY);
    } else {
      let t = this._getSecondPointerPosition(e);
      let n = (e.pageX + t.x) * 0.5;
      let r = (e.pageY + t.y) * 0.5;
      this._rotateStart.set(n, r);
    }
  }
  _handleTouchStartPan(e) {
    if (this._pointers.length === 1) {
      this._panStart.set(e.pageX, e.pageY);
    } else {
      let t = this._getSecondPointerPosition(e);
      let n = (e.pageX + t.x) * 0.5;
      let r = (e.pageY + t.y) * 0.5;
      this._panStart.set(n, r);
    }
  }
  _handleTouchStartDolly(e) {
    let t = this._getSecondPointerPosition(e);
    let n = e.pageX - t.x;
    let r = e.pageY - t.y;
    let i = Math.sqrt(n * n + r * r);
    this._dollyStart.set(0, i);
  }
  _handleTouchStartDollyPan(e) {
    if (this.enableZoom) {
      this._handleTouchStartDolly(e);
    }
    if (this.enablePan) {
      this._handleTouchStartPan(e);
    }
  }
  _handleTouchStartDollyRotate(e) {
    if (this.enableZoom) {
      this._handleTouchStartDolly(e);
    }
    if (this.enableRotate) {
      this._handleTouchStartRotate(e);
    }
  }
  _handleTouchMoveRotate(e) {
    if (this._pointers.length == 1) {
      this._rotateEnd.set(e.pageX, e.pageY);
    } else {
      let t = this._getSecondPointerPosition(e);
      let n = (e.pageX + t.x) * 0.5;
      let r = (e.pageY + t.y) * 0.5;
      this._rotateEnd.set(n, r);
    }
    this._rotateDelta.subVectors(this._rotateEnd, this._rotateStart).multiplyScalar(this.rotateSpeed);
    let t = this.domElement;
    this._rotateLeft(gE * this._rotateDelta.x / t.clientHeight);
    this._rotateUp(gE * this._rotateDelta.y / t.clientHeight);
    this._rotateStart.copy(this._rotateEnd);
  }
  _handleTouchMovePan(e) {
    if (this._pointers.length === 1) {
      this._panEnd.set(e.pageX, e.pageY);
    } else {
      let t = this._getSecondPointerPosition(e);
      let n = (e.pageX + t.x) * 0.5;
      let r = (e.pageY + t.y) * 0.5;
      this._panEnd.set(n, r);
    }
    this._panDelta.subVectors(this._panEnd, this._panStart).multiplyScalar(this.panSpeed);
    this._pan(this._panDelta.x, this._panDelta.y);
    this._panStart.copy(this._panEnd);
  }
  _handleTouchMoveDolly(e) {
    let t = this._getSecondPointerPosition(e);
    let n = e.pageX - t.x;
    let r = e.pageY - t.y;
    let i = Math.sqrt(n * n + r * r);
    this._dollyEnd.set(0, i);
    this._dollyDelta.set(0, (this._dollyEnd.y / this._dollyStart.y) ** +this.zoomSpeed);
    this._dollyOut(this._dollyDelta.y);
    this._dollyStart.copy(this._dollyEnd);
    let a = (e.pageX + t.x) * 0.5;
    let o = (e.pageY + t.y) * 0.5;
    this._updateZoomParameters(a, o);
  }
  _handleTouchMoveDollyPan(e) {
    if (this.enableZoom) {
      this._handleTouchMoveDolly(e);
    }
    if (this.enablePan) {
      this._handleTouchMovePan(e);
    }
  }
  _handleTouchMoveDollyRotate(e) {
    if (this.enableZoom) {
      this._handleTouchMoveDolly(e);
    }
    if (this.enableRotate) {
      this._handleTouchMoveRotate(e);
    }
  }
  _addPointer(e) {
    this._pointers.push(e.pointerId);
  }
  _removePointer(e) {
    delete this._pointerPositions[e.pointerId];
    for (let t = 0; t < this._pointers.length; t++) {
      if (this._pointers[t] == e.pointerId) {
        this._pointers.splice(t, 1);
        return;
      }
    }
  }
  _isTrackingPointer(e) {
    for (let t = 0; t < this._pointers.length; t++) {
      if (this._pointers[t] == e.pointerId) {
        return true;
      }
    }
    return false;
  }
  _trackPointer(e) {
    let t = this._pointerPositions[e.pointerId];
    if (t === undefined) {
      t = new S_();
      this._pointerPositions[e.pointerId] = t;
    }
    t.set(e.pageX, e.pageY);
  }
  _getSecondPointerPosition(e) {
    let t = e.pointerId === this._pointers[0] ? this._pointers[1] : this._pointers[0];
    return this._pointerPositions[t];
  }
  _customWheelEvent(e) {
    let t = e.deltaMode;
    let n = {
      clientX: e.clientX,
      clientY: e.clientY,
      deltaY: e.deltaY
    };
    switch (t) {
      case 1:
        n.deltaY *= 16;
        break;
      case 2:
        n.deltaY *= 100;
    }
    if (e.ctrlKey && !this._controlActive) {
      n.deltaY *= 10;
    }
    return n;
  }
};
function bE(e) {
  if (this.enabled !== false) {
    if (this._pointers.length === 0) {
      this.domElement.setPointerCapture(e.pointerId);
      this.domElement.ownerDocument.addEventListener(`pointermove`, this._onPointerMove);
      this.domElement.ownerDocument.addEventListener(`pointerup`, this._onPointerUp);
    }
    if (!this._isTrackingPointer(e)) {
      this._addPointer(e);
      if (e.pointerType === `touch`) {
        this._onTouchStart(e);
      } else {
        this._onMouseDown(e);
      }
      if (this._cursorStyle === `grab`) {
        this.domElement.style.cursor = `grabbing`;
      }
    }
  }
}
function xE(e) {
  if (this.enabled !== false) {
    if (e.pointerType === `touch`) {
      this._onTouchMove(e);
    } else {
      this._onMouseMove(e);
    }
  }
}
function SE(e) {
  this._removePointer(e);
  switch (this._pointers.length) {
    case 0:
      this.domElement.releasePointerCapture(e.pointerId);
      this.domElement.ownerDocument.removeEventListener(`pointermove`, this._onPointerMove);
      this.domElement.ownerDocument.removeEventListener(`pointerup`, this._onPointerUp);
      this.dispatchEvent(dE);
      this.state = _E.NONE;
      if (this._cursorStyle === `grab`) {
        this.domElement.style.cursor = `grab`;
      }
      break;
    case 1:
      let t = this._pointers[0];
      let n = this._pointerPositions[t];
      this._onTouchStart({
        pointerId: t,
        pageX: n.x,
        pageY: n.y
      });
  }
}
function CE(e) {
  let t;
  switch (e.button) {
    case 0:
      t = this.mouseButtons.LEFT;
      break;
    case 1:
      t = this.mouseButtons.MIDDLE;
      break;
    case 2:
      t = this.mouseButtons.RIGHT;
      break;
    default:
      t = -1;
  }
  switch (t) {
    case ah.DOLLY:
      if (this.enableZoom === false) {
        return;
      }
      this._handleMouseDownDolly(e);
      this.state = _E.DOLLY;
      break;
    case ah.ROTATE:
      if (e.ctrlKey || e.metaKey || e.shiftKey) {
        if (this.enablePan === false) {
          return;
        }
        this._handleMouseDownPan(e);
        this.state = _E.PAN;
      } else {
        if (this.enableRotate === false) {
          return;
        }
        this._handleMouseDownRotate(e);
        this.state = _E.ROTATE;
      }
      break;
    case ah.PAN:
      if (e.ctrlKey || e.metaKey || e.shiftKey) {
        if (this.enableRotate === false) {
          return;
        }
        this._handleMouseDownRotate(e);
        this.state = _E.ROTATE;
      } else {
        if (this.enablePan === false) {
          return;
        }
        this._handleMouseDownPan(e);
        this.state = _E.PAN;
      }
      break;
    default:
      this.state = _E.NONE;
  }
  if (this.state !== _E.NONE) {
    this.dispatchEvent(uE);
  }
}
function wE(e) {
  switch (this.state) {
    case _E.ROTATE:
      if (this.enableRotate === false) {
        return;
      }
      this._handleMouseMoveRotate(e);
      break;
    case _E.DOLLY:
      if (this.enableZoom === false) {
        return;
      }
      this._handleMouseMoveDolly(e);
      break;
    case _E.PAN:
      if (this.enablePan === false) {
        return;
      }
      this._handleMouseMovePan(e);
  }
}
function TE(e) {
  if (this.enabled !== false && this.enableZoom !== false && this.state === _E.NONE) {
    e.preventDefault();
    this.dispatchEvent(uE);
    this._handleMouseWheel(this._customWheelEvent(e));
    this.dispatchEvent(dE);
  }
}
function EE(e) {
  if (this.enabled !== false) {
    this._handleKeyDown(e);
  }
}
function DE(e) {
  this._trackPointer(e);
  switch (this._pointers.length) {
    case 1:
      switch (this.touches.ONE) {
        case oh.ROTATE:
          if (this.enableRotate === false) {
            return;
          }
          this._handleTouchStartRotate(e);
          this.state = _E.TOUCH_ROTATE;
          break;
        case oh.PAN:
          if (this.enablePan === false) {
            return;
          }
          this._handleTouchStartPan(e);
          this.state = _E.TOUCH_PAN;
          break;
        default:
          this.state = _E.NONE;
      }
      break;
    case 2:
      switch (this.touches.TWO) {
        case oh.DOLLY_PAN:
          if (this.enableZoom === false && this.enablePan === false) {
            return;
          }
          this._handleTouchStartDollyPan(e);
          this.state = _E.TOUCH_DOLLY_PAN;
          break;
        case oh.DOLLY_ROTATE:
          if (this.enableZoom === false && this.enableRotate === false) {
            return;
          }
          this._handleTouchStartDollyRotate(e);
          this.state = _E.TOUCH_DOLLY_ROTATE;
          break;
        default:
          this.state = _E.NONE;
      }
      break;
    default:
      this.state = _E.NONE;
  }
  if (this.state !== _E.NONE) {
    this.dispatchEvent(uE);
  }
}
function OE(e) {
  this._trackPointer(e);
  switch (this.state) {
    case _E.TOUCH_ROTATE:
      if (this.enableRotate === false) {
        return;
      }
      this._handleTouchMoveRotate(e);
      this.update();
      break;
    case _E.TOUCH_PAN:
      if (this.enablePan === false) {
        return;
      }
      this._handleTouchMovePan(e);
      this.update();
      break;
    case _E.TOUCH_DOLLY_PAN:
      if (this.enableZoom === false && this.enablePan === false) {
        return;
      }
      this._handleTouchMoveDollyPan(e);
      this.update();
      break;
    case _E.TOUCH_DOLLY_ROTATE:
      if (this.enableZoom === false && this.enableRotate === false) {
        return;
      }
      this._handleTouchMoveDollyRotate(e);
      this.update();
      break;
    default:
      this.state = _E.NONE;
  }
}
function kE(e) {
  if (this.enabled !== false) {
    e.preventDefault();
  }
}
function AE(e) {
  if (e.key === `Control`) {
    this._controlActive = true;
    this.domElement.getRootNode().addEventListener(`keyup`, this._interceptControlUp, {
      passive: true,
      capture: true
    });
  }
}
function jE(e) {
  if (e.key === `Control`) {
    this._controlActive = false;
    this.domElement.getRootNode().removeEventListener(`keyup`, this._interceptControlUp, {
      passive: true,
      capture: true
    });
  }
}
var ME = null;
function NE(e) {
  ME = e;
}
function PE() {
  return ME;
}
var Q = 0.001;
function FE(e, t, n) {
  let r = typeof t.z == `number` && Number.isFinite(t.z) ? t.z * Q : t.profundidade * Q / 2;
  let i = x_.degToRad(t.rotacao ?? 0);
  e.rotation.y = i;
  e.position.set(t.x * Q, t.y * Q, r);
}
function IE(e, t) {
  let n = new xv();
  let r = e.largura * Q;
  let i = e.altura * Q;
  let a = e.profundidade * Q;
  let o = new ix({
    color: t ? 15000286 : 16579577,
    roughness: 0.35,
    metalness: 0.02
  });
  let s = new ix({
    color: t ? 15592424 : 16777215,
    roughness: 0.12,
    metalness: 0.05
  });
  let c = new ix({
    color: 12896462,
    roughness: 0.22,
    metalness: 0.88
  });
  let l = new ix({
    color: 13817822,
    roughness: 0.18,
    metalness: 0.94
  });
  let u = new ix({
    color: 16119802,
    roughness: 0.06,
    metalness: 0.98
  });
  let d = new ix({
    color: 1974566,
    roughness: 0.65,
    metalness: 0.2
  });
  let f = new ix({
    color: 14348021,
    roughness: 0.03,
    metalness: 0.1,
    transparent: true,
    opacity: 0.35,
    side: 2
  });
  let p = new ix({
    color: 2238512,
    roughness: 0.08,
    metalness: 0.2,
    transparent: true,
    opacity: 0.75,
    side: 2
  });
  let m = new ix({
    color: 15265266,
    roughness: 0.02,
    metalness: 0.96
  });
  let h = new ix({
    color: 7227949,
    roughness: 0.5,
    metalness: 0.02
  });
  let g = new ix({
    color: 15592424,
    roughness: 0.18,
    metalness: 0.05
  });
  let _ = new ix({
    color: 16448508,
    roughness: 0.14,
    metalness: 0.02
  });
  let v = new ix({
    color: t ? 10393224 : 14209734,
    roughness: 0.92,
    metalness: 0,
    side: 2
  });
  let y = new ix({
    color: t ? 5919820 : 8156005,
    roughness: 0.9,
    metalness: 0,
    side: 2
  });
  let b = new ix({
    color: 790034,
    roughness: 0.1,
    metalness: 0.6
  });
  let x = new ix({
    color: 6809849,
    emissive: 3718648,
    emissiveIntensity: 0.6,
    roughness: 0.2
  });
  function S(e, t, n, r, i = 0, a = 0, o = 0) {
    let s = new pb(new zb(t, n, r), e);
    s.position.set(i, a, o);
    s.castShadow = true;
    s.receiveShadow = true;
    return s;
  }
  function C(e, t, n, r, i = 24) {
    let a = new pb(new Bb(e, t, n, i), r);
    a.castShadow = true;
    a.receiveShadow = true;
    return a;
  }
  switch (e.tipo) {
    case `porta`:
      {
        let e = Q * 65;
        let t = Q * 14;
        let s = a * 0.45;
        let d = S(h, e, i, a, -r / 2 + e / 2, 0, 0);
        let f = S(h, e, i, a, r / 2 - e / 2, 0, 0);
        let p = S(h, r - e * 2, e, a, 0, i / 2 - e / 2, 0);
        let m = S(h, t, i, t, -r / 2 - t / 2, 0, a / 2 + t / 2);
        let g = S(h, t, i, t, r / 2 + t / 2, 0, a / 2 + t / 2);
        let _ = S(h, r + t * 2, t, t, 0, i / 2 + t / 2, a / 2 + t / 2);
        let v = S(o, r - e * 2 - Q * 6, i - e - Q * 10, s, 0, -0.0275, 0);
        let y = [];
        for (let t = -2; t <= 2; t++) {
          let n = S(c, (r - e * 2) * 0.75, Q * 4, s + Q * 2, 0, i * 0.14 * t - e / 2, 0);
          y.push(n);
        }
        let b = -i / 2 + Q * 1000;
        let x = r / 2 - e - Q * 55;
        let w = C(Q * 24, Q * 24, Q * 4, l);
        w.rotation.x = Math.PI / 2;
        w.position.set(x, b, a / 2 + Q * 2);
        let T = C(Q * 8, Q * 8, Q * 28, u);
        T.rotation.x = Math.PI / 2;
        T.position.set(x, b, a / 2 + Q * 16);
        let E = S(u, Q * 110, Q * 14, Q * 8, x - Q * 45, b, a / 2 + Q * 30);
        let D = C(Q * 24, Q * 24, Q * 4, l);
        D.rotation.x = Math.PI / 2;
        D.position.set(x, b, -a / 2 - Q * 2);
        let O = C(Q * 8, Q * 8, Q * 28, u);
        O.rotation.x = Math.PI / 2;
        O.position.set(x, b, -a / 2 - Q * 16);
        let k = S(u, Q * 110, Q * 14, Q * 8, x - Q * 45, b, -a / 2 - Q * 30);
        let A = [];
        for (let t of [-i * 0.35, 0, i * 0.35]) {
          let n = C(Q * 7, Q * 7, Q * 70, l);
          n.position.set(-r / 2 + e + Q * 2, t, a / 2);
          A.push(n);
        }
        n.add(d, f, p, m, g, _, v, ...y, w, T, E, D, O, k, ...A);
        break;
      }
    case `janela`:
      {
        let e = Q * 60;
        let t = Q * 38;
        let s = Q * 24;
        let u = Q * 35;
        let d = S(o, r, e, a, 0, i / 2 - e / 2, 0);
        let p = S(o, r, e, a, 0, -i / 2 + e / 2, 0);
        let m = S(o, e, i, a, -r / 2 + e / 2, 0, 0);
        let h = S(o, e, i, a, r / 2 - e / 2, 0, 0);
        let _ = S(g, r + Q * 40, s, a + u, 0, -i / 2 - s / 2, u / 2);
        let v = (r - e * 2) / 2 + Q * 15;
        let y = i - e * 2;
        let b = -a * 0.16;
        let x = a * 0.16;
        let C = S(c, v, y, a * 0.32, -r / 4 + Q * 7.5, 0, b);
        let w = new pb(new Kb(v - t * 2, y - t * 2), f);
        w.position.set(-r / 4 + Q * 7.5, 0, b);
        let T = S(c, v, y, a * 0.32, r / 4 - Q * 7.5, 0, x);
        let E = new pb(new Kb(v - t * 2, y - t * 2), f);
        E.position.set(r / 4 - Q * 7.5, 0, x);
        let D = S(l, Q * 18, Q * 80, Q * 6, -r / 4 + v / 2 - Q * 10, 0, b + a * 0.17);
        let O = S(l, Q * 18, Q * 80, Q * 6, r / 4 - v / 2 + Q * 10, 0, x + a * 0.17);
        n.add(d, p, m, h, _, C, w, T, E, D, O);
        break;
      }
    case `tomada`:
      {
        let e = S(s, r, i, Q * 8, 0, 0, 0);
        let t = S(o, r * 0.65, i * 0.72, Q * 3, 0, 0, 0.0055);
        let a = [];
        for (let e of [-i * 0.22, i * 0.22]) {
          let t = new pb(new Bb(Q * 14, Q * 14, Q * 3, 6), d);
          t.rotation.x = Math.PI / 2;
          t.position.set(0, e, 0.006);
          for (let t of [Q * -5, 0, Q * 5]) {
            let n = C(Q * 2, Q * 2, Q * 4, d, 12);
            n.rotation.x = Math.PI / 2;
            n.position.set(t === 0 ? Q * 3 : Q * -3, e + t, 0.007);
            a.push(n);
          }
          a.push(t);
        }
        n.add(e, t, ...a);
        break;
      }
    case `interruptor`:
      {
        let e = S(s, r, i, Q * 8, 0, 0, 0);
        let t = S(o, r * 0.65, i * 0.72, Q * 3, 0, 0, 0.0055);
        let a = S(s, r * 0.45, i * 0.28, Q * 5, 0, i * 0.17, 0.007);
        let c = S(s, r * 0.45, i * 0.28, Q * 5, 0, -i * 0.17, 0.007);
        let l = S(d, r * 0.45, Q * 1.5, Q * 5.5, 0, 0, 0.007);
        n.add(e, t, a, c, l);
        break;
      }
    case `ponto_rede`:
      {
        let e = S(s, r, i, Q * 8, 0, 0, 0);
        let t = S(o, r * 0.65, i * 0.72, Q * 3, 0, 0, 0.0055);
        let a = [];
        for (let e of [-i * 0.2, i * 0.2]) {
          let t = S(d, Q * 16, Q * 14, Q * 4, 0, e, 0.006);
          let n = S(c, Q * 10, Q * 3, Q * 4.5, 0, e - Q * 4, 0.006500000000000001);
          a.push(t, n);
        }
        n.add(e, t, ...a);
        break;
      }
    case `torneira`:
      {
        let e = Q * 24;
        let t = -a / 2 + Q * 40;
        let r = -i / 2;
        let o = C(0.026000000000000002, 0.026000000000000002, Q * 4, d);
        o.position.set(0, r + Q * 2, t);
        let s = C(e, e * 0.9, Q * 45, u);
        s.position.set(0, r + Q * 25, t);
        let f = C(Q * 10, Q * 10, Q * 22, u);
        f.rotation.z = Math.PI / 2;
        f.position.set(Q * 20, r + Q * 35, t);
        let p = S(u, Q * 6, Q * 60, Q * 10, Q * 32, r + Q * 55, t);
        p.rotation.z = -0.25;
        let m = C(Q * 14, Q * 14, i * 0.45, u);
        m.position.set(0, r + i * 0.25, t);
        let h = (a - Q * 70) / 2;
        let g = new pb(new qb(h, Q * 10, 16, 24, Math.PI), u);
        g.rotation.y = Math.PI / 2;
        g.position.set(0, r + i * 0.5 + h, t + h);
        let _ = new pb(new qb(h, Q * 14, 12, 32, Math.PI * 0.9), c);
        _.rotation.y = Math.PI / 2;
        _.position.set(0, r + i * 0.5 + h, t + h);
        let v = S(u, Q * 12, Q * 12, a * 0.65, 0, r + i * 0.42, t + a * 0.32);
        let y = t + h * 2;
        let b = r + i * 0.5 + h - Q * 60;
        let x = C(Q * 16, Q * 20, Q * 65, u);
        x.position.set(0, b, y);
        let w = C(Q * 21, Q * 21, Q * 10, d);
        w.position.set(0, b - Q * 15, y);
        let T = C(Q * 18, Q * 18, Q * 4, l);
        T.position.set(0, b - Q * 33, y);
        n.add(o, s, f, p, m, g, _, v, x, w, T);
        break;
      }
    case `cuba`:
      {
        let e = Q * 26;
        let t = Q * 6;
        let o = Q * 6;
        let s = i - o;
        let c = i / 2 - o / 2;
        let f = S(l, r, o, e, 0, c, a / 2 - e / 2);
        let p = S(l, r, o, e, 0, c, -a / 2 + e / 2);
        let m = S(l, e, o, a - e * 2, -r / 2 + e / 2, c, 0);
        let h = S(l, e, o, a - e * 2, r / 2 - e / 2, c, 0);
        let g = r - e * 2;
        let _ = a - e * 2;
        let v = -i / 2 + s / 2;
        let y = S(l, t, s, _, -g / 2 + t / 2, v, 0);
        let b = S(l, t, s, _, g / 2 - t / 2, v, 0);
        let x = S(l, g, s, t, 0, v, -_ / 2 + t / 2);
        let w = S(l, g, s, t, 0, v, _ / 2 - t / 2);
        let T = -i / 2 + t / 2;
        let E = S(l, g - t * 2, t, _ - t * 2, 0, T, 0);
        let D = Math.min(g, _) * 0.15;
        let O = C(D, D, Q * 3, u);
        O.position.set(0, T + Q * 2, 0);
        let k = C(D * 0.78, D * 0.78, Q * 4, d);
        k.position.set(0, T + Q * 2.5, 0);
        let A = C(D * 0.65, D * 0.6, Q * 2, l);
        A.position.set(0, T + Q * 3.5, 0);
        let ee = C(Q * 4, Q * 4, Q * 10, u);
        ee.position.set(0, T + Q * 7, 0);
        let te = S(u, Q * 60, Q * 8, Q * 2, 0, c - Q * 35, -_ / 2 + t + Q * 1);
        n.add(f, p, m, h, y, b, x, w, E, O, k, A, ee, te);
        break;
      }
    case `coifa`:
      {
        let e = i * 0.52;
        let t = i * 0.48;
        let o = a * 0.48;
        let s = S(l, r * 0.38, e, o, 0, i / 2 - e / 2, -a / 2 + o / 2);
        let f = S(l, r, t * 0.3, a, 0, -i / 2 + t * 0.3 / 2, 0);
        let p = S(l, r * 0.75, t * 0.7, a * 0.75, 0, -i / 2 + t * 0.65, -a * 0.08);
        let m = S(c, r * 0.42, Q * 6, a * 0.78, -r * 0.23, -i / 2 + Q * 3, 0);
        let h = S(c, r * 0.42, Q * 6, a * 0.78, r * 0.23, -i / 2 + Q * 3, 0);
        let g = S(d, r * 0.5, Q * 22, Q * 4, 0, -i / 2 + t * 0.3 / 2, a / 2 + Q * 2);
        let _ = S(x, Q * 35, Q * 8, Q * 5, 0, -i / 2 + t * 0.3 / 2, a / 2 + Q * 2.5);
        let v = C(Q * 16, Q * 16, Q * 4, u);
        v.position.set(-r * 0.35, -i / 2 + Q * 2, a * 0.35);
        let y = C(Q * 16, Q * 16, Q * 4, u);
        y.position.set(r * 0.35, -i / 2 + Q * 2, a * 0.35);
        n.add(s, f, p, m, h, g, _, v, y);
        break;
      }
    case `fogao`:
      {
        let e = Q * 12;
        let t = i * 0.45;
        let o = Q * 24;
        let s = -i / 2 + t / 2 + i * 0.06;
        let f = S(l, r, i - e, a - Q * 10, 0, -0.012 / 2, Q * -5);
        let m = S(d, r, e, a, 0, i / 2 - e / 2, 0);
        let h = [];
        for (let e of [-1, 1]) {
          for (let t of [-1, 1]) {
            let n = e * r * 0.24;
            let o = t * a * 0.23;
            let s = C(Q * 35, Q * 40, Q * 8, c);
            s.position.set(n, i / 2 + Q * 4, o);
            let l = C(Q * 28, Q * 28, Q * 5, d);
            l.position.set(n, i / 2 + Q * 10, o);
            let u = S(d, Q * 110, Q * 8, Q * 14, n, i / 2 + Q * 14, o);
            let f = S(d, Q * 14, Q * 8, Q * 110, n, i / 2 + Q * 14, o);
            h.push(s, l, u, f);
          }
        }
        let g = S(l, r, Q * 65, Q * 10, 0, i / 2 - e - Q * 35, a / 2 + Q * 5);
        let _ = [];
        for (let t = -2; t <= 2; t++) {
          let n = C(Q * 16, Q * 16, Q * 14, u);
          n.rotation.x = Math.PI / 2;
          n.position.set(r * 0.18 * t, i / 2 - e - Q * 35, a / 2 + Q * 17);
          _.push(n);
        }
        let v = S(d, r * 0.88, t, o, 0, s, a / 2 + o / 2);
        let y = new pb(new Kb(r * 0.65, t * 0.6), p);
        y.position.set(0, s, a / 2 + o + Q * 1);
        let b = S(u, r * 0.72, Q * 18, Q * 26, 0, s + t / 2 - Q * 25, a / 2 + o + Q * 22);
        n.add(f, m, ...h, g, ..._, v, y, b);
        break;
      }
    case `geladeira`:
      {
        let e = a * 0.08;
        let t = i * 0.28;
        let o = i * 0.62;
        let s = -i / 2 + t / 2 + i * 0.04;
        let c = i / 2 - o / 2 - Q * 12;
        let u = S(l, r, i, a - e, 0, 0, -e / 2);
        let f = (r - Q * 10) / 2;
        let p = S(l, f, o, e, -r / 4, c, a / 2 - e / 2);
        let m = S(l, f, o, e, r / 4, c, a / 2 - e / 2);
        let h = S(l, r - Q * 8, t, e, 0, s, a / 2 - e / 2);
        let g = S(d, Q * 12, o * 0.8, Q * 14, Q * -6, c, a / 2 + Q * 2);
        let _ = S(d, Q * 12, o * 0.8, Q * 14, Q * 6, c, a / 2 + Q * 2);
        let v = S(d, r * 0.6, Q * 14, Q * 14, 0, s + t / 2 - Q * 15, a / 2 + Q * 2);
        let y = S(d, f * 0.65, Q * 140, Q * 18, -r / 4, c - Q * 20, a / 2 - e / 2 + Q * 6);
        let b = S(x, Q * 40, Q * 14, Q * 4, -r / 4, c + Q * 40, a / 2 + Q * 1);
        let C = S(d, r * 0.94, i * 0.04, a * 0.85, 0, -i / 2 + i * 0.04 / 2, 0);
        n.add(u, p, m, h, g, _, v, y, b, C);
        break;
      }
    case `ar_condicionado`:
      {
        let e = S(s, r, i, a, 0, 0, 0);
        let t = S(d, r * 0.88, Q * 12, a * 0.7, 0, i / 2 - Q * 6, 0);
        let c = S(o, r * 0.92, Q * 28, Q * 16, 0, -i / 2 + Q * 16, a / 2);
        let l = S(u, r * 0.96, Q * 4, Q * 4, 0, -i * 0.22, a / 2 + Q * 2);
        let f = S(x, Q * 45, Q * 18, Q * 3, r * 0.3, 0, a / 2 + Q * 2);
        n.add(e, t, c, l, f);
        break;
      }
    case `espelho`:
      {
        let e = S(c, r, i, a, 0, 0, 0);
        let t = new pb(new Kb(r - Q * 20, i - Q * 20), m);
        t.position.set(0, 0, a / 2 + Q * 1);
        let o = S(f, r - Q * 16, i - Q * 16, Q * 2, 0, 0, a / 2 + Q * 0.5);
        n.add(e, t, o);
        break;
      }
    case `tv`:
      {
        let e = S(d, r, i, a * 0.25, 0, 0, -a * 0.1);
        let t = new pb(new Kb(r - Q * 18, i - Q * 18), b);
        t.position.set(0, 0, a * 0.05 + Q * 1);
        let o = S(l, r, Q * 12, a * 0.3, 0, -i / 2 + Q * 6, 0);
        let s = C(Q * 2, Q * 2, Q * 3, x, 8);
        s.rotation.x = Math.PI / 2;
        s.position.set(0, -i / 2 + Q * 6, a * 0.16);
        let c = S(l, r * 0.42, Q * 10, a * 0.75, 0, -i / 2 - Q * 10, 0);
        let u = S(l, Q * 70, Q * 40, Q * 30, 0, -i / 2 - Q * 5, -a * 0.1);
        n.add(e, t, o, s, c, u);
        break;
      }
    case `vaso`:
      {
        let e = i * 0.45;
        let t = a * 0.28;
        let o = r * 0.88;
        let c = a * 0.68;
        let l = i * 0.52;
        let d = -a / 2 + t / 2;
        let f = S(_, r, e, t, 0, i / 2 - e / 2, d);
        let p = S(_, r * 1.02, Q * 18, t * 1.04, 0, i / 2 + Q * 9, d);
        let m = C(Q * 16, Q * 16, Q * 6, u);
        m.position.set(0, i / 2 + Q * 20, d);
        let h = a / 2 - c / 2;
        let g = -i / 2 + l / 2;
        let v = S(_, o * 0.6, l, c * 0.7, 0, g, h - c * 0.1);
        let y = new pb(new Bb(o / 2, o / 2.3, l * 0.75, 32), _);
        y.scale.z = c / o;
        y.position.set(0, -i / 2 + l * 0.62, h);
        let b = new pb(new Bb(o / 2, o / 2, Q * 14, 32), s);
        b.scale.z = c / o;
        b.position.set(0, -i / 2 + l + Q * 7, h);
        let x = new pb(new Bb(o / 2.04, o / 2.04, Q * 12, 32), s);
        x.scale.z = c / o;
        x.position.set(0, -i / 2 + l + Q * 20, h);
        n.add(f, p, m, v, y, b, x);
        break;
      }
    case `box`:
      {
        let e = Q * 35;
        let t = Q * 45;
        let a = r / 2 + Q * 20;
        let o = i - t - Q * 20;
        let s = C(Q * 16, Q * 16, r, u);
        s.rotation.z = Math.PI / 2;
        s.position.set(0, i / 2 - t / 2, 0);
        let c = C(Q * 25, Q * 25, Q * 10, l);
        c.rotation.x = Math.PI / 2;
        c.position.set(-r * 0.25, i / 2 - Q * 10, Q * 12);
        let d = C(Q * 25, Q * 25, Q * 10, l);
        d.rotation.x = Math.PI / 2;
        d.position.set(r * 0.15, i / 2 - Q * 10, Q * 12);
        let p = new pb(new Kb(a - Q * 10, o), f);
        p.position.set(-r / 4, -0.045 / 2, Q * -10);
        let m = new pb(new Kb(a, o), f);
        m.position.set(r / 4, -0.045 / 2, Q * 12);
        let h = S(u, Q * 240, Q * 20, Q * 35, r * 0.18, 0, Q * 26);
        let g = S(u, e, i, e, -r / 2 + e / 2, 0, 0);
        let _ = S(u, e, i, e, r / 2 - e / 2, 0, 0);
        let v = S(u, r, Q * 12, Q * 35, 0, -i / 2 + Q * 6, 0);
        n.add(s, c, d, p, m, h, g, _, v);
        break;
      }
    case `cama_casal`:
    case `cama_solteiro`:
      {
        let t = e.tipo === `cama_solteiro`;
        let c = a * 0.08;
        let l = i * 1.55;
        let u = i * 0.28;
        let d = i * 0.32;
        let f = a - c;
        let p = -a / 2 + c / 2;
        let m = S(y, r, l, c, 0, -i / 2 + l / 2, p);
        let g = [];
        let _ = t ? 5 : 8;
        let b = (r - Q * 20) / _;
        for (let e = 0; e < _; e++) {
          let t = -r / 2 + Q * 10 + (e + 0.5) * b;
          let n = S(v, b - Q * 4, l * 0.94, c * 0.45, t, -i / 2 + l / 2, p + c * 0.25);
          g.push(n);
        }
        let x = a / 2 - f / 2;
        let w = -i / 2 + i * 0.16 + u / 2;
        let T = S(y, r, u, f, 0, w, x);
        let E = w + u / 2 + d / 2;
        let D = S(o, r - Q * 24, d, f - Q * 24, 0, E, x);
        let O = S(s, r - Q * 20, Q * 22, f - Q * 20, 0, E + d / 2 + Q * 11, x);
        let k = S(y, r - Q * 10, Q * 28, f * 0.42, 0, E + d / 2 + Q * 20, x + f * 0.26);
        let A = t ? 1 : 2;
        let ee = [];
        for (let e = 0; e < A; e++) {
          let t = A === 1 ? 0 : r * 0.24 * (e === 0 ? -1 : 1);
          let n = S(s, r * (A === 1 ? 0.62 : 0.44), d * 0.45, f * 0.22, t, E + d / 2 + Q * 30, p + c / 2 + f * 0.18);
          n.rotation.x = -0.15;
          ee.push(n);
        }
        let te = [];
        for (let e of [-1, 1]) {
          for (let t of [-1, 1]) {
            let n = C(Q * 18, Q * 12, i * 0.16, h);
            n.position.set(e * (r / 2 - Q * 50), -i / 2 + i * 0.16 / 2, x + t * (f / 2 - Q * 50));
            te.push(n);
          }
        }
        n.add(m, ...g, T, D, O, k, ...ee, ...te);
        break;
      }
    case `cortina`:
      {
        let e = Q * 35;
        let t = S(c, r, e, a * 0.4, 0, i / 2 - e / 2, 0);
        let o = r / 12;
        let s = [];
        for (let t = 0; t < 12; t++) {
          let n = -r / 2 + o * (t + 0.5);
          let c = i - e;
          let l = new pb(new Bb(o * 0.52, o * 0.52, c, 12, 1, true), v);
          l.position.set(n, -0.035 / 2, (t % 2 == 0 ? 1 : -1) * (a * 0.2));
          l.castShadow = true;
          s.push(l);
        }
        n.add(t, ...s);
        break;
      }
  }
  n.traverse(t => {
    if (t instanceof pb) {
      t.userData.componenteId = e.id;
    }
  });
  return n;
}
function LE(e) {
  if (!e || typeof e != `object`) {
    return false;
  }
  let t = e;
  if (typeof t.tipo != `string` || t.tipo === ``) {
    return false;
  } else {
    return [t.largura, t.altura, t.profundidade, t.x, t.y].every(e => typeof e == `number` && Number.isFinite(e) && e > 0);
  }
}
function RE(e, t, n) {
  let r = new xv();
  for (let i of e) {
    if (!LE(i) || i.visivel === false) {
      continue;
    }
    let e = IE(i, n);
    if (e.children.length !== 0) {
      FE(e, i, t);
      e.userData = {
        componenteId: i.id,
        bloqueado: i.bloqueado === true
      };
      r.add(e);
    }
  }
  return r;
}
function zE(e, t) {
  for (let n of t.children.slice()) {
    if (n && n.isObject3D) {
      e.add(n);
    }
  }
}
var $ = 0.001;
var BE = 35;
var VE = 1013358;
var HE = 2370357;
var UE = new X(0, 1, 0);
function WE(e, t) {
  let n = new X();
  t.getWorldDirection(n);
  return new jy().setFromNormalAndCoplanarPoint(n, e);
}
function GE(e, t) {
  let n = e.clone().project(t);
  return new S_(n.x, n.y);
}
function KE() {
  let e = document.createElement(`canvas`);
  e.width = 64;
  e.height = 64;
  let t = e.getContext(`2d`);
  t.beginPath();
  t.arc(32, 32, 26, 0, Math.PI * 2);
  t.fillStyle = `#0f766e`;
  t.fill();
  t.lineWidth = 4;
  t.strokeStyle = `#ffffff`;
  t.stroke();
  t.fillStyle = `#ffffff`;
  t.beginPath();
  t.moveTo(32, 17);
  t.lineTo(24, 28);
  t.lineTo(40, 28);
  t.closePath();
  t.fill();
  t.beginPath();
  t.moveTo(32, 47);
  t.lineTo(24, 36);
  t.lineTo(40, 36);
  t.closePath();
  t.fill();
  t.fillRect(29.5, 26, 5, 12);
  let n = new Fb(e);
  n.needsUpdate = true;
  return n;
}
function qE() {
  let e = document.createElement(`canvas`);
  e.width = 64;
  e.height = 64;
  let t = e.getContext(`2d`);
  t.beginPath();
  t.arc(32, 32, 26, 0, Math.PI * 2);
  t.fillStyle = `#0f766e`;
  t.fill();
  t.lineWidth = 4;
  t.strokeStyle = `#ffffff`;
  t.stroke();
  t.fillStyle = `#ffffff`;
  t.beginPath();
  t.moveTo(17, 32);
  t.lineTo(28, 24);
  t.lineTo(28, 40);
  t.closePath();
  t.fill();
  t.beginPath();
  t.moveTo(47, 32);
  t.lineTo(36, 24);
  t.lineTo(36, 40);
  t.closePath();
  t.fill();
  t.fillRect(26, 29.5, 12, 5);
  let n = new Fb(e);
  n.needsUpdate = true;
  return n;
}
function JE() {
  let e = document.createElement(`canvas`);
  e.width = 64;
  e.height = 64;
  let t = e.getContext(`2d`);
  t.beginPath();
  t.arc(32, 32, 26, 0, Math.PI * 2);
  t.fillStyle = `#0f766e`;
  t.fill();
  t.lineWidth = 4;
  t.strokeStyle = `#ffffff`;
  t.stroke();
  t.strokeStyle = `#ffffff`;
  t.fillStyle = `#ffffff`;
  t.lineWidth = 3.5;
  t.beginPath();
  t.moveTo(22, 40);
  t.lineTo(42, 24);
  t.stroke();
  t.beginPath();
  t.moveTo(45, 21);
  t.lineTo(36, 21);
  t.lineTo(43, 28);
  t.closePath();
  t.fill();
  t.beginPath();
  t.moveTo(19, 43);
  t.lineTo(28, 43);
  t.lineTo(21, 36);
  t.closePath();
  t.fill();
  let n = new Fb(e);
  n.needsUpdate = true;
  return n;
}
function YE() {
  let e = document.createElement(`canvas`);
  e.width = 64;
  e.height = 64;
  let t = e.getContext(`2d`);
  t.beginPath();
  t.arc(32, 32, 26, 0, Math.PI * 2);
  t.fillStyle = `#0f766e`;
  t.fill();
  t.lineWidth = 4;
  t.strokeStyle = `#ffffff`;
  t.stroke();
  t.fillStyle = `#ffffff`;
  t.beginPath();
  t.moveTo(45, 19);
  t.lineTo(36, 19);
  t.lineTo(45, 28);
  t.closePath();
  t.fill();
  t.beginPath();
  t.moveTo(19, 45);
  t.lineTo(28, 45);
  t.lineTo(19, 36);
  t.closePath();
  t.fill();
  t.beginPath();
  t.moveTo(19, 19);
  t.lineTo(28, 19);
  t.lineTo(19, 28);
  t.closePath();
  t.fill();
  t.beginPath();
  t.moveTo(45, 45);
  t.lineTo(36, 45);
  t.lineTo(45, 36);
  t.closePath();
  t.fill();
  let n = new Fb(e);
  n.needsUpdate = true;
  return n;
}
function XE() {
  let e = document.createElement(`canvas`);
  e.width = 64;
  e.height = 64;
  let t = e.getContext(`2d`);
  t.beginPath();
  t.arc(32, 32, 18, 0, Math.PI * 2);
  t.fillStyle = `rgba(255,255,255,0.95)`;
  t.fill();
  t.lineWidth = 4;
  t.strokeStyle = `#0f766e`;
  t.stroke();
  t.beginPath();
  t.arc(32, 32, 18, Math.PI * 0.35, Math.PI * 1.55);
  t.lineWidth = 5;
  t.strokeStyle = `#0f766e`;
  t.stroke();
  t.beginPath();
  t.moveTo(38, 10);
  t.lineTo(52, 16);
  t.lineTo(39, 24);
  t.closePath();
  t.fillStyle = `#0f766e`;
  t.fill();
  let n = new Fb(e);
  n.needsUpdate = true;
  return n;
}
function ZE() {
  let e = document.createElement(`canvas`);
  e.width = 64;
  e.height = 64;
  let t = e.getContext(`2d`);
  t.beginPath();
  t.arc(32, 32, 26, 0, Math.PI * 2);
  t.fillStyle = `#dc2626`;
  t.fill();
  t.lineWidth = 4;
  t.strokeStyle = `#ffffff`;
  t.stroke();
  t.fillStyle = `#ffffff`;
  t.beginPath();
  t.moveTo(17, 32);
  t.lineTo(28, 24);
  t.lineTo(28, 40);
  t.closePath();
  t.fill();
  t.beginPath();
  t.moveTo(47, 32);
  t.lineTo(36, 24);
  t.lineTo(36, 40);
  t.closePath();
  t.fill();
  t.fillRect(26, 29.5, 12, 5);
  let n = new Fb(e);
  n.needsUpdate = true;
  return n;
}
function QE() {
  let e = document.createElement(`canvas`);
  e.width = 64;
  e.height = 64;
  let t = e.getContext(`2d`);
  t.beginPath();
  t.arc(32, 32, 26, 0, Math.PI * 2);
  t.fillStyle = `#2563eb`;
  t.fill();
  t.lineWidth = 4;
  t.strokeStyle = `#ffffff`;
  t.stroke();
  t.fillStyle = `#ffffff`;
  t.beginPath();
  t.moveTo(32, 17);
  t.lineTo(24, 28);
  t.lineTo(40, 28);
  t.closePath();
  t.fill();
  t.beginPath();
  t.moveTo(32, 47);
  t.lineTo(24, 36);
  t.lineTo(40, 36);
  t.closePath();
  t.fill();
  t.fillRect(29.5, 26, 5, 12);
  let n = new Fb(e);
  n.needsUpdate = true;
  return n;
}
function $E(e) {
  while (e.children.length > 0) {
    let t = e.children[0];
    e.remove(t);
    t.traverse(e => {
      let t = e;
      if (t.geometry) {
        t.geometry.dispose();
      }
      if (t.material) {
        if (Array.isArray(t.material)) {
          t.material.forEach(e => e.dispose());
        } else {
          t.material.dispose();
        }
      }
    });
  }
}
function eD(e, t, n, r, i, a, o = true) {
  let s = new xv();
  let c = a.largura * $;
  let l = a.altura * $;
  let u = a.profundidade * $;
  let d = e.largura * $;
  if (o) {
    let e = new xv();
    let n = 0.1;
    let r = 0.5;
    let i = [];
    let a = [];
    let o = Math.round(c / n);
    for (let e = 0; e <= o; e++) {
      let t = e * n;
      if (t > c + 0.001) {
        break;
      }
      if (Math.abs(t / r - Math.round(t / r)) < 0.0001) {
        a.push(t, 0.002, 0, t, 0.002, u);
      } else {
        i.push(t, 0.001, 0, t, 0.001, u);
      }
    }
    let l = Math.round(u / n);
    for (let e = 0; e <= l; e++) {
      let t = e * n;
      if (t > u + 0.001) {
        break;
      }
      if (Math.abs(t / r - Math.round(t / r)) < 0.0001) {
        a.push(0, 0.002, t, c, 0.002, t);
      } else {
        i.push(0, 0.001, t, c, 0.001, t);
      }
    }
    if (i.length > 0) {
      let n = new wy();
      n.setAttribute(`position`, new fy(i, 3));
      let r = new xb({
        color: t ? 3357509 : 13814205,
        transparent: true,
        opacity: t ? 0.4 : 0.5
      });
      e.add(new Nb(n, r));
    }
    if (a.length > 0) {
      let n = new wy();
      n.setAttribute(`position`, new fy(a, 3));
      let r = new xb({
        color: t ? 1096065 : 366185,
        transparent: true,
        opacity: t ? 0.6 : 0.7,
        linewidth: 1.5
      });
      e.add(new Nb(n, r));
    }
    s.add(e);
  }
  if (!n.temParedes) {
    return s;
  }
  let f = BT(i || n.paredePadrao);
  function p(e, r) {
    return new ix({
      color: f ? 16777215 : t ? n.paredeEscura : n.parede,
      map: f ? JT(f.url, HT(e / 10, r / 10, f.dimensaoCm)) : null,
      roughness: 0.85,
      metalness: 0,
      side: 2
    });
  }
  let m = new pb(new Kb(c, l), p(a.largura, a.altura));
  m.position.set(c / 2, l / 2, 0);
  m.receiveShadow = true;
  let h = new pb(new Kb(u, l), p(a.profundidade, a.altura));
  h.rotation.y = Math.PI / 2;
  h.position.set(0, l / 2, u / 2);
  h.receiveShadow = true;
  let g = new pb(new Kb(u, l), p(a.profundidade, a.altura));
  g.rotation.y = -Math.PI / 2;
  g.position.set(c, l / 2, u / 2);
  g.receiveShadow = true;
  if (d < c - 0.01) {
    let e = new Nb(new Gb(new Kb(d, l)), new xb({
      color: 9741240,
      transparent: true,
      opacity: 0.5
    }));
    e.position.set(d / 2, l / 2, 0.002);
    s.add(e);
  }
  let _ = VT(r || n.pisoPadrao);
  let v = _ ? new ix({
    color: 16777215,
    map: JT(_.url, HT(a.largura / 10, a.profundidade / 10, _.dimensaoCm)),
    roughness: 0.4,
    metalness: 0.05,
    side: 2
  }) : new ix({
    color: t ? n.pisoCorEscura : n.pisoCor,
    roughness: 0.9,
    metalness: 0,
    side: 2
  });
  let y = new pb(new Kb(c, u), v);
  y.rotation.x = -Math.PI / 2;
  y.position.set(c / 2, 0, u / 2);
  y.receiveShadow = true;
  s.add(m, h, g, y);
  return s;
}
function tD(e) {
  let t = x_.degToRad(e.rotacao);
  return {
    dirX: new X(Math.cos(t), 0, -Math.sin(t)),
    dirZ: new X(Math.sin(t), 0, Math.cos(t))
  };
}
function nD(e, t, n, r) {
  let {
    dirX: i,
    dirZ: a
  } = tD(e);
  return new X(e.x * $, e.y * $, e.z * $).addScaledVector(i, t * e.largura * $ / 2).addScaledVector(UE, n * e.altura * $ / 2).addScaledVector(a, r * e.profundidade * $ / 2);
}
function _Component56({
  preset: e
}) {
  let t = BT(e.paredePadrao);
  let n = VT(e.pisoPadrao);
  if (e.temParedes) {
                return <span className={`flex h-8 w-12 shrink-0 flex-col overflow-hidden rounded border border-border`} aria-hidden={true}><span className={`h-[55%] w-full`} style={t ? {
        backgroundImage: `url(${t.url})`,
        backgroundSize: `cover`,
        backgroundPosition: `center`
      } : {
        backgroundColor: e.parede
      }} /><span className={`h-[45%] w-full border-t border-border/60`} style={n ? {
        backgroundImage: `url(${n.url})`,
        backgroundSize: `cover`,
        backgroundPosition: `center`
      } : {
        backgroundColor: e.pisoCor
      }} /></span>;
  } else {
        return <span className={`h-8 w-12 shrink-0 rounded border border-dashed border-border`} aria-hidden={true} />;
  }
}
function _Component63({
  cenario: e,
  onMudar: t
}) {
  let [n, r] = (0, k.useState)(false);
  let i = (0, k.useRef)(null);
  let a = zT(e.preset);
  (0, k.useEffect)(() => {
    if (!n) {
      return;
    }
    function e(e) {
      if (i.current && !i.current.contains(e.target)) {
        r(false);
      }
    }
    function t(e) {
      if (e.key === `Escape`) {
        r(false);
      }
    }
    document.addEventListener(`mousedown`, e);
    document.addEventListener(`keydown`, t);
    return () => {
      document.removeEventListener(`mousedown`, e);
      document.removeEventListener(`keydown`, t);
    };
  }, [n]);
                                  return <div ref={i} className={`relative`}><button type={`button`} aria-expanded={n} aria-label={`Cenário: ${a.nome}`} title={`Trocar o cenário`} onClick={() => r(e => !e)} className={U(`flex h-8 items-center gap-1.5 rounded-lg border px-2 transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring/35`, n ? `border-primary bg-accent text-foreground` : `border-transparent text-muted-foreground hover:bg-accent hover:text-foreground`)}><Qt className={`h-4 w-4`} /><span className={`hidden max-w-28 truncate text-[11px] font-medium xl:inline`}>{a.nome}</span><Wt className={`h-3 w-3`} /></button>{n && <div className={`absolute left-0 top-full z-30 mt-2 max-h-[70vh] w-64 origin-top-left animate-scale-in overflow-y-auto rounded-lg border border-border bg-popover p-2 text-popover-foreground shadow-lg`}><p className={`px-1.5 pb-1 text-[11px] font-semibold text-muted-foreground`}>{`Mockup do cenário`}</p><div className={`grid gap-px`}>{UT.map(n => {
          let r = n.id === a.id;
                              return <button type={`button`} onClick={() => t({
            ...e,
            preset: n.id
          })} className={U(`flex items-center gap-2 rounded-md px-1.5 py-1.5 text-left text-[13px] transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring/35`, r ? `bg-accent font-medium text-foreground` : `text-muted-foreground hover:bg-accent hover:text-foreground`)} key={n.id}><_Component56 preset={n} /><span className={`min-w-0 flex-1 truncate`}>{n.nome}</span>{r && <Ut className={`h-3.5 w-3.5 shrink-0 text-primary`} />}</button>;
        })}</div>{a.temParedes && <L.Fragment><p className={`mt-2 border-t border-border px-1.5 pt-2 pb-1 text-[11px] font-semibold text-muted-foreground`}>{`Parede`}</p><div className={`grid gap-px`}><button type={`button`} onClick={() => t({
            ...e,
            parede: ``
          })} className={U(`flex items-center gap-2 rounded-md px-1.5 py-1.5 text-left text-[13px] transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring/35`, e.parede === `` ? `bg-accent font-medium text-foreground` : `text-muted-foreground hover:bg-accent hover:text-foreground`)}><span className={`h-6 w-6 shrink-0 rounded border border-border`} style={{
              backgroundColor: a.parede
            }} aria-hidden={true} /><span className={`min-w-0 flex-1 truncate`}>{`Padrão do cômodo`}</span>{e.parede === `` && <Ut className={`h-3.5 w-3.5 shrink-0 text-primary`} />}</button>{GT.map(n => {
            let r = e.parede === n.id;
                                                return <button type={`button`} onClick={() => t({
              ...e,
              parede: n.id
            })} className={U(`flex items-center gap-2 rounded-md px-1.5 py-1.5 text-left text-[13px] transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring/35`, r ? `bg-accent font-medium text-foreground` : `text-muted-foreground hover:bg-accent hover:text-foreground`)} key={n.id}><img src={n.url} alt={``} className={`h-6 w-6 shrink-0 rounded border border-border object-cover`} aria-hidden={true} /><span className={`min-w-0 flex-1 truncate`}>{n.nome}</span>{r && <Ut className={`h-3.5 w-3.5 shrink-0 text-primary`} />}</button>;
          })}</div><p className={`mt-2 border-t border-border px-1.5 pt-2 pb-1 text-[11px] font-semibold text-muted-foreground`}>{`Piso`}</p><div className={`grid gap-px`}><button type={`button`} onClick={() => t({
            ...e,
            piso: ``
          })} className={U(`flex items-center gap-2 rounded-md px-1.5 py-1.5 text-left text-[13px] transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring/35`, e.piso === `` ? `bg-accent font-medium text-foreground` : `text-muted-foreground hover:bg-accent hover:text-foreground`)}><span className={`h-6 w-6 shrink-0 rounded border border-border`} style={{
              backgroundColor: a.pisoCor
            }} aria-hidden={true} /><span className={`min-w-0 flex-1 truncate`}>{`Padrão do cômodo`}</span>{e.piso === `` && <Ut className={`h-3.5 w-3.5 shrink-0 text-primary`} />}</button>{WT.map(n => {
            let r = e.piso === n.id;
                                                return <button type={`button`} onClick={() => t({
              ...e,
              piso: n.id
            })} className={U(`flex items-center gap-2 rounded-md px-1.5 py-1.5 text-left text-[13px] transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring/35`, r ? `bg-accent font-medium text-foreground` : `text-muted-foreground hover:bg-accent hover:text-foreground`)} key={n.id}><img src={n.url} alt={``} className={`h-6 w-6 shrink-0 rounded border border-border object-cover`} aria-hidden={true} /><span className={`min-w-0 flex-1 truncate`}>{n.nome}</span>{r && <Ut className={`h-3.5 w-3.5 shrink-0 text-primary`} />}</button>;
          })}</div></L.Fragment>}</div>}</div>;
}
function aD(e, t, n, r, i, a) {
  let o = Number(a?.largura_mm) || 600;
  let s = Number(a?.altura_mm) || 700;
  let c = Number(a?.profundidade_mm) || 500;
  let l = a?.categoria ?? `vertical`;
  let u = o / 2;
  let d = s / 2;
  let f = c / 2;
  let p = [];
  t.traverse(e => {
    if (e instanceof pb) {
      p.push(e);
    }
  });
  n.traverse(e => {
    if (e instanceof pb) {
      p.push(e);
    }
  });
  let m = new pS(e.origin, e.direction).intersectObjects(p, false);
  let h = null;
  if (m.length > 0) {
    h = m[0].point;
  } else {
    let t = new jy(new X(0, 1, 0), 0);
    let n = new X();
    if (e.intersectPlane(t, n)) {
      h = n;
    } else {
      let t = new jy(new X(0, 0, 1), 0);
      let n = new X();
      if (e.intersectPlane(t, n)) {
        h = n;
      }
    }
  }
  if (!h) {
    return {
      x: r.largura / 2,
      y: l === `horizontal` ? Math.max(r.altura - d, 1400) : d,
      z: f,
      largura: o,
      altura: s,
      profundidade: c
    };
  }
  let g = Math.round(h.x / $ / 10) * 10;
  let _ = Math.round(h.y / $ / 10) * 10;
  let v = Math.round(h.z / $ / 10) * 10;
  if (l === `horizontal`) {
    if (_ < 1200) {
      _ = Math.max(r.altura - d, 1400);
    }
  } else if (_ < s * 0.9) {
    _ = d;
  }
  if (v < c * 0.9) {
    v = f;
  }
  g = Math.min(r.largura - u, Math.max(u, g));
  _ = Math.min(r.altura - d, Math.max(d, _));
  v = Math.min(i.profundidade - f, Math.max(f, v));
  return {
    x: g,
    y: _,
    z: v,
    largura: o,
    altura: s,
    profundidade: c
  };
}
function _Component89({
  cena: e,
  nicho: t,
  comodo: n,
  selecionadoId: r,
  componenteSelecionadoId: i,
  interativo: a,
  vista: o,
  escuro: s,
  cenario: c,
  className: l,
  onSelecionar: u,
  onSelecionarComponente: d,
  onMover: f,
  onMoverComponente: p,
  onRedimensionarComponente: m,
  onRedimensionar: h,
  onGirar: g,
  onGirarComponente: _,
  onInteracaoInicio: v,
  onInteracaoFim: y,
  onMudarVista: b,
  onMudarCenario: x,
  onDropModulo: S,
  onExcluir: C,
  onExcluirComponente: w,
  onDuplicar: T,
  onBloquear: E,
  onBloquearComponente: D
}) {
  let O = (0, k.useRef)(null);
  let A = (0, k.useRef)(null);
  let ee = (0, k.useRef)(null);
  let [te, j] = (0, k.useState)(`perspectiva`);
  let [ne, re] = (0, k.useState)(`mover`);
  let [M, ie] = (0, k.useState)(true);
  let [ae, oe] = (0, k.useState)(true);
  let [se, ce] = (0, k.useState)(false);
  let [le, ue] = (0, k.useState)(false);
  let [de, fe] = (0, k.useState)(false);
  let [pe, me] = (0, k.useState)(true);
  let [N, he] = (0, k.useState)(`tecnica`);
  let [ge, _e] = (0, k.useState)(true);
  let [ve, ye] = (0, k.useState)(true);
  let [be, xe] = (0, k.useState)(null);
  let Se = (0, k.useRef)(xe);
  (0, k.useEffect)(() => {
    Se.current = xe;
  }, [xe]);
  let Ce = (0, k.useRef)(ne);
  (0, k.useEffect)(() => {
    Ce.current = ne;
  }, [ne]);
  let P = (0, k.useRef)(o);
  (0, k.useEffect)(() => {
    P.current = o;
  }, [o]);
  let we = (0, k.useRef)(ge);
  (0, k.useEffect)(() => {
    we.current = ge;
  }, [ge]);
  let F = (0, k.useRef)(N);
  (0, k.useEffect)(() => {
    F.current = N;
  }, [N]);
  let Te = (0, k.useRef)(t);
  (0, k.useEffect)(() => {
    Te.current = t;
  }, [t]);
  let I = (0, k.useRef)(n);
  (0, k.useEffect)(() => {
    I.current = n;
  }, [n]);
  let [Ee, De] = (0, k.useState)(0);
  let R = zT(c.preset);
  let z = (0, k.useRef)({
    onSelecionar: u,
    onSelecionarComponente: d,
    onMover: f,
    onMoverComponente: p,
    onRedimensionarComponente: m,
    onRedimensionar: h,
    onGirar: g,
    onGirarComponente: _,
    onInteracaoInicio: v,
    onInteracaoFim: y,
    onMudarVista: b,
    onDropModulo: S,
    onExcluir: C,
    onExcluirComponente: w,
    onDuplicar: T,
    onBloquear: E,
    onBloquearComponente: D
  });
  (0, k.useEffect)(() => {
    z.current = {
      onSelecionar: u,
      onSelecionarComponente: d,
      onMover: f,
      onMoverComponente: p,
      onRedimensionarComponente: m,
      onRedimensionar: h,
      onGirar: g,
      onGirarComponente: _,
      onInteracaoInicio: v,
      onInteracaoFim: y,
      onMudarVista: b,
      onDropModulo: S,
      onExcluir: C,
      onExcluirComponente: w,
      onDuplicar: T,
      onBloquear: E,
      onBloquearComponente: D
    };
  }, [u, d, f, p, m, h, g, _, v, y, b, S, C, w, T, E, D]);
  let Oe = (0, k.useRef)(pe);
  (0, k.useEffect)(() => {
    Oe.current = pe;
  }, [pe]);
  let ke = (0, k.useRef)(a);
  (0, k.useEffect)(() => {
    ke.current = a;
  }, [a]);
  (0, k.useEffect)(() => {
    let e = O.current;
    let r = A.current;
    if (!e || !r) {
      return;
    }
    let i = e.clientWidth || 800;
    let a = e.clientHeight || 600;
    let o = i / a;
    let s = new LT({
      antialias: true,
      alpha: true
    });
    s.setPixelRatio(Math.min(window.devicePixelRatio, 2));
    s.setSize(i, a);
    s.shadowMap.enabled = true;
    s.shadowMap.type = 1;
    s.domElement.style.touchAction = `none`;
    s.domElement.style.display = `block`;
    e.appendChild(s.domElement);
    let c = new Av();
    let l = (n?.largura ?? t.largura) * $;
    let u = (n?.altura ?? t.altura) * $;
    let d = (n?.profundidade ?? t.profundidade ?? 3000) * $;
    let f = l / 2;
    let p = u / 2;
    let m = d / 2;
    let h = Math.max(l, u, d) * 1.5;
    let g = new Kx(BE, o, 0.01, 300);
    g.position.set(f + h * 0.8, p + h * 0.7, m + h * 1.1);
    let _ = Math.max(l, u, d) * 1.3;
    let v = new qx(-_ * o / 2, _ * o / 2, _ / 2, -_ / 2, -100, 200);
    v.position.copy(g.position);
    let y = g;
    let b = new yE(y, s.domElement);
    b.enableDamping = true;
    b.dampingFactor = 0.08;
    b.maxPolarAngle = Math.PI / 2 + 0.05;
    b.minDistance = 0.1;
    b.maxDistance = 80;
    b.target.set(f, p * 0.8, m);
    b.update();
    let x = new Px(16777215, 9081498, 1.2);
    c.add(x);
    let S = new Yx(16776698, 1.6);
    S.position.set(-2.5, 4.5, 3.5);
    S.castShadow = true;
    S.shadow.mapSize.width = 2048;
    S.shadow.mapSize.height = 2048;
    S.shadow.bias = -0.0001;
    let C = new Yx(15660287, 0.6);
    C.position.set(3.5, 2.5, -2);
    c.add(S, C);
    let w = new xv();
    let T = new xv();
    let E = new xv();
    let D = new xv();
    let k = new xv();
    let te = new xv();
    let j = new xv();
    let ne = new zb(1, 1, 1);
    let re = new pb(ne, new tb({
      color: 1013358,
      transparent: true,
      opacity: 0.35,
      depthTest: false
    }));
    let M = new Nb(new Gb(ne), new xb({
      color: 1357990,
      depthTest: false,
      linewidth: 2
    }));
    j.add(re, M);
    j.visible = false;
    j.renderOrder = 10;
    c.add(w, T, E, D, k, te, j);
    let ie = new Nb(new Gb(new zb(1, 1, 1)), new xb({
      color: VE,
      depthTest: false,
      transparent: true,
      linewidth: 2
    }));
    ie.visible = false;
    ie.renderOrder = 3;
    c.add(ie);
    let ae = new Nb(new Gb(new zb(1, 1, 1)), new xb({
      color: VE,
      depthTest: false,
      transparent: true,
      linewidth: 2
    }));
    ae.visible = false;
    ae.renderOrder = 3;
    c.add(ae);
    let oe = new Float32Array(900);
    let se = new wy();
    se.setAttribute(`position`, new ly(oe, 3));
    se.setDrawRange(0, 0);
    let ce = new Nb(se, new xb({
      color: VE,
      depthTest: false,
      transparent: true,
      linewidth: 1.5
    }));
    ce.renderOrder = 4;
    c.add(ce);
    let le = new xv();
    let ue = new Kb(1, 1);
    let de = new pb(ue, new tb({
      color: 1096065,
      transparent: true,
      opacity: 0.18,
      depthTest: false,
      side: 2
    }));
    de.rotation.x = -Math.PI / 2;
    let fe = new Nb(new Gb(ue), new xb({
      color: 366185,
      depthTest: false,
      linewidth: 2
    }));
    fe.rotation.x = -Math.PI / 2;
    let pe = new Float32Array(24);
    let me = new wy();
    me.setAttribute(`position`, new ly(pe, 3));
    let N = new Nb(me, new xb({
      color: 1096065,
      transparent: true,
      opacity: 0.45,
      depthTest: false
    }));
    le.add(de, fe, N);
    le.visible = false;
    le.renderOrder = 8;
    c.add(le);
    function he(e, t, n, r, i, a, o = 0) {
      de.scale.set(r, a, 1);
      fe.scale.set(r, a, 1);
      le.position.set(e, 0.003, n);
      le.rotation.y = x_.degToRad(o);
      let s = r / 2;
      let c = a / 2;
      let l = Math.max(0, t - i / 2);
      let u = [-s, 0, -c, -s, l, -c, s, 0, -c, s, l, -c, s, 0, c, s, l, c, -s, 0, c, -s, l, c];
      pe.set(u);
      me.getAttribute(`position`).needsUpdate = true;
      le.visible = true;
    }
    let ge = [KE(), qE(), JE(), YE(), XE(), ZE(), QE()];
    let _e = [];
    for (let e = 0; e < ge.length; e++) {
      let t = new Jy(new Py({
        map: ge[e],
        sizeAttenuation: false,
        depthTest: false,
        transparent: true
      }));
      t.scale.set(0.028, 0.028, 1);
      t.visible = false;
      t.renderOrder = 5;
      D.add(t);
      _e.push(t);
    }
    let ve = [];
    let ye = [new X(), new X(), new X()];
    for (let e = 0; e < 3; e++) {
      let e = document.createElement(`span`);
      e.className = `pointer-events-none absolute select-none rounded border border-stone-200 bg-white/90 px-1.5 py-0.5 text-[11px] font-mono font-medium text-emerald-700 shadow-md backdrop-blur transition-opacity duration-150 -translate-x-1/2 -translate-y-1/2 dark:border-stone-700 dark:bg-stone-900/90 dark:text-emerald-400`;
      e.style.display = `none`;
      r.appendChild(e);
      ve.push(e);
    }
    let be = new pS();
    let xe = new S_();
    let F = {
      renderer: s,
      scene: c,
      cameraPersp: g,
      cameraOrtho: v,
      cameraAtiva: y,
      controls: b,
      cenario: w,
      modulosGroup: T,
      componentesGroup: E,
      gizmoGroup: D,
      fixadoresGroup: k,
      contornosGroup: te,
      previewDropGroup: j,
      modulosMap: new Map(),
      contornoSelecionado: ie,
      contornoComponente: ae,
      linhasCotas: ce,
      bufferLinhas: oe,
      alcas: _e,
      projecaoSoloGroup: le,
      atualizarProjecaoSolo: he,
      rotulos: ve,
      posicoesRotulos: ye,
      raycaster: be,
      ponteiro: xe,
      luzPrincipal: S,
      luzAmbiente: x,
      arraste: null,
      quadro: 0,
      observador: null,
      nichoChave: ``,
      cena: {
        modulos: []
      },
      selecionadoId: null
    };
    ee.current = F;
    let Ee = true;
    let L = () => {
      if (Ee) {
        F.quadro = requestAnimationFrame(L);
        b.update();
        if (Oe.current) {
          let t = F.cameraAtiva;
          let n = e.clientWidth / 2;
          let r = e.clientHeight / 2;
          let i = new X();
          ve.forEach((e, a) => {
            if (e.style.display === `none`) {
              return;
            }
            i.copy(ye[a]).project(t);
            if (i.z > 1) {
              e.style.display = `none`;
              return;
            }
            let o = i.x * n + n;
            let s = -i.y * r + r;
            e.style.left = `${o}px`;
            e.style.top = `${s}px`;
          });
        }
        s.render(c, F.cameraAtiva);
      }
    };
    L();
    let R = new ResizeObserver(e => {
      let t = e[0];
      if (!t) {
        return;
      }
      let n = t.contentRect.width;
      let r = t.contentRect.height;
      if (n <= 0 || r <= 0) {
        return;
      }
      s.setSize(n, r);
      g.aspect = n / r;
      g.updateProjectionMatrix();
      let i = n / r;
      v.left = -_ * i / 2;
      v.right = _ * i / 2;
      v.top = _ / 2;
      v.bottom = -_ / 2;
      v.updateProjectionMatrix();
    });
    R.observe(e);
    F.observador = R;
    let Ae = e => {
      if (!ke.current || e.button !== 0) {
        return;
      }
      let t = s.domElement.getBoundingClientRect();
      xe.x = (e.clientX - t.left) / t.width * 2 - 1;
      xe.y = -((e.clientY - t.top) / t.height) * 2 + 1;
      be.setFromCamera(xe, F.cameraAtiva);
      if (Ce.current === `mover`) {
        let e = _e.filter(e => e.visible);
        let t = be.intersectObjects(e, false);
        if (t.length > 0) {
          b.enabled = false;
          let e = t[0].object;
          z.current.onInteracaoInicio();
          let n = e.userData.id;
          let r = F.cena.modulos.find(e => e.id === n);
          let i = (F.cena.componentes ?? []).find(e => e.id === n);
          if (r?.bloqueado || i?.bloqueado) {
            return;
          }
          b.enabled = false;
          z.current.onInteracaoInicio();
          let a = e.getWorldPosition(new X());
          let o = !r && !!i;
          if (e.userData.tipo === `mover-altura`) {
            let e = new X();
            F.cameraAtiva.getWorldDirection(e);
            e.y = 0;
            if (e.lengthSq() < 0.0001) {
              e.set(0, 0, 1);
            }
            e.normalize();
            let t = new jy().setFromNormalAndCoplanarPoint(e, a);
            let s = r ? r.y : i ? i.y : 0;
            if (o) {
              F.arraste = {
                tipo: `mover-altura-componente`,
                id: n,
                pontoInicial: a,
                yOriginal: s,
                plano: t
              };
            } else {
              F.arraste = {
                tipo: `mover-altura`,
                id: n,
                pontoInicial: a,
                yOriginal: s,
                plano: t
              };
            }
            return;
          }
          if (e.userData.tipo === `mover-x` || e.userData.tipo === `mover-z`) {
            let t = e.userData.tipo === `mover-x` ? `x` : `z`;
            let s = new X();
            F.cameraAtiva.getWorldDirection(s);
            let c;
            c = t === `x` ? Math.abs(s.y) > 0.7 ? new jy(new X(0, 1, 0), -a.y) : new jy(new X(0, 0, 1), -a.z) : Math.abs(s.y) > 0.7 ? new jy(new X(0, 1, 0), -a.y) : new jy(new X(1, 0, 0), -a.x);
            let l = t === `x` ? r ? r.x : i ? i.x : 0 : r ? typeof r.z == `number` ? r.z : 0 : i && typeof i.z == `number` ? i.z : 0;
            F.arraste = {
              tipo: `mover-eixo`,
              id: n,
              eixo: t,
              plano: c,
              pontoInicial: a,
              valorOriginal: l,
              isComponente: o
            };
            return;
          }
        }
      }
      if (Ce.current === `editar`) {
        let e = _e.filter(e => e.visible);
        let t = be.intersectObjects(e, false);
        if (t.length > 0) {
          let e = t[0].object;
          let n = e.userData.id;
          let r = F.cena.modulos.find(e => e.id === n);
          let i = (F.cena.componentes ?? []).find(e => e.id === n);
          if (r?.bloqueado || i?.bloqueado) {
            return;
          }
          b.enabled = false;
          z.current.onInteracaoInicio();
          if (e.userData.tipo === `rotacao`) {
            if (i) {
              z.current.onGirarComponente?.(e.userData.id);
            } else {
              z.current.onGirar(e.userData.id);
            }
            b.enabled = true;
            return;
          }
          let a = e.getWorldPosition(new X());
          let o = WE(a, F.cameraAtiva);
          if (e.userData.tipo === `mover-altura`) {
            if (r) {
              let e = new X();
              F.cameraAtiva.getWorldDirection(e);
              e.y = 0;
              if (e.lengthSq() < 0.0001) {
                e.set(0, 0, 1);
              }
              e.normalize();
              let t = new jy().setFromNormalAndCoplanarPoint(e, a);
              F.arraste = {
                tipo: `mover-altura`,
                id: r.id,
                pontoInicial: a,
                yOriginal: r.y,
                plano: t
              };
              return;
            }
            let e = i;
            if (e) {
              let t = new X();
              F.cameraAtiva.getWorldDirection(t);
              t.y = 0;
              if (t.lengthSq() < 0.0001) {
                t.set(0, 0, 1);
              }
              t.normalize();
              let n = new jy().setFromNormalAndCoplanarPoint(t, a);
              F.arraste = {
                tipo: `mover-altura-componente`,
                id: e.id,
                pontoInicial: a,
                yOriginal: e.y,
                plano: n
              };
              return;
            }
            return;
          }
          if (e.userData.tipo === `profundidade`) {
            let e = i;
            if (e) {
              let t = GE(a, F.cameraAtiva);
              let n = GE(a.clone().addScaledVector(UE, -0.1), F.cameraAtiva).clone().sub(t).length();
              F.arraste = {
                tipo: `redimensionar-profundidade-componente`,
                id: e.id,
                original: {
                  ...e
                },
                escalaTelaMm: 100 / (n > 0.00001 ? n : 0.00001),
                telaInicial: t
              };
              return;
            }
            if (r) {
              let e = GE(a, F.cameraAtiva);
              let t = GE(a.clone().addScaledVector(UE, -0.1), F.cameraAtiva).clone().sub(e).length();
              F.arraste = {
                tipo: `redimensionar-profundidade`,
                id: r.id,
                original: {
                  ...r
                },
                escalaTelaMm: 100 / (t > 0.00001 ? t : 0.00001),
                telaInicial: e
              };
            }
            return;
          }
          if (e.userData.tipo === `altura` || e.userData.tipo === `largura` || e.userData.tipo === `geral`) {
            let t = e.userData.tipo === `altura` ? 0 : e.userData.sinalX;
            let n = e.userData.tipo === `largura` ? 0 : e.userData.sinalY;
            let s = i;
            if (s) {
              F.arraste = {
                tipo: `redimensionar-componente`,
                id: s.id,
                canto: {
                  sinalX: t,
                  sinalY: n
                },
                original: {
                  ...s
                },
                pontoInicial: a,
                plano: o
              };
              return;
            }
            if (r) {
              F.arraste = {
                tipo: `redimensionar`,
                id: r.id,
                canto: {
                  sinalX: t,
                  sinalY: n
                },
                original: {
                  ...r
                },
                pontoInicial: a,
                plano: o
              };
            }
            return;
          }
          return;
        }
      }
      let n = [];
      F.modulosGroup.traverse(e => {
        if (e instanceof pb && e.userData.moduloId) {
          n.push(e);
        }
      });
      let r = be.intersectObjects(n, false);
      if (r.length > 0) {
        let e = r[0].object.userData.moduloId;
        z.current.onSelecionar(e);
        z.current.onSelecionarComponente(null);
        let t = F.cena.modulos.find(t => t.id === e);
        if (t && !t.bloqueado && Ce.current === `mover`) {
          b.enabled = false;
          z.current.onInteracaoInicio();
          let n = r[0].point;
          let i = typeof t.z == `number` && Number.isFinite(t.z) ? t.z : Dm(t) / 2;
          let a = new X(t.x * $, t.y * $, i * $);
          let o = a.clone().sub(n);
          let s;
          s = P.current === `superior` ? new jy(new X(0, 1, 0), -a.y) : P.current === `frontal` ? new jy(new X(0, 0, 1), -a.z) : P.current === `lateral` ? new jy(new X(1, 0, 0), -a.x) : new jy(new X(0, 1, 0), -a.y);
          F.arraste = {
            tipo: `mover`,
            id: e,
            deslocamento: o,
            pontoInicial: n.clone(),
            plano: s,
            xOriginal: t.x,
            yOriginal: t.y,
            zOriginal: i
          };
        }
        return;
      }
      let i = [];
      F.componentesGroup.traverse(e => {
        if (e instanceof pb && e.userData.componenteId) {
          i.push(e);
        }
      });
      let a = be.intersectObjects(i, false);
      if (a.length > 0) {
        let e = a[0].object.userData.componenteId;
        let t = (F.cena.componentes ?? []).find(t => t.id === e);
        z.current.onSelecionarComponente(e);
        z.current.onSelecionar(null);
        if (t && !t.bloqueado && Ce.current === `mover`) {
          b.enabled = false;
          z.current.onInteracaoInicio();
          let n = a[0].point;
          let r = typeof t.z == `number` && Number.isFinite(t.z) ? t.z : t.profundidade / 2;
          let i = new X(t.x * $, t.y * $, r * $);
          let o = i.clone().sub(n);
          let s;
          s = P.current === `superior` ? new jy(new X(0, 1, 0), -i.y) : P.current === `frontal` ? new jy(new X(0, 0, 1), -i.z) : P.current === `lateral` ? new jy(new X(1, 0, 0), -i.x) : new jy(new X(0, 1, 0), -i.y);
          F.arraste = {
            tipo: `mover-componente`,
            id: e,
            deslocamento: o,
            pontoInicial: n.clone(),
            plano: s,
            xOriginal: t.x,
            yOriginal: t.y,
            zOriginal: r
          };
        }
        return;
      }
      z.current.onSelecionar(null);
      z.current.onSelecionarComponente(null);
    };
    let je = e => {
      if (!F.arraste) {
        return;
      }
      let t = s.domElement.getBoundingClientRect();
      xe.x = (e.clientX - t.left) / t.width * 2 - 1;
      xe.y = -((e.clientY - t.top) / t.height) * 2 + 1;
      be.setFromCamera(xe, F.cameraAtiva);
      if (F.arraste.tipo === `mover-eixo`) {
        let e = F.arraste;
        let t = new X();
        if (be.ray.intersectPlane(e.plano, t)) {
          let n = e.eixo === `x` ? t.x - e.pontoInicial.x : t.z - e.pontoInicial.z;
          let r = e.valorOriginal + n / $;
          if (we.current) {
            r = Math.round(r / 50) * 50;
          }
          r = Math.round(r);
          if (e.isComponente) {
            z.current.onMoverComponente(e.id, {
              [e.eixo]: r
            });
          } else {
            let t = F.cena.modulos.find(t => t.id === e.id);
            if (t) {
              let n = Te.current;
              let i = I.current;
              let a = Em(t) / 2;
              let o = Dm(t) / 2;
              let s = Math.max(n.largura, i.largura);
              let c = Math.max(n.profundidade, i.profundidade);
              r = e.eixo === `x` ? Math.max(a, Math.min(s - a, r)) : Math.max(o, Math.min(c - o, r));
              z.current.onMover(e.id, {
                x: e.eixo === `x` ? r : t.x,
                y: t.y,
                z: e.eixo === `z` ? r : typeof t.z == `number` ? t.z : Dm(t) / 2
              });
            }
          }
        }
      } else if (F.arraste.tipo === `mover`) {
        let e = F.arraste;
        let t = new X();
        if (be.ray.intersectPlane(e.plano, t)) {
          let n = t.add(e.deslocamento);
          let r = n.x / $;
          let i = n.y / $;
          let a = n.z / $;
          if (P.current === `superior`) {
            i = e.yOriginal;
          } else if (P.current === `frontal`) {
            a = e.zOriginal;
          } else if (P.current === `lateral`) {
            r = e.xOriginal;
          } else {
            i = e.yOriginal;
          }
          if (we.current) {
            r = Math.round(r / 50) * 50;
            i = Math.round(i / 50) * 50;
            a = Math.round(a / 50) * 50;
          }
          let o = F.cena.modulos.find(t => t.id === e.id);
          if (o) {
            let e = Te.current;
            let t = I.current;
            let n = Em(o) / 2;
            let s = o.altura / 2;
            let c = Dm(o) / 2;
            let l = Math.max(e.largura, t.largura);
            let u = Math.max(e.altura, t.altura);
            let d = Math.max(e.profundidade, t.profundidade);
            r = Math.max(n, Math.min(l - n, r));
            i = Math.max(s, Math.min(u - s, i));
            a = Math.max(c, Math.min(d - c, a));
          }
          z.current.onMover(e.id, {
            x: Math.round(r),
            y: Math.round(i),
            z: Math.round(a)
          });
        }
      } else if (F.arraste.tipo === `mover-altura`) {
        let e = F.arraste;
        let t = new X();
        if (be.ray.intersectPlane(e.plano, t)) {
          let n = (t.y - e.pontoInicial.y) / $;
          let r = e.yOriginal + n;
          if (we.current) {
            r = Math.round(r / 50) * 50;
          }
          let i = F.cena.modulos.find(t => t.id === e.id);
          if (i) {
            let t = Te.current;
            let n = I.current;
            let a = i.altura / 2;
            let o = Math.max(t.altura, n.altura);
            r = Math.max(a, Math.min(o - a, r));
            z.current.onMover(e.id, {
              x: i.x,
              y: Math.round(r),
              z: i.z
            });
          }
        }
      } else if (F.arraste.tipo === `mover-altura-componente`) {
        let e = F.arraste;
        let t = new X();
        if (be.ray.intersectPlane(e.plano, t)) {
          let n = (t.y - e.pontoInicial.y) / $;
          let r = e.yOriginal + n;
          if (we.current) {
            r = Math.round(r / 50) * 50;
          }
          let i = (F.cena.componentes ?? []).find(t => t.id === e.id);
          if (i) {
            let t = Te.current;
            let n = I.current;
            let a = i.altura / 2;
            let o = Math.max(t.altura, n.altura);
            r = Math.max(a, Math.min(o - a, r));
            z.current.onMoverComponente(e.id, {
              y: Math.round(r)
            });
          }
        }
      } else if (F.arraste.tipo === `mover-componente`) {
        let e = F.arraste;
        let t = new X();
        if (be.ray.intersectPlane(e.plano, t)) {
          let n = t.add(e.deslocamento);
          let r = n.x / $;
          let i = n.y / $;
          let a = n.z / $;
          if (P.current === `superior`) {
            i = e.yOriginal;
          } else if (P.current === `frontal`) {
            a = e.zOriginal;
          } else if (P.current === `lateral`) {
            r = e.xOriginal;
          } else {
            i = e.yOriginal;
          }
          if (we.current) {
            r = Math.round(r / 50) * 50;
            i = Math.round(i / 50) * 50;
            a = Math.round(a / 50) * 50;
          }
          let o = (F.cena.componentes ?? []).find(t => t.id === e.id);
          if (o) {
            let e = Te.current;
            let t = I.current;
            let n = (o.rotacao ?? 0) % 180 != 0;
            let s = (n ? o.profundidade : o.largura) / 2;
            let c = o.altura / 2;
            let l = (n ? o.largura : o.profundidade) / 2;
            let u = Math.max(e.largura, t.largura);
            let d = Math.max(e.altura, t.altura);
            let f = Math.max(e.profundidade, t.profundidade);
            r = Math.max(s, Math.min(u - s, r));
            i = Math.max(c, Math.min(d - c, i));
            a = Math.max(l, Math.min(f - l, a));
          }
          z.current.onMoverComponente(e.id, {
            x: Math.round(r),
            y: Math.round(i),
            z: Math.round(a)
          });
        }
      } else if (F.arraste.tipo === `redimensionar`) {
        let e = F.arraste;
        let t = new X();
        if (be.ray.intersectPlane(e.plano, t)) {
          let n = t.clone().sub(e.pontoInicial);
          let {
            dirX: r
          } = tD(e.original);
          let i = {
            x: e.canto.sinalX * e.original.largura / 2 + n.dot(r) / $,
            y: e.canto.sinalY * e.original.altura / 2 + n.y / $
          };
          let a = Zm(e.original, e.canto, i);
          z.current.onRedimensionar(e.id, a);
        }
      } else if (F.arraste.tipo === `redimensionar-profundidade`) {
        let e = F.arraste;
        let t = (e.telaInicial.y - xe.y) * e.escalaTelaMm;
        let n = $m(e.original, t, I.current.profundidade);
        z.current.onRedimensionar(e.id, n);
      } else if (F.arraste.tipo === `redimensionar-profundidade-componente`) {
        let e = F.arraste;
        let t = (e.telaInicial.y - xe.y) * e.escalaTelaMm;
        let n = typeof e.original.z == `number` && Number.isFinite(e.original.z) ? e.original.z : e.original.profundidade / 2;
        let r = Math.max(e.original.profundidade / 2, Math.min(I.current.profundidade - e.original.profundidade / 2, n + t));
        z.current.onMoverComponente(e.id, {
          z: Math.round(r / 10) * 10
        });
      } else if (F.arraste.tipo === `redimensionar-componente`) {
        let e = F.arraste;
        let t = new X();
        if (be.ray.intersectPlane(e.plano, t)) {
          let r = t.clone().sub(e.pontoInicial);
          let i = new X(1, 0, 0);
          let a = {
            x: e.canto.sinalX * e.original.largura / 2 + r.dot(i) / $,
            y: e.canto.sinalY * e.original.altura / 2 + r.y / $
          };
          let o = eh(e.original, e.canto, a, n.largura, n.altura);
          z.current.onRedimensionarComponente(e.id, o);
        }
      }
    };
    let Me = () => {
      if (F.arraste) {
        F.arraste = null;
        b.enabled = true;
        z.current.onInteracaoFim();
      }
    };
    let Ne = e => {
      e.preventDefault();
      if (e.dataTransfer) {
        e.dataTransfer.dropEffect = `copy`;
      }
    };
    let Pe = e => {
      e.preventDefault();
      if (e.dataTransfer) {
        e.dataTransfer.dropEffect = `copy`;
      }
      let t = s.domElement.getBoundingClientRect();
      xe.x = (e.clientX - t.left) / t.width * 2 - 1;
      xe.y = -((e.clientY - t.top) / t.height) * 2 + 1;
      be.setFromCamera(xe, F.cameraAtiva);
      let n = PE();
      let r = aD(be.ray, F.modulosGroup, F.cenario, Te.current, I.current, n);
      j.scale.set(r.largura * $, r.altura * $, r.profundidade * $);
      j.position.set(r.x * $, r.y * $, r.z * $);
      j.visible = true;
    };
    let Fe = () => {
      j.visible = false;
    };
    let Ie = e => {
      e.preventDefault();
      j.visible = false;
      let t = PE();
      if (!t) {
        try {
          let n = e.dataTransfer?.getData(`application/json`);
          if (n) {
            t = JSON.parse(n);
          }
        } catch {
          t = null;
        }
      }
      if (!t) {
        return;
      }
      let n = s.domElement.getBoundingClientRect();
      xe.x = (e.clientX - n.left) / n.width * 2 - 1;
      xe.y = -((e.clientY - n.top) / n.height) * 2 + 1;
      be.setFromCamera(xe, F.cameraAtiva);
      let r = aD(be.ray, F.modulosGroup, F.cenario, Te.current, I.current, t);
      z.current.onDropModulo?.(t, {
        x: r.x,
        y: r.y,
        z: r.z
      });
    };
    let Le = e => {
      e.preventDefault();
      e.stopPropagation();
      let t = s.domElement.getBoundingClientRect();
      xe.x = (e.clientX - t.left) / t.width * 2 - 1;
      xe.y = -((e.clientY - t.top) / t.height) * 2 + 1;
      be.setFromCamera(xe, F.cameraAtiva);
      let n = [];
      F.modulosGroup.traverse(e => {
        if (e instanceof pb && e.userData.moduloId) {
          n.push(e);
        }
      });
      let r = be.intersectObjects(n, false);
      if (r.length > 0) {
        let t = r[0].object.userData.moduloId;
        z.current.onSelecionar(t);
        z.current.onSelecionarComponente(null);
        Se.current({
          x: e.clientX,
          y: e.clientY,
          targetId: t,
          targetType: `modulo`
        });
        return;
      }
      let i = [];
      F.componentesGroup.traverse(e => {
        if (e instanceof pb && e.userData.componenteId) {
          i.push(e);
        }
      });
      let a = be.intersectObjects(i, false);
      if (a.length > 0) {
        let t = a[0].object.userData.componenteId;
        z.current.onSelecionarComponente(t);
        z.current.onSelecionar(null);
        Se.current({
          x: e.clientX,
          y: e.clientY,
          targetId: t,
          targetType: `componente`
        });
        return;
      }
    };
    let Re = s.domElement;
    Re.addEventListener(`pointerdown`, Ae);
    window.addEventListener(`pointermove`, je);
    window.addEventListener(`pointerup`, Me);
    Re.addEventListener(`contextmenu`, Le);
    Re.addEventListener(`dragenter`, Ne);
    Re.addEventListener(`dragover`, Pe);
    Re.addEventListener(`dragleave`, Fe);
    Re.addEventListener(`drop`, Ie);
    De(e => e + 1);
    return () => {
      Ee = false;
      cancelAnimationFrame(F.quadro);
      Re.removeEventListener(`pointerdown`, Ae);
      window.removeEventListener(`pointermove`, je);
      window.removeEventListener(`pointerup`, Me);
      Re.removeEventListener(`contextmenu`, Le);
      Re.removeEventListener(`dragenter`, Ne);
      Re.removeEventListener(`dragover`, Pe);
      Re.removeEventListener(`dragleave`, Fe);
      Re.removeEventListener(`drop`, Ie);
      R.disconnect();
      b.dispose();
      s.dispose();
      s.forceContextLoss();
      if (Re.parentElement === e) {
        e.removeChild(Re);
      }
      ve.forEach(e => e.remove());
    };
  }, []);
  (0, k.useEffect)(() => {
    let e = ee.current;
    if (!e) {
      return;
    }
    $E(e.cenario);
    let r = eD(t, s, R, c.piso, c.parede, n, M);
    zE(e.cenario, r);
  }, [t, s, R, c.piso, c.parede, n, Ee, M]);
  (0, k.useEffect)(() => {
    let t = ee.current;
    if (t) {
      $E(t.componentesGroup);
      zE(t.componentesGroup, RE(e.componentes ?? [], n, s));
    }
  }, [e.componentes, n, s, Ee]);
  (0, k.useEffect)(() => {
    let t = ee.current;
    if (!t) {
      return;
    }
    let r = (e.componentes ?? []).find(e => e.id === i);
    if (!r || !a) {
      t.contornoComponente.visible = false;
      return;
    }
    let o = typeof r.z == `number` && Number.isFinite(r.z) ? r.z * $ : r.profundidade * $ / 2;
    t.contornoComponente.scale.set(r.largura * $ * 1.04, r.altura * $ * 1.04, r.profundidade * $ * 1.04);
    if (r.parede === `fundo`) {
      t.contornoComponente.rotation.y = 0;
      t.contornoComponente.position.set(r.x * $, r.y * $, o);
    } else if (r.parede === `esquerda`) {
      t.contornoComponente.rotation.y = Math.PI / 2;
      t.contornoComponente.position.set(o, r.y * $, r.x * $);
    } else {
      t.contornoComponente.rotation.y = -Math.PI / 2;
      t.contornoComponente.position.set(n.largura * $ - o, r.y * $, r.x * $);
    }
    t.contornoComponente.visible = true;
  }, [e.componentes, i, a, n]);
  (0, k.useEffect)(() => {
    let e = ee.current;
    if (e && O.current) {
      if (te === `ortografica`) {
        e.cameraOrtho.position.copy(e.cameraPersp.position);
        e.cameraOrtho.zoom = 1;
        e.cameraOrtho.updateProjectionMatrix();
        e.cameraAtiva = e.cameraOrtho;
        e.controls.object = e.cameraOrtho;
      } else {
        e.cameraPersp.position.copy(e.cameraOrtho.position);
        e.cameraPersp.updateProjectionMatrix();
        e.cameraAtiva = e.cameraPersp;
        e.controls.object = e.cameraPersp;
      }
      e.controls.update();
    }
  }, [te]);
  (0, k.useEffect)(() => {
    let e = ee.current;
    if (!e) {
      return;
    }
    let r = (n?.largura ?? t.largura) * $;
    let i = (n?.altura ?? t.altura) * $;
    let a = (n?.profundidade ?? t.profundidade ?? 3000) * $;
    let s = r / 2;
    let c = i / 2;
    let l = a / 2;
    let u = Math.max(r, i, a) * 1.5;
    if (o === `frontal`) {
      e.controls.target.set(s, c, l);
      e.cameraAtiva.position.set(s, c, l + u * 1.3);
    } else if (o === `superior`) {
      e.controls.target.set(s, 0, l);
      e.cameraAtiva.position.set(s, c + u * 1.4, l);
    } else if (o === `lateral`) {
      e.controls.target.set(s, c, l);
      e.cameraAtiva.position.set(s + u * 1.3, c, l);
    } else {
      e.controls.target.set(s, c * 0.85, l);
      e.cameraAtiva.position.set(s + u * 0.85, c + u * 0.75, l + u * 1.15);
    }
    e.controls.update();
  }, [o, n, t]);
  (0, k.useEffect)(() => {
    let e = ee.current;
    if (e) {
      e.luzPrincipal.intensity = ve ? 1.6 : 0.4;
      e.luzAmbiente.intensity = ve ? 1.2 : 0.5;
    }
  }, [ve]);
  (0, k.useEffect)(() => {
    let t = ee.current;
    if (!t) {
      return;
    }
    t.cena = e;
    t.selecionadoId = r;
    let o = new Set(e.modulos.map(e => e.id));
    for (let [e, n] of t.modulosMap) {
      if (!o.has(e)) {
        t.modulosGroup.remove(n);
        $E(n);
        t.modulosMap.delete(e);
      }
    }
    $E(t.fixadoresGroup);
    $E(t.contornosGroup);
    for (let n of e.modulos) {
      let e = t.modulosMap.get(n.id);
      if (e) {
        $E(e);
      } else {
        e = new xv();
        t.modulosGroup.add(e);
        t.modulosMap.set(n.id, e);
      }
      e.visible = n.visivel !== false;
      e.position.set(n.x * $, n.y * $, n.z * $);
      e.rotation.y = x_.degToRad(n.rotacao);
      let {
        pecas: r,
        ferragens: i
      } = rt({
        ...n,
        portasAbertas: le
      });
      for (let t of r) {
        let r = YT(t.acabamento);
        let i = new zb(t.tamanho3D.x * $, t.tamanho3D.y * $, t.tamanho3D.z * $);
        let a;
        a = r.texturaUrl ? new ix({
          map: JT(r.texturaUrl, r.repeticao || [2, 2]),
          roughness: r.rugosidade,
          metalness: r.metalicidade
        }) : new ix({
          color: r.hex,
          roughness: r.rugosidade,
          metalness: r.metalicidade
        });
        if (se) {
          a.transparent = true;
          a.opacity = t.isFrente ? 0.25 : 0.45;
        }
        let o = new pb(i, a);
        o.position.set(t.posRelativa.x * $, t.posRelativa.y * $, t.posRelativa.z * $);
        o.castShadow = true;
        o.receiveShadow = true;
        o.userData.moduloId = n.id;
        o.userData.pecaId = t.id;
        if (t.rotacaoPorta && le) {
          let n = new xv();
          n.position.set(t.rotacaoPorta.pivot.x * $, t.rotacaoPorta.pivot.y * $, t.rotacaoPorta.pivot.z * $);
          o.position.x -= t.rotacaoPorta.pivot.x * $;
          o.position.z -= t.rotacaoPorta.pivot.z * $;
          n.add(o);
          n.rotation.y = t.rotacaoPorta.angulo;
          e.add(n);
        } else {
          e.add(o);
        }
        if (ae) {
          let n = new Nb(new Gb(i), new xb({
            color: s ? 4871528 : HE,
            linewidth: 1.2,
            transparent: true,
            opacity: 0.65
          }));
          n.position.copy(o.position);
          if (!t.rotacaoPorta || !le) {
            e.add(n);
          }
        }
      }
      if (de) {
        let t = new Bb(0.007, 0.007, 0.015, 8);
        let n = new ix({
          color: 14251782,
          metalness: 0.85,
          roughness: 0.2
        });
        for (let r of i) {
          let i = new pb(t, n);
          i.position.set(r.posRelativa.x * $, r.posRelativa.y * $, r.posRelativa.z * $);
          e.add(i);
        }
      }
    }
    let c = (e.componentes ?? []).find(e => e.id === i);
    if (c) {
      t.contornoSelecionado.visible = false;
      t.linhasCotas.geometry.setDrawRange(0, 0);
      for (let e of t.rotulos) {
        e.style.display = `none`;
      }
      if (c.bloqueado) {
        for (let e of t.alcas) {
          e.visible = false;
        }
        t.projecaoSoloGroup.visible = false;
        return;
      }
      let e = typeof c.z == `number` && Number.isFinite(c.z) ? c.z * $ : c.profundidade * $ / 2;
      let r = c.largura * $ / 2;
      let i = c.altura * $ / 2;
      let o = c.profundidade * $ / 2;
      let s = x_.degToRad(c.rotacao ?? 0);
      let l = Math.cos(s);
      let u = Math.sin(s);
      let d = (t, a, s = 1) => {
        let d = t * r;
        let f = s * o;
        let p = d * l + f * u;
        let m = -d * u + f * l;
        let h = c.x * $ + p;
        let g = c.y * $ + a * i;
        let _ = e + m;
        if (c.parede === `fundo`) {
          return new X(h, g, _);
        } else if (c.parede === `esquerda`) {
          return new X(_, g, h);
        } else {
          return new X(n.largura * $ - _, g, h);
        }
      };
      t.atualizarProjecaoSolo(d(0, 0, 0).x, c.y * $, d(0, 0, 0).z, c.largura * $, c.altura * $, c.profundidade * $, (c.parede === `esquerda` ? 90 : c.parede === `direita` ? -90 : 0) + (c.rotacao ?? 0));
      if (ne === `mover`) {
        let e = d(0, 0, 0);
        t.alcas[0].position.copy(d(0, 1, 0).addScaledVector(UE, 0.12));
        t.alcas[0].visible = a;
        t.alcas[0].userData = {
          tipo: `mover-altura`,
          id: c.id
        };
        let n = d(1, 0, 0);
        let r = n.clone().sub(e).normalize();
        t.alcas[5].position.copy(n.addScaledVector(r, 0.1));
        t.alcas[5].visible = a;
        t.alcas[5].userData = {
          tipo: `mover-x`,
          id: c.id
        };
        let i = d(0, 0, 1);
        let o = i.clone().sub(e).normalize();
        t.alcas[6].position.copy(i.addScaledVector(o, 0.1));
        t.alcas[6].visible = a;
        t.alcas[6].userData = {
          tipo: `mover-z`,
          id: c.id
        };
        for (let e = 1; e < 5; e++) {
          t.alcas[e].visible = false;
        }
      } else {
        t.alcas[0].position.copy(d(1, 1, 1));
        t.alcas[0].visible = a;
        t.alcas[0].userData = {
          tipo: `altura`,
          id: c.id,
          sinalY: 1
        };
        t.alcas[1].position.copy(d(1, -1, 1));
        t.alcas[1].visible = a;
        t.alcas[1].userData = {
          tipo: `largura`,
          id: c.id,
          sinalX: 1
        };
        t.alcas[2].position.copy(d(-1, -1, 1));
        t.alcas[2].visible = a;
        t.alcas[2].userData = {
          tipo: `profundidade`,
          id: c.id
        };
        t.alcas[3].position.copy(d(-1, 1, 1));
        t.alcas[3].visible = a;
        t.alcas[3].userData = {
          tipo: `geral`,
          id: c.id,
          sinalX: -1,
          sinalY: 1
        };
        let e = d(0, 1, 0).addScaledVector(UE, 0.16);
        t.alcas[4].position.copy(e);
        t.alcas[4].visible = a;
        t.alcas[4].userData = {
          tipo: `rotacao`,
          id: c.id
        };
        t.alcas[5].visible = false;
        t.alcas[6].visible = false;
      }
      return;
    }
    let l = e.modulos.find(e => e.id === r);
    if (!l || l.visivel === false) {
      t.contornoSelecionado.visible = false;
      for (let e of t.alcas) {
        e.visible = false;
      }
      t.linhasCotas.geometry.setDrawRange(0, 0);
      for (let e of t.rotulos) {
        e.style.display = `none`;
      }
      t.projecaoSoloGroup.visible = false;
      return;
    }
    t.contornoSelecionado.scale.set(l.largura * $, l.altura * $, l.profundidade * $);
    t.contornoSelecionado.position.set(l.x * $, l.y * $, l.z * $);
    t.contornoSelecionado.rotation.y = x_.degToRad(l.rotacao);
    t.contornoSelecionado.visible = true;
    if (l.bloqueado) {
      for (let e of t.alcas) {
        e.visible = false;
      }
      t.linhasCotas.geometry.setDrawRange(0, 0);
      for (let e of t.rotulos) {
        e.style.display = `none`;
      }
      t.projecaoSoloGroup.visible = false;
      return;
    }
    t.atualizarProjecaoSolo(l.x * $, l.y * $, l.z * $, l.largura * $, l.altura * $, l.profundidade * $, l.rotacao);
    if (ne === `mover`) {
      let e = nD(l, 0, 0, 0);
      t.alcas[0].position.copy(nD(l, 0, 1, 0).addScaledVector(UE, 0.12));
      t.alcas[0].visible = a;
      t.alcas[0].userData = {
        tipo: `mover-altura`,
        id: l.id
      };
      let n = nD(l, 1, 0, 0);
      let r = n.clone().sub(e).normalize();
      t.alcas[5].position.copy(n.addScaledVector(r, 0.1));
      t.alcas[5].visible = a;
      t.alcas[5].userData = {
        tipo: `mover-x`,
        id: l.id
      };
      let i = nD(l, 0, 0, 1);
      let o = i.clone().sub(e).normalize();
      t.alcas[6].position.copy(i.addScaledVector(o, 0.1));
      t.alcas[6].visible = a;
      t.alcas[6].userData = {
        tipo: `mover-z`,
        id: l.id
      };
      for (let e = 1; e < 5; e++) {
        t.alcas[e].visible = false;
      }
    } else {
      t.alcas[0].position.copy(nD(l, 1, 1, 1));
      t.alcas[0].visible = a;
      t.alcas[0].userData = {
        tipo: `altura`,
        id: l.id,
        sinalY: 1
      };
      t.alcas[1].position.copy(nD(l, 1, -1, 1));
      t.alcas[1].visible = a;
      t.alcas[1].userData = {
        tipo: `largura`,
        id: l.id,
        sinalX: 1
      };
      t.alcas[2].position.copy(nD(l, -1, -1, 1));
      t.alcas[2].visible = a;
      t.alcas[2].userData = {
        tipo: `profundidade`,
        id: l.id
      };
      t.alcas[3].position.copy(nD(l, -1, 1, 1));
      t.alcas[3].visible = a;
      t.alcas[3].userData = {
        tipo: `geral`,
        id: l.id,
        sinalX: -1,
        sinalY: 1
      };
      t.alcas[4].position.copy(nD(l, 0, 1, 1).addScaledVector(UE, 0.16));
      t.alcas[4].visible = a;
      t.alcas[4].userData = {
        tipo: `rotacao`,
        id: l.id
      };
      t.alcas[5].visible = false;
      t.alcas[6].visible = false;
    }
    if (pe) {
      let {
        dirX: e,
        dirZ: n
      } = tD(l);
      let r = [];
      function i(e, t) {
        r.push(e.x, e.y, e.z, t.x, t.y, t.z);
      }
      let a = nD(l, -1, -1, 1);
      let o = nD(l, 1, -1, 1);
      let c = nD(l, -1, 1, 1);
      let u = nD(l, 1, 1, 1);
      let d = nD(l, 1, 1, -1);
      let f = nD(l, -1, 1, -1);
      let p = t.linhasCotas.material;
      if (N === `tecnica`) {
        p.color.setHex(s ? 10592682 : 4144966);
        let r = 0.08;
        let u = new X(0, -1, 0);
        let d = a.clone().addScaledVector(u, r);
        let m = o.clone().addScaledVector(u, r);
        i(a, a.clone().addScaledVector(u, 0.1));
        i(o, o.clone().addScaledVector(u, 0.1));
        i(d, m);
        let h = e.clone().add(new X(0, 1, 0)).normalize().multiplyScalar(0.015);
        i(d.clone().sub(h), d.clone().add(h));
        i(m.clone().sub(h), m.clone().add(h));
        let g = e.clone().negate();
        let _ = a.clone().addScaledVector(g, r);
        let v = c.clone().addScaledVector(g, r);
        i(a, a.clone().addScaledVector(g, 0.1));
        i(c, c.clone().addScaledVector(g, 0.1));
        i(_, v);
        let y = e.clone().add(new X(0, 1, 0)).normalize().multiplyScalar(0.015);
        i(_.clone().sub(y), _.clone().add(y));
        i(v.clone().sub(y), v.clone().add(y));
        let b = new X(0, 1, 0).addScaledVector(e, -1).normalize();
        let x = c.clone().addScaledVector(b, r);
        let S = f.clone().addScaledVector(b, r);
        i(c, c.clone().addScaledVector(b, 0.1));
        i(f, f.clone().addScaledVector(b, 0.1));
        i(x, S);
        let C = n.clone().add(new X(0, 1, 0)).normalize().multiplyScalar(0.015);
        i(x.clone().sub(C), x.clone().add(C));
        i(S.clone().sub(C), S.clone().add(C));
        t.posicoesRotulos[0] = d.clone().lerp(m, 0.5).addScaledVector(u, 0.018);
        t.posicoesRotulos[1] = _.clone().lerp(v, 0.5).addScaledVector(g, 0.024);
        t.posicoesRotulos[2] = x.clone().lerp(S, 0.5).addScaledVector(b, 0.02);
        let w = e => {
          let t = Math.round(e * 10) / 10;
          if (t % 1 == 0) {
            return t.toFixed(0);
          } else {
            return t.toFixed(1);
          }
        };
        let T = [w(l.largura), w(l.altura), w(l.profundidade)];
        t.rotulos.forEach((e, t) => {
          e.className = `pointer-events-none absolute select-none text-[11px] font-mono font-bold text-stone-800 dark:text-stone-100 bg-white/75 dark:bg-stone-900/75 px-1 py-0.5 rounded shadow-xs border border-stone-200/70 dark:border-stone-700/70 transition-opacity duration-150 -translate-x-1/2 -translate-y-1/2 backdrop-blur-[1px]`;
          e.textContent = T[t];
          e.style.display = `block`;
        });
      } else {
        p.color.setHex(VE);
        let n = new X(0, -0.05, 0);
        let r = e.clone().multiplyScalar(-0.05);
        let s = new X(0, 0.05, 0);
        let f = a.clone().add(n);
        let m = o.clone().add(n);
        i(f, m);
        let h = a.clone().add(r);
        let g = c.clone().add(r);
        i(h, g);
        let _ = u.clone().add(s);
        let v = d.clone().add(s);
        i(_, v);
        t.posicoesRotulos[0] = f.clone().lerp(m, 0.5).add(new X(0, -0.02, 0));
        t.posicoesRotulos[1] = h.clone().lerp(g, 0.5).add(e.clone().multiplyScalar(-0.035));
        t.posicoesRotulos[2] = _.clone().lerp(v, 0.5).add(new X(0, 0.02, 0));
        let y = [`${Math.round(l.largura)} mm`, `${Math.round(l.altura)} mm`, `${Math.round(l.profundidade)} mm`];
        t.rotulos.forEach((e, t) => {
          e.className = `pointer-events-none absolute select-none rounded border border-stone-200 bg-white/95 px-1.5 py-0.5 text-[11px] font-mono font-medium text-emerald-700 shadow-md backdrop-blur transition-opacity duration-150 -translate-x-1/2 -translate-y-1/2 dark:border-stone-700 dark:bg-stone-900/95 dark:text-emerald-400`;
          e.textContent = y[t];
          e.style.display = `block`;
        });
      }
      let m = t.linhasCotas.geometry.getAttribute(`position`);
      t.bufferLinhas.set(r);
      m.needsUpdate = true;
      t.linhasCotas.geometry.setDrawRange(0, r.length / 3);
    } else {
      t.linhasCotas.geometry.setDrawRange(0, 0);
      for (let e of t.rotulos) {
        e.style.display = `none`;
      }
    }
  }, [e, r, i, ne, ae, se, le, de, pe, N, a, s, Ee]);
                                                                                          return <div className={U(`relative h-full w-full select-none overflow-hidden`, l)}><div ref={O} className={`h-full w-full cursor-grab active:cursor-grabbing`} /><div ref={A} className={`pointer-events-none absolute inset-0 overflow-hidden`} />{be && <L.Fragment><div className={`fixed inset-0 z-[100]`} onClick={() => xe(null)} onContextMenu={e => {
        e.preventDefault();
        xe(null);
      }} /><div className={`fixed z-[101] min-w-[180px] rounded-xl border border-stone-200/80 bg-white/95 py-1.5 shadow-2xl backdrop-blur-lg dark:border-stone-700/80 dark:bg-stone-900/95`} style={{
        left: be.x,
        top: be.y
      }}>{be.targetType === `modulo` && <L.Fragment><button type={`button`} className={`flex w-full items-center gap-2.5 px-3 py-2 text-left text-[13px] text-stone-700 transition-colors hover:bg-stone-100 dark:text-stone-300 dark:hover:bg-stone-800`} onClick={() => {
            re(`mover`);
            xe(null);
          }}><Ln className={`h-3.5 w-3.5 text-stone-500`} />{` Mover`}</button><button type={`button`} className={`flex w-full items-center gap-2.5 px-3 py-2 text-left text-[13px] text-stone-700 transition-colors hover:bg-stone-100 dark:text-stone-300 dark:hover:bg-stone-800`} onClick={() => {
            re(`editar`);
            xe(null);
          }}><Wn className={`h-3.5 w-3.5 text-stone-500`} />{` Editar / Deformar`}</button><button type={`button`} className={`flex w-full items-center gap-2.5 px-3 py-2 text-left text-[13px] text-stone-700 transition-colors hover:bg-stone-100 dark:text-stone-300 dark:hover:bg-stone-800`} onClick={() => {
            g(be.targetId);
            xe(null);
          }}><$n className={`h-3.5 w-3.5 text-stone-500`} />{` Girar 90°`}</button><button type={`button`} className={`flex w-full items-center gap-2.5 px-3 py-2 text-left text-[13px] text-stone-700 transition-colors hover:bg-stone-100 dark:text-stone-300 dark:hover:bg-stone-800`} onClick={() => {
            T?.(be.targetId);
            xe(null);
          }}><$t className={`h-3.5 w-3.5 text-stone-500`} />{` Duplicar`}</button>{(() => {
            let t = e.modulos.find(e => e.id === be.targetId)?.bloqueado ?? false;
                        return <button type={`button`} className={`flex w-full items-center gap-2.5 px-3 py-2 text-left text-[13px] text-stone-700 transition-colors hover:bg-stone-100 dark:text-stone-300 dark:hover:bg-stone-800`} onClick={() => {
              E?.(be.targetId, !t);
              xe(null);
            }}>{t ? <On className={`h-3.5 w-3.5 text-stone-500`} /> : <_Component57 className={`h-3.5 w-3.5 text-stone-500`} />}{t ? `Desbloquear` : `Bloquear`}</button>;
          })()}<div className={`my-1 h-px bg-stone-200 dark:bg-stone-700`} /><button type={`button`} className={`flex w-full items-center gap-2.5 px-3 py-2 text-left text-[13px] text-red-600 transition-colors hover:bg-red-50 dark:text-red-400 dark:hover:bg-red-950/30`} onClick={() => {
            C?.(be.targetId);
            xe(null);
          }}><_Component26 className={`h-3.5 w-3.5`} />{` Excluir`}</button></L.Fragment>}{be.targetType === `componente` && <L.Fragment><button type={`button`} className={`flex w-full items-center gap-2.5 px-3 py-2 text-left text-[13px] text-stone-700 transition-colors hover:bg-stone-100 dark:text-stone-300 dark:hover:bg-stone-800`} onClick={() => {
            re(`mover`);
            xe(null);
          }}><Ln className={`h-3.5 w-3.5 text-stone-500`} />{` Mover`}</button><button type={`button`} className={`flex w-full items-center gap-2.5 px-3 py-2 text-left text-[13px] text-stone-700 transition-colors hover:bg-stone-100 dark:text-stone-300 dark:hover:bg-stone-800`} onClick={() => {
            re(`editar`);
            xe(null);
          }}><Wn className={`h-3.5 w-3.5 text-stone-500`} />{` Editar / Deformar`}</button><button type={`button`} className={`flex w-full items-center gap-2.5 px-3 py-2 text-left text-[13px] text-stone-700 transition-colors hover:bg-stone-100 dark:text-stone-300 dark:hover:bg-stone-800`} onClick={() => {
            _?.(be.targetId);
            xe(null);
          }}><$n className={`h-3.5 w-3.5 text-stone-500`} />{` Girar 90°`}</button>{(() => {
            let t = (e.componentes ?? []).find(e => e.id === be.targetId)?.bloqueado ?? false;
                        return <button type={`button`} className={`flex w-full items-center gap-2.5 px-3 py-2 text-left text-[13px] text-stone-700 transition-colors hover:bg-stone-100 dark:text-stone-300 dark:hover:bg-stone-800`} onClick={() => {
              D?.(be.targetId, !t);
              xe(null);
            }}>{t ? <On className={`h-3.5 w-3.5 text-stone-500`} /> : <_Component57 className={`h-3.5 w-3.5 text-stone-500`} />}{t ? `Desbloquear` : `Bloquear`}</button>;
          })()}<div className={`my-1 h-px bg-stone-200 dark:bg-stone-700`} /><button type={`button`} className={`flex w-full items-center gap-2.5 px-3 py-2 text-left text-[13px] text-red-600 transition-colors hover:bg-red-50 dark:text-red-400 dark:hover:bg-red-950/30`} onClick={() => {
            w?.(be.targetId);
            xe(null);
          }}><_Component26 className={`h-3.5 w-3.5`} />{` Excluir`}</button></L.Fragment>}</div></L.Fragment>}<div className={`absolute top-3 left-3 right-3 z-20 flex flex-wrap items-center gap-1 rounded-xl border border-stone-200/80 bg-white/90 p-1.5 shadow-xl backdrop-blur-md sm:top-4 sm:left-4 sm:right-auto sm:gap-1.5 dark:border-stone-800/80 dark:bg-stone-900/90`}><div className={`flex items-center rounded-lg bg-stone-100 p-0.5 dark:bg-stone-800`}><button type={`button`} title={`Câmera 3D Perspectiva`} onClick={() => j(`perspectiva`)} className={U(`flex h-8 w-8 items-center justify-center rounded-md text-xs font-semibold transition-all`, te === `perspectiva` ? `bg-white text-emerald-600 shadow-sm dark:bg-stone-700 dark:text-emerald-400` : `text-stone-600 hover:text-stone-900 dark:text-stone-400 dark:hover:text-stone-100`)}><Lt className={`h-4 w-4`} /></button><button type={`button`} title={`Câmera 3D Ortográfica (CAD Isométrica)`} onClick={() => j(`ortografica`)} className={U(`flex h-8 w-8 items-center justify-center rounded-md text-xs font-semibold transition-all`, te === `ortografica` ? `bg-white text-emerald-600 shadow-sm dark:bg-stone-700 dark:text-emerald-400` : `text-stone-600 hover:text-stone-900 dark:text-stone-400 dark:hover:text-stone-100`)}><Mn className={`h-4 w-4`} /></button></div><div className={`h-5 w-[1px] bg-stone-200 dark:bg-stone-700`} /><div className={`flex items-center rounded-lg bg-stone-100 p-0.5 dark:bg-stone-800`}><button type={`button`} title={`Modo Mover (Bloqueia mudança de tamanho - move pelo solo e cenário)`} onClick={() => re(`mover`)} className={U(`flex items-center gap-1.5 rounded-md px-2.5 py-1 text-xs font-semibold transition-all`, ne === `mover` ? `bg-emerald-600 text-white shadow-sm` : `text-stone-600 hover:text-stone-900 dark:text-stone-400 dark:hover:text-stone-100`)}><Ln className={`h-4 w-4`} /><span>{`Mover`}</span></button><button type={`button`} title={`Modo Editar / Deformar (Ativa os 4 pontos de medidas e profundidade)`} onClick={() => re(`editar`)} className={U(`flex items-center gap-1.5 rounded-md px-2.5 py-1 text-xs font-semibold transition-all`, ne === `editar` ? `bg-emerald-600 text-white shadow-sm` : `text-stone-600 hover:text-stone-900 dark:text-stone-400 dark:hover:text-stone-100`)}><_Component58 className={`h-4 w-4`} /><span>{`Editar / Deformar`}</span></button></div><div className={`h-5 w-[1px] bg-stone-200 dark:bg-stone-700`} /><div className={`flex items-center gap-1`}>{[`perspectiva`, `frontal`, `superior`, `lateral`].map(e => <button type={`button`} title={`Vista ${e.charAt(0).toUpperCase() + e.slice(1)}`} onClick={() => z.current.onMudarVista?.(e)} className={U(`rounded-md px-2.5 py-1 text-xs font-medium capitalize transition-colors`, o === e ? `bg-emerald-600 text-white shadow-sm` : `bg-transparent text-stone-700 hover:bg-stone-100 dark:text-stone-300 dark:hover:bg-stone-800`)} key={e}>{e === `perspectiva` ? `3D` : e === `superior` ? `Topo` : e}</button>)}</div><div className={`h-5 w-[1px] bg-stone-200 dark:bg-stone-700`} /><div className={`flex items-center gap-1`}><button type={`button`} title={`Grade Modular de Piso (Quadriculado de Dimensão e Projeção no Solo)`} onClick={() => ie(e => !e)} className={U(`flex h-8 w-8 items-center justify-center rounded-lg border transition-all`, M ? `border-emerald-500 bg-emerald-50 text-emerald-700 dark:bg-emerald-950/40 dark:text-emerald-400` : `border-transparent text-stone-500 hover:bg-stone-100 dark:hover:bg-stone-800`)}><_Component59 className={`h-4 w-4`} /></button><button type={`button`} title={`Modo Contorno / Arestas Estruturais`} onClick={() => oe(e => !e)} className={U(`flex h-8 w-8 items-center justify-center rounded-lg border transition-all`, ae ? `border-emerald-500 bg-emerald-50 text-emerald-700 dark:bg-emerald-950/40 dark:text-emerald-400` : `border-transparent text-stone-500 hover:bg-stone-100 dark:hover:bg-stone-800`)}><_Component60 className={`h-4 w-4`} /></button><button type={`button`} title={`Modo Raio-X / Transparência (Ver interior e divisórias)`} onClick={() => ce(e => !e)} className={U(`flex h-8 w-8 items-center justify-center rounded-lg border transition-all`, se ? `border-emerald-500 bg-emerald-50 text-emerald-700 dark:bg-emerald-950/40 dark:text-emerald-400` : `border-transparent text-stone-500 hover:bg-stone-100 dark:hover:bg-stone-800`)}><_Component13 className={`h-4 w-4`} /></button><button type={`button`} title={`Abrir / Fechar Portas e Gavetas`} onClick={() => ue(e => !e)} className={U(`flex h-8 w-8 items-center justify-center rounded-lg border transition-all`, le ? `border-emerald-500 bg-emerald-50 text-emerald-700 dark:bg-emerald-950/40 dark:text-emerald-400` : `border-transparent text-stone-500 hover:bg-stone-100 dark:hover:bg-stone-800`)}><_Component61 className={`h-4 w-4`} /></button><button type={`button`} title={`Mostrar / Ocultar Fixadores e Minifix`} onClick={() => fe(e => !e)} className={U(`flex h-8 w-8 items-center justify-center rounded-lg border transition-all`, de ? `border-amber-500 bg-amber-50 text-amber-700 dark:bg-amber-950/40 dark:text-amber-400` : `border-transparent text-stone-500 hover:bg-stone-100 dark:hover:bg-stone-800`)}><_Component17 className={`h-4 w-4`} /></button><div className={`flex items-center rounded-lg border border-stone-200/80 bg-stone-50/90 p-0.5 dark:border-stone-700/80 dark:bg-stone-800/90`}><button type={`button`} title={pe ? `Desativar Cotas 3D` : `Ativar Cotas e Dimensões 3D`} onClick={() => me(e => !e)} className={U(`flex h-7 w-7 items-center justify-center rounded-md transition-all`, pe ? `bg-emerald-600 text-white shadow-xs` : `text-stone-500 hover:text-stone-900 dark:text-stone-400 dark:hover:text-stone-100`)}><_Component36 className={`h-3.5 w-3.5`} /></button>{pe && <div className={`flex items-center gap-0.5 border-l border-stone-200 pl-1 pr-0.5 dark:border-stone-700`}><button type={`button`} title={`Cotas Técnicas CAD (Linhas de chamada, arestas e delimitadores 45°)`} onClick={() => he(`tecnica`)} className={U(`rounded px-1.5 py-0.5 text-[10.5px] font-semibold transition-all`, N === `tecnica` ? `bg-white font-bold text-emerald-700 shadow-xs dark:bg-stone-700 dark:text-emerald-400` : `text-stone-500 hover:text-stone-800 dark:text-stone-400 dark:hover:text-stone-200`)}>{`CAD`}</button><button type={`button`} title={`Cotas Flutuantes (Badges 3D arredondados)`} onClick={() => he(`flutuante`)} className={U(`rounded px-1.5 py-0.5 text-[10.5px] font-semibold transition-all`, N === `flutuante` ? `bg-white font-bold text-emerald-700 shadow-xs dark:bg-stone-700 dark:text-emerald-400` : `text-stone-500 hover:text-stone-800 dark:text-stone-400 dark:hover:text-stone-200`)}>{`Flutuante`}</button></div>}</div><button type={`button`} title={`Alinhamento Magnético (Snap nas paredes e módulos)`} onClick={() => _e(e => !e)} className={U(`flex h-8 w-8 items-center justify-center rounded-lg border transition-all`, ge ? `border-indigo-500 bg-indigo-50 text-indigo-700 dark:bg-indigo-950/40 dark:text-indigo-400` : `border-transparent text-stone-500 hover:bg-stone-100 dark:hover:bg-stone-800`)}><_Component62 className={`h-4 w-4`} /></button><button type={`button`} title={`Iluminação de Estúdio & Sombras`} onClick={() => ye(e => !e)} className={U(`flex h-8 w-8 items-center justify-center rounded-lg border transition-all`, ve ? `border-amber-500 bg-amber-50 text-amber-600 dark:bg-amber-950/40 dark:text-amber-400` : `border-transparent text-stone-500 hover:bg-stone-100 dark:hover:bg-stone-800`)}><En className={`h-4 w-4`} /></button></div><div className={`h-5 w-[1px] bg-stone-200 dark:bg-stone-700`} /><_Component63 cenario={c} onMudar={x} /></div></div>;
}
function _Component90({
  largura: e,
  segmentos: t,
  className: n
}) {
  let r = t => `${Math.min(100, Math.max(0, t / e * 100))}%`;
            return <div className={U(`relative h-14 select-none`, n)}><span className={`absolute left-0 top-0 text-[10px] font-medium tabular-nums text-muted-foreground`}>{Math.round(e)}{` mm`}</span><div className={`absolute inset-x-0 top-6 h-px bg-border`} /><span className={`absolute left-0 top-4 h-3 w-px bg-border`} /><span className={`absolute right-0 top-4 h-3 w-px bg-border`} />{t.map(t => {
      let n = t.fim - t.inicio;
      let i = n / e > 0.07;
                        return <k.Fragment key={t.id}><span className={`absolute top-[18px] h-[10px] w-px bg-border`} style={{
          left: r(t.inicio)
        }} /><span className={`absolute top-[18px] h-[10px] w-px bg-border`} style={{
          left: r(t.fim)
        }} />{i && <span className={`absolute top-8 -translate-x-1/2 whitespace-nowrap text-[10px] tabular-nums text-muted-foreground`} style={{
          left: r((t.inicio + t.fim) / 2)
        }} title={t.nome}>{Math.round(n)}</span>}</k.Fragment>;
    })}</div>;
}
function _Component86({
  modulos: e,
  carregando: t,
  semeando: n,
  aoAdicionar: r,
  aoSemear: i,
  aoCriar: a,
  aoDesenhar: o,
  aoRemover: s
}) {
  let [c, l] = (0, k.useState)(`todos`);
  let u = (0, k.useMemo)(() => c === `todos` ? e : e.filter(e => e.categoria === c), [e, c]);
  let d = (0, k.useMemo)(() => {
    let e = new Map();
    for (let t of u) {
      e.set(t.categoria, [...(e.get(t.categoria) ?? []), t]);
    }
    return yi.filter(t => e.has(t)).map(t => ({
      categoria: t,
      itens: e.get(t) ?? []
    }));
  }, [u]);
                                        return <aside className={`flex h-full w-full flex-col gap-3 overflow-hidden`}><div className={`flex items-center justify-between gap-2`}><span className={`text-xs font-semibold text-muted-foreground uppercase tracking-wider`}>{`Módulos`}</span><Lo align={`right`} trigger={<span className={`inline-flex select-none items-center justify-center whitespace-nowrap rounded-md text-xs font-medium border border-input bg-background shadow-xs hover:bg-accent hover:text-accent-foreground h-8 px-2.5 gap-1 cursor-pointer transition-colors`} title={`Novo módulo`}><_Component10 className={`h-3.5 w-3.5`} />{`Novo módulo`}<Wt className={`h-3 w-3 opacity-60 ml-0.5`} /></span>} items={[{
        label: `Desenhar módulo 2D (Recomendado)`,
        icon: <Un className={`h-4 w-4 text-primary`} />,
        onSelect: () => o?.()
      }, {
        label: `Formulário rápido`,
        icon: <_Component10 className={`h-4 w-4 text-stone-500`} />,
        onSelect: () => a()
      }]} /></div><_Component31 value={c} onChange={e => l(e.target.value)}><option value={`todos`}>{`Todas as categorias`}</option>{yi.map(e => <option value={e} key={e}>{vi[e]}</option>)}</_Component31><div className={`flex-1 overflow-y-auto pr-1`}>{t ? <div className={`space-y-2`}><Ks className={`h-20`} /><Ks className={`h-20`} /><Ks className={`h-20`} /></div> : e.length === 0 ? <Ws icon={<Tn className={`h-4 w-4`} />} title={`Biblioteca vazia`} description={`Carregue a biblioteca padrão de módulos para começar.`} action={<G size={`sm`} onClick={i} disabled={n}><_Component17 className={`h-4 w-4`} />{n ? `Carregando...` : `Carregar padrão`}</G>} /> : <div className={`space-y-4`}>{d.map(e => <div className={`space-y-2`} key={e.categoria}><p className={`text-[11px] font-semibold text-muted-foreground`}>{vi[e.categoria]}</p><div className={`grid grid-cols-2 gap-2`}>{e.itens.map(e => <div className={U(`group relative flex flex-col gap-2 rounded-[10px] border border-border bg-card p-2 text-left transition-colors duration-150 cursor-grab active:cursor-grabbing hover:border-primary/40`)} key={e.id}><button type={`button`} draggable={true} onDragStart={t => {
                NE(e);
                t.dataTransfer.setData(`application/json`, JSON.stringify(e));
                t.dataTransfer.effectAllowed = `copy`;
              }} onDragEnd={() => {
                NE(null);
              }} onClick={() => r(e)} className={`flex flex-col gap-2 w-full text-left focus-visible:outline-none`} title={`Adicionar ${e.nome} (ou arraste para o 3D)`}><span className={`grid h-14 place-items-center text-foreground`}><XT modulo={e} className={`max-h-14`} /></span><span className={`min-w-0`}><span className={`block truncate text-[11px] font-medium leading-tight`}>{e.nome}</span><span className={`numero block text-[10px] text-muted-foreground`}>{Math.round(Number(e.largura_mm))}{` × `}{Math.round(Number(e.altura_mm))}</span></span></button>{s && <button type={`button`} title={`Excluir ${e.nome} da biblioteca`} onClick={t => {
                t.stopPropagation();
                s(e);
              }} className={`absolute top-1.5 right-1.5 h-6 w-6 rounded-md bg-background/90 hover:bg-rose-600 hover:text-white text-muted-foreground opacity-0 group-hover:opacity-100 transition-all flex items-center justify-center shadow-xs z-10 cursor-pointer border border-border/60 hover:border-rose-600`}><_Component26 className={`h-3 w-3`} /></button>}</div>)}</div></div>)}</div>}</div></aside>;
}
var lD = {
  porta: <_Component64 className={`h-4 w-4`} />,
  janela: <_Component65 className={`h-4 w-4`} />,
  cortina: <Tr className={`h-4 w-4`} />,
  tomada: <Kn className={`h-4 w-4`} />,
  interruptor: <_Component66 className={`h-4 w-4`} />,
  ponto_rede: <_Component67 className={`h-4 w-4`} />,
  ar_condicionado: <At className={`h-4 w-4`} />,
  tv: <_Component68 className={`h-4 w-4`} />,
  espelho: <En className={`h-4 w-4`} />,
  coifa: <Rt className={`h-4 w-4`} />,
  torneira: <_Component69 className={`h-4 w-4`} />,
  cuba: <_Component70 className={`h-4 w-4`} />,
  vaso: <Zn className={`h-4 w-4`} />,
  box: <Pn className={`h-4 w-4`} />,
  geladeira: <Zn className={`h-4 w-4`} />,
  fogao: <_Component71 className={`h-4 w-4`} />,
  cama_casal: <Pt className={`h-4 w-4`} />,
  cama_solteiro: <Ft className={`h-4 w-4`} />
};
var uD = [{
  valor: `fundo`,
  rotulo: `Parede do fundo`
}, {
  valor: `esquerda`,
  rotulo: `Parede esquerda`
}, {
  valor: `direita`,
  rotulo: `Parede direita`
}];
function _Component87({
  paredeAtiva: e,
  aoMudarParede: t,
  aoAdicionarComponente: n,
  aoRemoverComponente: r,
  aoSelecionarComponente: i,
  componenteSelecionadoId: a,
  componentes: o,
  aoCarregarModelo: s,
  larguraParede: c,
  tipoComodo: l,
  aoAlternarVisivelComponente: u,
  aoAlternarBloqueadoComponente: d
}) {
  let f = vm[l];
                                return <div className={`flex h-full flex-col gap-4 overflow-y-auto pr-1`}><section className={`space-y-2`}><p className={`text-[11px] font-semibold uppercase tracking-wider text-muted-foreground`}>{`Ambiente`}</p><p className={`text-[11px] text-muted-foreground`}>{`Troca paredes, piso e medidas. Os móveis e as peças que você já colocou são mantidos.`}</p><div className={`grid gap-2`}>{rh.map(e => {
          let t = UT.find(t => t.id === e.cenario);
          let n = BT(t?.paredePadrao);
          let r = VT(t?.pisoPadrao);
                                                                                          return <button type={`button`} onClick={() => s(e)} className={`flex gap-2.5 rounded-[10px] border border-border bg-card p-2.5 text-left transition-colors hover:border-primary/50 hover:bg-accent/50 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring/35`} key={e.id}><span className={`flex h-14 w-10 shrink-0 flex-col overflow-hidden rounded border border-border`} aria-hidden={true}><span className={`h-[55%] w-full`} style={n ? {
                backgroundImage: `url(${n.url})`,
                backgroundSize: `cover`,
                backgroundPosition: `center`
              } : {
                backgroundColor: t?.parede ?? `#e8e4dd`
              }} /><span className={`h-[45%] w-full border-t border-border/60`} style={r ? {
                backgroundImage: `url(${r.url})`,
                backgroundSize: `cover`,
                backgroundPosition: `center`
              } : {
                backgroundColor: t?.pisoCor ?? `#ded4c4`
              }} /></span><span className={`min-w-0`}><span className={`block truncate text-[12px] font-semibold text-foreground`}>{e.nome}</span><span className={`numero mt-0.5 block text-[10px] text-muted-foreground`}>{e.comodo.largura / 10}{` × `}{e.comodo.profundidade / 10}{` × `}{e.comodo.altura / 10}{` cm`}</span><span className={`mt-0.5 block text-[10px] text-muted-foreground`}>{e.descricao}</span></span></button>;
        })}</div></section><section className={`space-y-2 border-t border-border pt-3`}><p className={`text-[11px] font-semibold uppercase tracking-wider text-muted-foreground`}>{`Peças de `}{Ne[l].toLowerCase()}</p><p className={`text-[11px] text-muted-foreground`}>{`Só as peças deste cômodo. Arraste na cena depois de adicionar; móveis ficam na Biblioteca.`}</p><label className={`flex items-center gap-2 text-[11px] text-muted-foreground`}>{`Instalar em`}<select value={e} onChange={e => t(e.target.value)} className={`h-7 flex-1 rounded-md border border-input bg-background px-2 text-[12px] text-foreground`}>{uD.map(e => <option value={e.valor} key={e.valor}>{e.rotulo}{` (`}{Math.round(c / 10)}{` cm)`}</option>)}</select></label><div className={`grid grid-cols-2 gap-2`}>{f.map(e => {
          let t = _m[e];
                                                            return <button type={`button`} onClick={() => n(e)} title={`Adicionar ${t.nome} (${t.largura} × ${t.altura} mm)`} className={`flex items-center gap-2 rounded-lg border border-border bg-card px-2 py-1.5 text-left transition-colors hover:border-primary/50 hover:bg-accent/50 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring/35`} key={e}><span className={`text-muted-foreground`}>{lD[e]}</span><span className={`min-w-0`}><span className={`block truncate text-[11px] font-medium text-foreground`}>{t.nome}</span><span className={`numero block text-[10px] text-muted-foreground`}>{t.largura}{` × `}{t.altura}{` mm`}</span></span></button>;
        })}</div></section>{o.length > 0 && <section className={`space-y-2 border-t border-border pt-3`}><p className={`text-[11px] font-semibold uppercase tracking-wider text-muted-foreground`}>{`Peças instaladas`}</p><div className={`grid gap-1`}>{o.map(e => {
          let t = e.id === a;
          let n = e.visivel !== false;
          let o = e.bloqueado === true;
                                                                                return <div className={U(`flex items-center gap-1 rounded-md border px-2 py-1.5 transition-colors duration-150`, t ? `border-primary bg-accent` : `border-border hover:bg-accent/40`)} key={e.id}><button type={`button`} onClick={() => i(e.id)} className={`min-w-0 flex-1 text-left focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring/35`}><span className={`block truncate text-[12px] font-medium text-foreground`}>{_m[e.tipo].nome}</span><span className={`numero block text-[10px] text-muted-foreground`}>{e.parede}{` · x `}{Math.round(e.x)}{` · y `}{Math.round(e.y)}{` mm`}</span></button><button type={`button`} onClick={() => u?.(e.id)} aria-label={n ? `Ocultar elemento` : `Mostrar elemento`} title={n ? `Ocultar` : `Mostrar`} className={`rounded-md p-1.5 text-muted-foreground transition-colors duration-150 hover:bg-accent hover:text-foreground`}>{n ? <_Component13 className={`h-3.5 w-3.5`} /> : <_Component12 className={`h-3.5 w-3.5`} />}</button><button type={`button`} onClick={() => d?.(e.id)} aria-label={o ? `Desbloquear elemento` : `Bloquear elemento`} title={o ? `Desbloquear` : `Bloquear`} className={U(`rounded-md p-1.5 transition-colors duration-150 hover:bg-accent hover:text-foreground`, o ? `text-foreground` : `text-muted-foreground`)}>{o ? <_Component57 className={`h-3.5 w-3.5`} /> : <On className={`h-3.5 w-3.5`} />}</button><button type={`button`} onClick={() => r(e.id)} aria-label={`Remover ${_m[e.tipo].nome}`} title={`Remover`} className={`rounded-md p-1.5 text-muted-foreground transition-colors duration-150 hover:bg-destructive/10 hover:text-destructive`}><_Component26 className={`h-3.5 w-3.5`} /></button></div>;
        })}</div></section>}</div>;
}
function _Component88({
  modulos: e,
  selecionadoId: t,
  aoSelecionar: n,
  aoAlternarVisivel: r,
  aoAlternarBloqueado: i,
  aoExcluir: a
}) {
  if (e.length === 0) {
    return <Ws className={`py-8`} title={`Nenhum elemento na cena`} description={`Adicione módulos pela aba Biblioteca para vê-los aqui.`} />;
  } else {
        return <ul className={`divide-y divide-border overflow-hidden rounded-[10px] border border-border`}>{e.map(e => {
        let o = e.id === t;
        let s = e.visivel !== false;
        let c = e.bloqueado === true;
                                                                                        return <li key={e.id}><div className={U(`flex items-center gap-2 px-2.5 py-2 transition-colors duration-150`, o ? `bg-accent` : `hover:bg-muted/50`)}><button type={`button`} onClick={() => n(e.id)} className={`flex min-w-0 flex-1 items-center gap-2 text-left`} title={`Selecionar na cena`}><span className={`h-3 w-3 shrink-0 rounded-[3px] border border-border`} style={{
                backgroundColor: e.cor
              }} aria-hidden={true} /><span className={`min-w-0`}><span className={`block truncate text-[12px] font-medium leading-tight`}>{e.nome}</span><span className={`numero block text-[10px] text-muted-foreground`}>{Za(e.largura, 0)}{` × `}{Za(e.altura, 0)}{` ×`}{` `}{Za(e.profundidade, 0)}{` mm`}</span></span></button><button type={`button`} onClick={() => r(e.id)} aria-label={s ? `Ocultar elemento` : `Mostrar elemento`} title={s ? `Ocultar` : `Mostrar`} className={`rounded-md p-1.5 text-muted-foreground transition-colors duration-150 hover:bg-accent hover:text-foreground`}>{s ? <_Component13 className={`h-3.5 w-3.5`} /> : <_Component12 className={`h-3.5 w-3.5`} />}</button><button type={`button`} onClick={() => i(e.id)} aria-label={c ? `Desbloquear elemento` : `Bloquear elemento`} title={c ? `Desbloquear` : `Bloquear`} className={U(`rounded-md p-1.5 transition-colors duration-150 hover:bg-accent hover:text-foreground`, c ? `text-foreground` : `text-muted-foreground`)}>{c ? <_Component57 className={`h-3.5 w-3.5`} /> : <On className={`h-3.5 w-3.5`} />}</button><button type={`button`} onClick={() => a(e.id)} aria-label={`Remover elemento`} title={`Remover`} className={`rounded-md p-1.5 text-muted-foreground transition-colors duration-150 hover:bg-destructive/10 hover:text-destructive`}><_Component26 className={`h-3.5 w-3.5`} /></button></div></li>;
      })}</ul>;
  }
}
function _Component77({
  corSelecionada: e,
  acabamentoCaixaria: t,
  acabamentoFrente: n,
  temSelecao: r,
  aoAplicar: i,
  aoAplicarCaixaria: a,
  aoAplicarFrente: o,
  aoAplicarTodos: s
}) {
  let [c, l] = (0, k.useState)(`madeira`);
  let [u, d] = (0, k.useState)(`tudo`);
  let f = RT.filter(e => e.categoria === c);
  function p(e) {
    if (r) {
      if (u === `caixaria` && a) {
        a(e.id);
      } else if (u === `frente` && o) {
        o(e.id);
      } else {
        i(e.id);
        a?.(e.id);
        o?.(e.id);
      }
    } else if (s) {
      s(e.id);
    }
  }
  return <div className={`space-y-4`}><div className={`flex items-center justify-between`}><p className={`text-[12px] font-bold text-foreground`}>{`Catálogo de Padrões e Texturas`}</p>{r && <span className={`inline-flex items-center gap-1 rounded-full bg-emerald-100 dark:bg-emerald-950/60 px-2 py-0.5 text-[10px] font-semibold text-emerald-700 dark:text-emerald-400 border border-emerald-300 dark:border-emerald-800`}><span className={`h-1.5 w-1.5 rounded-full bg-emerald-500`} />{`Móvel selecionado`}</span>}</div>{!r ? <div className={`rounded-[10px] border border-emerald-500/30 bg-emerald-50/50 dark:bg-emerald-950/20 p-2.5 text-[11px] text-emerald-900 dark:text-emerald-200 flex items-center gap-2`}><span className={`h-2 w-2 shrink-0 rounded-full bg-emerald-500 animate-pulse`} /><p>{`Clique em qualquer acabamento para aplicar em todos os móveis do ambiente.`}</p></div> : <div className={`flex rounded-lg bg-stone-100 p-0.5 dark:bg-stone-800`}><button type={`button`} onClick={() => d(`tudo`)} className={U(`flex-1 rounded-md py-1 text-center text-xs font-medium transition-all`, u === `tudo` ? `bg-white text-foreground shadow-sm dark:bg-stone-700` : `text-muted-foreground hover:text-foreground`)}>{`Todo Módulo`}</button><button type={`button`} onClick={() => d(`caixaria`)} className={U(`flex-1 rounded-md py-1 text-center text-xs font-medium transition-all`, u === `caixaria` ? `bg-white text-foreground shadow-sm dark:bg-stone-700` : `text-muted-foreground hover:text-foreground`)}>{`Caixaria`}</button><button type={`button`} onClick={() => d(`frente`)} className={U(`flex-1 rounded-md py-1 text-center text-xs font-medium transition-all`, u === `frente` ? `bg-white text-foreground shadow-sm dark:bg-stone-700` : `text-muted-foreground hover:text-foreground`)}>{`Frentes / Portas`}</button></div>}<div className={`flex gap-1 border-b border-border pb-1`}>{[{
        id: `madeira`,
        label: `Madeiras`
      }, {
        id: `pedra`,
        label: `Pedras/Mármores`
      }, {
        id: `monolitico`,
        label: `Unicolores`
      }, {
        id: `especial`,
        label: `Especiais`
      }].map(e => <button type={`button`} onClick={() => l(e.id)} className={U(`rounded-md px-2 py-1 text-[11px] font-semibold transition-colors`, c === e.id ? `bg-emerald-600 text-white shadow-xs` : `text-muted-foreground hover:bg-stone-100 hover:text-foreground dark:hover:bg-stone-800`)} key={e.id}>{e.label}</button>)}</div><div className={`grid grid-cols-2 gap-2.5 max-h-[340px] overflow-y-auto pr-1`}>{f.map(i => {
        let a = e === i.id || e?.toLowerCase() === i.hex.toLowerCase() || u === `caixaria` && t === i.id || u === `frente` && n === i.id;
        return <button type={`button`} onClick={() => p(i)} className={U(`group flex flex-col items-start gap-1.5 rounded-xl border p-2 text-left text-[11px] transition-all cursor-pointer shadow-xs hover:shadow-md hover:-translate-y-0.5 active:scale-95`, a ? `border-emerald-500 ring-2 ring-emerald-500/35 bg-emerald-50/20 dark:bg-emerald-950/20` : `border-border hover:border-emerald-500/60 bg-card`)} key={i.id}><div className={`relative h-14 w-full overflow-hidden rounded-[8px] border border-border/80 shadow-inner`} style={{ backgroundColor: i.hex }}>{i.texturaUrl ? <img src={i.texturaUrl} alt={i.nome} className={`h-full w-full object-cover transition-transform duration-200 group-hover:scale-105`} loading={`lazy`} onError={e => { e.currentTarget.style.display = 'none'; }} /> : null}{a && <span className={`absolute top-1.5 right-1.5 flex h-4 w-4 items-center justify-center rounded-full bg-emerald-600 text-white shadow`}><Ut className={`h-2.5 w-2.5`} /></span>}</div><div className={`w-full`}><p className={`truncate font-semibold text-foreground text-[11px]`}>{i.nome}</p><p className={`line-clamp-1 text-[10px] text-muted-foreground`}>{i.descricao || i.categoria}</p></div></button>;
      })}</div><div className={`border-t border-border pt-4`}><p className={`mb-2 text-[11px] font-bold text-muted-foreground uppercase tracking-wider`}>{`Aplicar na cena inteira`}</p><div className={`flex flex-wrap gap-2`}>{RT.slice(0, 8).map(e => <button type={`button`} onClick={() => s(e.id)} title={`Aplicar ${e.nome} em toda a cena`} className={`h-7 w-7 rounded-lg border border-border overflow-hidden transition-transform duration-150 hover:scale-115 hover:shadow-sm focus-visible:ring-2`} style={{
          backgroundColor: e.hex
        }} key={`todos-${e.id}`}>{e.texturaUrl && <img src={e.texturaUrl} alt={e.nome} className={`h-full w-full object-cover`} onError={e => { e.currentTarget.style.display = 'none'; }} />}</button>)}</div><G variant={`outline`} size={`sm`} className={`mt-3 w-full text-xs font-semibold`} onClick={() => s(`branco-tx`)}>{`Padronizar Branco TX`}</G></div></div>;
}
function _Component78({
  cena: e
}) {
  let t = (0, k.useMemo)(() => at(e), [e]);
  function n() {
    let e = t.listaPecas.map(e => [`"${e.moduloNome}"`, `"${e.nome}"`, e.tipo, e.largura, e.altura, e.espessura, e.fitaBorda.topo ? `Sim` : `Nao`, e.fitaBorda.base ? `Sim` : `Nao`, e.fitaBorda.esquerda ? `Sim` : `Nao`, e.fitaBorda.direita ? `Sim` : `Nao`, `"${e.acabamento}"`].join(`,`));
    let n = new Blob([`Modulo,Peca,Tipo,Comprimento_mm,Largura_mm,Espessura_mm,Borda_Topo,Borda_Base,Borda_Esq,Borda_Dir,Acabamento
${e.join(`
`)}`], {
      type: `text/csv;charset=utf-8;`
    });
    let r = URL.createObjectURL(n);
    let i = document.createElement(`a`);
    i.href = r;
    i.setAttribute(`download`, `plano-de-corte-${Date.now()}.csv`);
    document.body.appendChild(i);
    i.click();
    document.body.removeChild(i);
  }
                                                                                return <div className={`flex h-full w-full flex-col gap-4 overflow-y-auto pr-1 text-xs`}><div className={`grid grid-cols-3 gap-2`}><div className={`rounded-xl border border-border bg-stone-50/50 p-2.5 dark:bg-stone-900/50`}><div className={`flex items-center gap-1.5 text-muted-foreground`}><_Component60 className={`h-3.5 w-3.5 text-emerald-600`} /><span className={`text-[10px] font-medium`}>{`Chapas Est.`}</span></div><p className={`mt-1 text-base font-bold text-foreground`}>{t.chapasEstimadas}{` `}<span className={`text-[10px] font-normal text-muted-foreground`}>{`un`}</span></p><p className={`text-[9px] text-muted-foreground`}>{t.areaMDFM2}{` m² total`}</p></div><div className={`rounded-xl border border-border bg-stone-50/50 p-2.5 dark:bg-stone-900/50`}><div className={`flex items-center gap-1.5 text-muted-foreground`}><_Component72 className={`h-3.5 w-3.5 text-indigo-600`} /><span className={`text-[10px] font-medium`}>{`Fita de Borda`}</span></div><p className={`mt-1 text-base font-bold text-foreground`}>{t.metrosFitaBorda}{` `}<span className={`text-[10px] font-normal text-muted-foreground`}>{`m`}</span></p><p className={`text-[9px] text-muted-foreground`}>{`4 bordas analisadas`}</p></div><div className={`rounded-xl border border-border bg-stone-50/50 p-2.5 dark:bg-stone-900/50`}><div className={`flex items-center gap-1.5 text-muted-foreground`}><Er className={`h-3.5 w-3.5 text-amber-600`} /><span className={`text-[10px] font-medium`}>{`Total Peças`}</span></div><p className={`mt-1 text-base font-bold text-foreground`}>{t.totalPecas}{` `}<span className={`text-[10px] font-normal text-muted-foreground`}>{`itens`}</span></p><p className={`text-[9px] text-muted-foreground`}>{`Em `}{e.modulos.length}{` módulos`}</p></div></div><div className={`flex items-center justify-between`}><p className={`text-[11px] font-semibold text-muted-foreground uppercase tracking-wider`}>{`Lista Detalhada de Peças`}</p><G variant={`outline`} size={`sm`} onClick={n} className={`h-7 gap-1.5 text-[11px]`}><_Component37 className={`h-3.5 w-3.5`} />{`Exportar CSV`}</G></div><div className={`overflow-x-auto rounded-lg border border-border`}><table className={`w-full text-left text-[11px]`}><thead className={`bg-stone-100 text-stone-700 dark:bg-stone-800 dark:text-stone-300`}><tr><th className={`p-2 font-medium`}>{`Peça`}</th><th className={`p-2 font-medium`}>{`Módulo`}</th><th className={`p-2 font-medium text-right`}>{`Comp.`}</th><th className={`p-2 font-medium text-right`}>{`Larg.`}</th><th className={`p-2 font-medium text-center`}>{`Esp.`}</th><th className={`p-2 font-medium text-center`}>{`Borda`}</th></tr></thead><tbody className={`divide-y divide-border`}>{t.listaPecas.map(e => {
            let t = [e.fitaBorda.topo, e.fitaBorda.base, e.fitaBorda.esquerda, e.fitaBorda.direita].filter(Boolean).length;
                                                                                                                                    return <tr className={`hover:bg-stone-50/60 dark:hover:bg-stone-900/40`} key={e.id}><td className={`p-2 font-medium text-foreground`}><div>{e.nome}</div><div className={`text-[9px] text-muted-foreground capitalize`}>{e.acabamento}</div></td><td className={`p-2 text-muted-foreground truncate max-w-[90px]`}>{e.moduloNome}</td><td className={`p-2 text-right font-mono`}>{Math.round(e.largura)}</td><td className={`p-2 text-right font-mono`}>{Math.round(e.altura)}</td><td className={`p-2 text-center font-mono`}>{e.espessura}</td><td className={`p-2 text-center`}><span className={`inline-block rounded px-1 py-0.5 text-[9px] font-mono ${t > 0 ? `bg-indigo-50 text-indigo-700 dark:bg-indigo-950/50 dark:text-indigo-300` : `text-muted-foreground`}`}>{t}{`L`}</span></td></tr>;
          })}</tbody></table></div><div className={`space-y-2 border-t border-border pt-3`}><p className={`text-[11px] font-semibold text-muted-foreground uppercase tracking-wider`}>{`Quantitativo de Ferragens`}</p><div className={`divide-y divide-border rounded-lg border border-border`}>{t.ferragens.map(e => <div className={`flex items-center justify-between p-2`} key={e.chave}><span className={`text-foreground`}>{e.nome}</span><span className={`font-mono font-semibold text-emerald-600 dark:text-emerald-400`}>{e.quantidade}{` `}{e.unidade}</span></div>)}</div></div></div>;
}
function _Component79({
  cena: e,
  nomeProjeto: t,
  margem: n,
  aoMudarMargem: r,
  margemEditavel: i,
  ambienteNome: a,
  aoGerarOrcamento: o,
  gerando: s,
  podeGerar: c
}) {
  let {
    data: l
  } = Ir();
  let [u, d] = (0, k.useState)(false);
  let [f, p] = (0, k.useState)(false);
  let [m, h] = (0, k.useState)(false);
  let [g, _] = (0, k.useState)(n);
  (0, k.useEffect)(() => {
    _(n);
  }, [n]);
  let [v, y] = (0, k.useState)(() => {
    let e = l?.config_precos ?? {};
    return {
      precoChapaMDF: Number(e.precoChapaMDF) > 0 ? Number(e.precoChapaMDF) : it.precoChapaMDF,
      precoChapaFundo: Number(e.precoChapaFundo) > 0 ? Number(e.precoChapaFundo) : it.precoChapaFundo,
      precoMetroFita: Number(e.precoMetroFita) > 0 ? Number(e.precoMetroFita) : it.precoMetroFita,
      precoDobradica: Number(e.precoDobradica) >= 0 ? Number(e.precoDobradica) : it.precoDobradica,
      precoCorredica: Number(e.precoCorredica) >= 0 ? Number(e.precoCorredica) : it.precoCorredica,
      precoPuxador: Number(e.precoPuxador) >= 0 ? Number(e.precoPuxador) : it.precoPuxador,
      precoMinifix: Number(e.precoMinifix) >= 0 ? Number(e.precoMinifix) : it.precoMinifix,
      precoParafuso: Number(e.precoParafuso) >= 0 ? Number(e.precoParafuso) : it.precoParafuso,
      precoSuporte: Number(e.precoSuporte) >= 0 ? Number(e.precoSuporte) : it.precoSuporte,
      precoSapata: Number(e.precoSapata) >= 0 ? Number(e.precoSapata) : it.precoSapata,
      precoServicoPeca: Number(e.precoServicoPeca) >= 0 ? Number(e.precoServicoPeca) : it.precoServicoPeca,
      taxaMontagemBase: Number(e.taxaMontagemBase) >= 0 ? Number(e.taxaMontagemBase) : it.taxaMontagemBase,
      margemPadrao: Number(e.margemPadrao) >= 0 ? Number(e.margemPadrao) : it.margemPadrao
    };
  });
  (0, k.useEffect)(() => {
    if (l?.config_precos) {
      let e = l.config_precos;
      y(t => ({
        precoChapaMDF: Number(e.precoChapaMDF) > 0 ? Number(e.precoChapaMDF) : t.precoChapaMDF,
        precoChapaFundo: Number(e.precoChapaFundo) > 0 ? Number(e.precoChapaFundo) : t.precoChapaFundo,
        precoMetroFita: Number(e.precoMetroFita) > 0 ? Number(e.precoMetroFita) : t.precoMetroFita,
        precoDobradica: Number(e.precoDobradica) >= 0 ? Number(e.precoDobradica) : t.precoDobradica,
        precoCorredica: Number(e.precoCorredica) >= 0 ? Number(e.precoCorredica) : t.precoCorredica,
        precoPuxador: Number(e.precoPuxador) >= 0 ? Number(e.precoPuxador) : t.precoPuxador,
        precoMinifix: Number(e.precoMinifix) >= 0 ? Number(e.precoMinifix) : t.precoMinifix,
        precoParafuso: Number(e.precoParafuso) >= 0 ? Number(e.precoParafuso) : t.precoParafuso,
        precoSuporte: Number(e.precoSuporte) >= 0 ? Number(e.precoSuporte) : t.precoSuporte,
        precoSapata: Number(e.precoSapata) >= 0 ? Number(e.precoSapata) : t.precoSapata,
        precoServicoPeca: Number(e.precoServicoPeca) >= 0 ? Number(e.precoServicoPeca) : t.precoServicoPeca,
        taxaMontagemBase: Number(e.taxaMontagemBase) >= 0 ? Number(e.taxaMontagemBase) : t.taxaMontagemBase,
        margemPadrao: Number(e.margemPadrao) >= 0 ? Number(e.margemPadrao) : t.margemPadrao
      }));
    }
  }, [l]);
  let [b, x] = (0, k.useState)(v);
  (0, k.useEffect)(() => {
    x(v);
  }, [v]);
  let S = (0, k.useMemo)(() => at(e, g, v), [e, g, v]);
  function C() {
    if (!i) {
      return;
    }
    let e = Math.min(200, Math.max(0, Math.round(g * 100) / 100));
    _(e);
    if (e !== n) {
      r(e);
    }
  }
  function w() {
    y(b);
    p(false);
  }
  function T() {
    let e = l?.config_precos ?? {};
    x({
      precoChapaMDF: Number(e.precoChapaMDF) > 0 ? Number(e.precoChapaMDF) : it.precoChapaMDF,
      precoChapaFundo: Number(e.precoChapaFundo) > 0 ? Number(e.precoChapaFundo) : it.precoChapaFundo,
      precoMetroFita: Number(e.precoMetroFita) > 0 ? Number(e.precoMetroFita) : it.precoMetroFita,
      precoDobradica: Number(e.precoDobradica) >= 0 ? Number(e.precoDobradica) : it.precoDobradica,
      precoCorredica: Number(e.precoCorredica) >= 0 ? Number(e.precoCorredica) : it.precoCorredica,
      precoPuxador: Number(e.precoPuxador) >= 0 ? Number(e.precoPuxador) : it.precoPuxador,
      precoMinifix: Number(e.precoMinifix) >= 0 ? Number(e.precoMinifix) : it.precoMinifix,
      precoParafuso: Number(e.precoParafuso) >= 0 ? Number(e.precoParafuso) : it.precoParafuso,
      precoSuporte: Number(e.precoSuporte) >= 0 ? Number(e.precoSuporte) : it.precoSuporte,
      precoSapata: Number(e.precoSapata) >= 0 ? Number(e.precoSapata) : it.precoSapata,
      precoServicoPeca: Number(e.precoServicoPeca) >= 0 ? Number(e.precoServicoPeca) : it.precoServicoPeca,
      taxaMontagemBase: Number(e.taxaMontagemBase) >= 0 ? Number(e.taxaMontagemBase) : it.taxaMontagemBase,
      margemPadrao: Number(e.margemPadrao) >= 0 ? Number(e.margemPadrao) : it.margemPadrao
    });
  }
  function E() {
    let n = S.ferragens.map(e => `  - ${e.nome}: ${e.quantidade} ${e.unidade} × ${W(e.precoUnitario)} = ${W(e.total)}`).join(`
`);
    let r = `
ORÇAMENTO DE PROJETO - PLANEJADOS PRO
Estudo: ${t || `Estudo 3D`}
${a ? `Ambiente: ${a}` : `Sem ambiente vinculado`}
Módulos: ${e.modulos.length}
Peças Totais: ${S.totalPecas}

RESUMO DE MATERIAIS & CUSTOS:
- MDF Caixaria/Frentes: ${S.chapasEstimadas} chapas (~${Za(S.areaMDFM2, 2)} m²) @ ${W(v.precoChapaMDF)}/chapa = ${W(S.custoMDF)}
- Fita de Borda PVC: ${S.metrosFitaBorda} metros @ ${W(v.precoMetroFita)}/m = ${W(S.custoFita)}
- Ferragens e Fixadores: ${W(S.custoFerragens)}
${n}
- Mão de Obra, Usinagem e Montagem: ${W(S.custoServicos)} (${S.totalPecas} peças @ ${W(v.precoServicoPeca)} + taxa de montagem ${W(v.taxaMontagemBase)})

Custo Total de Produção: ${W(S.custoTotal)}
Markup do ambiente: +${Za(g, 2)}%
VALOR TOTAL PROPOSTA: ${W(S.precoVenda)}
    `.trim();
    navigator.clipboard.writeText(r);
    d(true);
    setTimeout(() => d(false), 2000);
  }
                                                                                                                          return <div className={`flex h-full w-full flex-col gap-4 overflow-y-auto pr-1 text-xs`}><div className={`rounded-xl border border-border bg-card p-4 shadow-xs`}><div className={`flex items-center justify-between`}><span className={`text-xs font-medium text-muted-foreground`}>{`Valor sugerido de venda`}</span><span className={`rounded-full border border-border bg-muted/40 px-2 py-0.5 text-[10px] font-semibold tabular-nums text-foreground`}>{`+`}{Za(g, 2)}{`%`}</span></div><p className={`mt-2 text-2xl font-bold tracking-tight text-foreground numero`}>{W(S.precoVenda)}</p><p className={`mt-1 text-[11px] text-muted-foreground`}>{`Custo de produção: `}{W(S.custoTotal)}{` · Lucro estimado:`}{` `}<span className={`font-semibold text-emerald-600 dark:text-emerald-400`}>{W(S.precoVenda - S.custoTotal)}</span></p></div><div className={`space-y-2 rounded-xl border border-border bg-muted/30 p-3`}><div className={`flex items-center justify-between`}><label className={`flex items-center gap-1.5 text-[11px] font-semibold text-foreground`} htmlFor={`orc-margem`}><Gn className={`h-3.5 w-3.5 text-primary`} />{`Markup do ambiente`}</label><div className={`flex items-center gap-1`}><K id={`orc-margem`} type={`number`} min={`0`} max={`200`} disabled={!i} value={g} onChange={e => _(Number(e.target.value) || 0)} onBlur={C} onKeyDown={e => {
            if (e.key === `Enter`) {
              e.currentTarget.blur();
            }
          }} className={`h-7 w-16 text-right font-mono text-xs`} /><span className={`font-medium text-muted-foreground`}>{`%`}</span></div></div><input type={`range`} min={`0`} max={`200`} step={`5`} value={g} disabled={!i} onChange={e => _(Number(e.target.value))} onPointerUp={C} onKeyUp={C} className={`h-1.5 w-full cursor-pointer accent-emerald-600 disabled:cursor-not-allowed disabled:opacity-50`} aria-label={`Markup do ambiente`} /><p className={`text-[10px] text-muted-foreground`}>{a ? `Salvo no ambiente ${a} e usado em todo orçamento desta peça.` : `Vincule um ambiente ao estudo para guardar o markup do cômodo. Sem vínculo, o orçamento usa 30%.`}</p></div><div className={`space-y-2.5`}><div className={`flex items-center justify-between`}><p className={`text-[11px] font-semibold uppercase tracking-wider text-muted-foreground`}>{`Composição de custos de fábrica`}</p><G variant={`ghost`} size={`sm`} onClick={() => p(true)} className={`h-6 gap-1 px-2 text-[11px] text-primary hover:text-primary/90`} title={`Ajustar preços das chapas, fita, ferragens e montagem deste estudo`}><_Component73 className={`h-3 w-3`} />{`Tabela de preços`}</G></div><div className={`divide-y divide-border rounded-lg border border-border bg-card`}><div className={`flex items-center justify-between p-2.5`}><div><p className={`font-medium text-foreground`}>{`Chapas de MDF`}</p><p className={`text-[10px] text-muted-foreground`}>{S.chapasEstimadas}{` chapas (`}{W(v.precoChapaMDF)}{`/un) · ~`}{Za(S.areaMDFM2, 2)}{` m²`}</p></div><span className={`font-mono font-semibold text-foreground`}>{W(S.custoMDF)}</span></div><div className={`flex items-center justify-between p-2.5`}><div><p className={`font-medium text-foreground`}>{`Fita de borda PVC`}</p><p className={`text-[10px] text-muted-foreground`}>{S.metrosFitaBorda}{` metros lineares (`}{W(v.precoMetroFita)}{`/m)`}</p></div><span className={`font-mono font-semibold text-foreground`}>{W(S.custoFita)}</span></div><div><button type={`button`} onClick={() => h(e => !e)} className={`flex w-full items-center justify-between p-2.5 text-left hover:bg-muted/40 transition-colors`}><div><p className={`flex items-center gap-1 font-medium text-foreground`}>{`Ferragens e acessórios`}{m ? <Gt className={`h-3 w-3 text-muted-foreground`} /> : <Wt className={`h-3 w-3 text-muted-foreground`} />}</p><p className={`text-[10px] text-muted-foreground`}>{S.ferragens.reduce((e, t) => e + t.quantidade, 0)}{` itens computados`}</p></div><span className={`font-mono font-semibold text-foreground`}>{W(S.custoFerragens)}</span></button>{m && <div className={`bg-muted/20 px-3 py-1.5 text-[11px] space-y-1 border-t border-border/50`}>{S.ferragens.map(e => <div className={`flex justify-between text-muted-foreground`} key={e.chave}><span>{e.nome}{` (`}{e.quantidade}{` `}{e.unidade}{` × `}{W(e.precoUnitario)}{`)`}</span><span className={`font-mono text-foreground`}>{W(e.total)}</span></div>)}</div>}</div><div className={`flex items-center justify-between p-2.5`}><div><p className={`font-medium text-foreground`}>{`Corte, usinagem e montagem`}</p><p className={`text-[10px] text-muted-foreground`}>{S.totalPecas}{` peças (`}{W(v.precoServicoPeca)}{`/un) + taxa base `}{W(v.taxaMontagemBase)}</p></div><span className={`font-mono font-semibold text-foreground`}>{W(S.custoServicos)}</span></div></div></div><div className={`flex flex-col gap-2 border-t border-border pt-3`}><G variant={`default`} size={`sm`} onClick={o} disabled={!c || s} className={`w-full gap-1.5 text-xs`} title={c ? `Criar o orçamento comercial do projeto a partir deste estudo` : `Salve o estudo com pelo menos um módulo para gerar o orçamento`}><_Component74 className={`h-3.5 w-3.5`} />{s ? `Gerando orçamento...` : `Gerar orçamento do estudo`}</G><div className={`flex gap-2`}><G variant={`outline`} size={`sm`} onClick={E} className={`flex-1 gap-1.5 text-xs`}>{u ? <Ut className={`h-3.5 w-3.5 text-emerald-600`} /> : <$t className={`h-3.5 w-3.5`} />}{u ? `Copiado` : `Copiar proposta`}</G><G variant={`outline`} size={`sm`} onClick={() => window.print()} className={`gap-1.5 text-xs`}><Jn className={`h-3.5 w-3.5`} />{`Imprimir`}</G></div></div><_Component21 open={f} onOpenChange={p} title={`Tabela de Preços & Custos Deste Estudo`} description={`Ajuste os valores unitários praticados neste projeto para recalcular os custos e margens de venda em tempo real.`} size={`lg`}><div className={`space-y-4 text-xs`}><div className={`grid gap-4 sm:grid-cols-2`}><div className={`space-y-3 rounded-lg border border-border p-3`}><p className={`flex items-center gap-1.5 font-semibold text-foreground`}><Rt className={`h-3.5 w-3.5 text-primary`} />{`Chapas MDF`}</p><_Component19 label={`Chapa MDF 15/18mm (R$/chapa)`}><K type={`number`} step={`0.01`} min={`0`} value={b.precoChapaMDF} onChange={e => x(t => ({
                ...t,
                precoChapaMDF: Number(e.target.value) || 0
              }))} /></_Component19><_Component19 label={`Chapa Fundo 6mm (R$/chapa)`}><K type={`number`} step={`0.01`} min={`0`} value={b.precoChapaFundo} onChange={e => x(t => ({
                ...t,
                precoChapaFundo: Number(e.target.value) || 0
              }))} /></_Component19></div><div className={`space-y-3 rounded-lg border border-border p-3`}><p className={`flex items-center gap-1.5 font-semibold text-foreground`}><_Component60 className={`h-3.5 w-3.5 text-primary`} />{`Fita de Borda PVC`}</p><_Component19 label={`Fita aplicada (R$/metro)`}><K type={`number`} step={`0.01`} min={`0`} value={b.precoMetroFita} onChange={e => x(t => ({
                ...t,
                precoMetroFita: Number(e.target.value) || 0
              }))} /></_Component19></div></div><div className={`space-y-3 rounded-lg border border-border p-3`}><p className={`flex items-center gap-1.5 font-semibold text-foreground`}><Er className={`h-3.5 w-3.5 text-primary`} />{`Ferragens & Acessórios Unitários`}</p><div className={`grid grid-cols-2 gap-3 sm:grid-cols-4`}><_Component19 label={`Dobradiça 35mm (R$/un)`}><K type={`number`} step={`0.01`} min={`0`} value={b.precoDobradica} onChange={e => x(t => ({
                ...t,
                precoDobradica: Number(e.target.value) || 0
              }))} /></_Component19><_Component19 label={`Corrediça (R$/par)`}><K type={`number`} step={`0.01`} min={`0`} value={b.precoCorredica} onChange={e => x(t => ({
                ...t,
                precoCorredica: Number(e.target.value) || 0
              }))} /></_Component19><_Component19 label={`Puxador (R$/un)`}><K type={`number`} step={`0.01`} min={`0`} value={b.precoPuxador} onChange={e => x(t => ({
                ...t,
                precoPuxador: Number(e.target.value) || 0
              }))} /></_Component19><_Component19 label={`Minifix (R$/un)`}><K type={`number`} step={`0.01`} min={`0`} value={b.precoMinifix} onChange={e => x(t => ({
                ...t,
                precoMinifix: Number(e.target.value) || 0
              }))} /></_Component19><_Component19 label={`Parafuso (R$/un)`}><K type={`number`} step={`0.01`} min={`0`} value={b.precoParafuso} onChange={e => x(t => ({
                ...t,
                precoParafuso: Number(e.target.value) || 0
              }))} /></_Component19><_Component19 label={`Suporte Prateleira (R$/un)`}><K type={`number`} step={`0.01`} min={`0`} value={b.precoSuporte} onChange={e => x(t => ({
                ...t,
                precoSuporte: Number(e.target.value) || 0
              }))} /></_Component19><_Component19 label={`Sapata Regulável (R$/un)`}><K type={`number`} step={`0.01`} min={`0`} value={b.precoSapata} onChange={e => x(t => ({
                ...t,
                precoSapata: Number(e.target.value) || 0
              }))} /></_Component19></div></div><div className={`space-y-3 rounded-lg border border-border p-3`}><p className={`flex items-center gap-1.5 font-semibold text-foreground`}><_Component75 className={`h-3.5 w-3.5 text-primary`} />{`Mão de Obra & Serviços`}</p><div className={`grid grid-cols-2 gap-3`}><_Component19 label={`Custo por peça usinada/cortada (R$/peça)`}><K type={`number`} step={`0.01`} min={`0`} value={b.precoServicoPeca} onChange={e => x(t => ({
                ...t,
                precoServicoPeca: Number(e.target.value) || 0
              }))} /></_Component19><_Component19 label={`Taxa base de montagem/instalação (R$)`}><K type={`number`} step={`0.01`} min={`0`} value={b.taxaMontagemBase} onChange={e => x(t => ({
                ...t,
                taxaMontagemBase: Number(e.target.value) || 0
              }))} /></_Component19></div></div><div className={`flex justify-between pt-2`}><G type={`button`} variant={`outline`} size={`sm`} onClick={T} className={`gap-1.5`}><Qn className={`h-3.5 w-3.5`} />{`Restaurar tabela padrão`}</G><div className={`flex gap-2`}><G type={`button`} variant={`ghost`} size={`sm`} onClick={() => p(false)}>{`Cancelar`}</G><G type={`button`} size={`sm`} onClick={w} className={`gap-1.5`}><Ut className={`h-3.5 w-3.5`} />{`Aplicar neste estudo`}</G></div></div></div></_Component21></div>;
}
function _Component76({
  label: e,
  valor: t,
  onCommit: n,
  minimo: r = 100,
  maximo: i = mm,
  passo: a
}) {
  let [o, s] = (0, k.useState)(null);
  let c = (0, k.useRef)(null);
  let l = o ?? String(Math.round(t));
  let u = a ?? (i <= 20 ? 1 : 10);
  function d(e) {
    let t = Math.min(i, Math.max(r, Math.round(e)));
    s(null);
    n(t);
  }
  function f() {
    let e = Number((o ?? ``).replace(`,`, `.`));
    if (Number.isFinite(e)) {
      d(e);
    } else {
      s(null);
    }
  }
  function p(e = 1) {
    let n = o === null ? t : Number(o.replace(`,`, `.`));
    d((Number.isFinite(n) ? n : t) + u * e);
  }
  function m(e = 1) {
    let n = o === null ? t : Number(o.replace(`,`, `.`));
    d((Number.isFinite(n) ? n : t) - u * e);
  }
  (0, k.useEffect)(() => {
    let e = c.current;
    if (!e) {
      return;
    }
    let t = e => {
      e.preventDefault();
      let t = e.shiftKey ? 5 : 1;
      if (e.deltaY < 0) {
        p(t);
      } else if (e.deltaY > 0) {
        m(t);
      }
    };
    e.addEventListener(`wheel`, t, {
      passive: false
    });
    return () => e.removeEventListener(`wheel`, t);
  });
          return <_Component19 label={e}><div className={`relative flex items-center`}><K ref={c} inputMode={`numeric`} value={l} className={`pr-6 text-xs h-8`} onFocus={() => s(String(Math.round(t)))} onChange={e => s(e.target.value)} onBlur={f} onKeyDown={e => {
        if (e.key === `Enter`) {
          e.currentTarget.blur();
        } else if (e.key === `ArrowUp`) {
          e.preventDefault();
          p(e.shiftKey ? 5 : 1);
        } else if (e.key === `ArrowDown`) {
          e.preventDefault();
          m(e.shiftKey ? 5 : 1);
        }
      }} /><div className={`absolute right-0.5 inset-y-0 flex flex-col justify-center py-0.5 pointer-events-auto`}><button type={`button`} tabIndex={-1} onClick={() => p(1)} disabled={t >= i} className={`flex h-3.5 w-4 items-center justify-center rounded-t text-muted-foreground hover:bg-muted hover:text-foreground active:scale-95 disabled:opacity-20 disabled:pointer-events-none transition-colors`} title={`Incrementar (ou role o scroll / seta cima)`} aria-label={`Incrementar`}><Gt className={`h-3 w-3`} /></button><button type={`button`} tabIndex={-1} onClick={() => m(1)} disabled={t <= r} className={`flex h-3.5 w-4 items-center justify-center rounded-b text-muted-foreground hover:bg-muted hover:text-foreground active:scale-95 disabled:opacity-20 disabled:pointer-events-none transition-colors`} title={`Decrementar (ou role o scroll / seta baixo)`} aria-label={`Decrementar`}><Wt className={`h-3 w-3`} /></button></div></div></_Component19>;
}
function _D({
  nome: e,
  aoMudarNome: t,
  nicho: n,
  aoMudarNicho: r,
  selecionado: i,
  aoMudarModulo: a,
  aoGirar: o,
  aoDuplicar: s,
  aoExcluir: c,
  aoLimpar: l,
  aoAplicarTodos: u,
  cena: d,
  ambiente: f,
  ambientesDoProjeto: p,
  medicaoAmbiente: m,
  aoVincularAmbiente: h,
  aoMudarMargem: g,
  aoGerarOrcamento: _,
  gerandoOrcamento: v,
  podeGerarOrcamento: y,
  comodo: b,
  aoMudarComodo: x,
  componenteSelecionado: S,
  aoMudarComponente: C,
  aoGirarComponente: w,
  aoRemoverComponente: T
}) {
  let [E, D] = (0, k.useState)(`parametros`);
                                                                                                                              return <aside className={`flex h-full w-full flex-col gap-3 overflow-hidden`}><_Component32 value={E} onValueChange={D} tabs={[{
      value: `parametros`,
      label: `Parâmetros`
    }, {
      value: `materiais`,
      label: `Materiais`
    }, {
      value: `corte`,
      label: `Corte`
    }, {
      value: `orcamento`,
      label: `Orçamento`
    }]} /><div className={`flex-1 overflow-y-auto pr-1`}>{E === `parametros` && <div className={`space-y-5`}><div className={`space-y-3`}><p className={`text-[11px] font-semibold text-muted-foreground uppercase tracking-wider`}>{`Estudo`}</p><_Component19 label={`Nome do estudo`}><K value={e} onChange={e => t(e.target.value)} maxLength={120} /></_Component19></div><div className={`space-y-3 border-t border-border pt-4`}><p className={`text-[11px] font-semibold text-muted-foreground uppercase tracking-wider`}>{`Ambiente do estudo`}</p><_Component19 label={`Cômodo do projeto`}><_Component31 value={f?.id ?? ``} onChange={e => h(e.target.value === `` ? null : e.target.value)}><option value={``}>{`Sem ambiente`}</option>{p.map(e => <option value={e.id} key={e.id}>{e.nome}</option>)}</_Component31></_Component19>{f ? <L.Fragment><div className={`overflow-hidden rounded-lg border border-border/60 bg-muted/30`}><_Component34 entrada={{
                nome: f.nome,
                tipo: f.tipo,
                largura_cm: m?.largura_cm ?? null,
                altura_cm: m?.altura_cm ?? null,
                profundidade_cm: m?.profundidade_cm ?? null,
                desnivel_cm: m?.desnivel_cm ?? null,
                pontos_eletricos: m?.pontos_eletricos ?? 0,
                pontos_hidraulicos: m?.pontos_hidraulicos ?? 0,
                margem_percent: f.margem_percent
              }} /></div><p className={`text-[11px] text-muted-foreground`}>{Ne[f.tipo]}{` · markup `}{eo(f.margem_percent)}{` aplicado no orçamento.`}</p></L.Fragment> : <p className={`rounded-[10px] border border-dashed border-border p-3 text-[12px] text-muted-foreground`}>{`Vincule o estudo a um cômodo do projeto para herdar o mockup, as medidas do vão e o markup cobrado nele.`}</p>}</div><div className={`space-y-3 border-t border-border pt-4`}><p className={`text-[11px] font-semibold text-muted-foreground uppercase tracking-wider`}>{`Cômodo`}</p><_Component19 label={`Tipo do cômodo`}><_Component31 value={b.tipo} onChange={e => x({
              tipo: e.target.value
            })}>{je.map(e => <option value={e} key={e}>{Ne[e]}</option>)}</_Component31></_Component19><p className={`text-[11px] text-muted-foreground`}>{`O tipo define quais peças aparecem no painel Cômodo: peças de cozinha, de banheiro, de quarto.`}</p><div className={`grid grid-cols-3 gap-2`}><_Component76 label={`Compr.`} valor={b.largura} minimo={1000} maximo={12000} onCommit={e => x({
              largura: e
            })} /><_Component76 label={`Prof.`} valor={b.profundidade} minimo={1000} maximo={12000} onCommit={e => x({
              profundidade: e
            })} /><_Component76 label={`Altura`} valor={b.altura} minimo={1000} maximo={6000} onCommit={e => x({
              altura: e
            })} /></div><p className={`text-[11px] text-muted-foreground`}>{`O desenho mostra o cômodo inteiro; a régua e as cotas seguem o vão de trabalho.`}</p></div>{S && <div className={`space-y-3 border-t border-border pt-4`}><div className={`flex items-center justify-between`}><p className={`text-[11px] font-semibold text-muted-foreground uppercase tracking-wider`}>{_m[S.tipo].nome}</p><div className={`flex items-center gap-1.5`}><G variant={`outline`} size={`sm`} className={`h-7 gap-1 px-2 text-[11px] font-mono`} onClick={() => w ? w() : C(S.id, {
                rotacao: ((S.rotacao ?? 0) + 90) % 360
              })} title={`Girar peça 90°`}><$n className={`h-3 w-3`} />{S.rotacao ?? 0}{`°`}</G><G variant={`ghost`} size={`icon`} className={U(`h-7 w-7`, S.bloqueado ? `text-foreground` : `text-muted-foreground`)} onClick={() => C(S.id, {
                bloqueado: S.bloqueado !== true
              })} title={S.bloqueado ? `Desbloquear peça` : `Bloquear peça`} aria-label={S.bloqueado ? `Desbloquear peça` : `Bloquear peça`}>{S.bloqueado ? <_Component57 className={`h-3.5 w-3.5`} /> : <On className={`h-3.5 w-3.5`} />}</G><G variant={`ghost`} size={`icon`} className={`h-7 w-7 text-muted-foreground hover:text-destructive`} onClick={() => T(S.id)} title={`Remover peça do cômodo`} aria-label={`Remover peça do cômodo`}><_Component26 className={`h-3.5 w-3.5`} /></G></div></div><_Component19 label={`Parede`}><_Component31 value={S.parede} onChange={e => C(S.id, {
              parede: e.target.value
            })}><option value={`fundo`}>{`Parede do fundo`}</option><option value={`esquerda`}>{`Parede esquerda`}</option><option value={`direita`}>{`Parede direita`}</option></_Component31></_Component19><div className={`grid grid-cols-2 gap-2`}><_Component76 label={`Posição X`} valor={S.x} minimo={0} maximo={b.largura + b.profundidade} onCommit={e => C(S.id, {
              x: e
            })} /><_Component76 label={`Altura Y (Piso)`} valor={S.y} minimo={0} maximo={b.altura} onCommit={e => C(S.id, {
              y: e
            })} /><_Component76 label={`Afastamento Z (Frente)`} valor={typeof S.z == `number` && Number.isFinite(S.z) ? S.z : S.profundidade / 2} minimo={0} maximo={b.profundidade} onCommit={e => C(S.id, {
              z: e
            })} /><_Component76 label={`Profundidade`} valor={S.profundidade} minimo={10} maximo={6000} onCommit={e => C(S.id, {
              profundidade: e
            })} /><_Component76 label={`Largura`} valor={S.largura} minimo={20} maximo={6000} onCommit={e => C(S.id, {
              largura: e
            })} /><_Component76 label={`Altura`} valor={S.altura} minimo={20} maximo={6000} onCommit={e => C(S.id, {
              altura: e
            })} /></div><p className={`text-[11px] text-muted-foreground`}>{`Arraste a peça ou suas alças 3D na cena para posicionar; use os campos acima para o ajuste fino com precisão milimétrica.`}</p></div>}<div className={`space-y-3 border-t border-border pt-4`}><p className={`text-[11px] font-semibold text-muted-foreground uppercase tracking-wider`}>{`Medidas do vão`}</p><div className={`grid grid-cols-3 gap-2`}><_Component76 label={`Largura`} valor={n.largura} onCommit={e => r({
              largura: e
            })} /><_Component76 label={`Altura`} valor={n.altura} onCommit={e => r({
              altura: e
            })} /><_Component76 label={`Prof.`} valor={n.profundidade} onCommit={e => r({
              profundidade: e
            })} /></div></div><div className={`space-y-3 border-t border-border pt-4`}><p className={`text-[11px] font-semibold text-muted-foreground uppercase tracking-wider`}>{`Módulo selecionado`}</p>{i ? <div className={`space-y-3`}><div className={`flex items-center justify-between gap-2`}><span className={`min-w-0 truncate text-[12px] font-medium text-foreground`}>{i.nome}</span><span className={`shrink-0 rounded bg-stone-100 px-1.5 py-0.5 text-[10px] font-medium text-muted-foreground dark:bg-stone-800`}>{vi[i.categoria]}</span></div><div className={`grid grid-cols-3 gap-2`}><_Component76 label={`Largura`} valor={i.largura} onCommit={e => a({
                largura: e
              })} /><_Component76 label={`Altura`} valor={i.altura} onCommit={e => a({
                altura: e
              })} /><_Component76 label={`Prof.`} valor={i.profundidade} onCommit={e => a({
                profundidade: e,
                z: e / 2
              })} /></div><div className={`rounded-lg border border-border bg-stone-50/50 p-2.5 space-y-3 dark:bg-stone-900/40`}><p className={`text-[10px] font-semibold uppercase tracking-wider text-muted-foreground`}>{`Engenharia Estrutural`}</p><div><label className={`text-[11px] font-medium text-foreground`}>{`Espessura do MDF`}</label><div className={`mt-1 flex gap-1.5`}>{[15, 18, 25].map(e => <button type={`button`} onClick={() => a({
                    espessura: e
                  })} className={`flex-1 rounded-md py-1 text-xs font-medium border transition-colors ${(i.espessura ?? 15) === e ? `border-emerald-600 bg-emerald-50 text-emerald-700 dark:bg-emerald-950/40 dark:text-emerald-300` : `border-border text-muted-foreground hover:bg-stone-100 dark:hover:bg-stone-800`}`} key={e}>{e}{` mm`}</button>)}</div></div><div className={`grid grid-cols-2 gap-2`}><_Component76 label={`Prateleiras`} valor={i.prateleiras ?? 0} minimo={0} maximo={6} onCommit={e => a({
                  prateleiras: e
                })} /><_Component76 label={`Divisórias Verticais`} valor={i.divisorias ?? 0} minimo={0} maximo={4} onCommit={e => a({
                  divisorias: e
                })} /></div><div className={`grid grid-cols-2 gap-2`}><_Component76 label={`Portas`} valor={i.portas} minimo={0} maximo={12} onCommit={e => a({
                  portas: e
                })} /><_Component76 label={`Gavetas`} valor={i.gavetas} minimo={0} maximo={12} onCommit={e => a({
                  gavetas: e
                })} /></div><div><label className={`text-[11px] font-medium text-foreground`}>{`Modelo de Puxador`}</label><select value={i.puxador ?? `perfil_alca`} onChange={e => a({
                  puxador: e.target.value
                })} className={`mt-1 w-full rounded-md border border-border bg-card px-2 py-1 text-xs text-foreground focus:outline-none focus:ring-1 focus:ring-emerald-500`}><option value={`perfil_alca`}>{`Perfil Alça / Barra`}</option><option value={`cava`}>{`Perfil Cava / Gola`}</option><option value={`concha`}>{`Concha Embutida`}</option><option value={`fecho_toque`}>{`Fecho Toque (Sem puxador)`}</option><option value={`nenhum`}>{`Nenhum`}</option></select></div>{i.portas > 0 && <div><label className={`text-[11px] font-medium text-foreground`}>{`Abertura da Porta`}</label><div className={`mt-1 flex gap-1.5`}><button type={`button`} onClick={() => a({
                    tipoPorta: `giro`
                  })} className={`flex-1 rounded-md py-1 text-xs font-medium border ${(i.tipoPorta ?? `giro`) === `giro` ? `border-emerald-600 bg-emerald-50 text-emerald-700 dark:bg-emerald-950/40 dark:text-emerald-300` : `border-border text-muted-foreground`}`}>{`Giro Lateral`}</button><button type={`button`} onClick={() => a({
                    tipoPorta: `basculante`
                  })} className={`flex-1 rounded-md py-1 text-xs font-medium border ${i.tipoPorta === `basculante` ? `border-emerald-600 bg-emerald-50 text-emerald-700 dark:bg-emerald-950/40 dark:text-emerald-300` : `border-border text-muted-foreground`}`}>{`Basculante`}</button></div></div>}</div><div className={`grid grid-cols-2 gap-2`}><_Component76 label={`Posição X (mm)`} valor={i.x} minimo={0} onCommit={e => a({
                x: e
              })} /><_Component76 label={`Posição Y (mm)`} valor={i.y} minimo={0} onCommit={e => a({
                y: e
              })} /></div><div className={`flex flex-wrap gap-2 pt-1`}><G variant={`outline`} size={`sm`} onClick={o}><$n className={`h-4 w-4`} />{`Girar 90°`}</G><G variant={`outline`} size={`sm`} onClick={s}><$t className={`h-4 w-4`} />{`Duplicar`}</G><G variant={`ghost`} size={`sm`} onClick={c}><_Component26 className={`h-4 w-4 text-destructive`} />{`Excluir`}</G></div></div> : <p className={`rounded-[10px] border border-dashed border-border p-3 text-[12px] text-muted-foreground`}>{`Clique em um módulo na cena para editar medidas, portas, divisórias e ferragens.`}</p>}</div><div className={`border-t border-border pt-4`}><G variant={`outline`} size={`sm`} className={`w-full`} onClick={l}><_Component53 className={`h-4 w-4`} />{`Limpar cena`}</G></div></div>}{E === `materiais` && <_Component77 corSelecionada={i?.cor ?? null} acabamentoCaixaria={i?.acabamentoCaixaria} acabamentoFrente={i?.acabamentoFrente} temSelecao={!!i} aoAplicar={e => a({
        cor: e
      })} aoAplicarCaixaria={e => a({
        acabamentoCaixaria: e
      })} aoAplicarFrente={e => a({
        acabamentoFrente: e
      })} aoAplicarTodos={u} />}{E === `corte` && <_Component78 cena={d} />}{E === `orcamento` && <_Component79 cena={d} nomeProjeto={e} margem={f?.margem_percent ?? 30} aoMudarMargem={g} margemEditavel={!!f} ambienteNome={f?.nome ?? null} aoGerarOrcamento={_} gerando={v} podeGerar={y} />}</div></aside>;
}
var vD = {
  nome: ``,
  categoria: `vertical`,
  largura_mm: `600`,
  altura_mm: `720`,
  profundidade_mm: `450`,
  portas: `1`,
  gavetas: `0`,
  cor: bi[0].hex
};
function _Component91({
  open: e,
  onOpenChange: t
}) {
  let r = om();
  let {
    register: a,
    handleSubmit: o,
    reset: s,
    formState: {
      errors: c,
      isSubmitting: l
    }
  } = i({
    resolver: n(jc),
    defaultValues: vD
  });
  (0, k.useEffect)(() => {
    if (e) {
      s(vD);
    }
  }, [e, s]);
  async function u(e) {
    await r.mutateAsync({
      nome: e.nome,
      categoria: e.categoria,
      largura_mm: _l(e.largura_mm),
      altura_mm: _l(e.altura_mm),
      profundidade_mm: _l(e.profundidade_mm),
      portas: e.portas ? Math.trunc(_l(e.portas)) : 0,
      gavetas: e.gavetas ? Math.trunc(_l(e.gavetas)) : 0,
      cor: gl(e.cor)
    });
    t(false);
  }
        return <_Component21 open={e} onOpenChange={t} title={`Novo módulo na biblioteca`} description={`O módulo fica disponível para todos os estudos da marcenaria.`} footer={<L.Fragment><G variant={`outline`} onClick={() => t(false)} disabled={l}>{`Cancelar`}</G><G form={`modulo-catalogo-form`} type={`submit`} disabled={l}>{l ? `Salvando...` : `Adicionar`}</G></L.Fragment>}><form id={`modulo-catalogo-form`} onSubmit={o(u)} className={`grid gap-4 sm:grid-cols-3`}><_Component19 label={`Nome`} htmlFor={`mc-nome`} error={c.nome?.message} required={true} className={`sm:col-span-3`}><K id={`mc-nome`} placeholder={`Ex: Aéreo 900 com nicho`} {...a(`nome`)} /></_Component19><_Component19 label={`Categoria`} htmlFor={`mc-categoria`} error={c.categoria?.message} required={true}><_Component31 id={`mc-categoria`} {...a(`categoria`)}>{yi.map(e => <option value={e} key={e}>{vi[e]}</option>)}</_Component31></_Component19><_Component19 label={`Material`} htmlFor={`mc-cor`} error={c.cor?.message}><_Component31 id={`mc-cor`} {...a(`cor`)}>{bi.map(e => <option value={e.hex} key={e.hex}>{e.nome}</option>)}</_Component31></_Component19><_Component19 label={`Portas`} htmlFor={`mc-portas`} error={c.portas?.message}><K id={`mc-portas`} inputMode={`numeric`} {...a(`portas`)} /></_Component19><_Component19 label={`Largura (mm)`} htmlFor={`mc-largura`} error={c.largura_mm?.message} required={true}><K id={`mc-largura`} inputMode={`decimal`} {...a(`largura_mm`)} /></_Component19><_Component19 label={`Altura (mm)`} htmlFor={`mc-altura`} error={c.altura_mm?.message} required={true}><K id={`mc-altura`} inputMode={`decimal`} {...a(`altura_mm`)} /></_Component19><_Component19 label={`Profundidade (mm)`} htmlFor={`mc-profundidade`} error={c.profundidade_mm?.message} required={true}><K id={`mc-profundidade`} inputMode={`decimal`} {...a(`profundidade_mm`)} /></_Component19><_Component19 label={`Gavetas`} htmlFor={`mc-gavetas`} error={c.gavetas?.message}><K id={`mc-gavetas`} inputMode={`numeric`} {...a(`gavetas`)} /></_Component19></form></_Component21>;
}
var bD = [{
  id: `porta-sobreposta`,
  nome: `Porta sobreposta`,
  grupo: `portas`,
  imagem: `/designer-assets/overlay-door.webp`
}, {
  id: `porta-embutida`,
  nome: `Porta embutida`,
  grupo: `portas`,
  imagem: `/designer-assets/inside-door.webp`
}, {
  id: `1-gaveta-sobreposta`,
  nome: `1 gaveta sobreposta`,
  grupo: `gavetas-sobrepostas`,
  imagem: `/designer-assets/1-box.webp`
}, {
  id: `2-gavetas-sobrepostas`,
  nome: `2 gavetas sobrepostas`,
  grupo: `gavetas-sobrepostas`,
  imagem: `/designer-assets/2-box.webp`
}, {
  id: `3-gavetas-sobrepostas`,
  nome: `3 gavetas sobrepostas`,
  grupo: `gavetas-sobrepostas`,
  imagem: `/designer-assets/3-box.webp`
}, {
  id: `4-gavetas-sobrepostas`,
  nome: `4 gavetas sobrepostas`,
  grupo: `gavetas-sobrepostas`,
  imagem: `/designer-assets/4-box.webp`
}, {
  id: `2-gavetas-1-gavetao-sobreposta`,
  nome: `2 gavetas sobrepostas, 1 gaveta grande sobreposta`,
  grupo: `gavetas-sobrepostas`,
  imagem: `/designer-assets/2-box-1-big-box.webp`
}, {
  id: `1-gaveta-embutida`,
  nome: `1 gaveta embutida`,
  grupo: `gavetas-embutidas`,
  imagem: `/designer-assets/1-box-inside.webp`
}, {
  id: `2-gavetas-embutidas`,
  nome: `2 gavetas embutidas`,
  grupo: `gavetas-embutidas`,
  imagem: `/designer-assets/2-box-inside.webp`
}, {
  id: `3-gavetas-embutidas`,
  nome: `3 gavetas embutidas`,
  grupo: `gavetas-embutidas`,
  imagem: `/designer-assets/3-box-inside.webp`
}, {
  id: `4-gavetas-embutidas`,
  nome: `4 gavetas embutidas`,
  grupo: `gavetas-embutidas`,
  imagem: `/designer-assets/4-box-inside.webp`
}, {
  id: `2-gavetas-1-gavetao-embutida`,
  nome: `2 gavetas embutidas, 1 gaveta grande embutida`,
  grupo: `gavetas-embutidas`,
  imagem: `/designer-assets/2-box-1-big-box-inside.webp`
}, {
  id: `painel-embutido`,
  nome: `Painel embutido`,
  grupo: `paineis-fundos`,
  imagem: `/designer-assets/1-inset-panel.webp`
}, {
  id: `painel-sobreposto`,
  nome: `Painel sobreposto`,
  grupo: `paineis-fundos`,
  imagem: `/designer-assets/1-over-panel.webp`
}, {
  id: `fundo-hdf`,
  nome: `Painel traseiro de HDF`,
  grupo: `paineis-fundos`,
  imagem: `/designer-assets/1-backwall.webp`
}, {
  id: `fundo-sobreposto`,
  nome: `Painel traseiro sobreposto`,
  grupo: `paineis-fundos`,
  imagem: `/designer-assets/1-backwall.webp`
}, {
  id: `fundo-embutido`,
  nome: `Painel traseiro embutido`,
  grupo: `paineis-fundos`,
  imagem: `/designer-assets/inset-backwall.webp`
}, {
  id: `nicho-vazio`,
  nome: `Nicho aberto (vazio)`,
  grupo: `vazio`,
  imagem: `/designer-assets/1-box.webp`
}];
function _Component82({
  aberto: e,
  onFechar: t,
  onSelecionar: n
}) {
  let r = (0, k.useRef)(null);
  (0, k.useEffect)(() => {
    if (!e) {
      return;
    }
    let n = e => {
      if (r.current && !r.current.contains(e.target)) {
        t();
      }
    };
    let i = e => {
      if (e.key === `Escape`) {
        t();
      }
    };
    document.addEventListener(`mousedown`, n);
    document.addEventListener(`keydown`, i);
    return () => {
      document.removeEventListener(`mousedown`, n);
      document.removeEventListener(`keydown`, i);
    };
  }, [e, t]);
  if (e) {
                                            return <div className={`fixed inset-0 z-50 flex items-center justify-center bg-black/40 backdrop-blur-xs p-4 animate-in fade-in duration-150`}><div ref={r} className={`w-full max-w-sm rounded-xl border border-border bg-card text-card-foreground shadow-2xl overflow-hidden flex flex-col max-h-[85vh] animate-in zoom-in-95 duration-150`}><div className={`flex items-center justify-between border-b border-border px-4 py-3 bg-muted/40`}><h3 className={`text-sm font-semibold`}>{`Selecionar tipo`}</h3><button type={`button`} onClick={t} className={`rounded-lg p-1 text-muted-foreground hover:bg-accent hover:text-foreground transition-colors`}><Dr className={`h-4 w-4`} /></button></div><div className={`flex-1 overflow-y-auto divide-y divide-border/40 p-1`}>{bD.map(e => <button type={`button`} onClick={() => {
            n(e.id);
            t();
          }} className={`flex w-full items-center gap-3.5 px-3 py-2.5 text-left text-xs transition-colors hover:bg-accent hover:text-accent-foreground rounded-lg group`} key={e.id}><div className={`h-11 w-11 shrink-0 rounded-md border border-border/80 bg-background flex items-center justify-center overflow-hidden p-1 group-hover:border-primary/50 transition-colors`}><img src={e.imagem} alt={e.nome} className={`max-h-full max-w-full object-contain`} onError={e => {
                e.target.style.display = `none`;
              }} /></div><span className={`font-medium flex-1 text-[13px]`}>{e.nome}</span></button>)}</div></div></div>;
  } else {
    return null;
  }
}
var SD = [{
  id: `FL-E078`,
  codigo: `FL-E078`,
  nome: `Branco Puro`,
  imagem: `/designer-assets/FL-E078.webp`,
  hex: `#f8f9fa`
}, {
  id: `FL-E079`,
  codigo: `FL-E079`,
  nome: `Cinza Claro`,
  imagem: `/designer-assets/FL-E079.webp`,
  hex: `#dcdfdc`
}, {
  id: `FL-E080`,
  codigo: `FL-E080`,
  nome: `Areia Suave`,
  imagem: `/designer-assets/FL-E080.webp`,
  hex: `#e7e4dc`
}, {
  id: `FL-E081`,
  codigo: `FL-E081`,
  nome: `Off White`,
  imagem: `/designer-assets/FL-E081.webp`,
  hex: `#f0ece1`
}, {
  id: `FL-E082`,
  codigo: `FL-E082`,
  nome: `Marfim`,
  imagem: `/designer-assets/FL-E082.webp`,
  hex: `#ede4d0`
}, {
  id: `FL-E083`,
  codigo: `FL-E083`,
  nome: `Bege Papiro`,
  imagem: `/designer-assets/FL-E083.webp`,
  hex: `#e4d7c5`
}, {
  id: `FL-E084`,
  codigo: `FL-E084`,
  nome: `Camurça`,
  imagem: `/designer-assets/FL-E084.webp`,
  hex: `#c4b39b`
}, {
  id: `FL-E085`,
  codigo: `FL-E085`,
  nome: `Nude Natural`,
  imagem: `/designer-assets/FL-E085.webp`,
  hex: `#cebca3`
}, {
  id: `FL-E086`,
  codigo: `FL-E086`,
  nome: `Cinza Urbano`,
  imagem: `/designer-assets/FL-E086.webp`,
  hex: `#9a9c97`
}, {
  id: `FL-E087`,
  codigo: `FL-E087`,
  nome: `Grafite Silk`,
  imagem: `/designer-assets/FL-E087.webp`,
  hex: `#434647`
}, {
  id: `FL-E088`,
  codigo: `FL-E088`,
  nome: `Concreto Leve`,
  imagem: `/designer-assets/FL-E088.webp`,
  hex: `#a4a19b`
}, {
  id: `FL-E089`,
  codigo: `FL-E089`,
  nome: `Chumbo Fosco`,
  imagem: `/designer-assets/FL-E089.webp`,
  hex: `#4a4c4f`
}, {
  id: `FL-E090`,
  codigo: `FL-E090`,
  nome: `Freijó Natural`,
  imagem: `/designer-assets/FL-E090.webp`,
  hex: `#c29b68`
}, {
  id: `FL-E091`,
  codigo: `FL-E091`,
  nome: `Carvalho Soft`,
  imagem: `/designer-assets/FL-E091.webp`,
  hex: `#d5bc98`
}, {
  id: `FL-E092`,
  codigo: `FL-E092`,
  nome: `Nogueira Imperial`,
  imagem: `/designer-assets/FL-E092.webp`,
  hex: `#463327`
}, {
  id: `FL-E093`,
  codigo: `FL-E093`,
  nome: `Cacau`,
  imagem: `/designer-assets/FL-E093.webp`,
  hex: `#634227`
}, {
  id: `FL-E094`,
  codigo: `FL-E094`,
  nome: `Carvalho Rústico`,
  imagem: `/designer-assets/FL-E094.webp`,
  hex: `#af8153`
}, {
  id: `FL-E095`,
  codigo: `FL-E095`,
  nome: `Fendi Texturizado`,
  imagem: `/designer-assets/FL-E095.webp`,
  hex: `#b8aca0`
}, {
  id: `FL-E096`,
  codigo: `FL-E096`,
  nome: `Carvalho Dourado`,
  imagem: `/designer-assets/FL-E096.webp`,
  hex: `#bf925f`
}, {
  id: `FL-E098`,
  codigo: `FL-E098`,
  nome: `Preto Absoluto`,
  imagem: `/designer-assets/FL-E098.webp`,
  hex: `#1d1f21`
}, {
  id: `FL-E099`,
  codigo: `FL-E099`,
  nome: `Terracota`,
  imagem: `/designer-assets/FL-E099.webp`,
  hex: `#9b533c`
}, {
  id: `FL-E100`,
  codigo: `FL-E100`,
  nome: `Azul Petróleo`,
  imagem: `/designer-assets/FL-E100.webp`,
  hex: `#2b404d`
}, {
  id: `FL-E101`,
  codigo: `FL-E101`,
  nome: `Verde Musgo`,
  imagem: `/designer-assets/FL-E101.webp`,
  hex: `#3e4c41`
}, {
  id: `FL-E102`,
  codigo: `FL-E102`,
  nome: `Rosa Queimado`,
  imagem: `/designer-assets/FL-E102.webp`,
  hex: `#ba8982`
}, {
  id: `FL-E103`,
  codigo: `FL-E103`,
  nome: `Cinza Titânio`,
  imagem: `/designer-assets/FL-E103.webp`,
  hex: `#6c6e73`
}, {
  id: `FL-W101`,
  codigo: `FL-W101`,
  nome: `Lâmina Clara`,
  imagem: `/designer-assets/FL-W101.webp`,
  hex: `#d8c3a5`
}, {
  id: `FL-W102`,
  codigo: `FL-W102`,
  nome: `Lâmina Média`,
  imagem: `/designer-assets/FL-W102.webp`,
  hex: `#a88a6d`
}, {
  id: `FL-W103`,
  codigo: `FL-W103`,
  nome: `Lâmina Escura`,
  imagem: `/designer-assets/FL-W103.webp`,
  hex: `#654933`
}, {
  id: `FL-S101`,
  codigo: `FL-S101`,
  nome: `Pedra Mármore`,
  imagem: `/designer-assets/FL-S101.webp`,
  hex: `#e1e1e4`
}, {
  id: `FL-S102`,
  codigo: `FL-S102`,
  nome: `Mármore Nero`,
  imagem: `/designer-assets/FL-S102.webp`,
  hex: `#222326`
}];
function CD({
  aberto: e,
  titulo: t,
  materialSelecionadoId: n,
  espessuraSelecionada: r,
  tamanhoSelecionado: i,
  onFechar: a,
  onSalvar: o
}) {
  let [s, c] = (0, k.useState)(n);
  let [l, u] = (0, k.useState)(r);
  let [d, f] = (0, k.useState)(i || `1830x2750`);
  let p = (0, k.useRef)(null);
  (0, k.useEffect)(() => {
    if (e) {
      c(n || `FL-E083`);
      u(r || 16);
      f(i || `1830x2750`);
    }
  }, [e, n, r, i]);
  (0, k.useEffect)(() => {
    if (!e) {
      return;
    }
    let t = e => {
      if (p.current && !p.current.contains(e.target)) {
        a();
      }
    };
    let n = e => {
      if (e.key === `Escape`) {
        a();
      }
    };
    document.addEventListener(`mousedown`, t);
    document.addEventListener(`keydown`, n);
    return () => {
      document.removeEventListener(`mousedown`, t);
      document.removeEventListener(`keydown`, n);
    };
  }, [e, a]);
  if (e) {
                                                                    return <div className={`fixed inset-0 z-50 flex items-center justify-center bg-black/40 backdrop-blur-xs p-4 animate-in fade-in duration-150`}><div ref={p} className={`w-full max-w-xl rounded-2xl border border-stone-200 dark:border-stone-800 bg-white dark:bg-stone-900 text-stone-900 dark:text-stone-100 shadow-2xl overflow-hidden flex flex-col max-h-[90vh] animate-in zoom-in-95 duration-150`}><div className={`flex items-center justify-between px-6 pt-6 pb-4`}><h2 className={`text-2xl font-bold tracking-tight`}>{t}</h2><button type={`button`} onClick={a} className={`rounded-lg p-1 text-stone-400 hover:bg-stone-100 hover:text-stone-700 dark:hover:bg-stone-800 dark:hover:text-stone-200 transition-colors`}><Dr className={`h-5 w-5`} /></button></div><div className={`grid grid-cols-2 gap-4 px-6 pb-5`}><div><label className={`block text-[10px] font-mono font-medium tracking-wider text-stone-500 uppercase mb-1.5`}>{`ESPESSURA DO PAINEL, MM:`}</label><select value={l} onChange={e => {
              let t = Number(e.target.value);
              u(t);
              o(s, t, d);
            }} className={`w-full rounded-md border border-stone-200 dark:border-stone-700 bg-white dark:bg-stone-800 px-3 py-2 text-sm font-medium shadow-2xs focus:outline-none focus:ring-1 focus:ring-primary cursor-pointer`}>{[6, 9, 12, 15, 16, 18, 25].map(e => <option value={e} key={e}>{e}</option>)}</select></div><div><label className={`block text-[10px] font-mono font-medium tracking-wider text-stone-500 uppercase mb-1.5`}>{`TAMANHO DO PAINEL, MM:`}</label><select value={d} onChange={e => {
              let t = e.target.value;
              f(t);
              o(s, l, t);
            }} className={`w-full rounded-md border border-stone-200 dark:border-stone-700 bg-white dark:bg-stone-800 px-3 py-2 text-sm font-medium shadow-2xs focus:outline-none focus:ring-1 focus:ring-primary cursor-pointer`}>{[`1830x2750`, `1840x2750`, `1850x2750`, `2750x1830`].map(e => <option value={e} key={e}>{e}</option>)}</select></div></div><div className={`flex-1 overflow-y-auto px-6 pb-6`}><div className={`grid grid-cols-5 gap-3.5`}>{SD.map(e => {
              let t = s === e.id || s === e.codigo;
                                                                                                  return <button type={`button`} onClick={() => {
                c(e.id);
                o(e.id, l, d);
                a();
              }} className={U(`flex flex-col rounded-lg overflow-hidden transition-all text-left group relative border bg-white dark:bg-stone-800 shadow-2xs hover:shadow-md`, t ? `ring-2 ring-stone-900 dark:ring-white border-stone-900 dark:border-white` : `border-stone-200 dark:border-stone-700 hover:border-stone-400`)} key={e.id}>{t && <div className={`absolute top-1 right-1 z-10 flex h-5 w-5 items-center justify-center rounded-xs bg-stone-900 text-white dark:bg-white dark:text-stone-900 shadow-xs`}><Ut className={`h-3.5 w-3.5 stroke-[3]`} /></div>}<div className={`h-20 w-full relative overflow-hidden flex items-center justify-center`} style={{
                  backgroundColor: e.hex || `#e4d7c5`
                }}><img src={e.imagem} alt={e.nome} className={`h-full w-full object-cover`} onError={e => {
                    e.target.style.display = `none`;
                  }} /></div><div className={`border-t border-stone-100 dark:border-stone-700/60 bg-white dark:bg-stone-800/90 py-1.5 px-1 text-center`}><span className={`font-mono text-[11px] font-medium text-stone-600 dark:text-stone-300 group-hover:text-stone-900 dark:group-hover:text-white`}>{e.codigo}</span></div></button>;
            })}</div></div></div></div>;
  } else {
    return null;
  }
}
var wD = {
  nome: `Módulo Customizado`,
  categoria: `horizontal`,
  largura: 2752,
  altura: 1700,
  profundidade: 500,
  espessuraCorpo: 16,
  espessuraFrentes: 16,
  materialCorpo: `FL-E083`,
  materialFrentes: `FL-E083`,
  fundoPadrao: `hdf-6mm`,
  recuoTraseiroMm: 15,
  caixas: [{
    id: `caixa-principal`,
    x: 0,
    y: 0,
    largura: 2752,
    altura: 1700,
    profundidade: 500,
    preenchimento: `porta-sobreposta`,
    materialFrentes: `FL-E083`,
    materialCorpo: `FL-E083`,
    espessuraCorpo: 16,
    espessuraFrentes: 16,
    puxadorLado: `direita`
  }],
  caixaSelecionadaId: `caixa-principal`
};
function TD({
  aberto: e,
  onFechar: t,
  onSalvar: n
}) {
  let [r, i] = (0, k.useState)(wD);
  let [a, o] = (0, k.useState)([wD]);
  let [s, c] = (0, k.useState)(0);
  let [l, u] = (0, k.useState)(`selecionar`);
  let [d, f] = (0, k.useState)(null);
  let [p, m] = (0, k.useState)(null);
  let [h, g] = (0, k.useState)(`1830x2750`);
  let [_, v] = (0, k.useState)(false);
  let y = (0, k.useMemo)(() => r.caixas.find(e => e.id === r.caixaSelecionadaId) || r.caixas[0] || null, [r.caixas, r.caixaSelecionadaId]);
  let b = (0, k.useMemo)(() => {
    let e = y?.materialFrentes || r.materialFrentes;
    let t = SD.find(t => t.id === e || t.codigo === e);
    if (t?.hex) {
      return t.hex;
    } else {
      return RT.find(t => t.id === e)?.hex || `#e4d7c5`;
    }
  }, [y, r.materialFrentes]);
  let x = (0, k.useMemo)(() => {
    let e = y?.materialCorpo || r.materialCorpo;
    let t = SD.find(t => t.id === e || t.codigo === e);
    if (t?.hex) {
      return t.hex;
    } else {
      return RT.find(t => t.id === e)?.hex || `#e4d7c5`;
    }
  }, [y, r.materialCorpo]);
  let [S, C] = (0, k.useState)(0.32);
  let [w, T] = (0, k.useState)({
    x: 200,
    y: 140
  });
  let E = (0, k.useRef)(null);
  let [D, O] = (0, k.useState)(null);
  let [A, ee] = (0, k.useState)(null);
  (0, k.useEffect)(() => {
    if (e && (i(wD), o([wD]), c(0), u(`selecionar`), f(null), E.current)) {
      let e = E.current.getBoundingClientRect();
      let t = Math.min((e.width - 240) / 2752, (e.height - 240) / 1700, 0.4);
      C(t);
      T({
        x: Math.max(60, (e.width - t * 2752) / 2),
        y: Math.max(60, (e.height - t * 1700) / 2)
      });
    }
  }, [e]);
  let te = (0, k.useCallback)(e => {
    let t = a.slice(0, s + 1);
    t.push(e);
    o(t);
    c(t.length - 1);
    i(e);
  }, [a, s]);
  let j = (0, k.useCallback)(() => {
    if (s > 0) {
      let e = s - 1;
      c(e);
      i(a[e]);
    }
  }, [s, a]);
  let ne = (0, k.useCallback)(() => {
    if (s < a.length - 1) {
      let e = s + 1;
      c(e);
      i(a[e]);
    }
  }, [s, a]);
  (0, k.useEffect)(() => {
    if (!e) {
      return;
    }
    let n = e => {
      if ((e.metaKey || e.ctrlKey) && e.key === `z`) {
        e.preventDefault();
        if (e.shiftKey) {
          ne();
        } else {
          j();
        }
      } else if (e.key === `Delete` || e.key === `Backspace`) {
        if (r.caixaSelecionadaId) {
          e.preventDefault();
          re();
        }
      } else if (e.key === `Escape`) {
        if (d) {
          f(null);
        } else {
          t();
        }
      }
    };
    window.addEventListener(`keydown`, n);
    return () => window.removeEventListener(`keydown`, n);
  }, [e, r.caixaSelecionadaId, d, j, ne, t]);
  function re() {
    if (r.caixaSelecionadaId) {
      let e = r.caixas.filter(e => e.id !== r.caixaSelecionadaId);
      te({
        ...r,
        caixas: e,
        caixaSelecionadaId: null
      });
    } else if (r.caixas.length > 0) {
      te({
        ...r,
        caixas: [],
        caixaSelecionadaId: null
      });
    }
  }
  let M = (0, k.useCallback)((e, t) => {
    if (!E.current) {
      return {
        x: 0,
        y: 0
      };
    }
    let n = E.current.getBoundingClientRect();
    return {
      x: (e - n.left - w.x) / S,
      y: (t - n.top - w.y) / S
    };
  }, [w.x, w.y, S]);
  let ie = (e, t = 10) => Math.round(e / t) * t;
  let ae = e => {
    if (e.button !== 0) {
      return;
    }
    let t = M(e.clientX, e.clientY);
    if (l === `desenhar`) {
      O({
        startX: ie(t.x),
        startY: ie(t.y),
        currentX: ie(t.x),
        currentY: ie(t.y)
      });
      e.target.setPointerCapture(e.pointerId);
    }
  };
  let oe = e => {
    if (D) {
      let t = M(e.clientX, e.clientY);
      O(e => e ? {
        ...e,
        currentX: ie(t.x),
        currentY: ie(t.y)
      } : null);
    } else if (A) {
      let t = (e.clientX - A.origemMouseX) / S;
      let n = (e.clientY - A.origemMouseY) / S;
      let r = ie(A.origemBoxX + t);
      let a = ie(A.origemBoxY + n);
      i(e => ({
        ...e,
        caixas: e.caixas.map(e => e.id === A.id ? {
          ...e,
          x: r,
          y: a
        } : e)
      }));
    }
  };
  let se = e => {
    if (D) {
      let t = Math.min(D.startX, D.currentX);
      let n = Math.min(D.startY, D.currentY);
      let i = Math.abs(D.currentX - D.startX);
      let a = Math.abs(D.currentY - D.startY);
      O(null);
      try {
        e.target.releasePointerCapture(e.pointerId);
      } catch {}
      if (i >= 50 && a >= 50) {
        let e = {
          id: `caixa-${Date.now()}-${Math.random().toString(36).substring(2, 6)}`,
          x: t,
          y: n,
          largura: i,
          altura: a,
          profundidade: r.profundidade,
          preenchimento: `porta-sobreposta`,
          materialFrentes: r.materialFrentes,
          materialCorpo: r.materialCorpo,
          espessuraCorpo: r.espessuraCorpo,
          espessuraFrentes: r.espessuraFrentes,
          puxadorLado: `direita`
        };
        let o = {
          ...r,
          caixas: [...r.caixas, e],
          caixaSelecionadaId: e.id
        };
        te(o);
        u(`selecionar`);
        f(e.id);
      }
    } else if (A) {
      te(r);
      ee(null);
    }
  };
  let ce = e => {
    let t = e || r.caixaSelecionadaId || r.caixas[0]?.id;
    if (!t) {
      return;
    }
    let n = r.caixas.find(e => e.id === t);
    if (!n || n.largura < 80) {
      return;
    }
    let i = n.espessuraCorpo || r.espessuraCorpo || 16;
    let a = Math.round((n.largura - i) / 2);
    let o = {
      ...n,
      id: `c-sub1-${Date.now()}-${Math.random().toString(36).substring(2, 5)}`,
      largura: a,
      puxadorLado: `esquerda`
    };
    let s = {
      ...n,
      id: `c-sub2-${Date.now()}-${Math.random().toString(36).substring(2, 5)}`,
      x: n.x + a + i,
      largura: a,
      puxadorLado: `direita`
    };
    let c = r.caixas.filter(e => e.id !== t).concat([o, s]);
    te({
      ...r,
      caixas: c,
      caixaSelecionadaId: o.id
    });
  };
  let le = e => {
    let t = e || r.caixaSelecionadaId || r.caixas[0]?.id;
    if (!t) {
      return;
    }
    let n = r.caixas.find(e => e.id === t);
    if (!n || n.altura < 80) {
      return;
    }
    let i = n.espessuraCorpo || r.espessuraCorpo || 16;
    let a = Math.round((n.altura - i) / 2);
    let o = {
      ...n,
      id: `c-sub1-${Date.now()}-${Math.random().toString(36).substring(2, 5)}`,
      altura: a
    };
    let s = {
      ...n,
      id: `c-sub2-${Date.now()}-${Math.random().toString(36).substring(2, 5)}`,
      y: n.y + a + i,
      altura: a
    };
    let c = r.caixas.filter(e => e.id !== t).concat([o, s]);
    te({
      ...r,
      caixas: c,
      caixaSelecionadaId: o.id
    });
  };
  let ue = e => {
    let t = e || r.caixaSelecionadaId || r.caixas[0]?.id;
    if (!t) {
      return;
    }
    let n = r.caixas.map(e => {
      if (e.id === t) {
        let t = e.puxadorLado === `esquerda` ? `direita` : `esquerda`;
        return {
          ...e,
          puxadorLado: t
        };
      }
      return e;
    });
    te({
      ...r,
      caixas: n,
      caixaSelecionadaId: t
    });
  };
  let de = (e, t) => {
    e.stopPropagation();
    te({
      ...r,
      caixaSelecionadaId: t
    });
    if (l === `selecionar`) {
      f(t);
    } else if (l === `divisao-vertical`) {
      ce(t);
    } else if (l === `divisao-horizontal`) {
      le(t);
    }
  };
  let fe = e => {
    if (!d) {
      return;
    }
    let t = r.caixas.map(t => t.id === d ? {
      ...t,
      preenchimento: e
    } : t);
    te({
      ...r,
      caixas: t
    });
    f(null);
  };
  let pe = e => {
    let t = Math.max(100, Math.min(1200, e || 500));
    te({
      ...r,
      profundidade: t,
      caixas: r.caixas.map(e => ({
        ...e,
        profundidade: t
      }))
    });
  };
  let me = async () => {
    if (r.caixas.length !== 0) {
      try {
        v(true);
        await n(r, true);
        t();
      } finally {
        v(false);
      }
    }
  };
  let N = (0, k.useMemo)(() => {
    if (r.caixas.length === 0) {
      return null;
    }
    let e = Infinity;
    let t = -Infinity;
    let n = Infinity;
    let i = -Infinity;
    r.caixas.forEach(r => {
      e = Math.min(e, r.x);
      t = Math.max(t, r.x + r.largura);
      n = Math.min(n, r.y);
      i = Math.max(i, r.y + r.altura);
    });
    let a = Math.round(t - e);
    let o = Math.round(i - n);
    let s = Array.from(new Set(r.caixas.flatMap(e => [Math.round(e.x), Math.round(e.x + e.largura)]))).sort((e, t) => e - t);
    let c = [];
    for (let e = 0; e < s.length - 1; e++) {
      let t = s[e];
      let n = s[e + 1];
      if (n - t > 1) {
        c.push({
          x1: t,
          x2: n,
          valor: n - t
        });
      }
    }
    let l = Array.from(new Set(r.caixas.flatMap(e => [Math.round(e.y), Math.round(e.y + e.altura)]))).sort((e, t) => e - t);
    let u = [];
    for (let e = 0; e < l.length - 1; e++) {
      let t = l[e];
      let n = l[e + 1];
      if (n - t > 1) {
        u.push({
          y1: t,
          y2: n,
          valor: n - t
        });
      }
    }
    return {
      minX: e,
      maxX: t,
      minY: n,
      maxY: i,
      larguraTotal: a,
      alturaTotal: o,
      segmentosX: c,
      segmentosY: u
    };
  }, [r.caixas]);
  if (e) {
                                                                                                                                                                return <div className={`fixed inset-0 z-50 flex flex-col bg-stone-100 dark:bg-stone-950 select-none`}><div className={`absolute top-4 left-4 right-4 z-30 flex items-center justify-between pointer-events-none`}><div className={`flex items-center gap-1 rounded-xl bg-white/95 dark:bg-stone-900/95 p-1.5 shadow-lg border border-stone-200/80 dark:border-stone-800/80 pointer-events-auto backdrop-blur-md`}><button type={`button`} title={`Desfazer (Ctrl+Z)`} onClick={j} disabled={s <= 0} className={`rounded-lg p-2 text-stone-600 dark:text-stone-300 hover:bg-stone-100 dark:hover:bg-stone-800 disabled:opacity-35 transition-colors`}><_Component80 className={`h-4 w-4`} /></button><button type={`button`} title={`Refazer (Ctrl+Shift+Z)`} onClick={ne} disabled={s >= a.length - 1} className={`rounded-lg p-2 text-stone-600 dark:text-stone-300 hover:bg-stone-100 dark:hover:bg-stone-800 disabled:opacity-35 transition-colors`}><Yn className={`h-4 w-4`} /></button><div className={`h-5 w-px bg-stone-200 dark:bg-stone-800 mx-1`} /><button type={`button`} title={`Ponteiro / Selecionar / Preenchimento`} onClick={() => u(`selecionar`)} className={U(`rounded-lg p-2 transition-colors`, l === `selecionar` ? `bg-stone-200 text-stone-900 dark:bg-stone-800 dark:text-stone-100` : `text-stone-600 dark:text-stone-300 hover:bg-stone-100 dark:hover:bg-stone-800`)}><In className={`h-4 w-4 fill-current`} /></button><button type={`button`} title={`Lápis / Desenhar Caixa do Móvel`} onClick={() => u(`desenhar`)} className={U(`rounded-lg p-2 transition-colors`, l === `desenhar` ? `bg-stone-200 text-stone-900 dark:bg-stone-800 dark:text-stone-100` : `text-stone-600 dark:text-stone-300 hover:bg-stone-100 dark:hover:bg-stone-800`)}><Wn className={`h-4 w-4`} /></button><button type={`button`} title={`Divisão Vertical (divide módulo ao meio ou adiciona portas verticais)`} onClick={() => {
            u(`divisao-vertical`);
            ce();
          }} className={U(`rounded-lg p-2 transition-colors`, l === `divisao-vertical` ? `bg-stone-200 text-stone-900 dark:bg-stone-800 dark:text-stone-100` : `text-stone-600 dark:text-stone-300 hover:bg-stone-100 dark:hover:bg-stone-800`)}><Zt className={`h-4 w-4`} /></button><button type={`button`} title={`Divisão Horizontal (divide módulo ao meio horizontalmente)`} onClick={() => {
            u(`divisao-horizontal`);
            le();
          }} className={U(`rounded-lg p-2 transition-colors`, l === `divisao-horizontal` ? `bg-stone-200 text-stone-900 dark:bg-stone-800 dark:text-stone-100` : `text-stone-600 dark:text-stone-300 hover:bg-stone-100 dark:hover:bg-stone-800`)}><_Component81 className={`h-4 w-4`} /></button><div className={`h-5 w-px bg-stone-200 dark:bg-stone-800 mx-1`} /><button type={`button`} title={`Excluir selecionado ou limpar tudo`} onClick={re} className={`rounded-lg p-2 text-rose-600 hover:bg-rose-50 dark:text-rose-400 dark:hover:bg-rose-950/40 transition-colors`}><_Component26 className={`h-4 w-4`} /></button></div><div className={`flex items-center gap-3 rounded-xl bg-white/95 dark:bg-stone-900/95 px-4 py-2 shadow-lg border border-stone-200/80 dark:border-stone-800/80 pointer-events-auto backdrop-blur-md text-xs`}>{y?.preenchimento.includes(`porta`) && <L.Fragment><button type={`button`} title={`Clique para alternar abertura da porta (Esquerda / Direita)`} onClick={() => ue(y.id)} className={`flex items-center gap-1.5 bg-sky-100/80 hover:bg-sky-200 dark:bg-sky-950/70 dark:hover:bg-sky-900 text-sky-800 dark:text-sky-200 border border-sky-300/80 dark:border-sky-700/80 px-2 py-1 rounded-md text-xs font-semibold transition-colors cursor-pointer`}><span className={`font-medium text-sky-700 dark:text-sky-300`}>{`Porta:`}</span><span className={`capitalize`}>{y.puxadorLado === `esquerda` ? `Esquerda` : `Direita`}</span></button><div className={`h-4 w-px bg-stone-200 dark:bg-stone-800`} /></L.Fragment>}<button type={`button`} onClick={() => m(`Frentes`)} className={`flex items-center gap-1.5 text-stone-700 dark:text-stone-200 hover:bg-stone-100 dark:hover:bg-stone-800 px-1.5 py-1 rounded-md transition-colors cursor-pointer`}><span className={`font-medium text-stone-600 dark:text-stone-400`}>{`Frentes:`}</span><div className={`h-4 w-4 rounded-xs border border-stone-300 shadow-2xs shrink-0`} style={{
              backgroundColor: b
            }} /><span className={`font-medium font-mono text-[11px]`}>{y?.espessuraFrentes || r.espessuraFrentes}{`x`}{h}</span></button><div className={`h-4 w-px bg-stone-200 dark:bg-stone-800`} /><button type={`button`} onClick={() => m(`Corpo do móvel`)} className={`flex items-center gap-1.5 text-stone-700 dark:text-stone-200 hover:bg-stone-100 dark:hover:bg-stone-800 px-1.5 py-1 rounded-md transition-colors cursor-pointer`}><span className={`font-medium text-stone-600 dark:text-stone-400`}>{`Corpo do móvel:`}</span><div className={`h-4 w-4 rounded-xs border border-stone-300 shadow-2xs shrink-0`} style={{
              backgroundColor: x
            }} /><span className={`font-medium font-mono text-[11px]`}>{y?.espessuraCorpo || r.espessuraCorpo}{`x`}{h}</span></button><div className={`h-4 w-px bg-stone-200 dark:bg-stone-800`} /><div className={`flex items-center gap-1.5 text-stone-700 dark:text-stone-200`}><span className={`font-medium text-stone-600 dark:text-stone-400`}>{`Profundidade:`}</span><input type={`number`} value={y?.profundidade || r.profundidade} onChange={e => pe(Number(e.target.value))} className={`w-14 rounded-md border border-stone-300 dark:border-stone-700 bg-transparent px-1.5 py-0.5 text-center font-mono text-xs font-semibold focus:outline-none focus:ring-1 focus:ring-primary`} /></div><div className={`flex items-center gap-1 text-stone-600 dark:text-stone-400 font-mono text-xs cursor-default`}><span>{`mm`}</span><Wt className={`h-3 w-3 opacity-60`} /></div>{r.caixas.length > 0 && <button type={`button`} onClick={me} disabled={_} className={`ml-2 rounded-lg bg-emerald-600 hover:bg-emerald-700 text-white px-3 py-1.5 font-medium text-xs shadow-xs transition-colors`}>{_ ? `Inserindo...` : `Inserir no Projeto 3D`}</button>}<button type={`button`} onClick={t} className={`rounded-lg p-1 text-stone-500 hover:bg-stone-100 hover:text-stone-800 dark:hover:bg-stone-800 dark:hover:text-stone-200 transition-colors ml-1`}><Dr className={`h-4 w-4`} /></button></div></div><div ref={E} onPointerDown={ae} onPointerMove={oe} onPointerUp={se} className={U(`relative flex-1 w-full h-full overflow-hidden touch-none`, l === `desenhar` ? `cursor-crosshair` : `cursor-default`)} style={{
        backgroundImage: `
            radial-gradient(circle, rgba(0,0,0,0.06) 1px, transparent 1px),
            linear-gradient(to right, rgba(0,0,0,0.03) 1px, transparent 1px),
            linear-gradient(to bottom, rgba(0,0,0,0.03) 1px, transparent 1px)
          `,
        backgroundSize: `20px 20px, 100px 100px, 100px 100px`
      }}>{r.caixas.length === 0 && !D && <div className={`absolute inset-0 flex items-center justify-center pointer-events-none select-none`}><span className={`text-3xl font-light tracking-wide text-stone-300 dark:text-stone-700/80`}>{`Desenhar móveis`}</span></div>}<div className={`absolute origin-top-left pointer-events-auto`} style={{
          transform: `translate(${w.x}px, ${w.y}px) scale(${S})`
        }}>{r.caixas.map(e => {
            let t = r.caixaSelecionadaId === e.id;
            let n = e.preenchimento.includes(`1-gaveta`) ? 1 : e.preenchimento.includes(`2-gaveta`) ? 2 : e.preenchimento.includes(`3-gaveta`) ? 3 : e.preenchimento.includes(`4-gaveta`) ? 4 : 0;
                                                                                    return <div onClick={t => de(t, e.id)} className={U(`absolute transition-shadow select-none group cursor-pointer`, t ? `shadow-md ring-4 ring-sky-300/60` : `hover:brightness-95`)} style={{
              left: `${e.x}px`,
              top: `${e.y}px`,
              width: `${e.largura}px`,
              height: `${e.altura}px`,
              border: `3.5px solid #38bdf8`,
              backgroundColor: `rgba(186, 230, 253, 0.45)`
            }} key={e.id}>{n > 0 ? <div className={`flex flex-col h-full w-full divide-y-[3px] divide-sky-400`}>{Array.from({
                  length: n
                }).map((e, t) => <div className={`flex-1 relative flex items-center justify-center`} key={t}><div className={`rounded-full bg-slate-500 shadow-xs`} style={{
                    width: `22px`,
                    height: `22px`
                  }} /></div>)}</div> : <div className={`relative h-full w-full`}>{e.preenchimento.includes(`porta`) && <div title={`Clique para alternar lado do puxador (Esquerda / Direita)`} onClick={t => {
                  t.stopPropagation();
                  ue(e.id);
                }} className={U(`absolute top-1/2 -translate-y-1/2 rounded-full bg-slate-600 dark:bg-slate-300 shadow-md ring-2 ring-white/90 dark:ring-stone-900 cursor-pointer hover:scale-135 active:scale-95 transition-all duration-150 z-10`, e.puxadorLado === `esquerda` ? `left-8` : `right-8`)} style={{
                  width: `28px`,
                  height: `28px`
                }} />}</div>}</div>;
          })}{D && (() => {
            let e = Math.min(D.startX, D.currentX);
            let t = Math.min(D.startY, D.currentY);
            let n = Math.abs(D.currentX - D.startX);
            let r = Math.abs(D.currentY - D.startY);
                                                return <div className={`absolute pointer-events-none`} style={{
              left: `${e}px`,
              top: `${t}px`,
              width: `${n}px`,
              height: `${r}px`,
              border: `3.5px solid #38bdf8`,
              backgroundColor: `rgba(186, 230, 253, 0.45)`
            }}><div className={`absolute right-10 top-1/2 -translate-y-1/2 rounded-full bg-slate-500 shadow-xs`} style={{
                width: `26px`,
                height: `26px`
              }} /><div className={`absolute -bottom-14 left-1/2 -translate-x-1/2 bg-blue-600 text-white font-mono font-bold px-3 py-1.5 rounded-lg shadow-md whitespace-nowrap text-2xl`}>{Math.round(n)}{` x `}{Math.round(r)}{` mm`}</div></div>;
          })()}{N && !D && <svg className={`absolute overflow-visible pointer-events-none`} style={{
            left: 0,
            top: 0,
            width: 1,
            height: 1
          }}>{(() => {
              let e = N.minX - 75;
              let t = `#6366f1`;
              let n = `#4338ca`;
                                                                                                  return <g>{N.segmentosY.map((r, i) => {
                  let a = (r.y1 + r.y2) / 2;
                                                                                                            return <g key={`seg-y-${i}`}><line x1={e} y1={r.y1} x2={e} y2={r.y2} stroke={t} strokeWidth={`3.5`} /><line x1={e - 35} y1={r.y1} x2={e + 35} y2={r.y1} stroke={t} strokeWidth={`3.5`} /><line x1={e - 35} y1={r.y2} x2={e + 35} y2={r.y2} stroke={t} strokeWidth={`3.5`} /><text x={e - 28} y={a} fill={n} fontSize={`50`} fontFamily={`monospace`} fontWeight={`600`} textAnchor={`middle`} transform={`rotate(-90 ${e - 28} ${a})`}>{Math.round(r.valor)}</text></g>;
                })}{N.segmentosY.length > 1 && <g>{`const totalX = posX - 80`}<line x1={e - 80} y1={N.minY} x2={e - 80} y2={N.maxY} stroke={t} strokeWidth={`3.5`} /><line x1={e - 80 - 35} y1={N.minY} x2={e - 80 + 35} y2={N.minY} stroke={t} strokeWidth={`3.5`} /><line x1={e - 80 - 35} y1={N.maxY} x2={e - 80 + 35} y2={N.maxY} stroke={t} strokeWidth={`3.5`} /><text x={e - 110} y={(N.minY + N.maxY) / 2} fill={n} fontSize={`54`} fontFamily={`monospace`} fontWeight={`bold`} textAnchor={`middle`} transform={`rotate(-90 ${e - 110} ${(N.minY + N.maxY) / 2})`}>{N.alturaTotal}</text></g>}</g>;
            })()}{(() => {
              let e = N.maxY + 75;
              let t = `#6366f1`;
              let n = `#4338ca`;
                                                                                                  return <g>{N.segmentosX.map((r, i) => {
                  let a = (r.x1 + r.x2) / 2;
                                                                                                            return <g key={`seg-x-${i}`}><line x1={r.x1} y1={e} x2={r.x2} y2={e} stroke={t} strokeWidth={`3.5`} /><line x1={r.x1} y1={e - 35} x2={r.x1} y2={e + 35} stroke={t} strokeWidth={`3.5`} /><line x1={r.x2} y1={e - 35} x2={r.x2} y2={e + 35} stroke={t} strokeWidth={`3.5`} /><text x={a} y={e + 52} fill={n} fontSize={`50`} fontFamily={`monospace`} fontWeight={`600`} textAnchor={`middle`}>{Math.round(r.valor)}</text></g>;
                })}{N.segmentosX.length > 1 && <g>{`const totalY = posY + 80`}<line x1={N.minX} y1={e + 80} x2={N.maxX} y2={e + 80} stroke={t} strokeWidth={`3.5`} /><line x1={N.minX} y1={e + 80 - 35} x2={N.minX} y2={e + 80 + 35} stroke={t} strokeWidth={`3.5`} /><line x1={N.maxX} y1={e + 80 - 35} x2={N.maxX} y2={e + 80 + 35} stroke={t} strokeWidth={`3.5`} /><text x={(N.minX + N.maxX) / 2} y={e + 135} fill={n} fontSize={`54`} fontFamily={`monospace`} fontWeight={`bold`} textAnchor={`middle`}>{N.larguraTotal}</text></g>}</g>;
            })()}</svg>}</div></div><_Component82 aberto={!!d} onFechar={() => f(null)} onSelecionar={fe} /><CD aberto={!!p} titulo={p || `Corpo do móvel`} materialSelecionadoId={p === `Frentes` ? y?.materialFrentes || r.materialFrentes : y?.materialCorpo || r.materialCorpo} espessuraSelecionada={p === `Frentes` ? y?.espessuraFrentes || r.espessuraFrentes : y?.espessuraCorpo || r.espessuraCorpo} tamanhoSelecionado={h} onFechar={() => m(null)} onSalvar={(e, t, n) => {
        g(n);
        if (p === `Frentes`) {
          let n = r.caixas.map(n => n.id === r.caixaSelecionadaId ? {
            ...n,
            materialFrentes: e,
            espessuraFrentes: t
          } : n);
          te({
            ...r,
            materialFrentes: e,
            espessuraFrentes: t,
            caixas: n
          });
        } else {
          let n = r.caixas.map(n => n.id === r.caixaSelecionadaId ? {
            ...n,
            materialCorpo: e,
            espessuraCorpo: t
          } : n);
          te({
            ...r,
            materialCorpo: e,
            espessuraCorpo: t,
            caixas: n
          });
        }
      }} /></div>;
  } else {
    return null;
  }
}
function ED(e, t) {
  if (!e.caixas || e.caixas.length === 0) {
    return {
      tenant_id: t,
      nome: e.nome.trim() || `Módulo ${e.largura}x${e.altura}x${e.profundidade}`,
      categoria: e.categoria,
      largura_mm: Math.round(e.largura),
      altura_mm: Math.round(e.altura),
      profundidade_mm: Math.round(e.profundidade),
      cor: e.materialCorpo,
      portas: 0,
      gavetas: 0,
      ativo: true
    };
  }
  let n = Infinity;
  let r = -Infinity;
  let i = Infinity;
  let a = -Infinity;
  let o = 0;
  let s = 0;
  let c = 0;
  for (let t of e.caixas) {
    n = Math.min(n, t.x);
    r = Math.max(r, t.x + t.largura);
    i = Math.min(i, t.y);
    a = Math.max(a, t.y + t.altura);
    o = Math.max(o, t.profundidade);
    if (t.preenchimento.includes(`porta`)) {
      s++;
    }
    if (t.preenchimento.includes(`1-gaveta`)) {
      c += 1;
    }
    if (t.preenchimento.includes(`2-gavetas`) || t.preenchimento.includes(`2-gaveta`)) {
      c += 2;
    }
    if (t.preenchimento.includes(`3-gavetas`) || t.preenchimento.includes(`3-gaveta`)) {
      c += 3;
    }
    if (t.preenchimento.includes(`4-gavetas`) || t.preenchimento.includes(`4-gaveta`)) {
      c += 4;
    }
  }
  let l = Math.max(1, r - n);
  let u = Math.max(1, a - i);
  let d = o || e.profundidade || 500;
  let f = e.nome.trim() || `Módulo Customizado`;
  let p = Math.random().toString(36).substring(2, 6).toUpperCase();
  return {
    tenant_id: t,
    nome: `${f} ${Math.round(l)}x${Math.round(u)}x${Math.round(d)} [${p}]`,
    categoria: e.categoria,
    largura_mm: Math.round(l),
    altura_mm: Math.round(u),
    profundidade_mm: Math.round(d),
    cor: e.materialCorpo,
    portas: s,
    gavetas: c,
    ativo: true
  };
}
function DD(e, t, n, r) {
  let i = Infinity;
  let a = -Infinity;
  let o = Infinity;
  let s = -Infinity;
  let c = 0;
  let l = 0;
  let u = 0;
  for (let t of e.caixas) {
    i = Math.min(i, t.x);
    a = Math.max(a, t.x + t.largura);
    o = Math.min(o, t.y);
    s = Math.max(s, t.y + t.altura);
    c = Math.max(c, t.profundidade);
    if (t.preenchimento.includes(`porta`)) {
      l++;
    }
    if (t.preenchimento.includes(`1-gaveta`)) {
      u += 1;
    }
    if (t.preenchimento.includes(`2-gavetas`) || t.preenchimento.includes(`2-gaveta`)) {
      u += 2;
    }
    if (t.preenchimento.includes(`3-gavetas`) || t.preenchimento.includes(`3-gaveta`)) {
      u += 3;
    }
    if (t.preenchimento.includes(`4-gavetas`) || t.preenchimento.includes(`4-gaveta`)) {
      u += 4;
    }
  }
  let d = Math.max(1, a - i);
  let f = Math.max(1, s - o);
  let p = c || e.profundidade || 500;
  let m = e.categoria === `horizontal`;
  let h = d / 2;
  let g = p / 2;
  let _ = t.profundidade ?? 2400;
  let v = Tm(p / 2, g, Math.max(g, _ - g));
  let y = m ? Math.max(0, t.altura - f / 2) : f / 2;
  let b = n.modulos.reduce((e, t) => Math.max(e, t.x + Em(t) / 2), 0) + h;
  let x = e.nome.trim() || `Módulo Customizado`;
  return {
    id: Sm(),
    catalogo_id: r?.id ?? null,
    nome: r?.nome || `${x} ${Math.round(d)}x${Math.round(f)}x${Math.round(p)}`,
    categoria: e.categoria,
    x: b,
    y,
    z: v,
    largura: Math.round(d),
    altura: Math.round(f),
    profundidade: Math.round(p),
    rotacao: 0,
    cor: e.materialCorpo || `FL-E083`,
    portas: l,
    gavetas: u,
    espessura: e.espessuraCorpo || 16,
    prateleiras: 0,
    divisorias: 0,
    acabamentoCaixaria: e.materialCorpo || `FL-E083`,
    acabamentoFrente: e.materialFrentes || `FL-E083`,
    puxador: `perfil_alca`,
    tipoPorta: l > 0 ? `giro` : `nenhuma`,
    portasAbertas: false,
    visivel: true,
    bloqueado: false,
    caixasDesenho: e.caixas
  };
}
function OD() {
  let {
    id: e
  } = g();
  let t = f();
  let {
    data: n,
    isLoading: r
  } = lm(e);
  if (r) {
    return <Ks className={`h-dvh w-full`} />;
  } else if (n) {
    return <_Component83 design={n} key={n.id} />;
  } else {
        return <div className={`flex h-dvh w-full items-center justify-center p-6`}><Ws title={`Estudo 3D não encontrado`} action={<G variant={`outline`} onClick={() => t(`/designer`)}><Mt className={`h-4 w-4`} />{`Voltar aos Estudos`}</G>} /></div>;
  }
}
function _Component83({
  design: e
}) {
  let t = f();
  let {
    escuro: n
  } = Xo();
  let {
    data: r,
    isLoading: i
  } = im();
  let a = am();
  let o = dm(e.id);
  let s = om();
  let c = sm();
  let [l, u] = (0, k.useState)(null);
  let {
    data: d
  } = Yl(e.projeto_id);
  let p = (0, k.useMemo)(() => d?.ambientes ?? [], [d]);
  let {
    data: m
  } = Au(e.ambiente_id ?? undefined);
  let h = _u(e.projeto_id);
  let g = yu(e.id);
  let [_, v] = (0, k.useState)(() => Pm(e.cena));
  let [y, b] = (0, k.useState)(() => ({
    largura: Number(e.largura_mm),
    altura: Number(e.altura_mm),
    profundidade: Number(e.profundidade_mm)
  }));
  let [x, S] = (0, k.useState)(e.nome);
  let [C, w] = (0, k.useState)(null);
  let [T, E] = (0, k.useState)(null);
  let [D, O] = (0, k.useState)(`fundo`);
  let [A, ee] = (0, k.useState)(`frontal`);
  let [te, j] = (0, k.useState)(`biblioteca`);
  let [ne, re] = (0, k.useState)(false);
  let [M, ie] = (0, k.useState)(false);
  let [ae, oe] = (0, k.useState)(false);
  let [se, ce] = (0, k.useState)(false);
  let le = () => typeof window > `u` || typeof window.matchMedia != `function` || window.matchMedia(`(min-width: 1024px)`).matches;
  let [ue, de] = (0, k.useState)(le);
  let [fe, pe] = (0, k.useState)(le);
  let [me, he] = (0, k.useState)([]);
  let [ge, _e] = (0, k.useState)([]);
  let ve = (0, k.useRef)(null);
  let ye = (0, k.useMemo)(() => _.modulos.find(e => e.id === C) ?? null, [_.modulos, C]);
  let be = (0, k.useMemo)(() => _.componentes ?? [], [_.componentes]);
  let xe = (0, k.useMemo)(() => _.comodo ?? {
    largura: y.largura,
    profundidade: Math.max(2400, y.profundidade),
    altura: y.altura,
    tipo: zT((_.cenario ?? gm).preset).tipo
  }, [_.comodo, y.largura, y.profundidade, y.altura]);
  let Se = (0, k.useMemo)(() => be.find(e => e.id === T) ?? null, [be, T]);
  let Ce = (0, k.useMemo)(() => nh(_).map(e => ({
    ...e,
    nome: _.modulos.find(t => t.id === e.id)?.nome ?? ``
  })), [_]);
  function P(e) {
    he(t => [...t.slice(-49), e]);
    _e([]);
  }
  function we(e, t) {
    if (t?.historico !== false) {
      P(_);
    }
    v(e);
    re(true);
  }
  function F() {
    ve.current = _;
  }
  function Te() {
    if (!ve.current) {
      return;
    }
    let e = ve.current;
    ve.current = null;
    if (e !== _) {
      P(e);
    }
  }
  function I() {
    he(e => {
      let t = e[e.length - 1];
      if (t) {
        _e(e => [...e.slice(-49), _]);
        v(t);
        re(true);
        return e.slice(0, -1);
      } else {
        return e;
      }
    });
  }
  function Ee() {
    _e(e => {
      let t = e[e.length - 1];
      if (t) {
        he(e => [...e.slice(-49), _]);
        v(t);
        re(true);
        return e.slice(0, -1);
      } else {
        return e;
      }
    });
  }
  function De(e) {
    let t = eE(_, y, e);
    we(t.cena);
    w(t.modulo.id);
  }
  async function R(t, n) {
    if (!t.caixas || t.caixas.length === 0) {
      return;
    }
    let r = ED(t, e.tenant_id);
    let i = await s.mutateAsync({
      ...r,
      cor: r.cor ?? null
    });
    if (n) {
      let e = DD(t, y, _, i ?? undefined);
      we({
        ..._,
        modulos: [..._.modulos, e]
      });
      w(e.id);
      N.success(`Módulo ${e.largura}x${e.altura} inserido no projeto com sucesso!`);
    }
  }
  function z(e, t) {
    let n = tE(_, y, e, t);
    we(n.cena);
    w(n.modulo.id);
  }
  function Oe(e) {
    let t = {
      ...y,
      ...e
    };
    b(t);
    we(Gm(_, t));
  }
  async function ke(e) {
    await o.mutateAsync({
      ambiente_id: e
    });
    if (!e) {
      return;
    }
    let t = await Su(e).catch(() => null);
    if (!t) {
      return;
    }
    let n = e => e === null ? null : Math.round(e * 10);
    let r = {
      largura: n(t.largura_cm) ?? y.largura,
      altura: n(t.altura_cm) ?? y.altura,
      profundidade: n(t.profundidade_cm) ?? y.profundidade
    };
    if (r.largura === y.largura && r.altura === y.altura && r.profundidade === y.profundidade) {
      return;
    }
    let i = p.find(t => t.id === e)?.nome ?? `ambiente`;
    b(r);
    we(Gm(_, r));
    N.success(`Vão de ${i} aplicado ao estudo.`);
  }
  function Ae(t) {
    if (e.ambiente_id) {
      h.mutate({
        id: e.ambiente_id,
        payload: {
          margem_percent: Math.min(200, Math.max(0, t))
        }
      });
    }
  }
  function je(e) {
    let t = rE(_, xe, e);
    b({
      largura: t.comodo.largura,
      altura: t.comodo.altura,
      profundidade: y.profundidade
    });
    we(t.cena);
  }
  function Me(e) {
    let t = iE(_, e, D, xe);
    we(t.cena);
    E(t.componente.id);
    w(null);
  }
  function Ne(e, t) {
    if (!(_.componentes ?? []).find(t => t.id === e)?.bloqueado || `bloqueado` in t || `visivel` in t) {
      we(aE(_, e, t, xe), {
        historico: false
      });
    }
  }
  function Pe(e) {
    let t = (_.componentes ?? []).find(t => t.id === e);
    if (!t) {
      return;
    }
    let n = t.visivel !== false;
    we(aE(_, e, {
      visivel: !n
    }, xe));
  }
  function Fe(e) {
    let t = (_.componentes ?? []).find(t => t.id === e);
    if (!t) {
      return;
    }
    let n = t.bloqueado === true;
    we(aE(_, e, {
      bloqueado: !n
    }, xe));
  }
  function Ie(e) {
    if (!(_.componentes ?? []).find(t => t.id === e)?.bloqueado) {
      we(oE(_, e));
      if (e === T) {
        E(null);
      }
    }
  }
  function Le(e) {
    let t = nE(_, e);
    b(t.nicho);
    w(null);
    E(null);
    O(`fundo`);
    we(t.cena);
    N.success(`${e.nome} aplicado. O que já estava desenhado foi mantido.`);
  }
  async function Re() {
    await g.mutateAsync({});
  }
  function ze(e) {
    if (C && (!_.modulos.find(e => e.id === C)?.bloqueado || `bloqueado` in e || `visivel` in e)) {
      we(Km(_, y, C, e));
    }
  }
  function Be(e) {
    let t = e ?? C;
    if (t) {
      if (!_.modulos.find(e => e.id === t)?.bloqueado) {
        we(Ym(_, y, t));
      }
    }
  }
  function Ve(e) {
    let t = e ?? T;
    if (t) {
      if (!(_.componentes ?? []).find(e => e.id === t)?.bloqueado) {
        we(Xm(_, xe, t));
      }
    }
  }
  function He() {
    if (!C) {
      return;
    }
    let e = Jm(_, y, C);
    we(e.cena);
    if (e.novoId) {
      w(e.novoId);
    }
  }
  function Ue(e) {
    let t = e ?? C;
    if (t) {
      we(qm(_, t));
      if (t === C) {
        w(null);
      }
    }
  }
  function We() {
    we(cE(_));
    w(null);
    E(null);
  }
  function Ge(e) {
    we({
      ..._,
      modulos: _.modulos.map(t => ({
        ...t,
        cor: e,
        acabamentoCaixaria: e,
        acabamentoFrente: e
      }))
    });
  }
  function Ke(e) {
    let t = _.modulos.find(t => t.id === e);
    if (t) {
      we(Km(_, y, e, {
        visivel: t.visivel === false
      }), {
        historico: false
      });
      P(_);
    }
  }
  function qe(e) {
    let t = _.modulos.find(t => t.id === e);
    if (t) {
      we(Km(_, y, e, {
        bloqueado: t.bloqueado !== true
      }), {
        historico: false
      });
      P(_);
    }
  }
  function Je(e, t) {
    if (C) {
      we(Qm(_, y, C, e, t));
    }
  }
  async function Ye() {
    await o.mutateAsync({
      nome: x.trim() || `Estudo 3D`,
      largura_mm: y.largura,
      altura_mm: y.altura,
      profundidade_mm: y.profundidade,
      cena: _
    });
    re(false);
  }
  let Xe = (0, k.useRef)({
    desfazer: I,
    refazerAcao: Ee,
    excluir: Ue,
    selecionadoId: C
  });
  (0, k.useEffect)(() => {
    Xe.current = {
      desfazer: I,
      refazerAcao: Ee,
      excluir: Ue,
      selecionadoId: C
    };
  });
  (0, k.useEffect)(() => {
    function e(e) {
      let t = e.target;
      if (t && (t.tagName === `INPUT` || t.tagName === `TEXTAREA` || t.isContentEditable)) {
        return;
      }
      let n = e.ctrlKey || e.metaKey;
      if (n && e.key.toLowerCase() === `z`) {
        e.preventDefault();
        if (e.shiftKey) {
          Xe.current.refazerAcao();
        } else {
          Xe.current.desfazer();
        }
        return;
      }
      if (n && e.key.toLowerCase() === `y`) {
        e.preventDefault();
        Xe.current.refazerAcao();
        return;
      }
      if ((e.key === `Delete` || e.key === `Backspace`) && Xe.current.selecionadoId) {
        e.preventDefault();
        Xe.current.excluir();
        return;
      }
      if (e.key === `Escape`) {
        w(null);
      }
    }
    window.addEventListener(`keydown`, e);
    return () => window.removeEventListener(`keydown`, e);
  }, []);
  (0, k.useEffect)(() => {
    let e = window.matchMedia(`(min-width: 1024px)`);
    let t = e => {
      if (!e.matches) {
        de(false);
        pe(false);
      }
    };
    e.addEventListener(`change`, t);
    return () => e.removeEventListener(`change`, t);
  }, []);
                                                                                  return <div className={`flex h-dvh w-full flex-col overflow-hidden bg-background text-foreground select-none`}><header className={`z-30 flex h-13 shrink-0 items-center justify-between gap-2 overflow-hidden border-b border-border bg-card px-2 shadow-sm sm:px-3`}><div className={`flex min-w-0 flex-1 items-center gap-1.5 sm:gap-2.5`}><G variant={`ghost`} size={`sm`} onClick={() => t(`/designer`)} className={`h-8 shrink-0 gap-1.5 px-2 text-xs font-medium text-muted-foreground hover:text-foreground`} title={`Voltar aos Estudos 3D`}><Mt className={`h-4 w-4`} /><span className={`hidden sm:inline`}>{`Voltar`}</span></G><div className={`hidden h-4 w-[1px] bg-border sm:block`} /><div className={`flex min-w-0 items-center gap-2`}><input type={`text`} value={x} onChange={e => {
            S(e.target.value);
            re(true);
          }} placeholder={`Nome do Estudo 3D`} className={`h-7 w-32 min-w-0 truncate rounded-md border border-transparent bg-transparent px-2 text-xs font-semibold text-foreground hover:border-border focus:border-emerald-500 focus:bg-card focus:outline-none focus:ring-1 focus:ring-emerald-500 sm:w-44 md:w-60`} /><span className={`hidden xl:inline-block rounded-full bg-stone-100 px-2 py-0.5 text-[10px] font-mono text-muted-foreground dark:bg-stone-800`}>{`Vão: `}{Za(y.largura, 0)}{` × `}{Za(y.altura, 0)}{` × `}{Za(y.profundidade, 0)}{` mm`}</span></div></div><div className={`hidden md:flex items-center gap-1`}><div className={`flex items-center gap-1 rounded-lg border border-border bg-muted/40 p-0.5`}><G variant={`ghost`} size={`icon`} className={`h-7 w-7`} onClick={I} disabled={me.length === 0} title={`Desfazer (Ctrl+Z)`}><_Component80 className={`h-3.5 w-3.5`} /></G><G variant={`ghost`} size={`icon`} className={`h-7 w-7`} onClick={Ee} disabled={ge.length === 0} title={`Refazer (Ctrl+Shift+Z)`}><Yn className={`h-3.5 w-3.5`} /></G></div><div className={`h-4 w-[1px] bg-border mx-1`} /><div className={`flex items-center gap-1 rounded-lg border border-border bg-muted/40 px-1.5 py-0.5 text-xs`}>{[`x`, `y`, `z`].map(e => <div className={`flex items-center gap-0.5`} key={e}><span className={`text-[10px] font-bold uppercase text-muted-foreground`}>{e}</span><button type={`button`} disabled={!ye} onClick={() => Je(e, -10)} className={`h-5 w-5 rounded text-[11px] font-semibold text-muted-foreground hover:bg-card hover:text-foreground disabled:opacity-30`} title={`Deslocar ${e} -10mm`}>{`−`}</button><button type={`button`} disabled={!ye} onClick={() => Je(e, 10)} className={`h-5 w-5 rounded text-[11px] font-semibold text-muted-foreground hover:bg-card hover:text-foreground disabled:opacity-30`} title={`Deslocar ${e} +10mm`}>{`+`}</button></div>)}</div><div className={`h-4 w-[1px] bg-border mx-1`} /><G variant={`outline`} size={`sm`} className={`h-7 gap-1 text-xs`} onClick={() => Be()} disabled={!ye} title={`Girar 90°`}><$n className={`h-3.5 w-3.5`} /><span className={`hidden lg:inline`}>{`Girar`}</span></G><G variant={`outline`} size={`sm`} className={`h-7 gap-1 text-xs`} onClick={He} disabled={!ye} title={`Duplicar módulo`}><$t className={`h-3.5 w-3.5`} /><span className={`hidden lg:inline`}>{`Duplicar`}</span></G><G variant={`ghost`} size={`sm`} className={`h-7 gap-1 text-xs text-destructive hover:bg-destructive/10`} onClick={() => Ue()} disabled={!ye} title={`Excluir módulo`}><_Component26 className={`h-3.5 w-3.5`} /><span className={`hidden lg:inline`}>{`Excluir`}</span></G></div><div className={`flex shrink-0 items-center gap-1.5 sm:gap-2`}><div className={`hidden items-center gap-1.5 px-1 sm:px-2 min-[420px]:flex`}><span className={U(`h-2 w-2 rounded-full`, ne ? `bg-amber-500 animate-pulse` : `bg-emerald-500`)} /><span className={`text-[11px] font-medium text-muted-foreground hidden sm:inline`}>{ne ? `Não salvo` : `Salvo`}</span></div><G size={`sm`} className={`h-8 gap-1.5 text-xs bg-emerald-600 hover:bg-emerald-700 text-white font-medium`} onClick={() => void Ye()} disabled={o.isPending || !ne}><_Component84 className={`h-3.5 w-3.5`} />{o.isPending ? `Salvando...` : `Salvar`}</G><div className={`hidden h-4 w-[1px] bg-border sm:block`} /><button type={`button`} onClick={() => {
          let e = !ue;
          de(e);
          if (e && !le()) {
            pe(false);
          }
        }} title={ue ? `Ocultar Biblioteca` : `Mostrar Biblioteca`} className={U(`flex h-8 w-8 items-center justify-center rounded-lg border transition-colors`, ue ? `border-border bg-stone-100 text-foreground dark:bg-stone-800` : `border-transparent text-muted-foreground hover:bg-stone-100 dark:hover:bg-stone-800`)}>{ue ? <Rn className={`h-4 w-4`} /> : <_Component85 className={`h-4 w-4`} />}</button><button type={`button`} onClick={() => {
          let e = !fe;
          pe(e);
          if (e && !le()) {
            de(false);
          }
        }} title={fe ? `Ocultar Parâmetros` : `Mostrar Parâmetros`} className={U(`flex h-8 w-8 items-center justify-center rounded-lg border transition-colors`, fe ? `border-border bg-stone-100 text-foreground dark:bg-stone-800` : `border-transparent text-muted-foreground hover:bg-stone-100 dark:hover:bg-stone-800`)}>{fe ? <Bn className={`h-4 w-4`} /> : <Vn className={`h-4 w-4`} />}</button></div></header><div className={`relative flex flex-1 min-h-0 w-full overflow-hidden`}>{(ue || fe) && <div className={`absolute inset-0 z-10 bg-black/40 backdrop-blur-[1px] lg:hidden`} onClick={() => {
        de(false);
        pe(false);
      }} />}{ue && <aside className={`absolute inset-y-0 left-0 z-20 flex w-72 max-w-[85vw] shrink-0 flex-col overflow-hidden border-r border-border bg-card p-3 shadow-lg transition-all duration-200 lg:static lg:w-64 lg:max-w-none xl:w-72`}><_Component32 value={te} onValueChange={j} tabs={[{
          value: `biblioteca`,
          label: `Biblioteca`
        }, {
          value: `comodo`,
          label: `Cômodo`
        }, {
          value: `elementos`,
          label: `Elementos`,
          count: _.modulos.length
        }]} /><div className={`min-h-0 flex-1 overflow-hidden mt-3`}>{te === `biblioteca` && <_Component86 modulos={r ?? []} carregando={i} semeando={a.isPending} aoAdicionar={De} aoSemear={() => a.mutate()} aoCriar={() => ie(true)} aoDesenhar={() => oe(true)} aoRemover={e => u(e)} />}{te === `comodo` && <_Component87 paredeAtiva={D} aoMudarParede={O} aoAdicionarComponente={Me} aoRemoverComponente={Ie} aoSelecionarComponente={E} componenteSelecionadoId={T} componentes={be} aoCarregarModelo={Le} larguraParede={ym(D, xe)} tipoComodo={xe.tipo} aoAlternarVisivelComponente={Pe} aoAlternarBloqueadoComponente={Fe} />}{te === `elementos` && <div className={`h-full overflow-y-auto pr-1`}><_Component88 modulos={_.modulos} selecionadoId={C} aoSelecionar={w} aoAlternarVisivel={Ke} aoAlternarBloqueado={qe} aoExcluir={Ue} /></div>}</div></aside>}<main className={`relative isolate flex min-w-0 flex-1 flex-col h-full overflow-hidden bg-stone-900/5 dark:bg-stone-950`}><div className={`relative flex-1 min-h-0 w-full`}><_Component89 cena={_} nicho={y} comodo={xe} selecionadoId={C} componenteSelecionadoId={T} interativo={true} vista={A} escuro={n} cenario={_.cenario ?? gm} onSelecionar={e => {
            w(e);
            if (e) {
              E(null);
            }
          }} onSelecionarComponente={e => {
            E(e);
            if (e) {
              w(null);
            }
          }} onMover={(e, t) => we(Wm(_, y, e, t), {
            historico: false
          })} onMoverComponente={(e, t) => Ne(e, t)} onRedimensionarComponente={(e, t) => Ne(e, t)} onRedimensionar={(e, t) => we(Km(_, y, e, t), {
            historico: false
          })} onGirar={e => Be(e)} onGirarComponente={e => Ve(e)} onInteracaoInicio={F} onInteracaoFim={Te} onMudarVista={e => ee(e)} onMudarCenario={e => we(sE(_, e))} onDropModulo={z} onExcluir={e => Ue(e)} onExcluirComponente={e => Ie(e)} onDuplicar={() => He()} onBloquear={(e, t) => we(Km(_, y, e, {
            bloqueado: t
          }))} onBloquearComponente={(e, t) => we(aE(_, e, {
            bloqueado: t
          }, xe))} />{_.modulos.length === 0 && <div className={`pointer-events-none absolute inset-0 grid place-items-center p-6`}><div className={`max-w-sm rounded-xl border border-dashed border-border bg-card/90 p-4 text-center shadow-lg backdrop-blur-md`}><p className={`text-xs font-medium text-foreground`}>{`Sua cena 3D está vazia`}</p><p className={`mt-1 text-[11px] text-muted-foreground`}>{`Clique em um módulo da biblioteca à esquerda para posicioná-lo. Arraste para mover, use as alças nos cantos para redimensionar e gire na alça do topo.`}</p></div></div>}</div><div className={`shrink-0 border-t border-border bg-card/80 px-2 py-1`}><_Component90 largura={Math.max(y.largura, th(_) || y.largura)} segmentos={Ce} /></div></main>{fe && <aside className={`absolute inset-y-0 right-0 z-20 flex w-80 max-w-[90vw] shrink-0 flex-col overflow-hidden border-l border-border bg-card p-3 shadow-lg transition-all duration-200 lg:static lg:w-76 lg:max-w-none xl:w-84`}><_D nome={x} aoMudarNome={e => {
          S(e);
          re(true);
        }} nicho={y} aoMudarNicho={Oe} selecionado={ye} aoMudarModulo={ze} aoGirar={() => Be()} aoDuplicar={He} aoExcluir={() => Ue()} aoLimpar={() => ce(true)} aoAplicarTodos={Ge} cena={_} ambiente={e.ambiente} ambientesDoProjeto={p} medicaoAmbiente={m ?? null} aoVincularAmbiente={ke} aoMudarMargem={Ae} aoGerarOrcamento={() => void Re()} gerandoOrcamento={g.isPending} podeGerarOrcamento={_.modulos.length > 0 && !ne} comodo={xe} aoMudarComodo={je} componenteSelecionado={Se} aoMudarComponente={Ne} aoGirarComponente={() => Ve()} aoRemoverComponente={Ie} /></aside>}</div><_Component91 open={M} onOpenChange={ie} /><TD aberto={ae} onFechar={() => oe(false)} onSalvar={R} /><_Component29 open={se} onOpenChange={ce} title={`Limpar cena`} description={`Os módulos e as peças do cômodo serão removidos. O ambiente fica.`} confirmLabel={`Limpar`} onConfirm={We} /><_Component29 open={!!l} onOpenChange={e => !e && u(null)} title={`Excluir módulo da biblioteca`} description={`Deseja realmente remover "${l?.nome}" da biblioteca?`} confirmLabel={c.isPending ? `Excluindo...` : `Excluir`} onConfirm={async () => {
      if (l) {
        await c.mutateAsync(l.id);
        u(null);
      }
    }} /></div>;
}
function AD({
  somenteLeitura: e
}) {
  let {
    data: t,
    isLoading: r
  } = Ir();
  let a = Rr();
  let o = zr();
  let s = (0, k.useRef)(null);
  let {
    register: c,
    handleSubmit: l,
    reset: u,
    formState: {
      errors: d,
      isSubmitting: f
    }
  } = i({
    resolver: n(Sc),
    defaultValues: {
      name: ``,
      documento: ``,
      telefone: ``,
      email: ``,
      endereco: ``,
      cidade: ``,
      uf: ``,
      cep: ``,
      termos_contrato: ``,
      faturamento_email: ``,
      faturamento_documento: ``
    }
  });
  (0, k.useEffect)(() => {
    if (t) {
      u({
        name: t.name,
        documento: t.documento ?? ``,
        telefone: t.telefone ?? ``,
        email: t.email ?? ``,
        endereco: t.endereco ?? ``,
        cidade: t.cidade ?? ``,
        uf: t.uf ?? ``,
        cep: t.cep ?? ``,
        termos_contrato: t.termos_contrato ?? ``,
        faturamento_email: t.faturamento_email ?? ``,
        faturamento_documento: t.faturamento_documento ?? ``
      });
    }
  }, [t, u]);
  async function p(e) {
    await a.mutateAsync(jl(e));
  }
  async function m(e) {
    if (e && e.length !== 0 && t) {
      await o.mutateAsync({
        file: e[0],
        tenantId: t.id
      });
      if (s.current) {
        s.current.value = ``;
      }
    }
  }
  if (r) {
    return <Ks className={`h-64`} />;
  } else {
                                                            return <div className={`space-y-6`}><Rs><_Component11><Bs className={`text-base`}>{`Identidade visual`}</Bs></_Component11><Hs className={`flex items-center gap-4`}>{t?.logo_url ? <img src={t.logo_url} alt={`Logotipo`} className={`h-16 w-16 rounded-lg border border-border object-cover`} /> : <div className={`grid h-16 w-16 place-items-center rounded-lg border border-dashed border-border text-muted-foreground`}><_Component92 className={`h-5 w-5`} /></div>}<div><input ref={s} type={`file`} accept={`image/*`} className={`hidden`} onChange={e => void m(e.target.files)} /><G variant={`outline`} size={`sm`} disabled={e || o.isPending} onClick={() => s.current?.click()}><_Component42 className={`h-4 w-4`} />{o.isPending ? `Enviando...` : `Trocar logotipo`}</G><p className={`mt-1 text-xs text-muted-foreground`}>{`PNG ou JPG quadrado, até 2 MB.`}</p></div></Hs></Rs><Rs><_Component11><Bs className={`text-base`}>{`Dados da empresa`}</Bs></_Component11><Hs><form onSubmit={l(p)} className={`grid gap-4 sm:grid-cols-2`}><_Component19 label={`Nome da marcenaria`} htmlFor={`t-name`} error={d.name?.message} required={true} className={`sm:col-span-2`}><K id={`t-name`} disabled={e} {...c(`name`)} /></_Component19><_Component19 label={`CNPJ/CPF`} htmlFor={`t-doc`} error={d.documento?.message}><K id={`t-doc`} disabled={e} {...c(`documento`)} /></_Component19><_Component19 label={`Telefone`} htmlFor={`t-tel`} error={d.telefone?.message}><K id={`t-tel`} disabled={e} {...c(`telefone`)} /></_Component19><_Component19 label={`E-mail`} htmlFor={`t-email`} error={d.email?.message}><K id={`t-email`} disabled={e} {...c(`email`)} /></_Component19><_Component19 label={`Endereço`} htmlFor={`t-end`} error={d.endereco?.message}><K id={`t-end`} disabled={e} {...c(`endereco`)} /></_Component19><_Component19 label={`Cidade`} htmlFor={`t-cidade`} error={d.cidade?.message}><K id={`t-cidade`} disabled={e} {...c(`cidade`)} /></_Component19><div className={`grid grid-cols-2 gap-4`}><_Component19 label={`UF`} htmlFor={`t-uf`} error={d.uf?.message}><K id={`t-uf`} maxLength={2} disabled={e} {...c(`uf`)} /></_Component19><_Component19 label={`CEP`} htmlFor={`t-cep`} error={d.cep?.message}><K id={`t-cep`} disabled={e} {...c(`cep`)} /></_Component19></div><_Component19 label={`Termos contratuais padrão`} htmlFor={`t-termos`} error={d.termos_contrato?.message} className={`sm:col-span-2`}><Rl id={`t-termos`} rows={5} disabled={e} {...c(`termos_contrato`)} /></_Component19><_Component19 label={`E-mail de faturamento`} htmlFor={`t-fat-email`} error={d.faturamento_email?.message}><K id={`t-fat-email`} disabled={e} {...c(`faturamento_email`)} /></_Component19><_Component19 label={`Documento de faturamento`} htmlFor={`t-fat-doc`} error={d.faturamento_documento?.message}><K id={`t-fat-doc`} disabled={e} {...c(`faturamento_documento`)} /></_Component19>{!e && <div className={`sm:col-span-2`}><G type={`submit`} disabled={f}>{f ? `Salvando...` : `Salvar dados`}</G></div>}</form></Hs></Rs><Rs><_Component11><Bs className={`text-base`}>{`Assinatura SaaS`}</Bs></_Component11><Hs className={`flex flex-wrap items-center gap-6 text-sm`}><div><p className={`text-[11px] font-medium text-muted-foreground`}>{`Plano`}</p><p className={`font-medium capitalize`}>{t?.plano_nome ?? `-`}</p></div><div><p className={`text-[11px] font-medium text-muted-foreground`}>{`Situação`}</p><Gs label={t?.plano_status ?? `-`} tone={t?.plano_status === `ativo` ? `bg-emerald-600 dark:bg-emerald-500` : `bg-amber-500 dark:bg-amber-400`} /></div></Hs></Rs></div>;
  }
}
function _Component96({
  ehAdmin: e
}) {
  let {
    data: t,
    isLoading: r
  } = Lr();
  let a = Br();
  let o = Vr();
  let [s, c] = (0, k.useState)(false);
  let {
    register: l,
    handleSubmit: u,
    reset: d,
    formState: {
      errors: f,
      isSubmitting: p
    }
  } = i({
    resolver: n(Cc),
    defaultValues: {
      full_name: ``,
      email: ``,
      password: ``,
      role: `marceneiro`
    }
  });
  (0, k.useEffect)(() => {
    if (s) {
      d({
        full_name: ``,
        email: ``,
        password: ``,
        role: `marceneiro`
      });
    }
  }, [s, d]);
  async function m(e) {
    await a.mutateAsync(e);
    c(false);
  }
          return <div className={`space-y-4`}><div className={`flex justify-end`}><G size={`sm`} disabled={!e} onClick={() => c(true)}><_Component10 className={`h-4 w-4`} />{`Novo membro`}</G></div>{r ? <Ks className={`h-48`} /> : <Rs className={`overflow-hidden`}><_Component28><_Component25><_Component24><J>{`Nome`}</J><J className={`hidden sm:table-cell`}>{`E-mail`}</J><J className={`hidden md:table-cell`}>{`Telefone`}</J><J>{`Perfil de acesso`}</J></_Component24></_Component25><_Component27>{(t ?? []).map(t => {
            let n = t.roles[0] ?? `member`;
                                    return <_Component24 key={t.id}><Y className={`font-medium`}>{t.full_name ?? `-`}</Y><Y className={`hidden sm:table-cell text-muted-foreground`}>{t.email}</Y><Y className={`hidden md:table-cell text-muted-foreground`}>{oo(t.telefone)}</Y><Y>{e ? <_Component31 className={`h-8 w-44 text-xs`} value={n} onChange={e => o.mutate({
                  userId: t.id,
                  role: e.target.value
                })}>{Gr.map(e => <option value={e} key={e}>{Wr[e]}</option>)}{!Gr.includes(n) && <option value={n}>{Wr[n] ?? n}</option>}</_Component31> : <Gs label={Wr[n] ?? n} tone={`bg-stone-400 dark:bg-stone-500`} />}</Y></_Component24>;
          })}</_Component27></_Component28></Rs>}<_Component21 open={s} onOpenChange={c} title={`Novo membro da equipe`} description={`O membro acessará apenas os dados desta marcenaria.`} footer={<L.Fragment><G variant={`outline`} onClick={() => c(false)} disabled={p}>{`Cancelar`}</G><G form={`membro-form`} type={`submit`} disabled={p}>{p ? `Criando...` : `Criar acesso`}</G></L.Fragment>}><form id={`membro-form`} onSubmit={u(m)} className={`grid gap-4`}><_Component19 label={`Nome completo`} htmlFor={`m-nome`} error={f.full_name?.message} required={true}><K id={`m-nome`} {...l(`full_name`)} /></_Component19><_Component19 label={`E-mail`} htmlFor={`m-email`} error={f.email?.message} required={true}><K id={`m-email`} type={`email`} {...l(`email`)} /></_Component19><_Component19 label={`Senha provisória`} htmlFor={`m-senha`} error={f.password?.message} required={true}><K id={`m-senha`} type={`text`} {...l(`password`)} /></_Component19><_Component19 label={`Perfil de acesso`} htmlFor={`m-role`} error={f.role?.message} required={true}><_Component31 id={`m-role`} {...l(`role`)}>{Gr.map(e => <option value={e} key={e}>{Wr[e]}</option>)}</_Component31></_Component19></form></_Component21></div>;
}
function MD() {
  let {
    user: e,
    roles: t
  } = Ct();
  let r = Hr(e?.id);
  let {
    data: a
  } = Lr();
  let [o, s] = (0, k.useState)(``);
  let [c, l] = (0, k.useState)(false);
  let {
    register: u,
    handleSubmit: d,
    reset: f,
    formState: {
      errors: p,
      isSubmitting: m
    }
  } = i({
    resolver: n(wc),
    defaultValues: {
      full_name: ``,
      telefone: ``
    }
  });
  let h = (a ?? []).find(t => t.id === e?.id);
  (0, k.useEffect)(() => {
    if (h) {
      f({
        full_name: h.full_name ?? ``,
        telefone: h.telefone ?? ``
      });
    }
  }, [h, f]);
  async function g(e) {
    await r.mutateAsync(Ml(e));
  }
  async function _() {
    if (o.length < 6) {
      N.error(`A senha deve ter no mínimo 6 caracteres.`);
      return;
    }
    l(true);
    let {
      error: e
    } = await B.auth.updateUser({
      password: o
    });
    l(false);
    if (e) {
      N.error(e.message);
      return;
    }
    s(``);
    N.success(`Senha atualizada.`);
  }
              return <div className={`space-y-6`}><Rs><_Component11><Bs className={`flex items-center gap-2 text-base`}><_Component93 className={`h-4 w-4`} />{`Meu perfil`}</Bs></_Component11><Hs><form onSubmit={d(g)} className={`grid gap-4 sm:grid-cols-2`}><_Component19 label={`E-mail`} htmlFor={`u-email`}><K id={`u-email`} value={e?.email ?? ``} readOnly={true} disabled={true} /></_Component19><_Component19 label={`Perfis`} htmlFor={`u-roles`}><div className={`flex h-9 items-center gap-2`}>{t.length > 0 ? t.map(e => <Gs label={Wr[e] ?? e} tone={`bg-stone-400 dark:bg-stone-500`} key={e} />) : <span className={`text-sm text-muted-foreground`}>{`-`}</span>}</div></_Component19><_Component19 label={`Nome completo`} htmlFor={`u-nome`} error={p.full_name?.message} required={true}><K id={`u-nome`} {...u(`full_name`)} /></_Component19><_Component19 label={`Telefone`} htmlFor={`u-tel`} error={p.telefone?.message}><K id={`u-tel`} {...u(`telefone`)} /></_Component19><div className={`sm:col-span-2`}><G type={`submit`} disabled={m}>{m ? `Salvando...` : `Salvar perfil`}</G></div></form></Hs></Rs><Rs><_Component11><Bs className={`flex items-center gap-2 text-base`}><_Component94 className={`h-4 w-4`} />{`Segurança`}</Bs><Vs>{`Altere sua senha de acesso à plataforma.`}</Vs></_Component11><Hs><div className={`flex flex-col gap-4 sm:flex-row sm:items-end`}><_Component19 label={`Nova senha`} htmlFor={`u-senha`}><K id={`u-senha`} type={`password`} placeholder={`Mínimo 6 caracteres`} value={o} onChange={e => s(e.target.value)} /></_Component19><G type={`button`} onClick={_} disabled={c || !o}>{c ? `Alterando...` : `Alterar senha`}</G></div></Hs></Rs></div>;
}
function ND({
  somenteLeitura: e
}) {
  let {
    data: t,
    isLoading: r
  } = Ir();
  let a = Rr();
  let {
    register: o,
    handleSubmit: s,
    reset: c,
    formState: {
      errors: l,
      isSubmitting: u
    }
  } = i({
    resolver: n(Mc),
    defaultValues: it
  });
  (0, k.useEffect)(() => {
    if (t) {
      let e = t.config_precos ?? {};
      c({
        precoChapaMDF: Number(e.precoChapaMDF) > 0 ? Number(e.precoChapaMDF) : it.precoChapaMDF,
        precoChapaFundo: Number(e.precoChapaFundo) > 0 ? Number(e.precoChapaFundo) : it.precoChapaFundo,
        precoMetroFita: Number(e.precoMetroFita) > 0 ? Number(e.precoMetroFita) : it.precoMetroFita,
        precoDobradica: Number(e.precoDobradica) >= 0 ? Number(e.precoDobradica) : it.precoDobradica,
        precoCorredica: Number(e.precoCorredica) >= 0 ? Number(e.precoCorredica) : it.precoCorredica,
        precoPuxador: Number(e.precoPuxador) >= 0 ? Number(e.precoPuxador) : it.precoPuxador,
        precoMinifix: Number(e.precoMinifix) >= 0 ? Number(e.precoMinifix) : it.precoMinifix,
        precoParafuso: Number(e.precoParafuso) >= 0 ? Number(e.precoParafuso) : it.precoParafuso,
        precoSuporte: Number(e.precoSuporte) >= 0 ? Number(e.precoSuporte) : it.precoSuporte,
        precoSapata: Number(e.precoSapata) >= 0 ? Number(e.precoSapata) : it.precoSapata,
        precoServicoPeca: Number(e.precoServicoPeca) >= 0 ? Number(e.precoServicoPeca) : it.precoServicoPeca,
        taxaMontagemBase: Number(e.taxaMontagemBase) >= 0 ? Number(e.taxaMontagemBase) : it.taxaMontagemBase,
        margemPadrao: Number(e.margemPadrao) >= 0 ? Number(e.margemPadrao) : it.margemPadrao
      });
    }
  }, [t, c]);
  async function d(e) {
    await a.mutateAsync({
      config_precos: e
    });
    N.success(`Tabela de preços e custos padrão salva com sucesso.`);
  }
  function f() {
    c(it);
    N.info(`Valores padrão de mercado preenchidos. Clique em Salvar para confirmar.`);
  }
  if (r) {
    return <Ks className={`h-64`} />;
  } else {
                                return <form onSubmit={s(d)} className={`space-y-6`}><div className={`flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between`}><div><h2 className={`text-base font-semibold text-foreground`}>{`Tabela de Preços & Custos do Orçamento 3D`}</h2><p className={`text-xs text-muted-foreground`}>{`Defina os custos médios praticados pela sua marcenaria. Eles serão usados como base nos cálculos automáticos de orçamento no editor 3D e nas propostas comerciais.`}</p></div><div className={`flex items-center gap-2`}><G type={`button`} variant={`outline`} size={`sm`} disabled={e} onClick={f} className={`gap-1.5 text-xs`}><Qn className={`h-3.5 w-3.5`} />{`Restaurar padrões`}</G><G type={`submit`} size={`sm`} disabled={e || u} className={`gap-1.5 text-xs`}><Xt className={`h-3.5 w-3.5`} />{u ? `Salvando...` : `Salvar tabela`}</G></div></div><div className={`grid gap-6 md:grid-cols-2`}><Rs><_Component11><Bs className={`flex items-center gap-2 text-sm font-semibold`}><Rt className={`h-4 w-4 text-primary`} />{`Chapas & Painéis MDF`}</Bs><Vs className={`text-xs`}>{`Preço de compra por chapa inteira padrão (2,75 m × 1,85 m).`}</Vs></_Component11><Hs className={`grid gap-4 sm:grid-cols-2`}><_Component19 label={`Chapa MDF 15mm/18mm (R$/chapa)`} htmlFor={`p-mdf`} error={l.precoChapaMDF?.message} required={true}><K id={`p-mdf`} type={`number`} step={`0.01`} min={`0`} disabled={e} {...o(`precoChapaMDF`, {
                valueAsNumber: true
              })} /></_Component19><_Component19 label={`Chapa Fundo 6mm (R$/chapa)`} htmlFor={`p-fundo`} error={l.precoChapaFundo?.message} required={true}><K id={`p-fundo`} type={`number`} step={`0.01`} min={`0`} disabled={e} {...o(`precoChapaFundo`, {
                valueAsNumber: true
              })} /></_Component19></Hs></Rs><Rs><_Component11><Bs className={`flex items-center gap-2 text-sm font-semibold`}><_Component60 className={`h-4 w-4 text-primary`} />{`Fita de Borda PVC`}</Bs><Vs className={`text-xs`}>{`Custo por metro linear de fita aplicada (material + cola).`}</Vs></_Component11><Hs><_Component19 label={`Preço por metro linear aplicado (R$/m)`} htmlFor={`p-fita`} error={l.precoMetroFita?.message} required={true}><K id={`p-fita`} type={`number`} step={`0.01`} min={`0`} disabled={e} {...o(`precoMetroFita`, {
                valueAsNumber: true
              })} /></_Component19></Hs></Rs><Rs className={`md:col-span-2`}><_Component11><Bs className={`flex items-center gap-2 text-sm font-semibold`}><Er className={`h-4 w-4 text-primary`} />{`Ferragens, Puxadores & Fixadores`}</Bs><Vs className={`text-xs`}>{`Valores unitários médios utilizados na decomposição estrutural dos módulos.`}</Vs></_Component11><Hs className={`grid gap-4 sm:grid-cols-2 lg:grid-cols-4`}><_Component19 label={`Dobradiça 35mm amortecedor (R$/un)`} htmlFor={`p-dob`} error={l.precoDobradica?.message}><K id={`p-dob`} type={`number`} step={`0.01`} min={`0`} disabled={e} {...o(`precoDobradica`, {
                valueAsNumber: true
              })} /></_Component19><_Component19 label={`Corrediça telescópica (R$/par)`} htmlFor={`p-cor`} error={l.precoCorredica?.message}><K id={`p-cor`} type={`number`} step={`0.01`} min={`0`} disabled={e} {...o(`precoCorredica`, {
                valueAsNumber: true
              })} /></_Component19><_Component19 label={`Puxador Perfil/Cava (R$/un)`} htmlFor={`p-pux`} error={l.precoPuxador?.message}><K id={`p-pux`} type={`number`} step={`0.01`} min={`0`} disabled={e} {...o(`precoPuxador`, {
                valueAsNumber: true
              })} /></_Component19><_Component19 label={`Conector Minifix + Tambor (R$/un)`} htmlFor={`p-mini`} error={l.precoMinifix?.message}><K id={`p-mini`} type={`number`} step={`0.01`} min={`0`} disabled={e} {...o(`precoMinifix`, {
                valueAsNumber: true
              })} /></_Component19><_Component19 label={`Parafuso Estrutural (R$/un)`} htmlFor={`p-par`} error={l.precoParafuso?.message}><K id={`p-par`} type={`number`} step={`0.01`} min={`0`} disabled={e} {...o(`precoParafuso`, {
                valueAsNumber: true
              })} /></_Component19><_Component19 label={`Suporte de Prateleira (R$/un)`} htmlFor={`p-sup`} error={l.precoSuporte?.message}><K id={`p-sup`} type={`number`} step={`0.01`} min={`0`} disabled={e} {...o(`precoSuporte`, {
                valueAsNumber: true
              })} /></_Component19><_Component19 label={`Sapata / Pé Nivelador (R$/un)`} htmlFor={`p-sap`} error={l.precoSapata?.message}><K id={`p-sap`} type={`number`} step={`0.01`} min={`0`} disabled={e} {...o(`precoSapata`, {
                valueAsNumber: true
              })} /></_Component19></Hs></Rs><Rs><_Component11><Bs className={`flex items-center gap-2 text-sm font-semibold`}><_Component75 className={`h-4 w-4 text-primary`} />{`Mão de Obra, Usinagem & Montagem`}</Bs><Vs className={`text-xs`}>{`Custos de corte, usinagem e serviço de montagem.`}</Vs></_Component11><Hs className={`grid gap-4 sm:grid-cols-2`}><_Component19 label={`Custo por peça cortada/furada (R$/peça)`} htmlFor={`p-serv-peca`} error={l.precoServicoPeca?.message}><K id={`p-serv-peca`} type={`number`} step={`0.01`} min={`0`} disabled={e} {...o(`precoServicoPeca`, {
                valueAsNumber: true
              })} /></_Component19><_Component19 label={`Taxa base de montagem/instalação (R$)`} htmlFor={`p-taxa-mont`} error={l.taxaMontagemBase?.message}><K id={`p-taxa-mont`} type={`number`} step={`0.01`} min={`0`} disabled={e} {...o(`taxaMontagemBase`, {
                valueAsNumber: true
              })} /></_Component19></Hs></Rs><Rs><_Component11><Bs className={`flex items-center gap-2 text-sm font-semibold`}><Bt className={`h-4 w-4 text-primary`} />{`Markup / Margem Padrão de Venda`}</Bs><Vs className={`text-xs`}>{`Percentual padrão aplicado sobre o custo de fábrica quando o cômodo não tiver markup específico.`}</Vs></_Component11><Hs><_Component19 label={`Margem de Lucro Sugerida (%)`} htmlFor={`p-margem-padrao`} error={l.margemPadrao?.message}><K id={`p-margem-padrao`} type={`number`} step={`1`} min={`0`} max={`300`} disabled={e} {...o(`margemPadrao`, {
                valueAsNumber: true
              })} /></_Component19></Hs></Rs></div></form>;
  }
}
function PD() {
  let [e, t] = (0, k.useState)(`marcenaria`);
  let {
    isAdmin: n,
    roles: r
  } = Ct();
  let i = !n;
        return <div className={`space-y-6`}><Fs title={`Configurações`} description={`Conta, equipe, preços e identidade da marcenaria.`}><_Component32 value={e} onValueChange={t} tabs={[{
        value: `marcenaria`,
        label: `Perfil da marcenaria`
      }, {
        value: `precos`,
        label: `Custos & Orçamento 3D`
      }, {
        value: `equipe`,
        label: `Equipe`
      }, {
        value: `conta`,
        label: `Minha conta`
      }]} /></Fs>{!n && r.length > 0 && <div className={`flex items-center gap-2 rounded-lg border border-border bg-muted/40 px-3 py-2 text-sm text-muted-foreground`}><_Component95 className={`h-4 w-4`} />{`Você não é administrador: dados da marcenaria, preços e equipe estão somente leitura.`}</div>}{e === `marcenaria` && <AD somenteLeitura={i} />}{e === `precos` && <ND somenteLeitura={i} />}{e === `equipe` && <L.Fragment><div className={`hidden items-center gap-2 text-sm text-muted-foreground sm:flex`}><Cr className={`h-4 w-4`} />{`Perfis disponíveis: `}{Kr.map(e => Wr[e]).join(`, `)}{`.`}</div><_Component96 ehAdmin={n} /></L.Fragment>}{e === `conta` && <MD />}</div>;
}
var FD = [`/login`, `/cadastro`, `/recuperar-senha`, `/auth-error`];
function ID() {
  let {
    recovery: e,
    loading: t
  } = Ct();
  let n = b();
  if (e) {
    return <Yc />;
  }
  if (t) {
    return null;
  }
  let r = <_Component108><_Component99 path={`/`} element={<_Component98><_Component97 /></_Component98>} /><_Component99 path={`/clientes`} element={<_Component98><Vl /></_Component98>} /><_Component99 path={`/clientes/:id`} element={<_Component98><_Component100 /></_Component98>} /><_Component99 path={`/projetos`} element={<_Component98><_Component101 /></_Component98>} /><_Component99 path={`/projetos/:id`} element={<_Component98><Lf /></_Component98>} /><_Component99 path={`/estoque`} element={<_Component98><Uf /></_Component98>} /><_Component99 path={`/orcamentos`} element={<_Component98><_Component102 /></_Component98>} /><_Component99 path={`/orcamentos/:id`} element={<_Component98><Yf /></_Component98>} /><_Component99 path={`/ordens`} element={<_Component98><_Component103 /></_Component98>} /><_Component99 path={`/ordens/:id`} element={<_Component98><_Component104 /></_Component98>} /><_Component99 path={`/contratos`} element={<_Component98><_Component105 /></_Component98>} /><_Component99 path={`/contratos/:id`} element={<_Component98><Rp /></_Component98>} /><_Component99 path={`/financeiro`} element={<_Component98><_Component106 /></_Component98>} /><_Component99 path={`/designer`} element={<_Component98><$T /></_Component98>} /><_Component99 path={`/designer/:id`} element={<_Component98><OD /></_Component98>} /><_Component99 path={`/configuracoes`} element={<_Component98><PD /></_Component98>} /><_Component99 path={`/login`} element={<Tt><Kc /></Tt>} /><_Component99 path={`/cadastro`} element={<Tt><_Component107 /></Tt>} /><_Component99 path={`/recuperar-senha`} element={<Tt><Jc /></Tt>} /><_Component99 path={`/auth-error`} element={<Xc />} /><_Component99 path={`*`} element={<Zc />} /></_Component108>;
  if (FD.includes(n.pathname) || n.pathname.startsWith(`/designer/`) && n.pathname !== `/designer`) {
    return r;
  } else {
    return <_Component109>{r}</_Component109>;
  }
}
function LD() {
  return <_Component110><St><De /><ID /></St></_Component110>;
}
var RD = new D({
  defaultOptions: {
    queries: {
      staleTime: 300000,
      gcTime: 900000,
      refetchOnWindowFocus: false,
      retry: 1
    },
    mutations: {
      retry: 0
    }
  }
});
(0, A.createRoot)(document.getElementById(`root`)).render(<k.StrictMode><_Component111 client={RD}><LD /></_Component111></k.StrictMode>);
var zD = false;
function BD() {
  if (zD) {
    return;
  }
  zD = true;
  let e = document.getElementById(`preloader`);
  if (e) {
    e.remove();
  }
}
BD();